export const translationsDictionary = {
  "ar": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "كن شريكنا",
        "SHARE_PODSQUEEZE": "شارك Podsqueeze مع جمهورك",
        "AND_EARN_MONEY": "واكسب المال!",
        "LAST_UPDATED": "آخر تحديث: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "كن شريكًا تابعًا",
        "EARN_COMMISSION": "اكسب",
        "COMMISSION": "عمولة",
        "ON_EVERY_SALE": "على كل عملية بيع تتم من خلال رابط الإحالة الخاص بك لمدة 15 شهرًا. شارك رابطك على موقعك الإلكتروني، وسائل التواصل الاجتماعي، أو مع أصدقائك. الانضمام يستغرق ثوانٍ.",
        "GET_AUTOMATICALLY_APPROVED": "احصل على الموافقة تلقائيًا.",
        "JOIN_NOW": "انضم الآن",
        "HOW_IT_WORKS": "كيف يعمل",
        "FREQUENTLY_ASKED_QUESTIONS": "الأسئلة الشائعة",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "ما هو الشريك التابع؟",
        "AFFILIATE_PARTNER_DESCRIPTION": "الشريك التابع هو شخص يروج لمنتجات أو خدمات شركة أخرى من خلال رابط إحالة فريد ويكسب عمولة على كل عملية بيع تتم من خلال هذا الرابط.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "كيف يمكنني أن أصبح شريكًا تابعًا؟",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "أن تصبح شريكًا تابعًا سريع وسهل، يستغرق بضع ثوانٍ فقط من وقتك. للبدء، انقر ببساطة على زر 'انضم الآن' وسجل باستخدام بريدك الإلكتروني. بمجرد التسجيل، ستحصل على وصول إلى لوحة تحكم سهلة الاستخدام حيث ستجد رابط الإحالة الفريد الخاص بك. شارك هذا الرابط مع عائلتك، أصدقائك، أو جمهورك عبر الإنترنت. كلما نقر شخص ما على رابط الإحالة الخاص بك وأجرى عملية شراء على موقع Podsqueeze، ستحصل على عمولة بنسبة 25% على كل دفعة لمدة 15 شهرًا كاملة! تابع أرباحك بسهولة من خلال لوحة تحكم الشركاء التابعة، التي توفر نظرة عامة واضحة على جميع المبيعات التي حققتها.",
        "HOW_CAN_I_TRACK_MY_SALES": "كيف يمكنني تتبع مبيعاتي وعمولتي؟",
        "TRACKING_SALES_DESCRIPTION": "استخدم لوحة تحكم برنامج الشركاء التابعين لتتبع مبيعاتك وعمولاتك. برنامج التتبع متاح لكل من الشركاء التابعين والشركاء التجاريين.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "متى وكيف سأستلم مدفوعاتي؟",
        "PAYMENT_DESCRIPTION": "ستستلم مدفوعاتك عبر PayPal كل 30 يومًا. يرجى ملاحظة أن هناك حد أدنى للسحب قدره 50 دولارًا. لذا، بمجرد أن تصل إلى هذا المبلغ، يمكنك توقع استلام مدفوعاتك كساعة العمل كل 30 يومًا.",
        "STILL_GOT_QUESTIONS": "هل لا تزال لديك أسئلة؟",
        "SEND_US_A_MESSAGE": "أرسل لنا رسالة عبر دردشة الدعم أو راسلنا عبر البريد الإلكتروني على team@podsqueeze.com"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "شريط التنقل",
        "main.affiliateHero": "بطل الشراكة",
        "main.footer": "تذييل"
      }
    },
    "edit": {
      "audioEditElements": {
        "error.processing.rss": "نواجه بعض الصعوبات في معالجة بعض خلاصة RSS. يرجى رفع ملف.",
        "edit.enhance.audio": "قم بتحرير وتعزيز تسجيل الصوت الخاص بك",
        "trial.label": "تجريبي",
        "audio.editing.experience": "اختبر تحرير الصوت بسلاسة مع خوارزميات الذكاء الاصطناعي المتقدمة للحصول على نتائج طبيعية وعالية الجودة، بنقرة واحدة فقط.",
        "improve.audio.quality": "تحسين جودة الصوت",
        "remove.hums.silences": "إزالة الضوضاء والصمت",
        "upgrade.edit.audio": "قم بالترقية لتتمكن من تحرير صوتك بنقرة واحدة فقط",
        "available.plans": "متاح لجميع الخطط المدفوعة",
        "upgrade.now": "قم بالترقية الآن",
        "audio.element.support": "متصفحك لا يدعم عنصر الصوت.",
        "download.audio": "تحميل الصوت",
        "loading.audio": "تحميل الصوت",
        "editing.audio": "تحرير الصوت"
      },
      "videoEditElements": {
        "error.exporting.video": "خطأ أثناء تصدير الفيديو",
        "download.failed": "فشل التنزيل: {error.message}",
        "generating.video": "جاري إنشاء الفيديو",
        "error.generating.clip": "خطأ في إنشاء المقطع",
        "please.retry.support": "يرجى المحاولة مرة أخرى أو التواصل مع دعم المستخدم لدينا",
        "browser.not.support.video": "متصفحك لا يدعم علامة الفيديو.",
        "this.might.take.minutes": "يرجى عدم إغلاق النافذة، قد يستغرق هذا بضع دقائق.",
        "exporting.video": "جارٍ تصدير الفيديو الخاص بك...",
        "seamless.audio.editing": "استمتع بتحرير صوت سلس مع خوارزميات الذكاء الاصطناعي المتقدمة للحصول على نتائج طبيعية وعالية الجودة، بنقرة واحدة فقط.",
        "difficulties.processing.rss": "نواجه بعض الصعوبات في معالجة بعض خلايا RSS. يرجى رفع ملف.",
        "edit.enhance.video.recording": "قم بتحرير وتعزيز تسجيل الفيديو الخاص بك",
        "trial": "تجريبي",
        "enhance.audio.quality": "تعزيز جودة الصوت",
        "enhance.audio.quality.edit": "تعزيز جودة الصوت وتحريره",
        "trim.filler.words.video": "قص الكلمات الزائدة من الفيديو (مثل: همهمات)",
        "trim.long.silences.video": "قص الصمت الطويل من الفيديو",
        "upgrade.to.edit.video": "قم بالترقية لتتمكن من تحرير الفيديو الخاص بك بنقرة واحدة فقط",
        "available.pro.agency.plans": "متاح لخطط المحترفين والوكالات",
        "upgrade.now": "قم بالترقية الآن",
        "download.only.audio": "تنزيل الصوت فقط",
        "download.video": "تنزيل الفيديو",
        "please.dont.close.window": "يرجى عدم إغلاق النافذة",
        "export.video": "تصدير الفيديو"
      },
      "videogramBaseTemplate": {
        "media.fit": "تغطية",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "مدة الوسائط"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "حلقات أخرى من هذا البودكاست",
        "tab.shownotes": "ملاحظات الحلقة",
        "tab.timestamps": "علامات زمنية",
        "tab.blogpost": "مقال المدونة",
        "tab.transcript": "النص المكتوب",
        "key.points": "النقاط الرئيسية"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "صفحتك الرئيسية حية في مكتشف البودكاست لدينا. شاركها مع جمهورك!",
        "landingPage.create": "أنشئ صفحة رئيسية جميلة لهذه الحلقة",
        "landingPage.edit": "تعديل الصفحة",
        "landingPage.visit": "زيارة الصفحة",
        "landingPage.delete": "حذف الصفحة",
        "landingPage.createButton": "إنشاء صفحة رئيسية"
      },
      "SocialLinksModal": {
        "manage.episode.links": "إدارة روابط الحلقات",
        "youtube.link": "رابط يوتيوب",
        "enter.youtube.link": "أدخل رابط يوتيوب",
        "apple.podcasts.link": "رابط آبل بودكاست",
        "enter.apple.podcasts.link": "أدخل رابط آبل بودكاست",
        "spotify.link": "رابط سبوتيفاي",
        "enter.spotify.link": "أدخل رابط سبوتيفاي",
        "saving": "جاري الحفظ...",
        "save": "حفظ",
        "social.links.updated.successfully": "تم تحديث الروابط الاجتماعية بنجاح!"
      },
      "affiliatesection": {
        "affiliate.section.title": "كن شريكًا تابعًا",
        "affiliate.section.subtitle": "شارك Podsqueeze مع جمهورك و",
        "affiliate.section.earn": "اكسب المال!",
        "affiliate.section.commission": "يقدم برنامج الشركاء لدينا عمولة بنسبة 25% لمدة 15 شهرًا، على كل عملية بيع وتجديد اشتراك.",
        "affiliate.section.join": "الانضمام يستغرق ثوانٍ!",
        "affiliate.section.knowMore": "اعرف المزيد"
      },
      "asseenon": {
        "podnews.logo": "شعار بودنيوز",
        "transistor.logo": "شعار ترانزستور",
        "thepodcasthost.logo": "شعار مضيف البودكاست",
        "schoolofpodcasting.logo": "شعار مدرسة البودكاست",
        "semrush.logo": "شعار سيمراش"
      },
      "assembleshownotes": {
        "episode.description": "وصف الحلقة",
        "bullet.points": "نقاط رئيسية",
        "timestamps": "الطوابع الزمنية",
        "links.and.mentions": "الروابط والذكر",
        "extra.content": "محتوى إضافي",
        "assemble.show.notes": "قم بتجميع ملاحظات العرض الخاصة بك",
        "downloading": "جارٍ التحميل",
        "copied": "تم النسخ",
        "enter.placeholder": "أدخل {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "أخذ استراحة من البودكاست",
        "cancellation.option.no_recurrent": "لا أريد اشتراكًا متكررًا",
        "cancellation.option.expensive": "إنه مكلف جدًا",
        "cancellation.option.not_saving_time": "لا يوفر لي وقتًا كافيًا",
        "cancellation.option.dissatisfied_content": "غير راضٍ عن جودة المحتوى المولد",
        "cancellation.option.unresponsive_support": "دعم العملاء غير مستجيب",
        "cancellation.option.not_using": "لا أستخدم الخدمة بما فيه الكفاية",
        "cancellation.option.difficulty_navigating": "صعوبة في استخدام/التنقل في المنتج",
        "cancellation.option.better_alternative": "وجدت منتجًا بديلًا أفضل",
        "cancellation.option.other": "أخرى",
        "cancellation.video.message": "70% من مستخدمينا يتوقفون عن عملية الإلغاء بعد مشاهدة هذا الفيديو",
        "cancellation.button.cancel": "ما زلت أريد الإلغاء",
        "cancellation.button.try_again": "أريد أن أعطيها فرصة أخرى",
        "cancellation.prompt.select_reason": "يرجى مساعدتنا في تحسين المنتج من خلال اختيار سبب إلغاء اشتراكك:",
        "cancellation.placeholder.answer": "اكتب إجابتك هنا...",
        "cancellation.placeholder.specify_reason": "يرجى تحديد سبب إلغاء الاشتراك",
        "cancellation.button.next": "التالي",
        "cancellation.button.go_back": "العودة",
        "cancellation.last_question.title": "آخر سؤال من جانبنا",
        "lose.all.accumulated.minutes": "إذا ألغيت، ستخسر جميع أوقاتك المستحقة.",
        "keep.accumulating.minutes": "إذا ألغيت، ستخسر جميع أوقاتك المستحقة.",
        "here.are.some.ideas": "هناك بعض الأفكار لمساعدتك على الحصول على المزيد من قيمة Podsqueeze",
        "convert.and.repurpose.episodes": "تحويل وإعادة استخدام أقدم الحلقات للحصول على محتوى جديد",
        "generate.articles.favorite.podcasts.and.vides": "تحويل وإعادة استخدام أقدم الحلقات للحصول على محتوى جديد",
        "share.your.account.with.a.friend": "شارك حسابك مع صديق يمكن أن يكون مفيد",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "هنا هو الفيديو الذي يظهر كيفية الحصول على المزيد من قيمة Podsqueeze",
        "cancellation.last_question.prompt": "ما التغييرات أو التحسينات التي قد تجعلك تفكر في إعادة الانضمام إلى خدمتنا؟",
        "cancellation.feedback.message": "ستساعدنا ملاحظاتك في التحسين 🙏",
        "cancellation.button.confirm": "تأكيد الإلغاء",
        "cancellation.minutes.accumulated": "لديك",
        "cancellation.minutes.accumulated.suffix": "دقائق متراكمة بقيمة",
        "cancellation.reminder.text": "يرجى التذكر:",
        "cancellation.minutes.warning": "الدقائق المتراكمة هي ميزة للاشتراكات النشطة. بإلغاء اشتراكك ستفقد دقائقك بشكل دائم.",
        "cancellation.content.deletion.warning": "سيتم حذف جميع المحتوى المُولد بشكل دائم بعد 30 يومًا.",
        "cancellation.minutes.left.title": "لا تزال لديك دقائق متبقية! لا تضيعها!",
        "cancellation.suggestion.clips": "أعد توظيف الحلقات القديمة في مقاطع للشبكات الاجتماعية",
        "cancellation.suggestion.articles": "حول الحلقات القديمة إلى مقالات باستخدام Podsqueeze للاستفادة من السيو.",
        "cancellation.suggestion.linkedin": "حول الحلقات الموثوقة القديمة إلى منشورات LinkedIn لتعزيز علامتك التجارية الشخصية",
        "cancellation.suggestion.share": "شارك حساب Podsqueeze مع صديق حتى يتمكن من الاستفادة من دقائقك غير المستخدمة.",
        "cancellation.button.keep.subscription": "الاحتفاظ بالاشتراك",
        "cancellation.button.keep.minutes": "الاحتفاظ بـ",
        "cancellation.button.keep.minutes.suffix": "قيمة الدقائق",
        "cancellation.lifetime.before_you_go": "قبل أن تذهب...",
        "cancellation.lifetime.title": "ما رأيك بالوصول مدى الحياة مقابل 49$ فقط؟",
        "cancellation.lifetime.subtitle": "احتفظ بحساب Starter الخاص بك. لا اشتراكات. لا تجديدات. ملكك فقط — للأبد.",
        "cancellation.lifetime.feature1": "وصول مدى الحياة إلى Podsqueeze بدفعة واحدة قدرها 49$",
        "cancellation.lifetime.feature2": "استخدمه عندما تحتاجه، بدون ضغط — إنه ملكك للأبد",
        "cancellation.lifetime.feature3": "يشمل جميع ميزات خطة Starter الحالية والمستقبلية",
        "cancellation.lifetime.button_cancel": "ما زلت أريد الإلغاء",
        "cancellation.lifetime.button_deal": "احصل على العرض مدى الحياة",
        "cancellation.downgrade.title": "احتفظ بكل محتواك مقابل 5.99$ فقط شهريًا",
        "cancellation.downgrade.subtitle": "بالتراجع إلى Starter يمكنك...",
        "cancellation.downgrade.feature1": "الاحتفاظ بكل المحتوى المُولد",
        "cancellation.downgrade.feature2": "إبقاء مواقعك الإلكترونية تعمل",
        "cancellation.downgrade.feature3": "160 دقيقة و 10 مقاطع شهريًا للعمل العرضي",
        "cancellation.billing.monthly": "شهري",
        "cancellation.billing.annual": "سنوي",
        "cancellation.billing.discount": "خصم 30%",
        "cancellation.plan.starter": "خطة Starter",
        "cancellation.price.monthly": "8.99$/شهر",
        "cancellation.price.annual": "5.99$/شهر",
        "cancellation.price.annual_billing": "يُحصّل 71.88$ سنويًا",
        "cancellation.feature.minutes": "160 دقيقة/شهر",
        "cancellation.feature.clips": "10 مقاطع/شهر",
        "cancellation.downgrade.button": "التراجع إلى Starter والاحتفاظ بالمحتوى",
        "cancellation.error.payment_link": "تعذر الحصول على رابط الدفع. حاول مرة أخرى.",
        "cancellation.error.payment_service": "خطأ في الاتصال بخدمة الدفع.",
        "cancellation.option.question.break": "هل يمكنك إخبارنا المزيد عن سبب أخذك لاستراحة؟",
        "cancellation.option.question.no_recurrent": "هل يمكنك مشاركة سبب تفضيلك عدم وجود اشتراك متكرر؟",
        "cancellation.option.question.expensive": "ما الأسعار أو الميزات التي ستجعل الخدمة أكثر قيمة بالنسبة لك؟",
        "cancellation.option.question.not_saving_time": "ما الذي لا يزال يستغرق الكثير من وقتك في عمليتك؟",
        "cancellation.option.question.dissatisfied_content": "ما هي جوانب المحتوى التي لم تكن راضياً عنها؟",
        "cancellation.option.question.unresponsive_support": "هل يمكنك وصف تجربتك مع دعم العملاء لدينا؟",
        "cancellation.option.question.not_using": "هل هناك شيء يشجعك على استخدام الخدمة أكثر؟",
        "cancellation.option.question.difficulty_navigating": "ما الصعوبات التي واجهتها في استخدام/التنقل في المنتج؟",
        "cancellation.option.question.better_alternative": "ما المنتج البديل الذي وجدته وما الذي يعجبك فيه؟",
        "cancellation.option.question.other": "يرجى تحديد سبب الإلغاء:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "نحن نقدر خصوصيتك",
        "cookiebanner.cookieUsage": "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على الموقع وتحليل حركة المرور لدينا. من خلال النقر على قبول، فإنك توافق على استخدامنا لملفات تعريف الارتباط.",
        "cookiebanner.privacyPolicy": "سياسة الخصوصية",
        "cookiebanner.accept": "قبول",
        "cookiebanner.decline": "رفض"
      },
      "episodeTitleBox": {
        "loading": "جارٍ التحميل...",
        "editEpisodeTitleClicked": "تم النقر على تعديل عنوان الحلقة",
        "newEpisodeTitleStored": "تم تخزين عنوان الحلقة الجديد"
      },
      "famewall": {
        "loading.message": "جارٍ التحميل..."
      },
      "footer": {
        "footer.features": "الميزات",
        "footer.transcriptGenerator": "مولد النصوص",
        "footer.subtitlesGenerator": "مولد الترجمة",
        "footer.descriptionGenerator": "مولد الوصف",
        "footer.podcastSummarizer": "مولد الملخص",
        "footer.titlesGenerator": "مولد العناوين",
        "footer.bulletPointsGenerator": "مولد النقاط الرئيسية",
        "footer.chaptersClipsGenerator": "مولد الفصول والمقاطع",
        "footer.socialMediaPostsGenerator": "مولد منشورات وسائل التواصل الاجتماعي",
        "footer.newsletterGenerator": "مولد النشرة الإخبارية",
        "footer.blogPostGenerator": "مولد مقالات المدونة",
        "footer.podcastLandingPages": "صفحات هبوط البودكاست",
        "footer.podcastClipMaker": "صانع مقاطع البودكاست",
        "footer.audiogramGenerator": "مولد الأوديوغرام",
        "footer.aiAudioEnhancer": "محسن الصوت بالذكاء الاصطناعي",
        "footer.convertYoutubeToText": "تحويل يوتيوب إلى نص",
        "footer.youtubeVideoNoiseRemover": "مزيل الضوضاء من فيديو يوتيوب",
        "footer.youtubeVideoKeyPoints": "النقاط الرئيسية لفيديو يوتيوب",
        "footer.freeResources": "موارد مجانية",
        "footer.findPodcastTopicIdeas": "ابحث عن أفكار لمواضيع البودكاست",
        "footer.articles": "مقالات",
        "footer.freeEbooks": "كتب إلكترونية مجانية",
        "footer.community": "المجتمع",
        "footer.ourPodcast": "بودكاستنا",
        "footer.product": "المنتج",
        "footer.giftCard": "بطاقة هدايا",
        "footer.onboardingEbook": "كتاب إلكتروني للتوجيه",
        "footer.pricing": "التسعير",
        "footer.affiliates": "الشركاء",
        "footer.media": "وسائل الإعلام",
        "footer.testimonials": "شهادات",
        "footer.legal": "قانوني",
        "footer.privacyPolicy": "سياسة الخصوصية",
        "footer.termsOfUse": "شروط الاستخدام",
        "footer.refundPolicy": "سياسة الاسترداد",
        "footer.allRightsReserved": "جميع الحقوق محفوظة."
      },
      "globalState": {
        "cookie.enabled": "تم تفعيل الكوكيز",
        "language.default": "اللغة الافتراضية"
      },
      "head": {
        "keywords.list": "بودسكووز، الذكاء الاصطناعي، البودكاست، إنشاء المحتوى، نسخ البودكاست، ملاحظات العرض، الطوابع الزمنية، نشرات البودكاست، تغريدات، منشورات المدونات، منشورات التواصل الاجتماعي، العناوين، كاتب ملاحظات العرض"
      },
      "imageResultModal": {
        "download.image": "تحميل الصورة",
        "generating.image": "جاري إنشاء الصورة",
        "ai.prompt.label": "أدخل موجهًا للذكاء الاصطناعي لإنشاء صورة",
        "ai.prompt.placeholder": "مثال: كلب يجري في الحديقة...",
        "processing": "جاري المعالجة...",
        "create": "إنشاء",
        "text.color.label": "لون النص",
        "quote.icon.color.label": "لون أيقونة الاقتباس",
        "background.color.label": "لون الخلفية",
        "font.label": "الخط",
        "upload.cover.image": "رفع صورة الغلاف",
        "aspect.ratio.info": "نسبة العرض إلى الارتفاع 1:1، الحجم الموصى به 1200x1200",
        "upload.logo.label": "رفع الشعار",
        "choose.file": "اختر ملف",
        "upload.success": "تم الرفع بنجاح",
        "choose.quote": "اختر اقتباسًا",
        "select.template": "اختر القالب",
        "quote.label": "اقتباس",
        "enter.quote.here": "أدخل الاقتباس هنا",
        "author.label": "المؤلف",
        "enter.author.name": "أدخل اسم المؤلف",
        "podcast.name.label": "اسم البودكاست",
        "enter.podcast.name": "أدخل اسم البودكاست",
        "colors": "الألوان",
        "select.font": "اختر الخط",
        "cover.logo.images": "صور الغلاف والشعار",
        "logo.image": "صورة الشعار",
        "upgrade.here": "ترقية هنا",
        "remove.logo": "إزالة شعار Podsqueeze",
        "default_templates": "القوالب الافتراضية",
        "saved_templates_count": "القوالب المحفوظة",
        "save_current_template": "حفظ القالب الحالي",
        "no_saved_templates": "لا توجد قوالب محفوظة بعد",
        "save_template": "حفظ القالب",
        "cancel": "إلغاء",
        "save": "حفظ",
        "enter_template_name": "أدخل اسم القالب",
        "reset_template": "إعادة تعيين",
        "add_element": "إضافة عنصر",
        "generate": "إنشاء",
        "add_image": "إضافة صورة",
        "upload_image": "تحميل صورة",
        "or": "أو",
        "generate_with_ai": "إنشاء بالذكاء الاصطناعي",
        "search_fonts": "بحث عن الخطوط...",
        "upload_logo": "تحميل الشعار",
        "square_image_recommended": "يوصى بصورة مربعة",
        "opacity": "الشفافية",
        "layers": "الطبقات",
        "no_element_selected": "لم يتم تحديد عنصر",
        "bold_shortcut": "عريض (Ctrl+B)",
        "italic_shortcut": "مائل (Ctrl+I)",
        "underline_shortcut": "تسطير (Ctrl+U)",
        "edit_text": "تحرير النص",
        "tint_color": "لون الصبغة",
        "toggle_gradient_transparent": "تبديل التدرج إلى شفاف",
        "rotate_gradient": "تدوير التدرج 45 درجة",
        "alt_background": "الخلفية",
        "alt_podcast_logo": "شعار البودكاست",
        "alt_custom": "مخصص",
        "alt_right_side": "الجانب الأيمن",
        "alt_profile": "الملف الشخصي"
      },
      "intentModal": {
        "intentModal.title": "ماذا تريد أن تفعل مع Podsqueeze؟",
        "intentModal.sourceOption.Write_Show_Notes": "كتابة ملاحظات العرض",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "كتابة منشور مدونة ونشرة إخبارية",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "إنشاء مقاطع فيديو أو تسجيلات صوتية",
        "intentModal.sourceOption.Create_Quote_Images": "إنشاء صور اقتباس",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "تحرير وتعزيز الصوت/الفيديو",
        "intentModal.sourceOption.Transcribe": "نسخ",
        "intentModal.sourceOption.Create_a_Website": "إنشاء موقع ويب",
        "intentModal.sourceOption.All_of_the_Above": "كل ما سبق",
        "intentModal.sourceOption.Other": "أخرى",
        "intentModal.otherPlaceholder": "يرجى التحديد",
        "intentModal.submitButton": "إرسال وتسجيل",
        "intentModal.skip": "تخطي"
      },
      "languageSwitcher": {
        "language.en": "الإنجليزية",
        "language.es": "الإسبانية",
        "language.fr": "الفرنسية",
        "language.de": "الألمانية",
        "language.it": "الإيطالية",
        "language.pt": "البرتغالية",
        "language.nl": "الهولندية",
        "language.pl": "البولندية",
        "language.ru": "الروسية",
        "language.zh": "الصينية",
        "language.ja": "اليابانية",
        "language.ko": "الكورية",
        "language.ar": "العربية",
        "language.th": "التايلاندية",
        "language.vi": "الفيتنامية"
      },
      "lazyImage": {
        "lazyImage.alt": "وصف الصورة"
      },
      "metadata": {
        "meta.title": "عنوان صفحتك",
        "meta.appName": "بود سكويز",
        "meta.appCategory": "أداة"
      },
      "navbar": {
        "navbar.dashboard": "لوحة التحكم",
        "navbar.login": "تسجيل الدخول",
        "navbar.openMenu": "فتح القائمة الرئيسية",
        "navbar.features": "الميزات",
        "navbar.resources": "الموارد",
        "navbar.pricing": "التسعير",
        "navbar.contact": "اتصل بنا",
        "navbar.seeAllFeatures": "عرض جميع الميزات",
        "navbar.mainFeatures": "الميزات الرئيسية",
        "navbar.podcastTranscription": "مولد نصوص البودكاست والفيديو",
        "navbar.transcriptionDescription": "نص دقيق مع تصنيف المتحدثين وملف SRT للترجمات.",
        "navbar.podcastSummarizer": "ملخص البودكاست",
        "navbar.summarizerDescription": "إنشاء ملاحظات عرض كاملة أسرع 20 مرة، بصوتك الخاص.",
        "navbar.podcastClipMaker": "صانع مقاطع البودكاست",
        "navbar.clipMakerDescription": "توليد مقاطع قصيرة أو مخططات صوتية تلقائيًا لبودكاستك.",
        "navbar.audioEnhancer": "محسن الصوت بالذكاء الاصطناعي",
        "navbar.audioEnhancerDescription": "تحسين الصوت تلقائيًا، وإزالة الصمت وكلمات الحشو.",
        "navbar.podsqueezeFeaturesWalkthrough": "دليل ميزات PODSQUEEZE",
        "navbar.blog": "مدونة",
        "navbar.blogDescription": "مقالات وإرشادات قابلة للتنفيذ لإطلاق وتنمية بودكاست ناجح.",
        "navbar.podcastTopicIdeas": "أفكار مواضيع البودكاست",
        "navbar.topicIdeasDescription": "اكتشف مواضيع البودكاست التي يبحث عنها الجمهور.",
        "navbar.actionableEbooks": "كتب إلكترونية قابلة للتنفيذ",
        "navbar.topPodcasts": "أفضل البودكاستات",
        "navbar.ebooksDescription": "تحميل كتب إلكترونية مجانية مع نصائح قابلة للتنفيذ لنقل البودكاست الخاص بك إلى المستوى التالي.",
        "navbar.freeThumbnailMaker": "صانع صور مصغرة مجاني للبودكاست",
        "navbar.freeThumbnailMakerDescription": "إنشاء صور مصغرة احترافية وجذابة للحلقات بالذكاء الاصطناعي.",
        "navbar.seoOptimizer": "محسن SEO",
        "navbar.seoOptimizerDescription": "حسّن حلقات البودكاست الخاصة بك لظهور أفضل في محركات البحث.",
        "navbar.podcastDescription": "استمع إلى البودكاست الخاص بنا، حيث نجري مقابلات مع مقدمي البودكاست ذوي الخبرة ومستخدمي Podsqueeze من جميع أنحاء العالم. نطلب منهم مشاركة نصائحهم ورؤاهم وقصصهم وكل ما تحتاج لمعرفته لتنمية البودكاست الخاص بك."
      },
      "resultModal": {
        "prompt.transcript.quote": "اقتباس",
        "prompt.transcript.blog": "مدونة",
        "prompt.transcript.tweets": "تغريدات",
        "prompt.shownotes.firstPerson": "ملاحظات العرض بصيغة المتكلم",
        "prompt.shownotes.replaceName": "استبدال الاسم في ملاحظات العرض",
        "prompt.shownotes.friendlyTone": "ملاحظات عرض بنبرة ودية",
        "prompt.shownotes.youtubeDescription": "وصف يوتيوب لملاحظات العرض",
        "prompt.shownotes.engagingQuestion": "سؤال جذاب لملاحظات العرض",
        "prompt.timestamps.formatAsChapters": "تنسيق الطوابع الزمنية كفصول",
        "prompt.timestamps.detailedDescriptions": "وصف مفصل وملخص للطوابع الزمنية",
        "prompt.timestamps.improveSpeakerNames": "تحسين أسماء المتحدثين في الطوابع الزمنية",
        "prompt.newsletter.casualTone": "نشرة بريدية بنبرة غير رسمية",
        "prompt.newsletter.shorter": "نشرة بريدية أقصر",
        "prompt.newsletter.contentSections": "أقسام المحتوى في النشرة البريدية",
        "prompt.newsletter.changeName": "تغيير الاسم في النشرة البريدية",
        "prompt.mentions.fullURL": "روابط كاملة في الإشارات",
        "prompt.mentions.replaceName": "استبدال الاسم في الإشارات",
        "prompt.tweets.underdogTone": "تغريدات بنبرة المتحدي",
        "prompt.tweets.firstPerson": "تغريدات بصيغة المتكلم",
        "prompt.shortPost.relevantEmojis": "رموز تعبيرية ذات صلة في المنشور القصير",
        "prompt.shortPost.educationalTone": "منشور قصير بنبرة تعليمية",
        "prompt.shortPost.underdogTone": "منشور قصير بنبرة المتحدي",
        "prompt.shortPost.firstPerson": "منشور قصير بصيغة المتكلم",
        "prompt.titles.youtubeOptimized": "عناوين محسّنة ليوتيوب",
        "prompt.titles.startWithHowTo": "ابدأ بعناوين 'كيفية'",
        "prompt.titles.otherOptions": "خيارات أخرى للعناوين",
        "prompt.keywords.youtubeOptimized": "كلمات مفتاحية محسّنة ليوتيوب",
        "prompt.keywords.separateWithCommas": "افصل الكلمات المفتاحية بفواصل",
        "prompt.quotes.lorem1": "اقتباس لوريم إيبسوم 1",
        "prompt.quotes.lorem2": "اقتباس لوريم إيبسوم 2",
        "prompt.bulletPoints.lorem1": "نقطة لوريم إيبسوم 1",
        "prompt.bulletPoints.lorem2": "نقطة لوريم إيبسوم 2",
        "prompt.longPost.firstPerson": "منشور طويل بصيغة المتكلم",
        "prompt.longPost.relevantEmojis": "رموز تعبيرية ذات صلة في المنشور الطويل",
        "prompt.longPost.changeName": "تغيير الاسم في المنشور الطويل",
        "alert.tuningInstructionsEmpty": "لا يمكن أن تكون تعليمات الضبط فارغة.",
        "text.timestamps.byPodsqueeze": "الطوابع الزمنية بواسطة PodSqueeze",
        "button.copied": "تم النسخ",
        "button.copy": "نسخ",
        "embed.transcript": "تضمين النص",
        "embed.description": "وصف للتضمين",
        "preview.title": "معاينة العنوان",
        "loading.regenerating": "إعادة التوليد...",
        "placeholder.tuningInstructions": "أدخل تعليمات الضبط...",
        "button.saveClose": "حفظ وإغلاق",
        "button.acceptChanges": "قبول التغييرات",
        "button.discard": "تجاهل",
        "button.embedTranscript": "تضمين النص",
        "text.copiedToClipboard": "تم النسخ إلى الحافظة",
        "download.srtFile": "تحميل ملف SRT",
        "text.forCaptions": "للتعليقات التوضيحية",
        "tune.title": "ضبط نتائجك",
        "tune.description": "قم بضبط نتائجك باستخدام الخيارات التالية.",
        "instruction.label": "تعليمات:",
        "button.tuneResult": "ضبط النتيجة",
        "instruction.saveForLater": "احفظ للوقت لاحق",
        "feedback.happyWithResults": "هل أنت سعيد بالنتائج؟"
      },
      "resultModalTranscript": {
        "prompt.quote": "ابحث عن ثلاث اقتباسات جيدة من النص",
        "prompt.blog": "اكتب مقالة مدونة مكونة من 500 كلمة تركز على الموضوع X",
        "prompt.tweets": "اكتب ثلاث تغريدات جذابة من النص",
        "transcript.autoTranscribed": "تم النسخ تلقائيًا باستخدام Podsqueeze",
        "alert.emptyPrompt": "لا يمكن أن تكون تعليمات الضبط فارغة",
        "embed.transcript": "تضمين النص",
        "embed.description": "قم بتضمين نص بحجم مناسب مع ميزة البحث على موقع WordPress الخاص بك أو أي صفحة تدعم HTML.",
        "button.copied": "تم النسخ!",
        "button.copy": "نسخ",
        "preview.title": "معاينة",
        "edit.speakers": "تعديل أسماء المتحدثين",
        "button.saveClose": "حفظ وإغلاق",
        "placeholder.prompt": "مثل: ابحث عن ثلاث اقتباسات جيدة من النص",
        "upgrade.pro": "قم بالترقية إلى Pro لاستخدام هذه الميزة",
        "upgrade.link": "ترقية إلى Pro",
        "button.generate": "إنشاء",
        "feedback.happy": "هل أنت سعيد بالنتائج؟",
        "instruction": "تعليمات: ",
        "generating.results": "جاري إنشاء النتائج",
        "full.transcription": "النسخ الكامل",
        "srt.file": "& ملف SRT",
        "download.srt": "تحميل ملف SRT",
        "caption.subtitles": "للتعليقات التوضيحية والترجمات.",
        "generate.from.transcript": "إنشاء من النص باستخدام Gpt-4o",
        "gpt.tweak.text": "اطلب من أحدث GPT تعديل النص حسب رغبتك. استخدم اللغة الطبيعية ولا تتردد في أن تكون محددًا.",
        "copied.clipboard": "تم النسخ إلى الحافظة",
        "transcript.public.available": "الرابط العام",
        "audio.notSupported": "متصفحك لا يدعم عنصر الصوت.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "أضف اسم البودكاست",
        "podcast.title": "بودكاست {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "كيف عرفت عن بودسكويس؟",
        "sourceModal.otherPlaceholder": "يرجى التحديد",
        "sourceModal.nextButton": "التالي",
        "sourceModal.skip": "تخطي"
      },
      "squeezeEditResults": {
        "error.processing.rss": "نواجه بعض الصعوبات في معالجة بعض خلاصة RSS. يرجى رفع ملف."
      },
      "squeezeResults": {
        "copiedToClipboard": "تم النسخ إلى الحافظة",
        "publicLink": "عام في ",
        "createLink": "إنشاء رابط لمشاركة صفحة النتائج هذه",
        "assembleShowNotes": "تجميع ملاحظات العرض",
        "convertAnotherEpisode": "تحويل حلقة أخرى",
        "writtenContent": "محتوى مكتوب",
        "videoClipsAndImages": "مقاطع فيديو وصور",
        "editAudio": "تعديل الصوت"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "شاهد المزيد واضبط",
        "see.more": "شاهد المزيد",
        "generating": "يتم الإنشاء",
        "download.all": "تحميل الكل",
        "full.transcription": "نسخة كاملة",
        "transcript.benefit": "هل تعلم أن إضافة نسخ كاملة إلى ملاحظات العرض الخاصة بك تعزز حركة المرور والمشاركة على موقع الويب؟",
        "learn.more": "تعلم المزيد",
        "transcript.bonus": "يمكنك تقديم نسخ كاملة كهدية لبرنامج عضوية البودكاست الخاص بك.",
        "show.notes": "ملاحظات العرض",
        "show.notes.engagement": "فكر في تكملة هذا الوصف القصير بعناصر أخرى في ملاحظات العرض الخاصة بك لتعزيز المشاركة وتحسين محركات البحث.",
        "show.notes.examples": "ابحث عن الإلهام من هذه الأمثلة الـ 17 لملاحظات عرض البودكاست لصياغة الملاحظات المثالية لبودكاستك.",
        "timestamps": "الطوابع الزمنية",
        "timestamps.benefit": "أضف هذه الطوابع الزمنية إلى وصف حلقتك وسينشئ ذلك فصولًا تلقائيًا على سبوتيفاي ويوتيوب.",
        "titles": "العناوين",
        "titles.engagement": "تميل العناوين التي تحتوي على علامات استفهام والتفضيلات إلى أن تكون جذابة بشكل خاص.",
        "links.and.mentions": "الروابط والإشارات",
        "mentions.resources": "فكر في تضمين الإشارات أدناه ضمن قسم الموارد في ملاحظات العرض الخاصة بك.",
        "mentions.affiliate": "تحقق مما إذا كانت المنتجات المذكورة تحتوي على برامج تابعة وفكر في إضافة روابط تابعة في ملاحظات العرض الخاصة بك.",
        "mentions.social.media": "قم بوسم الأشخاص المذكورين في حلقتك على وسائل التواصل الاجتماعي لتشجيعهم على المشاركة والتفاعل مع منشورك.",
        "keywords": "الكلمات الرئيسية",
        "keywords.youtube": "عند تحميل حلقتك على يوتيوب، فقط انسخ والصق هذه الكلمات الرئيسية في قسم العلامات.",
        "keywords.social.media": "أعد استخدام هذه الكلمات الرئيسية كهاشتاجات على وسائل التواصل الاجتماعي.",
        "blog.post": "مقال مدونة",
        "blog.post.linkedin": "فكر في استخدام هذا المحتوى لصياغة منشور طويل على لينكد إن،",
        "blog.post.share": "شارك هذا المحتوى في مجتمعات ريديت ومجموعات فيسبوك التي تتماشى مع موضوع بودكاستك.",
        "newsletter": "النشرة الإخبارية",
        "newsletter.content": "بعض مستخدمينا يعيدون استخدام محتوى هذه النشرة الإخبارية لإنشاء أوصاف حلقات أكثر شمولاً لملاحظات العرض.",
        "linkedin.and.facebook": "لينكد إن وفيسبوك",
        "short.post.description": "استخدم هذه المنشورات القصيرة كأوصاف عند مشاركة مقاطع الفيديو والملفات الصوتية ذات الصلة على وسائل التواصل الاجتماعي.",
        "tweets": "تغريدات",
        "quotes": "اقتباسات",
        "bullet.points": "نقاط رئيسية",
        "add.custom.result": "إضافة نتيجة تخصيصية",
        "bullet.points.skimming": "غالبًا ما يسرد مقدمو البودكاست الموضوعات الرئيسية للحلقة كنقاط رئيسية في ملاحظات العرض لتسهيل القراءة السريعة."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "شاهد المزيد واضبط",
        "generating": "جاري الإنشاء",
        "not.available.for.rss.feed": "غير متوفر لهذا الخلاصة RSS",
        "regenerate.episode.upload.file": "إعادة إنشاء الحلقة وتحميل ملف الصوت/الفيديو مباشرة من جهاز الكمبيوتر الخاص بك",
        "processing.difficulties": "نواجه بعض الصعوبات في معالجة بعض خلاصات RSS. يرجى تحميل ملف.",
        "video.clips": "مقاطع الفيديو",
        "ai.short.clips": "مقاطع قصيرة",
        "quote.image": "صورة الاقتباس"
      },
      "title": {
        "title.text": "علامتك"
      },
      "topbar": {
        "topbar.forYou": "لك",
        "topbar.joinPodcast": "انضم إلى لقائنا الافتراضي القادم للبودكاست!",
        "topbar.saveYourSpot": "احفظ مكانك",
        "topbar.dismiss": "تجاهل"
      },
      "trackers": {
        "trackers.init": "جارٍ تهيئة المتعقبين مع تمكين الكوكيز: ",
        "trackers.loadScripts": "جارٍ تحميل سكريبتات التتبع..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "مرحبًا بك في تطبيقي",
        "content.description": "هذا تطبيق تجريبي يوضح الترجمة.",
        "button.submit": "إرسال"
      },
      "videoResultModal": {
        "ai_editing_clip": "بودسكووز AI يقوم بتحرير مقطعك",
        "export_clip": "تصدير المقطع",
        "ai_edit": "تحرير AI",
        "ai_editing_clip_duration": "سيستغرق هذا بضع ثوانٍ",
        "generating_clip": "يتم إنشاء مقطعك...",
        "generating_clip_notice": "قد يستغرق هذا بضع دقائق. سنرسل لك بريدًا إلكترونيًا بمجرد الانتهاء.",
        "edit_another_video": "يمكنك الانتظار هنا أو تحرير فيديو آخر",
        "download_video": "تحميل الفيديو",
        "back_to_editing": "العودة إلى التحرير",
        "export_video_button": "تصدير المقطع",
        "notice_storage": "تنبيه: نقوم بتخزين الصوت الخاص بك لمدة 30 يومًا. بعد هذه الفترة، سينتهي هذا المقطع.",
        "error_generating_clip": "خطأ في إنشاء المقطع",
        "error_user_support": "يرجى المحاولة مرة أخرى أو التواصل مع دعم المستخدمين لدينا",
        "select_template": "اختر القالب",
        "add_30s_prev": "30 ثانية من الفصل السابق",
        "add_30s_next": "30 ثانية من الفصل التالي",
        "undo": "تراجع",
        "subtitles_font": "خط الترجمة",
        "subtitles_color": "لون الترجمة",
        "subtitles_box_color": "لون الترجمة المتحركة",
        "adjust_podcast_title_position": "تعديل الموضع العمودي لعنوان البودكاست",
        "adjust_subtitles_size": "تعديل حجم الترجمة",
        "adjust_subtitles_vertical_position": "تعديل الموضع العمودي للترجمة",
        "remove_subtitles": "إزالة الترجمة",
        "animated_subtitles": "ترجمة متحركة",
        "upgrade_here": "ترقية هنا",
        "remove_logo": "لإزالة الشعار",
        "remove_podsqueeze_logo": "إزالة شعار بودسكووز",
        "aspect_ratio": "نسبة العرض إلى الارتفاع",
        "youtube": "يوتيوب",
        "social_media": "تويتر (X)، لينكد إن، إنستغرام",
        "reels": "ريلز، قصص، يوتيوب شورتس، تيك توك",
        "episode_title": "عنوان الحلقة",
        "podcast_title": "عنوان البودكاست",
        "titles_font": "خط العناوين",
        "title_colors": "ألوان عناوين البودكاست/الحلقة",
        "video_fit": "تناسب الفيديو",
        "adjust_horizontal_position": "تعديل الموضع الأفقي",
        "adjust_vertical_position": "تعديل الموضع العمودي",
        "adjust_video_zoom": "تعديل التكبير",
        "adjust_video_width": "تعديل عرض الفيديو",
        "adjust_video_height": "تعديل ارتفاع الفيديو",
        "background_color": "لون الخلفية",
        "edit_clip": "تحرير المقطع",
        "edit_layout": "تعديل الترتيب",
        "choose_short": "اختر مقطعًا قصيرًا",
        "edit_audio": "تحرير الصوت",
        "framing": "إطار",
        "background": "خلفية",
        "text_style": "نمط النص",
        "music": "موسيقى",
        "choose_chapter": "اختر فصلاً",
        "clips_left": "لديك",
        "apply_layout": "تطبيق الترتيب",
        "clips_left_number": "مقاطع متبقية",
        "need_more_clips": "تحتاج إلى المزيد من المقاطع؟ قم بترقية خطتك هنا",
        "download_srt_file": "تحميل ملف SRT",
        "track_selected": "المسار: ",
        "no_background_music": "لا توجد موسيقى خلفية مختارة",
        "volume": "الصوت:",
        "remove": "إزالة",
        "track_ambient_piano": "بيانو وأوتار محيطة",
        "track_deep_meditation": "تأمل عميق",
        "track_chill_upbeat": "لها إيقاع مريح",
        "track_inspiring_ambient": "أجواء سينمائية ملهمة",
        "track_just_relax": "فقط استرخ",
        "track_movement": "حركة",
        "track_once_in_paris": "مرة في باريس",
        "track_perfect_beauty": "جمال مثالي",
        "track_summer_adventures": "مغامرات الصيف",
        "track_sunset_groove": "إيقاع غروب الشمس",
        "track_tvari_cafe": "مقهى تيفاري في طوكيو",
        "track_short_piano_intermezzo": "قطعة بيانو قصيرة",
        "track_dramatic_background": "موسيقى خلفية درامية",
        "track_dramatic_hiphop": "جاز هيب هوب درامي",
        "track_emotional_orchestra": "أوركسترا عاطفية",
        "track_halloween_short": "موسيقى هالوين",
        "track_improvisation_037": "ارتجال الجاز",
        "track_inspiration_piano": "بيانو ملهم",
        "track_medieval_extract": "موسيقى القرون الوسطى",
        "track_short_8": "مقطع أمبيانت قصير",
        "track_flute": "فلوت هادئ",
        "track_piano_guitar_duet": "ثنائي بيانو وجيتار",
        "track_intro_jazz": "جاز افتتاحي",
        "track_romantic_jazz": "جاز رومانسي",
        "turn_into_short_clip": "تحويل هذا المقطع إلى مقطع قصير (<60 ثانية)",
        "recommended_for_youtube": "موصى به لـ YouTube",
        "browser_not_support_audio": "متصفحك لا يدعم عنصر الصوت.",
        "watch_tutorial": "شاهد هذا الشرح",
        "audiogram_maker": "حول كيفية تحقيق أقصى استفادة من صانع الصوتيات",
        "store_audio_notice": "ملاحظة: نحن نخزن صوتك لمدة 30 يومًا.",
        "clip_maker": "حول كيفية تحقيق أقصى استفادة من صانع المقاطع",
        "split_screen_mode": "وضع تقسيم الشاشة",
        "none": "لا شيء",
        "vertical_split": "تقسيم عمودي",
        "horizontal_split": "تقسيم أفقي",
        "layers": "استخدم الطبقات أدناه لتحريكها للأمام أو للخلف.",
        "screen_1_horizontal_position": "الموضع الأفقي للشاشة 1",
        "screen_2_horizontal_position": "الموضع الأفقي للشاشة 2",
        "track_mysterious_dark_background": "خلفية مظلمة غامضة",
        "track_acoustic_ambient_inspiration": "إلهام محيطي صوتي",
        "track_aristocracy_classical": "الأرستقراطية الكلاسيكية",
        "track_folk_music_river_knows_my_name": "موسيقى شعبية - النهر يعرف اسمي",
        "track_funy_adventure": "مغامرة ممتعة",
        "track_energetic_sports_rock_trailer": "تريلر روك رياضي نشط",
        "track_fun_upbeat_energetic_pop_rock": "بوب روك نشط وممتع",
        "track_epic_emotional_inspirational": "ملحمي عاطفي ملهم",
        "track_inspirational_epic": "ملحمي ملهم",
        "all_music": "كل الموسيقى",
        "energetic_music": "نشطة",
        "inspirational_music": "ملهمة",
        "ambient_music": "محيطية",
        "chill_music": "هادئة",
        "hiphop_music": "هيب هوب",
        "quirky_music": "غريبة",
        "dramatic_music": "درامية",
        "acoustic_music": "صوتية",
        "classical_music": "كلاسيكية",
        "categories": "الفئات",
        "select_track": "اختر المسار",
        "upload_music": "رفع الموسيقى",
        "my_music": "موسيقاي",
        "downloading": "جاري التحميل...",
        "download_again": "إعادة تحميل",
        "download": "تحميل",
        "download_failed_alert": "فشل في تحميل الفيديو. يرجى المحاولة مرة أخرى.",
        "translate_subtitles": "ترجمة الترجمات المصاحبة",
        "translate_to": "ترجمة إلى",
        "select_language": "اختر اللغة",
        "select_new_language": "اختر لغة جديدة",
        "translating": "جاري الترجمة...",
        "translation_complete": "اكتملت الترجمة",
        "error_translation": "خطأ أثناء الترجمة. يرجى المحاولة مرة أخرى.",
        "original_language": "الأصلي"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "عنوان الحلقة"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "ليس لديك أي محتوى بعد.",
        "userPodcastsInfo.generateContent": "أنشئ محتواك الأول",
        "placeholder.search_folders": "البحث في المجلدات...",
        "search.no_results": "لا توجد مجلدات تطابق بحثك."
      },
      "landingPageModal": {
        "upload.error": "فشل في رفع الصورة: ",
        "upload.image.file": "يرجى رفع ملف صورة.",
        "upgrade.pro.message": "تخصيص الصفحة متاح فقط لحسابات Pro و Agency",
        "upgrade.now": "ترقية الآن",
        "upgrade.unique.landing.page": " واصنع صفحة هبوط فريدة للحلقة.",
        "logo.recommendation": "ارتفاع الشعار الموصى به 200 بكسل",
        "social.links.top.menu": "روابط التواصل الاجتماعي في القائمة العلوية",
        "linkedin.label": "لينكد إن",
        "linkedin.placeholder": "أدخل رابط لينكد إن",
        "facebook.label": "فيسبوك",
        "facebook.placeholder": "أدخل رابط فيسبوك",
        "saving...": "جارٍ الحفظ...",
        "save": "حفظ",
        "saved.successfully": "تم الحفظ بنجاح!",
        "uploading.image": "جارٍ رفع الصورة...",
        "upload.episode.cover": "رفع غلاف الحلقة",
        "upload.logo": "رفع الشعار",
        "where.listen.episode": "أين يمكننا الاستماع إلى هذه الحلقة أيضًا؟",
        "youtube.label": "يوتيوب",
        "youtube.placeholder": "أدخل رابط يوتيوب",
        "apple.podcast.label": "بودكاست آبل",
        "apple.podcast.placeholder": "أدخل رابط بودكاست آبل",
        "spotify.label": "سبوتيفاي",
        "spotify.placeholder": "أدخل رابط سبوتيفاي",
        "image.size.recommendation": "الحجم الموصى به 1000x1000 بكسل",
        "primary.color.label": "اللون الأساسي",
        "header.background.color": "لون خلفية الرأس والروابط.",
        "landing.page.customization": "تخصيص صفحة الهبوط",
        "create.branded.landing.page": "أنشئ صفحة هبوط جميلة تحمل علامتك التجارية لمشاركتها مع مستمعيك",
        "episode.image": "صورة الحلقة",
        "episode.links": "روابط الحلقة",
        "page.header": "رأس الصفحة",
        "page.color": "لون الصفحة",
        "visit.landing.page": "زيارة صفحة الهبوط"
      },
      "page": {
        "loading.dashboard": "جارٍ تحميل لوحة التحكم",
        "convert.new.episode": "تحويل حلقة جديدة",
        "convert.audio.or.video": "تحويل الملفات الصوتية أو الملفات المرئية",
        "minutes.left": "لديك",
        "need.more.minutes": "تحتاج إلى المزيد من الدقائق؟",
        "upgrade.plan": "قم بترقية خطتك هنا.",
        "your.podcasts": "البودكاست الخاصة بك",
        "podsqueeze.results.page": "صفحة نتائج بودسكووز",
        "access.podsqueeze.results": "الوصول إلى نتائج بودسكووز لهذه الحلقة. ستتمكن من رؤية جميع المحتويات التي تم إنشاؤها"
      },
      "podcast": {
        "confirm.delete_episode": "هل أنت متأكد أنك تريد حذف هذه الحلقة؟",
        "alert.something_wrong": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
        "confirm.delete_folder": "هل أنت متأكد أنك تريد حذف هذا المجلد؟",
        "loading.episodes": "جارٍ تحميل الحلقات...",
        "folder.empty": "هذا المجلد فارغ.",
        "content.no_content": "لا يوجد محتوى متاح.",
        "content.generate_first": "قم بإنشاء البودكاست الأول الخاص بك.",
        "button.personalize_ai": "خصص باستخدام الذكاء الاصطناعي",
        "button.edit_website": "تحرير الموقع الإلكتروني",
        "button.visit_website": "زيارة الموقع الإلكتروني",
        "button.generate_website": "إنشاء موقع إلكتروني",
        "placeholder.search": "بحث...",
        "label.sort_by": "ترتيب حسب",
        "label.last_episodes_loaded": "آخر الحلقات المحملة",
        "button.load_all_episodes": "تحميل جميع الحلقات",
        "loading": "جارٍ التحميل...",
        "add.new.episode": "إضافة حلقة جديدة",
        "order.newest": "الأحدث أولاً",
        "order.oldest": "الأقدم أولاً",
        "order.a_to_z": "أ إلى ي",
        "order.z_to_a": "ي إلى أ"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "إنشاء مجلد بودكاست جديد:",
        "folder.name.placeholder": "اسم المجلد",
        "create.button": "إنشاء"
      },
      "podcastLandingModal": {
        "upload.image.error": "يرجى رفع ملف صورة",
        "podcast.cover.title": "صورة غلاف البودكاست",
        "podcast.cover.upload": "قم برفع صورة غلاف البودكاست الخاصة بك هنا. ستظهر بشكل بارز على صفحة الهبوط الخاصة بك.",
        "upload.image.uploading": "جارٍ رفع الصورة...",
        "podcast.cover.upload.button": "رفع صورة الغلاف",
        "podcast.cover.recommended.size": "الحجم الموصى به: 1400x1400 بكسل",
        "profile.info.title": "معلومات الملف الشخصي",
        "profile.info.upload": "أضف صورتك الشخصية واسمك لتخصيص صفحة الهبوط الخاصة بك.",
        "profile.upload.button": "رفع صورة الملف الشخصي",
        "profile.name.label": "اسم الملف الشخصي",
        "profile.name.placeholder": "أدخل اسمك",
        "platform.links.title": "روابط المنصات",
        "platform.links.upload": "أضف روابط البودكاست الخاص بك على منصات مختلفة.",
        "platform.links.youtube_link": "رابط يوتيوب",
        "platform.links.youtube_link.placeholder": "أدخل رابط يوتيوب",
        "platform.links.spotify_link": "رابط سبوتيفاي",
        "platform.links.spotify_link.placeholder": "أدخل رابط سبوتيفاي",
        "platform.links.apple_podcast_link": "رابط آبل بودكاست",
        "platform.links.apple_podcast_link.placeholder": "أدخل رابط آبل بودكاست",
        "platform.links.linkedin_link": "رابط لينكد إن",
        "platform.links.linkedin_link.placeholder": "أدخل رابط لينكد إن",
        "platform.links.facebook_link": "رابط فيسبوك",
        "platform.links.facebook_link.placeholder": "أدخل رابط فيسبوك",
        "platform.links.twitter_link": "رابط تويتر",
        "platform.links.twitter_link.placeholder": "أدخل رابط تويتر",
        "call.to.action.title": "دعوة إلى العمل",
        "call.to.action.upload": "قم بإعداد زر الدعوة إلى العمل لصفحة الهبوط.",
        "call.to.action.button.text.label": "نص الزر",
        "call.to.action.button.text.placeholder": "أدخل نص الزر",
        "call.to.action.button.link.label": "رابط الزر",
        "call.to.action.button.link.placeholder": "أدخل رابط الزر",
        "color.styles.title": "أنماط الألوان",
        "color.styles.upload": "خصص ألوان صفحة الهبوط الخاصة بك.",
        "color.styles.primary.label": "اللون الأساسي",
        "color.styles.primary.description": "اختر اللون الأساسي لصفحة الهبوط الخاصة بك",
        "color.styles.secondary.label": "اللون الثانوي",
        "color.styles.secondary.description": "اختر اللون الثانوي لصفحة الهبوط الخاصة بك",
        "podcast.info.title": "معلومات البودكاست",
        "podcast.info.upload": "قم بتحرير تفاصيل البودكاست الخاص بك.",
        "podcast.info.name.label": "اسم البودكاست",
        "podcast.info.name.placeholder": "أدخل اسم البودكاست",
        "podcast.info.description.label": "وصف البودكاست",
        "podcast.info.description.placeholder": "أدخل وصف البودكاست",
        "edit.website.title": "تحرير الموقع",
        "generate.website.title": "إنشاء موقع",
        "for": "لـ",
        "saving": "جارٍ الحفظ...",
        "save.changes": "حفظ التغييرات",
        "generate.website": "إنشاء موقع",
        "changes.saved.success": "تم حفظ التغييرات بنجاح!",
        "podcast.cover.menu": "غلاف البودكاست",
        "podcast.info.menu": "معلومات البودكاست",
        "profile.menu": "الملف الشخصي",
        "platform.links.menu": "روابط المنصات",
        "call.to.action.menu": "دعوة إلى العمل",
        "color.styles.menu": "أنماط الألوان"
      },
      "podcastMoveModal": {
        "move.episode.label": "نقل هذه الحلقة إلى:",
        "move.episode.instruction": "يمكنك كتابة اسم جديد لإنشاء مجلد.",
        "move.episode.button": "نقل",
        "move.episode.error.selectFolder": "يرجى اختيار مجلد لنقل الحلقة."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "إعدادات الذكاء الاصطناعي لبودكاست {{podcastTitle}}",
        "ai.customize.writing.style": "خصص أسلوب الكتابة الخاص بك باستخدام الذكاء الاصطناعي",
        "ai.content.writing.preference": "كيف تود أن تكتب Podsqueeze محتواك؟",
        "ai.voice.placeholder": "مثال: نبرة احترافية ولكن ودية. المستمعون هم صانعي البودكاست. اكتب بصيغة المتكلم.",
        "ai.character.limit.reached": "لقد وصلت إلى حد الأحرف البالغ 50.",
        "ai.upgrade.now": "قم بالترقية الآن",
        "ai.fix.transcript.misspells": "إصلاح الأخطاء الإملائية في النص",
        "ai.enter.misspelled.words": "اكتب الكلمات التي غالبًا ما يخطئ الذكاء الاصطناعي في كتابتها في حلقات هذا البودكاست، مثل الأسماء",
        "ai.enter.word.press.enter": "أدخل كلمة واضغط على Enter",
        "ai.add.word": "أضف كلمة",
        "ai.tag.limit.reached": "تم الوصول إلى حد 1 علامة.",
        "ai.save": "احفظ",
        "ai.save.close": "احفظ وأغلق"
      },
      "selectedepisode": {
        "selectedEpisode.title": "عنوان الحلقة",
        "selectedEpisode.podcastName": "اسم البودكاست",
        "selectedEpisode.showNotes": "ملاحظات العرض",
        "selectedEpisode.timestamp": "الطابع الزمني",
        "selectedEpisode.staticTimestamp": "الطابع الزمني الثابت",
        "selectedEpisode.mentions": "الإشارات",
        "selectedEpisode.newsletter": "النشرة الإخبارية",
        "selectedEpisode.titles": "العناوين",
        "selectedEpisode.tweeter": "المغرد",
        "selectedEpisode.shortPost": "منشور قصير",
        "selectedEpisode.transcription": "نسخة مكتوبة",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "الكلمات الرئيسية",
        "selectedEpisode.quotes": "اقتباسات",
        "selectedEpisode.longPost": "منشور طويل",
        "selectedEpisode.bulletPoints": "نقاط رئيسية",
        "selectedEpisode.publicLink": "رابط عام",
        "selectedEpisode.embeddedId": "معرف مدمج",
        "selectedEpisode.episodeUrl": "رابط الحلقة"
      },
      "sidebar": {
        "tools": "الأدوات",
        "find.podcast.topic.ideas": "ابحث عن أفكار مواضيع البودكاست",
        "podcast.thumbnail.maker": "صانع الصور المصغرة للبودكاست",
        "podcast.seo.optimizer": "محسن SEO للبودكاست",
        "account": "الحساب",
        "payment.settings": "إعدادات الدفع",
        "support": "الدعم",
        "logout": "تسجيل الخروج",
        "plan": "الخطة",
        "resets.in": "إعادة تعيين في",
        "days": "أيام و",
        "hours": "ساعات",
        "api.access": "الوصول إلى الواجهة البرمجية",
        "upgrade.plan": "ترقية الخطة"
      },
      "updateEmailModal": {
        "email.validation.error": "يرجى إدخال عنوان بريد إلكتروني صالح.",
        "email.change.confirm": "هل أنت متأكد أنك تريد تغيير عنوان بريدك الإلكتروني؟",
        "email.change.success": "تم تغيير بريدك الإلكتروني بنجاح!",
        "email.in.use.error": "هذا البريد الإلكتروني قيد الاستخدام بالفعل. يرجى تجربة بريد آخر.",
        "email.recent.login.error": "قبل المتابعة في هذه العملية، يرجى تسجيل الدخول مرة أخرى باستخدام عنوان البريد الإلكتروني الحالي.",
        "email.invalid.error": "عنوان البريد الإلكتروني غير صالح. يرجى تجربة بريد آخر.",
        "subscription.cancel.error": "يرجى إلغاء اشتراكك المدفوع النشط أولاً.",
        "account.delete.confirm": "هل أنت متأكد أنك تريد حذف حسابك؟\n\nلا يمكن التراجع عن هذا الإجراء.",
        "account.delete.success": "تم حذف حسابك بنجاح.",
        "account.delete.error": "حدث خطأ ما ولم نتمكن من حذف حسابك.\n\nيرجى التواصل مع دعم المستخدم لدينا.",
        "subscription.cancel": "إلغاء الاشتراك",
        "account.delete": "حذف الحساب",
        "account.delete.warning": "حذف حسابك لا يمكن التراجع عنه وسيؤدي إلى مسح جميع محتوياتك ومعلومات تسجيل الدخول بشكل دائم. يرجى التقدم بحذر حيث لا يمكن التراجع عن هذا الإجراء.",
        "current.account.email": "البريد الإلكتروني الحالي للحساب",
        "enter.new.email": "أدخل بريدك الإلكتروني الجديد للحساب",
        "update": "تحديث",
        "change.password": "تغيير كلمة المرور",
        "payment.settings": "إعدادات الدفع"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "عنوان الحلقة"
      },
      "episodelist": {
        "loading.episodes": "جارٍ تحميل الحلقات",
        "no.episodes.found": "لم يتم العثور على حلقات. يرجى المحاولة مرة أخرى باستخدام معرف RSS صالح",
        "select.episode": "اختر الحلقة التي تريد إنشاء محتوى لها"
      },
      "interfaces": {
        "user.activePlan.tier": "الدرجة",
        "user.activePlan.creationDate": "تاريخ الإنشاء",
        "user.activePlan.minutesAvailable": "الدقائق المتاحة"
      },
      "loadingbar": {
        "loadingbar.magic": "نحن لا زلنا نعمل سحرنا ✨",
        "loadingbar.longer": "بعض الحلقات تأخذ وقتًا أطول قليلاً... 🐌",
        "loadingbar.hardwork": "خوادمنا تعمل بجد 🦾"
      },
      "page": {
        "main.background": "خلفية المكون الرئيسي"
      },
      "recordfile": {
        "microphone.camera.access.denied": "خطأ: تم رفض الوصول إلى الميكروفون أو الكاميرا.",
        "microphone.camera.not.found": "خطأ: لم يتم العثور على ميكروفون أو كاميرا.",
        "microphone.camera.not.readable": "خطأ: الميكروفون أو الكاميرا غير قابلة للقراءة.",
        "microphone.camera.access.error": "خطأ: حدث خطأ غير معروف أثناء الوصول إلى الميكروفون أو الكاميرا.",
        "media.not.recorded": "خطأ: لم يتم تسجيل أي وسائط.",
        "upload.failed": "خطأ: فشل التحميل.",
        "upload.success": "نجاح: تم إكمال التحميل بنجاح.",
        "upload.in.progress": "التحميل جارٍ...",
        "upload.button": "تحميل التسجيل",
        "stop.recording": "إيقاف التسجيل",
        "record.audio": "تسجيل الصوت",
        "record.audio.video": "تسجيل الصوت مع الفيديو",
        "record.again": "تسجيل مرة أخرى",
        "episode.language": "اختر لغة الحلقة"
      },
      "selectBox": {
        "language.english": "الإنجليزية",
        "language.arabic": "العربية",
        "language.bulgarian": "البلغارية",
        "language.catalan": "الكتالونية",
        "language.croatian": "الكرواتية",
        "language.czech": "التشيكية",
        "language.danish": "الدنماركية",
        "language.dutch": "الهولندية",
        "language.finnish": "الفنلندية",
        "language.french": "الفرنسية",
        "language.german": "الألمانية",
        "language.greek": "اليونانية",
        "language.hindi": "الهندية",
        "language.hungarian": "المجرية",
        "language.indonesian": "الإندونيسية",
        "language.italian": "الإيطالية",
        "language.japanese": "اليابانية",
        "language.korean": "الكورية",
        "language.lithuanian": "الليتوانية",
        "language.latvian": "اللاتفية",
        "language.malay": "المالاوية",
        "language.mandarin": "الماندرين",
        "language.norwegian": "النرويجية",
        "language.polish": "البولندية",
        "language.portuguese": "البرتغالية",
        "language.romanian": "الرومانية",
        "language.russian": "الروسية",
        "language.slovak": "السلوفاكية",
        "language.slovenian": "السلوفينية",
        "language.spanish": "الإسبانية",
        "language.swedish": "السويدية",
        "language.tamil": "التاميلية",
        "language.turkish": "التركية",
        "language.ukrainian": "الأوكرانية",
        "language.bashkir": "الباشكير",
        "language.basque": "الباسكية",
        "language.belarusian": "البيلاروسية",
        "language.cantonese": "الكانتونية",
        "language.esperanto": "الإسبرانتو",
        "language.estonian": "الإستونية",
        "language.galician": "الجاليكية",
        "language.interlingua": "الإنترلينغوا",
        "language.marathi": "الماراثية",
        "language.mongolian": "المغولية",
        "language.persian": "الفارسية",
        "language.thai": "التايلندية",
        "language.uyghur": "الأويغورية",
        "language.vietnamese": "الفيتنامية",
        "language.welsh": "الويلزية"
      },
      "selectedepisode": {
        "processing.episode": "معالجة الحلقة",
        "processing.time": "عادةً ما يستغرق بين 5 - 10 دقائق",
        "email.notification": "يمكنك إغلاق هذه النافذة. سنرسل لك بريدًا إلكترونيًا بمجرد أن تكون جاهزة. سيكون محتواك متاحًا أيضًا على لوحة التحكم الخاصة بك.",
        "not.enough.minutes.title": "ليس لديك مناسبات كافية",
        "not.enough.minutes.message": "ليس لديك مناسبات كافية لتحويل هذه الحلقة. يرجى تحديث خطة الموقع الخاصة بك.",
        "upgrade.plan": "تحديث خطة الموقع الخاصة بك",
        "convert.shorter.episode": "تحويل حلقة أقصر",
        "technical.difficulties": "عذرًا! نحن نواجه بعض الصعوبات التقنية. لا تقلق، فريقنا يعمل على حل المشكلة! يرجى المحاولة مرة أخرى لاحقًا.",
        "no.discount": "لا تقلق، لن نقوم بخصم أي دقائق!",
        "high.demand": "نحن نواجه طلبًا أعلى من المعتاد، لذا قد يستغرق معالجة طلبك وقتًا أطول من المعتاد. نعتذر عن أي إزعاج!",
        "email.ready": "سنرسل لك بريدًا إلكترونيًا بمجرد أن تكون جاهزة. يمكنك أيضًا الوصول إلى نتائجك على لوحة التحكم الخاصة بك.",
        "select.podcast.folder": "اختر مجلد البودكاست الذي تنتمي إليه هذه الحلقة، أو أنشئ واحدًا جديدًا عن طريق كتابة اسم.",
        "give.voice": "تخصيص صوت المجلد",
        "generate.content": "إنشاء محتوى",
        "content.ready": "محتواك جاهز!",
        "ask.ai.tune": "يمكنك أن تطلب من الذكاء الاصطناعي ضبط كل محتوى ليناسب احتياجاتك بشكل أفضل.",
        "convert.another.episode": "تحويل حلقة أخرى",
        "error.title": "خطأ",
        "convert.another.file": "تحويل ملف آخر"
      },
      "submitfile": {
        "file.size.exceeded.free": "حجم الملف يتجاوز الحد الأقصى البالغ 4 جيجابايت. <p>يرجى <a href='/pricing'><b><u>الترقية لتحميل ملفات أكبر</u></b></a></p>",
        "file.size.exceeded.paid": "حجم الملف يتجاوز الحد الأقصى البالغ 10 جيجابايت. <p>يرجى اختيار ملف أصغر.</p>",
        "file.upload.invalid": "يرجى تحميل ملف صوتي أو فيديو",
        "upload.in.progress": "جارٍ تحميل الملف. يرجى عدم إغلاق هذه النافذة.",
        "upload.button": "تحميل & إنشاء",
        "close.button": "إغلاق",
        "upgrade.message.free": "المزيد من التحميلات متاحة فقط للخطط المدفوعة.",
        "upgrade.now.button": "ترقية الآن",
        "pricing.info": "ابتداءً من 12 دولارًا شهريًا",
        "upload.file.label": "تحميل ملف صوتي أو فيديو",
        "max.file.size.free": "(الحد الأقصى 4 جيجابايت)",
        "max.file.size.paid": "(الحد الأقصى 10 جيجابايت)",
        "podsqueeze.audiograms.info": "سيقوم Podsqueeze بإنشاء مخططات صوتية لملفات الصوت ومقاطع قصيرة لملفات الفيديو",
        "file.placeholder": "ملف MP3/WAV الخاص بك",
        "episode.language.label": "لغة الحلقة",
        "multiple.files.selected": "{{count}} ملفات محددة",
        "clear.all": "مسح الكل",
        "file.name": "{{name}}",
        "multiple.files.toggle": "اختيار ملفات متعددة",
        "file.upload.error": "خطأ في تحميل الملف",
        "file.upload.success": "تم تحميل الملف بنجاح",
        "file.upload.processing": "جارٍ تحميل الملف",
        "click.to.upload": "اضغط لتحميل",
        "click.to.upload.multiple": "اضغط لتحميل ملفات متعددة",
        "select.folder.label": "حدد أو أنشئ مجلد",
        "enter.url": "أدخل الرابط",
        "upload.file": "تحميل ملف",
        "media.url.label": "رابط الوسائط",
        "media.url.help": "أدخل رابط ملف الصوت أو الفيديو الخاص بك. سنقوم بتنزيله ومعالجته لك.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "اسم الحلقة",
        "url.input.required": "الرجاء إدخال رابط الوسائط",
        "url.upload.error": "فشل في تحميل الوسائط من الرابط. يرجى التحقق من الرابط والمحاولة مرة أخرى.",
        "supported.formats": "الصيغ المدعومة",
        "uploading": "جارٍ التحميل...",
        "media.url.requirements": "يجب أن يكون عنوان URL رابطًا مباشرًا إلى ملف وسائط عام (وليس صفحة ويب)"
      },
      "submitrssid": {
        "error.selectRss": "يرجى اختيار RSS صالح من القائمة المنسدلة",
        "label.insertRssFeed": "أدخل خلاصة RSS الخاصة بك",
        "placeholder.insertRssFeed": "أدخل خلاصة RSS الخاصة بك",
        "label.searchByPodcast": "ابحث باسم البودكاست بدلاً من ذلك",
        "label.searchForPodcast": "ابحث عن اسم البودكاست الخاص بك",
        "placeholder.searchForPodcast": "ابحث عن بودكاست",
        "label.cantFindPodcast": "لا تستطيع العثور على البودكاست الخاص بك؟ ",
        "label.clickHereUseRss": "انقر هنا لاستخدام خلاصة RSS الخاصة بك بدلاً من ذلك",
        "label.selectedPodcast": "البودكاست المحدد",
        "label.episodeLanguage": "لغة الحلقة",
        "button.seeAllEpisodes": "عرض جميع الحلقات"
      },
      "submitsection": {
        "search.podcast": "ابحث عن البودكاست الخاص بك",
        "upload.audio.video": "قم بتحميل الصوت أو الفيديو",
        "record.audio": "سجل الصوت",
        "youtube.video": "رابط يوتيوب",
        "create.content": "لنقم بإنشاء محتوى لبودكاستك!",
        "select.folder.label": "حدد أو أنشئ قائمة"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "أدخل رابط فيديو يوتيوب",
        "error.insertYouTubeUrl": "يرجى إدخال رابط يوتيوب.",
        "label.insertYouTubeUrl": "إدخال رابط يوتيوب",
        "button.loading": "جار التحميل...",
        "message.downloadingFile": "جار تحميل الملف...",
        "error.processingFailed": "فشلت المعالجة",
        "button.submitYouTubeVideo": "إرسال فيديو يوتيوب",
        "error.youtubeVideoNotAvailable": "هذا الفيديو على يوتيوب غير متاح للتنزيل. يرجى رفع الصوت أو الفيديو الخاص بك مباشرة إلى بودسكويد.",
        "episode.language.label": "اللغة المستخدمة",
        "select.folder.label": "حدد أو أنشئ مجلد"
      },
      "tabs": {
        "tab.label.tab1": "علامة التبويب 1",
        "tab.label.tab2": "علامة التبويب 2",
        "tab.label.tab3": "علامة التبويب 3"
      },
      "tutorialVideo": {
        "tutorial.title": "استفد إلى أقصى حد من بودسكووز",
        "tutorial.chapter.introduction": "مقدمة",
        "tutorial.chapter.bestShowNotes": "احصل على أفضل ملاحظات العرض وتوقيتات الأحداث",
        "tutorial.chapter.blogPosts": "استخدام المدونات والنشرات الإخبارية",
        "tutorial.chapter.editingTranscripts": "تضمين وتحرير النصوص",
        "tutorial.chapter.personalizingAI": "تخصيص الذكاء الاصطناعي وإعطاء صوتك الخاص",
        "tutorial.chapter.speedingUpNotes": "تسريع ملاحظات العرض",
        "tutorial.chapter.creatingClips": "إنشاء مقاطع فيديو وصور",
        "tutorial.chapter.generatingLandingPage": "إنشاء صفحة هبوط",
        "tutorial.chapter.shareResults": "مشاركة النتائج مع فريقك",
        "tutorial.closeVideoCheckbox": "إغلاق الفيديو بمجرد جاهزية النتائج الأولى"
      },
      "uploadloadingbar": {
        "upload.loading": "جارٍ التحميل..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "اتصل بنا",
        "contact.section.email": "راسلنا عبر البريد الإلكتروني على support@podsqueeze.com",
        "contact.section.tiago.role": "مؤسس مشارك",
        "contact.section.joao.role": "مؤسس مشارك",
        "contact.section.image.alt.sendMessage": "إرسال رسالة",
        "contact.section.image.alt.tiago": "مؤسس مشارك في بودسكيز تياغو",
        "contact.section.image.alt.joao": "مؤسس مشارك في بودسكيز جوان"
      },
      "contactsection": {
        "contact.section.title": "اتصل بنا",
        "contact.section.email": "راسلنا عبر البريد الإلكتروني support@podsqueeze.com",
        "contact.section.tiago.role": "مؤسس مشارك",
        "contact.section.joao.role": "مؤسس مشارك",
        "contact.section.image.alt.sendMessage": "إرسال رسالة",
        "contact.section.image.alt.tiago": "مؤسس مشارك في بودسكيز تياغو",
        "contact.section.image.alt.joao": "مؤسس مشارك في بودسكيز جوان"
      },
      "home-agenciessection": {
        "join.content.creators": "انضم إلى 20,000 منشئ محتوى ومحترفي البودكاست الذين يستخدمون بودسكووز",
        "content.creators": "منشئو المحتوى",
        "podcast.managers": "مديرو البودكاست",
        "producers.studios": "المنتجون والاستوديوهات",
        "for.podcasters": "للبودكاسترز ومديري البودكاست والوكالات",
        "manage.content.creation": "إدارة إنشاء المحتوى بسهولة لـ",
        "multiple.podcasts": "عدة بودكاستات",
        "podsqueeze.description": "بودسكووز هو أداة قوية لجميع محترفي البودكاست. سواء كنت بودكاستر منفرد، أو مدير بودكاست، أو وكالة، يقدم بودسكووز جميع الميزات التي تحتاجها لتبسيط سير عمل إنشاء محتوى البودكاست الخاص بك.",
        "create.podcast.folders": "إنشاء مجلدات بودكاست للحفاظ على تنظيم حلقاتك.",
        "share.content.page": "شارك صفحة المحتوى الخاصة بك بسهولة مع العملاء والفريق",
        "tune.ai.voice": "ضبط صوت الذكاء الاصطناعي لكل عرض تديره",
        "plan.content.episodes": "خطط لمحتوى الحلقات القادمة باستخدام",
        "podcast.topics.finder": "أداة العثور على مواضيع البودكاست المتقدمة لدينا",
        "podsqueeze.testimonial": "تمكن بودسكووز من استخدام التعليمات لضبط محتوى كل بودكاست نديره وحفظه للحلقات المستقبلية، مما يسمح لنا بالحفاظ على تناسق أصوات كل عرض. هذه ميزة متميزة لم نجدها في أي أدوات أخرى",
        "coo.podigy": "المدير التنفيذي للعمليات في بوديجي بودكاست",
        "agenciessection.joinCreators": "انضم إلى 20,000 منشئ محتوى ومحترفي البودكاست الذين يستخدمون بودسكووز",
        "agenciessection.contentCreators": "منشئو المحتوى",
        "agenciessection.podcastManagers": "مديرو البودكاست",
        "agenciessection.producersStudios": "المنتجون والاستوديوهات",
        "agenciessection.forPodcasters": "للبودكاسترز ومديري البودكاست والوكالات",
        "agenciessection.manageContent": "إدارة إنشاء المحتوى بسهولة لـ",
        "agenciessection.multiplePodcasts": "عدة بودكاستات",
        "agenciessection.podsqueezeDescription": "بودسكووز هو أداة قوية لجميع محترفي البودكاست. سواء كنت بودكاستر منفرد، أو مدير بودكاست، أو وكالة، يقدم بودسكووز جميع الميزات التي تحتاجها لتبسيط سير عمل إنشاء محتوى البودكاست الخاص بك.",
        "agenciessection.createPodcastFolders": "إنشاء مجلدات بودكاست للحفاظ على تنظيم حلقاتك.",
        "agenciessection.shareContent": "شارك صفحة المحتوى الخاصة بك بسهولة مع العملاء والفريق",
        "agenciessection.tuneAI": "ضبط صوت الذكاء الاصطناعي لكل عرض تديره",
        "agenciessection.planContent": "خطط لمحتوى الحلقات القادمة باستخدام",
        "agenciessection.podcastTopicsFinder": "أداة العثور على مواضيع البودكاست المتقدمة لدينا",
        "agenciessection.podsqueezeQuote": "تمكن بودسكووز من استخدام التعليمات لضبط محتوى كل بودكاست نديره وحفظه للحلقات المستقبلية، مما يسمح لنا بالحفاظ على تناسق أصوات كل عرض. هذه ميزة متميزة لم نجدها في أي أدوات أخرى",
        "agenciessection.coO": "المدير التنفيذي للعمليات في بوديجي بودكاست"
      },
      "home-audioeditsection": {
        "new.feature": "ميزة جديدة",
        "seamless.editing": "تحرير سلس وتعزيز الصوت بشكل طبيعي، ",
        "high.quality.results": " نتائج عالية الجودة",
        "experience.seamless.audio.editing": "اختبر تحرير الصوت السلس مع خوارزميات الذكاء الاصطناعي المتقدمة لتسجيلات عالية الجودة. ",
        "remove.ums": "إزالة الترددات غير المرغوب فيها",
        "enhance.sound.quality": "، والصمت، وتعزيز جودة الصوت بنقرة واحدة فقط.",
        "enhance.audio.now": "تعزيز الصوت الآن",
        "sample.audio.recorded": "عينة صوتية، مسجلة مباشرة من الهاتف.",
        "original.recording": "التسجيل الأصلي",
        "audio.after.ai.edit": "الصوت بعد تحرير الذكاء الاصطناعي وتعزيزه",
        "experience.audio.editing": "اختبر تحرير الصوت السلس مع خوارزميات الذكاء الاصطناعي المتقدمة لتسجيلات عالية الجودة."
      },
      "home-blogsection": {
        "more.resources.label": "المزيد من الموارد لبودكاستك",
        "learn.how.to.get.most": "تعلم كيفية الاستفادة القصوى من",
        "your.content": "محتواك",
        "get.most.out.of.ai.content": "استفد إلى أقصى حد من المحتوى الذي تم إنشاؤه بواسطة الذكاء الاصطناعي لبودكاستك",
        "welcome.to.podsqueeze": "مرحبًا بك في بودسكووز – أسهل طريقة لتحويل بودكاستك إلى نص وإنشاء محتوى جذاب...",
        "will.google.penalize.ai.content": "هل ستعاقب جوجل محتواك الذي تم إنشاؤه بواسطة الذكاء الاصطناعي؟",
        "ai.content.discussion": "أدى ظهور المحتوى الذي تم إنشاؤه بواسطة الذكاء الاصطناعي إلى إشعال النقاشات ورفع المخاوف بين منشئي المحتوى والمسوقين وتحسين محركات البحث...",
        "what.is.rss.feed": "ما هو خلاصة RSS للبودكاست وكيفية استخدامها",
        "rss.feed.benefits": "كمنشئ بودكاست، قد تكون قد سمعت مصطلح 'خلاصة RSS' من قبل، لكن قد لا تعرف بالضبط ما هو أو كيف يمكن أن يفيدك...",
        "visit.blog": "زيارة المدونة"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "المقاطع والصوتيات",
        "clipsAndAudiograms.subtitle": "إعادة استخدام البودكاست الخاص بك إلى مقاطع بسهولة",
        "clipsAndAudiograms.description": "ما عليك سوى اختيار فصل من حلقتك وتصديره كمقطع أو صوتية لـ TikTok وInstagram وYouTube Shorts. اختر قالبًا وضبطه على أسلوبك الخاص.",
        "clipsAndAudiograms.createClips": "إنشاء مقاطع الآن",
        "textEditor.title": "محرر نصي",
        "textEditor.description": "قم بضبط مقاطعك والصوتيات مباشرة من الترجمة. حرر الترجمة وقم بقص الفيديو الخاص بك عن طريق إزالة كلمات معينة.",
        "oneClickShorts.title": "مقاطع بنقرة واحدة (<60 ثانية)",
        "oneClickShorts.description": "دع الذكاء الاصطناعي يتولى عملية التحرير نيابةً عنك. بضغطة زر، سيقوم الذكاء الاصطناعي بتقصير كل فصل من حلقاتك إلى أقل من 60 ثانية، جاهزًا للنشر كمقطع YouTube Short أو TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "تواصل مع المؤسسين",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- مطور ومقدم بودكاست",
        "contact.section.joao.role": "- مصمم تجربة المستخدم / واجهة المستخدم"
      },
      "home-contentexplanation": {
        "wide.variety.content": "تنوع واسع من المحتوى",
        "generate.content": "إنشاء محتوى مع",
        "one.click": " نقرة واحدة!",
        "transcript.srt": "النص الكامل وملف SRT",
        "transcript.description": "احصل على النص الكامل لحلقة البودكاست الخاصة بك، بالإضافة إلى ملف SRT جاهز لإنشاء الترجمة والتعليقات التوضيحية.",
        "show.notes": "ملاحظات العرض",
        "show.notes.description": "تلخيص الموضوعات الرئيسية التي تم تناولها في حلقتك وجعلها أكثر قابلية للبحث",
        "timestamps": "الطوابع الزمنية",
        "timestamps.description": "إنشاء فصول مع الطوابع الزمنية وإرشاد المستمعين إلى مقاطع محددة من حلقة البودكاست الخاصة بك",
        "blog.social.posts": "المدونة والمنشورات الاجتماعية",
        "blog.social.posts.description": "انشر عن حلقة البودكاست الخاصة بك في كل مكان واحصل على مستمعين جدد",
        "newsletter": "النشرة الإخبارية",
        "newsletter.description": "ابقِ مستمعيك على اطلاع بأحدث الحلقات",
        "titles.more": "العناوين والمزيد!",
        "titles.more.description": "إنشاء عناوين جذابة، اقتباسات، نقاط رئيسية، كلمات مفتاحية والمزيد!",
        "see.sample.content": "شاهد محتوى عينة",
        "wannabe.entrepreneur": "رائد أعمال طموح - #299 بودسكووز حقق للتو 100,000 دولار في الإيرادات السنوية!",
        "making.space": "خلق مساحة - ستيف هارفي: “يمكنك الاستمرار”",
        "modern.wisdom": "الحكمة الحديثة - إريك هويل - دليل إلى اللغز الأساسي للعقل"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "خط الفاصل"
      },
      "home-explanationsection": {
        "fast.accurate": "سريع ودقيق",
        "generate.content": "قم بإنشاء محتوى لبودكاستك مع",
        "power.of.ai": "قوة الذكاء الاصطناعي",
        "upload.image.alt": "رفع صورة",
        "select.episode": "اختر حلقة من خلاصة RSS الخاصة بك أو قم بتحميل ملف صوتي/مرئي",
        "paste.rss.feed": "ما عليك سوى لصق عنوان URL لخلاصة RSS الخاصة بك لاختيار حلقة من القائمة أو تحميل ملف صوتي أو مرئي.",
        "content.image.alt": "صورة المحتوى",
        "one.click.content": "احصل على كل المحتوى بنقرة واحدة!",
        "user.friendly.interface": "واجهة بديهية وسهلة الاستخدام يمكنك البدء في استخدامها على الفور. قم بإنشاء محتوى لبودكاستك بنقرة واحدة.",
        "tune.image.alt": "صورة الضبط",
        "edit.fine.tune": "قم بتحرير وضبط كل محتوى بدقة",
        "direct.edit.content": "قم بتحرير وضبط كل محتوى مباشرة حسب رغبتك باستخدام الذكاء الاصطناعي. على سبيل المثال، يمكنك طلب نغمة معينة، أو خطاب مباشر أو غير مباشر، أو ببساطة تصحيح الأسماء المكتوبة بشكل خاطئ.",
        "multiple.language.support": "دعم لغات متعددة",
        "language.flags.alt": "أعلام اللغات",
        "generate.content.aria": "إنشاء محتوى"
      },
      "home-featuressection": {
        "loading": "جار التحميل...",
        "transcribe.write.show.notes": "قم بتفريغ وكتابة ملاحظات العرض لبودكاستك",
        "twenty.times.faster": "أسرع بـ 20 مرة",
        "save.manual.work": "وفر ما يصل إلى 100% من العمل اليدوي. قم بتفريغ بودكاستك تلقائيًا بدقة متطورة مع تصنيف المتحدثين، وولّد ملاحظات عرض كاملة ومنشورات على وسائل التواصل الاجتماعي بصوتك الخاص.",
        "generate.content": "إنشاء محتوى",
        "transcripts": "نصوص",
        "full.transcript": "احصل على النص الكامل لحلقات بودكاستك ونصوص فيديوهات يوتيوب، بالإضافة إلى ملف SRT للترجمات.",
        "show.notes": "ملاحظات العرض",
        "summarize.generate.show.notes": "قم بتلخيص وإنشاء ملاحظات العرض بصوتك الخاص، مع الطوابع الزمنية، والنقاط الرئيسية، والذكر.",
        "blog.newsletter": "مدونة ونشرة إخبارية",
        "actionable.blog.posts": "احصل على منشورات مدونة قابلة للتنفيذ حول حلقاتك ونشرات إخبارية جاهزة للإرسال مع النقاط الرئيسية.",
        "social.media": "وسائل التواصل الاجتماعي",
        "short.posts.insights": "احصل على منشورات قصيرة ورؤى مختصرة لنشر الكلمة على وسائل التواصل الاجتماعي.",
        "quote": "من بين جميع أفضل أدوات تفريغ الصوت بالذكاء الاصطناعي التي اختبرناها، كانت Podsqueeze هي الأكثر فائدة في إنتاج ملاحظات العرض، والطوابع الزمنية، والعناوين، والذكر، ونماذج منشورات المدونة، والاقتباسات الرئيسية.",
        "justin.jackson": "جاستن جاكسون",
        "cofounder.transistor": "مؤسس مشارك في Transistor.fm",
        "transcribe_and_write_show_notes": "نسخ البودكاست، الملخصات، والمنشورات الاجتماعية",
        "twenty_times_faster": "أسرع بـ 20 مرة",
        "save_manual_work": "وفر ما يصل إلى 100% من العمل اليدوي. قم بتفريغ بودكاستك تلقائيًا بدقة متطورة مع تصنيف المتحدثين، وولّد ملاحظات عرض كاملة ومنشورات على وسائل التواصل الاجتماعي بصوتك الخاص.",
        "generate_content": "إنشاء محتوى",
        "full_transcript": "احصل على النص الكامل لحلقات بودكاستك ونصوص فيديوهات يوتيوب، بالإضافة إلى ملف SRT للترجمات.",
        "show_notes": "ملاحظات العرض",
        "summarize_and_generate_show_notes": "قم بتلخيص وإنشاء ملاحظات العرض بصوتك الخاص، مع الطوابع الزمنية، والنقاط الرئيسية، والذكر.",
        "blog_and_newsletter": "مدونة ونشرة إخبارية",
        "actionable_blog_posts": "احصل على منشورات مدونة قابلة للتنفيذ حول حلقاتك ونشرات إخبارية جاهزة للإرسال مع النقاط الرئيسية.",
        "social_media": "وسائل التواصل الاجتماعي",
        "short_posts_and_insights": "احصل على منشورات قصيرة ورؤى مختصرة لنشر الكلمة على وسائل التواصل الاجتماعي.",
        "testimonial": "من بين جميع أفضل أدوات تفريغ الصوت بالذكاء الاصطناعي التي اختبرناها، كانت Podsqueeze هي الأكثر فائدة في إنتاج ملاحظات العرض، والطوابع الزمنية، والعناوين، والذكر، ونماذج منشورات المدونة، والاقتباسات الرئيسية.",
        "cofounder_transistor": "مؤسس مشارك في Transistor.fm"
      },
      "home-page": {
        "main.background": "لون الخلفية للمكون الرئيسي"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "استمع إلى البودكاست الخاص بنا",
        "podcast.section.subtitle": "دروس متقدمة من",
        "podcast.section.highlight": "بودكاستر ذوي خبرة",
        "podcast.section.description": "استمع إلى البودكاست الخاص بنا، حيث نجري مقابلات مع بودكاستر ذوي خبرة ومستخدمي Podsqueeze من جميع أنحاء العالم. نطلب منهم مشاركة نصائحهم، ورؤاهم، وقصصهم، وكل ما تحتاج لمعرفته لتنمية بودكاستك الخاص.",
        "podcast.link.spotify": "استمع على سبوتيفاي",
        "podcast.link.apple": "استمع على آبل بودكاست",
        "podcast.link.youtube": "استمع على يوتيوب"
      },
      "home-spinner": {
        "spinner.loading": "جارٍ التحميل..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "قم بأتمتة البودكاست الخاص بك",
        "tagline.productionPromotion": "الإنتاج والترويج",
        "tagline.launchGrow": "قم بإطلاق وتنمية البودكاست الصوتي أو المرئي الخاص بك بسهولة مع كل ما تحتاجه في مكان واحد، بمساعدة الذكاء الاصطناعي.",
        "tagline.uploadGenerate": "قم بإنشاء نسخ البودكاست، الملخصات، المقاطع القصيرة مع الكتابات والمزيد بسهولة!",
        "tagline.singleClick": " كل ذلك بنقرة واحدة.",
        "tagline.transcripts": "نسخ البودكاست",
        "tagline.showNotes": "ملاحظات العرض",
        "tagline.newslettersBlogs": "النشرات الإخبارية والمدونات",
        "tagline.socialPosts": "المشاركات الاجتماعية",
        "tagline.shortClipsAudiograms": "مقاطع قصيرة وأوديوغرامات",
        "tagline.podcastWebsite": "موقع البودكاست",
        "tagline.aiAudioEnhancement": "تحسين الصوت بالذكاء الاصطناعي",
        "tagline.removeSilences": "إزالة الصمت والاهتزازات",
        "tagline.generateNow": "قم بالتوليد الآن مجانًا",
        "tagline.noCreditCard": "لا حاجة لبطاقة ائتمان",
        "testimonial.robWalling.title": "روب والينغ، شخصية ناشئة",
        "testimonial.robWalling.subtitle": "بودكاست الشركات الناشئة لبقية الناس",
        "testimonial.robWalling.quote": "كانت ملاحظات عرض Podsqueeze الأفضل. نستخدمها كثيرًا للحصول على ملخصات ورؤى من بودكاستات أخرى.",
        "testimonial.johnGarmet.title": "جون غارميت، مدير العمليات",
        "testimonial.johnGarmet.subtitle": "شركة هيرد ميديا",
        "testimonial.johnGarmet.quote": "تساعدنا Podsqueeze على أن نكون أكثر كفاءة وتوليد المزيد من المحتوى لعملائنا. نوصي بها بشدة.",
        "testimonial.davidJackson.title": "ديفيد جاكسون، مدرب بودكاست",
        "testimonial.davidJackson.subtitle": "مدرسة البودكاست",
        "testimonial.davidJackson.quote": "تعد Podsqueeze شريكتي في العصف الذهني. إنها أفضل طريقة للتوصل إلى تسويق البودكاست."
      },
      "home-testimonials": {
        "testimonials.title": "ماذا يقول الناس عن بودسكووز",
        "testimonials.image.alt": "بودسكووز - إعادة استخدام محتوى البودكاست الخاص بك باستخدام الذكاء الاصطناعي | منتج الصيد",
        "testimonials.heading": "ماذا يقول الناس عن بودسكووز"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "كلمة المرور غير صحيحة",
        "error.userNotFound": "المستخدم غير موجود",
        "error.somethingWentWrong": "عذرًا، حدث خطأ ما",
        "button.sendResetEmail": "إرسال بريد إعادة تعيين كلمة المرور",
        "button.login": "تسجيل الدخول",
        "placeholder.email": "عنوان البريد الإلكتروني",
        "placeholder.password": "كلمة المرور",
        "link.forgotPassword": "نسيت كلمة المرور؟",
        "link.createAccount": "إنشاء حساب",
        "text.or": "أو",
        "button.continueWithGoogle": "تابع باستخدام جوجل",
        "text.podcastDescription": "أطلق وطور بودكاست الصوت أو الفيديو الخاص بك بسهولة مع كل ما تحتاجه في مكان واحد.",
        "feature.transcripts": "نصوص",
        "feature.showNotes": "ملاحظات العرض",
        "feature.newslettersAndBlogs": "النشرات الإخبارية والمدونات",
        "feature.socialPosts": "المشاركات الاجتماعية",
        "feature.shortClipsAndAudiograms": "مقاطع قصيرة وأوديوغرامات",
        "feature.podcastWebsite": "موقع البودكاست",
        "feature.aiAudioEnhancement": "تحسين الصوت بالذكاء الاصطناعي",
        "feature.removeSilences": "إزالة الصمت والاهتزازات",
        "button.sendVerificationEmail": "إرسال بريد التحقق",
        "error.emailNotVerified": "البريد الإلكتروني غير موثق"
      },
      "page": {
        "login.form": "نموذج تسجيل الدخول"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "صفحة الشركاء في بودسكووز",
        "affiliate.page.description": "احصل على عمولة بنسبة 25% على كل عملية بيع تتم من خلال رابط الإحالة الخاص بك لمدة 15 شهرًا. شارك رابطك على موقعك الإلكتروني، وسائل التواصل الاجتماعي، أو مع أصدقائك. الانضمام يستغرق ثوانٍ. يتم الموافقة عليك تلقائيًا."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "أفضل هدية لمنشئ البودكاست",
        "bestGiftForPodcaster.description": "اكتشف أفضل الهدايا لمنشئي البودكاست لتعزيز تجربتهم.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "احصل على المزيد من مستمعي البودكاست",
        "get-more-podcast-listeners.description": "احصل على المزيد من مستمعي البودكاست وسهّل عملية الإنتاج مع ملاحظات العرض التلقائية، ومقاطع قصيرة لتنمية عرضك على وسائل التواصل الاجتماعي والمزيد."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "نمو جمهور البودكاست الخاص بك",
        "grow_your_podcast_audience.description": "وفر الكثير من الوقت وزد جمهور البودكاست الخاص بك مع بودسكووز. قم بإنشاء ملاحظات كاملة للعرض، ومنشورات على وسائل التواصل الاجتماعي، ومقاطع قصيرة والمزيد لبودكاستك."
      },
      "index": {
        "home.page.title": "ملاحظات عرض البودكاست بالذكاء الاصطناعي، النصوص، الملخصات ومولد المقاطع.",
        "home.page.description": "قم بإنشاء ملاحظات العرض، الطوابع الزمنية، النشرات الإخبارية والمزيد لبودكاستك بنقرة واحدة! قم بإنشاء محتوى لبودكاستك بسرعة وقم بتعديله وفقًا لاحتياجاتك. التسجيل مجاني."
      },
      "login": {
        "login.tryItNow": "جربه الآن!",
        "login.createAccountDescription": "أنشئ حسابًا وابدأ في إنشاء ملاحظات العرض، والتوقيتات، والنشرات الإخبارية والمزيد لبودكاستك بنقرة واحدة! قم بإنشاء محتوى لبودكاستك بسرعة واضبطه وفقًا لاحتياجاتك. التسجيل مجاني."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "التسويق للبودكاست",
        "marketing.for.podcasts.description": "تعمل Podsqueeze على تبسيط التسويق للبودكاست من خلال ملاحظات العرض التي يتم إنشاؤها تلقائيًا، ومنشورات وسائل التواصل الاجتماعي، ومقاطع الفيديو القصيرة لزيادة نطاق وصولك وتنمية عرضك."
      },
      "media": {
        "media.page.title": "صفحة وسائط بودسكووز",
        "media.page.description": "تعرف على المزيد حول بودسكووز. تواصل معنا! نود التعاون!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "مولد وصف البودكاست",
        "podcast.description.generator.description": "قم بتحسين وصول البودكاست الخاص بك وتفاعله مع أوصاف مولدة بواسطة الذكاء الاصطناعي. قم بأتمتة كتابة ملاحظات العرض واستعد وقتك الثمين."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "إعادة استخدام البودكاست الخاص بك لمنشورات وسائل التواصل الاجتماعي",
        "convert.podcast.episodes.to.social.media.posts": "تحويل حلقات البودكاست إلى منشورات على وسائل التواصل الاجتماعي. توليد المنشورات تلقائيًا لـ LinkedIn و Twitter و Facebook ومقاطع قصيرة لـ TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "مولد مواضيع البودكاست المجاني",
        "podcast.topics.generator.description": "يتيح لك مولد مواضيع البودكاست المجاني لدينا العثور على أفضل أفكار المواضيع ويتنبأ بمدى وصولها المحتمل على جوجل ويوتيوب."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "مساعدك الافتراضي للبودكاست",
        "podcast.virtual.assistant.description": "مساعد افتراضي للبودكاست يعتمد على الذكاء الاصطناعي يكتب ملاحظات برنامجك وينشئ منشورات لوسائل التواصل الاجتماعي. قم بتبسيط إنتاج وتسويق البودكاست الخاص بك مع Podsqueeze."
      },
      "pricing": {
        "pricing.title": "التسعير",
        "pricing.description": "قم بإنشاء ملاحظات العرض، والطوابع الزمنية، والنشرات الإخبارية والمزيد للبودكاست الخاص بك بنقرة واحدة! لدينا عدة مستويات أسعار لتلبية احتياجاتك في البودكاست."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "روّج لبودكاستك",
        "promote.your.podcast.description": "قم بإنشاء ملاحظات العرض، ومنشورات وسائل التواصل الاجتماعي، ومقاطع قصيرة لنشرها والترويج لبودكاستك في بضع دقائق فقط."
      },
      "register": {
        "create.podsqueeze.account": "إنشاء حساب Podsqueeze",
        "generate.content.podcast": "قم بإنشاء ملاحظات العرض، والتوقيتات، والنشرات الإخبارية والمزيد لبودكاستك بنقرة واحدة! قم بسرعة بإنشاء محتوى لبودكاستك وضبطه وفقًا لاحتياجاتك. التسجيل مجاني."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "إعادة استخدام محتوى البودكاست تلقائيًا",
        "repurpose.your.podcast.content.with.ai": "إعادة استخدام محتوى البودكاست الخاص بك باستخدام الذكاء الاصطناعي. قم بإنشاء ملاحظات العرض، والعناوين، ومقاطع قصيرة لتطبيق تيك توك، والمزيد، بكل سهولة بنقرة واحدة!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "محسن SEO للبودكاست (مجاني)",
        "seo.optimizer.description": "حلل وحسّن حلقات البودكاست الخاصة بك لظهور أفضل في محركات البحث مع توصيات SEO مدعومة بالذكاء الاصطناعي.",
        "seo.optimizer.heading": "محسن SEO للبودكاست",
        "seo.optimizer.headingnote": "حلل وحسّن حلقات البودكاست الخاصة بك لظهور أفضل في محركات البحث مع توصيات SEO مدعومة بالذكاء الاصطناعي.",
        "seo.optimizer.selectEpisode": "اختر حلقة لتحليلها",
        "seo.optimizer.results": "نتائج تحليل SEO",
        "seo.optimizer.searchPodcastPlaceholder": "ابحث عن بودكاست",
        "seo.optimizer.searchEpisodesPlaceholder": "ابحث عن الحلقات...",
        "seo.optimizer.analyseAnotherEpisode": "حلل حلقة أخرى",
        "seo.optimizer.findingEpisodes": "جاري العثور على جميع الحلقات...",
        "seo.optimizer.analysingEpisode": "جاري تحليل الحلقة",
        "seo.optimizer.scoreTooltip": "النتيجة:",
        "seo.optimizer.topKeywords": "حددنا هذه الكلمات المفتاحية الرئيسية:",
        "seo.optimizer.topKeywordsnote": "استنادًا إلى تحليل الكلمات المفتاحية في أسفل الصفحة.",
        "seo.optimizer.optimizedContent": "استنادًا إلى الكلمات المفتاحية، إليك العنوان والوصف المحسنين:",
        "seo.optimizer.originalTitle": "العنوان الأصلي",
        "seo.optimizer.optimizedTitle": "العنوان المحسن",
        "seo.optimizer.originalDescription": "الوصف الأصلي",
        "seo.optimizer.optimizedDescription": "الوصف المحسن",
        "seo.optimizer.showMore": "عرض المزيد",
        "seo.optimizer.showLess": "عرض أقل",
        "seo.optimizer.keywordAnalysis": "تحليل الكلمات المفتاحية",
        "seo.optimizer.keywordAnalysisnote": "يتم حساب الدرجات بناءً على حجم البحث والمنافسة (عدد النتائج الأخرى لنفس الكلمة المفتاحية) وفي حالة يوتيوب، متوسط عدد المشاهدات لكل فيديو لنفس الكلمة المفتاحية.",
        "seo.optimizer.seoScore": "درجة SEO",
        "seo.optimizer.spotifyScore": "درجة Spotify",
        "seo.optimizer.youtubeScore": "درجة YouTube",
        "seo.optimizer.totalScore": "الإجمالي"
      },
      "squeeze": {
        "podsqueeze.title": "بودسكووز - أداة توليد محتوى البودكاست بالذكاء الاصطناعي",
        "podsqueeze.description": "قم بإنشاء ملاحظات الحلقة، وتوقيتات، ونشرات إخبارية والمزيد لبودكاستك بنقرة واحدة! قم بسرعة بإنشاء محتوى لبودكاستك وضبطه وفقًا لاحتياجاتك. التسجيل مجاني."
      },
      "thumbnail-creator": {
        "title": "مولد مصغرات البودكاست المجاني - إنشاء مصغرات الحلقات بالذكاء الاصطناعي",
        "description": "إنشاء مصغرات بودكاست مذهلة بالذكاء الاصطناعي. إنتاج أعمال فنية احترافية وجذابة للحلقات تزيد من الرؤية وتجذب المزيد من المستمعين إلى بودكاستك.",
        "selectPodcast": "اختر البودكاست الخاص بك",
        "loadEpisodes": "تحميل الحلقات",
        "selectEpisode": "اختر حلقة لإنشاء مصغرة",
        "createThumbnail": "إنشاء مصغرة",
        "results": "المصغرة المولدة الخاصة بك",
        "download": "تحميل",
        "share": "مشاركة",
        "regenerate": "إعادة إنتاج",
        "editThumbnail": "تحرير المصغرة",
        "editPlaceholder": "صف كيف تريد تعديل هذه المصغرة...",
        "customPrompt": "موجه مخصص",
        "yourThumbnail": "مصغرتك",
        "createAnother": "← إنشاء مصغرة أخرى",
        "findingEpisodes": "البحث عن الحلقات...",
        "searchPodcastPlaceholder": "ابحث عن البودكاست الخاص بك...",
        "searchingPodcasts": "البحث عن البودكاست...",
        "heroDescription": "إنتاج مصغرات بودكاست مذهلة ومهنية بتصميم مدعوم بالذكاء الاصطناعي يجذب الانتباه ويزيد من رؤية حلقاتك.",
        "generatedWithPrompt": "تم إنتاجه بالموجه:",
        "customPromptPlaceholder": "أدخل موجهاً مخصصاً لإنتاج المصغرة...",
        "generating": "إنتاج...",
        "generate": "إنتاج",
        "modernMinimalist": "عصري وبسيط",
        "vibrantDynamic": "نابض بالحياة وديناميكي",
        "professionalClean": "مهني ونظيف",
        "generatingThumbnail": "إنتاج المصغرة...",
        "generatingNewThumbnail": "إنتاج مصغرة جديدة...",
        "showingFirstEpisodes": "عرض أول 10 حلقات. استخدم البحث للعثور على حلقات محددة.",
        "imageUrlCopied": "تم نسخ رابط الصورة إلى الحافظة!",
        "failedToGenerate": "فشل في إنتاج المصغرة. يرجى المحاولة مرة أخرى.",
        "promotionalTitle": "إنتاج ملاحظات العرض والطوابع الزمنية والمقاطع الفيروسية والمزيد مع Podsqueeze",
        "promotionalSubtitle": "انضم إلى أكثر من 100 ألف منشئ آخر وابدأ في تنمية عرضك",
        "startNow": "ابدأ الآن",
        "free": "مجاني",
        "podcast": "بودكاست",
        "thumbnail": "مصغرة",
        "creator": "منشئ",
        "replaceFace": "استبدال الوجه",
        "uploading": "جاري الرفع...",
        "uploadImageError": "يرجى رفع ملف صورة.",
        "uploadFailedError": "فشل في رفع الصورة. يرجى المحاولة مرة أخرى.",
        "uploadingImage": "جاري رفع الصورة...",
        "generatingNewThumbnailLoading": "إنتاج مصغرة جديدة...",
        "failedToGenerateWithFace": "فشل في إنتاج المصغرة مع استبدال الوجه. يرجى المحاولة مرة أخرى."
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "جاري تحميل الحلقات...",
        "episodeList.noEpisodes": "لا توجد حلقات عامة متاحة",
        "episodeList.checkBack": "عد لاحقاً للاطلاع على الحلقات الجديدة",
        "episodeList.title": "حلقات هذا البودكاست",
        "episodeList.readLess": "عرض أقل",
        "episodeList.readMore": "قراءة المزيد",
        "episodeList.coverImageAlt": "غلاف {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "ابدأ الآن",
        "alert.subscriptionRunning": "اشتراكك الحالي لا يزال ساريًا.\n\nيرجى إلغاء اشتراكك الحالي قبل شراء اشتراك جديد.",
        "alert.subscriptionEnds": "اشتراكك الحالي لا يزال ساريًا.\n\nسينتهي في {date}",
        "alert.subscriptionCancelled": "لقد تم إلغاء اشتراكك بالفعل وسينتهي في {date}",
        "button.openDashboard": "فتح لوحة التحكم",
        "button.signUp": "سجل الآن",
        "button.buySubscription": "شراء اشتراك",
        "button.cancelled": "ملغى",
        "button.cancelSubscription": "إلغاء الاشتراك",
        "button.upgradeSubscription": "ترقية الاشتراك",
        "button.loading": "جارٍ التحميل",
        "upgrade.details.currentMinutes": "سيبدأ هذا فترة اشتراك جديدة. ستحتفظ بجميع دقائقك الحالية.",
        "upgrade.details.remainingAnnual": "تم حساب هذه القيمة بناءً على الوقت المتبقي في اشتراكك السنوي الحالي."
      },
      "page": {
        "pricing.free.title": "مجاني",
        "pricing.free.subtitle": "جرب Podsqueeze. لا حاجة لبطاقة ائتمان.",
        "pricing.free.price.annual": "$0 يتم الفوترة سنويًا",
        "pricing.free.features.podcast_time": "30 دقيقة من وقت البودكاست شهريًا",
        "pricing.free.features.video_clips": "3 مقاطع فيديو",
        "common.with_watermark": "مع علامة مائية",
        "pricing.free.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.free.features.file_upload": "رفع ملفات حتى 4 جيجابايت",
        "pricing.free.features.upload": "رفع واحد",
        "pricing.free.features.landing_pages": "صفحات هبوط للبودكاست",
        "pricing.free.features.audio_enhancement": "تعزيز الصوت",
        "common.sign_up": "سجل الآن",
        "common.open_dashboard": "افتح لوحة التحكم",
        "pricing.starter.title": "بداية",
        "pricing.starter.subtitle": "مثالي لمقدمي البودكاست الهواة الذين يرغبون في توفير الوقت.",
        "pricing.starter.price.annual": "$132 يتم الفوترة سنويًا",
        "pricing.billed_annually": "يتم الفوترة سنويًا",
        "minutes.accumulate": "ترحيل الدقائق",
        "pricing.starter.features.podcast_time": "160 دقيقة من وقت البودكاست شهريًا",
        "pricing.starter.features.video_clips": "10 مقاطع فيديو أو مقاطع صوتية",
        "pricing.starter.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.starter.features.file_upload": "رفع ملفات حتى 4 جيجابايت",
        "pricing.starter.features.unlimited_uploads": "رفع غير محدود",
        "pricing.starter.features.landing_pages": "صفحات هبوط للبودكاست",
        "pricing.pro.title": "محترف",
        "pricing.pro.subtitle": "للمحترفين الذين يستخدمون البودكاست لتطوير ودعم أعمالهم.",
        "pricing.pro.price.annual": "$324 يتم الفوترة سنويًا",
        "pricing.pro.features.podcast_time": "320 دقيقة من وقت البودكاست شهريًا",
        "pricing.pro.features.personalize_ai_voice": "تخصيص صوت الذكاء الاصطناعي",
        "pricing.pro.features.video_clips": "20 مقطع فيديو أو مقطع صوتي",
        "common.no_watermark": "بدون علامة مائية",
        "pricing.pro.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.pro.features.file_upload": "رفع ملفات حتى 10 جيجابايت",
        "pricing.pro.features.unlimited_uploads": "رفع غير محدود",
        "pricing.pro.features.landing_pages": "صفحات هبوط للبودكاست",
        "common.customizable": "قابل للتخصيص",
        "pricing.pro.features.audio_video_edit": "تحرير سحري للصوت والفيديو",
        "pricing.agency_lite.title": "وكالة لايت",
        "pricing.agency_lite.subtitle": "لوكالات البودكاست التي ترغب في تبسيط وتنمية أعمالها.",
        "pricing.agency_lite.price.annual": "$495 يتم الفوترة سنويًا",
        "pricing.agency_lite.features.podcast_time": "600 دقيقة من وقت البودكاست شهريًا",
        "pricing.agency_lite.features.personalize_ai_voice": "تخصيص صوت الذكاء الاصطناعي",
        "pricing.agency_lite.features.video_clips": "40 مقطع فيديو أو مقطع صوتي",
        "pricing.agency_lite.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.agency_lite.features.file_upload": "رفع ملفات حتى 10 جيجابايت",
        "pricing.agency_lite.features.unlimited_uploads": "رفع غير محدود",
        "pricing.agency_lite.features.landing_pages": "صفحات هبوط للبودكاست",
        "pricing.agency_lite.features.audio_video_edit": "تحرير سحري للصوت والفيديو",
        "pricing.agency_plus.title": "وكالة بلس",
        "pricing.agency_plus.subtitle": "لوكالات البودكاست التي ترغب في تبسيط وتنمية أعمالها.",
        "pricing.agency_plus.price.annual": "$1.251 يتم الفوترة سنويًا",
        "pricing.agency_plus.features.podcast_time": "2000 دقيقة من وقت البودكاست شهريًا",
        "pricing.agency_plus.features.personalize_ai_voice": "تخصيص صوت الذكاء الاصطناعي",
        "pricing.agency_plus.features.video_clips": "80 مقطع فيديو أو مقطع صوتي",
        "pricing.agency_plus.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.agency_plus.features.file_upload": "رفع ملفات حتى 10 جيجابايت",
        "pricing.agency_plus.features.unlimited_uploads": "رفع غير محدود",
        "pricing.agency_plus.features.landing_pages": "صفحات هبوط للبودكاست",
        "pricing.agency_plus.features.audio_video_edit": "تحرير سحري للصوت والفيديو",
        "pricing.agency_scale.title": "وكالة سكيل",
        "pricing.agency_scale.subtitle": "لوكالات البودكاست التي ترغب في تبسيط وتنمية أعمالها.",
        "pricing.agency_scale.price.annual": "$2.175 يتم الفوترة سنويًا",
        "pricing.agency_scale.features.podcast_time": "4000 دقيقة من وقت البودكاست شهريًا",
        "pricing.agency_scale.features.personalize_ai_voice": "تخصيص صوت الذكاء الاصطناعي",
        "pricing.agency_scale.features.video_clips": "160 مقطع فيديو أو مقطع صوتي",
        "pricing.agency_scale.features.quote_images": "صور اقتباس غير محدودة",
        "pricing.agency_scale.features.file_upload": "رفع ملفات حتى 10 جيجابايت",
        "pricing.agency_scale.features.unlimited_uploads": "رفع غير محدود",
        "pricing.agency_scale.features.landing_pages": "صفحات هبوط للبودكاست",
        "pricing.agency_scale.features.audio_video_edit": "تحرير سحري للصوت والفيديو",
        "pricing.header": "لمقدمي البودكاست الفرديين ووكالات البودكاست",
        "pricing.minutes_reset": "يمكنك تجميع ما يصل إلى 3 أضعاف دقائقك الشهرية، طالما أنك تبقى على خطتك الحالية أو تقوم بالترقية.",
        "pricing.most_popular": "أكثر شعبية",
        "pricing.minutes_per_month": "دقائق في الشهر",
        "pricing.enterprise_title": "المؤسسة",
        "pricing.enterprise_subtitle": "لوكالات وشركات الوساطة التي ترغب في تطوير أعمالها.",
        "pricing.enterprise_price": "مخصص",
        "pricing.enterprise_price_note": "ابق على تواصل مع team@podsqueeze.com أو حجز موعد معنا أدناه.",
        "pricing.enterprise_feature_priority_support": "دعم الأولوية",
        "pricing.enterprise_feature_team_sits": "مقاطع صوتية متعددة",
        "pricing.enterprise_personalized_team_training": "تدريب الفريق والتوثيق",
        "pricing.book_demo": "حجز موعد"
      },
      "toggle": {
        "pay.monthly": "شهري",
        "pay.annually": "سنوي",
        "discount.30percent": "30% خصم"
      },
      "upgradeModal": {
        "upgrade.success": "تم ترقية اشتراكك بنجاح",
        "upgrade.error": "نأسف، حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا",
        "upgrade.loading": "جارٍ الترقية",
        "upgrade.confirmPay": "تأكيد والدفع",
        "upgrade.cancel": "إلغاء",
        "coupon.placeholder": "رمز القسيمة",
        "coupon.apply": "تطبيق",
        "coupon.have": "لدي قسيمة",
        "upgrade.confirmation": "أنت على وشك الترقية إلى",
        "upgrade.price": "سوف تدفع"
      }
    },
    "register": {
      "page": {
        "register.form": "نموذج التسجيل"
      },
      "registerForm": {
        "error.invalidCredentials": "يرجى إدخال عنوان بريد إلكتروني وكلمة مرور صحيحة.",
        "error.weakPassword": "يرجى استخدام كلمة مرور أقوى 💪",
        "error.emailInUse": "المستخدم موجود بالفعل",
        "error.userNotFound": "لم يتم العثور على المستخدم",
        "error.generic": "عذرًا، حدث خطأ ما",
        "placeholder.email": "عنوان البريد الإلكتروني",
        "placeholder.password": "كلمة المرور",
        "button.registering": "جارٍ التسجيل...",
        "button.register": "تسجيل",
        "label.newsletter": "انضم إلى 12,000 بودكاستر واشترك في نشرتنا الإخبارية للحصول على تحديثات المنتجات، ونصائح قابلة للتنفيذ، وكتب إلكترونية، وهدايا والمزيد.",
        "label.alreadyHaveAccount": "هل لديك حساب بالفعل؟",
        "label.logInHere": "قم بتسجيل الدخول هنا",
        "label.or": "أو",
        "button.signingIn": "جارٍ تسجيل الدخول...",
        "button.continueWithGoogle": "تابع باستخدام جوجل",
        "label.podcastDescription": "أطلق ونمِّ بودكاستك الصوتي أو المرئي بسهولة مع كل ما تحتاجه في مكان واحد.",
        "feature.transcripts": "نصوص",
        "feature.showNotes": "ملاحظات العرض",
        "feature.newslettersBlogs": "نشرات إخبارية ومدونات",
        "feature.socialPosts": "منشورات اجتماعية",
        "feature.shortClips": "مقاطع قصيرة ومقاطع صوتية",
        "feature.podcastWebsite": "موقع البودكاست",
        "feature.audioEnhancement": "تحسين الصوت بالذكاء الاصطناعي",
        "feature.removeSilences": "إزالة الصمت والـ 'أمم'"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "نص"
      },
      "TopicFinder": {
        "competition.veryHigh": "مرتفع جداً",
        "competition.high": "مرتفع",
        "competition.medium": "متوسط",
        "competition.low": "منخفض",
        "competition.veryLow": "منخفض جداً",
        "upgrade.button": "ترقية إلى برو",
        "clicks.label": "نقرات",
        "searches.label": "عمليات البحث",
        "competition.label": "المنافسة",
        "fetching.results": "جاري جلب النتائج",
        "table.topic": "الموضوع",
        "tooltip.topic": "الموضوع الرئيسي الذي يغطيه حلقة البودكاست الخاصة بك",
        "table.monthlySearches": "عمليات البحث الشهرية",
        "tooltip.monthlySearches": "نطاق عمليات البحث الشهرية على جوجل التي قد تتوقعها",
        "table.competition": "المنافسة",
        "tooltip.competition": "الموضوع الرئيسي أو الموضوع الذي يغطيه البودكاست.",
        "table.monthlyGoogleClicks": "نقرات جوجل الشهرية",
        "tooltip.monthlyGoogleClicks": "توقع لنطاق النقرات الشهرية على جوجل التي قد تتوقعها",
        "table.youtubeReach": "الوصول على يوتيوب",
        "tooltip.youtubeReach": "توقع لأقصى عدد من المشاهدات على يوتيوب التي قد تتوقعها في الأشهر الستة الأولى، بناءً على متوسط المنافسين",
        "intro.title": "مولد مواضيع البودكاست المجاني",
        "intro.description": "احصل على أفكار لمواضيع البودكاست التي يبحث عنها الجمهور",
        "intro.check1": "تحقق من الطلب على كل فكرة موضوع على جوجل",
        "intro.check2": "اكتشف مدى تنافسية كل فكرة موضوع بودكاست",
        "intro.check3": "قدّر النقرات على جوجل والمشاهدات على يوتيوب التي يمكنك الحصول عليها",
        "upgrade.message": "تحتاج إلى ترقية إلى برو للوصول إلى جميع النتائج",
        "learnMore.label": "تعرف على المزيد حول",
        "learnMore.link": "أداة مولد مواضيع البودكاست المجاني",
        "newSearch.button": "بحث جديد",
        "share.button": "مشاركة هذا البحث",
        "form.label": "أدخل مجالات البودكاست الخاصة بك",
        "form.placeholder": "التسويق الرقمي",
        "form.submit": "ابحث عن أفكار المواضيع"
      },
      "page": {
        "main.background": "خلفية"
      },
      "shareTopics": {
        "share.results": "مشاركة النتائج",
        "share.facebook": "مشاركة على فيسبوك",
        "share.whatsapp": "مشاركة على واتساب",
        "share.twitter": "مشاركة على تويتر",
        "share.linkedin": "مشاركة على لينكد إن",
        "copy.success": "تم النسخ",
        "copy.link": "نسخ الرابط"
      },
      "youtubeScore": {
        "loading.placeholder": "١٢٣٤",
        "views.label": "مشاهدات"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "لم يتمكن من الحصول على التركيبة الحالية",
        "error.addImage": "خطأ في إضافة عنصر الصورة:",
        "alert.uploadImage": "يرجى رفع ملف صورة.",
        "error.uploadImage": "خطأ في رفع الصورة:",
        "alert.uploadFailed": "فشل في رفع الصورة. يرجى المحاولة مرة أخرى.",
        "error.getDownloadURL": "خطأ في الحصول على رابط التحميل:",
        "alert.processImageFailed": "فشل في معالجة الصورة المرفوعة. يرجى المحاولة مرة أخرى.",
        "error.addText": "خطأ في إضافة عنصر النص:",
        "text.settingsPlaceholder": "ستظهر الإعدادات عند تحديد العنصر",
        "text.addElement": "إضافة عنصر",
        "text.uploading": "جارٍ الرفع...",
        "button.uploadImage": "رفع صورة",
        "text.newText": "نص جديد",
        "button.addText": "إضافة نص",
        "text.selectedElementSettings": "إعدادات العنصر المحدد"
      },
      "FontSelector": {
        "allFonts": "جميع الخطوط",
        "myFonts": "خطوطي",
        "uploadFont": "تحميل الخط",
        "noCustomFonts": "لا توجد خطوط مخصصة حتى الآن.",
        "uploadToAdd": "قم بتحميل ملف خط لإضافته إلى مجموعتك.",
        "text_outline": "محيط النص",
        "outline_color": "لون المحيط",
        "outline_width": "سمك المحيط"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "تناسب",
        "imageLayoutSettings.zoom": "تكبير",
        "imageLayoutSettings.horizontalAlignment": "محاذاة أفقية",
        "imageLayoutSettings.verticalAlignment": "محاذاة عمودية",
        "imageLayoutSettings.deleteElement": "حذف العنصر"
      },
      "TemplateBox": {
        "confirm.delete.template": "هل أنت متأكد أنك تريد حذف هذا القالب؟"
      },
      "TextSettings": {
        "error.getting_current_text": "خطأ في الحصول على النص الحالي:",
        "event.delete_text_element_clicked": "تم النقر على حذف عنصر النص",
        "error.changing_text_font": "خطأ في تغيير خط النص:",
        "event.text_font_changed": "تم تغيير خط النص",
        "error.changing_text_size": "خطأ في تغيير حجم النص:",
        "event.text_size_changed": "تم تغيير حجم النص",
        "error.changing_text_color": "خطأ في تغيير لون النص:",
        "event.text_color_changed": "تم تغيير لون النص",
        "event.text_content_added": "تم إضافة محتوى النص",
        "error.adding_text_content": "خطأ في إضافة محتوى النص:",
        "event.text_content_updated": "تم تحديث محتوى النص",
        "label.text_content": "محتوى النص",
        "label.text_font": "خط النص",
        "label.adjust_text_size": "تعديل حجم النص",
        "label.text_color": "لون النص",
        "button.delete": "حذف"
      },
      "audiogramBaseTemplate": {
        "color.white": "أبيض",
        "font.roboto": "روبوتو",
        "color.black": "#000",
        "url.defaultEpisode": "رابطالحلقةالافتراضية",
        "time.0s": "0 ث",
        "font.inter": "إنتر",
        "duration.1s": "1 ث",
        "easing.quadraticOut": "خارج-تربيعي",
        "animation.fade": "تلاشي",
        "type.text": "نص",
        "name.podcastTitle": "عنوانالبودكاست",
        "name.snippetTitle": "عنوانالمقتطف",
        "type.image": "صورة",
        "name.audioBackgroundImage": "صورةخلفيةالصوت",
        "name.subtitlesText": "نصالعناوين",
        "effect.highlight": "تسليطالضوء",
        "type.audio": "صوت",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "عنوان المقتطف",
        "podcast.title": "عنوان البودكاست",
        "new.episode": "حلقة جديدة"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "أبيض",
        "default.font.judson": "جادسون",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "رابطالحلقةالافتراضي",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "موسيقى الخلفية",
        "audio.type": "صوت"
      },
      "imageElement": {
        "upload.image.error": "يرجى رفع ملف صورة.",
        "upload.file.loading": "جارٍ رفع الملف. يرجى عدم إغلاق هذه النافذة.",
        "upload.image.label": "تعديل الصورة",
        "ai.prompt.label": "أدخل موجهًا للذكاء الاصطناعي لإنشاء صورة",
        "ai.prompt.placeholder": "مثال: كلب يجري في الحديقة...",
        "ai.processing": "جارٍ المعالجة...",
        "ai.create": "إنشاء",
        "customize.image.title": "تخصيص الصورة",
        "enter.image.url": "أدخل رابط الصورة",
        "or": "أو"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "خطأ في جلب القوالب:",
        "template.savedSuccessfully": "تم حفظ القالب بنجاح",
        "error.savingTemplate": "خطأ في حفظ القالب:",
        "loading.savedTemplates": "جارٍ تحميل القوالب المحفوظة...",
        "no.savedTemplates": "لا توجد قوالب محفوظة",
        "select_template": "اختر قالب",
        "saving.template": "جارٍ حفظ القالب...",
        "template_name": "اسم القالب",
        "enter.templateName": "أدخل اسم القالب",
        "cancel": "إلغاء",
        "save": "حفظ",
        "default_templates": "القوالب الافتراضية",
        "saved_templates_count": "عدد القوالب المحفوظة ({count})",
        "folder_templates_count": "قوالب المجلد ({count})",
        "account_templates_count": "قوالب الحساب ({count})",
        "save_current_template": "حفظ القالب الحالي"
      },
      "subtitlesElement": {
        "edit.word": "تعديل الكلمة",
        "edit.label": "تعديل",
        "remove.word.subtitle": "إزالة الكلمة من العنوان الفرعي فقط",
        "erase.subtitle": "مسح من العنوان الفرعي",
        "remove.word.clip": "إزالة الكلمة من الصوت والعنوان الفرعي",
        "remove.clip": "إزالة من المقطع"
      },
      "utils": {
        "video.utils.title": "العنوان",
        "video.utils.currentTime": "الوقت الحالي",
        "video.utils.nextTime": "الوقت التالي",
        "video.utils.duration": "المدة",
        "video.utils.description": "الوصف",
        "video.utils.srtSegment": "جزء SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "نص الترجمة الخاص بك هنا"
      }
    }
  },
  "de": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "WERDEN SIE UNSER PARTNER",
        "SHARE_PODSQUEEZE": "Teilen Sie Podsqueeze mit Ihrem Publikum",
        "AND_EARN_MONEY": "und verdienen Sie Geld!",
        "LAST_UPDATED": "Zuletzt aktualisiert: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Werden Sie ein Affiliate-Partner",
        "EARN_COMMISSION": "Verdienen",
        "COMMISSION": "Provision",
        "ON_EVERY_SALE": "bei jedem Verkauf, der über Ihren exklusiven Empfehlungslink innerhalb eines Zeitraums von 15 Monaten erfolgt. Teilen Sie Ihren Link auf Ihrer Website, in sozialen Medien oder mit Ihren Freunden. Die Anmeldung dauert nur Sekunden.",
        "GET_AUTOMATICALLY_APPROVED": "Werden Sie automatisch genehmigt.",
        "JOIN_NOW": "Jetzt beitreten",
        "HOW_IT_WORKS": "SO FUNKTIONIERT'S",
        "FREQUENTLY_ASKED_QUESTIONS": "Häufig Gestellte Fragen",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Was ist ein Affiliate-Partner?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Ein Affiliate-Partner ist jemand, der die Produkte oder Dienstleistungen eines anderen Unternehmens über einen einzigartigen Empfehlungslink bewirbt und eine Provision für jeden über diesen Link getätigten Verkauf erhält.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Wie kann ich ein Affiliate-Partner werden?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Affiliate-Partner zu werden ist schnell und einfach, es dauert nur ein paar Sekunden. Um zu beginnen, klicken Sie einfach auf die Schaltfläche 'Jetzt beitreten' und melden Sie sich mit Ihrer E-Mail an. Sobald Sie registriert sind, haben Sie Zugriff auf ein benutzerfreundliches Dashboard, in dem Sie Ihren einzigartigen Empfehlungslink finden. Teilen Sie diesen Link mit Ihrer Familie, Ihren Freunden oder Ihrem Online-Publikum. Jedes Mal, wenn jemand auf Ihren Empfehlungslink klickt und einen Kauf auf der Podsqueeze-Website tätigt, verdienen Sie 25% Provision auf jede Zahlung für insgesamt 15 Monate! Verfolgen Sie Ihre Einnahmen mühelos über Ihr Affiliate-Dashboard, das Ihnen einen klaren Überblick über alle generierten Verkäufe bietet.",
        "HOW_CAN_I_TRACK_MY_SALES": "Wie kann ich meine Verkäufe und Provisionen verfolgen?",
        "TRACKING_SALES_DESCRIPTION": "Verwenden Sie unser Affiliate-Programm-Dashboard, um Ihre Verkäufe und Provisionen zu verfolgen. Die Tracking-Software ist sowohl für Affiliate-Partner als auch für Geschäftspartner verfügbar.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Wann und wie erhalte ich meine Zahlung?",
        "PAYMENT_DESCRIPTION": "Sie erhalten Ihre Zahlung alle 30 Tage über PayPal. Bitte beachten Sie, dass es eine Mindestauszahlungsgrenze von 50 $ gibt. Sobald Sie diesen Betrag erreicht haben, können Sie erwarten, dass Sie Ihre Zahlung wie ein Uhrwerk alle 30 Tage erhalten.",
        "STILL_GOT_QUESTIONS": "HABEN SIE NOCH FRAGEN?",
        "SEND_US_A_MESSAGE": "Senden Sie uns eine Nachricht im Support-Chat oder schreiben Sie uns an team@podsqueeze.com",
        "NOTE": "Hinweis",
        "AFFILIATE_ADS_RESTRICTION": "Affiliate-Partnern ist es untersagt, Anzeigen auf Google zu erstellen oder an Gebotsauktionen für relevante Schlüsselwörter im Zusammenhang mit Podsqueeze teilzunehmen.",
        "AFFILIATE_TERMS_OF_USE": "Nutzungsbedingungen für Affiliates",
        "CAN_I_RUN_ADS": "Kann ich Anzeigen und CPC-Kampagnen auf Google schalten, um meinen Empfehlungslink zu bewerben?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Affiliate-Partnern ist es untersagt, Anzeigen in Suchmaschinen zu erstellen oder an Gebotsauktionen für Schlüsselwörter im Zusammenhang mit Podsqueeze teilzunehmen. Diese Einschränkung hilft, die Integrität unserer Werbestrategie zu wahren und eine konsistente Markenbotschaft sicherzustellen. Bitte beachten Sie, dass Verkäufe, die aus solchen Gebotskampagnen resultieren, nicht für eine Auszahlung berechtigt sind.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Wie generiert Podsqueeze Titel für Ihren Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Navigationsleiste",
        "main.affiliateHero": "Affiliateheld",
        "main.footer": "Fußzeile"
      }
    },
    "edit": {
      "audioEditElements": {
        "error.processing.rss": "Wir haben Schwierigkeiten, einige RSS-Feeds zu verarbeiten. Bitte laden Sie eine Datei hoch.",
        "edit.enhance.audio": "Bearbeiten und verbessern Sie Ihre Audioaufnahme",
        "trial.label": "Testversion",
        "audio.editing.experience": "Erleben Sie nahtloses Audio-Editing mit fortschrittlichen KI-Algorithmen für natürliche, hochwertige Ergebnisse – mit nur einem Klick.",
        "improve.audio.quality": "Audioqualität verbessern",
        "remove.hums.silences": "Brummtöne und Stille entfernen",
        "upgrade.edit.audio": "Upgrade, um Ihre Audiodateien mit nur einem Klick bearbeiten zu können",
        "available.plans": "Verfügbar für Alle Bezahlt Pläne",
        "upgrade.now": "Jetzt upgraden",
        "audio.element.support": "Ihr Browser unterstützt das Audio-Element nicht.",
        "download.audio": "Audio herunterladen",
        "loading.audio": "Audio laden",
        "editing.audio": "Audio bearbeiten"
      },
      "videoEditElements": {
        "error.exporting.video": "Fehler beim Exportieren des Videos",
        "download.failed": "Download fehlgeschlagen: {error.message}",
        "generating.video": "Video wird generiert",
        "error.generating.clip": "Fehler beim Generieren des Clips",
        "please.retry.support": "Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Benutzersupport",
        "browser.not.support.video": "Ihr Browser unterstützt das Video-Tag nicht.",
        "this.might.take.minutes": "Bitte schließen Sie das Fenster nicht, dies könnte einige Minuten dauern.",
        "exporting.video": "Ihr Video wird exportiert...",
        "seamless.audio.editing": "Erleben Sie nahtloses Audio-Editing mit fortschrittlichen KI-Algorithmen für natürliche, hochwertige Ergebnisse, mit nur einem Klick.",
        "difficulties.processing.rss": "Wir haben einige Schwierigkeiten bei der Verarbeitung einiger RSS-Feeds. Bitte laden Sie eine Datei hoch.",
        "edit.enhance.video.recording": "Bearbeiten und verbessern Sie Ihre Videoaufnahme",
        "trial": "Testversion",
        "enhance.audio.quality": "Audioqualität verbessern",
        "enhance.audio.quality.edit": "Audioqualität verbessern & bearbeiten",
        "trim.filler.words.video": "Füllwörter aus dem Video trimmen (z.B. Ähs)",
        "trim.long.silences.video": "Lange Pausen aus dem Video trimmen",
        "upgrade.to.edit.video": "Upgrade, um Ihr Video mit nur einem Klick bearbeiten zu können",
        "available.pro.agency.plans": "Verfügbar für Pro- und Agenturpläne",
        "upgrade.now": "Jetzt upgraden",
        "download.only.audio": "Nur Audio herunterladen",
        "download.video": "Video herunterladen",
        "please.dont.close.window": "Bitte schließen Sie das Fenster nicht",
        "export.video": "Video exportieren"
      },
      "videogramBaseTemplate": {
        "media.fit": "abdecken",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "Medien"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Weitere Episoden von diesem Podcast",
        "tab.shownotes": "Shownotes",
        "tab.timestamps": "Zeitstempel",
        "tab.blogpost": "Blogbeitrag",
        "tab.transcript": "Transkript",
        "key.points": "Kernpunkte"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Ihre Landing-Page ist in unserem Podcast-Finder live. Teilen Sie sie mit Ihrem Publikum!",
        "landingPage.create": "Erstellen Sie eine schöne Landing-Page für diese Episode",
        "landingPage.edit": "Seite bearbeiten",
        "landingPage.visit": "Seite besuchen",
        "landingPage.delete": "Seite löschen",
        "landingPage.createButton": "Landing-Page erstellen"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Episodenlinks verwalten",
        "youtube.link": "YouTube-Link",
        "enter.youtube.link": "YouTube-Link eingeben",
        "apple.podcasts.link": "Apple Podcasts-Link",
        "enter.apple.podcasts.link": "Apple Podcasts-Link eingeben",
        "spotify.link": "Spotify-Link",
        "enter.spotify.link": "Spotify-Link eingeben",
        "saving": "Speichern...",
        "save": "Speichern",
        "social.links.updated.successfully": "Soziale Links erfolgreich aktualisiert!"
      },
      "affiliatesection": {
        "affiliate.section.title": "WERDEN SIE EIN AFFILIATE-PARTNER",
        "affiliate.section.subtitle": "Teilen Sie Podsqueeze mit Ihrem Publikum und",
        "affiliate.section.earn": "verdienen Sie Geld!",
        "affiliate.section.commission": "Unser Affiliate-Programm bietet 25% Provision für 15 Monate auf jeden Verkauf und jede Abonnementverlängerung.",
        "affiliate.section.join": "Es dauert nur Sekunden, um beizutreten!",
        "affiliate.section.knowMore": "Mehr erfahren"
      },
      "asseenon": {
        "podnews.logo": "podnews-Logo",
        "transistor.logo": "Transistor-Logo",
        "thepodcasthost.logo": "Logo des Podcast-Hosts",
        "schoolofpodcasting.logo": "Logo der Podcast-Schule",
        "semrush.logo": "semrush-Logo"
      },
      "assembleshownotes": {
        "episode.description": "Episodenbeschreibung",
        "bullet.points": "Stichpunkte",
        "timestamps": "Zeitstempel",
        "links.and.mentions": "Links & Erwähnungen",
        "extra.content": "Zusätzlicher Inhalt",
        "assemble.show.notes": "Stellen Sie Ihre Notizen zusammen",
        "downloading": "Wird heruntergeladen",
        "copied": "Kopiert",
        "enter.placeholder": "{{label}} eingeben..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Eine Pause vom Podcasting machen",
        "cancellation.option.no_recurrent": "Ich möchte kein wiederkehrendes Abonnement",
        "cancellation.option.expensive": "Es ist zu teuer",
        "cancellation.option.not_saving_time": "Sparen mir nicht genug Zeit",
        "cancellation.option.dissatisfied_content": "Unzufrieden mit der Qualität der generierten Inhalte",
        "cancellation.option.unresponsive_support": "Unresponsive Kundenbetreuung",
        "cancellation.option.not_using": "Nutze den Dienst nicht genug",
        "cancellation.option.difficulty_navigating": "Schwierigkeiten bei der Nutzung/Navigierung des Produkts",
        "cancellation.option.better_alternative": "Habe ein besseres alternatives Produkt gefunden",
        "cancellation.option.other": "Andere",
        "cancellation.video.message": "70% unserer Nutzer brechen den Stornierungsprozess ab, nachdem sie dieses Video angesehen haben",
        "cancellation.button.cancel": "Ich möchte trotzdem kündigen",
        "cancellation.button.try_again": "Ich möchte es noch einmal versuchen",
        "cancellation.prompt.select_reason": "Bitte helfen Sie uns, das Produkt zu verbessern, indem Sie den Grund für die Kündigung Ihres Abonnements auswählen:",
        "cancellation.placeholder.answer": "Geben Sie hier Ihre Antwort ein...",
        "cancellation.placeholder.specify_reason": "Bitte geben Sie Ihren Kündigungsgrund an",
        "cancellation.button.next": "Weiter",
        "cancellation.button.go_back": "Zurück",
        "cancellation.last_question.title": "Letzte Frage von unserer Seite",
        "lose.all.accumulated.minutes": "Wenn du kündigst, verlierst du alle deine angesammelten Minuten.",
        "keep.accumulating.minutes": "Wenn du kündigst, verlierst du alle deine angesammelten Minuten.",
        "here.are.some.ideas": "Hier sind einige Ideen, um dir weiterhin von Podsqueeze zu profitieren",
        "convert.and.repurpose.episodes": "Konvertiere und wiederverwende deine älteren Episoden in neues Inhalt",
        "generate.articles.favorite.podcasts.and.vides": "Generiere Artikel aus deinen Favoriten-Podcasts",
        "share.your.account.with.a.friend": "Teile dein Konto mit einem Freund, der dir helfen könnte",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Hier ist ein Video, das zeigt, wie du Podsqueeze am besten nutzen kannst",
        "cancellation.last_question.prompt": "Welche Änderungen oder Verbesserungen würden Sie dazu bringen, unseren Dienst wieder in Anspruch zu nehmen?",
        "cancellation.feedback.message": "Ihr Feedback wird uns helfen, uns zu verbessern 🙏",
        "cancellation.button.confirm": "Kündigung bestätigen",
        "cancellation.minutes.accumulated": "Sie haben",
        "cancellation.minutes.accumulated.suffix": "angesammelte Minuten im Wert von",
        "cancellation.reminder.text": "Bitte denken Sie daran:",
        "cancellation.minutes.warning": "Angesammelte Minuten sind ein Vorteil für aktive Abonnements. Durch die Kündigung Ihres Abonnements gehen Ihre Minuten dauerhaft verloren.",
        "cancellation.content.deletion.warning": "Alle Ihre generierten Inhalte werden nach 30 Tagen dauerhaft gelöscht.",
        "cancellation.minutes.left.title": "Sie haben noch Minuten übrig! Lassen Sie sie nicht verfallen!",
        "cancellation.suggestion.clips": "Verwandeln Sie ältere Episoden in Clips für soziale Medien",
        "cancellation.suggestion.articles": "Verwandeln Sie ältere Episoden mit Podsqueeze in Artikel, um von SEO zu profitieren.",
        "cancellation.suggestion.linkedin": "Verwandeln Sie ältere Autorität-Episoden in LinkedIn-Posts, um Ihre persönliche Marke zu stärken",
        "cancellation.suggestion.share": "Teilen Sie Ihr Podsqueeze-Konto mit einem Freund, damit er von Ihren ungenutzten Minuten profitieren kann.",
        "cancellation.button.keep.subscription": "Mein Abonnement behalten",
        "cancellation.button.keep.minutes": "Meine",
        "cancellation.button.keep.minutes.suffix": "im Wert von Minuten behalten",
        "cancellation.lifetime.before_you_go": "Bevor Sie gehen...",
        "cancellation.lifetime.title": "Wie wäre es mit lebenslangem Zugang für nur $49?",
        "cancellation.lifetime.subtitle": "Behalten Sie Ihr Starter-Konto. Keine Abonnements. Keine Verlängerungen. Nur Ihres — für immer.",
        "cancellation.lifetime.feature1": "Lebenslanger Zugang zu Podsqueeze für eine einmalige Zahlung von $49",
        "cancellation.lifetime.feature2": "Nutzen Sie es, wann immer Sie es brauchen, ohne Druck — es gehört für immer Ihnen",
        "cancellation.lifetime.feature3": "Enthält alle aktuellen und zukünftigen Starter-Plan-Features",
        "cancellation.lifetime.button_cancel": "Ich möchte trotzdem kündigen",
        "cancellation.lifetime.button_deal": "Lifetime-Deal erhalten",
        "cancellation.downgrade.title": "Behalten Sie alle Ihre Inhalte für nur $5.99/Monat",
        "cancellation.downgrade.subtitle": "Durch das Downgrade auf Starter können Sie...",
        "cancellation.downgrade.feature1": "Alle Ihre generierten Inhalte behalten",
        "cancellation.downgrade.feature2": "Ihre Websites am Laufen halten",
        "cancellation.downgrade.feature3": "160 Minuten und 10 Clips pro Monat für gelegentliche Arbeiten",
        "cancellation.billing.monthly": "Monatlich",
        "cancellation.billing.annual": "Jährlich",
        "cancellation.billing.discount": "30% RABATT",
        "cancellation.plan.starter": "Starter Plan",
        "cancellation.price.monthly": "$8.99/Monat",
        "cancellation.price.annual": "$5.99/Monat",
        "cancellation.price.annual_billing": "jährlich $71.88 abgerechnet",
        "cancellation.feature.minutes": "160 Min/Monat",
        "cancellation.feature.clips": "10 Clips/Monat",
        "cancellation.downgrade.button": "Auf Starter downgraden & Inhalte behalten",
        "cancellation.error.payment_link": "Zahlungslink konnte nicht abgerufen werden. Bitte versuchen Sie es erneut.",
        "cancellation.error.payment_service": "Fehler beim Verbinden mit dem Zahlungsdienst.",
        "cancellation.option.question.break": "Können Sie uns mehr darüber erzählen, warum Sie eine Pause machen?",
        "cancellation.option.question.no_recurrent": "Könnten Sie uns mitteilen, warum Sie kein wiederkehrendes Abonnement bevorzugen?",
        "cancellation.option.question.expensive": "Welche Preise oder Funktionen würden den Service für Sie wertvoller machen?",
        "cancellation.option.question.not_saving_time": "Was nimmt in Ihrem Prozess immer noch viel Zeit in Anspruch?",
        "cancellation.option.question.dissatisfied_content": "Mit welchen Aspekten des Inhalts waren Sie unzufrieden?",
        "cancellation.option.question.unresponsive_support": "Können Sie Ihre Erfahrung mit unserem Kundensupport beschreiben?",
        "cancellation.option.question.not_using": "Gibt es etwas, das Sie dazu ermutigen würde, den Service öfter zu nutzen?",
        "cancellation.option.question.difficulty_navigating": "Welche Schwierigkeiten hatten Sie bei der Nutzung/Navigation des Produkts?",
        "cancellation.option.question.better_alternative": "Welches alternative Produkt haben Sie gefunden und was gefällt Ihnen daran?",
        "cancellation.option.question.other": "Bitte geben Sie Ihren Grund für die Kündigung an:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Wir schätzen Ihre Privatsphäre",
        "cookiebanner.cookieUsage": "Wir verwenden Cookies, um Ihre Website-Erfahrung zu verbessern und unseren Verkehr zu analysieren. Durch Klicken auf Akzeptieren stimmen Sie unserer Verwendung von Cookies zu.",
        "cookiebanner.privacyPolicy": "Datenschutzerklärung",
        "cookiebanner.accept": "Akzeptieren",
        "cookiebanner.decline": "Ablehnen"
      },
      "episodeTitleBox": {
        "loading": "Laden...",
        "editEpisodeTitleClicked": "Titel der Episode bearbeiten angeklickt",
        "newEpisodeTitleStored": "Neuer Episodentitel gespeichert"
      },
      "famewall": {
        "loading.message": "Wird geladen..."
      },
      "footer": {
        "footer.features": "Funktionen",
        "footer.transcriptGenerator": "Transkript-Generator",
        "footer.subtitlesGenerator": "Untertitel-Generator",
        "footer.descriptionGenerator": "Beschreibungsgenerator",
        "footer.podcastSummarizer": "Podcast-Zusammenfassung",
        "footer.titlesGenerator": "Titel-Generator",
        "footer.bulletPointsGenerator": "Stichpunkt-Generator",
        "footer.chaptersClipsGenerator": "Kapitel- & Clip-Generator",
        "footer.socialMediaPostsGenerator": "Generator für Social-Media-Beiträge",
        "footer.newsletterGenerator": "Newsletter-Generator",
        "footer.blogPostGenerator": "Blogbeitrags-Generator",
        "footer.podcastLandingPages": "Podcast-Startseiten",
        "footer.podcastClipMaker": "Podcast-Clip-Maker",
        "footer.audiogramGenerator": "Audiogramm-Generator",
        "footer.aiAudioEnhancer": "KI-Audio-Verbesserer",
        "footer.convertYoutubeToText": "Youtube in Text umwandeln",
        "footer.youtubeVideoNoiseRemover": "Youtube Video Rauschunterdrücker",
        "footer.youtubeVideoKeyPoints": "Youtube Video Schlüsselpunkte",
        "footer.freeResources": "Kostenlose Ressourcen",
        "footer.findPodcastTopicIdeas": "Podcast-Themenideen finden",
        "footer.articles": "Artikel",
        "footer.freeEbooks": "Kostenlose eBooks",
        "footer.community": "Gemeinschaft",
        "footer.ourPodcast": "Unser Podcast",
        "footer.product": "Produkt",
        "footer.giftCard": "Geschenkkarte",
        "footer.onboardingEbook": "Onboarding-eBook",
        "footer.pricing": "Preise",
        "footer.affiliates": "Partner",
        "footer.media": "Medien",
        "footer.testimonials": "Testimonials",
        "footer.legal": "Rechtliches",
        "footer.privacyPolicy": "Datenschutzrichtlinie",
        "footer.termsOfUse": "Nutzungsbedingungen",
        "footer.refundPolicy": "Rückerstattungsrichtlinie",
        "footer.allRightsReserved": "Alle Rechte vorbehalten."
      },
      "globalState": {
        "cookie.enabled": "Cookies aktiviert",
        "language.default": "Standardsprache"
      },
      "head": {
        "keywords.list": "Podsqueeze, KI, Podcasts, Inhaltsgenerierung, Podcast-Transkription, Shownotes, Zeitstempel, Podcast-Newsletter, Tweets, Blogbeiträge, Social Posts, Titel, Shownotes-Autor"
      },
      "imageResultModal": {
        "download.image": "Bild herunterladen",
        "generating.image": "Bild wird generiert",
        "ai.prompt.label": "Geben Sie einen Prompt ein, damit die KI ein Bild generiert",
        "ai.prompt.placeholder": "Z.B.: Ein Hund, der im Park läuft...",
        "processing": "Verarbeitung...",
        "create": "Erstellen",
        "text.color.label": "Textfarbe",
        "quote.icon.color.label": "Farbe des Zitat-Icons",
        "background.color.label": "Hintergrundfarbe",
        "font.label": "Schriftart",
        "upload.cover.image": "Cover-Bild hochladen",
        "aspect.ratio.info": "Seitenverhältnis 1:1, empfohlene Größe 1200x1200",
        "upload.logo.label": "Logo hochladen",
        "choose.file": "Datei auswählen",
        "upload.success": "Erfolgreich hochgeladen",
        "choose.quote": "Wählen Sie ein Zitat",
        "select.template": "Vorlage auswählen",
        "quote.label": "Zitat",
        "enter.quote.here": "Zitat hier eingeben",
        "author.label": "Autor",
        "enter.author.name": "Namen des Autors eingeben",
        "podcast.name.label": "Podcast-Name",
        "enter.podcast.name": "Podcast-Namen eingeben",
        "colors": "Farben",
        "select.font": "Schriftart auswählen",
        "cover.logo.images": "Cover- und Logo-Bilder",
        "logo.image": "Logo-Bild",
        "upgrade.here": "Hier upgraden",
        "remove.logo": "Podsqueeze-Logo entfernen",
        "default_templates": "Standard-Vorlagen",
        "saved_templates_count": "Gespeicherte Vorlagen",
        "save_current_template": "Aktuelle Vorlage speichern",
        "no_saved_templates": "Noch keine gespeicherten Vorlagen",
        "save_template": "Vorlage speichern",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "enter_template_name": "Vorlagenname eingeben",
        "reset_template": "Zurücksetzen",
        "add_element": "Element hinzufügen",
        "generate": "Generieren",
        "add_image": "Bild hinzufügen",
        "upload_image": "Bild hochladen",
        "or": "oder",
        "generate_with_ai": "Mit KI generieren",
        "search_fonts": "Schriftarten suchen...",
        "upload_logo": "Logo hochladen",
        "square_image_recommended": "Quadratisches Bild empfohlen",
        "opacity": "Deckkraft",
        "layers": "Ebenen",
        "no_element_selected": "Kein Element ausgewählt",
        "bold_shortcut": "Fett (Strg+B)",
        "italic_shortcut": "Kursiv (Strg+I)",
        "underline_shortcut": "Unterstrichen (Strg+U)",
        "edit_text": "Text bearbeiten",
        "tint_color": "Farbton",
        "toggle_gradient_transparent": "Verlauf auf transparent umschalten",
        "rotate_gradient": "Verlauf um 45 Grad drehen",
        "alt_background": "Hintergrund",
        "alt_podcast_logo": "Podcast-Logo",
        "alt_custom": "Benutzerdefiniert",
        "alt_right_side": "Rechte Seite",
        "alt_profile": "Profil"
      },
      "intentModal": {
        "intentModal.title": "Was möchten Sie mit Podsqueeze tun?",
        "intentModal.sourceOption.Write_Show_Notes": "Show-Notizen schreiben",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Blogbeitrag & Newsletter schreiben",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Videoclips oder Audiogramme erstellen",
        "intentModal.sourceOption.Create_Quote_Images": "Zitatbilder erstellen",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Audio/Video bearbeiten und verbessern",
        "intentModal.sourceOption.Transcribe": "Transkribieren",
        "intentModal.sourceOption.Create_a_Website": "Eine Website erstellen",
        "intentModal.sourceOption.All_of_the_Above": "Alle oben genannten",
        "intentModal.sourceOption.Other": "Sonstiges",
        "intentModal.otherPlaceholder": "Bitte angeben",
        "intentModal.submitButton": "Einreichen & Registrieren",
        "intentModal.skip": "Überspringen"
      },
      "languageSwitcher": {
        "language.en": "Englisch",
        "language.es": "Spanisch",
        "language.fr": "Französisch",
        "language.de": "Deutsch",
        "language.it": "Italienisch",
        "language.pt": "Portugiesisch",
        "language.nl": "Niederländisch",
        "language.pl": "Polnisch",
        "language.ru": "Russisch",
        "language.zh": "Chinesisch",
        "language.ja": "Japanisch",
        "language.ko": "Koreanisch",
        "language.ar": "Arabisch",
        "language.th": "Thailändisch",
        "language.vi": "Vietnamesisch"
      },
      "lazyImage": {
        "lazyImage.alt": "Bildbeschreibung"
      },
      "metadata": {
        "meta.title": "Ihr Seitentitel",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Dienstprogramm"
      },
      "navbar": {
        "navbar.dashboard": "Dashboard",
        "navbar.login": "Anmelden",
        "navbar.openMenu": "Hauptmenü öffnen",
        "navbar.features": "Funktionen",
        "navbar.resources": "Ressourcen",
        "navbar.pricing": "Preise",
        "navbar.contact": "Kontakt",
        "navbar.seeAllFeatures": "Alle Funktionen anzeigen",
        "navbar.mainFeatures": "HAUPTFUNKTIONEN",
        "navbar.podcastTranscription": "Podcast- und Video-Transkriptionsgenerator",
        "navbar.transcriptionDescription": "Hochgenaues Transkript mit Sprecherkennzeichnung und SRT-Datei für Untertitel.",
        "navbar.podcastSummarizer": "Podcast-Zusammenfasser",
        "navbar.summarizerDescription": "Erstellen Sie vollständige Show-Notizen 20x schneller, in Ihrer eigenen Stimme.",
        "navbar.podcastClipMaker": "Podcast-Clip-Maker",
        "navbar.clipMakerDescription": "Automatisch kurze Clips oder Audiogramme für Ihren Podcast erstellen.",
        "navbar.audioEnhancer": "AI Audio-Verbesserer",
        "navbar.audioEnhancerDescription": "Audio automatisch verbessern, Stille und Füllwörter entfernen.",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE FUNKTIONEN ÜBERBLICK",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Umsetzbare Artikel und Leitfäden, um einen erfolgreichen Podcast zu starten und zu wachsen.",
        "navbar.podcastTopicIdeas": "Podcast-Themenideen",
        "navbar.topicIdeasDescription": "Entdecken Sie Podcast-Themen, nach denen das Publikum sucht.",
        "navbar.actionableEbooks": "Umsetzbare eBooks",
        "navbar.topPodcasts": "TOP PODCASTS",
        "navbar.ebooksDescription": "Laden Sie kostenlose eBooks mit umsetzbaren Tipps herunter, um Ihren Podcast auf das nächste Level zu bringen.",
        "navbar.freeThumbnailMaker": "Kostenloses Podcast-Thumbnail-Tool",
        "navbar.freeThumbnailMakerDescription": "Erstellen Sie professionelle, auffällige Episode-Thumbnails mit KI.",
        "navbar.seoOptimizer": "SEO-Optimierer",
        "navbar.seoOptimizerDescription": "Optimieren Sie Ihre Podcast-Episoden für bessere Sichtbarkeit in Suchmaschinen.",
        "navbar.podcastDescription": "Hören Sie sich unseren Podcast an, in dem wir erfahrene Podcaster und Podsqueeze-Nutzer aus der ganzen Welt interviewen. Wir bitten sie, ihre Tipps, Erkenntnisse, Geschichten und alles zu teilen, was Sie wissen müssen, um Ihren eigenen Podcast zu erweitern."
      },
      "resultModal": {
        "prompt.transcript.quote": "Zitat",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Shownotes aus der Ich-Perspektive",
        "prompt.shownotes.replaceName": "Namen in den Shownotes ersetzen",
        "prompt.shownotes.friendlyTone": "Freundlicher Ton in den Shownotes",
        "prompt.shownotes.youtubeDescription": "YouTube-Beschreibung in den Shownotes",
        "prompt.shownotes.engagingQuestion": "Fesselnde Frage in den Shownotes",
        "prompt.newsletter.casualTone": "Lässiger Ton im Newsletter",
        "prompt.newsletter.shorter": "Kürzerer Newsletter",
        "prompt.newsletter.contentSections": "Inhaltsabschnitte im Newsletter",
        "prompt.newsletter.changeName": "Namen im Newsletter ändern",
        "prompt.mentions.fullURL": "Vollständige URL-Erwähnungen",
        "prompt.mentions.replaceName": "Namen in Erwähnungen ersetzen",
        "prompt.tweets.underdogTone": "Underdog-Ton in Tweets",
        "prompt.tweets.firstPerson": "Tweets aus der Ich-Perspektive",
        "prompt.shortPost.relevantEmojis": "Relevante Emojis im kurzen Beitrag",
        "prompt.shortPost.educationalTone": "Bildender Ton im kurzen Beitrag",
        "prompt.shortPost.underdogTone": "Underdog-Ton im kurzen Beitrag",
        "prompt.shortPost.firstPerson": "Kurzer Beitrag aus der Ich-Perspektive",
        "prompt.titles.youtubeOptimized": "YouTube-optimierte Titel",
        "prompt.titles.startWithHowTo": "Titel mit 'Wie man' beginnen",
        "prompt.titles.otherOptions": "Weitere Optionen für Titel",
        "prompt.keywords.youtubeOptimized": "YouTube-optimierte Schlüsselwörter",
        "prompt.keywords.separateWithCommas": "Schlüsselwörter mit Kommas trennen",
        "prompt.quotes.lorem1": "Lorem ipsum Zitat 1",
        "prompt.quotes.lorem2": "Lorem ipsum Zitat 2",
        "prompt.bulletPoints.lorem1": "Lorem ipsum Aufzählungspunkt 1",
        "prompt.bulletPoints.lorem2": "Lorem ipsum Aufzählungspunkt 2",
        "prompt.longPost.firstPerson": "Langer Beitrag aus der Ich-Perspektive",
        "prompt.longPost.relevantEmojis": "Relevante Emojis im langen Beitrag",
        "prompt.longPost.changeName": "Namen im langen Beitrag ändern",
        "alert.tuningInstructionsEmpty": "Die Abstimmungsanweisungen dürfen nicht leer sein.",
        "text.timestamps.byPodsqueeze": "Zeitstempel von PodSqueeze",
        "button.copied": "Kopiert",
        "button.copy": "Kopieren",
        "embed.transcript": "Transkript einbetten",
        "embed.description": "Beschreibung für das Einbetten",
        "preview.title": "Vorschau Titel",
        "loading.regenerating": "Wird regeneriert...",
        "placeholder.tuningInstructions": "Geben Sie die Abstimmungsanweisungen ein...",
        "button.saveClose": "Speichern und Schließen",
        "button.acceptChanges": "Änderungen akzeptieren",
        "button.discard": "Verwerfen",
        "button.embedTranscript": "Transkript einbetten",
        "text.copiedToClipboard": "In die Zwischenablage kopiert",
        "download.srtFile": "SRT-Datei herunterladen",
        "text.forCaptions": "für Untertitel",
        "tune.title": "Passen Sie Ihre Ergebnisse an",
        "tune.description": "Passen Sie Ihre Ergebnisse mit den folgenden Optionen an.",
        "instruction.label": "Anweisungen:",
        "button.tuneResult": "Ergebnis anpassen",
        "instruction.saveForLater": "Für später speichern",
        "feedback.happyWithResults": "Sind Sie mit den Ergebnissen zufrieden?",
        "prompt.timestamps.formatAsChapters": "Zeitstempel als Kapitel mit beschreibenden Titeln formatieren",
        "prompt.timestamps.detailedDescriptions": "Detaillierte Zeitstempel mit Themenbeschreibungen und wichtigen Punkten erstellen",
        "prompt.timestamps.improveSpeakerNames": "Sprechernamen durch beschreibendere Titel wie 'Moderator', 'Experte' oder 'Gast' ersetzen"
      },
      "resultModalTranscript": {
        "prompt.quote": "Finde drei gute Zitate aus dem Transkript",
        "prompt.blog": "Schreibe einen 500 Wörter langen Blogbeitrag zum Thema X",
        "prompt.tweets": "Schreibe drei ansprechende Tweets aus dem Transkript",
        "transcript.autoTranscribed": "Automatisch transkribiert mit Podsqueeze",
        "alert.emptyPrompt": "Die Anweisungen dürfen nicht leer sein",
        "embed.transcript": "Transkript einbetten",
        "embed.description": "Bette ein handhabbares Transkript mit einer Suchfunktion auf deiner WordPress-Seite oder einer beliebigen HTML-unterstützten Seite ein.",
        "button.copied": "Kopiert!",
        "button.copy": "Kopieren",
        "preview.title": "Vorschau",
        "edit.speakers": "Namen der Sprecher bearbeiten",
        "button.saveClose": "Speichern & Schließen",
        "placeholder.prompt": "z.B.: Finde drei gute Zitate aus dem Transkript",
        "upgrade.pro": "Upgrade auf Pro, um diese Funktion zu nutzen",
        "upgrade.link": "Upgrade auf Pro",
        "button.generate": "Erstellen",
        "feedback.happy": "Bist du mit den Ergebnissen zufrieden?",
        "instruction": "Anweisung: ",
        "generating.results": "Ergebnisse werden generiert",
        "full.transcription": "Vollständige Transkription",
        "srt.file": "& SRT-Datei",
        "download.srt": "SRT-Datei herunterladen",
        "caption.subtitles": "für Untertitel und Untertitel.",
        "generate.from.transcript": "Aus Transkript mit Gpt-4o generieren",
        "gpt.tweak.text": "Bitte die neueste GPT-Version, den Text nach deinen Wünschen anzupassen. Verwende natürliche Sprache und scheue dich nicht, spezifisch zu sein.",
        "copied.clipboard": "In die Zwischenablage kopiert",
        "transcript.public.available": "URL verfügbar",
        "audio.notSupported": "Dein Browser unterstützt das Audioelement nicht.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Podcast-Namen hinzufügen",
        "podcast.title": "{{title}} Podcast"
      },
      "sourceModal": {
        "sourceModal.title": "Wie haben Sie von Podsqueeze erfahren?",
        "sourceModal.otherPlaceholder": "Bitte angeben",
        "sourceModal.nextButton": "Weiter",
        "sourceModal.skip": "Überspringen"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Wir haben Schwierigkeiten, einige RSS-Feeds zu verarbeiten. Bitte laden Sie eine Datei hoch."
      },
      "squeezeResults": {
        "copiedToClipboard": "In die Zwischenablage kopiert",
        "publicLink": "Öffentlich unter ",
        "createLink": "Einen Link erstellen, um diese Ergebnis-Seite zu teilen",
        "assembleShowNotes": "Show-Notizen zusammenstellen",
        "convertAnotherEpisode": "Eine weitere Episode konvertieren",
        "writtenContent": "Schriftlicher Inhalt",
        "videoClipsAndImages": "Videoausschnitte & Bilder",
        "editAudio": "Audio bearbeiten"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Mehr sehen und abstimmen",
        "see.more": "Mehr sehen",
        "generating": "Generiere",
        "download.all": "Alles herunterladen",
        "full.transcription": "Vollständige Transkription",
        "transcript.benefit": "Wusstest du, dass das Hinzufügen vollständiger Transkripte zu deinen Shownotes den Website-Verkehr und das Engagement steigert?",
        "learn.more": "Mehr erfahren",
        "transcript.bonus": "Du kannst vollständige Transkripte als Bonus für dein Podcast-Mitgliedsprogramm bereitstellen.",
        "show.notes": "Shownotes",
        "show.notes.engagement": "Überlege, diese kurze Beschreibung mit anderen Elementen in deinen Shownotes zu ergänzen, um das Engagement und die SEO zu steigern.",
        "show.notes.examples": "Lass dich von diesen 17 Beispielen für Podcast-Shownotes inspirieren, um die perfekten für deinen Podcast zu erstellen.",
        "timestamps": "Zeitstempel",
        "timestamps.benefit": "Füge diese Zeitstempel zur Beschreibung deiner Episode hinzu, und es werden automatisch Kapitel auf Spotify und YouTube erstellt.",
        "titles": "Titel",
        "titles.engagement": "Titel mit Fragezeichen und Superlativen sind besonders ansprechend.",
        "links.and.mentions": "Links & Erwähnungen",
        "mentions.resources": "Überlege, die unten genannten Erwähnungen im Ressourcenbereich deiner Shownotes aufzunehmen.",
        "mentions.affiliate": "Überprüfe, ob die erwähnten Produkte Affiliate-Programme haben, und ziehe in Betracht, Affiliate-Links in deinen Shownotes hinzuzufügen.",
        "mentions.social.media": "Tagge die in deiner Episode erwähnten Personen in sozialen Medien, um sie zu ermutigen, deinen Beitrag zu teilen und sich damit zu beschäftigen.",
        "keywords": "Schlüsselwörter",
        "keywords.youtube": "Wenn du deine Episode auf YouTube hochlädst, kopiere und füge diese Schlüsselwörter einfach in den Tag-Bereich ein.",
        "keywords.social.media": "Nutze diese Schlüsselwörter für Hashtags in sozialen Medien.",
        "blog.post": "Blogbeitrag",
        "blog.post.linkedin": "Überlege, diesen Inhalt zu verwenden, um einen langen LinkedIn-Beitrag zu erstellen.",
        "blog.post.share": "Teile diesen Inhalt in Reddit-Communities und Facebook-Gruppen, die mit dem Thema deines Podcasts übereinstimmen.",
        "newsletter": "Newsletter",
        "newsletter.content": "Einige unserer Nutzer verwenden diesen Newsletter-Inhalt, um umfassendere Episodenbeschreibungen für Shownotes zu erstellen.",
        "linkedin.and.facebook": "LinkedIn & Facebook",
        "short.post.description": "Verwende diese kurzen Beiträge als Beschreibungen, wenn du verwandte Videoclips und Audiogramme in sozialen Medien teilst.",
        "tweets": "Tweets",
        "quotes": "Zitate",
        "bullet.points": "Stichpunkte",
        "add.custom.result": "Benutzerdefiniertes Ergebnis hinzufügen",
        "bullet.points.skimming": "Podcaster listen häufig die Hauptthemen der Episode als Stichpunkte in den Shownotes auf, um ein einfaches Überfliegen zu ermöglichen."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Mehr sehen und anpassen",
        "generating": "Generiere",
        "not.available.for.rss.feed": "Nicht verfügbar für diesen RSS-Feed",
        "regenerate.episode.upload.file": "Episode neu generieren und Ihre Audio-/Videodatei direkt von Ihrem Computer hochladen",
        "processing.difficulties": "Wir haben einige Schwierigkeiten bei der Verarbeitung einiger RSS-Feeds. Bitte laden Sie eine Datei hoch.",
        "video.clips": "Videoclips",
        "ai.short.clips": "Kurze KI-Clips",
        "quote.image": "Zitatbild"
      },
      "title": {
        "title.text": "dein.label"
      },
      "topbar": {
        "topbar.forYou": "Für Sie",
        "topbar.joinPodcast": "Nehmen Sie an unserem nächsten virtuellen Podcast-Treffen teil!",
        "topbar.saveYourSpot": "Sichern Sie sich Ihren Platz",
        "topbar.dismiss": "Schließen"
      },
      "trackers": {
        "trackers.init": "Tracker werden mit aktivierten Cookies initialisiert: ",
        "trackers.loadScripts": "Tracking-Skripte werden geladen..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Willkommen in meiner Anwendung",
        "content.description": "Dies ist eine Beispielanwendung, die die Übersetzung demonstriert.",
        "button.submit": "Einreichen"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI bearbeitet Ihr Clip",
        "export_clip": "Clip exportieren",
        "ai_edit": "AI bearbeiten",
        "ai_editing_clip_duration": "Das wird ein paar Sekunden dauern",
        "generating_clip": "Ihr Clip wird generiert...",
        "generating_clip_notice": "Das kann ein paar Minuten dauern. Wir werden Ihnen eine E-Mail senden, sobald es fertig ist.",
        "edit_another_video": "Sie können hier warten oder ein anderes Video bearbeiten",
        "download_video": "Video herunterladen",
        "back_to_editing": "Zurück zur Bearbeitung",
        "export_video_button": "Clip exportieren",
        "notice_storage": "Hinweis: Wir speichern Ihre Audiodatei für 30 Tage. Nach diesem Zeitraum wird dieser Clip ablaufen.",
        "error_generating_clip": "Fehler beim Generieren des Clips",
        "error_user_support": "Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Benutzersupport",
        "select_template": "Vorlage auswählen",
        "add_30s_prev": "30s aus dem vorherigen Kapitel",
        "add_30s_next": "30s aus dem nächsten Kapitel",
        "undo": "Rückgängig",
        "subtitles_font": "Schriftart der Untertitel",
        "subtitles_color": "Farbe der Untertitel",
        "subtitles_box_color": "Animation Farbe",
        "adjust_podcast_title_position": "Vertikale Position des Podcast-Titels anpassen",
        "adjust_subtitles_size": "Größe der Untertitel anpassen",
        "adjust_subtitles_vertical_position": "Vertikale Position der Untertitel anpassen",
        "remove_subtitles": "Untertitel entfernen",
        "animated_subtitles": "Animierte Untertitel",
        "upgrade_here": "Hier upgraden",
        "remove_logo": " um das Logo zu entfernen",
        "remove_podsqueeze_logo": "Podsqueeze-Logo entfernen",
        "aspect_ratio": "Seitenverhältnis",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Episodentitel",
        "podcast_title": "Podcast-Titel",
        "titles_font": "Schriftart der Titel",
        "title_colors": "Farben der Podcast-/Episodentitel",
        "video_fit": "Videoanpassung",
        "adjust_horizontal_position": "Horizontale Position anpassen",
        "adjust_vertical_position": "Vertikale Position anpassen",
        "adjust_video_zoom": "Videozoom anpassen",
        "adjust_video_width": "Videobreite anpassen",
        "adjust_video_height": "Videohöhe anpassen",
        "background_color": "Hintergrundfarbe",
        "edit_clip": "Clip bearbeiten",
        "edit_layout": "Layout bearbeiten",
        "choose_short": "Kurzen Clip auswählen",
        "edit_audio": "Audio bearbeiten",
        "framing": "Rahmung",
        "background": "Hintergrund",
        "text_style": "Textstil",
        "music": "Musik",
        "choose_chapter": "Kapitel auswählen",
        "clips_left": "Sie haben",
        "clips_left_number": "Clips übrig",
        "need_more_clips": "Brauchen Sie mehr Clips? Hier Ihren Plan upgraden",
        "download_srt_file": "SRT-Datei herunterladen",
        "track_selected": "Track: ",
        "no_background_music": "Keine Hintergrundmusik ausgewählt",
        "volume": "Lautstärke:",
        "remove": "Entfernen",
        "track_ambient_piano": "Ambient Klavier und Streicher",
        "track_deep_meditation": "Tiefe Meditation",
        "track_chill_upbeat": "Für ihren chilligen, optimistischen Stil",
        "track_inspiring_ambient": "Inspirierende cineastische Ambientmusik",
        "track_just_relax": "Einfach entspannen",
        "track_movement": "Bewegung",
        "track_once_in_paris": "Einmal in Paris",
        "track_perfect_beauty": "Perfekte Schönheit",
        "track_summer_adventures": "Sommerabenteuer",
        "track_sunset_groove": "Sonnenuntergangs-Groove",
        "track_tvari_cafe": "Tvari Tokyo Café",
        "track_short_piano_intermezzo": "Kurzes Klavier-Intermezzo",
        "track_dramatic_background": "Dramatische Hintergrundmusik",
        "track_dramatic_hiphop": "Dramatischer Hip-Hop Jazz",
        "track_emotional_orchestra": "Emotionales Orchester",
        "track_halloween_short": "Halloween-Musik",
        "track_improvisation_037": "Jazz-Improvisation",
        "track_inspiration_piano": "Inspirierendes Klavier",
        "track_medieval_extract": "Mittelalterliche Musik",
        "track_short_8": "Kurzer Ambient-Track",
        "track_flute": "Friedliche Flöte",
        "track_piano_guitar_duet": "Klavier-Gitarren-Duett",
        "track_intro_jazz": "Intro-Jazz",
        "track_romantic_jazz": "Romantischer Jazz",
        "recommended_for_youtube": "Empfohlen für YouTube",
        "turn_into_short_clip": "Diesen Clip in einen kurzen Clip (<60s) umwandeln",
        "browser_not_support_audio": "Ihr Browser unterstützt das Audioelement nicht.",
        "watch_tutorial": "Sehen Sie sich dieses Tutorial an",
        "audiogram_maker": "wie man das Beste aus unserem Audiogramm-Ersteller herausholt",
        "store_audio_notice": "Hinweis: Wir speichern Ihre Audiodatei für 30 Tage.",
        "clip_maker": "wie man das Beste aus unserem Clip-Ersteller herausholt",
        "split_screen_mode": "Split-Bildschirmmodus",
        "none": "Keine",
        "vertical_split": "Vertikale Aufteilung",
        "horizontal_split": "Horizontale Aufteilung",
        "layers": "Verwenden Sie die Ebenen unten, um sie nach vorne oder hinten zu verschieben.",
        "screen_1_horizontal_position": "Bildschirm 1 Horizontale Position",
        "screen_2_horizontal_position": "Bildschirm 2 Horizontale Position",
        "track_mysterious_dark_background": "Geheimnisvoller dunkler Hintergrund",
        "track_acoustic_ambient_inspiration": "Akustische Ambient-Inspiration",
        "track_aristocracy_classical": "Aristokratie-Klassik",
        "track_folk_music_river_knows_my_name": "Folk-Musik - Der Fluss kennt meinen Namen",
        "track_funy_adventure": "Lustiges Abenteuer",
        "track_energetic_sports_rock_trailer": "Energetischer Sport-Rock-Trailer",
        "track_fun_upbeat_energetic_pop_rock": "Fröhlicher Energetischer Pop-Rock",
        "track_epic_emotional_inspirational": "Episch Emotional Inspirierend",
        "track_inspirational_epic": "Inspirierend Episch",
        "all_music": "Alle Musik",
        "energetic_music": "Energisch",
        "inspirational_music": "Inspirierend",
        "ambient_music": "Ambient",
        "chill_music": "Entspannt",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Skurril",
        "dramatic_music": "Dramatisch",
        "acoustic_music": "Akustisch",
        "classical_music": "Klassisch",
        "categories": "Kategorien",
        "select_track": "Track auswählen",
        "upload_music": "Musik hochladen",
        "my_music": "Meine Musik",
        "downloading": "Wird heruntergeladen...",
        "download_again": "Erneut herunterladen",
        "download": "Herunterladen",
        "download_failed_alert": "Video konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.",
        "translate_subtitles": "Untertitel Übersetzen",
        "translate_to": "Übersetzen nach",
        "select_language": "Sprache Auswählen",
        "select_new_language": "Neue Sprache auswählen",
        "translating": "Übersetzung läuft...",
        "translation_complete": "Übersetzung Abgeschlossen",
        "error_translation": "Fehler bei der Übersetzung. Bitte versuchen Sie es erneut.",
        "original_language": "Original"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Episodentitel"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Sie haben noch keine Inhalte.",
        "userPodcastsInfo.generateContent": "Erstellen Sie Ihren ersten Inhalt",
        "placeholder.search_folders": "Ordner durchsuchen...",
        "search.no_results": "Keine Ordner entsprechen Ihrer Suche."
      },
      "landingPageModal": {
        "upload.error": "Fehler beim Hochladen des Bildes: ",
        "upload.image.file": "Bitte laden Sie eine Bilddatei hoch.",
        "upgrade.pro.message": "Die Anpassung der Seite ist nur für Pro- und Agenturkonten verfügbar.",
        "upgrade.now": "Jetzt upgraden",
        "upgrade.unique.landing.page": " und erstellen Sie eine einzigartige Episoden-Landingpage.",
        "logo.recommendation": "Empfohlene Logo-Höhe 200px",
        "social.links.top.menu": "Soziale Links im oberen Menü",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "LinkedIn-Link eingeben",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Facebook-Link eingeben",
        "saving...": "Speichern...",
        "save": "Speichern",
        "saved.successfully": "Erfolgreich gespeichert!",
        "uploading.image": "Bild wird hochgeladen...",
        "upload.episode.cover": "Episoden-Cover hochladen",
        "upload.logo": "Logo hochladen",
        "where.listen.episode": "Wo können wir diese Episode noch anhören?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "YouTube-Link eingeben",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Apple Podcasts-Link eingeben",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Spotify-Link eingeben",
        "image.size.recommendation": "Empfohlene Größe 1000x1000px",
        "primary.color.label": "Primärfarbe",
        "header.background.color": "Hintergrundfarbe und Links der Kopfzeile.",
        "landing.page.customization": "Anpassung der Landingpage",
        "create.branded.landing.page": "Erstellen Sie eine schöne, gebrandete Landingpage, um sie mit Ihren Zuhörern zu teilen",
        "episode.image": "Episodenbild",
        "episode.links": "Episodenlinks",
        "page.header": "Seitenkopf",
        "page.color": "Seitenfarbe",
        "visit.landing.page": "Landingpage besuchen"
      },
      "page": {
        "loading.dashboard": "Lade Dashboard",
        "convert.new.episode": "Neue Episode konvertieren",
        "convert.audio.or.video": "Audio oder Video konvertieren",
        "minutes.left": "Sie haben",
        "need.more.minutes": "Brauchen Sie mehr Minuten?",
        "upgrade.plan": "Upgrade Ihren Plan hier.",
        "your.podcasts": "Ihre Podcasts",
        "podsqueeze.results.page": "Podsqueeze Ergebnisseite",
        "access.podsqueeze.results": "Zugriff auf Podsqueeze-Ergebnisse für diese Episode. Sie können alle generierten Inhalte sehen."
      },
      "podcast": {
        "confirm.delete_episode": "Sind Sie sicher, dass Sie diese Episode löschen möchten?",
        "alert.something_wrong": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        "confirm.delete_folder": "Sind Sie sicher, dass Sie diesen Ordner löschen möchten?",
        "loading.episodes": "Lade Episoden...",
        "folder.empty": "Dieser Ordner ist leer.",
        "content.no_content": "Keine Inhalte verfügbar.",
        "content.generate_first": "Erstellen Sie Ihren ersten Podcast.",
        "button.personalize_ai": "Mit KI personalisieren",
        "button.edit_website": "Website bearbeiten",
        "button.visit_website": "Website besuchen",
        "button.generate_website": "Website generieren",
        "placeholder.search": "Suche...",
        "label.sort_by": "Sortieren nach",
        "label.last_episodes_loaded": "Letzte Episoden geladen",
        "button.load_all_episodes": "Alle Episoden laden",
        "loading": "Laden...",
        "add.new.episode": "Neue Episode hinzufügen",
        "order.newest": "Neueste zuerst",
        "order.oldest": "Älteste zuerst",
        "order.a_to_z": "A bis Z",
        "order.z_to_a": "Z bis A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Erstellen Sie einen neuen Podcast-Ordner:",
        "folder.name.placeholder": "Name des Ordners",
        "create.button": "Erstellen"
      },
      "podcastLandingModal": {
        "upload.image.error": "Bitte laden Sie eine Bilddatei hoch",
        "podcast.cover.title": "Podcast Coverbild",
        "podcast.cover.upload": "Laden Sie hier Ihr Podcast-Coverbild hoch. Dies wird prominent auf Ihrer Landingpage angezeigt.",
        "upload.image.uploading": "Bild wird hochgeladen...",
        "podcast.cover.upload.button": "Coverbild hochladen",
        "podcast.cover.recommended.size": "Empfohlene Größe: 1400x1400 Pixel",
        "profile.info.title": "Profilinformationen",
        "profile.info.upload": "Fügen Sie Ihr Profilbild und Ihren Namen hinzu, um Ihre Landingpage zu personalisieren.",
        "profile.upload.button": "Profilbild hochladen",
        "profile.name.label": "Profilname",
        "profile.name.placeholder": "Geben Sie Ihren Namen ein",
        "platform.links.title": "Plattformlinks",
        "platform.links.upload": "Fügen Sie Links zu Ihrem Podcast auf verschiedenen Plattformen hinzu.",
        "platform.links.youtube_link": "YouTube-Link",
        "platform.links.youtube_link.placeholder": "Geben Sie den YouTube-Link ein",
        "platform.links.spotify_link": "Spotify-Link",
        "platform.links.spotify_link.placeholder": "Geben Sie den Spotify-Link ein",
        "platform.links.apple_podcast_link": "Apple Podcast-Link",
        "platform.links.apple_podcast_link.placeholder": "Geben Sie den Apple Podcast-Link ein",
        "platform.links.linkedin_link": "LinkedIn-Link",
        "platform.links.linkedin_link.placeholder": "Geben Sie den LinkedIn-Link ein",
        "platform.links.facebook_link": "Facebook-Link",
        "platform.links.facebook_link.placeholder": "Geben Sie den Facebook-Link ein",
        "platform.links.twitter_link": "Twitter-Link",
        "platform.links.twitter_link.placeholder": "Geben Sie den Twitter-Link ein",
        "call.to.action.title": "Handlungsaufforderung",
        "call.to.action.upload": "Richten Sie Ihre Handlungsaufforderungsschaltfläche für die Landingpage ein.",
        "call.to.action.button.text.label": "Schaltflächentext",
        "call.to.action.button.text.placeholder": "Geben Sie den Schaltflächentext ein",
        "call.to.action.button.link.label": "Schaltflächenlink",
        "call.to.action.button.link.placeholder": "Geben Sie den Schaltflächenlink ein",
        "color.styles.title": "Farbstile",
        "color.styles.upload": "Passen Sie die Farben Ihrer Landingpage an.",
        "color.styles.primary.label": "Primärfarbe",
        "color.styles.primary.description": "Wählen Sie die Primärfarbe für Ihre Landingpage",
        "color.styles.secondary.label": "Sekundärfarbe",
        "color.styles.secondary.description": "Wählen Sie die Sekundärfarbe für Ihre Landingpage",
        "podcast.info.title": "Podcast-Informationen",
        "podcast.info.upload": "Bearbeiten Sie die Details Ihres Podcasts.",
        "podcast.info.name.label": "Podcast-Name",
        "podcast.info.name.placeholder": "Geben Sie den Podcast-Namen ein",
        "podcast.info.description.label": "Podcast-Beschreibung",
        "podcast.info.description.placeholder": "Geben Sie die Podcast-Beschreibung ein",
        "edit.website.title": "Website bearbeiten",
        "generate.website.title": "Website generieren",
        "for": "für",
        "saving": "Speichern...",
        "save.changes": "Änderungen speichern",
        "generate.website": "Website generieren",
        "changes.saved.success": "Änderungen erfolgreich gespeichert!",
        "podcast.cover.menu": "Podcast Cover",
        "podcast.info.menu": "Podcast-Info",
        "profile.menu": "Profil",
        "platform.links.menu": "Plattformlinks",
        "call.to.action.menu": "Handlungsaufforderung",
        "color.styles.menu": "Farbstile",
        "view.website": "Website besuchen"
      },
      "podcastMoveModal": {
        "move.episode.label": "Bewege diese Episode nach:",
        "move.episode.instruction": "Sie können einen neuen Namen eingeben, um einen Ordner zu erstellen.",
        "move.episode.button": "Bewegen",
        "move.episode.error.selectFolder": "Bitte wählen Sie einen Ordner aus, um die Episode zu verschieben."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "AI-Einstellungen für den {{podcastTitle}} Podcast",
        "ai.customize.writing.style": "Passen Sie Ihren AI-Schreibstil an",
        "ai.content.writing.preference": "Wie möchten Sie, dass Podsqueeze Ihren Inhalt schreibt?",
        "ai.voice.placeholder": "Beispiel: Professioneller, aber freundlicher Ton. Die Zuhörer sind Podcaster. Schreiben Sie in der ersten Person.",
        "ai.character.limit.reached": "Sie haben Ihr Zeichenlimit von 50 erreicht. ",
        "ai.upgrade.now": "Jetzt upgraden",
        "ai.fix.transcript.misspells": "Rechtschreibfehler im Transkript beheben",
        "ai.enter.misspelled.words": "Schreiben Sie die Wörter auf, die die KI häufig in diesen Podcast-Episoden falsch schreibt, z.B. Namen",
        "ai.enter.word.press.enter": "Geben Sie ein Wort ein und drücken Sie die Eingabetaste",
        "ai.add.word": "Wort hinzufügen",
        "ai.tag.limit.reached": "Das Limit von 1 Tag wurde erreicht. ",
        "ai.save": "Speichern",
        "ai.save.close": "Speichern & Schließen"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Episodentitel",
        "selectedEpisode.podcastName": "Podcastname",
        "selectedEpisode.showNotes": "Show-Notizen",
        "selectedEpisode.timestamp": "Zeitstempel",
        "selectedEpisode.staticTimestamp": "Statischer Zeitstempel",
        "selectedEpisode.mentions": "Erwähnungen",
        "selectedEpisode.newsletter": "Newsletter",
        "selectedEpisode.titles": "Titel",
        "selectedEpisode.tweeter": "Tweeter",
        "selectedEpisode.shortPost": "Kurzer Beitrag",
        "selectedEpisode.transcription": "Transkription",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Schlüsselwörter",
        "selectedEpisode.quotes": "Zitate",
        "selectedEpisode.longPost": "Langer Beitrag",
        "selectedEpisode.bulletPoints": "Stichpunkte",
        "selectedEpisode.publicLink": "Öffentlicher Link",
        "selectedEpisode.embeddedId": "Eingebettete ID",
        "selectedEpisode.episodeUrl": "Episoden-URL"
      },
      "sidebar": {
        "tools": "Werkzeuge",
        "find.podcast.topic.ideas": "Podcast-Themenideen finden",
        "podcast.thumbnail.maker": "Podcast-Thumbnail-Ersteller",
        "podcast.seo.optimizer": "Podcast-SEO-Optimierer",
        "account": "Konto",
        "payment.settings": "Zahlungseinstellungen",
        "support": "Unterstützung",
        "logout": "Abmelden",
        "plan": "Plan",
        "resets.in": "Zurücksetzen in",
        "api.access": "API-Zugriff",
        "days": "Tagen und",
        "hours": "Stunden",
        "upgrade.plan": "Plan upgraden"
      },
      "updateEmailModal": {
        "email.validation.error": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        "email.change.confirm": "Sind Sie sicher, dass Sie Ihre E-Mail-Adresse ändern möchten?",
        "email.change.success": "Ihre E-Mail-Adresse wurde erfolgreich geändert!",
        "email.in.use.error": "Diese E-Mail-Adresse wird bereits verwendet. Bitte versuchen Sie eine andere.",
        "email.recent.login.error": "Bitte melden Sie sich erneut mit der aktuellen E-Mail-Adresse an, bevor Sie mit dieser Aktion fortfahren.",
        "email.invalid.error": "Ungültige E-Mail-Adresse. Bitte versuchen Sie eine andere.",
        "subscription.cancel.error": "Bitte kündigen Sie zuerst Ihr aktives kostenpflichtiges Abonnement.",
        "account.delete.confirm": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten?\n\nDiese Aktion kann nicht rückgängig gemacht werden.",
        "account.delete.success": "Ihr Konto wurde erfolgreich gelöscht.",
        "account.delete.error": "Etwas ist schiefgelaufen und wir konnten Ihr Konto nicht löschen.\n\nBitte wenden Sie sich an unseren Benutzersupport.",
        "subscription.cancel": "Abonnement kündigen",
        "account.delete": "Konto löschen",
        "account.delete.warning": "Das Löschen Ihres Kontos ist irreversibel und wird alle Ihre Inhalte und Anmeldeinformationen dauerhaft löschen. Bitte gehen Sie vorsichtig vor, da diese Aktion nicht rückgängig gemacht werden kann.",
        "current.account.email": "Aktuelle Konten-E-Mail",
        "enter.new.email": "Geben Sie Ihre neue Konten-E-Mail ein",
        "update": "Aktualisieren",
        "change.password": "Passwort ändern",
        "payment.settings": "Zahlungseinstellungen"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "episodentitel"
      },
      "episodelist": {
        "loading.episodes": "Lade Episoden",
        "no.episodes.found": "Keine Episoden gefunden. Bitte versuchen Sie es erneut mit einer gültigen RSS-ID",
        "select.episode": "Wählen Sie die Episode aus, für die Sie Inhalte erstellen möchten",
        "search.episodes": "Episoden suchen..."
      },
      "interfaces": {
        "user.activePlan.tier": "Stufe",
        "user.activePlan.creationDate": "Erstellungsdatum",
        "user.activePlan.minutesAvailable": "Verfügbare Minuten"
      },
      "loadingbar": {
        "loadingbar.magic": "Wir arbeiten noch an unserem Zauber ✨",
        "loadingbar.longer": "Einige Episoden dauern ein wenig länger... 🐌",
        "loadingbar.hardwork": "Unsere Server arbeiten hart 🦾"
      },
      "page": {
        "main.background": "Hintergrund der Hauptkomponente"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Fehler: Der Zugriff auf das Mikrofon oder die Kamera wurde verweigert.",
        "microphone.camera.not.found": "Fehler: Kein Mikrofon oder keine Kamera gefunden.",
        "microphone.camera.not.readable": "Fehler: Das Mikrofon oder die Kamera ist nicht lesbar.",
        "microphone.camera.access.error": "Fehler: Ein unbekannter Fehler ist beim Zugriff auf das Mikrofon oder die Kamera aufgetreten.",
        "media.not.recorded": "Fehler: Es wurde kein Medium aufgezeichnet.",
        "upload.failed": "Fehler: Upload fehlgeschlagen.",
        "upload.success": "Erfolg: Upload erfolgreich abgeschlossen.",
        "upload.in.progress": "Upload läuft...",
        "upload.button": "Aufnahme hochladen",
        "stop.recording": "Aufnahme stoppen",
        "record.audio": "Audio aufnehmen",
        "record.audio.video": "Audio mit Video aufnehmen",
        "record.again": "Aufnahme erneut starten",
        "episode.language": "Episodensprache auswählen"
      },
      "selectBox": {
        "language.english": "Englisch",
        "language.arabic": "Arabisch",
        "language.bulgarian": "Bulgarisch",
        "language.catalan": "Katalanisch",
        "language.croatian": "Kroatisch",
        "language.czech": "Tschechisch",
        "language.danish": "Dänisch",
        "language.dutch": "Niederländisch",
        "language.finnish": "Finnisch",
        "language.french": "Französisch",
        "language.german": "Deutsch",
        "language.greek": "Griechisch",
        "language.hindi": "Hindi",
        "language.hungarian": "Ungarisch",
        "language.indonesian": "Indonesisch",
        "language.italian": "Italienisch",
        "language.japanese": "Japanisch",
        "language.korean": "Koreanisch",
        "language.lithuanian": "Litauisch",
        "language.latvian": "Lettisch",
        "language.malay": "Malaiisch",
        "language.mandarin": "Mandarin",
        "language.norwegian": "Norwegisch",
        "language.polish": "Polnisch",
        "language.portuguese": "Portugiesisch",
        "language.romanian": "Rumänisch",
        "language.russian": "Russisch",
        "language.slovak": "Slowakisch",
        "language.slovenian": "Slowenisch",
        "language.spanish": "Spanisch",
        "language.swedish": "Schwedisch",
        "language.tamil": "Tamil",
        "language.turkish": "Türkisch",
        "language.ukrainian": "Ukrainisch",
        "language.bashkir": "Baskirisch",
        "language.basque": "Baskisch",
        "language.belarusian": "Weißrussisch",
        "language.cantonese": "Kantonesisch",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estnisch",
        "language.galician": "Galicisch",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongolisch",
        "language.persian": "Persisch",
        "language.thai": "Thai",
        "language.uyghur": "Uigur",
        "language.vietnamese": "Vietnamesisch",
        "language.welsh": "Walisisch"
      },
      "selectedepisode": {
        "processing.episode": "Episode wird verarbeitet",
        "processing.time": "Es dauert normalerweise zwischen 5 und 10 Minuten",
        "email.notification": "Sie können dieses Fenster schließen. Wir senden Ihnen eine E-Mail, sobald es bereit ist. Ihr Inhalt wird auch auf Ihrem Dashboard verfügbar sein.",
        "convert.another.episode": "Andere Episode konvertieren",
        "technical.difficulties": "Ups! Wir haben technische Schwierigkeiten. Seien Sie versichert, unser Team kümmert sich darum! Bitte versuchen Sie es später noch einmal.",
        "no.discount": "Keine Sorge, wir werden keine Minuten abziehen!",
        "high.demand": "Wir erleben eine höhere Nachfrage als gewöhnlich, daher kann es länger dauern, Ihre Anfrage zu bearbeiten. Wir entschuldigen uns für die Unannehmlichkeiten!",
        "email.ready": "Wir senden Ihnen eine E-Mail, sobald es bereit ist. Sie können Ihre Ergebnisse auch auf Ihrem Dashboard abrufen.",
        "select.podcast.folder": "Wählen Sie den Podcast-Ordner aus, zu dem diese Episode gehört, oder erstellen Sie einen neuen, indem Sie einen Namen eingeben.",
        "give.voice": "Geben Sie ihm Ihre eigene Stimme",
        "generate.content": "Inhalt generieren",
        "content.ready": "Ihr Inhalt ist bereit!",
        "ask.ai.tune": "Sie können die KI weiterhin bitten, jeden Inhalt anzupassen, um besser auf Ihre Bedürfnisse einzugehen.",
        "not.enough.minutes.title": "Nicht genug Minuten",
        "not.enough.minutes.message": "Sie haben nicht genug Minuten, um diese Episode zu konvertieren. Bitte aktualisieren Sie Ihren Plan.",
        "upgrade.plan": "Plan aktualisieren",
        "convert.shorter.episode": "Kürzere Episode konvertieren",
        "error.title": "Fehler",
        "convert.another.file": "Andere Datei konvertieren"
      },
      "submitfile": {
        "file.size.exceeded.free": "Die Dateigröße überschreitet das maximale Limit von 4 GB. <p>Bitte <a href='/pricing'><b><u>aktualisieren Sie, um größere Dateien hochzuladen</u></b></a></p>",
        "file.size.exceeded.paid": "Die Dateigröße überschreitet das maximale Limit von 10 GB. <p>Bitte wählen Sie eine kleinere Datei aus.</p>",
        "file.upload.invalid": "Bitte laden Sie eine Audio- oder Videodatei hoch",
        "upload.in.progress": "Datei wird hochgeladen. Bitte schließen Sie dieses Fenster nicht.",
        "upload.button": "Hochladen & Generieren",
        "close.button": "Schließen",
        "upgrade.message.free": "Weitere Uploads sind nur für kostenpflichtige Tarife verfügbar.",
        "upgrade.now.button": "Jetzt aktualisieren",
        "pricing.info": "ab 12 $/Monat",
        "upload.file.label": "Laden Sie eine Audio- oder Videodatei hoch",
        "max.file.size.free": "(max 4 GB)",
        "max.file.size.paid": "(max 10 GB)",
        "podsqueeze.audiograms.info": "Podsqueeze erstellt Audiogramme für Audiodateien und kurze Clips für Videodateien",
        "file.placeholder": "Ihre MP3/WAV-Datei",
        "episode.language.label": "Episodensprache",
        "multiple.files.selected": "{{count}} Dateien ausgewählt",
        "clear.all": "Alle löschen",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Mehrere Dateien auswählen",
        "file.upload.error": "Fehler beim Hochladen der Datei",
        "file.upload.success": "Datei erfolgreich hochgeladen",
        "file.upload.processing": "Datei wird verarbeitet",
        "click.to.upload": "Klicken Sie zum Hochladen",
        "click.to.upload.multiple": "Klicken Sie zum Hochladen mehrerer Dateien",
        "select.folder.label": "Ordner auswählen oder erstellen",
        "enter.url": "URL eingeben",
        "upload.file": "Datei hochladen",
        "media.url.label": "Medien-URL",
        "media.url.help": "Geben Sie die URL Ihrer Audio- oder Videodatei ein. Wir werden sie für Sie herunterladen und verarbeiten.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Episodenname",
        "url.input.required": "Bitte geben Sie eine Medien-URL ein",
        "url.upload.error": "Fehler beim Hochladen der Medien von der URL. Bitte überprüfen Sie die URL und versuchen Sie es erneut.",
        "supported.formats": "Unterstützte Formate",
        "uploading": "Wird hochgeladen...",
        "media.url.requirements": "Die URL muss ein direkter Link zu einer öffentlichen Mediendatei sein (keine Webseite)"
      },
      "submitrssid": {
        "error.selectRss": "Bitte wählen Sie einen gültigen RSS-Feed aus dem Dropdown-Menü aus",
        "label.insertRssFeed": "Fügen Sie Ihren RSS-Feed ein",
        "placeholder.insertRssFeed": "Fügen Sie Ihren RSS-Feed ein",
        "label.searchByPodcast": "Stattdessen nach Podcast-Namen suchen",
        "label.searchForPodcast": "Suchen Sie nach Ihrem Podcast-Namen",
        "placeholder.searchForPodcast": "Nach einem Podcast suchen",
        "label.cantFindPodcast": "Können Sie Ihren Podcast nicht finden? ",
        "label.clickHereUseRss": "Klicken Sie hier, um stattdessen Ihren RSS-Feed zu verwenden",
        "label.selectedPodcast": "Ausgewählter Podcast",
        "label.episodeLanguage": "Episodensprache",
        "button.seeAllEpisodes": "Alle Episoden anzeigen",
        "select.folder.label": "Ordner auswählen oder erstellen"
      },
      "submitsection": {
        "search.podcast": "Suche deinen Podcast",
        "upload.audio.video": "Audio oder Video hochladen",
        "record.audio": "Audio aufnehmen",
        "youtube.video": "YouTube-Link",
        "create.content": "Lass uns Inhalte für deinen Podcast erstellen!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Geben Sie die YouTube-Video-URL ein",
        "error.insertYouTubeUrl": "Bitte fügen Sie eine YouTube-URL ein.",
        "label.insertYouTubeUrl": "YouTube-URL einfügen",
        "button.loading": "Wird geladen...",
        "message.downloadingFile": "Datei wird heruntergeladen...",
        "error.processingFailed": "Verarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "button.submitYouTubeVideo": "YouTube-Video einreichen",
        "episode.language.label": "Verwendete Sprache",
        "select.folder.label": "Ordner auswählen oder erstellen"
      },
      "tabs": {
        "tab.label.tab1": "Tab 1",
        "tab.label.tab2": "Tab 2",
        "tab.label.tab3": "Tab 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Das Beste aus Podsqueeze herausholen",
        "tutorial.chapter.introduction": "Einführung",
        "tutorial.chapter.bestShowNotes": "Die besten Show-Notizen und Zeitstempel erhalten",
        "tutorial.chapter.blogPosts": "Nutzung von Blogbeiträgen und Newslettern",
        "tutorial.chapter.editingTranscripts": "Transkripte einbetten und bearbeiten",
        "tutorial.chapter.personalizingAI": "KI personalisieren und Ihre eigene Stimme geben",
        "tutorial.chapter.speedingUpNotes": "Show-Notizen beschleunigen",
        "tutorial.chapter.creatingClips": "Videoclips und Bilder erstellen",
        "tutorial.chapter.generatingLandingPage": "Eine Landingpage generieren",
        "tutorial.chapter.shareResults": "Ergebnisse mit Ihrem Team teilen",
        "tutorial.closeVideoCheckbox": "Video schließen, sobald die ersten Ergebnisse vorliegen"
      },
      "uploadloadingbar": {
        "upload.loading": "Wird geladen..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Kontaktiere uns",
        "contact.section.email": "Schreibe uns an support@podsqueeze.com",
        "contact.section.tiago.role": "Mitbegründer",
        "contact.section.joao.role": "Mitbegründer",
        "contact.section.image.alt.sendMessage": "Nachricht senden",
        "contact.section.image.alt.tiago": "Mitbegründer Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Mitbegründer Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Kontaktiere uns",
        "contact.section.email": "Schreibe uns an support@podsqueeze.com",
        "contact.section.tiago.role": "Mitgründer",
        "contact.section.joao.role": "Mitgründer",
        "contact.section.image.alt.sendMessage": "Nachricht senden",
        "contact.section.image.alt.tiago": "Mitgründer Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Mitgründer Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Schließen Sie sich 20.000 Content-Erstellern und Podcast-Profis an, die Podsqueeze verwenden",
        "content.creators": "Content-Ersteller",
        "podcast.managers": "Podcast-Manager",
        "producers.studios": "Produzenten & Studios",
        "for.podcasters": "FÜR PODCASTER, PODCAST-MANAGER UND AGENTUREN",
        "manage.content.creation": "Verwalten Sie die Inhaltserstellung mühelos für",
        "multiple.podcasts": "mehrere Podcasts",
        "podsqueeze.description": "Podsqueeze ist ein leistungsstarkes Tool für alle Podcast-Profis. Egal, ob Sie ein Solo-Podcaster, Podcast-Manager oder eine Agentur sind, Podsqueeze bietet alle Funktionen, die Sie benötigen, um Ihren Workflow zur Erstellung von Podcast-Inhalten zu optimieren.",
        "create.podcast.folders": "Erstellen Sie Podcast-Ordner, um Ihre Episoden organisiert zu halten.",
        "share.content.page": "Teilen Sie Ihre Inhaltsseite einfach mit Kunden und Team",
        "tune.ai.voice": "Passen Sie die KI-Stimme für jede Show an, die Sie verwalten",
        "plan.content.episodes": "Planen Sie die Inhalte für die nächsten Episoden mit unserem fortschrittlichen",
        "podcast.topics.finder": "Podcast-Themenfinder",
        "podsqueeze.testimonial": "Die Fähigkeit von Podsqueeze, Eingabeaufforderungen zu verwenden, um die Inhalte jedes Podcasts, den wir verwalten, anzupassen und sie für zukünftige Episoden zu speichern, ermöglicht es uns, die Stimmen jeder Show konsistent zu halten. Dies ist ein Elite-Feature, das wir in keinem anderen Tool finden konnten.",
        "coo.podigy": "COO bei Podigy Podcasts",
        "agenciessection.joinCreators": "Schließen Sie sich 20.000 Content-Erstellern und Podcast-Profis an, die Podsqueeze verwenden",
        "agenciessection.contentCreators": "Content-Ersteller",
        "agenciessection.podcastManagers": "Podcast-Manager",
        "agenciessection.producersStudios": "Produzenten & Studios",
        "agenciessection.forPodcasters": "FÜR PODCASTER, PODCAST-MANAGER UND AGENTUREN",
        "agenciessection.manageContent": "Verwalten Sie die Inhaltserstellung mühelos für",
        "agenciessection.multiplePodcasts": "mehrere Podcasts",
        "agenciessection.podsqueezeDescription": "Podsqueeze ist ein leistungsstarkes Tool für alle Podcast-Profis. Egal, ob Sie ein Solo-Podcaster, Podcast-Manager oder eine Agentur sind, Podsqueeze bietet alle Funktionen, die Sie benötigen, um Ihren Workflow zur Erstellung von Podcast-Inhalten zu optimieren.",
        "agenciessection.createPodcastFolders": "Erstellen Sie Podcast-Ordner, um Ihre Episoden organisiert zu halten.",
        "agenciessection.shareContent": "Teilen Sie Ihre Inhaltsseite einfach mit Kunden und Team",
        "agenciessection.tuneAI": "Passen Sie die KI-Stimme für jede Show an, die Sie verwalten",
        "agenciessection.planContent": "Planen Sie die Inhalte für die nächsten Episoden mit unserem fortschrittlichen",
        "agenciessection.podcastTopicsFinder": "Podcast-Themenfinder",
        "agenciessection.podsqueezeQuote": "Die Fähigkeit von Podsqueeze, Eingabeaufforderungen zu verwenden, um die Inhalte jedes Podcasts, den wir verwalten, anzupassen und sie für zukünftige Episoden zu speichern, ermöglicht es uns, die Stimmen jeder Show konsistent zu halten. Dies ist ein Elite-Feature, das wir in keinem anderen Tool finden konnten.",
        "agenciessection.coO": "COO bei Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NEUE FUNKTION",
        "seamless.editing": "Nahtloses Bearbeiten und Audioverbesserung für natürliche, ",
        "high.quality.results": " hochqualitative Ergebnisse",
        "experience.seamless.audio.editing": "Erleben Sie nahtloses Audio-Editing mit fortschrittlichen KI-Algorithmen für erstklassige Aufnahmen. ",
        "remove.ums": "Ums entfernen",
        "enhance.sound.quality": ", Pausen und verbessern Sie die Klangqualität mit nur einem Klick.",
        "enhance.audio.now": "Audio jetzt verbessern",
        "sample.audio.recorded": "Beispielaudio, direkt vom Telefon aufgenommen.",
        "original.recording": "Originalaufnahme",
        "audio.after.ai.edit": "Audio nach KI-Bearbeitung und -Verbesserung",
        "experience.audio.editing": "Erleben Sie nahtloses Audio-Editing mit fortschrittlichen KI-Algorithmen für erstklassige Aufnahmen. "
      },
      "home-blogsection": {
        "more.resources.label": "MEHR RESSOURCEN FÜR DEINEN PODCAST",
        "learn.how.to.get.most": "Erfahre, wie du das Beste aus",
        "your.content": "deinem Inhalt",
        "get.most.out.of.ai.content": "Das Beste aus KI-generierten Inhalten für deinen Podcast herausholen",
        "welcome.to.podsqueeze": "Willkommen bei Podsqueeze – der einfachsten Möglichkeit, deinen Podcast zu transkribieren und fesselnde Inhalte zu erstellen...",
        "will.google.penalize.ai.content": "Wird Google deine KI-generierten Inhalte bestrafen?",
        "ai.content.discussion": "Das Aufkommen von KI-generierten Inhalten hat Diskussionen entfacht und Bedenken unter Inhaltsanbietern, Vermarktern und SEO-Experten geweckt...",
        "what.is.rss.feed": "Was ist ein RSS-Feed für Podcasts und wie nutzt man ihn",
        "rss.feed.benefits": "Als Podcaster hast du vielleicht schon einmal den Begriff 'RSS-Feed' gehört, aber du weißt vielleicht nicht genau, was es ist oder wie es dir nützen kann...",
        "visit.blog": "Blog besuchen"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS & AUDIOGRAMME",
        "clipsAndAudiograms.subtitle": "Verwandle deinen Podcast mühelos in Clips",
        "clipsAndAudiograms.description": "Wähle einfach ein Kapitel aus deiner Episode aus und exportiere es als Clip oder Audiogramm für TikTok, Instagram und YouTube Shorts. Wähle eine Vorlage und passe sie deinem eigenen Stil an.",
        "clipsAndAudiograms.createClips": "Jetzt Clips erstellen",
        "textEditor.title": "Textbasierter Editor",
        "textEditor.description": "Feinabstimmung deiner Clips und Audiogramme direkt aus den Untertiteln. Bearbeite Untertitel und schneide dein Video, indem du bestimmte Wörter entfernst.",
        "oneClickShorts.title": "Ein-Klick-Shorts (<60s)",
        "oneClickShorts.description": "Lass die KI die Bearbeitung für dich übernehmen. Mit einem Knopfdruck verkürzt die KI jedes Kapitel deiner Episode auf unter 60 Sekunden, bereit zum Posten als YouTube Short oder TikTok-Clips."
      },
      "home-conatctsection": {
        "contact.section.title": "Kontaktieren Sie die Gründer",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Entwickler & Podcaster",
        "contact.section.joao.role": "- UX/UI-Designer"
      },
      "home-contentexplanation": {
        "wide.variety.content": "BREITE VIELFALT AN INHALT",
        "generate.content": "Inhalt generieren mit",
        "one.click": " einem Klick!",
        "transcript.srt": "Transkript & SRT",
        "transcript.description": "Erhalten Sie das vollständige Transkript Ihrer Podcast-Episode sowie eine SRT-Datei, die bereit ist, um Untertitel und Untertitel zu generieren.",
        "show.notes": "Show-Notizen",
        "show.notes.description": "Fassen Sie die Hauptthemen Ihrer Episode zusammen und machen Sie sie durchsuchbarer",
        "timestamps": "Zeitstempel",
        "timestamps.description": "Erstellen Sie Kapitel mit Zeitstempeln und leiten Sie die Zuhörer zu bestimmten Segmenten Ihrer Podcast-Episode",
        "blog.social.posts": "Blog- & Social-Posts",
        "blog.social.posts.description": "Posten Sie über Ihre Podcast-Episode überall und gewinnen Sie neue Zuhörer",
        "newsletter": "Newsletter",
        "newsletter.description": "Halten Sie Ihre Zuhörer mit neuen Episoden auf dem Laufenden",
        "titles.more": "Titel & mehr!",
        "titles.more.description": "Generieren Sie eingängige Titel, Zitate, Aufzählungspunkte, Schlüsselwörter und mehr!",
        "see.sample.content": "BEISPIELINHALT ANSEHEN",
        "wannabe.entrepreneur": "Wollte Unternehmer - #299 Podsqueeze hat gerade 100.000 $ Jahresumsatz erreicht!",
        "making.space": "Raum schaffen - Steve Harvey: „Sie könnten genauso gut weitermachen“",
        "modern.wisdom": "Moderne Weisheit - Erik Hoel - Ein Leitfaden zum grundlegenden Geheimnis des Geistes"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Trennlinie"
      },
      "home-explanationsection": {
        "fast.accurate": "SCHNELL UND GENAU",
        "generate.content": "Inhalt für deinen Podcast mit der",
        "power.of.ai": "Kraft der KI",
        "upload.image.alt": "Bild hochladen",
        "select.episode": "Wähle eine Episode aus deinem RSS-Feed oder lade eine Audio-/Videodatei hoch",
        "paste.rss.feed": "Füge einfach die URL deines RSS-Feeds ein, um eine Episode aus der Liste auszuwählen oder eine Audio- oder Videodatei hochzuladen.",
        "content.image.alt": "Inhaltsbild",
        "one.click.content": "Erhalte alle Inhalte mit einem Klick!",
        "user.friendly.interface": "Intuitive und benutzerfreundliche Oberfläche, die du sofort nutzen kannst. Generiere Inhalte für deinen Podcast mit einem Klick.",
        "tune.image.alt": "Stimmungsbild",
        "edit.fine.tune": "Bearbeite und passe jeden Inhalt fein an",
        "direct.edit.content": "Bearbeite und passe jeden Inhalt direkt nach deinen Wünschen mit KI an. Zum Beispiel kannst du nach einem bestimmten Ton, direkter oder indirekter Rede fragen oder einfach falsch geschriebene Namen korrigieren.",
        "multiple.language.support": "Unterstützung mehrerer Sprachen",
        "language.flags.alt": "Sprachflaggen",
        "generate.content.aria": "Inhalt generieren"
      },
      "home-featuressection": {
        "loading": "Laden...",
        "transcribe.write.show.notes": "Transkribieren und schreiben Sie Show-Notizen für Ihren Podcast",
        "twenty.times.faster": "20x schneller",
        "save.manual.work": "Sparen Sie bis zu 100 % der manuellen Arbeit. Transkribieren Sie Ihren Podcast automatisch mit modernster Genauigkeit und Sprecherkennzeichnung und erstellen Sie vollständige Show-Notizen und Social-Media-Beiträge in Ihrer eigenen Stimme.",
        "generate.content": "Inhalt generieren",
        "transcripts": "Transkripte",
        "full.transcript": "Erhalten Sie das vollständige Transkript Ihrer Podcast-Episoden und YouTube-Video-Transkripte sowie eine SRT-Datei für Untertitel.",
        "show.notes": "Show-Notizen",
        "summarize.generate.show.notes": "Fassen Sie zusammen und generieren Sie Show-Notizen in Ihrer eigenen Stimme, komplett mit Zeitstempeln, Aufzählungspunkten und Erwähnungen.",
        "blog.newsletter": "Blog und Newsletter",
        "actionable.blog.posts": "Erhalten Sie umsetzbare Blogbeiträge zu Ihren Episoden und versandbereite Newsletter mit den wichtigsten Erkenntnissen.",
        "social.media": "Soziale Medien",
        "short.posts.insights": "Erhalten Sie kurze Beiträge und kleine Einblicke, um das Wort in sozialen Medien zu verbreiten.",
        "quote": "Von all den besten KI-Transkriptionstools, die wir getestet haben, hat Podsqueeze die nützlichsten Ergebnisse für Show-Notizen, Zeitstempel, Titel, Erwähnungen, Beispiel-Blogbeiträge und wichtige Zitate generiert.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Mitbegründer von Transistor.fm",
        "transcribe_and_write_show_notes": "Transkribieren und schreiben Sie Show-Notizen für Ihren Podcast",
        "twenty_times_faster": "20x schneller",
        "save_manual_work": "Sparen Sie bis zu 100 % der manuellen Arbeit. Transkribieren Sie Ihren Podcast automatisch mit modernster Genauigkeit und Sprecherkennzeichnung und erstellen Sie vollständige Show-Notizen und Social-Media-Beiträge in Ihrer eigenen Stimme.",
        "generate_content": "Inhalt generieren",
        "full_transcript": "Erhalten Sie das vollständige Transkript Ihrer Podcast-Episoden und YouTube-Video-Transkripte sowie eine SRT-Datei für Untertitel.",
        "show_notes": "Show-Notizen",
        "summarize_and_generate_show_notes": "Fassen Sie zusammen und generieren Sie Show-Notizen in Ihrer eigenen Stimme, komplett mit Zeitstempeln, Aufzählungspunkten und Erwähnungen.",
        "blog_and_newsletter": "Blog und Newsletter",
        "actionable_blog_posts": "Erhalten Sie umsetzbare Blogbeiträge zu Ihren Episoden und versandbereite Newsletter mit den wichtigsten Erkenntnissen.",
        "social_media": "Soziale Medien",
        "short_posts_and_insights": "Erhalten Sie kurze Beiträge und kleine Einblicke, um das Wort in sozialen Medien zu verbreiten.",
        "testimonial": "Von all den besten KI-Transkriptionstools, die wir getestet haben, hat Podsqueeze die nützlichsten Ergebnisse für Show-Notizen, Zeitstempel, Titel, Erwähnungen, Beispiel-Blogbeiträge und wichtige Zitate generiert.",
        "cofounder_transistor": "Mitbegründer von Transistor.fm"
      },
      "home-page": {
        "main.background": "Hintergrundfarbe für die Hauptkomponente"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "HÖREN SIE UNSEREN PODCAST",
        "podcast.section.subtitle": "Meisterklassen von",
        "podcast.section.highlight": "erfahrenen Podcastern",
        "podcast.section.description": "Hören Sie unseren Podcast, in dem wir erfahrene Podcaster und Nutzer von Podsqueeze aus der ganzen Welt interviewen. Wir bitten sie, ihre Tipps, Einblicke, Geschichten und alles, was Sie wissen müssen, um Ihren eigenen Podcast zu wachsen, zu teilen.",
        "podcast.link.spotify": "Auf Spotify hören",
        "podcast.link.apple": "Auf Apple Podcasts hören",
        "podcast.link.youtube": "Auf YouTube hören"
      },
      "home-spinner": {
        "spinner.loading": "Wird geladen..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatisiere deinen Podcast",
        "tagline.productionPromotion": "Produktion & Promotion",
        "tagline.launchGrow": "Starte und wachse mühelos deinen Audio- oder Video-Podcast mit allem, was du an einem Ort benötigst, mit Hilfe von KI.",
        "tagline.uploadGenerate": "Erstellen Sie ganz einfach Podcast-Transkripte, Zusammenfassungen, kurze Clips mit Untertiteln und vieles mehr!",
        "tagline.singleClick": " Alles mit einem einzigen Klick.",
        "tagline.transcripts": "Podcast Transkripte",
        "tagline.showNotes": "Show-Notizen",
        "tagline.newslettersBlogs": "Newsletter & Blogs",
        "tagline.socialPosts": "Soziale Beiträge",
        "tagline.shortClipsAudiograms": "Kurze Clips & Audiogramme",
        "tagline.podcastWebsite": "Podcast-Website",
        "tagline.aiAudioEnhancement": "KI-Audioverbesserung",
        "tagline.removeSilences": "Entferne Pausen und Ähs",
        "tagline.generateNow": "Jetzt kostenlos generieren",
        "tagline.noCreditCard": "Keine Kreditkarte erforderlich",
        "testimonial.robWalling.title": "Rob Walling, Startup-Persönlichkeit",
        "testimonial.robWalling.subtitle": "Startups für den Rest von uns Podcast",
        "testimonial.robWalling.quote": "Die Show-Notizen von Podsqueeze sind die besten. Wir nutzen sie oft für Zusammenfassungen und um Einblicke aus anderen Podcasts zu gewinnen.",
        "testimonial.johnGarmet.title": "John Garmet, Betriebsleiter",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze hilft uns, effizienter zu sein und mehr Inhalte für unsere Kunden zu generieren. Wir empfehlen es sehr.",
        "testimonial.davidJackson.title": "David Jackson, Podcast-Coach",
        "testimonial.davidJackson.subtitle": "Schule des Podcastings",
        "testimonial.davidJackson.quote": "Podsqueeze ist mein Brainstorming-Partner. Es ist der beste Weg, um Podcast-Marketing zu entwickeln."
      },
      "home-testimonials": {
        "testimonials.title": "Was sagen die Leute über Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Verwenden Sie KI, um Ihre Podcast-Inhalte neu zu nutzen | Product Hunt",
        "testimonials.heading": "Was sagen die Leute über Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Falsches Passwort",
        "error.userNotFound": "Benutzer nicht gefunden",
        "error.somethingWentWrong": "Ups, etwas ist schiefgelaufen",
        "button.sendResetEmail": "Zurücksetzungs-E-Mail senden",
        "button.login": "Anmelden",
        "placeholder.email": "E-Mail-Adresse",
        "placeholder.password": "Passwort",
        "link.forgotPassword": "Passwort vergessen?",
        "link.createAccount": "Konto erstellen",
        "text.or": "ODER",
        "button.continueWithGoogle": "Mit Google fortfahren",
        "text.podcastDescription": "Starten und wachsen Sie mühelos Ihren Audio- oder Video-Podcast mit allem, was Sie an einem Ort benötigen.",
        "feature.transcripts": "Transkripte",
        "feature.showNotes": "Show-Notizen",
        "feature.newslettersAndBlogs": "Newsletter & Blogs",
        "feature.socialPosts": "Soziale Beiträge",
        "feature.shortClipsAndAudiograms": "Kurze Clips & Audiogramme",
        "feature.podcastWebsite": "Podcast-Website",
        "feature.aiAudioEnhancement": "KI-Audioverbesserung",
        "feature.removeSilences": "Stille und Ähs entfernen",
        "button.sendVerificationEmail": "Verifizierungse-Mail senden",
        "error.emailNotVerified": "E-Mail nicht verifiziert",
        "text": {
          "pleaseVerifyAccount": "Bitte Bestätigen Sie Ihr Konto",
          "checkSpamFolder": "Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Bitte überprüfen Sie Ihren Posteingang und Spam-Ordner.",
          "or": "ODER"
        },
        "button": {
          "resendVerificationEmail": "Bestätigungs-E-Mail Erneut Senden",
          "sendVerificationEmail": "Bestätigungs-E-Mail Senden"
        },
        "success": {
          "verificationEmailSent": "Bestätigungs-E-Mail erfolgreich gesendet!"
        },
        "error": {
          "verificationEmailFailed": "Fehler beim Senden der Bestätigungs-E-Mail. Bitte versuchen Sie es erneut."
        }
      },
      "page": {
        "login.form": "Anmeldeformular"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze Partnerseite",
        "affiliate.page.description": "Verdienen Sie 25 % Provision auf jeden Verkauf, der über Ihren exklusiven Empfehlungslink innerhalb von 15 Monaten getätigt wird. Teilen Sie Ihren Link auf Ihrer Website, in sozialen Medien oder mit Ihren Freunden. Die Anmeldung dauert nur wenige Sekunden. Sie werden automatisch genehmigt."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Das beste Geschenk für einen Podcaster",
        "bestGiftForPodcaster.description": "Entdecken Sie die besten Geschenke für Podcaster, um ihr Erlebnis zu verbessern.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Mehr Podcast-Hörer gewinnen",
        "get-more-podcast-listeners.description": "Gewinnen Sie mehr Podcast-Hörer und optimieren Sie die Produktion mit automatischen Show-Notizen, kurzen Clips, um Ihre Show in sozialen Medien zu fördern, und vielem mehr."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Wachsen Sie Ihr Podcast-Publikum",
        "grow_your_podcast_audience.description": "Sparen Sie eine Menge Zeit und vergrößern Sie Ihr Podcast-Publikum mit Podsqueeze. Erstellen Sie vollständige Shownotes, Social-Media-Beiträge, kurze Clips und mehr für Ihren Podcast."
      },
      "index": {
        "home.page.title": "AI Podcast Show-Notizen, Transkripte, Zusammenfassungen und Clip-Generator.",
        "home.page.description": "Generieren Sie Show-Notizen, Zeitstempel, Newsletter und mehr für Ihren Podcast mit einem Klick! Erstellen Sie schnell Inhalte für Ihren Podcast und passen Sie sie an Ihre Bedürfnisse an. Kostenlose Anmeldung."
      },
      "login": {
        "login.tryItNow": "Jetzt ausprobieren!",
        "login.createAccountDescription": "Erstellen Sie ein Konto und beginnen Sie mit einem Klick, Shownotes, Zeitstempel, Newsletter und mehr für Ihren Podcast zu generieren! Generieren Sie schnell Inhalte für Ihren Podcast und passen Sie sie an Ihre Bedürfnisse an. Kostenlose Anmeldung."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing für Podcasts",
        "marketing.for.podcasts.description": "Podsqueeze optimiert das Marketing für Podcasts mit automatisch generierten Shownotes, Social-Media-Beiträgen und kurzen Clips, um Ihre Reichweite zu erhöhen und Ihre Show zu vergrößern."
      },
      "media": {
        "media.page.title": "Podsqueeze Medienseite",
        "media.page.description": "Erfahren Sie mehr über Podsqueeze. Kontaktieren Sie uns! Wir würden uns freuen, zusammenzuarbeiten!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Podcast-Beschreibungsgenerator",
        "podcast.description.generator.description": "Verbessern Sie die Reichweite und das Engagement Ihres Podcasts mit KI-generierten Beschreibungen. Automatisieren Sie das Schreiben Ihrer Shownotes und gewinnen Sie wertvolle Zeit zurück."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Nutzen Sie Ihren Podcast für Social-Media-Beiträge",
        "convert.podcast.episodes.to.social.media.posts": "Konvertieren Sie Podcast-Episoden in Social-Media-Beiträge. Generieren Sie automatisch Beiträge für LinkedIn, Twitter, Facebook und kurze Clips für TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Kostenloser Podcast-Themen-Generator",
        "podcast.topics.generator.description": "Unser kostenloser Podcast-Themen-Generator hilft Ihnen, die besten Themenideen zu finden und prognostiziert deren potenzielle Reichweite auf Google und YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Ihr Podcast-Virtual-Assistent",
        "podcast.virtual.assistant.description": "KI-Podcast-Virtual-Assistent, der Ihre Shownotes schreibt und Social-Media-Beiträge erstellt. Optimieren Sie Ihre Podcast-Produktion und -Vermarktung mit Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Preise",
        "pricing.description": "Erstellen Sie Shownotes, Zeitstempel, Newsletter und mehr für Ihren Podcast mit einem Klick! Wir haben mehrere Preisklassen, um Ihre Podcast-Bedürfnisse zu erfüllen."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promote deinen Podcast",
        "promote.your.podcast.description": "Erstelle Show-Notizen, Social-Media-Beiträge und kurze Clips, um deinen Podcast in nur wenigen Minuten zu veröffentlichen und zu bewerben."
      },
      "register": {
        "create.podsqueeze.account": "Ein Podsqueeze-Konto erstellen",
        "generate.content.podcast": "Erstellen Sie mit einem Klick Shownotes, Zeitstempel, Newsletter und mehr für Ihren Podcast! Generieren Sie schnell Inhalte für Ihren Podcast und passen Sie sie an Ihre Bedürfnisse an. Kostenlose Anmeldung."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Podcast-Inhalte automatisch umwandeln",
        "repurpose.your.podcast.content.with.ai": "Wandeln Sie Ihre Podcast-Inhalte mit KI um. Generieren Sie automatisch Show-Notizen, Titel, kurze Clips für TikTok und vieles mehr – alles mit einem Klick!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "KOSTENLOSER Podcast SEO Optimizer",
        "seo.optimizer.description": "Analysieren und optimieren Sie Ihre Podcast-Episoden für bessere Sichtbarkeit in Suchmaschinen mit KI-gestützten SEO-Empfehlungen.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analysieren und optimieren Sie Ihre Podcast-Episoden für bessere Sichtbarkeit in Suchmaschinen mit KI-gestützten SEO-Empfehlungen.",
        "seo.optimizer.selectEpisode": "Wählen Sie eine Episode zur Analyse",
        "seo.optimizer.results": "SEO-Analyseergebnisse",
        "seo.optimizer.searchPodcastPlaceholder": "Nach einem Podcast suchen",
        "seo.optimizer.searchEpisodesPlaceholder": "Episoden durchsuchen...",
        "seo.optimizer.analyseAnotherEpisode": "Eine andere Episode analysieren",
        "seo.optimizer.findingEpisodes": "Alle Episoden werden gefunden...",
        "seo.optimizer.analysingEpisode": "Episode wird analysiert",
        "seo.optimizer.scoreTooltip": "Bewertung:",
        "seo.optimizer.topKeywords": "Wir haben diese Top-Keywords identifiziert:",
        "seo.optimizer.topKeywordsnote": "Basierend auf der Keyword-Analyse am Ende der Seite.",
        "seo.optimizer.optimizedContent": "Basierend auf Keywords sind hier der optimierte Titel und die Beschreibung:",
        "seo.optimizer.originalTitle": "Ursprünglicher Titel",
        "seo.optimizer.optimizedTitle": "Optimierter Titel",
        "seo.optimizer.originalDescription": "Ursprüngliche Beschreibung",
        "seo.optimizer.optimizedDescription": "Optimierte Beschreibung",
        "seo.optimizer.showMore": "Mehr anzeigen",
        "seo.optimizer.showLess": "Weniger anzeigen",
        "seo.optimizer.keywordAnalysis": "Keyword-Analyse",
        "seo.optimizer.keywordAnalysisnote": "Bewertungen werden basierend auf der Suche nach Volumen, Wettbewerb (wie viele andere Ergebnisse es für das gleiche Keyword gibt) und bei YouTube auf der durchschnittlichen Anzahl der Ansichten pro Video für das gleiche Keyword berechnet.",
        "seo.optimizer.seoScore": "SEO-Bewertung",
        "seo.optimizer.spotifyScore": "Spotify-Bewertung",
        "seo.optimizer.youtubeScore": "YouTube-Bewertung",
        "seo.optimizer.totalScore": "Gesamt"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - KI-Podcast-Inhaltserzeugungswerkzeug",
        "podsqueeze.description": "Erzeugen Sie mit einem Klick Shownotes, Zeitstempel, Newsletter und mehr für Ihren Podcast! Generieren Sie schnell Inhalte für Ihren Podcast und passen Sie sie an Ihre Bedürfnisse an. Kostenlose Anmeldung."
      },
      "thumbnail-creator": {
        "title": "Kostenloser Podcast-Thumbnail-Generator - Erstelle KI-gestützte Episode-Thumbnails",
        "description": "Erstelle beeindruckende Podcast-Thumbnails mit KI. Generiere professionelle, aufmerksamkeitsstarke Episode-Grafiken, die die Sichtbarkeit erhöhen und mehr Hörer zu deinem Podcast locken.",
        "selectPodcast": "Wähle Deinen Podcast",
        "loadEpisodes": "Episoden Laden",
        "selectEpisode": "Episode zum Erstellen eines Thumbnails auswählen",
        "createThumbnail": "Thumbnail Erstellen",
        "results": "Dein Generiertes Thumbnail",
        "download": "Herunterladen",
        "share": "Teilen",
        "regenerate": "Neu Generieren",
        "editThumbnail": "Thumbnail Bearbeiten",
        "editPlaceholder": "Beschreibe, wie du dieses Thumbnail ändern möchtest...",
        "customPrompt": "Benutzerdefinierte Eingabe",
        "yourThumbnail": "Dein Thumbnail",
        "createAnother": "← Weiteres Thumbnail Erstellen",
        "findingEpisodes": "Episoden werden gesucht...",
        "searchPodcastPlaceholder": "Suche nach deinem Podcast...",
        "searchingPodcasts": "Podcasts werden durchsucht...",
        "heroDescription": "Generiere beeindruckende, professionelle Podcast-Thumbnails mit KI-gestütztem Design, das Aufmerksamkeit erregt und die Sichtbarkeit deiner Episoden steigert.",
        "generatedWithPrompt": "Generiert mit der Eingabe:",
        "customPromptPlaceholder": "Gib eine benutzerdefinierte Eingabe für die Thumbnail-Generierung ein...",
        "generating": "Generiere...",
        "generate": "Generieren",
        "modernMinimalist": "Modern & Minimalistisch",
        "vibrantDynamic": "Lebhaft & Dynamisch",
        "professionalClean": "Professionell & Sauber",
        "generatingThumbnail": "Thumbnail wird generiert...",
        "generatingNewThumbnail": "Neues Thumbnail wird generiert...",
        "showingFirstEpisodes": "Zeige die ersten 10 Episoden. Verwende die Suche, um spezifische Episoden zu finden.",
        "imageUrlCopied": "Bild-URL in die Zwischenablage kopiert!",
        "failedToGenerate": "Fehler beim Generieren des Thumbnails. Bitte versuche es erneut.",
        "promotionalTitle": "Generiere Shownotizen, Zeitstempel, Virale Clips und Vieles Mehr mit Podsqueeze",
        "promotionalSubtitle": "Schließe dich über 100K+ Erstellern an und beginne, deine Show wachsen zu lassen",
        "startNow": "Jetzt starten",
        "free": "KOSTENLOS",
        "podcast": "PODCAST",
        "thumbnail": "THUMBNAIL",
        "creator": "ERSTELLER",
        "replaceFace": "Gesicht Ersetzen",
        "uploading": "Hochladen...",
        "uploadImageError": "Bitte lade eine Bilddatei hoch.",
        "uploadFailedError": "Fehler beim Hochladen des Bildes. Bitte versuche es erneut.",
        "uploadingImage": "Bild wird hochgeladen...",
        "generatingNewThumbnailLoading": "Neues Thumbnail wird generiert...",
        "failedToGenerateWithFace": "Fehler beim Generieren des Thumbnails mit Gesichtsersetzung. Bitte versuche es erneut."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Neuen Podcast-Ordner erstellen",
      "folder.name.placeholder": "Ordnernamen eingeben",
      "create.button": "Erstellen"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Episoden werden geladen...",
        "episodeList.noEpisodes": "Keine öffentlichen Episoden verfügbar",
        "episodeList.checkBack": "Schauen Sie später nach neuen Episoden vorbei",
        "episodeList.title": "Episoden dieses Podcasts",
        "episodeList.readLess": "WENIGER LESEN",
        "episodeList.readMore": "MEHR LESEN",
        "episodeList.coverImageAlt": "Cover für {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Loslegen",
        "alert.subscriptionRunning": "Ihr aktuelles Abonnement läuft noch.\n\nBitte kündigen Sie Ihr aktuelles Abonnement, bevor Sie ein neues kaufen.",
        "alert.subscriptionEnds": "Ihr aktuelles Abonnement läuft noch.\n\nEs endet am {date}",
        "alert.subscriptionCancelled": "Ihr Abonnement wurde bereits gekündigt und endet am {date}",
        "button.openDashboard": "Dashboard öffnen",
        "button.signUp": "Registrieren",
        "button.buySubscription": "Abonnement kaufen",
        "button.cancelled": "Storniert",
        "button.cancelSubscription": "Abonnement kündigen",
        "button.upgradeSubscription": "Abonnement upgraden",
        "button.loading": "Laden",
        "upgrade.details.currentMinutes": "Dies wird einen neuen Abonnementzeitraum starten. Sie behalten alle Ihre aktuellen Minuten.",
        "upgrade.details.remainingAnnual": "Dieser Wert wurde basierend auf der verbleibenden Zeit in Ihrem aktuellen Jahresabonnement berechnet."
      },
      "page": {
        "pricing.free.title": "Kostenlos",
        "pricing.free.subtitle": "Teste Podsqueeze. Keine Kreditkarte erforderlich.",
        "pricing.free.price.annual": "0 $ Jährlich abgerechnet",
        "pricing.free.features.podcast_time": "30 Minuten Podcastzeit pro Monat",
        "pricing.free.features.video_clips": "3 Videoausschnitte",
        "common.with_watermark": "mit Wasserzeichen",
        "pricing.free.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.free.features.file_upload": "Datei-Upload bis zu 4Gb",
        "pricing.free.features.upload": "1 Upload",
        "pricing.free.features.landing_pages": "Podcast-Startseiten",
        "pricing.free.features.audio_enhancement": "Audio-Verbesserung",
        "common.sign_up": "Anmelden",
        "common.open_dashboard": "Dashboard öffnen",
        "pricing.starter.title": "Starter",
        "pricing.starter.subtitle": "Perfekt für Hobby-Podcaster, die Zeit sparen möchten.",
        "pricing.starter.price.annual": "132 $ Jährlich abgerechnet",
        "minutes.accumulate": "Minutenübertrag",
        "pricing.starter.features.podcast_time": "160 Minuten Podcastzeit pro Monat",
        "pricing.starter.features.video_clips": "10 Videoausschnitte oder Audiogramme",
        "pricing.starter.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.starter.features.file_upload": "Datei-Upload bis zu 4Gb",
        "pricing.starter.features.unlimited_uploads": "Unbegrenzte Uploads",
        "pricing.starter.features.landing_pages": "Podcast-Startseiten",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Für Profis, die Podcasting nutzen, um ihre Geschäfte zu entwickeln und zu unterstützen.",
        "pricing.pro.price.annual": "324 $ Jährlich abgerechnet",
        "pricing.pro.features.podcast_time": "320 Minuten Podcastzeit pro Monat",
        "pricing.pro.features.personalize_ai_voice": "AI-Stimme personalisieren",
        "pricing.pro.features.video_clips": "20 Videoausschnitte oder Audiogramme",
        "common.no_watermark": "kein Wasserzeichen",
        "pricing.pro.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.pro.features.file_upload": "Datei-Upload bis zu 10Gb",
        "pricing.pro.features.unlimited_uploads": "Unbegrenzte Uploads",
        "pricing.pro.features.landing_pages": "Podcast-Startseiten",
        "common.customizable": "anpassbar",
        "pricing.pro.features.audio_video_edit": "Audio- und Video-Magic-Edit",
        "pricing.pro.features.everything_in_pro": "Alles in Pro",
        "pricing.agency_lite.title": "Agentur Lite",
        "pricing.agency_lite.subtitle": "Für Podcast-Agenturen, die ihr Geschäft optimieren und wachsen möchten.",
        "pricing.agency_lite.price.annual": "495 $ Jährlich abgerechnet",
        "pricing.agency_lite.features.podcast_time": "600 Minuten Podcastzeit pro Monat",
        "pricing.agency_lite.features.personalize_ai_voice": "AI-Stimme personalisieren",
        "pricing.agency_lite.features.video_clips": "40 Videoausschnitte oder Audiogramme",
        "pricing.agency_lite.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.agency_lite.features.file_upload": "Datei-Upload bis zu 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Unbegrenzte Uploads",
        "pricing.agency_lite.features.landing_pages": "Podcast-Startseiten",
        "pricing.agency_lite.features.audio_video_edit": "Audio- und Video-Magic-Edit",
        "pricing.agency_plus.title": "Agentur Plus",
        "pricing.agency_plus.subtitle": "Für Podcast-Agenturen, die ihr Geschäft optimieren und wachsen möchten.",
        "pricing.agency_plus.price.annual": "1.251 $ Jährlich abgerechnet",
        "pricing.agency_plus.features.podcast_time": "2000 Minuten Podcastzeit pro Monat",
        "pricing.agency_plus.features.personalize_ai_voice": "AI-Stimme personalisieren",
        "pricing.agency_plus.features.video_clips": "80 Videoausschnitte oder Audiogramme",
        "pricing.agency_plus.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.agency_plus.features.file_upload": "Datei-Upload bis zu 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Unbegrenzte Uploads",
        "pricing.agency_plus.features.landing_pages": "Podcast-Startseiten",
        "pricing.agency_plus.features.audio_video_edit": "Audio- und Video-Magic-Edit",
        "pricing.agency_scale.title": "Agentur Scale",
        "pricing.agency_scale.subtitle": "Für Podcast-Agenturen, die ihr Geschäft optimieren und wachsen möchten.",
        "pricing.agency_scale.price.annual": "2.175 $ Jährlich abgerechnet",
        "pricing.agency_scale.features.podcast_time": "4000 Minuten Podcastzeit pro Monat",
        "pricing.agency_scale.features.personalize_ai_voice": "AI-Stimme personalisieren",
        "pricing.agency_scale.features.video_clips": "160 Videoausschnitte oder Audiogramme",
        "pricing.agency_scale.features.quote_images": "Unbegrenzte Zitatbilder",
        "pricing.agency_scale.features.file_upload": "Datei-Upload bis zu 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Unbegrenzte Uploads",
        "pricing.agency_scale.features.landing_pages": "Podcast-Startseiten",
        "pricing.agency_scale.features.audio_video_edit": "Audio- und Video-Magic-Edit",
        "pricing.header": "Für Solo-Podcaster und Podcast-Agenturen",
        "pricing.minutes_reset": "Sie können bis zu 3x Ihre monatlichen Minuten ansammeln, solange Sie in Ihrem aktuellen Plan bleiben oder upgraden.",
        "pricing.most_popular": "Beliebt",
        "pricing.minutes_per_month": "Minuten pro Monat",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Für Podcast-Agenturen und Medienunternehmen, die ihr Geschäft skalieren möchten.",
        "pricing.enterprise_price": "Angepasst",
        "pricing.enterprise_price_note": "Kontaktieren Sie team@podsqueeze.com oder buchen Sie einen Termin unten.",
        "pricing.enterprise_feature_priority_support": "Prioritäre Unterstützung",
        "pricing.enterprise_feature_team_sits": "Mehrere Team-Sitzungen",
        "pricing.enterprise_personalized_team_training": "Team-Onboarding und Training",
        "pricing.book_demo": "Termin buchen",
        "pricing.unlimited": "Unbegrenzt",
        "pricing.custom": "Angepasst"
      },
      "toggle": {
        "pay.monthly": "Monatlich",
        "pay.annually": "Jährlich",
        "discount.30percent": "30% RABATT"
      },
      "upgradeModal": {
        "upgrade.success": "Ihr Abonnement wurde erfolgreich aktualisiert",
        "upgrade.error": "Es tut uns leid, etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut",
        "upgrade.loading": "Aktualisiere",
        "upgrade.confirmPay": "Bestätigen & Bezahlen",
        "upgrade.cancel": "Abbrechen",
        "coupon.placeholder": "Gutscheincode",
        "coupon.apply": "Anwenden",
        "coupon.have": "Ich habe einen Gutschein",
        "upgrade.confirmation": "Sie sind dabei, auf zu aktualisieren",
        "upgrade.price": "Sie werden bezahlen"
      }
    },
    "register": {
      "page": {
        "register.form": "Registrierungsformular"
      },
      "registerForm": {
        "error.invalidCredentials": "Bitte geben Sie eine gültige E-Mail-Adresse und ein Passwort ein.",
        "error.weakPassword": "Bitte verwenden Sie ein stärkeres Passwort 💪",
        "error.emailInUse": "Benutzer existiert bereits",
        "error.userNotFound": "Benutzer nicht gefunden",
        "error.generic": "Ups, etwas ist schiefgelaufen",
        "placeholder.email": "E-Mail-Adresse",
        "placeholder.password": "Passwort",
        "button.registering": "Registriere...",
        "button.register": "Registrieren",
        "label.newsletter": "Schließen Sie sich 12.000 Podcastern an und abonnieren Sie unseren Newsletter für Produktupdates, umsetzbare Tipps, E-Books, Verlosungen und mehr.",
        "label.alreadyHaveAccount": "Haben Sie bereits ein Konto?",
        "label.logInHere": "Hier einloggen",
        "label.or": "ODER",
        "button.signingIn": "Anmelden...",
        "button.continueWithGoogle": "Mit Google fortfahren",
        "label.podcastDescription": "Starten und wachsen Sie mühelos Ihren Audio- oder Video-Podcast mit allem, was Sie an einem Ort benötigen.",
        "feature.transcripts": "Transkripte",
        "feature.showNotes": "Show-Notizen",
        "feature.newslettersBlogs": "Newsletter & Blogs",
        "feature.socialPosts": "Soziale Beiträge",
        "feature.shortClips": "Kurze Clips & Audiogramme",
        "feature.podcastWebsite": "Podcast-Website",
        "feature.audioEnhancement": "KI-Audioverbesserung",
        "feature.removeSilences": "Stille und Ähs entfernen"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "Text"
      },
      "TopicFinder": {
        "competition.veryHigh": "SEHR HOCH",
        "competition.high": "HOCH",
        "competition.medium": "MITTEL",
        "competition.low": "NIEDRIG",
        "competition.veryLow": "SEHR NIEDRIG",
        "upgrade.button": "Upgrade auf Pro",
        "clicks.label": "Klicks",
        "searches.label": "Suchanfragen",
        "competition.label": "Wettbewerb",
        "fetching.results": "Ergebnisse werden abgerufen",
        "table.topic": "Thema",
        "tooltip.topic": "Das Hauptthema, das in deiner Podcast-Episode behandelt wird",
        "table.monthlySearches": "Monatliche Suchanfragen",
        "tooltip.monthlySearches": "Der Bereich monatlicher Google-Suchanfragen, den du erwarten kannst",
        "table.competition": "Wettbewerb",
        "tooltip.competition": "Das Hauptthema oder der Hauptgegenstand, der im Podcast behandelt wird.",
        "table.monthlyGoogleClicks": "Monatliche Google-Klicks",
        "tooltip.monthlyGoogleClicks": "Eine Vorhersage des Bereichs monatlicher Google-Klicks, die du erwarten kannst",
        "table.youtubeReach": "YouTube-Reichweite",
        "tooltip.youtubeReach": "Eine Vorhersage der maximalen YouTube-Aufrufe, die du in den ersten 6 Monaten erwarten kannst, basierend auf dem Durchschnittswettbewerber",
        "intro.title": "Kostenloser Podcast-Themen-Generator",
        "intro.description": "Erhalte Themenideen für deinen Podcast, nach denen das Publikum sucht",
        "intro.check1": "Überprüfe die Nachfrage nach jeder Themenidee bei Google",
        "intro.check2": "Finde heraus, wie wettbewerbsfähig jede Podcast-Themenidee ist",
        "intro.check3": "Schätze die Google-Klicks und YouTube-Aufrufe, die du erhalten kannst",
        "upgrade.message": "Du musst auf Pro upgraden, um auf alle Ergebnisse zuzugreifen",
        "learnMore.label": "Erfahre mehr über den",
        "learnMore.link": "kostenlosen Podcast-Themen-Generator",
        "newSearch.button": "Neue Suche",
        "share.button": "Diese Suche teilen",
        "form.label": "Gib deine Podcast-Nischen ein",
        "form.placeholder": "Digitales Marketing",
        "form.submit": "Themenideen finden"
      },
      "page": {
        "main.background": "Hintergrund"
      },
      "shareTopics": {
        "share.results": "Ergebnisse teilen",
        "share.facebook": "Auf Facebook teilen",
        "share.whatsapp": "Auf WhatsApp teilen",
        "share.twitter": "Auf Twitter teilen",
        "share.linkedin": "Auf LinkedIn teilen",
        "copy.success": "Kopiert",
        "copy.link": "Link kopieren"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "Aufrufe"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Aktuelle Komposition konnte nicht abgerufen werden",
        "error.addImage": "Fehler beim Hinzufügen des Bildelements:",
        "alert.uploadImage": "Bitte laden Sie eine Bilddatei hoch.",
        "error.uploadImage": "Fehler beim Hochladen des Bildes:",
        "alert.uploadFailed": "Hochladen des Bildes fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "error.getDownloadURL": "Fehler beim Abrufen der Download-URL:",
        "alert.processImageFailed": "Verarbeitung des hochgeladenen Bildes fehlgeschlagen. Bitte versuchen Sie es erneut.",
        "error.addText": "Fehler beim Hinzufügen des Textelements:",
        "text.settingsPlaceholder": "Einstellungen werden angezeigt, wenn das Element ausgewählt ist",
        "text.addElement": "Element hinzufügen",
        "text.uploading": "Hochladen...",
        "button.uploadImage": "Bild hochladen",
        "text.newText": "Neuer Text",
        "button.addText": "Text hinzufügen",
        "text.selectedElementSettings": "Einstellungen des ausgewählten Elements"
      },
      "FontSelector": {
        "allFonts": "Alle Schriftarten",
        "myFonts": "Meine Schriftarten",
        "uploadFont": "Schriftart hochladen",
        "noCustomFonts": "Noch keine benutzerdefinierten Schriftarten.",
        "uploadToAdd": "Laden Sie eine Schriftartdatei hoch, um sie zu Ihrer Sammlung hinzuzufügen.",
        "text_outline": "Textkontur",
        "outline_color": "Konturfarbe",
        "outline_width": "Konturbreite"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Anpassen",
        "imageLayoutSettings.zoom": "Zoom",
        "imageLayoutSettings.horizontalAlignment": "Horizontale Ausrichtung",
        "imageLayoutSettings.verticalAlignment": "Vertikale Ausrichtung",
        "imageLayoutSettings.deleteElement": "Element löschen"
      },
      "TemplateBox": {
        "confirm.delete.template": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?"
      },
      "TextSettings": {
        "error.getting_current_text": "Fehler beim Abrufen des aktuellen Textes:",
        "event.delete_text_element_clicked": "Text-Element gelöscht",
        "error.changing_text_font": "Fehler beim Ändern der Schriftart:",
        "event.text_font_changed": "Schriftart geändert",
        "error.changing_text_size": "Fehler beim Ändern der Textgröße:",
        "event.text_size_changed": "Textgröße geändert",
        "error.changing_text_color": "Fehler beim Ändern der Textfarbe:",
        "event.text_color_changed": "Textfarbe geändert",
        "event.text_content_added": "Textinhalt hinzugefügt",
        "error.adding_text_content": "Fehler beim Hinzufügen des Textinhalts:",
        "event.text_content_updated": "Textinhalt aktualisiert",
        "label.text_content": "Textinhalt",
        "label.text_font": "Schriftart",
        "label.text_font_weight": "Schriftstärke",
        "label.adjust_text_size": "Textgröße anpassen",
        "label.text_color": "Textfarbe",
        "button.delete": "Löschen"
      },
      "audiogramBaseTemplate": {
        "color.white": "Weiß",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "standardEpisodenUrl",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "quadratisch-aus",
        "animation.fade": "einblenden",
        "type.text": "Text",
        "name.podcastTitle": "PodcastTitel",
        "name.snippetTitle": "SnippetTitel",
        "type.image": "Bild",
        "name.audioBackgroundImage": "AudioHintergrundBild",
        "name.subtitlesText": "UntertitelText",
        "effect.highlight": "hervorheben",
        "type.audio": "Audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "Snippet-Titel",
        "podcast.title": "Podcast-Titel",
        "new.episode": "NEUE FOLGE"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Weiß",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "standardEpisodenUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "hintergrundmusik",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Bitte laden Sie eine Bilddatei hoch.",
        "upload.file.loading": "Datei wird hochgeladen. Bitte schließen Sie dieses Fenster nicht.",
        "upload.image.label": "Laden Sie Ihr eigenes Bild hoch",
        "ai.prompt.label": "Geben Sie einen Prompt ein, damit die KI ein Bild generiert",
        "ai.prompt.placeholder": "Z.B.: Ein Hund, der im Park läuft...",
        "ai.processing": "Wird verarbeitet...",
        "ai.create": "Erstellen",
        "customize.image.title": "Bild anpassen",
        "enter.image.url": "Bild-URL eingeben",
        "or": "oder"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Fehler beim Abrufen der Vorlagen:",
        "template.savedSuccessfully": "Vorlage erfolgreich gespeichert",
        "error.savingTemplate": "Fehler beim Speichern der Vorlage:",
        "loading.savedTemplates": "Gespeicherte Vorlagen werden geladen...",
        "no.savedTemplates": "Keine Vorlagen gespeichert",
        "select_template": "Vorlage auswählen",
        "saving.template": "Vorlage wird gespeichert...",
        "template_name": "Vorlagenname",
        "enter.templateName": "Vorlagenname eingeben",
        "cancel": "Abbrechen",
        "save": "Speichern",
        "default_templates": "Standardvorlagen",
        "saved_templates_count": "Gespeicherte Vorlagen ({count})",
        "folder_templates_count": "Ordner-Vorlagen ({count})",
        "account_templates_count": "Konto-Vorlagen ({count})",
        "save_current_template": "Aktuelle Vorlage speichern"
      },
      "subtitlesElement": {
        "edit.word": "Wort bearbeiten",
        "edit.label": "bearbeiten",
        "remove.word.subtitle": "Wort nur aus dem Untertitel entfernen",
        "erase.subtitle": "aus dem Untertitel löschen",
        "remove.word.clip": "Wort aus Audio und Untertitel entfernen",
        "remove.clip": "aus dem Clip entfernen"
      },
      "utils": {
        "video.utils.title": "Titel",
        "video.utils.currentTime": "Aktuelle Zeit",
        "video.utils.nextTime": "Nächste Zeit",
        "video.utils.duration": "Dauer",
        "video.utils.description": "Beschreibung",
        "video.utils.srtSegment": "SRT-Segment"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Ihr Untertiteltext hier"
      }
    }
  },
  "en": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "BECOME OUR PARTNER",
        "SHARE_PODSQUEEZE": "Share Podsqueeze with your audience",
        "AND_EARN_MONEY": "and earn money!",
        "LAST_UPDATED": "Last updated: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Become an Affiliate Partner",
        "EARN_COMMISSION": "Earn ",
        "COMMISSION": " commission",
        "ON_EVERY_SALE": "on every sale made through your exclusive referral link for a period of 15 months. Share your link on your website, social media, or with your friends. Takes seconds to join.",
        "GET_AUTOMATICALLY_APPROVED": "Get automatically approved.",
        "JOIN_NOW": "Join now",
        "HOW_IT_WORKS": "HOW IT WORKS",
        "FREQUENTLY_ASKED_QUESTIONS": "Frequently Asked Questions",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "What is an Affiliate Partner?",
        "AFFILIATE_PARTNER_DESCRIPTION": "An Affiliate partner is someone who promotes another company's products or services through a unique referral link and earns a commission on every sale made through that link.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "How can I become an Affiliate Partner?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Becoming an Affiliate Partner is quick and easy, taking just a few seconds of your time. To get started, simply click the 'Join Now' button and sign up using your email. Once registered, you'll gain access to a user-friendly dashboard where you'll find your unique referral link. Share this link with your family, friends, or online audience. Whenever someone clicks on your referral link and makes a purchase on Podsqueeze's website, you'll earn a 25% commission on each payment for an entire 15 months! Keep track of your earnings effortlessly through your Affiliate dashboard, which provides a clear overview of all the sales you've generated.",
        "HOW_CAN_I_TRACK_MY_SALES": "How can I track my sales and commissions?",
        "TRACKING_SALES_DESCRIPTION": "Use our affiliate program dashboard to track your sales and commissions. The tracking software is available for both Affiliate Partners and Business Partners.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "When and how will I receive my payment?",
        "PAYMENT_DESCRIPTION": "You will receive your payment via PayPal every 30 days. Please note that there is a minimum payout threshold of $50. So, as soon as you reach this amount, you can expect to receive your payment like clockwork every 30 days.",
        "STILL_GOT_QUESTIONS": "STILL GOT QUESTIONS?",
        "SEND_US_A_MESSAGE": "Send us a message on the support chat or email us to team@podsqueeze.com",
        "NOTE": "Note",
        "AFFILIATE_ADS_RESTRICTION": "Affiliates are expressly prohibited from creating ads on Google or engaging in bidding for relevant keywords associated with Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Affiliate Terms of Use",
        "CAN_I_RUN_ADS": "Can I run ads and CPC campaigns on Google to promote my referral link?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Affiliates are strictly prohibited from creating ads on search engines or engaging in keyword bidding related to Podsqueeze. This restriction helps maintain the integrity of our advertising strategy and ensures consistent brand messaging. Please note that sales resulting from such bidding campaigns will not be eligible for payout.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "How does Podsqueeze generate titles for your Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "NavBar",
        "main.affiliateHero": "Affiliatehero",
        "main.footer": "Footer"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Add Intro & Outro Music",
        "intro.music": "Intro Music",
        "outro.music": "Outro Music",
        "intro.duration": "Intro Duration",
        "outro.duration": "Outro Duration",
        "intro.mode": "Intro Mode",
        "outro.mode": "Outro Mode",
        "cancel": "Cancel",
        "save": "Save",
        "apply": "Apply",
        "current.intro.music": "Current Intro Music",
        "current.outro.music": "Current Outro Music",
        "change.music": "Change Music",
        "choose.music": "Choose Music File",
        "browser.not.support.audio": "Your browser does not support the audio element.",
        "save.and.apply": "Save & Apply",
        "no.music.selected": "No music selected",
        "delete.music": "Delete music",
        "uploading.file": "Uploading file...",
        "download.audio": "Download Audio",
        "download.video": "Download Video"
      },
      "audioEditElements": {
        "error.processing.rss": "We are experiencing some difficulties processing some RSS feeds. Please upload a file.",
        "edit.enhance.audio": "Edit and enhance your audio recording",
        "trial.label": "Trial",
        "audio.editing.experience": "Experience seamless audio editing with advanced AI algorithms for natural, high-quality results, with just one click.",
        "improve.audio.quality": "Improve Audio Quality",
        "remove.hums.silences": "Remove Hums & Silences",
        "upgrade.edit.audio": "Upgrade to be able to edit your audio with one single click",
        "available.plans": "Available for All Paid Plans",
        "upgrade.now": "Upgrade Now",
        "audio.element.support": "Your browser does not support the audio element.",
        "download.audio": "Download Enhanced Audio",
        "loading.audio": "Loading Audio",
        "editing.audio": "Editing Audio",
        "add.intro.outro": "Add Intro & Outro",
        "add.intro.outro.music": "Add intro and outro music to your audio"
      },
      "videoEditElements": {
        "error.exporting.video": "Error while exporting video",
        "download.failed": "Download failed: {error.message}",
        "generating.video": "Generating Video",
        "error.generating.clip": "Error Generating Clip",
        "please.retry.support": "Please retry or reach out to our user support",
        "browser.not.support.video": "Your browser does not support the video tag.",
        "this.might.take.minutes": "Please don't close the window, this might take a few minutes.",
        "exporting.video": "Exporting your video...",
        "seamless.audio.editing": "Experience seamless audio editing with advanced AI algorithms for natural, high-quality results, with just one click.",
        "difficulties.processing.rss": "We are experiencing some difficulties processing some RSS feeds. Please upload a file.",
        "edit.enhance.video.recording": "Edit and enhance your video recording",
        "trial": "Trial",
        "enhance.audio.quality": "Enhance Audio Quality",
        "enhance.audio.quality.edit": "Enhance Audio Quality & Edit",
        "trim.filler.words.video": "Trim filler words from video (ex: hums)",
        "trim.long.silences.video": "Trim long silences from video",
        "upgrade.to.edit.video": "Upgrade to be able to edit your video with one single click",
        "available.pro.agency.plans": "Available for All Paid Plans",
        "upgrade.now": "Upgrade Now",
        "download.only.audio": "Download Only Audio",
        "download.video": "Download Video",
        "export.video": "Export Video",
        "please.dont.close.window": "Please don't close the window",
        "add.intro.outro": "Add Intro & Outro",
        "add.intro.outro.music": "Add intro and outro music to your video"
      },
      "videogramBaseTemplate": {
        "media.fit": "cover",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "media"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Other episodes from this Podcast",
        "tab.shownotes": "Show Notes",
        "tab.timestamps": "Timestamps",
        "tab.blogpost": "Blog Post",
        "tab.transcript": "Transcript",
        "key.points": "Key Points"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Your landing page is live in our podcast finder. Share it with your audience!",
        "landingPage.create": "Create a beautiful landing page for this episode",
        "landingPage.edit": "Edit Page",
        "landingPage.visit": "Visit Page",
        "landingPage.delete": "Delete Page",
        "landingPage.createButton": "Create Landing Page"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Manage Episode Links",
        "youtube.link": "YouTube Link",
        "enter.youtube.link": "Enter YouTube link",
        "apple.podcasts.link": "Apple Podcasts Link",
        "enter.apple.podcasts.link": "Enter Apple Podcasts link",
        "spotify.link": "Spotify Link",
        "enter.spotify.link": "Enter Spotify link",
        "saving": "Saving...",
        "save": "Save",
        "social.links.updated.successfully": "Social links updated successfully!"
      },
      "affiliatesection": {
        "affiliate.section.title": "BECOME AN AFFILIATE PARTNER",
        "affiliate.section.subtitle": "Share Podsqueeze with your audience and",
        "affiliate.section.earn": "earn money!",
        "affiliate.section.commission": "Our affiliate program offers 25% commission for 15 months, on every sale and subscription renewal payment.",
        "affiliate.section.join": "Takes seconds to join!",
        "affiliate.section.knowMore": "Know More"
      },
      "asseenon": {
        "podnews.logo": "podnews logo",
        "transistor.logo": "transsistor logo",
        "thepodcasthost.logo": "the podcast host logo",
        "schoolofpodcasting.logo": "School of podcasting logo",
        "semrush.logo": "semrush logo"
      },
      "assembleshownotes": {
        "episode.description": "Episode Description",
        "bullet.points": "Bullet Points",
        "timestamps": "Timestamps",
        "links.and.mentions": "Links & Mentions",
        "extra.content": "Extra Content",
        "assemble.show.notes": "Assemble Your Show Notes",
        "downloading": "Downloading",
        "copied": "Copied",
        "enter.placeholder": "Enter {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Taking a break from podcasting",
        "cancellation.option.no_recurrent": "I don't want a recurrent subscription",
        "cancellation.option.expensive": "It's too expensive",
        "cancellation.option.not_saving_time": "Is not saving me enough time",
        "cancellation.option.dissatisfied_content": "Dissatisfied with the quality of the content generated",
        "cancellation.option.unresponsive_support": "Unresponsive customer support",
        "cancellation.option.not_using": "Not using the service enough",
        "cancellation.option.difficulty_navigating": "Difficulty in using/navigating the product",
        "cancellation.option.better_alternative": "Found a better alternative product",
        "cancellation.option.other": "Other",
        "cancellation.video.message": "70% of our users stop the cancellation process after watching this video",
        "cancellation.button.cancel": "I Still Want To Cancel",
        "cancellation.button.try_again": "I Want To Give it Another Try",
        "cancellation.prompt.select_reason": "Please, help us improve the product by selecting the reason for canceling your subscription:",
        "cancellation.placeholder.answer": "Type your answer here...",
        "cancellation.placeholder.specify_reason": "Please specify your reason for cancellation",
        "cancellation.button.next": "Next",
        "cancellation.button.go_back": "Go Back",
        "cancellation.last_question.title": "Last Question From Our Side",
        "lose.all.accumulated.minutes": "If you cancel, you will lose all your accumulated minutes.",
        "keep.accumulating.minutes": "If you cancel, your accumulated minutes will be lost.",
        "here.are.some.ideas": "Here are some ideas to help you continue to benefit from Podsqueeze",
        "convert.and.repurpose.episodes": "Convert and repurpose your older episodes into fresh content",
        "generate.articles.favorite.podcasts.and.vides": "Generate articles from your favorite podcasts",
        "share.your.account.with.a.friend": "Share your account with a friend who could benefit",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Most Of Our Users Stop The Cancellation Process After Watching This Video",
        "cancellation.last_question.prompt": "What changes or improvements would make you consider rejoining our service?",
        "cancellation.feedback.message": "Your feedback will help us improve 🙏",
        "cancellation.button.confirm": "Confirm Cancellation",
        "cancellation.minutes.accumulated": "You have",
        "cancellation.minutes.accumulated.suffix": "accumulated minutes, valued at",
        "cancellation.reminder.text": "Please remember:",
        "cancellation.minutes.warning": "Accumulated minutes are a perk for active subscriptions. By canceling your subscription your minutes will be permanently lost.",
        "cancellation.content.deletion.warning": "All your generated content will be permanently deleted after 30 days.",
        "cancellation.minutes.left.title": "You Still Have Minutes Left! Don't Let Them Go to Waste!",
        "cancellation.suggestion.clips": "Repurpose older episodes into clips for social media",
        "cancellation.suggestion.articles": "Turn older episodes into articles with Podsqueeze to benefit from SEO.",
        "cancellation.suggestion.linkedin": "Turn older authority episodes into linkedin posts to boost your personal brand",
        "cancellation.suggestion.share": "Share your Podsqueeze account with a friend so they can benefit from your unused minutes.",
        "cancellation.button.keep.subscription": "Keep My Subscription",
        "cancellation.button.keep.minutes": "Keep My",
        "cancellation.button.keep.minutes.suffix": "Worth of Minutes",
        "cancellation.lifetime.before_you_go": "Before you go...",
        "cancellation.lifetime.title": "How About Lifetime Access for Just $49?",
        "cancellation.lifetime.subtitle": "Keep your Starter Account. No subscriptions. No renewals. Just yours — forever.",
        "cancellation.lifetime.feature1": "Lifetime access to Podsqueeze for a one-time payment of $49",
        "cancellation.lifetime.feature2": "Use it whenever you need, no pressure — it's yours forever",
        "cancellation.lifetime.feature3": "Includes all current and future Starter Plan features",
        "cancellation.lifetime.button_cancel": "I still want to cancel",
        "cancellation.lifetime.button_deal": "Get lifetime deal",
        "cancellation.downgrade.title": "Keep all of your content for only $5.99/mo",
        "cancellation.downgrade.subtitle": "By downgrading to Starter you get to...",
        "cancellation.downgrade.feature1": "Keep all of your generated content",
        "cancellation.downgrade.feature2": "Keep your websites running",
        "cancellation.downgrade.feature3": "160 minutes and 10 clips a month for occasional work",
        "cancellation.billing.monthly": "Monthly",
        "cancellation.billing.annual": "Annual",
        "cancellation.billing.discount": "30% OFF",
        "cancellation.plan.starter": "Starter Plan",
        "cancellation.price.monthly": "$8.99/mo",
        "cancellation.price.annual": "$5.99/mo",
        "cancellation.price.annual_billing": "billed $71.88 annually",
        "cancellation.feature.minutes": "160 mins/month",
        "cancellation.feature.clips": "10 clips/month",
        "cancellation.downgrade.button": "Downgrade to Starter & Keep Content",
        "cancellation.error.payment_link": "Could not get payment link. Please try again.",
        "cancellation.error.payment_service": "Error connecting to payment service.",
        "cancellation.option.question.break": "Can you tell us more about why you're taking a break?",
        "cancellation.option.question.no_recurrent": "Could you share why you prefer not to have a recurrent subscription?",
        "cancellation.option.question.expensive": "What pricing or features would make the service more valuable for you?",
        "cancellation.option.question.not_saving_time": "What is still taking you a lot of time in your process?",
        "cancellation.option.question.dissatisfied_content": "What aspects of the content were you dissatisfied with?",
        "cancellation.option.question.unresponsive_support": "Can you describe your experience with our customer support?",
        "cancellation.option.question.not_using": "Is there anything that would encourage you to use the service more often?",
        "cancellation.option.question.difficulty_navigating": "What difficulties did you encounter while using or navigating the product?",
        "cancellation.option.question.better_alternative": "Which alternative product did you find and what do you like about it?",
        "cancellation.option.question.other": "Please specify your reason for cancellation:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "We value your privacy",
        "cookiebanner.cookieUsage": "We use cookies to enhance your website experience and analyze our traffic. By clicking accept, you consent to our use of cookies.",
        "cookiebanner.privacyPolicy": "Privacy Policy",
        "cookiebanner.accept": "Accept",
        "cookiebanner.decline": "Decline"
      },
      "episodeTitleBox": {
        "loading": "Loading...",
        "editEpisodeTitleClicked": "Edit Episode Title Clicked",
        "newEpisodeTitleStored": "New Episode Title Stored"
      },
      "famewall": {
        "loading.message": "Loading..."
      },
      "footer": {
        "footer.features": "Features",
        "footer.transcriptGenerator": "Transcript Generator",
        "footer.subtitlesGenerator": "Subtitles Generator",
        "footer.descriptionGenerator": "Description Generator",
        "footer.podcastSummarizer": "Podcast Summarizer",
        "footer.titlesGenerator": "Titles Generator",
        "footer.bulletPointsGenerator": "Bullet Points Generator",
        "footer.chaptersClipsGenerator": "Chapters & Clips Generator",
        "footer.socialMediaPostsGenerator": "Social Media Posts Generator",
        "footer.newsletterGenerator": "Newsletter Generator",
        "footer.blogPostGenerator": "Blog Post Generator",
        "footer.podcastLandingPages": "Podcast Landing Pages",
        "footer.podcastClipMaker": "Podcast Clip Maker",
        "footer.audiogramGenerator": "Audiogram Generator",
        "footer.aiAudioEnhancer": "AI Audio Enhancer",
        "footer.convertYoutubeToText": "Convert Youtube to Text",
        "footer.youtubeVideoNoiseRemover": "Youtube Video Noise Remover",
        "footer.youtubeVideoKeyPoints": "Youtube Video Key Points",
        "footer.freeResources": "Free Resources",
        "footer.findPodcastTopicIdeas": "Find podcast topic ideas",
        "footer.articles": "Articles",
        "footer.freeEbooks": "Free eBooks",
        "footer.community": "Community",
        "footer.ourPodcast": "Our Podcast",
        "footer.product": "Product",
        "footer.giftCard": "Gift Card",
        "footer.onboardingEbook": "Onboarding eBook",
        "footer.pricing": "Pricing",
        "footer.affiliates": "Affiliates",
        "footer.media": "Media",
        "footer.testimonials": "Testimonials",
        "footer.legal": "Legal",
        "footer.privacyPolicy": "Privacy Policy",
        "footer.termsOfUse": "Terms of Use",
        "footer.refundPolicy": "Refund Policy",
        "footer.allRightsReserved": "All Rights Reserved."
      },
      "globalState": {
        "cookie.enabled": "Cookie enabled",
        "language.default": "Default language"
      },
      "head": {
        "keywords.list": "Podsqueeze, AI, Podcasts, Content Generation, Podcast transcription, Shownotes, Timestamps, Podcast Newsletters, Tweets, Blog Posts, Social Posts, Titles, Shownotes writer"
      },
      "imageResultModal": {
        "download.image": "Download Image",
        "generating.image": "Generating Image",
        "ai.prompt.label": "Enter a prompt for the AI to generate an image",
        "ai.prompt.placeholder": "Ex: A dog running in the park...",
        "processing": "Processing...",
        "create": "Create",
        "text.color.label": "Text Color",
        "quote.icon.color.label": "Quote Icon Color",
        "background.color.label": "Background Color",
        "font.label": "Font",
        "upload.cover.image": "Upload Cover Image",
        "aspect.ratio.info": "Aspect ratio 1:1, recommended size 1200x1200",
        "upload.logo.label": "Upload Logo",
        "choose.file": "Choose File",
        "upload.success": "Successfully uploaded",
        "choose.quote": "Choose a Quote",
        "select.template": "Select Template",
        "quote.label": "Quote",
        "enter.quote.here": "Enter Quote Here",
        "author.label": "Author",
        "enter.author.name": "Enter Author Name",
        "podcast.name.label": "Podcast Name",
        "enter.podcast.name": "Enter Podcast Name",
        "colors": "Colors",
        "select.font": "Select Font",
        "cover.logo.images": "Cover & Logo Images",
        "logo.image": "Logo Image",
        "upgrade.here": "Upgrade here",
        "remove.logo": "Remove Podsqueeze logo",
        "default_templates": "Default Templates",
        "saved_templates_count": "Saved Templates",
        "save_current_template": "Save Current Template",
        "no_saved_templates": "No saved templates yet",
        "save_template": "Save Template",
        "cancel": "Cancel",
        "save": "Save",
        "enter_template_name": "Enter template name",
        "reset_template": "Reset",
        "add_element": "Add Element",
        "generate": "Generate",
        "add_image": "Add Image",
        "upload_image": "Upload image",
        "or": "or",
        "generate_with_ai": "Generate with AI",
        "search_fonts": "Search fonts...",
        "upload_logo": "Upload logo",
        "square_image_recommended": "Square image recommended",
        "opacity": "Opacity",
        "layers": "Layers",
        "no_element_selected": "No element selected",
        "bold_shortcut": "Bold (Ctrl+B)",
        "italic_shortcut": "Italic (Ctrl+I)",
        "underline_shortcut": "Underline (Ctrl+U)",
        "edit_text": "Edit text",
        "tint_color": "Tint color",
        "toggle_gradient_transparent": "Toggle gradient to transparent",
        "rotate_gradient": "Rotate gradient 45 degrees",
        "alt_background": "Background",
        "alt_podcast_logo": "Podcast Logo",
        "alt_custom": "Custom",
        "alt_right_side": "Right Side",
        "alt_profile": "Profile"
      },
      "intentModal": {
        "intentModal.title": "What do you want to do with Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Write Show Notes",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Write Blog Post & Newsletter",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Create Video Clips or Audiograms",
        "intentModal.sourceOption.Create_Quote_Images": "Create Quote Images",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Edit & Enhance Audio/Video",
        "intentModal.sourceOption.Transcribe": "Transcribe",
        "intentModal.sourceOption.Create_a_Website": "Create a Website",
        "intentModal.sourceOption.All_of_the_Above": "All of the Above",
        "intentModal.sourceOption.Other": "Other",
        "intentModal.otherPlaceholder": "Please specify",
        "intentModal.submitButton": "Submit & Register",
        "intentModal.skip": "Skip"
      },
      "languageSwitcher": {
        "language.en": "English",
        "language.es": "Español",
        "language.fr": "Français",
        "language.de": "Deutsch",
        "language.it": "Italiano",
        "language.pt": "Português",
        "language.nl": "Nederlands",
        "language.pl": "Polski",
        "language.ru": "Русский",
        "language.zh": "中文",
        "language.ja": "日本語",
        "language.ko": "한국어",
        "language.ar": "العربية",
        "language.th": "ไทย",
        "language.vi": "Tiếng Việt"
      },
      "lazyImage": {
        "lazyImage.alt": "Image description"
      },
      "metadata": {
        "meta.title": "Your Page Title",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Utility"
      },
      "navbar": {
        "navbar.dashboard": "Dashboard",
        "navbar.login": "Login",
        "navbar.openMenu": "Open main menu",
        "navbar.features": "Features",
        "navbar.resources": "Resources",
        "navbar.pricing": "Pricing",
        "navbar.contact": "Contact",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "See all features",
        "navbar.mainFeatures": "MAIN FEATURES",
        "navbar.podcastTranscription": "Podcast and Video Transcription Generator",
        "navbar.transcriptionDescription": "High accuracy transcript with speaker labeling and SRT file for subtitles.",
        "navbar.podcastSummarizer": "Podcast Summarizer",
        "navbar.summarizerDescription": "Create complete show notes 20x faster, in your own voice.",
        "navbar.podcastClipMaker": "Podcast Clip Maker",
        "navbar.clipMakerDescription": "Automatically generate short clips or audiograms for your podcast.",
        "navbar.audioEnhancer": "Ai Audio Enhancer",
        "navbar.audioEnhancerDescription": "Automatically enhance audio, remove silences and filler words.",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE FEATURES WALKTHROUGH",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Actionable articles and guides to launch and grow a successful podcast.",
        "navbar.podcastTopicIdeas": "Podcast Topic Ideas",
        "navbar.topicIdeasDescription": "Discover podcast topics that audiences are searching for.",
        "navbar.actionableEbooks": "Actionable eBooks",
        "navbar.ebooksDescription": "Download free ebooks with actionable tips to take your podcast to the next level.",
        "navbar.freeThumbnailMaker": "Free Podcast Thumbnail Maker",
        "navbar.freeThumbnailMakerDescription": "Create professional, eye-catching episode thumbnails with AI.",
        "navbar.seoOptimizer": "SEO Optimizer",
        "navbar.seoOptimizerDescription": "Optimize your podcast episodes for better search engine visibility.",
        "navbar.podcastDescription": "Listen to our podcast, where we interview experienced podcasters and users of Podsqueeze from around the world. We ask them to share their tips, insights, stories, and everything you need to know to grow your own podcast."
      },
      "resultModal": {
        "prompt.transcript.quote": "Quote",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "First person shownotes",
        "prompt.shownotes.replaceName": "Replace name in shownotes",
        "prompt.shownotes.friendlyTone": "Friendly tone shownotes",
        "prompt.shownotes.youtubeDescription": "YouTube description shownotes",
        "prompt.shownotes.engagingQuestion": "Engaging question shownotes",
        "prompt.timestamps.formatAsChapters": "Format timestamps as chapters with descriptive titles",
        "prompt.timestamps.detailedDescriptions": "Create detailed timestamps with topic descriptions and key takeaways",
        "prompt.timestamps.improveSpeakerNames": "Replace speaker names with more descriptive titles like 'Host', 'Expert', or 'Guest'",
        "prompt.newsletter.casualTone": "Casual tone newsletter",
        "prompt.newsletter.shorter": "Shorter newsletter",
        "prompt.newsletter.contentSections": "Content sections newsletter",
        "prompt.newsletter.changeName": "Change name in newsletter",
        "prompt.mentions.fullURL": "Full URL mentions",
        "prompt.mentions.replaceName": "Replace name in mentions",
        "prompt.tweets.underdogTone": "Underdog tone tweets",
        "prompt.tweets.firstPerson": "First person tweets",
        "prompt.shortPost.relevantEmojis": "Relevant emojis short post",
        "prompt.shortPost.educationalTone": "Educational tone short post",
        "prompt.shortPost.underdogTone": "Underdog tone short post",
        "prompt.shortPost.firstPerson": "First person short post",
        "prompt.titles.youtubeOptimized": "YouTube optimized titles",
        "prompt.titles.startWithHowTo": "Start with 'How to' titles",
        "prompt.titles.otherOptions": "Other options for titles",
        "prompt.keywords.youtubeOptimized": "YouTube optimized keywords",
        "prompt.keywords.separateWithCommas": "Separate keywords with commas",
        "prompt.quotes.lorem1": "Lorem ipsum quote 1",
        "prompt.quotes.lorem2": "Lorem ipsum quote 2",
        "prompt.bulletPoints.lorem1": "Lorem ipsum bullet point 1",
        "prompt.bulletPoints.lorem2": "Lorem ipsum bullet point 2",
        "prompt.longPost.firstPerson": "First person long post",
        "prompt.longPost.relevantEmojis": "Relevant emojis long post",
        "prompt.longPost.changeName": "Change name in long post",
        "alert.tuningInstructionsEmpty": "Tuning instructions cannot be empty.",
        "text.timestamps.byPodsqueeze": "Timestamps by PodSqueeze",
        "button.copied": "Copied",
        "button.copy": "Copy",
        "embed.transcript": "Embed Transcript",
        "embed.description": "Description for embedding",
        "preview.title": "Preview Title",
        "loading.regenerating": "Regenerating...",
        "placeholder.tuningInstructions": "Enter tuning instructions...",
        "button.saveClose": "Save and Close",
        "button.acceptChanges": "Accept Changes",
        "button.discard": "Discard",
        "button.embedTranscript": "Embed Transcript",
        "text.copiedToClipboard": "Copied to clipboard",
        "download.srtFile": "Download SRT File",
        "text.forCaptions": "for captions",
        "tune.title": "Tune Your Results",
        "tune.description": "Adjust your results with the following options.",
        "instruction.label": "Instructions:",
        "button.tuneResult": "Tune Result",
        "instruction.saveForLater": "Save for later",
        "button.readMore": "Read More",
        "button.showLess": "Show Less",
        "customPrompt.used": "Custom Prompt Used:",
        "feedback.happyWithResults": "Are you happy with the results?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Find three good quotes from the transcript",
        "prompt.blog": "Write a 500 words blog post focusing on topic X",
        "prompt.tweets": "Write three engaging tweets from the transcript",
        "transcript.autoTranscribed": "Automatically Transcribed With Podsqueeze",
        "alert.emptyPrompt": "Tuning instructions can not be empty",
        "embed.transcript": "Embed Transcript",
        "embed.description": "Embed a manageable-sized transcript with a search feature on your WordPress site or any HTML-supported page.",
        "button.copied": "Copied!",
        "button.copy": "Copy Code Snippet",
        "transcript.public.available": "Public URL",
        "button.generate": "Generate",
        "preview.title": "Transcript Preview",
        "edit.speakers": "Edit Speaker's Names",
        "button.saveClose": "Save & Close",
        "placeholder.prompt": "eg: Find three good quotes from the transcript",
        "upgrade.pro": "Upgrade to Pro to use this feature",
        "upgrade.link": "Upgrade to Pro",
        "feedback.happy": "Are you happy with the results?",
        "instruction": "Instruction: ",
        "generating.results": "Generating Results",
        "full.transcription": "Full Transcription",
        "srt.file": "& SRT file",
        "download.srt": "Download SRT file",
        "caption.subtitles": "for captions and subtitles.",
        "generate.from.transcript": "Generate From Transcript With Gpt-4.1",
        "gpt.tweak.text": "Ask the latest GPT to tweak the text to your liking. Use natural language and don't be afraid to be specific.",
        "copied.clipboard": "Copied to clipboard",
        "audio.notSupported": "Your browser does not support the audio element.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Add Podcast Name",
        "podcast.title": "{{title}} Podcast"
      },
      "sourceModal": {
        "sourceModal.title": "How did you find out about Podsqueeze?",
        "sourceModal.otherPlaceholder": "Please specify",
        "sourceModal.nextButton": "Next",
        "sourceModal.skip": "Skip"
      },
      "squeezeEditResults": {
        "error.processing.rss": "We are experiencing some difficulties processing some RSS feeds. Please upload a file."
      },
      "squeezeResults": {
        "copiedToClipboard": "Copied To Clip Board",
        "publicLink": "Public at ",
        "createLink": "Create a link to share this Results Page",
        "assembleShowNotes": "Assemble Show Notes",
        "convertAnotherEpisode": "Convert another episode",
        "writtenContent": "Written content",
        "videoClipsAndImages": "Video Clips & Images",
        "editAudio": "Edit & Enhance Audio"
      },
      "squeezeTextCard": {
        "enter.ai.prompt": "Enter new prompt for AI to generate content",
        "enter.ai.prompt.placeholder": "Describe how you want the content to be generated. For example: 'Write a blog post about the main topics discussed in this episode'",
        "save.prompt": "Save",
        "title.placeholder": "Enter title"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "See more and tune",
        "see.more": "See more",
        "generating": "Generating",
        "download.all": "Download All",
        "full.transcription": "Full Transcription",
        "transcript.benefit": "Did you know adding full transcripts to your show notes boosts website traffic and engagement?",
        "learn.more": "Learn more",
        "transcript.bonus": "You can provide full transcripts as a bonus for your podcast membership program.",
        "show.notes": "Show Notes",
        "show.notes.engagement": "Consider complementing this short description with other elements in your show notes for a boost in engagement and SEO.",
        "show.notes.examples": "Find inspiration from these 17 podcast show notes examples to craft the perfect ones for your podcast.",
        "timestamps": "Timestamps",
        "timestamps.benefit": "Add these timestamps to your episode's description and it will automatically create chapters on spotify and youtube.",
        "titles": "Titles",
        "titles.engagement": "Titles featuring question marks and superlatives tend to be particularly engaging.",
        "links.and.mentions": "Links & Mentions",
        "mentions.resources": "Consider including the mentions below within your show notes' resources section.",
        "mentions.affiliate": "See if the products mentioned have affiliate programs and consider adding affiliate links in your show notes.",
        "mentions.social.media": "Tag the people mentioned in your episode on social media to encourage them to share and engage with your post.",
        "keywords": "Keywords",
        "keywords.youtube": "When you upload your episode to YouTube, just copy and paste these keywords into the tag section.",
        "keywords.social.media": "Repurpose these keywords for social media hashtags.",
        "blog.post": "Blog Post",
        "blog.post.linkedin": "Consider using this content to craft a long form Linkedin post,",
        "blog.post.share": "Share this content in Reddit communities and Facebook Groups that align with your podcast's topic.",
        "newsletter": "Newsletter",
        "newsletter.content": "Some of our users repurpose this newsletter content to create more comprehensive episode descriptions for show notes.",
        "linkedin.and.facebook": "Linkedin & Facebook",
        "short.post.description": "Use these brief posts as descriptions when sharing related video clips and audiograms on social media.",
        "tweets": "Tweets",
        "quotes": "Quotes",
        "bullet.points": "Bullet Points",
        "add.custom.result": "Add Custom Result",
        "bullet.points.skimming": "Podcasters often list main episode topics as bullet points in show notes for easy skimming."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "See more and tune",
        "generating": "Generating",
        "not.available.for.rss.feed": "Not available for this rss feed",
        "regenerate.episode.upload.file": "Regenerate the episode and upload your audio/video file directly from your computer",
        "processing.difficulties": "We are experiencing some difficulties processing some RSS feeds. Please upload a file.",
        "video.clips": "Create Video Clips",
        "ai.short.clips": "AI Short Clips",
        "quote.image": "Quote Image"
      },
      "title": {
        "title.text": "your.label"
      },
      "topbar": {
        "topbar.forYou": "For You",
        "topbar.joinPodcast": "Join our next podcasting virtual meet up!",
        "topbar.saveYourSpot": "Save Your Spot",
        "topbar.dismiss": "Dismiss"
      },
      "trackers": {
        "trackers.init": "Initializing trackers with cookies enabled: ",
        "trackers.loadScripts": "Loading tracking scripts..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Welcome to My Application",
        "content.description": "This is a sample application demonstrating translation.",
        "button.submit": "Submit"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI Is Editing Your Clip",
        "export_clip": "Export Clip",
        "ai_edit": "AI Edit",
        "ai_editing_clip_duration": "This will take a few seconds",
        "generating_clip": "Generating your clip...",
        "generating_clip_notice": "This might take a few minutes. We will email you once it's done.",
        "edit_another_video": "You can wait here or edit another video",
        "download_video": "Download Video",
        "back_to_editing": "Back to Editing",
        "export_video_button": "Export Clip",
        "notice_storage": "Notice: We store your audio for 30 days. After this period, this clip will expire.",
        "error_generating_clip": "Error Generating Clip",
        "error_user_support": "Please retry or reach out to our user support",
        "select_template": "Select template",
        "add_30s_prev": "30s from previous chapter",
        "add_30s_next": "30s from next chapter",
        "undo": "Undo",
        "subtitles_font": "Subtitle's Font",
        "subtitles_color": "Subtitles Color",
        "subtitles_box_color": "Animation Color",
        "adjust_podcast_title_position": "Adjust Podcast Title Vertical Position",
        "adjust_subtitles_size": "Adjust Subtitles Size",
        "adjust_subtitles_vertical_position": "Adjust Subtitles Vertical Position",
        "remove_subtitles": "Remove Subtitles",
        "animated_subtitles": "Animated Subtitles",
        "upgrade_here": "Upgrade here",
        "remove_logo": " to remove logo",
        "remove_podsqueeze_logo": "Remove podsqueeze logo",
        "aspect_ratio": "Aspect ratio",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Episode Title",
        "podcast_title": "Podcast Title",
        "titles_font": "Titles Font",
        "title_colors": "Podcast/episode title colors",
        "video_fit": "Video Fit",
        "adjust_horizontal_position": "Adjust Horizontal Position",
        "adjust_vertical_position": "Adjust Vertical Position",
        "adjust_video_zoom": "Adjust Video Zoom",
        "adjust_video_width": "Adjust Video Width",
        "adjust_video_height": "Adjust Video Height",
        "background_color": "Background color",
        "edit_clip": "Edit Clip",
        "edit_layout": "Edit Layout",
        "choose_short": "Choose a Short",
        "edit_audio": "Edit Audio",
        "framing": "Framing",
        "background": "Background",
        "text_style": "Text Style",
        "music": "Music",
        "choose_chapter": "Choose a chapter",
        "clips_left": "You have",
        "clips_left_number": "clips left",
        "apply_layout": "Apply Layout",
        "need_more_clips": "Need more clips? Upgrade Your Plan Here",
        "download_srt_file": "Download SRT File",
        "track_selected": "Track: ",
        "no_background_music": "No Background Music Selected",
        "volume": "Volume:",
        "remove": "Remove",
        "track_ambient_piano": "Ambient piano and strings",
        "track_deep_meditation": "Deep meditation",
        "track_chill_upbeat": "For her chill upbeat",
        "track_inspiring_ambient": "Inspiring cinematic ambient",
        "track_just_relax": "Just relax",
        "track_movement": "Movement",
        "track_once_in_paris": "Once in paris",
        "track_perfect_beauty": "Perfect beauty",
        "track_summer_adventures": "Summer adventures",
        "track_sunset_groove": "Sunset groove",
        "track_tvari_cafe": "Tvari tokyo cafe",
        "track_short_piano_intermezzo": "Short Piano Intermezzo",
        "track_dramatic_background": "Dramatic Background Music",
        "track_dramatic_hiphop": "Dramatic Hip-Hop Jazz",
        "track_emotional_orchestra": "Emotional Orchestra",
        "track_halloween_short": "Halloween Music",
        "track_improvisation_037": "Jazz Improvisation",
        "track_inspiration_piano": "Inspirational Piano",
        "track_medieval_extract": "Medieval Music",
        "track_short_8": "Short Ambient Track",
        "track_flute": "Peaceful Flute",
        "track_piano_guitar_duet": "Piano Guitar Duet",
        "track_intro_jazz": "Intro Jazz",
        "track_romantic_jazz": "Romantic Jazz",
        "track_mysterious_dark_background": "Mysterious Dark Background",
        "track_acoustic_ambient_inspiration": "Acoustic Ambient Inspiration",
        "track_aristocracy_classical": "Aristocracy Classical",
        "track_folk_music_river_knows_my_name": "Folk Music - River Knows My Name",
        "track_funy_adventure": "Fun Adventure",
        "track_energetic_sports_rock_trailer": "Energetic Sports Rock Trailer",
        "track_fun_upbeat_energetic_pop_rock": "Fun Upbeat Energetic Pop Rock",
        "track_epic_emotional_inspirational": "Epic Emotional Inspirational",
        "track_inspirational_epic": "Inspirational Epic",
        "all_music": "All Music",
        "energetic_music": "Energetic",
        "inspirational_music": "Inspirational",
        "ambient_music": "Ambient",
        "chill_music": "Chill",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Quirky",
        "dramatic_music": "Dramatic",
        "acoustic_music": "Acoustic",
        "classical_music": "Classical",
        "categories": "Categories",
        "select_track": "Select Track",
        "upload_music": "Upload Music",
        "my_music": "My Music",
        "recommended_for_youtube": "Recommended for YouTube",
        "turn_into_short_clip": "Turn this clip into a Short (<60s)",
        "browser_not_support_audio": "Your browser does not support the audio element.",
        "watch_tutorial": "Watch this tutorial",
        "audiogram_maker": "on how to take the most of our audiogram maker",
        "store_audio_notice": "Notice: We store your audio for 30 days.",
        "split_screen_mode": "Split Screen Mode",
        "none": "None",
        "vertical_split": "Vertical Split",
        "horizontal_split": "Horizontal Split",
        "layers": "Use the layers below to move them forward or backward.",
        "screen_1_horizontal_position": "Screen 1 Horizontal Position",
        "screen_2_horizontal_position": "Screen 2 Horizontal Position",
        "clip_maker": "on how to take the most of our clip maker",
        "downloading": "Downloading...",
        "download_again": "Download Again",
        "download": "Download",
        "download_failed_alert": "Failed to download video. Please try again.",
        "translate_subtitles": "Translate Subtitles",
        "translate_to": "Translate to",
        "select_language": "Select Language",
        "select_new_language": "Select new language",
        "translating": "Translating...",
        "translation_complete": "Translation Complete",
        "error_translation": "Error during translation. Please try again.",
        "original_language": "Original"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Episode Title"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "You don't have any content yet.",
        "userPodcastsInfo.generateContent": "Generate your first content",
        "placeholder.search_folders": "Search folders...",
        "search.no_results": "No folders match your search."
      },
      "landingPageModal": {
        "upload.error": "Failed to upload image: ",
        "upload.image.file": "Please upload an image file.",
        "upgrade.pro.message": "Page customization is only available for Pro and Agency accounts",
        "upgrade.now": "Upgrade now",
        "upgrade.unique.landing.page": " and make an unique episode landing page.",
        "logo.recommendation": "Recommended logo height 200px",
        "social.links.top.menu": "Social Links on Top Menu",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Enter LinkedIn link",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Enter Facebook link",
        "saving...": "Saving...",
        "save": "Save",
        "saved.successfully": "Saved successfully!",
        "uploading.image": "Uploading image...",
        "upload.episode.cover": "Upload Episode Cover",
        "upload.logo": "Upload Logo",
        "where.listen.episode": "Where else can we listen to this episode?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Enter YouTube link",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Enter Apple Podcasts link",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Enter Spotify link",
        "image.size.recommendation": "Recommended size 1000x1000px",
        "primary.color.label": "Primary Color",
        "header.background.color": "Header background color and links.",
        "landing.page.customization": "Landing Page Customization",
        "create.branded.landing.page": "Create a beautiful branded landing page to share with your listeners",
        "episode.image": "Episode Image",
        "episode.links": "Episode Links",
        "page.header": "Page Header",
        "page.color": "Page Color",
        "visit.landing.page": "Visit Landing Page"
      },
      "page": {
        "loading.dashboard": "Loading Dashboard",
        "convert.new.episode": "Convert New Episode",
        "convert.audio.or.video": "Convert Audio or Video",
        "minutes.left": "You have",
        "need.more.minutes": "Need more minutes?",
        "upgrade.plan": "Upgrade your plan here.",
        "your.podcasts": "Your podcasts",
        "podsqueeze.results.page": "Podsqueeze Results Page",
        "access.podsqueeze.results": "Access podsqueeze results for this episode. You will be able to see all the generated content"
      },
      "podcast": {
        "confirm.delete_episode": "Are you sure you want to delete this episode?",
        "alert.something_wrong": "Something went wrong. Please try again.",
        "confirm.delete_folder": "Are you sure you want to delete this folder?",
        "loading.episodes": "Loading episodes...",
        "folder.empty": "This folder is empty.",
        "content.no_content": "No content available.",
        "content.generate_first": "Generate your first podcast.",
        "button.personalize_ai": "Personalize with AI",
        "button.edit_website": "Edit Website",
        "button.visit_website": "Visit Website",
        "button.generate_website": "Generate Website",
        "placeholder.search": "Search...",
        "label.sort_by": "Sort by",
        "label.last_episodes_loaded": "Last episodes loaded",
        "button.load_all_episodes": "Load all episodes",
        "loading": "Loading...",
        "add.new.episode": "Add New Episode",
        "order.newest": "Newest First",
        "order.oldest": "Oldest First",
        "order.a_to_z": "A to Z",
        "order.z_to_a": "Z to A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Create a new podcast folder:",
        "folder.name.placeholder": "Folder's name",
        "create.button": "Create"
      },
      "podcastLandingModal": {
        "upload.image.error": "Please upload an image file",
        "podcast.cover.title": "Podcast Cover Image",
        "podcast.cover.upload": "Upload your podcast cover image here. This will be displayed prominently on your landing page.",
        "upload.image.uploading": "Uploading image...",
        "podcast.cover.upload.button": "Upload Cover Image",
        "podcast.cover.recommended.size": "Recommended size: 1400x1400 pixels",
        "profile.info.title": "Profile Information",
        "profile.info.upload": "Add your profile picture and name to personalize your landing page.",
        "profile.upload.button": "Upload Profile Picture",
        "profile.name.label": "Profile Name",
        "profile.name.placeholder": "Enter your name",
        "platform.links.title": "Platform Links",
        "platform.links.upload": "Add links to your podcast on various platforms.",
        "platform.links.youtube_link": "YouTube Link",
        "platform.links.youtube_link.placeholder": "Enter YouTube link",
        "platform.links.spotify_link": "Spotify Link",
        "platform.links.spotify_link.placeholder": "Enter Spotify link",
        "platform.links.apple_podcast_link": "Apple Podcast Link",
        "platform.links.apple_podcast_link.placeholder": "Enter Apple Podcast link",
        "platform.links.linkedin_link": "LinkedIn Link",
        "platform.links.linkedin_link.placeholder": "Enter LinkedIn link",
        "platform.links.facebook_link": "Facebook Link",
        "platform.links.facebook_link.placeholder": "Enter Facebook link",
        "platform.links.twitter_link": "Twitter Link",
        "platform.links.twitter_link.placeholder": "Enter Twitter link",
        "call.to.action.title": "Call to Action",
        "call.to.action.upload": "Set up your call-to-action button for the landing page.",
        "call.to.action.button.text.label": "Button Text",
        "call.to.action.button.text.placeholder": "Enter button text",
        "call.to.action.button.link.label": "Button Link",
        "call.to.action.button.link.placeholder": "Enter button link",
        "color.styles.title": "Color Styles",
        "color.styles.upload": "Customize the colors of your landing page.",
        "color.styles.primary.label": "Primary Color",
        "color.styles.primary.description": "Choose the primary color for your landing page",
        "color.styles.secondary.label": "Secondary Color",
        "color.styles.secondary.description": "Choose the secondary color for your landing page",
        "podcast.info.title": "Podcast Information",
        "podcast.info.upload": "Edit your podcast's details.",
        "podcast.info.name.label": "Podcast Name",
        "podcast.info.name.placeholder": "Enter podcast name",
        "podcast.info.description.label": "Podcast Description",
        "podcast.info.description.placeholder": "Enter podcast description",
        "edit.website.title": "Edit Website",
        "generate.website.title": "Generate Website",
        "for": "for",
        "saving": "Saving...",
        "save.changes": "Save Changes",
        "generate.website": "Generate Website",
        "changes.saved.success": "Changes saved successfully!",
        "podcast.cover.menu": "Podcast Cover",
        "podcast.info.menu": "Podcast Info",
        "profile.menu": "Profile",
        "platform.links.menu": "Platform Links",
        "call.to.action.menu": "Call to Action",
        "color.styles.menu": "Color Styles",
        "logo.menu": "Logo",
        "logo.title": "Upload Logo",
        "logo.upload": "Upload your podcast logo. This will be displayed on your landing page.",
        "logo.upload.button": "Upload Logo",
        "platform.links.description": "Add links to your podcast on different platforms",
        "social.links.menu": "Social Links",
        "social.links.title": "Social Media Links",
        "social.links.description": "Add your social media profile links",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Enter your LinkedIn profile URL",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Enter your Facebook page URL",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Enter your Twitter profile URL",
        "platform.links.youtubeLink": "YouTube",
        "platform.links.youtubeLink.placeholder": "Enter your YouTube channel URL",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Enter your Instagram profile URL",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Enter your YouTube channel URL",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Enter your Spotify profile URL",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Enter your Apple Podcast profile URL",
        "view.website": "View Website"
      },
      "podcastMoveModal": {
        "move.episode.label": "Move this episode to:",
        "move.episode.instruction": "You can type a new name to create a folder.",
        "move.episode.button": "Move",
        "move.episode.error.selectFolder": "Please select a folder to move the episode."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "AI Settings for {{podcastTitle}} Podcast",
        "ai.customize.writing.style": "Customize Your AI Writing Style",
        "ai.content.writing.preference": "How would you like Podsqueeze to write your content?",
        "ai.voice.placeholder": "Example: Professional but friendly tone. The listeners are podcasters. Write in the first person.",
        "ai.character.limit.reached": "You have reached your character limit of 50. ",
        "ai.upgrade.now": "Upgrade now",
        "ai.fix.transcript.misspells": "Fix Transcript Misspells",
        "ai.enter.misspelled.words": "Write down the words that the AI often misspells in these podcast's episodes, eg. names",
        "ai.enter.word.press.enter": "Enter a word and press Enter",
        "ai.add.word": "Add Word",
        "ai.tag.limit.reached": "Reached the limit of 1 tag. ",
        "ai.save": "Save",
        "ai.save.close": "Save & Close"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Episode Title",
        "selectedEpisode.podcastName": "Podcast Name",
        "selectedEpisode.showNotes": "Show Notes",
        "selectedEpisode.timestamp": "Timestamp",
        "selectedEpisode.staticTimestamp": "Static Timestamp",
        "selectedEpisode.mentions": "Mentions",
        "selectedEpisode.newsletter": "Newsletter",
        "selectedEpisode.titles": "Titles",
        "selectedEpisode.tweeter": "Tweeter",
        "selectedEpisode.shortPost": "Short Post",
        "selectedEpisode.transcription": "Transcription",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Keywords",
        "selectedEpisode.quotes": "Quotes",
        "selectedEpisode.longPost": "Long Post",
        "selectedEpisode.bulletPoints": "Bullet Points",
        "selectedEpisode.publicLink": "Public Link",
        "selectedEpisode.embeddedId": "Embedded ID",
        "selectedEpisode.episodeUrl": "Episode URL"
      },
      "sidebar": {
        "tools": "Tools",
        "find.podcast.topic.ideas": "Find Podcast Topic Ideas",
        "podcast.thumbnail.maker": "Podcast Thumbnail Maker",
        "podcast.seo.optimizer": "Podcast SEO Optimizer",
        "account": "Account",
        "payment.settings": "Payment Settings",
        "support": "Support",
        "logout": "Logout",
        "plan": "Plan",
        "resets.in": "Resets in",
        "api.access": "API Access",
        "days": "days and",
        "hours": "hours",
        "upgrade.plan": "Upgrade Plan"
      },
      "updateEmailModal": {
        "email.validation.error": "Please enter a valid email address.",
        "email.change.confirm": "Are you sure you want to change your email address?",
        "email.change.success": "Your email has been successfully changed!",
        "email.in.use.error": "This email is already in use. Please try another one.",
        "email.recent.login.error": "Before continuing with this operation, please login again using the current email address.",
        "email.invalid.error": "Invalid email address. Please try another one.",
        "subscription.cancel.error": "Please cancel your active paid subscription first.",
        "account.delete.confirm": "Are you sure you want to delete your account?\n\nThis action cannot be undone.",
        "account.delete.success": "Your account has been successfully deleted.",
        "account.delete.error": "Something went wrong and we were not able to delete your account.\n\n Please reach out to our user support.",
        "subscription.cancel": "Cancel Subscription",
        "account.delete": "Delete Account",
        "account.delete.warning": "Deleting your account is irreversible and will permanently erase all your content and login information. Please proceed with caution as this action cannot be undone.",
        "current.account.email": "Current Account Email",
        "enter.new.email": "Enter your new account email",
        "update": "Update",
        "change.password": "Change Password",
        "payment.settings": "Payment Settings"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "episodeTitle"
      },
      "episodelist": {
        "loading.episodes": "Loading Episodes",
        "no.episodes.found": "No Episodes Found. Please try again with a valid RSS id",
        "select.episode": "Select the episode you want to create content for",
        "search.episodes": "Search episodes..."
      },
      "interfaces": {
        "user.activePlan.tier": "Tier",
        "user.activePlan.creationDate": "Creation Date",
        "user.activePlan.minutesAvailable": "Minutes Available"
      },
      "loadingbar": {
        "loadingbar.magic": "We are still working our magic ✨",
        "loadingbar.longer": "Some episodes take a little bit longer... 🐌",
        "loadingbar.hardwork": "Our servers are working hard 🦾"
      },
      "page": {
        "main.background": "Background of the main component"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Error: Access to the microphone or camera has been denied.",
        "microphone.camera.not.found": "Error: No microphone or camera found.",
        "microphone.camera.not.readable": "Error: The microphone or camera is not readable.",
        "microphone.camera.access.error": "Error: An unknown error occurred while accessing the microphone or camera.",
        "media.not.recorded": "Error: No media has been recorded.",
        "upload.failed": "Error: Upload failed.",
        "upload.success": "Success: Upload completed successfully.",
        "upload.in.progress": "Upload in progress...",
        "upload.button": "Upload Recording",
        "stop.recording": "Stop Recording",
        "record.audio": "Record Audio",
        "record.audio.video": "Record Audio with Video",
        "record.again": "Record Again",
        "episode.language": "Select Episode Language",
        "select.folder": "Select the podcast folder this episode belongs to, or create a new one.",
        "give.voice": "Customize the Folder's Voice"
      },
      "selectBox": {
        "language.english": "English",
        "language.arabic": "Arabic",
        "language.bulgarian": "Bulgarian",
        "language.catalan": "Catalan",
        "language.croatian": "Croatian",
        "language.czech": "Czech",
        "language.danish": "Danish",
        "language.dutch": "Dutch",
        "language.finnish": "Finnish",
        "language.french": "French",
        "language.german": "German",
        "language.greek": "Greek",
        "language.hindi": "Hindi",
        "language.hungarian": "Hungarian",
        "language.indonesian": "Indonesian",
        "language.italian": "Italian",
        "language.japanese": "Japanese",
        "language.korean": "Korean",
        "language.lithuanian": "Lithuanian",
        "language.latvian": "Latvian",
        "language.malay": "Malay",
        "language.mandarin": "Mandarin",
        "language.norwegian": "Norwegian",
        "language.polish": "Polish",
        "language.portuguese": "Portuguese",
        "language.romanian": "Romanian",
        "language.russian": "Russian",
        "language.slovak": "Slovak",
        "language.slovenian": "Slovenian",
        "language.spanish": "Spanish",
        "language.swedish": "Swedish",
        "language.tamil": "Tamil",
        "language.turkish": "Turkish",
        "language.ukrainian": "Ukrainian",
        "language.bashkir": "Bashkir",
        "language.basque": "Basque",
        "language.belarusian": "Belarusian",
        "language.cantonese": "Cantonese",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estonian",
        "language.galician": "Galician",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongolian",
        "language.persian": "Persian",
        "language.thai": "Thai",
        "language.uyghur": "Uyghur",
        "language.vietnamese": "Vietnamese",
        "language.welsh": "Welsh"
      },
      "selectedepisode": {
        "processing.episode": "Processing Episode",
        "processing.time": "It usually takes between 5 - 10 min",
        "email.notification": "You can close this window. We will send you an email once it is ready. Your content will also be available on your dashboard.",
        "convert.another.episode": "Convert another episode",
        "technical.difficulties": "Oops! We're experiencing some technical difficulties. Rest assured, our team is on the case! Please try again later.",
        "no.discount": "Don't worry, we won't discount any minutes!",
        "high.demand": "We're experiencing higher than normal demand, so it might take longer than usual to process your request. We apologize for any inconvenience!",
        "email.ready": "We'll send you an email once it is ready. You can also access your results on your dashboard.",
        "select.podcast.folder": "Select the podcast folder this episode belongs to, or create a new one.",
        "give.voice": "Customize the Folder's Voice",
        "generate.content": "Generate Content",
        "not.enough.minutes.title": "Not enough minutes",
        "not.enough.minutes.message": "You don't have enough minutes to convert this episode. Please update your plan.",
        "upgrade.plan": "Upgrade your plan",
        "convert.shorter.episode": "Convert a shorter episode",
        "content.ready": "Your content is ready!",
        "ask.ai.tune": "You can still ask the AI to tune each content to better suit your needs.",
        "error.title": "Error",
        "convert.another.file": "Convert Another File"
      },
      "submitfile": {
        "file.size.exceeded.free": "File size exceeds the maximum limit of 4 GB. <p>Please <a href='/pricing'><b><u>upgrade to upload larger files</u></b></a></p>",
        "file.size.exceeded.paid": "File size exceeds the maximum limit of 10 GB. <p>Please select a smaller file.</p>",
        "file.upload.invalid": "Please upload an audio or video file",
        "upload.in.progress": "Uploading file. Please, do not close this window.",
        "upload.button": "Upload & Generate",
        "close.button": "Close",
        "upgrade.message.free": "More uploads are only available for paid tiers.",
        "upgrade.now.button": "Upgrade Now",
        "pricing.info": "starting from $6/month",
        "upload.file.label": "Upload an audio or video file",
        "max.file.size.free": "(max 4 gb)",
        "max.file.size.paid": "(max 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze will generate audiograms for audio files and short clips for video files",
        "file.placeholder": "Your MP3/WAV File",
        "episode.language.label": "Episode Language",
        "multiple.files.selected": "{{count}} files selected",
        "clear.all": "Clear all",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Select multiple files",
        "file.upload.error": "Error uploading file",
        "file.upload.success": "File uploaded successfully",
        "file.upload.processing": "Processing file",
        "click.to.upload": "Click to upload",
        "click.to.upload.multiple": "Click to upload multiple files",
        "select.folder.label": "Select or create a folder",
        "enter.url": "Enter URL",
        "upload.file": "Upload File",
        "media.url.label": "Media URL",
        "media.url.help": "Enter the URL of your audio or video file. We'll download and process it for you.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Episode Name",
        "url.input.required": "Please enter a media URL",
        "url.upload.error": "Failed to upload media from URL. Please check the URL and try again.",
        "supported.formats": "Supported formats",
        "uploading": "Uploading...",
        "media.url.requirements": "URL must be a direct link to a public media file (not a webpage)"
      },
      "submitrssid": {
        "error.selectRss": "Please select a valid RSS from the dropdown",
        "label.insertRssFeed": "Insert your RSS Feed",
        "placeholder.insertRssFeed": "Insert your RSS Feed",
        "label.searchByPodcast": "Search by podcast name instead",
        "label.searchForPodcast": "Search for your podcast name",
        "placeholder.searchForPodcast": "Search for a podcast",
        "label.cantFindPodcast": "Can't find your podcast? ",
        "label.clickHereUseRss": "Click here to use your RSS feed instead",
        "label.selectedPodcast": "Selected podcast",
        "label.episodeLanguage": "Episode Language",
        "button.seeAllEpisodes": "See all episodes",
        "select.folder.label": "Select or create folder"
      },
      "submitsection": {
        "search.podcast": "Search Your Podcast",
        "upload.audio.video": "Upload Audio or Video",
        "record.audio": "Record Audio",
        "youtube.video": "YouTube Link",
        "create.content": "Let's create content for your podcast!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Enter YouTube video URL",
        "error.insertYouTubeUrl": "Please insert a YouTube URL.",
        "label.insertYouTubeUrl": "Insert YouTube URL",
        "button.loading": "Loading...",
        "message.downloadingFile": "Downloading file...",
        "error.processingFailed": "Processing failed.",
        "button.submitYouTubeVideo": "Submit YouTube Video",
        "episode.language.label": "Used Language",
        "error.youtubeVideoNotAvailable": "This YouTube Video Is Not Available For Download. Please Upload Your Audio Or Video Directly To Podsqueeze.",
        "select.folder.label": "Select or create folder"
      },
      "tabs": {
        "tab.label.tab1": "Tab 1",
        "tab.label.tab2": "Tab 2",
        "tab.label.tab3": "Tab 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Take the Most Out Of Podsqueeze",
        "tutorial.chapter.introduction": "Introduction",
        "tutorial.chapter.bestShowNotes": "Get the best show notes and timestamps",
        "tutorial.chapter.blogPosts": "Utilizing blog posts and newsletters",
        "tutorial.chapter.editingTranscripts": "Embedding and editing transcripts",
        "tutorial.chapter.personalizingAI": "Personalizing AI and Give Your Own Voice",
        "tutorial.chapter.speedingUpNotes": "Speeding Up Show Notes",
        "tutorial.chapter.creatingClips": "Creating video clips and images",
        "tutorial.chapter.generatingLandingPage": "Generating a landing page",
        "tutorial.chapter.shareResults": "Share Results With Your Team",
        "tutorial.closeVideoCheckbox": "Close video once first results are ready"
      },
      "uploadloadingbar": {
        "upload.loading": "Loading..."
      }
    },
    "home": {
      "affiliate-affiliatehero": {
        "affiliatehero.becomePartner": "BECOME OUR PARTNER",
        "affiliatehero.sharePodsqueeze": "Share Podsqueeze with your audience",
        "affiliatehero.andEarnMoney": " and earn money!",
        "affiliatehero.lastUpdated": "Last updated: {date}",
        "affiliatehero.becomeAffiliatePartner": "Become an Affiliate Partner",
        "affiliatehero.earnCommission": "Earn ",
        "affiliatehero.commissionPercentage": "25% commission",
        "affiliatehero.details": " on every sale made through your exclusive referral link for a period of 15 months. Share your link on your website, social media, or with your friends. Takes seconds to join. Get automatically approved.",
        "affiliatehero.joinNow": "Join now",
        "affiliatehero.howItWorks": "HOW IT WORKS",
        "affiliatehero.faq": "Frequently Asked Questions",
        "affiliatehero.whatIsAffiliatePartner": "What is an Affiliate Partner?",
        "affiliatehero.affiliatePartnerDefinition": "An Affiliate partner is someone who promotes another company's products or services through a unique referral link and earns a commission on every sale made through that link.",
        "affiliatehero.howToBecomeAffiliate": "How can I become an Affiliate Partner?",
        "affiliatehero.becomingAffiliateDetails": "Becoming an Affiliate Partner is quick and easy, taking just a few seconds of your time. To get started, simply click the \"Join Now\" button and sign up using your email. Once registered, you'll gain access to a user-friendly dashboard where you'll find your unique referral link. Share this link with your family, friends, or online audience. Whenever someone clicks on your referral link and makes a purchase on Podsqueeze's website, you'll earn a 25% commission on each payment for an entire 15 months! Keep track of your earnings effortlessly through your Affiliate dashboard, which provides a clear overview of all the sales you've generated.",
        "affiliatehero.trackSales": "How can I track my sales and commissions?",
        "affiliatehero.trackSalesDetails": "Use our affiliate program dashboard to track your sales and commissions. The tracking software is available for both Affiliate Partners and Business Partners.",
        "affiliatehero.paymentDetails": "When and how will I receive my payment?",
        "affiliatehero.paymentInfo": "You will receive your payment via PayPal every 30 days. Please note that there is a minimum payout threshold of $50. So, as soon as you reach this amount, you can expect to receive your payment like clockwork every 30 days.",
        "affiliatehero.stillGotQuestions": "STILL GOT QUESTIONS?",
        "affiliatehero.contactUs": "Send us a message on the support chat or email us to team@podsqueeze.com"
      },
      "affiliate-page": {
        "your.label.navbar": "NavBar",
        "your.label.affiliatehero": "Affiliatehero",
        "your.label.footer": "Footer",
        "your.label.background": "bg-[#643ADA]"
      },
      "contactsection": {
        "contact.section.title": "Contact Us",
        "contact.section.email": "Email us at support@podsqueeze.com",
        "contact.section.tiago.role": "Co-founder",
        "contact.section.joao.role": "Co-founder",
        "contact.section.image.alt.sendMessage": "Send message",
        "contact.section.image.alt.tiago": "Co-founder Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-founder Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Join 20,000 content creators and podcast professionals using Podsqueeze",
        "content.creators": "Content Creators",
        "podcast.managers": "Podcast Managers",
        "producers.studios": "Producers & Studios",
        "for.podcasters": "FOR PODCASTERS, PODCAST MANAGERS AND AGENCIES",
        "manage.content.creation": "Effortlessly manage content creation for",
        "multiple.podcasts": "multiple podcasts",
        "podsqueeze.description": "Podsqueeze is a powerful tool for all podcasting professionals. Whether you're a solo podcaster, podcast manager, or agency, Podsqueeze offers all the features you need to streamline your podcast content creation workflow.",
        "create.podcast.folders": "Create podcast folders to keep your episodes organized.",
        "share.content.page": "Easily share your content page with clients and team",
        "tune.ai.voice": "Tune the AI voice for every show you manage",
        "plan.content.episodes": "Plan the content for the next episodes with our advanced",
        "podcast.topics.finder": "podcast topics finder",
        "podsqueeze.testimonial": "Podsqueeze's ability to use prompts to tune the content of each podcast we manage and save them for future episodes, allows us to keep the voices of each show consistent. This is an elite feature that we couldn't find in any other tools",
        "coo.podigy": "COO at Podigy Podcasts",
        "agenciessection.joinCreators": "Join 70,000 content creators and podcast professionals using Podsqueeze",
        "agenciessection.contentCreators": "Content Creators",
        "agenciessection.podcastManagers": "Podcast Managers",
        "agenciessection.producersStudios": "Producers & Studios",
        "agenciessection.forPodcasters": "FOR PODCASTERS, PODCAST MANAGERS AND AGENCIES",
        "agenciessection.manageContent": "Effortlessly manage content creation for",
        "agenciessection.multiplePodcasts": "multiple podcasts",
        "agenciessection.podsqueezeDescription": "Podsqueeze is a powerful tool for all podcasting professionals. Whether you're a solo podcaster, podcast manager, or agency, Podsqueeze offers all the features you need to streamline your podcast content creation workflow.",
        "agenciessection.createPodcastFolders": "Create podcast folders to keep your episodes organized.",
        "agenciessection.shareContent": "Easily share your content page with clients and team",
        "agenciessection.tuneAI": "Tune the AI voice for every show you manage",
        "agenciessection.planContent": "Plan the content for the next episodes with our advanced",
        "agenciessection.podcastTopicsFinder": "podcast topics finder",
        "agenciessection.podsqueezeQuote": "Podsqueeze's ability to use prompts to tune the content of each podcast we manage and save them for future episodes, allows us to keep the voices of each show consistent. This is an elite feature that we couldn't find in any other tools",
        "agenciessection.coO": "COO at Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NEW FEATURE",
        "seamless.editing": "Seamless editing and audio enhancement for natural, ",
        "high.quality.results": " high-quality results",
        "experience.seamless.audio.editing": "Experience seamless audio editing with advanced AI algorithms for top-notch recordings. ",
        "remove.ums": "Remove ums",
        "enhance.sound.quality": ", silences, and enhance sound quality with just one click.",
        "enhance.audio.now": "Enhance Audio Now",
        "sample.audio.recorded": "Sample audio, recorded directly from phone.",
        "original.recording": "Original recording",
        "audio.after.ai.edit": "Audio after AI edit and enhancement",
        "experience.audio.editing": "Experience seamless audio editing with advanced AI algorithms for top-notch recordings. "
      },
      "home-blogsection": {
        "more.resources.label": "MORE RESOURCES FOR YOUR PODCAST",
        "learn.how.to.get.most": "Learn how to get the most out of",
        "your.content": "your content",
        "get.most.out.of.ai.content": "Get the Most Out of AI-Generated Content for Your Podcast",
        "welcome.to.podsqueeze": "Welcome to Podsqueeze – the simplest way to transcribe your podcast and create captivating content...",
        "will.google.penalize.ai.content": "Will Google penalize your AI-generated content?",
        "ai.content.discussion": "The emergence of AI-generated content has ignited discussions and raised concerns among content creators, marketers, and SEO...",
        "what.is.rss.feed": "What is an RSS feed for Podcasts and how to use it",
        "rss.feed.benefits": "As a podcaster, you might have heard the term 'RSS feed' before, but you might not know exactly what it is or how it can benefit...",
        "visit.blog": "Visit Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS & AUDIOGRAMS",
        "clipsAndAudiograms.subtitle": "Repurpose your podcast into clips effortlessly",
        "clipsAndAudiograms.description": "Simply choose a chapter from your episode and export it as a clip or audiogram for TikTok, Instagram and Youtube Shorts. Choose a template and tune to your own style.",
        "clipsAndAudiograms.createClips": "Create Clips Now",
        "textEditor.title": "Text based editor",
        "textEditor.description": "Fine-tune your clips and audiograms directly from the subtitles. Edit subtitles and trim your video by removing specific words.",
        "oneClickShorts.title": "One click shorts (<60s)",
        "oneClickShorts.description": "Let AI handle the editing for you. With the press of a button, AI will shorten each chapter of your episode to under 60 seconds, ready for posting as a YouTube Short or Tik Tok clips."
      },
      "home-conatctsection": {
        "contact.section.title": "Contact the Founders",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Developer & Podcaster",
        "contact.section.joao.role": "- UX/UI Designer"
      },
      "home-contentexplanation": {
        "wide.variety.content": "WIDE VARIETY OF CONTENT",
        "generate.content": "Generate content with",
        "one.click": " one click!",
        "transcript.srt": "Transcript & SRT",
        "transcript.description": "Get the full transcript of your podcast episode, along with an SRT file ready for generating captions and subtitles.",
        "show.notes": "Show notes",
        "show.notes.description": "Summarize the main topics covered in your episode and make it more searchable",
        "timestamps": "Timestamps",
        "timestamps.description": "Create chapters with timestamps and guide listeners to specific segments of your podcast episode",
        "blog.social.posts": "Blog & Social Posts",
        "blog.social.posts.description": "Post about your podcast episode everywhere and get new listeners",
        "newsletter": "Newsletter",
        "newsletter.description": "Keep your listeners up to date with new episodes",
        "titles.more": "Titles & more!",
        "titles.more.description": "Generate catchy titles, quotes, bullet points, keywords and more!",
        "see.sample.content": "SEE SAMPLE CONTENT",
        "wannabe.entrepreneur": "Wannabe Entrepreneur - #299 Podsqueeze just hit $100,000 in annual revenue!",
        "making.space": "Making Space - Steve Harvey: “You Might As Well Keep Going”",
        "modern.wisdom": "Modern Wisdom - Erik Hoel - A Guide To The Fundamental Mystery Of The Mind"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Divider line"
      },
      "home-explanationsection": {
        "fast.accurate": "FAST AND ACCURATE",
        "generate.content": "Generate content for your podcast with the",
        "power.of.ai": "power of AI",
        "upload.image.alt": "upload image",
        "select.episode": "Select an episode from your RSS feed or upload an audio/video file",
        "paste.rss.feed": "Simply paste your RSS feed URL to choose an episode from the list or upload an audio or video file.",
        "content.image.alt": "content image",
        "one.click.content": "Get all the content with one click!",
        "user.friendly.interface": "Intuitive and user friendly interface you can start using right away. Generate content for your podcast with one click.",
        "tune.image.alt": "tune image",
        "edit.fine.tune": "Edit and fine-tune each content",
        "direct.edit.content": "Directly edit and fine-tune each content to your liking with AI. For example, you can ask for a specific tone, direct or indirect speech or simply correct misspelled names.",
        "multiple.language.support": "Multiple language support",
        "language.flags.alt": "language flags",
        "generate.content.aria": "Generate content"
      },
      "home-featuressection": {
        "loading": "Loading...",
        "transcribe.write.show.notes": "Transcribe and write show notes for your podcast",
        "twenty.times.faster": "20x faster",
        "save.manual.work": "Save up to 100% of manual work. Automatically transcribe your podcast with state-of-the-art accuracy and speaker labeling, and generate complete show notes and social media posts in your own voice.",
        "generate.content": "Generate Content",
        "transcripts": "Transcripts",
        "full.transcript": "Get the full transcript of your podcast episodes and YouTube video transcripts, along with an SRT file for subtitles.",
        "show.notes": "Show Notes",
        "summarize.generate.show.notes": "Summarize and generate show notes in your own voice, complete with timestamps, bullet points and mentions.",
        "blog.newsletter": "Blog and Newsletter",
        "actionable.blog.posts": "Get actionable blog posts about your episodes and ready-to-send newsletters with the main takeaways.",
        "social.media": "Social media",
        "short.posts.insights": "Get short posts and bite-sized insights to spread the word on social media.",
        "quote": "Of all the best AI transcription tools we tested, Podsqueeze generated the most useful outputs for Show Notes, Timestamps, Titles, Mentions, Sample Blog Posts, and Key Quotes.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Co-founder of Transistor.fm",
        "transcribe_and_write_show_notes": "Podcast transcription, summaries and social posts",
        "twenty_times_faster": "20x faster",
        "save_manual_work": "Save up to 100% of manual work. Automatically transcribe your podcast with state-of-the-art accuracy and speaker labeling, and generate complete show notes and social media posts in your own voice.",
        "generate_content": "Generate Content",
        "full_transcript": "Get the full transcript of your podcast episodes and YouTube video transcripts, along with an SRT file for subtitles.",
        "show_notes": "Show Notes",
        "summarize_and_generate_show_notes": "Summarize and generate show notes in your own voice, complete with timestamps, bullet points and mentions.",
        "blog_and_newsletter": "Blog and Newsletter",
        "actionable_blog_posts": "Get actionable blog posts about your episodes and ready-to-send newsletters with the main takeaways.",
        "social_media": "Social media",
        "short_posts_and_insights": "Get short posts and bite-sized insights to spread the word on social media.",
        "testimonial": "Of all the best AI transcription tools we tested, Podsqueeze generated the most useful outputs for Show Notes, Timestamps, Titles, Mentions, Sample Blog Posts, and Key Quotes.",
        "cofounder_transistor": "Co-founder of Transistor.fm"
      },
      "home-page": {
        "main.background": "Background color for the main component"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "LISTEN TO OUR PODCAST",
        "podcast.section.subtitle": "Masterclasses from",
        "podcast.section.highlight": "experienced Podcasters",
        "podcast.section.description": "Listen to our podcast, where we interview experienced podcasters and users of Podsqueeze from around the world. We ask them to share their tips, insights, stories, and everything you need to know to grow your own podcast.",
        "podcast.link.spotify": "Listen on Spotify",
        "podcast.link.apple": "Listen on Apple Podcasts",
        "podcast.link.youtube": "Listen on YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Loading..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automate Your Podcast",
        "tagline.productionPromotion": "Production & Promotion",
        "tagline.launchGrow": "Effortlessly launch and grow your audio or video podcast with everything you need in one place, with the help of AI.",
        "tagline.uploadGenerate": "Easily generate podcast transcripts, summaries, short clips with captions and much more!",
        "tagline.singleClick": " All with a single click.",
        "tagline.transcripts": "Podcast Transcription",
        "tagline.showNotes": "Show Notes",
        "tagline.newslettersBlogs": "Newsletters & Blogs",
        "tagline.socialPosts": "Social Posts",
        "tagline.shortClipsAudiograms": "Short Clips & Audiograms",
        "tagline.podcastWebsite": "Podcast Website",
        "tagline.aiAudioEnhancement": "AI Audio Enhancement",
        "tagline.removeSilences": "Remove silences and uhms",
        "tagline.generateNow": "Generate now for free",
        "tagline.noCreditCard": "No credit card required",
        "testimonial.robWalling.title": "Rob Walling, Startup Personality",
        "testimonial.robWalling.subtitle": "Startups for the Rest of Us Podcast",
        "testimonial.robWalling.quote": "Podsqueeze show notes have been the best. We use it a lot for summaries and to get insights from other podcasts.",
        "testimonial.johnGarmet.title": "John Garmet, Director of Operations",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze helps us be more efficient and generate more content for our clients. We highly recommend it.",
        "testimonial.davidJackson.title": "David Jackson, Podcast Coach",
        "testimonial.davidJackson.subtitle": "School of Podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze is my brainstorming partner. It's the best way to come up with podcast marketing."
      },
      "home-testimonials": {
        "testimonials.title": "What are people saying about Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Re-purpose your podcast content using AI | Product Hunt",
        "testimonials.heading": "What are people saying about Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Incorrect password",
        "error.userNotFound": "User not found",
        "error.somethingWentWrong": "Oops, something went wrong",
        "button.sendResetEmail": "Send Reset Email",
        "button.login": "Login",
        "placeholder.email": "E-mail address",
        "placeholder.password": "Password",
        "link.forgotPassword": "Forgot your password?",
        "link.createAccount": "Create Account",
        "text.or": "OR",
        "button.continueWithGoogle": "Continue with Google",
        "text.podcastDescription": "Effortlessly launch and grow your audio or video podcast with everything you need in one place.",
        "feature.transcripts": "Transcripts",
        "feature.showNotes": "Show Notes",
        "feature.newslettersAndBlogs": "Newsletters & Blogs",
        "feature.socialPosts": "Social Posts",
        "feature.shortClipsAndAudiograms": "Short Clips & Audiograms",
        "feature.podcastWebsite": "Podcast Website",
        "feature.aiAudioEnhancement": "AI Audio Enhancement",
        "feature.removeSilences": "Remove silences and uhms",
        "button.sendVerificationEmail": "Send Verification Email",
        "error.emailNotVerified": "Email not verified, please verify your email to continue",
        "error.emailAlreadyVerified": "Email already verified",
        "success.emailVerified": "Email verified",
        "text.pleaseVerifyAccount": "Please Verify Your Account",
        "text.checkSpamFolder": "We've sent you a verification email. Please check your inbox and spam folder.",
        "button.resendVerificationEmail": "Resend Verification Email",
        "error.verificationEmailFailed": "Failed to send verification email. Please try again.",
        "success.verificationEmailSent": "Verification email sent successfully!"
      },
      "page": {
        "login.form": "LoginForm"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze Affiliates Page",
        "affiliate.page.description": "Earn 25% commission on every sale made through your exclusive referral link for a period of 15 months. Share your link on your website, social media, or with your friends. Takes seconds to join. Get automatically approved."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Best Gift for a Podcaster",
        "bestGiftForPodcaster.description": "Discover the best gifts for podcasters to enhance their experience.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Get more podcast listeners",
        "get-more-podcast-listeners.description": "Get more podcast listeners and streamline production with automatic show notes, short clips to grow your show on social media and much more."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Grow Your Podcast Audience",
        "grow_your_podcast_audience.description": "Save a ton of time and grow your podcast audience with Podsqueeze. Generate complete show notes, social media posts, short clips and more for your podcast."
      },
      "index": {
        "home.page.title": "Podcast Transcription, Summaries & Clips – Try Free",
        "home.page.description": "Podcast transcript generator, summarizer, clip maker & AI audio enhancer—all-in-one tool to grow your podcast and save hours of effort. Free to sign up."
      },
      "login": {
        "login.tryItNow": "Try it now!",
        "login.createAccountDescription": "Create an account and start generating shownotes, timestamps, newsletters and more for your podcast with one click! Quickly generate content for your podcast and tune it to your needs. Free Sign up."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing for Podcasts",
        "marketing.for.podcasts.description": "Podsqueeze streamlines marketing for podcasts with auto-generated show notes, social media posts, and short clips to boost your reach and grow your show."
      },
      "media": {
        "media.page.title": "Podsqueeze Media Page",
        "media.page.description": "Know more about Podsqueeze. Get in touch! We'd love to collaborate!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Podcast Description Generator",
        "podcast.description.generator.description": "Improve your podcast's reach and engagement with AI-generated descriptions. Automate your Show Notes writing and reclaim precious time."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Repurpose your podcast for social media posts",
        "convert.podcast.episodes.to.social.media.posts": "Convert podcast episodes into social media posts. Automatically generate posts for LinkedIn, Twitter, facebook, and short clips for tiktok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Free Podcast Topics Generator",
        "podcast.topics.generator.description": "Our free podcast topics generator lets you find the best topic ideas and predicts their potential reach on Google and YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Your Podcast Virtual Assistant",
        "podcast.virtual.assistant.description": "AI podcast virtual assistant that writes your show notes and creates social media posts. Streamline your podcast production and marketing with Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Podsqueeze Pricing",
        "pricing.description": "Podcast transcript generator, summarizer, clip maker & AI audio enhancer—all-in-one tool to grow your podcast and save hours of effort. Free to sign up."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promote your Podcast",
        "promote.your.podcast.description": "Generate show notes, social media posts and short clips to publish and promote your podcast in just a few minutes."
      },
      "register": {
        "create.podsqueeze.account": "Create a Podsqueeze Account",
        "generate.content.podcast": "Podcast transcript generator, summarizer, clip maker & AI audio enhancer—all-in-one tool to grow your podcast and save hours of effort. Free to sign up."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Automatically repurpose podcast content",
        "repurpose.your.podcast.content.with.ai": "Repurpose your podcast content with AI. Automatically generate show notes, titles, short clips for tiktok, and much more, all with one click!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "FREE Podcast SEO Optimizer",
        "seo.optimizer.description": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.selectEpisode": "Select an Episode to Analyze",
        "seo.optimizer.results": "SEO Analysis Results",
        "seo.optimizer.searchPodcastPlaceholder": "Search for a podcast",
        "seo.optimizer.searchingPodcasts": "Searching podcasts...",
        "seo.optimizer.searchEpisodesPlaceholder": "Search episodes...",
        "seo.optimizer.analyseAnotherEpisode": "Analyse Another Episode",
        "seo.optimizer.findingEpisodes": "Finding all episodes...",
        "seo.optimizer.analysingEpisode": "Analysing Episode",
        "seo.optimizer.scoreTooltip": "Score:",
        "seo.optimizer.topKeywords": "We identified these Top Keywords:",
        "seo.optimizer.topKeywordsnote": "Based on the keyword analysis at the bottom of the page.",
        "seo.optimizer.optimizedContent": "Based on keywords here are the optimized title and description:",
        "seo.optimizer.originalTitle": "Original Title",
        "seo.optimizer.optimizedTitle": "Optimized Title",
        "seo.optimizer.originalDescription": "Original Description",
        "seo.optimizer.optimizedDescription": "Optimized Description",
        "seo.optimizer.showMore": "Show More",
        "seo.optimizer.showLess": "Show Less",
        "seo.optimizer.keywordAnalysis": "Keyword Analysis",
        "seo.optimizer.keywordAnalysisnote": "Scores are calculated based on search volume, competition (how many other results are there for the same keyword), and in the case of youtube, the average number of views per video under the same keyword.",
        "seo.optimizer.seoScore": "SEO Score",
        "seo.optimizer.spotifyScore": "Spotify Score",
        "seo.optimizer.youtubeScore": "YouTube Score",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - AI Podcast content generator tool",
        "podsqueeze.description": "Podcast transcript generator, summarizer, clip maker & AI audio enhancer—all-in-one tool to grow your podcast and save hours of effort. Free to sign up."
      },
      "thumbnail-creator": {
        "title": "Free Podcast Thumbnail Maker - Generate AI-Powered Episode Thumbnails",
        "description": "Create clean, professional episode artwork fast with our free podcast thumbnail maker. No design skills needed.",
        "selectPodcast": "Select Your Podcast",
        "loadEpisodes": "Load Episodes",
        "selectEpisode": "Select Episode to Create Thumbnail",
        "createThumbnail": "Create Thumbnail",
        "results": "Your Generated Thumbnail",
        "download": "Download",
        "share": "Share",
        "regenerate": "Regenerate",
        "editThumbnail": "Edit Thumbnail",
        "editPlaceholder": "Describe how you'd like to modify this thumbnail...",
        "customPrompt": "Custom Prompt",
        "yourThumbnail": "Your Thumbnail",
        "createAnother": "← Create Another Thumbnail",
        "findingEpisodes": "Finding episodes...",
        "searchPodcastPlaceholder": "Search for your podcast...",
        "searchingPodcasts": "Searching podcasts...",
        "heroDescription": "Generate stunning, professional podcast episode thumbnails with AI-powered design that grab attention and boost your episode visibility.",
        "generatedWithPrompt": "Generated with prompt:",
        "customPromptPlaceholder": "Enter custom prompt for thumbnail generation...",
        "generating": "Generating...",
        "generate": "Generate",
        "modernMinimalist": "Modern & Minimalist",
        "vibrantDynamic": "Vibrant & Dynamic",
        "professionalClean": "Professional & Clean",
        "generatingThumbnail": "Generating thumbnail...",
        "generatingNewThumbnail": "Generating new thumbnail...",
        "showingFirstEpisodes": "Showing first 10 episodes. Use search to find specific episodes.",
        "imageUrlCopied": "Image URL copied to clipboard!",
        "failedToGenerate": "Failed to generate thumbnail. Please try again.",
        "promotionalTitle": "Generate Shownotes, Timestamps, Viral Clips and Much More With Podsqueeze",
        "promotionalSubtitle": "Join other 100K+ creators and start growing your show",
        "startNow": "Start now",
        "free": "FREE",
        "podcast": "PODCAST",
        "thumbnail": "THUMBNAIL",
        "creator": "MAKER",
        "replaceFace": "Replace Face",
        "uploading": "Uploading...",
        "uploadImageError": "Please upload an image file.",
        "uploadFailedError": "Failed to upload image. Please try again.",
        "uploadingImage": "Uploading image...",
        "generatingNewThumbnailLoading": "Generating new thumbnail...",
        "failedToGenerateWithFace": "Failed to generate thumbnail with face replacement. Please try again."
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Loading Episodes...",
        "episodeList.noEpisodes": "No Public Episodes Available",
        "episodeList.checkBack": "Check back later for new episodes",
        "episodeList.title": "Episodes from this Podcast",
        "episodeList.readLess": "READ LESS",
        "episodeList.readMore": "READ MORE",
        "episodeList.coverImageAlt": "Cover for {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Get Started",
        "alert.subscriptionRunning": "Your current subscription is still running.\n\nPlease cancel your current subscription before buying a new one.",
        "alert.subscriptionEnds": "Your current subscription is still running.\n\nIt finishes on {date}",
        "alert.subscriptionCancelled": "Your subscription has already been cancelled and it will end at {date}",
        "button.openDashboard": "Open Dashboard",
        "button.signUp": "Sign Up",
        "button.buySubscription": "Buy Subscription",
        "button.cancelled": "Cancelled",
        "button.cancelSubscription": "Cancel Subscription",
        "button.upgradeSubscription": "Upgrade Subscription",
        "button.loading": "Loading",
        "upgrade.details.currentMinutes": "This will start a new subscription period. You will keep all your current minutes.",
        "upgrade.details.remainingAnnual": "This value was calculated based on the time remaining in your current annual subscription."
      },
      "page": {
        "pricing.free.title": "Free",
        "pricing.free.subtitle": "Try out Podsqueeze. No credit card required.",
        "pricing.free.price.annual": "$0 Billed Annually",
        "pricing.free.features.podcast_time": "30 mins of podcast time per month",
        "pricing.free.features.video_clips": "3 video clip",
        "common.with_watermark": "with watermark",
        "pricing.free.features.quote_images": "Quote images",
        "pricing.free.features.file_upload": "File upload up to 4Gb",
        "pricing.free.features.upload": "1 upload",
        "pricing.free.features.landing_pages": "Podcast landing pages",
        "pricing.free.features.audio_enhancement": "Audio enhancement",
        "common.sign_up": "Sign up",
        "common.open_dashboard": "Open Dashboard",
        "pricing.starter.title": "Starter",
        "pricing.starter.subtitle": "Perfect for hobbyist podcasters who want to save time.",
        "pricing.starter.price.annual": "$132 Billed Annually",
        "pricing.billed_annually": "Billed Annually",
        "minutes.accumulate": "Minutes Rollover",
        "pricing.starter.features.podcast_time": "160 mins of podcast time per month",
        "pricing.starter.features.video_clips": "10 video clips or audiograms",
        "pricing.starter.features.quote_images": "Quote images",
        "pricing.starter.features.file_upload": "File upload up to 4Gb",
        "pricing.starter.features.unlimited_uploads": "Unlimited Uploads",
        "pricing.starter.features.landing_pages": "Podcast landing pages",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "For professionals that use podcasting to develop and support their businesses.",
        "pricing.pro.price.annual": "$324 Billed Annually",
        "pricing.pro.features.podcast_time": "320 mins of podcast time per month",
        "pricing.pro.features.personalize_ai_voice": "Personalize AI voice",
        "pricing.pro.features.video_clips": "20 video clips or audiograms",
        "common.no_watermark": "no watermark",
        "pricing.pro.features.quote_images": "Quote Images",
        "pricing.pro.features.file_upload": "File upload up to 10Gb",
        "pricing.pro.features.unlimited_uploads": "Unlimited Uploads",
        "pricing.pro.features.landing_pages": "Podcast landing pages",
        "common.customizable": "customizable",
        "pricing.pro.features.audio_video_edit": "Audio Enhancement",
        "pricing.pro.features.everything_in_pro": "Everything in Pro",
        "pricing.agency_lite.title": "Agency Lite",
        "pricing.agency_lite.subtitle": "For podcast agencies that want to streamline and grow their business.",
        "pricing.agency_lite.price.annual": "$495 Billed Annually",
        "pricing.agency_lite.features.podcast_time": "600 mins of podcast time per month",
        "pricing.agency_lite.features.personalize_ai_voice": "Personalize AI voice",
        "pricing.agency_lite.features.video_clips": "40 video clips or audiograms",
        "pricing.agency_lite.features.quote_images": "Quote images",
        "pricing.agency_lite.features.file_upload": "File upload up to 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Unlimited Uploads",
        "pricing.agency_lite.features.landing_pages": "Podcast landing pages",
        "pricing.agency_lite.features.audio_video_edit": "Audio Enhancement",
        "pricing.agency_plus.title": "Agency Plus",
        "pricing.agency_plus.subtitle": "For podcast agencies that want to streamline and grow their business.",
        "pricing.agency_plus.price.annual": "$1.251 Billed Annually",
        "pricing.agency_plus.features.podcast_time": "2000 mins of podcast time per month",
        "pricing.agency_plus.features.personalize_ai_voice": "Personalize AI voice",
        "pricing.agency_plus.features.video_clips": "80 video clips or audiograms",
        "pricing.agency_plus.features.quote_images": "Quote images",
        "pricing.agency_plus.features.file_upload": "File upload up to 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Unlimited Uploads",
        "pricing.agency_plus.features.landing_pages": "Podcast landing pages",
        "pricing.agency_plus.features.audio_video_edit": "Audio Enhancement",
        "pricing.agency_scale.title": "Agency Scale",
        "pricing.agency_scale.subtitle": "For podcast agencies that want to streamline and grow their business.",
        "pricing.agency_scale.price.annual": "$2.175 Billed Annually",
        "pricing.agency_scale.features.podcast_time": "4000 mins of podcast time per month",
        "pricing.agency_scale.features.personalize_ai_voice": "Personalize AI voice",
        "pricing.agency_scale.features.video_clips": "160 video clips or audiograms",
        "pricing.agency_scale.features.quote_images": "Quote images",
        "pricing.agency_scale.features.file_upload": "File upload up to 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Unlimited Uploads",
        "pricing.agency_scale.features.landing_pages": "Podcast landing pages",
        "pricing.agency_scale.features.audio_video_edit": "Audio Enhancement",
        "pricing.header": "For solo podcasters and podcast agencies",
        "pricing.minutes_reset": "You can accumulate up to 3x your monthly minutes, as long as you remain on your current plan or upgrade.",
        "pricing.most_popular": "Most Popular",
        "pricing.minutes_per_month": "Minutes per month",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "For agencies and media companies who want to scale their podcasting and media production.",
        "pricing.enterprise_price": "Custom",
        "pricing.enterprise_price_note": "Reach out to team@podsqueeze.com or book a demo bellow.",
        "pricing.enterprise_feature_priority_support": "Priority support",
        "pricing.enterprise_feature_team_sits": "Multiple team sits",
        "pricing.enterprise_personalized_team_training": "Team onboarding and training",
        "pricing.book_demo": "Book a demo",
        "pricing.unlimited": "Unlimited",
        "pricing.custom": "Custom"
      },
      "toggle": {
        "pay.monthly": "Monthly",
        "pay.annually": "Annually",
        "discount.30percent": "30% OFF"
      },
      "upgradeModal": {
        "upgrade.success": "Your subscription has been upgraded successfully",
        "upgrade.error": "We are sorry, something went wrong. Please try again later",
        "upgrade.loading": "Upgrading",
        "upgrade.confirmPay": "Confirm & Pay",
        "upgrade.cancel": "Cancel",
        "coupon.placeholder": "Cupon Code",
        "coupon.apply": "Apply",
        "coupon.have": "I have a coupon",
        "upgrade.confirmation": "You are about to upgrade to",
        "upgrade.price": "You will pay"
      }
    },
    "register": {
      "page": {
        "register.form": "RegisterForm"
      },
      "registerForm": {
        "error.invalidCredentials": "Please enter a valid email address and password.",
        "error.weakPassword": "Please use a stronger password 💪",
        "error.emailInUse": "User already exists",
        "error.userNotFound": "User not found",
        "error.generic": "Ups, something went wrong",
        "placeholder.email": "E-mail address",
        "placeholder.password": "Password",
        "button.registering": "Registering...",
        "button.register": "Register",
        "label.newsletter": "Join 12,000 podcasters and subscribe to our newsletter for product updates, actionable tips, ebooks, giveaways and more.",
        "label.alreadyHaveAccount": "Already have an account?",
        "label.logInHere": "Log in here",
        "label.or": "OR",
        "button.signingIn": "Signing in...",
        "button.continueWithGoogle": "Continue with Google",
        "label.podcastDescription": "Effortlessly launch and grow your audio or video podcast with everything you need in one place.",
        "feature.transcripts": "Transcripts",
        "feature.showNotes": "Show Notes",
        "feature.newslettersBlogs": "Newsletters & Blogs",
        "feature.socialPosts": "Social Posts",
        "feature.shortClips": "Short Clips & Audiograms",
        "feature.podcastWebsite": "Podcast Website",
        "feature.audioEnhancement": "AI Audio Enhancement",
        "feature.removeSilences": "Remove silences and uhms"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "text"
      },
      "TopicFinder": {
        "competition.veryHigh": "VERY HIGH",
        "competition.high": "HIGH",
        "competition.medium": "MEDIUM",
        "competition.low": "LOW",
        "competition.veryLow": "VERY LOW",
        "upgrade.button": "Upgrade to Pro",
        "clicks.label": "clicks",
        "searches.label": "searches",
        "competition.label": "competition",
        "fetching.results": "Fetching Results",
        "table.topic": "Topic",
        "tooltip.topic": "The main topic covered by your podcast episode",
        "table.monthlySearches": "Monthly Searches",
        "tooltip.monthlySearches": "The range of monthly google searches you might expect",
        "table.competition": "Competition",
        "tooltip.competition": "The main subject or topic covered by the podcast.",
        "table.monthlyGoogleClicks": "Monthly Google Clicks",
        "tooltip.monthlyGoogleClicks": "A prediction of the range of monthly google clicks you might expect",
        "table.youtubeReach": "Youtube Reach",
        "tooltip.youtubeReach": "A prediction of the max youtube views you might expect in the first 6 months, based on the average competitor",
        "intro.title": "Free Podcast Topics Generator",
        "intro.description": "Get topic ideas for your podcast that audiences are searching for",
        "intro.check1": "Check out the demand for each topic idea on Google",
        "intro.check2": "Find out how competitive each podcast topic idea is",
        "intro.check3": "Estimate the Google clicks and YouTube views you can get",
        "upgrade.message": "You need to upgrade to Pro to access all results",
        "learnMore.label": "Learn more about the",
        "learnMore.link": "free podcast topics generator tool",
        "newSearch.button": "New Search",
        "share.button": "Share This Search",
        "form.label": "Enter your podcast niches",
        "form.placeholder": "Digital Marketing",
        "form.submit": "Find Topic Ideas"
      },
      "page": {
        "main.background": "background"
      },
      "shareTopics": {
        "share.results": "Share Results",
        "share.facebook": "Share on Facebook",
        "share.whatsapp": "Share on WhatsApp",
        "share.twitter": "Share on Twitter",
        "share.linkedin": "Share on LinkedIn",
        "copy.success": "Copied",
        "copy.link": "Copy Link"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "views"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Could not get current composition",
        "error.addImage": "Error adding image element:",
        "alert.uploadImage": "Please upload an image file.",
        "error.uploadImage": "Error uploading image:",
        "alert.uploadFailed": "Failed to upload image. Please try again.",
        "error.getDownloadURL": "Error getting download URL:",
        "alert.processImageFailed": "Failed to process uploaded image. Please try again.",
        "error.addText": "Error adding text element:",
        "error.addShape": "Error adding shape element:",
        "text.settingsPlaceholder": "Settings will show when element is selected",
        "text.addElement": "Add Element",
        "text.uploading": "Uploading...",
        "button.uploadImage": "Upload Image",
        "text.newText": "New Text",
        "button.addText": "Add Text",
        "button.addShape": "Add Shape",
        "text.selectedElementSettings": "Selected Element Settings"
      },
      "FontSelector": {
        "allFonts": "All fonts",
        "myFonts": "My Fonts",
        "uploadFont": "Upload Font",
        "noCustomFonts": "No custom fonts yet.",
        "uploadToAdd": "Upload a font file to add it to your collection.",
        "text_outline": "Text Outline",
        "outline_color": "Outline Color",
        "outline_width": "Outline Width"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Fit",
        "imageLayoutSettings.zoom": "Zoom",
        "imageLayoutSettings.horizontalAlignment": "Horizontal Alignment",
        "imageLayoutSettings.verticalAlignment": "Vertical Alignment",
        "imageLayoutSettings.deleteElement": "Delete Element"
      },
      "TemplateBox": {
        "confirm.delete.template": "Are you sure you want to delete this template?"
      },
      "TextSettings": {
        "error.getting_current_text": "Error getting current text:",
        "event.delete_text_element_clicked": "Delete Text Element Clicked",
        "error.changing_text_font": "Error changing text font:",
        "event.text_font_changed": "Text Font Changed",
        "error.changing_text_size": "Error changing text size:",
        "event.text_size_changed": "Text Size Changed",
        "error.changing_text_color": "Error changing text color:",
        "event.text_color_changed": "Text Color Changed",
        "event.text_content_added": "Text Content Added",
        "error.adding_text_content": "Error adding text content:",
        "event.text_content_updated": "Text Content Updated",
        "label.text_content": "Text Content",
        "label.text_font": "Text Font",
        "label.text_font_weight": "Font Weight",
        "label.adjust_text_size": "Adjust Text Size",
        "label.text_color": "Text Color",
        "button.delete": "Delete"
      },
      "audiogramBaseTemplate": {
        "color.white": "White",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "quadratic-out",
        "animation.fade": "fade",
        "type.text": "text",
        "name.podcastTitle": "PodcastTitle",
        "name.snippetTitle": "snippetTitle",
        "type.image": "image",
        "name.audioBackgroundImage": "AudioBackgroundImage",
        "name.subtitlesText": "subtitlesText",
        "effect.highlight": "highlight",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "snippetTitle",
        "podcast.title": "podcastTitle",
        "new.episode": "NEW EPISODE"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "White",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "defaultEpisodeUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "background_music",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Please upload an image file.",
        "upload.file.loading": "Uploading file. Please, do not close this window.",
        "upload.image.label": "Replace Image",
        "ai.prompt.label": "Enter a prompt for the AI to generate an image",
        "ai.prompt.placeholder": "Ex: A dog running in the park...",
        "ai.processing": "Processing...",
        "ai.create": "Create",
        "customize.image.title": "Customize Image",
        "enter.image.url": "Enter Image URL",
        "or": "or"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Error fetching templates:",
        "template.savedSuccessfully": "Template saved successfully",
        "error.savingTemplate": "Error saving template:",
        "loading.savedTemplates": "Loading saved templates...",
        "no.savedTemplates": "No templates saved",
        "select_template": "Select Template",
        "saving.template": "Saving template...",
        "template_name": "Template Name",
        "enter.templateName": "Enter template name",
        "cancel": "Cancel",
        "save": "Save",
        "default_templates": "Default Templates",
        "saved_templates_count": "Saved Templates ({count})",
        "folder_templates_count": "Folder Templates ({count})",
        "account_templates_count": "Account Templates ({count})",
        "save_current_template": "Save Current Template"
      },
      "subtitlesElement": {
        "edit.word": "Edit Word",
        "edit.label": "edit",
        "remove.word.subtitle": "Remove word from the Subtitle only",
        "erase.subtitle": "erase from subtitle",
        "remove.word.clip": "Remove word from the Audio and Subtitle",
        "remove.clip": "remove from clip"
      },
      "utils": {
        "video.utils.title": "Title",
        "video.utils.currentTime": "Current Time",
        "video.utils.nextTime": "Next Time",
        "video.utils.duration": "Duration",
        "video.utils.description": "Description",
        "video.utils.srtSegment": "SRT Segment"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Your subtitle text here"
      }
    }
  },
  "es": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "CONVIÉRTETE EN NUESTRO SOCIO",
        "SHARE_PODSQUEEZE": "Comparte Podsqueeze con tu audiencia",
        "AND_EARN_MONEY": "¡y gana dinero!",
        "LAST_UPDATED": "Última actualización: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Conviértete en un Socio Afiliado",
        "EARN_COMMISSION": "Gana",
        "COMMISSION": "comisión",
        "ON_EVERY_SALE": "en cada venta realizada a través de tu enlace de referencia exclusivo durante un período de 15 meses. Comparte tu enlace en tu sitio web, redes sociales, o con tus amigos. Te tomará solo unos segundos unirte.",
        "GET_AUTOMATICALLY_APPROVED": "Obtén aprobación automática.",
        "JOIN_NOW": "Únete ahora",
        "HOW_IT_WORKS": "CÓMO FUNCIONA",
        "FREQUENTLY_ASKED_QUESTIONS": "Preguntas Frecuentes",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "¿Qué es un Socio Afiliado?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Un Socio Afiliado es alguien que promociona los productos o servicios de otra empresa a través de un enlace de referencia único y gana una comisión por cada venta realizada a través de ese enlace.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "¿Cómo puedo convertirme en un Socio Afiliado?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Convertirse en un Socio Afiliado es rápido y fácil, solo te tomará unos segundos. Para comenzar, simplemente haz clic en el botón 'Únete ahora' e inscríbete con tu correo electrónico. Una vez registrado, tendrás acceso a un panel fácil de usar donde encontrarás tu enlace de referencia único. Comparte este enlace con tu familia, amigos o audiencia en línea. Cada vez que alguien haga clic en tu enlace de referencia y realice una compra en el sitio web de Podsqueeze, ganarás una comisión del 25% en cada pago durante 15 meses completos. Lleva un registro de tus ganancias sin esfuerzo a través de tu panel de afiliado, que proporciona una visión clara de todas las ventas que has generado.",
        "HOW_CAN_I_TRACK_MY_SALES": "¿Cómo puedo rastrear mis ventas y comisiones?",
        "TRACKING_SALES_DESCRIPTION": "Usa nuestro panel del programa de afiliados para rastrear tus ventas y comisiones. El software de seguimiento está disponible tanto para Socios Afiliados como para Socios Comerciales.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "¿Cuándo y cómo recibiré mi pago?",
        "PAYMENT_DESCRIPTION": "Recibirás tu pago a través de PayPal cada 30 días. Ten en cuenta que hay un umbral mínimo de pago de $50. Así que, tan pronto como alcances esta cantidad, puedes esperar recibir tu pago puntualmente cada 30 días.",
        "STILL_GOT_QUESTIONS": "¿TODAVÍA TIENES PREGUNTAS?",
        "SEND_US_A_MESSAGE": "Envíanos un mensaje en el chat de soporte o escríbenos a team@podsqueeze.com",
        "NOTE": "Nota",
        "AFFILIATE_ADS_RESTRICTION": "A los afiliados se les prohíbe expresamente crear anuncios en Google o participar en la puja de palabras clave relevantes asociadas con Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Términos de Uso de Afiliados",
        "CAN_I_RUN_ADS": "¿Puedo ejecutar anuncios y campañas CPC en Google para promocionar mi enlace de referencia?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "A los afiliados se les prohíbe estrictamente crear anuncios en motores de búsqueda o participar en la puja de palabras clave relacionadas con Podsqueeze. Esta restricción ayuda a mantener la integridad de nuestra estrategia publicitaria y asegura una coherencia en el mensaje de la marca. Ten en cuenta que las ventas resultantes de dichas campañas de puja no serán elegibles para pago.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "¿Cómo genera Podsqueeze títulos para tu Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Barra de Navegación",
        "main.affiliateHero": "Heroe de Afiliados",
        "main.footer": "Pie de Página"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Añadir Música de Introducción y Cierre",
        "intro.music": "Música de Introducción",
        "outro.music": "Música de Cierre",
        "intro.duration": "Duración de Introducción",
        "outro.duration": "Duración de Cierre",
        "intro.mode": "Modo de Introducción",
        "outro.mode": "Modo de Cierre",
        "cancel": "Cancelar",
        "save": "Guardar",
        "apply": "Aplicar",
        "current.intro.music": "Música de Introducción Actual",
        "current.outro.music": "Música de Cierre Actual",
        "change.music": "Cambiar Música",
        "choose.music": "Elegir Archivo de Música",
        "browser.not.support.audio": "Tu navegador no soporta el elemento de audio.",
        "save.and.apply": "Guardar y Aplicar",
        "no.music.selected": "No hay música seleccionada",
        "delete.music": "Eliminar música",
        "uploading.file": "Subiendo archivo...",
        "download.audio": "Descargar Audio",
        "download.video": "Descargar Video"
      },
      "audioEditElements": {
        "error.processing.rss": "Estamos experimentando algunas dificultades para procesar algunos feeds RSS. Por favor, sube un archivo.",
        "edit.enhance.audio": "Edita y mejora tu grabación de audio",
        "trial.label": "Prueba",
        "audio.editing.experience": "Experimenta una edición de audio sin interrupciones con algoritmos de IA avanzados para resultados naturales y de alta calidad, con solo un clic.",
        "improve.audio.quality": "Mejorar la Calidad del Audio",
        "remove.hums.silences": "Eliminar Zumbidos y Silencios",
        "upgrade.edit.audio": "Actualiza para poder editar tu audio con un solo clic",
        "available.plans": "Disponible para Todos los Planes Pagados",
        "upgrade.now": "Actualiza Ahora",
        "audio.element.support": "Tu navegador no soporta el elemento de audio.",
        "download.audio": "Descargar Audio",
        "loading.audio": "Cargando Audio",
        "editing.audio": "Editando Audio"
      },
      "videoEditElements": {
        "error.exporting.video": "Error al exportar el video",
        "download.failed": "Descarga fallida: {error.message}",
        "generating.video": "Generando video",
        "error.generating.clip": "Error al generar el clip",
        "please.retry.support": "Por favor, inténtalo de nuevo o contacta a nuestro soporte al usuario",
        "browser.not.support.video": "Tu navegador no soporta la etiqueta de video.",
        "this.might.take.minutes": "Por favor, no cierres la ventana, esto puede tardar unos minutos.",
        "exporting.video": "Exportando tu video...",
        "seamless.audio.editing": "Experimenta una edición de audio sin interrupciones con algoritmos de IA avanzados para resultados naturales y de alta calidad, con solo un clic.",
        "difficulties.processing.rss": "Estamos experimentando algunas dificultades para procesar algunos feeds RSS. Por favor, sube un archivo.",
        "edit.enhance.video.recording": "Edita y mejora tu grabación de video",
        "trial": "Prueba",
        "enhance.audio.quality": "Mejorar la calidad del audio",
        "enhance.audio.quality.edit": "Mejorar la calidad del audio y editar",
        "trim.filler.words.video": "Recortar palabras de relleno del video (ej: murmullos)",
        "trim.long.silences.video": "Recortar silencios largos del video",
        "upgrade.to.edit.video": "Actualiza para poder editar tu video con un solo clic",
        "available.pro.agency.plans": "Disponible para planes Pro y Agencia",
        "upgrade.now": "Actualiza ahora",
        "download.only.audio": "Descargar solo audio",
        "download.video": "Descargar video",
        "please.dont.close.window": "Por favor, no cierres la ventana",
        "export.video": "Exportar video"
      },
      "videogramBaseTemplate": {
        "media.fit": "cubrir",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "media"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Otros episodios de este Podcast",
        "tab.shownotes": "Notas del Programa",
        "tab.timestamps": "Marcas de Tiempo",
        "tab.blogpost": "Entrada del Blog",
        "tab.transcript": "Transcripción",
        "key.points": "Puntos Clave"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "¡Tu página de destino está activa en nuestro buscador de podcasts. Compártela con tu audiencia!",
        "landingPage.create": "Crea una hermosa página de destino para este episodio",
        "landingPage.edit": "Editar Página",
        "landingPage.visit": "Visitar Página",
        "landingPage.delete": "Eliminar Página",
        "landingPage.createButton": "Crear Página de Destino"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Gestionar enlaces de episodios",
        "youtube.link": "Enlace de YouTube",
        "enter.youtube.link": "Ingrese el enlace de YouTube",
        "apple.podcasts.link": "Enlace de Apple Podcasts",
        "enter.apple.podcasts.link": "Ingrese el enlace de Apple Podcasts",
        "spotify.link": "Enlace de Spotify",
        "enter.spotify.link": "Ingrese el enlace de Spotify",
        "saving": "Guardando...",
        "save": "Guardar",
        "social.links.updated.successfully": "¡Enlaces sociales actualizados con éxito!"
      },
      "affiliatesection": {
        "affiliate.section.title": "CONVIÉRTETE EN UN SOCIO AFILIADO",
        "affiliate.section.subtitle": "Comparte Podsqueeze con tu audiencia y",
        "affiliate.section.earn": "¡gana dinero!",
        "affiliate.section.commission": "Nuestro programa de afiliados ofrece un 25% de comisión durante 15 meses, en cada venta y pago de renovación de suscripción.",
        "affiliate.section.join": "¡Se tarda segundos en unirse!",
        "affiliate.section.knowMore": "Saber más"
      },
      "asseenon": {
        "podnews.logo": "logo de podnews",
        "transistor.logo": "logo de transistor",
        "thepodcasthost.logo": "logo de the podcast host",
        "schoolofpodcasting.logo": "logo de la Escuela de Podcasting",
        "semrush.logo": "logo de semrush"
      },
      "assembleshownotes": {
        "episode.description": "Descripción del episodio",
        "bullet.points": "Puntos clave",
        "timestamps": "Marcas de tiempo",
        "links.and.mentions": "Enlaces y menciones",
        "extra.content": "Contenido adicional",
        "assemble.show.notes": "Reúne tus notas del programa",
        "downloading": "Descargando",
        "copied": "Copiado",
        "enter.placeholder": "Ingresa {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Tomando un descanso de la podcasting",
        "cancellation.option.no_recurrent": "No quiero una suscripción recurrente",
        "cancellation.option.expensive": "Es demasiado caro",
        "cancellation.option.not_saving_time": "No me está ahorrando suficiente tiempo",
        "cancellation.option.dissatisfied_content": "Insatisfecho con la calidad del contenido generado",
        "cancellation.option.unresponsive_support": "Soporte al cliente no responde",
        "cancellation.option.not_using": "No estoy usando el servicio lo suficiente",
        "cancellation.option.difficulty_navigating": "Dificultad para usar/navegar el producto",
        "cancellation.option.better_alternative": "Encontré un producto alternativo mejor",
        "cancellation.option.other": "Otro",
        "cancellation.video.message": "El 70% de nuestros usuarios detienen el proceso de cancelación después de ver este video",
        "cancellation.button.cancel": "Aún Quiero Cancelar",
        "cancellation.button.try_again": "Quiero Intentarlo de Nuevo",
        "cancellation.prompt.select_reason": "Por favor, ayúdanos a mejorar el producto seleccionando la razón para cancelar tu suscripción:",
        "cancellation.placeholder.answer": "Escribe tu respuesta aquí...",
        "cancellation.placeholder.specify_reason": "Por favor especifica tu razón para la cancelación",
        "cancellation.button.next": "Siguiente",
        "cancellation.button.go_back": "Regresar",
        "cancellation.last_question.title": "Última Pregunta de Nuestra Parte",
        "lose.all.accumulated.minutes": "Si cancelas, perderás todos tus minutos acumulados.",
        "keep.accumulating.minutes": "Si cancelas, los minutos acumulados se mantendrán para que puedas usarlos cuando vuelvas a hacer un podcast.",
        "here.are.some.ideas": "Aquí hay algunas ideas para ayudarte a continuar obteniendo valor de Podsqueeze",
        "convert.and.repurpose.episodes": "Convierte y reutiliza tus episodios más antiguos en nuevo contenido",
        "generate.articles.favorite.podcasts.and.vides": "Genera artículos a partir de tus podcasts favoritos",
        "share.your.account.with.a.friend": "Comparte tu cuenta con un amigo que podría ser útil",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Aquí hay un video que muestra cómo usar Podsqueeze al máximo",
        "cancellation.last_question.prompt": "¿Qué cambios o mejoras te harían considerar volver a unirte a nuestro servicio?",
        "cancellation.feedback.message": "Tu opinión nos ayudará a mejorar 🙏",
        "cancellation.button.confirm": "Confirmar Cancelación",
        "cancellation.minutes.accumulated": "Tienes",
        "cancellation.minutes.accumulated.suffix": "minutos acumulados, valorados en",
        "cancellation.reminder.text": "Por favor recuerda:",
        "cancellation.minutes.warning": "Los minutos acumulados son un beneficio para suscripciones activas. Al cancelar tu suscripción tus minutos se perderán permanentemente.",
        "cancellation.content.deletion.warning": "Todo tu contenido generado será eliminado permanentemente después de 30 días.",
        "cancellation.minutes.left.title": "¡Aún te quedan minutos! ¡No los desperdicies!",
        "cancellation.suggestion.clips": "Reutiliza episodios antiguos en clips para redes sociales",
        "cancellation.suggestion.articles": "Convierte episodios antiguos en artículos con Podsqueeze para beneficiarte del SEO.",
        "cancellation.suggestion.linkedin": "Convierte episodios de autoridad antiguos en publicaciones de LinkedIn para impulsar tu marca personal",
        "cancellation.suggestion.share": "Comparte tu cuenta de Podsqueeze con un amigo para que pueda beneficiarse de tus minutos no utilizados.",
        "cancellation.button.keep.subscription": "Mantener Mi Suscripción",
        "cancellation.button.keep.minutes": "Mantener Mis",
        "cancellation.button.keep.minutes.suffix": "en Valor de Minutos",
        "cancellation.lifetime.before_you_go": "Antes de que te vayas...",
        "cancellation.lifetime.title": "¿Qué tal acceso de por vida por solo $49?",
        "cancellation.lifetime.subtitle": "Mantén tu cuenta Starter. Sin suscripciones. Sin renovaciones. Solo tuya — para siempre.",
        "cancellation.lifetime.feature1": "Acceso de por vida a Podsqueeze por un pago único de $49",
        "cancellation.lifetime.feature2": "Úsalo cuando lo necesites, sin presión — es tuyo para siempre",
        "cancellation.lifetime.feature3": "Incluye todas las características actuales y futuras del Plan Starter",
        "cancellation.lifetime.button_cancel": "Aún quiero cancelar",
        "cancellation.lifetime.button_deal": "Obtener oferta de por vida",
        "cancellation.downgrade.title": "Mantén todo tu contenido por solo $5.99/mes",
        "cancellation.downgrade.subtitle": "Al degradar a Starter puedes...",
        "cancellation.downgrade.feature1": "Mantener todo tu contenido generado",
        "cancellation.downgrade.feature2": "Mantener tus sitios web funcionando",
        "cancellation.downgrade.feature3": "160 minutos y 10 clips al mes para trabajo ocasional",
        "cancellation.billing.monthly": "Mensual",
        "cancellation.billing.annual": "Anual",
        "cancellation.billing.discount": "30% DESC",
        "cancellation.plan.starter": "Plan Starter",
        "cancellation.price.monthly": "$8.99/mes",
        "cancellation.price.annual": "$5.99/mes",
        "cancellation.price.annual_billing": "facturado $71.88 anualmente",
        "cancellation.feature.minutes": "160 mins/mes",
        "cancellation.feature.clips": "10 clips/mes",
        "cancellation.downgrade.button": "Degradar a Starter y Mantener Contenido",
        "cancellation.error.payment_link": "No se pudo obtener el enlace de pago. Inténtalo de nuevo.",
        "cancellation.error.payment_service": "Error al conectar con el servicio de pago.",
        "cancellation.option.question.break": "¿Puedes contarnos más sobre por qué te estás tomando un descanso?",
        "cancellation.option.question.no_recurrent": "¿Podrías compartir por qué prefieres no tener una suscripción recurrente?",
        "cancellation.option.question.expensive": "¿Qué precios o características harían que el servicio fuera más valioso para ti?",
        "cancellation.option.question.not_saving_time": "¿Qué te sigue tomando mucho tiempo en tu proceso?",
        "cancellation.option.question.dissatisfied_content": "¿Con qué aspectos del contenido no estabas satisfecho?",
        "cancellation.option.question.unresponsive_support": "¿Puedes describir tu experiencia con nuestro soporte al cliente?",
        "cancellation.option.question.not_using": "¿Hay algo que te animaría a usar el servicio más a menudo?",
        "cancellation.option.question.difficulty_navigating": "¿Qué dificultades encontraste al usar o navegar por el producto?",
        "cancellation.option.question.better_alternative": "¿Qué producto alternativo encontraste y qué te gusta de él?",
        "cancellation.option.question.other": "Por favor especifica tu razón para la cancelación:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Valoramos su privacidad",
        "cookiebanner.cookieUsage": "Utilizamos cookies para mejorar su experiencia en el sitio web y analizar nuestro tráfico. Al hacer clic en aceptar, consiente nuestro uso de cookies.",
        "cookiebanner.privacyPolicy": "Política de Privacidad",
        "cookiebanner.accept": "Aceptar",
        "cookiebanner.decline": "Rechazar"
      },
      "episodeTitleBox": {
        "loading": "Cargando...",
        "editEpisodeTitleClicked": "Título del episodio editado",
        "newEpisodeTitleStored": "Nuevo título del episodio guardado"
      },
      "famewall": {
        "loading.message": "Cargando..."
      },
      "footer": {
        "footer.features": "Características",
        "footer.transcriptGenerator": "Generador de Transcripciones",
        "footer.subtitlesGenerator": "Generador de Subtítulos",
        "footer.descriptionGenerator": "Generador de Descripciones",
        "footer.podcastSummarizer": "Generador de Resúmenes de Podcast",
        "footer.titlesGenerator": "Generador de Títulos",
        "footer.bulletPointsGenerator": "Generador de Puntos Clave",
        "footer.chaptersClipsGenerator": "Generador de Capítulos y Clips",
        "footer.socialMediaPostsGenerator": "Generador de Publicaciones en Redes Sociales",
        "footer.newsletterGenerator": "Generador de Boletines",
        "footer.blogPostGenerator": "Generador de Publicaciones de Blog",
        "footer.podcastLandingPages": "Páginas de Aterrizaje de Podcast",
        "footer.podcastClipMaker": "Creador de Clips de Podcast",
        "footer.audiogramGenerator": "Generador de Audiogramas",
        "footer.aiAudioEnhancer": "Mejorador de Audio AI",
        "footer.convertYoutubeToText": "Convertir Youtube a Texto",
        "footer.youtubeVideoNoiseRemover": "Eliminador de Ruido de Video de Youtube",
        "footer.youtubeVideoKeyPoints": "Puntos Clave del Video de Youtube",
        "footer.freeResources": "Recursos Gratuitos",
        "footer.findPodcastTopicIdeas": "Encontrar Ideas de Temas para Podcast",
        "footer.articles": "Artículos",
        "footer.freeEbooks": "eBooks Gratuitos",
        "footer.community": "Comunidad",
        "footer.ourPodcast": "Nuestro Podcast",
        "footer.product": "Producto",
        "footer.giftCard": "Tarjeta de Regalo",
        "footer.onboardingEbook": "eBook de Incorporación",
        "footer.pricing": "Precios",
        "footer.affiliates": "Afiliados",
        "footer.media": "Medios",
        "footer.testimonials": "Testimonios",
        "footer.legal": "Legal",
        "footer.privacyPolicy": "Política de Privacidad",
        "footer.termsOfUse": "Términos de Uso",
        "footer.refundPolicy": "Política de Reembolso",
        "footer.allRightsReserved": "Todos los Derechos Reservados."
      },
      "globalState": {
        "cookie.enabled": "Cookies habilitadas",
        "language.default": "Idioma predeterminado"
      },
      "head": {
        "keywords.list": "Podsqueeze, IA, Podcasts, Generación de Contenido, Transcripción de Podcasts, Notas del Programa, Tiempos, Boletines de Podcasts, Tweets, Publicaciones de Blog, Publicaciones en Redes Sociales, Títulos, Escritor de Notas del Programa"
      },
      "imageResultModal": {
        "download.image": "Descargar Imagen",
        "generating.image": "Generando Imagen",
        "ai.prompt.label": "Ingresa un prompt para que la IA genere una imagen",
        "ai.prompt.placeholder": "Ej: Un perro corriendo en el parque...",
        "processing": "Procesando...",
        "create": "Crear",
        "text.color.label": "Color del Texto",
        "quote.icon.color.label": "Color del Icono de Cita",
        "background.color.label": "Color de Fondo",
        "font.label": "Fuente",
        "upload.cover.image": "Subir Imagen de Portada",
        "aspect.ratio.info": "Relación de aspecto 1:1, tamaño recomendado 1200x1200",
        "upload.logo.label": "Subir Logo",
        "choose.file": "Elegir Archivo",
        "upload.success": "Subido con éxito",
        "choose.quote": "Elegir una Cita",
        "select.template": "Seleccionar plantilla",
        "quote.label": "Cita",
        "enter.quote.here": "Ingresa la Cita Aquí",
        "author.label": "Autor",
        "enter.author.name": "Ingresa el Nombre del Autor",
        "podcast.name.label": "Nombre del Podcast",
        "enter.podcast.name": "Ingresa el Nombre del Podcast",
        "colors": "Colores",
        "select.font": "Seleccionar Fuente",
        "cover.logo.images": "Imágenes de Portada y Logo",
        "logo.image": "Imagen del Logo",
        "upgrade.here": "Mejorar aquí",
        "remove.logo": "Eliminar logo de Podsqueeze",
        "default_templates": "Plantillas por defecto",
        "saved_templates_count": "Plantillas guardadas",
        "save_current_template": "Guardar plantilla actual",
        "no_saved_templates": "Aún no hay plantillas guardadas",
        "save_template": "Guardar plantilla",
        "cancel": "Cancelar",
        "save": "Guardar",
        "enter_template_name": "Ingrese el nombre de la plantilla",
        "reset_template": "Restablecer",
        "add_element": "Agregar Elemento",
        "generate": "Generar",
        "add_image": "Agregar Imagen",
        "upload_image": "Subir imagen",
        "or": "o",
        "generate_with_ai": "Generar con IA",
        "search_fonts": "Buscar fuentes...",
        "upload_logo": "Subir logo",
        "square_image_recommended": "Se recomienda imagen cuadrada",
        "opacity": "Opacidad",
        "layers": "Capas",
        "no_element_selected": "Ningún elemento seleccionado",
        "bold_shortcut": "Negrita (Ctrl+B)",
        "italic_shortcut": "Cursiva (Ctrl+I)",
        "underline_shortcut": "Subrayado (Ctrl+U)",
        "edit_text": "Editar texto",
        "tint_color": "Color de tinte",
        "toggle_gradient_transparent": "Alternar gradiente a transparente",
        "rotate_gradient": "Rotar gradiente 45 grados",
        "alt_background": "Fondo",
        "alt_podcast_logo": "Logo del Podcast",
        "alt_custom": "Personalizado",
        "alt_right_side": "Lado Derecho",
        "alt_profile": "Perfil"
      },
      "intentModal": {
        "intentModal.title": "¿Qué quieres hacer con Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Escribir Notas del Programa",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Escribir Publicación de Blog y Boletín",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Crear Clips de Video o Audiogramas",
        "intentModal.sourceOption.Create_Quote_Images": "Crear Imágenes de Citas",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Editar y Mejorar Audio/Video",
        "intentModal.sourceOption.Transcribe": "Transcribir",
        "intentModal.sourceOption.Create_a_Website": "Crear un Sitio Web",
        "intentModal.sourceOption.All_of_the_Above": "Todo lo Anterior",
        "intentModal.sourceOption.Other": "Otro",
        "intentModal.otherPlaceholder": "Por favor especifica",
        "intentModal.submitButton": "Enviar y Registrar",
        "intentModal.skip": "Saltar"
      },
      "languageSwitcher": {
        "language.en": "Inglés",
        "language.es": "Español",
        "language.fr": "Francés",
        "language.de": "Alemán",
        "language.it": "Italiano",
        "language.pt": "Portugués",
        "language.nl": "Neerlandés",
        "language.pl": "Polaco",
        "language.ru": "Ruso",
        "language.zh": "Chino",
        "language.ja": "Japonés",
        "language.ko": "Coreano",
        "language.ar": "Árabe",
        "language.th": "Tailandés",
        "language.vi": "Vietnamita"
      },
      "lazyImage": {
        "lazyImage.alt": "Descripción de la imagen"
      },
      "metadata": {
        "meta.title": "El Título de Tu Página",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Utilidad"
      },
      "navbar": {
        "navbar.dashboard": "Tablero",
        "navbar.login": "Iniciar sesión",
        "navbar.openMenu": "Abrir menú principal",
        "navbar.features": "Características",
        "navbar.resources": "Recursos",
        "navbar.pricing": "Precios",
        "navbar.contact": "Contacto",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "Ver todas las características",
        "navbar.mainFeatures": "CARACTERÍSTICAS PRINCIPALES",
        "navbar.podcastTranscription": "Generador de transcripciones de podcast y video",
        "navbar.transcriptionDescription": "Transcripción de alta precisión con etiquetado de hablantes y archivo SRT para subtítulos.",
        "navbar.podcastSummarizer": "Resumidor de podcast",
        "navbar.summarizerDescription": "Crea notas completas del programa 20 veces más rápido, con tu propia voz.",
        "navbar.podcastClipMaker": "Creador de clips de podcast",
        "navbar.clipMakerDescription": "Genera automáticamente clips cortos o audiogramas para tu podcast.",
        "navbar.audioEnhancer": "Mejorador de audio Ai",
        "navbar.audioEnhancerDescription": "Mejora automáticamente el audio, elimina silencios y palabras de relleno.",
        "navbar.podsqueezeFeaturesWalkthrough": "GUÍA DE CARACTERÍSTICAS DE PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Artículos y guías prácticas para lanzar y hacer crecer un podcast exitoso.",
        "navbar.podcastTopicIdeas": "Ideas de temas para podcast",
        "navbar.topicIdeasDescription": "Descubre temas de podcast que las audiencias están buscando.",
        "navbar.actionableEbooks": "eBooks Accionables",
        "navbar.ebooksDescription": "Descarga eBooks gratuitos con consejos accionables para llevar tu podcast al siguiente nivel.",
        "navbar.freeThumbnailMaker": "Creador Gratuito de Miniaturas de Podcast",
        "navbar.freeThumbnailMakerDescription": "Crea miniaturas profesionales y llamativas para episodios con IA.",
        "navbar.seoOptimizer": "Optimizador SEO",
        "navbar.seoOptimizerDescription": "Optimiza tus episodios de podcast para mejor visibilidad en motores de búsqueda.",
        "navbar.podcastDescription": "Escucha nuestro podcast, donde entrevistamos a podcasters experimentados y usuarios de Podsqueeze de todo el mundo. Les pedimos que compartan sus consejos, perspectivas, historias y todo lo que necesitas saber para hacer crecer tu propio podcast."
      },
      "resultModal": {
        "prompt.transcript.quote": "Cita",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Notas de presentación en primera persona",
        "prompt.shownotes.replaceName": "Reemplazar nombre en las notas de presentación",
        "prompt.shownotes.friendlyTone": "Notas de presentación en tono amigable",
        "prompt.shownotes.youtubeDescription": "Descripción de YouTube en las notas de presentación",
        "prompt.shownotes.engagingQuestion": "Pregunta atractiva en las notas de presentación",
        "prompt.newsletter.casualTone": "Boletín en tono casual",
        "prompt.newsletter.shorter": "Boletín más corto",
        "prompt.newsletter.contentSections": "Secciones de contenido en el boletín",
        "prompt.newsletter.changeName": "Cambiar nombre en el boletín",
        "prompt.mentions.fullURL": "Menciones de URL completa",
        "prompt.mentions.replaceName": "Reemplazar nombre en menciones",
        "prompt.tweets.underdogTone": "Tweets en tono de desvalido",
        "prompt.tweets.firstPerson": "Tweets en primera persona",
        "prompt.shortPost.relevantEmojis": "Emojis relevantes en publicación corta",
        "prompt.shortPost.educationalTone": "Publicación corta en tono educativo",
        "prompt.shortPost.underdogTone": "Publicación corta en tono de desvalido",
        "prompt.shortPost.firstPerson": "Publicación corta en primera persona",
        "prompt.titles.youtubeOptimized": "Títulos optimizados para YouTube",
        "prompt.titles.startWithHowTo": "Comenzar con títulos 'Cómo hacer'",
        "prompt.titles.otherOptions": "Otras opciones para títulos",
        "prompt.keywords.youtubeOptimized": "Palabras clave optimizadas para YouTube",
        "prompt.keywords.separateWithCommas": "Separar palabras clave con comas",
        "prompt.quotes.lorem1": "Cita de Lorem ipsum 1",
        "prompt.quotes.lorem2": "Cita de Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Punto de viñeta de Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Punto de viñeta de Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Publicación larga en primera persona",
        "prompt.longPost.relevantEmojis": "Emojis relevantes en publicación larga",
        "prompt.longPost.changeName": "Cambiar nombre en publicación larga",
        "alert.tuningInstructionsEmpty": "Las instrucciones de ajuste no pueden estar vacías.",
        "text.timestamps.byPodsqueeze": "Marcas de tiempo por PodSqueeze",
        "button.copied": "Copiado",
        "button.copy": "Copiar",
        "embed.transcript": "Incrustar transcripción",
        "embed.description": "Descripción para incrustar",
        "preview.title": "Título de vista previa",
        "loading.regenerating": "Regenerando...",
        "placeholder.tuningInstructions": "Ingrese instrucciones de ajuste...",
        "button.saveClose": "Guardar y cerrar",
        "button.acceptChanges": "Aceptar cambios",
        "button.discard": "Descartar",
        "button.embedTranscript": "Incrustar transcripción",
        "text.copiedToClipboard": "Copiado al portapapeles",
        "download.srtFile": "Descargar archivo SRT",
        "text.forCaptions": "para subtítulos",
        "tune.title": "Ajusta tus resultados",
        "tune.description": "Ajusta tus resultados con las siguientes opciones.",
        "instruction.label": "Instrucciones:",
        "button.tuneResult": "Ajustar resultado",
        "instruction.saveForLater": "Guardar para más tarde",
        "button.readMore": "Leer más",
        "button.showLess": "Mostrar menos",
        "customPrompt.used": "Prompt personalizado usado:",
        "feedback.happyWithResults": "¿Estás satisfecho con los resultados?",
        "prompt.timestamps.formatAsChapters": "Formatear marcas de tiempo como capítulos con títulos descriptivos",
        "prompt.timestamps.detailedDescriptions": "Crear marcas de tiempo detalladas con descripciones de temas y puntos clave",
        "prompt.timestamps.improveSpeakerNames": "Reemplazar nombres de oradores con títulos más descriptivos como 'Anfitrión', 'Experto' o 'Invitado'"
      },
      "resultModalTranscript": {
        "prompt.quote": "Encuentra tres buenas citas del transcripto",
        "prompt.blog": "Escribe un artículo de blog de 500 palabras centrado en el tema X",
        "prompt.tweets": "Escribe tres tweets atractivos del transcripto",
        "transcript.autoTranscribed": "Transcrito automáticamente con Podsqueeze",
        "alert.emptyPrompt": "Las instrucciones de ajuste no pueden estar vacías",
        "embed.transcript": "Incrustar transcripto",
        "embed.description": "Incrusta un transcripto de tamaño manejable con una función de búsqueda en tu sitio de WordPress o en cualquier página compatible con HTML.",
        "button.copied": "¡Copiado!",
        "button.copy": "Copiar",
        "preview.title": "Vista previa",
        "edit.speakers": "Editar nombres de los hablantes",
        "button.saveClose": "Guardar y cerrar",
        "placeholder.prompt": "p.ej: Encuentra tres buenas citas del transcripto",
        "upgrade.pro": "Actualiza a Pro para usar esta función",
        "upgrade.link": "Actualizar a Pro",
        "button.generate": "Generar",
        "feedback.happy": "¿Estás satisfecho con los resultados?",
        "instruction": "Instrucción: ",
        "generating.results": "Generando resultados",
        "full.transcription": "Transcripción completa",
        "srt.file": "& archivo SRT",
        "download.srt": "Descargar archivo SRT",
        "caption.subtitles": "para subtítulos y subtítulos.",
        "generate.from.transcript": "Generar desde el transcripto con Gpt-4o",
        "gpt.tweak.text": "Pide al último GPT que ajuste el texto a tu gusto. Usa lenguaje natural y no tengas miedo de ser específico.",
        "copied.clipboard": "Copiado al portapapeles",
        "transcript.public.available": "URL disponible",
        "audio.notSupported": "Tu navegador no soporta el elemento de audio.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Agregar Nombre del Podcast",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "¿Cómo te enteraste de Podsqueeze?",
        "sourceModal.otherPlaceholder": "Por favor especifica",
        "sourceModal.nextButton": "Siguiente",
        "sourceModal.skip": "Saltar"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Estamos experimentando algunas dificultades para procesar algunos feeds RSS. Por favor, sube un archivo."
      },
      "squeezeResults": {
        "copiedToClipboard": "Copiado al portapapeles",
        "publicLink": "Público en ",
        "createLink": "Crear un enlace para compartir esta página de resultados",
        "assembleShowNotes": "Ensamblar notas del programa",
        "convertAnotherEpisode": "Convertir otro episodio",
        "writtenContent": "Contenido escrito",
        "videoClipsAndImages": "Clips de video e imágenes",
        "editAudio": "Editar audio"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Ver más y sintonizar",
        "see.more": "Ver más",
        "generating": "Generando",
        "download.all": "Descargar todo",
        "full.transcription": "Transcripción completa",
        "transcript.benefit": "¿Sabías que agregar transcripciones completas a tus notas del programa aumenta el tráfico y la participación en el sitio web?",
        "learn.more": "Aprender más",
        "transcript.bonus": "Puedes proporcionar transcripciones completas como un bono para tu programa de membresía de podcast.",
        "show.notes": "Notas del programa",
        "show.notes.engagement": "Considera complementar esta breve descripción con otros elementos en tus notas del programa para aumentar la participación y el SEO.",
        "show.notes.examples": "Encuentra inspiración en estos 17 ejemplos de notas de programas de podcast para crear las perfectas para tu podcast.",
        "timestamps": "Marcas de tiempo",
        "timestamps.benefit": "Agrega estas marcas de tiempo a la descripción de tu episodio y se crearán automáticamente capítulos en Spotify y YouTube.",
        "titles": "Títulos",
        "titles.engagement": "Los títulos que incluyen signos de interrogación y superlativos tienden a ser particularmente atractivos.",
        "links.and.mentions": "Enlaces y menciones",
        "mentions.resources": "Considera incluir las menciones a continuación en la sección de recursos de tus notas del programa.",
        "mentions.affiliate": "Verifica si los productos mencionados tienen programas de afiliados y considera agregar enlaces de afiliados en tus notas del programa.",
        "mentions.social.media": "Etiqueta a las personas mencionadas en tu episodio en las redes sociales para animarlas a compartir y participar en tu publicación.",
        "keywords": "Palabras clave",
        "keywords.youtube": "Cuando subas tu episodio a YouTube, simplemente copia y pega estas palabras clave en la sección de etiquetas.",
        "keywords.social.media": "Reutiliza estas palabras clave para hashtags en redes sociales.",
        "blog.post": "Publicación de blog",
        "blog.post.linkedin": "Considera usar este contenido para crear una publicación larga en Linkedin.",
        "blog.post.share": "Comparte este contenido en comunidades de Reddit y grupos de Facebook que se alineen con el tema de tu podcast.",
        "newsletter": "Boletín",
        "newsletter.content": "Algunos de nuestros usuarios reutilizan este contenido del boletín para crear descripciones de episodios más completas para las notas del programa.",
        "linkedin.and.facebook": "Linkedin y Facebook",
        "short.post.description": "Usa estas breves publicaciones como descripciones al compartir clips de video relacionados y audiogramas en redes sociales.",
        "tweets": "Tweets",
        "quotes": "Citas",
        "bullet.points": "Puntos clave",
        "add.custom.result": "Agregar resultado personalizado",
        "bullet.points.skimming": "Los podcasters a menudo enumeran los temas principales del episodio como puntos clave en las notas del programa para facilitar la lectura rápida."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Ver más y sintonizar",
        "generating": "Generando",
        "not.available.for.rss.feed": "No disponible para este feed RSS",
        "regenerate.episode.upload.file": "Regenerar el episodio y subir tu archivo de audio/video directamente desde tu computadora",
        "processing.difficulties": "Estamos experimentando algunas dificultades para procesar algunos feeds RSS. Por favor, sube un archivo.",
        "video.clips": "Clips de Video",
        "ai.short.clips": "Clips Cortos de IA",
        "quote.image": "Imagen de Cita"
      },
      "title": {
        "title.text": "tu.etiqueta"
      },
      "topbar": {
        "topbar.forYou": "Para Ti",
        "topbar.joinPodcast": "¡Únete a nuestra próxima reunión virtual de podcasting!",
        "topbar.saveYourSpot": "Reserva tu lugar",
        "topbar.dismiss": "Descartar"
      },
      "trackers": {
        "trackers.init": "Inicializando rastreadores con cookies habilitadas: ",
        "trackers.loadScripts": "Cargando scripts de seguimiento..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Bienvenido a Mi Aplicación",
        "content.description": "Esta es una aplicación de muestra que demuestra la traducción.",
        "button.submit": "Enviar"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI está editando tu clip",
        "export_clip": "Exportar Clip",
        "ai_edit": "Edición de IA",
        "ai_editing_clip_duration": "Esto tomará unos segundos",
        "generating_clip": "Generando tu clip...",
        "generating_clip_notice": "Esto puede tardar unos minutos. Te enviaremos un correo electrónico una vez que esté listo.",
        "edit_another_video": "Puedes esperar aquí o editar otro video",
        "download_video": "Descargar Video",
        "back_to_editing": "Volver a la Edición",
        "export_video_button": "Exportar Clip",
        "notice_storage": "Aviso: Almacenamos tu audio durante 30 días. Después de este período, este clip expirará.",
        "error_generating_clip": "Error al Generar Clip",
        "error_user_support": "Por favor, intenta de nuevo o contacta a nuestro soporte al usuario",
        "select_template": "Seleccionar plantilla",
        "add_30s_prev": "30s del capítulo anterior",
        "add_30s_next": "30s del próximo capítulo",
        "undo": "Deshacer",
        "subtitles_font": "Fuente de los Subtítulos",
        "subtitles_color": "Color de los Subtítulos",
        "subtitles_box_color": "Color de la animación",
        "adjust_podcast_title_position": "Ajustar la Posición Vertical del Título del Podcast",
        "adjust_subtitles_size": "Ajustar el Tamaño de los Subtítulos",
        "adjust_subtitles_vertical_position": "Ajustar la Posición Vertical de los Subtítulos",
        "remove_subtitles": "Eliminar Subtítulos",
        "animated_subtitles": "Subtítulos Animados",
        "upgrade_here": "Mejorar aquí",
        "remove_logo": " para eliminar el logo",
        "remove_podsqueeze_logo": "Eliminar el logo de podsqueeze",
        "aspect_ratio": "Relación de aspecto",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Historias, YouTube Shorts, TikTok",
        "episode_title": "Título del Episodio",
        "podcast_title": "Título del Podcast",
        "titles_font": "Fuente de los Títulos",
        "title_colors": "Colores del título del podcast/episodio",
        "video_fit": "Ajuste de Video",
        "adjust_horizontal_position": "Ajustar Posición Horizontal",
        "adjust_vertical_position": "Ajustar Posición Vertical",
        "adjust_video_zoom": "Ajustar Zoom del Video",
        "adjust_video_width": "Ajustar Ancho del Video",
        "adjust_video_height": "Ajustar Altura del Video",
        "background_color": "Color de Fondo",
        "edit_clip": "Editar Clip",
        "edit_layout": "Editar Layout",
        "choose_short": "Elegir un Short",
        "edit_audio": "Editar Audio",
        "framing": "Enmarcado",
        "background": "Fondo",
        "text_style": "Estilo de Texto",
        "music": "Música",
        "choose_chapter": "Elegir un capítulo",
        "clips_left": "Te quedan",
        "clips_left_number": "clips restantes",
        "apply_layout": "Aplicar Layout",
        "need_more_clips": "¿Necesitas más clips? Mejora tu plan aquí",
        "download_srt_file": "Descargar Archivo SRT",
        "track_selected": "Pista: ",
        "no_background_music": "No se ha seleccionado música de fondo",
        "volume": "Volumen:",
        "remove": "Eliminar",
        "track_ambient_piano": "Piano ambiental y cuerdas",
        "track_deep_meditation": "Meditación profunda",
        "track_chill_upbeat": "Para su ambiente relajado",
        "track_inspiring_ambient": "Ambiental cinematográfico inspirador",
        "track_just_relax": "Solo relájate",
        "track_movement": "Movimiento",
        "track_once_in_paris": "Una vez en París",
        "track_perfect_beauty": "Belleza perfecta",
        "track_summer_adventures": "Aventuras de verano",
        "track_sunset_groove": "Ritmo del atardecer",
        "track_tvari_cafe": "Café Tvari Tokio",
        "track_short_piano_intermezzo": "Intermedio Corto de Piano",
        "track_dramatic_background": "Música Dramática de Fondo",
        "track_dramatic_hiphop": "Jazz Hip-Hop Dramático",
        "track_emotional_orchestra": "Orquesta Emocional",
        "track_halloween_short": "Música de Halloween",
        "track_improvisation_037": "Improvisación de Jazz",
        "track_inspiration_piano": "Piano Inspiracional",
        "track_medieval_extract": "Música Medieval",
        "track_short_8": "Pista Ambient Corta",
        "track_flute": "Flauta Pacífica",
        "track_piano_guitar_duet": "Dueto de Piano y Guitarra",
        "track_intro_jazz": "Jazz de Introducción",
        "track_romantic_jazz": "Jazz Romántico",
        "recommended_for_youtube": "Recomendado para YouTube",
        "turn_into_short_clip": "Convertir este clip en un corto (<60s)",
        "browser_not_support_audio": "Tu navegador no soporta el elemento de audio.",
        "watch_tutorial": "Mira este tutorial",
        "audiogram_maker": "sobre cómo aprovechar al máximo nuestro creador de audiogramas",
        "store_audio_notice": "Aviso: Almacenamos tu audio durante 30 días.",
        "clip_maker": "sobre cómo aprovechar al máximo nuestro creador de clips",
        "split_screen_mode": "Modo de división de pantalla",
        "none": "Ninguno",
        "vertical_split": "División vertical",
        "horizontal_split": "División horizontal",
        "layers": "Usa las capas de abajo para moverlas hacia adelante o hacia atrás.",
        "screen_1_horizontal_position": "Posición Horizontal de la Pantalla 1",
        "screen_2_horizontal_position": "Posición Horizontal de la Pantalla 2",
        "track_mysterious_dark_background": "Fondo Misterioso Oscuro",
        "track_acoustic_ambient_inspiration": "Inspiración Acústica Ambiental",
        "track_aristocracy_classical": "Aristocracia Clásica",
        "track_folk_music_river_knows_my_name": "Música Folk - El Río Conoce Mi Nombre",
        "track_funy_adventure": "Aventura Divertida",
        "track_energetic_sports_rock_trailer": "Tráiler de Rock Deportivo Enérgico",
        "track_fun_upbeat_energetic_pop_rock": "Pop Rock Enérgico Divertido",
        "track_epic_emotional_inspirational": "Épico Emocional Inspirador",
        "track_inspirational_epic": "Épico Inspirador",
        "all_music": "Toda la Música",
        "energetic_music": "Energética",
        "inspirational_music": "Inspiradora",
        "ambient_music": "Ambiental",
        "chill_music": "Relajada",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Peculiar",
        "dramatic_music": "Dramática",
        "acoustic_music": "Acústica",
        "classical_music": "Clásica",
        "categories": "Categorías",
        "select_track": "Seleccionar Pista",
        "upload_music": "Subir Música",
        "my_music": "Mi Música",
        "downloading": "Descargando...",
        "download_again": "Descargar de nuevo",
        "download": "Descargar",
        "download_failed_alert": "Error al descargar el video. Por favor inténtalo de nuevo.",
        "translate_subtitles": "Traducir Subtítulos",
        "translate_to": "Traducir a",
        "select_language": "Seleccionar Idioma",
        "select_new_language": "Seleccionar nuevo idioma",
        "translating": "Traduciendo...",
        "translation_complete": "Traducción Completa",
        "error_translation": "Error durante la traducción. Por favor intenta de nuevo.",
        "original_language": "Original"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Título del Episodio"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Aún no tienes ningún contenido.",
        "userPodcastsInfo.generateContent": "Genera tu primer contenido",
        "placeholder.search_folders": "Buscar carpetas...",
        "search.no_results": "Ninguna carpeta coincide con tu búsqueda."
      },
      "landingPageModal": {
        "upload.error": "Error al subir la imagen: ",
        "upload.image.file": "Por favor, sube un archivo de imagen.",
        "upgrade.pro.message": "La personalización de la página solo está disponible para cuentas Pro y Agency",
        "upgrade.now": "Actualiza ahora",
        "upgrade.unique.landing.page": " y crea una página de destino única para el episodio.",
        "logo.recommendation": "Altura recomendada del logo 200px",
        "social.links.top.menu": "Enlaces sociales en el menú superior",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Ingresa el enlace de LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Ingresa el enlace de Facebook",
        "saving...": "Guardando...",
        "save": "Guardar",
        "saved.successfully": "¡Guardado con éxito!",
        "uploading.image": "Subiendo imagen...",
        "upload.episode.cover": "Subir portada del episodio",
        "upload.logo": "Subir logo",
        "where.listen.episode": "¿Dónde más podemos escuchar este episodio?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Ingresa el enlace de YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Ingresa el enlace de Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Ingresa el enlace de Spotify",
        "image.size.recommendation": "Tamaño recomendado 1000x1000px",
        "primary.color.label": "Color Primario",
        "header.background.color": "Color de fondo del encabezado y enlaces.",
        "landing.page.customization": "Personalización de la Página de Destino",
        "create.branded.landing.page": "Crea una hermosa página de destino de marca para compartir con tus oyentes",
        "episode.image": "Imagen del Episodio",
        "episode.links": "Enlaces del Episodio",
        "page.header": "Encabezado de la Página",
        "page.color": "Color de la Página",
        "visit.landing.page": "Visitar Página de Destino"
      },
      "page": {
        "loading.dashboard": "Cargando el panel",
        "convert.new.episode": "Convertir nuevo episodio",
        "convert.audio.or.video": "Convertir audio o video",
        "minutes.left": "Te quedan",
        "need.more.minutes": "¿Necesitas más minutos?",
        "upgrade.plan": "Actualiza tu plan aquí.",
        "your.podcasts": "Tus podcasts",
        "podsqueeze.results.page": "Página de resultados de Podsqueeze",
        "access.podsqueeze.results": "Accede a los resultados de podsqueeze para este episodio. Podrás ver todo el contenido generado"
      },
      "podcast": {
        "confirm.delete_episode": "¿Estás seguro de que quieres eliminar este episodio?",
        "alert.something_wrong": "Algo salió mal. Por favor, inténtalo de nuevo.",
        "confirm.delete_folder": "¿Estás seguro de que quieres eliminar esta carpeta?",
        "loading.episodes": "Cargando episodios...",
        "folder.empty": "Esta carpeta está vacía.",
        "content.no_content": "No hay contenido disponible.",
        "content.generate_first": "Genera tu primer podcast.",
        "button.personalize_ai": "Personalizar con IA",
        "button.edit_website": "Editar sitio web",
        "button.visit_website": "Visitar sitio web",
        "button.generate_website": "Generar sitio web",
        "placeholder.search": "Buscar...",
        "label.sort_by": "Ordenar por",
        "label.last_episodes_loaded": "Últimos episodios cargados",
        "button.load_all_episodes": "Cargar todos los episodios",
        "loading": "Cargando...",
        "add.new.episode": "Agregar nuevo episodio",
        "order.newest": "Más recientes primero",
        "order.oldest": "Más antiguos primero",
        "order.a_to_z": "A a Z",
        "order.z_to_a": "Z a A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Crear una nueva carpeta de podcast:",
        "folder.name.placeholder": "Nombre de la carpeta",
        "create.button": "Crear"
      },
      "podcastLandingModal": {
        "upload.image.error": "Por favor, sube un archivo de imagen",
        "podcast.cover.title": "Imagen de Portada del Podcast",
        "podcast.cover.upload": "Sube la imagen de portada de tu podcast aquí. Se mostrará de manera destacada en tu página de inicio.",
        "upload.image.uploading": "Subiendo imagen...",
        "podcast.cover.upload.button": "Subir Imagen de Portada",
        "podcast.cover.recommended.size": "Tamaño recomendado: 1400x1400 píxeles",
        "profile.info.title": "Información del Perfil",
        "profile.info.upload": "Agrega tu foto de perfil y nombre para personalizar tu página de inicio.",
        "profile.upload.button": "Subir Foto de Perfil",
        "profile.name.label": "Nombre del Perfil",
        "profile.name.placeholder": "Ingresa tu nombre",
        "platform.links.title": "Enlaces de la Plataforma",
        "platform.links.upload": "Agrega enlaces a tu podcast en varias plataformas.",
        "platform.links.youtube_link": "Enlace de YouTube",
        "platform.links.youtube_link.placeholder": "Ingresa el enlace de YouTube",
        "platform.links.spotify_link": "Enlace de Spotify",
        "platform.links.spotify_link.placeholder": "Ingresa el enlace de Spotify",
        "platform.links.apple_podcast_link": "Enlace de Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Ingresa el enlace de Apple Podcast",
        "platform.links.linkedin_link": "Enlace de LinkedIn",
        "platform.links.linkedin_link.placeholder": "Ingresa el enlace de LinkedIn",
        "platform.links.facebook_link": "Enlace de Facebook",
        "platform.links.facebook_link.placeholder": "Ingresa el enlace de Facebook",
        "platform.links.twitter_link": "Enlace de Twitter",
        "platform.links.twitter_link.placeholder": "Ingresa el enlace de Twitter",
        "call.to.action.title": "Llamada a la Acción",
        "call.to.action.upload": "Configura el botón de llamada a la acción para la página de inicio.",
        "call.to.action.button.text.label": "Texto del Botón",
        "call.to.action.button.text.placeholder": "Ingresa el texto del botón",
        "call.to.action.button.link.label": "Enlace del Botón",
        "call.to.action.button.link.placeholder": "Ingresa el enlace del botón",
        "color.styles.title": "Estilos de Color",
        "color.styles.upload": "Personaliza los colores de tu página de inicio.",
        "color.styles.primary.label": "Color Primario",
        "color.styles.primary.description": "Elige el color primario para tu página de inicio",
        "color.styles.secondary.label": "Color Secundario",
        "color.styles.secondary.description": "Elige el color secundario para tu página de inicio",
        "podcast.info.title": "Información del Podcast",
        "podcast.info.upload": "Edita los detalles de tu podcast.",
        "podcast.info.name.label": "Nombre del Podcast",
        "podcast.info.name.placeholder": "Ingresa el nombre del podcast",
        "podcast.info.description.label": "Descripción del Podcast",
        "podcast.info.description.placeholder": "Ingresa la descripción del podcast",
        "edit.website.title": "Editar Sitio Web",
        "generate.website.title": "Generar Sitio Web",
        "for": "para",
        "saving": "Guardando...",
        "save.changes": "Guardar Cambios",
        "generate.website": "Generar Sitio Web",
        "changes.saved.success": "¡Cambios guardados con éxito!",
        "podcast.cover.menu": "Portada del Podcast",
        "podcast.info.menu": "Información del Podcast",
        "profile.menu": "Perfil",
        "platform.links.menu": "Enlaces de la Plataforma",
        "call.to.action.menu": "Llamada a la Acción",
        "color.styles.menu": "Estilos de Color",
        "logo.menu": "Logo",
        "logo.title": "Subir Logo",
        "logo.upload": "Sube tu logo de podcast. Se mostrará en tu página de inicio.",
        "logo.upload.button": "Subir Logo",
        "platform.links.description": "Agrega enlaces a tu podcast en diferentes plataformas",
        "social.links.menu": "Enlaces de Redes Sociales",
        "social.links.title": "Enlaces de Redes Sociales",
        "social.links.description": "Agrega enlaces a tus perfiles de redes sociales",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Ingresa tu enlace de LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Ingresa tu enlace de Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Ingresa tu enlace de Twitter",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Ingresa tu enlace de Instagram",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Ingresa tu enlace de YouTube",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Ingresa tu enlace de Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Ingresa tu enlace de Apple Podcast",
        "platform.links.youtubeLink": "YouTube",
        "platform.links.youtubeLink.placeholder": "Ingresa tu enlace de YouTube",
        "view.website": "Ver Sitio Web"
      },
      "podcastMoveModal": {
        "move.episode.label": "Mover este episodio a:",
        "move.episode.instruction": "Puedes escribir un nuevo nombre para crear una carpeta.",
        "move.episode.button": "Mover",
        "move.episode.error.selectFolder": "Por favor, seleccione una carpeta para mover el episodio."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Configuración de IA para el podcast {{podcastTitle}}",
        "ai.customize.writing.style": "Personaliza tu estilo de escritura de IA",
        "ai.content.writing.preference": "¿Cómo te gustaría que Podsqueeze escribiera tu contenido?",
        "ai.voice.placeholder": "Ejemplo: Tono profesional pero amigable. Los oyentes son podcasters. Escribe en primera persona.",
        "ai.character.limit.reached": "Has alcanzado tu límite de caracteres de 50.",
        "ai.upgrade.now": "Actualiza ahora",
        "ai.fix.transcript.misspells": "Corregir errores de transcripción",
        "ai.enter.misspelled.words": "Escribe las palabras que la IA suele escribir mal en estos episodios del podcast, por ejemplo, nombres",
        "ai.enter.word.press.enter": "Ingresa una palabra y presiona Enter",
        "ai.add.word": "Agregar palabra",
        "ai.tag.limit.reached": "Has alcanzado el límite de 1 etiqueta.",
        "ai.save": "Guardar",
        "ai.save.close": "Guardar y cerrar"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Título del Episodio",
        "selectedEpisode.podcastName": "Nombre del Podcast",
        "selectedEpisode.showNotes": "Notas del Programa",
        "selectedEpisode.timestamp": "Marca de Tiempo",
        "selectedEpisode.staticTimestamp": "Marca de Tiempo Estática",
        "selectedEpisode.mentions": "Menciones",
        "selectedEpisode.newsletter": "Boletín",
        "selectedEpisode.titles": "Títulos",
        "selectedEpisode.tweeter": "Twittero",
        "selectedEpisode.shortPost": "Publicación Corta",
        "selectedEpisode.transcription": "Transcripción",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Palabras Clave",
        "selectedEpisode.quotes": "Citas",
        "selectedEpisode.longPost": "Publicación Larga",
        "selectedEpisode.bulletPoints": "Puntos Clave",
        "selectedEpisode.publicLink": "Enlace Público",
        "selectedEpisode.embeddedId": "ID Embebido",
        "selectedEpisode.episodeUrl": "URL del Episodio"
      },
      "sidebar": {
        "tools": "Herramientas",
        "find.podcast.topic.ideas": "Encuentra Ideas de Temas para Podcast",
        "podcast.thumbnail.maker": "Creador de Miniaturas de Podcast",
        "podcast.seo.optimizer": "Optimizador SEO de Podcast",
        "account": "Cuenta",
        "payment.settings": "Configuración de Pago",
        "support": "Soporte",
        "logout": "Cerrar Sesión",
        "plan": "Plan",
        "resets.in": "Se reinicia en",
        "api.access": "Acceso a la API",
        "days": "días y",
        "hours": "horas",
        "upgrade.plan": "Actualizar Plan"
      },
      "updateEmailModal": {
        "email.validation.error": "Por favor, introduce una dirección de correo electrónico válida.",
        "email.change.confirm": "¿Estás seguro de que deseas cambiar tu dirección de correo electrónico?",
        "email.change.success": "¡Tu correo electrónico ha sido cambiado con éxito!",
        "email.in.use.error": "Este correo electrónico ya está en uso. Por favor, prueba con otro.",
        "email.recent.login.error": "Antes de continuar con esta operación, por favor inicia sesión nuevamente usando la dirección de correo electrónico actual.",
        "email.invalid.error": "Dirección de correo electrónico inválida. Por favor, prueba con otra.",
        "subscription.cancel.error": "Por favor, cancela primero tu suscripción paga activa.",
        "account.delete.confirm": "¿Estás seguro de que deseas eliminar tu cuenta?\n\nEsta acción no se puede deshacer.",
        "account.delete.success": "Tu cuenta ha sido eliminada con éxito.",
        "account.delete.error": "Algo salió mal y no pudimos eliminar tu cuenta.\n\nPor favor, contacta a nuestro soporte al usuario.",
        "subscription.cancel": "Cancelar Suscripción",
        "account.delete": "Eliminar Cuenta",
        "account.delete.warning": "Eliminar tu cuenta es irreversible y borrará permanentemente todo tu contenido e información de inicio de sesión. Por favor, procede con precaución ya que esta acción no se puede deshacer.",
        "current.account.email": "Correo Electrónico Actual de la Cuenta",
        "enter.new.email": "Introduce tu nuevo correo electrónico de cuenta",
        "update": "Actualizar",
        "change.password": "Cambiar Contraseña",
        "payment.settings": "Configuración de Pago"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "títuloDelEpisodio"
      },
      "episodelist": {
        "loading.episodes": "Cargando episodios",
        "no.episodes.found": "No se encontraron episodios. Por favor, intenta de nuevo con un ID de RSS válido",
        "select.episode": "Selecciona el episodio para el que deseas crear contenido",
        "search.episodes": "Buscar episodios..."
      },
      "interfaces": {
        "user.activePlan.tier": "Nivel",
        "user.activePlan.creationDate": "Fecha de Creación",
        "user.activePlan.minutesAvailable": "Minutos Disponibles"
      },
      "loadingbar": {
        "loadingbar.magic": "Todavía estamos haciendo nuestra magia ✨",
        "loadingbar.longer": "Algunos episodios tardan un poco más... 🐌",
        "loadingbar.hardwork": "Nuestros servidores están trabajando duro 🦾"
      },
      "page": {
        "main.background": "Fondo del componente principal"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Error: Se ha denegado el acceso al micrófono o a la cámara.",
        "microphone.camera.not.found": "Error: No se encontró ningún micrófono o cámara.",
        "microphone.camera.not.readable": "Error: El micrófono o la cámara no son legibles.",
        "microphone.camera.access.error": "Error: Ocurrió un error desconocido al acceder al micrófono o a la cámara.",
        "media.not.recorded": "Error: No se ha grabado ningún medio.",
        "upload.failed": "Error: La carga ha fallado.",
        "upload.success": "Éxito: La carga se completó con éxito.",
        "upload.in.progress": "Cargando en progreso...",
        "upload.button": "Subir Grabación",
        "stop.recording": "Detener Grabación",
        "record.audio": "Grabar Audio",
        "record.audio.video": "Grabar Audio con Video",
        "record.again": "Grabar de nuevo",
        "episode.language": "Seleccionar Idioma del Episodio"
      },
      "selectBox": {
        "language.english": "Inglés",
        "language.arabic": "Árabe",
        "language.bulgarian": "Búlgaro",
        "language.catalan": "Catalán",
        "language.croatian": "Croata",
        "language.czech": "Checo",
        "language.danish": "Danés",
        "language.dutch": "Neerlandés",
        "language.finnish": "Finlandés",
        "language.french": "Francés",
        "language.german": "Alemán",
        "language.greek": "Griego",
        "language.hindi": "Hindi",
        "language.hungarian": "Húngaro",
        "language.indonesian": "Indonesio",
        "language.italian": "Italiano",
        "language.japanese": "Japonés",
        "language.korean": "Coreano",
        "language.lithuanian": "Lituano",
        "language.latvian": "Letón",
        "language.malay": "Malayo",
        "language.mandarin": "Mandarín",
        "language.norwegian": "Noruego",
        "language.polish": "Polaco",
        "language.portuguese": "Portugués",
        "language.romanian": "Rumano",
        "language.russian": "Ruso",
        "language.slovak": "Eslovaco",
        "language.slovenian": "Esloveno",
        "language.spanish": "Español",
        "language.swedish": "Sueco",
        "language.tamil": "Tamil",
        "language.turkish": "Turco",
        "language.ukrainian": "Ucraniano",
        "language.bashkir": "Bashkir",
        "language.basque": "Vasco",
        "language.belarusian": "Bielorruso",
        "language.cantonese": "Cantonés",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estonio",
        "language.galician": "Gallego",
        "language.interlingua": "Interlingua",
        "language.marathi": "Maratí",
        "language.mongolian": "Mongol",
        "language.persian": "Persa",
        "language.thai": "Tailandés",
        "language.uyghur": "Uigur",
        "language.vietnamese": "Vietnamita",
        "language.welsh": "Galés"
      },
      "selectedepisode": {
        "processing.episode": "Procesando episodio",
        "processing.time": "Normalmente toma entre 5 y 10 minutos",
        "email.notification": "Puedes cerrar esta ventana. Te enviaremos un correo electrónico una vez que esté listo. Tu contenido también estará disponible en tu panel de control.",
        "convert.another.episode": "Convertir otro episodio",
        "technical.difficulties": "¡Ups! Estamos experimentando algunas dificultades técnicas. ¡Ten la seguridad de que nuestro equipo está trabajando en ello! Por favor, intenta de nuevo más tarde.",
        "no.discount": "No te preocupes, ¡no descontaremos ningún minuto!",
        "high.demand": "Estamos experimentando una demanda más alta de lo normal, por lo que puede tardar más de lo habitual en procesar tu solicitud. ¡Pedimos disculpas por cualquier inconveniente!",
        "email.ready": "Te enviaremos un correo electrónico una vez que esté listo. También puedes acceder a tus resultados en tu panel de control.",
        "select.podcast.folder": "Selecciona la carpeta del podcast a la que pertenece este episodio, o crea una nueva escribiendo un nombre.",
        "give.voice": "Personaliza la voz de la carpeta",
        "generate.content": "Generar contenido",
        "not.enough.minutes.title": "No tienes suficientes minutos",
        "not.enough.minutes.message": "No tienes suficientes minutos para convertir este episodio. Por favor, actualiza tu plan.",
        "upgrade.plan": "Actualizar mi plan",
        "convert.shorter.episode": "Convertir episodio más corto",
        "content.ready": "¡Tu contenido está listo!",
        "ask.ai.tune": "Aún puedes pedirle a la IA que ajuste cada contenido para que se adapte mejor a tus necesidades.",
        "error.title": "Error",
        "convert.another.file": "Convertir otro archivo"
      },
      "submitfile": {
        "file.size.exceeded.free": "El tamaño del archivo excede el límite máximo de 4 GB. <p>Por favor, <a href='/pricing'><b><u>actualiza para subir archivos más grandes</u></b></a></p>",
        "file.size.exceeded.paid": "El tamaño del archivo excede el límite máximo de 10 GB. <p>Por favor, selecciona un archivo más pequeño.</p>",
        "file.upload.invalid": "Por favor, sube un archivo de audio o video",
        "upload.in.progress": "Subiendo archivo. Por favor, no cierres esta ventana.",
        "upload.button": "Subir & Generar",
        "close.button": "Cerrar",
        "upgrade.message.free": "Más subidas solo están disponibles para niveles de pago.",
        "upgrade.now.button": "Actualizar Ahora",
        "pricing.info": "a partir de $12/mes",
        "upload.file.label": "Sube un archivo de audio o video",
        "max.file.size.free": "(máx 4 gb)",
        "max.file.size.paid": "(máx 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze generará audiogramas para archivos de audio y clips cortos para archivos de video",
        "file.placeholder": "Tu archivo MP3/WAV",
        "episode.language.label": "Idioma del episodio",
        "select.folder.label": "Selecciona o crea una carpeta",
        "multiple.files.selected": "{{count}} archivos seleccionados",
        "clear.all": "Limpiar todo",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Seleccionar múltiples archivos",
        "file.upload.error": "Error al subir el archivo",
        "file.upload.success": "Archivo subido correctamente",
        "file.upload.processing": "Procesando archivo",
        "click.to.upload": "Haz clic para subir",
        "click.to.upload.multiple": "Haz clic para subir múltiples archivos",
        "enter.url": "Ingresar URL",
        "upload.file": "Subir archivo",
        "media.url.label": "URL del medio",
        "media.url.help": "Ingresa la URL de tu archivo de audio o video. Lo descargaremos y procesaremos por ti.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Nombre del episodio",
        "url.input.required": "Por favor, ingresa una URL de medio",
        "url.upload.error": "Error al subir medio desde URL. Por favor, verifica la URL e intenta nuevamente.",
        "supported.formats": "Formatos soportados",
        "uploading": "Subiendo...",
        "media.url.requirements": "La URL debe ser un enlace directo a un archivo multimedia público (no una página web)"
      },
      "submitrssid": {
        "error.selectRss": "Por favor, selecciona un RSS válido del menú desplegable",
        "label.insertRssFeed": "Inserta tu RSS Feed",
        "placeholder.insertRssFeed": "Inserta tu RSS Feed",
        "label.searchByPodcast": "Buscar por nombre de podcast en su lugar",
        "label.searchForPodcast": "Busca el nombre de tu podcast",
        "placeholder.searchForPodcast": "Buscar un podcast",
        "label.cantFindPodcast": "¿No puedes encontrar tu podcast? ",
        "label.clickHereUseRss": "Haz clic aquí para usar tu RSS feed en su lugar",
        "label.selectedPodcast": "Podcast seleccionado",
        "label.episodeLanguage": "Idioma del episodio",
        "button.seeAllEpisodes": "Ver todos los episodios",
        "select.folder.label": "Selecciona o crea una carpeta"
      },
      "submitsection": {
        "search.podcast": "Buscar tu podcast",
        "upload.audio.video": "Subir audio o video",
        "record.audio": "Grabar audio",
        "youtube.video": "Link de YouTube",
        "create.content": "¡Vamos a crear contenido para tu podcast!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Ingrese la URL del video de YouTube",
        "error.insertYouTubeUrl": "Por favor, inserte una URL de YouTube.",
        "label.insertYouTubeUrl": "Insertar URL de YouTube",
        "button.loading": "Cargando...",
        "message.downloadingFile": "Descargando archivo...",
        "error.processingFailed": "Error: no se pudo procesar el video.",
        "error.youtubeVideoNotAvailable": "Este video de YouTube no está disponible para descarga. Por favor, suba su audio o video directamente a Podsqueeze.",
        "button.submitYouTubeVideo": "Enviar video de YouTube",
        "episode.language.label": "Idioma utilizado",
        "select.folder.label": "Selecciona o crea una carpeta"
      },
      "tabs": {
        "tab.label.tab1": "Pestaña 1",
        "tab.label.tab2": "Pestaña 2",
        "tab.label.tab3": "Pestaña 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Saca el Máximo Provecho de Podsqueeze",
        "tutorial.chapter.introduction": "Introducción",
        "tutorial.chapter.bestShowNotes": "Obtén las mejores notas del programa y marcas de tiempo",
        "tutorial.chapter.blogPosts": "Utilizando publicaciones de blog y boletines",
        "tutorial.chapter.editingTranscripts": "Incorporando y editando transcripciones",
        "tutorial.chapter.personalizingAI": "Personalizando la IA y Dando Tu Propia Voz",
        "tutorial.chapter.speedingUpNotes": "Acelerando las Notas del Programa",
        "tutorial.chapter.creatingClips": "Creando clips de video e imágenes",
        "tutorial.chapter.generatingLandingPage": "Generando una página de destino",
        "tutorial.chapter.shareResults": "Comparte Resultados con Tu Equipo",
        "tutorial.closeVideoCheckbox": "Cerrar video una vez que los primeros resultados estén listos"
      },
      "uploadloadingbar": {
        "upload.loading": "Cargando..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Contáctanos",
        "contact.section.email": "Envíanos un correo a support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fundador",
        "contact.section.joao.role": "Co-fundador",
        "contact.section.image.alt.sendMessage": "Enviar mensaje",
        "contact.section.image.alt.tiago": "Co-fundador de Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fundador de Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Contáctanos",
        "contact.section.email": "Envíanos un correo a support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fundador",
        "contact.section.joao.role": "Co-fundador",
        "contact.section.image.alt.sendMessage": "Enviar mensaje",
        "contact.section.image.alt.tiago": "Co-fundador de Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fundador de Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Únete a 20,000 creadores de contenido y profesionales de podcasts que utilizan Podsqueeze",
        "content.creators": "Creadores de Contenido",
        "podcast.managers": "Gerentes de Podcasts",
        "producers.studios": "Productores y Estudios",
        "for.podcasters": "PARA PODCASTERS, GERENTES DE PODCAST Y AGENCIAS",
        "manage.content.creation": "Gestiona sin esfuerzo la creación de contenido para",
        "multiple.podcasts": "múltiples podcasts",
        "podsqueeze.description": "Podsqueeze es una herramienta poderosa para todos los profesionales del podcasting. Ya seas un podcaster en solitario, un gerente de podcast o una agencia, Podsqueeze ofrece todas las características que necesitas para optimizar tu flujo de trabajo de creación de contenido de podcast.",
        "create.podcast.folders": "Crea carpetas de podcast para mantener tus episodios organizados.",
        "share.content.page": "Comparte fácilmente tu página de contenido con clientes y equipo",
        "tune.ai.voice": "Ajusta la voz de IA para cada programa que gestionas",
        "plan.content.episodes": "Planifica el contenido para los próximos episodios con nuestro avanzado",
        "podcast.topics.finder": "buscador de temas de podcast",
        "podsqueeze.testimonial": "La capacidad de Podsqueeze para usar indicaciones para ajustar el contenido de cada podcast que gestionamos y guardarlos para episodios futuros, nos permite mantener las voces de cada programa consistentes. Esta es una característica de élite que no pudimos encontrar en ninguna otra herramienta.",
        "coo.podigy": "COO en Podigy Podcasts",
        "agenciessection.joinCreators": "Únete a 20,000 creadores de contenido y profesionales de podcasts que utilizan Podsqueeze",
        "agenciessection.contentCreators": "Creadores de Contenido",
        "agenciessection.podcastManagers": "Gerentes de Podcasts",
        "agenciessection.producersStudios": "Productores y Estudios",
        "agenciessection.forPodcasters": "PARA PODCASTERS, GERENTES DE PODCAST Y AGENCIAS",
        "agenciessection.manageContent": "Gestiona sin esfuerzo la creación de contenido para",
        "agenciessection.multiplePodcasts": "múltiples podcasts",
        "agenciessection.podsqueezeDescription": "Podsqueeze es una herramienta poderosa para todos los profesionales del podcasting. Ya seas un podcaster en solitario, un gerente de podcast o una agencia, Podsqueeze ofrece todas las características que necesitas para optimizar tu flujo de trabajo de creación de contenido de podcast.",
        "agenciessection.createPodcastFolders": "Crea carpetas de podcast para mantener tus episodios organizados.",
        "agenciessection.shareContent": "Comparte fácilmente tu página de contenido con clientes y equipo",
        "agenciessection.tuneAI": "Ajusta la voz de IA para cada programa que gestionas",
        "agenciessection.planContent": "Planifica el contenido para los próximos episodios con nuestro avanzado",
        "agenciessection.podcastTopicsFinder": "buscador de temas de podcast",
        "agenciessection.podsqueezeQuote": "La capacidad de Podsqueeze para usar indicaciones para ajustar el contenido de cada podcast que gestionamos y guardarlos para episodios futuros, nos permite mantener las voces de cada programa consistentes. Esta es una característica de élite que no pudimos encontrar en ninguna otra herramienta.",
        "agenciessection.coO": "COO en Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NUEVA FUNCIÓN",
        "seamless.editing": "Edición fluida y mejora de audio para un sonido natural, ",
        "high.quality.results": " resultados de alta calidad",
        "experience.seamless.audio.editing": "Experimenta una edición de audio fluida con algoritmos de IA avanzados para grabaciones de primera calidad. ",
        "remove.ums": "Eliminar 'ums'",
        "enhance.sound.quality": ", silencios y mejora la calidad del sonido con solo un clic.",
        "enhance.audio.now": "Mejorar audio ahora",
        "sample.audio.recorded": "Audio de muestra, grabado directamente desde el teléfono.",
        "original.recording": "Grabación original",
        "audio.after.ai.edit": "Audio después de la edición y mejora con IA",
        "experience.audio.editing": "Experimenta una edición de audio fluida con algoritmos de IA avanzados para grabaciones de primera calidad. "
      },
      "home-blogsection": {
        "more.resources.label": "MÁS RECURSOS PARA TU PODCAST",
        "learn.how.to.get.most": "Aprende a sacar el máximo provecho de",
        "your.content": "tu contenido",
        "get.most.out.of.ai.content": "Saca el Máximo Provecho del Contenido Generado por IA para Tu Podcast",
        "welcome.to.podsqueeze": "Bienvenido a Podsqueeze – la forma más sencilla de transcribir tu podcast y crear contenido cautivador...",
        "will.google.penalize.ai.content": "¿Google penalizará tu contenido generado por IA?",
        "ai.content.discussion": "La aparición del contenido generado por IA ha encendido discusiones y ha suscitado preocupaciones entre creadores de contenido, marketers y SEO...",
        "what.is.rss.feed": "¿Qué es un feed RSS para Podcasts y cómo usarlo?",
        "rss.feed.benefits": "Como podcaster, es posible que hayas oído el término 'feed RSS' antes, pero puede que no sepas exactamente qué es o cómo puede beneficiarte...",
        "visit.blog": "Visitar Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS Y AUDIOGRAMAS",
        "clipsAndAudiograms.subtitle": "Reutiliza tu podcast en clips sin esfuerzo",
        "clipsAndAudiograms.description": "Simplemente elige un capítulo de tu episodio y expórtalo como un clip o audiograma para TikTok, Instagram y YouTube Shorts. Elige una plantilla y ajusta a tu propio estilo.",
        "clipsAndAudiograms.createClips": "Crear Clips Ahora",
        "textEditor.title": "Editor basado en texto",
        "textEditor.description": "Ajusta tus clips y audiogramas directamente desde los subtítulos. Edita subtítulos y recorta tu video eliminando palabras específicas.",
        "oneClickShorts.title": "Shorts de un clic (<60s)",
        "oneClickShorts.description": "Deja que la IA se encargue de la edición por ti. Con solo presionar un botón, la IA acortará cada capítulo de tu episodio a menos de 60 segundos, listo para publicar como un YouTube Short o clips de TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Contacta a los Fundadores",
        "contact.section.email": "equipo@podsqueeze.com",
        "contact.section.tiago.role": "- Desarrollador y Podcaster",
        "contact.section.joao.role": "- Diseñador UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "AMPLIA VARIEDAD DE CONTENIDO",
        "generate.content": "Generar contenido con",
        "one.click": " ¡un clic!",
        "transcript.srt": "Transcripción y SRT",
        "transcript.description": "Obtén la transcripción completa de tu episodio de podcast, junto con un archivo SRT listo para generar subtítulos.",
        "show.notes": "Notas del programa",
        "show.notes.description": "Resume los temas principales tratados en tu episodio y hazlo más buscable",
        "timestamps": "Marcas de tiempo",
        "timestamps.description": "Crea capítulos con marcas de tiempo y guía a los oyentes a segmentos específicos de tu episodio de podcast",
        "blog.social.posts": "Publicaciones en blog y redes sociales",
        "blog.social.posts.description": "Publica sobre tu episodio de podcast en todas partes y consigue nuevos oyentes",
        "newsletter": "Boletín",
        "newsletter.description": "Mantén a tus oyentes actualizados con nuevos episodios",
        "titles.more": "Títulos y más!",
        "titles.more.description": "Genera títulos llamativos, citas, puntos clave, palabras clave y más!",
        "see.sample.content": "VER CONTENIDO DE MUESTRA",
        "wannabe.entrepreneur": "Aspirante a Emprendedor - #299 Podsqueeze acaba de alcanzar $100,000 en ingresos anuales!",
        "making.space": "Haciendo Espacio - Steve Harvey: “Más te vale seguir adelante”",
        "modern.wisdom": "Sabiduría Moderna - Erik Hoel - Una Guía Para El Misterio Fundamental De La Mente"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Línea divisoria"
      },
      "home-explanationsection": {
        "fast.accurate": "RÁPIDO Y PRECISO",
        "generate.content": "Genera contenido para tu podcast con el",
        "power.of.ai": "poder de la IA",
        "upload.image.alt": "subir imagen",
        "select.episode": "Selecciona un episodio de tu feed RSS o sube un archivo de audio/video",
        "paste.rss.feed": "Simplemente pega la URL de tu feed RSS para elegir un episodio de la lista o subir un archivo de audio o video.",
        "content.image.alt": "imagen de contenido",
        "one.click.content": "¡Obtén todo el contenido con un clic!",
        "user.friendly.interface": "Interfaz intuitiva y fácil de usar que puedes comenzar a utilizar de inmediato. Genera contenido para tu podcast con un clic.",
        "tune.image.alt": "imagen de ajuste",
        "edit.fine.tune": "Edita y ajusta cada contenido",
        "direct.edit.content": "Edita y ajusta directamente cada contenido a tu gusto con IA. Por ejemplo, puedes pedir un tono específico, discurso directo o indirecto o simplemente corregir nombres mal escritos.",
        "multiple.language.support": "Soporte para múltiples idiomas",
        "language.flags.alt": "banderas de idiomas",
        "generate.content.aria": "Generar contenido"
      },
      "home-featuressection": {
        "loading": "Cargando...",
        "transcribe.write.show.notes": "Transcribe y escribe notas del programa para tu podcast",
        "twenty.times.faster": "20x más rápido",
        "save.manual.work": "Ahorra hasta el 100% del trabajo manual. Transcribe automáticamente tu podcast con una precisión de última generación y etiquetado de hablantes, y genera notas del programa completas y publicaciones en redes sociales con tu propia voz.",
        "generate.content": "Generar Contenido",
        "transcripts": "Transcripciones",
        "full.transcript": "Obtén la transcripción completa de tus episodios de podcast y transcripciones de videos de YouTube, junto con un archivo SRT para subtítulos.",
        "show.notes": "Notas del Programa",
        "summarize.generate.show.notes": "Resume y genera notas del programa en tu propia voz, completas con marcas de tiempo, viñetas y menciones.",
        "blog.newsletter": "Blog y Boletín",
        "actionable.blog.posts": "Obtén publicaciones de blog accionables sobre tus episodios y boletines listos para enviar con los puntos clave.",
        "social.media": "Redes sociales",
        "short.posts.insights": "Obtén publicaciones cortas y conocimientos breves para difundir la palabra en redes sociales.",
        "quote": "De todas las mejores herramientas de transcripción de IA que probamos, Podsqueeze generó los resultados más útiles para Notas del Programa, Marcas de Tiempo, Títulos, Menciones, Ejemplos de Publicaciones de Blog y Citas Clave.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Co-fundador de Transistor.fm",
        "transcribe_and_write_show_notes": "Transcripciones de podcast, resumen y publicaciones en redes sociales",
        "twenty_times_faster": "20x más rápido",
        "save_manual_work": "Ahorra hasta el 100% del trabajo manual. Transcribe automáticamente tu podcast con una precisión de última generación y etiquetado de hablantes, y genera notas del programa completas y publicaciones en redes sociales con tu propia voz.",
        "generate_content": "Generar Contenido",
        "full_transcript": "Obtén la transcripción completa de tus episodios de podcast y transcripciones de videos de YouTube, junto con un archivo SRT para subtítulos.",
        "show_notes": "Notas del Programa",
        "summarize_and_generate_show_notes": "Resume y genera notas del programa en tu propia voz, completas con marcas de tiempo, viñetas y menciones.",
        "blog_and_newsletter": "Blog y Boletín",
        "actionable_blog_posts": "Obtén publicaciones de blog accionables sobre tus episodios y boletines listos para enviar con los puntos clave.",
        "social_media": "Redes sociales",
        "short_posts_and_insights": "Obtén publicaciones cortas y conocimientos breves para difundir la palabra en redes sociales.",
        "testimonial": "De todas las mejores herramientas de transcripción de IA que probamos, Podsqueeze generó los resultados más útiles para Notas del Programa, Marcas de Tiempo, Títulos, Menciones, Ejemplos de Publicaciones de Blog y Citas Clave.",
        "cofounder_transistor": "Co-fundador de Transistor.fm"
      },
      "home-page": {
        "main.background": "Color de fondo para el componente principal"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "ESCÚCHANOS EN NUESTRO PODCAST",
        "podcast.section.subtitle": "Clases magistrales de",
        "podcast.section.highlight": "podcasters experimentados",
        "podcast.section.description": "Escucha nuestro podcast, donde entrevistamos a podcasters experimentados y usuarios de Podsqueeze de todo el mundo. Les pedimos que compartan sus consejos, ideas, historias y todo lo que necesitas saber para hacer crecer tu propio podcast.",
        "podcast.link.spotify": "Escuchar en Spotify",
        "podcast.link.apple": "Escuchar en Apple Podcasts",
        "podcast.link.youtube": "Escuchar en YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Cargando..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatiza tu podcast",
        "tagline.productionPromotion": "Producción y promoción",
        "tagline.launchGrow": "Lanza y haz crecer tu podcast de audio o video sin esfuerzo, con todo lo que necesitas en un solo lugar, con la ayuda de la IA.",
        "tagline.uploadGenerate": "Genera podcast transcript, resumen, clips cortos con subtítulos y mucho más!",
        "tagline.singleClick": " Todo con un solo clic.",
        "tagline.transcripts": "Transcripciones de podcast",
        "tagline.showNotes": "Notas del programa",
        "tagline.newslettersBlogs": "Boletines y blogs",
        "tagline.socialPosts": "Publicaciones en redes sociales",
        "tagline.shortClipsAudiograms": "Clips cortos y audiogramas",
        "tagline.podcastWebsite": "Sitio web del podcast",
        "tagline.aiAudioEnhancement": "Mejora de audio con IA",
        "tagline.removeSilences": "Eliminar silencios y muletillas",
        "tagline.generateNow": "Genera ahora gratis",
        "tagline.noCreditCard": "No se requiere tarjeta de crédito",
        "testimonial.robWalling.title": "Rob Walling, Personalidad de Startups",
        "testimonial.robWalling.subtitle": "Podcast Startups para el resto de nosotros",
        "testimonial.robWalling.quote": "Las notas del programa de Podsqueeze han sido las mejores. Las usamos mucho para resúmenes y para obtener información de otros podcasts.",
        "testimonial.johnGarmet.title": "John Garmet, Director de Operaciones",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze nos ayuda a ser más eficientes y generar más contenido para nuestros clientes. Lo recomendamos encarecidamente.",
        "testimonial.davidJackson.title": "David Jackson, Coach de Podcasts",
        "testimonial.davidJackson.subtitle": "Escuela de Podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze es mi compañero de lluvia de ideas. Es la mejor manera de generar marketing para podcasts."
      },
      "home-testimonials": {
        "testimonials.title": "¿Qué dicen las personas sobre Podsqueeze?",
        "testimonials.image.alt": "Podsqueeze - Reutiliza el contenido de tu podcast usando IA | Product Hunt",
        "testimonials.heading": "¿Qué dicen las personas sobre Podsqueeze?"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Contraseña incorrecta",
        "error.userNotFound": "Usuario no encontrado",
        "error.somethingWentWrong": "Ups, algo salió mal",
        "button.sendResetEmail": "Enviar correo de restablecimiento",
        "button.login": "Iniciar sesión",
        "placeholder.email": "Dirección de correo electrónico",
        "placeholder.password": "Contraseña",
        "link.forgotPassword": "¿Olvidaste tu contraseña?",
        "link.createAccount": "Crear cuenta",
        "text.or": "O",
        "button.continueWithGoogle": "Continuar con Google",
        "text.podcastDescription": "Lanza y haz crecer tu podcast de audio o video sin esfuerzo con todo lo que necesitas en un solo lugar.",
        "feature.transcripts": "Transcripciones",
        "feature.showNotes": "Notas del programa",
        "feature.newslettersAndBlogs": "Boletines y Blogs",
        "feature.socialPosts": "Publicaciones en redes sociales",
        "feature.shortClipsAndAudiograms": "Clips cortos y Audiogramas",
        "feature.podcastWebsite": "Sitio web del podcast",
        "feature.aiAudioEnhancement": "Mejora de audio con IA",
        "feature.removeSilences": "Eliminar silencios y muletillas",
        "button.sendVerificationEmail": "Enviar correo de verificación",
        "error.emailNotVerified": "Correo electrónico no verificado, por favor verifica tu correo para continuar",
        "error.emailAlreadyVerified": "Correo electrónico ya verificado",
        "success.emailVerified": "Correo electrónico verificado",
        "text": {
          "pleaseVerifyAccount": "Por favor, Verifica tu Cuenta",
          "checkSpamFolder": "Te hemos enviado un correo de verificación. Por favor, revisa tu bandeja de entrada y la carpeta de spam.",
          "or": "O"
        },
        "button": {
          "resendVerificationEmail": "Reenviar Correo de Verificación",
          "sendVerificationEmail": "Enviar Correo de Verificación"
        },
        "success": {
          "verificationEmailSent": "¡Correo de verificación enviado exitosamente!"
        },
        "error": {
          "verificationEmailFailed": "Error al enviar el correo de verificación. Por favor, inténtalo de nuevo."
        }
      },
      "page": {
        "login.form": "FormularioDeInicioDeSesión"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Página de Afiliados de Podsqueeze",
        "affiliate.page.description": "Gana un 25% de comisión por cada venta realizada a través de tu enlace de referencia exclusivo durante un período de 15 meses. Comparte tu enlace en tu sitio web, redes sociales o con tus amigos. Unirse toma segundos. Obtén aprobación automática."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Mejor Regalo para un Podcaster",
        "bestGiftForPodcaster.description": "Descubre los mejores regalos para podcasters que mejorarán su experiencia.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Consigue más oyentes de podcast",
        "get-more-podcast-listeners.description": "Consigue más oyentes de podcast y optimiza la producción con notas de programa automáticas, clips cortos para hacer crecer tu programa en redes sociales y mucho más."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Haz Crecer la Audiencia de Tu Podcast",
        "grow_your_podcast_audience.description": "Ahorra mucho tiempo y haz crecer la audiencia de tu podcast con Podsqueeze. Genera notas completas del programa, publicaciones en redes sociales, clips cortos y más para tu podcast."
      },
      "index": {
        "home.page.title": "Notas del programa de podcast de IA, transcripciones, resúmenes y generador de clips.",
        "home.page.description": "¡Genera notas del programa, marcas de tiempo, boletines y más para tu podcast con un solo clic! Genera rápidamente contenido para tu podcast y ajústalo a tus necesidades. Registro gratuito."
      },
      "login": {
        "login.tryItNow": "¡Pruébalo ahora!",
        "login.createAccountDescription": "Crea una cuenta y comienza a generar notas de programa, marcas de tiempo, boletines y más para tu podcast con un solo clic. Genera contenido rápidamente para tu podcast y ajústalo a tus necesidades. Registro gratuito."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing para Podcasts",
        "marketing.for.podcasts.description": "Podsqueeze simplifica el marketing para podcasts con notas de programa generadas automáticamente, publicaciones en redes sociales y clips cortos para aumentar tu alcance y hacer crecer tu programa."
      },
      "media": {
        "media.page.title": "Página de Medios de Podsqueeze",
        "media.page.description": "Conoce más sobre Podsqueeze. ¡Ponte en contacto! ¡Nos encantaría colaborar!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Generador de Descripciones de Podcast",
        "podcast.description.generator.description": "Mejora el alcance y la participación de tu podcast con descripciones generadas por IA. Automatiza la redacción de tus Notas del Programa y recupera tiempo valioso."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Reutiliza tu podcast para publicaciones en redes sociales",
        "convert.podcast.episodes.to.social.media.posts": "Convierte episodios de podcast en publicaciones para redes sociales. Genera automáticamente publicaciones para LinkedIn, Twitter, Facebook y clips cortos para TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Generador de Temas de Podcast Gratuito",
        "podcast.topics.generator.description": "Nuestro generador de temas de podcast gratuito te permite encontrar las mejores ideas de temas y predice su alcance potencial en Google y YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Tu Asistente Virtual de Podcast",
        "podcast.virtual.assistant.description": "Asistente virtual de podcast basado en IA que escribe tus notas del programa y crea publicaciones en redes sociales. Optimiza la producción y el marketing de tu podcast con Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Precios",
        "pricing.description": "¡Genera notas de programa, marcas de tiempo, boletines y más para tu podcast con un solo clic! Tenemos varios niveles de precios para satisfacer tus necesidades de podcasting."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promociona tu Podcast",
        "promote.your.podcast.description": "Genera notas del programa, publicaciones en redes sociales y clips cortos para publicar y promocionar tu podcast en solo unos minutos."
      },
      "register": {
        "create.podsqueeze.account": "Crear una cuenta de Podsqueeze",
        "generate.content.podcast": "¡Genera notas del programa, marcas de tiempo, boletines y más para tu podcast con un solo clic! Genera rápidamente contenido para tu podcast y ajústalo a tus necesidades. Registro gratuito."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Reutiliza automáticamente el contenido del podcast",
        "repurpose.your.podcast.content.with.ai": "Reutiliza el contenido de tu podcast con IA. Genera automáticamente notas del programa, títulos, clips cortos para TikTok y mucho más, ¡todo con un clic!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "Optimizador SEO de Podcast GRATIS",
        "seo.optimizer.description": "Analiza y optimiza tus episodios de podcast para mejor visibilidad en motores de búsqueda con recomendaciones SEO impulsadas por IA.",
        "seo.optimizer.heading": "Optimizador SEO de Podcast",
        "seo.optimizer.headingnote": "Analiza y optimiza tus episodios de podcast para mejor visibilidad en motores de búsqueda con recomendaciones SEO impulsadas por IA.",
        "seo.optimizer.selectEpisode": "Selecciona un Episodio para Analizar",
        "seo.optimizer.results": "Resultados del Análisis SEO",
        "seo.optimizer.searchPodcastPlaceholder": "Buscar un podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Buscar episodios...",
        "seo.optimizer.analyseAnotherEpisode": "Analizar Otro Episodio",
        "seo.optimizer.findingEpisodes": "Encontrando todos los episodios...",
        "seo.optimizer.analysingEpisode": "Analizando Episodio",
        "seo.optimizer.scoreTooltip": "Puntuación:",
        "seo.optimizer.topKeywords": "Identificamos estas Palabras Clave Principales:",
        "seo.optimizer.topKeywordsnote": "Basado en el análisis de palabras clave al final de la página.",
        "seo.optimizer.optimizedContent": "Basado en palabras clave, aquí están el título y descripción optimizados:",
        "seo.optimizer.originalTitle": "Título Original",
        "seo.optimizer.optimizedTitle": "Título Optimizado",
        "seo.optimizer.originalDescription": "Descripción Original",
        "seo.optimizer.optimizedDescription": "Descripción Optimizada",
        "seo.optimizer.showMore": "Mostrar Más",
        "seo.optimizer.showLess": "Mostrar Menos",
        "seo.optimizer.keywordAnalysis": "Análisis de Palabras Clave",
        "seo.optimizer.keywordAnalysisnote": "Las puntuaciones se calculan en función del volumen de búsqueda, la competencia (cuántos otros resultados hay para la misma palabra clave) y en el caso de YouTube, el número medio de vistas por video para la misma palabra clave.",
        "seo.optimizer.seoScore": "Puntuación SEO",
        "seo.optimizer.spotifyScore": "Puntuación Spotify",
        "seo.optimizer.youtubeScore": "Puntuación YouTube",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Herramienta generadora de contenido de podcasts con IA",
        "podsqueeze.description": "¡Genera notas del programa, marcas de tiempo, boletines y más para tu podcast con un solo clic! Genera rápidamente contenido para tu podcast y ajústalo a tus necesidades. Registro gratuito."
      },
      "thumbnail-creator": {
        "title": "Generador Gratuito de Miniaturas de Podcast - Crea Miniaturas de Episodios con IA",
        "description": "Crea impresionantes miniaturas de podcast con IA. Genera arte visual profesional y llamativo para episodios que aumenta la visibilidad y atrae más oyentes a tu podcast.",
        "selectPodcast": "Selecciona Tu Podcast",
        "loadEpisodes": "Cargar Episodios",
        "selectEpisode": "Selecciona Episodio para Crear Miniatura",
        "createThumbnail": "Crear Miniatura",
        "results": "Tu Miniatura Generada",
        "download": "Descargar",
        "share": "Compartir",
        "regenerate": "Regenerar",
        "editThumbnail": "Editar Miniatura",
        "editPlaceholder": "Describe cómo te gustaría modificar esta miniatura...",
        "customPrompt": "Prompt Personalizado",
        "yourThumbnail": "Tu Miniatura",
        "createAnother": "← Crear Otra Miniatura",
        "findingEpisodes": "Buscando episodios...",
        "searchPodcastPlaceholder": "Busca tu podcast...",
        "searchingPodcasts": "Buscando podcasts...",
        "heroDescription": "Genera miniaturas de podcast impresionantes y profesionales con diseño potenciado por IA que captura la atención y aumenta la visibilidad de tus episodios.",
        "generatedWithPrompt": "Generado con el prompt:",
        "customPromptPlaceholder": "Ingresa un prompt personalizado para la generación de miniaturas...",
        "generating": "Generando...",
        "generate": "Generar",
        "modernMinimalist": "Moderno y Minimalista",
        "vibrantDynamic": "Vibrante y Dinámico",
        "professionalClean": "Profesional y Limpio",
        "generatingThumbnail": "Generando miniatura...",
        "generatingNewThumbnail": "Generando nueva miniatura...",
        "showingFirstEpisodes": "Mostrando los primeros 10 episodios. Usa la búsqueda para encontrar episodios específicos.",
        "imageUrlCopied": "¡URL de imagen copiada al portapapeles!",
        "failedToGenerate": "Error al generar la miniatura. Por favor, inténtalo de nuevo.",
        "promotionalTitle": "Genera Notas del Programa, Marcas de Tiempo, Clips Virales y Mucho Más Con Podsqueeze",
        "promotionalSubtitle": "Únete a otros 100K+ creadores y comienza a hacer crecer tu programa",
        "startNow": "Empezar ahora",
        "free": "GRATIS",
        "podcast": "PODCAST",
        "thumbnail": "MINIATURA",
        "creator": "CREADOR",
        "replaceFace": "Reemplazar Cara",
        "uploading": "Subiendo...",
        "uploadImageError": "Por favor sube un archivo de imagen.",
        "uploadFailedError": "Error al subir la imagen. Por favor, inténtalo de nuevo.",
        "uploadingImage": "Subiendo imagen...",
        "generatingNewThumbnailLoading": "Generando nueva miniatura...",
        "failedToGenerateWithFace": "Error al generar la miniatura con reemplazo de cara. Por favor, inténtalo de nuevo."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Crear nueva carpeta de podcast",
      "folder.name.placeholder": "Ingrese el nombre de la carpeta",
      "create.button": "Crear"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Cargando episodios...",
        "episodeList.noEpisodes": "No hay episodios públicos disponibles",
        "episodeList.checkBack": "Vuelve más tarde para ver nuevos episodios",
        "episodeList.title": "Episodios de este Podcast",
        "episodeList.readLess": "LEER MENOS",
        "episodeList.readMore": "LEER MÁS",
        "episodeList.coverImageAlt": "Portada de {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Comenzar",
        "alert.subscriptionRunning": "Tu suscripción actual aún está activa.\n\nPor favor, cancela tu suscripción actual antes de comprar una nueva.",
        "alert.subscriptionEnds": "Tu suscripción actual aún está activa.\n\nFinaliza el {date}",
        "alert.subscriptionCancelled": "Tu suscripción ya ha sido cancelada y finalizará el {date}",
        "button.openDashboard": "Abrir Panel",
        "button.signUp": "Registrarse",
        "button.buySubscription": "Comprar Suscripción",
        "button.cancelled": "Cancelado",
        "button.cancelSubscription": "Cancelar Suscripción",
        "button.upgradeSubscription": "Actualizar Suscripción",
        "button.loading": "Cargando",
        "upgrade.details.currentMinutes": "Esto iniciará un nuevo período de suscripción. Mantendrás todos tus minutos actuales.",
        "upgrade.details.remainingAnnual": "Este valor fue calculado en base al tiempo restante en tu suscripción anual actual."
      },
      "page": {
        "pricing.free.title": "Gratis",
        "pricing.free.subtitle": "Prueba Podsqueeze. No se requiere tarjeta de crédito.",
        "pricing.free.price.annual": "$0 Facturado Anualmente",
        "pricing.free.features.podcast_time": "30 minutos de tiempo de podcast por mes",
        "pricing.free.features.video_clips": "3 clips de video",
        "common.with_watermark": "con marca de agua",
        "pricing.free.features.quote_images": "Imágenes de citas ilimitadas",
        "pricing.free.features.file_upload": "Carga de archivos de hasta 4Gb",
        "pricing.free.features.upload": "1 carga",
        "pricing.free.features.landing_pages": "Páginas de destino de podcast",
        "pricing.free.features.audio_enhancement": "Mejora de audio",
        "common.sign_up": "Regístrate",
        "common.open_dashboard": "Abrir Panel de Control",
        "pricing.starter.title": "Inicio",
        "pricing.starter.subtitle": "Perfecto para podcasters aficionados que quieren ahorrar tiempo.",
        "pricing.starter.price.annual": "$132 Facturado Anualmente",
        "pricing.billed_annually": "Facturado Anualmente",
        "minutes.accumulate": "Minutos acumulados",
        "pricing.starter.features.podcast_time": "160 minutos de tiempo de podcast por mes",
        "pricing.starter.features.video_clips": "10 clips de video o audiogramas",
        "pricing.starter.features.quote_images": "Imágenes de citas ilimitadas",
        "pricing.starter.features.file_upload": "Carga de archivos de hasta 4Gb",
        "pricing.starter.features.unlimited_uploads": "Cargas Ilimitadas",
        "pricing.starter.features.landing_pages": "Páginas de destino de podcast",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Para profesionales que utilizan el podcasting para desarrollar y apoyar sus negocios.",
        "pricing.pro.price.annual": "$324 Facturado Anualmente",
        "pricing.pro.features.podcast_time": "320 minutos de tiempo de podcast por mes",
        "pricing.pro.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.pro.features.video_clips": "20 clips de video o audiogramas",
        "common.no_watermark": "sin marca de agua",
        "pricing.pro.features.quote_images": "Imágenes de Citas Ilimitadas",
        "pricing.pro.features.file_upload": "Carga de archivos de hasta 10Gb",
        "pricing.pro.features.unlimited_uploads": "Cargas Ilimitadas",
        "pricing.pro.features.landing_pages": "Páginas de destino de podcast",
        "common.customizable": "personalizable",
        "pricing.pro.features.audio_video_edit": "Edición Mágica de Audio y Video",
        "pricing.pro.features.everything_in_pro": "Todo en Pro",
        "pricing.agency_lite.title": "Agencia Lite",
        "pricing.agency_lite.subtitle": "Para agencias de podcast que quieren optimizar y hacer crecer su negocio.",
        "pricing.agency_lite.price.annual": "$495 Facturado Anualmente",
        "pricing.agency_lite.features.podcast_time": "600 minutos de tiempo de podcast por mes",
        "pricing.agency_lite.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_lite.features.video_clips": "40 clips de video o audiogramas",
        "pricing.agency_lite.features.quote_images": "Imágenes de citas ilimitadas",
        "pricing.agency_lite.features.file_upload": "Carga de archivos de hasta 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Cargas Ilimitadas",
        "pricing.agency_lite.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_lite.features.audio_video_edit": "Edición Mágica de Audio y Video",
        "pricing.agency_plus.title": "Agencia Plus",
        "pricing.agency_plus.subtitle": "Para agencias de podcast que quieren optimizar y hacer crecer su negocio.",
        "pricing.agency_plus.price.annual": "$1.251 Facturado Anualmente",
        "pricing.agency_plus.features.podcast_time": "2000 minutos de tiempo de podcast por mes",
        "pricing.agency_plus.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_plus.features.video_clips": "80 clips de video o audiogramas",
        "pricing.agency_plus.features.quote_images": "Imágenes de citas ilimitadas",
        "pricing.agency_plus.features.file_upload": "Carga de archivos de hasta 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Cargas Ilimitadas",
        "pricing.agency_plus.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_plus.features.audio_video_edit": "Edición Mágica de Audio y Video",
        "pricing.agency_scale.title": "Agencia Escala",
        "pricing.agency_scale.subtitle": "Para agencias de podcast que quieren optimizar y hacer crecer su negocio.",
        "pricing.agency_scale.price.annual": "$2.175 Facturado Anualmente",
        "pricing.agency_scale.features.podcast_time": "4000 minutos de tiempo de podcast por mes",
        "pricing.agency_scale.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_scale.features.video_clips": "160 clips de video o audiogramas",
        "pricing.agency_scale.features.quote_images": "Imágenes de citas ilimitadas",
        "pricing.agency_scale.features.file_upload": "Carga de archivos de hasta 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Cargas Ilimitadas",
        "pricing.agency_scale.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_scale.features.audio_video_edit": "Edición Mágica de Audio y Video",
        "pricing.header": "Para podcasters solitarios y agencias de podcast",
        "pricing.minutes_reset": "*Puedes acumular hasta 3 veces tus minutos mensuales, siempre que permanezcas en tu plan actual o actualices.*",
        "pricing.most_popular": "Más popular",
        "pricing.minutes_per_month": "Minutos por mes",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Para agencias y compañías de medios que quieren escalar su negocio.",
        "pricing.enterprise_price": "Personalizado",
        "pricing.enterprise_price_note": "Contacta con team@podsqueeze.com o reserva un demo abajo.",
        "pricing.enterprise_feature_priority_support": "Soporte prioritario",
        "pricing.enterprise_feature_team_sits": "Sesiones de equipo",
        "pricing.enterprise_personalized_team_training": "Onboarding y entrenamiento del equipo",
        "pricing.book_demo": "Reservar un demo",
        "pricing.unlimited": "Ilimitado",
        "pricing.custom": "Personalizado"
      },
      "toggle": {
        "pay.monthly": "Mensual",
        "pay.annually": "Anual",
        "discount.30percent": "30% DESCUENTO"
      },
      "upgradeModal": {
        "upgrade.success": "Tu suscripción ha sido actualizada con éxito",
        "upgrade.error": "Lo sentimos, algo salió mal. Por favor, inténtalo de nuevo más tarde",
        "upgrade.loading": "Actualizando",
        "upgrade.confirmPay": "Confirmar y Pagar",
        "upgrade.cancel": "Cancelar",
        "coupon.placeholder": "Código de Cupón",
        "coupon.apply": "Aplicar",
        "coupon.have": "Tengo un cupón",
        "upgrade.confirmation": "Estás a punto de actualizar a",
        "upgrade.price": "Vas a pagar"
      }
    },
    "register": {
      "page": {
        "register.form": "FormularioDeRegistro"
      },
      "registerForm": {
        "error.invalidCredentials": "Por favor, introduce una dirección de correo electrónico y una contraseña válidas.",
        "error.weakPassword": "Por favor, utiliza una contraseña más fuerte 💪",
        "error.emailInUse": "El usuario ya existe",
        "error.userNotFound": "Usuario no encontrado",
        "error.generic": "Ups, algo salió mal",
        "placeholder.email": "Dirección de correo electrónico",
        "placeholder.password": "Contraseña",
        "button.registering": "Registrando...",
        "button.register": "Registrarse",
        "label.newsletter": "Únete a 12,000 podcasters y suscríbete a nuestro boletín para recibir actualizaciones de productos, consejos prácticos, ebooks, sorteos y más.",
        "label.alreadyHaveAccount": "¿Ya tienes una cuenta?",
        "label.logInHere": "Inicia sesión aquí",
        "label.or": "O",
        "button.signingIn": "Iniciando sesión...",
        "button.continueWithGoogle": "Continuar con Google",
        "label.podcastDescription": "Lanza y haz crecer tu podcast de audio o video sin esfuerzo con todo lo que necesitas en un solo lugar.",
        "feature.transcripts": "Transcripciones",
        "feature.showNotes": "Notas del programa",
        "feature.newslettersBlogs": "Boletines y Blogs",
        "feature.socialPosts": "Publicaciones en redes sociales",
        "feature.shortClips": "Clips cortos y Audiogramas",
        "feature.podcastWebsite": "Sitio web del podcast",
        "feature.audioEnhancement": "Mejora de audio con IA",
        "feature.removeSilences": "Eliminar silencios y muletillas"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "texto"
      },
      "TopicFinder": {
        "competition.veryHigh": "MUY ALTO",
        "competition.high": "ALTO",
        "competition.medium": "MEDIO",
        "competition.low": "BAJO",
        "competition.veryLow": "MUY BAJO",
        "upgrade.button": "Actualizar a Pro",
        "clicks.label": "clics",
        "searches.label": "búsquedas",
        "competition.label": "competencia",
        "fetching.results": "Obteniendo Resultados",
        "table.topic": "Tema",
        "tooltip.topic": "El tema principal cubierto por tu episodio de podcast",
        "table.monthlySearches": "Búsquedas Mensuales",
        "tooltip.monthlySearches": "El rango de búsquedas mensuales en Google que podrías esperar",
        "table.competition": "Competencia",
        "tooltip.competition": "El tema o asunto principal cubierto por el podcast.",
        "table.monthlyGoogleClicks": "Clics Mensuales en Google",
        "tooltip.monthlyGoogleClicks": "Una predicción del rango de clics mensuales en Google que podrías esperar",
        "table.youtubeReach": "Alcance en Youtube",
        "tooltip.youtubeReach": "Una predicción de las vistas máximas en Youtube que podrías esperar en los primeros 6 meses, basado en el competidor promedio",
        "intro.title": "Generador de Temas de Podcast Gratuito",
        "intro.description": "Obtén ideas de temas para tu podcast que las audiencias están buscando",
        "intro.check1": "Verifica la demanda de cada idea de tema en Google",
        "intro.check2": "Descubre cuán competitiva es cada idea de tema de podcast",
        "intro.check3": "Estima los clics en Google y las vistas en YouTube que puedes obtener",
        "upgrade.message": "¡Actualiza a Pro para ver más ideas de temas!",
        "learnMore.label": "Aprende más sobre el",
        "learnMore.link": "herramienta generadora de temas de podcast gratuita",
        "newSearch.button": "Nueva Búsqueda",
        "share.button": "Compartir Esta Búsqueda",
        "form.label": "Ingresa tus nichos de podcast",
        "form.placeholder": "Marketing Digital",
        "form.submit": "Encontrar Ideas de Temas"
      },
      "page": {
        "main.background": "fondo"
      },
      "shareTopics": {
        "share.results": "Compartir Resultados",
        "share.facebook": "Compartir en Facebook",
        "share.whatsapp": "Compartir en WhatsApp",
        "share.twitter": "Compartir en Twitter",
        "share.linkedin": "Compartir en LinkedIn",
        "copy.success": "Copiado",
        "copy.link": "Copiar Enlace"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "vistas"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "No se pudo obtener la composición actual",
        "error.addImage": "Error al agregar el elemento de imagen:",
        "alert.uploadImage": "Por favor, sube un archivo de imagen.",
        "error.uploadImage": "Error al subir la imagen:",
        "alert.uploadFailed": "Error al subir la imagen. Por favor, inténtalo de nuevo.",
        "error.getDownloadURL": "Error al obtener la URL de descarga:",
        "alert.processImageFailed": "Error al procesar la imagen subida. Por favor, inténtalo de nuevo.",
        "error.addText": "Error al agregar el elemento de texto:",
        "text.settingsPlaceholder": "Las configuraciones se mostrarán cuando se seleccione el elemento",
        "text.addElement": "Agregar Elemento",
        "text.uploading": "Subiendo...",
        "button.uploadImage": "Subir Imagen",
        "text.newText": "Nuevo Texto",
        "button.addText": "Agregar Texto",
        "text.selectedElementSettings": "Configuraciones del Elemento Seleccionado"
      },
      "FontSelector": {
        "allFonts": "Todas las fuentes",
        "myFonts": "Mis fuentes",
        "uploadFont": "Subir fuente",
        "noCustomFonts": "Aún no hay fuentes personalizadas.",
        "uploadToAdd": "Sube un archivo de fuente para añadirlo a tu colección.",
        "text_outline": "Contorno de texto",
        "outline_color": "Color de contorno",
        "outline_width": "Grosor del contorno"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Ajustar",
        "imageLayoutSettings.zoom": "Zoom",
        "imageLayoutSettings.horizontalAlignment": "Alineación Horizontal",
        "imageLayoutSettings.verticalAlignment": "Alineación Vertical",
        "imageLayoutSettings.deleteElement": "Eliminar Elemento"
      },
      "TemplateBox": {
        "confirm.delete.template": "¿Está seguro de que desea eliminar esta plantilla?"
      },
      "TextSettings": {
        "error.getting_current_text": "Error al obtener el texto actual:",
        "event.delete_text_element_clicked": "Elemento de texto eliminado",
        "error.changing_text_font": "Error al cambiar la fuente del texto:",
        "event.text_font_changed": "Fuente del texto cambiada",
        "error.changing_text_size": "Error al cambiar el tamaño del texto:",
        "event.text_size_changed": "Tamaño del texto cambiado",
        "error.changing_text_color": "Error al cambiar el color del texto:",
        "event.text_color_changed": "Color del texto cambiado",
        "event.text_content_added": "Contenido de texto añadido",
        "error.adding_text_content": "Error al añadir contenido de texto:",
        "event.text_content_updated": "Contenido de texto actualizado",
        "label.text_content": "Contenido de texto",
        "label.text_font": "Fuente del texto",
        "label.text_font_weight": "Peso de la fuente",
        "label.adjust_text_size": "Ajustar tamaño del texto",
        "label.text_color": "Color del texto",
        "button.delete": "Eliminar"
      },
      "audiogramBaseTemplate": {
        "color.white": "Blanco",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "urlDelEpisodioPorDefecto",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "cuadrático-salida",
        "animation.fade": "desvanecer",
        "type.text": "texto",
        "name.podcastTitle": "TítuloDelPodcast",
        "name.snippetTitle": "TítuloDelFragmento",
        "type.image": "imagen",
        "name.audioBackgroundImage": "ImagenDeFondoDeAudio",
        "name.subtitlesText": "TextoDeSubtítulos",
        "effect.highlight": "resaltar",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "títuloDelFragmento",
        "podcast.title": "títuloDelPodcast",
        "new.episode": "NUEVO EPISODIO"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Blanco",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "urlDelEpisodioPorDefecto",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "música_de_fondo",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Por favor, sube un archivo de imagen.",
        "upload.file.loading": "Subiendo archivo. Por favor, no cierres esta ventana.",
        "upload.image.label": "Reemplazar imagen",
        "ai.prompt.label": "Ingresa un prompt para que la IA genere una imagen",
        "ai.prompt.placeholder": "Ej: Un perro corriendo en el parque...",
        "ai.processing": "Procesando...",
        "ai.create": "Crear",
        "customize.image.title": "Personalizar Imagen",
        "enter.image.url": "Ingresa la URL de la imagen",
        "or": "o"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Error al obtener las plantillas:",
        "template.savedSuccessfully": "Plantilla guardada con éxito",
        "error.savingTemplate": "Error al guardar la plantilla:",
        "loading.savedTemplates": "Cargando plantillas guardadas...",
        "no.savedTemplates": "No hay plantillas guardadas",
        "select_template": "Seleccionar Plantilla",
        "saving.template": "Guardando plantilla...",
        "template_name": "Nombre de la Plantilla",
        "enter.templateName": "Ingrese el nombre de la plantilla",
        "cancel": "Cancelar",
        "save": "Guardar",
        "default_templates": "Plantillas Predeterminadas",
        "saved_templates_count": "Plantillas Guardadas ({count})",
        "folder_templates_count": "Plantillas de Carpeta ({count})",
        "account_templates_count": "Plantillas de Cuenta ({count})",
        "save_current_template": "Guardar Plantilla Actual"
      },
      "subtitlesElement": {
        "edit.word": "Editar Palabra",
        "edit.label": "editar",
        "remove.word.subtitle": "Eliminar palabra solo del subtítulo",
        "erase.subtitle": "eliminar del subtítulo",
        "remove.word.clip": "Eliminar palabra del audio y del subtítulo",
        "remove.clip": "eliminar del clip"
      },
      "utils": {
        "video.utils.title": "Título",
        "video.utils.currentTime": "Tiempo Actual",
        "video.utils.nextTime": "Próximo Tiempo",
        "video.utils.duration": "Duración",
        "video.utils.description": "Descripción",
        "video.utils.srtSegment": "Segmento SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Tu texto de subtítulo aquí"
      }
    }
  },
  "fr": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "DEVENEZ NOTRE PARTENAIRE",
        "SHARE_PODSQUEEZE": "Partagez Podsqueeze avec votre audience",
        "AND_EARN_MONEY": "et gagnez de l'argent!",
        "LAST_UPDATED": "Dernière mise à jour : {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Devenez un Partenaire Affilié",
        "EARN_COMMISSION": "Gagnez",
        "COMMISSION": "commission",
        "ON_EVERY_SALE": "sur chaque vente effectuée via votre lien de référence exclusif pendant une période de 15 mois. Partagez votre lien sur votre site Web, vos réseaux sociaux ou avec vos amis. L'inscription prend quelques secondes.",
        "GET_AUTOMATICALLY_APPROVED": "Soyez approuvé automatiquement.",
        "JOIN_NOW": "Rejoignez maintenant",
        "HOW_IT_WORKS": "COMMENT ÇA MARCHE",
        "FREQUENTLY_ASKED_QUESTIONS": "Questions Fréquemment Posées",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Qu'est-ce qu'un Partenaire Affilié?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Un Partenaire Affilié est une personne qui fait la promotion des produits ou services d'une autre entreprise via un lien de référence unique et qui gagne une commission sur chaque vente effectuée via ce lien.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Comment puis-je devenir un Partenaire Affilié?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Devenir un Partenaire Affilié est rapide et facile, cela ne prend que quelques secondes. Pour commencer, il suffit de cliquer sur le bouton 'Rejoignez maintenant' et de vous inscrire avec votre email. Une fois inscrit, vous aurez accès à un tableau de bord convivial où vous trouverez votre lien de référence unique. Partagez ce lien avec votre famille, vos amis ou votre audience en ligne. Chaque fois que quelqu'un clique sur votre lien de référence et effectue un achat sur le site de Podsqueeze, vous gagnerez une commission de 25% sur chaque paiement pendant 15 mois! Suivez vos gains sans effort grâce à votre tableau de bord Affilié, qui vous fournit un aperçu clair de toutes les ventes que vous avez générées.",
        "HOW_CAN_I_TRACK_MY_SALES": "Comment puis-je suivre mes ventes et commissions?",
        "TRACKING_SALES_DESCRIPTION": "Utilisez notre tableau de bord du programme d'affiliation pour suivre vos ventes et commissions. Le logiciel de suivi est disponible pour les Partenaires Affiliés et les Partenaires Commerciaux.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Quand et comment vais-je recevoir mon paiement?",
        "PAYMENT_DESCRIPTION": "Vous recevrez votre paiement via PayPal tous les 30 jours. Veuillez noter qu'il y a un seuil minimum de paiement de 50 $. Dès que vous atteignez ce montant, vous pouvez vous attendre à recevoir votre paiement ponctuellement tous les 30 jours.",
        "STILL_GOT_QUESTIONS": "VOUS AVEZ ENCORE DES QUESTIONS?",
        "SEND_US_A_MESSAGE": "Envoyez-nous un message via le chat de support ou écrivez-nous à team@podsqueeze.com",
        "NOTE": "Remarque",
        "AFFILIATE_ADS_RESTRICTION": "Les affiliés ne sont pas autorisés à créer des annonces sur Google ou à participer aux enchères pour des mots clés associés à Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Conditions d'utilisation des Affiliés",
        "CAN_I_RUN_ADS": "Puis-je diffuser des annonces et des campagnes CPC sur Google pour promouvoir mon lien de référence?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Les affiliés ne sont pas autorisés à créer des annonces sur les moteurs de recherche ou à participer aux enchères pour des mots clés associés à Podsqueeze. Cette restriction permet de maintenir l'intégrité de notre stratégie publicitaire et d'assurer une cohérence dans le message de la marque. Veuillez noter que les ventes résultant de ces campagnes ne seront pas éligibles au paiement.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Comment Podsqueeze génère-t-il des titres pour votre Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Barre de navigation",
        "main.affiliateHero": "Héros d'affiliation",
        "main.footer": "Pied de page"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Ajouter Musique d'Introduction et de Fin",
        "intro.music": "Musique d'Introduction",
        "outro.music": "Musique de Fin",
        "intro.duration": "Durée d'Introduction",
        "outro.duration": "Durée de Fin",
        "intro.mode": "Mode d'Introduction",
        "outro.mode": "Mode de Fin",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "apply": "Appliquer",
        "current.intro.music": "Musique d'Introduction Actuelle",
        "current.outro.music": "Musique de Fin Actuelle",
        "change.music": "Changer la Musique",
        "choose.music": "Choisir un Fichier Musical",
        "browser.not.support.audio": "Votre navigateur ne prend pas en charge l'élément audio.",
        "save.and.apply": "Enregistrer et Appliquer",
        "no.music.selected": "Aucune musique sélectionnée",
        "delete.music": "Supprimer la musique",
        "uploading.file": "Téléchargement du fichier..."
      },
      "audioEditElements": {
        "error.processing.rss": "Nous rencontrons des difficultés à traiter certains flux RSS. Veuillez télécharger un fichier.",
        "edit.enhance.audio": "Modifier et améliorer votre enregistrement audio",
        "trial.label": "Essai",
        "audio.editing.experience": "Découvrez un montage audio fluide avec des algorithmes d'IA avancés pour des résultats naturels et de haute qualité, en un seul clic.",
        "improve.audio.quality": "Améliorer la qualité audio",
        "remove.hums.silences": "Supprimer les bourdonnements et les silences",
        "upgrade.edit.audio": "Mettez à niveau pour pouvoir éditer votre audio en un seul clic",
        "available.plans": "Disponible pour tous les plans payés",
        "upgrade.now": "Mettez à niveau maintenant",
        "audio.element.support": "Votre navigateur ne prend pas en charge l'élément audio.",
        "download.audio": "Télécharger l'audio",
        "loading.audio": "Chargement audio",
        "editing.audio": "Édition audio"
      },
      "videoEditElements": {
        "error.exporting.video": "Erreur lors de l'exportation de la vidéo",
        "download.failed": "Échec du téléchargement : {error.message}",
        "generating.video": "Génération de la vidéo",
        "error.generating.clip": "Erreur lors de la génération du clip",
        "please.retry.support": "Veuillez réessayer ou contacter notre support utilisateur",
        "browser.not.support.video": "Votre navigateur ne prend pas en charge la balise vidéo.",
        "this.might.take.minutes": "Veuillez ne pas fermer la fenêtre, cela pourrait prendre quelques minutes.",
        "exporting.video": "Exportation de votre vidéo...",
        "seamless.audio.editing": "Découvrez un montage audio sans couture avec des algorithmes d'IA avancés pour des résultats naturels et de haute qualité, en un seul clic.",
        "difficulties.processing.rss": "Nous rencontrons des difficultés à traiter certains flux RSS. Veuillez télécharger un fichier.",
        "edit.enhance.video.recording": "Modifier et améliorer votre enregistrement vidéo",
        "trial": "Essai",
        "enhance.audio.quality": "Améliorer la qualité audio",
        "enhance.audio.quality.edit": "Améliorer la qualité audio et modifier",
        "trim.filler.words.video": "Couper les mots de remplissage de la vidéo (ex : hums)",
        "trim.long.silences.video": "Couper les longs silences de la vidéo",
        "upgrade.to.edit.video": "Mettez à niveau pour pouvoir modifier votre vidéo en un seul clic",
        "available.pro.agency.plans": "Disponible pour les plans Pro et Agence",
        "upgrade.now": "Mettez à niveau maintenant",
        "download.only.audio": "Télécharger uniquement l'audio",
        "download.video": "Télécharger la vidéo",
        "please.dont.close.window": "Veuillez ne pas fermer la fenêtre",
        "export.video": "Exporter la vidéo"
      },
      "videogramBaseTemplate": {
        "media.fit": "couverture",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "média"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Autres épisodes de ce Podcast",
        "tab.shownotes": "Notes de l'émission",
        "tab.timestamps": "Repères temporels",
        "tab.blogpost": "Article de blog",
        "tab.transcript": "Transcription",
        "key.points": "Points clés"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Votre page d'atterrissage est en ligne dans notre moteur de recherche de podcasts. Partagez-la avec votre audience !",
        "landingPage.create": "Créez une belle page d'atterrissage pour cet épisode",
        "landingPage.edit": "Modifier la page",
        "landingPage.visit": "Visiter la page",
        "landingPage.delete": "Supprimer la page",
        "landingPage.createButton": "Créer une page d'atterrissage"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Gérer les liens d'épisode",
        "youtube.link": "Lien YouTube",
        "enter.youtube.link": "Entrez le lien YouTube",
        "apple.podcasts.link": "Lien Apple Podcasts",
        "enter.apple.podcasts.link": "Entrez le lien Apple Podcasts",
        "spotify.link": "Lien Spotify",
        "enter.spotify.link": "Entrez le lien Spotify",
        "saving": "Enregistrement...",
        "save": "Enregistrer",
        "social.links.updated.successfully": "Liens sociaux mis à jour avec succès !"
      },
      "affiliatesection": {
        "affiliate.section.title": "DEVENIR UN PARTENAIRE AFFILIÉ",
        "affiliate.section.subtitle": "Partagez Podsqueeze avec votre audience et",
        "affiliate.section.earn": "gagnez de l'argent !",
        "affiliate.section.commission": "Notre programme d'affiliation offre une commission de 25 % pendant 15 mois, sur chaque vente et paiement de renouvellement d'abonnement.",
        "affiliate.section.join": "Rejoindre prend quelques secondes !",
        "affiliate.section.knowMore": "En savoir plus"
      },
      "asseenon": {
        "podnews.logo": "logo de podnews",
        "transistor.logo": "logo de transistor",
        "thepodcasthost.logo": "logo de l'hôte de podcast",
        "schoolofpodcasting.logo": "logo de l'école de podcasting",
        "semrush.logo": "logo de semrush"
      },
      "assembleshownotes": {
        "episode.description": "Description de l'épisode",
        "bullet.points": "Points clés",
        "timestamps": "Horodatages",
        "links.and.mentions": "Liens et mentions",
        "extra.content": "Contenu supplémentaire",
        "assemble.show.notes": "Assemblez vos notes d'émission",
        "downloading": "Téléchargement",
        "copied": "Copié",
        "enter.placeholder": "Entrez {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Prendre une pause de la podcasting",
        "cancellation.option.no_recurrent": "Je ne veux pas d'un abonnement récurrent",
        "cancellation.option.expensive": "C'est trop cher",
        "cancellation.option.not_saving_time": "Ne me fait pas gagner assez de temps",
        "cancellation.option.dissatisfied_content": "Insatisfait de la qualité du contenu généré",
        "cancellation.option.unresponsive_support": "Support client non réactif",
        "cancellation.option.not_using": "Je n'utilise pas assez le service",
        "cancellation.option.difficulty_navigating": "Difficulté à utiliser/naviguer dans le produit",
        "cancellation.option.better_alternative": "J'ai trouvé un meilleur produit alternatif",
        "cancellation.option.other": "Autre",
        "cancellation.video.message": "70 % de nos utilisateurs arrêtent le processus d'annulation après avoir regardé cette vidéo",
        "cancellation.button.cancel": "Je veux toujours annuler",
        "cancellation.button.try_again": "Je veux essayer à nouveau",
        "cancellation.prompt.select_reason": "Veuillez nous aider à améliorer le produit en sélectionnant la raison de l'annulation de votre abonnement :",
        "cancellation.placeholder.answer": "Tapez votre réponse ici...",
        "cancellation.placeholder.specify_reason": "Veuillez spécifier votre raison d'annulation",
        "cancellation.button.next": "Suivant",
        "cancellation.button.go_back": "Retour",
        "cancellation.last_question.title": "Dernière question de notre part",
        "generate.articles.favorite.podcasts.and.vides": "Générer des articles à partir de vos podcasts favoris",
        "lose.all.accumulated.minutes": "Si vous annulez, vous perdrez tous vos minutes accumulées.",
        "keep.accumulating.minutes": "Si vous annulez, les minutes accumulées seront perdues.",
        "convert.and.repurpose.episodes": "Converti et réutilise tes épisodes plus anciens en nouveau contenu",
        "here.are.some.ideas": "Voici quelques idées pour vous aider à continuer à profiter de Podsqueeze",
        "share.your.account.with.a.friend": "Partager votre compte avec un ami qui pourrait être utile",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Voici un vidéo qui montre comment utiliser Podsqueeze au mieux",
        "cancellation.last_question.prompt": "Quels changements ou améliorations vous feraient envisager de rejoindre à nouveau notre service ?",
        "cancellation.feedback.message": "Vos retours nous aideront à nous améliorer 🙏",
        "cancellation.button.confirm": "Confirmer l'annulation",
        "cancellation.minutes.accumulated": "Vous avez",
        "cancellation.minutes.accumulated.suffix": "minutes accumulées d'une valeur de",
        "cancellation.reminder.text": "Veuillez vous rappeler :",
        "cancellation.minutes.warning": "Les minutes accumulées sont un avantage pour les abonnements actifs. En annulant votre abonnement, vos minutes seront définitivement perdues.",
        "cancellation.content.deletion.warning": "Tout votre contenu généré sera définitivement supprimé après 30 jours.",
        "cancellation.minutes.left.title": "Il vous reste encore des minutes ! Ne les gaspillez pas !",
        "cancellation.suggestion.clips": "Réutilisez d'anciens épisodes en clips pour les réseaux sociaux",
        "cancellation.suggestion.articles": "Transformez d'anciens épisodes en articles avec Podsqueeze pour bénéficier du SEO.",
        "cancellation.suggestion.linkedin": "Transformez d'anciens épisodes d'autorité en posts LinkedIn pour renforcer votre marque personnelle",
        "cancellation.suggestion.share": "Partagez votre compte Podsqueeze avec un ami pour qu'il puisse bénéficier de vos minutes inutilisées.",
        "cancellation.button.keep.subscription": "Garder Mon Abonnement",
        "cancellation.button.keep.minutes": "Garder Mes",
        "cancellation.button.keep.minutes.suffix": "de Valeur en Minutes",
        "cancellation.lifetime.before_you_go": "Avant de partir...",
        "cancellation.lifetime.title": "Que diriez-vous d'un accès à vie pour seulement 49$ ?",
        "cancellation.lifetime.subtitle": "Gardez votre compte Starter. Pas d'abonnements. Pas de renouvellements. Juste à vous — pour toujours.",
        "cancellation.lifetime.feature1": "Accès à vie à Podsqueeze pour un paiement unique de 49$",
        "cancellation.lifetime.feature2": "Utilisez-le quand vous en avez besoin, sans pression — c'est à vous pour toujours",
        "cancellation.lifetime.feature3": "Inclut toutes les fonctionnalités actuelles et futures du Plan Starter",
        "cancellation.lifetime.button_cancel": "Je veux toujours annuler",
        "cancellation.lifetime.button_deal": "Obtenir l'offre à vie",
        "cancellation.downgrade.title": "Gardez tout votre contenu pour seulement 5,99$/mois",
        "cancellation.downgrade.subtitle": "En passant au Starter vous pouvez...",
        "cancellation.downgrade.feature1": "Garder tout votre contenu généré",
        "cancellation.downgrade.feature2": "Garder vos sites web en fonctionnement",
        "cancellation.downgrade.feature3": "160 minutes et 10 clips par mois pour un travail occasionnel",
        "cancellation.billing.monthly": "Mensuel",
        "cancellation.billing.annual": "Annuel",
        "cancellation.billing.discount": "30% RÉDUCTION",
        "cancellation.plan.starter": "Plan Starter",
        "cancellation.price.monthly": "8,99$/mois",
        "cancellation.price.annual": "5,99$/mois",
        "cancellation.price.annual_billing": "facturé 71,88$ annuellement",
        "cancellation.feature.minutes": "160 mins/mois",
        "cancellation.feature.clips": "10 clips/mois",
        "cancellation.downgrade.button": "Passer au Starter et Garder le Contenu",
        "cancellation.error.payment_link": "Impossible d'obtenir le lien de paiement. Veuillez réessayer.",
        "cancellation.error.payment_service": "Erreur de connexion au service de paiement.",
        "cancellation.option.question.break": "Pouvez-vous nous en dire plus sur les raisons de votre pause ?",
        "cancellation.option.question.no_recurrent": "Pourriez-vous partager pourquoi vous préférez ne pas avoir un abonnement récurrent ?",
        "cancellation.option.question.expensive": "Quels prix ou fonctionnalités rendraient le service plus précieux pour vous ?",
        "cancellation.option.question.not_saving_time": "Qu'est-ce qui vous prend encore beaucoup de temps dans votre processus ?",
        "cancellation.option.question.dissatisfied_content": "Quels aspects du contenu vous ont déplu ?",
        "cancellation.option.question.unresponsive_support": "Pouvez-vous décrire votre expérience avec notre support client ?",
        "cancellation.option.question.not_using": "Y a-t-il quelque chose qui vous encouragerait à utiliser le service plus souvent ?",
        "cancellation.option.question.difficulty_navigating": "Quelles difficultés avez-vous rencontrées lors de l'utilisation/navigation du produit ?",
        "cancellation.option.question.better_alternative": "Quel produit alternatif avez-vous trouvé et qu'est-ce qui vous plaît à son sujet ?",
        "cancellation.option.question.other": "Veuillez spécifier votre raison d'annulation :"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Nous valorisons votre vie privée",
        "cookiebanner.cookieUsage": "Nous utilisons des cookies pour améliorer votre expérience sur notre site et analyser notre trafic. En cliquant sur accepter, vous consentez à notre utilisation des cookies.",
        "cookiebanner.privacyPolicy": "Politique de confidentialité",
        "cookiebanner.accept": "Accepter",
        "cookiebanner.decline": "Refuser"
      },
      "episodeTitleBox": {
        "loading": "Chargement...",
        "editEpisodeTitleClicked": "Titre de l'épisode modifié",
        "newEpisodeTitleStored": "Nouveau titre d'épisode enregistré"
      },
      "famewall": {
        "loading.message": "Chargement..."
      },
      "footer": {
        "footer.features": "Fonctionnalités",
        "footer.transcriptGenerator": "Générateur de Transcriptions",
        "footer.subtitlesGenerator": "Générateur de Sous-titres",
        "footer.descriptionGenerator": "Générateur de Descriptions",
        "footer.podcastSummarizer": "Générateur de Résumés de Podcast",
        "footer.titlesGenerator": "Générateur de Titres",
        "footer.bulletPointsGenerator": "Générateur de Points Clés",
        "footer.chaptersClipsGenerator": "Générateur de Chapitres & Clips",
        "footer.socialMediaPostsGenerator": "Générateur de Publications sur les Réseaux Sociaux",
        "footer.newsletterGenerator": "Générateur de Newsletters",
        "footer.blogPostGenerator": "Générateur d'Articles de Blog",
        "footer.podcastLandingPages": "Pages d'Atterrissage de Podcasts",
        "footer.podcastClipMaker": "Créateur de Clips de Podcast",
        "footer.audiogramGenerator": "Générateur d'Audiogrammes",
        "footer.aiAudioEnhancer": "Améliorateur Audio IA",
        "footer.convertYoutubeToText": "Convertir Youtube en Texte",
        "footer.youtubeVideoNoiseRemover": "Supresseur de Bruit de Vidéo Youtube",
        "footer.youtubeVideoKeyPoints": "Points Clés de Vidéo Youtube",
        "footer.freeResources": "Ressources Gratuites",
        "footer.findPodcastTopicIdeas": "Trouver des Idées de Sujets de Podcast",
        "footer.articles": "Articles",
        "footer.freeEbooks": "eBooks Gratuits",
        "footer.community": "Communauté",
        "footer.ourPodcast": "Notre Podcast",
        "footer.product": "Produit",
        "footer.giftCard": "Carte Cadeau",
        "footer.onboardingEbook": "eBook d'Intégration",
        "footer.pricing": "Tarification",
        "footer.affiliates": "Affiliés",
        "footer.media": "Médias",
        "footer.testimonials": "Témoignages",
        "footer.legal": "Légal",
        "footer.privacyPolicy": "Politique de Confidentialité",
        "footer.termsOfUse": "Conditions d'Utilisation",
        "footer.refundPolicy": "Politique de Remboursement",
        "footer.allRightsReserved": "Tous Droits Réservés."
      },
      "globalState": {
        "cookie.enabled": "Cookie activé",
        "language.default": "Langue par défaut"
      },
      "head": {
        "keywords.list": "Podsqueeze, IA, Podcasts, Génération de contenu, Transcription de podcast, Notes d'émission, Horodatages, Newsletters de podcast, Tweets, Articles de blog, Publications sur les réseaux sociaux, Titres, Rédacteur de notes d'émission"
      },
      "imageResultModal": {
        "download.image": "Télécharger l'image",
        "generating.image": "Génération de l'image",
        "ai.prompt.label": "Entrez une invite pour que l'IA génère une image",
        "ai.prompt.placeholder": "Ex : Un chien courant dans le parc...",
        "processing": "Traitement...",
        "create": "Créer",
        "text.color.label": "Couleur du texte",
        "quote.icon.color.label": "Couleur de l'icône de citation",
        "background.color.label": "Couleur de fond",
        "font.label": "Police",
        "upload.cover.image": "Télécharger l'image de couverture",
        "aspect.ratio.info": "Ratio d'aspect 1:1, taille recommandée 1200x1200",
        "upload.logo.label": "Télécharger le logo",
        "choose.file": "Choisir un fichier",
        "upload.success": "Téléchargement réussi",
        "choose.quote": "Choisir une citation",
        "select.template": "Sélectionner un modèle",
        "quote.label": "Citation",
        "enter.quote.here": "Entrez la citation ici",
        "author.label": "Auteur",
        "enter.author.name": "Entrez le nom de l'auteur",
        "podcast.name.label": "Nom du podcast",
        "enter.podcast.name": "Entrez le nom du podcast",
        "colors": "Couleurs",
        "select.font": "Sélectionner une police",
        "cover.logo.images": "Images de couverture et de logo",
        "logo.image": "Image du logo",
        "upgrade.here": "Mettre à niveau ici",
        "remove.logo": "Supprimer le logo Podsqueeze",
        "default_templates": "Modèles par défaut",
        "saved_templates_count": "Modèles sauvegardés",
        "save_current_template": "Sauvegarder le modèle actuel",
        "no_saved_templates": "Aucun modèle sauvegardé pour le moment",
        "save_template": "Sauvegarder le modèle",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "enter_template_name": "Entrez le nom du modèle",
        "reset_template": "Réinitialiser",
        "add_element": "Ajouter un Élément",
        "generate": "Générer",
        "add_image": "Ajouter une Image",
        "upload_image": "Télécharger une image",
        "or": "ou",
        "generate_with_ai": "Générer avec l'IA",
        "search_fonts": "Rechercher des polices...",
        "upload_logo": "Télécharger le logo",
        "square_image_recommended": "Image carrée recommandée",
        "opacity": "Opacité",
        "layers": "Calques",
        "no_element_selected": "Aucun élément sélectionné",
        "bold_shortcut": "Gras (Ctrl+B)",
        "italic_shortcut": "Italique (Ctrl+I)",
        "underline_shortcut": "Souligné (Ctrl+U)",
        "edit_text": "Modifier le texte",
        "tint_color": "Couleur de teinte",
        "toggle_gradient_transparent": "Basculer le dégradé en transparent",
        "rotate_gradient": "Rotation du dégradé de 45 degrés",
        "alt_background": "Arrière-plan",
        "alt_podcast_logo": "Logo du Podcast",
        "alt_custom": "Personnalisé",
        "alt_right_side": "Côté Droit",
        "alt_profile": "Profil"
      },
      "intentModal": {
        "intentModal.title": "Que voulez-vous faire avec Podsqueeze ?",
        "intentModal.sourceOption.Write_Show_Notes": "Écrire des notes d'émission",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Écrire un article de blog et une newsletter",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Créer des clips vidéo ou des audiogrammes",
        "intentModal.sourceOption.Create_Quote_Images": "Créer des images de citation",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Éditer et améliorer l'audio/vidéo",
        "intentModal.sourceOption.Transcribe": "Transcrire",
        "intentModal.sourceOption.Create_a_Website": "Créer un site web",
        "intentModal.sourceOption.All_of_the_Above": "Tout ce qui précède",
        "intentModal.sourceOption.Other": "Autre",
        "intentModal.otherPlaceholder": "Veuillez préciser",
        "intentModal.submitButton": "Soumettre et s'inscrire",
        "intentModal.skip": "Passer"
      },
      "languageSwitcher": {
        "language.en": "Anglais",
        "language.es": "Espagnol",
        "language.fr": "Français",
        "language.de": "Allemand",
        "language.it": "Italien",
        "language.pt": "Portugais",
        "language.nl": "Néerlandais",
        "language.pl": "Polonais",
        "language.ru": "Russe",
        "language.zh": "Chinois",
        "language.ja": "Japonais",
        "language.ko": "Coréen",
        "language.ar": "Arabe",
        "language.th": "Thaï",
        "language.vi": "Vietnamien"
      },
      "lazyImage": {
        "lazyImage.alt": "Description de l'image"
      },
      "metadata": {
        "meta.title": "Le titre de votre page",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Utilitaire"
      },
      "navbar": {
        "navbar.dashboard": "Tableau de bord",
        "navbar.login": "Connexion",
        "navbar.openMenu": "Ouvrir le menu principal",
        "navbar.features": "Fonctionnalités",
        "navbar.resources": "Ressources",
        "navbar.pricing": "Tarification",
        "navbar.contact": "Contact",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "Voir toutes les fonctionnalités",
        "navbar.mainFeatures": "FONCTIONNALITÉS PRINCIPALES",
        "navbar.podcastTranscription": "Générateur de transcription de podcast et vidéo",
        "navbar.transcriptionDescription": "Transcription d'une grande précision avec identification des intervenants et fichier SRT pour les sous-titres.",
        "navbar.podcastSummarizer": "Résumé de podcast",
        "navbar.summarizerDescription": "Créez des notes de spectacle complètes 20 fois plus rapidement, dans votre propre voix.",
        "navbar.podcastClipMaker": "Créateur de clips de podcast",
        "navbar.clipMakerDescription": "Générez automatiquement de courts extraits ou audiogrammes pour votre podcast.",
        "navbar.audioEnhancer": "Améliorateur audio Ai",
        "navbar.audioEnhancerDescription": "Améliorez automatiquement l'audio, supprimez les silences et les mots de remplissage.",
        "navbar.podsqueezeFeaturesWalkthrough": "GUIDE DES FONCTIONNALITÉS DE PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Articles et guides pratiques pour lancer et développer un podcast réussi.",
        "navbar.podcastTopicIdeas": "Idées de sujets de podcast",
        "navbar.topicIdeasDescription": "Découvrez des sujets de podcast que les auditeurs recherchent.",
        "navbar.actionableEbooks": "eBooks Pratiques",
        "navbar.ebooksDescription": "Téléchargez des eBooks gratuits avec des conseils pratiques pour amener votre podcast au niveau supérieur.",
        "navbar.freeThumbnailMaker": "Créateur Gratuit de Vignettes de Podcast",
        "navbar.freeThumbnailMakerDescription": "Créez des vignettes d'épisodes professionnelles et accrocheuses avec l'IA.",
        "navbar.seoOptimizer": "Optimiseur SEO",
        "navbar.seoOptimizerDescription": "Optimisez vos épisodes de podcast pour une meilleure visibilité dans les moteurs de recherche.",
        "navbar.podcastDescription": "Écoutez notre podcast, où nous interviewons des podcasters expérimentés et des utilisateurs de Podsqueeze du monde entier. Nous leur demandons de partager leurs conseils, perspectives, histoires et tout ce que vous devez savoir pour développer votre propre podcast."
      },
      "resultModal": {
        "prompt.transcript.quote": "Citation",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Notes d'émission à la première personne",
        "prompt.shownotes.replaceName": "Remplacer le nom dans les notes d'émission",
        "prompt.shownotes.friendlyTone": "Notes d'émission au ton amical",
        "prompt.shownotes.youtubeDescription": "Description YouTube des notes d'émission",
        "prompt.shownotes.engagingQuestion": "Question engageante dans les notes d'émission",
        "prompt.timestamps.formatAsChapters": "Formater les horodatages comme des chapitres avec des titres descriptifs",
        "prompt.timestamps.detailedDescriptions": "Créer des horodatages détaillés avec des descriptions de sujets et des points clés",
        "prompt.timestamps.improveSpeakerNames": "Remplacer les noms d'orateurs par des titres plus descriptifs comme 'Animateur', 'Expert' ou 'Invité'",
        "prompt.newsletter.casualTone": "Newsletter au ton décontracté",
        "prompt.newsletter.shorter": "Newsletter plus courte",
        "prompt.newsletter.contentSections": "Sections de contenu de la newsletter",
        "prompt.newsletter.changeName": "Changer le nom dans la newsletter",
        "prompt.mentions.fullURL": "Mentions d'URL complète",
        "prompt.mentions.replaceName": "Remplacer le nom dans les mentions",
        "prompt.tweets.underdogTone": "Tweets au ton d'outsider",
        "prompt.tweets.firstPerson": "Tweets à la première personne",
        "prompt.shortPost.relevantEmojis": "Emojis pertinents pour publication courte",
        "prompt.shortPost.educationalTone": "Publication courte au ton éducatif",
        "prompt.shortPost.underdogTone": "Publication courte au ton d'outsider",
        "prompt.shortPost.firstPerson": "Publication courte à la première personne",
        "prompt.titles.youtubeOptimized": "Titres optimisés pour YouTube",
        "prompt.titles.startWithHowTo": "Commencer par des titres 'Comment faire'",
        "prompt.titles.otherOptions": "Autres options pour les titres",
        "prompt.keywords.youtubeOptimized": "Mots-clés optimisés pour YouTube",
        "prompt.keywords.separateWithCommas": "Séparer les mots-clés par des virgules",
        "prompt.quotes.lorem1": "Citation Lorem ipsum 1",
        "prompt.quotes.lorem2": "Citation Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Point de liste Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Point de liste Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Publication longue à la première personne",
        "prompt.longPost.relevantEmojis": "Emojis pertinents pour publication longue",
        "prompt.longPost.changeName": "Changer le nom dans la publication longue",
        "alert.tuningInstructionsEmpty": "Les instructions d'ajustement ne peuvent pas être vides.",
        "text.timestamps.byPodsqueeze": "Horodatages par PodSqueeze",
        "button.copied": "Copié",
        "button.copy": "Copier",
        "embed.transcript": "Intégrer la transcription",
        "embed.description": "Description pour l'intégration",
        "preview.title": "Titre de prévisualisation",
        "loading.regenerating": "Régénération...",
        "placeholder.tuningInstructions": "Entrez les instructions d'ajustement...",
        "button.saveClose": "Sauvegarder et fermer",
        "button.acceptChanges": "Accepter les modifications",
        "button.discard": "Annuler",
        "button.embedTranscript": "Intégrer la transcription",
        "text.copiedToClipboard": "Copié dans le presse-papiers",
        "download.srtFile": "Télécharger le fichier SRT",
        "text.forCaptions": "pour les sous-titres",
        "tune.title": "Ajustez vos résultats",
        "tune.description": "Ajustez vos résultats avec les options suivantes.",
        "instruction.label": "Instructions:",
        "button.tuneResult": "Ajuster le résultat",
        "instruction.saveForLater": "Sauvegarder pour plus tard",
        "button.readMore": "Lire plus",
        "button.showLess": "Afficher moins",
        "customPrompt.used": "Prompt personnalisé utilisé:",
        "feedback.happyWithResults": "Êtes-vous satisfait des résultats?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Trouvez trois bonnes citations dans la transcription",
        "prompt.blog": "Rédigez un article de blog de 500 mots sur le sujet X",
        "prompt.tweets": "Rédigez trois tweets engageants à partir de la transcription",
        "transcript.autoTranscribed": "Transcrit automatiquement avec Podsqueeze",
        "alert.emptyPrompt": "Les instructions de réglage ne peuvent pas être vides",
        "embed.transcript": "Intégrer la transcription",
        "embed.description": "Intégrez une transcription de taille gérable avec une fonction de recherche sur votre site WordPress ou toute page supportant HTML.",
        "button.copied": "Copié !",
        "button.copy": "Copier",
        "preview.title": "Aperçu",
        "edit.speakers": "Modifier les noms des intervenants",
        "button.saveClose": "Enregistrer et fermer",
        "placeholder.prompt": "ex : Trouvez trois bonnes citations dans la transcription",
        "upgrade.pro": "Mettez à niveau vers Pro pour utiliser cette fonctionnalité",
        "upgrade.link": "Mettez à niveau vers Pro",
        "button.generate": "Générer",
        "feedback.happy": "Êtes-vous satisfait des résultats ?",
        "instruction": "Instruction : ",
        "generating.results": "Génération des résultats",
        "full.transcription": "Transcription complète",
        "srt.file": "& fichier SRT",
        "download.srt": "Télécharger le fichier SRT",
        "caption.subtitles": "pour les sous-titres et légendes.",
        "generate.from.transcript": "Générer à partir de la transcription avec Gpt-4o",
        "gpt.tweak.text": "Demandez au dernier GPT d'ajuster le texte selon vos préférences. Utilisez un langage naturel et n'hésitez pas à être spécifique.",
        "copied.clipboard": "Copié dans le presse-papiers",
        "transcript.public.available": "URL disponible",
        "audio.notSupported": "Votre navigateur ne prend pas en charge l'élément audio.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Ajouter le nom du podcast",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Comment avez-vous entendu parler de Podsqueeze ?",
        "sourceModal.otherPlaceholder": "Veuillez préciser",
        "sourceModal.nextButton": "Suivant",
        "sourceModal.skip": "Passer"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Nous rencontrons des difficultés à traiter certains flux RSS. Veuillez télécharger un fichier."
      },
      "squeezeResults": {
        "copiedToClipboard": "Copié dans le presse-papiers",
        "publicLink": "Public à ",
        "createLink": "Créer un lien pour partager cette page de résultats",
        "assembleShowNotes": "Assembler les notes de l'émission",
        "convertAnotherEpisode": "Convertir un autre épisode",
        "writtenContent": "Contenu écrit",
        "videoClipsAndImages": "Clips vidéo et images",
        "editAudio": "Éditer l'audio"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Voir plus et régler",
        "see.more": "Voir plus",
        "generating": "Génération en cours",
        "download.all": "Télécharger tout",
        "full.transcription": "Transcription complète",
        "transcript.benefit": "Saviez-vous qu'ajouter des transcriptions complètes à vos notes d'émission augmente le trafic et l'engagement sur votre site web ?",
        "learn.more": "En savoir plus",
        "transcript.bonus": "Vous pouvez fournir des transcriptions complètes comme bonus pour votre programme d'adhésion au podcast.",
        "show.notes": "Notes de l'émission",
        "show.notes.engagement": "Envisagez de compléter cette courte description avec d'autres éléments dans vos notes d'émission pour augmenter l'engagement et le SEO.",
        "show.notes.examples": "Trouvez de l'inspiration dans ces 17 exemples de notes d'émission de podcast pour créer les parfaites pour votre podcast.",
        "timestamps": "Horodatages",
        "timestamps.benefit": "Ajoutez ces horodatages à la description de votre épisode et cela créera automatiquement des chapitres sur Spotify et YouTube.",
        "titles": "Titres",
        "titles.engagement": "Les titres contenant des points d'interrogation et des superlatifs ont tendance à être particulièrement engageants.",
        "links.and.mentions": "Liens & Mentions",
        "mentions.resources": "Envisagez d'inclure les mentions ci-dessous dans la section ressources de vos notes d'émission.",
        "mentions.affiliate": "Vérifiez si les produits mentionnés ont des programmes d'affiliation et envisagez d'ajouter des liens d'affiliation dans vos notes d'émission.",
        "mentions.social.media": "Taguez les personnes mentionnées dans votre épisode sur les réseaux sociaux pour les encourager à partager et à interagir avec votre publication.",
        "keywords": "Mots-clés",
        "keywords.youtube": "Lorsque vous téléchargez votre épisode sur YouTube, copiez et collez simplement ces mots-clés dans la section des tags.",
        "keywords.social.media": "Réutilisez ces mots-clés pour des hashtags sur les réseaux sociaux.",
        "blog.post": "Article de blog",
        "blog.post.linkedin": "Envisagez d'utiliser ce contenu pour rédiger un post long sur LinkedIn,",
        "blog.post.share": "Partagez ce contenu dans des communautés Reddit et des groupes Facebook qui correspondent au sujet de votre podcast.",
        "newsletter": "Newsletter",
        "newsletter.content": "Certains de nos utilisateurs réutilisent ce contenu de newsletter pour créer des descriptions d'épisodes plus complètes pour les notes d'émission.",
        "linkedin.and.facebook": "LinkedIn & Facebook",
        "short.post.description": "Utilisez ces brèves publications comme descriptions lors du partage de clips vidéo et d'audiogrammes liés sur les réseaux sociaux.",
        "tweets": "Tweets",
        "quotes": "Citations",
        "bullet.points": "Points clés",
        "add.custom.result": "Ajouter un résultat personnalisé",
        "bullet.points.skimming": "Les podcasteurs listent souvent les principaux sujets d'épisode sous forme de points clés dans les notes d'émission pour un survol facile."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Voir plus et régler",
        "generating": "Génération en cours",
        "not.available.for.rss.feed": "Non disponible pour ce flux RSS",
        "regenerate.episode.upload.file": "Régénérer l'épisode et télécharger votre fichier audio/vidéo directement depuis votre ordinateur",
        "processing.difficulties": "Nous rencontrons des difficultés pour traiter certains flux RSS. Veuillez télécharger un fichier.",
        "video.clips": "Clips vidéo",
        "ai.short.clips": "Courts clips IA",
        "quote.image": "Image de citation"
      },
      "title": {
        "title.text": "votre.libellé"
      },
      "topbar": {
        "topbar.forYou": "Pour Vous",
        "topbar.joinPodcast": "Rejoignez notre prochaine rencontre virtuelle de podcasting !",
        "topbar.saveYourSpot": "Réservez Votre Place",
        "topbar.dismiss": "Ignorer"
      },
      "trackers": {
        "trackers.init": "Initialisation des trackers avec les cookies activés : ",
        "trackers.loadScripts": "Chargement des scripts de suivi..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Bienvenue dans mon application",
        "content.description": "Ceci est une application d'exemple démontrant la traduction.",
        "button.submit": "Soumettre"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI est en train d'éditer votre clip",
        "export_clip": "Exporter le clip",
        "ai_edit": "Édition IA",
        "ai_editing_clip_duration": "Cela prendra quelques secondes",
        "generating_clip": "Génération de votre clip...",
        "generating_clip_notice": "Cela peut prendre quelques minutes. Nous vous enverrons un email une fois que ce sera fait.",
        "edit_another_video": "Vous pouvez attendre ici ou éditer une autre vidéo",
        "download_video": "Télécharger la vidéo",
        "back_to_editing": "Retour à l'édition",
        "export_video_button": "Exporter le clip",
        "notice_storage": "Avis : Nous stockons votre audio pendant 30 jours. Après cette période, ce clip expirera.",
        "error_generating_clip": "Erreur lors de la génération du clip",
        "error_user_support": "Veuillez réessayer ou contacter notre support utilisateur",
        "select_template": "Sélectionner un modèle",
        "add_30s_prev": "30s du chapitre précédent",
        "add_30s_next": "30s du chapitre suivant",
        "undo": "Annuler",
        "subtitles_font": "Police des sous-titres",
        "subtitles_color": "Couleur des sous-titres",
        "subtitles_box_color": "Couleur de l'animation",
        "adjust_podcast_title_position": "Ajuster la position verticale du titre du podcast",
        "adjust_subtitles_size": "Ajuster la taille des sous-titres",
        "adjust_subtitles_vertical_position": "Ajuster la position verticale des sous-titres",
        "remove_subtitles": "Supprimer les sous-titres",
        "animated_subtitles": "Sous-titres animés",
        "upgrade_here": "Améliorez ici",
        "remove_logo": " pour supprimer le logo",
        "remove_podsqueeze_logo": "Supprimer le logo podsqueeze",
        "aspect_ratio": "Rapport d'aspect",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Fil Instagram",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Titre de l'épisode",
        "podcast_title": "Titre du podcast",
        "titles_font": "Police des titres",
        "title_colors": "Couleurs des titres de podcast/épisode",
        "video_fit": "Ajustement de la vidéo",
        "adjust_horizontal_position": "Ajuster la position horizontale",
        "adjust_vertical_position": "Ajuster la position verticale",
        "adjust_video_zoom": "Ajuster le zoom de la vidéo",
        "adjust_video_width": "Ajuster la largeur de la vidéo",
        "adjust_video_height": "Ajuster la hauteur de la vidéo",
        "background_color": "Couleur de fond",
        "edit_clip": "Éditer le clip",
        "edit_layout": "Modifier le layout",
        "choose_short": "Choisir un court",
        "edit_audio": "Éditer l'audio",
        "framing": "Mise en cadre",
        "background": "Arrière-plan",
        "text_style": "Style de texte",
        "music": "Musique",
        "choose_chapter": "Choisir un chapitre",
        "clips_left": "Il vous reste",
        "clips_left_number": "clips",
        "apply_layout": "Appliquer le layout",
        "need_more_clips": "Besoin de plus de clips ? Améliorez votre plan ici",
        "download_srt_file": "Télécharger le fichier SRT",
        "track_selected": "Piste : ",
        "no_background_music": "Aucune musique de fond sélectionnée",
        "volume": "Volume :",
        "remove": "Supprimer",
        "track_ambient_piano": "Piano ambiant et cordes",
        "track_deep_meditation": "Méditation profonde",
        "track_chill_upbeat": "Pour son ambiance chill upbeat",
        "track_inspiring_ambient": "Ambiance cinématographique inspirante",
        "track_just_relax": "Juste se détendre",
        "track_movement": "Mouvement",
        "track_once_in_paris": "Une fois à Paris",
        "track_perfect_beauty": "Beauté parfaite",
        "track_summer_adventures": "Aventures d'été",
        "track_sunset_groove": "Groove du coucher de soleil",
        "track_tvari_cafe": "Café Tvari Tokyo",
        "track_short_piano_intermezzo": "Court Intermezzo de Piano",
        "track_dramatic_background": "Musique de Fond Dramatique",
        "track_dramatic_hiphop": "Jazz Hip-Hop Dramatique",
        "track_emotional_orchestra": "Orchestre Émotionnel",
        "track_halloween_short": "Musique d'Halloween",
        "track_improvisation_037": "Improvisation Jazz",
        "track_inspiration_piano": "Piano Inspirant",
        "track_medieval_extract": "Musique Médiévale",
        "track_short_8": "Piste Ambiante Courte",
        "track_flute": "Flûte Paisible",
        "track_piano_guitar_duet": "Duo Piano-Guitare",
        "track_intro_jazz": "Jazz d'Introduction",
        "track_romantic_jazz": "Jazz Romantique",
        "recommended_for_youtube": "Recommandé pour YouTube",
        "turn_into_short_clip": "Transformer ce clip en un court (<60s)",
        "browser_not_support_audio": "Votre navigateur ne prend pas en charge l'élément audio.",
        "watch_tutorial": "Regardez ce tutoriel",
        "audiogram_maker": "sur comment tirer le meilleur parti de notre créateur d'audiogrammes",
        "store_audio_notice": "Avis : Nous stockons votre audio pendant 30 jours.",
        "clip_maker": "sur comment tirer le meilleur parti de notre créateur de clips",
        "split_screen_mode": "Mode de division d'écran",
        "none": "Aucun",
        "vertical_split": "Division verticale",
        "horizontal_split": "Division horizontale",
        "layers": "Utilisez les couches ci-dessous pour les déplacer vers l'avant ou l'arrière.",
        "screen_1_horizontal_position": "Position horizontale de l'écran 1",
        "screen_2_horizontal_position": "Position horizontale de l'écran 2",
        "track_mysterious_dark_background": "Arrière-plan sombre mystérieux",
        "track_acoustic_ambient_inspiration": "Inspiration acoustique ambiante",
        "track_aristocracy_classical": "Aristocratie classique",
        "track_folk_music_river_knows_my_name": "Musique folk - La rivière connaît mon nom",
        "track_funy_adventure": "Aventure amusante",
        "track_energetic_sports_rock_trailer": "Bande-annonce Rock Sportif Énergique",
        "track_fun_upbeat_energetic_pop_rock": "Pop Rock Énergique Amusant",
        "track_epic_emotional_inspirational": "Épique Émotionnel Inspirant",
        "track_inspirational_epic": "Épique Inspirant",
        "all_music": "Toute la musique",
        "energetic_music": "Énergique",
        "inspirational_music": "Inspirante",
        "ambient_music": "Ambiante",
        "chill_music": "Relaxante",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Décalée",
        "dramatic_music": "Dramatique",
        "acoustic_music": "Acoustique",
        "classical_music": "Classique",
        "categories": "Catégories",
        "select_track": "Sélectionner la piste",
        "upload_music": "Télécharger de la musique",
        "my_music": "Ma Musique",
        "downloading": "Téléchargement...",
        "download_again": "Télécharger à nouveau",
        "download": "Télécharger",
        "download_failed_alert": "Échec du téléchargement de la vidéo. Veuillez réessayer.",
        "translate_subtitles": "Traduire les Sous-titres",
        "translate_to": "Traduire vers",
        "select_language": "Sélectionner la Langue",
        "select_new_language": "Sélectionner une nouvelle langue",
        "translating": "Traduction en cours...",
        "translation_complete": "Traduction Terminée",
        "error_translation": "Erreur lors de la traduction. Veuillez réessayer.",
        "original_language": "Original"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Titre de l'épisode"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Vous n'avez pas encore de contenu.",
        "userPodcastsInfo.generateContent": "Générez votre premier contenu",
        "placeholder.search_folders": "Rechercher des dossiers...",
        "search.no_results": "Aucun dossier ne correspond à votre recherche."
      },
      "landingPageModal": {
        "upload.error": "Échec du téléchargement de l'image : ",
        "upload.image.file": "Veuillez télécharger un fichier image.",
        "upgrade.pro.message": "La personnalisation de la page n'est disponible que pour les comptes Pro et Agence",
        "upgrade.now": "Mettre à niveau maintenant",
        "upgrade.unique.landing.page": " et créer une page de destination d'épisode unique.",
        "logo.recommendation": "Hauteur de logo recommandée 200px",
        "social.links.top.menu": "Liens sociaux dans le menu supérieur",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Entrez le lien LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Entrez le lien Facebook",
        "saving...": "Enregistrement...",
        "save": "Enregistrer",
        "saved.successfully": "Enregistré avec succès !",
        "uploading.image": "Téléchargement de l'image...",
        "upload.episode.cover": "Télécharger la couverture de l'épisode",
        "upload.logo": "Télécharger le logo",
        "where.listen.episode": "Où d'autre pouvons-nous écouter cet épisode ?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Entrez le lien YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Entrez le lien Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Entrez le lien Spotify",
        "image.size.recommendation": "Taille recommandée 1000x1000px",
        "primary.color.label": "Couleur principale",
        "header.background.color": "Couleur de fond de l'en-tête et des liens.",
        "landing.page.customization": "Personnalisation de la page de destination",
        "create.branded.landing.page": "Créez une belle page de destination de marque à partager avec vos auditeurs",
        "episode.image": "Image de l'épisode",
        "episode.links": "Liens de l'épisode",
        "page.header": "En-tête de la page",
        "page.color": "Couleur de la page",
        "visit.landing.page": "Visiter la page de destination"
      },
      "page": {
        "loading.dashboard": "Chargement du tableau de bord",
        "convert.new.episode": "Convertir un nouvel épisode",
        "convert.audio.or.video": "Convertir audio ou vidéo",
        "minutes.left": "Il vous reste",
        "need.more.minutes": "Besoin de plus de minutes ?",
        "upgrade.plan": "Mettez à niveau votre plan ici.",
        "your.podcasts": "Vos podcasts",
        "podsqueeze.results.page": "Page des résultats Podsqueeze",
        "access.podsqueeze.results": "Accédez aux résultats Podsqueeze pour cet épisode. Vous pourrez voir tout le contenu généré"
      },
      "podcast": {
        "confirm.delete_episode": "Êtes-vous sûr de vouloir supprimer cet épisode ?",
        "alert.something_wrong": "Quelque chose a mal tourné. Veuillez réessayer.",
        "confirm.delete_folder": "Êtes-vous sûr de vouloir supprimer ce dossier ?",
        "loading.episodes": "Chargement des épisodes...",
        "folder.empty": "Ce dossier est vide.",
        "content.no_content": "Aucun contenu disponible.",
        "content.generate_first": "Générez votre premier podcast.",
        "button.personalize_ai": "Personnaliser avec l'IA",
        "button.edit_website": "Modifier le site Web",
        "button.visit_website": "Visiter le site Web",
        "button.generate_website": "Générer le site Web",
        "placeholder.search": "Rechercher...",
        "label.sort_by": "Trier par",
        "label.last_episodes_loaded": "Derniers épisodes chargés",
        "button.load_all_episodes": "Charger tous les épisodes",
        "loading": "Chargement...",
        "add.new.episode": "Ajouter un nouvel épisode",
        "order.newest": "Plus récents d'abord",
        "order.oldest": "Plus anciens d'abord",
        "order.a_to_z": "A à Z",
        "order.z_to_a": "Z à A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Créer un nouveau dossier de podcast :",
        "folder.name.placeholder": "Nom du dossier",
        "create.button": "Créer"
      },
      "podcastLandingModal": {
        "upload.image.error": "Veuillez télécharger un fichier image",
        "podcast.cover.title": "Image de couverture du podcast",
        "podcast.cover.upload": "Téléchargez votre image de couverture de podcast ici. Cela sera affiché en évidence sur votre page d'accueil.",
        "upload.image.uploading": "Téléchargement de l'image...",
        "podcast.cover.upload.button": "Télécharger l'image de couverture",
        "podcast.cover.recommended.size": "Taille recommandée : 1400x1400 pixels",
        "profile.info.title": "Informations sur le profil",
        "profile.info.upload": "Ajoutez votre photo de profil et votre nom pour personnaliser votre page d'accueil.",
        "profile.upload.button": "Télécharger la photo de profil",
        "profile.name.label": "Nom du profil",
        "profile.name.placeholder": "Entrez votre nom",
        "platform.links.title": "Liens de la plateforme",
        "platform.links.upload": "Ajoutez des liens vers votre podcast sur diverses plateformes.",
        "platform.links.youtube_link": "Lien YouTube",
        "platform.links.youtube_link.placeholder": "Entrez le lien YouTube",
        "platform.links.spotify_link": "Lien Spotify",
        "platform.links.spotify_link.placeholder": "Entrez le lien Spotify",
        "platform.links.apple_podcast_link": "Lien Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Entrez le lien Apple Podcast",
        "platform.links.linkedin_link": "Lien LinkedIn",
        "platform.links.linkedin_link.placeholder": "Entrez le lien LinkedIn",
        "platform.links.facebook_link": "Lien Facebook",
        "platform.links.facebook_link.placeholder": "Entrez le lien Facebook",
        "platform.links.twitter_link": "Lien Twitter",
        "platform.links.twitter_link.placeholder": "Entrez le lien Twitter",
        "call.to.action.title": "Appel à l'action",
        "call.to.action.upload": "Configurez votre bouton d'appel à l'action pour la page d'accueil.",
        "call.to.action.button.text.label": "Texte du bouton",
        "call.to.action.button.text.placeholder": "Entrez le texte du bouton",
        "call.to.action.button.link.label": "Lien du bouton",
        "call.to.action.button.link.placeholder": "Entrez le lien du bouton",
        "color.styles.title": "Styles de couleur",
        "color.styles.upload": "Personnalisez les couleurs de votre page d'accueil.",
        "color.styles.primary.label": "Couleur principale",
        "color.styles.primary.description": "Choisissez la couleur principale pour votre page d'accueil",
        "color.styles.secondary.label": "Couleur secondaire",
        "color.styles.secondary.description": "Choisissez la couleur secondaire pour votre page d'accueil",
        "podcast.info.title": "Informations sur le podcast",
        "podcast.info.upload": "Modifiez les détails de votre podcast.",
        "podcast.info.name.label": "Nom du podcast",
        "podcast.info.name.placeholder": "Entrez le nom du podcast",
        "podcast.info.description.label": "Description du podcast",
        "podcast.info.description.placeholder": "Entrez la description du podcast",
        "edit.website.title": "Modifier le site Web",
        "generate.website.title": "Générer le site Web",
        "for": "pour",
        "saving": "Enregistrement...",
        "save.changes": "Enregistrer les modifications",
        "generate.website": "Générer le site Web",
        "changes.saved.success": "Modifications enregistrées avec succès !",
        "podcast.cover.menu": "Couverture du podcast",
        "podcast.info.menu": "Infos sur le podcast",
        "profile.menu": "Profil",
        "platform.links.menu": "Liens de la plateforme",
        "call.to.action.menu": "Appel à l'action",
        "color.styles.menu": "Styles de couleur",
        "logo.menu": "Logo",
        "logo.title": "Télécharger le logo",
        "logo.upload": "Téléchargez votre logo de podcast. Il sera affiché sur votre page d'accueil.",
        "logo.upload.button": "Télécharger le logo",
        "platform.links.description": "Ajoutez des liens à votre podcast sur différentes plateformes",
        "social.links.menu": "Liens de réseaux sociaux",
        "social.links.title": "Liens de réseaux sociaux",
        "social.links.description": "Ajoutez des liens à vos profils de réseaux sociaux",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Entrez votre lien LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Entrez votre lien Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Entrez votre lien Twitter",
        "platform.links.youtubeLink": "YouTube",
        "platform.links.youtubeLink.placeholder": "Entrez votre lien YouTube",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Entrez votre lien Instagram",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Entrez votre lien Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Entrez votre lien Apple Podcast",
        "view.website": "Voir le site Web"
      },
      "podcastMoveModal": {
        "move.episode.label": "Déplacer cet épisode vers :",
        "move.episode.instruction": "Vous pouvez taper un nouveau nom pour créer un dossier.",
        "move.episode.button": "Déplacer",
        "move.episode.error.selectFolder": "Veuillez sélectionner un dossier pour déplacer l'épisode."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Paramètres de l'IA pour le podcast {{podcastTitle}}",
        "ai.customize.writing.style": "Personnalisez le style d'écriture de votre IA",
        "ai.content.writing.preference": "Comment souhaitez-vous que Podsqueeze rédige votre contenu ?",
        "ai.voice.placeholder": "Exemple : Ton professionnel mais amical. Les auditeurs sont des podcasteurs. Écrivez à la première personne.",
        "ai.character.limit.reached": "Vous avez atteint votre limite de caractères de 50.",
        "ai.upgrade.now": "Mettez à niveau maintenant",
        "ai.fix.transcript.misspells": "Corriger les fautes de transcription",
        "ai.enter.misspelled.words": "Écrivez les mots que l'IA orthographie souvent mal dans ces épisodes de podcast, par ex. des noms",
        "ai.enter.word.press.enter": "Entrez un mot et appuyez sur Entrée",
        "ai.add.word": "Ajouter un mot",
        "ai.tag.limit.reached": "Limite de 1 tag atteinte.",
        "ai.save": "Enregistrer",
        "ai.save.close": "Enregistrer et fermer"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Titre de l'épisode",
        "selectedEpisode.podcastName": "Nom du podcast",
        "selectedEpisode.showNotes": "Notes de l'émission",
        "selectedEpisode.timestamp": "Horodatage",
        "selectedEpisode.staticTimestamp": "Horodatage statique",
        "selectedEpisode.mentions": "Mentions",
        "selectedEpisode.newsletter": "Bulletin d'information",
        "selectedEpisode.titles": "Titres",
        "selectedEpisode.tweeter": "Tweeter",
        "selectedEpisode.shortPost": "Post court",
        "selectedEpisode.transcription": "Transcription",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Mots-clés",
        "selectedEpisode.quotes": "Citations",
        "selectedEpisode.longPost": "Post long",
        "selectedEpisode.bulletPoints": "Points clés",
        "selectedEpisode.publicLink": "Lien public",
        "selectedEpisode.embeddedId": "ID intégré",
        "selectedEpisode.episodeUrl": "URL de l'épisode"
      },
      "sidebar": {
        "tools": "Outils",
        "find.podcast.topic.ideas": "Trouvez des idées de sujets de podcast",
        "podcast.thumbnail.maker": "Créateur de miniatures de podcast",
        "podcast.seo.optimizer": "Optimiseur SEO de podcast",
        "account": "Compte",
        "payment.settings": "Paramètres de paiement",
        "support": "Support",
        "logout": "Déconnexion",
        "plan": "Plan",
        "resets.in": "Réinitialisations dans",
        "api.access": "Accès à l'API",
        "days": "jours et",
        "hours": "heures",
        "upgrade.plan": "Mettre à niveau le plan"
      },
      "updateEmailModal": {
        "email.validation.error": "Veuillez entrer une adresse e-mail valide.",
        "email.change.confirm": "Êtes-vous sûr de vouloir changer votre adresse e-mail ?",
        "email.change.success": "Votre e-mail a été changé avec succès !",
        "email.in.use.error": "Cette adresse e-mail est déjà utilisée. Veuillez en essayer une autre.",
        "email.recent.login.error": "Avant de continuer cette opération, veuillez vous reconnecter en utilisant l'adresse e-mail actuelle.",
        "email.invalid.error": "Adresse e-mail invalide. Veuillez en essayer une autre.",
        "subscription.cancel.error": "Veuillez d'abord annuler votre abonnement payant actif.",
        "account.delete.confirm": "Êtes-vous sûr de vouloir supprimer votre compte ?\n\nCette action ne peut pas être annulée.",
        "account.delete.success": "Votre compte a été supprimé avec succès.",
        "account.delete.error": "Une erreur s'est produite et nous n'avons pas pu supprimer votre compte.\n\nVeuillez contacter notre support utilisateur.",
        "subscription.cancel": "Annuler l'abonnement",
        "account.delete": "Supprimer le compte",
        "account.delete.warning": "La suppression de votre compte est irréversible et effacera définitivement tout votre contenu et vos informations de connexion. Veuillez procéder avec prudence, car cette action ne peut pas être annulée.",
        "current.account.email": "E-mail du compte actuel",
        "enter.new.email": "Entrez votre nouvelle adresse e-mail de compte",
        "update": "Mettre à jour",
        "change.password": "Changer le mot de passe",
        "payment.settings": "Paramètres de paiement"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "titreDeLépisode"
      },
      "episodelist": {
        "loading.episodes": "Chargement des épisodes",
        "no.episodes.found": "Aucun épisode trouvé. Veuillez réessayer avec un identifiant RSS valide",
        "select.episode": "Sélectionnez l'épisode pour lequel vous souhaitez créer du contenu",
        "search.episodes": "Rechercher des épisodes..."
      },
      "interfaces": {
        "user.activePlan.tier": "Niveau",
        "user.activePlan.creationDate": "Date de création",
        "user.activePlan.minutesAvailable": "Minutes disponibles"
      },
      "loadingbar": {
        "loadingbar.magic": "Nous continuons à faire notre magie ✨",
        "loadingbar.longer": "Certains épisodes prennent un peu plus de temps... 🐌",
        "loadingbar.hardwork": "Nos serveurs travaillent dur 🦾"
      },
      "page": {
        "main.background": "Arrière-plan du composant principal"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Erreur : L'accès au microphone ou à la caméra a été refusé.",
        "microphone.camera.not.found": "Erreur : Aucun microphone ou caméra trouvé.",
        "microphone.camera.not.readable": "Erreur : Le microphone ou la caméra n'est pas lisible.",
        "microphone.camera.access.error": "Erreur : Une erreur inconnue s'est produite lors de l'accès au microphone ou à la caméra.",
        "media.not.recorded": "Erreur : Aucun média n'a été enregistré.",
        "upload.failed": "Erreur : Échec du téléchargement.",
        "upload.success": "Succès : Téléchargement terminé avec succès.",
        "upload.in.progress": "Téléchargement en cours...",
        "upload.button": "Télécharger l'enregistrement",
        "stop.recording": "Arrêter l'enregistrement",
        "record.audio": "Enregistrer l'audio",
        "record.audio.video": "Enregistrer l'audio avec vidéo",
        "record.again": "Enregistrer à nouveau",
        "episode.language": "Sélectionner la langue de l'épisode"
      },
      "selectBox": {
        "language.english": "Anglais",
        "language.arabic": "Arabe",
        "language.bulgarian": "Bulgare",
        "language.catalan": "Catalan",
        "language.croatian": "Croate",
        "language.czech": "Tchèque",
        "language.danish": "Danois",
        "language.dutch": "Néerlandais",
        "language.finnish": "Finnois",
        "language.french": "Français",
        "language.german": "Allemand",
        "language.greek": "Grec",
        "language.hindi": "Hindi",
        "language.hungarian": "Hongrois",
        "language.indonesian": "Indonésien",
        "language.italian": "Italien",
        "language.japanese": "Japonais",
        "language.korean": "Coréen",
        "language.lithuanian": "Lituanien",
        "language.latvian": "Letton",
        "language.malay": "Malais",
        "language.mandarin": "Mandarin",
        "language.norwegian": "Norvégien",
        "language.polish": "Polonais",
        "language.portuguese": "Portugais",
        "language.romanian": "Roumain",
        "language.russian": "Russe",
        "language.slovak": "Slovaque",
        "language.slovenian": "Slovène",
        "language.spanish": "Espagnol",
        "language.swedish": "Suédois",
        "language.tamil": "Tamoul",
        "language.turkish": "Turc",
        "language.ukrainian": "Ukrainien",
        "language.bashkir": "Bachkir",
        "language.basque": "Basque",
        "language.belarusian": "Biélorusse",
        "language.cantonese": "Cantonais",
        "language.esperanto": "Espéranto",
        "language.estonian": "Estonien",
        "language.galician": "Galicien",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongol",
        "language.persian": "Persan",
        "language.thai": "Thaï",
        "language.uyghur": "Ouïghour",
        "language.vietnamese": "Vietnamien",
        "language.welsh": "Gallois"
      },
      "selectedepisode": {
        "processing.episode": "Traitement de l'épisode",
        "processing.time": "Cela prend généralement entre 5 et 10 minutes",
        "email.notification": "Vous pouvez fermer cette fenêtre. Nous vous enverrons un email une fois que c'est prêt. Votre contenu sera également disponible sur votre tableau de bord.",
        "convert.another.episode": "Convertir un autre épisode",
        "technical.difficulties": "Oups ! Nous rencontrons des difficultés techniques. Rassurez-vous, notre équipe est sur le coup ! Veuillez réessayer plus tard.",
        "no.discount": "Ne vous inquiétez pas, nous ne déduirons aucune minute !",
        "high.demand": "Nous connaissons une demande plus élevée que la normale, il se peut donc que le traitement de votre demande prenne plus de temps que d'habitude. Nous nous excusons pour tout inconvénient !",
        "email.ready": "Nous vous enverrons un email une fois que c'est prêt. Vous pouvez également accéder à vos résultats sur votre tableau de bord.",
        "select.podcast.folder": "Sélectionnez le dossier de podcast auquel cet épisode appartient, ou créez-en un nouveau en tapant un nom.",
        "give.voice": "Personnaliser la voix du dossier",
        "generate.content": "Générer du contenu",
        "not.enough.minutes.title": "Vous n'avez pas assez de minutes",
        "not.enough.minutes.message": "Vous n'avez pas assez de minutes pour convertir cet épisode. Veuillez mettre à jour votre plan.",
        "upgrade.plan": "Mettre à jour mon plan",
        "convert.shorter.episode": "Convertir un épisode plus court",
        "content.ready": "Votre contenu est prêt !",
        "ask.ai.tune": "Vous pouvez toujours demander à l'IA d'ajuster chaque contenu pour mieux répondre à vos besoins.",
        "error.title": "Erreur",
        "convert.another.file": "Convertir un autre fichier"
      },
      "submitfile": {
        "file.size.exceeded.free": "La taille du fichier dépasse la limite maximale de 4 Go. <p>Veuillez <a href='/pricing'><b><u>mettre à niveau pour télécharger des fichiers plus volumineux</u></b></a></p>",
        "file.size.exceeded.paid": "La taille du fichier dépasse la limite maximale de 10 Go. <p>Veuillez sélectionner un fichier plus petit.</p>",
        "file.upload.invalid": "Veuillez télécharger un fichier audio ou vidéo",
        "upload.in.progress": "Téléchargement du fichier. Veuillez ne pas fermer cette fenêtre.",
        "upload.button": "Télécharger & Générer",
        "close.button": "Fermer",
        "upgrade.message.free": "Plus de téléchargements ne sont disponibles que pour les niveaux payants.",
        "upgrade.now.button": "Mettre à niveau maintenant",
        "pricing.info": "à partir de 12 $/mois",
        "upload.file.label": "Télécharger un fichier audio ou vidéo",
        "max.file.size.free": "(max 4 Go)",
        "max.file.size.paid": "(max 10 Go)",
        "podsqueeze.audiograms.info": "Podsqueeze générera des audiogrammes pour les fichiers audio et des clips courts pour les fichiers vidéo",
        "file.placeholder": "Votre fichier MP3/WAV",
        "episode.language.label": "Langue de l'épisode",
        "multiple.files.selected": "{{count}} fichiers sélectionnés",
        "clear.all": "Effacer tout",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Sélectionner plusieurs fichiers",
        "file.upload.error": "Erreur lors du téléchargement du fichier",
        "file.upload.success": "Fichier téléchargé avec succès",
        "file.upload.processing": "Traitement du fichier",
        "click.to.upload": "Cliquer pour télécharger",
        "click.to.upload.multiple": "Cliquer pour télécharger plusieurs fichiers",
        "select.folder.label": "Sélectionner ou créer un dossier",
        "enter.url": "Saisir l'URL",
        "upload.file": "Télécharger un fichier",
        "media.url.label": "URL du média",
        "media.url.help": "Entrez l'URL de votre fichier audio ou vidéo. Nous le téléchargerons et le traiterons pour vous.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Nom de l'épisode",
        "url.input.required": "Veuillez saisir une URL de média",
        "url.upload.error": "Échec du téléchargement du média depuis l'URL. Veuillez vérifier l'URL et réessayer.",
        "supported.formats": "Formats pris en charge",
        "uploading": "Téléchargement en cours...",
        "media.url.requirements": "L'URL doit être un lien direct vers un fichier multimédia public (pas une page web)"
      },
      "submitrssid": {
        "error.selectRss": "Veuillez sélectionner un RSS valide dans le menu déroulant",
        "label.insertRssFeed": "Insérez votre flux RSS",
        "placeholder.insertRssFeed": "Insérez votre flux RSS",
        "label.searchByPodcast": "Rechercher par nom de podcast à la place",
        "label.searchForPodcast": "Recherchez le nom de votre podcast",
        "placeholder.searchForPodcast": "Rechercher un podcast",
        "label.cantFindPodcast": "Vous ne trouvez pas votre podcast ? ",
        "label.clickHereUseRss": "Cliquez ici pour utiliser votre flux RSS à la place",
        "label.selectedPodcast": "Podcast sélectionné",
        "label.episodeLanguage": "Langue de l'épisode",
        "button.seeAllEpisodes": "Voir tous les épisodes",
        "select.folder.label": "Sélectionner ou créer un dossier"
      },
      "submitsection": {
        "search.podcast": "Recherchez votre podcast",
        "upload.audio.video": "Téléchargez de l'audio ou de la vidéo",
        "record.audio": "Enregistrer de l'audio",
        "youtube.video": "Lien YouTube",
        "create.content": "Créons du contenu pour votre podcast !"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Entrez l'URL de la vidéo YouTube",
        "error.insertYouTubeUrl": "Veuillez insérer une URL YouTube.",
        "label.insertYouTubeUrl": "Insérer l'URL YouTube",
        "button.loading": "Chargement...",
        "message.downloadingFile": "Téléchargement du fichier...",
        "error.processingFailed": "Le traitement a échoué. Veuillez réessayer.",
        "error.youtubeVideoNotAvailable": "Cette vidéo YouTube n'est pas disponible pour le téléchargement. Veuillez télécharger votre audio ou vidéo directement à Podsqueeze ou utiliser un téléchargement YouTube d'abord. Merci pour votre patience.",
        "button.submitYouTubeVideo": "Soumettre la vidéo YouTube",
        "episode.language.label": "Langue utilisée",
        "select.folder.label": "Sélectionner ou créer un dossier"
      },
      "tabs": {
        "tab.label.tab1": "Onglet 1",
        "tab.label.tab2": "Onglet 2",
        "tab.label.tab3": "Onglet 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Tirez le meilleur parti de Podsqueeze",
        "tutorial.chapter.introduction": "Introduction",
        "tutorial.chapter.bestShowNotes": "Obtenez les meilleures notes d'émission et horodatages",
        "tutorial.chapter.blogPosts": "Utilisation des articles de blog et des newsletters",
        "tutorial.chapter.editingTranscripts": "Intégration et édition des transcriptions",
        "tutorial.chapter.personalizingAI": "Personnaliser l'IA et donner votre propre voix",
        "tutorial.chapter.speedingUpNotes": "Accélérer les notes d'émission",
        "tutorial.chapter.creatingClips": "Créer des clips vidéo et des images",
        "tutorial.chapter.generatingLandingPage": "Générer une page d'atterrissage",
        "tutorial.chapter.shareResults": "Partager les résultats avec votre équipe",
        "tutorial.closeVideoCheckbox": "Fermer la vidéo une fois les premiers résultats prêts"
      },
      "uploadloadingbar": {
        "upload.loading": "Chargement..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Contactez-nous",
        "contact.section.email": "Envoyez-nous un email à support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fondateur",
        "contact.section.joao.role": "Co-fondateur",
        "contact.section.image.alt.sendMessage": "Envoyer un message",
        "contact.section.image.alt.tiago": "Co-fondateur Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fondateur Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Contactez-nous",
        "contact.section.email": "Envoyez-nous un email à support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fondateur",
        "contact.section.joao.role": "Co-fondateur",
        "contact.section.image.alt.sendMessage": "Envoyer un message",
        "contact.section.image.alt.tiago": "Co-fondateur de Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fondateur de Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Rejoignez 20 000 créateurs de contenu et professionnels du podcast utilisant Podsqueeze",
        "content.creators": "Créateurs de contenu",
        "podcast.managers": "Gestionnaires de podcast",
        "producers.studios": "Producteurs & Studios",
        "for.podcasters": "POUR LES PODCASTEURS, GESTIONNAIRES DE PODCAST ET AGENCES",
        "manage.content.creation": "Gérez facilement la création de contenu pour",
        "multiple.podcasts": "plusieurs podcasts",
        "podsqueeze.description": "Podsqueeze est un outil puissant pour tous les professionnels du podcasting. Que vous soyez un podcasteur solo, un gestionnaire de podcast ou une agence, Podsqueeze offre toutes les fonctionnalités dont vous avez besoin pour rationaliser votre flux de travail de création de contenu de podcast.",
        "create.podcast.folders": "Créez des dossiers de podcast pour garder vos épisodes organisés.",
        "share.content.page": "Partagez facilement votre page de contenu avec vos clients et votre équipe",
        "tune.ai.voice": "Ajustez la voix de l'IA pour chaque émission que vous gérez",
        "plan.content.episodes": "Planifiez le contenu des prochains épisodes avec notre",
        "podcast.topics.finder": "outil de recherche de sujets de podcast avancé",
        "podsqueeze.testimonial": "La capacité de Podsqueeze à utiliser des invites pour ajuster le contenu de chaque podcast que nous gérons et à les enregistrer pour de futurs épisodes nous permet de garder les voix de chaque émission cohérentes. C'est une fonctionnalité élite que nous n'avons pas trouvée dans d'autres outils.",
        "coo.podigy": "COO chez Podigy Podcasts",
        "agenciessection.joinCreators": "Rejoignez 20 000 créateurs de contenu et professionnels du podcast utilisant Podsqueeze",
        "agenciessection.contentCreators": "Créateurs de contenu",
        "agenciessection.podcastManagers": "Gestionnaires de podcast",
        "agenciessection.producersStudios": "Producteurs & Studios",
        "agenciessection.forPodcasters": "POUR LES PODCASTEURS, GESTIONNAIRES DE PODCAST ET AGENCES",
        "agenciessection.manageContent": "Gérez facilement la création de contenu pour",
        "agenciessection.multiplePodcasts": "plusieurs podcasts",
        "agenciessection.podsqueezeDescription": "Podsqueeze est un outil puissant pour tous les professionnels du podcasting. Que vous soyez un podcasteur solo, un gestionnaire de podcast ou une agence, Podsqueeze offre toutes les fonctionnalités dont vous avez besoin pour rationaliser votre flux de travail de création de contenu de podcast.",
        "agenciessection.createPodcastFolders": "Créez des dossiers de podcast pour garder vos épisodes organisés.",
        "agenciessection.shareContent": "Partagez facilement votre page de contenu avec vos clients et votre équipe",
        "agenciessection.tuneAI": "Ajustez la voix de l'IA pour chaque émission que vous gérez",
        "agenciessection.planContent": "Planifiez le contenu des prochains épisodes avec notre",
        "agenciessection.podcastTopicsFinder": "outil de recherche de sujets de podcast avancé",
        "agenciessection.podsqueezeQuote": "La capacité de Podsqueeze à utiliser des invites pour ajuster le contenu de chaque podcast que nous gérons et à les enregistrer pour de futurs épisodes nous permet de garder les voix de chaque émission cohérentes. C'est une fonctionnalité élite que nous n'avons pas trouvée dans d'autres outils.",
        "agenciessection.coO": "COO chez Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NOUVELLE FONCTIONNALITÉ",
        "seamless.editing": "Édition fluide et amélioration audio pour un résultat naturel, ",
        "high.quality.results": " résultats de haute qualité",
        "experience.seamless.audio.editing": "Découvrez une édition audio fluide avec des algorithmes d'IA avancés pour des enregistrements de premier ordre. ",
        "remove.ums": "Supprimer les euh",
        "enhance.sound.quality": ", silences, et améliorez la qualité sonore d'un simple clic.",
        "enhance.audio.now": "Améliorer l'audio maintenant",
        "sample.audio.recorded": "Exemple audio, enregistré directement depuis le téléphone.",
        "original.recording": "Enregistrement original",
        "audio.after.ai.edit": "Audio après édition et amélioration par IA",
        "experience.audio.editing": "Découvrez une édition audio fluide avec des algorithmes d'IA avancés pour des enregistrements de premier ordre. "
      },
      "home-blogsection": {
        "more.resources.label": "PLUS DE RESSOURCES POUR VOTRE PODCAST",
        "learn.how.to.get.most": "Apprenez à tirer le meilleur parti de",
        "your.content": "votre contenu",
        "get.most.out.of.ai.content": "Tirez le meilleur parti du contenu généré par l'IA pour votre podcast",
        "welcome.to.podsqueeze": "Bienvenue sur Podsqueeze – la manière la plus simple de transcrire votre podcast et de créer un contenu captivant...",
        "will.google.penalize.ai.content": "Google va-t-il pénaliser votre contenu généré par l'IA ?",
        "ai.content.discussion": "L'émergence du contenu généré par l'IA a suscité des discussions et soulevé des préoccupations parmi les créateurs de contenu, les marketeurs et les experts en SEO...",
        "what.is.rss.feed": "Qu'est-ce qu'un flux RSS pour les podcasts et comment l'utiliser",
        "rss.feed.benefits": "En tant que podcasteur, vous avez peut-être déjà entendu le terme 'flux RSS', mais vous ne savez peut-être pas exactement ce que c'est ni comment cela peut vous bénéficier...",
        "visit.blog": "Visitez le blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS & AUDIOGRAMMES",
        "clipsAndAudiograms.subtitle": "Réutilisez votre podcast en clips sans effort",
        "clipsAndAudiograms.description": "Choisissez simplement un chapitre de votre épisode et exportez-le en tant que clip ou audiogramme pour TikTok, Instagram et YouTube Shorts. Choisissez un modèle et adaptez-le à votre propre style.",
        "clipsAndAudiograms.createClips": "Créer des Clips Maintenant",
        "textEditor.title": "Éditeur basé sur le texte",
        "textEditor.description": "Affinez vos clips et audiogrammes directement à partir des sous-titres. Modifiez les sous-titres et coupez votre vidéo en supprimant des mots spécifiques.",
        "oneClickShorts.title": "Shorts en un clic (<60s)",
        "oneClickShorts.description": "Laissez l'IA s'occuper du montage pour vous. D'un simple clic, l'IA raccourcira chaque chapitre de votre épisode à moins de 60 secondes, prêt à être publié en tant que YouTube Short ou clips TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Contactez les fondateurs",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Développeur & Podcasteur",
        "contact.section.joao.role": "- Designer UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "GRANDE VARIÉTÉ DE CONTENU",
        "generate.content": "Générer du contenu avec",
        "one.click": " un clic !",
        "transcript.srt": "Transcription & SRT",
        "transcript.description": "Obtenez la transcription complète de votre épisode de podcast, ainsi qu'un fichier SRT prêt à générer des sous-titres.",
        "show.notes": "Notes de l'épisode",
        "show.notes.description": "Résumez les principaux sujets abordés dans votre épisode et rendez-le plus facilement trouvable",
        "timestamps": "Horodatages",
        "timestamps.description": "Créez des chapitres avec des horodatages et guidez les auditeurs vers des segments spécifiques de votre épisode de podcast",
        "blog.social.posts": "Articles de blog & Publications sur les réseaux sociaux",
        "blog.social.posts.description": "Parlez de votre épisode de podcast partout et attirez de nouveaux auditeurs",
        "newsletter": "Bulletin d'information",
        "newsletter.description": "Tenez vos auditeurs informés des nouveaux épisodes",
        "titles.more": "Titres & plus !",
        "titles.more.description": "Générez des titres accrocheurs, des citations, des points clés, des mots-clés et plus encore !",
        "see.sample.content": "VOIR LE CONTENU D'ÉCHANTILLON",
        "wannabe.entrepreneur": "Entrepreneur en herbe - #299 Podsqueeze vient d'atteindre 100 000 $ de revenus annuels !",
        "making.space": "Making Space - Steve Harvey : « Vous pourriez aussi bien continuer »",
        "modern.wisdom": "Sagesse moderne - Erik Hoel - Un guide sur le mystère fondamental de l'esprit"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Ligne de séparation"
      },
      "home-explanationsection": {
        "fast.accurate": "RAPIDE ET PRÉCIS",
        "generate.content": "Générez du contenu pour votre podcast avec le",
        "power.of.ai": "pouvoir de l'IA",
        "upload.image.alt": "télécharger une image",
        "select.episode": "Sélectionnez un épisode de votre flux RSS ou téléchargez un fichier audio/vidéo",
        "paste.rss.feed": "Il vous suffit de coller l'URL de votre flux RSS pour choisir un épisode dans la liste ou de télécharger un fichier audio ou vidéo.",
        "content.image.alt": "image de contenu",
        "one.click.content": "Obtenez tout le contenu en un clic !",
        "user.friendly.interface": "Interface intuitive et conviviale que vous pouvez commencer à utiliser immédiatement. Générez du contenu pour votre podcast en un clic.",
        "tune.image.alt": "image de réglage",
        "edit.fine.tune": "Éditez et peaufinez chaque contenu",
        "direct.edit.content": "Éditez directement et peaufinez chaque contenu selon vos préférences avec l'IA. Par exemple, vous pouvez demander un ton spécifique, un discours direct ou indirect ou simplement corriger des noms mal orthographiés.",
        "multiple.language.support": "Support multilingue",
        "language.flags.alt": "drapeaux de langue",
        "generate.content.aria": "Générer du contenu"
      },
      "home-featuressection": {
        "loading": "Chargement...",
        "transcribe.write.show.notes": "Transcrire et rédiger des notes d'émission pour votre podcast",
        "twenty.times.faster": "20x plus rapide",
        "save.manual.work": "Économisez jusqu'à 100 % du travail manuel. Transcrivez automatiquement votre podcast avec une précision de pointe et un étiquetage des intervenants, et générez des notes d'émission complètes et des publications sur les réseaux sociaux dans votre propre voix.",
        "generate.content": "Générer du contenu",
        "transcripts": "Transcriptions",
        "full.transcript": "Obtenez la transcription complète de vos épisodes de podcast et des transcriptions de vidéos YouTube, ainsi qu'un fichier SRT pour les sous-titres.",
        "show.notes": "Notes d'émission",
        "summarize.generate.show.notes": "Résumez et générez des notes d'émission dans votre propre voix, complètes avec des horodatages, des points clés et des mentions.",
        "blog.newsletter": "Blog et Newsletter",
        "actionable.blog.posts": "Obtenez des articles de blog exploitables sur vos épisodes et des newsletters prêtes à être envoyées avec les principaux enseignements.",
        "social.media": "Réseaux sociaux",
        "short.posts.insights": "Obtenez des publications courtes et des aperçus concis pour faire passer le mot sur les réseaux sociaux.",
        "quote": "Parmi tous les meilleurs outils de transcription AI que nous avons testés, Podsqueeze a généré les résultats les plus utiles pour les notes d'émission, les horodatages, les titres, les mentions, des exemples d'articles de blog et des citations clés.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Co-fondateur de Transistor.fm",
        "transcribe_and_write_show_notes": "Transcription de podcast, résumés et messages sur les réseaux sociaux",
        "twenty_times_faster": "20x plus rapide",
        "save_manual_work": "Économisez jusqu'à 100 % du travail manuel. Transcrivez automatiquement votre podcast avec une précision de pointe et un étiquetage des intervenants, et générez des notes d'émission complètes et des publications sur les réseaux sociaux dans votre propre voix.",
        "generate_content": "Générer du contenu",
        "full_transcript": "Obtenez la transcription complète de vos épisodes de podcast et des transcriptions de vidéos YouTube, ainsi qu'un fichier SRT pour les sous-titres.",
        "show_notes": "Notes d'émission",
        "summarize_and_generate_show_notes": "Résumez et générez des notes d'émission dans votre propre voix, complètes avec des horodatages, des points clés et des mentions.",
        "blog_and_newsletter": "Blog et Newsletter",
        "actionable_blog_posts": "Obtenez des articles de blog exploitables sur vos épisodes et des newsletters prêtes à être envoyées avec les principaux enseignements.",
        "social_media": "Réseaux sociaux",
        "short_posts_and_insights": "Obtenez des publications courtes et des aperçus concis pour faire passer le mot sur les réseaux sociaux.",
        "testimonial": "Parmi tous les meilleurs outils de transcription AI que nous avons testés, Podsqueeze a généré les résultats les plus utiles pour les notes d'émission, les horodatages, les titres, les mentions, des exemples d'articles de blog et des citations clés.",
        "cofounder_transistor": "Co-fondateur de Transistor.fm"
      },
      "home-page": {
        "main.background": "Couleur de fond pour le composant principal"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "ÉCOUTEZ NOTRE PODCAST",
        "podcast.section.subtitle": "Masterclasses de",
        "podcast.section.highlight": "podcasteurs expérimentés",
        "podcast.section.description": "Écoutez notre podcast, où nous interviewons des podcasteurs expérimentés et des utilisateurs de Podsqueeze du monde entier. Nous leur demandons de partager leurs conseils, leurs idées, leurs histoires et tout ce que vous devez savoir pour développer votre propre podcast.",
        "podcast.link.spotify": "Écoutez sur Spotify",
        "podcast.link.apple": "Écoutez sur Apple Podcasts",
        "podcast.link.youtube": "Écoutez sur YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Chargement..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatisez votre podcast",
        "tagline.productionPromotion": "Production & Promotion",
        "tagline.launchGrow": "Lancez et développez facilement votre podcast audio ou vidéo avec tout ce dont vous avez besoin au même endroit, avec l'aide de l'IA.",
        "tagline.uploadGenerate": "Générez podcast transcript, résumé, clips courts avec sous-titres et bien plus encore!",
        "tagline.singleClick": " Le tout en un seul clic.",
        "tagline.transcripts": "Transcriptions de podcast",
        "tagline.showNotes": "Notes de l'émission",
        "tagline.newslettersBlogs": "Bulletins d'information & Blogs",
        "tagline.socialPosts": "Publications sur les réseaux sociaux",
        "tagline.shortClipsAudiograms": "Courtes vidéos & Audiogrammes",
        "tagline.podcastWebsite": "Site Web du podcast",
        "tagline.aiAudioEnhancement": "Amélioration audio par IA",
        "tagline.removeSilences": "Supprimer les silences et les euh",
        "tagline.generateNow": "Générez maintenant gratuitement",
        "tagline.noCreditCard": "Aucune carte de crédit requise",
        "testimonial.robWalling.title": "Rob Walling, Personnalité des startups",
        "testimonial.robWalling.subtitle": "Podcast Startups pour le reste d'entre nous",
        "testimonial.robWalling.quote": "Les notes de l'émission Podsqueeze ont été les meilleures. Nous les utilisons beaucoup pour les résumés et pour obtenir des idées d'autres podcasts.",
        "testimonial.johnGarmet.title": "John Garmet, Directeur des opérations",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze nous aide à être plus efficaces et à générer plus de contenu pour nos clients. Nous le recommandons vivement.",
        "testimonial.davidJackson.title": "David Jackson, Coach de podcast",
        "testimonial.davidJackson.subtitle": "École de podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze est mon partenaire de brainstorming. C'est le meilleur moyen de trouver des idées pour le marketing de podcast."
      },
      "home-testimonials": {
        "testimonials.title": "Que disent les gens de Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Réutilisez le contenu de votre podcast grâce à l'IA | Product Hunt",
        "testimonials.heading": "Que disent les gens de Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Mot de passe incorrect",
        "error.userNotFound": "Utilisateur non trouvé",
        "error.somethingWentWrong": "Oups, quelque chose a mal tourné",
        "button.sendResetEmail": "Envoyer l'e-mail de réinitialisation",
        "button.login": "Se connecter",
        "placeholder.email": "Adresse e-mail",
        "placeholder.password": "Mot de passe",
        "link.forgotPassword": "Mot de passe oublié ?",
        "link.createAccount": "Créer un compte",
        "text.or": "OU",
        "button.continueWithGoogle": "Continuer avec Google",
        "text.podcastDescription": "Lancez et développez facilement votre podcast audio ou vidéo avec tout ce dont vous avez besoin au même endroit.",
        "feature.transcripts": "Transcriptions",
        "feature.showNotes": "Notes de l'émission",
        "feature.newslettersAndBlogs": "Bulletins d'information & Blogs",
        "feature.socialPosts": "Publications sur les réseaux sociaux",
        "feature.shortClipsAndAudiograms": "Courtes vidéos & Audiogrammes",
        "feature.podcastWebsite": "Site Web du podcast",
        "feature.aiAudioEnhancement": "Amélioration audio par IA",
        "feature.removeSilences": "Supprimer les silences et les hésitations",
        "error.emailNotVerified": "E-mail non vérifié, veuillez vérifier votre e-mail pour continuer",
        "error.emailAlreadyVerified": "E-mail déjà vérifié",
        "success.emailVerified": "E-mail vérifié",
        "text.pleaseVerifyAccount": "Veuillez Vérifier Votre Compte",
        "text.checkSpamFolder": "Nous vous avons envoyé un e-mail de vérification. Veuillez vérifier votre boîte de réception et le dossier spam.",
        "button.resendVerificationEmail": "Renvoyer l'E-mail de Vérification",
        "button.sendVerificationEmail": "Envoyer l'E-mail de Vérification",
        "success.verificationEmailSent": "E-mail de vérification envoyé avec succès !",
        "error.verificationEmailFailed": "Échec de l'envoi de l'e-mail de vérification. Veuillez réessayer."
      },
      "page": {
        "login.form": "FormulaireDeConnexion"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Page des Affiliés Podsqueeze",
        "affiliate.page.description": "Gagnez 25 % de commission sur chaque vente réalisée via votre lien de parrainage exclusif pendant une période de 15 mois. Partagez votre lien sur votre site web, les réseaux sociaux ou avec vos amis. L'inscription prend quelques secondes. Obtenez une approbation automatique."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Meilleur Cadeau pour un Podcasteur",
        "bestGiftForPodcaster.description": "Découvrez les meilleurs cadeaux pour les podcasteurs afin d'améliorer leur expérience.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Obtenez plus d'auditeurs de podcast",
        "get-more-podcast-listeners.description": "Obtenez plus d'auditeurs de podcast et simplifiez la production avec des notes d'émission automatiques, des courts extraits pour développer votre émission sur les réseaux sociaux et bien plus encore."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Développez votre audience de podcast",
        "grow_your_podcast_audience.description": "Gagnez un temps précieux et développez votre audience de podcast avec Podsqueeze. Générez des notes d'émission complètes, des publications sur les réseaux sociaux, des extraits courts et plus encore pour votre podcast."
      },
      "index": {
        "home.page.title": "Notes de podcast AI, Transcription, Résumés et Générateur de Clips.",
        "home.page.description": "Générez des notes d'émission, des horodatages, des bulletins d'information et plus encore pour votre podcast en un clic ! Générez rapidement du contenu pour votre podcast et adaptez-le à vos besoins. Inscription gratuite."
      },
      "login": {
        "login.tryItNow": "Essayez-le maintenant !",
        "login.createAccountDescription": "Créez un compte et commencez à générer des notes d'émission, des horodatages, des bulletins d'information et plus encore pour votre podcast en un clic ! Générez rapidement du contenu pour votre podcast et adaptez-le à vos besoins. Inscription gratuite."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing pour les Podcasts",
        "marketing.for.podcasts.description": "Podsqueeze simplifie le marketing pour les podcasts avec des notes d'émission générées automatiquement, des publications sur les réseaux sociaux et des clips courts pour augmenter votre portée et développer votre émission."
      },
      "media": {
        "media.page.title": "Page Média de Podsqueeze",
        "media.page.description": "En savoir plus sur Podsqueeze. Contactez-nous ! Nous serions ravis de collaborer !"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Générateur de descriptions de podcast",
        "podcast.description.generator.description": "Améliorez la portée et l'engagement de votre podcast avec des descriptions générées par IA. Automatisez l'écriture de vos notes d'émission et reprenez un temps précieux."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Réutilisez votre podcast pour des publications sur les réseaux sociaux",
        "convert.podcast.episodes.to.social.media.posts": "Convertissez les épisodes de podcast en publications sur les réseaux sociaux. Générez automatiquement des publications pour LinkedIn, Twitter, Facebook et des clips courts pour TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Générateur de sujets de podcast gratuit",
        "podcast.topics.generator.description": "Notre générateur de sujets de podcast gratuit vous permet de trouver les meilleures idées de sujets et prédit leur portée potentielle sur Google et YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Votre Assistant Virtuel de Podcast",
        "podcast.virtual.assistant.description": "Assistant virtuel de podcast alimenté par IA qui rédige vos notes d'émission et crée des publications sur les réseaux sociaux. Simplifiez la production et le marketing de votre podcast avec Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Tarification",
        "pricing.description": "Générez des notes d'émission, des horodatages, des bulletins d'information et plus encore pour votre podcast en un clic ! Nous avons plusieurs niveaux de prix pour répondre à vos besoins en matière de podcasting."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promouvez votre podcast",
        "promote.your.podcast.description": "Générez des notes d'émission, des publications sur les réseaux sociaux et des clips courts pour publier et promouvoir votre podcast en quelques minutes seulement."
      },
      "register": {
        "create.podsqueeze.account": "Créer un compte Podsqueeze",
        "generate.content.podcast": "Générez des notes d'émission, des horodatages, des bulletins d'information et plus encore pour votre podcast en un clic ! Générez rapidement du contenu pour votre podcast et adaptez-le à vos besoins. Inscription gratuite."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Réutilisez automatiquement le contenu de votre podcast",
        "repurpose.your.podcast.content.with.ai": "Réutilisez le contenu de votre podcast avec l'IA. Générez automatiquement des notes d'émission, des titres, des clips courts pour TikTok, et bien plus encore, le tout en un clic !"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "Optimiseur SEO de Podcast GRATUIT",
        "seo.optimizer.description": "Analysez et optimisez vos épisodes de podcast pour une meilleure visibilité sur les moteurs de recherche avec des recommandations SEO alimentées par l'IA.",
        "seo.optimizer.heading": "Optimiseur SEO de Podcast",
        "seo.optimizer.headingnote": "Analysez et optimisez vos épisodes de podcast pour une meilleure visibilité sur les moteurs de recherche avec des recommandations SEO alimentées par l'IA.",
        "seo.optimizer.selectEpisode": "Sélectionner un Épisode à Analyser",
        "seo.optimizer.results": "Résultats de l'Analyse SEO",
        "seo.optimizer.searchPodcastPlaceholder": "Rechercher un podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Rechercher des épisodes...",
        "seo.optimizer.analyseAnotherEpisode": "Analyser un Autre Épisode",
        "seo.optimizer.findingEpisodes": "Recherche de tous les épisodes...",
        "seo.optimizer.analysingEpisode": "Analyse de l'Épisode",
        "seo.optimizer.scoreTooltip": "Score :",
        "seo.optimizer.topKeywords": "Nous avons identifié ces Mots-clés Principaux :",
        "seo.optimizer.topKeywordsnote": "Basé sur l'analyse des mots-clés en bas de la page.",
        "seo.optimizer.optimizedContent": "Basé sur les mots-clés, voici le titre et la description optimisés :",
        "seo.optimizer.originalTitle": "Titre Original",
        "seo.optimizer.optimizedTitle": "Titre Optimisé",
        "seo.optimizer.originalDescription": "Description Originale",
        "seo.optimizer.optimizedDescription": "Description Optimisée",
        "seo.optimizer.showMore": "Afficher Plus",
        "seo.optimizer.showLess": "Afficher Moins",
        "seo.optimizer.keywordAnalysis": "Analyse des Mots-clés",
        "seo.optimizer.keywordAnalysisnote": "Les scores sont calculés en fonction du volume de recherche, de la concurrence (combien d'autres résultats il y a pour le même mot-clé) et dans le cas de YouTube, le nombre moyen de vues par vidéo pour le même mot-clé.",
        "seo.optimizer.seoScore": "Score SEO",
        "seo.optimizer.spotifyScore": "Score Spotify",
        "seo.optimizer.youtubeScore": "Score YouTube",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Outil de génération de contenu de podcast par IA",
        "podsqueeze.description": "Générez des notes d'émission, des horodatages, des bulletins d'information et plus encore pour votre podcast en un clic ! Générez rapidement du contenu pour votre podcast et adaptez-le à vos besoins. Inscription gratuite."
      },
      "thumbnail-creator": {
        "title": "Générateur Gratuit de Miniatures de Podcast - Créez des Miniatures d'Épisodes avec l'IA",
        "description": "Créez des miniatures de podcast époustouflantes avec l'IA. Générez des visuels d'épisode professionnels et accrocheurs qui augmentent la visibilité et attirent plus d'auditeurs vers votre podcast.",
        "selectPodcast": "Sélectionnez Votre Podcast",
        "loadEpisodes": "Charger les Épisodes",
        "selectEpisode": "Sélectionnez un Épisode pour Créer une Miniature",
        "createThumbnail": "Créer une Miniature",
        "results": "Votre Miniature Générée",
        "download": "Télécharger",
        "share": "Partager",
        "regenerate": "Régénérer",
        "editThumbnail": "Modifier la Miniature",
        "editPlaceholder": "Décrivez comment vous souhaitez modifier cette miniature...",
        "customPrompt": "Prompt Personnalisé",
        "yourThumbnail": "Votre Miniature",
        "createAnother": "← Créer une Autre Miniature",
        "findingEpisodes": "Recherche d'épisodes...",
        "searchPodcastPlaceholder": "Recherchez votre podcast...",
        "searchingPodcasts": "Recherche de podcasts...",
        "heroDescription": "Générez des miniatures de podcast époustouflantes et professionnelles avec un design alimenté par l'IA qui capte l'attention et augmente la visibilité de vos épisodes.",
        "generatedWithPrompt": "Généré avec le prompt :",
        "customPromptPlaceholder": "Entrez un prompt personnalisé pour la génération de miniatures...",
        "generating": "Génération...",
        "generate": "Générer",
        "modernMinimalist": "Moderne et Minimaliste",
        "vibrantDynamic": "Vibrant et Dynamique",
        "professionalClean": "Professionnel et Épuré",
        "generatingThumbnail": "Génération de la miniature...",
        "generatingNewThumbnail": "Génération d'une nouvelle miniature...",
        "showingFirstEpisodes": "Affichage des 10 premiers épisodes. Utilisez la recherche pour trouver des épisodes spécifiques.",
        "imageUrlCopied": "URL de l'image copiée dans le presse-papiers !",
        "failedToGenerate": "Échec de la génération de la miniature. Veuillez réessayer.",
        "promotionalTitle": "Générez des Notes de Spectacle, des Horodatages, des Clips Viraux et Bien Plus Avec Podsqueeze",
        "promotionalSubtitle": "Rejoignez plus de 100K+ créateurs et commencez à faire grandir votre émission",
        "startNow": "Commencer maintenant",
        "free": "GRATUIT",
        "podcast": "PODCAST",
        "thumbnail": "MINIATURE",
        "creator": "CRÉATEUR",
        "replaceFace": "Remplacer le Visage",
        "uploading": "Téléchargement...",
        "uploadImageError": "Veuillez télécharger un fichier image.",
        "uploadFailedError": "Échec du téléchargement de l'image. Veuillez réessayer.",
        "uploadingImage": "Téléchargement de l'image...",
        "generatingNewThumbnailLoading": "Génération d'une nouvelle miniature...",
        "failedToGenerateWithFace": "Échec de la génération de la miniature avec remplacement de visage. Veuillez réessayer."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Créer un nouveau dossier de podcast",
      "folder.name.placeholder": "Entrez le nom du dossier",
      "create.button": "Créer"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Chargement des épisodes...",
        "episodeList.noEpisodes": "Aucun épisode public disponible",
        "episodeList.checkBack": "Revenez plus tard pour de nouveaux épisodes",
        "episodeList.title": "Épisodes de ce Podcast",
        "episodeList.readLess": "LIRE MOINS",
        "episodeList.readMore": "LIRE PLUS",
        "episodeList.coverImageAlt": "Couverture de {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Commencer",
        "alert.subscriptionRunning": "Votre abonnement actuel est toujours en cours.\n\nVeuillez annuler votre abonnement actuel avant d'en acheter un nouveau.",
        "alert.subscriptionEnds": "Votre abonnement actuel est toujours en cours.\n\nIl se termine le {date}",
        "alert.subscriptionCancelled": "Votre abonnement a déjà été annulé et il se terminera le {date}",
        "button.openDashboard": "Ouvrir le tableau de bord",
        "button.signUp": "S'inscrire",
        "button.buySubscription": "Acheter un abonnement",
        "button.cancelled": "Annulé",
        "button.cancelSubscription": "Annuler l'abonnement",
        "button.upgradeSubscription": "Mettre à niveau l'abonnement",
        "button.loading": "Chargement",
        "upgrade.details.currentMinutes": "Cela va commencer une nouvelle période d'abonnement. Vous conserverez tous vos minutes actuelles.",
        "upgrade.details.remainingAnnual": "Cette valeur a été calculée en fonction du temps restant dans votre abonnement annuel actuel."
      },
      "page": {
        "pricing.free.title": "Gratuit",
        "pricing.free.subtitle": "Essayez Podsqueeze. Aucune carte de crédit requise.",
        "pricing.free.price.annual": "0 $ Facturé Annuellement",
        "pricing.free.features.podcast_time": "30 minutes de temps de podcast par mois",
        "pricing.free.features.video_clips": "3 extraits vidéo",
        "common.with_watermark": "avec filigrane",
        "pricing.free.features.quote_images": "Images de citation illimitées",
        "pricing.free.features.file_upload": "Téléchargement de fichiers jusqu'à 4 Go",
        "pricing.free.features.upload": "1 téléchargement",
        "pricing.free.features.landing_pages": "Pages d'atterrissage de podcast",
        "pricing.free.features.audio_enhancement": "Amélioration audio",
        "common.sign_up": "S'inscrire",
        "common.open_dashboard": "Ouvrir le tableau de bord",
        "pricing.starter.title": "Démarrage",
        "pricing.starter.subtitle": "Parfait pour les podcasteurs amateurs qui souhaitent gagner du temps.",
        "pricing.starter.price.annual": "132 $ Facturé Annuellement",
        "pricing.billed_annually": "Facturé Annuellement",
        "minutes.accumulate": "Minutes accumulées*",
        "pricing.starter.features.podcast_time": "160 minutes de temps de podcast par mois",
        "pricing.starter.features.video_clips": "10 extraits vidéo ou audiogrammes",
        "pricing.starter.features.quote_images": "Images de citation illimitées",
        "pricing.starter.features.file_upload": "Téléchargement de fichiers jusqu'à 4 Go",
        "pricing.starter.features.unlimited_uploads": "Téléchargements illimités",
        "pricing.starter.features.landing_pages": "Pages d'atterrissage de podcast",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Pour les professionnels qui utilisent le podcasting pour développer et soutenir leur entreprise.",
        "pricing.pro.price.annual": "324 $ Facturé Annuellement",
        "pricing.pro.features.podcast_time": "320 minutes de temps de podcast par mois",
        "pricing.pro.features.personalize_ai_voice": "Personnaliser la voix IA",
        "pricing.pro.features.video_clips": "20 extraits vidéo ou audiogrammes",
        "common.no_watermark": "sans filigrane",
        "pricing.pro.features.quote_images": "Images de citation illimitées",
        "pricing.pro.features.file_upload": "Téléchargement de fichiers jusqu'à 10 Go",
        "pricing.pro.features.unlimited_uploads": "Téléchargements illimités",
        "pricing.pro.features.landing_pages": "Pages d'atterrissage de podcast",
        "common.customizable": "personnalisable",
        "pricing.pro.features.audio_video_edit": "Édition magique audio et vidéo",
        "pricing.pro.features.everything_in_pro": "Tout dans Pro",
        "pricing.agency_lite.title": "Agence Lite",
        "pricing.agency_lite.subtitle": "Pour les agences de podcast qui souhaitent rationaliser et développer leur activité.",
        "pricing.agency_lite.price.annual": "495 $ Facturé Annuellement",
        "pricing.agency_lite.features.podcast_time": "600 minutes de temps de podcast par mois",
        "pricing.agency_lite.features.personalize_ai_voice": "Personnaliser la voix IA",
        "pricing.agency_lite.features.video_clips": "40 extraits vidéo ou audiogrammes",
        "pricing.agency_lite.features.quote_images": "Images de citation illimitées",
        "pricing.agency_lite.features.file_upload": "Téléchargement de fichiers jusqu'à 10 Go",
        "pricing.agency_lite.features.unlimited_uploads": "Téléchargements illimités",
        "pricing.agency_lite.features.landing_pages": "Pages d'atterrissage de podcast",
        "pricing.agency_lite.features.audio_video_edit": "Édition magique audio et vidéo",
        "pricing.agency_plus.title": "Agence Plus",
        "pricing.agency_plus.subtitle": "Pour les agences de podcast qui souhaitent rationaliser et développer leur activité.",
        "pricing.agency_plus.price.annual": "1.251 $ Facturé Annuellement",
        "pricing.agency_plus.features.podcast_time": "2000 minutes de temps de podcast par mois",
        "pricing.agency_plus.features.personalize_ai_voice": "Personnaliser la voix IA",
        "pricing.agency_plus.features.video_clips": "80 extraits vidéo ou audiogrammes",
        "pricing.agency_plus.features.quote_images": "Images de citation illimitées",
        "pricing.agency_plus.features.file_upload": "Téléchargement de fichiers jusqu'à 10 Go",
        "pricing.agency_plus.features.unlimited_uploads": "Téléchargements illimités",
        "pricing.agency_plus.features.landing_pages": "Pages d'atterrissage de podcast",
        "pricing.agency_plus.features.audio_video_edit": "Édition magique audio et vidéo",
        "pricing.agency_scale.title": "Échelle d'Agence",
        "pricing.agency_scale.subtitle": "Pour les agences de podcast qui souhaitent rationaliser et développer leur activité.",
        "pricing.agency_scale.price.annual": "2.175 $ Facturé Annuellement",
        "pricing.agency_scale.features.podcast_time": "4000 minutes de temps de podcast par mois",
        "pricing.agency_scale.features.personalize_ai_voice": "Personnaliser la voix IA",
        "pricing.agency_scale.features.video_clips": "160 extraits vidéo ou audiogrammes",
        "pricing.agency_scale.features.quote_images": "Images de citation illimitées",
        "pricing.agency_scale.features.file_upload": "Téléchargement de fichiers jusqu'à 10 Go",
        "pricing.agency_scale.features.unlimited_uploads": "Téléchargements illimités",
        "pricing.agency_scale.features.landing_pages": "Pages d'atterrissage de podcast",
        "pricing.agency_scale.features.audio_video_edit": "Édition magique audio et vidéo",
        "pricing.header": "Pour les podcasteurs solo et les agences de podcast",
        "pricing.minutes_reset": "*Vous pouvez accumuler jusqu'à 3 fois vos minutes mensuelles, tant que vous restez sur votre plan actuel ou passez à un niveau supérieur.*",
        "pricing.most_popular": "Plus populaire",
        "pricing.minutes_per_month": "Minutes par mois",
        "pricing.enterprise_title": "Entreprise",
        "pricing.enterprise_subtitle": "Pour les agences et les entreprises de médias qui souhaitent développer leur activité.",
        "pricing.enterprise_price": "Personnalisé",
        "pricing.enterprise_price_note": "Contactez team@podsqueeze.com ou réservez un rendez-vous ci-dessous.",
        "pricing.enterprise_feature_priority_support": "Support prioritaire",
        "pricing.enterprise_feature_team_sits": "Séances d'équipe",
        "pricing.enterprise_personalized_team_training": "Onboarding et formation de l'équipe",
        "pricing.book_demo": "Réserver un rendez-vous",
        "pricing.unlimited": "Illimité",
        "pricing.custom": "Personnalisé"
      },
      "toggle": {
        "pay.monthly": "Mensuel",
        "pay.annually": "Annuel",
        "discount.30percent": "30%  RABAIS"
      },
      "upgradeModal": {
        "upgrade.success": "Votre abonnement a été mis à niveau avec succès",
        "upgrade.error": "Nous sommes désolés, quelque chose a mal tourné. Veuillez réessayer plus tard",
        "upgrade.loading": "Mise à niveau en cours",
        "upgrade.confirmPay": "Confirmer et Payer",
        "upgrade.cancel": "Annuler",
        "coupon.placeholder": "Code de Coupon",
        "coupon.apply": "Appliquer",
        "coupon.have": "J'ai un coupon",
        "upgrade.confirmation": "Vous êtes sur le point de passer à",
        "upgrade.price": "Vous paierez"
      }
    },
    "register": {
      "page": {
        "register.form": "Formulaire d'inscription"
      },
      "registerForm": {
        "error.invalidCredentials": "Veuillez entrer une adresse e-mail et un mot de passe valides.",
        "error.weakPassword": "Veuillez utiliser un mot de passe plus fort 💪",
        "error.emailInUse": "L'utilisateur existe déjà",
        "error.userNotFound": "Utilisateur non trouvé",
        "error.generic": "Oups, quelque chose a mal tourné",
        "placeholder.email": "Adresse e-mail",
        "placeholder.password": "Mot de passe",
        "button.registering": "Enregistrement...",
        "button.register": "S'inscrire",
        "label.newsletter": "Rejoignez 12 000 podcasteurs et abonnez-vous à notre newsletter pour des mises à jour sur les produits, des conseils pratiques, des ebooks, des cadeaux et plus encore.",
        "label.alreadyHaveAccount": "Vous avez déjà un compte ?",
        "label.logInHere": "Connectez-vous ici",
        "label.or": "OU",
        "button.signingIn": "Connexion en cours...",
        "button.continueWithGoogle": "Continuer avec Google",
        "label.podcastDescription": "Lancez et développez facilement votre podcast audio ou vidéo avec tout ce dont vous avez besoin au même endroit.",
        "feature.transcripts": "Transcriptions",
        "feature.showNotes": "Notes de l'émission",
        "feature.newslettersBlogs": "Newsletters & Blogs",
        "feature.socialPosts": "Publications sur les réseaux sociaux",
        "feature.shortClips": "Clips courts & Audiogrammes",
        "feature.podcastWebsite": "Site Web du podcast",
        "feature.audioEnhancement": "Amélioration audio par IA",
        "feature.removeSilences": "Supprimer les silences et les euhs"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "texte"
      },
      "TopicFinder": {
        "competition.veryHigh": "TRÈS ÉLEVÉ",
        "competition.high": "ÉLEVÉ",
        "competition.medium": "MOYEN",
        "competition.low": "FAIBLE",
        "competition.veryLow": "TRÈS FAIBLE",
        "upgrade.button": "Passer à Pro",
        "clicks.label": "clics",
        "searches.label": "recherches",
        "competition.label": "concurrence",
        "fetching.results": "Récupération des résultats",
        "table.topic": "Sujet",
        "tooltip.topic": "Le sujet principal abordé par votre épisode de podcast",
        "table.monthlySearches": "Recherches Mensuelles",
        "tooltip.monthlySearches": "La plage des recherches mensuelles sur Google que vous pouvez attendre",
        "table.competition": "Concurrence",
        "tooltip.competition": "Le sujet principal ou le thème abordé par le podcast.",
        "table.monthlyGoogleClicks": "Clics Mensuels sur Google",
        "tooltip.monthlyGoogleClicks": "Une prévision de la plage des clics mensuels sur Google que vous pouvez attendre",
        "table.youtubeReach": "Portée Youtube",
        "tooltip.youtubeReach": "Une prévision du nombre maximum de vues Youtube que vous pouvez attendre au cours des 6 premiers mois, basé sur le concurrent moyen",
        "intro.title": "Générateur de Sujets de Podcast Gratuit",
        "intro.description": "Obtenez des idées de sujets pour votre podcast que les auditeurs recherchent",
        "intro.check1": "Vérifiez la demande pour chaque idée de sujet sur Google",
        "intro.check2": "Découvrez à quel point chaque idée de sujet de podcast est compétitive",
        "intro.check3": "Estimez les clics Google et les vues Youtube que vous pouvez obtenir",
        "upgrade.message": "Vous devez passer à Pro pour accéder à tous les résultats",
        "learnMore.label": "En savoir plus sur le",
        "learnMore.link": "outil de générateur de sujets de podcast gratuit",
        "newSearch.button": "Nouvelle Recherche",
        "share.button": "Partager Cette Recherche",
        "form.label": "Entrez vos niches de podcast",
        "form.placeholder": "Marketing Digital",
        "form.submit": "Trouver des Idées de Sujets"
      },
      "page": {
        "main.background": "arrière-plan"
      },
      "shareTopics": {
        "share.results": "Partager les résultats",
        "share.facebook": "Partager sur Facebook",
        "share.whatsapp": "Partager sur WhatsApp",
        "share.twitter": "Partager sur Twitter",
        "share.linkedin": "Partager sur LinkedIn",
        "copy.success": "Copié",
        "copy.link": "Copier le lien"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "vues"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Impossible d'obtenir la composition actuelle",
        "error.addImage": "Erreur lors de l'ajout de l'élément image :",
        "alert.uploadImage": "Veuillez télécharger un fichier image.",
        "error.uploadImage": "Erreur lors du téléchargement de l'image :",
        "alert.uploadFailed": "Échec du téléchargement de l'image. Veuillez réessayer.",
        "error.getDownloadURL": "Erreur lors de l'obtention de l'URL de téléchargement :",
        "alert.processImageFailed": "Échec du traitement de l'image téléchargée. Veuillez réessayer.",
        "error.addText": "Erreur lors de l'ajout de l'élément texte :",
        "text.settingsPlaceholder": "Les paramètres s'afficheront lorsque l'élément est sélectionné",
        "text.addElement": "Ajouter un élément",
        "text.uploading": "Téléchargement...",
        "button.uploadImage": "Télécharger l'image",
        "text.newText": "Nouveau texte",
        "button.addText": "Ajouter du texte",
        "text.selectedElementSettings": "Paramètres de l'élément sélectionné"
      },
      "FontSelector": {
        "allFonts": "Toutes les polices",
        "myFonts": "Mes polices",
        "uploadFont": "Télécharger police",
        "noCustomFonts": "Pas encore de polices personnalisées.",
        "uploadToAdd": "Téléchargez un fichier de police pour l'ajouter à votre collection.",
        "text_outline": "Contour du texte",
        "outline_color": "Couleur du contour",
        "outline_width": "Épaisseur du contour"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Ajuster",
        "imageLayoutSettings.zoom": "Zoomer",
        "imageLayoutSettings.horizontalAlignment": "Alignement horizontal",
        "imageLayoutSettings.verticalAlignment": "Alignement vertical",
        "imageLayoutSettings.deleteElement": "Supprimer l'élément"
      },
      "TemplateBox": {
        "confirm.delete.template": "Êtes-vous sûr de vouloir supprimer ce modèle ?"
      },
      "TextSettings": {
        "error.getting_current_text": "Erreur lors de la récupération du texte actuel :",
        "event.delete_text_element_clicked": "Élément de texte supprimé cliqué",
        "error.changing_text_font": "Erreur lors du changement de la police de texte :",
        "event.text_font_changed": "Police de texte changée",
        "error.changing_text_size": "Erreur lors du changement de la taille du texte :",
        "event.text_size_changed": "Taille du texte changée",
        "error.changing_text_color": "Erreur lors du changement de la couleur du texte :",
        "event.text_color_changed": "Couleur du texte changée",
        "event.text_content_added": "Contenu de texte ajouté",
        "error.adding_text_content": "Erreur lors de l'ajout de contenu de texte :",
        "event.text_content_updated": "Contenu de texte mis à jour",
        "label.text_content": "Contenu de texte",
        "label.text_font": "Police de texte",
        "label.text_font_weight": "Graisse de police",
        "label.adjust_text_size": "Ajuster la taille du texte",
        "label.text_color": "Couleur du texte",
        "button.delete": "Supprimer"
      },
      "audiogramBaseTemplate": {
        "color.white": "Blanc",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "urlEpisodeParDefaut",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "quadratique-sortant",
        "animation.fade": "fondu",
        "type.text": "texte",
        "name.podcastTitle": "TitreDuPodcast",
        "name.snippetTitle": "TitreDuSnippet",
        "type.image": "image",
        "name.audioBackgroundImage": "ImageDeFondAudio",
        "name.subtitlesText": "texteDesSousTitres",
        "effect.highlight": "surligner",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "titreDuSnippet",
        "podcast.title": "titreDuPodcast",
        "new.episode": "NOUVEL ÉPISODE"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Blanc",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "urlEpisodeParDéfaut",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "musique_de_fond",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Veuillez télécharger un fichier image.",
        "upload.file.loading": "Téléchargement du fichier. Veuillez ne pas fermer cette fenêtre.",
        "upload.image.label": "Remplacer image",
        "ai.prompt.label": "Entrez une invite pour que l'IA génère une image",
        "ai.prompt.placeholder": "Ex : Un chien courant dans le parc...",
        "ai.processing": "Traitement en cours...",
        "ai.create": "Créer",
        "customize.image.title": "Personnaliser l'image",
        "enter.image.url": "Entrez l'URL de l'image",
        "or": "ou"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Erreur lors de la récupération des modèles :",
        "template.savedSuccessfully": "Modèle enregistré avec succès",
        "error.savingTemplate": "Erreur lors de l'enregistrement du modèle :",
        "loading.savedTemplates": "Chargement des modèles enregistrés...",
        "no.savedTemplates": "Aucun modèle enregistré",
        "select_template": "Sélectionner un modèle",
        "saving.template": "Enregistrement du modèle...",
        "template_name": "Nom du modèle",
        "enter.templateName": "Entrez le nom du modèle",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "default_templates": "Modèles par défaut",
        "saved_templates_count": "Modèles enregistrés ({count})",
        "folder_templates_count": "Modèles de Dossier ({count})",
        "account_templates_count": "Modèles de Compte ({count})",
        "save_current_template": "Enregistrer le modèle actuel"
      },
      "subtitlesElement": {
        "edit.word": "Modifier le mot",
        "edit.label": "modifier",
        "remove.word.subtitle": "Supprimer le mot du sous-titre uniquement",
        "erase.subtitle": "effacer du sous-titre",
        "remove.word.clip": "Supprimer le mot de l'audio et du sous-titre",
        "remove.clip": "supprimer du clip"
      },
      "utils": {
        "video.utils.title": "Titre",
        "video.utils.currentTime": "Temps actuel",
        "video.utils.nextTime": "Prochain moment",
        "video.utils.duration": "Durée",
        "video.utils.description": "Description",
        "video.utils.srtSegment": "Segment SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Votre texte de sous-titre ici"
      }
    }
  },
  "it": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "DIVENTA NOSTRO PARTNER",
        "SHARE_PODSQUEEZE": "Condividi Podsqueeze con il tuo pubblico",
        "AND_EARN_MONEY": "e guadagna!",
        "LAST_UPDATED": "Ultimo aggiornamento: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Diventa un Partner Affiliato",
        "EARN_COMMISSION": "Guadagna una",
        "COMMISSION": "commissione",
        "ON_EVERY_SALE": "su ogni vendita effettuata tramite il tuo link di riferimento esclusivo per un periodo di 15 mesi. Condividi il tuo link sul tuo sito web, sui social media o con i tuoi amici. Iscriversi richiede solo pochi secondi.",
        "GET_AUTOMATICALLY_APPROVED": "Ottieni l'approvazione automatica.",
        "JOIN_NOW": "Iscriviti ora",
        "HOW_IT_WORKS": "COME FUNZIONA",
        "FREQUENTLY_ASKED_QUESTIONS": "Domande Frequenti",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Cos'è un Partner Affiliato?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Un Partner Affiliato è qualcuno che promuove i prodotti o servizi di un'altra azienda tramite un link di riferimento unico e guadagna una commissione su ogni vendita effettuata tramite quel link.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Come posso diventare un Partner Affiliato?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Diventare un Partner Affiliato è rapido e semplice, richiede solo pochi secondi. Per iniziare, basta cliccare sul pulsante 'Iscriviti ora' e registrarsi utilizzando la propria email. Una volta registrato, avrai accesso a una dashboard facile da usare dove troverai il tuo link di riferimento unico. Condividi questo link con la tua famiglia, i tuoi amici o il tuo pubblico online. Ogni volta che qualcuno clicca sul tuo link di riferimento ed effettua un acquisto sul sito di Podsqueeze, guadagnerai una commissione del 25% su ogni pagamento per un intero periodo di 15 mesi! Tieni traccia dei tuoi guadagni senza sforzo attraverso la tua dashboard Affiliato, che fornisce una visione chiara di tutte le vendite che hai generato.",
        "HOW_CAN_I_TRACK_MY_SALES": "Come posso monitorare le mie vendite e commissioni?",
        "TRACKING_SALES_DESCRIPTION": "Utilizza la nostra dashboard del programma di affiliazione per monitorare le tue vendite e commissioni. Il software di tracciamento è disponibile sia per i Partner Affiliati che per i Partner Commerciali.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Quando e come riceverò il pagamento?",
        "PAYMENT_DESCRIPTION": "Riceverai il pagamento tramite PayPal ogni 30 giorni. Si prega di notare che esiste una soglia minima di pagamento di $50. Non appena raggiungi questo importo, puoi aspettarti di ricevere il pagamento come un orologio ogni 30 giorni.",
        "STILL_GOT_QUESTIONS": "HAI ANCORA DOMANDE?",
        "SEND_US_A_MESSAGE": "Inviaci un messaggio nella chat di supporto o scrivici a team@podsqueeze.com",
        "NOTE": "Nota",
        "AFFILIATE_ADS_RESTRICTION": "Gli affiliati non sono autorizzati a creare annunci su Google o a partecipare a offerte per parole chiave rilevanti associate a Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Termini di Utilizzo per Affiliati",
        "CAN_I_RUN_ADS": "Posso eseguire annunci e campagne CPC su Google per promuovere il mio link di riferimento?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Gli affiliati non sono autorizzati a creare annunci sui motori di ricerca o a partecipare a offerte per parole chiave relative a Podsqueeze. Questa restrizione aiuta a mantenere l'integrità della nostra strategia pubblicitaria e garantisce un messaggio di marca coerente. Si prega di notare che le vendite risultanti da tali campagne non saranno idonee per il pagamento.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Come genera Podsqueeze i titoli per il tuo Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Barra di Navigazione",
        "main.affiliateHero": "Eroe degli Affiliati",
        "main.footer": "Piede di Pagina"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Aggiungi Musica di Introduzione e Chiusura",
        "intro.music": "Musica di Introduzione",
        "outro.music": "Musica di Chiusura",
        "intro.duration": "Durata Introduzione",
        "outro.duration": "Durata Chiusura",
        "intro.mode": "Modalità Introduzione",
        "outro.mode": "Modalità Chiusura",
        "cancel": "Annulla",
        "save": "Salva",
        "apply": "Applica",
        "current.intro.music": "Musica di Introduzione Attuale",
        "current.outro.music": "Musica di Chiusura Attuale",
        "change.music": "Cambia Musica",
        "choose.music": "Scegli File Musicale",
        "browser.not.support.audio": "Il tuo browser non supporta l'elemento audio.",
        "save.and.apply": "Salva e Applica",
        "no.music.selected": "Nessuna musica selezionata",
        "delete.music": "Elimina musica",
        "uploading.file": "Caricamento del file..."
      },
      "audioEditElements": {
        "error.processing.rss": "Stiamo riscontrando alcune difficoltà nel processare alcuni feed RSS. Per favore, carica un file.",
        "edit.enhance.audio": "Modifica e migliora la tua registrazione audio",
        "trial.label": "Prova",
        "audio.editing.experience": "Sperimenta un'esperienza di modifica audio senza interruzioni con algoritmi IA avanzati per risultati naturali e di alta qualità, con un solo clic.",
        "improve.audio.quality": "Migliora la Qualità dell'Audio",
        "remove.hums.silences": "Elimina Ronzii e Silenzi",
        "upgrade.edit.audio": "Aggiorna per poter modificare il tuo audio con un solo clic",
        "available.plans": "Disponibile per tutti i piani pagati",
        "upgrade.now": "Aggiorna Ora",
        "audio.element.support": "Il tuo browser non supporta l'elemento audio.",
        "download.audio": "Scarica Audio",
        "loading.audio": "Caricamento Audio",
        "editing.audio": "Modificando Audio"
      },
      "videoEditElements": {
        "error.exporting.video": "Errore durante l'esportazione del video",
        "download.failed": "Download fallito: {error.message}",
        "generating.video": "Video in generazione",
        "error.generating.clip": "Errore durante la generazione del clip",
        "please.retry.support": "Si prega di riprovare o contattare il nostro supporto utenti",
        "browser.not.support.video": "Il tuo browser non supporta il tag video.",
        "this.might.take.minutes": "Si prega di non chiudere la finestra, potrebbe richiedere alcuni minuti.",
        "exporting.video": "Il tuo video sta venendo esportato...",
        "seamless.audio.editing": "Vivi un'esperienza di editing audio senza soluzione di continuità con algoritmi AI avanzati per risultati naturali e di alta qualità, con un solo clic.",
        "difficulties.processing.rss": "Abbiamo riscontrato alcune difficoltà nel processare alcuni feed RSS. Si prega di caricare un file.",
        "edit.enhance.video.recording": "Modifica e migliora la tua registrazione video",
        "trial": "Versione di prova",
        "enhance.audio.quality": "Migliora la qualità audio",
        "enhance.audio.quality.edit": "Migliora e modifica la qualità audio",
        "trim.filler.words.video": "Taglia le parole di riempimento dal video (ad es. ehm)",
        "trim.long.silences.video": "Taglia le lunghe pause dal video",
        "upgrade.to.edit.video": "Aggiorna per poter modificare il tuo video con un solo clic",
        "available.pro.agency.plans": "Disponibile per i piani Pro e Agenzia",
        "upgrade.now": "Aggiorna ora",
        "download.only.audio": "Scarica solo audio",
        "download.video": "Scarica video",
        "please.dont.close.window": "Si prega di non chiudere la finestra",
        "export.video": "Esporta video"
      },
      "videogramBaseTemplate": {
        "media.fit": "adattare",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "durata"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Altri episodi di questo Podcast",
        "tab.shownotes": "Note della puntata",
        "tab.timestamps": "Indicatori temporali",
        "tab.blogpost": "Articolo del blog",
        "tab.transcript": "Trascrizione",
        "key.points": "Punti chiave"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "La tua pagina di destinazione è attiva nel nostro motore di ricerca podcast. Condividila con il tuo pubblico!",
        "landingPage.create": "Crea una bellissima pagina di destinazione per questo episodio",
        "landingPage.edit": "Modifica Pagina",
        "landingPage.visit": "Visita Pagina",
        "landingPage.delete": "Elimina Pagina",
        "landingPage.createButton": "Crea Pagina di Destinazione"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Gestisci i link degli episodi",
        "youtube.link": "Link di YouTube",
        "enter.youtube.link": "Inserisci il link di YouTube",
        "apple.podcasts.link": "Link di Apple Podcasts",
        "enter.apple.podcasts.link": "Inserisci il link di Apple Podcasts",
        "spotify.link": "Link di Spotify",
        "enter.spotify.link": "Inserisci il link di Spotify",
        "saving": "Salvando...",
        "save": "Salva",
        "social.links.updated.successfully": "I link social sono stati aggiornati con successo!"
      },
      "affiliatesection": {
        "affiliate.section.title": "DIVENTA UN PARTNER AFFILIATO",
        "affiliate.section.subtitle": "Condividi Podsqueeze con il tuo pubblico e",
        "affiliate.section.earn": "guadagna denaro!",
        "affiliate.section.commission": "Il nostro programma di affiliazione offre una commissione del 25% per 15 mesi, su ogni vendita e pagamento di rinnovo dell'abbonamento.",
        "affiliate.section.join": "Ci vogliono solo pochi secondi per iscriversi!",
        "affiliate.section.knowMore": "Scopri di più"
      },
      "asseenon": {
        "podnews.logo": "logo di podnews",
        "transistor.logo": "logo di transistor",
        "thepodcasthost.logo": "logo di the podcast host",
        "schoolofpodcasting.logo": "logo della Scuola di Podcasting",
        "semrush.logo": "logo di semrush"
      },
      "assembleshownotes": {
        "episode.description": "Descrizione dell'episodio",
        "bullet.points": "Punti chiave",
        "timestamps": "Timestamp",
        "links.and.mentions": "Link e menzioni",
        "extra.content": "Contenuto extra",
        "assemble.show.notes": "Raccogli le tue note dello spettacolo",
        "downloading": "Scaricando",
        "copied": "Copiato",
        "enter.placeholder": "Inserisci {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Prendendo una pausa dalla creazione di podcast",
        "cancellation.option.no_recurrent": "Non voglio un abbonamento ricorrente",
        "cancellation.option.expensive": "È troppo costoso",
        "cancellation.option.not_saving_time": "Non mi sta risparmiando abbastanza tempo",
        "cancellation.option.dissatisfied_content": "Insoddisfatto della qualità del contenuto generato",
        "cancellation.option.unresponsive_support": "Il supporto al cliente non risponde",
        "cancellation.option.not_using": "Non sto utilizzando il servizio abbastanza",
        "cancellation.option.difficulty_navigating": "Difficoltà nell'uso/navigazione del prodotto",
        "cancellation.option.better_alternative": "Ho trovato un prodotto alternativo migliore",
        "cancellation.option.other": "Altro",
        "cancellation.video.message": "Il 70% dei nostri utenti interrompe il processo di cancellazione dopo aver visto questo video",
        "cancellation.button.cancel": "Voglio Ancora Annullare",
        "cancellation.button.try_again": "Voglio Riprovare",
        "cancellation.prompt.select_reason": "Per favore, aiutaci a migliorare il prodotto selezionando il motivo per cui stai cancellando il tuo abbonamento:",
        "cancellation.placeholder.answer": "Scrivi la tua risposta qui...",
        "cancellation.placeholder.specify_reason": "Per favore specifica il tuo motivo per la cancellazione",
        "cancellation.button.next": "Avanti",
        "cancellation.button.go_back": "Torna indietro",
        "cancellation.last_question.title": "Ultima Domanda da Parte Nostra",
        "lose.all.accumulated.minutes": "Se annullate, perderete tutti i minuti accumulati.",
        "keep.accumulating.minutes": "Se annullate, i minuti accumulati verranno persi.",
        "generate.articles.favorite.podcasts.and.vides": "Genera articoli dai tuoi podcast preferiti",
        "convert.and.repurpose.episodes": "Converti e riutilizza i tuoi episodi più vecchi in nuovo contenuto",
        "here.are.some.ideas": "Ecco alcune idee per aiutarti a continuare a trarre vantaggio da Podsqueeze",
        "share.your.account.with.a.friend": "Condividi il tuo account con un amico che potrebbe essere utile",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Ecco un video che mostra come utilizzare Podsqueeze al meglio",
        "cancellation.last_question.prompt": "Quali cambiamenti o miglioramenti ti farebbero considerare di riunirti al nostro servizio?",
        "cancellation.feedback.message": "Il tuo feedback ci aiuterà a migliorare 🙏",
        "cancellation.button.confirm": "Conferma Cancellazione",
        "cancellation.minutes.accumulated": "Hai",
        "cancellation.minutes.accumulated.suffix": "minuti accumulati, del valore di",
        "cancellation.reminder.text": "Ricorda:",
        "cancellation.minutes.warning": "I minuti accumulati sono un vantaggio per gli abbonamenti attivi. Cancellando il tuo abbonamento i tuoi minuti saranno persi permanentemente.",
        "cancellation.content.deletion.warning": "Tutto il tuo contenuto generato sarà eliminato permanentemente dopo 30 giorni.",
        "cancellation.minutes.left.title": "Hai Ancora Minuti Rimasti! Non Lasciarli Sprecare!",
        "cancellation.suggestion.clips": "Riutilizza episodi più vecchi in clip per i social media",
        "cancellation.suggestion.articles": "Trasforma episodi più vecchi in articoli con Podsqueeze per beneficiare del SEO.",
        "cancellation.suggestion.linkedin": "Trasforma episodi di autorità più vecchi in post LinkedIn per potenziare il tuo brand personale",
        "cancellation.suggestion.share": "Condividi il tuo account Podsqueeze con un amico così può beneficiare dei tuoi minuti inutilizzati.",
        "cancellation.button.keep.subscription": "Mantieni Il Mio Abbonamento",
        "cancellation.button.keep.minutes": "Mantieni I Miei",
        "cancellation.button.keep.minutes.suffix": "del Valore di Minuti",
        "cancellation.lifetime.before_you_go": "Prima che tu vada...",
        "cancellation.lifetime.title": "Che ne dici dell'accesso a vita per soli $49?",
        "cancellation.lifetime.subtitle": "Mantieni il tuo account Starter. Niente abbonamenti. Niente rinnovi. Solo tuo — per sempre.",
        "cancellation.lifetime.feature1": "Accesso a vita a Podsqueeze per un pagamento unico di $49",
        "cancellation.lifetime.feature2": "Usalo quando ne hai bisogno, senza pressioni — è tuo per sempre",
        "cancellation.lifetime.feature3": "Include tutte le funzionalità attuali e future del Piano Starter",
        "cancellation.lifetime.button_cancel": "Voglio ancora cancellare",
        "cancellation.lifetime.button_deal": "Ottieni l'offerta a vita",
        "cancellation.downgrade.title": "Mantieni tutti i tuoi contenuti per soli $5.99/mese",
        "cancellation.downgrade.subtitle": "Passando a Starter puoi...",
        "cancellation.downgrade.feature1": "Mantenere tutti i tuoi contenuti generati",
        "cancellation.downgrade.feature2": "Mantenere i tuoi siti web attivi",
        "cancellation.downgrade.feature3": "160 minuti e 10 clip al mese per lavori occasionali",
        "cancellation.billing.monthly": "Mensile",
        "cancellation.billing.annual": "Annuale",
        "cancellation.billing.discount": "30% SCONTO",
        "cancellation.plan.starter": "Piano Starter",
        "cancellation.price.monthly": "$8.99/mese",
        "cancellation.price.annual": "$5.99/mese",
        "cancellation.price.annual_billing": "fatturato $71.88 annualmente",
        "cancellation.feature.minutes": "160 min/mese",
        "cancellation.feature.clips": "10 clip/mese",
        "cancellation.downgrade.button": "Passa a Starter e Mantieni il Contenuto",
        "cancellation.error.payment_link": "Impossibile ottenere il link di pagamento. Riprova.",
        "cancellation.error.payment_service": "Errore nella connessione al servizio di pagamento.",
        "cancellation.option.question.break": "Puoi dirci di più sul perché stai prendendo una pausa?",
        "cancellation.option.question.no_recurrent": "Potresti condividere perché preferisci non avere un abbonamento ricorrente?",
        "cancellation.option.question.expensive": "Quali prezzi o funzionalità renderebbero il servizio più prezioso per te?",
        "cancellation.option.question.not_saving_time": "Cosa ti sta ancora portando via molto tempo nel tuo processo?",
        "cancellation.option.question.dissatisfied_content": "Di quali aspetti del contenuto non eri soddisfatto?",
        "cancellation.option.question.unresponsive_support": "Puoi descrivere la tua esperienza con il nostro supporto clienti?",
        "cancellation.option.question.not_using": "C'è qualcosa che ti incoraggerebbe a usare il servizio più spesso?",
        "cancellation.option.question.difficulty_navigating": "Quali difficoltà hai incontrato nell'usare/navigare il prodotto?",
        "cancellation.option.question.better_alternative": "Quale prodotto alternativo hai trovato e cosa ti piace di esso?",
        "cancellation.option.question.other": "Per favore specifica la tua ragione per la cancellazione:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Valorizziamo la tua privacy",
        "cookiebanner.cookieUsage": "Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito e analizzare il nostro traffico. Cliccando su accetta, acconsenti al nostro utilizzo dei cookie.",
        "cookiebanner.privacyPolicy": "Politica sulla riservatezza",
        "cookiebanner.accept": "Accettare",
        "cookiebanner.decline": "Rifiutare"
      },
      "episodeTitleBox": {
        "loading": "Caricamento...",
        "editEpisodeTitleClicked": "Titolo dell'episodio modificato",
        "newEpisodeTitleStored": "Nuovo titolo dell'episodio salvato"
      },
      "famewall": {
        "loading.message": "Caricamento..."
      },
      "footer": {
        "footer.features": "Caratteristiche",
        "footer.transcriptGenerator": "Generatore di Trascrizioni",
        "footer.subtitlesGenerator": "Generatore di Sottotitoli",
        "footer.descriptionGenerator": "Generatore di Descrizioni",
        "footer.podcastSummarizer": "Generatore di Sommari di Podcast",
        "footer.titlesGenerator": "Generatore di Titoli",
        "footer.bulletPointsGenerator": "Generatore di Punti Chiave",
        "footer.chaptersClipsGenerator": "Generatore di Capitoli e Clip",
        "footer.socialMediaPostsGenerator": "Generatore di Post sui Social Media",
        "footer.newsletterGenerator": "Generatore di Newsletter",
        "footer.blogPostGenerator": "Generatore di Post del Blog",
        "footer.podcastLandingPages": "Pagine di Atterraggio del Podcast",
        "footer.podcastClipMaker": "Creatore di Clip del Podcast",
        "footer.audiogramGenerator": "Generatore di Audiogrammi",
        "footer.aiAudioEnhancer": "Miglioratore Audio AI",
        "footer.convertYoutubeToText": "Convertire Youtube in Testo",
        "footer.youtubeVideoNoiseRemover": "Rimuovi Rumore Video di Youtube",
        "footer.youtubeVideoKeyPoints": "Punti Chiave del Video di Youtube",
        "footer.freeResources": "Risorse Gratuite",
        "footer.findPodcastTopicIdeas": "Trova Idee per Temi di Podcast",
        "footer.articles": "Articoli",
        "footer.freeEbooks": "eBooks Gratuiti",
        "footer.community": "Comunità",
        "footer.ourPodcast": "Il Nostro Podcast",
        "footer.product": "Prodotto",
        "footer.giftCard": "Buono Regalo",
        "footer.onboardingEbook": "eBook di Integrazione",
        "footer.pricing": "Prezzi",
        "footer.affiliates": "Affiliati",
        "footer.media": "Media",
        "footer.testimonials": "Testimonianze",
        "footer.legal": "Legale",
        "footer.privacyPolicy": "Politica sulla Privacy",
        "footer.termsOfUse": "Termini di Uso",
        "footer.refundPolicy": "Politica di Rimborso",
        "footer.allRightsReserved": "Tutti i Diritti Riservati."
      },
      "globalState": {
        "cookie.enabled": "Cookies attivati",
        "language.default": "Lingua predefinita"
      },
      "head": {
        "keywords.list": "Podsqueeze, IA, Podcast, Generazione di contenuti, Trascrizione di podcast, Note di trasmissione, Timestamp, Newsletter di podcast, Tweet, Articoli del blog, Pubblicazioni sui social network, Titoli, Redattore di note di trasmissione"
      },
      "imageResultModal": {
        "download.image": "Scarica l'immagine",
        "generating.image": "Generazione dell'immagine",
        "ai.prompt.label": "Inserisci un prompt per far generare un'immagine all'IA",
        "ai.prompt.placeholder": "Es : Un cane che corre nel parco...",
        "processing": "In elaborazione...",
        "create": "Creare",
        "text.color.label": "Colore del testo",
        "quote.icon.color.label": "Colore dell'icona della citazione",
        "background.color.label": "Colore di sfondo",
        "font.label": "Carattere",
        "upload.cover.image": "Carica l'immagine di copertina",
        "aspect.ratio.info": "Rapporto di aspetto 1:1, dimensione consigliata 1200x1200",
        "upload.logo.label": "Carica il logo",
        "choose.file": "Scegli un file",
        "upload.success": "Caricamento riuscito",
        "choose.quote": "Scegli una citazione",
        "select.template": "Seleziona un modello",
        "quote.label": "Citazione",
        "enter.quote.here": "Inserisci la citazione qui",
        "author.label": "Autore",
        "enter.author.name": "Inserisci il nome dell'autore",
        "podcast.name.label": "Nome del podcast",
        "enter.podcast.name": "Inserisci il nome del podcast",
        "colors": "Colori",
        "select.font": "Seleziona un carattere",
        "cover.logo.images": "Immagini di copertina e logo",
        "logo.image": "Immagine del logo",
        "upgrade.here": "Aggiorna qui",
        "remove.logo": "Rimuovi logo Podsqueeze",
        "default_templates": "Modelli predefiniti",
        "saved_templates_count": "Modelli salvati",
        "save_current_template": "Salva modello corrente",
        "no_saved_templates": "Nessun modello salvato ancora",
        "save_template": "Salva modello",
        "cancel": "Annulla",
        "save": "Salva",
        "enter_template_name": "Inserisci il nome del modello",
        "reset_template": "Ripristina",
        "add_element": "Aggiungi Elemento",
        "generate": "Genera",
        "add_image": "Aggiungi Immagine",
        "upload_image": "Carica immagine",
        "or": "o",
        "generate_with_ai": "Genera con IA",
        "search_fonts": "Cerca caratteri...",
        "upload_logo": "Carica logo",
        "square_image_recommended": "Immagine quadrata consigliata",
        "opacity": "Opacità",
        "layers": "Livelli",
        "no_element_selected": "Nessun elemento selezionato",
        "bold_shortcut": "Grassetto (Ctrl+B)",
        "italic_shortcut": "Corsivo (Ctrl+I)",
        "underline_shortcut": "Sottolineato (Ctrl+U)",
        "edit_text": "Modifica testo",
        "tint_color": "Colore tinta",
        "toggle_gradient_transparent": "Attiva/disattiva gradiente trasparente",
        "rotate_gradient": "Ruota gradiente di 45 gradi",
        "alt_background": "Sfondo",
        "alt_podcast_logo": "Logo del Podcast",
        "alt_custom": "Personalizzato",
        "alt_right_side": "Lato Destro",
        "alt_profile": "Profilo"
      },
      "intentModal": {
        "intentModal.title": "Cosa desideri fare con Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Scrivere le note dello spettacolo",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Scrivere un post sul blog e una newsletter",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Creare clip video o audiogrammi",
        "intentModal.sourceOption.Create_Quote_Images": "Creare immagini di citazioni",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Modificare e migliorare audio/video",
        "intentModal.sourceOption.Transcribe": "Trascrivere",
        "intentModal.sourceOption.Create_a_Website": "Creare un sito web",
        "intentModal.sourceOption.All_of_the_Above": "Tutto quanto sopra",
        "intentModal.sourceOption.Other": "Altro",
        "intentModal.otherPlaceholder": "Per favore specifica",
        "intentModal.submitButton": "Invia e registra",
        "intentModal.skip": "Salta"
      },
      "languageSwitcher": {
        "language.en": "Inglese",
        "language.es": "Spagnolo",
        "language.fr": "Francese",
        "language.de": "Tedesco",
        "language.it": "Italiano",
        "language.pt": "Portoghese",
        "language.nl": "Olandese",
        "language.pl": "Polacco",
        "language.ru": "Russo",
        "language.zh": "Cinese",
        "language.ja": "Giapponese",
        "language.ko": "Coreano",
        "language.ar": "Arabo",
        "language.th": "Tailandese",
        "language.vi": "Vietnamita"
      },
      "lazyImage": {
        "lazyImage.alt": "Descrizione dell'immagine"
      },
      "metadata": {
        "meta.title": "Titolo della tua pagina",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Utilità"
      },
      "navbar": {
        "navbar.dashboard": "Cruscotto",
        "navbar.login": "Accesso",
        "navbar.openMenu": "Apri il menu principale",
        "navbar.features": "Caratteristiche",
        "navbar.resources": "Risorse",
        "navbar.pricing": "Prezzi",
        "navbar.contact": "Contatto",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "Vedi tutte le caratteristiche",
        "navbar.mainFeatures": "CARATTERISTICHE PRINCIPALI",
        "navbar.podcastTranscription": "Generatore di trascrizioni di podcast e video",
        "navbar.transcriptionDescription": "Trascrizione ad alta precisione con etichettatura degli speaker e file SRT per i sottotitoli.",
        "navbar.podcastSummarizer": "Riassuntore di podcast",
        "navbar.summarizerDescription": "Crea note complete del programma 20 volte più velocemente, con la tua voce.",
        "navbar.podcastClipMaker": "Creatore di clip di podcast",
        "navbar.clipMakerDescription": "Genera automaticamente clip brevi o audiogrammi per il tuo podcast.",
        "navbar.audioEnhancer": "Miglioratore audio Ai",
        "navbar.audioEnhancerDescription": "Migliora automaticamente l'audio, elimina i silenzi e le parole di riempimento.",
        "navbar.podsqueezeFeaturesWalkthrough": "GUIDA ALLE CARATTERISTICHE DI PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Articoli e guide pratiche per lanciare e far crescere un podcast di successo.",
        "navbar.podcastTopicIdeas": "Idee per temi di podcast",
        "navbar.topicIdeasDescription": "Scopri i temi dei podcast che il pubblico sta cercando.",
        "navbar.actionableEbooks": "eBook Pratici",
        "navbar.ebooksDescription": "Scarica eBook gratuiti con consigli pratici per portare il tuo podcast al livello successivo.",
        "navbar.freeThumbnailMaker": "Creatore Gratuito di Miniature per Podcast",
        "navbar.freeThumbnailMakerDescription": "Crea miniature professionali e accattivanti per episodi con l'IA.",
        "navbar.seoOptimizer": "Ottimizzatore SEO",
        "navbar.seoOptimizerDescription": "Ottimizza i tuoi episodi podcast per una migliore visibilità nei motori di ricerca.",
        "navbar.podcastDescription": "Ascolta il nostro podcast, dove intervisiamo podcaster esperti e utenti di Podsqueeze da tutto il mondo. Chiediamo loro di condividere i loro consigli, intuizioni, storie e tutto ciò che devi sapere per far crescere il tuo podcast."
      },
      "resultModal": {
        "prompt.transcript.quote": "Citazione",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Note di presentazione in prima persona",
        "prompt.shownotes.replaceName": "Sostituisci nome nelle note di presentazione",
        "prompt.shownotes.friendlyTone": "Note di presentazione in tono amichevole",
        "prompt.shownotes.youtubeDescription": "Descrizione di YouTube nelle note di presentazione",
        "prompt.shownotes.engagingQuestion": "Domanda coinvolgente nelle note di presentazione",
        "prompt.newsletter.casualTone": "Newsletter in tono informale",
        "prompt.newsletter.shorter": "Newsletter più corta",
        "prompt.newsletter.contentSections": "Sezioni di contenuto nella newsletter",
        "prompt.newsletter.changeName": "Cambia nome nella newsletter",
        "prompt.mentions.fullURL": "Menzioni con URL completa",
        "prompt.mentions.replaceName": "Sostituisci nome nelle menzioni",
        "prompt.tweets.underdogTone": "Tweets in tono di sfavorito",
        "prompt.tweets.firstPerson": "Tweets in prima persona",
        "prompt.shortPost.relevantEmojis": "Emojis pertinenti nel post breve",
        "prompt.shortPost.educationalTone": "Post breve in tono educativo",
        "prompt.shortPost.underdogTone": "Post breve in tono di sfavorito",
        "prompt.shortPost.firstPerson": "Post breve in prima persona",
        "prompt.titles.youtubeOptimized": "Titoli ottimizzati per YouTube",
        "prompt.titles.startWithHowTo": "Inizia con titoli 'Come fare'",
        "prompt.titles.otherOptions": "Altre opzioni per i titoli",
        "prompt.keywords.youtubeOptimized": "Parole chiave ottimizzate per YouTube",
        "prompt.keywords.separateWithCommas": "Separa le parole chiave con le virgole",
        "prompt.quotes.lorem1": "Citazione di Lorem ipsum 1",
        "prompt.quotes.lorem2": "Citazione di Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Punto elenco di Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Punto elenco di Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Post lungo in prima persona",
        "prompt.longPost.relevantEmojis": "Emojis pertinenti nel post lungo",
        "prompt.longPost.changeName": "Cambia nome nel post lungo",
        "alert.tuningInstructionsEmpty": "Le istruzioni di regolazione non possono essere vuote.",
        "text.timestamps.byPodsqueeze": "Timestamp da PodSqueeze",
        "button.copied": "Copiato",
        "button.copy": "Copia",
        "embed.transcript": "Incorpora trascrizione",
        "embed.description": "Descrizione per incorporare",
        "preview.title": "Titolo dell'anteprima",
        "loading.regenerating": "Rigenerando...",
        "placeholder.tuningInstructions": "Inserisci istruzioni di regolazione...",
        "button.saveClose": "Salva e chiudi",
        "button.acceptChanges": "Accetta modifiche",
        "button.discard": "Scarta",
        "button.embedTranscript": "Incorpora trascrizione",
        "text.copiedToClipboard": "Copiato negli appunti",
        "download.srtFile": "Scarica file SRT",
        "text.forCaptions": "per sottotitoli",
        "tune.title": "Regola i tuoi risultati",
        "tune.description": "Regola i tuoi risultati con le seguenti opzioni.",
        "instruction.label": "Istruzioni:",
        "button.tuneResult": "Regola risultato",
        "instruction.saveForLater": "Salva per dopo",
        "button.readMore": "Leggi di più",
        "button.showLess": "Mostra meno",
        "customPrompt.used": "Prompt personalizzato usato:",
        "feedback.happyWithResults": "Sei soddisfatto dei risultati?",
        "prompt.timestamps.formatAsChapters": "Formattare i timestamp come capitoli con titoli descrittivi",
        "prompt.timestamps.detailedDescriptions": "Creare timestamp dettagliati con descrizioni degli argomenti e punti chiave",
        "prompt.timestamps.improveSpeakerNames": "Sostituire i nomi degli oratori con titoli più descrittivi come 'Conduttore', 'Esperto' o 'Ospite'"
      },
      "resultModalTranscript": {
        "prompt.quote": "Trova tre buone citazioni dal trascritto",
        "prompt.blog": "Scrivi un articolo di blog di 500 parole incentrato sul tema X",
        "prompt.tweets": "Scrivi tre tweet accattivanti dal trascritto",
        "transcript.autoTranscribed": "Trascritto automaticamente con Podsqueeze",
        "alert.emptyPrompt": "Le istruzioni di regolazione non possono essere vuote",
        "embed.transcript": "Incorpora trascritto",
        "embed.description": "Incorpora un trascritto di dimensioni gestibili con una funzione di ricerca nel tuo sito WordPress o in qualsiasi pagina compatibile con HTML.",
        "button.copied": "Copiato!",
        "button.copy": "Copia",
        "preview.title": "Anteprima",
        "edit.speakers": "Modifica i nomi degli oratori",
        "button.saveClose": "Salva e chiudi",
        "placeholder.prompt": "es: Trova tre buone citazioni dal trascritto",
        "upgrade.pro": "Aggiorna a Pro per utilizzare questa funzione",
        "upgrade.link": "Aggiorna a Pro",
        "button.generate": "Genera",
        "feedback.happy": "Sei soddisfatto dei risultati?",
        "instruction": "Istruzione: ",
        "generating.results": "Generando risultati",
        "full.transcription": "Trascrizione completa",
        "srt.file": "& file SRT",
        "download.srt": "Scarica file SRT",
        "caption.subtitles": "per sottotitoli e didascalie.",
        "generate.from.transcript": "Genera dal trascritto con Gpt-4o",
        "gpt.tweak.text": "Chiedi all'ultimo GPT di regolare il testo a tuo piacimento. Usa un linguaggio naturale e non aver paura di essere specifico.",
        "copied.clipboard": "Copiato negli appunti",
        "transcript.public.available": "URL disponibile",
        "audio.notSupported": "Il tuo browser non supporta l'elemento audio.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Aggiungi il nome del podcast",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Come hai saputo di Podsqueeze?",
        "sourceModal.otherPlaceholder": "Per favore specifica",
        "sourceModal.nextButton": "Successivo",
        "sourceModal.skip": "Salta"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Stiamo riscontrando alcune difficoltà nel processare alcuni feed RSS. Per favore, carica un file."
      },
      "squeezeResults": {
        "copiedToClipboard": "Copiato negli appunti",
        "publicLink": "Pubblico in",
        "createLink": "Crea un link per condividere questa pagina di risultati",
        "assembleShowNotes": "Raccogliere le note dello spettacolo",
        "convertAnotherEpisode": "Converti un altro episodio",
        "writtenContent": "Contenuto scritto",
        "videoClipsAndImages": "Clip video e immagini",
        "editAudio": "Modifica audio"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Vedi di più e regola",
        "see.more": "Vedi di più",
        "generating": "Generando",
        "download.all": "Scarica tutto",
        "full.transcription": "Trascrizione completa",
        "transcript.benefit": "Sapevi che aggiungere trascrizioni complete alle tue note del programma aumenta il traffico e l'interazione sul sito web?",
        "learn.more": "Per saperne di più",
        "transcript.bonus": "Puoi fornire trascrizioni complete come un bonus per il tuo programma di adesione al podcast.",
        "show.notes": "Note del programma",
        "show.notes.engagement": "Considera di integrare questa breve descrizione con altri elementi nelle tue note del programma per aumentare l'interazione e il SEO.",
        "show.notes.examples": "Trova ispirazione in questi 17 esempi di note di programmi di podcast per creare quelle perfette per il tuo podcast.",
        "timestamps": "Timestamp",
        "timestamps.benefit": "Aggiungi questi timestamp alla descrizione del tuo episodio e si creeranno automaticamente capitoli su Spotify e YouTube.",
        "titles": "Titoli",
        "titles.engagement": "I titoli che includono segni di domanda e superlativi tendono ad essere particolarmente attraenti.",
        "links.and.mentions": "Link e Menzioni",
        "mentions.resources": "Considera di includere le menzioni qui sotto nella sezione risorse delle tue note del programma.",
        "mentions.affiliate": "Verifica se i prodotti menzionati hanno programmi di affiliazione e considera di aggiungere link di affiliazione nelle tue note del programma.",
        "mentions.social.media": "Tagga le persone menzionate nel tuo episodio sui social media per incoraggiarle a condividere e interagire con il tuo post.",
        "keywords": "Parole chiave",
        "keywords.youtube": "Quando carichi il tuo episodio su YouTube, copia e incolla semplicemente queste parole chiave nella sezione delle etichette.",
        "keywords.social.media": "Riutilizza queste parole chiave per gli hashtag sui social media.",
        "blog.post": "Post del blog",
        "blog.post.linkedin": "Considera di utilizzare questo contenuto per creare un lungo post su Linkedin,",
        "blog.post.share": "Condividi questo contenuto nelle comunità di Reddit e nei gruppi di Facebook che si allineano con l'argomento del tuo podcast.",
        "newsletter": "Newsletter",
        "newsletter.content": "Alcuni dei nostri utenti riutilizzano questo contenuto della newsletter per creare descrizioni di episodi più complete per le note del programma.",
        "linkedin.and.facebook": "Linkedin e Facebook",
        "short.post.description": "Usa questi brevi post come descrizioni quando condividi clip video correlate e audiogrammi sui social media.",
        "tweets": "Tweet",
        "quotes": "Citazioni",
        "bullet.points": "Punti chiave",
        "add.custom.result": "Aggiungi risultato personalizzato",
        "bullet.points.skimming": "I podcaster spesso elencano i temi principali dell'episodio come punti chiave nelle note del programma per facilitare la lettura veloce."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Vedi di più e sintonizza",
        "generating": "Generando",
        "not.available.for.rss.feed": "Non disponibile per questo feed RSS",
        "regenerate.episode.upload.file": "Rigenera l'episodio e carica il tuo file audio/video direttamente dal tuo computer",
        "processing.difficulties": "Stiamo riscontrando alcune difficoltà nel processare alcuni feed RSS. Per favore, carica un file.",
        "video.clips": "Clip video",
        "ai.short.clips": "Clip brevi di IA",
        "quote.image": "Immagine di citazione"
      },
      "title": {
        "title.text": "tu.etichetta"
      },
      "topbar": {
        "topbar.forYou": "Per Te",
        "topbar.joinPodcast": "Unisciti alla nostra prossima riunione virtuale di podcasting!",
        "topbar.saveYourSpot": "Prenota Il Tuo Posto",
        "topbar.dismiss": "Scartare"
      },
      "trackers": {
        "trackers.init": "Inizializzando i tracker con i cookie abilitati: ",
        "trackers.loadScripts": "Caricamento degli script di tracciamento..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Benvenuto alla Mia Applicazione",
        "content.description": "Questa è un'applicazione di esempio che dimostra la traduzione.",
        "button.submit": "Invia"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI sta modificando il tuo clip",
        "export_clip": "Esporta Clip",
        "ai_edit": "Modifica IA",
        "ai_editing_clip_duration": "Ci vorranno alcuni secondi",
        "generating_clip": "Generando il tuo clip...",
        "generating_clip_notice": "Potrebbe richiedere alcuni minuti. Ti invieremo un'email una volta che è pronto.",
        "edit_another_video": "Puoi aspettare qui o modificare un altro video",
        "download_video": "Scarica Video",
        "back_to_editing": "Torna alla Modifica",
        "export_video_button": "Esporta Clip",
        "notice_storage": "Avviso: Conserviamo il tuo audio per 30 giorni. Dopo questo periodo, questo clip scadrà.",
        "error_generating_clip": "Errore nella Generazione del Clip",
        "error_user_support": "Per favore, prova di nuovo o contatta il nostro supporto utenti",
        "select_template": "Seleziona modello",
        "add_30s_prev": "30s del capitolo precedente",
        "add_30s_next": "30s del prossimo capitolo",
        "undo": "Annulla",
        "subtitles_font": "Font dei Sottotitoli",
        "subtitles_color": "Colore dei Sottotitoli",
        "subtitles_box_color": "Colore dell'animazione",
        "adjust_podcast_title_position": "Regola la Posizione Verticale del Titolo del Podcast",
        "adjust_subtitles_size": "Regola la Dimensione dei Sottotitoli",
        "adjust_subtitles_vertical_position": "Regola la Posizione Verticale dei Sottotitoli",
        "remove_subtitles": "Rimuovi Sottotitoli",
        "animated_subtitles": "Sottotitoli Animati",
        "upgrade_here": "Aggiorna qui",
        "remove_logo": " per rimuovere il logo",
        "remove_podsqueeze_logo": "Rimuovi logo di podsqueeze",
        "aspect_ratio": "Rapporto di aspetto",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Feed di Instagram",
        "reels": "Reels, Storie, YouTube Shorts, TikTok",
        "episode_title": "Titolo dell'Episodio",
        "podcast_title": "Titolo del Podcast",
        "titles_font": "Font dei Titoli",
        "title_colors": "Colori dei titoli del podcast/episodio",
        "video_fit": "Adattamento Video",
        "adjust_horizontal_position": "Regola la Posizione Orizzontale",
        "adjust_vertical_position": "Regola la Posizione Verticale",
        "adjust_video_zoom": "Regola il Zoom del Video",
        "adjust_video_width": "Regola la Larghezza del Video",
        "adjust_video_height": "Regola l'Altezza del Video",
        "background_color": "Colore di Sfondo",
        "edit_clip": "Modifica Clip",
        "edit_layout": "Modifica Layout",
        "choose_short": "Scegli un Short",
        "edit_audio": "Modifica Audio",
        "framing": "Incorniciatura",
        "background": "Sfondo",
        "text_style": "Stile del Testo",
        "music": "Musica",
        "choose_chapter": "Scegli un capitolo",
        "clips_left": "Ti rimangono",
        "apply_layout": "Applica Layout",
        "clips_left_number": "clip rimanenti",
        "need_more_clips": "Hai bisogno di più clip? Aggiorna il tuo piano qui",
        "download_srt_file": "Scarica File SRT",
        "track_selected": "Traccia: ",
        "no_background_music": "Non è stata selezionata musica di sfondo",
        "volume": "Volume:",
        "remove": "Rimuovi",
        "track_ambient_piano": "Piano ambientale e corde",
        "track_deep_meditation": "Meditazione profonda",
        "track_chill_upbeat": "Per il tuo ambiente rilassato e vivace",
        "track_inspiring_ambient": "Ambientazione cinematografica ispiratrice",
        "track_just_relax": "Semplicemente rilassati",
        "track_movement": "Movimento",
        "track_once_in_paris": "Una volta a Parigi",
        "track_perfect_beauty": "Bellezza perfetta",
        "track_summer_adventures": "Avventure estive",
        "track_sunset_groove": "Ritmo del tramonto",
        "track_tvari_cafe": "Caffè Tvari Tokyo",
        "track_short_piano_intermezzo": "Breve Intermezzo per Pianoforte",
        "track_dramatic_background": "Musica di Sottofondo Drammatica",
        "track_dramatic_hiphop": "Jazz Hip-Hop Drammatico",
        "track_emotional_orchestra": "Orchestra Emotiva",
        "track_halloween_short": "Musica di Halloween",
        "track_improvisation_037": "Improvvisazione Jazz",
        "track_inspiration_piano": "Pianoforte Ispirazionale",
        "track_medieval_extract": "Musica Medievale",
        "track_short_8": "Traccia Ambient Breve",
        "track_flute": "Flauto Tranquillo",
        "track_piano_guitar_duet": "Duetto Piano-Chitarra",
        "track_intro_jazz": "Jazz di Introduzione",
        "track_romantic_jazz": "Jazz Romantico",
        "recommended_for_youtube": "Consigliato per YouTube",
        "turn_into_short_clip": "Trasforma questo clip in un corto (<60s)",
        "browser_not_support_audio": "Il tuo browser non supporta l'elemento audio.",
        "watch_tutorial": "Guarda questo tutorial",
        "audiogram_maker": "su come sfruttare al meglio il nostro creatore di audiogrammi",
        "store_audio_notice": "Avviso: Conserviamo il tuo audio per 30 giorni.",
        "clip_maker": "su come sfruttare al meglio il nostro creatore di clip",
        "split_screen_mode": "Modalità di divisione dello schermo",
        "none": "Nessuno",
        "vertical_split": "Divisione verticale",
        "horizontal_split": "Divisione orizzontale",
        "layers": "Usa i livelli sottostanti per spostarli avanti o indietro.",
        "screen_1_horizontal_position": "Posizione Orizzontale Schermo 1",
        "screen_2_horizontal_position": "Posizione Orizzontale Schermo 2",
        "downloading": "Scaricando...",
        "download_again": "Scarica di nuovo",
        "download": "Scarica",
        "download_failed_alert": "Impossibile scaricare il video. Riprova.",
        "track_mysterious_dark_background": "Sfondo Misterioso Scuro",
        "track_acoustic_ambient_inspiration": "Ispirazione Acustica Ambientale",
        "track_aristocracy_classical": "Aristocrazia Classica",
        "track_folk_music_river_knows_my_name": "Musica Folk - Il Fiume Conosce Il Mio Nome",
        "track_funy_adventure": "Avventura Divertente",
        "track_energetic_sports_rock_trailer": "Trailer Rock Sportivo Energico",
        "track_fun_upbeat_energetic_pop_rock": "Pop Rock Energico Divertente",
        "track_epic_emotional_inspirational": "Epico Emotivo Ispirazionale",
        "track_inspirational_epic": "Epico Ispirazionale",
        "all_music": "Tutta la Musica",
        "energetic_music": "Energica",
        "inspirational_music": "Ispiratrice",
        "ambient_music": "Ambientale",
        "chill_music": "Rilassante",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Stravagante",
        "dramatic_music": "Drammatica",
        "acoustic_music": "Acustica",
        "classical_music": "Classica",
        "categories": "Categorie",
        "select_track": "Seleziona Traccia",
        "upload_music": "Carica Musica",
        "my_music": "La Mia Musica",
        "translate_subtitles": "Traduci Sottotitoli",
        "translate_to": "Traduci in",
        "select_language": "Seleziona Lingua",
        "select_new_language": "Seleziona nuova lingua",
        "translating": "Traduzione in corso...",
        "translation_complete": "Traduzione Completata",
        "error_translation": "Errore durante la traduzione. Riprova.",
        "original_language": "Originale"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Titolo dell'episodio"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Non c'è ancora contenuto disponibile.",
        "userPodcastsInfo.generateContent": "Genera il tuo primo contenuto",
        "placeholder.search_folders": "Cerca cartelle...",
        "search.no_results": "Nessuna cartella corrisponde alla tua ricerca."
      },
      "landingPageModal": {
        "upload.error": "Caricamento dell'immagine fallito: ",
        "upload.image.file": "Si prega di caricare un file immagine.",
        "upgrade.pro.message": "La personalizzazione della pagina è disponibile solo per gli account Pro e Agenzia",
        "upgrade.now": "Aggiorna ora",
        "upgrade.unique.landing.page": " e crea una pagina di destinazione dell'episodio unica.",
        "logo.recommendation": "Altezza del logo consigliata 200px",
        "social.links.top.menu": "Link sociali nel menu superiore",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Inserisci il link LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Inserisci il link Facebook",
        "saving...": "Salvataggio...",
        "save": "Salva",
        "saved.successfully": "Salvato con successo!",
        "uploading.image": "Caricamento dell'immagine...",
        "upload.episode.cover": "Carica la copertina dell'episodio",
        "upload.logo": "Carica il logo",
        "where.listen.episode": "Dove possiamo ascoltare questo episodio?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Inserisci il link YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Inserisci il link Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Inserisci il link Spotify",
        "image.size.recommendation": "Dimensione consigliata 1000x1000px",
        "primary.color.label": "Colore principale",
        "header.background.color": "Colore di sfondo dell'intestazione e dei link.",
        "landing.page.customization": "Personalizzazione della pagina di destinazione",
        "create.branded.landing.page": "Crea una bellissima pagina di destinazione del marchio da condividere con i tuoi ascoltatori",
        "episode.image": "Immagine dell'episodio",
        "episode.links": "Link dell'episodio",
        "page.header": "Intestazione della pagina",
        "page.color": "Colore della pagina",
        "visit.landing.page": "Visita la pagina di destinazione"
      },
      "page": {
        "loading.dashboard": "Caricamento del pannello di controllo",
        "convert.new.episode": "Converti nuovo episodio",
        "convert.audio.or.video": "Converti audio o video",
        "minutes.left": "Ti rimangono",
        "need.more.minutes": "Hai bisogno di più minuti?",
        "upgrade.plan": "Aggiorna il tuo piano qui.",
        "your.podcasts": "I tuoi podcast",
        "podsqueeze.results.page": "Pagina dei risultati di Podsqueeze",
        "access.podsqueeze.results": "Accedi ai risultati di Podsqueeze per questo episodio. Potrai vedere tutto il contenuto generato."
      },
      "podcast": {
        "confirm.delete_episode": "Sei sicuro di voler eliminare questo episodio?",
        "alert.something_wrong": "Qualcosa è andato storto. Per favore, riprova.",
        "confirm.delete_folder": "Sei sicuro di voler eliminare questa cartella?",
        "loading.episodes": "Caricamento episodi...",
        "folder.empty": "Questa cartella è vuota.",
        "content.no_content": "Nessun contenuto disponibile.",
        "content.generate_first": "Genera il tuo primo podcast.",
        "button.personalize_ai": "Personalizza con IA",
        "button.edit_website": "Modifica sito web",
        "button.visit_website": "Visita sito web",
        "button.generate_website": "Genera sito web",
        "placeholder.search": "Cerca...",
        "label.sort_by": "Ordina per",
        "label.last_episodes_loaded": "Ultimi episodi caricati",
        "button.load_all_episodes": "Carica tutti gli episodi",
        "loading": "Caricamento...",
        "add.new.episode": "Aggiungi nuovo episodio",
        "order.newest": "Più recenti prima",
        "order.oldest": "Più vecchi prima",
        "order.a_to_z": "A fino a Z",
        "order.z_to_a": "Z fino a A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Crea una nuova cartella podcast:",
        "folder.name.placeholder": "Nome della cartella",
        "create.button": "Crea"
      },
      "podcastLandingModal": {
        "upload.image.error": "Por favor, sube un archivo de imagen",
        "podcast.cover.title": "Imagen de Portada del Podcast",
        "podcast.cover.upload": "Sube la imagen de portada de tu podcast aquí. Esta se mostrará de manera destacada en tu página de inicio.",
        "upload.image.uploading": "Subiendo imagen...",
        "podcast.cover.upload.button": "Subir Imagen de Portada",
        "podcast.cover.recommended.size": "Tamaño recomendado: 1400x1400 píxeles",
        "profile.info.title": "Información del Perfil",
        "profile.info.upload": "Agrega tu foto de perfil y nombre para personalizar tu página de inicio.",
        "profile.upload.button": "Subir Foto de Perfil",
        "profile.name.label": "Nombre del Perfil",
        "profile.name.placeholder": "Ingresa tu nombre",
        "platform.links.title": "Enlaces de la Plataforma",
        "platform.links.upload": "Agrega enlaces a tu podcast en varias plataformas.",
        "platform.links.youtube_link": "Enlace de YouTube",
        "platform.links.youtube_link.placeholder": "Ingresa el enlace de YouTube",
        "platform.links.spotify_link": "Enlace de Spotify",
        "platform.links.spotify_link.placeholder": "Ingresa el enlace de Spotify",
        "platform.links.apple_podcast_link": "Enlace de Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Ingresa el enlace de Apple Podcast",
        "platform.links.linkedin_link": "Enlace de LinkedIn",
        "platform.links.linkedin_link.placeholder": "Ingresa el enlace de LinkedIn",
        "platform.links.facebook_link": "Enlace de Facebook",
        "platform.links.facebook_link.placeholder": "Ingresa el enlace de Facebook",
        "platform.links.twitter_link": "Enlace de Twitter",
        "platform.links.twitter_link.placeholder": "Ingresa el enlace de Twitter",
        "call.to.action.title": "Llamada a la Acción",
        "call.to.action.upload": "Configura tu botón de llamada a la acción para la página de inicio.",
        "call.to.action.button.text.label": "Texto del Botón",
        "call.to.action.button.text.placeholder": "Ingresa el texto del botón",
        "call.to.action.button.link.label": "Enlace del Botón",
        "call.to.action.button.link.placeholder": "Ingresa el enlace del botón",
        "color.styles.title": "Estilos de Color",
        "color.styles.upload": "Personaliza los colores de tu página de inicio.",
        "color.styles.primary.label": "Color Primario",
        "color.styles.primary.description": "Elige el color primario para tu página de inicio",
        "color.styles.secondary.label": "Color Secundario",
        "color.styles.secondary.description": "Elige el color secundario para tu página de inicio",
        "podcast.info.title": "Información del Podcast",
        "podcast.info.upload": "Edita los detalles de tu podcast.",
        "podcast.info.name.label": "Nombre del Podcast",
        "podcast.info.name.placeholder": "Ingresa el nombre del podcast",
        "podcast.info.description.label": "Descripción del Podcast",
        "podcast.info.description.placeholder": "Ingresa la descripción del podcast",
        "edit.website.title": "Editar Sitio Web",
        "generate.website.title": "Generar Sitio Web",
        "for": "para",
        "saving": "Guardando...",
        "save.changes": "Guardar Cambios",
        "generate.website": "Generar Sitio Web",
        "changes.saved.success": "¡Cambios guardados con éxito!",
        "podcast.cover.menu": "Portada del Podcast",
        "podcast.info.menu": "Información del Podcast",
        "profile.menu": "Perfil",
        "platform.links.menu": "Enlaces de la Plataforma",
        "call.to.action.menu": "Llamada a la Acción",
        "color.styles.menu": "Estilos de Color",
        "logo.menu": "Logo",
        "logo.title": "Subir Logo",
        "logo.upload": "Sube tu logo de podcast. Se mostrará en tu página de inicio.",
        "logo.upload.button": "Subir Logo",
        "platform.links.description": "Agrega enlaces a tu podcast en diferentes plataformas",
        "social.links.menu": "Enlaces de Redes Sociales",
        "social.links.title": "Enlaces de Redes Sociales",
        "social.links.description": "Agrega enlaces a tus perfiles de redes sociales",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Ingresa tu enlace de LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Ingresa tu enlace de Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Ingresa tu enlace de Twitter",
        "platform.links.youtubeLink": "YouTube",
        "platform.links.youtubeLink.placeholder": "Ingresa tu enlace de YouTube",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Ingresa tu enlace de Instagram",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Ingresa tu enlace de Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Ingresa tu enlace de Apple Podcast",
        "view.website": "Visualizza Sito Web"
      },
      "podcastMoveModal": {
        "move.episode.label": "Sposta questo episodio a:",
        "move.episode.instruction": "Puoi digitare un nuovo nome per creare una cartella.",
        "move.episode.button": "Sposta",
        "move.episode.error.selectFolder": "Seleziona una cartella per spostare l'episodio."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Impostazioni AI per il podcast {{podcastTitle}}",
        "ai.customize.writing.style": "Adatta il tuo stile di scrittura AI",
        "ai.content.writing.preference": "Come preferisci che Podsqueeze scriva il tuo contenuto?",
        "ai.voice.placeholder": "Esempio: tono professionale ma amichevole. Gli ascoltatori sono podcaster. Scrivi in prima persona.",
        "ai.character.limit.reached": "Hai raggiunto il tuo limite di caratteri di 50.",
        "ai.upgrade.now": "Aggiorna ora",
        "ai.fix.transcript.misspells": "Correggi gli errori di ortografia nel trascritto",
        "ai.enter.misspelled.words": "Annota le parole che l'IA scrive spesso male in questi episodi di podcast, ad esempio i nomi",
        "ai.enter.word.press.enter": "Inserisci una parola e premi invio",
        "ai.add.word": "Aggiungi parola",
        "ai.tag.limit.reached": "È stato raggiunto il limite di 1 tag.",
        "ai.save": "Salva",
        "ai.save.close": "Salva & Chiudi"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Titolo dell'Episodio",
        "selectedEpisode.podcastName": "Nome del Podcast",
        "selectedEpisode.showNotes": "Note del Programma",
        "selectedEpisode.timestamp": "Marca Temporale",
        "selectedEpisode.staticTimestamp": "Marca Temporale Statica",
        "selectedEpisode.mentions": "Menzioni",
        "selectedEpisode.newsletter": "Newsletter",
        "selectedEpisode.titles": "Titoli",
        "selectedEpisode.tweeter": "Twitter",
        "selectedEpisode.shortPost": "Post Breve",
        "selectedEpisode.transcription": "Trascrizione",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Parole Chiave",
        "selectedEpisode.quotes": "Citazioni",
        "selectedEpisode.longPost": "Post Lungo",
        "selectedEpisode.bulletPoints": "Punti Chiave",
        "selectedEpisode.publicLink": "Link Pubblico",
        "selectedEpisode.embeddedId": "ID Incorporato",
        "selectedEpisode.episodeUrl": "URL dell'Episodio"
      },
      "sidebar": {
        "tools": "Strumenti",
        "find.podcast.topic.ideas": "Trovare Idee per Argomenti di Podcast",
        "podcast.thumbnail.maker": "Creatore di Miniature per Podcast",
        "podcast.seo.optimizer": "Ottimizzatore SEO per Podcast",
        "account": "Account",
        "payment.settings": "Impostazioni di Pagamento",
        "support": "Supporto",
        "logout": "Disconnetti",
        "plan": "Piano",
        "resets.in": "Si reimposta in",
        "api.access": "Accesso API",
        "days": "giorni e",
        "hours": "ore",
        "upgrade.plan": "Aggiorna Piano"
      },
      "updateEmailModal": {
        "email.validation.error": "Inserisci un indirizzo email valido.",
        "email.change.confirm": "Sei sicuro di voler cambiare il tuo indirizzo email?",
        "email.change.success": "La tua email è stata cambiata con successo!",
        "email.in.use.error": "Questo indirizzo email è già in uso. Per favore prova con un altro.",
        "email.recent.login.error": "Prima di continuare con questa operazione, per favore riconnettiti con l'attuale indirizzo email.",
        "email.invalid.error": "Indirizzo email non valido. Per favore prova con un altro.",
        "subscription.cancel.error": "Per favore, prima annulla il tuo abbonamento a pagamento attivo.",
        "account.delete.confirm": "Sei sicuro di voler cancellare il tuo account?\n\nQuesta azione non può essere annullata.",
        "account.delete.success": "Il tuo account è stato cancellato con successo.",
        "account.delete.error": "Si è verificato un errore e non siamo riusciti a cancellare il tuo account.\n\nPer favore contatta il nostro supporto utenti.",
        "subscription.cancel": "Annulla l'abbonamento",
        "account.delete": "Cancella l'account",
        "account.delete.warning": "La cancellazione del tuo account è irreversibile e cancellerà definitivamente tutto il tuo contenuto e le tue informazioni di accesso. Procedi con cautela, poiché questa azione non può essere annullata.",
        "current.account.email": "Email dell'account attuale",
        "enter.new.email": "Inserisci il tuo nuovo indirizzo email dell'account",
        "update": "Aggiorna",
        "change.password": "Cambia la password",
        "payment.settings": "Impostazioni di pagamento"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "Titolo dell'episodio"
      },
      "episodelist": {
        "loading.episodes": "Caricamento episodi",
        "no.episodes.found": "Non sono stati trovati episodi. Per favore, riprova con un ID RSS valido",
        "select.episode": "Seleziona l'episodio per cui desideri creare contenuto"
      },
      "interfaces": {
        "user.activePlan.tier": "Livello",
        "user.activePlan.creationDate": "Data di Creazione",
        "user.activePlan.minutesAvailable": "Minuti Disponibili"
      },
      "loadingbar": {
        "loadingbar.magic": "Stiamo lavorando sulla nostra magia ✨",
        "loadingbar.longer": "Alcuni episodi richiedono un po' più di tempo... 🐌",
        "loadingbar.hardwork": "I nostri server stanno lavorando duramente 🦾"
      },
      "page": {
        "main.background": "Sfondo del componente principale"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Errore: L'accesso al microfono o alla telecamera è stato negato.",
        "microphone.camera.not.found": "Errore: Nessun microfono o telecamera trovati.",
        "microphone.camera.not.readable": "Errore: Il microfono o la telecamera non sono leggibili.",
        "microphone.camera.access.error": "Errore: Si è verificato un errore sconosciuto durante l'accesso al microfono o alla telecamera.",
        "media.not.recorded": "Errore: Nessun media è stato registrato.",
        "upload.failed": "Errore: Caricamento fallito.",
        "upload.success": "Successo: Caricamento completato con successo.",
        "upload.in.progress": "Caricamento in corso...",
        "upload.button": "Carica Registrazione",
        "stop.recording": "Ferma Registrazione",
        "record.audio": "Registra Audio",
        "record.audio.video": "Registra Audio con Video",
        "record.again": "Registra di Nuovo",
        "episode.language": "Seleziona Lingua Episodio"
      },
      "selectBox": {
        "language.english": "Inglese",
        "language.arabic": "Arabo",
        "language.bulgarian": "Bulgaro",
        "language.catalan": "Catalano",
        "language.croatian": "Croato",
        "language.czech": "Ceco",
        "language.danish": "Danese",
        "language.dutch": "Olandese",
        "language.finnish": "Finlandese",
        "language.french": "Francese",
        "language.german": "Tedesco",
        "language.greek": "Greco",
        "language.hindi": "Hindi",
        "language.hungarian": "Ungherese",
        "language.indonesian": "Indonesiano",
        "language.italian": "Italiano",
        "language.japanese": "Giapponese",
        "language.korean": "Coreano",
        "language.lithuanian": "Lituano",
        "language.latvian": "Lettone",
        "language.malay": "Malese",
        "language.mandarin": "Mandarino",
        "language.norwegian": "Norvegese",
        "language.polish": "Polacco",
        "language.portuguese": "Portoghese",
        "language.romanian": "Rumeno",
        "language.russian": "Russo",
        "language.slovak": "Slovacco",
        "language.slovenian": "Sloveno",
        "language.spanish": "Spagnolo",
        "language.swedish": "Svedese",
        "language.tamil": "Tamil",
        "language.turkish": "Turco",
        "language.ukrainian": "Ucraino",
        "language.bashkir": "Basciro",
        "language.basque": "Basco",
        "language.belarusian": "Bielorusso",
        "language.cantonese": "Cantonese",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estone",
        "language.galician": "Galiziano",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongolo",
        "language.persian": "Persiano",
        "language.thai": "Thai",
        "language.uyghur": "Uiguro",
        "language.vietnamese": "Vietnamita",
        "language.welsh": "Gallese"
      },
      "selectedepisode": {
        "processing.episode": "Trattamento dell'episodio",
        "processing.time": "Di solito ci vuole tra i 5 e i 10 minuti",
        "email.notification": "Puoi chiudere questa finestra. Ti invieremo un'email una volta che è pronto. Il tuo contenuto sarà anche disponibile sulla tua dashboard.",
        "convert.another.episode": "Converti un altro episodio",
        "technical.difficulties": "Ops! Stiamo riscontrando difficoltà tecniche. Non preoccuparti, il nostro team è al lavoro! Per favore, riprova più tardi.",
        "no.discount": "Non preoccuparti, non dedurremo nessun minuto!",
        "high.demand": "Stiamo riscontrando una domanda più alta del normale, quindi potrebbe volerci più tempo del solito per elaborare la tua richiesta. Ci scusiamo per eventuali inconvenienti!",
        "email.ready": "Ti invieremo un'email una volta che è pronto. Puoi anche accedere ai tuoi risultati dalla tua dashboard.",
        "select.podcast.folder": "Seleziona la cartella del podcast a cui appartiene questo episodio, oppure creane una nuova digitando un nome.",
        "give.voice": "Personalizza la voce della cartella",
        "generate.content": "Genera contenuto",
        "not.enough.minutes.title": "Non hai abbastanza minuti",
        "not.enough.minutes.message": "Non hai abbastanza minuti per convertire questo episodio. Per favore, aggiorna il tuo piano.",
        "upgrade.plan": "Aggiorna il tuo piano",
        "convert.shorter.episode": "Converti un episodio più corto",
        "content.ready": "Il tuo contenuto è pronto!",
        "ask.ai.tune": "Puoi sempre chiedere all'IA di regolare ogni contenuto per rispondere meglio alle tue esigenze.",
        "error.title": "Errore",
        "convert.another.file": "Converti un altro file"
      },
      "submitfile": {
        "file.size.exceeded.free": "La dimensione del file supera il limite massimo di 4 GB. <p>Per favore, <a href='/pricing'><b><u>aggiorna per caricare file più grandi</u></b></a></p>",
        "file.size.exceeded.paid": "La dimensione del file supera il limite massimo di 10 GB. <p>Per favore, seleziona un file più piccolo.</p>",
        "file.upload.invalid": "Per favore, carica un file audio o video",
        "upload.in.progress": "Caricamento del file in corso. Per favore, non chiudere questa finestra.",
        "upload.button": "Carica & Genera",
        "close.button": "Chiudi",
        "upgrade.message.free": "Ulteriori caricamenti sono disponibili solo per i livelli a pagamento.",
        "upgrade.now.button": "Aggiorna Ora",
        "pricing.info": "a partire da $12/mese",
        "upload.file.label": "Carica un file audio o video",
        "max.file.size.free": "(max 4 gb)",
        "max.file.size.paid": "(max 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze genererà audiogrammi per file audio e clip brevi per file video",
        "file.placeholder": "Il tuo file MP3/WAV",
        "episode.language.label": "Lingua dell'episodio",
        "multiple.files.selected": "{{count}} file selezionati",
        "clear.all": "Cancella tutto",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Seleziona più file",
        "file.upload.error": "Errore nel caricamento del file",
        "file.upload.success": "File caricato con successo",
        "file.upload.processing": "Elaborazione del file",
        "click.to.upload": "Clicca per caricare",
        "click.to.upload.multiple": "Clicca per caricare più file",
        "select.folder.label": "Seleziona o crea una cartella",
        "enter.url": "Inserisci l'URL",
        "upload.file": "Carica un file",
        "media.url.label": "URL del media",
        "media.url.help": "Inserisci l'URL del tuo file audio o video. Lo caricheremo e lo elaboraremo per te.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Nome dell'episodio",
        "url.input.required": "Per favore, inserisci un URL di media",
        "url.upload.error": "Errore nel caricamento del media dall'URL. Per favore, verifica l'URL e riprova.",
        "supported.formats": "Formati supportati",
        "uploading": "Caricamento in corso...",
        "media.url.requirements": "L'URL deve essere un link diretto a un file multimediale pubblico (non una pagina web)"
      },
      "submitrssid": {
        "error.selectRss": "Per favore, seleziona un RSS valido dal menu a discesa",
        "label.insertRssFeed": "Inserisci il tuo RSS Feed",
        "placeholder.insertRssFeed": "Inserisci il tuo RSS Feed",
        "label.searchByPodcast": "Cerca per nome del podcast invece",
        "label.searchForPodcast": "Cerca il nome del tuo podcast",
        "placeholder.searchForPodcast": "Cerca un podcast",
        "label.cantFindPodcast": "Non riesci a trovare il tuo podcast?",
        "label.clickHereUseRss": "Clicca qui per utilizzare il tuo RSS feed invece",
        "label.selectedPodcast": "Podcast selezionato",
        "label.episodeLanguage": "Lingua dell'episodio",
        "button.seeAllEpisodes": "Vedi tutti gli episodi",
        "select.folder.label": "Seleziona o crea una cartella"
      },
      "submitsection": {
        "search.podcast": "Cerca il tuo podcast",
        "upload.audio.video": "Carica audio o video",
        "record.audio": "Registra audio",
        "youtube.video": "Link YouTube",
        "create.content": "Creiamo contenuti per il tuo podcast!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Inserisci l'URL del video di YouTube",
        "error.insertYouTubeUrl": "Per favore, inserisci un URL di YouTube.",
        "label.insertYouTubeUrl": "Inserisci l'URL del video di YouTube",
        "button.loading": "Caricamento...",
        "message.downloadingFile": "Scaricamento file...",
        "error.processingFailed": "Si è verificato un errore durante l'elaborazione del video. Per favore, riprova.",
        "button.submitYouTubeVideo": "Invia Video di YouTube",
        "error.youtubeVideoNotAvailable": "Questo video YouTube non è disponibile per il download. Per favore, carica il tuo audio o video direttamente a Podsqueeze o usa un YouTube downloader prima. Grazie per la tua pazienza.",
        "episode.language.label": "Lingua utilizzata",
        "select.folder.label": "Seleziona o crea una cartella"
      },
      "tabs": {
        "tab.label.tab1": "Etichetta 1",
        "tab.label.tab2": "Etichetta 2",
        "tab.label.tab3": "Etichetta 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Sfrutta al Massimo Podsqueeze",
        "tutorial.chapter.introduction": "Introduzione",
        "tutorial.chapter.bestShowNotes": "Ottieni le migliori note del programma e timestamp",
        "tutorial.chapter.blogPosts": "Utilizzando post del blog e newsletter",
        "tutorial.chapter.editingTranscripts": "Incorporando e modificando trascrizioni",
        "tutorial.chapter.personalizingAI": "Personalizzando l'IA e Dando la Tua Propria Voce",
        "tutorial.chapter.speedingUpNotes": "Accelerando le Note del Programma",
        "tutorial.chapter.creatingClips": "Creando clip video e immagini",
        "tutorial.chapter.generatingLandingPage": "Generando una pagina di destinazione",
        "tutorial.chapter.shareResults": "Condividi Risultati Con Il Tuo Team",
        "tutorial.closeVideoCheckbox": "Chiudi video una volta che i primi risultati sono pronti"
      },
      "uploadloadingbar": {
        "upload.loading": "Caricamento..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Contattaci",
        "contact.section.email": "Inviaci una mail a support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fondatore",
        "contact.section.joao.role": "Co-fondatore",
        "contact.section.image.alt.sendMessage": "Invia messaggio",
        "contact.section.image.alt.tiago": "Co-fondatore di Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fondatore di Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Contattaci",
        "contact.section.email": "Inviaci una mail a support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fondatore",
        "contact.section.joao.role": "Co-fondatore",
        "contact.section.image.alt.sendMessage": "Invia messaggio",
        "contact.section.image.alt.tiago": "Co-fondatore di Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fondatore di Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Unisciti a 20.000 creatori di contenuti e professionisti dei podcast che utilizzano Podsqueeze",
        "content.creators": "Creatori di Contenuti",
        "podcast.managers": "Gestori di Podcast",
        "producers.studios": "Produttori e Studi",
        "for.podcasters": "PER PODCASTER, GESTORI DI PODCAST E AGENZIE",
        "manage.content.creation": "Gestisci la creazione di contenuti senza sforzo per",
        "multiple.podcasts": "multipli podcast",
        "podsqueeze.description": "Podsqueeze è uno strumento potente per tutti i professionisti del podcasting. Che tu sia un podcaster solista, un gestore di podcast o un'agenzia, Podsqueeze offre tutte le caratteristiche di cui hai bisogno per ottimizzare il tuo flusso di lavoro nella creazione di contenuti per podcast.",
        "create.podcast.folders": "Crea cartelle di podcast per mantenere organizzati i tuoi episodi.",
        "share.content.page": "Condividi facilmente la tua pagina di contenuti con clienti e team",
        "tune.ai.voice": "Regola la voce dell'IA per ogni programma che gestisci",
        "plan.content.episodes": "Pianifica il contenuto dei prossimi episodi con il nostro avanzato",
        "podcast.topics.finder": "trovatore di argomenti per podcast",
        "podsqueeze.testimonial": "La capacità di Podsqueeze di utilizzare indicazioni per regolare il contenuto di ogni podcast che gestiamo e salvarli per episodi futuri, ci permette di mantenere le voci di ogni programma coerenti. Questa è una caratteristica d'élite che non siamo riusciti a trovare in nessun altro strumento.",
        "coo.podigy": "COO presso Podigy Podcasts",
        "agenciessection.joinCreators": "Unisciti a 20.000 creatori di contenuti e professionisti dei podcast che utilizzano Podsqueeze",
        "agenciessection.contentCreators": "Creatori di Contenuti",
        "agenciessection.podcastManagers": "Gestori di Podcast",
        "agenciessection.producersStudios": "Produttori e Studi",
        "agenciessection.forPodcasters": "PER PODCASTER, GESTORI DI PODCAST E AGENZIE",
        "agenciessection.manageContent": "Gestisci la creazione di contenuti senza sforzo per",
        "agenciessection.multiplePodcasts": "multipli podcast",
        "agenciessection.podsqueezeDescription": "Podsqueeze è uno strumento potente per tutti i professionisti del podcasting. Che tu sia un podcaster solista, un gestore di podcast o un'agenzia, Podsqueeze offre tutte le caratteristiche di cui hai bisogno per ottimizzare il tuo flusso di lavoro nella creazione di contenuti per podcast.",
        "agenciessection.createPodcastFolders": "Crea cartelle di podcast per mantenere organizzati i tuoi episodi.",
        "agenciessection.shareContent": "Condividi facilmente la tua pagina di contenuti con clienti e team",
        "agenciessection.tuneAI": "Regola la voce dell'IA per ogni programma che gestisci",
        "agenciessection.planContent": "Pianifica il contenuto dei prossimi episodi con il nostro avanzato",
        "agenciessection.podcastTopicsFinder": "trovatore di argomenti per podcast",
        "agenciessection.podsqueezeQuote": "La capacità di Podsqueeze di utilizzare indicazioni per regolare il contenuto di ogni podcast che gestiamo e salvarli per episodi futuri, ci permette di mantenere le voci di ogni programma coerenti. Questa è una caratteristica d'élite che non siamo riusciti a trovare in nessun altro strumento.",
        "agenciessection.coO": "COO presso Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NUOVA FUNZIONE",
        "seamless.editing": "Modifica fluida e miglioramento dell'audio per un risultato naturale, ",
        "high.quality.results": " risultati di alta qualità",
        "experience.seamless.audio.editing": "Sperimenta una modifica audio fluida con algoritmi IA avanzati per registrazioni di prima categoria. ",
        "remove.ums": "Elimina esitazioni",
        "enhance.sound.quality": ", silenzi e migliora la qualità del suono con un solo clic.",
        "enhance.audio.now": "Migliora audio ora",
        "sample.audio.recorded": "Esempio di audio, registrato direttamente dal telefono.",
        "original.recording": "Registrazione originale",
        "audio.after.ai.edit": "Audio dopo la modifica e il miglioramento con IA",
        "experience.audio.editing": "Sperimenta una modifica audio fluida con algoritmi IA avanzati per registrazioni di prima categoria. "
      },
      "home-blogsection": {
        "more.resources.label": "PIÙ RISORSE PER IL TUO PODCAST",
        "learn.how.to.get.most": "Impara a trarre il massimo da",
        "your.content": "il tuo contenuto",
        "get.most.out.of.ai.content": "Ottieni il Massimo dal Contenuto Generato da IA per il Tuo Podcast",
        "welcome.to.podsqueeze": "Benvenuto a Podsqueeze - il modo più semplice per trascrivere il tuo podcast e creare contenuto accattivante...",
        "will.google.penalize.ai.content": "Google penalizzerà il tuo contenuto generato da IA?",
        "ai.content.discussion": "L'emergere del contenuto generato da IA ha scatenato discussioni e sollevato preoccupazioni tra i creatori di contenuto, i marketer e gli SEO...",
        "what.is.rss.feed": "Cos'è un feed RSS per i Podcast e come usarlo?",
        "rss.feed.benefits": "Come podcaster, potresti aver sentito il termine 'feed RSS' prima, ma potresti non sapere esattamente cosa sia o come può beneficiarti...",
        "visit.blog": "Visita il Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIP E AUDIOGRAMMI",
        "clipsAndAudiograms.subtitle": "Riutilizza il tuo podcast in clip senza sforzo",
        "clipsAndAudiograms.description": "Scegli semplicemente un capitolo del tuo episodio ed esportalo come clip o audiogramma per TikTok, Instagram e YouTube Shorts. Scegli un modello e adattalo al tuo stile.",
        "clipsAndAudiograms.createClips": "Crea Clip Ora",
        "textEditor.title": "Editor basato su testo",
        "textEditor.description": "Ajusta le tue clip e audiogrammi direttamente dai sottotitoli. Modifica i sottotitoli e taglia il tuo video eliminando parole specifiche.",
        "oneClickShorts.title": "Shorts con un clic (<60s)",
        "oneClickShorts.description": "Lascia che l'IA si occupi del montaggio per te. Con un solo clic, l'IA ridurrà ogni capitolo del tuo episodio a meno di 60 secondi, pronto per essere pubblicato come un YouTube Short o clip di TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Contatta i fondatori",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Sviluppatore & Podcaster",
        "contact.section.joao.role": "- Designer UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "VASTA VARIETÀ DI CONTENUTO",
        "generate.content": "Genera contenuto con",
        "one.click": "un clic!",
        "transcript.srt": "Trascrizione e SRT",
        "transcript.description": "Ottieni la trascrizione completa del tuo episodio di podcast, insieme a un file SRT pronto per generare sottotitoli.",
        "show.notes": "Note del programma",
        "show.notes.description": "Riassumi i temi principali trattati nel tuo episodio e rendilo più ricercabile",
        "timestamps": "Timestamp",
        "timestamps.description": "Crea capitoli con timestamp e guida gli ascoltatori a segmenti specifici del tuo episodio di podcast",
        "blog.social.posts": "Post su blog e social network",
        "blog.social.posts.description": "Pubblica sul tuo episodio di podcast ovunque e attira nuovi ascoltatori",
        "newsletter": "Newsletter",
        "newsletter.description": "Tieni aggiornati i tuoi ascoltatori con nuovi episodi",
        "titles.more": "Titoli e altro ancora!",
        "titles.more.description": "Genera titoli accattivanti, citazioni, punti chiave, parole chiave e altro ancora.",
        "see.sample.content": "VEDI CONTENUTO DI ESEMPIO",
        "wannabe.entrepreneur": "Imprenditore in erba - #299 Podsqueeze ha appena raggiunto $100,000 di entrate annuali!",
        "making.space": "Fare Spazio - Steve Harvey: “Meglio che tu vada avanti”",
        "modern.wisdom": "Saggezza Moderna - Erik Hoel - Una Guida Per Il Mistero Fondamentale Della Mente"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Linea divisoria"
      },
      "home-explanationsection": {
        "fast.accurate": "VELOCE E PRECISO",
        "generate.content": "Genera contenuti per il tuo podcast con il",
        "power.of.ai": "potere dell'IA",
        "upload.image.alt": "carica un'immagine",
        "select.episode": "Seleziona un episodio dal tuo feed RSS o carica un file audio/video",
        "paste.rss.feed": "Basta incollare l'URL del tuo feed RSS per scegliere un episodio dalla lista o caricare un file audio o video.",
        "content.image.alt": "immagine del contenuto",
        "one.click.content": "Ottieni tutto il contenuto con un solo clic!",
        "user.friendly.interface": "Interfaccia intuitiva e user-friendly che puoi iniziare a utilizzare immediatamente. Genera contenuti per il tuo podcast con un solo clic.",
        "tune.image.alt": "immagine di regolazione",
        "edit.fine.tune": "Modifica e affina ogni contenuto",
        "direct.edit.content": "Modifica direttamente e affina ogni contenuto secondo le tue preferenze con l'IA. Ad esempio, puoi richiedere un tono specifico, un discorso diretto o indiretto o semplicemente correggere nomi mal ortografati.",
        "multiple.language.support": "Supporto multilingua",
        "language.flags.alt": "bandiere di lingua",
        "generate.content.aria": "Generare contenuto"
      },
      "home-featuressection": {
        "loading": "Caricamento...",
        "transcribe.write.show.notes": "Trascrivi e scrivi note del programma per il tuo podcast",
        "twenty.times.faster": "20 volte più veloce",
        "save.manual.work": "Risparmia fino al 100% del lavoro manuale. Trascrivi automaticamente il tuo podcast con un'accuratezza all'avanguardia e l'etichettatura dei parlanti, e genera note del programma complete e post sui social media con la tua voce.",
        "generate.content": "Genera Contenuto",
        "transcripts": "Trascrizioni",
        "full.transcript": "Ottieni la trascrizione completa dei tuoi episodi di podcast e trascrizioni dei video di YouTube, insieme a un file SRT per i sottotitoli.",
        "show.notes": "Note del Programma",
        "summarize.generate.show.notes": "Riassumi e genera note del programma con la tua voce, complete di timestamp, punti elenco e menzioni.",
        "blog.newsletter": "Blog e Newsletter",
        "actionable.blog.posts": "Ottieni post del blog azionabili sui tuoi episodi e newsletter pronte per essere inviate con i punti chiave.",
        "social.media": "Social media",
        "short.posts.insights": "Ottieni post brevi e intuizioni concise per diffondere la parola sui social media.",
        "quote": "Di tutti i migliori strumenti di trascrizione IA che abbiamo testato, Podsqueeze ha generato i risultati più utili per Note del Programma, Timestamp, Titoli, Menzioni, Esempi di Post del Blog e Citazioni Chiave.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Co-fondatore di Transistor.fm",
        "transcribe_and_write_show_notes": "Trascrizione di podcast, riassunti e post sui social media",
        "twenty_times_faster": "20 volte più veloce",
        "save_manual_work": "Risparmia fino al 100% del lavoro manuale. Trascrivi automaticamente il tuo podcast con un'accuratezza all'avanguardia e l'etichettatura dei parlanti, e genera note del programma complete e post sui social media con la tua voce.",
        "generate_content": "Genera Contenuto",
        "full_transcript": "Ottieni la trascrizione completa dei tuoi episodi di podcast e trascrizioni dei video di YouTube, insieme a un file SRT per i sottotitoli.",
        "show_notes": "Note del Programma",
        "summarize_and_generate_show_notes": "Riassumi e genera note del programma con la tua voce, complete di timestamp, punti elenco e menzioni.",
        "blog_and_newsletter": "Blog e Newsletter",
        "actionable_blog_posts": "Ottieni post del blog azionabili sui tuoi episodi e newsletter pronte per essere inviate con i punti chiave.",
        "social_media": "Social media",
        "short_posts_and_insights": "Ottieni post brevi e intuizioni concise per diffondere la parola sui social media.",
        "testimonial": "Di tutti i migliori strumenti di trascrizione IA che abbiamo testato, Podsqueeze ha generato i risultati più utili per Note del Programma, Timestamp, Titoli, Menzioni, Esempi di Post del Blog e Citazioni Chiave.",
        "cofounder_transistor": "Co-fondatore di Transistor.fm"
      },
      "home-page": {
        "main.background": "Colore di sfondo per il componente principale"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "ASCOLTA IL NOSTRO PODCAST",
        "podcast.section.subtitle": "Lezioni magistrali di",
        "podcast.section.highlight": "podcaster esperti",
        "podcast.section.description": "Ascolta il nostro podcast, dove intervistiamo podcaster esperti e utenti di Podsqueeze da tutto il mondo. Chiediamo loro di condividere i loro consigli, idee, storie e tutto ciò che devi sapere per far crescere il tuo podcast.",
        "podcast.link.spotify": "Ascolta su Spotify",
        "podcast.link.apple": "Ascolta su Apple Podcasts",
        "podcast.link.youtube": "Ascolta su YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Caricamento..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatizza il tuo Podcast",
        "tagline.productionPromotion": "Produzione e Promozione",
        "tagline.launchGrow": "Lancia e fai crescere il tuo podcast audio o video senza sforzo, con tutto ciò di cui hai bisogno in un unico posto, con l'aiuto dell'IA.",
        "tagline.uploadGenerate": "Genera podcast transcript, riassunto, clip corti con sottotitoli e molto altro!",
        "tagline.singleClick": " Tutto con un solo clic.",
        "tagline.transcripts": "Trascrizioni del Podcast",
        "tagline.showNotes": "Note del Programma",
        "tagline.newslettersBlogs": "Newsletter e Blog",
        "tagline.socialPosts": "Post sui Social Network",
        "tagline.shortClipsAudiograms": "Clip Brevi e Audiogrammi",
        "tagline.podcastWebsite": "Sito Web del Podcast",
        "tagline.aiAudioEnhancement": "Miglioramento dell'Audio con IA",
        "tagline.removeSilences": "Elimina silenzi e muletillas",
        "tagline.generateNow": "Genera ora gratuitamente",
        "tagline.noCreditCard": "Non è richiesta la carta di credito",
        "testimonial.robWalling.title": "Rob Walling, Personalità delle Startups",
        "testimonial.robWalling.subtitle": "Podcast Startups per il Resto di Noi",
        "testimonial.robWalling.quote": "Le note del programma di Podsqueeze sono state le migliori. Le usiamo molto per i riassunti e per ottenere informazioni da altri podcast.",
        "testimonial.johnGarmet.title": "John Garmet, Direttore Operativo",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze ci aiuta a essere più efficienti e a generare più contenuti per i nostri clienti. Lo raccomandiamo vivamente.",
        "testimonial.davidJackson.title": "David Jackson, Coach di Podcast",
        "testimonial.davidJackson.subtitle": "Scuola di Podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze è il mio compagno di brainstorming. È il modo migliore per generare marketing per i podcast."
      },
      "home-testimonials": {
        "testimonials.title": "Cosa dicono le persone su Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Usa l'IA per riutilizzare i tuoi contenuti podcast | Product Hunt",
        "testimonials.heading": "Cosa dicono le persone su Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Password errata",
        "error.userNotFound": "Utente non trovato",
        "error.somethingWentWrong": "Ops, qualcosa è andato storto",
        "button.sendResetEmail": "Invia email di ripristino",
        "button.login": "Accedi",
        "placeholder.email": "Indirizzo email",
        "placeholder.password": "Password",
        "link.forgotPassword": "Hai dimenticato la tua password?",
        "link.createAccount": "Crea un account",
        "text.or": "O",
        "button.continueWithGoogle": "Continua con Google",
        "text.podcastDescription": "Lancia e fai crescere il tuo podcast audio o video senza sforzo con tutto ciò di cui hai bisogno in un unico posto.",
        "feature.transcripts": "Trascrizioni",
        "feature.showNotes": "Note dello spettacolo",
        "feature.newslettersAndBlogs": "Newsletter e Blog",
        "feature.socialPosts": "Post sui social",
        "feature.shortClipsAndAudiograms": "Clip brevi e Audiogrammi",
        "feature.podcastWebsite": "Sito web del podcast",
        "feature.aiAudioEnhancement": "Miglioramento audio con IA",
        "feature.removeSilences": "Rimuovi silenzi e muletillas",
        "button.sendVerificationEmail": "Invia email di verifica",
        "error.emailNotVerified": "Email non verificata",
        "error.emailAlreadyVerified": "Email già verificata",
        "success.verificationEmailSent": "Email di verifica inviata",
        "success.emailVerified": "Email verificata",
        "text.pleaseVerifyAccount": "Per favore, verifica il tuo account",
        "text.checkSpamFolder": "Ti abbiamo inviato un'email di verifica. Per favore, controlla la tua casella di posta e la cartella degli spam.",
        "button.resendVerificationEmail": "Rinvio email di verifica",
        "error.verificationEmailFailed": "Errore durante l'invio dell'email di verifica. Per favore, riprova."
      },
      "page": {
        "login.form": "ModuloDiAccesso"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Pagina degli Affiliati di Podsqueeze",
        "affiliate.page.description": "Guadagna il 25% di commissione per ogni vendita effettuata attraverso il tuo link di riferimento esclusivo per un periodo di 15 mesi. Condividi il tuo link sul tuo sito web, sui social media o con i tuoi amici. Unirsi richiede solo pochi secondi. Ottieni approvazione automatica."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Miglior regalo per un podcaster",
        "bestGiftForPodcaster.description": "Scopri i migliori regali per i podcaster per migliorare la loro esperienza.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Ottieni più ascoltatori di podcast",
        "get-more-podcast-listeners.description": "Ottieni più ascoltatori di podcast e ottimizza la produzione con note di programma automatiche, clip brevi per far crescere il tuo programma sui social network e molto altro."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Fai crescere il tuo pubblico di podcast",
        "grow_your_podcast_audience.description": "Risparmia molto tempo e sviluppa il tuo pubblico di podcast con Podsqueeze. Genera note di spettacolo complete, post sui social media, clip brevi e molto altro per il tuo podcast."
      },
      "index": {
        "home.page.title": "Note del programma del podcast di IA, trascrizioni, riassunti e generatore di clip.",
        "home.page.description": "Genera note del programma, timestamp, newsletter e altro per il tuo podcast con un solo clic! Genera rapidamente contenuti per il tuo podcast e adattalo alle tue esigenze. Registrazione gratuita."
      },
      "login": {
        "login.tryItNow": "Provalo ora!",
        "login.createAccountDescription": "Crea un account e inizia a generare note di programma, timestamp, bollettini e altro per il tuo podcast con un solo clic! Genera rapidamente contenuti per il tuo podcast e adattalo alle tue esigenze. Registrazione gratuita."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing per Podcast",
        "marketing.for.podcasts.description": "Podsqueeze ottimizza il marketing per i podcast con note di spettacolo generate automaticamente, post sui social media e brevi clip per aumentare la tua portata e ingrandire il tuo spettacolo."
      },
      "media": {
        "media.page.title": "Pagina dei Media di Podsqueeze",
        "media.page.description": "Scopri di più su Podsqueeze. Mettiti in contatto! Ci piacerebbe collaborare!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Generatore di Descrizioni Podcast",
        "podcast.description.generator.description": "Migliora la portata e il coinvolgimento del tuo podcast con descrizioni generate da IA. Automatizza la stesura delle tue Note del Programma e recupera tempo prezioso."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Riutilizza il tuo podcast per post sui social media",
        "convert.podcast.episodes.to.social.media.posts": "Converti episodi di podcast in post per i social media. Genera automaticamente post per LinkedIn, Twitter, Facebook e clip brevi per TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Generatore Gratuito di Temi per Podcast",
        "podcast.topics.generator.description": "Il nostro generatore gratuito di temi per podcast ti permette di trovare le migliori idee per i temi e prevedere il loro potenziale di raggiungimento su Google e YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Il Tuo Assistente Virtuale per Podcast",
        "podcast.virtual.assistant.description": "Assistente virtuale per podcast basato su IA che redige le tue note del programma e crea post per i social network. Ottimizza la produzione e il marketing del tuo podcast con Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Prices",
        "pricing.description": "Genera note di spettacolo, timestamp, newsletter e altro per il tuo podcast con un clic! Abbiamo più livelli di prezzo per soddisfare le tue esigenze di podcasting."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promuovi il tuo Podcast",
        "promote.your.podcast.description": "Genera note dello spettacolo, post sui social media e brevi clip da pubblicare e promuovere il tuo podcast in pochi minuti."
      },
      "register": {
        "create.podsqueeze.account": "Crea un account Podsqueeze",
        "generate.content.podcast": "Genera note di trasmissione, timestamp, newsletter e molto altro per il tuo podcast con un solo clic! Genera rapidamente contenuti per il tuo podcast e adattalo alle tue esigenze. Iscrizione gratuita."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Converti automaticamente i contenuti del podcast",
        "repurpose.your.podcast.content.with.ai": "Converti i tuoi contenuti podcast con l'IA. Genera automaticamente note di spettacolo, titoli, brevi clip per TikTok e molto altro, tutto con un solo clic!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "Ottimizzatore SEO Podcast GRATUITO",
        "seo.optimizer.description": "Analizza e ottimizza i tuoi episodi podcast per una migliore visibilità sui motori di ricerca con raccomandazioni SEO basate sull'IA.",
        "seo.optimizer.heading": "Ottimizzatore SEO Podcast",
        "seo.optimizer.headingnote": "Analizza e ottimizza i tuoi episodi podcast per una migliore visibilità sui motori di ricerca con raccomandazioni SEO basate sull'IA.",
        "seo.optimizer.selectEpisode": "Seleziona un Episodio da Analizzare",
        "seo.optimizer.results": "Risultati dell'Analisi SEO",
        "seo.optimizer.searchPodcastPlaceholder": "Cerca un podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Cerca episodi...",
        "seo.optimizer.analyseAnotherEpisode": "Analizza un Altro Episodio",
        "seo.optimizer.findingEpisodes": "Ricerca di tutti gli episodi...",
        "seo.optimizer.analysingEpisode": "Analisi Episodio",
        "seo.optimizer.scoreTooltip": "Punteggio:",
        "seo.optimizer.topKeywords": "Abbiamo identificato queste Parole Chiave Principali:",
        "seo.optimizer.topKeywordsnote": "Basato sulle parole chiave al fondo della pagina.",
        "seo.optimizer.optimizedContent": "Basato sulle parole chiave, ecco il titolo e la descrizione ottimizzati:",
        "seo.optimizer.originalTitle": "Titolo Originale",
        "seo.optimizer.optimizedTitle": "Titolo Ottimizzato",
        "seo.optimizer.originalDescription": "Descrizione Originale",
        "seo.optimizer.optimizedDescription": "Descrizione Ottimizzata",
        "seo.optimizer.showMore": "Mostra di Più",
        "seo.optimizer.showLess": "Mostra di Meno",
        "seo.optimizer.keywordAnalysis": "Analisi delle Parole Chiave",
        "seo.optimizer.keywordAnalysisnote": "I punteggi sono calcolati in base al volume di ricerca, alla competizione (quanti altri risultati ci sono per la stessa parola chiave) e nel caso di YouTube, il numero medio di visualizzazioni per video per la stessa parola chiave.",
        "seo.optimizer.seoScore": "Punteggio SEO",
        "seo.optimizer.spotifyScore": "Punteggio Spotify",
        "seo.optimizer.youtubeScore": "Punteggio YouTube",
        "seo.optimizer.totalScore": "Totale"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Strumento di generazione di contenuti podcast AI",
        "podsqueeze.description": "Genera note di spettacolo, timestamp, newsletter e altro ancora per il tuo podcast con un solo clic! Genera rapidamente contenuti per il tuo podcast e adattali alle tue esigenze. Iscrizione gratuita."
      },
      "thumbnail-creator": {
        "title": "Generatore Gratuito di Miniature per Podcast - Crea Miniature di Episodi con l'IA",
        "description": "Crea miniature per podcast straordinarie con l'IA. Genera contenuti visivi professionali e accattivanti per episodi che aumentano la visibilità e attirano più ascoltatori al tuo podcast.",
        "selectPodcast": "Seleziona il Tuo Podcast",
        "loadEpisodes": "Carica Episodi",
        "selectEpisode": "Seleziona Episodio per Creare una Miniatura",
        "createThumbnail": "Crea Miniatura",
        "results": "La Tua Miniatura Generata",
        "download": "Scarica",
        "share": "Condividi",
        "regenerate": "Rigenera",
        "editThumbnail": "Modifica Miniatura",
        "editPlaceholder": "Descrivi come vorresti modificare questa miniatura...",
        "customPrompt": "Prompt Personalizzato",
        "yourThumbnail": "La Tua Miniatura",
        "createAnother": "← Crea Un'Altra Miniatura",
        "findingEpisodes": "Ricerca episodi...",
        "searchPodcastPlaceholder": "Cerca il tuo podcast...",
        "searchingPodcasts": "Ricerca podcast...",
        "heroDescription": "Genera miniature per podcast straordinarie e professionali con design potenziato dall'IA che cattura l'attenzione e aumenta la visibilità dei tuoi episodi.",
        "generatedWithPrompt": "Generato con il prompt:",
        "customPromptPlaceholder": "Inserisci un prompt personalizzato per la generazione di miniature...",
        "generating": "Generando...",
        "generate": "Genera",
        "modernMinimalist": "Moderno e Minimalista",
        "vibrantDynamic": "Vibrante e Dinamico",
        "professionalClean": "Professionale e Pulito",
        "generatingThumbnail": "Generazione miniatura...",
        "generatingNewThumbnail": "Generazione nuova miniatura...",
        "showingFirstEpisodes": "Mostrando i primi 10 episodi. Usa la ricerca per trovare episodi specifici.",
        "imageUrlCopied": "URL dell'immagine copiato negli appunti!",
        "failedToGenerate": "Generazione della miniatura fallita. Riprova.",
        "promotionalTitle": "Genera Note dello Show, Timestamp, Clip Virali e Molto Altro Con Podsqueeze",
        "promotionalSubtitle": "Unisciti ad altri 100K+ creatori e inizia a far crescere il tuo show",
        "startNow": "Inizia ora",
        "free": "GRATUITO",
        "podcast": "PODCAST",
        "thumbnail": "MINIATURA",
        "creator": "CREATORE",
        "replaceFace": "Sostituisci Volto",
        "uploading": "Caricamento...",
        "uploadImageError": "Carica un file immagine.",
        "uploadFailedError": "Caricamento immagine fallito. Riprova.",
        "uploadingImage": "Caricamento immagine...",
        "generatingNewThumbnailLoading": "Generazione nuova miniatura...",
        "failedToGenerateWithFace": "Generazione miniatura con sostituzione volto fallita. Riprova."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Crea una nuova cartella podcast",
      "folder.name.placeholder": "Inserisci il nome della cartella",
      "create.button": "Crea"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Caricamento episodi...",
        "episodeList.noEpisodes": "Nessun episodio pubblico disponibile",
        "episodeList.checkBack": "Torna più tardi per nuovi episodi",
        "episodeList.title": "Episodi di questo Podcast",
        "episodeList.readLess": "LEGGI MENO",
        "episodeList.readMore": "LEGGI DI PIÙ",
        "episodeList.coverImageAlt": "Copertina di {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Iniziare",
        "alert.subscriptionRunning": "La tua attuale sottoscrizione è ancora attiva.\n\nPer favore, annulla la tua attuale sottoscrizione prima di acquistarne una nuova.",
        "alert.subscriptionEnds": "La tua attuale sottoscrizione è ancora attiva.\n\nTermina il {date}",
        "alert.subscriptionCancelled": "La tua sottoscrizione è già stata annullata e terminerà il {date}",
        "button.openDashboard": "Apri Pannello di Controllo",
        "button.signUp": "Registrati",
        "button.buySubscription": "Acquista Sottoscrizione",
        "button.cancelled": "Annullato",
        "button.cancelSubscription": "Annulla Sottoscrizione",
        "button.upgradeSubscription": "Aggiorna Sottoscrizione",
        "button.loading": "Caricamento",
        "upgrade.details.currentMinutes": "Questo avvierà un nuovo periodo di sottoscrizione. Manterrai tutti i tuoi minuti attuali.",
        "upgrade.details.remainingAnnual": "Questo valore è stato calcolato in base al tempo rimanente nella tua attuale sottoscrizione annuale."
      },
      "page": {
        "pricing.free.title": "Gratuito",
        "pricing.free.subtitle": "Prova Podsqueeze. Non è richiesta la carta di credito.",
        "pricing.free.price.annual": "$0 Fatturato annualmente",
        "pricing.free.features.podcast_time": "30 minuti di tempo podcast al mese",
        "pricing.free.features.video_clips": "3 clip video",
        "common.with_watermark": "con filigrana",
        "pricing.free.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.free.features.file_upload": "Caricamento di file fino a 4Gb",
        "pricing.free.features.upload": "1 caricamento",
        "pricing.free.features.landing_pages": "Pagine di destinazione del podcast",
        "pricing.free.features.audio_enhancement": "Miglioramento audio",
        "common.sign_up": "Iscriviti",
        "common.open_dashboard": "Apri il pannello di controllo",
        "pricing.starter.title": "Inizio",
        "pricing.starter.subtitle": "Perfetto per i podcaster amatoriali che vogliono risparmiare tempo.",
        "pricing.starter.price.annual": "$132 Fatturato annualmente",
        "minutes.accumulate": "Minuti accumulati",
        "pricing.billed_annually": "Fatturato annualmente",
        "pricing.starter.features.podcast_time": "160 minuti di tempo podcast al mese",
        "pricing.starter.features.video_clips": "10 clip video o audiogrammi",
        "pricing.starter.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.starter.features.file_upload": "Caricamento di file fino a 4Gb",
        "pricing.starter.features.unlimited_uploads": "Caricamenti illimitati",
        "pricing.starter.features.landing_pages": "Pagine di destinazione del podcast",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Per i professionisti che utilizzano il podcasting per sviluppare e sostenere i loro affari.",
        "pricing.pro.price.annual": "$324 Fatturato annualmente",
        "pricing.pro.features.podcast_time": "320 minuti di tempo podcast al mese",
        "pricing.pro.features.personalize_ai_voice": "Personalizza la voce dell'IA",
        "pricing.pro.features.video_clips": "20 clip video o audiogrammi",
        "common.no_watermark": "senza filigrana",
        "pricing.pro.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.pro.features.file_upload": "Caricamento di file fino a 10Gb",
        "pricing.pro.features.unlimited_uploads": "Caricamenti illimitati",
        "pricing.pro.features.landing_pages": "Pagine di destinazione del podcast",
        "common.customizable": "personalizzabile",
        "pricing.pro.features.audio_video_edit": "Modifica magica di audio e video",
        "pricing.pro.features.everything_in_pro": "Tutto in Pro",
        "pricing.agency_lite.title": "Agenzia Lite",
        "pricing.agency_lite.subtitle": "Per le agenzie di podcast che vogliono ottimizzare e far crescere il loro business.",
        "pricing.agency_lite.price.annual": "$495 Fatturato annualmente",
        "pricing.agency_lite.features.podcast_time": "600 minuti di tempo podcast al mese",
        "pricing.agency_lite.features.personalize_ai_voice": "Personalizza la voce dell'IA",
        "pricing.agency_lite.features.video_clips": "40 clip video o audiogrammi",
        "pricing.agency_lite.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.agency_lite.features.file_upload": "Caricamento di file fino a 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Caricamenti illimitati",
        "pricing.agency_lite.features.landing_pages": "Pagine di destinazione del podcast",
        "pricing.agency_lite.features.audio_video_edit": "Modifica magica di audio e video",
        "pricing.agency_plus.title": "Agenzia Plus",
        "pricing.agency_plus.subtitle": "Per le agenzie di podcast che vogliono ottimizzare e far crescere il loro business.",
        "pricing.agency_plus.price.annual": "$1.251 Fatturato annualmente",
        "pricing.agency_plus.features.podcast_time": "2000 minuti di tempo podcast al mese",
        "pricing.agency_plus.features.personalize_ai_voice": "Personalizza la voce dell'IA",
        "pricing.agency_plus.features.video_clips": "80 clip video o audiogrammi",
        "pricing.agency_plus.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.agency_plus.features.file_upload": "Caricamento di file fino a 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Caricamenti illimitati",
        "pricing.agency_plus.features.landing_pages": "Pagine di destinazione del podcast",
        "pricing.agency_plus.features.audio_video_edit": "Modifica magica di audio e video",
        "pricing.agency_scale.title": "Scala dell'Agenzia",
        "pricing.agency_scale.subtitle": "Per le agenzie di podcast che vogliono ottimizzare e far crescere il loro business.",
        "pricing.agency_scale.price.annual": "$2.175 Fatturato annualmente",
        "pricing.agency_scale.features.podcast_time": "4000 minuti di tempo podcast al mese",
        "pricing.agency_scale.features.personalize_ai_voice": "Personalizza la voce dell'IA",
        "pricing.agency_scale.features.video_clips": "160 clip video o audiogrammi",
        "pricing.agency_scale.features.quote_images": "Immagini di citazioni illimitate",
        "pricing.agency_scale.features.file_upload": "Caricamento di file fino a 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Caricamenti illimitati",
        "pricing.agency_scale.features.landing_pages": "Pagine di destinazione del podcast",
        "pricing.agency_scale.features.audio_video_edit": "Modifica magica di audio e video",
        "pricing.header": "Per i podcaster solitari e le agenzie di podcast",
        "pricing.minutes_reset": "Puoi accumulare fino a 3 volte i tuoi minuti mensili, finché rimani sul tuo piano attuale o effettui un upgrade.",
        "pricing.most_popular": "Più popolare",
        "pricing.minutes_per_month": "Minuti per mese",
        "pricing.enterprise_title": "Azienda",
        "pricing.enterprise_subtitle": "Per le agenzie e le aziende di media che vogliono sviluppare il loro business.",
        "pricing.enterprise_price": "Personalizzato",
        "pricing.enterprise_price_note": "Contattaci team@podsqueeze.com o prenota un appuntamento qui sotto.",
        "pricing.enterprise_feature_priority_support": "Supporto prioritario",
        "pricing.enterprise_feature_team_sits": "Sedute di team",
        "pricing.enterprise_personalized_team_training": "Onboarding e formazione del team",
        "pricing.book_demo": "Prenota un appuntamento",
        "pricing.unlimited": "Illimitato",
        "pricing.custom": "Personalizzato"
      },
      "toggle": {
        "pay.monthly": "Mensile",
        "pay.annually": "Annuo",
        "discount.30percent": "30% Sconto"
      },
      "upgradeModal": {
        "upgrade.success": "Il tuo abbonamento è stato aggiornato con successo",
        "upgrade.error": "Ci dispiace, qualcosa è andato storto. Per favore, riprova più tardi",
        "upgrade.loading": "Aggiornamento",
        "upgrade.confirmPay": "Conferma e Paga",
        "upgrade.cancel": "Annulla",
        "coupon.placeholder": "Codice Coupon",
        "coupon.apply": "Applica",
        "coupon.have": "Ho un coupon",
        "upgrade.confirmation": "Stai per aggiornare a",
        "upgrade.price": "Stai per pagare"
      }
    },
    "register": {
      "page": {
        "register.form": "ModuloDiRegistrazione"
      },
      "registerForm": {
        "error.invalidCredentials": "Inserisci un indirizzo email e una password validi.",
        "error.weakPassword": "Per favore, usa una password più forte 💪",
        "error.emailInUse": "L'utente esiste già",
        "error.userNotFound": "Utente non trovato",
        "error.generic": "Ops, qualcosa è andato storto",
        "placeholder.email": "Indirizzo email",
        "placeholder.password": "Password",
        "button.registering": "Registrazione in corso...",
        "button.register": "Registrati",
        "label.newsletter": "Unisciti a 12.000 podcaster e iscriviti alla nostra newsletter per aggiornamenti sui prodotti, consigli pratici, ebook, regali e molto altro.",
        "label.alreadyHaveAccount": "Hai già un account?",
        "label.logInHere": "Accedi qui",
        "label.or": "O",
        "button.signingIn": "Accesso in corso...",
        "button.continueWithGoogle": "Continua con Google",
        "label.podcastDescription": "Lancia e sviluppa facilmente il tuo podcast audio o video con tutto ciò di cui hai bisogno nello stesso posto.",
        "feature.transcripts": "Trascrizioni",
        "feature.showNotes": "Note dello spettacolo",
        "feature.newslettersBlogs": "Newsletter & Blog",
        "feature.socialPosts": "Post sui social network",
        "feature.shortClips": "Brevi video & Audiogrammi",
        "feature.podcastWebsite": "Sito web del podcast",
        "feature.audioEnhancement": "Miglioramento audio tramite IA",
        "feature.removeSilences": "Rimuovi i silenzi e gli eh"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "testo"
      },
      "TopicFinder": {
        "competition.veryHigh": "Very High",
        "competition.high": "High",
        "competition.medium": "Medium",
        "competition.low": "Low",
        "competition.veryLow": "Very Low",
        "upgrade.button": "Upgrade to Pro",
        "clicks.label": "Clicks",
        "searches.label": "Searches",
        "competition.label": "Competition",
        "fetching.results": "Fetching results",
        "table.topic": "Topic",
        "tooltip.topic": "The main topic covered in your podcast episode",
        "table.monthlySearches": "Monthly Searches",
        "tooltip.monthlySearches": "The range of Google searches you can expect each month",
        "table.competition": "Competition",
        "tooltip.competition": "The main topic or theme covered by the podcast.",
        "table.monthlyGoogleClicks": "Monthly Google Clicks",
        "tooltip.monthlyGoogleClicks": "Forecast of the range of Google clicks you can expect each month",
        "table.youtubeReach": "YouTube Reach",
        "tooltip.youtubeReach": "Forecast of the maximum number of YouTube views you can expect in the first 6 months based on average competitors",
        "intro.title": "Free Podcast Topic Generator",
        "intro.description": "Get ideas for podcast topics that your audience is searching for",
        "intro.check1": "See the demand on Google for each topic idea",
        "intro.check2": "Understand the level of competition for each podcast topic idea",
        "intro.check3": "Estimate the clicks you can get on Google and views on YouTube",
        "upgrade.message": "You need to upgrade to Pro to access all results",
        "learnMore.label": "Learn more about",
        "learnMore.link": "free tool to generate podcast topics",
        "newSearch.button": "New Search",
        "share.button": "Share this search",
        "form.label": "Enter your podcast niche",
        "form.placeholder": "Digital Marketing",
        "form.submit": "Find Topic Ideas"
      },
      "page": {
        "main.background": "sfondo"
      },
      "shareTopics": {
        "share.results": "Condividi Risultati",
        "share.facebook": "Condividi su Facebook",
        "share.whatsapp": "Condividi su WhatsApp",
        "share.twitter": "Condividi su Twitter",
        "share.linkedin": "Condividi su LinkedIn",
        "copy.success": "Copiato",
        "copy.link": "Copia il Link"
      },
      "youtubeScore": {
        "loading.placeholder": "Caricamento...",
        "views.label": "visualizzazioni"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "No se pudo obtener la composición actual",
        "error.addImage": "Error al agregar el elemento de imagen:",
        "alert.uploadImage": "Por favor, sube un archivo de imagen.",
        "error.uploadImage": "Error al subir la imagen:",
        "alert.uploadFailed": "Error al subir la imagen. Por favor, inténtalo de nuevo.",
        "error.getDownloadURL": "Error al obtener la URL de descarga:",
        "alert.processImageFailed": "Error al procesar la imagen subida. Por favor, inténtalo de nuevo.",
        "error.addText": "Error al agregar el elemento de texto:",
        "text.settingsPlaceholder": "Las configuraciones se mostrarán cuando se seleccione el elemento",
        "text.addElement": "Agregar Elemento",
        "text.uploading": "Subiendo...",
        "button.uploadImage": "Subir Imagen",
        "text.newText": "Nuevo Texto",
        "button.addText": "Agregar Texto",
        "text.selectedElementSettings": "Configuraciones del Elemento Seleccionado"
      },
      "FontSelector": {
        "allFonts": "Tutti i caratteri",
        "myFonts": "I miei caratteri",
        "uploadFont": "Carica carattere",
        "noCustomFonts": "Ancora nessun carattere personalizzato.",
        "uploadToAdd": "Carica un file di caratteri per aggiungerlo alla tua collezione.",
        "text_outline": "Contorno del testo",
        "outline_color": "Colore del contorno",
        "outline_width": "Spessore del contorno"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Ajustar",
        "imageLayoutSettings.zoom": "Zoom",
        "imageLayoutSettings.horizontalAlignment": "Alineación Horizontal",
        "imageLayoutSettings.verticalAlignment": "Alineación Vertical",
        "imageLayoutSettings.deleteElement": "Eliminar Elemento"
      },
      "TemplateBox": {
        "confirm.delete.template": "¿Está seguro de que desea eliminar esta plantilla?"
      },
      "TextSettings": {
        "error.getting_current_text": "Errore nel recupero del testo corrente:",
        "event.delete_text_element_clicked": "Elemento di testo eliminato cliccato",
        "error.changing_text_font": "Errore nel cambiare il font del testo:",
        "event.text_font_changed": "Font del testo cambiato",
        "error.changing_text_size": "Errore nel cambiare la dimensione del testo:",
        "event.text_size_changed": "Dimensione del testo cambiata",
        "error.changing_text_color": "Errore nel cambiare il colore del testo:",
        "event.text_color_changed": "Colore del testo cambiato",
        "event.text_content_added": "Contenuto del testo aggiunto",
        "error.adding_text_content": "Errore nell'aggiungere il contenuto del testo:",
        "event.text_content_updated": "Contenuto del testo aggiornato",
        "label.text_content": "Contenuto del testo",
        "label.text_font": "Font del testo",
        "label.text_font_weight": "Spessore del font",
        "label.adjust_text_size": "Regola dimensione del testo",
        "label.text_color": "Colore del testo",
        "button.delete": "Elimina"
      },
      "audiogramBaseTemplate": {
        "color.white": "Bianco",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "urlDellEpisodioDiDefault",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "quadratico-uscita",
        "animation.fade": "scomparire",
        "type.text": "testo",
        "name.podcastTitle": "TitoloDelPodcast",
        "name.snippetTitle": "TitoloDelFrammento",
        "type.image": "immagine",
        "name.audioBackgroundImage": "ImmagineDiSfondoAudio",
        "name.subtitlesText": "testoDeiSottotitoli",
        "effect.highlight": "evidenziare",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "Titolo del frammento",
        "podcast.title": "Titolo del podcast",
        "new.episode": "NUOVO EPISODIO"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Bianco",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "urlDellEpisodioPredefinito",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "musica_di_sfondo",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Per favore, carica un file immagine.",
        "upload.file.loading": "Caricamento file. Per favore, non chiudere questa finestra.",
        "upload.image.label": "Sostituisci immagine",
        "ai.prompt.label": "Inserisci un prompt per far generare un'immagine dall'IA",
        "ai.prompt.placeholder": "Esempio: Un cane che corre nel parco...",
        "ai.processing": "In elaborazione...",
        "ai.create": "Crea",
        "customize.image.title": "Personalizza Immagine",
        "enter.image.url": "Inserisci l'URL dell'immagine",
        "or": "o"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Erreur lors de la récupération des modèles :",
        "template.savedSuccessfully": "Modèle enregistré avec succès",
        "error.savingTemplate": "Erreur lors de l'enregistrement du modèle :",
        "loading.savedTemplates": "Chargement des modèles enregistrés...",
        "no.savedTemplates": "Aucun modèle enregistré",
        "select_template": "Sélectionner un modèle",
        "saving.template": "Enregistrement du modèle...",
        "template_name": "Nom du modèle",
        "enter.templateName": "Entrez le nom du modèle",
        "cancel": "Annuler",
        "save": "Enregistrer",
        "default_templates": "Modelli Predefiniti",
        "saved_templates_count": "Modelli Salvati ({count})",
        "folder_templates_count": "Modelli di Cartella ({count})",
        "account_templates_count": "Modelli di Account ({count})",
        "save_current_template": "Salva Modello Attuale"
      },
      "subtitlesElement": {
        "edit.word": "Modifica la parola",
        "edit.label": "modifica",
        "remove.word.subtitle": "Rimuovi la parola solo dai sottotitoli",
        "erase.subtitle": "cancella dai sottotitoli",
        "remove.word.clip": "Rimuovi la parola dall'audio e dai sottotitoli",
        "remove.clip": "rimuovi dal clip"
      },
      "utils": {
        "video.utils.title": "Titolo",
        "video.utils.currentTime": "Tempo Attuale",
        "video.utils.nextTime": "Prossimo Tempo",
        "video.utils.duration": "Durata",
        "video.utils.description": "Descrizione",
        "video.utils.srtSegment": "Segmento SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Qui va il tuo testo del sottotitolo"
      }
    }
  },
  "ja": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "パートナーになる",
        "SHARE_PODSQUEEZE": "Podsqueezeをあなたのオーディエンスと共有",
        "AND_EARN_MONEY": "してお金を稼ごう！",
        "LAST_UPDATED": "最終更新日: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "アフィリエイトパートナーになる",
        "EARN_COMMISSION": "稼ぐ",
        "COMMISSION": "コミッション",
        "ON_EVERY_SALE": "15か月間、あなたの専用紹介リンクを通じて行われたすべての販売に対してコミッションを獲得。リンクをウェブサイト、ソーシャルメディア、または友達と共有しましょう。参加には数秒しかかかりません。",
        "GET_AUTOMATICALLY_APPROVED": "自動的に承認されます。",
        "JOIN_NOW": "今すぐ参加",
        "HOW_IT_WORKS": "使い方",
        "FREQUENTLY_ASKED_QUESTIONS": "よくある質問",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "アフィリエイトパートナーとは？",
        "AFFILIATE_PARTNER_DESCRIPTION": "アフィリエイトパートナーとは、他社の製品やサービスを独自の紹介リンクを通じて宣伝し、そのリンクを通じて行われたすべての販売に対してコミッションを得る人のことです。",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "どうすればアフィリエイトパートナーになれますか？",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "アフィリエイトパートナーになるのは簡単で、数秒しかかかりません。始めるには、「今すぐ参加」ボタンをクリックして、メールアドレスで登録してください。登録が完了すると、使いやすいダッシュボードにアクセスでき、あなたの独自の紹介リンクが表示されます。このリンクを家族や友人、オンラインのオーディエンスと共有しましょう。誰かがあなたの紹介リンクをクリックしてPodsqueezeのウェブサイトで購入を行うと、15か月間のすべての支払いに対して25％のコミッションが得られます！あなたのダッシュボードで生成されたすべての売上を簡単に追跡できます。",
        "HOW_CAN_I_TRACK_MY_SALES": "売上とコミッションをどうやって追跡できますか？",
        "TRACKING_SALES_DESCRIPTION": "アフィリエイトプログラムダッシュボードを使用して、売上とコミッションを追跡できます。この追跡ソフトウェアは、アフィリエイトパートナーとビジネスパートナーの両方が利用できます。",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "いつ、そしてどのようにして支払いを受け取りますか？",
        "PAYMENT_DESCRIPTION": "支払いは30日ごとにPayPalで受け取ります。最低支払い額が50ドルであることにご注意ください。この金額に達すると、30日ごとにきちんと支払いを受け取ることができます。",
        "STILL_GOT_QUESTIONS": "まだ質問がありますか？",
        "SEND_US_A_MESSAGE": "サポートチャットでメッセージを送るか、team@podsqueeze.com にメールを送ってください",
        "NOTE": "注意",
        "AFFILIATE_ADS_RESTRICTION": "アフィリエイトパートナーは、Googleでの広告作成や、Podsqueezeに関連するキーワードの入札を行うことはできません。",
        "AFFILIATE_TERMS_OF_USE": "アフィリエイト利用規約",
        "CAN_I_RUN_ADS": "紹介リンクを宣伝するためにGoogleで広告やCPCキャンペーンを実行できますか？",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "アフィリエイトパートナーは、検索エンジンでの広告作成やPodsqueezeに関連するキーワードの入札を行うことは禁止されています。この制限は、私たちの広告戦略の整合性を保ち、ブランドメッセージの一貫性を確保するのに役立ちます。これらの入札キャンペーンからの販売は支払い対象外となります。",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Podsqueezeはどのようにしてポッドキャストのタイトルを生成しますか？"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "ナビゲーションバー",
        "main.affiliateHero": "アフィリエイトヒーロー",
        "main.footer": "フッター"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "イントロとアウトロの音楽を追加",
        "intro.music": "イントロ音楽",
        "outro.music": "アウトロ音楽",
        "intro.duration": "イントロ時間",
        "outro.duration": "アウトロ時間",
        "intro.mode": "イントロモード",
        "outro.mode": "アウトロモード",
        "cancel": "キャンセル",
        "save": "保存",
        "apply": "適用",
        "current.intro.music": "現在のイントロ音楽",
        "current.outro.music": "現在のアウトロ音楽",
        "change.music": "音楽を変更",
        "choose.music": "音楽ファイルを選択",
        "browser.not.support.audio": "お使いのブラウザは音声要素をサポートしていません。",
        "save.and.apply": "保存して適用",
        "no.music.selected": "音楽が選択されていません",
        "delete.music": "音楽を削除",
        "uploading.file": "ファイルをアップロード中..."
      },
      "audioEditElements": {
        "error.processing.rss": "一部のRSSフィードの処理に問題が発生しています。ファイルをアップロードしてください。",
        "edit.enhance.audio": "音声録音を編集して強化する",
        "trial.label": "トライアル",
        "audio.editing.experience": "高度なAIアルゴリズムを使用したシームレスな音声編集を体験し、自然で高品質な結果をワンクリックで得られます。",
        "improve.audio.quality": "音質を改善する",
        "remove.hums.silences": "ハム音と無音を除去する",
        "upgrade.edit.audio": "ワンクリックで音声を編集できるようにアップグレードする",
        "available.plans": "すべての支払いプランで利用可能",
        "upgrade.now": "今すぐアップグレード",
        "audio.element.support": "お使いのブラウザはaudio要素をサポートしていません。",
        "download.audio": "音声をダウンロード",
        "loading.audio": "音声読み込み中",
        "editing.audio": "音声編集"
      },
      "videoEditElements": {
        "error.exporting.video": "ビデオのエクスポート中にエラーが発生しました",
        "download.failed": "ダウンロードに失敗しました: {error.message}",
        "generating.video": "ビデオを生成中",
        "error.generating.clip": "クリップの生成中にエラーが発生しました",
        "please.retry.support": "再試行するか、ユーザーサポートにお問い合わせください",
        "browser.not.support.video": "お使いのブラウザはvideoタグをサポートしていません。",
        "this.might.take.minutes": "ウィンドウを閉じないでください。これには数分かかる場合があります。",
        "exporting.video": "ビデオをエクスポート中...",
        "seamless.audio.editing": "高度なAIアルゴリズムを使用したシームレスなオーディオ編集を体験してください。自然で高品質な結果を、ワンクリックで実現します。",
        "difficulties.processing.rss": "一部のRSSフィードの処理に困難が生じています。ファイルをアップロードしてください。",
        "edit.enhance.video.recording": "ビデオ録画を編集および強化する",
        "trial": "トライアル",
        "enhance.audio.quality": "オーディオ品質を向上させる",
        "enhance.audio.quality.edit": "オーディオ品質を向上させて編集する",
        "trim.filler.words.video": "ビデオからフィラー言葉をトリミングする（例：うーん）",
        "trim.long.silences.video": "ビデオから長い沈黙をトリミングする",
        "upgrade.to.edit.video": "ワンクリックでビデオを編集できるようにアップグレードする",
        "available.pro.agency.plans": "プロおよびエージェンシープランで利用可能",
        "upgrade.now": "今すぐアップグレード",
        "download.only.audio": "オーディオのみをダウンロード",
        "download.video": "ビデオをダウンロード",
        "please.dont.close.window": "ウィンドウを閉じないでください",
        "export.video": "ビデオをエクスポート"
      },
      "videogramBaseTemplate": {
        "media.fit": "カバー",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "メディア"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "このポッドキャストの他のエピソード",
        "tab.shownotes": "番組ノート",
        "tab.timestamps": "タイムスタンプ",
        "tab.blogpost": "ブログ記事",
        "tab.transcript": "文字起こし",
        "key.points": "重要ポイント"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "あなたのランディングページは私たちのポッドキャストファインダーで公開されています。オーディエンスと共有しましょう！",
        "landingPage.create": "このエピソードのために美しいランディングページを作成します",
        "landingPage.edit": "ページを編集",
        "landingPage.visit": "ページを訪問",
        "landingPage.delete": "ページを削除",
        "landingPage.createButton": "ランディングページを作成"
      },
      "SocialLinksModal": {
        "manage.episode.links": "エピソードリンクを管理",
        "youtube.link": "YouTubeリンク",
        "enter.youtube.link": "YouTubeリンクを入力",
        "apple.podcasts.link": "Apple Podcastsリンク",
        "enter.apple.podcasts.link": "Apple Podcastsリンクを入力",
        "spotify.link": "Spotifyリンク",
        "enter.spotify.link": "Spotifyリンクを入力",
        "saving": "保存中...",
        "save": "保存",
        "social.links.updated.successfully": "ソーシャルリンクが正常に更新されました！"
      },
      "affiliatesection": {
        "affiliate.section.title": "アフィリエイトパートナーになる",
        "affiliate.section.subtitle": "あなたのオーディエンスとPodsqueezeを共有し、",
        "affiliate.section.earn": "お金を稼ぎましょう！",
        "affiliate.section.commission": "私たちのアフィリエイトプログラムは、すべての販売およびサブスクリプション更新の支払いに対して、15ヶ月間25%のコミッションを提供します。",
        "affiliate.section.join": "参加するのは数秒で完了します！",
        "affiliate.section.knowMore": "詳細を知る"
      },
      "asseenon": {
        "podnews.logo": "ポッドニュースのロゴ",
        "transistor.logo": "トランジスタのロゴ",
        "thepodcasthost.logo": "ポッドキャストホストのロゴ",
        "schoolofpodcasting.logo": "ポッドキャスティングスクールのロゴ",
        "semrush.logo": "セムラッシュのロゴ"
      },
      "assembleshownotes": {
        "episode.description": "エピソードの説明",
        "bullet.points": "箇条書き",
        "timestamps": "タイムスタンプ",
        "links.and.mentions": "リンクと言及",
        "extra.content": "追加コンテンツ",
        "assemble.show.notes": "ショーノートをまとめる",
        "downloading": "ダウンロード中",
        "copied": "コピーしました",
        "enter.placeholder": "{{label}}を入力..."
      },
      "cancelationModal": {
        "cancellation.option.break": "ポッドキャスティングを休む",
        "cancellation.option.no_recurrent": "定期購読を希望しません",
        "cancellation.option.expensive": "高すぎます",
        "cancellation.option.not_saving_time": "十分な時間を節約できていません",
        "cancellation.option.dissatisfied_content": "生成されたコンテンツの質に不満",
        "cancellation.option.unresponsive_support": "反応のないカスタマーサポート",
        "cancellation.option.not_using": "サービスを十分に利用していません",
        "cancellation.option.difficulty_navigating": "製品の使用/ナビゲーションに困難を感じています",
        "cancellation.option.better_alternative": "より良い代替製品を見つけました",
        "cancellation.option.other": "その他",
        "cancellation.video.message": "私たちのユーザーの70%がこのビデオを見た後にキャンセルプロセスを中止します",
        "cancellation.button.cancel": "キャンセルしたいです",
        "cancellation.button.try_again": "もう一度試したいです",
        "cancellation.prompt.select_reason": "購読をキャンセルする理由を選択することで、製品の改善にご協力ください:",
        "cancellation.placeholder.answer": "ここに回答を入力してください...",
        "cancellation.placeholder.specify_reason": "キャンセルの理由を具体的に記入してください",
        "cancellation.button.next": "次へ",
        "cancellation.button.go_back": "戻る",
        "lose.all.accumulated.minutes": "キャンセルすると、累積されたすべての分が失われます。",
        "keep.accumulating.minutes": "キャンセルしても、累積された分を保持して、次のポッドキャスト開始時に使用できます。",
        "here.are.some.ideas": "ここにはPodsqueezeをより多く使用するためのいくつかのアイデアがあります。",
        "generate.articles.favorite.podcasts.and.vides": "購入したエピソードを新しいコンテンツに変換して使用できます。",
        "convert.and.repurpose.episodes": "購入したエピソードを新しいコンテンツに変換して使用できます。",
        "share.your.account.with.a.friend": "購入したエピソードを新しいコンテンツに変換して使用できます。",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "購入したエピソードを新しいコンテンツに変換して使用できます。",
        "cancellation.last_question.title": "最後の質問です",
        "cancellation.last_question.prompt": "再度サービスに参加することを検討するために、どのような変更や改善が必要ですか？",
        "cancellation.feedback.message": "あなたのフィードバックは私たちの改善に役立ちます 🙏",
        "cancellation.button.confirm": "キャンセルを確認",
        "cancellation.minutes.accumulated": "あなたは",
        "cancellation.minutes.accumulated.suffix": "の蓄積された分があり、価値は",
        "cancellation.reminder.text": "覚えておいてください:",
        "cancellation.minutes.warning": "蓄積された分はアクティブなサブスクリプションの特典です。サブスクリプションをキャンセルすると、あなたの分は永久に失われます。",
        "cancellation.content.deletion.warning": "生成されたすべてのコンテンツは30日後に永久に削除されます。",
        "cancellation.minutes.left.title": "まだ分が残っています！無駄にしないでください！",
        "cancellation.suggestion.clips": "古いエピソードをソーシャルメディア用のクリップに再利用する",
        "cancellation.suggestion.articles": "古いエピソードをPodsqueezeで記事に変換してSEOの恩恵を受ける。",
        "cancellation.suggestion.linkedin": "古い権威あるエピソードをLinkedInの投稿に変換して個人ブランドを強化する",
        "cancellation.suggestion.share": "使用していない分を友達が活用できるようにPodsqueezeアカウントを共有する。",
        "cancellation.button.keep.subscription": "サブスクリプションを維持する",
        "cancellation.button.keep.minutes": "私の",
        "cancellation.button.keep.minutes.suffix": "価値の分を維持する",
        "cancellation.lifetime.before_you_go": "行く前に...",
        "cancellation.lifetime.title": "たった$49で生涯アクセスはいかがですか？",
        "cancellation.lifetime.subtitle": "Starterアカウントを保持。 サブスクリプションなし。更新なし。 あなただけのもの — 永遠に。",
        "cancellation.lifetime.feature1": "一回限りの$49支払いでPodsqueezeへの生涯アクセス",
        "cancellation.lifetime.feature2": "必要な時に使用、プレッシャーなし — 永遠にあなたのもの",
        "cancellation.lifetime.feature3": "現在および将来のすべてのStarterプラン機能を含む",
        "cancellation.lifetime.button_cancel": "まだキャンセルしたい",
        "cancellation.lifetime.button_deal": "ライフタイムディールを取得",
        "cancellation.downgrade.title": "月額$5.99でコンテンツをすべて保持",
        "cancellation.downgrade.subtitle": "Starterにダウングレードすることで...",
        "cancellation.downgrade.feature1": "生成されたコンテンツをすべて保持",
        "cancellation.downgrade.feature2": "ウェブサイトを稼働し続ける",
        "cancellation.downgrade.feature3": "月160分と10クリップで時々の作業に",
        "cancellation.billing.monthly": "月額",
        "cancellation.billing.annual": "年額",
        "cancellation.billing.discount": "30%オフ",
        "cancellation.plan.starter": "Starterプラン",
        "cancellation.price.monthly": "$8.99/月",
        "cancellation.price.annual": "$5.99/月",
        "cancellation.price.annual_billing": "年額$71.88で請求",
        "cancellation.feature.minutes": "160分/月",
        "cancellation.feature.clips": "10クリップ/月",
        "cancellation.downgrade.button": "Starterにダウングレードしてコンテンツを保持",
        "cancellation.error.payment_link": "支払いリンクを取得できませんでした。もう一度お試しください。",
        "cancellation.error.payment_service": "支払いサービスへの接続エラー。",
        "cancellation.option.question.break": "なぜ休憩を取るのか、詳しく教えていただけませんか？",
        "cancellation.option.question.no_recurrent": "なぜ定期的なサブスクリプションを希望しないのか、共有していただけませんか？",
        "cancellation.option.question.expensive": "どのような価格設定や機能があれば、サービスをより価値あるものにできるでしょうか？",
        "cancellation.option.question.not_saving_time": "あなたのプロセスで、まだ多くの時間を要しているものは何ですか？",
        "cancellation.option.question.dissatisfied_content": "コンテンツのどの側面に不満がありましたか？",
        "cancellation.option.question.unresponsive_support": "当社のカスタマーサポートでの体験について説明していただけますか？",
        "cancellation.option.question.not_using": "サービスをより頻繁に使用することを促すものはありますか？",
        "cancellation.option.question.difficulty_navigating": "製品の使用/ナビゲーションでどのような困難に遭遇しましたか？",
        "cancellation.option.question.better_alternative": "どのような代替製品を見つけて、その何が気に入っているのですか？",
        "cancellation.option.question.other": "キャンセルの理由を指定してください："
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "私たちはあなたのプライバシーを重視しています",
        "cookiebanner.cookieUsage": "私たちは、ウェブサイトの体験を向上させ、トラフィックを分析するためにクッキーを使用しています。受け入れるをクリックすることで、クッキーの使用に同意したことになります。",
        "cookiebanner.privacyPolicy": "プライバシーポリシー",
        "cookiebanner.accept": "受け入れる",
        "cookiebanner.decline": "拒否する"
      },
      "episodeTitleBox": {
        "loading": "読み込み中...",
        "editEpisodeTitleClicked": "エピソードタイトルの編集がクリックされました",
        "newEpisodeTitleStored": "新しいエピソードタイトルが保存されました"
      },
      "famewall": {
        "loading.message": "読み込み中..."
      },
      "footer": {
        "footer.features": "機能",
        "footer.transcriptGenerator": "トランスクリプトジェネレーター",
        "footer.subtitlesGenerator": "字幕ジェネレーター",
        "footer.descriptionGenerator": "説明ジェネレーター",
        "footer.podcastSummarizer": "ポッドキャストサマライザー",
        "footer.titlesGenerator": "タイトルジェネレーター",
        "footer.bulletPointsGenerator": "箇条書きジェネレーター",
        "footer.chaptersClipsGenerator": "章とクリップジェネレーター",
        "footer.socialMediaPostsGenerator": "ソーシャルメディア投稿ジェネレーター",
        "footer.newsletterGenerator": "ニュースレタージェネレーター",
        "footer.blogPostGenerator": "ブログ投稿ジェネレーター",
        "footer.podcastLandingPages": "ポッドキャストランディングページ",
        "footer.podcastClipMaker": "ポッドキャストクリップメーカー",
        "footer.audiogramGenerator": "オーディオグラムジェネレーター",
        "footer.aiAudioEnhancer": "AIオーディオエンハンサー",
        "footer.convertYoutubeToText": "YouTubeをテキストに変換",
        "footer.youtubeVideoNoiseRemover": "YouTube動画ノイズ除去",
        "footer.youtubeVideoKeyPoints": "YouTube動画の重要ポイント",
        "footer.freeResources": "無料リソース",
        "footer.findPodcastTopicIdeas": "ポッドキャストのトピックアイデアを見つける",
        "footer.articles": "記事",
        "footer.freeEbooks": "無料eBook",
        "footer.community": "コミュニティ",
        "footer.ourPodcast": "私たちのポッドキャスト",
        "footer.product": "製品",
        "footer.giftCard": "ギフトカード",
        "footer.onboardingEbook": "オンボーディングeBook",
        "footer.pricing": "価格",
        "footer.affiliates": "アフィリエイト",
        "footer.media": "メディア",
        "footer.testimonials": "推薦の声",
        "footer.legal": "法的情報",
        "footer.privacyPolicy": "プライバシーポリシー",
        "footer.termsOfUse": "利用規約",
        "footer.refundPolicy": "返金ポリシー",
        "footer.allRightsReserved": "全著作権所有。"
      },
      "globalState": {
        "cookie.enabled": "クッキーが有効",
        "language.default": "デフォルト言語"
      },
      "head": {
        "keywords.list": "ポッドスクイーズ, AI, ポッドキャスト, コンテンツ生成, ポッドキャストの文字起こし, ショーノート, タイムスタンプ, ポッドキャストニュースレター, ツイート, ブログ投稿, ソーシャル投稿, タイトル, ショーノートライター"
      },
      "imageResultModal": {
        "download.image": "画像をダウンロード",
        "generating.image": "画像を生成中",
        "ai.prompt.label": "AIに画像を生成するためのプロンプトを入力してください",
        "ai.prompt.placeholder": "例: 公園で走っている犬...",
        "processing": "処理中...",
        "create": "作成",
        "text.color.label": "テキストカラー",
        "quote.icon.color.label": "引用アイコンの色",
        "background.color.label": "背景色",
        "font.label": "フォント",
        "upload.cover.image": "カバー画像をアップロード",
        "aspect.ratio.info": "アスペクト比 1:1、推奨サイズ 1200x1200",
        "upload.logo.label": "ロゴをアップロード",
        "choose.file": "ファイルを選択",
        "upload.success": "アップロードに成功しました",
        "choose.quote": "引用を選択",
        "select.template": "テンプレートを選択",
        "quote.label": "引用",
        "enter.quote.here": "ここに引用を入力",
        "author.label": "著者",
        "enter.author.name": "著者名を入力",
        "podcast.name.label": "ポッドキャスト名",
        "enter.podcast.name": "ポッドキャスト名を入力",
        "colors": "色",
        "select.font": "フォントを選択",
        "cover.logo.images": "カバーとロゴの画像",
        "logo.image": "ロゴ画像",
        "upgrade.here": "ここでアップグレード",
        "remove.logo": "Podsqueezeロゴを削除",
        "default_templates": "デフォルトテンプレート",
        "saved_templates_count": "保存されたテンプレート",
        "save_current_template": "現在のテンプレートを保存",
        "no_saved_templates": "保存されたテンプレートはまだありません",
        "save_template": "テンプレートを保存",
        "cancel": "キャンセル",
        "save": "保存",
        "enter_template_name": "テンプレート名を入力",
        "reset_template": "リセット",
        "add_element": "要素を追加",
        "generate": "生成",
        "add_image": "画像を追加",
        "upload_image": "画像をアップロード",
        "or": "または",
        "generate_with_ai": "AIで生成",
        "search_fonts": "フォントを検索...",
        "upload_logo": "ロゴをアップロード",
        "square_image_recommended": "正方形の画像を推奨",
        "opacity": "不透明度",
        "layers": "レイヤー",
        "no_element_selected": "要素が選択されていません",
        "bold_shortcut": "太字 (Ctrl+B)",
        "italic_shortcut": "斜体 (Ctrl+I)",
        "underline_shortcut": "下線 (Ctrl+U)",
        "edit_text": "テキストを編集",
        "tint_color": "色調",
        "toggle_gradient_transparent": "グラデーションを透明に切り替え",
        "rotate_gradient": "グラデーションを45度回転",
        "alt_background": "背景",
        "alt_podcast_logo": "ポッドキャストのロゴ",
        "alt_custom": "カスタム",
        "alt_right_side": "右側",
        "alt_profile": "プロフィール"
      },
      "intentModal": {
        "intentModal.title": "Podsqueezeで何をしたいですか？",
        "intentModal.sourceOption.Write_Show_Notes": "ショーノートを書く",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "ブログ投稿とニュースレターを書く",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "ビデオクリップまたはオーディオグラムを作成する",
        "intentModal.sourceOption.Create_Quote_Images": "引用画像を作成する",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "音声/ビデオを編集・強化する",
        "intentModal.sourceOption.Transcribe": "文字起こしする",
        "intentModal.sourceOption.Create_a_Website": "ウェブサイトを作成する",
        "intentModal.sourceOption.All_of_the_Above": "上記すべて",
        "intentModal.sourceOption.Other": "その他",
        "intentModal.otherPlaceholder": "具体的に記入してください",
        "intentModal.submitButton": "送信して登録",
        "intentModal.skip": "スキップ"
      },
      "languageSwitcher": {
        "language.en": "英語",
        "language.es": "スペイン語",
        "language.fr": "フランス語",
        "language.de": "ドイツ語",
        "language.it": "イタリア語",
        "language.pt": "ポルトガル語",
        "language.nl": "オランダ語",
        "language.pl": "ポーランド語",
        "language.ru": "ロシア語",
        "language.zh": "中国語",
        "language.ja": "日本語",
        "language.ko": "韓国語",
        "language.ar": "アラビア語",
        "language.th": "タイ語",
        "language.vi": "ベトナム語"
      },
      "lazyImage": {
        "lazyImage.alt": "画像の説明"
      },
      "metadata": {
        "meta.title": "あなたのページタイトル",
        "meta.appName": "ポッドスクイーズ",
        "meta.appCategory": "ユーティリティ"
      },
      "navbar": {
        "navbar.dashboard": "ダッシュボード",
        "navbar.login": "ログイン",
        "navbar.openMenu": "メインメニューを開く",
        "navbar.features": "機能",
        "navbar.resources": "リソース",
        "navbar.pricing": "料金",
        "navbar.contact": "お問い合わせ",
        "navbar.topPodcasts": "トップポッドキャスト",
        "navbar.seeAllFeatures": "すべての機能を見る",
        "navbar.mainFeatures": "主な機能",
        "navbar.podcastTranscription": "ポッドキャストとビデオの文字起こし生成器",
        "navbar.transcriptionDescription": "話者ラベリングと字幕用のSRTファイル付きの高精度な文字起こし。",
        "navbar.podcastSummarizer": "ポッドキャスト要約器",
        "navbar.summarizerDescription": "自分の声で20倍速く完全なショーノートを作成します。",
        "navbar.podcastClipMaker": "ポッドキャストクリップメーカー",
        "navbar.clipMakerDescription": "ポッドキャスト用の短いクリップやオーディオグラムを自動生成します。",
        "navbar.audioEnhancer": "AIオーディオエンハンサー",
        "navbar.audioEnhancerDescription": "オーディオを自動的に強化し、無音やフィラー言葉を取り除きます。",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE機能のウォークスルー",
        "navbar.blog": "ブログ",
        "navbar.blogDescription": "成功するポッドキャストを立ち上げ、成長させるための実用的な記事とガイド。",
        "navbar.podcastTopicIdeas": "ポッドキャストのトピックアイデア",
        "navbar.topicIdeasDescription": "オーディエンスが検索しているポッドキャストのトピックを発見します。",
        "navbar.actionableEbooks": "実践的なeBook",
        "navbar.ebooksDescription": "ポッドキャストを次のレベルに上げるための実践的なヒント満載の無料eBookをダウンロード。",
        "navbar.freeThumbnailMaker": "無料ポッドキャストサムネイル作成ツール",
        "navbar.freeThumbnailMakerDescription": "AIでプロフェッショナルで魅力的なエピソードサムネイルを作成。",
        "navbar.seoOptimizer": "SEOオプティマイザー",
        "navbar.seoOptimizerDescription": "検索エンジンでの視認性向上のためにポッドキャストエピソードを最適化。",
        "navbar.podcastDescription": "世界中の経験豊富なポッドキャスターとPodsqueezeユーザーにインタビューする私たちのポッドキャストを聞いてください。彼らのヒント、洞察、ストーリー、そしてあなた自身のポッドキャストを成長させるために知っておくべきすべてを共有してもらいます。"
      },
      "resultModal": {
        "prompt.transcript.quote": "引用",
        "prompt.transcript.blog": "ブログ",
        "prompt.transcript.tweets": "ツイート",
        "prompt.shownotes.firstPerson": "一人称のショーノート",
        "prompt.shownotes.replaceName": "ショーノートの名前を置き換える",
        "prompt.shownotes.friendlyTone": "フレンドリーなトーンのショーノート",
        "prompt.shownotes.youtubeDescription": "YouTubeの説明ショーノート",
        "prompt.shownotes.engagingQuestion": "魅力的な質問のショーノート",
        "prompt.timestamps.formatAsChapters": "タイムスタンプを説明的なタイトル付きのチャプターとしてフォーマットする",
        "prompt.timestamps.detailedDescriptions": "トピックの説明と重要なポイントを含む詳細なタイムスタンプを作成する",
        "prompt.timestamps.improveSpeakerNames": "話者名を「ホスト」「専門家」「ゲスト」などのより説明的なタイトルに置き換える",
        "prompt.newsletter.casualTone": "カジュアルなトーンのニュースレター",
        "prompt.newsletter.shorter": "短いニュースレター",
        "prompt.newsletter.contentSections": "コンテンツセクションのニュースレター",
        "prompt.newsletter.changeName": "ニュースレターの名前を変更する",
        "prompt.mentions.fullURL": "完全なURLの言及",
        "prompt.mentions.replaceName": "言及の名前を置き換える",
        "prompt.tweets.underdogTone": "アンダードッグトーンのツイート",
        "prompt.tweets.firstPerson": "一人称のツイート",
        "prompt.shortPost.relevantEmojis": "関連する絵文字の短い投稿",
        "prompt.shortPost.educationalTone": "教育的なトーンの短い投稿",
        "prompt.shortPost.underdogTone": "アンダードッグトーンの短い投稿",
        "prompt.shortPost.firstPerson": "一人称の短い投稿",
        "prompt.titles.youtubeOptimized": "YouTube最適化タイトル",
        "prompt.titles.startWithHowTo": "'How to'で始まるタイトル",
        "prompt.titles.otherOptions": "タイトルの他のオプション",
        "prompt.keywords.youtubeOptimized": "YouTube最適化キーワード",
        "prompt.keywords.separateWithCommas": "キーワードをカンマで区切る",
        "prompt.quotes.lorem1": "ロレム・イプサム引用1",
        "prompt.quotes.lorem2": "ロレム・イプサム引用2",
        "prompt.bulletPoints.lorem1": "ロレム・イプサム箇条書き1",
        "prompt.bulletPoints.lorem2": "ロレム・イプサム箇条書き2",
        "prompt.longPost.firstPerson": "一人称の長い投稿",
        "prompt.longPost.relevantEmojis": "関連する絵文字の長い投稿",
        "prompt.longPost.changeName": "長い投稿の名前を変更する",
        "alert.tuningInstructionsEmpty": "調整指示は空にできません。",
        "text.timestamps.byPodsqueeze": "PodSqueezeによるタイムスタンプ",
        "button.copied": "コピーしました",
        "button.copy": "コピー",
        "embed.transcript": "トランスクリプトを埋め込む",
        "embed.description": "埋め込み用の説明",
        "preview.title": "プレビュータイトル",
        "loading.regenerating": "再生成中...",
        "placeholder.tuningInstructions": "調整指示を入力...",
        "button.saveClose": "保存して閉じる",
        "button.acceptChanges": "変更を受け入れる",
        "button.discard": "破棄する",
        "button.embedTranscript": "トランスクリプトを埋め込む",
        "text.copiedToClipboard": "クリップボードにコピーしました",
        "download.srtFile": "SRTファイルをダウンロード",
        "text.forCaptions": "キャプション用",
        "tune.title": "結果を調整する",
        "tune.description": "以下のオプションで結果を調整します。",
        "instruction.label": "指示:",
        "button.tuneResult": "結果を調整する",
        "instruction.saveForLater": "後で保存する",
        "button.readMore": "もっと読む",
        "button.showLess": "もっと読む",
        "customPrompt.used": "使用されたカスタムプロンプト:",
        "feedback.happyWithResults": "結果に満足していますか？"
      },
      "resultModalTranscript": {
        "prompt.quote": "トランスクリプトから良い引用を3つ見つける",
        "prompt.blog": "トピックXに焦点を当てた500語のブログ記事を書く",
        "prompt.tweets": "トランスクリプトから魅力的なツイートを3つ書く",
        "transcript.autoTranscribed": "Podsqueezeで自動転写されました",
        "alert.emptyPrompt": "調整指示は空にできません",
        "embed.transcript": "トランスクリプトを埋め込む",
        "embed.description": "WordPressサイトやHTMLをサポートするページに検索機能付きの管理しやすいサイズのトランスクリプトを埋め込みます。",
        "button.copied": "コピーしました！",
        "button.copy": "コピー",
        "preview.title": "プレビュー",
        "edit.speakers": "スピーカーの名前を編集",
        "button.saveClose": "保存して閉じる",
        "placeholder.prompt": "例: トランスクリプトから良い引用を3つ見つける",
        "upgrade.pro": "この機能を使用するにはProにアップグレードしてください",
        "upgrade.link": "Proにアップグレード",
        "button.generate": "生成",
        "feedback.happy": "結果に満足していますか？",
        "instruction": "指示: ",
        "generating.results": "結果を生成中",
        "full.transcription": "完全なトランスクリプション",
        "srt.file": "& SRTファイル",
        "download.srt": "SRTファイルをダウンロード",
        "caption.subtitles": "キャプションと字幕用。",
        "generate.from.transcript": "Gpt-4oを使用してトランスクリプトから生成",
        "gpt.tweak.text": "最新のGPTにテキストを好みに合わせて調整するように依頼します。自然な言葉を使い、具体的に伝えることを恐れないでください。",
        "copied.clipboard": "クリップボードにコピーしました",
        "transcript.public.available": "公開URL",
        "audio.notSupported": "お使いのブラウザはaudio要素をサポートしていません。",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "ポッドキャスト名を追加",
        "podcast.title": "{{title}} ポッドキャスト"
      },
      "sourceModal": {
        "sourceModal.title": "Podsqueezeをどのように知りましたか？",
        "sourceModal.otherPlaceholder": "具体的にご記入ください",
        "sourceModal.nextButton": "次へ",
        "sourceModal.skip": "スキップ"
      },
      "squeezeEditResults": {
        "error.processing.rss": "一部のRSSフィードの処理に問題が発生しています。ファイルをアップロードしてください。"
      },
      "squeezeResults": {
        "copiedToClipboard": "クリップボードにコピーされました",
        "publicLink": "公開リンク: ",
        "createLink": "この結果ページを共有するためのリンクを作成",
        "assembleShowNotes": "ショーノートをまとめる",
        "convertAnotherEpisode": "別のエピソードを変換",
        "writtenContent": "テキストコンテンツ",
        "videoClipsAndImages": "ビデオクリップと画像",
        "editAudio": "オーディオを編集"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "もっと見ると調整する",
        "see.more": "もっと見る",
        "generating": "生成中",
        "download.all": "すべてダウンロード",
        "full.transcription": "完全な文字起こし",
        "transcript.benefit": "番組ノートに完全な文字起こしを追加すると、ウェブサイトのトラフィックとエンゲージメントが向上することをご存知ですか？",
        "learn.more": "もっと学ぶ",
        "transcript.bonus": "ポッドキャストのメンバーシッププログラムの特典として、完全な文字起こしを提供できます。",
        "show.notes": "番組ノート",
        "show.notes.engagement": "この短い説明を番組ノートの他の要素と組み合わせて、エンゲージメントとSEOを向上させることを検討してください。",
        "show.notes.examples": "この17のポッドキャスト番組ノートの例からインスピレーションを得て、あなたのポッドキャストに最適なものを作成してください。",
        "timestamps": "タイムスタンプ",
        "timestamps.benefit": "これらのタイムスタンプをエピソードの説明に追加すると、SpotifyやYouTubeで自動的にチャプターが作成されます。",
        "titles": "タイトル",
        "titles.engagement": "疑問符や最上級を含むタイトルは特にエンゲージメントが高い傾向があります。",
        "links.and.mentions": "リンクと言及",
        "mentions.resources": "以下の言及を番組ノートのリソースセクションに含めることを検討してください。",
        "mentions.affiliate": "言及された製品にアフィリエイトプログラムがあるか確認し、番組ノートにアフィリエイトリンクを追加することを検討してください。",
        "mentions.social.media": "エピソードで言及された人々をソーシャルメディアでタグ付けして、彼らにあなたの投稿を共有し、エンゲージメントを促すようにしましょう。",
        "keywords": "キーワード",
        "keywords.youtube": "エピソードをYouTubeにアップロードする際、これらのキーワードをタグセクションにコピー＆ペーストしてください。",
        "keywords.social.media": "これらのキーワードをソーシャルメディアのハッシュタグとして再利用してください。",
        "blog.post": "ブログ投稿",
        "blog.post.linkedin": "このコンテンツを使用して、長文のLinkedIn投稿を作成することを検討してください。",
        "blog.post.share": "このコンテンツを、ポッドキャストのトピックに関連するRedditコミュニティやFacebookグループで共有してください。",
        "newsletter": "ニュースレター",
        "newsletter.content": "私たちのユーザーの中には、このニュースレターのコンテンツを再利用して、番組ノートのためにより包括的なエピソード説明を作成する人もいます。",
        "linkedin.and.facebook": "LinkedInとFacebook",
        "short.post.description": "関連するビデオクリップやオーディオグラムをソーシャルメディアで共有する際に、これらの短い投稿を説明として使用してください。",
        "tweets": "ツイート",
        "quotes": "引用",
        "bullet.points": "箇条書き",
        "add.custom.result": "カスタム結果を追加",
        "bullet.points.skimming": "ポッドキャスターは、エピソードの主要なトピックを箇条書きで番組ノートに記載し、簡単にスキミングできるようにすることがよくあります。"
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "もっと見ると調整する",
        "generating": "生成中",
        "not.available.for.rss.feed": "このRSSフィードでは利用できません",
        "regenerate.episode.upload.file": "エピソードを再生成し、コンピュータから直接音声/動画ファイルをアップロードしてください",
        "processing.difficulties": "一部のRSSフィードの処理に困難が生じています。ファイルをアップロードしてください。",
        "video.clips": "ビデオクリップ",
        "ai.short.clips": "AIショートクリップ",
        "quote.image": "引用画像"
      },
      "title": {
        "title.text": "あなたのラベル"
      },
      "topbar": {
        "topbar.forYou": "あなたのために",
        "topbar.joinPodcast": "次回のポッドキャストのバーチャルミートアップに参加しよう！",
        "topbar.saveYourSpot": "スポットを確保する",
        "topbar.dismiss": "閉じる"
      },
      "trackers": {
        "trackers.init": "クッキーが有効な状態でトラッカーを初期化しています: ",
        "trackers.loadScripts": "トラッキングスクリプトを読み込んでいます..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "私のアプリケーションへようこそ",
        "content.description": "これは翻訳を示すサンプルアプリケーションです。",
        "button.submit": "送信"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AIがクリップを編集しています",
        "export_clip": "クリップをエクスポート",
        "ai_edit": "AI編集",
        "ai_editing_clip_duration": "これには数秒かかります",
        "generating_clip": "クリップを生成中...",
        "generating_clip_notice": "これには数分かかる場合があります。完了次第、メールでお知らせします。",
        "edit_another_video": "ここで待つか、別の動画を編集できます",
        "download_video": "動画をダウンロード",
        "back_to_editing": "編集に戻る",
        "export_video_button": "クリップをエクスポート",
        "notice_storage": "お知らせ: 音声は30日間保存されます。この期間が過ぎると、このクリップは期限切れになります。",
        "error_generating_clip": "クリップの生成中にエラーが発生しました",
        "error_user_support": "再試行するか、ユーザーサポートにお問い合わせください",
        "select_template": "テンプレートを選択",
        "add_30s_prev": "前の章から30秒",
        "add_30s_next": "次の章から30秒",
        "undo": "元に戻す",
        "subtitles_font": "字幕のフォント",
        "subtitles_color": "字幕の色",
        "subtitles_box_color": "アニメーションの色",
        "adjust_podcast_title_position": "ポッドキャストタイトルの垂直位置を調整",
        "adjust_subtitles_size": "字幕のサイズを調整",
        "adjust_subtitles_vertical_position": "字幕の垂直位置を調整",
        "remove_subtitles": "字幕を削除",
        "animated_subtitles": "アニメーション字幕",
        "upgrade_here": "ここでアップグレード",
        "remove_logo": "ロゴを削除するには",
        "remove_podsqueeze_logo": "Podsqueezeロゴを削除",
        "aspect_ratio": "アスペクト比",
        "youtube": "YouTube",
        "social_media": "Twitter (X)、LinkedIn、Instagramフィード",
        "reels": "リール、ストーリー、YouTubeショート、TikTok",
        "episode_title": "エピソードタイトル",
        "podcast_title": "ポッドキャストタイトル",
        "titles_font": "タイトルのフォント",
        "title_colors": "ポッドキャスト/エピソードタイトルの色",
        "video_fit": "動画のフィット",
        "adjust_horizontal_position": "水平位置を調整",
        "adjust_vertical_position": "垂直位置を調整",
        "adjust_video_zoom": "動画のズームを調整",
        "adjust_video_width": "動画の幅を調整",
        "adjust_video_height": "動画の高さを調整",
        "background_color": "背景色",
        "edit_clip": "クリップを編集",
        "edit_layout": "レイアウトを編集",
        "choose_short": "ショートを選択",
        "edit_audio": "音声を編集",
        "framing": "フレーミング",
        "background": "背景",
        "text_style": "テキストスタイル",
        "music": "音楽",
        "choose_chapter": "章を選択",
        "clips_left": "残りのクリップ数",
        "apply_layout": "レイアウトを適用",
        "clips_left_number": "クリップが残っています",
        "need_more_clips": "もっとクリップが必要ですか？ここでプランをアップグレード",
        "download_srt_file": "SRTファイルをダウンロード",
        "track_selected": "トラック: ",
        "no_background_music": "バックグラウンド音楽が選択されていません",
        "volume": "音量:",
        "remove": "削除",
        "track_ambient_piano": "アンビエントピアノと弦楽器",
        "track_deep_meditation": "深い瞑想",
        "track_chill_upbeat": "彼女のチルアップビート",
        "track_inspiring_ambient": "インスパイアリングシネマティックアンビエント",
        "track_just_relax": "ただリラックス",
        "track_movement": "ムーブメント",
        "track_once_in_paris": "パリの一度",
        "track_perfect_beauty": "完璧な美",
        "track_summer_adventures": "夏の冒険",
        "track_sunset_groove": "サンセットグルーヴ",
        "track_tvari_cafe": "トヴァリ東京カフェ",
        "track_short_piano_intermezzo": "短いピアノ間奏曲",
        "track_dramatic_background": "ドラマチックな背景音楽",
        "track_dramatic_hiphop": "ドラマチックなヒップホップジャズ",
        "track_emotional_orchestra": "感情的なオーケストラ",
        "track_halloween_short": "ハロウィン音楽",
        "track_improvisation_037": "ジャズ即興演奏",
        "track_inspiration_piano": "インスピレーションピアノ",
        "track_medieval_extract": "中世音楽",
        "track_short_8": "短いアンビエントトラック",
        "track_flute": "平和なフルート",
        "track_piano_guitar_duet": "ピアノ・ギターデュエット",
        "track_intro_jazz": "イントロジャズ",
        "track_romantic_jazz": "ロマンチックジャズ",
        "recommended_for_youtube": "YouTubeにおすすめ",
        "turn_into_short_clip": "このクリップをショートクリップに変換（<60秒）",
        "browser_not_support_audio": "お使いのブラウザはaudio要素をサポートしていません。",
        "watch_tutorial": "このチュートリアルを見てください",
        "audiogram_maker": "オーディオグラムメーカーを最大限に活用する方法",
        "store_audio_notice": "お知らせ: 音声は30日間保存されます。",
        "clip_maker": "クリップメーカーを最大限に活用する方法",
        "split_screen_mode": "分割画面モード",
        "none": "なし",
        "vertical_split": "垂直分割",
        "horizontal_split": "水平分割",
        "layers": "下のレイヤーを使用して、前後に移動します。",
        "screen_1_horizontal_position": "画面1の水平位置",
        "screen_2_horizontal_position": "画面2の水平位置",
        "track_mysterious_dark_background": "神秘的なダークバックグラウンド",
        "track_acoustic_ambient_inspiration": "アコースティック・アンビエント・インスピレーション",
        "track_aristocracy_classical": "アリストクラシー・クラシカル",
        "track_folk_music_river_knows_my_name": "フォークミュージック - リバー・ノウズ・マイ・ネーム",
        "track_funy_adventure": "楽しい冒険",
        "track_energetic_sports_rock_trailer": "エネルギッシュなスポーツロックトレーラー",
        "track_fun_upbeat_energetic_pop_rock": "楽しいアップビートなエネルギッシュポップロック",
        "track_epic_emotional_inspirational": "壮大で感情的なインスピレーション",
        "track_inspirational_epic": "インスピレーショナルエピック",
        "all_music": "すべての音楽",
        "energetic_music": "エネルギッシュ",
        "inspirational_music": "インスピレーショナル",
        "ambient_music": "アンビエント",
        "chill_music": "チル",
        "hiphop_music": "ヒップホップ",
        "quirky_music": "クイーク",
        "dramatic_music": "ドラマティック",
        "acoustic_music": "アコースティック",
        "classical_music": "クラシック",
        "categories": "カテゴリー",
        "select_track": "トラックを選択",
        "upload_music": "音楽をアップロード",
        "my_music": "マイミュージック",
        "downloading": "ダウンロード中...",
        "download_again": "再ダウンロード",
        "download": "ダウンロード",
        "download_failed_alert": "動画のダウンロードに失敗しました。もう一度お試しください。",
        "translate_subtitles": "字幕を翻訳",
        "translate_to": "翻訳先",
        "select_language": "言語を選択",
        "select_new_language": "新しい言語を選択",
        "translating": "翻訳中...",
        "translation_complete": "翻訳完了",
        "error_translation": "翻訳中にエラーが発生しました。もう一度お試しください。",
        "original_language": "オリジナル"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "エピソードタイトル"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "まだコンテンツがありません。",
        "userPodcastsInfo.generateContent": "最初のコンテンツを生成する",
        "placeholder.search_folders": "フォルダを検索...",
        "search.no_results": "検索に一致するフォルダがありません。"
      },
      "landingPageModal": {
        "upload.error": "画像のアップロードに失敗しました: ",
        "upload.image.file": "画像ファイルをアップロードしてください。",
        "upgrade.pro.message": "ページのカスタマイズはProおよびAgencyアカウントのみ利用可能です。",
        "upgrade.now": "今すぐアップグレード",
        "upgrade.unique.landing.page": "そしてユニークなエピソードのランディングページを作成します。",
        "logo.recommendation": "推奨ロゴの高さ 200px",
        "social.links.top.menu": "トップメニューのソーシャルリンク",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "LinkedInのリンクを入力してください",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Facebookのリンクを入力してください",
        "saving...": "保存中...",
        "save": "保存",
        "saved.successfully": "保存に成功しました！",
        "uploading.image": "画像をアップロード中...",
        "upload.episode.cover": "エピソードカバーをアップロード",
        "upload.logo": "ロゴをアップロード",
        "where.listen.episode": "このエピソードを他にどこで聞けますか？",
        "youtube.label": "YouTube",
        "youtube.placeholder": "YouTubeのリンクを入力してください",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Apple Podcastsのリンクを入力してください",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Spotifyのリンクを入力してください",
        "image.size.recommendation": "推奨サイズ 1000x1000px",
        "primary.color.label": "プライマリカラー",
        "header.background.color": "ヘッダーの背景色とリンク。",
        "landing.page.customization": "ランディングページのカスタマイズ",
        "create.branded.landing.page": "リスナーと共有するための美しいブランドのランディングページを作成します",
        "episode.image": "エピソード画像",
        "episode.links": "エピソードリンク",
        "page.header": "ページヘッダー",
        "page.color": "ページカラー",
        "visit.landing.page": "ランディングページを訪問"
      },
      "page": {
        "loading.dashboard": "ダッシュボードを読み込んでいます",
        "convert.new.episode": "新しいエピソードを変換",
        "convert.audio.or.video": "音声またはビデオを変換",
        "minutes.left": "残り時間は",
        "need.more.minutes": "もっと時間が必要ですか？",
        "upgrade.plan": "ここでプランをアップグレードしてください。",
        "your.podcasts": "あなたのポッドキャスト",
        "podsqueeze.results.page": "Podsqueeze 結果ページ",
        "access.podsqueeze.results": "このエピソードの podsqueeze 結果にアクセスします。生成されたすべてのコンテンツを見ることができます"
      },
      "podcast": {
        "confirm.delete_episode": "このエピソードを削除してもよろしいですか？",
        "alert.something_wrong": "何かがうまくいきませんでした。もう一度お試しください。",
        "confirm.delete_folder": "このフォルダーを削除してもよろしいですか？",
        "loading.episodes": "エピソードを読み込んでいます...",
        "folder.empty": "このフォルダーは空です。",
        "content.no_content": "利用可能なコンテンツはありません。",
        "content.generate_first": "最初のポッドキャストを生成してください。",
        "button.personalize_ai": "AIでパーソナライズ",
        "button.edit_website": "ウェブサイトを編集",
        "button.visit_website": "ウェブサイトを訪問",
        "button.generate_website": "ウェブサイトを生成",
        "placeholder.search": "検索...",
        "label.sort_by": "並べ替え",
        "label.last_episodes_loaded": "最後に読み込まれたエピソード",
        "button.load_all_episodes": "すべてのエピソードを読み込む",
        "loading": "読み込み中...",
        "add.new.episode": "新しいエピソードを追加",
        "order.newest": "最新順",
        "order.oldest": "古い順",
        "order.a_to_z": "A から Z",
        "order.z_to_a": "Z から A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "新しいポッドキャストフォルダーを作成:",
        "folder.name.placeholder": "フォルダー名",
        "create.button": "作成"
      },
      "podcastLandingModal": {
        "upload.image.error": "画像ファイルをアップロードしてください",
        "podcast.cover.title": "ポッドキャストカバー画像",
        "podcast.cover.upload": "ここにポッドキャストのカバー画像をアップロードしてください。これはランディングページに目立つように表示されます。",
        "upload.image.uploading": "画像をアップロード中...",
        "podcast.cover.upload.button": "カバー画像をアップロード",
        "podcast.cover.recommended.size": "推奨サイズ: 1400x1400 ピクセル",
        "profile.info.title": "プロフィール情報",
        "profile.info.upload": "プロフィール写真と名前を追加して、ランディングページをパーソナライズしましょう。",
        "profile.upload.button": "プロフィール写真をアップロード",
        "profile.name.label": "プロフィール名",
        "profile.name.placeholder": "名前を入力してください",
        "platform.links.title": "プラットフォームリンク",
        "platform.links.upload": "さまざまなプラットフォームでのポッドキャストへのリンクを追加します。",
        "platform.links.youtube_link": "YouTubeリンク",
        "platform.links.youtube_link.placeholder": "YouTubeリンクを入力してください",
        "platform.links.spotify_link": "Spotifyリンク",
        "platform.links.spotify_link.placeholder": "Spotifyリンクを入力してください",
        "platform.links.apple_podcast_link": "Apple Podcastリンク",
        "platform.links.apple_podcast_link.placeholder": "Apple Podcastリンクを入力してください",
        "platform.links.linkedin_link": "LinkedInリンク",
        "platform.links.linkedin_link.placeholder": "LinkedInリンクを入力してください",
        "platform.links.facebook_link": "Facebookリンク",
        "platform.links.facebook_link.placeholder": "Facebookリンクを入力してください",
        "platform.links.twitter_link": "Twitterリンク",
        "platform.links.twitter_link.placeholder": "Twitterリンクを入力してください",
        "call.to.action.title": "行動を促す呼びかけ",
        "call.to.action.upload": "ランディングページの行動を促すボタンを設定します。",
        "call.to.action.button.text.label": "ボタンテキスト",
        "call.to.action.button.text.placeholder": "ボタンテキストを入力してください",
        "call.to.action.button.link.label": "ボタンリンク",
        "call.to.action.button.link.placeholder": "ボタンリンクを入力してください",
        "color.styles.title": "カラースタイル",
        "color.styles.upload": "ランディングページの色をカスタマイズします。",
        "color.styles.primary.label": "プライマリーカラー",
        "color.styles.primary.description": "ランディングページのプライマリーカラーを選択してください",
        "color.styles.secondary.label": "セカンダリーカラー",
        "color.styles.secondary.description": "ランディングページのセカンダリーカラーを選択してください",
        "podcast.info.title": "ポッドキャスト情報",
        "podcast.info.upload": "ポッドキャストの詳細を編集します。",
        "podcast.info.name.label": "ポッドキャスト名",
        "podcast.info.name.placeholder": "ポッドキャスト名を入力してください",
        "podcast.info.description.label": "ポッドキャストの説明",
        "podcast.info.description.placeholder": "ポッドキャストの説明を入力してください",
        "edit.website.title": "ウェブサイトを編集",
        "generate.website.title": "ウェブサイトを生成",
        "for": "のために",
        "saving": "保存中...",
        "save.changes": "変更を保存",
        "generate.website": "ウェブサイトを生成",
        "changes.saved.success": "変更が正常に保存されました！",
        "podcast.cover.menu": "ポッドキャストカバー",
        "podcast.info.menu": "ポッドキャスト情報",
        "profile.menu": "プロフィール",
        "platform.links.menu": "プラットフォームリンク",
        "call.to.action.menu": "行動を促す呼びかけ",
        "color.styles.menu": "カラースタイル",
        "logo.menu": "ロゴ",
        "logo.title": "ロゴをアップロード",
        "logo.upload": "ポッドキャストのロゴをアップロードしてください。これはランディングページに表示されます。",
        "logo.upload.button": "ロゴをアップロード",
        "platform.links.description": "ポッドキャストのリンクをさまざまなプラットフォームに追加します。",
        "social.links.menu": "ソーシャルリンク",
        "social.links.title": "ソーシャルメディアリンク",
        "social.links.description": "ソーシャルメディアのプロフィールリンクを追加します。",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "LinkedInのプロフィールリンクを入力してください",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Facebookのページリンクを入力してください",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Twitterのプロフィールリンクを入力してください",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Instagramのプロフィールリンクを入力してください",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "YouTubeのプロフィールリンクを入力してください",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Spotifyのプロフィールリンクを入力してください",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Apple Podcastのプロフィールリンクを入力してください"
      },
      "podcastMoveModal": {
        "move.episode.label": "このエピソードを移動先:",
        "move.episode.instruction": "新しい名前を入力するとフォルダーを作成できます。",
        "move.episode.button": "移動",
        "move.episode.error.selectFolder": "エピソードを移動するフォルダーを選択してください。"
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "{{podcastTitle}} ポッドキャストのAI設定",
        "ai.customize.writing.style": "AIのライティングスタイルをカスタマイズ",
        "ai.content.writing.preference": "Podsqueezeにどのようにコンテンツを書いてほしいですか？",
        "ai.voice.placeholder": "例：プロフェッショナルでありながら親しみやすいトーン。リスナーはポッドキャスターです。第一人称で書いてください。",
        "ai.character.limit.reached": "文字数制限の50に達しました。",
        "ai.upgrade.now": "今すぐアップグレード",
        "ai.fix.transcript.misspells": "トランスクリプトの誤字を修正",
        "ai.enter.misspelled.words": "このポッドキャストのエピソードでAIがよく誤って綴る単語を書いてください。例：名前",
        "ai.enter.word.press.enter": "単語を入力してEnterを押してください",
        "ai.add.word": "単語を追加",
        "ai.tag.limit.reached": "タグの制限1に達しました。",
        "ai.save": "保存",
        "ai.save.close": "保存して閉じる"
      },
      "selectedepisode": {
        "selectedEpisode.title": "エピソードタイトル",
        "selectedEpisode.podcastName": "ポッドキャスト名",
        "selectedEpisode.showNotes": "ショーノート",
        "selectedEpisode.timestamp": "タイムスタンプ",
        "selectedEpisode.staticTimestamp": "静的タイムスタンプ",
        "selectedEpisode.mentions": "言及",
        "selectedEpisode.newsletter": "ニュースレター",
        "selectedEpisode.titles": "タイトル",
        "selectedEpisode.tweeter": "ツイッター",
        "selectedEpisode.shortPost": "ショートポスト",
        "selectedEpisode.transcription": "トランスクリプト",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "キーワード",
        "selectedEpisode.quotes": "引用",
        "selectedEpisode.longPost": "ロングポスト",
        "selectedEpisode.bulletPoints": "箇条書き",
        "selectedEpisode.publicLink": "公開リンク",
        "selectedEpisode.embeddedId": "埋め込みID",
        "selectedEpisode.episodeUrl": "エピソードURL"
      },
      "sidebar": {
        "tools": "ツール",
        "find.podcast.topic.ideas": "ポッドキャストのトピックアイデアを見つける",
        "podcast.thumbnail.maker": "ポッドキャストサムネイルメーカー",
        "podcast.seo.optimizer": "ポッドキャストSEO最適化ツール",
        "account": "アカウント",
        "payment.settings": "支払い設定",
        "support": "サポート",
        "logout": "ログアウト",
        "plan": "プラン",
        "resets.in": "リセットまで",
        "api.access": "APIアクセス",
        "days": "日と",
        "hours": "時間",
        "upgrade.plan": "プランをアップグレード"
      },
      "updateEmailModal": {
        "email.validation.error": "有効なメールアドレスを入力してください。",
        "email.change.confirm": "メールアドレスを変更してもよろしいですか？",
        "email.change.success": "メールアドレスが正常に変更されました！",
        "email.in.use.error": "このメールアドレスはすでに使用されています。別のものをお試しください。",
        "email.recent.login.error": "この操作を続行する前に、現在のメールアドレスで再度ログインしてください。",
        "email.invalid.error": "無効なメールアドレスです。別のものをお試しください。",
        "subscription.cancel.error": "まず、アクティブな有料サブスクリプションをキャンセルしてください。",
        "account.delete.confirm": "本当にアカウントを削除してもよろしいですか？\n\nこの操作は元に戻せません。",
        "account.delete.success": "アカウントが正常に削除されました。",
        "account.delete.error": "何かがうまくいかず、アカウントを削除できませんでした。\n\nユーザーサポートにお問い合わせください。",
        "subscription.cancel": "サブスクリプションをキャンセル",
        "account.delete": "アカウントを削除",
        "account.delete.warning": "アカウントを削除すると元に戻せず、すべてのコンテンツとログイン情報が永久に消去されます。この操作は元に戻せないため、注意して進めてください。",
        "current.account.email": "現在のアカウントメール",
        "enter.new.email": "新しいアカウントメールを入力してください",
        "update": "更新",
        "change.password": "パスワードを変更",
        "payment.settings": "支払い設定"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "エピソードタイトル"
      },
      "episodelist": {
        "loading.episodes": "エピソードを読み込んでいます",
        "no.episodes.found": "エピソードが見つかりませんでした。正しいRSS IDで再試行してください",
        "select.episode": "コンテンツを作成するエピソードを選択してください"
      },
      "interfaces": {
        "user.activePlan.tier": "ティア",
        "user.activePlan.creationDate": "作成日",
        "user.activePlan.minutesAvailable": "利用可能な分数"
      },
      "loadingbar": {
        "loadingbar.magic": "まだ魔法をかけています ✨",
        "loadingbar.longer": "いくつかのエピソードは少し時間がかかります... 🐌",
        "loadingbar.hardwork": "私たちのサーバーは一生懸命働いています 🦾"
      },
      "page": {
        "main.background": "メインコンポーネントの背景"
      },
      "recordfile": {
        "microphone.camera.access.denied": "エラー: マイクまたはカメラへのアクセスが拒否されました。",
        "microphone.camera.not.found": "エラー: マイクまたはカメラが見つかりません。",
        "microphone.camera.not.readable": "エラー: マイクまたはカメラが読み取れません。",
        "microphone.camera.access.error": "エラー: マイクまたはカメラへのアクセス中に不明なエラーが発生しました。",
        "media.not.recorded": "エラー: メディアが記録されていません。",
        "upload.failed": "エラー: アップロードに失敗しました。",
        "upload.success": "成功: アップロードが正常に完了しました。",
        "upload.in.progress": "アップロード中...",
        "upload.button": "録音をアップロード",
        "stop.recording": "録音を停止",
        "record.audio": "音声を録音",
        "record.audio.video": "音声とビデオを録音",
        "record.again": "録音を再開",
        "episode.language": "エピソードの言語を選択"
      },
      "selectBox": {
        "language.english": "英語",
        "language.arabic": "アラビア語",
        "language.bulgarian": "ブルガリア語",
        "language.catalan": "カタルーニャ語",
        "language.croatian": "クロアチア語",
        "language.czech": "チェコ語",
        "language.danish": "デンマーク語",
        "language.dutch": "オランダ語",
        "language.finnish": "フィンランド語",
        "language.french": "フランス語",
        "language.german": "ドイツ語",
        "language.greek": "ギリシャ語",
        "language.hindi": "ヒンディー語",
        "language.hungarian": "ハンガリー語",
        "language.indonesian": "インドネシア語",
        "language.italian": "イタリア語",
        "language.japanese": "日本語",
        "language.korean": "韓国語",
        "language.lithuanian": "リトアニア語",
        "language.latvian": "ラトビア語",
        "language.malay": "マレー語",
        "language.mandarin": "普通話",
        "language.norwegian": "ノルウェー語",
        "language.polish": "ポーランド語",
        "language.portuguese": "ポルトガル語",
        "language.romanian": "ルーマニア語",
        "language.russian": "ロシア語",
        "language.slovak": "スロバキア語",
        "language.slovenian": "スロベニア語",
        "language.spanish": "スペイン語",
        "language.swedish": "スウェーデン語",
        "language.tamil": "タミル語",
        "language.turkish": "トルコ語",
        "language.ukrainian": "ウクライナ語",
        "language.bashkir": "バシキール語",
        "language.basque": "バスク語",
        "language.belarusian": "ベラルーシ語",
        "language.cantonese": "広東語",
        "language.esperanto": "エスペラント",
        "language.estonian": "エストニア語",
        "language.galician": "ガリシア語",
        "language.interlingua": "インターリグア",
        "language.marathi": "マラーティー語",
        "language.mongolian": "モンゴル語",
        "language.persian": "ペルシャ語",
        "language.thai": "タイ語",
        "language.uyghur": "ウイグル語",
        "language.vietnamese": "ベトナム語",
        "language.welsh": "ウェールズ語"
      },
      "selectedepisode": {
        "processing.episode": "エピソードを処理中",
        "processing.time": "通常、5〜10分かかります",
        "email.notification": "このウィンドウを閉じても大丈夫です。準備ができ次第、メールをお送りします。あなたのコンテンツはダッシュボードでも利用可能です。",
        "convert.another.episode": "別のエピソードを変換",
        "technical.difficulties": "おっと！技術的な問題が発生しています。ご安心ください、私たちのチームが対応しています！後でもう一度お試しください。",
        "no.discount": "心配しないでください、時間を割引することはありません！",
        "high.demand": "通常よりも高い需要があるため、リクエストの処理に通常より時間がかかる場合があります。ご不便をおかけして申し訳ありません！",
        "email.ready": "準備ができ次第、メールをお送りします。結果はダッシュボードでもアクセスできます。",
        "select.podcast.folder": "このエピソードが属するポッドキャストフォルダーを選択するか、名前を入力して新しいフォルダーを作成してください。",
        "give.voice": "フォルダーの声をカスタマイズする",
        "not.enough.minutes.title": "十分な時間がありません",
        "not.enough.minutes.message": "このエピソードを変換するには十分な時間がありません。計画を更新してください。",
        "upgrade.plan": "計画を更新する",
        "convert.shorter.episode": "短いエピソードを変換する",
        "generate.content": "コンテンツを生成する",
        "content.ready": "あなたのコンテンツは準備ができました！",
        "ask.ai.tune": "AIに各コンテンツをあなたのニーズにより適したものに調整するように依頼することもできます。",
        "error.title": "エラー",
        "convert.another.file": "別のファイルを変換する"
      },
      "submitfile": {
        "file.size.exceeded.free": "ファイルサイズが最大制限の4GBを超えています。<p>より大きなファイルをアップロードするには、<a href='/pricing'><b><u>アップグレードしてください</u></b></a></p>",
        "file.size.exceeded.paid": "ファイルサイズが最大制限の10GBを超えています。<p>より小さいファイルを選択してください。</p>",
        "file.upload.invalid": "音声または動画ファイルをアップロードしてください",
        "upload.in.progress": "ファイルをアップロード中です。このウィンドウを閉じないでください。",
        "upload.button": "アップロード & 生成",
        "close.button": "閉じる",
        "upgrade.message.free": "追加のアップロードは有料プランのみで利用可能です。",
        "upgrade.now.button": "今すぐアップグレード",
        "pricing.info": "月額$12から",
        "upload.file.label": "音声または動画ファイルをアップロード",
        "max.file.size.free": "(最大4GB)",
        "max.file.size.paid": "(最大10GB)",
        "podsqueeze.audiograms.info": "Podsqueezeは音声ファイルのオーディオグラムと動画ファイルの短いクリップを生成します",
        "file.placeholder": "あなたのMP3/WAVファイル",
        "episode.language.label": "エピソードの言語",
        "select.folder.label": "選択または作成",
        "multiple.files.selected": "{{count}}ファイルが選択されました",
        "clear.all": "すべてクリア",
        "file.name": "{{name}}",
        "multiple.files.toggle": "複数ファイルを選択",
        "file.upload.error": "ファイルのアップロードエラー",
        "file.upload.success": "ファイルのアップロード成功",
        "file.upload.processing": "ファイル処理中",
        "click.to.upload": "クリックしてアップロード",
        "click.to.upload.multiple": "クリックして複数ファイルをアップロード",
        "enter.url": "URLを入力",
        "upload.file": "ファイルをアップロード",
        "media.url.label": "メディアURL",
        "media.url.help": "音声または動画ファイルのURLを入力してください。ダウンロードして処理します。",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "エピソード名",
        "url.input.required": "メディアURLを入力してください",
        "url.upload.error": "URLからのメディアのアップロードに失敗しました。URLを確認して再試行してください。",
        "supported.formats": "サポートされている形式",
        "uploading": "アップロード中...",
        "media.url.requirements": "URLは公開メディアファイルへの直接リンクである必要があります（ウェブページではありません）"
      },
      "submitrssid": {
        "error.selectRss": "ドロップダウンから有効なRSSを選択してください",
        "label.insertRssFeed": "RSSフィードを挿入してください",
        "placeholder.insertRssFeed": "RSSフィードを挿入してください",
        "label.searchByPodcast": "ポッドキャスト名で検索する",
        "label.searchForPodcast": "ポッドキャスト名を検索してください",
        "placeholder.searchForPodcast": "ポッドキャストを検索",
        "label.cantFindPodcast": "ポッドキャストが見つかりませんか？",
        "label.clickHereUseRss": "ここをクリックしてRSSフィードを使用してください",
        "label.selectedPodcast": "選択されたポッドキャスト",
        "label.episodeLanguage": "エピソードの言語",
        "button.seeAllEpisodes": "すべてのエピソードを見る",
        "select.folder.label": "選択または作成"
      },
      "submitsection": {
        "search.podcast": "ポッドキャストを検索",
        "upload.audio.video": "音声または動画をアップロード",
        "record.audio": "音声を録音",
        "youtube.video": "YouTubeビデオ",
        "create.content": "ポッドキャストのコンテンツを作成しましょう！"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "YouTube動画のURLを入力してください",
        "error.insertYouTubeUrl": "YouTubeのURLを挿入してください。",
        "label.insertYouTubeUrl": "YouTubeのURLを挿入",
        "button.loading": "読み込み中...",
        "message.downloadingFile": "ファイルをダウンロード中...",
        "error.processingFailed": "エラー：動画の処理に失敗しました。",
        "button.submitYouTubeVideo": "YouTube動画を送信",
        "error.youtubeVideoNotAvailable": "このYouTube動画はダウンロードできません。Podsqueezeに直接音声または動画をアップロードするか、YouTubeダウンローダーを使用してください。ご不便、お待ちいたします。",
        "episode.language.label": "使用言語",
        "select.folder.label": "選択または作成"
      },
      "tabs": {
        "tab.label.tab1": "タブ 1",
        "tab.label.tab2": "タブ 2",
        "tab.label.tab3": "タブ 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Podsqueezeを最大限に活用する",
        "tutorial.chapter.introduction": "はじめに",
        "tutorial.chapter.bestShowNotes": "最高のショーノートとタイムスタンプを取得する",
        "tutorial.chapter.blogPosts": "ブログ投稿とニュースレターの活用",
        "tutorial.chapter.editingTranscripts": "トランスクリプトの埋め込みと編集",
        "tutorial.chapter.personalizingAI": "AIのパーソナライズと自分の声を与える",
        "tutorial.chapter.speedingUpNotes": "ショーノートのスピードアップ",
        "tutorial.chapter.creatingClips": "ビデオクリップと画像の作成",
        "tutorial.chapter.generatingLandingPage": "ランディングページの生成",
        "tutorial.chapter.shareResults": "チームと結果を共有する",
        "tutorial.closeVideoCheckbox": "最初の結果が準備できたらビデオを閉じる"
      },
      "uploadloadingbar": {
        "upload.loading": "読み込み中..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "お問い合わせ",
        "contact.section.email": "support@podsqueeze.com までメールしてください",
        "contact.section.tiago.role": "共同創設者",
        "contact.section.joao.role": "共同創設者",
        "contact.section.image.alt.sendMessage": "メッセージを送信",
        "contact.section.image.alt.tiago": "Podsqueeze 共同創設者ティアゴ",
        "contact.section.image.alt.joao": "Podsqueeze 共同創設者ジョアン"
      },
      "contactsection": {
        "contact.section.title": "お問い合わせ",
        "contact.section.email": "support@podsqueeze.com までメールしてください",
        "contact.section.tiago.role": "共同創設者",
        "contact.section.joao.role": "共同創設者",
        "contact.section.image.alt.sendMessage": "メッセージを送信",
        "contact.section.image.alt.tiago": "Podsqueeze 共同創設者ティアゴ",
        "contact.section.image.alt.joao": "Podsqueeze 共同創設者ジョアン"
      },
      "home-agenciessection": {
        "join.content.creators": "Podsqueezeを使用している20,000人のコンテンツクリエイターとポッドキャスト専門家に参加しましょう",
        "content.creators": "コンテンツクリエイター",
        "podcast.managers": "ポッドキャストマネージャー",
        "producers.studios": "プロデューサーとスタジオ",
        "for.podcasters": "ポッドキャスター、ポッドキャストマネージャー、エージェンシーのために",
        "manage.content.creation": "コンテンツ制作を簡単に管理する",
        "multiple.podcasts": "複数のポッドキャストのために",
        "podsqueeze.description": "Podsqueezeは、すべてのポッドキャスト専門家のための強力なツールです。ソロポッドキャスター、ポッドキャストマネージャー、またはエージェンシーであっても、Podsqueezeはポッドキャストのコンテンツ制作ワークフローを効率化するために必要なすべての機能を提供します。",
        "create.podcast.folders": "エピソードを整理するためのポッドキャストフォルダーを作成します。",
        "share.content.page": "クライアントやチームとコンテンツページを簡単に共有します",
        "tune.ai.voice": "管理する各ショーのAI音声を調整します",
        "plan.content.episodes": "次のエピソードのコンテンツを当社の高度な",
        "podcast.topics.finder": "ポッドキャストトピックファインダーで計画します",
        "podsqueeze.testimonial": "Podsqueezeのプロンプトを使用して、管理する各ポッドキャストのコンテンツを調整し、将来のエピソードのために保存する能力により、各ショーの声を一貫して保つことができます。これは、他のツールでは見つけられなかったエリート機能です",
        "coo.podigy": "Podigy PodcastsのCOO",
        "agenciessection.joinCreators": "Podsqueezeを使用している20,000人のコンテンツクリエイターとポッドキャスト専門家に参加しましょう",
        "agenciessection.contentCreators": "コンテンツクリエイター",
        "agenciessection.podcastManagers": "ポッドキャストマネージャー",
        "agenciessection.producersStudios": "プロデューサーとスタジオ",
        "agenciessection.forPodcasters": "ポッドキャスター、ポッドキャストマネージャー、エージェンシーのために",
        "agenciessection.manageContent": "コンテンツ制作を簡単に管理する",
        "agenciessection.multiplePodcasts": "複数のポッドキャストのために",
        "agenciessection.podsqueezeDescription": "Podsqueezeは、すべてのポッドキャスト専門家のための強力なツールです。ソロポッドキャスター、ポッドキャストマネージャー、またはエージェンシーであっても、Podsqueezeはポッドキャストのコンテンツ制作ワークフローを効率化するために必要なすべての機能を提供します。",
        "agenciessection.createPodcastFolders": "エピソードを整理するためのポッドキャストフォルダーを作成します。",
        "agenciessection.shareContent": "クライアントやチームとコンテンツページを簡単に共有します",
        "agenciessection.tuneAI": "管理する各ショーのAI音声を調整します",
        "agenciessection.planContent": "次のエピソードのコンテンツを当社の高度な",
        "agenciessection.podcastTopicsFinder": "ポッドキャストトピックファインダーで計画します",
        "agenciessection.podsqueezeQuote": "Podsqueezeのプロンプトを使用して、管理する各ポッドキャストのコンテンツを調整し、将来のエピソードのために保存する能力により、各ショーの声を一貫して保つことができます。これは、他のツールでは見つけられなかったエリート機能です",
        "agenciessection.coO": "Podigy PodcastsのCOO"
      },
      "home-audioeditsection": {
        "new.feature": "新機能",
        "seamless.editing": "自然なシームレスな編集と音声の向上、",
        "high.quality.results": "高品質な結果",
        "experience.seamless.audio.editing": "最高の録音のための高度なAIアルゴリズムを使用したシームレスな音声編集を体験してください。",
        "remove.ums": "あいまいな言葉を削除",
        "enhance.sound.quality": "、沈黙を削除し、ワンクリックで音質を向上させます。",
        "enhance.audio.now": "今すぐ音声を向上させる",
        "sample.audio.recorded": "電話から直接録音されたサンプル音声。",
        "original.recording": "オリジナル録音",
        "audio.after.ai.edit": "AI編集と向上後の音声",
        "experience.audio.editing": "最高の録音のための高度なAIアルゴリズムを使用したシームレスな音声編集を体験してください。"
      },
      "home-blogsection": {
        "more.resources.label": "ポッドキャストのためのさらなるリソース",
        "learn.how.to.get.most": "最大限に活用する方法を学ぶ",
        "your.content": "あなたのコンテンツ",
        "get.most.out.of.ai.content": "ポッドキャストのためのAI生成コンテンツを最大限に活用する",
        "welcome.to.podsqueeze": "Podsqueezeへようこそ – ポッドキャストを文字起こしし、魅力的なコンテンツを作成する最も簡単な方法...",
        "will.google.penalize.ai.content": "GoogleはあなたのAI生成コンテンツをペナルティを与えるのか？",
        "ai.content.discussion": "AI生成コンテンツの出現は、コンテンツクリエイター、マーケター、SEOの間で議論を呼び起こし、懸念を引き起こしています...",
        "what.is.rss.feed": "ポッドキャストのRSSフィードとは何か、そしてそれをどのように使用するか",
        "rss.feed.benefits": "ポッドキャスターとして、'RSSフィード'という用語を聞いたことがあるかもしれませんが、それが何であるか、またどのように役立つかを正確に知らないかもしれません...",
        "visit.blog": "ブログを訪れる"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "クリップ & オーディオグラム",
        "clipsAndAudiograms.subtitle": "ポッドキャストを簡単にクリップに再利用",
        "clipsAndAudiograms.description": "エピソードから章を選択し、TikTok、Instagram、YouTube Shorts用のクリップまたはオーディオグラムとしてエクスポートします。テンプレートを選び、自分のスタイルに合わせて調整してください。",
        "clipsAndAudiograms.createClips": "今すぐクリップを作成",
        "textEditor.title": "テキストベースのエディタ",
        "textEditor.description": "字幕から直接クリップとオーディオグラムを微調整します。字幕を編集し、特定の単語を削除して動画をトリミングします。",
        "oneClickShorts.title": "ワンクリックショーツ（<60秒）",
        "oneClickShorts.description": "AIに編集を任せましょう。ボタンを押すだけで、AIがエピソードの各章を60秒未満に短縮し、YouTubeショートやTikTokクリップとして投稿できる準備をします。"
      },
      "home-conatctsection": {
        "contact.section.title": "創業者に連絡する",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- 開発者 & ポッドキャスター",
        "contact.section.joao.role": "- UX/UI デザイナー"
      },
      "home-contentexplanation": {
        "wide.variety.content": "幅広いコンテンツの種類",
        "generate.content": "コンテンツを生成する",
        "one.click": " ワンクリックで！",
        "transcript.srt": "トランスクリプト & SRT",
        "transcript.description": "ポッドキャストエピソードの完全なトランスクリプトと、キャプションや字幕生成のためのSRTファイルを取得します。",
        "show.notes": "ショーノート",
        "show.notes.description": "エピソードで扱った主要なトピックを要約し、検索しやすくします。",
        "timestamps": "タイムスタンプ",
        "timestamps.description": "タイムスタンプを使ってチャプターを作成し、リスナーをポッドキャストエピソードの特定のセグメントに導きます。",
        "blog.social.posts": "ブログ & ソーシャル投稿",
        "blog.social.posts.description": "ポッドキャストエピソードについてあらゆる場所に投稿し、新しいリスナーを獲得します。",
        "newsletter": "ニュースレター",
        "newsletter.description": "新しいエピソードでリスナーを最新の情報に保ちます。",
        "titles.more": "タイトル & もっと！",
        "titles.more.description": "キャッチーなタイトル、引用、箇条書き、キーワードなどを生成します！",
        "see.sample.content": "サンプルコンテンツを見る",
        "wannabe.entrepreneur": "起業家志望 - #299 Podsqueezeが年間収益10万ドルを達成！",
        "making.space": "メイキングスペース - スティーブ・ハーヴィー: “そのまま続けるべきだ”",
        "modern.wisdom": "モダンウィズダム - エリック・ホエル - 心の根本的な謎へのガイド"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "区切り線"
      },
      "home-explanationsection": {
        "fast.accurate": "迅速かつ正確",
        "generate.content": "ポッドキャストのコンテンツを生成する",
        "power.of.ai": "AIの力で",
        "upload.image.alt": "画像をアップロード",
        "select.episode": "RSSフィードからエピソードを選択するか、音声/動画ファイルをアップロードしてください",
        "paste.rss.feed": "RSSフィードのURLを貼り付けるだけで、リストからエピソードを選択するか、音声または動画ファイルをアップロードできます。",
        "content.image.alt": "コンテンツ画像",
        "one.click.content": "ワンクリックで全てのコンテンツを取得！",
        "user.friendly.interface": "直感的で使いやすいインターフェースですぐに使用開始できます。ワンクリックでポッドキャストのコンテンツを生成します。",
        "tune.image.alt": "調整画像",
        "edit.fine.tune": "各コンテンツを編集して微調整",
        "direct.edit.content": "AIを使って、好みに合わせて各コンテンツを直接編集し微調整できます。たとえば、特定のトーンを要求したり、直接的または間接的な表現を指定したり、単に誤字を修正したりできます。",
        "multiple.language.support": "複数言語のサポート",
        "language.flags.alt": "言語フラグ",
        "generate.content.aria": "コンテンツを生成"
      },
      "home-featuressection": {
        "loading": "読み込み中...",
        "transcribe.write.show.notes": "ポッドキャストのトランスクリプトとショーノートを作成する",
        "twenty.times.faster": "20倍速",
        "save.manual.work": "手作業を最大100%削減。最先端の精度と話者ラベリングでポッドキャストを自動的にトランスクリプトし、あなた自身の声で完全なショーノートとソーシャルメディア投稿を生成します。",
        "generate.content": "コンテンツを生成",
        "transcripts": "トランスクリプト",
        "full.transcript": "ポッドキャストエピソードとYouTube動画のトランスクリプトの完全なトランスクリプトを取得し、字幕用のSRTファイルも入手できます。",
        "show.notes": "ショーノート",
        "summarize.generate.show.notes": "タイムスタンプ、箇条書き、言及を含むあなた自身の声でショーノートを要約し生成します。",
        "blog.newsletter": "ブログとニュースレター",
        "actionable.blog.posts": "エピソードに関する実用的なブログ投稿と、主要なポイントを含む送信準備が整ったニュースレターを取得します。",
        "social.media": "ソーシャルメディア",
        "short.posts.insights": "ソーシャルメディアで広めるための短い投稿と一口サイズの洞察を取得します。",
        "quote": "私たちがテストした最高のAIトランスクリプションツールの中で、Podsqueezeはショーノート、タイムスタンプ、タイトル、言及、サンプルブログ投稿、重要な引用に最も役立つ出力を生成しました。",
        "justin.jackson": "ジャスティン・ジャクソン",
        "cofounder.transistor": "Transistor.fmの共同創設者",
        "transcribe_and_write_show_notes": "ポッドキャストトランスクリプト、サマリー、ソーシャルメディア投稿",
        "twenty_times_faster": "20倍速",
        "save_manual_work": "手作業を最大100%削減。最先端の精度と話者ラベリングでポッドキャストを自動的にトランスクリプトし、あなた自身の声で完全なショーノートとソーシャルメディア投稿を生成します。",
        "generate_content": "コンテンツを生成",
        "full_transcript": "ポッドキャストエピソードとYouTube動画のトランスクリプトの完全なトランスクリプトを取得し、字幕用のSRTファイルも入手できます。",
        "show_notes": "ショーノート",
        "summarize_and_generate_show_notes": "タイムスタンプ、箇条書き、言及を含むあなた自身の声でショーノートを要約し生成します。",
        "blog_and_newsletter": "ブログとニュースレター",
        "actionable_blog_posts": "エピソードに関する実用的なブログ投稿と、主要なポイントを含む送信準備が整ったニュースレターを取得します。",
        "social_media": "ソーシャルメディア",
        "short_posts_and_insights": "ソーシャルメディアで広めるための短い投稿と一口サイズの洞察を取得します。",
        "testimonial": "私たちがテストした最高のAIトランスクリプションツールの中で、Podsqueezeはショーノート、タイムスタンプ、タイトル、言及、サンプルブログ投稿、重要な引用に最も役立つ出力を生成しました。",
        "cofounder_transistor": "Transistor.fmの共同創設者"
      },
      "home-page": {
        "main.background": "メインコンポーネントの背景色"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "私たちのポッドキャストを聴く",
        "podcast.section.subtitle": "マスタークラスを提供する",
        "podcast.section.highlight": "経験豊富なポッドキャスターたち",
        "podcast.section.description": "私たちのポッドキャストを聴いて、世界中の経験豊富なポッドキャスターやPodsqueezeのユーザーにインタビューします。彼らに、ポッドキャストを成長させるために必要なヒント、洞察、ストーリーを共有してもらいます。",
        "podcast.link.spotify": "Spotifyで聴く",
        "podcast.link.apple": "Apple Podcastsで聴く",
        "podcast.link.youtube": "YouTubeで聴く"
      },
      "home-spinner": {
        "spinner.loading": "読み込み中..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "ポッドキャストを自動化する",
        "tagline.productionPromotion": "制作とプロモーション",
        "tagline.launchGrow": "AIの助けを借りて、すべてが一つの場所に揃った状態で、音声または動画のポッドキャストを簡単に立ち上げ、成長させましょう。",
        "tagline.uploadGenerate": "ポッドキャストのトランスクリプト、要約、キャプション付きの短いクリップなどを簡単に生成できます！",
        "tagline.singleClick": " すべてワンクリックで。",
        "tagline.transcripts": "ポッドキャストのトランスクリプト",
        "tagline.showNotes": "ショーノート",
        "tagline.newslettersBlogs": "ニュースレターとブログ",
        "tagline.socialPosts": "ソーシャル投稿",
        "tagline.shortClipsAudiograms": "ショートクリップとオーディオグラム",
        "tagline.podcastWebsite": "ポッドキャストウェブサイト",
        "tagline.aiAudioEnhancement": "AIオーディオ強化",
        "tagline.removeSilences": "沈黙や「あー」といった音を取り除く",
        "tagline.generateNow": "今すぐ無料で生成",
        "tagline.noCreditCard": "クレジットカードは不要",
        "testimonial.robWalling.title": "ロブ・ウォーリング、スタートアップパーソナリティ",
        "testimonial.robWalling.subtitle": "スタートアップ・フォー・ザ・レスト・オブ・アス・ポッドキャスト",
        "testimonial.robWalling.quote": "Podsqueezeのショーノートは最高です。要約や他のポッドキャストからの洞察を得るために多く使っています。",
        "testimonial.johnGarmet.title": "ジョン・ガーメット、オペレーションディレクター",
        "testimonial.johnGarmet.subtitle": "ハードメディア",
        "testimonial.johnGarmet.quote": "Podsqueezeは私たちがより効率的になり、クライアントのためにより多くのコンテンツを生成するのに役立っています。非常にお勧めです。",
        "testimonial.davidJackson.title": "デイビッド・ジャクソン、ポッドキャストコーチ",
        "testimonial.davidJackson.subtitle": "ポッドキャスティングスクール",
        "testimonial.davidJackson.quote": "Podsqueezeは私のブレインストーミングパートナーです。ポッドキャストマーケティングを考える最良の方法です。"
      },
      "home-testimonials": {
        "testimonials.title": "Podsqueezeについて人々は何と言っていますか",
        "testimonials.image.alt": "Podsqueeze - AIを使ってポッドキャストコンテンツを再利用 | Product Hunt",
        "testimonials.heading": "Podsqueezeについて人々は何と言っていますか"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "パスワードが間違っています",
        "error.userNotFound": "ユーザーが見つかりません",
        "error.somethingWentWrong": "おっと、何かがうまくいきませんでした",
        "button.sendResetEmail": "リセットメールを送信",
        "button.login": "ログイン",
        "placeholder.email": "Eメールアドレス",
        "placeholder.password": "パスワード",
        "link.forgotPassword": "パスワードをお忘れですか？",
        "link.createAccount": "アカウントを作成",
        "text.or": "または",
        "button.continueWithGoogle": "Googleで続行",
        "text.podcastDescription": "すべてが一つの場所に揃った状態で、オーディオまたはビデオポッドキャストを簡単に立ち上げ、成長させましょう。",
        "feature.transcripts": "トランスクリプト",
        "feature.showNotes": "ショーノート",
        "feature.newslettersAndBlogs": "ニュースレターとブログ",
        "feature.socialPosts": "ソーシャル投稿",
        "feature.shortClipsAndAudiograms": "ショートクリップとオーディオグラム",
        "feature.podcastWebsite": "ポッドキャストウェブサイト",
        "feature.aiAudioEnhancement": "AIオーディオ強化",
        "feature.removeSilences": "沈黙と「あー」と「うー」を削除",
        "button.sendVerificationEmail": "メールの確認を送信",
        "error.emailNotVerified": "メールが確認されていません",
        "error.emailAlreadyVerified": "メールがすでに確認されています",
        "success.emailVerified": "メールが確認されました",
        "text.pleaseVerifyAccount": "アカウントを確認してください",
        "text.checkSpamFolder": "確認メールを送信しました。お手数ですが、受信トレイと迷惑メールフォルダーを確認してください。",
        "button.resendVerificationEmail": "確認メールを再送信",
        "error.verificationEmailFailed": "確認メールの送信に失敗しました。もう一度お試しください。"
      },
      "page": {
        "login.form": "ログインフォーム"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze アフィリエイトページ",
        "affiliate.page.description": "あなたの専用紹介リンクを通じて行われたすべての販売に対して、15ヶ月間25%のコミッションを獲得できます。あなたのリンクをウェブサイト、ソーシャルメディア、または友人と共有してください。参加は数秒で完了します。自動的に承認されます。"
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "ポッドキャスターへの最高のギフト",
        "bestGiftForPodcaster.description": "ポッドキャスターの体験を向上させるための最高のギフトを見つけましょう。",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "ポッドキャストのリスナーを増やす",
        "get-more-podcast-listeners.description": "自動ショーノート、ソーシャルメディアでの番組成長のための短いクリップなどを活用して、ポッドキャストのリスナーを増やし、制作を効率化しましょう。"
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "ポッドキャストのオーディエンスを増やす",
        "grow_your_podcast_audience.description": "Podsqueezeを使って、時間を大幅に節約し、ポッドキャストのオーディエンスを増やしましょう。ポッドキャストのための完全なショーノート、ソーシャルメディア投稿、短いクリップなどを生成します。"
      },
      "index": {
        "home.page.title": "AIポッドキャストのショーノート、トランスクリプト、要約、クリップ生成器。",
        "home.page.description": "ワンクリックでポッドキャストのショーノート、タイムスタンプ、ニュースレターなどを生成！ポッドキャストのコンテンツを迅速に生成し、ニーズに合わせて調整します。無料サインアップ。"
      },
      "login": {
        "login.tryItNow": "今すぐ試す！",
        "login.createAccountDescription": "アカウントを作成して、ワンクリックでポッドキャストのショーノート、タイムスタンプ、ニュースレターなどを生成し始めましょう！ポッドキャストのコンテンツを迅速に生成し、ニーズに合わせて調整できます。無料でサインアップ。"
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "ポッドキャストのマーケティング",
        "marketing.for.podcasts.description": "Podsqueezeは、ポッドキャストのマーケティングを効率化し、自動生成されたショーノート、ソーシャルメディア投稿、短いクリップを提供して、リーチを拡大し、番組を成長させます。"
      },
      "media": {
        "media.page.title": "ポッドスクイーズ メディアページ",
        "media.page.description": "ポッドスクイーズについてもっと知りましょう。お問い合わせください！ご一緒にコラボレーションできることを楽しみにしています！"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "ポッドキャスト説明ジェネレーター",
        "podcast.description.generator.description": "AI生成の説明文でポッドキャストのリーチとエンゲージメントを向上させましょう。ショーノートの作成を自動化し、大切な時間を取り戻しましょう。"
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "ポッドキャストをソーシャルメディア投稿用に再利用する",
        "convert.podcast.episodes.to.social.media.posts": "ポッドキャストのエピソードをソーシャルメディア投稿に変換します。LinkedIn、Twitter、Facebook用の投稿を自動生成し、TikTok用の短いクリップも作成します。"
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "無料ポッドキャストトピックジェネレーター",
        "podcast.topics.generator.description": "私たちの無料ポッドキャストトピックジェネレーターを使えば、最適なトピックアイデアを見つけ、GoogleやYouTubeでの潜在的なリーチを予測できます。"
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "あなたのポッドキャストバーチャルアシスタント",
        "podcast.virtual.assistant.description": "AIポッドキャストバーチャルアシスタントがあなたのショーノートを作成し、ソーシャルメディア投稿を生成します。Podsqueezeを使ってポッドキャストの制作とマーケティングを効率化しましょう。"
      },
      "pricing": {
        "pricing.title": "料金",
        "pricing.description": "ワンクリックでポッドキャストのショーノート、タイムスタンプ、ニュースレターなどを生成できます！ポッドキャストのニーズに合わせた複数の価格帯をご用意しています。"
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "ポッドキャストを宣伝する",
        "promote.your.podcast.description": "ショーノート、ソーシャルメディア投稿、短いクリップを生成して、数分でポッドキャストを公開し宣伝します。"
      },
      "register": {
        "create.podsqueeze.account": "Podsqueezeアカウントを作成",
        "generate.content.podcast": "ワンクリックでポッドキャストのショーノート、タイムスタンプ、ニュースレターなどを生成！ポッドキャストのコンテンツを迅速に生成し、ニーズに合わせて調整します。無料でサインアップ。"
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "ポッドキャストコンテンツを自動的に再利用する",
        "repurpose.your.podcast.content.with.ai": "AIを使ってポッドキャストコンテンツを再利用しましょう。ショーノート、タイトル、TikTok用の短いクリップなどを自動的に生成し、すべてワンクリックで行えます！"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "無料ポッドキャストSEOオプティマイザー",
        "seo.optimizer.description": "AIによるSEO推奨で、ポッドキャストエピソードを検索エンジンでより見つけやすく分析・最適化します。",
        "seo.optimizer.heading": "ポッドキャストSEOオプティマイザー",
        "seo.optimizer.headingnote": "AIによるSEO推奨で、ポッドキャストエピソードを検索エンジンでより見つけやすく分析・最適化します。",
        "seo.optimizer.selectEpisode": "分析するエピソードを選択",
        "seo.optimizer.results": "SEO分析結果",
        "seo.optimizer.searchPodcastPlaceholder": "ポッドキャストを検索",
        "seo.optimizer.searchEpisodesPlaceholder": "エピソードを検索...",
        "seo.optimizer.analyseAnotherEpisode": "別のエピソードを分析",
        "seo.optimizer.findingEpisodes": "すべてのエピソードを検索中...",
        "seo.optimizer.analysingEpisode": "エピソードを分析中",
        "seo.optimizer.scoreTooltip": "スコア:",
        "seo.optimizer.topKeywords": "主要なキーワードを特定しました:",
        "seo.optimizer.topKeywordsnote": "ページ下部のキーワード分析に基づいています。",
        "seo.optimizer.optimizedContent": "キーワードに基づき、最適化されたタイトルと説明はこちら:",
        "seo.optimizer.originalTitle": "元のタイトル",
        "seo.optimizer.optimizedTitle": "最適化タイトル",
        "seo.optimizer.originalDescription": "元の説明",
        "seo.optimizer.optimizedDescription": "最適化説明",
        "seo.optimizer.showMore": "もっと見る",
        "seo.optimizer.showLess": "閉じる",
        "seo.optimizer.keywordAnalysis": "キーワード分析",
        "seo.optimizer.keywordAnalysisnote": "スコアは検索ボリューム、競合（同じキーワードの他の結果数）、YouTubeの場合は同キーワード動画の平均再生回数に基づいて計算されます。",
        "seo.optimizer.seoScore": "SEOスコア",
        "seo.optimizer.spotifyScore": "Spotifyスコア",
        "seo.optimizer.youtubeScore": "YouTubeスコア",
        "seo.optimizer.totalScore": "合計"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - AIポッドキャストコンテンツ生成ツール",
        "podsqueeze.description": "ワンクリックでポッドキャストのショーノート、タイムスタンプ、ニュースレターなどを生成！ポッドキャストのコンテンツを迅速に生成し、ニーズに合わせて調整します。無料サインアップ。"
      },
      "thumbnail-creator": {
        "title": "無料ポッドキャストサムネイルジェネレーター - AIパワードエピソードサムネイルを作成",
        "description": "AIで見事なポッドキャストサムネイルを作成します。視認性を高め、ポッドキャストにより多くのリスナーを引き付けるプロフェッショナルで目を引くエピソードアートワークを生成します。",
        "selectPodcast": "ポッドキャストを選択",
        "loadEpisodes": "エピソードを読み込み",
        "selectEpisode": "サムネイル作成用エピソードを選択",
        "createThumbnail": "サムネイルを作成",
        "results": "生成されたサムネイル",
        "download": "ダウンロード",
        "share": "共有",
        "regenerate": "再生成",
        "editThumbnail": "サムネイル編集",
        "editPlaceholder": "このサムネイルをどのように変更したいか説明してください...",
        "customPrompt": "カスタムプロンプト",
        "yourThumbnail": "あなたのサムネイル",
        "createAnother": "← 別のサムネイルを作成",
        "findingEpisodes": "エピソードを検索中...",
        "searchPodcastPlaceholder": "ポッドキャストを検索...",
        "searchingPodcasts": "ポッドキャストを検索中...",
        "heroDescription": "注目を集め、エピソードの視認性を高めるAI駆動デザインで、見事でプロフェッショナルなポッドキャストサムネイルを生成します。",
        "generatedWithPrompt": "プロンプトで生成:",
        "customPromptPlaceholder": "サムネイル生成用のカスタムプロンプトを入力...",
        "generating": "生成中...",
        "generate": "生成",
        "modernMinimalist": "モダン＆ミニマル",
        "vibrantDynamic": "鮮やか＆ダイナミック",
        "professionalClean": "プロフェッショナル＆クリーン",
        "generatingThumbnail": "サムネイルを生成中...",
        "generatingNewThumbnail": "新しいサムネイルを生成中...",
        "showingFirstEpisodes": "最初の10エピソードを表示中。特定のエピソードを見つけるには検索を使用してください。",
        "imageUrlCopied": "画像URLがクリップボードにコピーされました！",
        "failedToGenerate": "サムネイルの生成に失敗しました。再試行してください。",
        "promotionalTitle": "Podsqueezeでショーノート、タイムスタンプ、バイラルクリップなどを生成",
        "promotionalSubtitle": "10万人以上のクリエイターに参加して、ショーの成長を始めましょう",
        "startNow": "今すぐ開始",
        "free": "無料",
        "podcast": "ポッドキャスト",
        "thumbnail": "サムネイル",
        "creator": "クリエイター",
        "replaceFace": "顔を置き換え",
        "uploading": "アップロード中...",
        "uploadImageError": "画像ファイルをアップロードしてください。",
        "uploadFailedError": "画像のアップロードに失敗しました。再試行してください。",
        "uploadingImage": "画像をアップロード中...",
        "generatingNewThumbnailLoading": "新しいサムネイルを生成中...",
        "failedToGenerateWithFace": "顔置き換えでサムネイル生成に失敗しました。再試行してください。"
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "新しいポッドキャストフォルダーを作成",
      "folder.name.placeholder": "フォルダー名を入力",
      "create.button": "作成"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "エピソードを読み込み中...",
        "episodeList.noEpisodes": "公開エピソードがありません",
        "episodeList.checkBack": "新しいエピソードは後ほどご確認ください",
        "episodeList.title": "このポッドキャストのエピソード",
        "episodeList.readLess": "閉じる",
        "episodeList.readMore": "もっと見る",
        "episodeList.coverImageAlt": "{episodeTitle}のカバー"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "始める",
        "alert.subscriptionRunning": "現在のサブスクリプションはまだ有効です。\n\n新しいサブスクリプションを購入する前に、現在のサブスクリプションをキャンセルしてください。",
        "alert.subscriptionEnds": "現在のサブスクリプションはまだ有効です。\n\n終了日は {date} です。",
        "alert.subscriptionCancelled": "あなたのサブスクリプションはすでにキャンセルされており、終了日は {date} です。",
        "button.openDashboard": "ダッシュボードを開く",
        "button.signUp": "サインアップ",
        "button.buySubscription": "サブスクリプションを購入",
        "button.cancelled": "キャンセル済み",
        "button.cancelSubscription": "サブスクリプションをキャンセル",
        "button.upgradeSubscription": "サブスクリプションをアップグレード",
        "button.loading": "読み込み中",
        "upgrade.details.currentMinutes": "これにより新しいサブスクリプション期間が開始されます。現在のすべての分は保持されます。",
        "upgrade.details.remainingAnnual": "この値は、現在の年間サブスクリプションの残り時間に基づいて計算されました。"
      },
      "page": {
        "pricing.free.title": "無料",
        "pricing.free.subtitle": "Podsqueezeを試してみてください。クレジットカードは不要です。",
        "pricing.free.price.annual": "年間$0 請求",
        "pricing.free.features.podcast_time": "月あたり50分のポッドキャスト時間",
        "pricing.free.features.video_clips": "3つのビデオクリップ",
        "common.with_watermark": "透かし付き",
        "pricing.free.features.quote_images": "無制限の引用画像",
        "pricing.free.features.file_upload": "最大4Gbのファイルアップロード",
        "pricing.free.features.upload": "1回のアップロード",
        "pricing.free.features.landing_pages": "ポッドキャストのランディングページ",
        "pricing.free.features.audio_enhancement": "音声強化",
        "common.sign_up": "サインアップ",
        "common.open_dashboard": "ダッシュボードを開く",
        "pricing.starter.title": "スターター",
        "pricing.starter.subtitle": "時間を節約したい趣味のポッドキャスターに最適です。",
        "pricing.starter.price.annual": "年間$132 請求",
        "pricing.billed_annually": "年間請求",
        "minutes.accumulate": "繰り分",
        "pricing.starter.features.podcast_time": "月あたり160分のポッドキャスト時間",
        "pricing.starter.features.video_clips": "10のビデオクリップまたはオーディオグラム",
        "pricing.starter.features.quote_images": "無制限の引用画像",
        "pricing.starter.features.file_upload": "最大4Gbのファイルアップロード",
        "pricing.starter.features.unlimited_uploads": "無制限のアップロード",
        "pricing.starter.features.landing_pages": "ポッドキャストのランディングページ",
        "pricing.pro.title": "プロ",
        "pricing.pro.subtitle": "ビジネスを発展させ、サポートするためにポッドキャストを利用するプロフェッショナル向け。",
        "pricing.pro.price.annual": "年間$324 請求",
        "pricing.pro.features.podcast_time": "月あたり320分のポッドキャスト時間",
        "pricing.pro.features.personalize_ai_voice": "AI音声のパーソナライズ",
        "pricing.pro.features.video_clips": "20のビデオクリップまたはオーディオグラム",
        "common.no_watermark": "透かしなし",
        "pricing.pro.features.quote_images": "無制限の引用画像",
        "pricing.pro.features.file_upload": "最大10Gbのファイルアップロード",
        "pricing.pro.features.unlimited_uploads": "無制限のアップロード",
        "pricing.pro.features.landing_pages": "ポッドキャストのランディングページ",
        "common.customizable": "カスタマイズ可能",
        "pricing.pro.features.audio_video_edit": "オーディオとビデオのマジック編集",
        "pricing.agency_lite.title": "エージェンシーライト",
        "pricing.agency_lite.subtitle": "ビジネスを効率化し、成長させたいポッドキャストエージェンシー向け。",
        "pricing.agency_lite.price.annual": "年間$495 請求",
        "pricing.agency_lite.features.podcast_time": "月あたり600分のポッドキャスト時間",
        "pricing.agency_lite.features.personalize_ai_voice": "AI音声のパーソナライズ",
        "pricing.agency_lite.features.video_clips": "40のビデオクリップまたはオーディオグラム",
        "pricing.agency_lite.features.quote_images": "無制限の引用画像",
        "pricing.agency_lite.features.file_upload": "最大10Gbのファイルアップロード",
        "pricing.agency_lite.features.unlimited_uploads": "無制限のアップロード",
        "pricing.agency_lite.features.landing_pages": "ポッドキャストのランディングページ",
        "pricing.agency_lite.features.audio_video_edit": "オーディオとビデオのマジック編集",
        "pricing.agency_plus.title": "エージェンシープラス",
        "pricing.agency_plus.subtitle": "ビジネスを効率化し、成長させたいポッドキャストエージェンシー向け。",
        "pricing.agency_plus.price.annual": "年間$1,251 請求",
        "pricing.agency_plus.features.podcast_time": "月あたり2000分のポッドキャスト時間",
        "pricing.agency_plus.features.personalize_ai_voice": "AI音声のパーソナライズ",
        "pricing.agency_plus.features.video_clips": "80のビデオクリップまたはオーディオグラム",
        "pricing.agency_plus.features.quote_images": "無制限の引用画像",
        "pricing.agency_plus.features.file_upload": "最大10Gbのファイルアップロード",
        "pricing.agency_plus.features.unlimited_uploads": "無制限のアップロード",
        "pricing.agency_plus.features.landing_pages": "ポッドキャストのランディングページ",
        "pricing.agency_plus.features.audio_video_edit": "オーディオとビデオのマジック編集",
        "pricing.agency_scale.title": "エージェンシースケール",
        "pricing.agency_scale.subtitle": "ビジネスを効率化し、成長させたいポッドキャストエージェンシー向け。",
        "pricing.agency_scale.price.annual": "年間$2,175 請求",
        "pricing.agency_scale.features.podcast_time": "月あたり4000分のポッドキャスト時間",
        "pricing.agency_scale.features.personalize_ai_voice": "AI音声のパーソナライズ",
        "pricing.agency_scale.features.video_clips": "160のビデオクリップまたはオーディオグラム",
        "pricing.agency_scale.features.quote_images": "無制限の引用画像",
        "pricing.agency_scale.features.file_upload": "最大10Gbのファイルアップロード",
        "pricing.agency_scale.features.unlimited_uploads": "無制限のアップロード",
        "pricing.agency_scale.features.landing_pages": "ポッドキャストのランディングページ",
        "pricing.agency_scale.features.audio_video_edit": "オーディオとビデオのマジック編集",
        "pricing.header": "ソロポッドキャスターとポッドキャストエージェンシー向け",
        "pricing.minutes_reset": "現在のプランを維持またはアップグレードする限り、月間分数の最大3倍まで蓄積できます。",
        "pricing.most_popular": "最も人気",
        "pricing.minutes_per_month": "月あたりの分数",
        "pricing.enterprise_title": "エンタープライズ",
        "pricing.enterprise_subtitle": "メディアエージェンシーとメディア企業がビジネスを拡大したい場合に最適です。",
        "pricing.enterprise_price": "カスタマイズ",
        "pricing.enterprise_price_note": "team@podsqueeze.comまたは下記のデモ予約をご利用ください。",
        "pricing.enterprise_feature_priority_support": "優先サポート",
        "pricing.enterprise_feature_team_sits": "チームセッション",
        "pricing.enterprise_personalized_team_training": "チームオンボーディングとトレーニング",
        "pricing.book_demo": "デモ予約"
      },
      "toggle": {
        "pay.monthly": "月額",
        "pay.annually": "年額",
        "discount.30percent": "30%割引"
      },
      "upgradeModal": {
        "upgrade.success": "サブスクリプションが正常にアップグレードされました",
        "upgrade.error": "申し訳ありませんが、何かがうまくいきませんでした。後でもう一度お試しください",
        "upgrade.loading": "アップグレード中",
        "upgrade.confirmPay": "確認して支払う",
        "upgrade.cancel": "キャンセル",
        "coupon.placeholder": "クーポンコード",
        "coupon.apply": "適用",
        "coupon.have": "クーポンを持っています",
        "upgrade.confirmation": "次のプランにアップグレードしようとしています",
        "upgrade.price": "お支払いは"
      }
    },
    "register": {
      "page": {
        "register.form": "登録フォーム"
      },
      "registerForm": {
        "error.invalidCredentials": "有効なメールアドレスとパスワードを入力してください。",
        "error.weakPassword": "より強力なパスワードを使用してください 💪",
        "error.emailInUse": "ユーザーはすでに存在します",
        "error.userNotFound": "ユーザーが見つかりません",
        "error.generic": "うまくいきませんでした、何かが間違いました",
        "placeholder.email": "メールアドレス",
        "placeholder.password": "パスワード",
        "button.registering": "登録中...",
        "button.register": "登録する",
        "label.newsletter": "12,000人のポッドキャスターに参加し、製品の更新、実用的なヒント、電子書籍、プレゼントなどのニュースレターを購読してください。",
        "label.alreadyHaveAccount": "すでにアカウントをお持ちですか？",
        "label.logInHere": "ここでログイン",
        "label.or": "または",
        "button.signingIn": "サインイン中...",
        "button.continueWithGoogle": "Googleで続行",
        "label.podcastDescription": "必要なすべてが一つの場所に揃った、音声またはビデオポッドキャストを簡単に立ち上げ、成長させましょう。",
        "feature.transcripts": "トランスクリプト",
        "feature.showNotes": "ショーノート",
        "feature.newslettersBlogs": "ニュースレターとブログ",
        "feature.socialPosts": "ソーシャル投稿",
        "feature.shortClips": "ショートクリップとオーディオグラム",
        "feature.podcastWebsite": "ポッドキャストウェブサイト",
        "feature.audioEnhancement": "AIオーディオ強化",
        "feature.removeSilences": "沈黙や「あー」といった音を削除"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "テキスト"
      },
      "TopicFinder": {
        "competition.veryHigh": "非常に高い",
        "competition.high": "高い",
        "competition.medium": "中程度",
        "competition.low": "低い",
        "competition.veryLow": "非常に低い",
        "upgrade.button": "Proにアップグレード",
        "clicks.label": "クリック",
        "searches.label": "検索",
        "competition.label": "競争",
        "fetching.results": "結果を取得中",
        "table.topic": "トピック",
        "tooltip.topic": "ポッドキャストエピソードで扱われる主なトピック",
        "table.monthlySearches": "月間検索数",
        "tooltip.monthlySearches": "予想される月間Google検索の範囲",
        "table.competition": "競争",
        "tooltip.competition": "ポッドキャストで扱われる主なテーマまたはトピック。",
        "table.monthlyGoogleClicks": "月間Googleクリック数",
        "tooltip.monthlyGoogleClicks": "予想される月間Googleクリックの範囲",
        "table.youtubeReach": "YouTubeリーチ",
        "tooltip.youtubeReach": "平均的な競合に基づいて、最初の6ヶ月で予想される最大のYouTubeビュー数",
        "intro.title": "無料ポッドキャストトピックジェネレーター",
        "intro.description": "オーディエンスが検索しているポッドキャストのトピックアイデアを取得",
        "intro.check1": "各トピックアイデアの需要をGoogleで確認",
        "intro.check2": "各ポッドキャストトピックアイデアの競争状況を調べる",
        "intro.check3": "得られるGoogleクリック数とYouTubeビュー数を推定",
        "upgrade.message": "すべての結果にアクセスするにはProにアップグレードする必要があります",
        "learnMore.label": "についてもっと学ぶ",
        "learnMore.link": "無料ポッドキャストトピックジェネレーターツール",
        "newSearch.button": "新しい検索",
        "share.button": "この検索を共有",
        "form.label": "ポッドキャストのニッチを入力",
        "form.placeholder": "デジタルマーケティング",
        "form.submit": "トピックアイデアを見つける"
      },
      "page": {
        "main.background": "背景"
      },
      "shareTopics": {
        "share.results": "結果を共有",
        "share.facebook": "Facebookで共有",
        "share.whatsapp": "WhatsAppで共有",
        "share.twitter": "Twitterで共有",
        "share.linkedin": "LinkedInで共有",
        "copy.success": "コピーしました",
        "copy.link": "リンクをコピー"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "ビュー"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "現在の構成を取得できませんでした",
        "error.addImage": "画像要素の追加中にエラーが発生しました:",
        "alert.uploadImage": "画像ファイルをアップロードしてください。",
        "error.uploadImage": "画像のアップロード中にエラーが発生しました:",
        "alert.uploadFailed": "画像のアップロードに失敗しました。もう一度お試しください。",
        "error.getDownloadURL": "ダウンロードURLの取得中にエラーが発生しました:",
        "alert.processImageFailed": "アップロードされた画像の処理に失敗しました。もう一度お試しください。",
        "error.addText": "テキスト要素の追加中にエラーが発生しました:",
        "text.settingsPlaceholder": "要素が選択されると設定が表示されます",
        "text.addElement": "要素を追加",
        "text.uploading": "アップロード中...",
        "button.uploadImage": "画像をアップロード",
        "text.newText": "新しいテキスト",
        "button.addText": "テキストを追加",
        "text.selectedElementSettings": "選択された要素の設定"
      },
      "FontSelector": {
        "allFonts": "すべてのフォント",
        "myFonts": "マイフォント",
        "uploadFont": "フォントをアップロード",
        "noCustomFonts": "カスタムフォントはまだありません。",
        "uploadToAdd": "フォントファイルをアップロードしてコレクションに追加してください。",
        "text_outline": "テキストのアウトライン",
        "outline_color": "アウトラインの色",
        "outline_width": "アウトラインの太さ"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "フィット",
        "imageLayoutSettings.zoom": "ズーム",
        "imageLayoutSettings.horizontalAlignment": "水平揃え",
        "imageLayoutSettings.verticalAlignment": "垂直揃え",
        "imageLayoutSettings.deleteElement": "要素を削除"
      },
      "TemplateBox": {
        "confirm.delete.template": "このテンプレートを削除してもよろしいですか？"
      },
      "TextSettings": {
        "error.getting_current_text": "現在のテキストを取得中にエラーが発生しました：",
        "event.delete_text_element_clicked": "テキスト要素が削除されました",
        "error.changing_text_font": "テキストフォントの変更中にエラーが発生しました：",
        "event.text_font_changed": "テキストフォントが変更されました",
        "error.changing_text_size": "テキストサイズの変更中にエラーが発生しました：",
        "event.text_size_changed": "テキストサイズが変更されました",
        "error.changing_text_color": "テキストカラーの変更中にエラーが発生しました：",
        "event.text_color_changed": "テキストカラーが変更されました",
        "event.text_content_added": "テキストコンテンツが追加されました",
        "error.adding_text_content": "テキストコンテンツの追加中にエラーが発生しました：",
        "event.text_content_updated": "テキストコンテンツが更新されました",
        "label.text_content": "テキストコンテンツ",
        "label.text_font": "テキストフォント",
        "label.adjust_text_size": "テキストサイズを調整",
        "label.text_color": "テキストカラー",
        "button.delete": "削除"
      },
      "audiogramBaseTemplate": {
        "color.white": "白",
        "font.roboto": "ロボト",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 秒",
        "font.inter": "インター",
        "duration.1s": "1 秒",
        "easing.quadraticOut": "二次出力",
        "animation.fade": "フェード",
        "type.text": "テキスト",
        "name.podcastTitle": "ポッドキャストタイトル",
        "name.snippetTitle": "スニペットタイトル",
        "type.image": "画像",
        "name.audioBackgroundImage": "オーディオ背景画像",
        "name.subtitlesText": "字幕テキスト",
        "effect.highlight": "ハイライト",
        "type.audio": "オーディオ",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "スニペットタイトル",
        "podcast.title": "ポッドキャストタイトル",
        "new.episode": "新しいエピソード"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "白",
        "default.font.judson": "ジャドソン",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "defaultEpisodeUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "バックグラウンドミュージック",
        "audio.type": "オーディオ"
      },
      "imageElement": {
        "upload.image.error": "画像ファイルをアップロードしてください。",
        "upload.file.loading": "ファイルをアップロード中です。このウィンドウを閉じないでください。",
        "upload.image.label": "画像を置き換える",
        "ai.prompt.label": "AIに画像を生成するためのプロンプトを入力してください",
        "ai.prompt.placeholder": "例: 公園で走っている犬...",
        "ai.processing": "処理中...",
        "ai.create": "作成",
        "customize.image.title": "画像をカスタマイズ",
        "enter.image.url": "画像のURLを入力",
        "or": "または"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "テンプレートの取得中にエラーが発生しました：",
        "template.savedSuccessfully": "テンプレートが正常に保存されました",
        "error.savingTemplate": "テンプレートの保存中にエラーが発生しました：",
        "loading.savedTemplates": "保存されたテンプレートを読み込んでいます...",
        "no.savedTemplates": "保存されたテンプレートはありません",
        "select_template": "テンプレートを選択",
        "saving.template": "テンプレートを保存中...",
        "template_name": "テンプレート名",
        "enter.templateName": "テンプレート名を入力",
        "cancel": "キャンセル",
        "save": "保存",
        "default_templates": "デフォルトテンプレート",
        "saved_templates_count": "保存されたテンプレート ({count})",
        "folder_templates_count": "フォルダーテンプレート ({count})",
        "account_templates_count": "アカウントテンプレート ({count})",
        "save_current_template": "現在のテンプレートを保存"
      },
      "subtitlesElement": {
        "edit.word": "単語を編集",
        "edit.label": "編集",
        "remove.word.subtitle": "字幕から単語を削除",
        "erase.subtitle": "字幕から消去",
        "remove.word.clip": "音声と字幕から単語を削除",
        "remove.clip": "クリップから削除"
      },
      "utils": {
        "video.utils.title": "タイトル",
        "video.utils.currentTime": "現在の時間",
        "video.utils.nextTime": "次の時間",
        "video.utils.duration": "再生時間",
        "video.utils.description": "説明",
        "video.utils.srtSegment": "SRT セグメント"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "ここに字幕テキストを入力してください"
      }
    }
  },
  "ko": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "우리의 파트너가 되세요",
        "SHARE_PODSQUEEZE": "Podsqueeze를 당신의 청중과 공유하세요",
        "AND_EARN_MONEY": "하고 돈을 벌어요!",
        "LAST_UPDATED": "마지막 업데이트: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "제휴 파트너가 되세요",
        "EARN_COMMISSION": "수익",
        "COMMISSION": "커미션",
        "ON_EVERY_SALE": "15개월 동안 당신의 독점 추천 링크를 통해 이루어진 모든 판매에 대해 커미션을 얻으세요. 당신의 링크를 웹사이트, 소셜 미디어 또는 친구와 공유하세요. 가입하는 데 몇 초 밖에 걸리지 않습니다.",
        "GET_AUTOMATICALLY_APPROVED": "자동으로 승인됩니다.",
        "JOIN_NOW": "지금 가입하세요",
        "HOW_IT_WORKS": "작동 방법",
        "FREQUENTLY_ASKED_QUESTIONS": "자주 묻는 질문",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "제휴 파트너란 무엇인가요?",
        "AFFILIATE_PARTNER_DESCRIPTION": "제휴 파트너는 고유의 추천 링크를 통해 다른 회사의 제품이나 서비스를 홍보하고, 그 링크를 통해 이루어진 모든 판매에 대해 커미션을 받는 사람입니다.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "어떻게 제휴 파트너가 될 수 있나요?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "제휴 파트너가 되는 것은 빠르고 간단하며 몇 초밖에 걸리지 않습니다. 시작하려면 '지금 가입하세요' 버튼을 클릭하고 이메일을 사용하여 등록하세요. 등록이 완료되면, 사용하기 쉬운 대시보드에 액세스할 수 있으며, 고유한 추천 링크를 확인할 수 있습니다. 이 링크를 가족, 친구 또는 온라인 청중과 공유하세요. 누군가가 당신의 추천 링크를 클릭하고 Podsqueeze 웹사이트에서 구매를 완료하면, 15개월 동안 모든 결제에 대해 25%의 커미션을 얻게 됩니다! 생성된 모든 판매를 쉽게 추적할 수 있는 제휴 대시보드를 통해 수익을 확인할 수 있습니다.",
        "HOW_CAN_I_TRACK_MY_SALES": "내 판매 및 커미션을 어떻게 추적할 수 있나요?",
        "TRACKING_SALES_DESCRIPTION": "제휴 프로그램 대시보드를 사용하여 판매 및 커미션을 추적할 수 있습니다. 이 추적 소프트웨어는 제휴 파트너 및 비즈니스 파트너 모두에게 제공됩니다.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "언제 그리고 어떻게 지급을 받을 수 있나요?",
        "PAYMENT_DESCRIPTION": "지급은 매 30일마다 PayPal을 통해 이루어집니다. 최소 지급 기준이 50달러임을 유념하세요. 이 금액에 도달하면 매 30일마다 정기적으로 지급을 받을 수 있습니다.",
        "STILL_GOT_QUESTIONS": "아직 질문이 있으신가요?",
        "SEND_US_A_MESSAGE": "지원 채팅에서 메시지를 보내거나 team@podsqueeze.com으로 이메일을 보내주세요",
        "NOTE": "참고",
        "AFFILIATE_ADS_RESTRICTION": "제휴 파트너는 Google에서 광고를 생성하거나 Podsqueeze와 관련된 키워드 입찰에 참여할 수 없습니다.",
        "AFFILIATE_TERMS_OF_USE": "제휴 이용 약관",
        "CAN_I_RUN_ADS": "추천 링크를 홍보하기 위해 Google에서 광고 및 CPC 캠페인을 실행할 수 있나요?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "제휴 파트너는 검색 엔진에서 광고를 생성하거나 Podsqueeze와 관련된 키워드 입찰에 참여할 수 없습니다. 이 제한은 광고 전략의 무결성을 유지하고 브랜드 메시지의 일관성을 보장하는 데 도움이 됩니다. 이러한 입찰 캠페인에서 발생한 판매는 지급 대상에서 제외됩니다.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Podsqueeze는 어떻게 팟캐스트 제목을 생성하나요?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "내비게이션 바",
        "main.affiliateHero": "제휴 영웅",
        "main.footer": "푸터"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "인트로와 아웃트로 음악 추가",
        "intro.music": "인트로 음악",
        "outro.music": "아웃트로 음악",
        "intro.duration": "인트로 길이",
        "outro.duration": "아웃트로 길이",
        "intro.mode": "인트로 모드",
        "outro.mode": "아웃트로 모드",
        "cancel": "취소",
        "save": "저장",
        "apply": "적용",
        "current.intro.music": "현재 인트로 음악",
        "current.outro.music": "현재 아웃트로 음악",
        "change.music": "음악 변경",
        "choose.music": "음악 파일 선택",
        "browser.not.support.audio": "브라우저가 오디오 요소를 지원하지 않습니다.",
        "save.and.apply": "저장 및 적용",
        "no.music.selected": "선택된 음악 없음",
        "delete.music": "음악 삭제",
        "uploading.file": "파일 업로드 중..."
      },
      "audioEditElements": {
        "error.processing.rss": "일부 RSS 피드를 처리하는 데 어려움이 발생하고 있습니다. 파일을 업로드해 주세요.",
        "edit.enhance.audio": "오디오 녹음을 편집하고 향상시키기",
        "trial.label": "체험판",
        "audio.editing.experience": "고급 AI 알고리즘을 사용하여 자연스럽고 고품질의 결과를 단 한 번의 클릭으로 제공하는 원활한 오디오 편집을 경험하세요.",
        "improve.audio.quality": "오디오 품질 향상",
        "remove.hums.silences": "잡음 및 침묵 제거",
        "upgrade.edit.audio": "단 한 번의 클릭으로 오디오를 편집할 수 있도록 업그레이드하세요.",
        "available.plans": "모든 유료 플랜에서 이용 가능",
        "upgrade.now": "지금 업그레이드",
        "audio.element.support": "귀하의 브라우저는 오디오 요소를 지원하지 않습니다.",
        "download.audio": "오디오 다운로드",
        "loading.audio": "오디오 로딩 중",
        "editing.audio": "오디오 편집 중"
      },
      "videoEditElements": {
        "error.exporting.video": "비디오 내보내기 중 오류 발생",
        "download.failed": "다운로드 실패: {error.message}",
        "generating.video": "비디오 생성 중",
        "error.generating.clip": "클립 생성 중 오류 발생",
        "please.retry.support": "다시 시도하거나 사용자 지원팀에 문의해 주세요",
        "browser.not.support.video": "귀하의 브라우저는 비디오 태그를 지원하지 않습니다.",
        "this.might.take.minutes": "창을 닫지 마세요. 몇 분 정도 걸릴 수 있습니다.",
        "exporting.video": "비디오를 내보내는 중...",
        "seamless.audio.editing": "고급 AI 알고리즘을 사용하여 자연스럽고 고품질의 결과를 단 한 번의 클릭으로 경험하세요.",
        "difficulties.processing.rss": "일부 RSS 피드를 처리하는 데 어려움이 있습니다. 파일을 업로드해 주세요.",
        "edit.enhance.video.recording": "비디오 녹화를 편집하고 향상시키기",
        "trial": "체험판",
        "enhance.audio.quality": "오디오 품질 향상",
        "enhance.audio.quality.edit": "오디오 품질 향상 및 편집",
        "trim.filler.words.video": "비디오에서 불필요한 단어 제거 (예: 음음)",
        "trim.long.silences.video": "비디오에서 긴 침묵 제거",
        "upgrade.to.edit.video": "비디오를 단 한 번의 클릭으로 편집할 수 있도록 업그레이드하세요",
        "available.pro.agency.plans": "프로 및 에이전시 플랜에서 사용 가능",
        "upgrade.now": "지금 업그레이드",
        "download.only.audio": "오디오만 다운로드",
        "download.video": "비디오 다운로드",
        "please.dont.close.window": "창을 닫지 마세요",
        "export.video": "비디오 내보내기"
      },
      "videogramBaseTemplate": {
        "media.fit": "덮기",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "미디어"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "이 팟캐스트의 다른 에피소드",
        "tab.shownotes": "쇼 노트",
        "tab.timestamps": "타임스탬프",
        "tab.blogpost": "블로그 포스트",
        "tab.transcript": "대본",
        "key.points": "주요 포인트"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "귀하의 랜딩 페이지가 우리의 팟캐스트 찾기에서 활성화되었습니다. 청중과 공유하세요!",
        "landingPage.create": "이 에피소드를 위한 아름다운 랜딩 페이지 만들기",
        "landingPage.edit": "페이지 편집",
        "landingPage.visit": "페이지 방문",
        "landingPage.delete": "페이지 삭제",
        "landingPage.createButton": "랜딩 페이지 만들기"
      },
      "SocialLinksModal": {
        "manage.episode.links": "에피소드 링크 관리",
        "youtube.link": "유튜브 링크",
        "enter.youtube.link": "유튜브 링크를 입력하세요",
        "apple.podcasts.link": "애플 팟캐스트 링크",
        "enter.apple.podcasts.link": "애플 팟캐스트 링크를 입력하세요",
        "spotify.link": "스포티파이 링크",
        "enter.spotify.link": "스포티파이 링크를 입력하세요",
        "saving": "저장 중...",
        "save": "저장",
        "social.links.updated.successfully": "소셜 링크가 성공적으로 업데이트되었습니다!"
      },
      "affiliatesection": {
        "affiliate.section.title": "제휴 파트너가 되세요",
        "affiliate.section.subtitle": "당신의 청중과 Podsqueeze를 공유하고",
        "affiliate.section.earn": "돈을 벌어보세요!",
        "affiliate.section.commission": "우리의 제휴 프로그램은 모든 판매 및 구독 갱신 결제에 대해 15개월 동안 25%의 커미션을 제공합니다.",
        "affiliate.section.join": "가입하는 데 몇 초밖에 걸리지 않습니다!",
        "affiliate.section.knowMore": "자세히 알아보기"
      },
      "asseenon": {
        "podnews.logo": "팟뉴스 로고",
        "transistor.logo": "트랜지스터 로고",
        "thepodcasthost.logo": "더 팟캐스트 호스트 로고",
        "schoolofpodcasting.logo": "팟캐스팅 학교 로고",
        "semrush.logo": "세무시 로고"
      },
      "assembleshownotes": {
        "episode.description": "에피소드 설명",
        "bullet.points": "주요 내용",
        "timestamps": "타임스탬프",
        "links.and.mentions": "링크 및 언급",
        "extra.content": "추가 콘텐츠",
        "assemble.show.notes": "쇼 노트 작성하기",
        "downloading": "다운로드 중",
        "copied": "복사됨",
        "enter.placeholder": "{{label}} 입력..."
      },
      "cancelationModal": {
        "cancellation.option.break": "팟캐스트 중단하기",
        "cancellation.option.no_recurrent": "정기 구독을 원하지 않음",
        "cancellation.option.expensive": "너무 비쌈",
        "cancellation.option.not_saving_time": "시간을 충분히 절약하지 못함",
        "cancellation.option.dissatisfied_content": "생성된 콘텐츠의 품질에 불만족",
        "cancellation.option.unresponsive_support": "응답하지 않는 고객 지원",
        "cancellation.option.not_using": "서비스를 충분히 사용하지 않음",
        "cancellation.option.difficulty_navigating": "제품 사용/탐색에 어려움",
        "cancellation.option.better_alternative": "더 나은 대체 제품을 찾음",
        "cancellation.option.other": "기타",
        "cancellation.video.message": "우리 사용자 중 70%가 이 비디오를 본 후 취소 프로세스를 중단합니다.",
        "cancellation.button.cancel": "아직도 취소하고 싶습니다",
        "cancellation.button.try_again": "다시 시도하고 싶습니다",
        "cancellation.prompt.select_reason": "구독 취소 이유를 선택하여 제품 개선에 도움을 주십시오:",
        "cancellation.placeholder.answer": "여기에 답변을 입력하세요...",
        "cancellation.placeholder.specify_reason": "취소 이유를 구체적으로 입력해 주세요",
        "cancellation.button.next": "다음",
        "cancellation.button.go_back": "뒤로 가기",
        "cancellation.last_question.title": "마지막 질문입니다",
        "lose.all.accumulated.minutes": "취소하면 누적된 모든 분을 잃게 됩니다.",
        "keep.accumulating.minutes": "취소하더라도 누적된 분을 유지하여 다음 팟캐스트 시작 시 사용할 수 있습니다.",
        "here.are.some.ideas": "여기에는 Podsqueeze를 더 많이 사용하는 몇 가지 아이디어가 있습니다.",
        "generate.articles.favorite.podcasts.and.vides": "구매한 영상을 새로운 콘텐츠로 변환하여 사용할 수 있습니다.",
        "convert.and.repurpose.episodes": "구매한 영상을 새로운 콘텐츠로 변환하여 사용할 수 있습니다.",
        "share.your.account.with.a.friend": "구매한 영상을 새로운 콘텐츠로 변환하여 사용할 수 있습니다.",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "구매한 영상을 새로운 콘텐츠로 변환하여 사용할 수 있습니다.",
        "cancellation.last_question.prompt": "우리 서비스에 다시 가입할 것을 고려하게 만들기 위해 어떤 변화나 개선이 필요합니까?",
        "cancellation.feedback.message": "귀하의 피드백은 저희가 개선하는 데 도움이 됩니다 🙏",
        "cancellation.button.confirm": "취소 확인",
        "cancellation.minutes.accumulated": "축적된",
        "cancellation.minutes.accumulated.suffix": "분이 있으며 가치는",
        "cancellation.reminder.text": "기억해 주세요:",
        "cancellation.minutes.warning": "축적된 분은 활성 구독의 혜택입니다. 구독을 취소하면 귀하의 분은 영구적으로 손실됩니다.",
        "cancellation.content.deletion.warning": "생성된 모든 콘텐츠는 30일 후에 영구적으로 삭제됩니다.",
        "cancellation.minutes.left.title": "아직 남은 분이 있습니다! 낭비하지 마세요!",
        "cancellation.suggestion.clips": "오래된 에피소드를 소셜 미디어용 클립으로 재활용하세요",
        "cancellation.suggestion.articles": "오래된 에피소드를 Podsqueeze로 기사로 변환하여 SEO 혜택을 받으세요.",
        "cancellation.suggestion.linkedin": "오래된 권위 있는 에피소드를 LinkedIn 포스트로 변환하여 개인 브랜드를 강화하세요",
        "cancellation.suggestion.share": "사용하지 않은 분을 친구가 활용할 수 있도록 Podsqueeze 계정을 공유하세요.",
        "cancellation.button.keep.subscription": "구독 유지하기",
        "cancellation.button.keep.minutes": "내",
        "cancellation.button.keep.minutes.suffix": "가치의 분 유지하기",
        "cancellation.lifetime.before_you_go": "가기 전에...",
        "cancellation.lifetime.title": "단 $49로 평생 액세스는 어떠세요?",
        "cancellation.lifetime.subtitle": "Starter 계정을 유지하세요. 구독 없음. 갱신 없음. 오직 당신 것 — 영원히.",
        "cancellation.lifetime.feature1": "한 번의 $49 결제로 Podsqueeze 평생 액세스",
        "cancellation.lifetime.feature2": "필요할 때 사용하세요, 압박 없이 — 영원히 당신 것입니다",
        "cancellation.lifetime.feature3": "현재 및 미래의 모든 Starter 플랜 기능 포함",
        "cancellation.lifetime.button_cancel": "여전히 취소하고 싶습니다",
        "cancellation.lifetime.button_deal": "평생 딜 받기",
        "cancellation.downgrade.title": "월 $5.99로 모든 콘텐츠를 유지하세요",
        "cancellation.downgrade.subtitle": "Starter로 다운그레이드하면...",
        "cancellation.downgrade.feature1": "생성된 모든 콘텐츠 유지",
        "cancellation.downgrade.feature2": "웹사이트 계속 운영",
        "cancellation.downgrade.feature3": "가끔 작업을 위한 월 160분과 10개 클립",
        "cancellation.billing.monthly": "월간",
        "cancellation.billing.annual": "연간",
        "cancellation.billing.discount": "30% 할인",
        "cancellation.plan.starter": "Starter 플랜",
        "cancellation.price.monthly": "$8.99/월",
        "cancellation.price.annual": "$5.99/월",
        "cancellation.price.annual_billing": "연간 $71.88 청구",
        "cancellation.feature.minutes": "160분/월",
        "cancellation.feature.clips": "10클립/월",
        "cancellation.downgrade.button": "Starter로 다운그레이드하고 콘텐츠 유지",
        "cancellation.error.payment_link": "결제 링크를 가져올 수 없습니다. 다시 시도해 주세요.",
        "cancellation.error.payment_service": "결제 서비스 연결 오류.",
        "cancellation.option.question.break": "왜 휴식을 취하는지 더 자세히 말씀해 주실 수 있나요?",
        "cancellation.option.question.no_recurrent": "정기 구독을 원하지 않는 이유를 공유해 주실 수 있나요?",
        "cancellation.option.question.expensive": "어떤 가격이나 기능이 서비스를 더 가치있게 만들 수 있을까요?",
        "cancellation.option.question.not_saving_time": "귀하의 프로세스에서 여전히 많은 시간을 소요하는 것은 무엇인가요?",
        "cancellation.option.question.dissatisfied_content": "콘텐츠의 어떤 측면에 불만족스러우셨나요?",
        "cancellation.option.question.unresponsive_support": "저희 고객 지원에 대한 경험을 설명해 주실 수 있나요?",
        "cancellation.option.question.not_using": "서비스를 더 자주 사용하도록 격려할 수 있는 것이 있나요?",
        "cancellation.option.question.difficulty_navigating": "제품 사용/탐색 중 어떤 어려움을 겪으셨나요?",
        "cancellation.option.question.better_alternative": "어떤 대체 제품을 찾았고 그것의 무엇이 마음에 드시나요?",
        "cancellation.option.question.other": "취소 이유를 구체적으로 명시해 주세요:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "우리는 귀하의 개인 정보를 소중히 여깁니다",
        "cookiebanner.cookieUsage": "우리는 귀하의 웹사이트 경험을 향상하고 트래픽을 분석하기 위해 쿠키를 사용합니다. 수락을 클릭함으로써 귀하는 우리의 쿠키 사용에 동의하는 것입니다.",
        "cookiebanner.privacyPolicy": "개인정보 처리방침",
        "cookiebanner.accept": "수락",
        "cookiebanner.decline": "거부"
      },
      "episodeTitleBox": {
        "loading": "로딩 중...",
        "editEpisodeTitleClicked": "에피소드 제목 수정 클릭됨",
        "newEpisodeTitleStored": "새 에피소드 제목 저장됨"
      },
      "famewall": {
        "loading.message": "로딩 중..."
      },
      "footer": {
        "footer.features": "기능",
        "footer.transcriptGenerator": "전사 생성기",
        "footer.subtitlesGenerator": "자막 생성기",
        "footer.descriptionGenerator": "설명 생성기",
        "footer.podcastSummarizer": "팟캐스트 요약 생성기",
        "footer.titlesGenerator": "제목 생성기",
        "footer.bulletPointsGenerator": "글머리 기호 생성기",
        "footer.chaptersClipsGenerator": "챕터 및 클립 생성기",
        "footer.socialMediaPostsGenerator": "소셜 미디어 게시물 생성기",
        "footer.newsletterGenerator": "뉴스레터 생성기",
        "footer.blogPostGenerator": "블로그 게시물 생성기",
        "footer.podcastLandingPages": "팟캐스트 랜딩 페이지",
        "footer.podcastClipMaker": "팟캐스트 클립 제작기",
        "footer.audiogramGenerator": "오디오그램 생성기",
        "footer.aiAudioEnhancer": "AI 오디오 향상기",
        "footer.convertYoutubeToText": "유튜브를 텍스트로 변환",
        "footer.youtubeVideoNoiseRemover": "유튜브 비디오 소음 제거기",
        "footer.youtubeVideoKeyPoints": "유튜브 비디오 주요 포인트",
        "footer.freeResources": "무료 리소스",
        "footer.findPodcastTopicIdeas": "팟캐스트 주제 아이디어 찾기",
        "footer.articles": "기사",
        "footer.freeEbooks": "무료 전자책",
        "footer.community": "커뮤니티",
        "footer.ourPodcast": "우리의 팟캐스트",
        "footer.product": "제품",
        "footer.giftCard": "상품권",
        "footer.onboardingEbook": "온보딩 전자책",
        "footer.pricing": "가격",
        "footer.affiliates": "제휴사",
        "footer.media": "미디어",
        "footer.testimonials": "고객 후기",
        "footer.legal": "법적 고지",
        "footer.privacyPolicy": "개인정보 처리방침",
        "footer.termsOfUse": "이용 약관",
        "footer.refundPolicy": "환불 정책",
        "footer.allRightsReserved": "모든 권리 보유."
      },
      "globalState": {
        "cookie.enabled": "쿠키 사용 가능",
        "language.default": "기본 언어"
      },
      "head": {
        "keywords.list": "팟스퀴즈, AI, 팟캐스트, 콘텐츠 생성, 팟캐스트 전사, 쇼 노트, 타임스탬프, 팟캐스트 뉴스레터, 트윗, 블로그 게시물, 소셜 게시물, 제목, 쇼 노트 작성자"
      },
      "imageResultModal": {
        "download.image": "이미지 다운로드",
        "generating.image": "이미지 생성 중",
        "ai.prompt.label": "AI가 이미지를 생성할 프롬프트를 입력하세요",
        "ai.prompt.placeholder": "예: 공원에서 뛰고 있는 개...",
        "processing": "처리 중...",
        "create": "생성",
        "text.color.label": "텍스트 색상",
        "quote.icon.color.label": "인용 아이콘 색상",
        "background.color.label": "배경 색상",
        "font.label": "글꼴",
        "upload.cover.image": "표지 이미지 업로드",
        "aspect.ratio.info": "비율 1:1, 권장 크기 1200x1200",
        "upload.logo.label": "로고 업로드",
        "choose.file": "파일 선택",
        "upload.success": "업로드 성공",
        "choose.quote": "인용구 선택",
        "select.template": "템플릿 선택",
        "quote.label": "인용구",
        "enter.quote.here": "여기에 인용구 입력",
        "author.label": "저자",
        "enter.author.name": "저자 이름 입력",
        "podcast.name.label": "팟캐스트 이름",
        "enter.podcast.name": "팟캐스트 이름 입력",
        "colors": "색상",
        "select.font": "글꼴 선택",
        "cover.logo.images": "표지 및 로고 이미지",
        "logo.image": "로고 이미지",
        "upgrade.here": "여기에서 업그레이드",
        "remove.logo": "Podsqueeze 로고 제거",
        "default_templates": "기본 템플릿",
        "saved_templates_count": "저장된 템플릿",
        "save_current_template": "현재 템플릿 저장",
        "no_saved_templates": "저장된 템플릿이 아직 없습니다",
        "save_template": "템플릿 저장",
        "cancel": "취소",
        "save": "저장",
        "enter_template_name": "템플릿 이름 입력",
        "reset_template": "재설정",
        "add_element": "요소 추가",
        "generate": "생성",
        "add_image": "이미지 추가",
        "upload_image": "이미지 업로드",
        "or": "또는",
        "generate_with_ai": "AI로 생성",
        "search_fonts": "글꼴 검색...",
        "upload_logo": "로고 업로드",
        "square_image_recommended": "정사각형 이미지 권장",
        "opacity": "불투명도",
        "layers": "레이어",
        "no_element_selected": "선택된 요소 없음",
        "bold_shortcut": "굵게 (Ctrl+B)",
        "italic_shortcut": "기울임꼴 (Ctrl+I)",
        "underline_shortcut": "밑줄 (Ctrl+U)",
        "edit_text": "텍스트 편집",
        "tint_color": "색조",
        "toggle_gradient_transparent": "그라데이션 투명도 전환",
        "rotate_gradient": "그라데이션 45도 회전",
        "alt_background": "배경",
        "alt_podcast_logo": "팟캐스트 로고",
        "alt_custom": "사용자 지정",
        "alt_right_side": "오른쪽",
        "alt_profile": "프로필"
      },
      "intentModal": {
        "intentModal.title": "Podsqueeze로 무엇을 하시겠습니까?",
        "intentModal.sourceOption.Write_Show_Notes": "쇼 노트 작성",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "블로그 게시물 및 뉴스레터 작성",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "비디오 클립 또는 오디오그램 만들기",
        "intentModal.sourceOption.Create_Quote_Images": "인용 이미지 만들기",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "오디오/비디오 편집 및 향상",
        "intentModal.sourceOption.Transcribe": "전사하기",
        "intentModal.sourceOption.Create_a_Website": "웹사이트 만들기",
        "intentModal.sourceOption.All_of_the_Above": "위의 모든 항목",
        "intentModal.sourceOption.Other": "기타",
        "intentModal.otherPlaceholder": "구체적으로 입력해 주세요",
        "intentModal.submitButton": "제출 및 등록",
        "intentModal.skip": "건너뛰기"
      },
      "languageSwitcher": {
        "language.en": "영어",
        "language.es": "스페인어",
        "language.fr": "프랑스어",
        "language.de": "독일어",
        "language.it": "이탈리아어",
        "language.pt": "포르투갈어",
        "language.nl": "네덜란드어",
        "language.pl": "폴란드어",
        "language.ru": "러시아어",
        "language.zh": "중국어",
        "language.ja": "일본어",
        "language.ko": "한국어",
        "language.ar": "아랍어",
        "language.th": "태국어",
        "language.vi": "베트남어"
      },
      "lazyImage": {
        "lazyImage.alt": "이미지 설명"
      },
      "metadata": {
        "meta.title": "당신의 페이지 제목",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "유틸리티"
      },
      "navbar": {
        "navbar.dashboard": "대시보드",
        "navbar.login": "로그인",
        "navbar.openMenu": "메인 메뉴 열기",
        "navbar.features": "기능",
        "navbar.resources": "리소스",
        "navbar.pricing": "가격",
        "navbar.contact": "연락처",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "모든 기능 보기",
        "navbar.mainFeatures": "주요 기능",
        "navbar.podcastTranscription": "팟캐스트 및 비디오 전사 생성기",
        "navbar.transcriptionDescription": "화자 레이블이 있는 높은 정확도의 전사 및 자막용 SRT 파일.",
        "navbar.podcastSummarizer": "팟캐스트 요약기",
        "navbar.summarizerDescription": "자신의 목소리로 20배 빠르게 완전한 쇼 노트를 작성하세요.",
        "navbar.podcastClipMaker": "팟캐스트 클립 생성기",
        "navbar.clipMakerDescription": "팟캐스트를 위한 짧은 클립이나 오디오그램을 자동으로 생성합니다.",
        "navbar.audioEnhancer": "AI 오디오 향상기",
        "navbar.audioEnhancerDescription": "오디오를 자동으로 향상시키고, 침묵과 불필요한 단어를 제거합니다.",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE 기능 안내",
        "navbar.blog": "블로그",
        "navbar.blogDescription": "성공적인 팟캐스트를 시작하고 성장시키기 위한 실행 가능한 기사와 가이드.",
        "navbar.podcastTopicIdeas": "팟캐스트 주제 아이디어",
        "navbar.topicIdeasDescription": "청중이 검색하는 팟캐스트 주제를 발견하세요.",
        "navbar.actionableEbooks": "실용적인 eBook",
        "navbar.ebooksDescription": "팟캐스트를 다음 단계로 끌어올리는 실용적인 팁이 담긴 무료 eBook을 다운로드하세요.",
        "navbar.freeThumbnailMaker": "무료 팟캐스트 썸네일 제작기",
        "navbar.freeThumbnailMakerDescription": "AI로 전문적이고 눈길을 끄는 에피소드 썸네일을 제작하세요.",
        "navbar.seoOptimizer": "SEO 최적화 도구",
        "navbar.seoOptimizerDescription": "검색 엔진에서 더 나은 가시성을 위해 팟캐스트 에피소드를 최적화하세요.",
        "navbar.podcastDescription": "전 세계의 숙련된 팟캐스터와 Podsqueeze 사용자들을 인터뷰하는 저희 팟캐스트를 들어보세요. 그들의 팁, 통찰, 이야기, 그리고 자신만의 팟캐스트를 성장시키기 위해 알아야 할 모든 것을 공유해 달라고 요청합니다."
      },
      "resultModal": {
        "prompt.transcript.quote": "인용",
        "prompt.transcript.blog": "블로그",
        "prompt.transcript.tweets": "트윗",
        "prompt.shownotes.firstPerson": "1인칭 쇼노트",
        "prompt.shownotes.replaceName": "쇼노트에서 이름 바꾸기",
        "prompt.shownotes.friendlyTone": "친근한 톤의 쇼노트",
        "prompt.shownotes.youtubeDescription": "유튜브 설명 쇼노트",
        "prompt.shownotes.engagingQuestion": "흥미로운 질문 쇼노트",
        "prompt.timestamps.formatAsChapters": "타임스탬프를 챕터로 포맷하고 설명 제목 생성",
        "prompt.timestamps.detailedDescriptions": "주제 설명과 핵심 요약을 포함한 상세한 타임스탬프 생성",
        "prompt.timestamps.improveSpeakerNames": "발표자 이름을 '호스트', '전문가', '게스트'와 같은 더 설명적인 제목으로 바꾸기",
        "prompt.newsletter.casualTone": "캐주얼 톤의 뉴스레터",
        "prompt.newsletter.shorter": "짧은 뉴스레터",
        "prompt.newsletter.contentSections": "내용 섹션 뉴스레터",
        "prompt.newsletter.changeName": "뉴스레터에서 이름 바꾸기",
        "prompt.mentions.fullURL": "전체 URL 언급",
        "prompt.mentions.replaceName": "언급에서 이름 바꾸기",
        "prompt.tweets.underdogTone": "언더독 톤의 트윗",
        "prompt.tweets.firstPerson": "1인칭 트윗",
        "prompt.shortPost.relevantEmojis": "관련 이모지 짧은 포스트",
        "prompt.shortPost.educationalTone": "교육적인 톤의 짧은 포스트",
        "prompt.shortPost.underdogTone": "언더독 톤의 짧은 포스트",
        "prompt.shortPost.firstPerson": "1인칭 짧은 포스트",
        "prompt.titles.youtubeOptimized": "유튜브 최적화 제목",
        "prompt.titles.startWithHowTo": "'어떻게'로 시작하는 제목",
        "prompt.titles.otherOptions": "제목에 대한 다른 옵션",
        "prompt.keywords.youtubeOptimized": "유튜브 최적화 키워드",
        "prompt.keywords.separateWithCommas": "키워드를 쉼표로 구분하기",
        "prompt.quotes.lorem1": "로렘 입숨 인용 1",
        "prompt.quotes.lorem2": "로렘 입숨 인용 2",
        "prompt.bulletPoints.lorem1": "로렘 입숨 글머리 기호 1",
        "prompt.bulletPoints.lorem2": "로렘 입숨 글머리 기호 2",
        "prompt.longPost.firstPerson": "1인칭 긴 포스트",
        "prompt.longPost.relevantEmojis": "관련 이모지 긴 포스트",
        "prompt.longPost.changeName": "긴 포스트에서 이름 바꾸기",
        "alert.tuningInstructionsEmpty": "튜닝 지침은 비어 있을 수 없습니다.",
        "text.timestamps.byPodsqueeze": "PodSqueeze에 의한 타임스탬프",
        "button.copied": "복사됨",
        "button.copy": "복사",
        "embed.transcript": "전사 삽입",
        "embed.description": "삽입을 위한 설명",
        "preview.title": "미리보기 제목",
        "loading.regenerating": "재생성 중...",
        "placeholder.tuningInstructions": "튜닝 지침을 입력하세요...",
        "button.saveClose": "저장하고 닫기",
        "button.acceptChanges": "변경 사항 수락",
        "button.discard": "버리기",
        "button.embedTranscript": "전사 삽입",
        "text.copiedToClipboard": "클립보드에 복사됨",
        "download.srtFile": "SRT 파일 다운로드",
        "text.forCaptions": "자막용",
        "tune.title": "결과 조정",
        "tune.description": "다음 옵션으로 결과를 조정하세요.",
        "instruction.label": "지침:",
        "button.tuneResult": "결과 조정",
        "instruction.saveForLater": "나중에 저장",
        "button.readMore": "더 읽기",
        "button.showLess": "덜 보기",
        "customPrompt.used": "사용된 사용자 지정 프롬프트:",
        "feedback.happyWithResults": "결과에 만족하십니까?"
      },
      "resultModalTranscript": {
        "prompt.quote": "전사에서 세 가지 좋은 인용문 찾기",
        "prompt.blog": "주제 X에 초점을 맞춘 500단어 블로그 포스트 작성하기",
        "prompt.tweets": "전사에서 세 개의 매력적인 트윗 작성하기",
        "transcript.autoTranscribed": "Podsqueeze로 자동 전사됨",
        "alert.emptyPrompt": "조정 지침은 비어 있을 수 없습니다",
        "embed.transcript": "전사 내용 삽입",
        "embed.description": "WordPress 사이트나 HTML을 지원하는 페이지에 검색 기능이 있는 적당한 크기의 전사 내용을 삽입하세요.",
        "button.copied": "복사됨!",
        "button.copy": "복사",
        "preview.title": "미리보기",
        "edit.speakers": "발표자 이름 편집",
        "button.saveClose": "저장 및 닫기",
        "placeholder.prompt": "예: 전사에서 세 가지 좋은 인용문 찾기",
        "upgrade.pro": "이 기능을 사용하려면 Pro로 업그레이드하세요",
        "upgrade.link": "Pro로 업그레이드",
        "button.generate": "생성",
        "feedback.happy": "결과에 만족하십니까?",
        "instruction": "지침: ",
        "generating.results": "결과 생성 중",
        "full.transcription": "전체 전사",
        "srt.file": "& SRT 파일",
        "download.srt": "SRT 파일 다운로드",
        "caption.subtitles": "자막 및 캡션용.",
        "generate.from.transcript": "Gpt-4o로 전사에서 생성하기",
        "gpt.tweak.text": "최신 GPT에게 텍스트를 원하는 대로 조정하도록 요청하세요. 자연어를 사용하고 구체적으로 말하는 것을 두려워하지 마세요.",
        "copied.clipboard": "클립보드에 복사됨",
        "transcript.public.available": "공개 URL",
        "audio.notSupported": "귀하의 브라우저는 오디오 요소를 지원하지 않습니다.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "팟캐스트 이름 추가",
        "podcast.title": "{{title}} 팟캐스트"
      },
      "sourceModal": {
        "sourceModal.title": "Podsqueeze에 대해 어떻게 알게 되셨나요?",
        "sourceModal.otherPlaceholder": "구체적으로 입력해 주세요",
        "sourceModal.nextButton": "다음",
        "sourceModal.skip": "건너뛰기"
      },
      "squeezeEditResults": {
        "error.processing.rss": "일부 RSS 피드를 처리하는 데 어려움이 발생하고 있습니다. 파일을 업로드해 주세요."
      },
      "squeezeResults": {
        "copiedToClipboard": "클립보드에 복사됨",
        "publicLink": "공개 링크 ",
        "createLink": "이 결과 페이지를 공유할 링크 생성",
        "assembleShowNotes": "쇼 노트 작성",
        "convertAnotherEpisode": "다른 에피소드 변환",
        "writtenContent": "작성된 콘텐츠",
        "videoClipsAndImages": "비디오 클립 및 이미지",
        "editAudio": "오디오 편집"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "더 보기 및 조정",
        "see.more": "더 보기",
        "generating": "생성 중",
        "download.all": "모두 다운로드",
        "full.transcription": "전체 전사",
        "transcript.benefit": "전체 전사를 쇼 노트에 추가하면 웹사이트 트래픽과 참여도가 증가한다는 사실을 알고 계셨나요?",
        "learn.more": "자세히 알아보기",
        "transcript.bonus": "팟캐스트 회원 프로그램의 보너스로 전체 전사를 제공할 수 있습니다.",
        "show.notes": "쇼 노트",
        "show.notes.engagement": "이 짧은 설명을 쇼 노트의 다른 요소와 보완하여 참여도와 SEO를 높이는 것을 고려해 보세요.",
        "show.notes.examples": "이 17개의 팟캐스트 쇼 노트 예시에서 영감을 얻어 귀하의 팟캐스트에 적합한 노트를 작성하세요.",
        "timestamps": "타임스탬프",
        "timestamps.benefit": "이 타임스탬프를 에피소드 설명에 추가하면 Spotify와 YouTube에서 자동으로 챕터가 생성됩니다.",
        "titles": "제목",
        "titles.engagement": "물음표와 최상급이 포함된 제목은 특히 참여를 유도하는 경향이 있습니다.",
        "links.and.mentions": "링크 및 언급",
        "mentions.resources": "아래 언급된 내용을 쇼 노트의 리소스 섹션에 포함하는 것을 고려해 보세요.",
        "mentions.affiliate": "언급된 제품에 제휴 프로그램이 있는지 확인하고 쇼 노트에 제휴 링크를 추가하는 것을 고려해 보세요.",
        "mentions.social.media": "에피소드에서 언급된 사람들을 소셜 미디어에서 태그하여 그들이 귀하의 게시물을 공유하고 참여하도록 유도하세요.",
        "keywords": "키워드",
        "keywords.youtube": "에피소드를 YouTube에 업로드할 때 이 키워드를 태그 섹션에 복사하여 붙여넣기만 하면 됩니다.",
        "keywords.social.media": "이 키워드를 소셜 미디어 해시태그로 재사용하세요.",
        "blog.post": "블로그 게시물",
        "blog.post.linkedin": "이 콘텐츠를 사용하여 긴 형식의 LinkedIn 게시물을 작성하는 것을 고려해 보세요.",
        "blog.post.share": "이 콘텐츠를 귀하의 팟캐스트 주제와 관련된 Reddit 커뮤니티 및 Facebook 그룹에 공유하세요.",
        "newsletter": "뉴스레터",
        "newsletter.content": "일부 사용자들은 이 뉴스레터 콘텐츠를 사용하여 쇼 노트를 위한 더 포괄적인 에피소드 설명을 작성합니다.",
        "linkedin.and.facebook": "LinkedIn 및 Facebook",
        "short.post.description": "관련 비디오 클립 및 오디오그램을 소셜 미디어에 공유할 때 이 간단한 게시물을 설명으로 사용하세요.",
        "tweets": "트윗",
        "quotes": "인용",
        "bullet.points": "글머리 기호",
        "add.custom.result": "사용자 정의 결과 추가",
        "bullet.points.skimming": "팟캐스터들은 종종 주요 에피소드 주제를 쇼 노트에서 쉽게 훑어볼 수 있도록 글머리 기호로 나열합니다."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "더 보기 및 조정",
        "generating": "생성 중",
        "not.available.for.rss.feed": "이 RSS 피드에서는 사용할 수 없습니다",
        "regenerate.episode.upload.file": "에피소드를 재생성하고 컴퓨터에서 직접 오디오/비디오 파일을 업로드하세요",
        "processing.difficulties": "일부 RSS 피드를 처리하는 데 어려움이 발생하고 있습니다. 파일을 업로드해 주세요.",
        "video.clips": "비디오 클립",
        "ai.short.clips": "AI 단축 클립",
        "quote.image": "인용 이미지"
      },
      "title": {
        "title.text": "당신의.라벨"
      },
      "topbar": {
        "topbar.forYou": "당신을 위한",
        "topbar.joinPodcast": "다음 팟캐스트 가상 모임에 참여하세요!",
        "topbar.saveYourSpot": "자리를 예약하세요",
        "topbar.dismiss": "닫기"
      },
      "trackers": {
        "trackers.init": "쿠키가 활성화된 상태로 추적기를 초기화하는 중: ",
        "trackers.loadScripts": "추적 스크립트를 로드하는 중..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "내 애플리케이션에 오신 것을 환영합니다",
        "content.description": "이것은 번역을 보여주는 샘플 애플리케이션입니다.",
        "button.submit": "제출"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI가 클립을 편집하고 있습니다",
        "export_clip": "클립 내보내기",
        "ai_edit": "AI 편집",
        "ai_editing_clip_duration": "몇 초 정도 소요됩니다",
        "generating_clip": "클립을 생성하는 중...",
        "generating_clip_notice": "몇 분 정도 걸릴 수 있습니다. 완료되면 이메일로 알려드리겠습니다.",
        "edit_another_video": "여기서 기다리거나 다른 비디오를 편집할 수 있습니다",
        "download_video": "비디오 다운로드",
        "back_to_editing": "편집으로 돌아가기",
        "export_video_button": "클립 내보내기",
        "notice_storage": "알림: 오디오는 30일 동안 저장됩니다. 이 기간이 지나면 클립이 만료됩니다.",
        "error_generating_clip": "클립 생성 오류",
        "error_user_support": "다시 시도하거나 사용자 지원에 문의해 주세요",
        "select_template": "템플릿 선택",
        "add_30s_prev": "이전 챕터에서 30초 추가",
        "add_30s_next": "다음 챕터에서 30초 추가",
        "undo": "실행 취소",
        "subtitles_font": "자막 글꼴",
        "subtitles_color": "자막 색상",
        "subtitles_box_color": "애니메이션 색상",
        "adjust_podcast_title_position": "팟캐스트 제목 수직 위치 조정",
        "adjust_subtitles_size": "자막 크기 조정",
        "adjust_subtitles_vertical_position": "자막 수직 위치 조정",
        "remove_subtitles": "자막 제거",
        "animated_subtitles": "애니메이션 자막",
        "upgrade_here": "여기에서 업그레이드",
        "remove_logo": "로고 제거",
        "remove_podsqueeze_logo": "Podsqueeze 로고 제거",
        "aspect_ratio": "종횡비",
        "youtube": "유튜브",
        "social_media": "트위터(X), 링크드인, 인스타그램 피드",
        "reels": "릴스, 스토리, 유튜브 쇼츠, 틱톡",
        "episode_title": "에피소드 제목",
        "podcast_title": "팟캐스트 제목",
        "titles_font": "제목 글꼴",
        "title_colors": "팟캐스트/에피소드 제목 색상",
        "video_fit": "비디오 맞춤",
        "adjust_horizontal_position": "수평 위치 조정",
        "adjust_vertical_position": "수직 위치 조정",
        "adjust_video_zoom": "비디오 줌 조정",
        "adjust_video_width": "비디오 너비 조정",
        "adjust_video_height": "비디오 높이 조정",
        "background_color": "배경 색상",
        "edit_clip": "클립 편집",
        "edit_layout": "레이아웃 편집",
        "choose_short": "짧은 클립 선택",
        "edit_audio": "오디오 편집",
        "framing": "프레이밍",
        "background": "배경",
        "text_style": "텍스트 스타일",
        "music": "음악",
        "choose_chapter": "챕터 선택",
        "clips_left": "남은 클립 수:",
        "apply_layout": "레이아웃 적용",
        "clips_left_number": "클립이 남았습니다",
        "need_more_clips": "더 많은 클립이 필요하신가요? 여기에서 요금제를 업그레이드하세요",
        "download_srt_file": "SRT 파일 다운로드",
        "track_selected": "트랙: ",
        "no_background_music": "선택된 배경 음악이 없습니다",
        "volume": "볼륨:",
        "remove": "제거",
        "track_ambient_piano": "앰비언트 피아노와 현악기",
        "track_deep_meditation": "깊은 명상",
        "track_chill_upbeat": "차분한 경쾌함",
        "track_inspiring_ambient": "영감을 주는 시네마틱 앰비언트",
        "track_just_relax": "그냥 편안히 쉬세요",
        "track_movement": "움직임",
        "track_once_in_paris": "파리에서의 한때",
        "track_perfect_beauty": "완벽한 아름다움",
        "track_summer_adventures": "여름의 모험",
        "track_sunset_groove": "일몰 그루비",
        "track_tvari_cafe": "트바리 도쿄 카페",
        "track_short_piano_intermezzo": "짧은 피아노 간주곡",
        "track_dramatic_background": "드라마틱한 배경 음악",
        "track_dramatic_hiphop": "드라마틱한 힙합 재즈",
        "track_emotional_orchestra": "감정적인 오케스트라",
        "track_halloween_short": "할로윈 음악",
        "track_improvisation_037": "재즈 즉흥연주",
        "track_inspiration_piano": "영감을 주는 피아노",
        "track_medieval_extract": "중세 음악",
        "track_short_8": "짧은 앰비언트 트랙",
        "track_flute": "평화로운 플루트",
        "track_piano_guitar_duet": "피아노-기타 듀엣",
        "track_intro_jazz": "인트로 재즈",
        "track_romantic_jazz": "로맨틱 재즈",
        "recommended_for_youtube": "YouTube에 추천됨",
        "turn_into_short_clip": "이 클립을 짧은 클립(<60초)으로 변환",
        "browser_not_support_audio": "귀하의 브라우저는 오디오 요소를 지원하지 않습니다.",
        "watch_tutorial": "이 튜토리얼을 시청하세요",
        "audiogram_maker": "오디오그램 메이커를 최대한 활용하는 방법",
        "store_audio_notice": "알림: 오디오는 30일 동안 저장됩니다.",
        "clip_maker": "클립 메이커를 최대한 활용하는 방법",
        "split_screen_mode": "화면 분할 모드",
        "none": "없음",
        "vertical_split": "수직 분할",
        "horizontal_split": "수평 분할",
        "screen_1_horizontal_position": "화면 1 수평 위치",
        "screen_2_horizontal_position": "화면 2 수평 위치",
        "layers": "아래 레이어를 사용하여 앞뒤로 이동하세요.",
        "track_mysterious_dark_background": "신비로운 어두운 배경",
        "track_acoustic_ambient_inspiration": "어쿠스틱 앰비언트 인스피레이션",
        "track_aristocracy_classical": "아리스토크래시 클래시컬",
        "track_folk_music_river_knows_my_name": "포크 음악 - 강이 내 이름을 안다",
        "track_funy_adventure": "재미있는 모험",
        "track_energetic_sports_rock_trailer": "에너지틱한 스포츠 록 트레일러",
        "track_fun_upbeat_energetic_pop_rock": "재미있는 업비트 에너지틱 팝 록",
        "track_epic_emotional_inspirational": "서사적 감정적 영감",
        "track_inspirational_epic": "영감을 주는 서사시",
        "all_music": "모든 음악",
        "energetic_music": "에너지틱",
        "inspirational_music": "영감을 주는",
        "ambient_music": "앰비언트",
        "chill_music": "차분한",
        "hiphop_music": "힙합",
        "quirky_music": "기발한",
        "dramatic_music": "드라마틱",
        "acoustic_music": "어쿠스틱",
        "classical_music": "클래식",
        "categories": "카테고리",
        "select_track": "트랙 선택",
        "upload_music": "음악 업로드",
        "my_music": "내 음악",
        "downloading": "다운로드 중...",
        "download_again": "다시 다운로드",
        "download": "다운로드",
        "download_failed_alert": "비디오 다운로드에 실패했습니다. 다시 시도해 주세요.",
        "translate_subtitles": "자막 번역",
        "translate_to": "번역 대상",
        "select_language": "언어 선택",
        "select_new_language": "새 언어 선택",
        "translating": "번역 중...",
        "translation_complete": "번역 완료",
        "error_translation": "번역 중 오류가 발생했습니다. 다시 시도해 주세요.",
        "original_language": "원본"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "에피소드 제목"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "아직 콘텐츠가 없습니다.",
        "userPodcastsInfo.generateContent": "첫 번째 콘텐츠 생성하기",
        "placeholder.search_folders": "폴더 검색...",
        "search.no_results": "검색과 일치하는 폴더가 없습니다."
      },
      "landingPageModal": {
        "upload.error": "이미지 업로드 실패: ",
        "upload.image.file": "이미지 파일을 업로드해 주세요.",
        "upgrade.pro.message": "페이지 커스터마이징은 Pro 및 Agency 계정에서만 가능합니다.",
        "upgrade.now": "지금 업그레이드",
        "upgrade.unique.landing.page": " 및 고유한 에피소드 랜딩 페이지를 만드세요.",
        "logo.recommendation": "추천 로고 높이 200px",
        "social.links.top.menu": "상단 메뉴의 소셜 링크",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "LinkedIn 링크를 입력하세요",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Facebook 링크를 입력하세요",
        "saving...": "저장 중...",
        "save": "저장",
        "saved.successfully": "성공적으로 저장되었습니다!",
        "uploading.image": "이미지 업로드 중...",
        "upload.episode.cover": "에피소드 커버 업로드",
        "upload.logo": "로고 업로드",
        "where.listen.episode": "이 에피소드를 어디서 더 들을 수 있나요?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "YouTube 링크를 입력하세요",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Apple Podcasts 링크를 입력하세요",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Spotify 링크를 입력하세요",
        "image.size.recommendation": "추천 크기 1000x1000px",
        "primary.color.label": "기본 색상",
        "header.background.color": "헤더 배경 색상 및 링크.",
        "landing.page.customization": "랜딩 페이지 커스터마이징",
        "create.branded.landing.page": "청취자와 공유할 아름다운 브랜드 랜딩 페이지를 만드세요",
        "episode.image": "에피소드 이미지",
        "episode.links": "에피소드 링크",
        "page.header": "페이지 헤더",
        "page.color": "페이지 색상",
        "visit.landing.page": "랜딩 페이지 방문"
      },
      "page": {
        "loading.dashboard": "대시보드 로딩 중",
        "convert.new.episode": "새 에피소드 변환",
        "convert.audio.or.video": "음성 또는 비디오 변환",
        "minutes.left": "남은 시간: ",
        "need.more.minutes": "더 많은 시간이 필요하신가요?",
        "upgrade.plan": "여기에서 요금을 업그레이드하세요.",
        "your.podcasts": "당신의 팟캐스트",
        "podsqueeze.results.page": "Podsqueeze 결과 페이지",
        "access.podsqueeze.results": "이 에피소드의 podsqueeze 결과에 접근하세요. 생성된 모든 콘텐츠를 볼 수 있습니다."
      },
      "podcast": {
        "confirm.delete_episode": "이 에피소드를 삭제하시겠습니까?",
        "alert.something_wrong": "문제가 발생했습니다. 다시 시도해 주세요.",
        "confirm.delete_folder": "이 폴더를 삭제하시겠습니까?",
        "loading.episodes": "에피소드를 로딩 중...",
        "folder.empty": "이 폴더는 비어 있습니다.",
        "content.no_content": "사용 가능한 콘텐츠가 없습니다.",
        "content.generate_first": "첫 번째 팟캐스트를 생성하세요.",
        "button.personalize_ai": "AI로 개인화하기",
        "button.edit_website": "웹사이트 편집",
        "button.visit_website": "웹사이트 방문",
        "button.generate_website": "웹사이트 생성",
        "placeholder.search": "검색...",
        "label.sort_by": "정렬 기준",
        "label.last_episodes_loaded": "마지막으로 로드된 에피소드",
        "button.load_all_episodes": "모든 에피소드 로드",
        "loading": "로딩 중...",
        "add.new.episode": "새 에피소드 추가",
        "order.newest": "최신순",
        "order.oldest": "오래된순",
        "order.a_to_z": "가나다순",
        "order.z_to_a": "가나다 역순"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "새 팟캐스트 폴더 만들기:",
        "folder.name.placeholder": "폴더 이름",
        "create.button": "생성"
      },
      "podcastLandingModal": {
        "upload.image.error": "이미지 파일을 업로드해 주세요",
        "podcast.cover.title": "팟캐스트 커버 이미지",
        "podcast.cover.upload": "여기에 팟캐스트 커버 이미지를 업로드하세요. 이 이미지는 랜딩 페이지에 두드러지게 표시됩니다.",
        "upload.image.uploading": "이미지 업로드 중...",
        "podcast.cover.upload.button": "커버 이미지 업로드",
        "podcast.cover.recommended.size": "권장 크기: 1400x1400 픽셀",
        "profile.info.title": "프로필 정보",
        "profile.info.upload": "프로필 사진과 이름을 추가하여 랜딩 페이지를 개인화하세요.",
        "profile.upload.button": "프로필 사진 업로드",
        "profile.name.label": "프로필 이름",
        "profile.name.placeholder": "이름을 입력하세요",
        "platform.links.title": "플랫폼 링크",
        "platform.links.upload": "다양한 플랫폼에서 팟캐스트 링크를 추가하세요.",
        "platform.links.youtube_link": "유튜브 링크",
        "platform.links.youtube_link.placeholder": "유튜브 링크를 입력하세요",
        "platform.links.spotify_link": "스포티파이 링크",
        "platform.links.spotify_link.placeholder": "스포티파이 링크를 입력하세요",
        "platform.links.apple_podcast_link": "애플 팟캐스트 링크",
        "platform.links.apple_podcast_link.placeholder": "애플 팟캐스트 링크를 입력하세요",
        "platform.links.linkedin_link": "링크드인 링크",
        "platform.links.linkedin_link.placeholder": "링크드인 링크를 입력하세요",
        "platform.links.facebook_link": "페이스북 링크",
        "platform.links.facebook_link.placeholder": "페이스북 링크를 입력하세요",
        "platform.links.twitter_link": "트위터 링크",
        "platform.links.twitter_link.placeholder": "트위터 링크를 입력하세요",
        "call.to.action.title": "행동 촉구",
        "call.to.action.upload": "랜딩 페이지의 행동 촉구 버튼을 설정하세요.",
        "call.to.action.button.text.label": "버튼 텍스트",
        "call.to.action.button.text.placeholder": "버튼 텍스트를 입력하세요",
        "call.to.action.button.link.label": "버튼 링크",
        "call.to.action.button.link.placeholder": "버튼 링크를 입력하세요",
        "color.styles.title": "색상 스타일",
        "color.styles.upload": "랜딩 페이지의 색상을 사용자 정의하세요.",
        "color.styles.primary.label": "기본 색상",
        "color.styles.primary.description": "랜딩 페이지의 기본 색상을 선택하세요",
        "color.styles.secondary.label": "보조 색상",
        "color.styles.secondary.description": "랜딩 페이지의 보조 색상을 선택하세요",
        "podcast.info.title": "팟캐스트 정보",
        "podcast.info.upload": "팟캐스트의 세부 정보를 편집하세요.",
        "podcast.info.name.label": "팟캐스트 이름",
        "podcast.info.name.placeholder": "팟캐스트 이름을 입력하세요",
        "podcast.info.description.label": "팟캐스트 설명",
        "podcast.info.description.placeholder": "팟캐스트 설명을 입력하세요",
        "edit.website.title": "웹사이트 편집",
        "generate.website.title": "웹사이트 생성",
        "for": "을 위한",
        "saving": "저장 중...",
        "save.changes": "변경 사항 저장",
        "generate.website": "웹사이트 생성",
        "changes.saved.success": "변경 사항이 성공적으로 저장되었습니다!",
        "podcast.cover.menu": "팟캐스트 커버",
        "podcast.info.menu": "팟캐스트 정보",
        "profile.menu": "프로필",
        "platform.links.menu": "플랫폼 링크",
        "call.to.action.menu": "행동 촉구",
        "color.styles.menu": "색상 스타일",
        "logo.menu": "로고",
        "logo.title": "로고 업로드",
        "logo.upload": "팟캐스트의 로고를 업로드하세요. 이 로고는 랜딩 페이지에 표시됩니다.",
        "logo.upload.button": "로고 업로드",
        "platform.links.description": "팟캐스트의 링크를 다양한 플랫폼에 추가하세요.",
        "social.links.menu": "소셜 링크",
        "social.links.title": "소셜 미디어 링크",
        "social.links.description": "소셜 미디어 프로필 링크를 추가하세요.",
        "social.links.linkedinLink": "링크드인",
        "social.links.linkedinLink.placeholder": "링크드인 프로필 링크를 입력하세요",
        "social.links.facebookLink": "페이스북",
        "social.links.facebookLink.placeholder": "페이스북 페이지 링크를 입력하세요",
        "social.links.twitterLink": "트위터",
        "social.links.twitterLink.placeholder": "트위터 프로필 링크를 입력하세요",
        "platform.links.youtubeLink": "유튜브",
        "platform.links.youtubeLink.placeholder": "유튜브 프로필 링크를 입력하세요",
        "social.links.instagramLink": "인스타그램",
        "social.links.instagramLink.placeholder": "인스타그램 프로필 링크를 입력하세요",
        "social.links.spotifyLink": "스포티파이",
        "social.links.spotifyLink.placeholder": "스포티파이 프로필 링크를 입력하세요",
        "social.links.applePodcastLink": "애플 팟캐스트",
        "social.links.applePodcastLink.placeholder": "애플 팟캐스트 프로필 링크를 입력하세요"
      },
      "podcastMoveModal": {
        "move.episode.label": "이 에피소드를 이동할 위치:",
        "move.episode.instruction": "새 이름을 입력하여 폴더를 생성할 수 있습니다.",
        "move.episode.button": "이동",
        "move.episode.error.selectFolder": "에피소드를 이동할 폴더를 선택하세요."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "{{podcastTitle}} 팟캐스트를 위한 AI 설정",
        "ai.customize.writing.style": "AI 글쓰기 스타일 사용자 정의",
        "ai.content.writing.preference": "Podsqueeze가 귀하의 콘텐츠를 어떻게 작성하기를 원하십니까?",
        "ai.voice.placeholder": "예: 전문적이지만 친근한 톤. 청중은 팟캐스터입니다. 1인칭으로 작성하세요.",
        "ai.character.limit.reached": "50자의 한도에 도달했습니다. ",
        "ai.upgrade.now": "지금 업그레이드",
        "ai.fix.transcript.misspells": "전사에서 잘못된 철자 수정",
        "ai.enter.misspelled.words": "AI가 이 팟캐스트 에피소드에서 자주 잘못 철자하는 단어를 적어주세요. 예: 이름",
        "ai.enter.word.press.enter": "단어를 입력하고 Enter를 누르세요",
        "ai.add.word": "단어 추가",
        "ai.tag.limit.reached": "1개의 태그 한도에 도달했습니다. ",
        "ai.save": "저장",
        "ai.save.close": "저장 및 닫기"
      },
      "selectedepisode": {
        "selectedEpisode.title": "에피소드 제목",
        "selectedEpisode.podcastName": "팟캐스트 이름",
        "selectedEpisode.showNotes": "쇼 노트",
        "selectedEpisode.timestamp": "타임스탬프",
        "selectedEpisode.staticTimestamp": "정적 타임스탬프",
        "selectedEpisode.mentions": "언급",
        "selectedEpisode.newsletter": "뉴스레터",
        "selectedEpisode.titles": "제목",
        "selectedEpisode.tweeter": "트위터 사용자",
        "selectedEpisode.shortPost": "짧은 게시물",
        "selectedEpisode.transcription": "전사",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "키워드",
        "selectedEpisode.quotes": "인용",
        "selectedEpisode.longPost": "긴 게시물",
        "selectedEpisode.bulletPoints": "글머리 기호",
        "selectedEpisode.publicLink": "공식 링크",
        "selectedEpisode.embeddedId": "임베디드 ID",
        "selectedEpisode.episodeUrl": "에피소드 URL"
      },
      "sidebar": {
        "tools": "도구",
        "find.podcast.topic.ideas": "팟캐스트 주제 아이디어 찾기",
        "podcast.thumbnail.maker": "팟캐스트 썸네일 메이커",
        "podcast.seo.optimizer": "팟캐스트 SEO 최적화 도구",
        "account": "계정",
        "payment.settings": "결제 설정",
        "support": "지원",
        "logout": "로그아웃",
        "plan": "플랜",
        "resets.in": "재설정까지",
        "api.access": "API 액세스",
        "days": "일 과",
        "hours": "시간",
        "upgrade.plan": "플랜 업그레이드"
      },
      "updateEmailModal": {
        "email.validation.error": "유효한 이메일 주소를 입력해 주세요.",
        "email.change.confirm": "이메일 주소를 변경하시겠습니까?",
        "email.change.success": "이메일이 성공적으로 변경되었습니다!",
        "email.in.use.error": "이 이메일은 이미 사용 중입니다. 다른 이메일을 시도해 주세요.",
        "email.recent.login.error": "이 작업을 계속하기 전에 현재 이메일 주소로 다시 로그인해 주세요.",
        "email.invalid.error": "유효하지 않은 이메일 주소입니다. 다른 이메일을 시도해 주세요.",
        "subscription.cancel.error": "먼저 활성화된 유료 구독을 취소해 주세요.",
        "account.delete.confirm": "계정을 삭제하시겠습니까?\n\n이 작업은 취소할 수 없습니다.",
        "account.delete.success": "계정이 성공적으로 삭제되었습니다.",
        "account.delete.error": "문제가 발생하여 계정을 삭제할 수 없습니다.\n\n사용자 지원팀에 문의해 주세요.",
        "subscription.cancel": "구독 취소",
        "account.delete": "계정 삭제",
        "account.delete.warning": "계정을 삭제하면 복구할 수 없으며 모든 콘텐츠와 로그인 정보가 영구적으로 삭제됩니다. 이 작업은 취소할 수 없으므로 주의하여 진행해 주세요.",
        "current.account.email": "현재 계정 이메일",
        "enter.new.email": "새 계정 이메일을 입력해 주세요",
        "update": "업데이트",
        "change.password": "비밀번호 변경",
        "payment.settings": "결제 설정"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "에피소드 제목"
      },
      "episodelist": {
        "loading.episodes": "에피소드 로딩 중",
        "no.episodes.found": "에피소드가 없습니다. 유효한 RSS ID로 다시 시도해 주세요.",
        "select.episode": "콘텐츠를 생성할 에피소드를 선택하세요."
      },
      "interfaces": {
        "user.activePlan.tier": "티어",
        "user.activePlan.creationDate": "생성 날짜",
        "user.activePlan.minutesAvailable": "사용 가능한 분"
      },
      "loadingbar": {
        "loadingbar.magic": "우리는 여전히 마법을 부리고 있습니다 ✨",
        "loadingbar.longer": "일부 에피소드는 조금 더 시간이 걸립니다... 🐌",
        "loadingbar.hardwork": "우리 서버가 열심히 작업하고 있습니다 🦾"
      },
      "page": {
        "main.background": "주요 구성 요소의 배경"
      },
      "recordfile": {
        "microphone.camera.access.denied": "오류: 마이크 또는 카메라에 대한 접근이 거부되었습니다.",
        "microphone.camera.not.found": "오류: 마이크 또는 카메라를 찾을 수 없습니다.",
        "microphone.camera.not.readable": "오류: 마이크 또는 카메라를 읽을 수 없습니다.",
        "microphone.camera.access.error": "오류: 마이크 또는 카메라에 접근하는 동안 알 수 없는 오류가 발생했습니다.",
        "media.not.recorded": "오류: 기록된 미디어가 없습니다.",
        "upload.failed": "오류: 업로드에 실패했습니다.",
        "upload.success": "성공: 업로드가 성공적으로 완료되었습니다.",
        "upload.in.progress": "업로드 진행 중...",
        "upload.button": "녹음 업로드",
        "stop.recording": "녹음 중지",
        "record.audio": "오디오 녹음",
        "record.audio.video": "비디오와 함께 오디오 녹음",
        "record.again": "녹음 다시 시작",
        "episode.language": "에피소드 언어 선택"
      },
      "selectBox": {
        "language.english": "영어",
        "language.arabic": "아랍어",
        "language.bulgarian": "불가리아어",
        "language.catalan": "카탈루냐어",
        "language.croatian": "크로아티아어",
        "language.czech": "체코어",
        "language.danish": "덴마크어",
        "language.dutch": "네덜란드어",
        "language.finnish": "핀란드어",
        "language.french": "프랑스어",
        "language.german": "독일어",
        "language.greek": "그리스어",
        "language.hindi": "힌디어",
        "language.hungarian": "헝가리어",
        "language.indonesian": "인도네시아어",
        "language.italian": "이탈리아어",
        "language.japanese": "일본어",
        "language.korean": "한국어",
        "language.lithuanian": "리투아니아어",
        "language.latvian": "라트비아어",
        "language.malay": "말레이어",
        "language.mandarin": "표준 중국어",
        "language.norwegian": "노르웨이어",
        "language.polish": "폴란드어",
        "language.portuguese": "포르투갈어",
        "language.romanian": "루마니아어",
        "language.russian": "러시아어",
        "language.slovak": "슬로바키아어",
        "language.slovenian": "슬로베니아어",
        "language.spanish": "스페인어",
        "language.swedish": "스웨덴어",
        "language.tamil": "타밀어",
        "language.turkish": "터키어",
        "language.ukrainian": "우크라이나어",
        "language.bashkir": "바시키르어",
        "language.basque": "바스크어",
        "language.belarusian": "벨라루스어",
        "language.cantonese": "광둥어",
        "language.esperanto": "에스페란토",
        "language.estonian": "에스토니아어",
        "language.galician": "갈리시아어",
        "language.interlingua": "인터링구아",
        "language.marathi": "마라티어",
        "language.mongolian": "몽골어",
        "language.persian": "페르시아어",
        "language.thai": "태국어",
        "language.uyghur": "위구르어",
        "language.vietnamese": "베트남어",
        "language.welsh": "웨일스어"
      },
      "selectedepisode": {
        "processing.episode": "에피소드 처리 중",
        "processing.time": "보통 5 - 10분 정도 소요됩니다.",
        "email.notification": "이 창을 닫아도 됩니다. 준비가 완료되면 이메일을 보내드리겠습니다. 귀하의 콘텐츠는 대시보드에서도 확인할 수 있습니다.",
        "convert.another.episode": "다른 에피소드 변환",
        "technical.difficulties": "앗! 기술적인 문제가 발생했습니다. 저희 팀이 문제를 해결하고 있으니 안심하세요! 나중에 다시 시도해 주세요.",
        "no.discount": "걱정하지 마세요, 어떤 시간도 할인하지 않을 것입니다!",
        "high.demand": "평소보다 높은 수요가 발생하고 있어 요청 처리에 시간이 더 걸릴 수 있습니다. 불편을 드려 죄송합니다!",
        "email.ready": "준비가 완료되면 이메일을 보내드리겠습니다. 대시보드에서 결과를 확인할 수도 있습니다.",
        "select.podcast.folder": "이 에피소드가 속한 팟캐스트 폴더를 선택하거나 이름을 입력하여 새 폴더를 생성하세요.",
        "give.voice": "폴더의 음성 조정",
        "generate.content": "콘텐츠 생성",
        "not.enough.minutes.title": "충분한 시간이 없습니다",
        "not.enough.minutes.message": "이 에피소드를 변환하기에 충분한 시간이 없습니다. 계획을 업데이트하세요.",
        "upgrade.plan": "계획 업데이트",
        "convert.shorter.episode": "짧은 에피소드 변환",
        "content.ready": "귀하의 콘텐츠가 준비되었습니다!",
        "ask.ai.tune": "AI에게 각 콘텐츠를 귀하의 필요에 맞게 조정해 달라고 요청할 수 있습니다.",
        "error.title": "오류",
        "convert.another.file": "다른 파일 변환"
      },
      "submitfile": {
        "file.size.exceeded.free": "파일 크기가 최대 4GB의 한도를 초과했습니다. <p>더 큰 파일을 업로드하려면 <a href='/pricing'><b><u>업그레이드하세요</u></b></a></p>",
        "file.size.exceeded.paid": "파일 크기가 최대 10GB의 한도를 초과했습니다. <p>더 작은 파일을 선택하세요.</p>",
        "file.upload.invalid": "오디오 또는 비디오 파일을 업로드하세요.",
        "upload.in.progress": "파일을 업로드 중입니다. 이 창을 닫지 마세요.",
        "upload.button": "업로드 & 생성",
        "close.button": "닫기",
        "upgrade.message.free": "더 많은 업로드는 유료 요금제에서만 가능합니다.",
        "upgrade.now.button": "지금 업그레이드",
        "pricing.info": "월 $12부터 시작",
        "upload.file.label": "오디오 또는 비디오 파일 업로드",
        "max.file.size.free": "(최대 4GB)",
        "max.file.size.paid": "(최대 10GB)",
        "podsqueeze.audiograms.info": "Podsqueeze는 오디오 파일에 대한 오디오그램과 비디오 파일에 대한 짧은 클립을 생성합니다.",
        "file.placeholder": "당신의 MP3/WAV 파일",
        "episode.language.label": "에피소드 언어",
        "select.folder.label": "선택 또는 만들기",
        "multiple.files.selected": "{{count}}개 파일 선택됨",
        "clear.all": "모두 지우기",
        "file.name": "{{name}}",
        "multiple.files.toggle": "여러 파일 선택",
        "file.upload.error": "파일 업로드 오류",
        "file.upload.success": "파일 업로드 성공",
        "file.upload.processing": "파일 처리 중",
        "click.to.upload": "클릭하여 업로드",
        "click.to.upload.multiple": "클릭하여 여러 파일 업로드",
        "enter.url": "URL 입력",
        "upload.file": "파일 업로드",
        "media.url.label": "미디어 URL",
        "media.url.help": "오디오 또는 비디오 파일의 URL을 입력하세요. 다운로드하고 처리해 드립니다.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "에피소드 이름",
        "url.input.required": "미디어 URL을 입력하세요",
        "url.upload.error": "URL에서 미디어 업로드에 실패했습니다. URL을 확인하고 다시 시도하세요.",
        "supported.formats": "지원되는 형식",
        "uploading": "업로드 중...",
        "media.url.requirements": "URL은 공개 미디어 파일에 대한 직접 링크여야 합니다(웹 페이지가 아님)"
      },
      "submitrssid": {
        "error.selectRss": "드롭다운에서 유효한 RSS를 선택해 주세요",
        "label.insertRssFeed": "RSS 피드를 입력하세요",
        "placeholder.insertRssFeed": "RSS 피드를 입력하세요",
        "label.searchByPodcast": "대신 팟캐스트 이름으로 검색",
        "label.searchForPodcast": "팟캐스트 이름을 검색하세요",
        "placeholder.searchForPodcast": "팟캐스트 검색",
        "label.cantFindPodcast": "팟캐스트를 찾을 수 없나요? ",
        "label.clickHereUseRss": "여기를 클릭하여 대신 RSS 피드를 사용하세요",
        "label.selectedPodcast": "선택된 팟캐스트",
        "label.episodeLanguage": "에피소드 언어",
        "button.seeAllEpisodes": "모든 에피소드 보기",
        "select.folder.label": "선택 또는 만들기"
      },
      "submitsection": {
        "search.podcast": "당신의 팟캐스트 검색",
        "upload.audio.video": "오디오 또는 비디오 업로드",
        "record.audio": "오디오 녹음",
        "youtube.video": "YouTube 비디오",
        "create.content": "당신의 팟캐스트를 위한 콘텐츠를 만들어 봅시다!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "YouTube 비디오 URL을 입력하세요",
        "error.insertYouTubeUrl": "YouTube URL을 입력해 주세요.",
        "label.insertYouTubeUrl": "YouTube URL 입력",
        "button.loading": "로딩 중...",
        "message.downloadingFile": "파일 다운로드 중...",
        "error.processingFailed": "오류: 비디오 처리 실패.",
        "button.submitYouTubeVideo": "YouTube 비디오 제출",
        "error.youtubeVideoNotAvailable": "이 YouTube 비디오는 다운로드할 수 없습니다. 먼저 YouTube 다운로드를 사용하거나 Podsqueeze에 직접 오디오 또는 비디오를 업로드하세요. 감사합니다.",
        "episode.language.label": "사용 언어",
        "select.folder.label": "선택 또는 만들기"
      },
      "tabs": {
        "tab.label.tab1": "탭 1",
        "tab.label.tab2": "탭 2",
        "tab.label.tab3": "탭 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Podsqueeze를 최대한 활용하기",
        "tutorial.chapter.introduction": "소개",
        "tutorial.chapter.bestShowNotes": "최고의 쇼 노트 및 타임스탬프 얻기",
        "tutorial.chapter.blogPosts": "블로그 게시물 및 뉴스레터 활용하기",
        "tutorial.chapter.editingTranscripts": "전사 내용 삽입 및 편집하기",
        "tutorial.chapter.personalizingAI": "AI 개인화 및 나만의 목소리 주기",
        "tutorial.chapter.speedingUpNotes": "쇼 노트 속도 높이기",
        "tutorial.chapter.creatingClips": "비디오 클립 및 이미지 만들기",
        "tutorial.chapter.generatingLandingPage": "랜딩 페이지 생성하기",
        "tutorial.chapter.shareResults": "팀과 결과 공유하기",
        "tutorial.closeVideoCheckbox": "첫 번째 결과가 준비되면 비디오 닫기"
      },
      "uploadloadingbar": {
        "upload.loading": "로딩 중..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "문의하기",
        "contact.section.email": "support@podsqueeze.com으로 이메일 보내기",
        "contact.section.tiago.role": "공동 창립자",
        "contact.section.joao.role": "공동 창립자",
        "contact.section.image.alt.sendMessage": "메시지 보내기",
        "contact.section.image.alt.tiago": "Podsqueeze 공동 창립자 티아고",
        "contact.section.image.alt.joao": "Podsqueeze 공동 창립자 조안"
      },
      "contactsection": {
        "contact.section.title": "문의하기",
        "contact.section.email": "support@podsqueeze.com으로 이메일 보내기",
        "contact.section.tiago.role": "공동 창립자",
        "contact.section.joao.role": "공동 창립자",
        "contact.section.image.alt.sendMessage": "메시지 보내기",
        "contact.section.image.alt.tiago": "Podsqueeze 공동 창립자 티아고",
        "contact.section.image.alt.joao": "Podsqueeze 공동 창립자 조안"
      },
      "home-agenciessection": {
        "join.content.creators": "Podsqueeze를 사용하는 20,000명의 콘텐츠 제작자 및 팟캐스트 전문가와 함께하세요",
        "content.creators": "콘텐츠 제작자",
        "podcast.managers": "팟캐스트 관리자",
        "producers.studios": "제작자 및 스튜디오",
        "for.podcasters": "팟캐스터, 팟캐스트 관리자 및 에이전시를 위한",
        "manage.content.creation": "다음의 콘텐츠 제작을 손쉽게 관리하세요",
        "multiple.podcasts": "여러 팟캐스트",
        "podsqueeze.description": "Podsqueeze는 모든 팟캐스트 전문가를 위한 강력한 도구입니다. 솔로 팟캐스터, 팟캐스트 관리자 또는 에이전시 여부에 관계없이, Podsqueeze는 팟캐스트 콘텐츠 제작 워크플로를 간소화하는 데 필요한 모든 기능을 제공합니다.",
        "create.podcast.folders": "에피소드를 정리하기 위해 팟캐스트 폴더를 만드세요.",
        "share.content.page": "클라이언트 및 팀과 콘텐츠 페이지를 쉽게 공유하세요",
        "tune.ai.voice": "관리하는 각 쇼에 맞게 AI 음성을 조정하세요",
        "plan.content.episodes": "우리의 고급 기능으로 다음 에피소드의 콘텐츠를 계획하세요",
        "podcast.topics.finder": "팟캐스트 주제 찾기",
        "podsqueeze.testimonial": "Podsqueeze는 우리가 관리하는 각 팟캐스트의 콘텐츠를 조정하기 위해 프롬프트를 사용할 수 있는 기능을 제공하며, 이를 미래의 에피소드를 위해 저장할 수 있게 해줍니다. 이는 우리가 다른 도구에서 찾을 수 없는 엘리트 기능입니다.",
        "coo.podigy": "Podigy Podcasts의 COO",
        "agenciessection.joinCreators": "Podsqueeze를 사용하는 20,000명의 콘텐츠 제작자 및 팟캐스트 전문가와 함께하세요",
        "agenciessection.contentCreators": "콘텐츠 제작자",
        "agenciessection.podcastManagers": "팟캐스트 관리자",
        "agenciessection.producersStudios": "제작자 및 스튜디오",
        "agenciessection.forPodcasters": "팟캐스터, 팟캐스트 관리자 및 에이전시를 위한",
        "agenciessection.manageContent": "다음의 콘텐츠 제작을 손쉽게 관리하세요",
        "agenciessection.multiplePodcasts": "여러 팟캐스트",
        "agenciessection.podsqueezeDescription": "Podsqueeze는 모든 팟캐스트 전문가를 위한 강력한 도구입니다. 솔로 팟캐스터, 팟캐스트 관리자 또는 에이전시 여부에 관계없이, Podsqueeze는 팟캐스트 콘텐츠 제작 워크플로를 간소화하는 데 필요한 모든 기능을 제공합니다.",
        "agenciessection.createPodcastFolders": "에피소드를 정리하기 위해 팟캐스트 폴더를 만드세요.",
        "agenciessection.shareContent": "클라이언트 및 팀과 콘텐츠 페이지를 쉽게 공유하세요",
        "agenciessection.tuneAI": "관리하는 각 쇼에 맞게 AI 음성을 조정하세요",
        "agenciessection.planContent": "우리의 고급 기능으로 다음 에피소드의 콘텐츠를 계획하세요",
        "agenciessection.podcastTopicsFinder": "팟캐스트 주제 찾기",
        "agenciessection.podsqueezeQuote": "Podsqueeze는 우리가 관리하는 각 팟캐스트의 콘텐츠를 조정하기 위해 프롬프트를 사용할 수 있는 기능을 제공하며, 이를 미래의 에피소드를 위해 저장할 수 있게 해줍니다. 이는 우리가 다른 도구에서 찾을 수 없는 엘리트 기능입니다.",
        "agenciessection.coO": "Podigy Podcasts의 COO"
      },
      "home-audioeditsection": {
        "new.feature": "새로운 기능",
        "seamless.editing": "자연스러운 원활한 편집 및 오디오 향상, ",
        "high.quality.results": " 고품질 결과",
        "experience.seamless.audio.editing": "최고급 녹음을 위한 고급 AI 알고리즘으로 원활한 오디오 편집을 경험하세요. ",
        "remove.ums": "음을 제거하기",
        "enhance.sound.quality": ", 침묵을 제거하고 단 한 번의 클릭으로 음질을 향상시킵니다.",
        "enhance.audio.now": "지금 오디오 향상하기",
        "sample.audio.recorded": "전화에서 직접 녹음한 샘플 오디오.",
        "original.recording": "원본 녹음",
        "audio.after.ai.edit": "AI 편집 및 향상 후 오디오",
        "experience.audio.editing": "최고급 녹음을 위한 고급 AI 알고리즘으로 원활한 오디오 편집을 경험하세요. "
      },
      "home-blogsection": {
        "more.resources.label": "당신의 팟캐스트를 위한 추가 리소스",
        "learn.how.to.get.most": "최대한 활용하는 방법 배우기",
        "your.content": "당신의 콘텐츠",
        "get.most.out.of.ai.content": "당신의 팟캐스트를 위한 AI 생성 콘텐츠 최대한 활용하기",
        "welcome.to.podsqueeze": "Podsqueeze에 오신 것을 환영합니다 – 당신의 팟캐스트를 전사하고 매력적인 콘텐츠를 만드는 가장 간단한 방법...",
        "will.google.penalize.ai.content": "구글이 당신의 AI 생성 콘텐츠에 대해 패널티를 부과할까요?",
        "ai.content.discussion": "AI 생성 콘텐츠의 출현은 콘텐츠 제작자, 마케터 및 SEO 사이에서 논의와 우려를 불러일으켰습니다...",
        "what.is.rss.feed": "팟캐스트를 위한 RSS 피드란 무엇이며 어떻게 사용하는가",
        "rss.feed.benefits": "팟캐스터로서 'RSS 피드'라는 용어를 들어본 적이 있을지 모르지만, 그것이 정확히 무엇인지 또는 어떻게 도움이 되는지 잘 모를 수 있습니다...",
        "visit.blog": "블로그 방문하기"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "클립 및 오디오그램",
        "clipsAndAudiograms.subtitle": "당신의 팟캐스트를 손쉽게 클립으로 재활용하세요",
        "clipsAndAudiograms.description": "에피소드에서 챕터를 선택하고 TikTok, Instagram 및 YouTube Shorts용으로 클립 또는 오디오그램으로 내보내기만 하면 됩니다. 템플릿을 선택하고 자신의 스타일에 맞게 조정하세요.",
        "clipsAndAudiograms.createClips": "지금 클립 만들기",
        "textEditor.title": "텍스트 기반 편집기",
        "textEditor.description": "자막에서 직접 클립과 오디오그램을 세밀하게 조정하세요. 자막을 편집하고 특정 단어를 제거하여 비디오를 자르세요.",
        "oneClickShorts.title": "원클릭 쇼츠 (<60초)",
        "oneClickShorts.description": "AI가 편집을 처리하도록 하세요. 버튼을 누르기만 하면 AI가 에피소드의 각 챕터를 60초 이하로 단축하여 YouTube Shorts 또는 TikTok 클립으로 게시할 준비를 합니다."
      },
      "home-conatctsection": {
        "contact.section.title": "창립자에게 연락하기",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- 개발자 및 팟캐스터",
        "contact.section.joao.role": "- UX/UI 디자이너"
      },
      "home-contentexplanation": {
        "wide.variety.content": "다양한 콘텐츠",
        "generate.content": "다음으로 콘텐츠 생성하기",
        "one.click": " 한 번의 클릭으로!",
        "transcript.srt": "전사 및 SRT",
        "transcript.description": "팟캐스트 에피소드의 전체 전사와 자막 생성을 위한 SRT 파일을 받으세요.",
        "show.notes": "쇼 노트",
        "show.notes.description": "에피소드에서 다룬 주요 주제를 요약하고 검색 가능성을 높이세요.",
        "timestamps": "타임스탬프",
        "timestamps.description": "타임스탬프가 있는 챕터를 생성하고 청취자를 팟캐스트 에피소드의 특정 세그먼트로 안내하세요.",
        "blog.social.posts": "블로그 및 소셜 포스트",
        "blog.social.posts.description": "팟캐스트 에피소드에 대해 어디서나 게시하고 새로운 청취자를 확보하세요.",
        "newsletter": "뉴스레터",
        "newsletter.description": "새로운 에피소드로 청취자에게 최신 정보를 제공합니다.",
        "titles.more": "제목 및 기타!",
        "titles.more.description": "눈길을 끄는 제목, 인용구, 핵심 요점, 키워드 등을 생성하세요!",
        "see.sample.content": "샘플 콘텐츠 보기",
        "wannabe.entrepreneur": "예비 기업가 - #299 Podsqueeze가 연간 수익 100,000달러를 돌파했습니다!",
        "making.space": "공간 만들기 - 스티브 하비: “계속 가는 것이 좋습니다”",
        "modern.wisdom": "현대의 지혜 - 에릭 호엘 - 마음의 근본적인 신비에 대한 안내"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "구분선"
      },
      "home-explanationsection": {
        "fast.accurate": "빠르고 정확한",
        "generate.content": "당신의 팟캐스트를 위한 콘텐츠를 생성하세요",
        "power.of.ai": "AI의 힘으로",
        "upload.image.alt": "이미지 업로드",
        "select.episode": "RSS 피드에서 에피소드를 선택하거나 오디오/비디오 파일을 업로드하세요",
        "paste.rss.feed": "RSS 피드 URL을 붙여넣어 목록에서 에피소드를 선택하거나 오디오 또는 비디오 파일을 업로드하세요.",
        "content.image.alt": "콘텐츠 이미지",
        "one.click.content": "한 번의 클릭으로 모든 콘텐츠를 얻으세요!",
        "user.friendly.interface": "즉시 사용할 수 있는 직관적이고 사용자 친화적인 인터페이스. 한 번의 클릭으로 팟캐스트 콘텐츠를 생성하세요.",
        "tune.image.alt": "튜닝 이미지",
        "edit.fine.tune": "각 콘텐츠를 편집하고 세밀하게 조정하세요",
        "direct.edit.content": "AI를 사용하여 각 콘텐츠를 원하는 대로 직접 편집하고 세밀하게 조정하세요. 예를 들어, 특정 톤, 직접 또는 간접 화법을 요청하거나 잘못된 이름을 수정할 수 있습니다.",
        "multiple.language.support": "다국어 지원",
        "language.flags.alt": "언어 플래그",
        "generate.content.aria": "콘텐츠 생성"
      },
      "home-featuressection": {
        "loading": "로딩 중...",
        "transcribe.write.show.notes": "당신의 팟캐스트를 위한 전사 및 쇼 노트 작성",
        "twenty.times.faster": "20배 더 빠름",
        "save.manual.work": "수작업을 최대 100%까지 절약하세요. 최첨단 정확도와 화자 라벨링으로 팟캐스트를 자동으로 전사하고, 완전한 쇼 노트와 소셜 미디어 게시물을 당신의 목소리로 생성합니다.",
        "generate.content": "콘텐츠 생성",
        "transcripts": "전사본",
        "full.transcript": "당신의 팟캐스트 에피소드와 유튜브 비디오 전사본의 전체 전사본을 가져오고, 자막을 위한 SRT 파일도 함께 제공합니다.",
        "show.notes": "쇼 노트",
        "summarize.generate.show.notes": "타임스탬프, 글머리 기호 및 언급이 포함된 당신의 목소리로 쇼 노트를 요약하고 생성합니다.",
        "blog.newsletter": "블로그 및 뉴스레터",
        "actionable.blog.posts": "당신의 에피소드에 대한 실행 가능한 블로그 게시물과 주요 내용을 담은 발송 준비 완료 뉴스레터를 받으세요.",
        "social.media": "소셜 미디어",
        "short.posts.insights": "소셜 미디어에서 소식을 전파할 수 있는 짧은 게시물과 간단한 인사이트를 받으세요.",
        "quote": "우리가 테스트한 최고의 AI 전사 도구 중에서, Podsqueeze는 쇼 노트, 타임스탬프, 제목, 언급, 샘플 블로그 게시물 및 주요 인용에 가장 유용한 결과를 생성했습니다.",
        "justin.jackson": "저스틴 잭슨",
        "cofounder.transistor": "Transistor.fm의 공동 창립자",
        "transcribe_and_write_show_notes": "팟캐스트 전사, 요약 및 소셜 게시물",
        "twenty_times_faster": "20배 더 빠름",
        "save_manual_work": "수작업을 최대 100%까지 절약하세요. 최첨단 정확도와 화자 라벨링으로 팟캐스트를 자동으로 전사하고, 완전한 쇼 노트와 소셜 미디어 게시물을 당신의 목소리로 생성합니다.",
        "generate_content": "콘텐츠 생성",
        "full_transcript": "당신의 팟캐스트 에피소드와 유튜브 비디오 전사본의 전체 전사본을 가져오고, 자막을 위한 SRT 파일도 함께 제공합니다.",
        "show_notes": "쇼 노트",
        "summarize_and_generate_show_notes": "타임스탬프, 글머리 기호 및 언급이 포함된 당신의 목소리로 쇼 노트를 요약하고 생성합니다.",
        "blog_and_newsletter": "블로그 및 뉴스레터",
        "actionable_blog_posts": "당신의 에피소드에 대한 실행 가능한 블로그 게시물과 주요 내용을 담은 발송 준비 완료 뉴스레터를 받으세요.",
        "social_media": "소셜 미디어",
        "short_posts_and_insights": "소셜 미디어에서 소식을 전파할 수 있는 짧은 게시물과 간단한 인사이트를 받으세요.",
        "testimonial": "우리가 테스트한 최고의 AI 전사 도구 중에서, Podsqueeze는 쇼 노트, 타임스탬프, 제목, 언급, 샘플 블로그 게시물 및 주요 인용에 가장 유용한 결과를 생성했습니다.",
        "cofounder_transistor": "Transistor.fm의 공동 창립자"
      },
      "home-page": {
        "main.background": "주요 구성 요소의 배경 색상"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "우리의 팟캐스트를 들어보세요",
        "podcast.section.subtitle": "마스터 클래스",
        "podcast.section.highlight": "경험이 풍부한 팟캐스터들",
        "podcast.section.description": "전 세계의 경험이 풍부한 팟캐스터와 Podsqueeze 사용자들을 인터뷰하는 우리의 팟캐스트를 들어보세요. 그들에게 팟캐스트를 성장시키기 위해 알아야 할 팁, 통찰력, 이야기 등을 공유해 달라고 요청합니다.",
        "podcast.link.spotify": "Spotify에서 듣기",
        "podcast.link.apple": "Apple Podcasts에서 듣기",
        "podcast.link.youtube": "YouTube에서 듣기"
      },
      "home-spinner": {
        "spinner.loading": "로딩 중..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "당신의 팟캐스트 자동화하기",
        "tagline.productionPromotion": "제작 및 홍보",
        "tagline.launchGrow": "AI의 도움으로 모든 것을 한 곳에서 쉽게 오디오 또는 비디오 팟캐스트를 시작하고 성장시키세요.",
        "tagline.uploadGenerate": "팟캐스트 전사, 요약, 캡션 있는 짧은 클립 등을 쉽게 생성할 수 있습니다!",
        "tagline.singleClick": " 모두 한 번의 클릭으로.",
        "tagline.transcripts": "팟캐스트 전사",
        "tagline.showNotes": "쇼 노트",
        "tagline.newslettersBlogs": "뉴스레터 및 블로그",
        "tagline.socialPosts": "소셜 포스트",
        "tagline.shortClipsAudiograms": "짧은 클립 및 오디오그램",
        "tagline.podcastWebsite": "팟캐스트 웹사이트",
        "tagline.aiAudioEnhancement": "AI 오디오 향상",
        "tagline.removeSilences": "침묵과 어음을 제거하세요",
        "tagline.generateNow": "지금 무료로 생성하기",
        "tagline.noCreditCard": "신용카드 필요 없음",
        "testimonial.robWalling.title": "롭 월링, 스타트업 전문가",
        "testimonial.robWalling.subtitle": "우리의 스타트업 팟캐스트",
        "testimonial.robWalling.quote": "Podsqueeze의 쇼 노트는 최고입니다. 우리는 요약 및 다른 팟캐스트에서 통찰력을 얻기 위해 많이 사용합니다.",
        "testimonial.johnGarmet.title": "존 가르멧, 운영 이사",
        "testimonial.johnGarmet.subtitle": "허드 미디어",
        "testimonial.johnGarmet.quote": "Podsqueeze는 우리를 더 효율적으로 만들고 고객을 위한 더 많은 콘텐츠를 생성하는 데 도움을 줍니다. 우리는 강력히 추천합니다.",
        "testimonial.davidJackson.title": "데이비드 잭슨, 팟캐스트 코치",
        "testimonial.davidJackson.subtitle": "팟캐스팅 학교",
        "testimonial.davidJackson.quote": "Podsqueeze는 나의 브레인스토밍 파트너입니다. 팟캐스트 마케팅을 구상하는 최고의 방법입니다."
      },
      "home-testimonials": {
        "testimonials.title": "사람들이 Podsqueeze에 대해 뭐라고 말하고 있나요",
        "testimonials.image.alt": "Podsqueeze - AI를 사용하여 팟캐스트 콘텐츠 재활용 | Product Hunt",
        "testimonials.heading": "사람들이 Podsqueeze에 대해 뭐라고 말하고 있나요"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "잘못된 비밀번호",
        "error.userNotFound": "사용자를 찾을 수 없습니다",
        "error.somethingWentWrong": "이런, 문제가 발생했습니다",
        "button.sendResetEmail": "비밀번호 재설정 이메일 보내기",
        "button.login": "로그인",
        "placeholder.email": "이메일 주소",
        "placeholder.password": "비밀번호",
        "link.forgotPassword": "비밀번호를 잊으셨나요?",
        "link.createAccount": "계정 만들기",
        "text.or": "또는",
        "button.continueWithGoogle": "Google로 계속하기",
        "text.podcastDescription": "모든 것을 한 곳에서 제공하여 오디오 또는 비디오 팟캐스트를 손쉽게 시작하고 성장시키세요.",
        "feature.transcripts": "전사",
        "feature.showNotes": "쇼 노트",
        "feature.newslettersAndBlogs": "뉴스레터 및 블로그",
        "feature.socialPosts": "소셜 게시물",
        "feature.shortClipsAndAudiograms": "짧은 클립 및 오디오그램",
        "feature.podcastWebsite": "팟캐스트 웹사이트",
        "feature.aiAudioEnhancement": "AI 오디오 향상",
        "feature.removeSilences": "침묵 및 음을 제거합니다",
        "button.sendVerificationEmail": "인증 이메일 보내기",
        "error.emailNotVerified": "이메일이 확인되지 않았습니다",
        "error.emailAlreadyVerified": "이메일이 이미 확인되었습니다",
        "success.emailVerified": "이메일이 확인되었습니다",
        "text.pleaseVerifyAccount": "계정을 확인해주세요",
        "text.checkSpamFolder": "인증 이메일을 보냈습니다. 이메일을 확인해주세요.",
        "button.resendVerificationEmail": "인증 이메일 재보내기",
        "error.verificationEmailFailed": "인증 이메일 보내기에 실패했습니다. 다시 시도해주세요."
      },
      "page": {
        "login.form": "로그인 양식"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze 제휴사 페이지",
        "affiliate.page.description": "귀하의 독점 추천 링크를 통해 이루어진 모든 판매에 대해 15개월 동안 25%의 커미션을 받으세요. 웹사이트, 소셜 미디어 또는 친구와 링크를 공유하세요. 가입은 몇 초밖에 걸리지 않습니다. 자동으로 승인됩니다."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "팟캐스터를 위한 최고의 선물",
        "bestGiftForPodcaster.description": "팟캐스터의 경험을 향상시키기 위한 최고의 선물을 찾아보세요.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "더 많은 팟캐스트 청취자 확보하기",
        "get-more-podcast-listeners.description": "자동 쇼 노트, 소셜 미디어에서 쇼를 성장시키기 위한 짧은 클립 등으로 제작을 간소화하고 더 많은 팟캐스트 청취자를 확보하세요."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "팟캐스트 청중 늘리기",
        "grow_your_podcast_audience.description": "Podsqueeze를 사용하여 많은 시간을 절약하고 팟캐스트 청중을 늘리세요. 팟캐스트를 위한 완전한 쇼 노트, 소셜 미디어 게시물, 짧은 클립 등을 생성합니다."
      },
      "index": {
        "home.page.title": "AI 팟캐스트 쇼 노트, 전사, 요약 및 클립 생성기.",
        "home.page.description": "한 번의 클릭으로 팟캐스트를 위한 쇼 노트, 타임스탬프, 뉴스레터 등을 생성하세요! 팟캐스트 콘텐츠를 빠르게 생성하고 필요에 맞게 조정하세요. 무료 가입."
      },
      "login": {
        "login.tryItNow": "지금 시도해보세요!",
        "login.createAccountDescription": "계정을 생성하고 한 번의 클릭으로 팟캐스트를 위한 쇼노트, 타임스탬프, 뉴스레터 등을 생성하세요! 팟캐스트를 위한 콘텐츠를 빠르게 생성하고 필요에 맞게 조정하세요. 무료 가입."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "팟캐스트 마케팅",
        "marketing.for.podcasts.description": "Podsqueeze는 자동 생성된 쇼 노트, 소셜 미디어 게시물 및 짧은 클립으로 팟캐스트 마케팅을 간소화하여 도달 범위를 확대하고 쇼를 성장시킵니다."
      },
      "media": {
        "media.page.title": "팟스퀴즈 미디어 페이지",
        "media.page.description": "팟스퀴즈에 대해 더 알아보세요. 연락해 주세요! 함께 협업하고 싶습니다!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "팟캐스트 설명 생성기",
        "podcast.description.generator.description": "AI로 생성된 설명으로 팟캐스트의 도달 범위와 참여도를 향상시키세요. 쇼 노트 작성을 자동화하고 소중한 시간을 되찾으세요."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "팟캐스트를 소셜 미디어 게시물로 재활용하기",
        "convert.podcast.episodes.to.social.media.posts": "팟캐스트 에피소드를 소셜 미디어 게시물로 변환합니다. LinkedIn, Twitter, Facebook용 게시물을 자동으로 생성하고 TikTok용 짧은 클립을 만듭니다."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "무료 팟캐스트 주제 생성기",
        "podcast.topics.generator.description": "우리의 무료 팟캐스트 주제 생성기를 사용하면 최고의 주제 아이디어를 찾고 Google과 YouTube에서의 잠재적 도달 범위를 예측할 수 있습니다."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "당신의 팟캐스트 가상 비서",
        "podcast.virtual.assistant.description": "쇼 노트를 작성하고 소셜 미디어 게시물을 생성하는 AI 팟캐스트 가상 비서. Podsqueeze와 함께 팟캐스트 제작 및 마케팅을 간소화하세요."
      },
      "pricing": {
        "pricing.title": "가격",
        "pricing.description": "한 번의 클릭으로 팟캐스트를 위한 쇼노트, 타임스탬프, 뉴스레터 등을 생성하세요! 팟캐스트 요구에 맞는 여러 가격 등급이 있습니다."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "팟캐스트 홍보하기",
        "promote.your.podcast.description": "쇼 노트, 소셜 미디어 게시물 및 짧은 클립을 생성하여 몇 분 만에 팟캐스트를 게시하고 홍보하세요."
      },
      "register": {
        "create.podsqueeze.account": "Podsqueeze 계정 만들기",
        "generate.content.podcast": "한 번의 클릭으로 팟캐스트에 대한 쇼 노트, 타임스탬프, 뉴스레터 등을 생성하세요! 팟캐스트에 대한 콘텐츠를 빠르게 생성하고 필요에 맞게 조정하세요. 무료 가입."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "팟캐스트 콘텐츠를 자동으로 재활용하기",
        "repurpose.your.podcast.content.with.ai": "AI로 팟캐스트 콘텐츠를 재활용하세요. 한 번의 클릭으로 쇼 노트, 제목, 틱톡용 짧은 클립 등 다양한 콘텐츠를 자동으로 생성합니다!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "무료 팟캐스트 SEO 최적화 도구",
        "seo.optimizer.description": "AI 기반 SEO 추천으로 팟캐스트 에피소드를 검색 엔진에서 더 잘 보이도록 분석하고 최적화하세요.",
        "seo.optimizer.heading": "팟캐스트 SEO 최적화 도구",
        "seo.optimizer.headingnote": "AI 기반 SEO 추천으로 팟캐스트 에피소드를 검색 엔진에서 더 잘 보이도록 분석하고 최적화하세요.",
        "seo.optimizer.selectEpisode": "분석할 에피소드 선택",
        "seo.optimizer.results": "SEO 분석 결과",
        "seo.optimizer.searchPodcastPlaceholder": "팟캐스트 검색",
        "seo.optimizer.searchEpisodesPlaceholder": "에피소드 검색...",
        "seo.optimizer.analyseAnotherEpisode": "다른 에피소드 분석",
        "seo.optimizer.findingEpisodes": "모든 에피소드 찾는 중...",
        "seo.optimizer.analysingEpisode": "에피소드 분석 중",
        "seo.optimizer.scoreTooltip": "점수:",
        "seo.optimizer.topKeywords": "다음 주요 키워드를 확인했습니다:",
        "seo.optimizer.topKeywordsnote": "페이지 하단의 키워드 분석을 기반으로 합니다.",
        "seo.optimizer.optimizedContent": "키워드를 기반으로 최적화된 제목과 설명은 다음과 같습니다:",
        "seo.optimizer.originalTitle": "원본 제목",
        "seo.optimizer.optimizedTitle": "최적화된 제목",
        "seo.optimizer.originalDescription": "원본 설명",
        "seo.optimizer.optimizedDescription": "최적화된 설명",
        "seo.optimizer.showMore": "더 보기",
        "seo.optimizer.showLess": "간단히 보기",
        "seo.optimizer.keywordAnalysis": "키워드 분석",
        "seo.optimizer.keywordAnalysisnote": "점수는 검색량, 경쟁도(동일 키워드의 다른 결과 수), YouTube의 경우 동일 키워드 영상의 평균 조회수에 따라 계산됩니다.",
        "seo.optimizer.seoScore": "SEO 점수",
        "seo.optimizer.spotifyScore": "Spotify 점수",
        "seo.optimizer.youtubeScore": "YouTube 점수",
        "seo.optimizer.totalScore": "총합"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - AI 팟캐스트 콘텐츠 생성 도구",
        "podsqueeze.description": "한 번의 클릭으로 팟캐스트의 쇼 노트, 타임스탬프, 뉴스레터 등을 생성하세요! 팟캐스트에 필요한 콘텐츠를 빠르게 생성하고 조정할 수 있습니다. 무료 가입."
      },
      "thumbnail-creator": {
        "title": "무료 팟캐스트 썸네일 생성기 - AI 기반 에피소드 썸네일 생성",
        "description": "AI로 놀라운 팟캐스트 썸네일을 만들어보세요. 가시성을 높이고 팟캐스트에 더 많은 청취자를 끌어들이는 전문적이고 눈길을 끄는 에피소드 아트워크를 생성하세요.",
        "selectPodcast": "팟캐스트 선택",
        "loadEpisodes": "에피소드 로드",
        "selectEpisode": "썸네일 생성할 에피소드 선택",
        "createThumbnail": "썸네일 생성",
        "results": "생성된 썸네일",
        "download": "다운로드",
        "share": "공유",
        "regenerate": "재생성",
        "editThumbnail": "썸네일 편집",
        "editPlaceholder": "이 썸네일을 어떻게 수정하고 싶은지 설명해주세요...",
        "customPrompt": "사용자 정의 프롬프트",
        "yourThumbnail": "당신의 썸네일",
        "createAnother": "← 다른 썸네일 생성",
        "findingEpisodes": "에피소드 검색 중...",
        "searchPodcastPlaceholder": "팟캐스트 검색...",
        "searchingPodcasts": "팟캐스트 검색 중...",
        "heroDescription": "주목을 끌고 에피소드의 가시성을 높이는 AI 기반 디자인으로 놀랍고 전문적인 팟캐스트 썸네일을 생성하세요.",
        "generatedWithPrompt": "프롬프트로 생성됨:",
        "customPromptPlaceholder": "썸네일 생성을 위한 사용자 정의 프롬프트 입력...",
        "generating": "생성 중...",
        "generate": "생성",
        "modernMinimalist": "모던 & 미니멀",
        "vibrantDynamic": "생동감 & 다이나믹",
        "professionalClean": "전문적 & 깔끔",
        "generatingThumbnail": "썸네일 생성 중...",
        "generatingNewThumbnail": "새 썸네일 생성 중...",
        "showingFirstEpisodes": "처음 10개 에피소드 표시 중. 특정 에피소드를 찾으려면 검색을 사용하세요.",
        "imageUrlCopied": "이미지 URL이 클립보드에 복사되었습니다!",
        "failedToGenerate": "썸네일 생성에 실패했습니다. 다시 시도하세요.",
        "promotionalTitle": "Podsqueeze로 쇼 노트, 타임스탬프, 바이럴 클립 등을 생성하세요",
        "promotionalSubtitle": "100K+ 다른 크리에이터들과 함께하며 쇼 성장을 시작하세요",
        "startNow": "지금 시작",
        "free": "무료",
        "podcast": "팟캐스트",
        "thumbnail": "썸네일",
        "creator": "크리에이터",
        "replaceFace": "얼굴 교체",
        "uploading": "업로드 중...",
        "uploadImageError": "이미지 파일을 업로드해주세요.",
        "uploadFailedError": "이미지 업로드에 실패했습니다. 다시 시도하세요.",
        "uploadingImage": "이미지 업로드 중...",
        "generatingNewThumbnailLoading": "새 썸네일 생성 중...",
        "failedToGenerateWithFace": "얼굴 교체로 썸네일 생성에 실패했습니다. 다시 시도하세요."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "새 팟캐스트 폴더 만들기",
      "folder.name.placeholder": "폴더 이름 입력",
      "create.button": "생성"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "에피소드 로딩 중...",
        "episodeList.noEpisodes": "공개된 에피소드가 없습니다",
        "episodeList.checkBack": "새로운 에피소드는 나중에 다시 확인해주세요",
        "episodeList.title": "이 팟캐스트의 에피소드",
        "episodeList.readLess": "접기",
        "episodeList.readMore": "더 보기",
        "episodeList.coverImageAlt": "{episodeTitle}의 커버"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "시작하기",
        "alert.subscriptionRunning": "현재 구독이 계속 진행 중입니다.\n\n새로운 구독을 구매하기 전에 현재 구독을 취소해 주세요.",
        "alert.subscriptionEnds": "현재 구독이 계속 진행 중입니다.\n\n구독은 {date}에 종료됩니다.",
        "alert.subscriptionCancelled": "구독이 이미 취소되었으며 {date}에 종료됩니다.",
        "button.openDashboard": "대시보드 열기",
        "button.signUp": "가입하기",
        "button.buySubscription": "구독 구매",
        "button.cancelled": "취소됨",
        "button.cancelSubscription": "구독 취소",
        "button.upgradeSubscription": "구독 업그레이드",
        "button.loading": "로딩 중",
        "upgrade.details.currentMinutes": "이것은 새로운 구독 기간을 시작합니다. 현재의 모든 분을 유지합니다.",
        "upgrade.details.remainingAnnual": "이 값은 현재 연간 구독의 남은 시간에 따라 계산되었습니다."
      },
      "page": {
        "pricing.free.title": "무료",
        "pricing.free.subtitle": "Podsqueeze를 사용해 보세요. 신용카드 필요 없음.",
        "pricing.free.price.annual": "연간 $0 청구",
        "pricing.free.features.podcast_time": "월 50분의 팟캐스트 시간",
        "pricing.free.features.video_clips": "비디오 클립 3개",
        "common.with_watermark": "워터마크 포함",
        "pricing.free.features.quote_images": "무제한 인용 이미지",
        "pricing.free.features.file_upload": "최대 4Gb 파일 업로드",
        "pricing.free.features.upload": "1회 업로드",
        "pricing.free.features.landing_pages": "팟캐스트 랜딩 페이지",
        "pricing.free.features.audio_enhancement": "오디오 강화",
        "common.sign_up": "가입하기",
        "common.open_dashboard": "대시보드 열기",
        "pricing.starter.title": "스타터",
        "pricing.starter.subtitle": "시간을 절약하고 싶은 취미 팟캐스터에게 완벽합니다.",
        "pricing.starter.price.annual": "연간 $132 청구",
        "pricing.billed_annually": "연간 청구",
        "minutes.accumulate": "분 이월",
        "pricing.starter.features.podcast_time": "월 160분의 팟캐스트 시간",
        "pricing.starter.features.video_clips": "비디오 클립 또는 오디오그램 10개",
        "pricing.starter.features.quote_images": "무제한 인용 이미지",
        "pricing.starter.features.file_upload": "최대 4Gb 파일 업로드",
        "pricing.starter.features.unlimited_uploads": "무제한 업로드",
        "pricing.starter.features.landing_pages": "팟캐스트 랜딩 페이지",
        "pricing.pro.title": "프로",
        "pricing.pro.subtitle": "비즈니스를 개발하고 지원하기 위해 팟캐스트를 사용하는 전문가를 위한 것입니다.",
        "pricing.pro.price.annual": "연간 $324 청구",
        "pricing.pro.features.podcast_time": "월 320분의 팟캐스트 시간",
        "pricing.pro.features.personalize_ai_voice": "AI 음성 개인화",
        "pricing.pro.features.video_clips": "비디오 클립 또는 오디오그램 20개",
        "common.no_watermark": "워터마크 없음",
        "pricing.pro.features.quote_images": "무제한 인용 이미지",
        "pricing.pro.features.file_upload": "최대 10Gb 파일 업로드",
        "pricing.pro.features.unlimited_uploads": "무제한 업로드",
        "pricing.pro.features.landing_pages": "팟캐스트 랜딩 페이지",
        "common.customizable": "사용자 정의 가능",
        "pricing.pro.features.audio_video_edit": "오디오 및 비디오 매직 편집",
        "pricing.agency_lite.title": "에이전시 라이트",
        "pricing.agency_lite.subtitle": "비즈니스를 간소화하고 성장시키고자 하는 팟캐스트 에이전시를 위한 것입니다.",
        "pricing.agency_lite.price.annual": "연간 $495 청구",
        "pricing.agency_lite.features.podcast_time": "월 600분의 팟캐스트 시간",
        "pricing.agency_lite.features.personalize_ai_voice": "AI 음성 개인화",
        "pricing.agency_lite.features.video_clips": "비디오 클립 또는 오디오그램 40개",
        "pricing.agency_lite.features.quote_images": "무제한 인용 이미지",
        "pricing.agency_lite.features.file_upload": "최대 10Gb 파일 업로드",
        "pricing.agency_lite.features.unlimited_uploads": "무제한 업로드",
        "pricing.agency_lite.features.landing_pages": "팟캐스트 랜딩 페이지",
        "pricing.agency_lite.features.audio_video_edit": "오디오 및 비디오 매직 편집",
        "pricing.agency_plus.title": "에이전시 플러스",
        "pricing.agency_plus.subtitle": "비즈니스를 간소화하고 성장시키고자 하는 팟캐스트 에이전시를 위한 것입니다.",
        "pricing.agency_plus.price.annual": "연간 $1,251 청구",
        "pricing.agency_plus.features.podcast_time": "월 2000분의 팟캐스트 시간",
        "pricing.agency_plus.features.personalize_ai_voice": "AI 음성 개인화",
        "pricing.agency_plus.features.video_clips": "비디오 클립 또는 오디오그램 80개",
        "pricing.agency_plus.features.quote_images": "무제한 인용 이미지",
        "pricing.agency_plus.features.file_upload": "최대 10Gb 파일 업로드",
        "pricing.agency_plus.features.unlimited_uploads": "무제한 업로드",
        "pricing.agency_plus.features.landing_pages": "팟캐스트 랜딩 페이지",
        "pricing.agency_plus.features.audio_video_edit": "오디오 및 비디오 매직 편집",
        "pricing.agency_scale.title": "에이전시 스케일",
        "pricing.agency_scale.subtitle": "비즈니스를 간소화하고 성장시키고자 하는 팟캐스트 에이전시를 위한 것입니다.",
        "pricing.agency_scale.price.annual": "연간 $2,175 청구",
        "pricing.agency_scale.features.podcast_time": "월 4000분의 팟캐스트 시간",
        "pricing.agency_scale.features.personalize_ai_voice": "AI 음성 개인화",
        "pricing.agency_scale.features.video_clips": "비디오 클립 또는 오디오그램 160개",
        "pricing.agency_scale.features.quote_images": "무제한 인용 이미지",
        "pricing.agency_scale.features.file_upload": "최대 10Gb 파일 업로드",
        "pricing.agency_scale.features.unlimited_uploads": "무제한 업로드",
        "pricing.agency_scale.features.landing_pages": "팟캐스트 랜딩 페이지",
        "pricing.agency_scale.features.audio_video_edit": "오디오 및 비디오 매직 편집",
        "pricing.header": "개인 팟캐스터 및 팟캐스트 에이전시를 위한",
        "pricing.minutes_reset": "현재 요금제를 유지하거나 업그레이드하는 한 월 사용 시간의 최대 3배까지 누적할 수 있습니다.",
        "pricing.most_popular": "가장 인기 있음",
        "pricing.minutes_per_month": "월 분",
        "pricing.enterprise_title": "기업",
        "pricing.enterprise_subtitle": "미디어 에이전시 및 미디어 기업이 비즈니스를 확장하고 싶은 경우 적합합니다.",
        "pricing.enterprise_price": "사용자 정의",
        "pricing.enterprise_price_note": "team@podsqueeze.com 또는 아래 데모 예약을 통해 문의하세요.",
        "pricing.enterprise_feature_priority_support": "우선 지원",
        "pricing.enterprise_feature_team_sits": "팀 세션",
        "pricing.enterprise_personalized_team_training": "팀 온보딩 및 훈련",
        "pricing.book_demo": "데모 예약"
      },
      "toggle": {
        "pay.monthly": "월별",
        "pay.annually": "연간",
        "discount.30percent": "30% 할인"
      },
      "upgradeModal": {
        "upgrade.success": "구독이 성공적으로 업그레이드되었습니다",
        "upgrade.error": "죄송합니다, 문제가 발생했습니다. 나중에 다시 시도해 주세요",
        "upgrade.loading": "업그레이드 중",
        "upgrade.confirmPay": "확인 및 결제",
        "upgrade.cancel": "취소",
        "coupon.placeholder": "쿠폰 코드",
        "coupon.apply": "적용",
        "coupon.have": "쿠폰이 있습니다",
        "upgrade.confirmation": "다음으로 업그레이드 하시겠습니까?",
        "upgrade.price": "결제하실 금액은"
      }
    },
    "register": {
      "page": {
        "register.form": "등록 양식"
      },
      "registerForm": {
        "error.invalidCredentials": "유효한 이메일 주소와 비밀번호를 입력하세요.",
        "error.weakPassword": "더 강력한 비밀번호를 사용하세요 💪",
        "error.emailInUse": "사용자가 이미 존재합니다.",
        "error.userNotFound": "사용자를 찾을 수 없습니다.",
        "error.generic": "앗, 뭔가 잘못되었습니다.",
        "placeholder.email": "이메일 주소",
        "placeholder.password": "비밀번호",
        "button.registering": "등록 중...",
        "button.register": "등록",
        "label.newsletter": "12,000명의 팟캐스터와 함께하고 제품 업데이트, 실행 가능한 팁, 전자책, 경품 및 기타 정보를 위한 뉴스레터를 구독하세요.",
        "label.alreadyHaveAccount": "이미 계정이 있으신가요?",
        "label.logInHere": "여기에서 로그인",
        "label.or": "또는",
        "button.signingIn": "로그인 중...",
        "button.continueWithGoogle": "Google로 계속하기",
        "label.podcastDescription": "모든 것을 한 곳에서 제공하여 오디오 또는 비디오 팟캐스트를 손쉽게 시작하고 성장시키세요.",
        "feature.transcripts": "전사",
        "feature.showNotes": "쇼 노트",
        "feature.newslettersBlogs": "뉴스레터 및 블로그",
        "feature.socialPosts": "소셜 게시물",
        "feature.shortClips": "짧은 클립 및 오디오그램",
        "feature.podcastWebsite": "팟캐스트 웹사이트",
        "feature.audioEnhancement": "AI 오디오 향상",
        "feature.removeSilences": "침묵과 음을 제거합니다."
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "텍스트"
      },
      "TopicFinder": {
        "competition.veryHigh": "매우 높음",
        "competition.high": "높음",
        "competition.medium": "보통",
        "competition.low": "낮음",
        "competition.veryLow": "매우 낮음",
        "upgrade.button": "프로로 업그레이드",
        "clicks.label": "클릭 수",
        "searches.label": "검색 수",
        "competition.label": "경쟁",
        "fetching.results": "결과 가져오는 중",
        "table.topic": "주제",
        "tooltip.topic": "당신의 팟캐스트 에피소드에서 다루는 주요 주제",
        "table.monthlySearches": "월간 검색 수",
        "tooltip.monthlySearches": "예상할 수 있는 월간 구글 검색 범위",
        "table.competition": "경쟁",
        "tooltip.competition": "팟캐스트에서 다루는 주요 주제 또는 주제",
        "table.monthlyGoogleClicks": "월간 구글 클릭 수",
        "tooltip.monthlyGoogleClicks": "예상할 수 있는 월간 구글 클릭 범위",
        "table.youtubeReach": "유튜브 도달 범위",
        "tooltip.youtubeReach": "경쟁자의 평균을 기준으로 첫 6개월 동안 예상할 수 있는 최대 유튜브 조회 수",
        "intro.title": "무료 팟캐스트 주제 생성기",
        "intro.description": "청중이 검색하는 팟캐스트 주제 아이디어를 얻으세요",
        "intro.check1": "각 주제 아이디어에 대한 수요를 구글에서 확인하세요",
        "intro.check2": "각 팟캐스트 주제 아이디어의 경쟁력을 알아보세요",
        "intro.check3": "예상되는 구글 클릭 수와 유튜브 조회 수를 추정하세요",
        "upgrade.message": "모든 결과에 액세스하려면 프로로 업그레이드해야 합니다",
        "learnMore.label": "자세히 알아보기",
        "learnMore.link": "무료 팟캐스트 주제 생성기 도구",
        "newSearch.button": "새 검색",
        "share.button": "이 검색 공유",
        "form.label": "당신의 팟캐스트 니치 입력",
        "form.placeholder": "디지털 마케팅",
        "form.submit": "주제 아이디어 찾기"
      },
      "page": {
        "main.background": "배경"
      },
      "shareTopics": {
        "share.results": "결과 공유",
        "share.facebook": "페이스북에 공유",
        "share.whatsapp": "왓츠앱에 공유",
        "share.twitter": "트위터에 공유",
        "share.linkedin": "링크드인에 공유",
        "copy.success": "복사됨",
        "copy.link": "링크 복사"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "조회수"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "현재 구성 정보를 가져올 수 없습니다.",
        "error.addImage": "이미지 요소 추가 중 오류 발생:",
        "alert.uploadImage": "이미지 파일을 업로드해 주세요.",
        "error.uploadImage": "이미지 업로드 중 오류 발생:",
        "alert.uploadFailed": "이미지 업로드에 실패했습니다. 다시 시도해 주세요.",
        "error.getDownloadURL": "다운로드 URL을 가져오는 중 오류 발생:",
        "alert.processImageFailed": "업로드된 이미지를 처리하는 데 실패했습니다. 다시 시도해 주세요.",
        "error.addText": "텍스트 요소 추가 중 오류 발생:",
        "text.settingsPlaceholder": "요소가 선택되면 설정이 표시됩니다.",
        "text.addElement": "요소 추가",
        "text.uploading": "업로드 중...",
        "button.uploadImage": "이미지 업로드",
        "text.newText": "새 텍스트",
        "button.addText": "텍스트 추가",
        "text.selectedElementSettings": "선택된 요소 설정"
      },
      "FontSelector": {
        "allFonts": "모든 폰트",
        "myFonts": "내 폰트",
        "uploadFont": "폰트 업로드",
        "noCustomFonts": "아직 사용자 정의 폰트가 없습니다.",
        "uploadToAdd": "폰트 파일을 업로드하여 컬렉션에 추가하세요.",
        "text_outline": "텍스트 윤곽선",
        "outline_color": "윤곽선 색상",
        "outline_width": "윤곽선 두께"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "맞춤",
        "imageLayoutSettings.zoom": "확대",
        "imageLayoutSettings.horizontalAlignment": "수평 정렬",
        "imageLayoutSettings.verticalAlignment": "수직 정렬",
        "imageLayoutSettings.deleteElement": "요소 삭제"
      },
      "TemplateBox": {
        "confirm.delete.template": "이 템플릿을 삭제하시겠습니까?"
      },
      "TextSettings": {
        "error.getting_current_text": "현재 텍스트를 가져오는 중 오류 발생:",
        "event.delete_text_element_clicked": "텍스트 요소 삭제 클릭됨",
        "error.changing_text_font": "텍스트 글꼴 변경 중 오류 발생:",
        "event.text_font_changed": "텍스트 글꼴 변경됨",
        "error.changing_text_size": "텍스트 크기 변경 중 오류 발생:",
        "event.text_size_changed": "텍스트 크기 변경됨",
        "error.changing_text_color": "텍스트 색상 변경 중 오류 발생:",
        "event.text_color_changed": "텍스트 색상 변경됨",
        "event.text_content_added": "텍스트 내용 추가됨",
        "error.adding_text_content": "텍스트 내용 추가 중 오류 발생:",
        "event.text_content_updated": "텍스트 내용 업데이트됨",
        "label.text_content": "텍스트 내용",
        "label.text_font": "텍스트 글꼴",
        "label.adjust_text_size": "텍스트 크기 조정",
        "label.text_color": "텍스트 색상",
        "button.delete": "삭제"
      },
      "audiogramBaseTemplate": {
        "color.white": "흰색",
        "font.roboto": "로보토",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0초",
        "font.inter": "인터",
        "duration.1s": "1초",
        "easing.quadraticOut": "2차 아웃",
        "animation.fade": "페이드",
        "type.text": "텍스트",
        "name.podcastTitle": "팟캐스트 제목",
        "name.snippetTitle": "스니펫 제목",
        "type.image": "이미지",
        "name.audioBackgroundImage": "오디오 배경 이미지",
        "name.subtitlesText": "자막 텍스트",
        "effect.highlight": "하이라이트",
        "type.audio": "오디오",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "스니펫 제목",
        "podcast.title": "팟캐스트 제목",
        "new.episode": "새 에피소드"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "흰색",
        "default.font.judson": "저드슨",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "기본에피소드URL",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "배경_음악",
        "audio.type": "오디오"
      },
      "imageElement": {
        "upload.image.error": "이미지 파일을 업로드해 주세요.",
        "upload.file.loading": "파일을 업로드 중입니다. 이 창을 닫지 마세요.",
        "upload.image.label": "이미지 교체",
        "ai.prompt.label": "AI가 이미지를 생성할 프롬프트를 입력하세요",
        "ai.prompt.placeholder": "예: 공원에서 뛰고 있는 개...",
        "ai.processing": "처리 중...",
        "ai.create": "생성",
        "customize.image.title": "이미지 사용자화",
        "enter.image.url": "이미지 URL 입력",
        "or": "또는"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "템플릿을 가져오는 중 오류가 발생했습니다:",
        "template.savedSuccessfully": "템플릿이 성공적으로 저장되었습니다",
        "error.savingTemplate": "템플릿을 저장하는 중 오류가 발생했습니다:",
        "loading.savedTemplates": "저장된 템플릿을 로드하는 중...",
        "no.savedTemplates": "저장된 템플릿이 없습니다",
        "select_template": "템플릿 선택",
        "saving.template": "템플릿을 저장하는 중...",
        "template_name": "템플릿 이름",
        "enter.templateName": "템플릿 이름을 입력하세요",
        "cancel": "취소",
        "save": "저장",
        "default_templates": "기본 템플릿",
        "saved_templates_count": "저장된 템플릿 ({count})",
        "folder_templates_count": "폴더 템플릿 ({count})",
        "account_templates_count": "계정 템플릿 ({count})",
        "save_current_template": "현재 템플릿 저장"
      },
      "subtitlesElement": {
        "edit.word": "단어 편집",
        "edit.label": "편집",
        "remove.word.subtitle": "자막에서만 단어 제거",
        "erase.subtitle": "자막에서 지우기",
        "remove.word.clip": "오디오 및 자막에서 단어 제거",
        "remove.clip": "클립에서 제거"
      },
      "utils": {
        "video.utils.title": "제목",
        "video.utils.currentTime": "현재 시간",
        "video.utils.nextTime": "다음 시간",
        "video.utils.duration": "길이",
        "video.utils.description": "설명",
        "video.utils.srtSegment": "SRT 세그먼트"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "여기에 자막 텍스트를 입력하세요"
      }
    }
  },
  "nl": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "WORD ONZE PARTNER",
        "SHARE_PODSQUEEZE": "Deel Podsqueeze met je publiek",
        "AND_EARN_MONEY": "en verdien geld!",
        "LAST_UPDATED": "Laatst bijgewerkt: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Word een Affiliate Partner",
        "EARN_COMMISSION": "Verdien",
        "COMMISSION": "commissie",
        "ON_EVERY_SALE": "op elke verkoop die via je exclusieve verwijzingslink gedurende een periode van 15 maanden wordt gedaan. Deel je link op je website, sociale media, of met je vrienden. Het duurt slechts enkele seconden om lid te worden.",
        "GET_AUTOMATICALLY_APPROVED": "Word automatisch goedgekeurd.",
        "JOIN_NOW": "Word lid",
        "HOW_IT_WORKS": "HOE HET WERKT",
        "FREQUENTLY_ASKED_QUESTIONS": "Veelgestelde Vragen",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Wat is een Affiliate Partner?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Een Affiliate Partner is iemand die de producten of diensten van een ander bedrijf promoot via een unieke verwijzingslink en een commissie verdient op elke verkoop die via die link wordt gedaan.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Hoe kan ik een Affiliate Partner worden?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Affiliate Partner worden is snel en eenvoudig en kost slechts enkele seconden van je tijd. Om te beginnen klik je gewoon op de knop 'Word lid' en meld je je aan met je e-mail. Zodra je bent geregistreerd, krijg je toegang tot een gebruiksvriendelijk dashboard waar je je unieke verwijzingslink kunt vinden. Deel deze link met je familie, vrienden, of online publiek. Elke keer dat iemand op je verwijzingslink klikt en een aankoop doet op de website van Podsqueeze, verdien je 25% commissie op elke betaling voor een volledige periode van 15 maanden! Houd je verdiensten moeiteloos bij via je Affiliate-dashboard, dat een duidelijk overzicht biedt van alle verkopen die je hebt gegenereerd.",
        "HOW_CAN_I_TRACK_MY_SALES": "Hoe kan ik mijn verkopen en commissies volgen?",
        "TRACKING_SALES_DESCRIPTION": "Gebruik ons affiliate programma dashboard om je verkopen en commissies bij te houden. De trackingsoftware is beschikbaar voor zowel Affiliate Partners als Business Partners.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Wanneer en hoe ontvang ik mijn betaling?",
        "PAYMENT_DESCRIPTION": "Je ontvangt je betaling elke 30 dagen via PayPal. Houd er rekening mee dat er een minimale uitbetalingsdrempel van $50 geldt. Zodra je dit bedrag hebt bereikt, kun je verwachten dat je elke 30 dagen stipt je betaling ontvangt.",
        "STILL_GOT_QUESTIONS": "NOG VRAGEN?",
        "SEND_US_A_MESSAGE": "Stuur ons een bericht in de supportchat of mail ons naar team@podsqueeze.com",
        "NOTE": "Opmerking",
        "AFFILIATE_ADS_RESTRICTION": "Affiliate Partners mogen geen advertenties maken op Google of deelnemen aan biedingen op relevante zoekwoorden die verband houden met Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Gebruiksvoorwaarden voor Affiliates",
        "CAN_I_RUN_ADS": "Kan ik advertenties en CPC-campagnes uitvoeren op Google om mijn verwijzingslink te promoten?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Affiliate Partners mogen geen advertenties maken op zoekmachines of deelnemen aan biedingen op zoekwoorden die verband houden met Podsqueeze. Deze beperking helpt de integriteit van onze advertent strategie te waarborgen en zorgt voor een consistente merkboodschap. Houd er rekening mee dat verkopen die voortkomen uit dergelijke biedcampagnes niet in aanmerking komen voor betaling.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Hoe genereert Podsqueeze titels voor je Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Navigatiebalk",
        "main.affiliateHero": "Affiliateheld",
        "main.footer": "Voettekst"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Intro- en Outromuziek Toevoegen",
        "intro.music": "Intromuziek",
        "outro.music": "Outromuziek",
        "intro.duration": "Introduur",
        "outro.duration": "Outroduur",
        "intro.mode": "Intromodus",
        "outro.mode": "Outromodus",
        "cancel": "Annuleren",
        "save": "Opslaan",
        "apply": "Toepassen",
        "current.intro.music": "Huidige Intromuziek",
        "current.outro.music": "Huidige Outromuziek",
        "change.music": "Muziek Wijzigen",
        "choose.music": "Muziekbestand Kiezen",
        "browser.not.support.audio": "Uw browser ondersteunt het audio-element niet.",
        "save.and.apply": "Opslaan en Toepassen",
        "no.music.selected": "Geen muziek geselecteerd",
        "delete.music": "Muziek verwijderen",
        "uploading.file": "Bestand uploaden..."
      },
      "audioEditElements": {
        "error.processing.rss": "We ondervinden enkele moeilijkheden bij het verwerken van sommige RSS-feeds. Upload alstublieft een bestand.",
        "edit.enhance.audio": "Bewerk en verbeter uw audio-opname",
        "trial.label": "Proefversie",
        "audio.editing.experience": "Ervaar naadloze audio-editing met geavanceerde AI-algoritmen voor natuurlijke, hoogwaardige resultaten, met slechts één klik.",
        "improve.audio.quality": "Verbeter de geluidskwaliteit",
        "remove.hums.silences": "Verwijder bromgeluiden en stiltes",
        "upgrade.edit.audio": "Upgrade om uw audio met één enkele klik te kunnen bewerken",
        "available.plans": "Beschikbaar voor Alle Betaalde Plannen",
        "upgrade.now": "Upgrade nu",
        "audio.element.support": "Uw browser ondersteunt het audio-element niet.",
        "download.audio": "Download audio",
        "loading.audio": "Audio laden",
        "editing.audio": "Audio bewerken"
      },
      "videoEditElements": {
        "error.exporting.video": "Fout bij het exporteren van video",
        "download.failed": "Download mislukt: {error.message}",
        "generating.video": "Video aan het genereren",
        "error.generating.clip": "Fout bij het genereren van clip",
        "please.retry.support": "Probeer het opnieuw of neem contact op met onze gebruikerssupport",
        "browser.not.support.video": "Uw browser ondersteunt de video-tag niet.",
        "this.might.take.minutes": "Sluit het venster alstublieft niet, dit kan enkele minuten duren.",
        "exporting.video": "Uw video aan het exporteren...",
        "seamless.audio.editing": "Ervaar naadloze audio-editing met geavanceerde AI-algoritmen voor natuurlijke, hoogwaardige resultaten, met slechts één klik.",
        "difficulties.processing.rss": "We ondervinden enkele moeilijkheden bij het verwerken van sommige RSS-feeds. Upload alstublieft een bestand.",
        "edit.enhance.video.recording": "Bewerk en verbeter uw video-opname",
        "trial": "Proefversie",
        "enhance.audio.quality": "Verbeter de geluidskwaliteit",
        "enhance.audio.quality.edit": "Verbeter de geluidskwaliteit & Bewerk",
        "trim.filler.words.video": "Trim vulwoorden uit video (bijv: hums)",
        "trim.long.silences.video": "Trim lange stiltes uit video",
        "upgrade.to.edit.video": "Upgrade om uw video met één enkele klik te kunnen bewerken",
        "available.pro.agency.plans": "Beschikbaar voor Pro- en Agency-plannen",
        "upgrade.now": "Upgrade nu",
        "download.only.audio": "Download alleen audio",
        "download.video": "Download video",
        "please.dont.close.window": "Sluit het venster alstublieft niet",
        "export.video": "Exporteer video"
      },
      "videogramBaseTemplate": {
        "media.fit": "bedekken",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "media"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Andere afleveringen van deze Podcast",
        "tab.shownotes": "Show notities",
        "tab.timestamps": "Tijdsmarkeringen",
        "tab.blogpost": "Blogbericht",
        "tab.transcript": "Transcriptie",
        "key.points": "Kernpunten"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Je landingspagina is live in onze podcastzoeker. Deel het met je publiek!",
        "landingPage.create": "Maak een mooie landingspagina voor deze aflevering",
        "landingPage.edit": "Bewerk Pagina",
        "landingPage.visit": "Bezoek Pagina",
        "landingPage.delete": "Verwijder Pagina",
        "landingPage.createButton": "Maak Landingspagina"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Beheer Aflevering Links",
        "youtube.link": "YouTube Link",
        "enter.youtube.link": "Voer YouTube-link in",
        "apple.podcasts.link": "Apple Podcasts Link",
        "enter.apple.podcasts.link": "Voer Apple Podcasts-link in",
        "spotify.link": "Spotify Link",
        "enter.spotify.link": "Voer Spotify-link in",
        "saving": "Opslaan...",
        "save": "Opslaan",
        "social.links.updated.successfully": "Sociale links succesvol bijgewerkt!"
      },
      "affiliatesection": {
        "affiliate.section.title": "WORD EEN AFFILIATE PARTNER",
        "affiliate.section.subtitle": "Deel Podsqueeze met je publiek en",
        "affiliate.section.earn": "verdien geld!",
        "affiliate.section.commission": "Ons affiliate programma biedt 25% commissie voor 15 maanden, op elke verkoop en abonnement verlengingsbetaling.",
        "affiliate.section.join": "Het kost seconden om je aan te melden!",
        "affiliate.section.knowMore": "Meer Weten"
      },
      "asseenon": {
        "podnews.logo": "podnews logo",
        "transistor.logo": "transistor logo",
        "thepodcasthost.logo": "de podcast host logo",
        "schoolofpodcasting.logo": "School of podcasting logo",
        "semrush.logo": "semrush logo"
      },
      "assembleshownotes": {
        "episode.description": "Afleveringsbeschrijving",
        "bullet.points": "Opsommingstekens",
        "timestamps": "Tijdstempels",
        "links.and.mentions": "Links & Vermeldingen",
        "extra.content": "Extra Inhoud",
        "assemble.show.notes": "Stel Je Shownotities Samen",
        "downloading": "Bezig met downloaden",
        "copied": "Gekopieerd",
        "enter.placeholder": "Voer {{label}} in..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Een pauze nemen van podcasting",
        "cancellation.option.no_recurrent": "Ik wil geen terugkerend abonnement",
        "cancellation.option.expensive": "Het is te duur",
        "cancellation.option.not_saving_time": "Biedt me niet genoeg tijdsbesparing",
        "cancellation.option.dissatisfied_content": "Ontevreden over de kwaliteit van de gegenereerde inhoud",
        "cancellation.option.unresponsive_support": "Onbereikbare klantenservice",
        "cancellation.option.not_using": "Gebruik de service niet genoeg",
        "cancellation.option.difficulty_navigating": "Moeite met het gebruiken/navigeren van het product",
        "cancellation.option.better_alternative": "Een beter alternatief product gevonden",
        "cancellation.option.other": "Anders",
        "cancellation.video.message": "70% van onze gebruikers stopt met het annuleringsproces na het bekijken van deze video",
        "cancellation.button.cancel": "Ik Wil Nog Steeds Annuleren",
        "cancellation.button.try_again": "Ik Wil Het Nog Een Keer Proberen",
        "cancellation.prompt.select_reason": "Help ons alstublieft het product te verbeteren door de reden voor het annuleren van uw abonnement te selecteren:",
        "cancellation.placeholder.answer": "Typ hier uw antwoord...",
        "cancellation.placeholder.specify_reason": "Geef alstublieft uw reden voor annulering op",
        "cancellation.button.next": "Volgende",
        "cancellation.button.go_back": "Teruggaan",
        "cancellation.last_question.title": "Laatste Vraag Van Onze Kant",
        "lose.all.accumulated.minutes": "Als u annuleert, verliest u alle opgebouwde minuten.",
        "generate.articles.favorite.podcasts.and.vides": "Genereer artikelen uit je favoriete podcasts",
        "convert.and.repurpose.episodes": "Converteer en hergebruik je oude afleveringen in nieuw content",
        "keep.accumulating.minutes": "Blijf minuten bijhouden om ze te gebruiken wanneer u terugkeert naar podcasting",
        "here.are.some.ideas": "Hier zijn enkele ideeën om je te helpen verder te profiteren van Podsqueeze",
        "share.your.account.with.a.friend": "Deel je account met een vriend die kan helpen",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Hier is een video die laat zien hoe je Podsqueeze het beste kunt gebruiken",
        "cancellation.last_question.prompt": "Welke veranderingen of verbeteringen zouden u kunnen overhalen om weer bij onze service aan te sluiten?",
        "cancellation.feedback.message": "Uw feedback helpt ons te verbeteren 🙏",
        "cancellation.button.confirm": "Bevestig Annulering",
        "cancellation.minutes.accumulated": "U heeft",
        "cancellation.minutes.accumulated.suffix": "opgebouwde minuten ter waarde van",
        "cancellation.reminder.text": "Vergeet niet:",
        "cancellation.minutes.warning": "Opgebouwde minuten zijn een voordeel voor actieve abonnementen. Door uw abonnement te annuleren gaan uw minuten permanent verloren.",
        "cancellation.content.deletion.warning": "Al uw gegenereerde inhoud wordt na 30 dagen permanent verwijderd.",
        "cancellation.minutes.left.title": "U Heeft Nog Minuten Over! Laat Ze Niet Verloren Gaan!",
        "cancellation.suggestion.clips": "Hergebruik oudere afleveringen in clips voor sociale media",
        "cancellation.suggestion.articles": "Zet oudere afleveringen om in artikelen met Podsqueeze om te profiteren van SEO.",
        "cancellation.suggestion.linkedin": "Zet oudere gezaghebbende afleveringen om in LinkedIn-posts om uw persoonlijke merk te versterken",
        "cancellation.suggestion.share": "Deel uw Podsqueeze-account met een vriend zodat hij kan profiteren van uw ongebruikte minuten.",
        "cancellation.button.keep.subscription": "Mijn Abonnement Behouden",
        "cancellation.button.keep.minutes": "Mijn",
        "cancellation.button.keep.minutes.suffix": "aan Waarde van Minuten Behouden",
        "cancellation.lifetime.before_you_go": "Voordat u weggaat...",
        "cancellation.lifetime.title": "Hoe zit het met levenslange toegang voor slechts $49?",
        "cancellation.lifetime.subtitle": "Behoud uw Starter Account. Geen abonnementen. Geen verlengingen. Alleen van u — voor altijd.",
        "cancellation.lifetime.feature1": "Levenslange toegang tot Podsqueeze voor een eenmalige betaling van $49",
        "cancellation.lifetime.feature2": "Gebruik het wanneer u het nodig heeft, geen druk — het is voor altijd van u",
        "cancellation.lifetime.feature3": "Bevat alle huidige en toekomstige Starter Plan functies",
        "cancellation.lifetime.button_cancel": "Ik wil nog steeds annuleren",
        "cancellation.lifetime.button_deal": "Krijg lifetime deal",
        "cancellation.downgrade.title": "Behoud al uw content voor slechts $5.99/maand",
        "cancellation.downgrade.subtitle": "Door te downgraden naar Starter kunt u...",
        "cancellation.downgrade.feature1": "Al uw gegenereerde content behouden",
        "cancellation.downgrade.feature2": "Uw websites draaiende houden",
        "cancellation.downgrade.feature3": "160 minuten en 10 clips per maand voor incidenteel werk",
        "cancellation.billing.monthly": "Maandelijks",
        "cancellation.billing.annual": "Jaarlijks",
        "cancellation.billing.discount": "30% KORTING",
        "cancellation.plan.starter": "Starter Plan",
        "cancellation.price.monthly": "$8.99/maand",
        "cancellation.price.annual": "$5.99/maand",
        "cancellation.price.annual_billing": "gefactureerd $71.88 jaarlijks",
        "cancellation.feature.minutes": "160 mins/maand",
        "cancellation.feature.clips": "10 clips/maand",
        "cancellation.downgrade.button": "Downgrade naar Starter & Behoud Content",
        "cancellation.error.payment_link": "Kon betaallink niet ophalen. Probeer opnieuw.",
        "cancellation.error.payment_service": "Fout bij verbinding maken met betaaldienst.",
        "cancellation.option.question.break": "Kunt u ons meer vertellen over waarom u een pauze neemt?",
        "cancellation.option.question.no_recurrent": "Kunt u delen waarom u liever geen terugkerend abonnement heeft?",
        "cancellation.option.question.expensive": "Welke prijzen of functies zouden de service waardevoller voor u maken?",
        "cancellation.option.question.not_saving_time": "Wat kost u nog steeds veel tijd in uw proces?",
        "cancellation.option.question.dissatisfied_content": "Met welke aspecten van de inhoud was u ontevreden?",
        "cancellation.option.question.unresponsive_support": "Kunt u uw ervaring met onze klantenservice beschrijven?",
        "cancellation.option.question.not_using": "Is er iets dat u zou aanmoedigen om de service vaker te gebruiken?",
        "cancellation.option.question.difficulty_navigating": "Welke moeilijkheden heeft u ondervonden bij het gebruiken/navigeren van het product?",
        "cancellation.option.question.better_alternative": "Welk alternatief product heeft u gevonden en wat vindt u eraan leuk?",
        "cancellation.option.question.other": "Gelieve uw reden voor annulering te specificeren:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Wij waarderen uw privacy",
        "cookiebanner.cookieUsage": "Wij gebruiken cookies om uw website-ervaring te verbeteren en ons verkeer te analyseren. Door op accepteren te klikken, stemt u in met ons gebruik van cookies.",
        "cookiebanner.privacyPolicy": "Privacybeleid",
        "cookiebanner.accept": "Accepteren",
        "cookiebanner.decline": "Weigeren"
      },
      "episodeTitleBox": {
        "loading": "Laden...",
        "editEpisodeTitleClicked": "Bewerken van afleveringstitel geklikt",
        "newEpisodeTitleStored": "Nieuwe afleveringstitel opgeslagen"
      },
      "famewall": {
        "loading.message": "Laden..."
      },
      "footer": {
        "footer.features": "Kenmerken",
        "footer.transcriptGenerator": "Transcriptgenerator",
        "footer.subtitlesGenerator": "Ondertitels Generator",
        "footer.descriptionGenerator": "Beschrijving Generator",
        "footer.podcastSummarizer": "Podcast Samenvatting Generator",
        "footer.titlesGenerator": "Titels Generator",
        "footer.bulletPointsGenerator": "Opsommingstekens Generator",
        "footer.chaptersClipsGenerator": "Hoofdstukken & Clips Generator",
        "footer.socialMediaPostsGenerator": "Social Media Berichten Generator",
        "footer.newsletterGenerator": "Nieuwsbrief Generator",
        "footer.blogPostGenerator": "Blogpost Generator",
        "footer.podcastLandingPages": "Podcast Landingspagina's",
        "footer.podcastClipMaker": "Podcast Clipmaker",
        "footer.audiogramGenerator": "Audiogram Generator",
        "footer.aiAudioEnhancer": "AI Audio Verbeteraar",
        "footer.convertYoutubeToText": "Converteer Youtube naar Tekst",
        "footer.youtubeVideoNoiseRemover": "Youtube Video Geluidverwijderaar",
        "footer.youtubeVideoKeyPoints": "Youtube Video Kernpunten",
        "footer.freeResources": "Gratis Bronnen",
        "footer.findPodcastTopicIdeas": "Vind podcast onderwerpideeën",
        "footer.articles": "Artikelen",
        "footer.freeEbooks": "Gratis eBooks",
        "footer.community": "Gemeenschap",
        "footer.ourPodcast": "Onze Podcast",
        "footer.product": "Product",
        "footer.giftCard": "Cadeaubon",
        "footer.onboardingEbook": "Onboarding eBook",
        "footer.pricing": "Prijzen",
        "footer.affiliates": "Affiliates",
        "footer.media": "Media",
        "footer.testimonials": "Getuigenissen",
        "footer.legal": "Juridisch",
        "footer.privacyPolicy": "Privacybeleid",
        "footer.termsOfUse": "Gebruiksvoorwaarden",
        "footer.refundPolicy": "Terugbetalingsbeleid",
        "footer.allRightsReserved": "Alle Rechten Voorbehouden."
      },
      "globalState": {
        "cookie.enabled": "Cookie ingeschakeld",
        "language.default": "Standaardtaal"
      },
      "head": {
        "keywords.list": "Podsqueeze, AI, Podcasts, Inhoud Generatie, Podcast transcriptie, Shownotes, Timestamps, Podcast Nieuwsbrieven, Tweets, Blogberichten, Sociale Berichten, Titels, Shownotes schrijver"
      },
      "imageResultModal": {
        "download.image": "Afbeelding Downloaden",
        "generating.image": "Afbeelding Genereren",
        "ai.prompt.label": "Voer een prompt in voor de AI om een afbeelding te genereren",
        "ai.prompt.placeholder": "Bijv: Een hond die in het park rent...",
        "processing": "Bezig met verwerken...",
        "create": "Aanmaken",
        "text.color.label": "Tekstkleur",
        "quote.icon.color.label": "Kleur van het Citaatpictogram",
        "background.color.label": "Achtergrondkleur",
        "font.label": "Lettertype",
        "upload.cover.image": "Upload Coverafbeelding",
        "aspect.ratio.info": "Beeldverhouding 1:1, aanbevolen grootte 1200x1200",
        "upload.logo.label": "Upload Logo",
        "choose.file": "Kies Bestand",
        "upload.success": "Succesvol geüpload",
        "choose.quote": "Kies een Citaat",
        "select.template": "Selecteer sjabloon",
        "quote.label": "Citaat",
        "enter.quote.here": "Voer Citaat Hier In",
        "author.label": "Auteur",
        "enter.author.name": "Voer Naam van de Auteur In",
        "podcast.name.label": "Podcast Naam",
        "enter.podcast.name": "Voer Podcast Naam In",
        "colors": "Kleuren",
        "select.font": "Selecteer Lettertype",
        "cover.logo.images": "Cover- en Logo-afbeeldingen",
        "logo.image": "Logo-afbeelding",
        "upgrade.here": "Upgrade hier",
        "remove.logo": "Podsqueeze logo verwijderen",
        "default_templates": "Standaard sjablonen",
        "saved_templates_count": "Opgeslagen sjablonen",
        "save_current_template": "Huidige sjabloon opslaan",
        "no_saved_templates": "Nog geen opgeslagen sjablonen",
        "save_template": "Sjabloon opslaan",
        "cancel": "Annuleren",
        "save": "Opslaan",
        "enter_template_name": "Voer sjabloonnaam in",
        "reset_template": "Resetten",
        "add_element": "Element toevoegen",
        "generate": "Genereren",
        "add_image": "Afbeelding toevoegen",
        "upload_image": "Afbeelding uploaden",
        "or": "of",
        "generate_with_ai": "Genereren met AI",
        "search_fonts": "Lettertypen zoeken...",
        "upload_logo": "Logo uploaden",
        "square_image_recommended": "Vierkante afbeelding aanbevolen",
        "opacity": "Doorzichtigheid",
        "layers": "Lagen",
        "no_element_selected": "Geen element geselecteerd",
        "bold_shortcut": "Vet (Ctrl+B)",
        "italic_shortcut": "Cursief (Ctrl+I)",
        "underline_shortcut": "Onderstrepen (Ctrl+U)",
        "edit_text": "Tekst bewerken",
        "tint_color": "Tintkleur",
        "toggle_gradient_transparent": "Verloop transparant maken",
        "rotate_gradient": "Verloop 45 graden draaien",
        "alt_background": "Achtergrond",
        "alt_podcast_logo": "Podcast-logo",
        "alt_custom": "Aangepast",
        "alt_right_side": "Rechterkant",
        "alt_profile": "Profiel"
      },
      "intentModal": {
        "intentModal.title": "Wat wil je doen met Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Schrijf Show Notities",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Schrijf Blogpost & Nieuwsbrief",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Maak Videoclips of Audiogrammen",
        "intentModal.sourceOption.Create_Quote_Images": "Maak Quote Afbeeldingen",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Bewerk & Verbeter Audio/Video",
        "intentModal.sourceOption.Transcribe": "Transcribeer",
        "intentModal.sourceOption.Create_a_Website": "Maak een Website",
        "intentModal.sourceOption.All_of_the_Above": "Alle bovenstaande",
        "intentModal.sourceOption.Other": "Anders",
        "intentModal.otherPlaceholder": "Gelieve te specificeren",
        "intentModal.submitButton": "Indienen & Registreren",
        "intentModal.skip": "Overslaan"
      },
      "languageSwitcher": {
        "language.en": "Engels",
        "language.es": "Spaans",
        "language.fr": "Frans",
        "language.de": "Duits",
        "language.it": "Italiaans",
        "language.pt": "Portugees",
        "language.nl": "Nederlands",
        "language.pl": "Pools",
        "language.ru": "Russisch",
        "language.zh": "Chinees",
        "language.ja": "Japans",
        "language.ko": "Koreaans",
        "language.ar": "Arabisch",
        "language.th": "Thais",
        "language.vi": "Vietnamees"
      },
      "lazyImage": {
        "lazyImage.alt": "Afbeeldingsbeschrijving"
      },
      "metadata": {
        "meta.title": "Uw Pagina Titel",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Hulpprogramma"
      },
      "navbar": {
        "navbar.dashboard": "Dashboard",
        "navbar.login": "Inloggen",
        "navbar.openMenu": "Hoofdmenu openen",
        "navbar.features": "Kenmerken",
        "navbar.resources": "Hulpmiddelen",
        "navbar.pricing": "Prijzen",
        "navbar.contact": "Contact",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "Bekijk alle kenmerken",
        "navbar.mainFeatures": "BELANGRIJKE KENMERKEN",
        "navbar.podcastTranscription": "Podcast en Video Transcriptie Generator",
        "navbar.transcriptionDescription": "Transcript met hoge nauwkeurigheid met sprekerlabeling en SRT-bestand voor ondertitels.",
        "navbar.podcastSummarizer": "Podcast Samenvatter",
        "navbar.summarizerDescription": "Maak complete show-notities 20x sneller, in je eigen stem.",
        "navbar.podcastClipMaker": "Podcast Clip Maker",
        "navbar.clipMakerDescription": "Genereer automatisch korte clips of audiogrammen voor je podcast.",
        "navbar.audioEnhancer": "Ai Audio Verbeteraar",
        "navbar.audioEnhancerDescription": "Verbeter audio automatisch, verwijder stiltes en vulwoorden.",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE KENMERKEN HANDLEIDING",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Actiegerichte artikelen en gidsen om een succesvolle podcast te lanceren en te laten groeien.",
        "navbar.podcastTopicIdeas": "Podcast Onderwerp Ideeën",
        "navbar.topicIdeasDescription": "Ontdek podcastonderwerpen waar het publiek naar op zoek is.",
        "navbar.actionableEbooks": "Bruikbare eBooks",
        "navbar.ebooksDescription": "Download gratis eBooks met bruikbare tips om je podcast naar het volgende niveau te tillen.",
        "navbar.freeThumbnailMaker": "Gratis Podcast Thumbnail Maker",
        "navbar.freeThumbnailMakerDescription": "Maak professionele, opvallende episode-thumbnails met AI.",
        "navbar.seoOptimizer": "SEO Optimalisator",
        "navbar.seoOptimizerDescription": "Optimaliseer je podcastepisodes voor betere zichtbaarheid in zoekmachines.",
        "navbar.podcastDescription": "Luister naar onze podcast, waar we ervaren podcasters en Podsqueeze-gebruikers van over de hele wereld interviewen. We vragen hen hun tips, inzichten, verhalen en alles wat je moet weten om je eigen podcast te laten groeien te delen."
      },
      "resultModal": {
        "prompt.transcript.quote": "Citaat",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Eerste persoon shownotes",
        "prompt.shownotes.replaceName": "Vervang naam in shownotes",
        "prompt.shownotes.friendlyTone": "Vriendelijke toon shownotes",
        "prompt.shownotes.youtubeDescription": "YouTube beschrijving shownotes",
        "prompt.shownotes.engagingQuestion": "Betrokken vraag shownotes",
        "prompt.timestamps.formatAsChapters": "Tijdstempels structuur 1",
        "prompt.timestamps.detailedDescriptions": "Tijdstempels structuur 2",
        "prompt.timestamps.improveSpeakerNames": "Vervang spreker in tijdstempels",
        "prompt.newsletter.casualTone": "Informele toon nieuwsbrief",
        "prompt.newsletter.shorter": "Kortere nieuwsbrief",
        "prompt.newsletter.contentSections": "Inhoudssecties nieuwsbrief",
        "prompt.newsletter.changeName": "Verander naam in nieuwsbrief",
        "prompt.mentions.fullURL": "Volledige URL vermeldingen",
        "prompt.mentions.replaceName": "Vervang naam in vermeldingen",
        "prompt.tweets.underdogTone": "Underdog toon tweets",
        "prompt.tweets.firstPerson": "Eerste persoon tweets",
        "prompt.shortPost.relevantEmojis": "Relevante emoji's korte post",
        "prompt.shortPost.educationalTone": "Educatieve toon korte post",
        "prompt.shortPost.underdogTone": "Underdog toon korte post",
        "prompt.shortPost.firstPerson": "Eerste persoon korte post",
        "prompt.titles.youtubeOptimized": "YouTube geoptimaliseerde titels",
        "prompt.titles.startWithHowTo": "Begin met 'Hoe te' titels",
        "prompt.titles.otherOptions": "Andere opties voor titels",
        "prompt.keywords.youtubeOptimized": "YouTube geoptimaliseerde zoekwoorden",
        "prompt.keywords.separateWithCommas": "Scheiding zoekwoorden met komma's",
        "prompt.quotes.lorem1": "Lorem ipsum citaat 1",
        "prompt.quotes.lorem2": "Lorem ipsum citaat 2",
        "prompt.bulletPoints.lorem1": "Lorem ipsum opsommingsteken 1",
        "prompt.bulletPoints.lorem2": "Lorem ipsum opsommingsteken 2",
        "prompt.longPost.firstPerson": "Eerste persoon lange post",
        "prompt.longPost.relevantEmojis": "Relevante emoji's lange post",
        "prompt.longPost.changeName": "Verander naam in lange post",
        "alert.tuningInstructionsEmpty": "Afsteminstructies mogen niet leeg zijn.",
        "text.timestamps.byPodsqueeze": "Tijdstempels door PodSqueeze",
        "button.copied": "Gekopieerd",
        "button.copy": "Kopieer",
        "embed.transcript": "Transcript insluiten",
        "embed.description": "Beschrijving voor insluiten",
        "preview.title": "Voorbeeld Titel",
        "loading.regenerating": "Regenereren...",
        "placeholder.tuningInstructions": "Voer afsteminstructies in...",
        "button.saveClose": "Opslaan en Sluiten",
        "button.acceptChanges": "Wijzigingen Accepteren",
        "button.discard": "Verwerpen",
        "button.embedTranscript": "Transcript insluiten",
        "text.copiedToClipboard": "Gekopieerd naar klembord",
        "download.srtFile": "Download SRT-bestand",
        "text.forCaptions": "voor ondertitels",
        "tune.title": "Stem je resultaten af",
        "tune.description": "Pas je resultaten aan met de volgende opties.",
        "instruction.label": "Instructies:",
        "button.tuneResult": "Resultaat afstemmen",
        "instruction.saveForLater": "Opslaan voor later",
        "button.readMore": "Lees meer",
        "button.showLess": "Toon minder",
        "customPrompt.used": "Gebruikte aangepaste prompt:",
        "feedback.happyWithResults": "Ben je tevreden met de resultaten?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Vind drie goede citaten uit de transcriptie",
        "prompt.blog": "Schrijf een blogpost van 500 woorden over onderwerp X",
        "prompt.tweets": "Schrijf drie boeiende tweets uit de transcriptie",
        "transcript.autoTranscribed": "Automatisch getranscribeerd met Podsqueeze",
        "alert.emptyPrompt": "Afstemmingsinstructies mogen niet leeg zijn",
        "embed.transcript": "Embed Transcriptie",
        "embed.description": "Embed een beheersbare transcriptie met een zoekfunctie op je WordPress-site of elke HTML-ondersteunde pagina.",
        "button.copied": "Gekopieerd!",
        "button.copy": "Kopieer",
        "preview.title": "Voorbeeld",
        "edit.speakers": "Bewerk Namen van Sprekers",
        "button.saveClose": "Opslaan & Sluiten",
        "placeholder.prompt": "bijv: Vind drie goede citaten uit de transcriptie",
        "upgrade.pro": "Upgrade naar Pro om deze functie te gebruiken",
        "upgrade.link": "Upgrade naar Pro",
        "button.generate": "Genereren",
        "feedback.happy": "Ben je tevreden met de resultaten?",
        "instruction": "Instructie: ",
        "generating.results": "Resultaten Genereren",
        "full.transcription": "Volledige Transcriptie",
        "srt.file": "& SRT-bestand",
        "download.srt": "Download SRT-bestand",
        "caption.subtitles": "voor bijschriften en ondertitels.",
        "generate.from.transcript": "Genereer uit Transcriptie met Gpt-4o",
        "gpt.tweak.text": "Vraag de nieuwste GPT om de tekst naar jouw wens aan te passen. Gebruik natuurlijke taal en wees niet bang om specifiek te zijn.",
        "copied.clipboard": "Gekopieerd naar klembord",
        "transcript.public.available": "URL beschikbaar",
        "audio.notSupported": "Je browser ondersteunt het audio-element niet.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Voeg Podcastnaam toe",
        "podcast.title": "{{title}} Podcast"
      },
      "sourceModal": {
        "sourceModal.title": "Hoe heeft u over Podsqueeze gehoord?",
        "sourceModal.otherPlaceholder": "Gelieve te specificeren",
        "sourceModal.nextButton": "Volgende",
        "sourceModal.skip": "Overslaan"
      },
      "squeezeEditResults": {
        "error.processing.rss": "We ondervinden enkele problemen bij het verwerken van bepaalde RSS-feeds. Gelieve een bestand te uploaden."
      },
      "squeezeResults": {
        "copiedToClipboard": "Gekopieerd naar het klembord",
        "publicLink": "Openbaar op ",
        "createLink": "Maak een link om deze resultatenpagina te delen",
        "assembleShowNotes": "Samenstellen van shownotities",
        "convertAnotherEpisode": "Converteer een andere aflevering",
        "writtenContent": "Geschreven inhoud",
        "videoClipsAndImages": "Video Clips & Afbeeldingen",
        "editAudio": "Bewerk audio"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Zie meer en stem af",
        "see.more": "Zie meer",
        "generating": "Genereren",
        "download.all": "Download Alles",
        "full.transcription": "Volledige Transcriptie",
        "transcript.benefit": "Wist je dat het toevoegen van volledige transcripties aan je show-notities het websiteverkeer en de betrokkenheid verhoogt?",
        "learn.more": "Leer meer",
        "transcript.bonus": "Je kunt volledige transcripties als bonus aanbieden voor je podcastlidmaatschapsprogramma.",
        "show.notes": "Show-notities",
        "show.notes.engagement": "Overweeg om deze korte beschrijving aan te vullen met andere elementen in je show-notities voor een boost in betrokkenheid en SEO.",
        "show.notes.examples": "Vind inspiratie in deze 17 voorbeelden van podcast show-notities om de perfecte voor jouw podcast te maken.",
        "timestamps": "Tijdstempels",
        "timestamps.benefit": "Voeg deze tijdstempels toe aan de beschrijving van je aflevering en het zal automatisch hoofdstukken creëren op Spotify en YouTube.",
        "titles": "Titels",
        "titles.engagement": "Titels met vraagtekens en superlatieven zijn vaak bijzonder aantrekkelijk.",
        "links.and.mentions": "Links & Vermeldingen",
        "mentions.resources": "Overweeg om de onderstaande vermeldingen op te nemen in de sectie met bronnen van je show-notities.",
        "mentions.affiliate": "Bekijk of de genoemde producten affiliate-programma's hebben en overweeg om affiliate-links in je show-notities toe te voegen.",
        "mentions.social.media": "Tag de mensen die in je aflevering worden genoemd op sociale media om hen aan te moedigen om je bericht te delen en ermee te interageren.",
        "keywords": "Trefwoorden",
        "keywords.youtube": "Wanneer je je aflevering op YouTube uploadt, kopieer en plak deze trefwoorden dan in de tagsectie.",
        "keywords.social.media": "Herbruik deze trefwoorden voor sociale media hashtags.",
        "blog.post": "Blogpost",
        "blog.post.linkedin": "Overweeg om deze inhoud te gebruiken om een lange LinkedIn-post te maken,",
        "blog.post.share": "Deel deze inhoud in Reddit-gemeenschappen en Facebook-groepen die aansluiten bij het onderwerp van je podcast.",
        "newsletter": "Nieuwsbrief",
        "newsletter.content": "Sommige van onze gebruikers hergebruiken deze nieuwsbriefinhoud om meer uitgebreide afleveringbeschrijvingen voor show-notities te creëren.",
        "linkedin.and.facebook": "LinkedIn & Facebook",
        "short.post.description": "Gebruik deze korte berichten als beschrijvingen bij het delen van gerelateerde videoclips en audiogrammen op sociale media.",
        "tweets": "Tweets",
        "quotes": "Citaten",
        "bullet.points": "Opsommingstekens",
        "add.custom.result": "Voeg aanvullend resultaat toe",
        "bullet.points.skimming": "Podcasters vermelden vaak de belangrijkste afleveringsthema's als opsommingstekens in show-notities voor gemakkelijk skimmen."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Zie meer en stem af",
        "generating": "Genereren",
        "not.available.for.rss.feed": "Niet beschikbaar voor deze rss-feed",
        "regenerate.episode.upload.file": "Genereer de aflevering opnieuw en upload je audio/video bestand rechtstreeks vanaf je computer",
        "processing.difficulties": "We ondervinden enkele moeilijkheden bij het verwerken van sommige RSS-feeds. Upload alstublieft een bestand.",
        "video.clips": "Video Clips",
        "ai.short.clips": "AI Korte Clips",
        "quote.image": "Citaatafbeelding"
      },
      "title": {
        "title.text": "jouw.label"
      },
      "topbar": {
        "topbar.forYou": "Voor Jou",
        "topbar.joinPodcast": "Doe mee met onze volgende virtuele podcastbijeenkomst!",
        "topbar.saveYourSpot": "Reserveer Je Plaats",
        "topbar.dismiss": "Afwijzen"
      },
      "trackers": {
        "trackers.init": "Trackers initialiseren met cookies ingeschakeld: ",
        "trackers.loadScripts": "Tracking scripts laden..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Welkom bij Mijn Toepassing",
        "content.description": "Dit is een voorbeeldtoepassing die vertaling demonstreert.",
        "button.submit": "Indienen"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI bewerkt je clip",
        "export_clip": "Exporteer Clip",
        "ai_edit": "AI-bewerking",
        "ai_editing_clip_duration": "Dit duurt een paar seconden",
        "generating_clip": "Je clip wordt gegenereerd...",
        "generating_clip_notice": "Dit kan enkele minuten duren. We sturen je een e-mail zodra het klaar is.",
        "edit_another_video": "Je kunt hier wachten of een andere video bewerken",
        "download_video": "Download Video",
        "back_to_editing": "Terug naar bewerken",
        "export_video_button": "Exporteer Clip",
        "notice_storage": "Opmerking: We slaan je audio 30 dagen op. Na deze periode vervalt deze clip.",
        "error_generating_clip": "Fout bij het genereren van de clip",
        "error_user_support": "Probeer het opnieuw of neem contact op met onze gebruikerssupport",
        "select_template": "Selecteer sjabloon",
        "add_30s_prev": "30s van het vorige hoofdstuk",
        "add_30s_next": "30s van het volgende hoofdstuk",
        "undo": "Ongedaan maken",
        "subtitles_font": "Lettertype van ondertitels",
        "subtitles_color": "Kleur van ondertitels",
        "subtitles_box_color": "Animatiekleur",
        "adjust_podcast_title_position": "Pas de verticale positie van de podcasttitel aan",
        "adjust_subtitles_size": "Pas de grootte van ondertitels aan",
        "adjust_subtitles_vertical_position": "Pas de verticale positie van ondertitels aan",
        "remove_subtitles": "Verwijder ondertitels",
        "animated_subtitles": "Geanimeerde ondertitels",
        "upgrade_here": "Upgrade hier",
        "remove_logo": " om logo te verwijderen",
        "remove_podsqueeze_logo": "Verwijder podsqueeze-logo",
        "aspect_ratio": "Beeldverhouding",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Verhalen, YouTube Shorts, TikTok",
        "episode_title": "Afleveringstitel",
        "podcast_title": "Podcasttitel",
        "titles_font": "Lettertype van titels",
        "title_colors": "Kleuren van podcast/afleveringstitels",
        "video_fit": "Video-inpassing",
        "adjust_horizontal_position": "Pas de horizontale positie aan",
        "adjust_vertical_position": "Pas de verticale positie aan",
        "adjust_video_zoom": "Pas de zoom van de video aan",
        "adjust_video_width": "Pas de breedte van de video aan",
        "adjust_video_height": "Pas de hoogte van de video aan",
        "background_color": "Achtergrondkleur",
        "edit_clip": "Bewerk Clip",
        "edit_layout": "Bewerk Layout",
        "choose_short": "Kies een Korte",
        "edit_audio": "Bewerk Audio",
        "framing": "Kadering",
        "background": "Achtergrond",
        "text_style": "Tekststijl",
        "music": "Muziek",
        "choose_chapter": "Kies een hoofdstuk",
        "clips_left": "Je hebt",
        "apply_layout": "Layout toepassen",
        "clips_left_number": "clips over",
        "need_more_clips": "Meer clips nodig? Upgrade je plan hier",
        "download_srt_file": "Download SRT-bestand",
        "track_selected": "Nummer: ",
        "no_background_music": "Geen achtergrondmuziek geselecteerd",
        "volume": "Volume:",
        "remove": "Verwijder",
        "track_ambient_piano": "Ambient piano en strijkers",
        "track_deep_meditation": "Diepe meditatie",
        "track_chill_upbeat": "Voor haar chill upbeat",
        "track_inspiring_ambient": "Inspirerende cinematische ambient",
        "track_just_relax": "Gewoon ontspannen",
        "track_movement": "Beweging",
        "track_once_in_paris": "Eens in Parijs",
        "track_perfect_beauty": "Perfecte schoonheid",
        "track_summer_adventures": "Zomeravonturen",
        "track_sunset_groove": "Zonsondergang groove",
        "track_tvari_cafe": "Tvari tokyo café",
        "track_short_piano_intermezzo": "Kort Piano Intermezzo",
        "track_dramatic_background": "Dramatische Achtergrondmuziek",
        "track_dramatic_hiphop": "Dramatische Hip-Hop Jazz",
        "track_emotional_orchestra": "Emotioneel Orkest",
        "track_halloween_short": "Halloween Muziek",
        "track_improvisation_037": "Jazz Improvisatie",
        "track_inspiration_piano": "Inspirerende Piano",
        "track_medieval_extract": "Middeleeuwse Muziek",
        "track_short_8": "Korte Ambient Track",
        "track_flute": "Vredige Fluit",
        "track_piano_guitar_duet": "Piano-Gitaar Duet",
        "track_intro_jazz": "Intro Jazz",
        "track_romantic_jazz": "Romantische Jazz",
        "recommended_for_youtube": "Aanbevolen voor YouTube",
        "turn_into_short_clip": "Verander deze clip in een korte clip (<60s)",
        "browser_not_support_audio": "Je browser ondersteunt het audio-element niet.",
        "watch_tutorial": "Bekijk deze tutorial",
        "audiogram_maker": "over hoe je het beste uit onze audiogrammaker haalt",
        "store_audio_notice": "Opmerking: We slaan je audio 30 dagen op.",
        "clip_maker": "over hoe je het beste uit onze clipmaker haalt",
        "split_screen_mode": "Splitschermmodus",
        "none": "Geen",
        "vertical_split": "Verticale splitsing",
        "horizontal_split": "Horizontale splitsing",
        "layers": "Gebruik de onderstaande lagen om ze naar voren of achteren te verplaatsen.",
        "screen_1_horizontal_position": "Horizontale positie scherm 1",
        "screen_2_horizontal_position": "Horizontale positie scherm 2",
        "track_mysterious_dark_background": "Mysterieuze donkere achtergrond",
        "track_acoustic_ambient_inspiration": "Akoestische ambient inspiratie",
        "track_aristocracy_classical": "Aristocratie klassiek",
        "track_folk_music_river_knows_my_name": "Folkmuziek - De rivier kent mijn naam",
        "track_funy_adventure": "Leuk avontuur",
        "track_energetic_sports_rock_trailer": "Energieke sport rock trailer",
        "track_fun_upbeat_energetic_pop_rock": "Leuke opgewekte energieke pop rock",
        "track_epic_emotional_inspirational": "Episch emotioneel inspirerend",
        "track_inspirational_epic": "Inspirerend episch",
        "all_music": "Alle muziek",
        "energetic_music": "Energiek",
        "inspirational_music": "Inspirerend",
        "ambient_music": "Ambient",
        "chill_music": "Ontspannen",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Eigenzinnig",
        "dramatic_music": "Dramatisch",
        "acoustic_music": "Akoestisch",
        "classical_music": "Klassiek",
        "categories": "Categorieën",
        "select_track": "Track selecteren",
        "upload_music": "Muziek uploaden",
        "my_music": "Mijn muziek",
        "downloading": "Downloaden...",
        "download_again": "Opnieuw downloaden",
        "download": "Downloaden",
        "download_failed_alert": "Kan video niet downloaden. Probeer het opnieuw.",
        "translate_subtitles": "Ondertitels Vertalen",
        "translate_to": "Vertalen naar",
        "select_language": "Selecteer Taal",
        "select_new_language": "Selecteer nieuwe taal",
        "translating": "Vertalen...",
        "translation_complete": "Vertaling Voltooid",
        "error_translation": "Fout tijdens vertaling. Probeer het opnieuw.",
        "original_language": "Origineel"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Afleveringstitel"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Je hebt nog geen inhoud.",
        "userPodcastsInfo.generateContent": "Genereer je eerste inhoud",
        "placeholder.search_folders": "Zoek mappen...",
        "search.no_results": "Geen mappen komen overeen met je zoekopdracht."
      },
      "landingPageModal": {
        "upload.error": "Uploaden van afbeelding mislukt: ",
        "upload.image.file": "Gelieve een afbeeldingsbestand te uploaden.",
        "upgrade.pro.message": "Pagina-aanpassing is alleen beschikbaar voor Pro- en Agency-accounts",
        "upgrade.now": "Nu upgraden",
        "upgrade.unique.landing.page": " en maak een unieke aflevering landingspagina.",
        "logo.recommendation": "Aanbevolen logo hoogte 200px",
        "social.links.top.menu": "Sociale links in het bovenste menu",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Voer LinkedIn-link in",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Voer Facebook-link in",
        "saving...": "Opslaan...",
        "save": "Opslaan",
        "saved.successfully": "Succesvol opgeslagen!",
        "uploading.image": "Afbeelding aan het uploaden...",
        "upload.episode.cover": "Upload Aflevering Cover",
        "upload.logo": "Upload Logo",
        "where.listen.episode": "Waar kunnen we deze aflevering nog meer beluisteren?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Voer YouTube-link in",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Voer Apple Podcasts-link in",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Voer Spotify-link in",
        "image.size.recommendation": "Aanbevolen grootte 1000x1000px",
        "primary.color.label": "Primaire Kleur",
        "header.background.color": "Achtergrondkleur van de header en links.",
        "landing.page.customization": "Aanpassing van de landingspagina",
        "create.branded.landing.page": "Maak een mooie gebrandmerkte landingspagina om te delen met je luisteraars",
        "episode.image": "Aflevering Afbeelding",
        "episode.links": "Aflevering Links",
        "page.header": "Pagina Header",
        "page.color": "Pagina Kleur",
        "visit.landing.page": "Bezoek Landingspagina"
      },
      "page": {
        "loading.dashboard": "Dashboard laden",
        "convert.new.episode": "Nieuwe aflevering converteren",
        "convert.audio.or.video": "Audio of video converteren",
        "minutes.left": "Je hebt",
        "need.more.minutes": "Meer minuten nodig?",
        "upgrade.plan": "Upgrade hier je abonnement.",
        "your.podcasts": "Jouw podcasts",
        "podsqueeze.results.page": "Podsqueeze Resultatenpagina",
        "access.podsqueeze.results": "Toegang tot podsqueeze-resultaten voor deze aflevering. Je kunt alle gegenereerde inhoud bekijken"
      },
      "podcast": {
        "confirm.delete_episode": "Weet je zeker dat je deze aflevering wilt verwijderen?",
        "alert.something_wrong": "Er is iets misgegaan. Probeer het opnieuw.",
        "confirm.delete_folder": "Weet je zeker dat je deze map wilt verwijderen?",
        "loading.episodes": "Afleveringen laden...",
        "folder.empty": "Deze map is leeg.",
        "content.no_content": "Geen inhoud beschikbaar.",
        "content.generate_first": "Genereer je eerste podcast.",
        "button.personalize_ai": "Personaliseer met AI",
        "button.edit_website": "Bewerk Website",
        "button.visit_website": "Bezoek Website",
        "button.generate_website": "Genereer Website",
        "placeholder.search": "Zoeken...",
        "label.sort_by": "Sorteer op",
        "label.last_episodes_loaded": "Laatste afleveringen geladen",
        "button.load_all_episodes": "Laad alle afleveringen",
        "loading": "Laden...",
        "add.new.episode": "Voeg Nieuwe Aflevering Toe",
        "order.newest": "Nieuwste eerst",
        "order.oldest": "Oudste eerst",
        "order.a_to_z": "A tot Z",
        "order.z_to_a": "Z tot A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Maak een nieuwe podcastmap:",
        "folder.name.placeholder": "Naam van de map",
        "create.button": "Aanmaken"
      },
      "podcastLandingModal": {
        "upload.image.error": "Upload een afbeeldingsbestand",
        "podcast.cover.title": "Podcast Coverafbeelding",
        "podcast.cover.upload": "Upload hier je podcast coverafbeelding. Deze zal prominent op je landingspagina worden weergegeven.",
        "upload.image.uploading": "Afbeelding aan het uploaden...",
        "podcast.cover.upload.button": "Upload Coverafbeelding",
        "podcast.cover.recommended.size": "Aanbevolen grootte: 1400x1400 pixels",
        "profile.info.title": "Profielinformatie",
        "profile.info.upload": "Voeg je profielfoto en naam toe om je landingspagina te personaliseren.",
        "profile.upload.button": "Upload Profielfoto",
        "profile.name.label": "Profielnaam",
        "profile.name.placeholder": "Voer je naam in",
        "platform.links.title": "Platformlinks",
        "platform.links.upload": "Voeg links naar je podcast op verschillende platforms toe.",
        "platform.links.youtube_link": "YouTube-link",
        "platform.links.youtube_link.placeholder": "Voer YouTube-link in",
        "platform.links.spotify_link": "Spotify-link",
        "platform.links.spotify_link.placeholder": "Voer Spotify-link in",
        "platform.links.apple_podcast_link": "Apple Podcast-link",
        "platform.links.apple_podcast_link.placeholder": "Voer Apple Podcast-link in",
        "platform.links.linkedin_link": "LinkedIn-link",
        "platform.links.linkedin_link.placeholder": "Voer LinkedIn-link in",
        "platform.links.facebook_link": "Facebook-link",
        "platform.links.facebook_link.placeholder": "Voer Facebook-link in",
        "platform.links.twitter_link": "Twitter-link",
        "platform.links.twitter_link.placeholder": "Voer Twitter-link in",
        "call.to.action.title": "Oproep tot Actie",
        "call.to.action.upload": "Stel je oproep-tot-actie-knop in voor de landingspagina.",
        "call.to.action.button.text.label": "Knoptekst",
        "call.to.action.button.text.placeholder": "Voer knoptekst in",
        "call.to.action.button.link.label": "Knoplink",
        "call.to.action.button.link.placeholder": "Voer knoplink in",
        "color.styles.title": "Kleurstijlen",
        "color.styles.upload": "Pas de kleuren van je landingspagina aan.",
        "color.styles.primary.label": "Primaire Kleur",
        "color.styles.primary.description": "Kies de primaire kleur voor je landingspagina",
        "color.styles.secondary.label": "Secundaire Kleur",
        "color.styles.secondary.description": "Kies de secundaire kleur voor je landingspagina",
        "podcast.info.title": "Podcastinformatie",
        "podcast.info.upload": "Bewerk de details van je podcast.",
        "podcast.info.name.label": "Podcastnaam",
        "podcast.info.name.placeholder": "Voer podcastnaam in",
        "podcast.info.description.label": "Podcastbeschrijving",
        "podcast.info.description.placeholder": "Voer podcastbeschrijving in",
        "edit.website.title": "Website Bewerken",
        "generate.website.title": "Website Genereren",
        "for": "voor",
        "saving": "Opslaan...",
        "save.changes": "Wijzigingen Opslaan",
        "generate.website": "Website Genereren",
        "changes.saved.success": "Wijzigingen succesvol opgeslagen!",
        "podcast.cover.menu": "Podcast Cover",
        "podcast.info.menu": "Podcast Info",
        "profile.menu": "Profiel",
        "platform.links.menu": "Platformlinks",
        "call.to.action.menu": "Oproep tot Actie",
        "color.styles.menu": "Kleurstijlen",
        "logo.menu": "Logo",
        "logo.title": "Logo Uploaden",
        "logo.upload": "Upload hier je podcast logo. Dit logo wordt weergegeven op je landingspagina.",
        "logo.upload.button": "Logo Uploaden",
        "platform.links.description": "Voeg links naar je podcast op verschillende platforms toe.",
        "social.links.menu": "Sociale Links",
        "social.links.title": "Sociale Media Links",
        "social.links.description": "Voeg links naar je sociale media profielen toe.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Voer LinkedIn-link in",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Voer Facebook-link in",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Voer Twitter-link in",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Voer Instagram-link in",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Voer YouTube-link in",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Voer Spotify-link in",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Voer Apple Podcast-link in",
        "view.website": "Bekijk Website"
      },
      "podcastMoveModal": {
        "move.episode.label": "Verplaats deze aflevering naar:",
        "move.episode.instruction": "Je kunt een nieuwe naam typen om een map te maken.",
        "move.episode.button": "Verplaatsen",
        "move.episode.error.selectFolder": "Selecteer een map om de aflevering te verplaatsen."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "AI-instellingen voor de {{podcastTitle}} podcast",
        "ai.customize.writing.style": "Pas je AI-schrijfstijl aan",
        "ai.content.writing.preference": "Hoe wil je dat Podsqueeze je inhoud schrijft?",
        "ai.voice.placeholder": "Voorbeeld: Professionele maar vriendelijke toon. De luisteraars zijn podcasters. Schrijf in de eerste persoon.",
        "ai.character.limit.reached": "Je hebt je tekenlimiet van 50 bereikt. ",
        "ai.upgrade.now": "Upgrade nu",
        "ai.fix.transcript.misspells": "Corrigeer spelfouten in het transcript",
        "ai.enter.misspelled.words": "Schrijf de woorden op die de AI vaak verkeerd spelt in deze afleveringen van de podcast, bijv. namen",
        "ai.enter.word.press.enter": "Voer een woord in en druk op Enter",
        "ai.add.word": "Voeg woord toe",
        "ai.tag.limit.reached": "Limiet van 1 tag bereikt. ",
        "ai.save": "Opslaan",
        "ai.save.close": "Opslaan & Sluiten"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Afleveringstitel",
        "selectedEpisode.podcastName": "Podcastnaam",
        "selectedEpisode.showNotes": "Show-notities",
        "selectedEpisode.timestamp": "Tijdstempel",
        "selectedEpisode.staticTimestamp": "Statische tijdstempel",
        "selectedEpisode.mentions": "Vermeldingen",
        "selectedEpisode.newsletter": "Nieuwsbrief",
        "selectedEpisode.titles": "Titels",
        "selectedEpisode.tweeter": "Tweeter",
        "selectedEpisode.shortPost": "Korte post",
        "selectedEpisode.transcription": "Transcriptie",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Trefwoorden",
        "selectedEpisode.quotes": "Citaties",
        "selectedEpisode.longPost": "Lange post",
        "selectedEpisode.bulletPoints": "Opsommingstekens",
        "selectedEpisode.publicLink": "Openbare link",
        "selectedEpisode.embeddedId": "Ingebedde ID",
        "selectedEpisode.episodeUrl": "Afleverings-URL"
      },
      "sidebar": {
        "tools": "Hulpmiddelen",
        "find.podcast.topic.ideas": "Vind Podcast Onderwerp Ideeën",
        "podcast.thumbnail.maker": "Podcast Thumbnail Maker",
        "podcast.seo.optimizer": "Podcast SEO Optimizer",
        "account": "Account",
        "payment.settings": "Betalingsinstellingen",
        "support": "Ondersteuning",
        "logout": "Uitloggen",
        "plan": "Plan",
        "resets.in": "Reset in",
        "api.access": "API Access",
        "days": "dagen en",
        "hours": "uren",
        "upgrade.plan": "Upgrade Plan"
      },
      "updateEmailModal": {
        "email.validation.error": "Voer een geldig e-mailadres in.",
        "email.change.confirm": "Weet u zeker dat u uw e-mailadres wilt wijzigen?",
        "email.change.success": "Uw e-mailadres is succesvol gewijzigd!",
        "email.in.use.error": "Dit e-mailadres is al in gebruik. Probeer een ander.",
        "email.recent.login.error": "Voordat u met deze actie doorgaat, log alstublieft opnieuw in met het huidige e-mailadres.",
        "email.invalid.error": "Ongeldig e-mailadres. Probeer een ander.",
        "subscription.cancel.error": "Annuleer eerst uw actieve betaalde abonnement.",
        "account.delete.confirm": "Weet u zeker dat u uw account wilt verwijderen?\n\nDeze actie kan niet ongedaan worden gemaakt.",
        "account.delete.success": "Uw account is succesvol verwijderd.",
        "account.delete.error": "Er is iets misgegaan en we konden uw account niet verwijderen.\n\nNeem alstublieft contact op met onze gebruikerssupport.",
        "subscription.cancel": "Abonnement Annuleren",
        "account.delete": "Account Verwijderen",
        "account.delete.warning": "Het verwijderen van uw account is onomkeerbaar en zal al uw inhoud en inloggegevens permanent wissen. Ga voorzichtig te werk, aangezien deze actie niet ongedaan kan worden gemaakt.",
        "current.account.email": "Huidig Account E-mailadres",
        "enter.new.email": "Voer uw nieuwe account e-mailadres in",
        "update": "Bijwerken",
        "change.password": "Wachtwoord Wijzigen",
        "payment.settings": "Betalingsinstellingen"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "afleveringTitel"
      },
      "episodelist": {
        "loading.episodes": "Afleveringen laden",
        "no.episodes.found": "Geen afleveringen gevonden. Probeer het opnieuw met een geldige RSS-id",
        "select.episode": "Selecteer de aflevering waarvoor je inhoud wilt maken"
      },
      "interfaces": {
        "user.activePlan.tier": "Niveau",
        "user.activePlan.creationDate": "Aanmaakdatum",
        "user.activePlan.minutesAvailable": "Beschikbare Minuten"
      },
      "loadingbar": {
        "loadingbar.magic": "We zijn nog steeds onze magie aan het doen ✨",
        "loadingbar.longer": "Sommige afleveringen duren iets langer... 🐌",
        "loadingbar.hardwork": "Onze servers werken hard 🦾"
      },
      "page": {
        "main.background": "Achtergrond van de hoofdcomponent"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Fout: Toegang tot de microfoon of camera is geweigerd.",
        "microphone.camera.not.found": "Fout: Geen microfoon of camera gevonden.",
        "microphone.camera.not.readable": "Fout: De microfoon of camera is niet leesbaar.",
        "microphone.camera.access.error": "Fout: Er is een onbekende fout opgetreden bij het toegang krijgen tot de microfoon of camera.",
        "media.not.recorded": "Fout: Er is geen media opgenomen.",
        "upload.failed": "Fout: Uploaden is mislukt.",
        "upload.success": "Succes: Upload is succesvol voltooid.",
        "upload.in.progress": "Uploaden is bezig...",
        "upload.button": "Opname Uploaden",
        "stop.recording": "Opname Stoppen",
        "record.audio": "Audio Opnemen",
        "record.audio.video": "Audio Opnemen met Video",
        "record.again": "Opname Opnieuw Starten",
        "episode.language": "Selecteer Aflevering Taal"
      },
      "selectBox": {
        "language.english": "Engels",
        "language.arabic": "Arabisch",
        "language.bulgarian": "Bulgaars",
        "language.catalan": "Catalaans",
        "language.croatian": "Kroatisch",
        "language.czech": "Tsjechisch",
        "language.danish": "Deens",
        "language.dutch": "Nederlands",
        "language.finnish": "Fins",
        "language.french": "Frans",
        "language.german": "Duits",
        "language.greek": "Grieks",
        "language.hindi": "Hindi",
        "language.hungarian": "Hongaars",
        "language.indonesian": "Indonesisch",
        "language.italian": "Italiaans",
        "language.japanese": "Japans",
        "language.korean": "Koreaans",
        "language.lithuanian": "Litouws",
        "language.latvian": "Lets",
        "language.malay": "Maleis",
        "language.mandarin": "Mandarijn",
        "language.norwegian": "Noors",
        "language.polish": "Pools",
        "language.portuguese": "Portugees",
        "language.romanian": "Roemeens",
        "language.russian": "Russisch",
        "language.slovak": "Slowaaks",
        "language.slovenian": "Sloveens",
        "language.spanish": "Spaans",
        "language.swedish": "Zweeds",
        "language.tamil": "Tamil",
        "language.turkish": "Turks",
        "language.ukrainian": "Oekraïens",
        "language.bashkir": "Bashkir",
        "language.basque": "Baskisch",
        "language.belarusian": "Wit-Russisch",
        "language.cantonese": "Kantonees",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estisch",
        "language.galician": "Galicisch",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongools",
        "language.persian": "Perzisch",
        "language.thai": "Thais",
        "language.uyghur": "Oeigoers",
        "language.vietnamese": "Vietnamees",
        "language.welsh": "Welsh"
      },
      "selectedepisode": {
        "processing.episode": "Aflevering verwerken",
        "processing.time": "Het duurt meestal tussen de 5 - 10 minuten",
        "email.notification": "Je kunt dit venster sluiten. We sturen je een e-mail zodra het klaar is. Je inhoud zal ook beschikbaar zijn op je dashboard.",
        "convert.another.episode": "Converteer een andere aflevering",
        "technical.difficulties": "Oeps! We ondervinden enkele technische problemen. Wees gerust, ons team is ermee bezig! Probeer het later opnieuw.",
        "no.discount": "Maak je geen zorgen, we zullen geen minuten korten!",
        "high.demand": "We ervaren een hogere vraag dan normaal, dus het kan langer duren dan gebruikelijk om je verzoek te verwerken. Onze excuses voor het ongemak!",
        "email.ready": "We sturen je een e-mail zodra het klaar is. Je kunt je resultaten ook op je dashboard bekijken.",
        "select.podcast.folder": "Selecteer de podcastmap waartoe deze aflevering behoort, of maak een nieuwe aan door een naam in te voeren.",
        "give.voice": "Voeg je eigen stem toe",
        "generate.content": "Inhoud genereren",
        "not.enough.minutes.title": "Je hebt niet genoeg minuten",
        "not.enough.minutes.message": "Je hebt niet genoeg minuten om deze aflevering te converteren. Aktualiseer je plan.",
        "upgrade.plan": "Aktualiseer je plan",
        "convert.shorter.episode": "Converteer een kortere aflevering",
        "content.ready": "Je inhoud is klaar!",
        "ask.ai.tune": "Je kunt de AI nog steeds vragen om elke inhoud aan te passen zodat deze beter aan je behoeften voldoet.",
        "error.title": "Fout",
        "convert.another.file": "Converteer een ander bestand"
      },
      "submitfile": {
        "file.size.exceeded.free": "Bestandsgrootte overschrijdt de maximale limiet van 4 GB. <p>Gelieve <a href='/pricing'><b><u>te upgraden om grotere bestanden te uploaden</u></b></a></p>",
        "file.size.exceeded.paid": "Bestandsgrootte overschrijdt de maximale limiet van 10 GB. <p>Gelieve een kleiner bestand te selecteren.</p>",
        "file.upload.invalid": "Gelieve een audio- of videobestand te uploaden",
        "upload.in.progress": "Bestand wordt geüpload. Sluit dit venster alstublieft niet.",
        "upload.button": "Uploaden & Genereren",
        "close.button": "Sluiten",
        "upgrade.message.free": "Meer uploads zijn alleen beschikbaar voor betaalde abonnementen.",
        "upgrade.now.button": "Upgrade Nu",
        "pricing.info": "vanaf $12/maand",
        "upload.file.label": "Upload een audio- of videobestand",
        "max.file.size.free": "(max 4 gb)",
        "max.file.size.paid": "(max 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze genereert audiogrammen voor audiobestanden en korte clips voor videobestanden",
        "file.placeholder": "Uw MP3/WAV-bestand",
        "episode.language.label": "Aflevering Taal",
        "select.folder.label": "Selecteer of maak een map",
        "multiple.files.selected": "{{count}} bestanden geselecteerd",
        "clear.all": "Alles wissen",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Selecteer meerdere bestanden",
        "file.upload.error": "Fout bij uploaden van bestand",
        "file.upload.success": "Bestand succesvol geüpload",
        "file.upload.processing": "Bestand verwerken",
        "click.to.upload": "Klik om te uploaden",
        "click.to.upload.multiple": "Klik om meerdere bestanden te uploaden",
        "enter.url": "URL invoeren",
        "upload.file": "Bestand uploaden",
        "media.url.label": "Media URL",
        "media.url.help": "Voer de URL van uw audio- of videobestand in. Wij zullen het voor u downloaden en verwerken.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Afleveringsnaam",
        "url.input.required": "Voer een media-URL in",
        "url.upload.error": "Kan media niet uploaden vanaf URL. Controleer de URL en probeer het opnieuw.",
        "supported.formats": "Ondersteunde formaten",
        "uploading": "Uploaden...",
        "media.url.requirements": "URL moet een directe link zijn naar een openbaar mediabestand (geen webpagina)"
      },
      "submitrssid": {
        "error.selectRss": "Selecteer een geldige RSS uit de dropdown",
        "label.insertRssFeed": "Voeg je RSS-feed toe",
        "placeholder.insertRssFeed": "Voeg je RSS-feed toe",
        "label.searchByPodcast": "Zoek op podcastnaam in plaats daarvan",
        "label.searchForPodcast": "Zoek naar je podcastnaam",
        "placeholder.searchForPodcast": "Zoek naar een podcast",
        "label.cantFindPodcast": "Kun je je podcast niet vinden? ",
        "label.clickHereUseRss": "Klik hier om in plaats daarvan je RSS-feed te gebruiken",
        "label.selectedPodcast": "Geselecteerde podcast",
        "label.episodeLanguage": "Taal van de aflevering",
        "button.seeAllEpisodes": "Bekijk alle afleveringen",
        "select.folder.label": "Selecteer of maak een map"
      },
      "submitsection": {
        "search.podcast": "Zoek je podcast",
        "upload.audio.video": "Upload audio of video",
        "record.audio": "Opnemen audio",
        "youtube.video": "YouTube Link",
        "create.content": "Laten we content maken voor je podcast!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Voer de YouTube-video-URL in",
        "error.insertYouTubeUrl": "Voer alstublieft een YouTube-URL in.",
        "label.insertYouTubeUrl": "Voer YouTube-URL in",
        "button.loading": "Laden...",
        "message.downloadingFile": "Bestand downloaden...",
        "error.processingFailed": "Fout: verwerking van video mislukt.",
        "button.submitYouTubeVideo": "Dien YouTube-video in",
        "error.youtubeVideoNotAvailable": "Deze YouTube-video is niet beschikbaar voor download. Upload uw audio of video direct naar Podsqueeze of gebruik eerst een YouTube-downloader. Bedankt voor uw geduld.",
        "episode.language.label": "Gebruikte taal",
        "select.folder.label": "Selecteer of maak een map"
      },
      "tabs": {
        "tab.label.tab1": "Tabblad 1",
        "tab.label.tab2": "Tabblad 2",
        "tab.label.tab3": "Tabblad 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Haal het meeste uit Podsqueeze",
        "tutorial.chapter.introduction": "Inleiding",
        "tutorial.chapter.bestShowNotes": "Krijg de beste show-notities en tijdstempels",
        "tutorial.chapter.blogPosts": "Gebruik maken van blogposts en nieuwsbrieven",
        "tutorial.chapter.editingTranscripts": "Transcripties insluiten en bewerken",
        "tutorial.chapter.personalizingAI": "AI personaliseren en je eigen stem geven",
        "tutorial.chapter.speedingUpNotes": "Show-notities versnellen",
        "tutorial.chapter.creatingClips": "Video's en afbeeldingen maken",
        "tutorial.chapter.generatingLandingPage": "Een landingspagina genereren",
        "tutorial.chapter.shareResults": "De resultaten delen met je team",
        "tutorial.closeVideoCheckbox": "Sluit video zodra de eerste resultaten klaar zijn"
      },
      "uploadloadingbar": {
        "upload.loading": "Laden..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Neem contact met ons op",
        "contact.section.email": "Stuur ons een e-mail op support@podsqueeze.com",
        "contact.section.tiago.role": "Mede-oprichter",
        "contact.section.joao.role": "Mede-oprichter",
        "contact.section.image.alt.sendMessage": "Stuur bericht",
        "contact.section.image.alt.tiago": "Mede-oprichter Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Mede-oprichter Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Neem contact met ons op",
        "contact.section.email": "Stuur ons een e-mail op support@podsqueeze.com",
        "contact.section.tiago.role": "Mede-oprichter",
        "contact.section.joao.role": "Mede-oprichter",
        "contact.section.image.alt.sendMessage": "Stuur bericht",
        "contact.section.image.alt.tiago": "Mede-oprichter Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Mede-oprichter Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Sluit je aan bij 20.000 contentmakers en podcastprofessionals die Podsqueeze gebruiken",
        "content.creators": "Contentmakers",
        "podcast.managers": "Podcastmanagers",
        "producers.studios": "Producenten & Studio's",
        "for.podcasters": "VOOR PODCASTERS, PODCASTMANAGERS EN BUREAUS",
        "manage.content.creation": "Beheer moeiteloos contentcreatie voor",
        "multiple.podcasts": "meerdere podcasts",
        "podsqueeze.description": "Podsqueeze is een krachtige tool voor alle podcastprofessionals. Of je nu een solo-podcaster, podcastmanager of bureau bent, Podsqueeze biedt alle functies die je nodig hebt om je workflow voor contentcreatie van podcasts te stroomlijnen.",
        "create.podcast.folders": "Maak podcastmappen aan om je afleveringen georganiseerd te houden.",
        "share.content.page": "Deel eenvoudig je contentpagina met klanten en team",
        "tune.ai.voice": "Stem de AI-stem af voor elke show die je beheert",
        "plan.content.episodes": "Plan de content voor de volgende afleveringen met onze geavanceerde",
        "podcast.topics.finder": "podcastonderwerpenzoeker",
        "podsqueeze.testimonial": "De mogelijkheid van Podsqueeze om prompts te gebruiken om de content van elke podcast die we beheren af te stemmen en deze op te slaan voor toekomstige afleveringen, stelt ons in staat om de stemmen van elke show consistent te houden. Dit is een elitefunctie die we in geen enkele andere tool konden vinden.",
        "coo.podigy": "COO bij Podigy Podcasts",
        "agenciessection.joinCreators": "Sluit je aan bij 20.000 contentmakers en podcastprofessionals die Podsqueeze gebruiken",
        "agenciessection.contentCreators": "Contentmakers",
        "agenciessection.podcastManagers": "Podcastmanagers",
        "agenciessection.producersStudios": "Producenten & Studio's",
        "agenciessection.forPodcasters": "VOOR PODCASTERS, PODCASTMANAGERS EN BUREAUS",
        "agenciessection.manageContent": "Beheer moeiteloos contentcreatie voor",
        "agenciessection.multiplePodcasts": "meerdere podcasts",
        "agenciessection.podsqueezeDescription": "Podsqueeze is een krachtige tool voor alle podcastprofessionals. Of je nu een solo-podcaster, podcastmanager of bureau bent, Podsqueeze biedt alle functies die je nodig hebt om je workflow voor contentcreatie van podcasts te stroomlijnen.",
        "agenciessection.createPodcastFolders": "Maak podcastmappen aan om je afleveringen georganiseerd te houden.",
        "agenciessection.shareContent": "Deel eenvoudig je contentpagina met klanten en team",
        "agenciessection.tuneAI": "Stem de AI-stem af voor elke show die je beheert",
        "agenciessection.planContent": "Plan de content voor de volgende afleveringen met onze geavanceerde",
        "agenciessection.podcastTopicsFinder": "podcastonderwerpenzoeker",
        "agenciessection.podsqueezeQuote": "De mogelijkheid van Podsqueeze om prompts te gebruiken om de content van elke podcast die we beheren af te stemmen en deze op te slaan voor toekomstige afleveringen, stelt ons in staat om de stemmen van elke show consistent te houden. Dit is een elitefunctie die we in geen enkele andere tool konden vinden.",
        "agenciessection.coO": "COO bij Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NIEUWE FUNCTIE",
        "seamless.editing": "Naadloze bewerking en audioverbetering voor natuurlijke, ",
        "high.quality.results": " hoogwaardig resultaat",
        "experience.seamless.audio.editing": "Ervaar naadloze audio-bewerking met geavanceerde AI-algoritmen voor topopnames. ",
        "remove.ums": "Verwijder um's",
        "enhance.sound.quality": ", stiltes en verbeter de geluidskwaliteit met slechts één klik.",
        "enhance.audio.now": "Verbeter audio nu",
        "sample.audio.recorded": "Voorbeeldaudio, rechtstreeks opgenomen vanaf de telefoon.",
        "original.recording": "Oorspronkelijke opname",
        "audio.after.ai.edit": "Audio na AI-bewerking en verbetering",
        "experience.audio.editing": "Ervaar naadloze audio-bewerking met geavanceerde AI-algoritmen voor topopnames. "
      },
      "home-blogsection": {
        "more.resources.label": "MEER BRONNEN VOOR JE PODCAST",
        "learn.how.to.get.most": "Leer hoe je het meeste uit",
        "your.content": "je content",
        "get.most.out.of.ai.content": "Haal het meeste uit AI-gegenereerde content voor je podcast",
        "welcome.to.podsqueeze": "Welkom bij Podsqueeze – de eenvoudigste manier om je podcast te transcriberen en boeiende content te creëren...",
        "will.google.penalize.ai.content": "Zal Google je AI-gegenereerde content straffen?",
        "ai.content.discussion": "De opkomst van AI-gegenereerde content heeft discussies aangewakkerd en zorgen geuit onder contentmakers, marketeers en SEO...",
        "what.is.rss.feed": "Wat is een RSS-feed voor podcasts en hoe gebruik je het",
        "rss.feed.benefits": "Als podcaster heb je misschien eerder de term 'RSS-feed' gehoord, maar je weet misschien niet precies wat het is of hoe het kan helpen...",
        "visit.blog": "Bezoek Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS & AUDIOGRAMMEN",
        "clipsAndAudiograms.subtitle": "Herbruik je podcast moeiteloos in clips",
        "clipsAndAudiograms.description": "Kies eenvoudig een hoofdstuk uit je aflevering en exporteer het als een clip of audiogram voor TikTok, Instagram en YouTube Shorts. Kies een sjabloon en pas het aan naar jouw stijl.",
        "clipsAndAudiograms.createClips": "Maak nu Clips",
        "textEditor.title": "Tekstgebaseerde editor",
        "textEditor.description": "Fijn afstemmen van je clips en audiogrammen direct vanuit de ondertitels. Bewerk ondertitels en knip je video door specifieke woorden te verwijderen.",
        "oneClickShorts.title": "Eén klik shorts (<60s)",
        "oneClickShorts.description": "Laat AI de montage voor je doen. Met de druk op een knop zal AI elk hoofdstuk van je aflevering inkorten tot onder de 60 seconden, klaar om te plaatsen als een YouTube Short of TikTok clips."
      },
      "home-conatctsection": {
        "contact.section.title": "Neem contact op met de Oprichters",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Ontwikkelaar & Podcaster",
        "contact.section.joao.role": "- UX/UI Ontwerper"
      },
      "home-contentexplanation": {
        "wide.variety.content": "BREDE VARIËTEIT AAN INHOUD",
        "generate.content": "Genereer inhoud met",
        "one.click": " één klik!",
        "transcript.srt": "Transcript & SRT",
        "transcript.description": "Krijg het volledige transcript van je podcastaflevering, samen met een SRT-bestand dat klaar is voor het genereren van bijschriften en ondertitels.",
        "show.notes": "Show-notities",
        "show.notes.description": "Vat de belangrijkste onderwerpen van je aflevering samen en maak het beter doorzoekbaar",
        "timestamps": "Tijdstempels",
        "timestamps.description": "Creëer hoofdstukken met tijdstempels en leid luisteraars naar specifieke segmenten van je podcastaflevering",
        "blog.social.posts": "Blog- en sociale berichten",
        "blog.social.posts.description": "Plaats over je podcastaflevering overal en krijg nieuwe luisteraars",
        "newsletter": "Nieuwsbrief",
        "newsletter.description": "Houd je luisteraars op de hoogte van nieuwe afleveringen",
        "titles.more": "Titels & meer!",
        "titles.more.description": "Genereer pakkende titels, citaten, opsommingstekens, zoekwoorden en meer!",
        "see.sample.content": "ZIEN VOORBEELD INHOUD",
        "wannabe.entrepreneur": "Wannabe Ondernemer - #299 Podsqueeze heeft net $100.000 aan jaarlijkse omzet bereikt!",
        "making.space": "Making Space - Steve Harvey: “Je kunt net zo goed doorgaan”",
        "modern.wisdom": "Moderne Wijsheid - Erik Hoel - Een Gids Voor Het Fundamentele Mysterie Van De Geest"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Dividerlijn"
      },
      "home-explanationsection": {
        "fast.accurate": "SNEL EN NAAKTE",
        "generate.content": "Genereer inhoud voor je podcast met de",
        "power.of.ai": "kracht van AI",
        "upload.image.alt": "upload afbeelding",
        "select.episode": "Selecteer een aflevering uit je RSS-feed of upload een audio-/videobestand",
        "paste.rss.feed": "Plak eenvoudig je RSS-feed URL om een aflevering uit de lijst te kiezen of upload een audio- of videobestand.",
        "content.image.alt": "inhoud afbeelding",
        "one.click.content": "Krijg alle inhoud met één klik!",
        "user.friendly.interface": "Intuïtieve en gebruiksvriendelijke interface die je direct kunt gebruiken. Genereer inhoud voor je podcast met één klik.",
        "tune.image.alt": "afstem afbeelding",
        "edit.fine.tune": "Bewerk en verfijn elke inhoud",
        "direct.edit.content": "Bewerk en verfijn elke inhoud direct naar wens met AI. Je kunt bijvoorbeeld vragen om een specifieke toon, directe of indirecte spraak of gewoon verkeerd gespelde namen corrigeren.",
        "multiple.language.support": "Ondersteuning voor meerdere talen",
        "language.flags.alt": "taalvlaggen",
        "generate.content.aria": "Genereer inhoud"
      },
      "home-featuressection": {
        "loading": "Laden...",
        "transcribe.write.show.notes": "Transcribeer en schrijf show-notities voor je podcast",
        "twenty.times.faster": "20x sneller",
        "save.manual.work": "Bespaar tot 100% van handmatig werk. Transcribeer je podcast automatisch met state-of-the-art nauwkeurigheid en sprekerlabeling, en genereer complete show-notities en sociale media berichten in je eigen stem.",
        "generate.content": "Genereer Inhoud",
        "transcripts": "Transcripten",
        "full.transcript": "Krijg het volledige transcript van je podcastafleveringen en YouTube-video-transcripten, samen met een SRT-bestand voor ondertitels.",
        "show.notes": "Show-notities",
        "summarize.generate.show.notes": "Vat samen en genereer show-notities in je eigen stem, compleet met tijdstempels, opsommingstekens en vermeldingen.",
        "blog.newsletter": "Blog en Nieuwsbrief",
        "actionable.blog.posts": "Krijg actiegerichte blogposts over je afleveringen en kant-en-klare nieuwsbrieven met de belangrijkste punten.",
        "social.media": "Sociale media",
        "short.posts.insights": "Krijg korte berichten en hapklare inzichten om het woord te verspreiden op sociale media.",
        "quote": "Van alle beste AI-transcriptietools die we hebben getest, genereerde Podsqueeze de meest nuttige output voor Show-notities, Tijdstempels, Titels, Vermeldingen, Voorbeeldblogposts en Belangrijke Citaten.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Mede-oprichter van Transistor.fm",
        "transcribe_and_write_show_notes": "Podcast transcriptie, samenvatting en sociale berichten",
        "twenty_times_faster": "20x sneller",
        "save_manual_work": "Bespaar tot 100% van handmatig werk. Transcribeer je podcast automatisch met state-of-the-art nauwkeurigheid en sprekerlabeling, en genereer complete show-notities en sociale media berichten in je eigen stem.",
        "generate_content": "Genereer Inhoud",
        "full_transcript": "Krijg het volledige transcript van je podcastafleveringen en YouTube-video-transcripten, samen met een SRT-bestand voor ondertitels.",
        "show_notes": "Show-notities",
        "summarize_and_generate_show_notes": "Vat samen en genereer show-notities in je eigen stem, compleet met tijdstempels, opsommingstekens en vermeldingen.",
        "blog_and_newsletter": "Blog en Nieuwsbrief",
        "actionable_blog_posts": "Krijg actiegerichte blogposts over je afleveringen en kant-en-klare nieuwsbrieven met de belangrijkste punten.",
        "social_media": "Sociale media",
        "short_posts_and_insights": "Krijg korte berichten en hapklare inzichten om het woord te verspreiden op sociale media.",
        "testimonial": "Van alle beste AI-transcriptietools die we hebben getest, genereerde Podsqueeze de meest nuttige output voor Show-notities, Tijdstempels, Titels, Vermeldingen, Voorbeeldblogposts en Belangrijke Citaten.",
        "cofounder_transistor": "Mede-oprichter van Transistor.fm"
      },
      "home-page": {
        "main.background": "Achtergrondkleur voor de hoofdcomponent"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "LUISTER NAAR ONZE PODCAST",
        "podcast.section.subtitle": "Masterclasses van",
        "podcast.section.highlight": "ervaren Podcasters",
        "podcast.section.description": "Luister naar onze podcast, waarin we ervaren podcasters en gebruikers van Podsqueeze van over de hele wereld interviewen. We vragen hen om hun tips, inzichten, verhalen en alles wat je moet weten om je eigen podcast te laten groeien te delen.",
        "podcast.link.spotify": "Luister op Spotify",
        "podcast.link.apple": "Luister op Apple Podcasts",
        "podcast.link.youtube": "Luister op YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Laden..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatiseer je podcast",
        "tagline.productionPromotion": "Productie & Promotie",
        "tagline.launchGrow": "Start en groei moeiteloos je audio- of videopodcast met alles wat je nodig hebt op één plek, met de hulp van AI.",
        "tagline.uploadGenerate": "Genereer eenvoudig podcasttranscripties, samenvattingen, korte clips met ondertitels en nog veel meer!",
        "tagline.singleClick": " Allemaal met één klik.",
        "tagline.transcripts": "Podcasttranscripties",
        "tagline.showNotes": "Show Notes",
        "tagline.newslettersBlogs": "Newsletters & Blogs",
        "tagline.socialPosts": "Sociale Berichten",
        "tagline.shortClipsAudiograms": "Korte Clips & Audiogrammen",
        "tagline.podcastWebsite": "Podcast Website",
        "tagline.aiAudioEnhancement": "AI Audio Verbetering",
        "tagline.removeSilences": "Verwijder stiltes en uhms",
        "tagline.generateNow": "Genereer nu gratis",
        "tagline.noCreditCard": "Geen creditcard vereist",
        "testimonial.robWalling.title": "Rob Walling, Startup Persoonlijkheid",
        "testimonial.robWalling.subtitle": "Startups voor de Rest van Ons Podcast",
        "testimonial.robWalling.quote": "De show-notities van Podsqueeze zijn de beste. We gebruiken het veel voor samenvattingen en om inzichten uit andere podcasts te halen.",
        "testimonial.johnGarmet.title": "John Garmet, Operationeel Directeur",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze helpt ons efficiënter te zijn en meer content voor onze klanten te genereren. We raden het ten zeerste aan.",
        "testimonial.davidJackson.title": "David Jackson, Podcast Coach",
        "testimonial.davidJackson.subtitle": "School of Podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze is mijn brainstormpartner. Het is de beste manier om op ideeën te komen voor podcastmarketing."
      },
      "home-testimonials": {
        "testimonials.title": "Wat zeggen mensen over Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Hergebruik je podcastinhoud met behulp van AI | Product Hunt",
        "testimonials.heading": "Wat zeggen mensen over Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Onjuist wachtwoord",
        "error.userNotFound": "Gebruiker niet gevonden",
        "error.somethingWentWrong": "Oeps, er is iets misgegaan",
        "button.sendResetEmail": "Stuur reset-e-mail",
        "button.login": "Inloggen",
        "placeholder.email": "E-mailadres",
        "placeholder.password": "Wachtwoord",
        "link.forgotPassword": "Wachtwoord vergeten?",
        "link.createAccount": "Account aanmaken",
        "text.or": "OF",
        "button.continueWithGoogle": "Doorgaan met Google",
        "text.podcastDescription": "Start en groei moeiteloos je audio- of videopodcast met alles wat je nodig hebt op één plek.",
        "feature.transcripts": "Transcripties",
        "feature.showNotes": "Show-notities",
        "feature.newslettersAndBlogs": "Nieuwsbrieven & Blogs",
        "feature.socialPosts": "Sociale berichten",
        "feature.shortClipsAndAudiograms": "Korte clips & audiogrammen",
        "feature.podcastWebsite": "Podcastwebsite",
        "feature.aiAudioEnhancement": "AI Audioverbetering",
        "feature.removeSilences": "Verwijder stiltes en uhms",
        "error.emailNotVerified": "E-mail niet geverifieerd",
        "text.pleaseVerifyAccount": "Controleer je account",
        "text.checkSpamFolder": "We hebben je een verificatie-e-mail gestuurd. Controleer je inbox en spamfolder.",
        "button.resendVerificationEmail": "Verificatie-e-mail opnieuw sturen",
        "error.verificationEmailFailed": "Fout bij het verzenden van de verificatie-e-mail. Probeer het opnieuw."
      },
      "page": {
        "login.form": "Inlogformulier"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze Affiliates Pagina",
        "affiliate.page.description": "Verdien 25% commissie op elke verkoop die via jouw exclusieve verwijzingslink wordt gemaakt gedurende een periode van 15 maanden. Deel je link op je website, sociale media of met je vrienden. Het kost seconden om je aan te melden. Word automatisch goedgekeurd."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Het Beste Cadeau voor een Podcaster",
        "bestGiftForPodcaster.description": "Ontdek de beste cadeaus voor podcasters om hun ervaring te verbeteren.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Krijg meer podcastluisteraars",
        "get-more-podcast-listeners.description": "Krijg meer podcastluisteraars en stroomlijn de productie met automatische show-notities, korte clips om je show op sociale media te laten groeien en nog veel meer."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Vergroot je podcastpubliek",
        "grow_your_podcast_audience.description": "Bespaar veel tijd en vergroot je podcastpubliek met Podsqueeze. Genereer complete show-notities, berichten voor sociale media, korte clips en meer voor je podcast."
      },
      "index": {
        "home.page.title": "AI Podcast Show-notities, Transcript, Samenvattingen en Clips Generator.",
        "home.page.description": "Genereer show-notities, tijdstempels, nieuwsbrieven en meer voor je podcast met één klik! Genereer snel inhoud voor je podcast en pas deze aan je behoeften aan. Gratis aanmelden."
      },
      "login": {
        "login.tryItNow": "Probeer het nu!",
        "login.createAccountDescription": "Maak een account aan en begin met het genereren van shownotes, tijdstempels, nieuwsbrieven en meer voor je podcast met één klik! Genereer snel inhoud voor je podcast en pas deze aan op jouw behoeften. Gratis aanmelden."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing voor Podcasts",
        "marketing.for.podcasts.description": "Podsqueeze vereenvoudigt marketing voor podcasts met automatisch gegenereerde show-notities, sociale media berichten en korte clips om je bereik te vergroten en je show te laten groeien."
      },
      "media": {
        "media.page.title": "Podsqueeze Media Pagina",
        "media.page.description": "Leer meer over Podsqueeze. Neem contact met ons op! We zouden graag willen samenwerken!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Podcast Beschrijving Generator",
        "podcast.description.generator.description": "Verbeter het bereik en de betrokkenheid van je podcast met AI-gegenereerde beschrijvingen. Automatiseer het schrijven van je Show Notes en herwin kostbare tijd."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Herbruik je podcast voor sociale media berichten",
        "convert.podcast.episodes.to.social.media.posts": "Converteer podcastafleveringen naar sociale media berichten. Genereer automatisch berichten voor LinkedIn, Twitter, Facebook en korte clips voor TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Gratis Podcast Onderwerpen Generator",
        "podcast.topics.generator.description": "Onze gratis podcast onderwerpen generator helpt je de beste onderwerpideeën te vinden en voorspelt hun potentiële bereik op Google en YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Jouw Podcast Virtuele Assistent",
        "podcast.virtual.assistant.description": "AI podcast virtuele assistent die je show-notities schrijft en sociale media berichten maakt. Stroomlijn je podcastproductie en marketing met Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Prijzen",
        "pricing.description": "Genereer shownotes, tijdstempels, nieuwsbrieven en meer voor je podcast met één klik! We hebben meerdere prijsklassen om aan je podcastbehoeften te voldoen."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promoot je Podcast",
        "promote.your.podcast.description": "Genereer show-notities, berichten voor sociale media en korte clips om je podcast in slechts enkele minuten te publiceren en te promoten."
      },
      "register": {
        "create.podsqueeze.account": "Maak een Podsqueeze-account aan",
        "generate.content.podcast": "Genereer shownotes, tijdstempels, nieuwsbrieven en meer voor je podcast met één klik! Genereer snel inhoud voor je podcast en pas deze aan op jouw behoeften. Gratis aanmelden."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Automatisch podcastinhoud hergebruiken",
        "repurpose.your.podcast.content.with.ai": "Hergebruik je podcastinhoud met AI. Genereer automatisch show-notities, titels, korte clips voor TikTok en nog veel meer, allemaal met één klik!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "GRATIS Podcast SEO Optimizer",
        "seo.optimizer.description": "Analyseer en optimaliseer je podcastepisodes voor betere zichtbaarheid in zoekmachines met AI-gestuurde SEO-aanbevelingen.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analyseer en optimaliseer je podcastepisodes voor betere zichtbaarheid in zoekmachines met AI-gestuurde SEO-aanbevelingen.",
        "seo.optimizer.selectEpisode": "Selecteer een Aflevering om te Analyseren",
        "seo.optimizer.results": "SEO Analyse Resultaten",
        "seo.optimizer.searchPodcastPlaceholder": "Zoek een podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Zoek afleveringen...",
        "seo.optimizer.analyseAnotherEpisode": "Analyseer een Andere Aflevering",
        "seo.optimizer.findingEpisodes": "Alle afleveringen worden opgehaald...",
        "seo.optimizer.analysingEpisode": "Aflevering wordt geanalyseerd",
        "seo.optimizer.scoreTooltip": "Score:",
        "seo.optimizer.topKeywords": "We hebben deze Top Trefwoorden geïdentificeerd:",
        "seo.optimizer.topKeywordsnote": "Gebaseerd op de trefwoordanalyse onderaan de pagina.",
        "seo.optimizer.optimizedContent": "Gebaseerd op trefwoorden zijn dit de geoptimaliseerde titel en beschrijving:",
        "seo.optimizer.originalTitle": "Originele Titel",
        "seo.optimizer.optimizedTitle": "Geoptimaliseerde Titel",
        "seo.optimizer.originalDescription": "Originele Beschrijving",
        "seo.optimizer.optimizedDescription": "Geoptimaliseerde Beschrijving",
        "seo.optimizer.showMore": "Meer weergeven",
        "seo.optimizer.showLess": "Minder weergeven",
        "seo.optimizer.keywordAnalysis": "Trefwoordanalyse",
        "seo.optimizer.keywordAnalysisnote": "Scores worden berekend op basis van zoekvolume, concurrentie (hoeveel andere resultaten er zijn voor hetzelfde trefwoord) en in het geval van YouTube het gemiddelde aantal weergaven per video voor hetzelfde trefwoord.",
        "seo.optimizer.seoScore": "SEO Score",
        "seo.optimizer.spotifyScore": "Spotify Score",
        "seo.optimizer.youtubeScore": "YouTube Score",
        "seo.optimizer.totalScore": "Totaal"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - AI Podcast inhoudsgenerator tool",
        "podsqueeze.description": "Genereer shownotes, tijdstempels, nieuwsbrieven en meer voor je podcast met één klik! Genereer snel inhoud voor je podcast en pas het aan op jouw behoeften. Gratis aanmelden."
      },
      "thumbnail-creator": {
        "title": "Gratis Podcast Thumbnail Generator - Maak AI-gestuurde Episode Thumbnails",
        "description": "Maak verbluffende podcast thumbnails met AI. Genereer professionele, opvallende episode kunst die de zichtbaarheid verhoogt en meer luisteraars naar je podcast trekt.",
        "selectPodcast": "Selecteer Je Podcast",
        "loadEpisodes": "Afleveringen Laden",
        "selectEpisode": "Selecteer Aflevering om Thumbnail te Maken",
        "createThumbnail": "Thumbnail Maken",
        "results": "Je Gegenereerde Thumbnail",
        "download": "Downloaden",
        "share": "Delen",
        "regenerate": "Opnieuw Genereren",
        "editThumbnail": "Thumbnail Bewerken",
        "editPlaceholder": "Beschrijf hoe je deze thumbnail wilt aanpassen...",
        "customPrompt": "Aangepaste Prompt",
        "yourThumbnail": "Je Thumbnail",
        "createAnother": "← Maak Nog Een Thumbnail",
        "findingEpisodes": "Afleveringen zoeken...",
        "searchPodcastPlaceholder": "Zoek je podcast...",
        "searchingPodcasts": "Podcasts zoeken...",
        "heroDescription": "Genereer verbluffende, professionele podcast thumbnails met AI-aangedreven ontwerp dat aandacht trekt en de zichtbaarheid van je afleveringen verhoogt.",
        "generatedWithPrompt": "Gegenereerd met prompt:",
        "customPromptPlaceholder": "Voer een aangepaste prompt in voor thumbnail generatie...",
        "generating": "Genereren...",
        "generate": "Genereren",
        "modernMinimalist": "Modern & Minimalistisch",
        "vibrantDynamic": "Levendig & Dynamisch",
        "professionalClean": "Professioneel & Schoon",
        "generatingThumbnail": "Thumbnail genereren...",
        "generatingNewThumbnail": "Nieuwe thumbnail genereren...",
        "showingFirstEpisodes": "Toont eerste 10 afleveringen. Gebruik zoeken om specifieke afleveringen te vinden.",
        "imageUrlCopied": "Afbeelding URL gekopieerd naar klembord!",
        "failedToGenerate": "Thumbnail genereren mislukt. Probeer opnieuw.",
        "promotionalTitle": "Genereer Shownotities, Tijdstempels, Virale Clips en Veel Meer Met Podsqueeze",
        "promotionalSubtitle": "Sluit je aan bij 100K+ andere makers en begin je show te laten groeien",
        "startNow": "Nu beginnen",
        "free": "GRATIS",
        "podcast": "PODCAST",
        "thumbnail": "THUMBNAIL",
        "creator": "MAKER",
        "replaceFace": "Gezicht Vervangen",
        "uploading": "Uploaden...",
        "uploadImageError": "Upload een afbeeldingsbestand.",
        "uploadFailedError": "Upload van afbeelding mislukt. Probeer opnieuw.",
        "uploadingImage": "Afbeelding uploaden...",
        "generatingNewThumbnailLoading": "Nieuwe thumbnail genereren...",
        "failedToGenerateWithFace": "Thumbnail genereren met gezichtsvervanging mislukt. Probeer opnieuw."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Maak Nieuwe Podcastmap",
      "folder.name.placeholder": "Voer de mapnaam in",
      "create.button": "Aanmaken"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Afleveringen laden...",
        "episodeList.noEpisodes": "Geen openbare afleveringen beschikbaar",
        "episodeList.checkBack": "Kom later terug voor nieuwe afleveringen",
        "episodeList.title": "Afleveringen van deze Podcast",
        "episodeList.readLess": "MINDER LEZEN",
        "episodeList.readMore": "MEER LEZEN",
        "episodeList.coverImageAlt": "Omslag van {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Aan de slag",
        "alert.subscriptionRunning": "Uw huidige abonnement is nog steeds actief.\n\nAnnuleer uw huidige abonnement voordat u een nieuw abonnement koopt.",
        "alert.subscriptionEnds": "Uw huidige abonnement is nog steeds actief.\n\nHet eindigt op {date}",
        "alert.subscriptionCancelled": "Uw abonnement is al geannuleerd en het eindigt op {date}",
        "button.openDashboard": "Dashboard openen",
        "button.signUp": "Aanmelden",
        "button.buySubscription": "Abonnement kopen",
        "button.cancelled": "Geannuleerd",
        "button.cancelSubscription": "Abonnement annuleren",
        "button.upgradeSubscription": "Abonnement upgraden",
        "button.loading": "Laden",
        "upgrade.details.currentMinutes": "Dit zal een nieuwe abonnementsperiode starten. U behoudt al uw huidige minuten.",
        "upgrade.details.remainingAnnual": "Deze waarde is berekend op basis van de resterende tijd in uw huidige jaarlijkse abonnement."
      },
      "page": {
        "pricing.free.title": "Gratis",
        "pricing.free.subtitle": "Probeer Podsqueeze uit. Geen creditcard vereist.",
        "pricing.free.price.annual": "€0 Jaarlijks gefactureerd",
        "pricing.free.features.podcast_time": "30 minuten podcasttijd per maand",
        "pricing.free.features.video_clips": "3 videoclips",
        "common.with_watermark": "met watermerk",
        "pricing.free.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.free.features.file_upload": "Bestand uploaden tot 4Gb",
        "pricing.free.features.upload": "1 upload",
        "pricing.free.features.landing_pages": "Podcast landingspagina's",
        "pricing.free.features.audio_enhancement": "Audio verbetering",
        "common.sign_up": "Aanmelden",
        "common.open_dashboard": "Dashboard openen",
        "pricing.starter.title": "Starter",
        "pricing.starter.subtitle": "Perfect voor hobby-podcasters die tijd willen besparen.",
        "pricing.starter.price.annual": "€132 Jaarlijks gefactureerd",
        "pricing.billed_annually": "Jaarlijks gefactureerd",
        "minutes.accumulate": "Overdracht van minuten.",
        "pricing.starter.features.podcast_time": "160 minuten podcasttijd per maand",
        "pricing.starter.features.video_clips": "10 videoclips of audiogrammen",
        "pricing.starter.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.starter.features.file_upload": "Bestand uploaden tot 4Gb",
        "pricing.starter.features.unlimited_uploads": "Onbeperkte uploads",
        "pricing.starter.features.landing_pages": "Podcast landingspagina's",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Voor professionals die podcasting gebruiken om hun bedrijf te ontwikkelen en te ondersteunen.",
        "pricing.pro.price.annual": "€324 Jaarlijks gefactureerd",
        "pricing.pro.features.podcast_time": "320 minuten podcasttijd per maand",
        "pricing.pro.features.personalize_ai_voice": "AI-stem personaliseren",
        "pricing.pro.features.video_clips": "20 videoclips of audiogrammen",
        "common.no_watermark": "geen watermerk",
        "pricing.pro.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.pro.features.file_upload": "Bestand uploaden tot 10Gb",
        "pricing.pro.features.unlimited_uploads": "Onbeperkte uploads",
        "pricing.pro.features.landing_pages": "Podcast landingspagina's",
        "common.customizable": "aanpasbaar",
        "pricing.pro.features.audio_video_edit": "Audio en Video Magische Bewerking",
        "pricing.agency_lite.title": "Agency Lite",
        "pricing.agency_lite.subtitle": "Voor podcastbureaus die hun bedrijf willen stroomlijnen en laten groeien.",
        "pricing.agency_lite.price.annual": "€495 Jaarlijks gefactureerd",
        "pricing.agency_lite.features.podcast_time": "600 minuten podcasttijd per maand",
        "pricing.agency_lite.features.personalize_ai_voice": "AI-stem personaliseren",
        "pricing.agency_lite.features.video_clips": "40 videoclips of audiogrammen",
        "pricing.agency_lite.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.agency_lite.features.file_upload": "Bestand uploaden tot 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Onbeperkte uploads",
        "pricing.agency_lite.features.landing_pages": "Podcast landingspagina's",
        "pricing.agency_lite.features.audio_video_edit": "Audio en Video Magische Bewerking",
        "pricing.agency_plus.title": "Agency Plus",
        "pricing.agency_plus.subtitle": "Voor podcastbureaus die hun bedrijf willen stroomlijnen en laten groeien.",
        "pricing.agency_plus.price.annual": "€1.251 Jaarlijks gefactureerd",
        "pricing.agency_plus.features.podcast_time": "2000 minuten podcasttijd per maand",
        "pricing.agency_plus.features.personalize_ai_voice": "AI-stem personaliseren",
        "pricing.agency_plus.features.video_clips": "80 videoclips of audiogrammen",
        "pricing.agency_plus.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.agency_plus.features.file_upload": "Bestand uploaden tot 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Onbeperkte uploads",
        "pricing.agency_plus.features.landing_pages": "Podcast landingspagina's",
        "pricing.agency_plus.features.audio_video_edit": "Audio en Video Magische Bewerking",
        "pricing.agency_scale.title": "Agency Scale",
        "pricing.agency_scale.subtitle": "Voor podcastbureaus die hun bedrijf willen stroomlijnen en laten groeien.",
        "pricing.agency_scale.price.annual": "€2.175 Jaarlijks gefactureerd",
        "pricing.agency_scale.features.podcast_time": "4000 minuten podcasttijd per maand",
        "pricing.agency_scale.features.personalize_ai_voice": "AI-stem personaliseren",
        "pricing.agency_scale.features.video_clips": "160 videoclips of audiogrammen",
        "pricing.agency_scale.features.quote_images": "Onbeperkte citaatafbeeldingen",
        "pricing.agency_scale.features.file_upload": "Bestand uploaden tot 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Onbeperkte uploads",
        "pricing.agency_scale.features.landing_pages": "Podcast landingspagina's",
        "pricing.agency_scale.features.audio_video_edit": "Audio en Video Magische Bewerking",
        "pricing.header": "Voor solo-podcasters en podcastbureaus",
        "pricing.minutes_reset": "Je kunt tot 3x je maandelijkse minuten opbouwen, zolang je op je huidige abonnement blijft of upgradet.",
        "pricing.most_popular": "Meest populaire",
        "pricing.minutes_per_month": "Minuten per maand",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Voor podcastbureaus en media-ondernemingen die hun bedrijf willen stroomlijnen en laten groeien.",
        "pricing.enterprise_price": "Aangepast",
        "pricing.enterprise_price_note": "Neem contact op met team@podsqueeze.com of boek een demo hieronder.",
        "pricing.enterprise_feature_priority_support": "Prioritair ondersteuning",
        "pricing.enterprise_feature_team_sits": "Team sessies",
        "pricing.enterprise_personalized_team_training": "Team onboarding en training",
        "pricing.book_demo": "Demo boeken"
      },
      "toggle": {
        "pay.monthly": "Maandelijks",
        "pay.annually": "Jaarlijks",
        "discount.30percent": "30% KORTING"
      },
      "upgradeModal": {
        "upgrade.success": "Uw abonnement is succesvol geüpgraded",
        "upgrade.error": "Het spijt ons, er is iets misgegaan. Probeer het later opnieuw",
        "upgrade.loading": "Bezig met upgraden",
        "upgrade.confirmPay": "Bevestigen & Betalen",
        "upgrade.cancel": "Annuleren",
        "coupon.placeholder": "Couponcode",
        "coupon.apply": "Toepassen",
        "coupon.have": "Ik heb een coupon",
        "upgrade.confirmation": "U staat op het punt te upgraden naar",
        "upgrade.price": "U betaalt"
      }
    },
    "register": {
      "page": {
        "register.form": "Registratieformulier"
      },
      "registerForm": {
        "error.invalidCredentials": "Voer een geldig e-mailadres en wachtwoord in.",
        "error.weakPassword": "Gebruik een sterker wachtwoord 💪",
        "error.emailInUse": "Gebruiker bestaat al",
        "error.userNotFound": "Gebruiker niet gevonden",
        "error.generic": "Oeps, er is iets misgegaan",
        "placeholder.email": "E-mailadres",
        "placeholder.password": "Wachtwoord",
        "button.registering": "Registreren...",
        "button.register": "Registreren",
        "label.newsletter": "Sluit je aan bij 12.000 podcasters en abonneer je op onze nieuwsbrief voor productupdates, praktische tips, e-books, weggeefacties en meer.",
        "label.alreadyHaveAccount": "Heb je al een account?",
        "label.logInHere": "Log hier in",
        "label.or": "OF",
        "button.signingIn": "Inloggen...",
        "button.continueWithGoogle": "Doorgaan met Google",
        "label.podcastDescription": "Start en groei moeiteloos je audio- of videopodcast met alles wat je nodig hebt op één plek.",
        "feature.transcripts": "Transcripties",
        "feature.showNotes": "Show-notities",
        "feature.newslettersBlogs": "Nieuwsbrieven & Blogs",
        "feature.socialPosts": "Sociale berichten",
        "feature.shortClips": "Korte clips & audiogrammen",
        "feature.podcastWebsite": "Podcastwebsite",
        "feature.audioEnhancement": "AI Audioverbetering",
        "feature.removeSilences": "Verwijder stiltes en uhms"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "tekst"
      },
      "TopicFinder": {
        "competition.veryHigh": "ZEER HOOG",
        "competition.high": "HOOG",
        "competition.medium": "MEDIUM",
        "competition.low": "LAAG",
        "competition.veryLow": "ZEER LAAG",
        "upgrade.button": "Upgrade naar Pro",
        "clicks.label": "klikken",
        "searches.label": "zoekopdrachten",
        "competition.label": "concurrentie",
        "fetching.results": "Resultaten ophalen",
        "table.topic": "Onderwerp",
        "tooltip.topic": "Het belangrijkste onderwerp dat in je podcastaflevering wordt behandeld",
        "table.monthlySearches": "Maandelijkse Zoekopdrachten",
        "tooltip.monthlySearches": "Het bereik van maandelijkse Google-zoekopdrachten dat je kunt verwachten",
        "table.competition": "Concurrentie",
        "tooltip.competition": "Het belangrijkste onderwerp of thema dat door de podcast wordt behandeld.",
        "table.monthlyGoogleClicks": "Maandelijkse Google Klikken",
        "tooltip.monthlyGoogleClicks": "Een voorspelling van het bereik van maandelijkse Google-klikken dat je kunt verwachten",
        "table.youtubeReach": "YouTube Bereik",
        "tooltip.youtubeReach": "Een voorspelling van het maximale aantal YouTube-weergaven dat je in de eerste 6 maanden kunt verwachten, gebaseerd op de gemiddelde concurrent",
        "intro.title": "Gratis Podcast Onderwerpen Generator",
        "intro.description": "Krijg onderwerpideeën voor je podcast waar het publiek naar zoekt",
        "intro.check1": "Bekijk de vraag naar elk onderwerpidee op Google",
        "intro.check2": "Ontdek hoe competitief elk podcastonderwerpidee is",
        "intro.check3": "Schat de Google-klikken en YouTube-weergaven die je kunt krijgen",
        "upgrade.message": "Je moet upgraden naar Pro om toegang te krijgen tot alle resultaten",
        "learnMore.label": "Leer meer over de",
        "learnMore.link": "gratis podcast onderwerpen generator tool",
        "newSearch.button": "Nieuwe Zoekopdracht",
        "share.button": "Deze Zoekopdracht Delen",
        "form.label": "Voer je podcast niches in",
        "form.placeholder": "Digitale Marketing",
        "form.submit": "Vind Onderwerpideeën"
      },
      "page": {
        "main.background": "achtergrond"
      },
      "shareTopics": {
        "share.results": "Deel Resultaten",
        "share.facebook": "Deel op Facebook",
        "share.whatsapp": "Deel op WhatsApp",
        "share.twitter": "Deel op Twitter",
        "share.linkedin": "Deel op LinkedIn",
        "copy.success": "Gekopieerd",
        "copy.link": "Kopieer Link"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "weergaven"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Kon de huidige compositie niet ophalen",
        "error.addImage": "Fout bij het toevoegen van afbeeldingelement:",
        "alert.uploadImage": "Gelieve een afbeeldingsbestand te uploaden.",
        "error.uploadImage": "Fout bij het uploaden van afbeelding:",
        "alert.uploadFailed": "Het uploaden van de afbeelding is mislukt. Probeer het opnieuw.",
        "error.getDownloadURL": "Fout bij het ophalen van de download-URL:",
        "alert.processImageFailed": "Het verwerken van de geüploade afbeelding is mislukt. Probeer het opnieuw.",
        "error.addText": "Fout bij het toevoegen van tekstelement:",
        "text.settingsPlaceholder": "Instellingen worden weergegeven wanneer het element is geselecteerd",
        "text.addElement": "Element Toevoegen",
        "text.uploading": "Aan het uploaden...",
        "button.uploadImage": "Afbeelding Uploaden",
        "text.newText": "Nieuwe Tekst",
        "button.addText": "Tekst Toevoegen",
        "text.selectedElementSettings": "Instellingen van Geselecteerd Element"
      },
      "FontSelector": {
        "allFonts": "Alle lettertypen",
        "myFonts": "Mijn lettertypen",
        "uploadFont": "Lettertype uploaden",
        "noCustomFonts": "Nog geen aangepaste lettertypen.",
        "uploadToAdd": "Upload een lettertypebestand om het aan je collectie toe te voegen.",
        "text_outline": "Tekstomlijning",
        "outline_color": "Omlijningskleur",
        "outline_width": "Omlijningsdikte"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Aanpassen",
        "imageLayoutSettings.zoom": "Inzoomen",
        "imageLayoutSettings.horizontalAlignment": "Horizontale Uitlijning",
        "imageLayoutSettings.verticalAlignment": "Verticale Uitlijning",
        "imageLayoutSettings.deleteElement": "Element Verwijderen"
      },
      "TemplateBox": {
        "confirm.delete.template": "Weet u zeker dat u deze sjabloon wilt verwijderen?"
      },
      "TextSettings": {
        "error.getting_current_text": "Fout bij het ophalen van de huidige tekst:",
        "event.delete_text_element_clicked": "Tekstelement Verwijderen Geklikt",
        "error.changing_text_font": "Fout bij het wijzigen van het lettertype:",
        "event.text_font_changed": "Lettertype Gewijzigd",
        "error.changing_text_size": "Fout bij het wijzigen van de tekstgrootte:",
        "event.text_size_changed": "Tekstgrootte Gewijzigd",
        "error.changing_text_color": "Fout bij het wijzigen van de tekstkleur:",
        "event.text_color_changed": "Tekstkleur Gewijzigd",
        "event.text_content_added": "Tekstinhoud Toegevoegd",
        "error.adding_text_content": "Fout bij het toevoegen van tekstinhoud:",
        "event.text_content_updated": "Tekstinhoud Bijgewerkt",
        "label.text_content": "Tekstinhoud",
        "label.text_font": "Lettertype",
        "label.text_font_weight": "Lettertype Dikte",
        "label.adjust_text_size": "Pas Tekstgrootte Aan",
        "label.text_color": "Tekstkleur",
        "button.delete": "Verwijderen"
      },
      "audiogramBaseTemplate": {
        "color.white": "Wit",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "kwadratisch-uit",
        "animation.fade": "vervagen",
        "type.text": "tekst",
        "name.podcastTitle": "PodcastTitel",
        "name.snippetTitle": "snippetTitel",
        "type.image": "afbeelding",
        "name.audioBackgroundImage": "AudioAchtergrondAfbeelding",
        "name.subtitlesText": "ondertitelsTekst",
        "effect.highlight": "markeren",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "snippetTitel",
        "podcast.title": "podcastTitel",
        "new.episode": "NIEUWE AFLEVERING"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Wit",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "standaardAfleveringUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "achtergrond_muziek",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Gelieve een afbeeldingsbestand te uploaden.",
        "upload.file.loading": "Bestand aan het uploaden. Sluit dit venster alstublieft niet.",
        "upload.image.label": "Afbeelding vervangen",
        "ai.prompt.label": "Voer een prompt in voor de AI om een afbeelding te genereren",
        "ai.prompt.placeholder": "Bijv: Een hond die in het park rent...",
        "ai.processing": "Bezig met verwerken...",
        "ai.create": "Aanmaken",
        "customize.image.title": "Afbeelding aanpassen",
        "enter.image.url": "Voer de afbeeldings-URL in",
        "or": "of"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Fout bij het ophalen van sjablonen:",
        "template.savedSuccessfully": "Sjabloon succesvol opgeslagen",
        "error.savingTemplate": "Fout bij het opslaan van sjabloon:",
        "loading.savedTemplates": "Bezig met het laden van opgeslagen sjablonen...",
        "no.savedTemplates": "Geen opgeslagen sjablonen",
        "select_template": "Selecteer Sjabloon",
        "saving.template": "Sjabloon opslaan...",
        "template_name": "Sjabloonnaam",
        "enter.templateName": "Voer sjabloonnaam in",
        "cancel": "Annuleren",
        "save": "Opslaan",
        "default_templates": "Standaard Sjablonen",
        "saved_templates_count": "Opgeslagen Sjablonen ({count})",
        "folder_templates_count": "Mapsjablonen ({count})",
        "account_templates_count": "Accountsjablonen ({count})",
        "save_current_template": "Huidige Sjabloon Opslaan"
      },
      "subtitlesElement": {
        "edit.word": "Bewerk Woord",
        "edit.label": "bewerken",
        "remove.word.subtitle": "Verwijder woord alleen uit de Ondertitel",
        "erase.subtitle": "verwijderen uit ondertitel",
        "remove.word.clip": "Verwijder woord uit de Audio en Ondertitel",
        "remove.clip": "verwijderen uit clip"
      },
      "utils": {
        "video.utils.title": "Titel",
        "video.utils.currentTime": "Huidige Tijd",
        "video.utils.nextTime": "Volgende Tijd",
        "video.utils.duration": "Duur",
        "video.utils.description": "Beschrijving",
        "video.utils.srtSegment": "SRT Segment"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Uw ondertiteltekst hier"
      }
    }
  },
  "pl": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "ZOSTAŃ NASZYM PARTNEREM",
        "SHARE_PODSQUEEZE": "Podziel się Podsqueeze z twoją publicznością",
        "AND_EARN_MONEY": "i zarabiaj pieniądze!",
        "LAST_UPDATED": "Ostatnia aktualizacja: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Zostań Partnerem Afiliacyjnym",
        "EARN_COMMISSION": "Zarabiaj",
        "COMMISSION": "prowizję",
        "ON_EVERY_SALE": "na każdej sprzedaży dokonanej za pośrednictwem twojego ekskluzywnego linku referencyjnego przez okres 15 miesięcy. Udostępnij swój link na swojej stronie internetowej, w mediach społecznościowych lub znajomym. Dołączenie zajmuje tylko kilka sekund.",
        "GET_AUTOMATICALLY_APPROVED": "Zostań automatycznie zatwierdzony.",
        "JOIN_NOW": "Dołącz teraz",
        "HOW_IT_WORKS": "JAK TO DZIAŁA",
        "FREQUENTLY_ASKED_QUESTIONS": "Często Zadawane Pytania",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Kim jest Partner Afiliacyjny?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Partner Afiliacyjny to osoba, która promuje produkty lub usługi innej firmy za pośrednictwem unikalnego linku referencyjnego i zarabia prowizję za każdą sprzedaż dokonaną za pośrednictwem tego linku.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Jak mogę zostać Partnerem Afiliacyjnym?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Zostanie Partnerem Afiliacyjnym jest szybkie i łatwe, zajmuje tylko kilka sekund. Aby rozpocząć, kliknij po prostu przycisk 'Dołącz teraz' i zarejestruj się przy użyciu swojego adresu e-mail. Po zarejestrowaniu uzyskasz dostęp do łatwego w obsłudze panelu, w którym znajdziesz swój unikalny link referencyjny. Udostępnij ten link swojej rodzinie, znajomym lub publiczności online. Za każdym razem, gdy ktoś kliknie twój link referencyjny i dokona zakupu na stronie Podsqueeze, zarobisz 25% prowizji za każdą płatność przez cały okres 15 miesięcy! Monitoruj swoje zarobki bez wysiłku za pomocą swojego panelu afiliacyjnego, który zapewnia przejrzysty przegląd wszystkich wygenerowanych sprzedaży.",
        "HOW_CAN_I_TRACK_MY_SALES": "Jak mogę śledzić swoje sprzedaże i prowizje?",
        "TRACKING_SALES_DESCRIPTION": "Skorzystaj z panelu programu afiliacyjnego, aby śledzić swoje sprzedaże i prowizje. Oprogramowanie śledzące jest dostępne zarówno dla Partnerów Afiliacyjnych, jak i Biznesowych.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Kiedy i jak otrzymam płatność?",
        "PAYMENT_DESCRIPTION": "Otrzymasz płatność za pośrednictwem PayPal co 30 dni. Pamiętaj, że istnieje minimalny próg wypłaty wynoszący 50 $. Gdy osiągniesz tę kwotę, możesz oczekiwać, że twoja płatność zostanie zrealizowana punktualnie co 30 dni.",
        "STILL_GOT_QUESTIONS": "MASZ JESZCZE PYTANIA?",
        "SEND_US_A_MESSAGE": "Wyślij nam wiadomość na czacie wsparcia lub napisz do nas na team@podsqueeze.com",
        "NOTE": "Uwaga",
        "AFFILIATE_ADS_RESTRICTION": "Partnerom Afiliacyjnym zabrania się tworzenia reklam w Google lub uczestniczenia w licytacjach słów kluczowych związanych z Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Warunki Użytkowania dla Partnerów Afiliacyjnych",
        "CAN_I_RUN_ADS": "Czy mogę uruchamiać reklamy i kampanie CPC w Google, aby promować mój link referencyjny?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Partnerom Afiliacyjnym zabrania się tworzenia reklam w wyszukiwarkach lub uczestniczenia w licytacjach słów kluczowych związanych z Podsqueeze. To ograniczenie pomaga utrzymać integralność naszej strategii reklamowej i zapewnia spójność w komunikatach marki. Pamiętaj, że sprzedaże wynikające z takich kampanii licytacyjnych nie kwalifikują się do wypłaty.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Jak Podsqueeze generuje tytuły dla Twojego Podcastu?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Pasek nawigacyjny",
        "main.affiliateHero": "Bohater afiliacyjny",
        "main.footer": "Stopka"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Dodaj Muzykę Wprowadzającą i Końcową",
        "intro.music": "Muzyka Wprowadzająca",
        "outro.music": "Muzyka Końcowa",
        "intro.duration": "Czas Trwania Wprowadzenia",
        "outro.duration": "Czas Trwania Zakończenia",
        "intro.mode": "Tryb Wprowadzenia",
        "outro.mode": "Tryb Zakończenia",
        "cancel": "Anuluj",
        "save": "Zapisz",
        "apply": "Zastosuj",
        "current.intro.music": "Obecna Muzyka Wprowadzająca",
        "current.outro.music": "Obecna Muzyka Końcowa",
        "change.music": "Zmień Muzykę",
        "choose.music": "Wybierz Plik Muzyczny",
        "browser.not.support.audio": "Twoja przeglądarka nie obsługuje elementu audio.",
        "save.and.apply": "Zapisz i Zastosuj",
        "no.music.selected": "Nie wybrano muzyki",
        "delete.music": "Usuń muzykę",
        "uploading.file": "Przesyłanie pliku..."
      },
      "audioEditElements": {
        "error.processing.rss": "Mamy trudności z przetwarzaniem niektórych kanałów RSS. Proszę przesłać plik.",
        "edit.enhance.audio": "Edytuj i popraw jakość swojego nagrania audio",
        "trial.label": "Wersja próbna",
        "audio.editing.experience": "Doświadcz płynnej edycji audio z zaawansowanymi algorytmami AI, które zapewniają naturalne, wysokiej jakości wyniki, za pomocą jednego kliknięcia.",
        "improve.audio.quality": "Popraw jakość dźwięku",
        "remove.hums.silences": "Usuń szumy i cisze",
        "upgrade.edit.audio": "Zaktualizuj, aby móc edytować swoje audio za pomocą jednego kliknięcia",
        "available.plans": "Dostępne w planach wszystkich płatnych",
        "upgrade.now": "Zaktualizuj teraz",
        "audio.element.support": "Twoja przeglądarka nie obsługuje elementu audio.",
        "download.audio": "Pobierz audio",
        "loading.audio": "Ładowanie audio",
        "editing.audio": "Edycja audio"
      },
      "videoEditElements": {
        "error.exporting.video": "Błąd podczas eksportowania wideo",
        "download.failed": "Pobieranie nie powiodło się: {error.message}",
        "generating.video": "Generowanie wideo",
        "error.generating.clip": "Błąd podczas generowania klipu",
        "please.retry.support": "Proszę spróbować ponownie lub skontaktować się z naszym wsparciem użytkowników",
        "browser.not.support.video": "Twoja przeglądarka nie obsługuje tagu wideo.",
        "this.might.take.minutes": "Proszę nie zamykać okna, to może potrwać kilka minut.",
        "exporting.video": "Eksportowanie wideo...",
        "seamless.audio.editing": "Doświadcz bezproblemowej edycji dźwięku z zaawansowanymi algorytmami AI dla naturalnych, wysokiej jakości wyników, za pomocą jednego kliknięcia.",
        "difficulties.processing.rss": "Mamy pewne trudności z przetwarzaniem niektórych kanałów RSS. Proszę przesłać plik.",
        "edit.enhance.video.recording": "Edytuj i popraw swoją nagranie wideo",
        "trial": "Wersja próbna",
        "enhance.audio.quality": "Popraw jakość dźwięku",
        "enhance.audio.quality.edit": "Popraw jakość dźwięku i edytuj",
        "trim.filler.words.video": "Przytnij zbędne słowa z wideo (np. hmm)",
        "trim.long.silences.video": "Przytnij długie cisze z wideo",
        "upgrade.to.edit.video": "Zaktualizuj, aby móc edytować swoje wideo za pomocą jednego kliknięcia",
        "available.pro.agency.plans": "Dostępne w planach Pro i Agency",
        "upgrade.now": "Zaktualizuj teraz",
        "download.only.audio": "Pobierz tylko dźwięk",
        "download.video": "Pobierz wideo",
        "please.dont.close.window": "Proszę nie zamykać okna",
        "export.video": "Eksportuj wideo"
      },
      "videogramBaseTemplate": {
        "media.fit": "pokrycie",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "media"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Inne odcinki tego Podcastu",
        "tab.shownotes": "Notatki do odcinka",
        "tab.timestamps": "Znaczniki czasu",
        "tab.blogpost": "Wpis na blogu",
        "tab.transcript": "Transkrypcja",
        "key.points": "Kluczowe punkty"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Twoja strona docelowa jest aktywna w naszym wyszukiwarce podcastów. Podziel się nią ze swoją publicznością!",
        "landingPage.create": "Utwórz piękną stronę docelową dla tego odcinka",
        "landingPage.edit": "Edytuj stronę",
        "landingPage.visit": "Odwiedź stronę",
        "landingPage.delete": "Usuń stronę",
        "landingPage.createButton": "Utwórz stronę docelową"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Zarządzaj linkami odcinka",
        "youtube.link": "Link do YouTube",
        "enter.youtube.link": "Wprowadź link do YouTube",
        "apple.podcasts.link": "Link do Apple Podcasts",
        "enter.apple.podcasts.link": "Wprowadź link do Apple Podcasts",
        "spotify.link": "Link do Spotify",
        "enter.spotify.link": "Wprowadź link do Spotify",
        "saving": "Zapisywanie...",
        "save": "Zapisz",
        "social.links.updated.successfully": "Linki społecznościowe zostały pomyślnie zaktualizowane!"
      },
      "affiliatesection": {
        "affiliate.section.title": "ZOSTAŃ PARTNEREM AFILIACYJNYM",
        "affiliate.section.subtitle": "Podziel się Podsqueeze ze swoją publicznością i",
        "affiliate.section.earn": "zarabiaj pieniądze!",
        "affiliate.section.commission": "Nasz program afiliacyjny oferuje 25% prowizji przez 15 miesięcy, na każdej sprzedaży i płatności za odnowienie subskrypcji.",
        "affiliate.section.join": "Dołączenie zajmuje sekundy!",
        "affiliate.section.knowMore": "Dowiedz się więcej"
      },
      "asseenon": {
        "podnews.logo": "logo podnews",
        "transistor.logo": "logo transsistora",
        "thepodcasthost.logo": "logo gospodarza podcastu",
        "schoolofpodcasting.logo": "logo Szkoły Podcastingu",
        "semrush.logo": "logo semrush"
      },
      "assembleshownotes": {
        "episode.description": "Opis odcinka",
        "bullet.points": "Punkty wypunktowane",
        "timestamps": "Znaczniki czasowe",
        "links.and.mentions": "Linki i wzmianki",
        "extra.content": "Dodatkowa zawartość",
        "assemble.show.notes": "Zbierz swoje notatki do programu",
        "downloading": "Pobieranie",
        "copied": "Skopiowano",
        "enter.placeholder": "Wprowadź {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Robię przerwę od podcastów",
        "cancellation.option.no_recurrent": "Nie chcę subskrypcji cyklicznej",
        "cancellation.option.expensive": "To jest za drogie",
        "cancellation.option.not_saving_time": "Nie oszczędza mi wystarczająco dużo czasu",
        "cancellation.option.dissatisfied_content": "Niezadowolony z jakości generowanych treści",
        "cancellation.option.unresponsive_support": "Nieodpowiadająca obsługa klienta",
        "cancellation.option.not_using": "Nie korzystam wystarczająco z usługi",
        "cancellation.option.difficulty_navigating": "Trudności w korzystaniu/nawigacji po produkcie",
        "cancellation.option.better_alternative": "Znalazłem lepszy produkt alternatywny",
        "cancellation.option.other": "Inne",
        "cancellation.video.message": "70% naszych użytkowników przerywa proces anulowania po obejrzeniu tego wideo",
        "cancellation.button.cancel": "Chcę nadal anulować",
        "cancellation.button.try_again": "Chcę spróbować ponownie",
        "cancellation.prompt.select_reason": "Proszę, pomóż nam poprawić produkt, wybierając powód anulowania subskrypcji:",
        "cancellation.placeholder.answer": "Wpisz swoją odpowiedź tutaj...",
        "cancellation.placeholder.specify_reason": "Proszę określić powód anulowania",
        "cancellation.button.next": "Dalej",
        "cancellation.button.go_back": "Wróć",
        "cancellation.last_question.title": "Ostatnie pytanie z naszej strony",
        "lose.all.accumulated.minutes": "Jeśli anulujesz, stracisz wszystkie zgromadzone minuty.",
        "keep.accumulating.minutes": "Kontynuuj zgromadzanie minut, aby użyć przy następnym powrocie do podcastu",
        "generate.articles.favorite.podcasts.and.vides": "Generuj artykuły z Twoich ulubionych podcastów",
        "convert.and.repurpose.episodes": "Przekształć i ponownie wykorzystaj swoje starsze odcinki w nowy trening",
        "here.are.some.ideas": "Oto kilka pomysłów, które pomogą Ci kontynuować korystanie z Podsqueeze",
        "share.your.account.with.a.friend": "Udostępnić swoje konto znajomemu, który może być przydatny",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Oto video, które pokazuje, jak maksymalnie wykorzystać Podsqueeze",
        "cancellation.last_question.prompt": "Jakie zmiany lub ulepszenia skłoniłyby Cię do rozważenia powrotu do naszej usługi?",
        "cancellation.feedback.message": "Twoja opinia pomoże nam się poprawić 🙏",
        "cancellation.button.confirm": "Potwierdź anulowanie",
        "cancellation.minutes.accumulated": "Masz",
        "cancellation.minutes.accumulated.suffix": "zgromadzonych minut o wartości",
        "cancellation.reminder.text": "Proszę pamiętać:",
        "cancellation.minutes.warning": "Zgromadzone minuty to korzyść dla aktywnych subskrypcji. Anulując subskrypcję Twoje minuty zostaną trwale utracone.",
        "cancellation.content.deletion.warning": "Cała Twoja wygenerowana treść zostanie trwale usunięta po 30 dniach.",
        "cancellation.minutes.left.title": "Nadal Masz Pozostałe Minuty! Nie Pozwól Im Się Zmarnować!",
        "cancellation.suggestion.clips": "Wykorzystaj starsze odcinki do stworzenia klipów dla mediów społecznościowych",
        "cancellation.suggestion.articles": "Zamień starsze odcinki na artykuły z Podsqueeze, aby skorzystać z SEO.",
        "cancellation.suggestion.linkedin": "Zamień starsze odcinki z autorytetami na posty LinkedIn, aby wzmocnić swoją markę osobistą",
        "cancellation.suggestion.share": "Udostępnij swoje konto Podsqueeze przyjacielowi, aby mógł skorzystać z Twoich niewykorzystanych minut.",
        "cancellation.button.keep.subscription": "Zatrzymaj Moją Subskrypcję",
        "cancellation.button.keep.minutes": "Zatrzymaj Moje",
        "cancellation.button.keep.minutes.suffix": "Wartości w Minutach",
        "cancellation.lifetime.before_you_go": "Zanim odejdziesz...",
        "cancellation.lifetime.title": "Co powiesz na dożywotni dostęp za tylko 49$?",
        "cancellation.lifetime.subtitle": "Zachowaj swoje konto Starter. Bez subskrypcji. Bez odnowień. Tylko Twoje — na zawsze.",
        "cancellation.lifetime.feature1": "Dożywotni dostęp do Podsqueeze za jednorazową płatność 49$",
        "cancellation.lifetime.feature2": "Używaj kiedy potrzebujesz, bez presji — to Twoje na zawsze",
        "cancellation.lifetime.feature3": "Zawiera wszystkie obecne i przyszłe funkcje Planu Starter",
        "cancellation.lifetime.button_cancel": "Nadal chcę anulować",
        "cancellation.lifetime.button_deal": "Zdobądź ofertę dożywotnią",
        "cancellation.downgrade.title": "Zachowaj całą swoją treść za tylko 5,99$/miesiąc",
        "cancellation.downgrade.subtitle": "Przechodząc na Starter możesz...",
        "cancellation.downgrade.feature1": "Zachować całą wygenerowaną treść",
        "cancellation.downgrade.feature2": "Utrzymać działanie swoich stron internetowych",
        "cancellation.downgrade.feature3": "160 minut i 10 klipów miesięcznie do okazjonalnej pracy",
        "cancellation.billing.monthly": "Miesięczny",
        "cancellation.billing.annual": "Roczny",
        "cancellation.billing.discount": "30% ZNIŻKI",
        "cancellation.plan.starter": "Plan Starter",
        "cancellation.price.monthly": "8,99$/miesiąc",
        "cancellation.price.annual": "5,99$/miesiąc",
        "cancellation.price.annual_billing": "naliczane 71,88$ rocznie",
        "cancellation.feature.minutes": "160 min/miesiąc",
        "cancellation.feature.clips": "10 klipów/miesiąc",
        "cancellation.downgrade.button": "Przejdź na Starter i Zachowaj Treść",
        "cancellation.error.payment_link": "Nie można uzyskać linku do płatności. Spróbuj ponownie.",
        "cancellation.error.payment_service": "Błąd połączenia z usługą płatności.",
        "cancellation.option.question.break": "Czy możesz opowiedzieć nam więcej o tym, dlaczego robisz przerwę?",
        "cancellation.option.question.no_recurrent": "Czy mógłbyś podzielić się, dlaczego wolisz nie mieć subskrypcji cyklicznej?",
        "cancellation.option.question.expensive": "Jakie ceny lub funkcje sprawiłyby, że usługa byłaby dla Ciebie bardziej wartościowa?",
        "cancellation.option.question.not_saving_time": "Co nadal zabiera Ci dużo czasu w Twoim procesie?",
        "cancellation.option.question.dissatisfied_content": "Z jakimi aspektami treści nie byłeś zadowolony?",
        "cancellation.option.question.unresponsive_support": "Czy możesz opisać swoje doświadczenie z naszym wsparciem klienta?",
        "cancellation.option.question.not_using": "Czy jest coś, co zachęciłoby Cię do częstszego korzystania z usługi?",
        "cancellation.option.question.difficulty_navigating": "Jakie trudności napotkałeś podczas używania/nawigacji produktu?",
        "cancellation.option.question.better_alternative": "Jaki alternatywny produkt znalazłeś i co Ci się w nim podoba?",
        "cancellation.option.question.other": "Proszę określ swoją przyczynę anulowania:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Cenimy Twoją prywatność",
        "cookiebanner.cookieUsage": "Używamy plików cookie, aby poprawić Twoje doświadczenia na stronie i analizować nasz ruch. Klikając 'akceptuj', wyrażasz zgodę na nasze użycie plików cookie.",
        "cookiebanner.privacyPolicy": "Polityka prywatności",
        "cookiebanner.accept": "Akceptuj",
        "cookiebanner.decline": "Odrzuć"
      },
      "episodeTitleBox": {
        "loading": "Ładowanie...",
        "editEpisodeTitleClicked": "Kliknięto Edytuj Tytuł Odcinka",
        "newEpisodeTitleStored": "Nowy Tytuł Odcinka Zapisany"
      },
      "famewall": {
        "loading.message": "Ładowanie..."
      },
      "footer": {
        "footer.features": "Funkcje",
        "footer.transcriptGenerator": "Generator Transkrypcji",
        "footer.subtitlesGenerator": "Generator Napisów",
        "footer.descriptionGenerator": "Generator Opisów",
        "footer.podcastSummarizer": "Generator Podsumowań Podcastów",
        "footer.titlesGenerator": "Generator Tytułów",
        "footer.bulletPointsGenerator": "Generator Punktów Wypunktowanych",
        "footer.chaptersClipsGenerator": "Generator Rozdziałów i Klipów",
        "footer.socialMediaPostsGenerator": "Generator Postów w Mediach Społecznościowych",
        "footer.newsletterGenerator": "Generator Biuletynów",
        "footer.blogPostGenerator": "Generator Postów na Blogu",
        "footer.podcastLandingPages": "Strony Docelowe Podcastów",
        "footer.podcastClipMaker": "Twórca Klipów Podcastów",
        "footer.audiogramGenerator": "Generator Audiogramów",
        "footer.aiAudioEnhancer": "AI Wzmacniacz Dźwięku",
        "footer.convertYoutubeToText": "Konwertuj Youtube na Tekst",
        "footer.youtubeVideoNoiseRemover": "Usuwacz Szumów z Wideo Youtube",
        "footer.youtubeVideoKeyPoints": "Kluczowe Punkty Wideo Youtube",
        "footer.freeResources": "Darmowe Zasoby",
        "footer.findPodcastTopicIdeas": "Znajdź pomysły na tematy podcastów",
        "footer.articles": "Artykuły",
        "footer.freeEbooks": "Darmowe eBooki",
        "footer.community": "Społeczność",
        "footer.ourPodcast": "Nasz Podcast",
        "footer.product": "Produkt",
        "footer.giftCard": "Karta Podarunkowa",
        "footer.onboardingEbook": "eBook Wprowadzający",
        "footer.pricing": "Cennik",
        "footer.affiliates": "Partnerzy",
        "footer.media": "Media",
        "footer.testimonials": "Referencje",
        "footer.legal": "Prawo",
        "footer.privacyPolicy": "Polityka Prywatności",
        "footer.termsOfUse": "Warunki Użytkowania",
        "footer.refundPolicy": "Polityka Zwrotów",
        "footer.allRightsReserved": "Wszelkie Prawa Zastrzeżone."
      },
      "globalState": {
        "cookie.enabled": "Ciasteczka włączone",
        "language.default": "Domyślny język"
      },
      "head": {
        "keywords.list": "Podsqueeze, AI, Podcasty, Generowanie treści, Transkrypcja podcastów, Notatki z odcinków, Znaczniki czasowe, Newslettery podcastowe, Tweety, Posty na blogu, Posty w mediach społecznościowych, Tytuły, Autor notatek z odcinków"
      },
      "imageResultModal": {
        "download.image": "Pobierz obraz",
        "generating.image": "Generowanie obrazu",
        "ai.prompt.label": "Wprowadź polecenie dla AI, aby wygenerować obraz",
        "ai.prompt.placeholder": "Np: Pies biegający w parku...",
        "processing": "Przetwarzanie...",
        "create": "Utwórz",
        "text.color.label": "Kolor tekstu",
        "quote.icon.color.label": "Kolor ikony cytatu",
        "background.color.label": "Kolor tła",
        "font.label": "Czcionka",
        "upload.cover.image": "Prześlij obraz okładki",
        "aspect.ratio.info": "Proporcje 1:1, zalecany rozmiar 1200x1200",
        "upload.logo.label": "Prześlij logo",
        "choose.file": "Wybierz plik",
        "upload.success": "Pomyślnie przesłano",
        "choose.quote": "Wybierz cytat",
        "select.template": "Wybierz szablon",
        "quote.label": "Cytat",
        "enter.quote.here": "Wprowadź cytat tutaj",
        "author.label": "Autor",
        "enter.author.name": "Wprowadź nazwisko autora",
        "podcast.name.label": "Nazwa podcastu",
        "enter.podcast.name": "Wprowadź nazwę podcastu",
        "colors": "Kolory",
        "select.font": "Wybierz czcionkę",
        "cover.logo.images": "Obrazy okładki i logo",
        "logo.image": "Logo obraz",
        "upgrade.here": "Ulepsz tutaj",
        "remove.logo": "Usuń logo Podsqueeze",
        "default_templates": "Szablony domyślne",
        "saved_templates_count": "Zapisane szablony",
        "save_current_template": "Zapisz bieżący szablon",
        "no_saved_templates": "Brak zapisanych szablonów",
        "save_template": "Zapisz szablon",
        "cancel": "Anuluj",
        "save": "Zapisz",
        "enter_template_name": "Wprowadź nazwę szablonu",
        "reset_template": "Resetuj",
        "add_element": "Dodaj element",
        "generate": "Generuj",
        "add_image": "Dodaj obraz",
        "upload_image": "Prześlij obraz",
        "or": "lub",
        "generate_with_ai": "Generuj z AI",
        "search_fonts": "Szukaj czcionek...",
        "upload_logo": "Prześlij logo",
        "square_image_recommended": "Zalecany obraz kwadratowy",
        "opacity": "Przezroczystość",
        "layers": "Warstwy",
        "no_element_selected": "Nie wybrano elementu",
        "bold_shortcut": "Pogrubienie (Ctrl+B)",
        "italic_shortcut": "Kursywa (Ctrl+I)",
        "underline_shortcut": "Podkreślenie (Ctrl+U)",
        "edit_text": "Edytuj tekst",
        "tint_color": "Kolor odcienia",
        "toggle_gradient_transparent": "Przełącz gradient na przezroczysty",
        "rotate_gradient": "Obróć gradient o 45 stopni",
        "alt_background": "Tło",
        "alt_podcast_logo": "Logo podcastu",
        "alt_custom": "Niestandardowy",
        "alt_right_side": "Prawa strona",
        "alt_profile": "Profil"
      },
      "intentModal": {
        "intentModal.title": "Co chcesz zrobić z Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Napisz notatki z programu",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Napisz post na bloga i newsletter",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Utwórz klipy wideo lub audiogramy",
        "intentModal.sourceOption.Create_Quote_Images": "Utwórz obrazy z cytatami",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Edytuj i popraw audio/wideo",
        "intentModal.sourceOption.Transcribe": "Transkrybuj",
        "intentModal.sourceOption.Create_a_Website": "Utwórz stronę internetową",
        "intentModal.sourceOption.All_of_the_Above": "Wszystkie powyższe",
        "intentModal.sourceOption.Other": "Inne",
        "intentModal.otherPlaceholder": "Proszę określić",
        "intentModal.submitButton": "Wyślij i zarejestruj",
        "intentModal.skip": "Pomiń"
      },
      "languageSwitcher": {
        "language.en": "Angielski",
        "language.es": "Hiszpański",
        "language.fr": "Francuski",
        "language.de": "Niemiecki",
        "language.it": "Włoski",
        "language.pt": "Portugalski",
        "language.nl": "Niderlandzki",
        "language.pl": "Polski",
        "language.ru": "Rosyjski",
        "language.zh": "Chiński",
        "language.ja": "Japoński",
        "language.ko": "Koreański",
        "language.ar": "Arabski",
        "language.th": "Tajski",
        "language.vi": "Wietnamski"
      },
      "lazyImage": {
        "lazyImage.alt": "Opis obrazu"
      },
      "metadata": {
        "meta.title": "Tytuł Twojej Strony",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Narzędzie"
      },
      "navbar": {
        "navbar.dashboard": "Panel sterowania",
        "navbar.login": "Zaloguj się",
        "navbar.openMenu": "Otwórz menu główne",
        "navbar.features": "Funkcje",
        "navbar.resources": "Zasoby",
        "navbar.pricing": "Cennik",
        "navbar.contact": "Kontakt",
        "navbar.topPodcasts": "Najpopularniejsze podcasty",
        "navbar.seeAllFeatures": "Zobacz wszystkie funkcje",
        "navbar.mainFeatures": "GŁÓWNE FUNKCJE",
        "navbar.podcastTranscription": "Generator transkrypcji podcastów i wideo",
        "navbar.transcriptionDescription": "Transkrypcja o wysokiej dokładności z oznaczeniem mówców i plikiem SRT do napisów.",
        "navbar.podcastSummarizer": "Podsumowacz podcastów",
        "navbar.summarizerDescription": "Twórz pełne notatki z odcinków 20 razy szybciej, własnym głosem.",
        "navbar.podcastClipMaker": "Twórca klipów podcastowych",
        "navbar.clipMakerDescription": "Automatycznie generuj krótkie klipy lub audiogramy dla swojego podcastu.",
        "navbar.audioEnhancer": "Wzmacniacz dźwięku AI",
        "navbar.audioEnhancerDescription": "Automatycznie poprawiaj dźwięk, usuwaj cisze i wypełniacze.",
        "navbar.podsqueezeFeaturesWalkthrough": "PRZEWODNIK PO FUNKCJACH PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Praktyczne artykuły i przewodniki, aby uruchomić i rozwijać udany podcast.",
        "navbar.podcastTopicIdeas": "Pomysły na tematy podcastów",
        "navbar.topicIdeasDescription": "Odkryj tematy podcastów, których szukają słuchacze.",
        "navbar.actionableEbooks": "Praktyczne eBooki",
        "navbar.ebooksDescription": "Pobierz bezpłatne eBooki z praktycznymi wskazówkami, aby przenieść swój podcast na wyższy poziom.",
        "navbar.freeThumbnailMaker": "Darmowy Kreator Miniatur Podcastu",
        "navbar.freeThumbnailMakerDescription": "Twórz profesjonalne, przyciągające wzrok miniatury odcinków z AI.",
        "navbar.seoOptimizer": "Optymalizator SEO",
        "navbar.seoOptimizerDescription": "Optymalizuj swoje odcinki podcastu dla lepszej widoczności w wyszukiwarkach.",
        "navbar.podcastDescription": "Posłuchaj naszego podcastu, gdzie przeprowadzamy wywiady z doświadczonymi podcasterami i użytkownikami Podsqueeze z całego świata. Prosimy ich o podzielenie się swoimi wskazówkami, spostrzeżeniami, historiami i wszystkim, co musisz wiedzieć, aby rozwijać swój własny podcast."
      },
      "resultModal": {
        "prompt.transcript.quote": "Cytat",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweety",
        "prompt.shownotes.firstPerson": "Notatki w pierwszej osobie",
        "prompt.shownotes.replaceName": "Zamień imię w notatkach",
        "prompt.shownotes.friendlyTone": "Przyjazny ton notatek",
        "prompt.shownotes.youtubeDescription": "Opis YouTube w notatkach",
        "prompt.shownotes.engagingQuestion": "Zajmujące pytanie w notatkach",
        "prompt.timestamps.formatAsChapters": "Formatuj znaczniki czasowe jako rozdziały z opisami",
        "prompt.timestamps.detailedDescriptions": "Twórz szczegółowe opisy znaczników czasowych",
        "prompt.timestamps.improveSpeakerNames": "Zamień imię mówcy na bardziej opisowe, np. 'Pytający', 'Ekspert' lub 'Gość'",
        "prompt.newsletter.casualTone": "Swobodny ton newslettera",
        "prompt.newsletter.shorter": "Krótszy newsletter",
        "prompt.newsletter.contentSections": "Sekcje treści newslettera",
        "prompt.newsletter.changeName": "Zmień imię w newsletterze",
        "prompt.mentions.fullURL": "Pełny URL w wzmiankach",
        "prompt.mentions.replaceName": "Zamień imię w wzmiankach",
        "prompt.tweets.underdogTone": "Ton outsidera w tweetach",
        "prompt.tweets.firstPerson": "Tweety w pierwszej osobie",
        "prompt.shortPost.relevantEmojis": "Odpowiednie emotikony w krótkim poście",
        "prompt.shortPost.educationalTone": "Edukacyjny ton w krótkim poście",
        "prompt.shortPost.underdogTone": "Ton outsidera w krótkim poście",
        "prompt.shortPost.firstPerson": "Krótki post w pierwszej osobie",
        "prompt.titles.youtubeOptimized": "Tytuły zoptymalizowane pod YouTube",
        "prompt.titles.startWithHowTo": "Tytuły zaczynające się od 'Jak to zrobić'",
        "prompt.titles.otherOptions": "Inne opcje tytułów",
        "prompt.keywords.youtubeOptimized": "Słowa kluczowe zoptymalizowane pod YouTube",
        "prompt.keywords.separateWithCommas": "Oddziel słowa kluczowe przecinkami",
        "prompt.quotes.lorem1": "Cytat Lorem ipsum 1",
        "prompt.quotes.lorem2": "Cytat Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Punkt wypunktowany Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Punkt wypunktowany Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Długi post w pierwszej osobie",
        "prompt.longPost.relevantEmojis": "Odpowiednie emotikony w długim poście",
        "prompt.longPost.changeName": "Zmień imię w długim poście",
        "alert.tuningInstructionsEmpty": "Instrukcje dostrajania nie mogą być puste.",
        "text.timestamps.byPodsqueeze": "Znaczniki czasowe od PodSqueeze",
        "button.copied": "Skopiowano",
        "button.copy": "Kopiuj",
        "embed.transcript": "Osadź transkrypt",
        "embed.description": "Opis do osadzenia",
        "preview.title": "Podgląd tytułu",
        "loading.regenerating": "Regenerowanie...",
        "placeholder.tuningInstructions": "Wprowadź instrukcje dostrajania...",
        "button.saveClose": "Zapisz i zamknij",
        "button.acceptChanges": "Akceptuj zmiany",
        "button.discard": "Odrzuć",
        "button.embedTranscript": "Osadź transkrypt",
        "text.copiedToClipboard": "Skopiowano do schowka",
        "download.srtFile": "Pobierz plik SRT",
        "text.forCaptions": "do napisów",
        "tune.title": "Dostosuj swoje wyniki",
        "tune.description": "Dostosuj swoje wyniki za pomocą następujących opcji.",
        "instruction.label": "Instrukcje:",
        "button.tuneResult": "Dostosuj wynik",
        "instruction.saveForLater": "Zapisz na później",
        "button.readMore": "Czytaj więcej",
        "button.showLess": "Pokaż mniej",
        "customPrompt.used": "Użyty niestandardowy prompt:",
        "feedback.happyWithResults": "Czy jesteś zadowolony z wyników?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Znajdź trzy dobre cytaty z transkryptu",
        "prompt.blog": "Napisz post na bloga o długości 500 słów koncentrując się na temacie X",
        "prompt.tweets": "Napisz trzy angażujące tweety z transkryptu",
        "transcript.autoTranscribed": "Automatycznie transkrybowane z Podsqueeze",
        "alert.emptyPrompt": "Instrukcje nie mogą być puste",
        "embed.transcript": "Osadź transkrypt",
        "embed.description": "Osadź transkrypt o odpowiedniej wielkości z funkcją wyszukiwania na swojej stronie WordPress lub dowolnej stronie obsługującej HTML.",
        "button.copied": "Skopiowano!",
        "button.copy": "Kopiuj",
        "preview.title": "Podgląd",
        "edit.speakers": "Edytuj imiona mówców",
        "button.saveClose": "Zapisz i zamknij",
        "placeholder.prompt": "np: Znajdź trzy dobre cytaty z transkryptu",
        "upgrade.pro": "Ulepsz do Pro, aby korzystać z tej funkcji",
        "upgrade.link": "Ulepsz do Pro",
        "button.generate": "Generuj",
        "feedback.happy": "Czy jesteś zadowolony z wyników?",
        "instruction": "Instrukcja: ",
        "generating.results": "Generowanie wyników",
        "full.transcription": "Pełna transkrypcja",
        "srt.file": "& plik SRT",
        "download.srt": "Pobierz plik SRT",
        "caption.subtitles": "do napisów i tłumaczeń.",
        "generate.from.transcript": "Generuj z transkryptu z Gpt-4o",
        "gpt.tweak.text": "Poproś najnowszego GPT, aby dostosował tekst do Twoich upodobań. Używaj naturalnego języka i nie bój się być konkretnym.",
        "copied.clipboard": "Skopiowano do schowka",
        "transcript.public.available": "URL publiczne",
        "audio.notSupported": "Twoja przeglądarka nie obsługuje elementu audio.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Dodaj nazwę podcastu",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Jak dowiedziałeś się o Podsqueeze?",
        "sourceModal.otherPlaceholder": "Proszę określić",
        "sourceModal.nextButton": "Dalej",
        "sourceModal.skip": "Pomiń"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Mamy trudności z przetwarzaniem niektórych kanałów RSS. Proszę przesłać plik."
      },
      "squeezeResults": {
        "copiedToClipboard": "Skopiowano do schowka",
        "publicLink": "Publiczny pod adresem ",
        "createLink": "Utwórz link do udostępnienia tej strony z wynikami",
        "assembleShowNotes": "Zbierz notatki z odcinka",
        "convertAnotherEpisode": "Przekonwertuj inny odcinek",
        "writtenContent": "Treść pisemna",
        "videoClipsAndImages": "Klipy wideo i obrazy",
        "editAudio": "Edytuj dźwięk"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Zobacz więcej i dostrój",
        "see.more": "Zobacz więcej",
        "generating": "Generowanie",
        "download.all": "Pobierz wszystko",
        "full.transcription": "Pełna transkrypcja",
        "transcript.benefit": "Czy wiesz, że dodanie pełnych transkrypcji do notatek o odcinkach zwiększa ruch na stronie i zaangażowanie?",
        "learn.more": "Dowiedz się więcej",
        "transcript.bonus": "Możesz dostarczyć pełne transkrypcje jako bonus dla swojego programu członkowskiego podcastu.",
        "show.notes": "Notatki o odcinkach",
        "show.notes.engagement": "Rozważ uzupełnienie tego krótkiego opisu innymi elementami w notatkach o odcinkach, aby zwiększyć zaangażowanie i SEO.",
        "show.notes.examples": "Znajdź inspirację w tych 17 przykładach notatek o odcinkach podcastów, aby stworzyć idealne dla swojego podcastu.",
        "timestamps": "Znaczniki czasowe",
        "timestamps.benefit": "Dodaj te znaczniki czasowe do opisu swojego odcinka, a automatycznie utworzy to rozdziały na Spotify i YouTube.",
        "titles": "Tytuły",
        "titles.engagement": "Tytuły zawierające znaki zapytania i superlatywy są szczególnie angażujące.",
        "links.and.mentions": "Linki i Wzmianki",
        "mentions.resources": "Rozważ uwzględnienie poniższych wzmiank w sekcji zasobów swoich notatek o odcinkach.",
        "mentions.affiliate": "Sprawdź, czy wymienione produkty mają programy partnerskie i rozważ dodanie linków partnerskich w swoich notatkach o odcinkach.",
        "mentions.social.media": "Oznacz osoby wspomniane w swoim odcinku w mediach społecznościowych, aby zachęcić je do udostępnienia i zaangażowania się w Twój post.",
        "keywords": "Słowa kluczowe",
        "keywords.youtube": "Gdy przesyłasz swój odcinek na YouTube, po prostu skopiuj i wklej te słowa kluczowe do sekcji tagów.",
        "keywords.social.media": "Wykorzystaj te słowa kluczowe jako hashtagi w mediach społecznościowych.",
        "blog.post": "Post na blogu",
        "blog.post.linkedin": "Rozważ użycie tej treści do stworzenia długiego posta na LinkedIn,",
        "blog.post.share": "Udostępnij tę treść w społecznościach Reddit i grupach na Facebooku, które są zgodne z tematem Twojego podcastu.",
        "newsletter": "Newsletter",
        "newsletter.content": "Niektórzy z naszych użytkowników przekształcają tę treść newslettera w bardziej szczegółowe opisy odcinków do notatek o odcinkach.",
        "linkedin.and.facebook": "LinkedIn i Facebook",
        "short.post.description": "Użyj tych krótkich postów jako opisów podczas udostępniania powiązanych klipów wideo i audiogramów w mediach społecznościowych.",
        "tweets": "Tweety",
        "quotes": "Cytaty",
        "bullet.points": "Punkty wypunktowane",
        "add.custom.result": "Dodaj własny wynik",
        "bullet.points.skimming": "Podcasterzy często wymieniają główne tematy odcinków jako punkty wypunktowane w notatkach o odcinkach, aby ułatwić przeglądanie."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Zobacz więcej i dostrój",
        "generating": "Generowanie",
        "not.available.for.rss.feed": "Niedostępne dla tego kanału RSS",
        "regenerate.episode.upload.file": "Regeneruj odcinek i przesyłaj swój plik audio/wideo bezpośrednio z komputera",
        "processing.difficulties": "Doświadczamy trudności w przetwarzaniu niektórych kanałów RSS. Proszę przesłać plik.",
        "video.clips": "Klipy wideo",
        "ai.short.clips": "Krótkie klipy AI",
        "quote.image": "Obrazek cytatu"
      },
      "title": {
        "title.text": "twoja.etykieta"
      },
      "topbar": {
        "topbar.forYou": "Dla Ciebie",
        "topbar.joinPodcast": "Dołącz do naszego następnego wirtualnego spotkania podcastowego!",
        "topbar.saveYourSpot": "Zarezerwuj swoje miejsce",
        "topbar.dismiss": "Zamknij"
      },
      "trackers": {
        "trackers.init": "Inicjowanie trackerów z włączonymi ciasteczkami: ",
        "trackers.loadScripts": "Ładowanie skryptów śledzących..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Witamy w Mojej Aplikacji",
        "content.description": "To jest przykładowa aplikacja demonstrująca tłumaczenie.",
        "button.submit": "Wyślij"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI edytuje Twój klip",
        "export_clip": "Eksportuj klip",
        "ai_edit": "Edycja AI",
        "ai_editing_clip_duration": "To zajmie kilka sekund",
        "generating_clip": "Generowanie Twojego klipu...",
        "generating_clip_notice": "To może potrwać kilka minut. Wyślemy Ci e-mail, gdy to będzie gotowe.",
        "edit_another_video": "Możesz poczekać tutaj lub edytować inny film",
        "download_video": "Pobierz wideo",
        "back_to_editing": "Powrót do edycji",
        "export_video_button": "Eksportuj klip",
        "notice_storage": "Uwaga: Przechowujemy Twoje audio przez 30 dni. Po tym okresie ten klip wygaśnie.",
        "error_generating_clip": "Błąd podczas generowania klipu",
        "error_user_support": "Proszę spróbować ponownie lub skontaktować się z naszym wsparciem użytkowników",
        "select_template": "Wybierz szablon",
        "add_30s_prev": "30s z poprzedniego rozdziału",
        "add_30s_next": "30s z następnego rozdziału",
        "undo": "Cofnij",
        "subtitles_font": "Czcionka napisów",
        "subtitles_color": "Kolor napisów",
        "subtitles_box_color": "Kolor animacji",
        "adjust_podcast_title_position": "Dostosuj pionową pozycję tytułu podcastu",
        "adjust_subtitles_size": "Dostosuj rozmiar napisów",
        "adjust_subtitles_vertical_position": "Dostosuj pionową pozycję napisów",
        "remove_subtitles": "Usuń napisy",
        "animated_subtitles": "Animowane napisy",
        "upgrade_here": "Ulepsz tutaj",
        "remove_logo": "aby usunąć logo",
        "remove_podsqueeze_logo": "Usuń logo podsqueeze",
        "aspect_ratio": "Proporcje",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Tytuł odcinka",
        "podcast_title": "Tytuł podcastu",
        "titles_font": "Czcionka tytułów",
        "title_colors": "Kolory tytułów podcastu/odcinka",
        "video_fit": "Dopasowanie wideo",
        "adjust_horizontal_position": "Dostosuj pozycję poziomą",
        "adjust_vertical_position": "Dostosuj pozycję pionową",
        "adjust_video_zoom": "Dostosuj zoom wideo",
        "adjust_video_width": "Dostosuj szerokość wideo",
        "adjust_video_height": "Dostosuj wysokość wideo",
        "background_color": "Kolor tła",
        "edit_clip": "Edytuj klip",
        "edit_layout": "Edytuj layout",
        "choose_short": "Wybierz krótki",
        "edit_audio": "Edytuj audio",
        "framing": "Kadrowanie",
        "background": "Tło",
        "text_style": "Styl tekstu",
        "music": "Muzyka",
        "choose_chapter": "Wybierz rozdział",
        "clips_left": "Masz",
        "apply_layout": "Zastosuj layout",
        "clips_left_number": "klipów",
        "need_more_clips": "Potrzebujesz więcej klipów? Ulepsz swój plan tutaj",
        "download_srt_file": "Pobierz plik SRT",
        "track_selected": "Ścieżka: ",
        "no_background_music": "Nie wybrano muzyki w tle",
        "volume": "Głośność:",
        "remove": "Usuń",
        "track_ambient_piano": "Ambientowe piano i smyczki",
        "track_deep_meditation": "Głęboka medytacja",
        "track_chill_upbeat": "Chillujący, optymistyczny",
        "track_inspiring_ambient": "Inspirująca, filmowa atmosfera",
        "track_just_relax": "Po prostu zrelaksuj się",
        "track_movement": "Ruch",
        "track_once_in_paris": "Raz w Paryżu",
        "track_perfect_beauty": "Idealne piękno",
        "track_summer_adventures": "Letnie przygody",
        "track_sunset_groove": "Zachodzące słońce",
        "track_tvari_cafe": "Kawiarnia Tvari w Tokio",
        "track_short_piano_intermezzo": "Krótkie Intermezzo Fortepianowe",
        "track_dramatic_background": "Dramatyczna Muzyka w Tle",
        "track_dramatic_hiphop": "Dramatyczny Hip-Hop Jazz",
        "track_emotional_orchestra": "Emocjonalna Orkiestra",
        "track_halloween_short": "Muzyka Halloween",
        "track_improvisation_037": "Improwizacja Jazzowa",
        "track_inspiration_piano": "Inspirujący Fortepian",
        "track_medieval_extract": "Muzyka Średniowieczna",
        "track_short_8": "Krótki Utwór Ambient",
        "track_flute": "Spokojna Flauta",
        "track_piano_guitar_duet": "Duet Fortepian-Gitara",
        "track_intro_jazz": "Jazz Wstępny",
        "track_romantic_jazz": "Romantyczny Jazz",
        "recommended_for_youtube": "Polecane dla YouTube",
        "turn_into_short_clip": "Przekształć ten klip w krótki (<60s)",
        "browser_not_support_audio": "Twoja przeglądarka nie obsługuje elementu audio.",
        "watch_tutorial": "Obejrzyj ten samouczek",
        "audiogram_maker": "jak najlepiej wykorzystać nasz kreator audiogramów",
        "store_audio_notice": "Uwaga: Przechowujemy Twoje audio przez 30 dni.",
        "clip_maker": "jak najlepiej wykorzystać nasz kreator klipów",
        "split_screen_mode": "Tryb podziału ekranu",
        "none": "Brak",
        "vertical_split": "Podział pionowy",
        "horizontal_split": "Podział poziomy",
        "layers": "Użyj poniższych warstw, aby przesunąć je do przodu lub do tyłu.",
        "screen_1_horizontal_position": "Pozycja Pozioma Ekranu 1",
        "screen_2_horizontal_position": "Pozycja Pozioma Ekranu 2",
        "track_mysterious_dark_background": "Tajemnicze ciemne tło",
        "track_acoustic_ambient_inspiration": "Akustyczna ambientowa inspiracja",
        "track_aristocracy_classical": "Arystokracja klasyczna",
        "track_folk_music_river_knows_my_name": "Muzyka folkowa - Rzeka zna moje imię",
        "track_funy_adventure": "Zabawna przygoda",
        "track_energetic_sports_rock_trailer": "Energetyczny sportowy rock trailer",
        "track_fun_upbeat_energetic_pop_rock": "Zabawny energetyczny pop rock",
        "track_epic_emotional_inspirational": "Epicki emocjonalny inspirujący",
        "track_inspirational_epic": "Inspirujący epicki",
        "all_music": "Cała muzyka",
        "energetic_music": "Energetyczna",
        "inspirational_music": "Inspirująca",
        "ambient_music": "Ambient",
        "chill_music": "Relaksacyjna",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Dziwaczna",
        "dramatic_music": "Dramatyczna",
        "acoustic_music": "Akustyczna",
        "classical_music": "Klasyczna",
        "categories": "Kategorie",
        "select_track": "Wybierz utwór",
        "upload_music": "Prześlij muzykę",
        "my_music": "Moja muzyka",
        "downloading": "Pobieranie...",
        "download_again": "Pobierz ponownie",
        "download": "Pobierz",
        "download_failed_alert": "Nie udało się pobrać wideo. Spróbuj ponownie.",
        "translate_subtitles": "Przetłumacz Napisy",
        "translate_to": "Przetłumacz na",
        "select_language": "Wybierz Język",
        "select_new_language": "Wybierz nowy język",
        "translating": "Tłumaczenie...",
        "translation_complete": "Tłumaczenie Zakończone",
        "error_translation": "Błąd podczas tłumaczenia. Spróbuj ponownie.",
        "original_language": "Oryginał"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Tytuł odcinka"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Nie masz jeszcze żadnej treści.",
        "userPodcastsInfo.generateContent": "Wygeneruj swoją pierwszą treść",
        "placeholder.search_folders": "Szukaj folderów...",
        "search.no_results": "Żaden folder nie pasuje do wyszukiwania."
      },
      "landingPageModal": {
        "upload.error": "Nie udało się przesłać obrazu: ",
        "upload.image.file": "Proszę przesłać plik obrazu.",
        "upgrade.pro.message": "Personalizacja strony jest dostępna tylko dla kont Pro i Agency",
        "upgrade.now": "Ulepsz teraz",
        "upgrade.unique.landing.page": " i stwórz unikalną stronę docelową odcinka.",
        "logo.recommendation": "Zalecana wysokość logo 200px",
        "social.links.top.menu": "Linki społecznościowe w górnym menu",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Wprowadź link do LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Wprowadź link do Facebooka",
        "saving...": "Zapisywanie...",
        "save": "Zapisz",
        "saved.successfully": "Zapisano pomyślnie!",
        "uploading.image": "Przesyłanie obrazu...",
        "upload.episode.cover": "Prześlij okładkę odcinka",
        "upload.logo": "Prześlij logo",
        "where.listen.episode": "Gdzie jeszcze możemy posłuchać tego odcinka?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Wprowadź link do YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Wprowadź link do Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Wprowadź link do Spotify",
        "image.size.recommendation": "Zalecany rozmiar 1000x1000px",
        "primary.color.label": "Kolor podstawowy",
        "header.background.color": "Kolor tła nagłówka i linków.",
        "landing.page.customization": "Personalizacja strony docelowej",
        "create.branded.landing.page": "Stwórz piękną markową stronę docelową, aby podzielić się z słuchaczami",
        "episode.image": "Obraz odcinka",
        "episode.links": "Linki do odcinka",
        "page.header": "Nagłówek strony",
        "page.color": "Kolor strony",
        "visit.landing.page": "Odwiedź stronę docelową"
      },
      "page": {
        "loading.dashboard": "Ładowanie pulpitu",
        "convert.new.episode": "Konwertuj nowy odcinek",
        "convert.audio.or.video": "Konwertuj audio lub video",
        "minutes.left": "Masz",
        "need.more.minutes": "Potrzebujesz więcej minut?",
        "upgrade.plan": "Zaktualizuj swój plan tutaj.",
        "your.podcasts": "Twoje podcasty",
        "podsqueeze.results.page": "Strona wyników Podsqueeze",
        "access.podsqueeze.results": "Uzyskaj dostęp do wyników podsqueeze dla tego odcinka. Będziesz mógł zobaczyć wszystkie wygenerowane treści"
      },
      "podcast": {
        "confirm.delete_episode": "Czy na pewno chcesz usunąć ten odcinek?",
        "alert.something_wrong": "Coś poszło nie tak. Spróbuj ponownie.",
        "confirm.delete_folder": "Czy na pewno chcesz usunąć ten folder?",
        "loading.episodes": "Ładowanie odcinków...",
        "folder.empty": "Ten folder jest pusty.",
        "content.no_content": "Brak dostępnych treści.",
        "content.generate_first": "Wygeneruj swój pierwszy podcast.",
        "button.personalize_ai": "Personalizuj z AI",
        "button.edit_website": "Edytuj stronę",
        "button.visit_website": "Odwiedź stronę",
        "button.generate_website": "Wygeneruj stronę",
        "placeholder.search": "Szukaj...",
        "label.sort_by": "Sortuj według",
        "label.last_episodes_loaded": "Ostatnio załadowane odcinki",
        "button.load_all_episodes": "Załaduj wszystkie odcinki",
        "loading": "Ładowanie...",
        "add.new.episode": "Dodaj nowy odcinek",
        "order.newest": "Najnowsze najpierw",
        "order.oldest": "Najstarsze najpierw",
        "order.a_to_z": "A do Z",
        "order.z_to_a": "Z do A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Utwórz nowy folder podcastu:",
        "folder.name.placeholder": "Nazwa folderu",
        "create.button": "Utwórz"
      },
      "podcastLandingModal": {
        "upload.image.error": "Proszę przesłać plik graficzny",
        "podcast.cover.title": "Obrazek okładki podcastu",
        "podcast.cover.upload": "Prześlij tutaj obrazek okładki swojego podcastu. Będzie on wyświetlany w widocznym miejscu na Twojej stronie głównej.",
        "upload.image.uploading": "Przesyłanie obrazu...",
        "podcast.cover.upload.button": "Prześlij obrazek okładki",
        "podcast.cover.recommended.size": "Zalecany rozmiar: 1400x1400 pikseli",
        "profile.info.title": "Informacje o profilu",
        "profile.info.upload": "Dodaj swoje zdjęcie profilowe i imię, aby spersonalizować swoją stronę główną.",
        "profile.upload.button": "Prześlij zdjęcie profilowe",
        "profile.name.label": "Nazwa profilu",
        "profile.name.placeholder": "Wprowadź swoje imię",
        "platform.links.title": "Linki do platform",
        "platform.links.upload": "Dodaj linki do swojego podcastu na różnych platformach.",
        "platform.links.youtube_link": "Link do YouTube",
        "platform.links.youtube_link.placeholder": "Wprowadź link do YouTube",
        "platform.links.spotify_link": "Link do Spotify",
        "platform.links.spotify_link.placeholder": "Wprowadź link do Spotify",
        "platform.links.apple_podcast_link": "Link do Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Wprowadź link do Apple Podcast",
        "platform.links.linkedin_link": "Link do LinkedIn",
        "platform.links.linkedin_link.placeholder": "Wprowadź link do LinkedIn",
        "platform.links.facebook_link": "Link do Facebooka",
        "platform.links.facebook_link.placeholder": "Wprowadź link do Facebooka",
        "platform.links.twitter_link": "Link do Twittera",
        "platform.links.twitter_link.placeholder": "Wprowadź link do Twittera",
        "call.to.action.title": "Call to Action",
        "call.to.action.upload": "Skonfiguruj przycisk wezwania do działania na stronie głównej.",
        "call.to.action.button.text.label": "Tekst przycisku",
        "call.to.action.button.text.placeholder": "Wprowadź tekst przycisku",
        "call.to.action.button.link.label": "Link przycisku",
        "call.to.action.button.link.placeholder": "Wprowadź link przycisku",
        "color.styles.title": "Style kolorów",
        "color.styles.upload": "Dostosuj kolory swojej strony głównej.",
        "color.styles.primary.label": "Kolor podstawowy",
        "color.styles.primary.description": "Wybierz kolor podstawowy dla swojej strony głównej",
        "color.styles.secondary.label": "Kolor dodatkowy",
        "color.styles.secondary.description": "Wybierz kolor dodatkowy dla swojej strony głównej",
        "podcast.info.title": "Informacje o podcastie",
        "podcast.info.upload": "Edytuj szczegóły swojego podcastu.",
        "podcast.info.name.label": "Nazwa podcastu",
        "podcast.info.name.placeholder": "Wprowadź nazwę podcastu",
        "podcast.info.description.label": "Opis podcastu",
        "podcast.info.description.placeholder": "Wprowadź opis podcastu",
        "edit.website.title": "Edytuj stronę",
        "generate.website.title": "Generuj stronę",
        "for": "dla",
        "saving": "Zapisywanie...",
        "save.changes": "Zapisz zmiany",
        "generate.website": "Generuj stronę",
        "changes.saved.success": "Zmiany zostały pomyślnie zapisane!",
        "podcast.cover.menu": "Okładka podcastu",
        "podcast.info.menu": "Informacje o podcastie",
        "profile.menu": "Profil",
        "platform.links.menu": "Linki do platform",
        "call.to.action.menu": "Call to Action",
        "color.styles.menu": "Style kolorów",
        "logo.menu": "Logo",
        "logo.title": "Logo Uploaden",
        "logo.upload": "Upload hier je podcast logo. Dit logo wordt weergegeven op je landingspagina.",
        "logo.upload.button": "Logo Uploaden",
        "platform.links.description": "Voeg links naar je podcast op verschillende platforms toe.",
        "social.links.menu": "Sociale Links",
        "social.links.title": "Sociale Media Links",
        "social.links.description": "Voeg links naar je sociale media profielen toe.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Voer LinkedIn-link in",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Voer Facebook-link in",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Voer Twitter-link in",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Voer Instagram-link in",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Voer YouTube-link in",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Voer Spotify-link in",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Voer Apple Podcast-link in",
        "view.website": "Zobacz stronę"
      },
      "podcastMoveModal": {
        "move.episode.label": "Przenieś ten odcinek do:",
        "move.episode.instruction": "Możesz wpisać nową nazwę, aby utworzyć folder.",
        "move.episode.button": "Przenieś",
        "move.episode.error.selectFolder": "Proszę wybrać folder, aby przenieść odcinek."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Ustawienia AI dla podcastu {{podcastTitle}}",
        "ai.customize.writing.style": "Dostosuj swój styl pisania AI",
        "ai.content.writing.preference": "Jak chciałbyś, aby Podsqueeze pisał Twoje treści?",
        "ai.voice.placeholder": "Przykład: Profesjonalny, ale przyjazny ton. Słuchacze to podcasterzy. Pisz w pierwszej osobie.",
        "ai.character.limit.reached": "Osiągnąłeś limit znaków wynoszący 50.",
        "ai.upgrade.now": "Ulepsz teraz",
        "ai.fix.transcript.misspells": "Popraw błędy w transkrypcji",
        "ai.enter.misspelled.words": "Wpisz słowa, które AI często błędnie pisze w odcinkach tego podcastu, np. imiona",
        "ai.enter.word.press.enter": "Wpisz słowo i naciśnij Enter",
        "ai.add.word": "Dodaj słowo",
        "ai.tag.limit.reached": "Osiągnięto limit 1 tagu.",
        "ai.save": "Zapisz",
        "ai.save.close": "Zapisz i zamknij"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Tytuł odcinka",
        "selectedEpisode.podcastName": "Nazwa podcastu",
        "selectedEpisode.showNotes": "Notatki do odcinka",
        "selectedEpisode.timestamp": "Znacznik czasu",
        "selectedEpisode.staticTimestamp": "Statyczny znacznik czasu",
        "selectedEpisode.mentions": "Wzmianki",
        "selectedEpisode.newsletter": "Biuletyn",
        "selectedEpisode.titles": "Tytuły",
        "selectedEpisode.tweeter": "Tweeter",
        "selectedEpisode.shortPost": "Krótki post",
        "selectedEpisode.transcription": "Transkrypcja",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Słowa kluczowe",
        "selectedEpisode.quotes": "Cytaty",
        "selectedEpisode.longPost": "Długi post",
        "selectedEpisode.bulletPoints": "Punkty wypunktowane",
        "selectedEpisode.publicLink": "Link publiczny",
        "selectedEpisode.embeddedId": "Zagnieżdżone ID",
        "selectedEpisode.episodeUrl": "URL odcinka"
      },
      "sidebar": {
        "tools": "Narzędzia",
        "find.podcast.topic.ideas": "Znajdź pomysły na tematy podcastów",
        "podcast.thumbnail.maker": "Kreator miniatur podcastów",
        "podcast.seo.optimizer": "Optymalizator SEO podcastów",
        "account": "Konto",
        "payment.settings": "Ustawienia płatności",
        "support": "Wsparcie",
        "logout": "Wyloguj się",
        "plan": "Plan",
        "resets.in": "Resetuje się za",
        "api.access": "Dostęp do API",
        "days": "dni i",
        "hours": "godzin",
        "upgrade.plan": "Zaktualizuj plan"
      },
      "updateEmailModal": {
        "email.validation.error": "Proszę wprowadzić prawidłowy adres e-mail.",
        "email.change.confirm": "Czy na pewno chcesz zmienić swój adres e-mail?",
        "email.change.success": "Twój adres e-mail został pomyślnie zmieniony!",
        "email.in.use.error": "Ten adres e-mail jest już używany. Proszę spróbować innego.",
        "email.recent.login.error": "Przed kontynuowaniem tej operacji, proszę zalogować się ponownie używając aktualnego adresu e-mail.",
        "email.invalid.error": "Nieprawidłowy adres e-mail. Proszę spróbować innego.",
        "subscription.cancel.error": "Proszę najpierw anulować swoją aktywną płatną subskrypcję.",
        "account.delete.confirm": "Czy na pewno chcesz usunąć swoje konto?\n\nTa akcja nie może być cofnięta.",
        "account.delete.success": "Twoje konto zostało pomyślnie usunięte.",
        "account.delete.error": "Coś poszło nie tak i nie mogliśmy usunąć twojego konta.\n\n Proszę skontaktować się z naszym wsparciem użytkowników.",
        "subscription.cancel": "Anuluj subskrypcję",
        "account.delete": "Usuń konto",
        "account.delete.warning": "Usunięcie konta jest nieodwracalne i na zawsze usunie wszystkie twoje treści oraz informacje logowania. Proszę postępować ostrożnie, ponieważ ta akcja nie może być cofnięta.",
        "current.account.email": "Aktualny adres e-mail konta",
        "enter.new.email": "Wprowadź nowy adres e-mail konta",
        "update": "Aktualizuj",
        "change.password": "Zmień hasło",
        "payment.settings": "Ustawienia płatności"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "tytułOdcinka"
      },
      "episodelist": {
        "loading.episodes": "Ładowanie odcinków",
        "no.episodes.found": "Nie znaleziono odcinków. Proszę spróbować ponownie z prawidłowym identyfikatorem RSS",
        "select.episode": "Wybierz odcinek, dla którego chcesz stworzyć treść"
      },
      "interfaces": {
        "user.activePlan.tier": "Poziom",
        "user.activePlan.creationDate": "Data utworzenia",
        "user.activePlan.minutesAvailable": "Dostępne minuty"
      },
      "loadingbar": {
        "loadingbar.magic": "Wciąż czarujemy ✨",
        "loadingbar.longer": "Niektóre odcinki zajmują trochę więcej czasu... 🐌",
        "loadingbar.hardwork": "Nasze serwery ciężko pracują 🦾"
      },
      "page": {
        "main.background": "Tło głównego komponentu"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Błąd: Dostęp do mikrofonu lub kamery został odmówiony.",
        "microphone.camera.not.found": "Błąd: Nie znaleziono mikrofonu ani kamery.",
        "microphone.camera.not.readable": "Błąd: Mikrofon lub kamera są niedostępne.",
        "microphone.camera.access.error": "Błąd: Wystąpił nieznany błąd podczas uzyskiwania dostępu do mikrofonu lub kamery.",
        "media.not.recorded": "Błąd: Nie nagrano żadnych mediów.",
        "upload.failed": "Błąd: Wysyłanie nie powiodło się.",
        "upload.success": "Sukces: Wysyłanie zakończone pomyślnie.",
        "upload.in.progress": "Wysyłanie w toku...",
        "upload.button": "Wyślij nagranie",
        "stop.recording": "Zatrzymaj nagrywanie",
        "record.audio": "Nagrywaj dźwięk",
        "record.audio.video": "Nagrywaj dźwięk z wideo",
        "record.again": "Nagrywaj ponownie",
        "episode.language": "Wybierz język odcinka"
      },
      "selectBox": {
        "language.english": "Angielski",
        "language.arabic": "Arabski",
        "language.bulgarian": "Bułgarski",
        "language.catalan": "Kataloński",
        "language.croatian": "Chorwacki",
        "language.czech": "Czeski",
        "language.danish": "Duński",
        "language.dutch": "Holenderski",
        "language.finnish": "Fiński",
        "language.french": "Francuski",
        "language.german": "Niemiecki",
        "language.greek": "Grecki",
        "language.hindi": "Hindi",
        "language.hungarian": "Węgierski",
        "language.indonesian": "Indonezyjski",
        "language.italian": "Włoski",
        "language.japanese": "Japoński",
        "language.korean": "Koreański",
        "language.lithuanian": "Litewski",
        "language.latvian": "Łotewski",
        "language.malay": "Malajski",
        "language.mandarin": "Mandaryński",
        "language.norwegian": "Norweski",
        "language.polish": "Polski",
        "language.portuguese": "Portugalski",
        "language.romanian": "Rumuński",
        "language.russian": "Rosyjski",
        "language.slovak": "Słowacki",
        "language.slovenian": "Słoweński",
        "language.spanish": "Hiszpański",
        "language.swedish": "Szwedzki",
        "language.tamil": "Tamilski",
        "language.turkish": "Turecki",
        "language.ukrainian": "Ukraiński",
        "language.bashkir": "Baszkirski",
        "language.basque": "Baskijski",
        "language.belarusian": "Białoruski",
        "language.cantonese": "Kantoński",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estoński",
        "language.galician": "Galicyjski",
        "language.interlingua": "Interlingua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongolski",
        "language.persian": "Perski",
        "language.thai": "Tajski",
        "language.uyghur": "Ujgur",
        "language.vietnamese": "Wietnamski",
        "language.welsh": "Walijski"
      },
      "selectedepisode": {
        "processing.episode": "Przetwarzanie odcinka",
        "processing.time": "Zwykle zajmuje to od 5 do 10 minut",
        "email.notification": "Możesz zamknąć to okno. Wyślemy Ci e-mail, gdy będzie gotowe. Twoje treści będą również dostępne na Twoim pulpicie.",
        "convert.another.episode": "Przetłumacz inny odcinek",
        "technical.difficulties": "Ups! Doświadczamy pewnych trudności technicznych. Możesz być pewny, że nasz zespół się tym zajmuje! Proszę spróbować ponownie później.",
        "no.discount": "Nie martw się, nie obniżymy żadnych minut!",
        "high.demand": "Doświadczamy wyższego niż zwykle popytu, więc przetworzenie Twojego żądania może zająć więcej czasu niż zwykle. Przepraszamy za wszelkie niedogodności!",
        "email.ready": "Wyślemy Ci e-mail, gdy będzie gotowe. Możesz również uzyskać dostęp do swoich wyników na swoim pulpicie.",
        "select.podcast.folder": "Wybierz folder podcastu, do którego należy ten odcinek, lub utwórz nowy, wpisując nazwę.",
        "give.voice": "Dodaj swoją własną głos",
        "not.enough.minutes.title": "Nie masz wystarczająco minut",
        "not.enough.minutes.message": "Nie masz wystarczająco minut do konwersji tego odcinka. Proszę zaktualizować swój plan.",
        "upgrade.plan": "Zaktualizuj swój plan",
        "convert.shorter.episode": "Przetłumacz krótszy odcinek",
        "generate.content": "Generuj treść",
        "content.ready": "Twoja treść jest gotowa!",
        "ask.ai.tune": "Możesz nadal poprosić AI o dostosowanie każdej treści, aby lepiej odpowiadała Twoim potrzebom.",
        "error.title": "Błąd",
        "convert.another.file": "Konwertuj inny plik"
      },
      "submitfile": {
        "file.size.exceeded.free": "Rozmiar pliku przekracza maksymalny limit 4 GB. <p>Proszę <a href='/pricing'><b><u>zaktualizować, aby przesłać większe pliki</u></b></a></p>",
        "file.size.exceeded.paid": "Rozmiar pliku przekracza maksymalny limit 10 GB. <p>Proszę wybrać mniejszy plik.</p>",
        "file.upload.invalid": "Proszę przesłać plik audio lub wideo",
        "upload.in.progress": "Przesyłanie pliku. Proszę, nie zamykaj tego okna.",
        "upload.button": "Prześlij & Generuj",
        "close.button": "Zamknij",
        "upgrade.message.free": "Więcej przesyłek jest dostępnych tylko w płatnych planach.",
        "upgrade.now.button": "Zaktualizuj teraz",
        "pricing.info": "od 12 $/miesiąc",
        "upload.file.label": "Prześlij plik audio lub wideo",
        "max.file.size.free": "(maks 4 gb)",
        "max.file.size.paid": "(maks 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze wygeneruje audiogramy dla plików audio i krótkie klipy dla plików wideo",
        "file.placeholder": "Twój plik MP3/WAV",
        "episode.language.label": "Język odcinka",
        "select.folder.label": "Wybierz lub utwórz folder",
        "multiple.files.selected": "{{count}} plików wybranych",
        "clear.all": "Wyczyść wszystko",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Wybierz wiele plików",
        "file.upload.error": "Błąd przesyłania pliku",
        "file.upload.success": "Plik przesłany pomyślnie",
        "file.upload.processing": "Przetwarzanie pliku",
        "click.to.upload": "Kliknij, aby przesłać",
        "click.to.upload.multiple": "Kliknij, aby przesłać wiele plików",
        "enter.url": "Wprowadź URL",
        "upload.file": "Prześlij plik",
        "media.url.label": "URL multimediów",
        "media.url.help": "Wprowadź URL pliku audio lub wideo. Pobierzemy go i przetworzymy dla Ciebie.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Nazwa odcinka",
        "url.input.required": "Wprowadź URL multimediów",
        "url.upload.error": "Nie udało się przesłać multimediów z URL. Sprawdź URL i spróbuj ponownie.",
        "supported.formats": "Obsługiwane formaty",
        "uploading": "Przesyłanie...",
        "media.url.requirements": "URL musi być bezpośrednim linkiem do publicznego pliku multimedialnego (nie strony internetowej)"
      },
      "submitrssid": {
        "error.selectRss": "Proszę wybrać prawidłowy RSS z rozwijanego menu",
        "label.insertRssFeed": "Wstaw swój kanał RSS",
        "placeholder.insertRssFeed": "Wstaw swój kanał RSS",
        "label.searchByPodcast": "Szukaj według nazwy podcastu",
        "label.searchForPodcast": "Szukaj swojego podcastu",
        "placeholder.searchForPodcast": "Szukaj podcastu",
        "label.cantFindPodcast": "Nie możesz znaleźć swojego podcastu? ",
        "label.clickHereUseRss": "Kliknij tutaj, aby użyć swojego kanału RSS",
        "label.selectedPodcast": "Wybrany podcast",
        "label.episodeLanguage": "Język odcinka",
        "button.seeAllEpisodes": "Zobacz wszystkie odcinki",
        "select.folder.label": "Wybierz lub utwórz folder"
      },
      "submitsection": {
        "search.podcast": "Szukaj swojego podcastu",
        "upload.audio.video": "Prześlij audio lub wideo",
        "record.audio": "Nagraj audio",
        "youtube.video": "Link YouTube",
        "create.content": "Stwórzmy treść dla twojego podcastu!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Wprowadź adres URL filmu YouTube",
        "error.insertYouTubeUrl": "Proszę wprowadzić adres URL YouTube.",
        "label.insertYouTubeUrl": "Wprowadź adres URL YouTube",
        "button.loading": "Ładowanie...",
        "message.downloadingFile": "Pobieranie pliku...",
        "error.processingFailed": "Błąd: przetwarzanie filmu nie powiodło się.",
        "button.submitYouTubeVideo": "Prześlij film YouTube",
        "error.youtubeVideoNotAvailable": "Ten film YouTube nie jest dostępny do pobrania. Proszę przesłać swoje audio lub wideo bezpośrednio do Podsqueeze lub użyć YouTube downloader najpierw. Dziękujemy za cierpliwość.",
        "episode.language.label": "Używana język",
        "select.folder.label": "Wybierz lub utwórz folder"
      },
      "tabs": {
        "tab.label.tab1": "Zakładka 1",
        "tab.label.tab2": "Zakładka 2",
        "tab.label.tab3": "Zakładka 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Wykorzystaj w pełni Podsqueeze",
        "tutorial.chapter.introduction": "Wprowadzenie",
        "tutorial.chapter.bestShowNotes": "Uzyskaj najlepsze notatki z odcinków i znaczniki czasowe",
        "tutorial.chapter.blogPosts": "Wykorzystanie postów na blogu i newsletterów",
        "tutorial.chapter.editingTranscripts": "Osadzanie i edytowanie transkryptów",
        "tutorial.chapter.personalizingAI": "Personalizacja AI i nadanie własnego głosu",
        "tutorial.chapter.speedingUpNotes": "Przyspieszanie notatek z odcinków",
        "tutorial.chapter.creatingClips": "Tworzenie klipów wideo i obrazów",
        "tutorial.chapter.generatingLandingPage": "Generowanie strony docelowej",
        "tutorial.chapter.shareResults": "Udostępnij wyniki swojemu zespołowi",
        "tutorial.closeVideoCheckbox": "Zamknij wideo, gdy pierwsze wyniki będą gotowe"
      },
      "uploadloadingbar": {
        "upload.loading": "Ładowanie..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Skontaktuj się z nami",
        "contact.section.email": "Napisz do nas na adres support@podsqueeze.com",
        "contact.section.tiago.role": "Współzałożyciel",
        "contact.section.joao.role": "Współzałożyciel",
        "contact.section.image.alt.sendMessage": "Wyślij wiadomość",
        "contact.section.image.alt.tiago": "Współzałożyciel Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Współzałożyciel Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Skontaktuj się z nami",
        "contact.section.email": "Napisz do nas na adres support@podsqueeze.com",
        "contact.section.tiago.role": "Współzałożyciel",
        "contact.section.joao.role": "Współzałożyciel",
        "contact.section.image.alt.sendMessage": "Wyślij wiadomość",
        "contact.section.image.alt.tiago": "Współzałożyciel Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Współzałożyciel Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Dołącz do 20 000 twórców treści i profesjonalistów podcastowych korzystających z Podsqueeze",
        "content.creators": "Twórcy Treści",
        "podcast.managers": "Menadżerowie Podcastów",
        "producers.studios": "Producenci i Studia",
        "for.podcasters": "DLA PODKASTERÓW, MENADŻERÓW PODCASTÓW I AGENCJI",
        "manage.content.creation": "Zarządzaj tworzeniem treści bez wysiłku dla",
        "multiple.podcasts": "wielu podcastów",
        "podsqueeze.description": "Podsqueeze to potężne narzędzie dla wszystkich profesjonalistów podcastowych. Niezależnie od tego, czy jesteś solowym podcasterem, menadżerem podcastów, czy agencją, Podsqueeze oferuje wszystkie funkcje, których potrzebujesz, aby uprościć swój proces tworzenia treści podcastowych.",
        "create.podcast.folders": "Twórz foldery podcastów, aby utrzymać porządek w swoich odcinkach.",
        "share.content.page": "Łatwo udostępniaj swoją stronę z treścią klientom i zespołowi",
        "tune.ai.voice": "Dostosuj głos AI dla każdego programu, którym zarządzasz",
        "plan.content.episodes": "Planuj treść na następne odcinki z naszym zaawansowanym",
        "podcast.topics.finder": "narzędziem do znajdowania tematów podcastów",
        "podsqueeze.testimonial": "Możliwość Podsqueeze do używania podpowiedzi w celu dostosowania treści każdego podcastu, którym zarządzamy i zapisywania ich na przyszłe odcinki, pozwala nam utrzymać spójność głosów każdego programu. To elitarna funkcja, której nie mogliśmy znaleźć w żadnych innych narzędziach",
        "coo.podigy": "COO w Podigy Podcasts",
        "agenciessection.joinCreators": "Dołącz do 20 000 twórców treści i profesjonalistów podcastowych korzystających z Podsqueeze",
        "agenciessection.contentCreators": "Twórcy Treści",
        "agenciessection.podcastManagers": "Menadżerowie Podcastów",
        "agenciessection.producersStudios": "Producenci i Studia",
        "agenciessection.forPodcasters": "DLA PODKASTERÓW, MENADŻERÓW PODCASTÓW I AGENCJI",
        "agenciessection.manageContent": "Zarządzaj tworzeniem treści bez wysiłku dla",
        "agenciessection.multiplePodcasts": "wielu podcastów",
        "agenciessection.podsqueezeDescription": "Podsqueeze to potężne narzędzie dla wszystkich profesjonalistów podcastowych. Niezależnie od tego, czy jesteś solowym podcasterem, menadżerem podcastów, czy agencją, Podsqueeze oferuje wszystkie funkcje, których potrzebujesz, aby uprościć swój proces tworzenia treści podcastowych.",
        "agenciessection.createPodcastFolders": "Twórz foldery podcastów, aby utrzymać porządek w swoich odcinkach.",
        "agenciessection.shareContent": "Łatwo udostępniaj swoją stronę z treścią klientom i zespołowi",
        "agenciessection.tuneAI": "Dostosuj głos AI dla każdego programu, którym zarządzasz",
        "agenciessection.planContent": "Planuj treść na następne odcinki z naszym zaawansowanym",
        "agenciessection.podcastTopicsFinder": "narzędziem do znajdowania tematów podcastów",
        "agenciessection.podsqueezeQuote": "Możliwość Podsqueeze do używania podpowiedzi w celu dostosowania treści każdego podcastu, którym zarządzamy i zapisywania ich na przyszłe odcinki, pozwala nam utrzymać spójność głosów każdego programu. To elitarna funkcja, której nie mogliśmy znaleźć w żadnych innych narzędziach",
        "agenciessection.coO": "COO w Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NOWA FUNKCJA",
        "seamless.editing": "Bezproblemowa edycja i poprawa dźwięku dla naturalnych, ",
        "high.quality.results": " wysokiej jakości wyników",
        "experience.seamless.audio.editing": "Doświadcz bezproblemowej edycji dźwięku z zaawansowanymi algorytmami AI dla najwyższej jakości nagrań. ",
        "remove.ums": "Usuń 'um'",
        "enhance.sound.quality": ", ciszy i popraw jakość dźwięku jednym kliknięciem.",
        "enhance.audio.now": "Popraw dźwięk teraz",
        "sample.audio.recorded": "Przykładowe nagranie dźwięku, nagrane bezpośrednio z telefonu.",
        "original.recording": "Oryginalne nagranie",
        "audio.after.ai.edit": "Dźwięk po edycji i poprawie AI",
        "experience.audio.editing": "Doświadcz bezproblemowej edycji dźwięku z zaawansowanymi algorytmami AI dla najwyższej jakości nagrań. "
      },
      "home-blogsection": {
        "more.resources.label": "WIĘCEJ ZASOBÓW DLA TWOJEGO PODCASTU",
        "learn.how.to.get.most": "Dowiedz się, jak w pełni wykorzystać",
        "your.content": "swoje treści",
        "get.most.out.of.ai.content": "Wykorzystaj w pełni treści generowane przez AI dla swojego podcastu",
        "welcome.to.podsqueeze": "Witamy w Podsqueeze – najprostszym sposobie na transkrypcję twojego podcastu i tworzenie fascynujących treści...",
        "will.google.penalize.ai.content": "Czy Google ukarze twoje treści generowane przez AI?",
        "ai.content.discussion": "Pojawienie się treści generowanych przez AI wzbudziło dyskusje i obawy wśród twórców treści, marketerów i specjalistów SEO...",
        "what.is.rss.feed": "Czym jest kanał RSS dla podcastów i jak go używać",
        "rss.feed.benefits": "Jako podcaster mogłeś wcześniej słyszeć termin 'kanał RSS', ale być może nie wiesz dokładnie, czym on jest i jakie korzyści może przynieść...",
        "visit.blog": "Odwiedź bloga"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "KLIPY I AUDIOGRAMY",
        "clipsAndAudiograms.subtitle": "Przekształć swój podcast w klipy bez wysiłku",
        "clipsAndAudiograms.description": "Wystarczy wybrać rozdział z odcinka i wyeksportować go jako klip lub audiogram na TikTok, Instagram i YouTube Shorts. Wybierz szablon i dostosuj go do swojego stylu.",
        "clipsAndAudiograms.createClips": "Utwórz klipy teraz",
        "textEditor.title": "Edytor oparty na tekście",
        "textEditor.description": "Dostosuj swoje klipy i audiogramy bezpośrednio z napisów. Edytuj napisy i przycinaj swoje wideo, usuwając konkretne słowa.",
        "oneClickShorts.title": "Krótkie filmy jednym kliknięciem (<60s)",
        "oneClickShorts.description": "Pozwól AI zająć się edycją za Ciebie. Za naciśnięciem przycisku, AI skróci każdy rozdział Twojego odcinka do mniej niż 60 sekund, gotowy do publikacji jako YouTube Short lub klipy TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Skontaktuj się z założycielami",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Programista i podcaster",
        "contact.section.joao.role": "- Projektant UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "SZEROKA WARIANTOWOŚĆ TREŚCI",
        "generate.content": "Generuj treści za pomocą",
        "one.click": " jednego kliknięcia!",
        "transcript.srt": "Transkrypcja i SRT",
        "transcript.description": "Uzyskaj pełną transkrypcję swojego odcinka podcastu, wraz z plikiem SRT gotowym do generowania napisów.",
        "show.notes": "Notatki do odcinka",
        "show.notes.description": "Podsumuj główne tematy poruszone w odcinku i ułatw ich wyszukiwanie",
        "timestamps": "Znaczniki czasowe",
        "timestamps.description": "Twórz rozdziały z znacznikami czasowymi i prowadź słuchaczy do konkretnych segmentów swojego odcinka podcastu",
        "blog.social.posts": "Posty na blogu i w mediach społecznościowych",
        "blog.social.posts.description": "Publikuj o swoim odcinku podcastu wszędzie i zdobywaj nowych słuchaczy",
        "newsletter": "Newsletter",
        "newsletter.description": "Informuj swoich słuchaczy o nowych odcinkach",
        "titles.more": "Tytuły i więcej!",
        "titles.more.description": "Generuj chwytliwe tytuły, cytaty, punkty, słowa kluczowe i więcej!",
        "see.sample.content": "ZOBACZ PRZYKŁADOWĄ TREŚĆ",
        "wannabe.entrepreneur": "Przyszły przedsiębiorca - #299 Podsqueeze właśnie osiągnął 100 000 dolarów rocznego przychodu!",
        "making.space": "Tworzenie przestrzeni - Steve Harvey: „Możesz po prostu kontynuować”",
        "modern.wisdom": "Nowoczesna mądrość - Erik Hoel - Przewodnik po fundamentalnej tajemnicy umysłu"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Linia dzieląca"
      },
      "home-explanationsection": {
        "fast.accurate": "SZYBKO I DOKŁADNIE",
        "generate.content": "Generuj treść dla swojego podcastu z",
        "power.of.ai": "mocą AI",
        "upload.image.alt": "prześlij obraz",
        "select.episode": "Wybierz odcinek z swojego kanału RSS lub prześlij plik audio/wideo",
        "paste.rss.feed": "Po prostu wklej adres URL swojego kanału RSS, aby wybrać odcinek z listy lub prześlij plik audio lub wideo.",
        "content.image.alt": "obraz treści",
        "one.click.content": "Uzyskaj całą treść jednym kliknięciem!",
        "user.friendly.interface": "Intuicyjny i przyjazny interfejs, który możesz zacząć używać od razu. Generuj treść dla swojego podcastu jednym kliknięciem.",
        "tune.image.alt": "obraz dostrojenia",
        "edit.fine.tune": "Edytuj i dostosuj każdą treść",
        "direct.edit.content": "Bezpośrednio edytuj i dostosuj każdą treść według własnych upodobań z pomocą AI. Na przykład, możesz poprosić o konkretny ton, mowę bezpośrednią lub pośrednią lub po prostu poprawić błędnie napisane imiona.",
        "multiple.language.support": "Wsparcie dla wielu języków",
        "language.flags.alt": "flagi języków",
        "generate.content.aria": "Generuj treść"
      },
      "home-featuressection": {
        "loading": "Ładowanie...",
        "transcribe.write.show.notes": "Transkrybuj i pisz notatki do swojego podcastu",
        "twenty.times.faster": "20x szybciej",
        "save.manual.work": "Oszczędź do 100% pracy ręcznej. Automatycznie transkrybuj swój podcast z najwyższą dokładnością i oznaczaniem mówców, a także generuj pełne notatki do programu i posty w mediach społecznościowych w swoim własnym głosie.",
        "generate.content": "Generuj treść",
        "transcripts": "Transkrypty",
        "full.transcript": "Uzyskaj pełny transkrypt swoich odcinków podcastu oraz transkrypty filmów z YouTube, wraz z plikiem SRT do napisów.",
        "show.notes": "Notatki do programu",
        "summarize.generate.show.notes": "Podsumuj i wygeneruj notatki do programu w swoim własnym głosie, z czasami, punktami i wzmiankami.",
        "blog.newsletter": "Blog i newsletter",
        "actionable.blog.posts": "Uzyskaj praktyczne posty na blogu o swoich odcinkach i gotowe do wysłania newslettery z najważniejszymi informacjami.",
        "social.media": "Media społecznościowe",
        "short.posts.insights": "Uzyskaj krótkie posty i zwięzłe spostrzeżenia, aby rozprzestrzenić wieści w mediach społecznościowych.",
        "quote": "Spośród wszystkich najlepszych narzędzi do transkrypcji AI, które testowaliśmy, Podsqueeze generował najbardziej użyteczne wyniki dla notatek do programu, znaczników czasowych, tytułów, wzmianków, przykładowych postów na blogu i kluczowych cytatów.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Współzałożyciel Transistor.fm",
        "transcribe_and_write_show_notes": "Transkrypcje podcastów, podsumowania i posty społecznościowe",
        "twenty_times_faster": "20x szybciej",
        "save_manual_work": "Oszczędź do 100% pracy ręcznej. Automatycznie transkrybuj swój podcast z najwyższą dokładnością i oznaczaniem mówców, a także generuj pełne notatki do programu i posty w mediach społecznościowych w swoim własnym głosie.",
        "generate_content": "Generuj treść",
        "full_transcript": "Uzyskaj pełny transkrypt swoich odcinków podcastu oraz transkrypty filmów z YouTube, wraz z plikiem SRT do napisów.",
        "show_notes": "Notatki do programu",
        "summarize_and_generate_show_notes": "Podsumuj i wygeneruj notatki do programu w swoim własnym głosie, z czasami, punktami i wzmiankami.",
        "blog_and_newsletter": "Blog i newsletter",
        "actionable_blog_posts": "Uzyskaj praktyczne posty na blogu o swoich odcinkach i gotowe do wysłania newslettery z najważniejszymi informacjami.",
        "social_media": "Media społecznościowe",
        "short_posts_and_insights": "Uzyskaj krótkie posty i zwięzłe spostrzeżenia, aby rozprzestrzenić wieści w mediach społecznościowych.",
        "testimonial": "Spośród wszystkich najlepszych narzędzi do transkrypcji AI, które testowaliśmy, Podsqueeze generował najbardziej użyteczne wyniki dla notatek do programu, znaczników czasowych, tytułów, wzmianków, przykładowych postów na blogu i kluczowych cytatów.",
        "cofounder_transistor": "Współzałożyciel Transistor.fm"
      },
      "home-page": {
        "main.background": "Kolor tła dla głównego komponentu"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "SŁUCHAJ NASZEGO PODCASTU",
        "podcast.section.subtitle": "Mistrzowskie lekcje od",
        "podcast.section.highlight": "doświadczonych podcasterów",
        "podcast.section.description": "Słuchaj naszego podcastu, w którym przeprowadzamy wywiady z doświadczonymi podcasterami i użytkownikami Podsqueeze z całego świata. Prosimy ich o podzielenie się swoimi wskazówkami, spostrzeżeniami, historiami i wszystkim, co musisz wiedzieć, aby rozwijać swój własny podcast.",
        "podcast.link.spotify": "Słuchaj na Spotify",
        "podcast.link.apple": "Słuchaj na Apple Podcasts",
        "podcast.link.youtube": "Słuchaj na YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Ładowanie..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Zautomatyzuj swój podcast",
        "tagline.productionPromotion": "Produkcja i promocja",
        "tagline.launchGrow": "Bez wysiłku uruchom i rozwijaj swój podcast audio lub wideo, mając wszystko, czego potrzebujesz w jednym miejscu, z pomocą AI.",
        "tagline.uploadGenerate": "Generuj podcast transcript, podsumowanie, krótkie klipy z napisami i wiele więcej!",
        "tagline.singleClick": " Wszystko za pomocą jednego kliknięcia.",
        "tagline.transcripts": "Podcast Transkrypcje",
        "tagline.showNotes": "Notatki do odcinka",
        "tagline.newslettersBlogs": "Biuletyny i blogi",
        "tagline.socialPosts": "Posty w mediach społecznościowych",
        "tagline.shortClipsAudiograms": "Krótkie klipy i audiogramy",
        "tagline.podcastWebsite": "Strona internetowa podcastu",
        "tagline.aiAudioEnhancement": "Udoskonalenie dźwięku AI",
        "tagline.removeSilences": "Usuń cisze i 'uhm'",
        "tagline.generateNow": "Generuj teraz za darmo",
        "tagline.noCreditCard": "Nie wymagana karta kredytowa",
        "testimonial.robWalling.title": "Rob Walling, Osobowość startupowa",
        "testimonial.robWalling.subtitle": "Podcast Startups for the Rest of Us",
        "testimonial.robWalling.quote": "Notatki do odcinków Podsqueeze były najlepsze. Używamy ich często do podsumowań i uzyskiwania wglądów z innych podcastów.",
        "testimonial.johnGarmet.title": "John Garmet, Dyrektor Operacyjny",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze pomaga nam być bardziej efektywnymi i generować więcej treści dla naszych klientów. Gorąco polecamy.",
        "testimonial.davidJackson.title": "David Jackson, Trener podcastów",
        "testimonial.davidJackson.subtitle": "Szkoła Podcastingu",
        "testimonial.davidJackson.quote": "Podsqueeze jest moim partnerem w burzy mózgów. To najlepszy sposób na wymyślenie marketingu podcastów."
      },
      "home-testimonials": {
        "testimonials.title": "Co mówią ludzie o Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Wykorzystaj ponownie treści swojego podcastu za pomocą AI | Product Hunt",
        "testimonials.heading": "Co mówią ludzie o Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Niepoprawne hasło",
        "error.userNotFound": "Użytkownik nie został znaleziony",
        "error.somethingWentWrong": "Ups, coś poszło nie tak",
        "button.sendResetEmail": "Wyślij e-mail resetujący",
        "button.login": "Zaloguj się",
        "placeholder.email": "Adres e-mail",
        "placeholder.password": "Hasło",
        "link.forgotPassword": "Zapomniałeś hasła?",
        "link.createAccount": "Utwórz konto",
        "text.or": "LUB",
        "button.continueWithGoogle": "Kontynuuj z Google",
        "text.podcastDescription": "Bez wysiłku uruchom i rozwijaj swój podcast audio lub wideo z wszystkim, czego potrzebujesz w jednym miejscu.",
        "feature.transcripts": "Transkrypcje",
        "feature.showNotes": "Notatki do odcinka",
        "feature.newslettersAndBlogs": "Biuletyny i blogi",
        "feature.socialPosts": "Posty w mediach społecznościowych",
        "feature.shortClipsAndAudiograms": "Krótkie klipy i audiogramy",
        "feature.podcastWebsite": "Strona internetowa podcastu",
        "feature.aiAudioEnhancement": "Udoskonalenie dźwięku AI",
        "feature.removeSilences": "Usuń cisze i 'uhm'",
        "error.emailNotVerified": "E-mail nie została zweryfikowana",
        "text.pleaseVerifyAccount": "Sprawdź swoje konto",
        "text.checkSpamFolder": "Wysłaliśmy ci e-mail weryfikacyjny. Sprawdź swoją pocztę i folder spam.",
        "button.resendVerificationEmail": "Wyślij e-mail weryfikacyjny ponownie",
        "error.verificationEmailFailed": "Błąd podczas wysyłania e-maila weryfikacyjnego. Spróbuj ponownie."
      },
      "page": {
        "login.form": "FormularzLogowania"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Strona Partnerów Podsqueeze",
        "affiliate.page.description": "Zarabiaj 25% prowizji od każdej sprzedaży dokonanej za pośrednictwem Twojego ekskluzywnego linku polecającego przez okres 15 miesięcy. Udostępnij swój link na swojej stronie internetowej, w mediach społecznościowych lub znajomym. Dołączenie zajmuje sekundy. Otrzymujesz automatyczną akceptację."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Najlepszy prezent dla podcastera",
        "bestGiftForPodcaster.description": "Odkryj najlepsze prezenty dla podcasterów, aby wzbogacić ich doświadczenie.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Zdobądź więcej słuchaczy podcastów",
        "get-more-podcast-listeners.description": "Zdobądź więcej słuchaczy podcastów i uprość produkcję dzięki automatycznym notatkom z odcinków, krótkim klipom, które pomogą rozwijać Twój program w mediach społecznościowych i wielu innym funkcjom."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Zwiększ swoją publiczność podcastu",
        "grow_your_podcast_audience.description": "Zaoszczędź mnóstwo czasu i zwiększ swoją publiczność podcastu z Podsqueeze. Generuj pełne notatki z odcinków, posty w mediach społecznościowych, krótkie klipy i więcej dla swojego podcastu."
      },
      "index": {
        "home.page.title": "Notatki z podcastu AI, transkrypcje, podsumowania i generator klipów.",
        "home.page.description": "Generuj notatki, znaczniki czasowe, biuletyny i więcej dla swojego podcastu jednym kliknięciem! Szybko generuj treści dla swojego podcastu i dostosuj je do swoich potrzeb. Darmowa rejestracja."
      },
      "login": {
        "login.tryItNow": "Wypróbuj teraz!",
        "login.createAccountDescription": "Utwórz konto i zacznij generować notatki, znaczniki czasowe, biuletyny i więcej dla swojego podcastu jednym kliknięciem! Szybko generuj treści dla swojego podcastu i dostosuj je do swoich potrzeb. Darmowa rejestracja."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing dla Podcastów",
        "marketing.for.podcasts.description": "Podsqueeze upraszcza marketing dla podcastów dzięki automatycznie generowanym notatkom z odcinków, postom w mediach społecznościowych i krótkim klipom, aby zwiększyć zasięg i rozwijać Twój program."
      },
      "media": {
        "media.page.title": "Strona Mediów Podsqueeze",
        "media.page.description": "Dowiedz się więcej o Podsqueeze. Skontaktuj się z nami! Chętnie nawiążemy współpracę!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Generator Opisów Podcastów",
        "podcast.description.generator.description": "Zwiększ zasięg i zaangażowanie swojego podcastu dzięki opisom generowanym przez AI. Zautomatyzuj pisanie notatek do programu i odzyskaj cenny czas."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Przekształć swój podcast na posty w mediach społecznościowych",
        "convert.podcast.episodes.to.social.media.posts": "Przekształć odcinki podcastu w posty w mediach społecznościowych. Automatycznie generuj posty na LinkedIn, Twitterze, Facebooku oraz krótkie klipy na TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Darmowy generator tematów podcastów",
        "podcast.topics.generator.description": "Nasz darmowy generator tematów podcastów pozwala znaleźć najlepsze pomysły na tematy i przewiduje ich potencjalny zasięg w Google i YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Twój Wirtualny Asystent Podcastowy",
        "podcast.virtual.assistant.description": "Wirtualny asystent podcastowy oparty na AI, który pisze notatki do Twojego programu i tworzy posty w mediach społecznościowych. Uprość produkcję i marketing swojego podcastu z Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Cennik",
        "pricing.description": "Generuj notatki, znaczniki czasu, biuletyny i więcej dla swojego podcastu jednym kliknięciem! Mamy wiele poziomów cenowych, aby spełnić Twoje potrzeby podcastowe."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promuj swój podcast",
        "promote.your.podcast.description": "Generuj notatki do odcinków, posty w mediach społecznościowych i krótkie klipy, aby opublikować i promować swój podcast w zaledwie kilka minut."
      },
      "register": {
        "create.podsqueeze.account": "Utwórz konto Podsqueeze",
        "generate.content.podcast": "Generuj notatki, znaczniki czasowe, biuletyny i więcej dla swojego podcastu jednym kliknięciem! Szybko generuj treści dla swojego podcastu i dostosuj je do swoich potrzeb. Darmowa rejestracja."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Automatycznie przekształć treści podcastu",
        "repurpose.your.podcast.content.with.ai": "Przekształć treści swojego podcastu z pomocą AI. Automatycznie generuj notatki do odcinków, tytuły, krótkie klipy na TikTok i wiele więcej, wszystko za jednym kliknięciem!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "DARMOWY Podcast SEO Optimizer",
        "seo.optimizer.description": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.selectEpisode": "Select an Episode to Analyze",
        "seo.optimizer.results": "SEO Analysis Results",
        "seo.optimizer.searchPodcastPlaceholder": "Search for a podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Search episodes...",
        "seo.optimizer.analyseAnotherEpisode": "Analyse Another Episode",
        "seo.optimizer.findingEpisodes": "Finding all episodes...",
        "seo.optimizer.analysingEpisode": "Analysing Episode",
        "seo.optimizer.scoreTooltip": "Score:",
        "seo.optimizer.topKeywords": "We identified these Top Keywords:",
        "seo.optimizer.topKeywordsnote": "Based on the keyword analysis at the bottom of the page.",
        "seo.optimizer.optimizedContent": "Based on keywords here are the optimized title and description:",
        "seo.optimizer.originalTitle": "Original Title",
        "seo.optimizer.optimizedTitle": "Optimized Title",
        "seo.optimizer.originalDescription": "Original Description",
        "seo.optimizer.optimizedDescription": "Optimized Description",
        "seo.optimizer.showMore": "Show More",
        "seo.optimizer.showLess": "Show Less",
        "seo.optimizer.keywordAnalysis": "Keyword Analysis",
        "seo.optimizer.keywordAnalysisnote": "Scores are calculated based on search volume, competition (how many other results are there for the same keyword), and in the case of youtube, the average number of views per video under the same keyword.",
        "seo.optimizer.seoScore": "SEO Score",
        "seo.optimizer.spotifyScore": "Spotify Score",
        "seo.optimizer.youtubeScore": "YouTube Score",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Narzędzie do generowania treści podcastów z wykorzystaniem AI",
        "podsqueeze.description": "Generuj notatki, znaczniki czasowe, biuletyny i więcej dla swojego podcastu jednym kliknięciem! Szybko generuj treści dla swojego podcastu i dostosuj je do swoich potrzeb. Darmowa rejestracja."
      },
      "thumbnail-creator": {
        "title": "Darmowy Generator Miniaturek Podcast - Twórz Miniaturki Odcinków z AI",
        "description": "Twórz oszałamiające miniaturki podcast z AI. Generuj profesjonalne, przyciągające wzrok grafiki odcinków, które zwiększają widoczność i przyciągają więcej słuchaczy do twojego podcastu.",
        "selectPodcast": "Wybierz Swój Podcast",
        "loadEpisodes": "Załaduj Odcinki",
        "selectEpisode": "Wybierz Odcinek do Utworzenia Miniaturki",
        "createThumbnail": "Utwórz Miniaturkę",
        "results": "Twoja Wygenerowana Miniaturka",
        "download": "Pobierz",
        "share": "Udostępnij",
        "regenerate": "Regeneruj",
        "editThumbnail": "Edytuj Miniaturkę",
        "editPlaceholder": "Opisz, jak chciałbyś zmodyfikować tę miniaturkę...",
        "customPrompt": "Niestandardowy Prompt",
        "yourThumbnail": "Twoja Miniaturka",
        "createAnother": "← Utwórz Kolejną Miniaturkę",
        "findingEpisodes": "Szukanie odcinków...",
        "searchPodcastPlaceholder": "Szukaj swojego podcastu...",
        "searchingPodcasts": "Przeszukiwanie podcastów...",
        "heroDescription": "Generuj oszałamiające, profesjonalne miniaturki podcast z projektem napędzanym przez AI, który przyciąga uwagę i zwiększa widoczność twoich odcinków.",
        "generatedWithPrompt": "Wygenerowano z promptem:",
        "customPromptPlaceholder": "Wprowadź niestandardowy prompt do generowania miniaturek...",
        "generating": "Generowanie...",
        "generate": "Generuj",
        "modernMinimalist": "Nowoczesny i Minimalistyczny",
        "vibrantDynamic": "Żywy i Dynamiczny",
        "professionalClean": "Profesjonalny i Czysty",
        "generatingThumbnail": "Generowanie miniaturki...",
        "generatingNewThumbnail": "Generowanie nowej miniaturki...",
        "showingFirstEpisodes": "Pokazywanie pierwszych 10 odcinków. Użyj wyszukiwania, aby znaleźć konkretne odcinki.",
        "imageUrlCopied": "URL obrazu skopiowany do schowka!",
        "failedToGenerate": "Nie udało się wygenerować miniaturki. Spróbuj ponownie.",
        "promotionalTitle": "Generuj Notatki z Programu, Znaczniki Czasu, Wirusowe Klipy i Wiele Więcej z Podsqueeze",
        "promotionalSubtitle": "Dołącz do ponad 100 tys. twórców i zacznij rozwijać swój program",
        "startNow": "Zacznij teraz",
        "free": "DARMOWY",
        "podcast": "PODCAST",
        "thumbnail": "MINIATURKA",
        "creator": "TWÓRCA",
        "replaceFace": "Zamień Twarz",
        "uploading": "Przesyłanie...",
        "uploadImageError": "Prześlij plik obrazu.",
        "uploadFailedError": "Przesłanie obrazu nie powiodło się. Spróbuj ponownie.",
        "uploadingImage": "Przesyłanie obrazu...",
        "generatingNewThumbnailLoading": "Generowanie nowej miniaturki...",
        "failedToGenerateWithFace": "Generowanie miniaturki z zamianą twarzy nie powiodło się. Spróbuj ponownie."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Utwórz nowy folder podcastu",
      "folder.name.placeholder": "Wprowadź nazwę folderu",
      "create.button": "Utwórz"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Ładowanie odcinków...",
        "episodeList.noEpisodes": "Brak dostępnych publicznych odcinków",
        "episodeList.checkBack": "Wróć później, aby zobaczyć nowe odcinki",
        "episodeList.title": "Odcinki z tego Podcastu",
        "episodeList.readLess": "CZYTAJ MNIEJ",
        "episodeList.readMore": "CZYTAJ WIĘCEJ",
        "episodeList.coverImageAlt": "Okładka dla {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Zacznij",
        "alert.subscriptionRunning": "Twoja obecna subskrypcja nadal trwa.\n\nProszę anulować obecną subskrypcję przed zakupem nowej.",
        "alert.subscriptionEnds": "Twoja obecna subskrypcja nadal trwa.\n\nKończy się {date}",
        "alert.subscriptionCancelled": "Twoja subskrypcja została już anulowana i zakończy się {date}",
        "button.openDashboard": "Otwórz Panel",
        "button.signUp": "Zarejestruj się",
        "button.buySubscription": "Kup Subskrypcję",
        "button.cancelled": "Anulowane",
        "button.cancelSubscription": "Anuluj Subskrypcję",
        "button.upgradeSubscription": "Ulepsz Subskrypcję",
        "button.loading": "Ładowanie",
        "upgrade.details.currentMinutes": "To rozpocznie nowy okres subskrypcyjny. Zachowasz wszystkie swoje obecne minuty.",
        "upgrade.details.remainingAnnual": "Ta wartość została obliczona na podstawie pozostałego czasu w Twojej obecnej rocznej subskrypcji."
      },
      "page": {
        "pricing.free.title": "Darmowy",
        "pricing.free.subtitle": "Wypróbuj Podsqueeze. Nie wymaga karty kredytowej.",
        "pricing.free.price.annual": "0 zł rocznie",
        "pricing.free.features.podcast_time": "30 minut czasu podcastu miesięcznie",
        "pricing.free.features.video_clips": "3 klipy wideo",
        "common.with_watermark": "z watermarkiem",
        "pricing.free.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.free.features.file_upload": "Przesyłanie plików do 4Gb",
        "pricing.free.features.upload": "1 przesyłanie",
        "pricing.free.features.landing_pages": "Strony docelowe podcastów",
        "pricing.free.features.audio_enhancement": "Ulepszanie dźwięku",
        "common.sign_up": "Zarejestruj się",
        "common.open_dashboard": "Otwórz pulpit nawigacyjny",
        "pricing.starter.title": "Początkowy",
        "pricing.starter.subtitle": "Idealny dla hobbystów podcastów, którzy chcą zaoszczędzić czas.",
        "pricing.starter.price.annual": "132 zł rocznie",
        "pricing.billed_annually": "Rocznie",
        "minutes.accumulate": "Przenoszenie minut",
        "pricing.starter.features.podcast_time": "160 minut czasu podcastu miesięcznie",
        "pricing.starter.features.video_clips": "10 klipów wideo lub audiogramów",
        "pricing.starter.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.starter.features.file_upload": "Przesyłanie plików do 4Gb",
        "pricing.starter.features.unlimited_uploads": "Nieograniczone przesyłania",
        "pricing.starter.features.landing_pages": "Strony docelowe podcastów",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Dla profesjonalistów, którzy wykorzystują podcasty do rozwijania i wspierania swoich biznesów.",
        "pricing.pro.price.annual": "324 zł rocznie",
        "pricing.pro.features.podcast_time": "320 minut czasu podcastu miesięcznie",
        "pricing.pro.features.personalize_ai_voice": "Personalizuj głos AI",
        "pricing.pro.features.video_clips": "20 klipów wideo lub audiogramów",
        "common.no_watermark": "bez watermarka",
        "pricing.pro.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.pro.features.file_upload": "Przesyłanie plików do 10Gb",
        "pricing.pro.features.unlimited_uploads": "Nieograniczone przesyłania",
        "pricing.pro.features.landing_pages": "Strony docelowe podcastów",
        "common.customizable": "możliwość dostosowania",
        "pricing.pro.features.audio_video_edit": "Magiczna edycja audio i wideo",
        "pricing.agency_lite.title": "Agencja Lite",
        "pricing.agency_lite.subtitle": "Dla agencji podcastowych, które chcą uprościć i rozwijać swój biznes.",
        "pricing.agency_lite.price.annual": "495 zł rocznie",
        "pricing.agency_lite.features.podcast_time": "600 minut czasu podcastu miesięcznie",
        "pricing.agency_lite.features.personalize_ai_voice": "Personalizuj głos AI",
        "pricing.agency_lite.features.video_clips": "40 klipów wideo lub audiogramów",
        "pricing.agency_lite.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.agency_lite.features.file_upload": "Przesyłanie plików do 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Nieograniczone przesyłania",
        "pricing.agency_lite.features.landing_pages": "Strony docelowe podcastów",
        "pricing.agency_lite.features.audio_video_edit": "Magiczna edycja audio i wideo",
        "pricing.agency_plus.title": "Agencja Plus",
        "pricing.agency_plus.subtitle": "Dla agencji podcastowych, które chcą uprościć i rozwijać swój biznes.",
        "pricing.agency_plus.price.annual": "1.251 zł rocznie",
        "pricing.agency_plus.features.podcast_time": "2000 minut czasu podcastu miesięcznie",
        "pricing.agency_plus.features.personalize_ai_voice": "Personalizuj głos AI",
        "pricing.agency_plus.features.video_clips": "80 klipów wideo lub audiogramów",
        "pricing.agency_plus.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.agency_plus.features.file_upload": "Przesyłanie plików do 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Nieograniczone przesyłania",
        "pricing.agency_plus.features.landing_pages": "Strony docelowe podcastów",
        "pricing.agency_plus.features.audio_video_edit": "Magiczna edycja audio i wideo",
        "pricing.agency_scale.title": "Agencja Scale",
        "pricing.agency_scale.subtitle": "Dla agencji podcastowych, które chcą uprościć i rozwijać swój biznes.",
        "pricing.agency_scale.price.annual": "2.175 zł rocznie",
        "pricing.agency_scale.features.podcast_time": "4000 minut czasu podcastu miesięcznie",
        "pricing.agency_scale.features.personalize_ai_voice": "Personalizuj głos AI",
        "pricing.agency_scale.features.video_clips": "160 klipów wideo lub audiogramów",
        "pricing.agency_scale.features.quote_images": "Nieograniczone obrazy cytatów",
        "pricing.agency_scale.features.file_upload": "Przesyłanie plików do 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Nieograniczone przesyłania",
        "pricing.agency_scale.features.landing_pages": "Strony docelowe podcastów",
        "pricing.agency_scale.features.audio_video_edit": "Magiczna edycja audio i wideo",
        "pricing.header": "Dla solowych podcasterów i agencji podcastowych",
        "pricing.minutes_reset": "Możesz zgromadzić do 3 razy więcej swoich miesięcznych minut, tak długo jak pozostajesz na swoim obecnym planie lub dokonasz aktualizacji.",
        "pricing.most_popular": "Najpopularniejszy",
        "pricing.minutes_per_month": "Minuty na miesiąc",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Dla agencji podcastowych i firm medialnych, które chcą skalować swoją działalność.",
        "pricing.enterprise_price": "Dostosowane",
        "pricing.enterprise_price_note": "Skontaktuj się z team@podsqueeze.com lub zarezerwuj wizytę poniżej.",
        "pricing.enterprise_feature_priority_support": "Priorytetowa pomoc",
        "pricing.enterprise_feature_team_sits": "Sesje zespołu",
        "pricing.enterprise_personalized_team_training": "Onboarding i szkolenie zespołu",
        "pricing.book_demo": "Zarezerwuj wizytę"
      },
      "toggle": {
        "pay.monthly": "Miesięczny",
        "pay.annually": "Roczny",
        "discount.30percent": "30% zniżki"
      },
      "upgradeModal": {
        "upgrade.success": "Twoja subskrypcja została pomyślnie zaktualizowana",
        "upgrade.error": "Przykro nam, coś poszło nie tak. Proszę spróbować ponownie później",
        "upgrade.loading": "Aktualizowanie",
        "upgrade.confirmPay": "Potwierdź i zapłać",
        "upgrade.cancel": "Anuluj",
        "coupon.placeholder": "Kod kuponu",
        "coupon.apply": "Zastosuj",
        "coupon.have": "Mam kupon",
        "upgrade.confirmation": "Zaraz zaktualizujesz do",
        "upgrade.price": "Zapłacisz"
      }
    },
    "register": {
      "page": {
        "register.form": "FormularzRejestracji"
      },
      "registerForm": {
        "error.invalidCredentials": "Proszę wprowadzić prawidłowy adres e-mail i hasło.",
        "error.weakPassword": "Proszę użyć silniejszego hasła 💪",
        "error.emailInUse": "Użytkownik już istnieje",
        "error.userNotFound": "Użytkownik nie został znaleziony",
        "error.generic": "Ups, coś poszło nie tak",
        "placeholder.email": "Adres e-mail",
        "placeholder.password": "Hasło",
        "button.registering": "Rejestrowanie...",
        "button.register": "Zarejestruj się",
        "label.newsletter": "Dołącz do 12 000 podcasterów i zapisz się do naszego newslettera, aby otrzymywać aktualizacje produktów, praktyczne porady, e-booki, konkursy i więcej.",
        "label.alreadyHaveAccount": "Masz już konto?",
        "label.logInHere": "Zaloguj się tutaj",
        "label.or": "LUB",
        "button.signingIn": "Logowanie...",
        "button.continueWithGoogle": "Kontynuuj z Google",
        "label.podcastDescription": "Bez wysiłku uruchom i rozwijaj swój podcast audio lub wideo z wszystkim, czego potrzebujesz w jednym miejscu.",
        "feature.transcripts": "Transkrypcje",
        "feature.showNotes": "Notatki z odcinka",
        "feature.newslettersBlogs": "Newslettery i blogi",
        "feature.socialPosts": "Posty w mediach społecznościowych",
        "feature.shortClips": "Krótkie klipy i audiogramy",
        "feature.podcastWebsite": "Strona internetowa podcastu",
        "feature.audioEnhancement": "Udoskonalenie dźwięku AI",
        "feature.removeSilences": "Usuń cisze i 'uhm'"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "tekst"
      },
      "TopicFinder": {
        "competition.veryHigh": "BARDZO WYSOKA",
        "competition.high": "WYSOKA",
        "competition.medium": "ŚREDNIA",
        "competition.low": "NISKA",
        "competition.veryLow": "BARDZO NISKA",
        "upgrade.button": "Ulepsz do Pro",
        "clicks.label": "kliknięcia",
        "searches.label": "wyszukiwania",
        "competition.label": "konkurencja",
        "fetching.results": "Pobieranie wyników",
        "table.topic": "Temat",
        "tooltip.topic": "Główny temat poruszany w odcinku Twojego podcastu",
        "table.monthlySearches": "Miesięczne wyszukiwania",
        "tooltip.monthlySearches": "Zakres miesięcznych wyszukiwań w Google, którego możesz się spodziewać",
        "table.competition": "Konkurencja",
        "tooltip.competition": "Główny temat lub zagadnienie poruszane w podcastie.",
        "table.monthlyGoogleClicks": "Miesięczne kliknięcia w Google",
        "tooltip.monthlyGoogleClicks": "Prognoza zakresu miesięcznych kliknięć w Google, których możesz się spodziewać",
        "table.youtubeReach": "Zasięg na YouTube",
        "tooltip.youtubeReach": "Prognoza maksymalnej liczby wyświetleń na YouTube, której możesz się spodziewać w ciągu pierwszych 6 miesięcy, na podstawie średniego konkurenta",
        "intro.title": "Generator Tematów Podcastów za Darmo",
        "intro.description": "Uzyskaj pomysły na tematy do swojego podcastu, które są wyszukiwane przez odbiorców",
        "intro.check1": "Sprawdź zapotrzebowanie na każdy pomysł na temat w Google",
        "intro.check2": "Dowiedz się, jak konkurencyjny jest każdy pomysł na temat podcastu",
        "intro.check3": "Osestimate kliknięcia w Google i wyświetlenia na YouTube, które możesz uzyskać",
        "upgrade.message": "Aby uzyskać dostęp do wszystkich wyników, musisz ulepszyć do Pro",
        "learnMore.label": "Dowiedz się więcej o",
        "learnMore.link": "darmowym narzędziu do generowania tematów podcastów",
        "newSearch.button": "Nowe Wyszukiwanie",
        "share.button": "Udostępnij to wyszukiwanie",
        "form.label": "Wprowadź swoje nisze podcastowe",
        "form.placeholder": "Marketing Cyfrowy",
        "form.submit": "Znajdź pomysły na tematy"
      },
      "page": {
        "main.background": "tło"
      },
      "shareTopics": {
        "share.results": "Udostępnij wyniki",
        "share.facebook": "Udostępnij na Facebooku",
        "share.whatsapp": "Udostępnij na WhatsAppie",
        "share.twitter": "Udostępnij na Twitterze",
        "share.linkedin": "Udostępnij na LinkedIn",
        "copy.success": "Skopiowano",
        "copy.link": "Skopiuj link"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "wyświetlenia"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Nie można pobrać bieżącej kompozycji",
        "error.addImage": "Błąd dodawania elementu obrazu:",
        "alert.uploadImage": "Proszę przesłać plik obrazu.",
        "error.uploadImage": "Błąd przesyłania obrazu:",
        "alert.uploadFailed": "Nie udało się przesłać obrazu. Proszę spróbować ponownie.",
        "error.getDownloadURL": "Błąd pobierania URL do pobrania:",
        "alert.processImageFailed": "Nie udało się przetworzyć przesłanego obrazu. Proszę spróbować ponownie.",
        "error.addText": "Błąd dodawania elementu tekstowego:",
        "text.settingsPlaceholder": "Ustawienia będą widoczne po wybraniu elementu",
        "text.addElement": "Dodaj Element",
        "text.uploading": "Przesyłanie...",
        "button.uploadImage": "Prześlij Obraz",
        "text.newText": "Nowy Tekst",
        "button.addText": "Dodaj Tekst",
        "text.selectedElementSettings": "Ustawienia Wybranego Elementu"
      },
      "FontSelector": {
        "allFonts": "Wszystkie czcionki",
        "myFonts": "Moje czcionki",
        "uploadFont": "Prześlij czcionkę",
        "noCustomFonts": "Brak niestandardowych czcionek.",
        "uploadToAdd": "Prześlij plik czcionki, aby dodać go do kolekcji.",
        "text_outline": "Kontur tekstu",
        "outline_color": "Kolor konturu",
        "outline_width": "Grubość konturu"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Dopasuj",
        "imageLayoutSettings.zoom": "Powiększenie",
        "imageLayoutSettings.horizontalAlignment": "Wyrównanie poziome",
        "imageLayoutSettings.verticalAlignment": "Wyrównanie pionowe",
        "imageLayoutSettings.deleteElement": "Usuń element"
      },
      "TemplateBox": {
        "confirm.delete.template": "Czy na pewno chcesz usunąć ten szablon?"
      },
      "TextSettings": {
        "error.getting_current_text": "Błąd podczas pobierania bieżącego tekstu:",
        "event.delete_text_element_clicked": "Kliknięto Usuń Element Tekstowy",
        "error.changing_text_font": "Błąd podczas zmiany czcionki tekstu:",
        "event.text_font_changed": "Czcionka Tekstu Zmieniona",
        "error.changing_text_size": "Błąd podczas zmiany rozmiaru tekstu:",
        "event.text_size_changed": "Rozmiar Tekstu Zmieniony",
        "error.changing_text_color": "Błąd podczas zmiany koloru tekstu:",
        "event.text_color_changed": "Kolor Tekstu Zmieniony",
        "event.text_content_added": "Zawartość Tekstowa Dodana",
        "error.adding_text_content": "Błąd podczas dodawania zawartości tekstowej:",
        "event.text_content_updated": "Zawartość Tekstowa Zaktualizowana",
        "label.text_content": "Zawartość Tekstowa",
        "label.text_font": "Czcionka Tekstu",
        "label.text_font_weight": "Waga Czcionki",
        "label.adjust_text_size": "Dostosuj Rozmiar Tekstu",
        "label.text_color": "Kolor Tekstu",
        "button.delete": "Usuń"
      },
      "audiogramBaseTemplate": {
        "color.white": "Biały",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "domyślnyUrlOdcinka",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "kwadratowy-wyjście",
        "animation.fade": "zanikanie",
        "type.text": "tekst",
        "name.podcastTitle": "TytułPodcastu",
        "name.snippetTitle": "TytułFragmentu",
        "type.image": "obraz",
        "name.audioBackgroundImage": "ObrazTłaAudio",
        "name.subtitlesText": "tekstNapisów",
        "effect.highlight": "podświetlenie",
        "type.audio": "audio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "tytułFragmentu",
        "podcast.title": "tytułPodcastu",
        "new.episode": "NOWY ODCINEK"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Biały",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "domyślnyUrlOdcinka",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "muzyka_tła",
        "audio.type": "audio"
      },
      "imageElement": {
        "upload.image.error": "Proszę przesłać plik graficzny.",
        "upload.file.loading": "Przesyłanie pliku. Proszę nie zamykać tego okna.",
        "upload.image.label": "Zastąp obraz",
        "ai.prompt.label": "Wprowadź polecenie dla AI, aby wygenerować obraz",
        "ai.prompt.placeholder": "Np: Pies biegający w parku...",
        "ai.processing": "Przetwarzanie...",
        "ai.create": "Utwórz",
        "customize.image.title": "Dostosuj obraz",
        "enter.image.url": "Wprowadź URL obrazu",
        "or": "lub"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Błąd podczas pobierania szablonów:",
        "template.savedSuccessfully": "Szablon zapisany pomyślnie",
        "error.savingTemplate": "Błąd podczas zapisywania szablonu:",
        "loading.savedTemplates": "Ładowanie zapisanych szablonów...",
        "no.savedTemplates": "Brak zapisanych szablonów",
        "select_template": "Wybierz szablon",
        "saving.template": "Zapisuję szablon...",
        "template_name": "Nazwa szablonu",
        "enter.templateName": "Wprowadź nazwę szablonu",
        "cancel": "Anuluj",
        "save": "Zapisz",
        "default_templates": "Domyślne szablony",
        "saved_templates_count": "Zapisane szablony ({count})",
        "folder_templates_count": "Szablony folderów ({count})",
        "account_templates_count": "Szablony konta ({count})",
        "save_current_template": "Zapisz bieżący szablon"
      },
      "subtitlesElement": {
        "edit.word": "Edytuj słowo",
        "edit.label": "edytuj",
        "remove.word.subtitle": "Usuń słowo tylko z napisu",
        "erase.subtitle": "usuń z napisu",
        "remove.word.clip": "Usuń słowo z audio i napisu",
        "remove.clip": "usuń z klipu"
      },
      "utils": {
        "video.utils.title": "Tytuł",
        "video.utils.currentTime": "Aktualny Czas",
        "video.utils.nextTime": "Następny Czas",
        "video.utils.duration": "Czas Trwania",
        "video.utils.description": "Opis",
        "video.utils.srtSegment": "Segment SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Tutaj wprowadź swój tekst napisów"
      }
    }
  },
  "pt": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "TORNE-SE NOSSO PARCEIRO",
        "SHARE_PODSQUEEZE": "Compartilhe Podsqueeze com seu público",
        "AND_EARN_MONEY": "e ganhe dinheiro!",
        "LAST_UPDATED": "Última atualização: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Torne-se um Parceiro Afiliado",
        "EARN_COMMISSION": "Ganhe",
        "COMMISSION": "comissão",
        "ON_EVERY_SALE": "em cada venda realizada através do seu link de referência exclusivo por um período de 15 meses. Compartilhe seu link no seu site, redes sociais ou com seus amigos. Leva segundos para se inscrever.",
        "GET_AUTOMATICALLY_APPROVED": "Seja aprovado automaticamente.",
        "JOIN_NOW": "Junte-se agora",
        "HOW_IT_WORKS": "COMO FUNCIONA",
        "FREQUENTLY_ASKED_QUESTIONS": "Perguntas Frequentes",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "O que é um Parceiro Afiliado?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Um Parceiro Afiliado é alguém que promove os produtos ou serviços de outra empresa através de um link de referência exclusivo e ganha uma comissão em cada venda realizada através desse link.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Como posso me tornar um Parceiro Afiliado?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Tornar-se um Parceiro Afiliado é rápido e fácil, levando apenas alguns segundos. Para começar, basta clicar no botão 'Junte-se agora' e se inscrever usando seu e-mail. Uma vez registrado, você terá acesso a um painel fácil de usar onde encontrará seu link de referência exclusivo. Compartilhe esse link com sua família, amigos ou público online. Sempre que alguém clicar no seu link de referência e fizer uma compra no site da Podsqueeze, você ganhará uma comissão de 25% em cada pagamento por um período de 15 meses! Acompanhe seus ganhos facilmente através do seu painel de Afiliado, que fornece uma visão clara de todas as vendas que você gerou.",
        "HOW_CAN_I_TRACK_MY_SALES": "Como posso acompanhar minhas vendas e comissões?",
        "TRACKING_SALES_DESCRIPTION": "Use nosso painel de programa de afiliados para acompanhar suas vendas e comissões. O software de rastreamento está disponível tanto para Parceiros Afiliados quanto para Parceiros de Negócios.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Quando e como receberei meu pagamento?",
        "PAYMENT_DESCRIPTION": "Você receberá seu pagamento via PayPal a cada 30 dias. Observe que há um limite mínimo de pagamento de $50. Assim que você atingir esse valor, pode esperar receber seu pagamento pontualmente a cada 30 dias.",
        "STILL_GOT_QUESTIONS": "AINDA TEM DÚVIDAS?",
        "SEND_US_A_MESSAGE": "Envie-nos uma mensagem no chat de suporte ou escreva para team@podsqueeze.com",
        "NOTE": "Nota",
        "AFFILIATE_ADS_RESTRICTION": "Afiliados estão expressamente proibidos de criar anúncios no Google ou participar de lances para palavras-chave relevantes associadas ao Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Termos de Uso para Afiliados",
        "CAN_I_RUN_ADS": "Posso executar anúncios e campanhas CPC no Google para promover meu link de referência?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Afiliados estão estritamente proibidos de criar anúncios em motores de busca ou participar de lances para palavras-chave relacionadas ao Podsqueeze. Essa restrição ajuda a manter a integridade da nossa estratégia de publicidade e garante uma mensagem de marca consistente. Observe que as vendas resultantes de tais campanhas de lances não serão elegíveis para pagamento.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Como o Podsqueeze gera títulos para seu Podcast?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Barra de Navegação",
        "main.affiliateHero": "Herói de Afiliados",
        "main.footer": "Rodapé"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Adicionar Música de Introdução e Encerramento",
        "intro.music": "Música de Introdução",
        "outro.music": "Música de Encerramento",
        "intro.duration": "Duração da Introdução",
        "outro.duration": "Duração do Encerramento",
        "intro.mode": "Modo de Introdução",
        "outro.mode": "Modo de Encerramento",
        "cancel": "Cancelar",
        "save": "Salvar",
        "apply": "Aplicar",
        "current.intro.music": "Música de Introdução Atual",
        "current.outro.music": "Música de Encerramento Atual",
        "change.music": "Alterar Música",
        "choose.music": "Escolher Arquivo de Música",
        "browser.not.support.audio": "Seu navegador não suporta o elemento de áudio.",
        "save.and.apply": "Salvar e Aplicar",
        "no.music.selected": "Nenhuma música selecionada",
        "delete.music": "Excluir música",
        "uploading.file": "Enviando arquivo..."
      },
      "audioEditElements": {
        "error.processing.rss": "Estamos enfrentando algumas dificuldades para processar alguns feeds RSS. Por favor, faça o upload de um arquivo.",
        "edit.enhance.audio": "Edite e melhore sua gravação de áudio",
        "trial.label": "Teste",
        "audio.editing.experience": "Experimente uma edição de áudio sem interrupções com algoritmos de IA avançados para resultados naturais e de alta qualidade, com apenas um clique.",
        "improve.audio.quality": "Melhorar a Qualidade do Áudio",
        "remove.hums.silences": "Remover Zumbidos e Silêncios",
        "upgrade.edit.audio": "Atualize para poder editar seu áudio com um único clique",
        "available.plans": "Disponível para Todos os Planos Pagos",
        "upgrade.now": "Atualizar Agora",
        "audio.element.support": "Seu navegador não suporta o elemento de áudio.",
        "download.audio": "Baixar Áudio",
        "loading.audio": "Carregando Áudio",
        "editing.audio": "Editando Áudio"
      },
      "videoEditElements": {
        "error.exporting.video": "Erro ao exportar vídeo",
        "download.failed": "Download falhou: {error.message}",
        "generating.video": "Gerando Vídeo",
        "error.generating.clip": "Erro ao Gerar Clipe",
        "please.retry.support": "Por favor, tente novamente ou entre em contato com nosso suporte ao usuário",
        "browser.not.support.video": "Seu navegador não suporta a tag de vídeo.",
        "this.might.take.minutes": "Por favor, não feche a janela, isso pode levar alguns minutos.",
        "exporting.video": "Exportando seu vídeo...",
        "seamless.audio.editing": "Experimente a edição de áudio sem interrupções com algoritmos de IA avançados para resultados naturais e de alta qualidade, com apenas um clique.",
        "difficulties.processing.rss": "Estamos enfrentando algumas dificuldades para processar alguns feeds RSS. Por favor, faça o upload de um arquivo.",
        "edit.enhance.video.recording": "Edite e melhore sua gravação de vídeo",
        "trial": "Teste",
        "enhance.audio.quality": "Melhorar a Qualidade do Áudio",
        "enhance.audio.quality.edit": "Melhorar a Qualidade do Áudio & Editar",
        "trim.filler.words.video": "Remover palavras de preenchimento do vídeo (ex: hums)",
        "trim.long.silences.video": "Remover longas silêncios do vídeo",
        "upgrade.to.edit.video": "Atualize para poder editar seu vídeo com um único clique",
        "available.pro.agency.plans": "Disponível para Planos Pro e Agência",
        "upgrade.now": "Atualizar Agora",
        "download.only.audio": "Baixar Apenas Áudio",
        "download.video": "Baixar Vídeo",
        "please.dont.close.window": "Por favor, não feche a janela",
        "export.video": "Exportar Vídeo"
      },
      "videogramBaseTemplate": {
        "media.fit": "cobrir",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "mídia"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Outros episódios deste Podcast",
        "tab.shownotes": "Notas do programa",
        "tab.timestamps": "Marcadores de tempo",
        "tab.blogpost": "Post do blog",
        "tab.transcript": "Transcrição",
        "key.points": "Pontos principais"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Sua página de destino está ao vivo em nosso buscador de podcasts. Compartilhe com seu público!",
        "landingPage.create": "Crie uma página de destino bonita para este episódio",
        "landingPage.edit": "Editar Página",
        "landingPage.visit": "Visitar Página",
        "landingPage.delete": "Excluir Página",
        "landingPage.createButton": "Criar Página de Destino"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Gerenciar Links de Episódio",
        "youtube.link": "Link do YouTube",
        "enter.youtube.link": "Insira o link do YouTube",
        "apple.podcasts.link": "Link do Apple Podcasts",
        "enter.apple.podcasts.link": "Insira o link do Apple Podcasts",
        "spotify.link": "Link do Spotify",
        "enter.spotify.link": "Insira o link do Spotify",
        "saving": "Salvando...",
        "save": "Salvar",
        "social.links.updated.successfully": "Links sociais atualizados com sucesso!"
      },
      "affiliatesection": {
        "affiliate.section.title": "TORNE-SE UM PARCEIRO AFILIADO",
        "affiliate.section.subtitle": "Compartilhe o Podsqueeze com seu público e",
        "affiliate.section.earn": "ganhe dinheiro!",
        "affiliate.section.commission": "Nosso programa de afiliados oferece 25% de comissão por 15 meses, em cada venda e pagamento de renovação de assinatura.",
        "affiliate.section.join": "Leva segundos para se inscrever!",
        "affiliate.section.knowMore": "Saiba Mais"
      },
      "asseenon": {
        "podnews.logo": "logo do podnews",
        "transistor.logo": "logo do transistor",
        "thepodcasthost.logo": "logo do the podcast host",
        "schoolofpodcasting.logo": "logo da School of Podcasting",
        "semrush.logo": "logo do semrush"
      },
      "assembleshownotes": {
        "episode.description": "Descrição do Episódio",
        "bullet.points": "Pontos Principais",
        "timestamps": "Capítulos",
        "links.and.mentions": "Links e Menções",
        "extra.content": "Conteúdo Extra",
        "assemble.show.notes": "Monte suas Notas do Show",
        "downloading": "Baixando",
        "copied": "Copiado",
        "enter.placeholder": "Digite {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Fazendo uma pausa no podcasting",
        "cancellation.option.no_recurrent": "Não quero uma assinatura recorrente",
        "cancellation.option.expensive": "É muito caro",
        "cancellation.option.not_saving_time": "Não está me economizando tempo suficiente",
        "cancellation.option.dissatisfied_content": "Insatisfeito com a qualidade do conteúdo gerado",
        "cancellation.option.unresponsive_support": "Suporte ao cliente não responsivo",
        "cancellation.option.not_using": "Não estou usando o serviço o suficiente",
        "cancellation.option.difficulty_navigating": "Dificuldade em usar/navegar no produto",
        "cancellation.option.better_alternative": "Encontrei um produto alternativo melhor",
        "cancellation.option.other": "Outro",
        "cancellation.video.message": "70% dos nossos usuários interrompem o processo de cancelamento após assistir a este vídeo",
        "cancellation.button.cancel": "Ainda Quero Cancelar",
        "cancellation.button.try_again": "Quero Tentar Novamente",
        "cancellation.prompt.select_reason": "Por favor, ajude-nos a melhorar o produto selecionando o motivo para cancelar sua assinatura:",
        "cancellation.placeholder.answer": "Digite sua resposta aqui...",
        "cancellation.placeholder.specify_reason": "Por favor, especifique seu motivo para o cancelamento",
        "cancellation.button.next": "Próximo",
        "cancellation.button.go_back": "Voltar",
        "cancellation.last_question.title": "Última Pergunta da Nossa Parte",
        "lose.all.accumulated.minutes": "Se você cancelar, você perderá todos os minutos acumulados.",
        "generate.articles.favorite.podcasts.and.vides": "Gerar artigos a partir dos seus podcasts favoritos",
        "convert.and.repurpose.episodes": "Converter e reutilizar seus episódios mais antigos em novo conteúdo",
        "keep.accumulating.minutes": "Continuar acumulando minutos para usar quando você retornar ao podcasting",
        "here.are.some.ideas": "Aqui estão algumas ideias para você continuar a obter valor do Podsqueeze",
        "share.your.account.with.a.friend": "Compartilhar sua conta com um amigo que pode ser útil",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Aqui está um vídeo mostrando como maximizar o uso do Podsqueeze",
        "cancellation.last_question.prompt": "Quais mudanças ou melhorias fariam você considerar voltar ao nosso serviço?",
        "cancellation.feedback.message": "Seu feedback nos ajudará a melhorar 🙏",
        "cancellation.button.confirm": "Confirmar Cancelamento",
        "cancellation.minutes.accumulated": "Você tem",
        "cancellation.minutes.accumulated.suffix": "minutos acumulados, avaliados em",
        "cancellation.reminder.text": "Por favor, lembre-se:",
        "cancellation.minutes.warning": "Minutos acumulados são um benefício para assinaturas ativas. Ao cancelar sua assinatura seus minutos serão perdidos permanentemente.",
        "cancellation.content.deletion.warning": "Todo o seu conteúdo gerado será permanentemente deletado após 30 dias.",
        "cancellation.minutes.left.title": "Você Ainda Tem Minutos Restantes! Não Os Desperdice!",
        "cancellation.suggestion.clips": "Reutilize episódios mais antigos em clipes para mídias sociais",
        "cancellation.suggestion.articles": "Transforme episódios mais antigos em artigos com Podsqueeze para se beneficiar do SEO.",
        "cancellation.suggestion.linkedin": "Transforme episódios de autoridade mais antigos em posts do LinkedIn para impulsionar sua marca pessoal",
        "cancellation.suggestion.share": "Compartilhe sua conta Podsqueeze com um amigo para que ele possa se beneficiar dos seus minutos não utilizados.",
        "cancellation.button.keep.subscription": "Manter Minha Assinatura",
        "cancellation.button.keep.minutes": "Manter Meus",
        "cancellation.button.keep.minutes.suffix": "em Valor de Minutos",
        "cancellation.lifetime.before_you_go": "Antes de você ir...",
        "cancellation.lifetime.title": "Que tal acesso vitalício por apenas $49?",
        "cancellation.lifetime.subtitle": "Mantenha sua conta Starter. Sem assinaturas. Sem renovações. Apenas seu — para sempre.",
        "cancellation.lifetime.feature1": "Acesso vitalício ao Podsqueeze por um pagamento único de $49",
        "cancellation.lifetime.feature2": "Use sempre que precisar, sem pressão — é seu para sempre",
        "cancellation.lifetime.feature3": "Inclui todos os recursos atuais e futuros do Plano Starter",
        "cancellation.lifetime.button_cancel": "Ainda quero cancelar",
        "cancellation.lifetime.button_deal": "Obter oferta vitalícia",
        "cancellation.downgrade.title": "Mantenha todo o seu conteúdo por apenas $5.99/mês",
        "cancellation.downgrade.subtitle": "Ao fazer downgrade para Starter você pode...",
        "cancellation.downgrade.feature1": "Manter todo o seu conteúdo gerado",
        "cancellation.downgrade.feature2": "Manter seus sites funcionando",
        "cancellation.downgrade.feature3": "160 minutos e 10 clipes por mês para trabalho ocasional",
        "cancellation.billing.monthly": "Mensal",
        "cancellation.billing.annual": "Anual",
        "cancellation.billing.discount": "30% DESC",
        "cancellation.plan.starter": "Plano Starter",
        "cancellation.price.monthly": "$8.99/mês",
        "cancellation.price.annual": "$5.99/mês",
        "cancellation.price.annual_billing": "cobrado $71.88 anualmente",
        "cancellation.feature.minutes": "160 mins/mês",
        "cancellation.feature.clips": "10 clipes/mês",
        "cancellation.downgrade.button": "Fazer Downgrade para Starter e Manter Conteúdo",
        "cancellation.error.payment_link": "Não foi possível obter o link de pagamento. Tente novamente.",
        "cancellation.error.payment_service": "Erro ao conectar com o serviço de pagamento.",
        "cancellation.option.question.break": "Pode nos contar mais sobre por que está fazendo uma pausa?",
        "cancellation.option.question.no_recurrent": "Poderia compartilhar por que prefere não ter uma assinatura recorrente?",
        "cancellation.option.question.expensive": "Que preços ou recursos tornariam o serviço mais valioso para você?",
        "cancellation.option.question.not_saving_time": "O que ainda está tomando muito do seu tempo no seu processo?",
        "cancellation.option.question.dissatisfied_content": "Com quais aspectos do conteúdo você não estava satisfeito?",
        "cancellation.option.question.unresponsive_support": "Pode descrever sua experiência com nosso suporte ao cliente?",
        "cancellation.option.question.not_using": "Há algo que o encorajaria a usar o serviço com mais frequência?",
        "cancellation.option.question.difficulty_navigating": "Que dificuldades você encontrou ao usar/navegar no produto?",
        "cancellation.option.question.better_alternative": "Que produto alternativo você encontrou e o que gosta nele?",
        "cancellation.option.question.other": "Por favor, especifique sua razão para cancelamento:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Valorizamos a sua privacidade",
        "cookiebanner.cookieUsage": "Usamos cookies para melhorar sua experiência no site e analisar nosso tráfego. Ao clicar em aceitar, você consente com o uso de cookies.",
        "cookiebanner.privacyPolicy": "Política de Privacidade",
        "cookiebanner.accept": "Aceitar",
        "cookiebanner.decline": "Recusar"
      },
      "episodeTitleBox": {
        "loading": "Carregando...",
        "editEpisodeTitleClicked": "Título do Episódio Editado",
        "newEpisodeTitleStored": "Novo Título do Episódio Armazenado"
      },
      "famewall": {
        "loading.message": "Carregando..."
      },
      "footer": {
        "footer.features": "Recursos",
        "footer.transcriptGenerator": "Gerador de Transcrições",
        "footer.subtitlesGenerator": "Gerador de Legendas",
        "footer.descriptionGenerator": "Gerador de Descrições",
        "footer.podcastSummarizer": "Gerador de Resumos de Podcast",
        "footer.titlesGenerator": "Gerador de Títulos",
        "footer.bulletPointsGenerator": "Gerador de Pontos de Tópicos",
        "footer.chaptersClipsGenerator": "Gerador de Capítulos e Clipes",
        "footer.socialMediaPostsGenerator": "Gerador de Postagens para Mídias Sociais",
        "footer.newsletterGenerator": "Gerador de Newsletter",
        "footer.blogPostGenerator": "Gerador de Postagens de Blog",
        "footer.podcastLandingPages": "Páginas de Destino de Podcast",
        "footer.podcastClipMaker": "Criador de Clipes de Podcast",
        "footer.audiogramGenerator": "Gerador de Audiogramas",
        "footer.aiAudioEnhancer": "Aprimorador de Áudio com IA",
        "footer.convertYoutubeToText": "Converter Youtube para Texto",
        "footer.youtubeVideoNoiseRemover": "Removedor de Ruído de Vídeo do Youtube",
        "footer.youtubeVideoKeyPoints": "Pontos-Chave do Vídeo do Youtube",
        "footer.freeResources": "Recursos Gratuitos",
        "footer.findPodcastTopicIdeas": "Encontrar Ideias de Tópicos para Podcast",
        "footer.articles": "Artigos",
        "footer.freeEbooks": "eBooks Gratuitos",
        "footer.community": "Comunidade",
        "footer.ourPodcast": "Nosso Podcast",
        "footer.product": "Produto",
        "footer.giftCard": "Cartão Presente",
        "footer.onboardingEbook": "eBook de Integração",
        "footer.pricing": "Preços",
        "footer.affiliates": "Afiliados",
        "footer.media": "Mídia",
        "footer.testimonials": "Depoimentos",
        "footer.legal": "Legal",
        "footer.privacyPolicy": "Política de Privacidade",
        "footer.termsOfUse": "Termos de Uso",
        "footer.refundPolicy": "Política de Reembolso",
        "footer.allRightsReserved": "Todos os Direitos Reservados."
      },
      "globalState": {
        "cookie.enabled": "Cookie habilitado",
        "language.default": "Idioma padrão"
      },
      "head": {
        "keywords.list": "Podsqueeze, IA, Podcasts, Geração de Conteúdo, Transcrição de Podcasts, Notas de Episódio, Marcação de Tempo, Newsletters de Podcasts, Tweets, Postagens de Blog, Postagens em Redes Sociais, Títulos, Redator de Notas de Episódio"
      },
      "imageResultModal": {
        "download.image": "Baixar Imagem",
        "generating.image": "Gerando Imagem",
        "ai.prompt.label": "Digite um prompt para a IA gerar uma imagem",
        "ai.prompt.placeholder": "Ex: Um cachorro correndo no parque...",
        "processing": "Processando...",
        "create": "Criar",
        "text.color.label": "Cor do Texto",
        "quote.icon.color.label": "Cor do Ícone de Citação",
        "background.color.label": "Cor de Fundo",
        "font.label": "Fonte",
        "upload.cover.image": "Carregar Imagem de Capa",
        "aspect.ratio.info": "Proporção 1:1, tamanho recomendado 1200x1200",
        "upload.logo.label": "Carregar Logo",
        "choose.file": "Escolher Arquivo",
        "upload.success": "Carregado com sucesso",
        "choose.quote": "Escolher uma Citação",
        "select.template": "Selecionar modelo",
        "quote.label": "Citação",
        "enter.quote.here": "Digite a Citação Aqui",
        "author.label": "Autor",
        "enter.author.name": "Digite o Nome do Autor",
        "podcast.name.label": "Nome do Podcast",
        "enter.podcast.name": "Digite o Nome do Podcast",
        "colors": "Cores",
        "select.font": "Selecionar Fonte",
        "cover.logo.images": "Imagens de Capa e Logo",
        "logo.image": "Imagem do Logo",
        "upgrade.here": "Atualizar aqui",
        "remove.logo": "Remover logo do Podsqueeze",
        "default_templates": "Modelos padrão",
        "saved_templates_count": "Modelos salvos",
        "save_current_template": "Salvar modelo atual",
        "no_saved_templates": "Nenhum modelo salvo ainda",
        "save_template": "Salvar modelo",
        "cancel": "Cancelar",
        "save": "Salvar",
        "enter_template_name": "Digite o nome do modelo",
        "reset_template": "Redefinir",
        "add_element": "Adicionar Elemento",
        "generate": "Gerar",
        "add_image": "Adicionar Imagem",
        "upload_image": "Enviar imagem",
        "or": "ou",
        "generate_with_ai": "Gerar com IA",
        "search_fonts": "Buscar fontes...",
        "upload_logo": "Enviar logo",
        "square_image_recommended": "Imagem quadrada recomendada",
        "opacity": "Opacidade",
        "layers": "Camadas",
        "no_element_selected": "Nenhum elemento selecionado",
        "bold_shortcut": "Negrito (Ctrl+B)",
        "italic_shortcut": "Itálico (Ctrl+I)",
        "underline_shortcut": "Sublinhado (Ctrl+U)",
        "edit_text": "Editar texto",
        "tint_color": "Cor de matiz",
        "toggle_gradient_transparent": "Alternar gradiente para transparente",
        "rotate_gradient": "Girar gradiente 45 graus",
        "alt_background": "Fundo",
        "alt_podcast_logo": "Logo do Podcast",
        "alt_custom": "Personalizado",
        "alt_right_side": "Lado Direito",
        "alt_profile": "Perfil"
      },
      "intentModal": {
        "intentModal.title": "O que você deseja fazer com o Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Escrever Notas do Show",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Escrever Post de Blog & Newsletter",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Criar Clipes de Vídeo ou Audiogramas",
        "intentModal.sourceOption.Create_Quote_Images": "Criar Imagens de Citação",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Editar & Melhorar Áudio/Vídeo",
        "intentModal.sourceOption.Transcribe": "Transcrever",
        "intentModal.sourceOption.Create_a_Website": "Criar um Site",
        "intentModal.sourceOption.All_of_the_Above": "Todas as Opções Acima",
        "intentModal.sourceOption.Other": "Outro",
        "intentModal.otherPlaceholder": "Por favor, especifique",
        "intentModal.submitButton": "Enviar & Registrar",
        "intentModal.skip": "Pular"
      },
      "languageSwitcher": {
        "language.en": "Inglês",
        "language.es": "Espanhol",
        "language.fr": "Francês",
        "language.de": "Alemão",
        "language.it": "Italiano",
        "language.pt": "Português",
        "language.nl": "Neerlandês",
        "language.pl": "Polonês",
        "language.ru": "Russo",
        "language.zh": "Chinês",
        "language.ja": "Japonês",
        "language.ko": "Coreano",
        "language.ar": "Árabe",
        "language.th": "Tailandês",
        "language.vi": "Vietnamita"
      },
      "lazyImage": {
        "lazyImage.alt": "Descrição da imagem"
      },
      "metadata": {
        "meta.title": "O Título da Sua Página",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Utilitário"
      },
      "navbar": {
        "navbar.dashboard": "Painel",
        "navbar.login": "Entrar",
        "navbar.openMenu": "Abrir menu principal",
        "navbar.features": "Funcionalidades",
        "navbar.resources": "Recursos",
        "navbar.pricing": "Preços",
        "navbar.contact": "Contato",
        "navbar.topPodcasts": "Top Podcasts",
        "navbar.seeAllFeatures": "Ver todos os recursos",
        "navbar.mainFeatures": "RECURSOS PRINCIPAIS",
        "navbar.podcastTranscription": "Gerador de Transcrição de Podcast e Vídeo",
        "navbar.transcriptionDescription": "Transcrição com alta precisão, com identificação de falantes e arquivo SRT para legendas.",
        "navbar.podcastSummarizer": "Resumidor de Podcast",
        "navbar.summarizerDescription": "Crie notas de programa completas 20x mais rápido, na sua própria voz.",
        "navbar.podcastClipMaker": "Criador de Clipes de Podcast",
        "navbar.clipMakerDescription": "Gere automaticamente clipes curtos ou audiogramas para seu podcast.",
        "navbar.audioEnhancer": "Aprimorador de Áudio Ai",
        "navbar.audioEnhancerDescription": "Aprimore automaticamente o áudio, remova silêncios e palavras de preenchimento.",
        "navbar.podsqueezeFeaturesWalkthrough": "GUIA DE RECURSOS DO PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Artigos e guias práticos para lançar e crescer um podcast de sucesso.",
        "navbar.podcastTopicIdeas": "Ideias de Tópicos para Podcast",
        "navbar.topicIdeasDescription": "Descubra tópicos de podcast que o público está procurando.",
        "navbar.actionableEbooks": "eBooks Práticos",
        "navbar.ebooksDescription": "Baixe eBooks gratuitos com dicas práticas para levar seu podcast ao próximo nível.",
        "navbar.freeThumbnailMaker": "Criador Gratuito de Miniaturas de Podcast",
        "navbar.freeThumbnailMakerDescription": "Crie miniaturas profissionais e atrativas para episódios com IA.",
        "navbar.seoOptimizer": "Otimizador SEO",
        "navbar.seoOptimizerDescription": "Otimize seus episódios de podcast para melhor visibilidade nos motores de busca.",
        "navbar.podcastDescription": "Ouça nosso podcast, onde entrevistamos podcasters experientes e usuários do Podsqueeze de todo o mundo. Pedimos para eles compartilharem suas dicas, insights, histórias e tudo que você precisa saber para fazer seu próprio podcast crescer."
      },
      "resultModal": {
        "prompt.transcript.quote": "Citação",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweets",
        "prompt.shownotes.firstPerson": "Notas de apresentação em primeira pessoa",
        "prompt.shownotes.replaceName": "Substituir nome nas notas de apresentação",
        "prompt.shownotes.friendlyTone": "Notas de apresentação em tom amigável",
        "prompt.shownotes.youtubeDescription": "Descrição do YouTube nas notas de apresentação",
        "prompt.shownotes.engagingQuestion": "Pergunta envolvente nas notas de apresentação",
        "prompt.newsletter.casualTone": "Newsletter em tom casual",
        "prompt.newsletter.shorter": "Newsletter mais curta",
        "prompt.newsletter.contentSections": "Seções de conteúdo na newsletter",
        "prompt.newsletter.changeName": "Alterar nome na newsletter",
        "prompt.mentions.fullURL": "Menções com URL completo",
        "prompt.mentions.replaceName": "Substituir nome nas menções",
        "prompt.tweets.underdogTone": "Tweets em tom de azarão",
        "prompt.tweets.firstPerson": "Tweets em primeira pessoa",
        "prompt.shortPost.relevantEmojis": "Emojis relevantes para post curto",
        "prompt.shortPost.educationalTone": "Post curto em tom educacional",
        "prompt.shortPost.underdogTone": "Post curto em tom de azarão",
        "prompt.shortPost.firstPerson": "Post curto em primeira pessoa",
        "prompt.titles.youtubeOptimized": "Títulos otimizados para YouTube",
        "prompt.titles.startWithHowTo": "Começar com títulos 'Como fazer'",
        "prompt.titles.otherOptions": "Outras opções para títulos",
        "prompt.keywords.youtubeOptimized": "Palavras-chave otimizadas para YouTube",
        "prompt.keywords.separateWithCommas": "Separar palavras-chave com vírgulas",
        "prompt.quotes.lorem1": "Citação Lorem ipsum 1",
        "prompt.quotes.lorem2": "Citação Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Ponto de bala Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Ponto de bala Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Post longo em primeira pessoa",
        "prompt.longPost.relevantEmojis": "Emojis relevantes para post longo",
        "prompt.longPost.changeName": "Alterar nome no post longo",
        "alert.tuningInstructionsEmpty": "As instruções de ajuste não podem estar vazias.",
        "text.timestamps.byPodsqueeze": "Timestamps por PodSqueeze",
        "button.copied": "Copiado",
        "button.copy": "Copiar",
        "embed.transcript": "Incorporar Transcrição",
        "embed.description": "Descrição para incorporação",
        "preview.title": "Título da Pré-visualização",
        "loading.regenerating": "Regenerando...",
        "placeholder.tuningInstructions": "Digite as instruções de ajuste...",
        "button.saveClose": "Salvar e Fechar",
        "button.acceptChanges": "Aceitar Alterações",
        "button.discard": "Descartar",
        "button.embedTranscript": "Incorporar Transcrição",
        "text.copiedToClipboard": "Copiado para a área de transferência",
        "download.srtFile": "Baixar Arquivo SRT",
        "text.forCaptions": "para legendas",
        "tune.title": "Ajuste Seus Resultados",
        "tune.description": "Ajuste seus resultados com as seguintes opções.",
        "button.tuneResult": "Ajustar Resultados",
        "instruction.label": "Instruções:",
        "instruction.saveForLater": "Salvar para depois",
        "button.readMore": "Ler mais",
        "button.showLess": "Mostrar menos",
        "customPrompt.used": "Prompt personalizado usado:",
        "feedback.happyWithResults": "Você está satisfeito com os resultados?",
        "prompt.timestamps.formatAsChapters": "Formatar timestamps como capítulos com títulos descritivos",
        "prompt.timestamps.detailedDescriptions": "Criar timestamps detalhados com descrições de tópicos e pontos-chave",
        "prompt.timestamps.improveSpeakerNames": "Substituir nomes de oradores por títulos mais descritivos como 'Apresentador', 'Especialista' ou 'Convidado'"
      },
      "resultModalTranscript": {
        "prompt.quote": "Encontre três boas citações da transcrição",
        "prompt.blog": "Escreva um post de blog de 500 palavras focando no tópico X",
        "prompt.tweets": "Escreva três tweets envolventes da transcrição",
        "transcript.autoTranscribed": "Transcrito automaticamente com Podsqueeze",
        "alert.emptyPrompt": "As instruções de ajuste não podem estar vazias",
        "embed.transcript": "Incorporar transcrição",
        "embed.description": "Incorpore uma transcrição gerenciável com recurso de busca no seu site WordPress ou qualquer página com suporte a HTML.",
        "button.copied": "Copiado!",
        "button.copy": "Copiar código",
        "transcript.public.available": "URL pública",
        "button.generate": "Gerar",
        "preview.title": "Pré-visualização da transcrição",
        "edit.speakers": "Editar nomes dos participantes",
        "button.saveClose": "Salvar e fechar",
        "placeholder.prompt": "ex: Encontre três boas citações da transcrição",
        "upgrade.pro": "Faça upgrade para o Pro para usar este recurso",
        "upgrade.link": "Faça upgrade para o Pro",
        "feedback.happy": "Você está satisfeito com os resultados?",
        "instruction": "Instrução: ",
        "generating.results": "Gerando resultados",
        "full.transcription": "Transcrição completa",
        "srt.file": "& arquivo SRT",
        "download.srt": "Baixar arquivo SRT",
        "caption.subtitles": "para legendas e subtítulos.",
        "generate.from.transcript": "Gerar da transcrição com Gpt-4.1",
        "gpt.tweak.text": "Peça ao GPT mais recente para ajustar o texto como desejar. Use linguagem natural e não tenha medo de ser específico.",
        "copied.clipboard": "Copiado para a área de transferência",
        "audio.notSupported": "Seu navegador não suporta o elemento de áudio.",
        "button.chatWithTranscript": "Conversar sobre a transcrição",
        "button.closeChat": "Fechar chat",
        "label.speaker": "Participante"
      },
      "selectPodcast": {
        "add.podcast.name": "Adicionar Nome do Podcast",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Como você descobriu sobre o Podsqueeze?",
        "sourceModal.otherPlaceholder": "Por favor, especifique",
        "sourceModal.nextButton": "Próximo",
        "sourceModal.skip": "Pular"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Estamos enfrentando algumas dificuldades para processar alguns feeds RSS. Por favor, faça o upload de um arquivo."
      },
      "squeezeResults": {
        "copiedToClipboard": "Copiado para a área de transferência",
        "publicLink": "Público em ",
        "createLink": "Criar um link para compartilhar esta Página de Resultados",
        "assembleShowNotes": "Montar Notas do Show",
        "convertAnotherEpisode": "Converter outro episódio",
        "writtenContent": "Conteúdo escrito",
        "videoClipsAndImages": "Clipes de Vídeo e Imagens",
        "editAudio": "Editar Áudio"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Veja mais e ajuste",
        "see.more": "Veja mais",
        "generating": "Gerando",
        "download.all": "Baixar Tudo",
        "full.transcription": "Transcrição Completa",
        "transcript.benefit": "Você sabia que adicionar transcrições completas às suas notas de programa aumenta o tráfego e o engajamento do site?",
        "learn.more": "Saiba mais",
        "transcript.bonus": "Você pode fornecer transcrições completas como um bônus para o seu programa de assinatura de podcast.",
        "show.notes": "Notas do Programa",
        "show.notes.engagement": "Considere complementar esta breve descrição com outros elementos em suas notas de programa para aumentar o engajamento e o SEO.",
        "show.notes.examples": "Encontre inspiração em estes 17 exemplos de notas de programa de podcast para criar as perfeitas para o seu podcast.",
        "timestamps": "Capítulos",
        "timestamps.benefit": "Adicione estas Capítulos à descrição do seu episódio e isso criará automaticamente capítulos no Spotify e no YouTube.",
        "titles": "Títulos",
        "titles.engagement": "Títulos com pontos de interrogação e superlativos tendem a ser particularmente envolventes.",
        "links.and.mentions": "Links & Menções",
        "mentions.resources": "Considere incluir as menções abaixo na seção de recursos das suas notas de programa.",
        "mentions.affiliate": "Veja se os produtos mencionados têm programas de afiliados e considere adicionar links de afiliados nas suas notas de programa.",
        "mentions.social.media": "Marque as pessoas mencionadas no seu episódio nas redes sociais para incentivá-las a compartilhar e interagir com sua postagem.",
        "keywords": "Palavras-chave",
        "keywords.youtube": "Quando você enviar seu episódio para o YouTube, basta copiar e colar estas palavras-chave na seção de tags.",
        "keywords.social.media": "Reaproveite estas palavras-chave para hashtags nas redes sociais.",
        "blog.post": "Postagem no Blog",
        "blog.post.linkedin": "Considere usar este conteúdo para criar uma postagem longa no Linkedin,",
        "blog.post.share": "Compartilhe este conteúdo em comunidades do Reddit e Grupos do Facebook que se alinhem com o tema do seu podcast.",
        "newsletter": "Newsletter",
        "newsletter.content": "Alguns de nossos usuários reaproveitam este conteúdo de newsletter para criar descrições de episódios mais abrangentes para as notas de programa.",
        "linkedin.and.facebook": "Linkedin & Facebook",
        "short.post.description": "Use estas postagens breves como descrições ao compartilhar clipes de vídeo e audiogramas relacionados nas redes sociais.",
        "tweets": "Tweets",
        "quotes": "Citações",
        "bullet.points": "Pontos Principais",
        "add.custom.result": "Adicionar Resultado Personalizado",
        "bullet.points.skimming": "Os podcasters costumam listar os principais tópicos do episódio como pontos principais nas notas de programa para facilitar a leitura."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Veja mais e ajuste",
        "generating": "Gerando",
        "not.available.for.rss.feed": "Não disponível para este feed RSS",
        "regenerate.episode.upload.file": "Regenerar o episódio e enviar seu arquivo de áudio/vídeo diretamente do seu computador",
        "processing.difficulties": "Estamos enfrentando algumas dificuldades para processar alguns feeds RSS. Por favor, envie um arquivo.",
        "video.clips": "Clipes de Vídeo",
        "ai.short.clips": "Clipes Curtos de IA",
        "quote.image": "Imagem da Citação"
      },
      "title": {
        "title.text": "seu.rótulo"
      },
      "topbar": {
        "topbar.forYou": "Para Você",
        "topbar.joinPodcast": "Participe do nosso próximo encontro virtual de podcast!",
        "topbar.saveYourSpot": "Reserve seu Lugar",
        "topbar.dismiss": "Dispensar"
      },
      "trackers": {
        "trackers.init": "Inicializando rastreadores com cookies habilitados: ",
        "trackers.loadScripts": "Carregando scripts de rastreamento..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "Sou o seu assistente. Como posso ajudar você hoje?",
        "button.send": "Enviar",
        "button.closeChat": "Fechar chat"
      },
      "translate": {
        "header.title": "Bem-vindo ao Meu Aplicativo",
        "content.description": "Este é um aplicativo de exemplo que demonstra tradução.",
        "button.submit": "Enviar"
      },
      "videoResultModal": {
        "ai_editing_clip": "O Podsqueeze AI está editando seu clipe",
        "export_clip": "Exportar Clipe",
        "ai_edit": "Edição de IA",
        "ai_editing_clip_duration": "Isso levará alguns segundos",
        "generating_clip": "Gerando seu clipe...",
        "generating_clip_notice": "Isso pode levar alguns minutos. Nós enviaremos um e-mail assim que estiver pronto.",
        "edit_another_video": "Você pode esperar aqui ou editar outro vídeo",
        "download_video": "Baixar Vídeo",
        "back_to_editing": "Voltar à Edição",
        "export_video_button": "Exportar Clipe",
        "notice_storage": "Aviso: Armazenamos seu áudio por 30 dias. Após esse período, este clipe expirará.",
        "error_generating_clip": "Erro ao Gerar o Clipe",
        "error_user_support": "Por favor, tente novamente ou entre em contato com nosso suporte ao usuário",
        "select_template": "Selecionar modelo",
        "add_30s_prev": "30s do capítulo anterior",
        "add_30s_next": "30s do próximo capítulo",
        "undo": "Desfazer",
        "subtitles_font": "Fonte das Legendas",
        "subtitles_color": "Cor das Legendas",
        "subtitles_box_color": "Cor da animação",
        "adjust_podcast_title_position": "Ajustar Posição Vertical do Título do Podcast",
        "adjust_subtitles_size": "Ajustar Tamanho das Legendas",
        "adjust_subtitles_vertical_position": "Ajustar Posição Vertical das Legendas",
        "remove_subtitles": "Remover Legendas",
        "animated_subtitles": "Legendas Animadas",
        "upgrade_here": "Atualizar aqui",
        "remove_logo": " para remover o logo",
        "remove_podsqueeze_logo": "Remover logo do podsqueeze",
        "aspect_ratio": "Proporção",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Feed do Instagram",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Título do Episódio",
        "podcast_title": "Título do Podcast",
        "titles_font": "Fonte dos Títulos",
        "title_colors": "Cores dos títulos do podcast/episódio",
        "video_fit": "Ajuste do Vídeo",
        "adjust_horizontal_position": "Ajustar Posição Horizontal",
        "adjust_vertical_position": "Ajustar Posição Vertical",
        "adjust_video_zoom": "Ajustar Zoom do Vídeo",
        "adjust_video_width": "Ajustar Largura do Vídeo",
        "adjust_video_height": "Ajustar Altura do Vídeo",
        "background_color": "Cor de Fundo",
        "edit_clip": "Editar Clipe",
        "edit_layout": "Editar Layout",
        "choose_short": "Escolher um Short",
        "edit_audio": "Editar Áudio",
        "framing": "Enquadramento",
        "background": "Fundo",
        "text_style": "Estilo do Texto",
        "music": "Música",
        "choose_chapter": "Escolher um capítulo",
        "clips_left": "Você tem",
        "apply_layout": "Aplicar Layout",
        "clips_left_number": "clips restantes",
        "need_more_clips": "Precisa de mais clipes? Atualize seu plano aqui",
        "download_srt_file": "Baixar Arquivo SRT",
        "track_selected": "Faixa: ",
        "no_background_music": "Nenhuma Música de Fundo Selecionada",
        "volume": "Volume:",
        "remove": "Remover",
        "track_ambient_piano": "Piano e cordas ambientes",
        "track_deep_meditation": "Meditação profunda",
        "track_chill_upbeat": "Para um clima descontraído e animado",
        "track_inspiring_ambient": "Ambiente cinematográfico inspirador",
        "track_just_relax": "Apenas relaxe",
        "track_movement": "Movimento",
        "track_once_in_paris": "Uma vez em Paris",
        "track_perfect_beauty": "Beleza perfeita",
        "track_summer_adventures": "Aventuras de verão",
        "track_sunset_groove": "Ritmo do pôr do sol",
        "track_tvari_cafe": "Café Tvari Tokyo",
        "track_short_piano_intermezzo": "Breve Intermezzo de Piano",
        "track_dramatic_background": "Música Dramática de Fundo",
        "track_dramatic_hiphop": "Jazz Hip-Hop Dramático",
        "track_emotional_orchestra": "Orquestra Emocional",
        "track_halloween_short": "Música de Halloween",
        "track_improvisation_037": "Improvisação Jazz",
        "track_inspiration_piano": "Piano Inspiracional",
        "track_medieval_extract": "Música Medieval",
        "track_short_8": "Faixa Ambient Curta",
        "track_flute": "Flauta Tranquila",
        "track_piano_guitar_duet": "Dueto Piano-Violão",
        "track_intro_jazz": "Jazz de Introdução",
        "track_romantic_jazz": "Jazz Romântico",
        "recommended_for_youtube": "Ideal para YouTube",
        "turn_into_short_clip": "Converter clipe em SHORT (<60s)",
        "browser_not_support_audio": "Seu navegador não suporta o elemento de áudio.",
        "watch_tutorial": "Assista a este tutorial",
        "audiogram_maker": "sobre como tirar o máximo proveito do nosso criador de audiogramas",
        "store_audio_notice": "Aviso: Armazenamos seu áudio por 30 dias.",
        "clip_maker": "sobre como tirar o máximo proveito do nosso criador de clipes",
        "split_screen_mode": "Modo de Divisão de Tela",
        "none": "Nenhum",
        "vertical_split": "Divisão Vertical",
        "horizontal_split": "Divisão Horizontal",
        "layers": "Use as camadas abaixo para movê-las para frente ou para trás.",
        "screen_1_horizontal_position": "Posição Horizontal da Tela 1",
        "screen_2_horizontal_position": "Posição Horizontal da Tela 2",
        "track_mysterious_dark_background": "Fundo Misterioso Escuro",
        "track_acoustic_ambient_inspiration": "Inspiração Acústica Ambiente",
        "track_aristocracy_classical": "Aristocracia Clássica",
        "track_folk_music_river_knows_my_name": "Música Folk - O Rio Conhece Meu Nome",
        "track_funy_adventure": "Aventura Divertida",
        "track_energetic_sports_rock_trailer": "Trailer de Rock Esportivo Energético",
        "track_fun_upbeat_energetic_pop_rock": "Pop Rock Energético Divertido",
        "track_epic_emotional_inspirational": "Épico Emocional Inspiracional",
        "track_inspirational_epic": "Épico Inspiracional",
        "all_music": "Toda a Música",
        "energetic_music": "Energética",
        "inspirational_music": "Inspiradora",
        "ambient_music": "Ambiente",
        "chill_music": "Relaxante",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Peculiar",
        "dramatic_music": "Dramática",
        "acoustic_music": "Acústica",
        "classical_music": "Clássica",
        "categories": "Categorias",
        "select_track": "Selecionar Faixa",
        "downloading": "Baixando...",
        "download_again": "Baixar novamente",
        "download": "Baixar",
        "download_failed_alert": "Falha ao baixar o vídeo. Tente novamente.",
        "translate_subtitles": "Traduzir Legendas",
        "translate_to": "Traduzir para",
        "select_language": "Selecionar Idioma",
        "select_new_language": "Selecionar novo idioma",
        "translating": "Traduzindo...",
        "translation_complete": "Tradução Completa",
        "error_translation": "Erro durante a tradução. Tente novamente.",
        "original_language": "Original"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Título do Episódio"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Você ainda não tem nenhum conteúdo.",
        "userPodcastsInfo.generateContent": "Gere seu primeiro conteúdo",
        "placeholder.search_folders": "Pesquisar pastas...",
        "search.no_results": "Nenhuma pasta corresponde à sua pesquisa."
      },
      "landingPageModal": {
        "upload.error": "Falha ao enviar a imagem: ",
        "upload.image.file": "Por favor, envie um arquivo de imagem.",
        "upgrade.pro.message": "A personalização da página está disponível apenas para contas Pro e Agency",
        "upgrade.now": "Atualize agora",
        "upgrade.unique.landing.page": " e crie uma página de destino única para o episódio.",
        "logo.recommendation": "Altura recomendada do logo 200px",
        "social.links.top.menu": "Links Sociais no Menu Superior",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Insira o link do LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Insira o link do Facebook",
        "saving...": "Salvando...",
        "save": "Salvar",
        "saved.successfully": "Salvo com sucesso!",
        "uploading.image": "Enviando imagem...",
        "upload.episode.cover": "Enviar Capa do Episódio",
        "upload.logo": "Enviar Logo",
        "where.listen.episode": "Onde mais podemos ouvir este episódio?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Insira o link do YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Insira o link do Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Insira o link do Spotify",
        "image.size.recommendation": "Tamanho recomendado 1000x1000px",
        "primary.color.label": "Cor Primária",
        "header.background.color": "Cor de fundo do cabeçalho e links.",
        "landing.page.customization": "Personalização da Página de Destino",
        "create.branded.landing.page": "Crie uma bela página de destino personalizada para compartilhar com seus ouvintes",
        "episode.image": "Imagem do Episódio",
        "episode.links": "Links do Episódio",
        "page.header": "Cabeçalho da Página",
        "page.color": "Cor da Página",
        "visit.landing.page": "Visitar Página de Destino"
      },
      "page": {
        "loading.dashboard": "Carregando Painel",
        "convert.new.episode": "Converter Novo Episódio",
        "convert.audio.or.video": "Converter áudio ou vídeo",
        "minutes.left": "Você tem",
        "need.more.minutes": "Precisa de mais minutos?",
        "upgrade.plan": "Atualize seu plano aqui.",
        "your.podcasts": "Seus podcasts",
        "podsqueeze.results.page": "Página de Resultados do Podsqueeze",
        "access.podsqueeze.results": "Acesse os resultados do podsqueeze para este episódio. Você poderá ver todo o conteúdo gerado"
      },
      "podcast": {
        "confirm.delete_episode": "Você tem certeza de que deseja excluir este episódio?",
        "alert.something_wrong": "Algo deu errado. Por favor, tente novamente.",
        "confirm.delete_folder": "Você tem certeza de que deseja excluir esta pasta?",
        "loading.episodes": "Carregando episódios...",
        "folder.empty": "Esta pasta está vazia.",
        "content.no_content": "Nenhum conteúdo disponível.",
        "content.generate_first": "Gere seu primeiro podcast.",
        "button.personalize_ai": "Personalizar com IA",
        "button.edit_website": "Editar Site",
        "button.visit_website": "Visitar Site",
        "button.generate_website": "Gerar Site",
        "placeholder.search": "Pesquisar...",
        "label.sort_by": "Ordenar por",
        "label.last_episodes_loaded": "Últimos episódios carregados",
        "button.load_all_episodes": "Carregar todos os episódios",
        "loading": "Carregando...",
        "add.new.episode": "Adicionar Novo Episódio",
        "order.newest": "Mais recentes primeiro",
        "order.oldest": "Mais antigos primeiro",
        "order.a_to_z": "A a Z",
        "order.z_to_a": "Z a A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Criar uma nova pasta de podcast:",
        "folder.name.placeholder": "Nome da pasta",
        "create.button": "Criar"
      },
      "podcastLandingModal": {
        "upload.image.error": "Por favor, faça o upload de um arquivo de imagem",
        "podcast.cover.title": "Imagem de Capa do Podcast",
        "podcast.cover.upload": "Faça o upload da imagem de capa do seu podcast aqui. Esta será exibida de forma proeminente na sua página de destino.",
        "upload.image.uploading": "Fazendo upload da imagem...",
        "podcast.cover.upload.button": "Fazer Upload da Imagem de Capa",
        "podcast.cover.recommended.size": "Tamanho recomendado: 1400x1400 pixels",
        "profile.info.title": "Informações do Perfil",
        "profile.info.upload": "Adicione sua foto de perfil e nome para personalizar sua página de destino.",
        "profile.upload.button": "Fazer Upload da Foto de Perfil",
        "profile.name.label": "Nome do Perfil",
        "profile.name.placeholder": "Digite seu nome",
        "platform.links.title": "Links da Plataforma",
        "platform.links.upload": "Adicione links para o seu podcast em várias plataformas.",
        "platform.links.youtube_link": "Link do YouTube",
        "platform.links.youtube_link.placeholder": "Digite o link do YouTube",
        "platform.links.spotify_link": "Link do Spotify",
        "platform.links.spotify_link.placeholder": "Digite o link do Spotify",
        "platform.links.apple_podcast_link": "Link do Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Digite o link do Apple Podcast",
        "platform.links.linkedin_link": "Link do LinkedIn",
        "platform.links.linkedin_link.placeholder": "Digite o link do LinkedIn",
        "platform.links.facebook_link": "Link do Facebook",
        "platform.links.facebook_link.placeholder": "Digite o link do Facebook",
        "platform.links.twitter_link": "Link do Twitter",
        "platform.links.twitter_link.placeholder": "Digite o link do Twitter",
        "call.to.action.title": "Chamada para Ação",
        "call.to.action.upload": "Configure o botão de chamada para ação para a página de destino.",
        "call.to.action.button.text.label": "Texto do Botão",
        "call.to.action.button.text.placeholder": "Digite o texto do botão",
        "call.to.action.button.link.label": "Link do Botão",
        "call.to.action.button.link.placeholder": "Digite o link do botão",
        "color.styles.title": "Estilos de Cor",
        "color.styles.upload": "Personalize as cores da sua página de destino.",
        "color.styles.primary.label": "Cor Primária",
        "color.styles.primary.description": "Escolha a cor primária para sua página de destino",
        "color.styles.secondary.label": "Cor Secundária",
        "color.styles.secondary.description": "Escolha a cor secundária para sua página de destino",
        "podcast.info.title": "Informações do Podcast",
        "podcast.info.upload": "Edite os detalhes do seu podcast.",
        "podcast.info.name.label": "Nome do Podcast",
        "podcast.info.name.placeholder": "Digite o nome do podcast",
        "podcast.info.description.label": "Descrição do Podcast",
        "podcast.info.description.placeholder": "Digite a descrição do podcast",
        "edit.website.title": "Editar Website",
        "generate.website.title": "Gerar Website",
        "for": "para",
        "saving": "Salvando...",
        "save.changes": "Salvar Alterações",
        "generate.website": "Gerar Website",
        "changes.saved.success": "Alterações salvas com sucesso!",
        "podcast.cover.menu": "Capa do Podcast",
        "podcast.info.menu": "Informações do Podcast",
        "profile.menu": "Perfil",
        "platform.links.menu": "Links da Plataforma",
        "call.to.action.menu": "Chamada para Ação",
        "color.styles.menu": "Estilos de Cor",
        "logo.menu": "Logo",
        "logo.title": "Logo Uploaden",
        "logo.upload": "Upload aqui o logo do seu podcast. Este logo será exibido na sua página de destino.",
        "logo.upload.button": "Logo Uploaden",
        "platform.links.description": "Adicione links para o seu podcast em várias plataformas.",
        "social.links.menu": "Links Sociais",
        "social.links.title": "Links Sociais",
        "social.links.description": "Adicione links para os seus perfis sociais.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Digite o link do LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Digite o link do Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Digite o link do Twitter",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Digite o link do Instagram",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Digite o link do YouTube",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Digite o link do Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Digite o link do Apple Podcast",
        "view.website": "Ver Site"
      },
      "podcastMoveModal": {
        "move.episode.label": "Mover este episódio para:",
        "move.episode.instruction": "Você pode digitar um novo nome para criar uma pasta.",
        "move.episode.button": "Mover",
        "move.episode.error.selectFolder": "Por favor, selecione uma pasta para mover o episódio."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Configurações de IA para o Podcast {{podcastTitle}}",
        "ai.customize.writing.style": "Personalize o Estilo de Escrita da Sua IA",
        "ai.content.writing.preference": "Como você gostaria que o Podsqueeze escrevesse seu conteúdo?",
        "ai.voice.placeholder": "Exemplo: Tom profissional, mas amigável. Os ouvintes são podcasters. Escreva na primeira pessoa.",
        "ai.character.limit.reached": "Você atingiu o limite de 50 caracteres.",
        "ai.upgrade.now": "Atualize agora",
        "ai.fix.transcript.misspells": "Corrigir Erros de Transcrição",
        "ai.enter.misspelled.words": "Anote as palavras que a IA costuma escrever incorretamente nos episódios deste podcast, por exemplo, nomes",
        "ai.enter.word.press.enter": "Digite uma palavra e pressione Enter",
        "ai.add.word": "Adicionar Palavra",
        "ai.tag.limit.reached": "Limite de 1 tag atingido.",
        "ai.save": "Salvar",
        "ai.save.close": "Salvar e Fechar"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Título do Episódio",
        "selectedEpisode.podcastName": "Nome do Podcast",
        "selectedEpisode.showNotes": "Notas do Programa",
        "selectedEpisode.timestamp": "Timestamp",
        "selectedEpisode.staticTimestamp": "Timestamp Estático",
        "selectedEpisode.mentions": "Menções",
        "selectedEpisode.newsletter": "Newsletter",
        "selectedEpisode.titles": "Títulos",
        "selectedEpisode.tweeter": "Twitter",
        "selectedEpisode.shortPost": "Postagem Curta",
        "selectedEpisode.transcription": "Transcrição",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Palavras-chave",
        "selectedEpisode.quotes": "Citações",
        "selectedEpisode.longPost": "Postagem Longa",
        "selectedEpisode.bulletPoints": "Pontos de Destaque",
        "selectedEpisode.publicLink": "Link Público",
        "selectedEpisode.embeddedId": "ID Incorporado",
        "selectedEpisode.episodeUrl": "URL do Episódio"
      },
      "sidebar": {
        "tools": "Ferramentas",
        "find.podcast.topic.ideas": "Encontre Tópicos para Podcast",
        "podcast.thumbnail.maker": "Criador de Thumbnails",
        "podcast.seo.optimizer": "Otimizador SEO de Titulo",
        "account": "Conta",
        "payment.settings": "Configurações de Pagamento",
        "support": "Suporte",
        "logout": "Sair",
        "plan": "Plano",
        "resets.in": "Reinicia em",
        "api.access": "Acesso à API",
        "days": "dias e",
        "hours": "horas",
        "upgrade.plan": "Atualizar Plano"
      },
      "updateEmailModal": {
        "email.validation.error": "Por favor, insira um endereço de e-mail válido.",
        "email.change.confirm": "Você tem certeza de que deseja mudar seu endereço de e-mail?",
        "email.change.success": "Seu e-mail foi alterado com sucesso!",
        "email.in.use.error": "Este e-mail já está em uso. Por favor, tente outro.",
        "email.recent.login.error": "Antes de continuar com esta operação, por favor, faça login novamente usando o endereço de e-mail atual.",
        "email.invalid.error": "Endereço de e-mail inválido. Por favor, tente outro.",
        "subscription.cancel.error": "Por favor, cancele sua assinatura paga ativa primeiro.",
        "account.delete.confirm": "Você tem certeza de que deseja excluir sua conta?\n\nEsta ação não pode ser desfeita.",
        "account.delete.success": "Sua conta foi excluída com sucesso.",
        "account.delete.error": "Algo deu errado e não conseguimos excluir sua conta.\n\nPor favor, entre em contato com nosso suporte ao usuário.",
        "subscription.cancel": "Cancelar Assinatura",
        "account.delete": "Excluir Conta",
        "account.delete.warning": "Excluir sua conta é irreversível e apagará permanentemente todo o seu conteúdo e informações de login. Por favor, prossiga com cautela, pois esta ação não pode ser desfeita.",
        "current.account.email": "E-mail da Conta Atual",
        "enter.new.email": "Insira seu novo e-mail da conta",
        "update": "Atualizar",
        "change.password": "Alterar Senha",
        "payment.settings": "Configurações de Pagamento"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "títuloDoEpisódio"
      },
      "episodelist": {
        "loading.episodes": "Carregando Episódios",
        "no.episodes.found": "Nenhum Episódio Encontrado. Por favor, tente novamente com um ID RSS válido",
        "select.episode": "Selecione o episódio para o qual deseja criar conteúdo"
      },
      "interfaces": {
        "user.activePlan.tier": "Nível",
        "user.activePlan.creationDate": "Data de Criação",
        "user.activePlan.minutesAvailable": "Minutos Disponíveis"
      },
      "loadingbar": {
        "loadingbar.magic": "Estamos ainda fazendo nossa mágica ✨",
        "loadingbar.longer": "Alguns episódios demoram um pouco mais... 🐌",
        "loadingbar.hardwork": "Nossos servidores estão trabalhando duro 🦾"
      },
      "page": {
        "main.background": "Fundo do componente principal"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Erro: O acesso ao microfone ou câmera foi negado.",
        "microphone.camera.not.found": "Erro: Nenhum microfone ou câmera encontrado.",
        "microphone.camera.not.readable": "Erro: O microfone ou câmera não é legível.",
        "microphone.camera.access.error": "Erro: Ocorreu um erro desconhecido ao acessar o microfone ou câmera.",
        "media.not.recorded": "Erro: Nenhum mídia foi gravada.",
        "upload.failed": "Erro: O upload falhou.",
        "upload.success": "Sucesso: Upload concluído com sucesso.",
        "upload.in.progress": "Upload em andamento...",
        "upload.button": "Fazer Upload da Gravação",
        "stop.recording": "Parar Gravação",
        "record.audio": "Gravar Áudio",
        "record.audio.video": "Gravar Áudio com Vídeo",
        "record.again": "Gravar de novo",
        "episode.language": "Selecionar Idioma do Episódio"
      },
      "selectBox": {
        "language.english": "Inglês",
        "language.arabic": "Árabe",
        "language.bulgarian": "Búlgaro",
        "language.catalan": "Catalão",
        "language.croatian": "Croata",
        "language.czech": "Tcheco",
        "language.danish": "Dinamarquês",
        "language.dutch": "Holandês",
        "language.finnish": "Finlandês",
        "language.french": "Francês",
        "language.german": "Alemão",
        "language.greek": "Grego",
        "language.hindi": "Hindi",
        "language.hungarian": "Húngaro",
        "language.indonesian": "Indonésio",
        "language.italian": "Italiano",
        "language.japanese": "Japonês",
        "language.korean": "Coreano",
        "language.lithuanian": "Lituano",
        "language.latvian": "Letão",
        "language.malay": "Malaio",
        "language.mandarin": "Mandarim",
        "language.norwegian": "Norueguês",
        "language.polish": "Polonês",
        "language.portuguese": "Português",
        "language.romanian": "Romeno",
        "language.russian": "Russo",
        "language.slovak": "Eslovaco",
        "language.slovenian": "Esloveno",
        "language.spanish": "Espanhol",
        "language.swedish": "Sueco",
        "language.tamil": "Tâmil",
        "language.turkish": "Turco",
        "language.ukrainian": "Ucraniano",
        "language.bashkir": "Bashkir",
        "language.basque": "Basco",
        "language.belarusian": "Bielorrusso",
        "language.cantonese": "Cantonês",
        "language.esperanto": "Esperanto",
        "language.estonian": "Estoniano",
        "language.galician": "Galego",
        "language.interlingua": "Interlíngua",
        "language.marathi": "Marathi",
        "language.mongolian": "Mongol",
        "language.persian": "Persa",
        "language.thai": "Tailandês",
        "language.uyghur": "Uigur",
        "language.vietnamese": "Vietnamita",
        "language.welsh": "Galês"
      },
      "selectedepisode": {
        "processing.episode": "Processando Episódio",
        "processing.time": "Normalmente leva entre 5 a 10 minutos",
        "email.notification": "Você pode fechar esta janela. Enviaremos um e-mail assim que estiver pronto. Seu conteúdo também estará disponível no seu painel.",
        "convert.another.episode": "Converter outro episódio",
        "technical.difficulties": "Ops! Estamos enfrentando algumas dificuldades técnicas. Fique tranquilo, nossa equipe está cuidando disso! Por favor, tente novamente mais tarde.",
        "no.discount": "Não se preocupe, não vamos descontar nenhum minuto!",
        "high.demand": "Estamos enfrentando uma demanda maior que o normal, então pode levar mais tempo do que o habitual para processar sua solicitação. Pedimos desculpas por qualquer inconveniente!",
        "email.ready": "Enviaremos um e-mail assim que estiver pronto. Você também pode acessar seus resultados no seu painel.",
        "select.podcast.folder": "Selecione a pasta do podcast à qual este episódio pertence, ou crie uma nova digitando um nome.",
        "give.voice": "Personalize a voz da pasta",
        "generate.content": "Gerar Conteúdo",
        "content.ready": "Seu conteúdo está pronto!",
        "not.enough.minutes.title": "Você não tem minutos suficientes para converter este episódio.",
        "not.enough.minutes.message": "Por favor, atualize seu plano para poder converter este episódio.",
        "upgrade.plan": "Atualizar Meu Plano",
        "convert.shorter.episode": "Converter um episódio mais curto",
        "ask.ai.tune": "Você ainda pode pedir à IA para ajustar cada conteúdo para melhor atender às suas necessidades.",
        "error.title": "Erro",
        "convert.another.file": "Converter outro arquivo"
      },
      "submitfile": {
        "file.size.exceeded.free": "O tamanho do arquivo excede o limite máximo de 4 GB. <p>Por favor, <a href='/pricing'><b><u>atualize para enviar arquivos maiores</u></b></a></p>",
        "file.size.exceeded.paid": "O tamanho do arquivo excede o limite máximo de 10 GB. <p>Por favor, selecione um arquivo menor.</p>",
        "file.upload.invalid": "Por favor, envie um arquivo de áudio ou vídeo",
        "upload.in.progress": "Enviando arquivo. Por favor, não feche esta janela.",
        "upload.button": "Enviar & Gerar",
        "close.button": "Fechar",
        "upgrade.message.free": "Mais envios estão disponíveis apenas para planos pagos.",
        "upgrade.now.button": "Atualizar Agora",
        "pricing.info": "a partir de $12/mês",
        "upload.file.label": "Envie um arquivo de áudio ou vídeo",
        "max.file.size.free": "(máx 4 gb)",
        "max.file.size.paid": "(máx 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze irá gerar audiogramas para arquivos de áudio e clipes curtos para arquivos de vídeo",
        "file.placeholder": "Seu arquivo MP3/WAV",
        "episode.language.label": "Idioma do Episódio",
        "multiple.files.selected": "{{count}} arquivos selecionados",
        "clear.all": "Limpar todos",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Selecionar múltiplos arquivos",
        "file.upload.error": "Erro ao enviar o arquivo",
        "file.upload.success": "Arquivo enviado com sucesso",
        "file.upload.processing": "Processando arquivo",
        "click.to.upload": "Clique para enviar",
        "click.to.upload.multiple": "Clique para enviar múltiplos arquivos",
        "select.folder.label": "Selecionar ou criar pasta",
        "enter.url": "Inserir URL",
        "upload.file": "Enviar arquivo",
        "media.url.label": "URL da mídia",
        "media.url.help": "Insira a URL do seu arquivo de áudio ou vídeo. Nós o baixaremos e processaremos para você.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Nome do episódio",
        "url.input.required": "Por favor, insira uma URL de mídia",
        "url.upload.error": "Falha ao enviar mídia da URL. Por favor, verifique a URL e tente novamente.",
        "supported.formats": "Formatos suportados",
        "uploading": "Enviando...",
        "media.url.requirements": "A URL deve ser um link direto para um arquivo de mídia público (não uma página web)"
      },
      "submitrssid": {
        "error.selectRss": "Por favor, selecione um RSS válido no menu suspenso",
        "label.insertRssFeed": "Insira seu Feed RSS",
        "placeholder.insertRssFeed": "Insira seu Feed RSS",
        "label.searchByPodcast": "Pesquisar pelo nome do podcast em vez disso",
        "label.searchForPodcast": "Pesquise pelo nome do seu podcast",
        "placeholder.searchForPodcast": "Pesquisar um podcast",
        "label.cantFindPodcast": "Não consegue encontrar seu podcast? ",
        "label.clickHereUseRss": "Clique aqui para usar seu feed RSS em vez disso",
        "label.selectedPodcast": "Podcast selecionado",
        "label.episodeLanguage": "Idioma do episódio",
        "button.seeAllEpisodes": "Ver todos os episódios",
        "select.folder.label": "Selecionar ou criar pasta"
      },
      "submitsection": {
        "search.podcast": "Pesquise Seu Podcast",
        "upload.audio.video": "Carregar Áudio ou Vídeo",
        "record.audio": "Gravar Áudio",
        "youtube.video": "Link de YouTube",
        "create.content": "Vamos criar conteúdo para o seu podcast!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Insira a URL do vídeo do YouTube",
        "error.insertYouTubeUrl": "Por favor, insira uma URL do YouTube.",
        "label.insertYouTubeUrl": "Inserir URL do YouTube",
        "button.loading": "Carregando...",
        "message.downloadingFile": "Baixando arquivo...",
        "error.processingFailed": "Ocorreu um erro ao processar o vídeo. Por favor, tente novamente.",
        "button.submitYouTubeVideo": "Enviar Vídeo do YouTube",
        "error.youtubeVideoNotAvailable": "Este vídeo do YouTube não está disponível para download. Por favor, carregue seu áudio ou vídeo diretamente para Podsqueeze ou use um YouTube downloader primeiro. Obrigado pela sua paciência.",
        "episode.language.label": "Idioma utilizado",
        "select.folder.label": "Selecionar ou criar pasta"
      },
      "tabs": {
        "tab.label.tab1": "Aba 1",
        "tab.label.tab2": "Aba 2",
        "tab.label.tab3": "Aba 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Aproveite ao Máximo o Podsqueeze",
        "tutorial.chapter.introduction": "Introdução",
        "tutorial.chapter.bestShowNotes": "Obtenha as melhores notas do show e timestamps",
        "tutorial.chapter.blogPosts": "Utilizando postagens de blog e newsletters",
        "tutorial.chapter.editingTranscripts": "Incorporando e editando transcrições",
        "tutorial.chapter.personalizingAI": "Personalizando a IA e Dando Sua Própria Voz",
        "tutorial.chapter.speedingUpNotes": "Acelerando as Notas do Show",
        "tutorial.chapter.creatingClips": "Criando clipes de vídeo e imagens",
        "tutorial.chapter.generatingLandingPage": "Gerando uma página de destino",
        "tutorial.chapter.shareResults": "Compartilhar Resultados com Sua Equipe",
        "tutorial.closeVideoCheckbox": "Fechar vídeo assim que os primeiros resultados estiverem prontos"
      },
      "uploadloadingbar": {
        "upload.loading": "Carregando..."
      }
    },
    "home": {
      "affiliate-affiliatehero": {
        "affiliatehero.becomePartner": "TORNE-SE NOSSO PARCEIRO",
        "affiliatehero.sharePodsqueeze": "Partilhe o Podsqueeze com o seu público",
        "affiliatehero.andEarnMoney": " e ganhe dinheiro!",
        "affiliatehero.lastUpdated": "Última atualização: {date}",
        "affiliatehero.becomeAffiliatePartner": "Torne-se um Parceiro Afiliado",
        "affiliatehero.earnCommission": "Ganhe ",
        "affiliatehero.commissionPercentage": "25% de comissão",
        "affiliatehero.details": " em cada venda realizada através do seu link de referência exclusivo por um período de 15 meses. Partilhe o seu link no seu site, redes sociais, ou com os seus amigos. Leva apenas alguns segundos para se inscrever. Aprovação automática.",
        "affiliatehero.joinNow": "Inscreva-se agora",
        "affiliatehero.howItWorks": "COMO FUNCIONA",
        "affiliatehero.faq": "Perguntas Frequentes",
        "affiliatehero.whatIsAffiliatePartner": "O que é um Parceiro Afiliado?",
        "affiliatehero.affiliatePartnerDefinition": "Um Parceiro Afiliado é alguém que promove os produtos ou serviços de outra empresa através de um link de referência único e ganha uma comissão em cada venda realizada através desse link.",
        "affiliatehero.howToBecomeAffiliate": "Como posso tornar-me um Parceiro Afiliado?",
        "affiliatehero.becomingAffiliateDetails": "Tornar-se um Parceiro Afiliado é rápido e fácil, levando apenas alguns segundos. Para começar, basta clicar no botão \"Inscreva-se agora\" e registar-se com o seu e-mail. Após o registo, terá acesso a um painel de controlo amigável onde encontrará o seu link de referência único. Partilhe este link com a sua família, amigos ou público online. Sempre que alguém clicar no seu link de referência e fizer uma compra no site da Podsqueeze, ganhará uma comissão de 25% em cada pagamento durante um período de 15 meses! Acompanhe os seus ganhos de forma fácil através do seu painel de controlo de Afiliado, que fornece uma visão clara de todas as vendas que gerou.",
        "affiliatehero.trackSales": "Como posso acompanhar as minhas vendas e comissões?",
        "affiliatehero.trackSalesDetails": "Use o nosso painel de controlo do programa de afiliados para acompanhar as suas vendas e comissões. O software de rastreamento está disponível tanto para Parceiros Afiliados como para Parceiros Empresariais.",
        "affiliatehero.paymentDetails": "Quando e como receberei o meu pagamento?",
        "affiliatehero.paymentInfo": "Receberá o seu pagamento via PayPal a cada 30 dias. Por favor, note que existe um limite mínimo de pagamento de $50. Assim que atingir este montante, pode esperar receber o seu pagamento pontualmente a cada 30 dias.",
        "affiliatehero.stillGotQuestions": "AINDA TEM DÚVIDAS?",
        "affiliatehero.contactUs": "Envie-nos uma mensagem no chat de suporte ou envie-nos um e-mail para team@podsqueeze.com"
      },
      "affiliate-page": {
        "your.label.navbar": "NavBar",
        "your.label.affiliatehero": "Affiliatehero",
        "your.label.footer": "Footer",
        "your.label.background": "bg-[#643ADA]"
      },
      "conatctsection": {
        "contact.section.title": "Entre em Contato",
        "contact.section.email": "Envie-nos um email para support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fundador",
        "contact.section.joao.role": "Co-fundador",
        "contact.section.image.alt.sendMessage": "Enviar mensagem",
        "contact.section.image.alt.tiago": "Co-fundador Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fundador Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Entre em Contato Conosco",
        "contact.section.email": "Envie-nos um email para support@podsqueeze.com",
        "contact.section.tiago.role": "Co-fundador",
        "contact.section.joao.role": "Co-fundador",
        "contact.section.image.alt.sendMessage": "Enviar mensagem",
        "contact.section.image.alt.tiago": "Co-fundador Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Co-fundador Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Junte-se a 20.000 criadores de conteúdo e profissionais de podcast usando o Podsqueeze",
        "content.creators": "Criadores de Conteúdo",
        "podcast.managers": "Gerentes de Podcast",
        "producers.studios": "Produtores e Estúdios",
        "for.podcasters": "PARA PODCASTERS, GERENTES DE PODCAST E AGÊNCIAS",
        "manage.content.creation": "Gerencie a criação de conteúdo sem esforço para",
        "multiple.podcasts": "múltiplos podcasts",
        "podsqueeze.description": "O Podsqueeze é uma ferramenta poderosa para todos os profissionais de podcast. Seja você um podcaster solo, gerente de podcast ou agência, o Podsqueeze oferece todos os recursos que você precisa para otimizar seu fluxo de trabalho de criação de conteúdo de podcast.",
        "create.podcast.folders": "Crie pastas de podcast para manter seus episódios organizados.",
        "share.content.page": "Compartilhe facilmente sua página de conteúdo com clientes e equipe",
        "tune.ai.voice": "Ajuste a voz da IA para cada programa que você gerencia",
        "plan.content.episodes": "Planeje o conteúdo dos próximos episódios com nosso avançado",
        "podcast.topics.finder": "localizador de tópicos de podcast",
        "podsqueeze.testimonial": "A capacidade do Podsqueeze de usar prompts para ajustar o conteúdo de cada podcast que gerenciamos e salvá-los para episódios futuros nos permite manter as vozes de cada programa consistentes. Este é um recurso de elite que não conseguimos encontrar em outras ferramentas",
        "coo.podigy": "COO da Podigy Podcasts",
        "agenciessection.joinCreators": "Junte-se a 20.000 criadores de conteúdo e profissionais de podcast usando o Podsqueeze",
        "agenciessection.contentCreators": "Criadores de Conteúdo",
        "agenciessection.podcastManagers": "Gerentes de Podcast",
        "agenciessection.producersStudios": "Produtores e Estúdios",
        "agenciessection.forPodcasters": "PARA PODCASTERS, GERENTES DE PODCAST E AGÊNCIAS",
        "agenciessection.manageContent": "Gerencie a criação de conteúdo sem esforço para",
        "agenciessection.multiplePodcasts": "múltiplos podcasts",
        "agenciessection.podsqueezeDescription": "O Podsqueeze é uma ferramenta poderosa para todos os profissionais de podcast. Seja você um podcaster solo, gerente de podcast ou agência, o Podsqueeze oferece todos os recursos que você precisa para otimizar seu fluxo de trabalho de criação de conteúdo de podcast.",
        "agenciessection.createPodcastFolders": "Crie pastas de podcast para manter seus episódios organizados.",
        "agenciessection.shareContent": "Compartilhe facilmente sua página de conteúdo com clientes e equipe",
        "agenciessection.tuneAI": "Ajuste a voz da IA para cada programa que você gerencia",
        "agenciessection.planContent": "Planeje o conteúdo dos próximos episódios com nosso avançado",
        "agenciessection.podcastTopicsFinder": "localizador de tópicos de podcast",
        "agenciessection.podsqueezeQuote": "A capacidade do Podsqueeze de usar prompts para ajustar o conteúdo de cada podcast que gerenciamos e salvá-los para episódios futuros nos permite manter as vozes de cada programa consistentes. Este é um recurso de elite que não conseguimos encontrar em outras ferramentas",
        "agenciessection.coO": "COO da Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "NOVA FUNÇÃO",
        "seamless.editing": "Edição contínua e aprimoramento de áudio para natural, ",
        "high.quality.results": " resultados de alta qualidade",
        "experience.seamless.audio.editing": "Experimente a edição de áudio contínua com algoritmos de IA avançados para gravações de primeira linha. ",
        "remove.ums": "Remover 'ums'",
        "enhance.sound.quality": ", silêncios e aprimorar a qualidade do som com apenas um clique.",
        "enhance.audio.now": "Aprimorar Áudio Agora",
        "sample.audio.recorded": "Áudio de amostra, gravado diretamente do telefone.",
        "original.recording": "Gravação original",
        "audio.after.ai.edit": "Áudio após edição e aprimoramento com IA",
        "experience.audio.editing": "Experimente a edição de áudio contínua com algoritmos de IA avançados para gravações de primeira linha. "
      },
      "home-blogsection": {
        "more.resources.label": "MAIS RECURSOS PARA SEU PODCAST",
        "learn.how.to.get.most": "Aprenda a aproveitar ao máximo",
        "your.content": "seu conteúdo",
        "get.most.out.of.ai.content": "Aproveite ao Máximo o Conteúdo Gerado por IA para Seu Podcast",
        "welcome.to.podsqueeze": "Bem-vindo ao Podsqueeze – a maneira mais simples de transcrever seu podcast e criar conteúdo cativante...",
        "will.google.penalize.ai.content": "O Google penalizará seu conteúdo gerado por IA?",
        "ai.content.discussion": "O surgimento do conteúdo gerado por IA gerou discussões e levantou preocupações entre criadores de conteúdo, profissionais de marketing e SEO...",
        "what.is.rss.feed": "O que é um feed RSS para Podcasts e como usá-lo",
        "rss.feed.benefits": "Como podcaster, você pode ter ouvido o termo 'feed RSS' antes, mas pode não saber exatamente o que é ou como pode beneficiar...",
        "visit.blog": "Visite o Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIPS & AUDIOGRAMAS",
        "clipsAndAudiograms.subtitle": "Reaproveite seu podcast em clips sem esforço",
        "clipsAndAudiograms.description": "Basta escolher um capítulo do seu episódio e exportá-lo como um clip ou audiograma para TikTok, Instagram e Youtube Shorts. Escolha um modelo e ajuste ao seu próprio estilo.",
        "clipsAndAudiograms.createClips": "Criar Clips Agora",
        "textEditor.title": "Editor baseado em texto",
        "textEditor.description": "Ajuste seus clips e audiogramas diretamente das legendas. Edite as legendas e corte seu vídeo removendo palavras específicas.",
        "oneClickShorts.title": "Shorts com um clique (<60s)",
        "oneClickShorts.description": "Deixe a IA cuidar da edição para você. Com o pressionar de um botão, a IA encurtará cada capítulo do seu episódio para menos de 60 segundos, pronto para ser postado como um YouTube Short ou clips do TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Entre em Contato com os Fundadores",
        "contact.section.email": "equipe@podsqueeze.com",
        "contact.section.tiago.role": "- Desenvolvedor & Podcaster",
        "contact.section.joao.role": "- Designer UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "AMPLA VARIEDADE DE CONTEÚDO",
        "generate.content": "Gerar conteúdo com",
        "one.click": " um clique!",
        "transcript.srt": "Transcrição & SRT",
        "transcript.description": "Obtenha a transcrição completa do seu episódio de podcast, juntamente com um arquivo SRT pronto para gerar legendas.",
        "show.notes": "Notas do episódio",
        "show.notes.description": "Resuma os principais tópicos abordados no seu episódio e torne-o mais pesquisável",
        "timestamps": "Capítulos",
        "timestamps.description": "Crie capítulos com Capítulos e guie os ouvintes para segmentos específicos do seu episódio de podcast",
        "blog.social.posts": "Postagens de Blog & Redes Sociais",
        "blog.social.posts.description": "Publique sobre seu episódio de podcast em todos os lugares e atraia novos ouvintes",
        "newsletter": "Newsletter",
        "newsletter.description": "Mantenha seus ouvintes atualizados com novos episódios",
        "titles.more": "Títulos & mais!",
        "titles.more.description": "Gere títulos cativantes, citações, pontos-chave, palavras-chave e mais!",
        "see.sample.content": "VEJA O CONTEÚDO DE AMOSTRA",
        "wannabe.entrepreneur": "Empreendedor Aspirante - #299 Podsqueeze acaba de atingir $100.000 em receita anual!",
        "making.space": "Fazendo Espaço - Steve Harvey: “Você Pode Continuar”",
        "modern.wisdom": "Sabedoria Moderna - Erik Hoel - Um Guia Para O Mistério Fundamental Da Mente"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Linha divisória"
      },
      "home-explanationsection": {
        "fast.accurate": "RÁPIDO E PRECISO",
        "generate.content": "Gere conteúdo para o seu podcast com o",
        "power.of.ai": "poder da IA",
        "upload.image.alt": "carregar imagem",
        "select.episode": "Selecione um episódio do seu feed RSS ou carregue um arquivo de áudio/vídeo",
        "paste.rss.feed": "Basta colar a URL do seu feed RSS para escolher um episódio da lista ou carregar um arquivo de áudio ou vídeo.",
        "content.image.alt": "imagem do conteúdo",
        "one.click.content": "Obtenha todo o conteúdo com um clique!",
        "user.friendly.interface": "Interface intuitiva e amigável que você pode começar a usar imediatamente. Gere conteúdo para o seu podcast com um clique.",
        "tune.image.alt": "imagem de ajuste",
        "edit.fine.tune": "Edite e ajuste cada conteúdo",
        "direct.edit.content": "Edite diretamente e ajuste cada conteúdo de acordo com sua preferência com a IA. Por exemplo, você pode pedir um tom específico, fala direta ou indireta ou simplesmente corrigir nomes mal escritos.",
        "multiple.language.support": "Suporte a múltiplos idiomas",
        "language.flags.alt": "bandeiras de idiomas",
        "generate.content.aria": "Gerar conteúdo"
      },
      "home-featuressection": {
        "loading": "Carregando...",
        "transcribe.write.show.notes": "Transcreva e escreva notas do programa para o seu podcast",
        "twenty.times.faster": "20x mais rápido",
        "save.manual.work": "Economize até 100% do trabalho manual. Transcreva automaticamente seu podcast com precisão de ponta e rotulagem de falantes, e gere notas do programa completas e postagens para redes sociais na sua própria voz.",
        "generate.content": "Gerar Conteúdo",
        "transcripts": "Transcrições",
        "full.transcript": "Obtenha a transcrição completa dos episódios do seu podcast e das transcrições de vídeos do YouTube, junto com um arquivo SRT para legendas.",
        "show.notes": "Notas do Programa",
        "summarize.generate.show.notes": "Resuma e gere notas do programa na sua própria voz, completas com timestamps, tópicos e menções.",
        "blog.newsletter": "Blog e Newsletter",
        "actionable.blog.posts": "Obtenha postagens de blog acionáveis sobre seus episódios e newsletters prontas para enviar com os principais pontos.",
        "social.media": "Mídias sociais",
        "short.posts.insights": "Obtenha postagens curtas e insights rápidos para divulgar nas mídias sociais.",
        "quote": "De todas as melhores ferramentas de transcrição de IA que testamos, o Podsqueeze gerou as saídas mais úteis para Notas do Programa, Timestamps, Títulos, Menções, Exemplos de Postagens de Blog e Citações Chave.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Co-fundador da Transistor.fm",
        "transcribe_and_write_show_notes": "Transcrições de podcast, resumos e posts de redes sociais",
        "twenty_times_faster": "20x mais rápido",
        "save_manual_work": "Economize até 100% do trabalho manual. Transcreva automaticamente seu podcast com precisão de ponta e rotulagem de falantes, e gere notas do programa completas e postagens para redes sociais na sua própria voz.",
        "generate_content": "Gerar Conteúdo",
        "full_transcript": "Obtenha a transcrição completa dos episódios do seu podcast e das transcrições de vídeos do YouTube, junto com um arquivo SRT para legendas.",
        "show_notes": "Notas do Programa",
        "summarize_and_generate_show_notes": "Resuma e gere notas do programa na sua própria voz, completas com timestamps, tópicos e menções.",
        "blog_and_newsletter": "Blog e Newsletter",
        "actionable_blog_posts": "Obtenha postagens de blog acionáveis sobre seus episódios e newsletters prontas para enviar com os principais pontos.",
        "social_media": "Mídias sociais",
        "short_posts_and_insights": "Obtenha postagens curtas e insights rápidos para divulgar nas mídias sociais.",
        "testimonial": "De todas as melhores ferramentas de transcrição de IA que testamos, o Podsqueeze gerou as saídas mais úteis para Notas do Programa, Timestamps, Títulos, Menções, Exemplos de Postagens de Blog e Citações Chave.",
        "cofounder_transistor": "Co-fundador da Transistor.fm"
      },
      "home-page": {
        "main.background": "Cor de fundo para o componente principal"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "OUÇA NOSSO PODCAST",
        "podcast.section.subtitle": "Masterclasses de",
        "podcast.section.highlight": "podcasters experientes",
        "podcast.section.description": "Ouça nosso podcast, onde entrevistamos podcasters experientes e usuários do Podsqueeze de todo o mundo. Pedimos que compartilhem suas dicas, insights, histórias e tudo o que você precisa saber para fazer seu próprio podcast crescer.",
        "podcast.link.spotify": "Ouça no Spotify",
        "podcast.link.apple": "Ouça no Apple Podcasts",
        "podcast.link.youtube": "Ouça no YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Carregando..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Automatize seu Podcast",
        "tagline.productionPromotion": "Produção e Promoção",
        "tagline.launchGrow": "Lance e cresça seu podcast de áudio ou vídeo sem esforço, com tudo que você precisa em um só lugar, com a ajuda da IA.",
        "tagline.uploadGenerate": "Faça a transcrição de podcasts, resumos, clips curtos com legendas e muito mais!",
        "tagline.singleClick": " Tudo com um único clique.",
        "tagline.transcripts": "Transcrição de Podcast",
        "tagline.showNotes": "Notas do Show",
        "tagline.newslettersBlogs": "Newsletters e Blogs",
        "tagline.socialPosts": "Postagens Sociais",
        "tagline.shortClipsAudiograms": "Clipes Curtos e Audiogramas",
        "tagline.podcastWebsite": "Website do Podcast",
        "tagline.aiAudioEnhancement": "Aprimoramento de Áudio com IA",
        "tagline.removeSilences": "Remover silêncios e hesitações",
        "tagline.generateNow": "Gere agora gratuitamente",
        "tagline.noCreditCard": "Nenhum cartão de crédito necessário",
        "testimonial.robWalling.title": "Rob Walling, Personalidade de Startup",
        "testimonial.robWalling.subtitle": "Podcast Startups para Todos Nós",
        "testimonial.robWalling.quote": "As notas do show do Podsqueeze foram as melhores. Usamos muito para resumos e para obter insights de outros podcasts.",
        "testimonial.johnGarmet.title": "John Garmet, Diretor de Operações",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "O Podsqueeze nos ajuda a ser mais eficientes e gerar mais conteúdo para nossos clientes. Recomendamos muito.",
        "testimonial.davidJackson.title": "David Jackson, Coach de Podcast",
        "testimonial.davidJackson.subtitle": "Escola de Podcasting",
        "testimonial.davidJackson.quote": "O Podsqueeze é meu parceiro de brainstorming. É a melhor maneira de criar marketing para podcasts."
      },
      "home-testimonials": {
        "testimonials.title": "O que as pessoas estão dizendo sobre o Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Reaproveite o conteúdo do seu podcast usando IA | Product Hunt",
        "testimonials.heading": "O que as pessoas estão dizendo sobre o Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Senha incorreta",
        "error.userNotFound": "Usuário não encontrado",
        "error.somethingWentWrong": "Ops, algo deu errado",
        "button.sendResetEmail": "Enviar E-mail de Redefinição",
        "button.login": "Entrar",
        "placeholder.email": "Endereço de e-mail",
        "placeholder.password": "Senha",
        "link.forgotPassword": "Esqueceu sua senha?",
        "link.createAccount": "Criar Conta",
        "text.or": "OU",
        "button.continueWithGoogle": "Continuar com o Google",
        "text.podcastDescription": "Lance e cresça seu podcast de áudio ou vídeo sem esforço com tudo que você precisa em um só lugar.",
        "feature.transcripts": "Transcrições",
        "feature.showNotes": "Notas do Show",
        "feature.newslettersAndBlogs": "Newsletters & Blogs",
        "feature.socialPosts": "Postagens Sociais",
        "feature.shortClipsAndAudiograms": "Clipes Curtos & Audiogramas",
        "feature.podcastWebsite": "Website do Podcast",
        "feature.aiAudioEnhancement": "Aprimoramento de Áudio com IA",
        "feature.removeSilences": "Remover silêncios e pausas",
        "error.emailNotVerified": "E-mail não verificado",
        "text.pleaseVerifyAccount": "Verifique sua conta",
        "text.checkSpamFolder": "Enviamos um e-mail de verificação para você. Por favor, verifique sua caixa de entrada e a pasta de spam.",
        "button.resendVerificationEmail": "Reenviar e-mail de verificação",
        "error.verificationEmailFailed": "Erro ao enviar e-mail de verificação. Por favor, tente novamente."
      },
      "page": {
        "login.form": "FormulárioDeLogin"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Página de Afiliados Podsqueeze",
        "affiliate.page.description": "Ganhe 25% de comissão em cada venda realizada através do seu link de referência exclusivo por um período de 15 meses. Compartilhe seu link no seu site, nas redes sociais ou com seus amigos. Leva segundos para se inscrever. Aprovação automática."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Melhor Presente para um Podcaster",
        "bestGiftForPodcaster.description": "Descubra os melhores presentes para podcasters para aprimorar sua experiência.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Atraia mais ouvintes para o podcast",
        "get-more-podcast-listeners.description": "Atraia mais ouvintes para o podcast e otimize a produção com notas de programa automáticas, clipes curtos para promover seu programa nas redes sociais e muito mais."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Aumente a Audiência do Seu Podcast",
        "grow_your_podcast_audience.description": "Economize muito tempo e aumente a audiência do seu podcast com o Podsqueeze. Gere notas de programa completas, postagens para redes sociais, clipes curtos e muito mais para o seu podcast."
      },
      "index": {
        "home.page.title": "Notas de Episódio de Podcast de IA, Transcrições, Resumos e Gerador de Clipes.",
        "home.page.description": "Gere notas de episódio, timestamps, newsletters e mais para o seu podcast com um clique! Gere rapidamente conteúdo para o seu podcast e ajuste-o às suas necessidades. Inscrição gratuita."
      },
      "login": {
        "login.tryItNow": "Experimente agora!",
        "login.createAccountDescription": "Crie uma conta e comece a gerar notas de episódio, timestamps, newsletters e mais para o seu podcast com um clique! Gere rapidamente conteúdo para o seu podcast e ajuste-o às suas necessidades. Inscrição gratuita."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Marketing para Podcasts",
        "marketing.for.podcasts.description": "O Podsqueeze simplifica o marketing para podcasts com notas de programa geradas automaticamente, postagens em redes sociais e clipes curtos para aumentar seu alcance e fazer seu programa crescer."
      },
      "media": {
        "media.page.title": "Página de Mídia do Podsqueeze",
        "media.page.description": "Saiba mais sobre o Podsqueeze. Entre em contato! Adoraríamos colaborar!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Gerador de Descrição de Podcast",
        "podcast.description.generator.description": "Melhore o alcance e o engajamento do seu podcast com descrições geradas por IA. Automatize a escrita das suas Notas do Show e recupere um tempo precioso."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Reaproveite seu podcast para postagens em redes sociais",
        "convert.podcast.episodes.to.social.media.posts": "Converta episódios de podcast em postagens para redes sociais. Gere automaticamente postagens para LinkedIn, Twitter, Facebook e clipes curtos para TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Gerador de Tópicos de Podcast Gratuito",
        "podcast.topics.generator.description": "Nosso gerador de tópicos de podcast gratuito permite que você encontre as melhores ideias de tópicos e prevê seu alcance potencial no Google e no YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Seu Assistente Virtual de Podcast",
        "podcast.virtual.assistant.description": "Assistente virtual de podcast com IA que escreve suas notas de programa e cria postagens para redes sociais. Otimize a produção e o marketing do seu podcast com o Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Preços",
        "pricing.description": "Gere notas de exibição, carimbos de data/hora, boletins informativos e muito mais para o seu podcast com um clique! Temos vários níveis de preços para atender às suas necessidades de podcasting."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Promova seu Podcast",
        "promote.your.podcast.description": "Gere notas do programa, postagens para redes sociais e clipes curtos para publicar e promover seu podcast em apenas alguns minutos."
      },
      "register": {
        "create.podsqueeze.account": "Criar uma Conta Podsqueeze",
        "generate.content.podcast": "Gere notas de episódio, timestamps, newsletters e mais para o seu podcast com um clique! Gere rapidamente conteúdo para o seu podcast e ajuste-o às suas necessidades. Inscrição gratuita."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Reaproveitar automaticamente o conteúdo do podcast",
        "repurpose.your.podcast.content.with.ai": "Reaproveite o conteúdo do seu podcast com IA. Gere automaticamente notas do programa, títulos, clipes curtos para TikTok e muito mais, tudo com um clique!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "Otimizador SEO de Podcast GRÁTIS",
        "seo.optimizer.description": "Analise e otimize seus episódios de podcast para melhor visibilidade nos motores de busca com recomendações SEO alimentadas por IA.",
        "seo.optimizer.heading": "Otimizador SEO de Podcast",
        "seo.optimizer.headingnote": "Analise e otimize seus episódios de podcast para melhor visibilidade nos motores de busca com recomendações SEO alimentadas por IA.",
        "seo.optimizer.selectEpisode": "Selecione um Episódio para Analisar",
        "seo.optimizer.results": "Resultados da Análise SEO",
        "seo.optimizer.searchPodcastPlaceholder": "Pesquisar por um podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Pesquisar episódios...",
        "seo.optimizer.analyseAnotherEpisode": "Analisar Outro Episódio",
        "seo.optimizer.findingEpisodes": "Encontrando todos os episódios...",
        "seo.optimizer.analysingEpisode": "Analisando Episódio",
        "seo.optimizer.scoreTooltip": "Pontuação:",
        "seo.optimizer.topKeywords": "Identificamos estas Palavras-chave Principais:",
        "seo.optimizer.topKeywordsnote": "Com base na análise de palavras-chave na parte inferior da página.",
        "seo.optimizer.optimizedContent": "Com base nas palavras-chave, aqui estão o título e descrição otimizados:",
        "seo.optimizer.originalTitle": "Título Original",
        "seo.optimizer.optimizedTitle": "Título Otimizado",
        "seo.optimizer.originalDescription": "Descrição Original",
        "seo.optimizer.optimizedDescription": "Descrição Otimizada",
        "seo.optimizer.showMore": "Mostrar Mais",
        "seo.optimizer.showLess": "Mostrar Menos",
        "seo.optimizer.keywordAnalysis": "Análise de Palavras-chave",
        "seo.optimizer.keywordAnalysisnote": "As pontuações são calculadas com base no volume de pesquisa, competição (quantos outros resultados existem para a mesma palavra-chave) e, no caso do YouTube, o número médio de visualizações por vídeo sob a mesma palavra-chave.",
        "seo.optimizer.seoScore": "Pontuação SEO",
        "seo.optimizer.spotifyScore": "Pontuação Spotify",
        "seo.optimizer.youtubeScore": "Pontuação YouTube",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Ferramenta de geração de conteúdo para podcasts com IA",
        "podsqueeze.description": "Gere notas de episódios, timestamps, newsletters e mais para o seu podcast com um clique! Gere rapidamente conteúdo para o seu podcast e ajuste-o às suas necessidades. Inscreva-se gratuitamente."
      },
      "thumbnail-creator": {
        "title": "Gerador Gratuito de Miniaturas de Podcast - Crie Miniaturas de Episódios com IA",
        "description": "Crie miniaturas impressionantes de podcast com IA. Gere arte visual profissional e atrativa para episódios que aumenta a visibilidade e atrai mais ouvintes para o seu podcast.",
        "selectPodcast": "Selecione Seu Podcast",
        "loadEpisodes": "Carregar Episódios",
        "selectEpisode": "Selecione Episódio para Criar Miniatura",
        "createThumbnail": "Criar Miniatura",
        "results": "Sua Miniatura Gerada",
        "download": "Baixar",
        "share": "Compartilhar",
        "regenerate": "Regenerar",
        "editThumbnail": "Editar Miniatura",
        "editPlaceholder": "Descreva como gostaria de modificar esta miniatura...",
        "customPrompt": "Prompt Personalizado",
        "yourThumbnail": "Sua Miniatura",
        "createAnother": "← Criar Outra Miniatura",
        "findingEpisodes": "Procurando episódios...",
        "searchPodcastPlaceholder": "Pesquise seu podcast...",
        "searchingPodcasts": "Pesquisando podcasts...",
        "heroDescription": "Gere miniaturas de podcast impressionantes e profissionais com design alimentado por IA que chama atenção e aumenta a visibilidade dos seus episódios.",
        "generatedWithPrompt": "Gerado com o prompt:",
        "customPromptPlaceholder": "Digite um prompt personalizado para geração de miniatura...",
        "generating": "Gerando...",
        "generate": "Gerar",
        "modernMinimalist": "Moderno e Minimalista",
        "vibrantDynamic": "Vibrante e Dinâmico",
        "professionalClean": "Profissional e Limpo",
        "generatingThumbnail": "Gerando miniatura...",
        "generatingNewThumbnail": "Gerando nova miniatura...",
        "showingFirstEpisodes": "Mostrando os primeiros 10 episódios. Use a pesquisa para encontrar episódios específicos.",
        "imageUrlCopied": "URL da imagem copiada para a área de transferência!",
        "failedToGenerate": "Falha ao gerar miniatura. Tente novamente.",
        "promotionalTitle": "Gere Notas do Show, Timestamps, Clipes Virais e Muito Mais Com Podsqueeze",
        "promotionalSubtitle": "Junte-se a outros 100K+ criadores e comece a crescer seu programa",
        "startNow": "Começar agora",
        "free": "GRÁTIS",
        "podcast": "PODCAST",
        "thumbnail": "MINIATURA",
        "creator": "CRIADOR",
        "replaceFace": "Substituir Rosto",
        "uploading": "Enviando...",
        "uploadImageError": "Por favor, envie um arquivo de imagem.",
        "uploadFailedError": "Falha ao enviar imagem. Tente novamente.",
        "uploadingImage": "Enviando imagem...",
        "generatingNewThumbnailLoading": "Gerando nova miniatura...",
        "failedToGenerateWithFace": "Falha ao gerar miniatura com substituição de rosto. Tente novamente."
      }
    },
    "podcastFolderCreateModal": {
      "create.new.podcast.folder": "Criar Nova Pasta de Podcast",
      "folder.name.placeholder": "Digite o nome da pasta",
      "create.button": "Criar"
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Carregando episódios...",
        "episodeList.noEpisodes": "Nenhum episódio público disponível",
        "episodeList.checkBack": "Volte mais tarde para novos episódios",
        "episodeList.title": "Episódios deste Podcast",
        "episodeList.readLess": "LER MENOS",
        "episodeList.readMore": "LER MAIS",
        "episodeList.coverImageAlt": "Capa de {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Começar",
        "alert.subscriptionRunning": "Sua assinatura atual ainda está ativa.\n\nPor favor, cancele sua assinatura atual antes de comprar uma nova.",
        "alert.subscriptionEnds": "Sua assinatura atual ainda está ativa.\n\nEla termina em {date}",
        "alert.subscriptionCancelled": "Sua assinatura já foi cancelada e terminará em {date}",
        "button.openDashboard": "Abrir Painel",
        "button.signUp": "Inscrever-se",
        "button.buySubscription": "Comprar Assinatura",
        "button.cancelled": "Cancelado",
        "button.cancelSubscription": "Cancelar Assinatura",
        "button.upgradeSubscription": "Atualizar Assinatura",
        "button.loading": "Carregando",
        "upgrade.details.currentMinutes": "Isso iniciará um novo período de assinatura. Você manterá todos os seus minutos atuais.",
        "upgrade.details.remainingAnnual": "Esse valor foi calculado com base no tempo restante da sua assinatura anual atual."
      },
      "page": {
        "pricing.free.title": "Gratuito",
        "pricing.free.subtitle": "Experimente o Podsqueeze. Sem necessidade de cartão de crédito.",
        "pricing.free.price.annual": "$0 Cobrado Anualmente",
        "pricing.free.features.podcast_time": "30 minutos de tempo de podcast por mês",
        "pricing.free.features.video_clips": "3 clipes de vídeo",
        "common.with_watermark": "com marca d'água",
        "pricing.free.features.quote_images": "Imagens de citação ilimitadas",
        "pricing.free.features.file_upload": "Upload de arquivos até 4Gb",
        "pricing.free.features.upload": "1 upload",
        "pricing.free.features.landing_pages": "Páginas de destino de podcast",
        "pricing.free.features.audio_enhancement": "Aprimoramento de áudio",
        "common.sign_up": "Inscrever-se",
        "common.open_dashboard": "Abrir Painel",
        "pricing.starter.title": "Iniciante",
        "pricing.starter.subtitle": "Perfeito para podcasters amadores que querem economizar tempo.",
        "pricing.starter.price.annual": "$132 Cobrado Anualmente",
        "pricing.billed_annually": "Cobrado Anualmente",
        "minutes.accumulate": "Minutos acumulados",
        "pricing.starter.features.podcast_time": "160 minutos de tempo de podcast por mês",
        "pricing.starter.features.video_clips": "10 clipes de vídeo ou audiogramas",
        "pricing.starter.features.quote_images": "Imagens de citação ilimitadas",
        "pricing.starter.features.file_upload": "Upload de arquivos até 4Gb",
        "pricing.starter.features.unlimited_uploads": "Uploads Ilimitados",
        "pricing.starter.features.landing_pages": "Páginas de destino de podcast",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Para profissionais que usam podcasting para desenvolver e apoiar seus negócios.",
        "pricing.pro.price.annual": "$324 Cobrado Anualmente",
        "pricing.pro.features.podcast_time": "320 minutos de tempo de podcast por mês",
        "pricing.pro.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.pro.features.video_clips": "20 clipes de vídeo ou audiogramas",
        "common.no_watermark": "sem marca d'água",
        "pricing.pro.features.quote_images": "Imagens de Citação Ilimitadas",
        "pricing.pro.features.file_upload": "Upload de arquivos até 10Gb",
        "pricing.pro.features.unlimited_uploads": "Uploads Ilimitados",
        "pricing.pro.features.landing_pages": "Páginas de destino de podcast",
        "common.customizable": "personalizável",
        "pricing.pro.features.audio_video_edit": "Edição Mágica de Áudio e Vídeo",
        "pricing.pro.features.everything_in_pro": "Tudo no Pro",
        "pricing.agency_lite.title": "Agência Lite",
        "pricing.agency_lite.subtitle": "Para agências de podcast que desejam otimizar e expandir seus negócios.",
        "pricing.agency_lite.price.annual": "$495 Cobrado Anualmente",
        "pricing.agency_lite.features.podcast_time": "600 minutos de tempo de podcast por mês",
        "pricing.agency_lite.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_lite.features.video_clips": "40 clipes de vídeo ou audiogramas",
        "pricing.agency_lite.features.quote_images": "Imagens de citação ilimitadas",
        "pricing.agency_lite.features.file_upload": "Upload de arquivos até 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Uploads Ilimitados",
        "pricing.agency_lite.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_lite.features.audio_video_edit": "Edição Mágica de Áudio e Vídeo",
        "pricing.agency_plus.title": "Agência Plus",
        "pricing.agency_plus.subtitle": "Para agências de podcast que desejam otimizar e expandir seus negócios.",
        "pricing.agency_plus.price.annual": "$1.251 Cobrado Anualmente",
        "pricing.agency_plus.features.podcast_time": "2000 minutos de tempo de podcast por mês",
        "pricing.agency_plus.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_plus.features.video_clips": "80 clipes de vídeo ou audiogramas",
        "pricing.agency_plus.features.quote_images": "Imagens de citação ilimitadas",
        "pricing.agency_plus.features.file_upload": "Upload de arquivos até 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Uploads Ilimitados",
        "pricing.agency_plus.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_plus.features.audio_video_edit": "Edição Mágica de Áudio e Vídeo",
        "pricing.agency_scale.title": "Agência Scale",
        "pricing.agency_scale.subtitle": "Para agências de podcast que desejam otimizar e expandir seus negócios.",
        "pricing.agency_scale.price.annual": "$2.175 Cobrado Anualmente",
        "pricing.agency_scale.features.podcast_time": "4000 minutos de tempo de podcast por mês",
        "pricing.agency_scale.features.personalize_ai_voice": "Personalizar voz de IA",
        "pricing.agency_scale.features.video_clips": "160 clipes de vídeo ou audiogramas",
        "pricing.agency_scale.features.quote_images": "Imagens de citação ilimitadas",
        "pricing.agency_scale.features.file_upload": "Upload de arquivos até 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Uploads Ilimitados",
        "pricing.agency_scale.features.landing_pages": "Páginas de destino de podcast",
        "pricing.agency_scale.features.audio_video_edit": "Edição Mágica de Áudio e Vídeo",
        "pricing.header": "Para podcasters solo e agências de podcast",
        "pricing.minutes_reset": "Você pode acumular até 3 vezes seus minutos mensais, desde que permaneça no seu plano atual ou faça upgrade.",
        "pricing.most_popular": "Mais popular",
        "pricing.minutes_per_month": "Minutos por mês",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Para agências e empresas de mídia que desejam escalar seu negócio.",
        "pricing.enterprise_price": "Personalizado",
        "pricing.enterprise_price_note": "Contate team@podsqueeze.com ou reserve uma demonstração abaixo.",
        "pricing.enterprise_feature_priority_support": "Suporte prioritário",
        "pricing.enterprise_feature_team_sits": "Sessões de equipe",
        "pricing.enterprise_personalized_team_training": "Onboarding e treinamento de equipe",
        "pricing.book_demo": "Reservar demonstração",
        "pricing.unlimited": "Ilimitado",
        "pricing.custom": "Personalizado"
      },
      "toggle": {
        "pay.monthly": "Mensal",
        "pay.annually": "Anual",
        "discount.30percent": "30% DESCONTO"
      },
      "upgradeModal": {
        "upgrade.success": "Sua assinatura foi atualizada com sucesso",
        "upgrade.error": "Desculpe, algo deu errado. Por favor, tente novamente mais tarde",
        "upgrade.loading": "Atualizando",
        "upgrade.confirmPay": "Confirmar e Pagar",
        "upgrade.cancel": "Cancelar",
        "coupon.placeholder": "Código do Cupom",
        "coupon.apply": "Aplicar",
        "coupon.have": "Eu tenho um cupom",
        "upgrade.confirmation": "Você está prestes a atualizar para",
        "upgrade.price": "Você pagará"
      }
    },
    "register": {
      "page": {
        "register.form": "Formulário de Registro"
      },
      "registerForm": {
        "error.invalidCredentials": "Por favor, insira um endereço de e-mail e senha válidos.",
        "error.weakPassword": "Por favor, use uma senha mais forte 💪",
        "error.emailInUse": "Usuário já existe",
        "error.userNotFound": "Usuário não encontrado",
        "error.generic": "Ops, algo deu errado",
        "placeholder.email": "Endereço de e-mail",
        "placeholder.password": "Senha",
        "button.registering": "Registrando...",
        "button.register": "Registrar",
        "label.newsletter": "Junte-se a 12.000 podcasters e inscreva-se em nossa newsletter para atualizações de produtos, dicas práticas, ebooks, sorteios e muito mais.",
        "label.alreadyHaveAccount": "Já tem uma conta?",
        "label.logInHere": "Faça login aqui",
        "label.or": "OU",
        "button.signingIn": "Entrando...",
        "button.continueWithGoogle": "Continuar com o Google",
        "label.podcastDescription": "Lance e cresça seu podcast de áudio ou vídeo sem esforço com tudo que você precisa em um só lugar.",
        "feature.transcripts": "Transcrições",
        "feature.showNotes": "Notas do Show",
        "feature.newslettersBlogs": "Newsletters & Blogs",
        "feature.socialPosts": "Postagens Sociais",
        "feature.shortClips": "Clipes Curtos & Audiogramas",
        "feature.podcastWebsite": "Website do Podcast",
        "feature.audioEnhancement": "Aprimoramento de Áudio com IA",
        "feature.removeSilences": "Remover silêncios e pausas"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "texto"
      },
      "TopicFinder": {
        "competition.veryHigh": "MUITO ALTO",
        "competition.high": "ALTO",
        "competition.medium": "MÉDIO",
        "competition.low": "BAIXO",
        "competition.veryLow": "MUITO BAIXO",
        "upgrade.button": "Atualizar para Pro",
        "clicks.label": "cliques",
        "searches.label": "pesquisas",
        "competition.label": "competição",
        "fetching.results": "Buscando Resultados",
        "table.topic": "Tópico",
        "tooltip.topic": "O principal tópico abordado pelo seu episódio de podcast",
        "table.monthlySearches": "Pesquisas Mensais",
        "tooltip.monthlySearches": "A faixa de pesquisas mensais no Google que você pode esperar",
        "table.competition": "Competição",
        "tooltip.competition": "O principal assunto ou tópico abordado pelo podcast.",
        "table.monthlyGoogleClicks": "Cliques Mensais no Google",
        "tooltip.monthlyGoogleClicks": "Uma previsão da faixa de cliques mensais no Google que você pode esperar",
        "table.youtubeReach": "Alcance no Youtube",
        "tooltip.youtubeReach": "Uma previsão do máximo de visualizações no Youtube que você pode esperar nos primeiros 6 meses, com base na média dos concorrentes",
        "intro.title": "Gerador de Tópicos de Podcast Gratuito",
        "intro.description": "Obtenha ideias de tópicos para o seu podcast que o público está pesquisando",
        "intro.check1": "Verifique a demanda por cada ideia de tópico no Google",
        "intro.check2": "Descubra quão competitiva é cada ideia de tópico de podcast",
        "intro.check3": "Estime os cliques no Google e as visualizações no YouTube que você pode obter",
        "upgrade.message": "Você precisa atualizar para Pro para acessar todos os resultados",
        "learnMore.label": "Saiba mais sobre o",
        "learnMore.link": "ferramenta geradora de tópicos de podcast gratuita",
        "newSearch.button": "Nova Pesquisa",
        "share.button": "Compartilhar Esta Pesquisa",
        "form.label": "Insira seus nichos de podcast",
        "form.placeholder": "Marketing Digital",
        "form.submit": "Encontrar Ideias de Tópicos"
      },
      "page": {
        "main.background": "fundo"
      },
      "shareTopics": {
        "share.results": "Compartilhar Resultados",
        "share.facebook": "Compartilhar no Facebook",
        "share.whatsapp": "Compartilhar no WhatsApp",
        "share.twitter": "Compartilhar no Twitter",
        "share.linkedin": "Compartilhar no LinkedIn",
        "copy.success": "Copiado",
        "copy.link": "Copiar Link"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "visualizações"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Não foi possível obter a composição atual",
        "error.addImage": "Erro ao adicionar elemento de imagem:",
        "alert.uploadImage": "Por favor, faça o upload de um arquivo de imagem.",
        "error.uploadImage": "Erro ao fazer upload da imagem:",
        "alert.uploadFailed": "Falha ao fazer upload da imagem. Por favor, tente novamente.",
        "error.getDownloadURL": "Erro ao obter a URL de download:",
        "alert.processImageFailed": "Falha ao processar a imagem enviada. Por favor, tente novamente.",
        "error.addText": "Erro ao adicionar elemento de texto:",
        "text.settingsPlaceholder": "As configurações serão exibidas quando o elemento estiver selecionado",
        "text.addElement": "Adicionar Elemento",
        "text.uploading": "Fazendo upload...",
        "button.uploadImage": "Fazer Upload da Imagem",
        "text.newText": "Novo Texto",
        "button.addText": "Adicionar Texto",
        "text.selectedElementSettings": "Configurações do Elemento Selecionado"
      },
      "FontSelector": {
        "allFonts": "Todas as fontes",
        "myFonts": "Minhas fontes",
        "uploadFont": "Carregar fonte",
        "noCustomFonts": "Ainda não há fontes personalizadas.",
        "uploadToAdd": "Carregue um arquivo de fonte para adicioná-lo à sua coleção.",
        "text_outline": "Contorno do texto",
        "outline_color": "Cor do contorno",
        "outline_width": "Espessura do contorno"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Ajustar",
        "imageLayoutSettings.zoom": "Zoom",
        "imageLayoutSettings.horizontalAlignment": "Alinhamento Horizontal",
        "imageLayoutSettings.verticalAlignment": "Alinhamento Vertical",
        "imageLayoutSettings.deleteElement": "Excluir Elemento"
      },
      "TemplateBox": {
        "confirm.delete.template": "Você tem certeza de que deseja excluir este modelo?"
      },
      "TextSettings": {
        "error.getting_current_text": "Erro ao obter o texto atual:",
        "event.delete_text_element_clicked": "Elemento de Texto Deletado Clicado",
        "error.changing_text_font": "Erro ao mudar a fonte do texto:",
        "event.text_font_changed": "Fonte do Texto Mudada",
        "error.changing_text_size": "Erro ao mudar o tamanho do texto:",
        "event.text_size_changed": "Tamanho do Texto Mudado",
        "error.changing_text_color": "Erro ao mudar a cor do texto:",
        "event.text_color_changed": "Cor do Texto Mudada",
        "event.text_content_added": "Conteúdo de Texto Adicionado",
        "error.adding_text_content": "Erro ao adicionar conteúdo de texto:",
        "event.text_content_updated": "Conteúdo de Texto Atualizado",
        "label.text_content": "Conteúdo do Texto",
        "label.text_font": "Fonte do Texto",
        "label.text_font_weight": "Peso da Fonte",
        "label.adjust_text_size": "Ajustar Tamanho do Texto",
        "label.text_color": "Cor do Texto",
        "button.delete": "Deletar"
      },
      "audiogramBaseTemplate": {
        "color.white": "Branco",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "urlDoEpisódioPadrão",
        "time.0s": "0 s",
        "font.inter": "Inter",
        "duration.1s": "1 s",
        "easing.quadraticOut": "quadrático-para-fora",
        "animation.fade": "desvanecer",
        "type.text": "texto",
        "name.podcastTitle": "TítuloDoPodcast",
        "name.snippetTitle": "TítuloDoTrecho",
        "type.image": "imagem",
        "name.audioBackgroundImage": "ImagemDeFundoDeÁudio",
        "name.subtitlesText": "textoDasLegendas",
        "effect.highlight": "destaque",
        "type.audio": "áudio",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "títuloDoTrecho",
        "podcast.title": "títuloDoPodcast",
        "new.episode": "NOVO EPISÓDIO"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Branco",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "urlDoEpisodioPadrão",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "música_de_fundo",
        "audio.type": "áudio"
      },
      "imageElement": {
        "upload.image.error": "Por favor, faça o upload de um arquivo de imagem.",
        "upload.file.loading": "Fazendo upload do arquivo. Por favor, não feche esta janela.",
        "upload.image.label": "Substituir imagem",
        "ai.prompt.label": "Digite um prompt para a IA gerar uma imagem",
        "ai.prompt.placeholder": "Ex: Um cachorro correndo no parque...",
        "ai.processing": "Processando...",
        "ai.create": "Criar",
        "customize.image.title": "Personalizar Imagem",
        "enter.image.url": "Digite a URL da Imagem",
        "or": "ou"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Erro ao buscar templates:",
        "template.savedSuccessfully": "Template salvo com sucesso",
        "error.savingTemplate": "Erro ao salvar template:",
        "loading.savedTemplates": "Carregando templates salvos...",
        "no.savedTemplates": "Nenhum template salvo",
        "select_template": "Selecionar Template",
        "saving.template": "Salvando template...",
        "template_name": "Nome do Template",
        "enter.templateName": "Digite o nome do template",
        "cancel": "Cancelar",
        "save": "Salvar",
        "default_templates": "Templates Padrão",
        "saved_templates_count": "Templates Salvos ({count})",
        "folder_templates_count": "Templates de Pasta ({count})",
        "account_templates_count": "Templates de Conta ({count})",
        "save_current_template": "Salvar Template Atual"
      },
      "subtitlesElement": {
        "edit.word": "Editar Palavra",
        "edit.label": "editar",
        "remove.word.subtitle": "Remover palavra apenas do Subtítulo",
        "erase.subtitle": "apagar do subtítulo",
        "remove.word.clip": "Remover palavra do Áudio e do Subtítulo",
        "remove.clip": "remover do clipe"
      },
      "utils": {
        "video.utils.title": "Título",
        "video.utils.currentTime": "Hora Atual",
        "video.utils.nextTime": "Próxima Hora",
        "video.utils.duration": "Duração",
        "video.utils.description": "Descrição",
        "video.utils.srtSegment": "Segmento SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Seu texto de legenda aqui"
      }
    }
  },
  "ru": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "СТАНЬТЕ НАШИМ ПАРТНЁРОМ",
        "SHARE_PODSQUEEZE": "Поделитесь Podsqueeze с вашей аудиторией",
        "AND_EARN_MONEY": "и зарабатывайте деньги!",
        "LAST_UPDATED": "Последнее обновление: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Станьте Партнёром по Аффилиации",
        "EARN_COMMISSION": "Зарабатывайте",
        "COMMISSION": "комиссию",
        "ON_EVERY_SALE": "с каждой продажи, сделанной через вашу эксклюзивную реферальную ссылку в течение 15 месяцев. Поделитесь своей ссылкой на своем веб-сайте, в социальных сетях или с друзьями. Присоединение занимает всего несколько секунд.",
        "GET_AUTOMATICALLY_APPROVED": "Получите автоматическое одобрение.",
        "JOIN_NOW": "Присоединяйтесь сейчас",
        "HOW_IT_WORKS": "КАК ЭТО РАБОТАЕТ",
        "FREQUENTLY_ASKED_QUESTIONS": "Часто задаваемые вопросы",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Кто такой Партнёр по Аффилиации?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Партнёр по Аффилиации - это человек, который продвигает продукты или услуги другой компании через уникальную реферальную ссылку и получает комиссию с каждой продажи, совершённой через эту ссылку.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Как я могу стать Партнёром по Аффилиации?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Стать Партнёром по Аффилиации быстро и легко, это занимает всего несколько секунд. Чтобы начать, просто нажмите кнопку 'Присоединяйтесь сейчас' и зарегистрируйтесь, используя свою электронную почту. После регистрации у вас будет доступ к удобной панели управления, где вы найдете свою уникальную реферальную ссылку. Поделитесь этой ссылкой со своей семьей, друзьями или онлайн-аудиторией. Каждый раз, когда кто-то кликает на вашу реферальную ссылку и совершает покупку на сайте Podsqueeze, вы зарабатываете 25% комиссии с каждого платежа в течение целых 15 месяцев! Отслеживайте свои доходы без труда через свою панель Партнёра, которая предоставляет четкий обзор всех совершённых продаж.",
        "HOW_CAN_I_TRACK_MY_SALES": "Как я могу отслеживать свои продажи и комиссионные?",
        "TRACKING_SALES_DESCRIPTION": "Используйте нашу панель программы аффилиации, чтобы отслеживать свои продажи и комиссионные. Программное обеспечение для отслеживания доступно как для Партнёров по Аффилиации, так и для Бизнес-Партнёров.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Когда и как я получу оплату?",
        "PAYMENT_DESCRIPTION": "Вы будете получать оплату через PayPal каждые 30 дней. Обратите внимание, что существует минимальный порог выплаты в размере 50 долларов. Как только вы достигнете этой суммы, вы можете ожидать, что ваша оплата будет поступать точно каждые 30 дней.",
        "STILL_GOT_QUESTIONS": "ЕЩЁ ОСТАЛИСЬ ВОПРОСЫ?",
        "SEND_US_A_MESSAGE": "Отправьте нам сообщение в чате поддержки или напишите нам на team@podsqueeze.com",
        "NOTE": "Примечание",
        "AFFILIATE_ADS_RESTRICTION": "Партнёрам по Аффилиации запрещено создавать рекламу в Google или участвовать в аукционах на ключевые слова, связанные с Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Условия использования для Партнёров по Аффилиации",
        "CAN_I_RUN_ADS": "Могу ли я запускать рекламу и кампании CPC в Google, чтобы продвигать свою реферальную ссылку?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Партнёрам по Аффилиации строго запрещено создавать рекламу в поисковых системах или участвовать в аукционах на ключевые слова, связанные с Podsqueeze. Это ограничение помогает сохранить целостность нашей рекламной стратегии и обеспечивает согласованность сообщений бренда. Обратите внимание, что продажи, совершенные в результате таких аукционных кампаний, не подлежат оплате.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Как Podsqueeze генерирует заголовки для вашего подкаста?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Навигационная панель",
        "main.affiliateHero": "Партнёрский герой",
        "main.footer": "Футер"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Добавить Вступительную и Завершающую Музыку",
        "intro.music": "Вступительная Музыка",
        "outro.music": "Завершающая Музыка",
        "intro.duration": "Длительность Вступления",
        "outro.duration": "Длительность Завершения",
        "intro.mode": "Режим Вступления",
        "outro.mode": "Режим Завершения",
        "cancel": "Отмена",
        "save": "Сохранить",
        "apply": "Применить",
        "current.intro.music": "Текущая Вступительная Музыка",
        "current.outro.music": "Текущая Завершающая Музыка",
        "change.music": "Изменить Музыку",
        "choose.music": "Выбрать Музыкальный Файл",
        "browser.not.support.audio": "Ваш браузер не поддерживает аудио элемент.",
        "save.and.apply": "Сохранить и Применить",
        "no.music.selected": "Музыка не выбрана",
        "delete.music": "Удалить музыку",
        "uploading.file": "Загрузка файла..."
      },
      "audioEditElements": {
        "error.processing.rss": "У нас возникли некоторые трудности с обработкой RSS-каналов. Пожалуйста, загрузите файл.",
        "edit.enhance.audio": "Редактируйте и улучшайте свою аудиозапись",
        "trial.label": "Пробный период",
        "audio.editing.experience": "Испытайте бесшовное редактирование аудио с помощью современных алгоритмов ИИ для естественных, качественных результатов всего одним кликом.",
        "improve.audio.quality": "Улучшить качество аудио",
        "remove.hums.silences": "Удалить гудения и тишину",
        "upgrade.edit.audio": "Обновите, чтобы редактировать ваше аудио одним кликом",
        "available.plans": "Доступно для всех планов",
        "upgrade.now": "Обновить сейчас",
        "audio.element.support": "Ваш браузер не поддерживает аудиоэлемент.",
        "download.audio": "Скачать аудио",
        "loading.audio": "Загрузка аудио",
        "editing.audio": "Редактирование аудио"
      },
      "videoEditElements": {
        "error.exporting.video": "Ошибка при экспорте видео",
        "download.failed": "Ошибка загрузки: {error.message}",
        "generating.video": "Генерация видео",
        "error.generating.clip": "Ошибка при генерации клипа",
        "please.retry.support": "Пожалуйста, повторите попытку или свяжитесь с нашей службой поддержки",
        "browser.not.support.video": "Ваш браузер не поддерживает тег видео.",
        "this.might.take.minutes": "Пожалуйста, не закрывайте окно, это может занять несколько минут.",
        "exporting.video": "Экспорт вашего видео...",
        "seamless.audio.editing": "Используйте бесшовное редактирование аудио с помощью современных алгоритмов ИИ для естественных, качественных результатов всего одним кликом.",
        "difficulties.processing.rss": "У нас возникли некоторые трудности с обработкой некоторых RSS-лент. Пожалуйста, загрузите файл.",
        "edit.enhance.video.recording": "Редактируйте и улучшайте свою видеозапись",
        "trial": "Пробный период",
        "enhance.audio.quality": "Улучшить качество аудио",
        "enhance.audio.quality.edit": "Улучшить качество аудио и редактировать",
        "trim.filler.words.video": "Удалить заполнительные слова из видео (например, мычание)",
        "trim.long.silences.video": "Удалить длинные паузы из видео",
        "upgrade.to.edit.video": "Обновите, чтобы иметь возможность редактировать ваше видео одним кликом",
        "available.pro.agency.plans": "Доступно для профессиональных и агентских планов",
        "upgrade.now": "Обновить сейчас",
        "download.only.audio": "Скачать только аудио",
        "download.video": "Скачать видео",
        "please.dont.close.window": "Пожалуйста, не закрывайте окно",
        "export.video": "Экспортировать видео"
      },
      "videogramBaseTemplate": {
        "media.fit": "покрытие",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "медиа"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Другие эпизоды этого подкаста",
        "tab.shownotes": "Заметки к выпуску",
        "tab.timestamps": "Временные метки",
        "tab.blogpost": "Запись в блоге",
        "tab.transcript": "Расшифровка",
        "key.points": "Ключевые моменты"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Ваша целевая страница активна в нашем поисковике подкастов. Поделитесь ею с вашей аудиторией!",
        "landingPage.create": "Создайте красивую целевую страницу для этого эпизода",
        "landingPage.edit": "Редактировать страницу",
        "landingPage.visit": "Посетить страницу",
        "landingPage.delete": "Удалить страницу",
        "landingPage.createButton": "Создать целевую страницу"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Управление ссылками на эпизоды",
        "youtube.link": "Ссылка на YouTube",
        "enter.youtube.link": "Введите ссылку на YouTube",
        "apple.podcasts.link": "Ссылка на Apple Podcasts",
        "enter.apple.podcasts.link": "Введите ссылку на Apple Podcasts",
        "spotify.link": "Ссылка на Spotify",
        "enter.spotify.link": "Введите ссылку на Spotify",
        "saving": "Сохранение...",
        "save": "Сохранить",
        "social.links.updated.successfully": "Социальные ссылки успешно обновлены!"
      },
      "affiliatesection": {
        "affiliate.section.title": "СТАНЬТЕ ПАРТНЁРОМ ПО ПРОГРАММЕ АФФИЛИРОВАНИЯ",
        "affiliate.section.subtitle": "Поделитесь Podsqueeze с вашей аудиторией и",
        "affiliate.section.earn": "зарабатывайте деньги!",
        "affiliate.section.commission": "Наша партнерская программа предлагает 25% комиссию на протяжении 15 месяцев за каждую продажу и продление подписки.",
        "affiliate.section.join": "Присоединиться можно за считанные секунды!",
        "affiliate.section.knowMore": "Узнать больше"
      },
      "asseenon": {
        "podnews.logo": "логотип podnews",
        "transistor.logo": "логотип transistor",
        "thepodcasthost.logo": "логотип the podcast host",
        "schoolofpodcasting.logo": "логотип Школы подкастинга",
        "semrush.logo": "логотип semrush"
      },
      "assembleshownotes": {
        "episode.description": "Описание эпизода",
        "bullet.points": "Основные моменты",
        "timestamps": "Временные метки",
        "links.and.mentions": "Ссылки и упоминания",
        "extra.content": "Дополнительный контент",
        "assemble.show.notes": "Соберите свои заметки к шоу",
        "downloading": "Загрузка",
        "copied": "Скопировано",
        "enter.placeholder": "Введите {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Взять паузу от подкастинга",
        "cancellation.option.no_recurrent": "Я не хочу подписку с автоматическим продлением",
        "cancellation.option.expensive": "Это слишком дорого",
        "cancellation.option.not_saving_time": "Не экономит мне достаточно времени",
        "cancellation.option.dissatisfied_content": "Не удовлетворен качеством создаваемого контента",
        "cancellation.option.unresponsive_support": "Неотзывчивая служба поддержки",
        "cancellation.option.not_using": "Недостаточно использую сервис",
        "cancellation.option.difficulty_navigating": "Трудности в использовании/навигации по продукту",
        "cancellation.option.better_alternative": "Нашел лучший альтернативный продукт",
        "cancellation.option.other": "Другое",
        "cancellation.video.message": "70% наших пользователей прекращают процесс отмены после просмотра этого видео",
        "cancellation.button.cancel": "Я все еще хочу отменить",
        "cancellation.button.try_again": "Я хочу попробовать еще раз",
        "cancellation.prompt.select_reason": "Пожалуйста, помогите нам улучшить продукт, выбрав причину отмены вашей подписки:",
        "cancellation.placeholder.answer": "Введите ваш ответ здесь...",
        "cancellation.placeholder.specify_reason": "Пожалуйста, уточните вашу причину отмены",
        "cancellation.button.next": "Далее",
        "cancellation.button.go_back": "Назад",
        "cancellation.last_question.title": "Последний вопрос с нашей стороны",
        "lose.all.accumulated.minutes": "Если вы отмените, вы потеряете все накопленные минуты.",
        "convert.and.repurpose.episodes": "Преобразовать и переработать старые эпизоды в свежий контент",
        "generate.articles.favorite.podcasts.and.vides": "Создать статьи из ваших любимых подкастов",
        "share.your.account.with.a.friend": "Поделиться своим аккаунтом с другом, который может получить пользу",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Вот видео, показывающее, как максимально использовать Podsqueeze",
        "keep.accumulating.minutes": "Продолжать накапливать минуты, чтобы использовать при следующем возвращении к подкасту",
        "here.are.some.ideas": "Вот несколько идей, которые помогут вам продолжать получать пользу от Podsqueeze",
        "cancellation.last_question.prompt": "Какие изменения или улучшения заставили бы вас рассмотреть возможность повторного присоединения к нашему сервису?",
        "cancellation.feedback.message": "Ваши отзывы помогут нам улучшиться 🙏",
        "cancellation.button.confirm": "Подтвердить отмену",
        "cancellation.minutes.accumulated": "У вас есть",
        "cancellation.minutes.accumulated.suffix": "накопленных минут стоимостью",
        "cancellation.reminder.text": "Пожалуйста, помните:",
        "cancellation.minutes.warning": "Накопленные минуты - это привилегия для активных подписок. Отменив подписку, ваши минуты будут безвозвратно потеряны.",
        "cancellation.content.deletion.warning": "Весь ваш сгенерированный контент будет безвозвратно удален через 30 дней.",
        "cancellation.minutes.left.title": "У Вас Еще Остались Минуты! Не Позволяйте Им Пропасть!",
        "cancellation.suggestion.clips": "Переработайте старые эпизоды в клипы для социальных сетей",
        "cancellation.suggestion.articles": "Превратите старые эпизоды в статьи с Podsqueeze для SEO-преимуществ.",
        "cancellation.suggestion.linkedin": "Превратите старые авторитетные эпизоды в посты LinkedIn для укрепления личного бренда",
        "cancellation.suggestion.share": "Поделитесь своим аккаунтом Podsqueeze с другом, чтобы он мог воспользоваться вашими неиспользованными минутами.",
        "cancellation.button.keep.subscription": "Сохранить Мою Подписку",
        "cancellation.button.keep.minutes": "Сохранить Мои",
        "cancellation.button.keep.minutes.suffix": "Стоимости в Минутах",
        "cancellation.lifetime.before_you_go": "Прежде чем уйти...",
        "cancellation.lifetime.title": "Как насчет пожизненного доступа всего за $49?",
        "cancellation.lifetime.subtitle": "Сохраните свой аккаунт Starter. Никаких подписок. Никаких продлений. Только ваш — навсегда.",
        "cancellation.lifetime.feature1": "Пожизненный доступ к Podsqueeze за единовременный платеж $49",
        "cancellation.lifetime.feature2": "Используйте когда нужно, без давления — это ваше навсегда",
        "cancellation.lifetime.feature3": "Включает все текущие и будущие функции Плана Starter",
        "cancellation.lifetime.button_cancel": "Я все еще хочу отменить",
        "cancellation.lifetime.button_deal": "Получить пожизненную сделку",
        "cancellation.downgrade.title": "Сохраните весь свой контент всего за $5.99/месяц",
        "cancellation.downgrade.subtitle": "Переходя на Starter вы сможете...",
        "cancellation.downgrade.feature1": "Сохранить весь ваш сгенерированный контент",
        "cancellation.downgrade.feature2": "Поддерживать работу ваших веб-сайтов",
        "cancellation.downgrade.feature3": "160 минут и 10 клипов в месяц для случайной работы",
        "cancellation.billing.monthly": "Ежемесячно",
        "cancellation.billing.annual": "Ежегодно",
        "cancellation.billing.discount": "30% СКИДКА",
        "cancellation.plan.starter": "План Starter",
        "cancellation.price.monthly": "$8.99/месяц",
        "cancellation.price.annual": "$5.99/месяц",
        "cancellation.price.annual_billing": "к оплате $71.88 ежегодно",
        "cancellation.feature.minutes": "160 мин/месяц",
        "cancellation.feature.clips": "10 клипов/месяц",
        "cancellation.downgrade.button": "Перейти на Starter и Сохранить Контент",
        "cancellation.error.payment_link": "Не удалось получить ссылку на оплату. Попробуйте еще раз.",
        "cancellation.error.payment_service": "Ошибка подключения к платежному сервису.",
        "cancellation.option.question.break": "Можете ли вы рассказать нам больше о том, почему делаете перерыв?",
        "cancellation.option.question.no_recurrent": "Могли бы вы поделиться, почему предпочитаете не иметь повторяющуюся подписку?",
        "cancellation.option.question.expensive": "Какие цены или функции сделали бы сервис более ценным для вас?",
        "cancellation.option.question.not_saving_time": "Что все еще отнимает у вас много времени в вашем процессе?",
        "cancellation.option.question.dissatisfied_content": "Какими аспектами контента вы были недовольны?",
        "cancellation.option.question.unresponsive_support": "Можете ли вы описать ваш опыт работы с нашей службой поддержки?",
        "cancellation.option.question.not_using": "Есть ли что-то, что побудило бы вас использовать сервис чаще?",
        "cancellation.option.question.difficulty_navigating": "С какими трудностями вы столкнулись при использовании/навигации по продукту?",
        "cancellation.option.question.better_alternative": "Какой альтернативный продукт вы нашли и что вам в нем нравится?",
        "cancellation.option.question.other": "Пожалуйста, укажите причину отмены:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Мы ценим вашу конфиденциальность",
        "cookiebanner.cookieUsage": "Мы используем файлы cookie для улучшения вашего опыта на сайте и анализа нашего трафика. Нажимая 'Принять', вы соглашаетесь на использование файлов cookie.",
        "cookiebanner.privacyPolicy": "Политика конфиденциальности",
        "cookiebanner.accept": "Принять",
        "cookiebanner.decline": "Отклонить"
      },
      "episodeTitleBox": {
        "loading": "Загрузка...",
        "editEpisodeTitleClicked": "Нажата кнопка редактирования названия эпизода",
        "newEpisodeTitleStored": "Новое название эпизода сохранено"
      },
      "famewall": {
        "loading.message": "Загрузка..."
      },
      "footer": {
        "footer.features": "Функции",
        "footer.transcriptGenerator": "Генератор транскрипций",
        "footer.subtitlesGenerator": "Генератор субтитров",
        "footer.descriptionGenerator": "Генератор описаний",
        "footer.podcastSummarizer": "Генератор резюме подкастов",
        "footer.titlesGenerator": "Генератор заголовков",
        "footer.bulletPointsGenerator": "Генератор маркерных пунктов",
        "footer.chaptersClipsGenerator": "Генератор глав и клипов",
        "footer.socialMediaPostsGenerator": "Генератор постов для социальных сетей",
        "footer.newsletterGenerator": "Генератор новостных рассылок",
        "footer.blogPostGenerator": "Генератор блог-постов",
        "footer.podcastLandingPages": "Целевые страницы подкастов",
        "footer.podcastClipMaker": "Создатель клипов подкастов",
        "footer.audiogramGenerator": "Генератор аудиограмм",
        "footer.aiAudioEnhancer": "Улучшение аудио с помощью ИИ",
        "footer.convertYoutubeToText": "Конвертировать Youtube в текст",
        "footer.youtubeVideoNoiseRemover": "Удаление шума из видео на Youtube",
        "footer.youtubeVideoKeyPoints": "Ключевые моменты видео на Youtube",
        "footer.freeResources": "Бесплатные ресурсы",
        "footer.findPodcastTopicIdeas": "Найдите идеи для тем подкастов",
        "footer.articles": "Статьи",
        "footer.freeEbooks": "Бесплатные электронные книги",
        "footer.community": "Сообщество",
        "footer.ourPodcast": "Наш подкаст",
        "footer.product": "Продукт",
        "footer.giftCard": "Подарочная карта",
        "footer.onboardingEbook": "Электронная книга по введению",
        "footer.pricing": "Цены",
        "footer.affiliates": "Партнеры",
        "footer.media": "Медиа",
        "footer.testimonials": "Отзывы",
        "footer.legal": "Юридическая информация",
        "footer.privacyPolicy": "Политика конфиденциальности",
        "footer.termsOfUse": "Условия использования",
        "footer.refundPolicy": "Политика возврата",
        "footer.allRightsReserved": "Все права защищены."
      },
      "globalState": {
        "cookie.enabled": "Файлы cookie включены",
        "language.default": "Язык по умолчанию"
      },
      "head": {
        "keywords.list": "Podsqueeze, ИИ, Подкасты, Генерация контента, Транскрипция подкастов, Шоуноты, Временные метки, Подкаст-рассылки, Твиты, Блог-посты, Социальные посты, Заголовки, Автор шоунотов"
      },
      "imageResultModal": {
        "download.image": "Скачать изображение",
        "generating.image": "Генерация изображения",
        "ai.prompt.label": "Введите запрос для генерации изображения ИИ",
        "ai.prompt.placeholder": "Например: Собака, бегущая в парке...",
        "processing": "Обработка...",
        "create": "Создать",
        "text.color.label": "Цвет текста",
        "quote.icon.color.label": "Цвет иконки цитаты",
        "background.color.label": "Цвет фона",
        "font.label": "Шрифт",
        "upload.cover.image": "Загрузить обложку",
        "aspect.ratio.info": "Соотношение сторон 1:1, рекомендуемый размер 1200x1200",
        "upload.logo.label": "Загрузить логотип",
        "choose.file": "Выбрать файл",
        "upload.success": "Успешно загружено",
        "choose.quote": "Выбрать цитату",
        "select.template": "Выбрать шаблон",
        "quote.label": "Цитата",
        "enter.quote.here": "Введите цитату здесь",
        "author.label": "Автор",
        "enter.author.name": "Введите имя автора",
        "podcast.name.label": "Название подкаста",
        "enter.podcast.name": "Введите название подкаста",
        "colors": "Цвета",
        "select.font": "Выбрать шрифт",
        "cover.logo.images": "Изображения обложки и логотипа",
        "logo.image": "Логотип изображение",
        "upgrade.here": "Обновить здесь",
        "remove.logo": "Удалить логотип Podsqueeze",
        "default_templates": "Шаблоны по умолчанию",
        "saved_templates_count": "Сохраненные шаблоны",
        "save_current_template": "Сохранить текущий шаблон",
        "no_saved_templates": "Пока нет сохраненных шаблонов",
        "save_template": "Сохранить шаблон",
        "cancel": "Отмена",
        "save": "Сохранить",
        "enter_template_name": "Введите название шаблона",
        "reset_template": "Сбросить",
        "add_element": "Добавить элемент",
        "generate": "Создать",
        "add_image": "Добавить изображение",
        "upload_image": "Загрузить изображение",
        "or": "или",
        "generate_with_ai": "Создать с помощью ИИ",
        "search_fonts": "Поиск шрифтов...",
        "upload_logo": "Загрузить логотип",
        "square_image_recommended": "Рекомендуется квадратное изображение",
        "opacity": "Прозрачность",
        "layers": "Слои",
        "no_element_selected": "Элемент не выбран",
        "bold_shortcut": "Жирный (Ctrl+B)",
        "italic_shortcut": "Курсив (Ctrl+I)",
        "underline_shortcut": "Подчеркнутый (Ctrl+U)",
        "edit_text": "Редактировать текст",
        "tint_color": "Цвет оттенка",
        "toggle_gradient_transparent": "Переключить градиент на прозрачный",
        "rotate_gradient": "Повернуть градиент на 45 градусов",
        "alt_background": "Фон",
        "alt_podcast_logo": "Логотип подкаста",
        "alt_custom": "Пользовательский",
        "alt_right_side": "Правая сторона",
        "alt_profile": "Профиль"
      },
      "intentModal": {
        "intentModal.title": "Что вы хотите сделать с Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Написать заметки к шоу",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Написать блог-пост и рассылку",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Создать видеоклипы или аудиограммы",
        "intentModal.sourceOption.Create_Quote_Images": "Создать изображения с цитатами",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Редактировать и улучшать аудио/видео",
        "intentModal.sourceOption.Transcribe": "Транскрибировать",
        "intentModal.sourceOption.Create_a_Website": "Создать веб-сайт",
        "intentModal.sourceOption.All_of_the_Above": "Все вышеперечисленное",
        "intentModal.sourceOption.Other": "Другое",
        "intentModal.otherPlaceholder": "Пожалуйста, уточните",
        "intentModal.submitButton": "Отправить и зарегистрироваться",
        "intentModal.skip": "Пропустить"
      },
      "languageSwitcher": {
        "language.en": "Английский",
        "language.es": "Испанский",
        "language.fr": "Французский",
        "language.de": "Немецкий",
        "language.it": "Итальянский",
        "language.pt": "Португальский",
        "language.nl": "Нидерландский",
        "language.pl": "Польский",
        "language.ru": "Русский",
        "language.zh": "Китайский",
        "language.ja": "Японский",
        "language.ko": "Корейский",
        "language.ar": "Арабский",
        "language.th": "Тайский",
        "language.vi": "Вьетнамский"
      },
      "lazyImage": {
        "lazyImage.alt": "Описание изображения"
      },
      "metadata": {
        "meta.title": "Название вашей страницы",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Утилита"
      },
      "navbar": {
        "navbar.dashboard": "Панель управления",
        "navbar.login": "Войти",
        "navbar.openMenu": "Открыть главное меню",
        "navbar.features": "Функции",
        "navbar.resources": "Ресурсы",
        "navbar.pricing": "Цены",
        "navbar.contact": "Контакт",
        "navbar.topPodcasts": "Топ подкасты",
        "navbar.seeAllFeatures": "Посмотреть все функции",
        "navbar.mainFeatures": "ОСНОВНЫЕ ФУНКЦИИ",
        "navbar.podcastTranscription": "Генератор транскрипции подкастов и видео",
        "navbar.transcriptionDescription": "Высокоточная транскрипция с маркировкой спикеров и SRT-файл для субтитров.",
        "navbar.podcastSummarizer": "Сумматор подкастов",
        "navbar.summarizerDescription": "Создавайте полные заметки к шоу в 20 раз быстрее, своим голосом.",
        "navbar.podcastClipMaker": "Создатель клипов подкастов",
        "navbar.clipMakerDescription": "Автоматически генерируйте короткие клипы или аудиограммы для вашего подкаста.",
        "navbar.audioEnhancer": "Улучшитель звука Ai",
        "navbar.audioEnhancerDescription": "Автоматически улучшайте звук, удаляйте паузы и лишние слова.",
        "navbar.podsqueezeFeaturesWalkthrough": "ПОДСКУЗ ФУНКЦИИ: ПОШАГОВОЕ РУКОВОДСТВО",
        "navbar.blog": "Блог",
        "navbar.blogDescription": "Практические статьи и руководства для запуска и развития успешного подкаста.",
        "navbar.podcastTopicIdeas": "Идеи тем для подкастов",
        "navbar.topicIdeasDescription": "Откройте для себя темы подкастов, которые ищут аудитории.",
        "navbar.actionableEbooks": "Практичные eBook",
        "navbar.ebooksDescription": "Скачайте бесплатные eBook с практическими советами для выведения вашего подкаста на новый уровень.",
        "navbar.freeThumbnailMaker": "Бесплатный Создатель Миниатюр Подкастов",
        "navbar.freeThumbnailMakerDescription": "Создавайте профессиональные, привлекательные миниатюры эпизодов с ИИ.",
        "navbar.seoOptimizer": "SEO Оптимизатор",
        "navbar.seoOptimizerDescription": "Оптимизируйте ваши эпизоды подкаста для лучшей видимости в поисковых системах.",
        "navbar.podcastDescription": "Слушайте наш подкаст, где мы берем интервью у опытных подкастеров и пользователей Podsqueeze со всего мира. Мы просим их поделиться своими советами, идеями, историями и всем, что вам нужно знать для развития собственного подкаста."
      },
      "resultModal": {
        "prompt.transcript.quote": "Цитата",
        "prompt.transcript.blog": "Блог",
        "prompt.transcript.tweets": "Твиты",
        "prompt.shownotes.firstPerson": "Шоноты от первого лица",
        "prompt.shownotes.replaceName": "Заменить имя в шонотах",
        "prompt.shownotes.friendlyTone": "Шоноты в дружелюбном тоне",
        "prompt.shownotes.youtubeDescription": "Описание YouTube в шонотах",
        "prompt.shownotes.engagingQuestion": "Вовлекающий вопрос в шонотах",
        "prompt.timestamps.formatAsChapters": "Форматировать временные метки как главы с описаниями",
        "prompt.timestamps.detailedDescriptions": "Создавать подробные описания временных меток",
        "prompt.timestamps.improveSpeakerNames": "Заменить имена спикеров на более описательные, например, 'Вопрошающий', 'Эксперт' или 'Гость'",
        "prompt.newsletter.casualTone": "Неформальный тон рассылки",
        "prompt.newsletter.shorter": "Краткая рассылка",
        "prompt.newsletter.contentSections": "Секции контента в рассылке",
        "prompt.newsletter.changeName": "Изменить имя в рассылке",
        "prompt.mentions.fullURL": "Полный URL в упоминаниях",
        "prompt.mentions.replaceName": "Заменить имя в упоминаниях",
        "prompt.tweets.underdogTone": "Твиты в тоне аутсайдера",
        "prompt.tweets.firstPerson": "Твиты от первого лица",
        "prompt.shortPost.relevantEmojis": "Соответствующие эмодзи в коротком посте",
        "prompt.shortPost.educationalTone": "Образовательный тон короткого поста",
        "prompt.shortPost.underdogTone": "Тон аутсайдера в коротком посте",
        "prompt.shortPost.firstPerson": "Короткий пост от первого лица",
        "prompt.titles.youtubeOptimized": "Оптимизированные для YouTube заголовки",
        "prompt.titles.startWithHowTo": "Начать с заголовков 'Как сделать'",
        "prompt.titles.otherOptions": "Другие варианты заголовков",
        "prompt.keywords.youtubeOptimized": "Оптимизированные для YouTube ключевые слова",
        "prompt.keywords.separateWithCommas": "Разделяйте ключевые слова запятыми",
        "prompt.quotes.lorem1": "Цитата Lorem ipsum 1",
        "prompt.quotes.lorem2": "Цитата Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Пункт списка Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Пункт списка Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Длинный пост от первого лица",
        "prompt.longPost.relevantEmojis": "Соответствующие эмодзи в длинном посте",
        "prompt.longPost.changeName": "Изменить имя в длинном посте",
        "alert.tuningInstructionsEmpty": "Инструкции по настройке не могут быть пустыми.",
        "text.timestamps.byPodsqueeze": "Временные метки от PodSqueeze",
        "button.copied": "Скопировано",
        "button.copy": "Копировать",
        "embed.transcript": "Встраивание транскрипта",
        "embed.description": "Описание для встраивания",
        "preview.title": "Предварительный просмотр заголовка",
        "loading.regenerating": "Регенерация...",
        "placeholder.tuningInstructions": "Введите инструкции по настройке...",
        "button.saveClose": "Сохранить и закрыть",
        "button.acceptChanges": "Принять изменения",
        "button.discard": "Отменить",
        "button.embedTranscript": "Встроить транскрипт",
        "text.copiedToClipboard": "Скопировано в буфер обмена",
        "download.srtFile": "Скачать файл SRT",
        "text.forCaptions": "для субтитров",
        "tune.title": "Настройте свои результаты",
        "tune.description": "Настройте свои результаты с помощью следующих опций.",
        "instruction.label": "Инструкции:",
        "button.tuneResult": "Настроить результат",
        "instruction.saveForLater": "Сохранить на потом",
        "button.readMore": "Читать больше",
        "button.showLess": "Показать меньше",
        "customPrompt.used": "Использованный пользовательский промпт:",
        "feedback.happyWithResults": "Вы довольны результатами?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Найдите три хорошие цитаты из транскрипта",
        "prompt.blog": "Напишите блог-пост на 500 слов, сосредоточенный на теме X",
        "prompt.tweets": "Напишите три увлекательных твита из транскрипта",
        "transcript.autoTranscribed": "Автоматически транскрибировано с помощью Podsqueeze",
        "alert.emptyPrompt": "Инструкции не могут быть пустыми",
        "embed.transcript": "Встроить транскрипт",
        "embed.description": "Встроить управляемый транскрипт с функцией поиска на вашем сайте WordPress или любой странице, поддерживающей HTML.",
        "button.copied": "Скопировано!",
        "button.copy": "Копировать",
        "preview.title": "Предварительный просмотр",
        "edit.speakers": "Редактировать имена спикеров",
        "button.saveClose": "Сохранить и закрыть",
        "placeholder.prompt": "например: Найдите три хорошие цитаты из транскрипта",
        "upgrade.pro": "Обновите до Pro, чтобы использовать эту функцию",
        "upgrade.link": "Обновить до Pro",
        "button.generate": "Создать",
        "feedback.happy": "Вы довольны результатами?",
        "instruction": "Инструкция: ",
        "generating.results": "Генерация результатов",
        "full.transcription": "Полная транскрипция",
        "srt.file": "& SRT файл",
        "download.srt": "Скачать SRT файл",
        "caption.subtitles": "для субтитров и титров.",
        "generate.from.transcript": "Генерировать из транскрипта с помощью Gpt-4o",
        "gpt.tweak.text": "Попросите последнюю версию GPT подкорректировать текст по вашему усмотрению. Используйте естественный язык и не бойтесь быть конкретным.",
        "copied.clipboard": "Скопировано в буфер обмена",
        "transcript.public.available": "URL общедоступно",
        "audio.notSupported": "Ваш браузер не поддерживает аудиоэлемент.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Добавить название подкаста",
        "podcast.title": "Подкаст {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Как вы узнали о Podsqueeze?",
        "sourceModal.otherPlaceholder": "Пожалуйста, уточните",
        "sourceModal.nextButton": "Далее",
        "sourceModal.skip": "Пропустить"
      },
      "squeezeEditResults": {
        "error.processing.rss": "У нас возникли некоторые трудности с обработкой некоторых RSS-каналов. Пожалуйста, загрузите файл."
      },
      "squeezeResults": {
        "copiedToClipboard": "Скопировано в буфер обмена",
        "publicLink": "Публичный по адресу ",
        "createLink": "Создать ссылку для分享 этой страницы результатов",
        "assembleShowNotes": "Собрать заметки к шоу",
        "convertAnotherEpisode": "Конвертировать другой эпизод",
        "writtenContent": "Письменный контент",
        "videoClipsAndImages": "Видеоклипы и изображения",
        "editAudio": "Редактировать аудио"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Смотрите больше и настраивайте",
        "see.more": "Смотрите больше",
        "generating": "Генерация",
        "download.all": "Скачать все",
        "full.transcription": "Полная транскрипция",
        "transcript.benefit": "Знаете ли вы, что добавление полных транскрипций в ваши заметки о шоу увеличивает трафик и вовлеченность на сайте?",
        "learn.more": "Узнать больше",
        "transcript.bonus": "Вы можете предоставить полные транскрипции в качестве бонуса для вашей программы членства в подкасте.",
        "show.notes": "Заметки о шоу",
        "show.notes.engagement": "Рассмотрите возможность дополнить это короткое описание другими элементами в ваших заметках о шоу для повышения вовлеченности и SEO.",
        "show.notes.examples": "Найдите вдохновение в этих 17 примерах заметок о подкастах, чтобы создать идеальные для вашего подкаста.",
        "timestamps": "Временные метки",
        "timestamps.benefit": "Добавьте эти временные метки в описание вашего эпизода, и они автоматически создадут главы на Spotify и YouTube.",
        "titles": "Заголовки",
        "titles.engagement": "Заголовки с вопросительными знаками и превосходными степенями, как правило, особенно привлекательны.",
        "links.and.mentions": "Ссылки и упоминания",
        "mentions.resources": "Рассмотрите возможность включения упоминаний ниже в раздел ресурсов ваших заметок о шоу.",
        "mentions.affiliate": "Проверьте, есть ли у упомянутых продуктов партнерские программы, и подумайте о добавлении партнерских ссылок в ваши заметки о шоу.",
        "mentions.social.media": "Отметьте людей, упомянутых в вашем эпизоде, в социальных сетях, чтобы побудить их делиться и взаимодействовать с вашим постом.",
        "keywords": "Ключевые слова",
        "keywords.youtube": "Когда вы загружаете свой эпизод на YouTube, просто скопируйте и вставьте эти ключевые слова в раздел тегов.",
        "keywords.social.media": "Используйте эти ключевые слова для хэштегов в социальных сетях.",
        "blog.post": "Блог пост",
        "blog.post.linkedin": "Рассмотрите возможность использования этого контента для создания длинного поста в LinkedIn.",
        "blog.post.share": "Поделитесь этим контентом в сообществах Reddit и группах Facebook, которые соответствуют теме вашего подкаста.",
        "newsletter": "Рассылка",
        "newsletter.content": "Некоторые из наших пользователей перерабатывают этот контент рассылки, чтобы создать более полные описания эпизодов для заметок о шоу.",
        "linkedin.and.facebook": "LinkedIn и Facebook",
        "short.post.description": "Используйте эти краткие посты в качестве описаний при публикации связанных видеоклипов и аудиограмм в социальных сетях.",
        "tweets": "Твиты",
        "quotes": "Цитаты",
        "bullet.points": "Маркированные пункты",
        "add.custom.result": "Добавить пользовательский результат",
        "bullet.points.skimming": "Подкастеры часто перечисляют основные темы эпизода в виде маркированных пунктов в заметках о шоу для удобства просмотра."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Смотрите больше и настраивайте",
        "generating": "Генерация",
        "not.available.for.rss.feed": "Недоступно для этого RSS-канала",
        "regenerate.episode.upload.file": "Перегенерируйте эпизод и загрузите свой аудио/видео файл прямо с компьютера",
        "processing.difficulties": "Мы испытываем некоторые трудности с обработкой некоторых RSS-каналов. Пожалуйста, загрузите файл.",
        "video.clips": "Видеоклипы",
        "ai.short.clips": "AI Короткие клипы",
        "quote.image": "Изображение цитаты"
      },
      "title": {
        "title.text": "ваша.метка"
      },
      "topbar": {
        "topbar.forYou": "Для вас",
        "topbar.joinPodcast": "Присоединяйтесь к нашей следующей виртуальной встрече подкастов!",
        "topbar.saveYourSpot": "Забронируйте свое место",
        "topbar.dismiss": "Закрыть"
      },
      "trackers": {
        "trackers.init": "Инициализация трекеров с включенными куками: ",
        "trackers.loadScripts": "Загрузка скриптов отслеживания..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Добро пожаловать в мое приложение",
        "content.description": "Это пример приложения, демонстрирующего перевод.",
        "button.submit": "Отправить"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI редактирует ваш клип",
        "export_clip": "Экспортировать клип",
        "ai_edit": "Редактирование AI",
        "ai_editing_clip_duration": "Это займет несколько секунд",
        "generating_clip": "Генерация вашего клипа...",
        "generating_clip_notice": "Это может занять несколько минут. Мы отправим вам электронное письмо, как только это будет сделано.",
        "edit_another_video": "Вы можете подождать здесь или отредактировать другое видео",
        "download_video": "Скачать видео",
        "back_to_editing": "Вернуться к редактированию",
        "export_video_button": "Экспортировать клип",
        "notice_storage": "Уведомление: Мы храним ваш аудиофайл в течение 30 дней. По истечении этого срока клип истечет.",
        "error_generating_clip": "Ошибка при генерации клипа",
        "error_user_support": "Пожалуйста, повторите попытку или свяжитесь с нашей службой поддержки",
        "select_template": "Выберите шаблон",
        "add_30s_prev": "30 секунд из предыдущей главы",
        "add_30s_next": "30 секунд из следующей главы",
        "undo": "Отменить",
        "subtitles_font": "Шрифт субтитров",
        "subtitles_color": "Цвет субтитров",
        "subtitles_box_color": "Цвет анимации",
        "adjust_podcast_title_position": "Настроить вертикальное положение заголовка подкаста",
        "adjust_subtitles_size": "Настроить размер субтитров",
        "adjust_subtitles_vertical_position": "Настроить вертикальное положение субтитров",
        "remove_subtitles": "Удалить субтитры",
        "animated_subtitles": "Анимированные субтитры",
        "upgrade_here": "Обновите здесь",
        "remove_logo": " чтобы удалить логотип",
        "remove_podsqueeze_logo": "Удалить логотип podsqueeze",
        "aspect_ratio": "Соотношение сторон",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Название эпизода",
        "podcast_title": "Название подкаста",
        "titles_font": "Шрифт заголовков",
        "title_colors": "Цвета заголовков подкаста/эпизода",
        "video_fit": "Подгонка видео",
        "adjust_horizontal_position": "Настроить горизонтальное положение",
        "adjust_vertical_position": "Настроить вертикальное положение",
        "adjust_video_zoom": "Настроить zoom видео",
        "adjust_video_width": "Настроить ширину видео",
        "adjust_video_height": "Настроить высоту видео",
        "background_color": "Цвет фона",
        "edit_clip": "Редактировать клип",
        "edit_layout": "Редактировать макет",
        "choose_short": "Выберите короткий",
        "edit_audio": "Редактировать аудио",
        "framing": "Кадрирование",
        "background": "Фон",
        "text_style": "Стиль текста",
        "music": "Музыка",
        "choose_chapter": "Выберите главу",
        "clips_left": "У вас осталось",
        "apply_layout": "Применить макет",
        "clips_left_number": "клипов",
        "need_more_clips": "Нужны дополнительные клипы? Обновите свой план здесь",
        "download_srt_file": "Скачать SRT файл",
        "track_selected": "Трек: ",
        "no_background_music": "Фоновая музыка не выбрана",
        "volume": "Громкость:",
        "remove": "Удалить",
        "track_ambient_piano": "Амбиентное пиано и струнные",
        "track_deep_meditation": "Глубокая медитация",
        "track_chill_upbeat": "Для её расслабляющего ритма",
        "track_inspiring_ambient": "Вдохновляющий кинематографический амбиент",
        "track_just_relax": "Просто расслабьтесь",
        "track_movement": "Движение",
        "track_once_in_paris": "Однажды в Париже",
        "track_perfect_beauty": "Совершенная красота",
        "track_summer_adventures": "Летние приключения",
        "track_sunset_groove": "Закатный ритм",
        "track_tvari_cafe": "Твари токийское кафе",
        "track_short_piano_intermezzo": "Короткое фортепианное интермеццо",
        "track_dramatic_background": "Драматическая фоновая музыка",
        "track_dramatic_hiphop": "Драматический хип-хоп джаз",
        "track_emotional_orchestra": "Эмоциональный оркестр",
        "track_halloween_short": "Музыка Хэллоуина",
        "track_improvisation_037": "Джазовая импровизация",
        "track_inspiration_piano": "Вдохновляющее фортепиано",
        "track_medieval_extract": "Средневековая музыка",
        "track_short_8": "Короткий эмбиент трек",
        "track_flute": "Спокойная флейта",
        "track_piano_guitar_duet": "Дуэт фортепиано и гитары",
        "track_intro_jazz": "Вступительный джаз",
        "track_romantic_jazz": "Романтический джаз",
        "recommended_for_youtube": "Рекомендуется для YouTube",
        "turn_into_short_clip": "Превратить этот клип в короткий (<60 сек.)",
        "browser_not_support_audio": "Ваш браузер не поддерживает аудиоэлемент.",
        "watch_tutorial": "Посмотрите этот учебник",
        "audiogram_maker": "как максимально использовать наш создатель аудиограммы",
        "store_audio_notice": "Уведомление: Мы храним ваше аудио в течение 30 дней.",
        "clip_maker": "как максимально использовать наш создатель клипов",
        "split_screen_mode": "Режим разделения экрана",
        "none": "Нет",
        "vertical_split": "Вертикальное разделение",
        "horizontal_split": "Горизонтальное разделение",
        "layers": "Используйте слои ниже, чтобы переместить их вперед или назад.",
        "screen_1_horizontal_position": "Горизонтальная позиция экрана 1",
        "screen_2_horizontal_position": "Горизонтальная позиция экрана 2",
        "track_mysterious_dark_background": "Таинственный темный фон",
        "track_acoustic_ambient_inspiration": "Акустическое окружение вдохновения",
        "track_aristocracy_classical": "Аристократическая классика",
        "track_folk_music_river_knows_my_name": "Фолк-музыка - Река знает мое имя",
        "track_funy_adventure": "Веселое приключение",
        "track_energetic_sports_rock_trailer": "Энергичный спортивный рок трейлер",
        "track_fun_upbeat_energetic_pop_rock": "Веселый позитивный энергичный поп-рок",
        "track_epic_emotional_inspirational": "Эпическое эмоциональное вдохновение",
        "track_inspirational_epic": "Вдохновляющий эпик",
        "all_music": "Вся музыка",
        "energetic_music": "Энергичная",
        "inspirational_music": "Вдохновляющая",
        "ambient_music": "Эмбиент",
        "chill_music": "Расслабляющая",
        "hiphop_music": "Хип-хоп",
        "quirky_music": "Причудливая",
        "dramatic_music": "Драматическая",
        "acoustic_music": "Акустическая",
        "classical_music": "Классическая",
        "categories": "Категории",
        "select_track": "Выберите трек",
        "upload_music": "Загрузить музыку",
        "my_music": "Моя музыка",
        "downloading": "Загрузка...",
        "download_again": "Скачать снова",
        "download": "Скачать",
        "download_failed_alert": "Не удалось скачать видео. Попробуйте еще раз.",
        "translate_subtitles": "Перевести Субтитры",
        "translate_to": "Перевести на",
        "select_language": "Выбрать Язык",
        "select_new_language": "Выбрать новый язык",
        "translating": "Переводится...",
        "translation_complete": "Перевод Завершён",
        "error_translation": "Ошибка при переводе. Попробуйте снова.",
        "original_language": "Оригинал"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Название эпизода"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "У вас пока нет контента.",
        "userPodcastsInfo.generateContent": "Создайте свой первый контент",
        "placeholder.search_folders": "Поиск папок...",
        "search.no_results": "Ни одна папка не соответствует вашему запросу."
      },
      "landingPageModal": {
        "upload.error": "Не удалось загрузить изображение: ",
        "upload.image.file": "Пожалуйста, загрузите файл изображения.",
        "upgrade.pro.message": "Настройка страницы доступна только для аккаунтов Pro и Agency",
        "upgrade.now": "Обновите сейчас",
        "upgrade.unique.landing.page": " и создайте уникальную целевую страницу эпизода.",
        "logo.recommendation": "Рекомендуемая высота логотипа 200px",
        "social.links.top.menu": "Социальные ссылки в верхнем меню",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Введите ссылку на LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Введите ссылку на Facebook",
        "saving...": "Сохранение...",
        "save": "Сохранить",
        "saved.successfully": "Успешно сохранено!",
        "uploading.image": "Загрузка изображения...",
        "upload.episode.cover": "Загрузить обложку эпизода",
        "upload.logo": "Загрузить логотип",
        "where.listen.episode": "Где еще мы можем послушать этот эпизод?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Введите ссылку на YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Введите ссылку на Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Введите ссылку на Spotify",
        "image.size.recommendation": "Рекомендуемый размер 1000x1000px",
        "primary.color.label": "Основной цвет",
        "header.background.color": "Цвет фона заголовка и ссылки.",
        "landing.page.customization": "Настройка целевой страницы",
        "create.branded.landing.page": "Создайте красивую брендированную целевую страницу, чтобы поделиться с вашими слушателями",
        "episode.image": "Изображение эпизода",
        "episode.links": "Ссылки на эпизод",
        "page.header": "Заголовок страницы",
        "page.color": "Цвет страницы",
        "visit.landing.page": "Посетить целевую страницу"
      },
      "page": {
        "loading.dashboard": "Загрузка панели управления",
        "convert.new.episode": "Конвертировать новый эпизод",
        "convert.audio.or.video": "Конвертировать аудио или видео",
        "minutes.left": "У вас есть",
        "need.more.minutes": "Нужно больше минут?",
        "upgrade.plan": "Обновите свой тарифный план здесь.",
        "your.podcasts": "Ваши подкасты",
        "podsqueeze.results.page": "Страница результатов Podsqueeze",
        "access.podsqueeze.results": "Получите доступ к результатам podsqueeze для этого эпизода. Вы сможете увидеть весь сгенерированный контент"
      },
      "podcast": {
        "confirm.delete_episode": "Вы уверены, что хотите удалить этот эпизод?",
        "alert.something_wrong": "Что-то пошло не так. Пожалуйста, попробуйте еще раз.",
        "confirm.delete_folder": "Вы уверены, что хотите удалить эту папку?",
        "loading.episodes": "Загрузка эпизодов...",
        "folder.empty": "Эта папка пуста.",
        "content.no_content": "Контент недоступен.",
        "content.generate_first": "Создайте свой первый подкаст.",
        "button.personalize_ai": "Персонализировать с помощью ИИ",
        "button.edit_website": "Редактировать сайт",
        "button.visit_website": "Посетить сайт",
        "button.generate_website": "Создать сайт",
        "placeholder.search": "Поиск...",
        "label.sort_by": "Сортировать по",
        "label.last_episodes_loaded": "Последние загруженные эпизоды",
        "button.load_all_episodes": "Загрузить все эпизоды",
        "loading": "Загрузка...",
        "add.new.episode": "Добавить новый эпизод",
        "order.newest": "Сначала новые",
        "order.oldest": "Сначала старые",
        "order.a_to_z": "От А до Я",
        "order.z_to_a": "От Я до А"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Создать новую папку подкаста:",
        "folder.name.placeholder": "Название папки",
        "create.button": "Создать"
      },
      "podcastLandingModal": {
        "upload.image.error": "Пожалуйста, загрузите файл изображения",
        "podcast.cover.title": "Обложка подкаста",
        "podcast.cover.upload": "Загрузите изображение обложки вашего подкаста здесь. Оно будет отображаться на вашей целевой странице.",
        "upload.image.uploading": "Загрузка изображения...",
        "podcast.cover.upload.button": "Загрузить обложку",
        "podcast.cover.recommended.size": "Рекомендуемый размер: 1400x1400 пикселей",
        "profile.info.title": "Информация о профиле",
        "profile.info.upload": "Добавьте свою фотографию профиля и имя, чтобы персонализировать вашу целевую страницу.",
        "profile.upload.button": "Загрузить фотографию профиля",
        "profile.name.label": "Имя профиля",
        "profile.name.placeholder": "Введите ваше имя",
        "platform.links.title": "Ссылки на платформы",
        "platform.links.upload": "Добавьте ссылки на ваш подкаст на различных платформах.",
        "platform.links.youtube_link": "Ссылка на YouTube",
        "platform.links.youtube_link.placeholder": "Введите ссылку на YouTube",
        "platform.links.spotify_link": "Ссылка на Spotify",
        "platform.links.spotify_link.placeholder": "Введите ссылку на Spotify",
        "platform.links.apple_podcast_link": "Ссылка на Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Введите ссылку на Apple Podcast",
        "platform.links.linkedin_link": "Ссылка на LinkedIn",
        "platform.links.linkedin_link.placeholder": "Введите ссылку на LinkedIn",
        "platform.links.facebook_link": "Ссылка на Facebook",
        "platform.links.facebook_link.placeholder": "Введите ссылку на Facebook",
        "platform.links.twitter_link": "Ссылка на Twitter",
        "platform.links.twitter_link.placeholder": "Введите ссылку на Twitter",
        "call.to.action.title": "Призыв к действию",
        "call.to.action.upload": "Настройте кнопку призыва к действию для целевой страницы.",
        "call.to.action.button.text.label": "Текст кнопки",
        "call.to.action.button.text.placeholder": "Введите текст кнопки",
        "call.to.action.button.link.label": "Ссылка кнопки",
        "call.to.action.button.link.placeholder": "Введите ссылку кнопки",
        "color.styles.title": "Цветовые стили",
        "color.styles.upload": "Настройте цвета вашей целевой страницы.",
        "color.styles.primary.label": "Основной цвет",
        "color.styles.primary.description": "Выберите основной цвет для вашей целевой страницы",
        "color.styles.secondary.label": "Вторичный цвет",
        "color.styles.secondary.description": "Выберите вторичный цвет для вашей целевой страницы",
        "podcast.info.title": "Информация о подкасте",
        "podcast.info.upload": "Редактируйте данные вашего подкаста.",
        "podcast.info.name.label": "Название подкаста",
        "podcast.info.name.placeholder": "Введите название подкаста",
        "podcast.info.description.label": "Описание подкаста",
        "podcast.info.description.placeholder": "Введите описание подкаста",
        "edit.website.title": "Редактировать сайт",
        "generate.website.title": "Сгенерировать сайт",
        "for": "для",
        "saving": "Сохранение...",
        "save.changes": "Сохранить изменения",
        "generate.website": "Сгенерировать сайт",
        "changes.saved.success": "Изменения успешно сохранены!",
        "podcast.cover.menu": "Обложка подкаста",
        "podcast.info.menu": "Информация о подкасте",
        "profile.menu": "Профиль",
        "platform.links.menu": "Ссылки на платформы",
        "call.to.action.menu": "Призыв к действию",
        "color.styles.menu": "Цветовые стили",
        "logo.menu": "Логотип",
        "logo.title": "Логотип загрузить",
        "logo.upload": "Загрузите логотип вашего подкаста. Этот логотип будет отображаться на вашей целевой странице.",
        "logo.upload.button": "Логотип загрузить",
        "platform.links.description": "Добавьте ссылки на ваш подкаст на различных платформах.",
        "social.links.menu": "Социальные ссылки",
        "social.links.title": "Социальные медиа ссылки",
        "social.links.description": "Добавьте ссылки на ваши социальные профили.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Введите ссылку на LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Введите ссылку на Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Введите ссылку на Twitter",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Введите ссылку на Instagram",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Введите ссылку на YouTube",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Введите ссылку на Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Введите ссылку на Apple Podcast"
      },
      "podcastMoveModal": {
        "move.episode.label": "Переместить этот эпизод в:",
        "move.episode.instruction": "Вы можете ввести новое имя, чтобы создать папку.",
        "move.episode.button": "Переместить",
        "move.episode.error.selectFolder": "Пожалуйста, выберите папку для перемещения эпизода."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Настройки ИИ для подкаста {{podcastTitle}}",
        "ai.customize.writing.style": "Настройте стиль письма вашего ИИ",
        "ai.content.writing.preference": "Как бы вы хотели, чтобы Podsqueeze писал ваш контент?",
        "ai.voice.placeholder": "Пример: Профессиональный, но дружелюбный тон. Слушатели - подкастеры. Пишите от первого лица.",
        "ai.character.limit.reached": "Вы достигли предела символов в 50.",
        "ai.upgrade.now": "Обновите сейчас",
        "ai.fix.transcript.misspells": "Исправить ошибки в транскрипции",
        "ai.enter.misspelled.words": "Запишите слова, которые ИИ часто ошибочно пишет в этих эпизодах подкаста, например, имена",
        "ai.enter.word.press.enter": "Введите слово и нажмите Enter",
        "ai.add.word": "Добавить слово",
        "ai.tag.limit.reached": "Достигнут предел в 1 тег.",
        "ai.save": "Сохранить",
        "ai.save.close": "Сохранить и закрыть"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Название эпизода",
        "selectedEpisode.podcastName": "Название подкаста",
        "selectedEpisode.showNotes": "Примечания к шоу",
        "selectedEpisode.timestamp": "Временная метка",
        "selectedEpisode.staticTimestamp": "Статическая временная метка",
        "selectedEpisode.mentions": "Упоминания",
        "selectedEpisode.newsletter": "Рассылка",
        "selectedEpisode.titles": "Заголовки",
        "selectedEpisode.tweeter": "Твиттер",
        "selectedEpisode.shortPost": "Краткий пост",
        "selectedEpisode.transcription": "Транскрипция",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Ключевые слова",
        "selectedEpisode.quotes": "Цитаты",
        "selectedEpisode.longPost": "Длинный пост",
        "selectedEpisode.bulletPoints": "Маркированные пункты",
        "selectedEpisode.publicLink": "Публичная ссылка",
        "selectedEpisode.embeddedId": "Встроенный ID",
        "selectedEpisode.episodeUrl": "URL эпизода"
      },
      "sidebar": {
        "tools": "Инструменты",
        "find.podcast.topic.ideas": "Найдите идеи для тем подкастов",
        "podcast.thumbnail.maker": "Создатель миниатюр подкастов",
        "podcast.seo.optimizer": "Оптимизатор SEO подкастов",
        "account": "Аккаунт",
        "payment.settings": "Настройки платежей",
        "support": "Поддержка",
        "logout": "Выйти",
        "plan": "План",
        "resets.in": "Сброс через",
        "api.access": "Доступ к API",
        "days": "дней и",
        "hours": "часов",
        "upgrade.plan": "Обновить план"
      },
      "updateEmailModal": {
        "email.validation.error": "Пожалуйста, введите действительный адрес электронной почты.",
        "email.change.confirm": "Вы уверены, что хотите изменить свой адрес электронной почты?",
        "email.change.success": "Ваш адрес электронной почты был успешно изменен!",
        "email.in.use.error": "Этот адрес электронной почты уже используется. Пожалуйста, попробуйте другой.",
        "email.recent.login.error": "Перед продолжением этой операции, пожалуйста, войдите снова, используя текущий адрес электронной почты.",
        "email.invalid.error": "Недействительный адрес электронной почты. Пожалуйста, попробуйте другой.",
        "subscription.cancel.error": "Сначала отмените свою активную платную подписку.",
        "account.delete.confirm": "Вы уверены, что хотите удалить свою учетную запись?\n\nЭто действие нельзя отменить.",
        "account.delete.success": "Ваша учетная запись была успешно удалена.",
        "account.delete.error": "Что-то пошло не так, и мы не смогли удалить вашу учетную запись.\n\nПожалуйста, свяжитесь с нашей службой поддержки пользователей.",
        "subscription.cancel": "Отменить подписку",
        "account.delete": "Удалить учетную запись",
        "account.delete.warning": "Удаление вашей учетной записи необратимо и навсегда стерет весь ваш контент и информацию для входа. Пожалуйста, действуйте осторожно, так как это действие нельзя отменить.",
        "current.account.email": "Текущий адрес электронной почты учетной записи",
        "enter.new.email": "Введите новый адрес электронной почты для вашей учетной записи",
        "update": "Обновить",
        "change.password": "Сменить пароль",
        "payment.settings": "Настройки платежей"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "названиеЭпизода"
      },
      "episodelist": {
        "loading.episodes": "Загрузка эпизодов",
        "no.episodes.found": "Эпизоды не найдены. Пожалуйста, попробуйте снова с действительным RSS-идентификатором",
        "select.episode": "Выберите эпизод, для которого вы хотите создать контент"
      },
      "interfaces": {
        "user.activePlan.tier": "Уровень",
        "user.activePlan.creationDate": "Дата создания",
        "user.activePlan.minutesAvailable": "Доступные минуты"
      },
      "loadingbar": {
        "loadingbar.magic": "Мы все еще творим магию ✨",
        "loadingbar.longer": "Некоторые эпизоды требуют немного больше времени... 🐌",
        "loadingbar.hardwork": "Наши серверы работают усердно 🦾"
      },
      "page": {
        "main.background": "Фон основного компонента"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Ошибка: Доступ к микрофону или камере запрещен.",
        "microphone.camera.not.found": "Ошибка: Микрофон или камера не найдены.",
        "microphone.camera.not.readable": "Ошибка: Микрофон или камера недоступны для чтения.",
        "microphone.camera.access.error": "Ошибка: Произошла неизвестная ошибка при доступе к микрофону или камере.",
        "media.not.recorded": "Ошибка: Медиа не записано.",
        "upload.failed": "Ошибка: Загрузка не удалась.",
        "upload.success": "Успех: Загрузка завершена успешно.",
        "upload.in.progress": "Загрузка в процессе...",
        "upload.button": "Загрузить запись",
        "stop.recording": "Остановить запись",
        "record.audio": "Записать аудио",
        "record.audio.video": "Записать аудио с видео",
        "record.again": "Записать снова",
        "episode.language": "Выберите язык эпизода"
      },
      "selectBox": {
        "language.english": "Английский",
        "language.arabic": "Арабский",
        "language.bulgarian": "Болгарский",
        "language.catalan": "Каталонский",
        "language.croatian": "Хорватский",
        "language.czech": "Чешский",
        "language.danish": "Датский",
        "language.dutch": "Нидерландский",
        "language.finnish": "Финский",
        "language.french": "Французский",
        "language.german": "Немецкий",
        "language.greek": "Греческий",
        "language.hindi": "Хинди",
        "language.hungarian": "Венгерский",
        "language.indonesian": "Индонезийский",
        "language.italian": "Итальянский",
        "language.japanese": "Японский",
        "language.korean": "Корейский",
        "language.lithuanian": "Литовский",
        "language.latvian": "Латышский",
        "language.malay": "Малайский",
        "language.mandarin": "Мандарин",
        "language.norwegian": "Норвежский",
        "language.polish": "Польский",
        "language.portuguese": "Португальский",
        "language.romanian": "Румынский",
        "language.russian": "Русский",
        "language.slovak": "Словацкий",
        "language.slovenian": "Словенский",
        "language.spanish": "Испанский",
        "language.swedish": "Шведский",
        "language.tamil": "Тамильский",
        "language.turkish": "Турецкий",
        "language.ukrainian": "Украинский",
        "language.bashkir": "Башкирский",
        "language.basque": "Баскский",
        "language.belarusian": "Белорусский",
        "language.cantonese": "Кантонский",
        "language.esperanto": "Эсперанто",
        "language.estonian": "Эстонский",
        "language.galician": "Галисийский",
        "language.interlingua": "Интерлингва",
        "language.marathi": "Маратхи",
        "language.mongolian": "Монгольский",
        "language.persian": "Персидский",
        "language.thai": "Тайский",
        "language.uyghur": "Уйгурский",
        "language.vietnamese": "Вьетнамский",
        "language.welsh": "Уэльский"
      },
      "selectedepisode": {
        "processing.episode": "Обработка эпизода",
        "processing.time": "Это обычно занимает от 5 до 10 минут",
        "email.notification": "Вы можете закрыть это окно. Мы отправим вам электронное письмо, как только оно будет готово. Ваш контент также будет доступен на вашей панели управления.",
        "convert.another.episode": "Конвертировать другой эпизод",
        "technical.difficulties": "Упс! У нас возникли некоторые технические трудности. Будьте уверены, наша команда уже работает над этим! Пожалуйста, попробуйте позже.",
        "no.discount": "Не волнуйтесь, мы не будем уменьшать количество минут!",
        "high.demand": "Мы испытываем повышенный спрос, поэтому обработка вашего запроса может занять больше времени, чем обычно. Приносим извинения за возможные неудобства!",
        "email.ready": "Мы отправим вам электронное письмо, как только оно будет готово. Вы также можете получить доступ к вашим результатам на вашей панели управления.",
        "select.podcast.folder": "Выберите папку подкаста, к которой принадлежит этот эпизод, или создайте новую, введя имя.",
        "give.voice": "Настройте голос папки",
        "generate.content": "Сгенерировать контент",
        "content.ready": "Ваш контент готов!",
        "not.enough.minutes.title": "У вас недостаточно минут",
        "not.enough.minutes.message": "У вас недостаточно минут для конвертации этого эпизода. Пожалуйста, обновите свой план.",
        "upgrade.plan": "Обновить свой план",
        "convert.shorter.episode": "Конвертировать более короткий эпизод",
        "ask.ai.tune": "Вы все еще можете попросить ИИ настроить каждый контент, чтобы он лучше соответствовал вашим потребностям.",
        "error.title": "Ошибка",
        "convert.another.file": "Конвертировать другой файл"
      },
      "submitfile": {
        "file.size.exceeded.free": "Размер файла превышает максимальный лимит в 4 ГБ. <p>Пожалуйста, <a href='/pricing'><b><u>обновите тариф, чтобы загружать более крупные файлы</u></b></a></p>",
        "file.size.exceeded.paid": "Размер файла превышает максимальный лимит в 10 ГБ. <p>Пожалуйста, выберите файл меньшего размера.</p>",
        "file.upload.invalid": "Пожалуйста, загрузите аудио или видео файл",
        "upload.in.progress": "Загрузка файла. Пожалуйста, не закрывайте это окно.",
        "upload.button": "Загрузить & Генерировать",
        "close.button": "Закрыть",
        "upgrade.message.free": "Больше загрузок доступны только для платных тарифов.",
        "upgrade.now.button": "Обновить сейчас",
        "pricing.info": "начиная с 12 долларов в месяц",
        "upload.file.label": "Загрузите аудио или видео файл",
        "max.file.size.free": "(макс 4 ГБ)",
        "max.file.size.paid": "(макс 10 ГБ)",
        "podsqueeze.audiograms.info": "Podsqueeze создаст аудиограммы для аудиофайлов и короткие клипы для видеофайлов",
        "file.placeholder": "Ваш MP3/WAV файл",
        "episode.language.label": "Язык эпизода",
        "select.folder.label": "Выбрать или создать папку",
        "multiple.files.selected": "Выбрано {{count}} файлов",
        "clear.all": "Очистить все",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Выбрать несколько файлов",
        "file.upload.error": "Ошибка загрузки файла",
        "file.upload.success": "Файл успешно загружен",
        "file.upload.processing": "Обработка файла",
        "click.to.upload": "Нажмите, чтобы загрузить",
        "click.to.upload.multiple": "Нажмите, чтобы загрузить несколько файлов",
        "enter.url": "Введите URL",
        "upload.file": "Загрузить файл",
        "media.url.label": "URL медиа",
        "media.url.help": "Введите URL вашего аудио или видео файла. Мы загрузим и обработаем его для вас.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Название эпизода",
        "url.input.required": "Пожалуйста, введите URL медиа",
        "url.upload.error": "Не удалось загрузить медиа по URL. Проверьте URL и попробуйте снова.",
        "supported.formats": "Поддерживаемые форматы",
        "uploading": "Загрузка...",
        "media.url.requirements": "URL должен быть прямой ссылкой на общедоступный медиафайл (не веб-страницу)"
      },
      "submitrssid": {
        "error.selectRss": "Пожалуйста, выберите действующий RSS из выпадающего списка",
        "label.insertRssFeed": "Вставьте ваш RSS-канал",
        "placeholder.insertRssFeed": "Вставьте ваш RSS-канал",
        "label.searchByPodcast": "Искать по названию подкаста",
        "label.searchForPodcast": "Искать ваш подкаст",
        "placeholder.searchForPodcast": "Поиск подкаста",
        "label.cantFindPodcast": "Не можете найти ваш подкаст? ",
        "label.clickHereUseRss": "Нажмите здесь, чтобы использовать ваш RSS-канал",
        "label.selectedPodcast": "Выбранный подкаст",
        "label.episodeLanguage": "Язык эпизода",
        "button.seeAllEpisodes": "Смотреть все эпизоды",
        "select.folder.label": "Выбрать или создать папку"
      },
      "submitsection": {
        "search.podcast": "Поиск вашего подкаста",
        "upload.audio.video": "Загрузить аудио или видео",
        "record.audio": "Записать аудио",
        "youtube.video": "Ссылка на YouTube",
        "create.content": "Давайте создадим контент для вашего подкаста!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Введите URL видео YouTube",
        "error.insertYouTubeUrl": "Пожалуйста, вставьте URL YouTube.",
        "label.insertYouTubeUrl": "Вставьте URL YouTube",
        "button.loading": "Загрузка...",
        "message.downloadingFile": "Загрузка файла...",
        "error.processingFailed": "Ошибка: обработка видео не удалась.",
        "error.youtubeVideoNotAvailable": "Это YouTube видео недоступно для скачивания. Пожалуйста, загрузите ваш аудио или видео непосредственно в Podsqueeze или используйте YouTube сканер сначала. Спасибо за ваше терпение.",
        "button.submitYouTubeVideo": "Отправить видео YouTube",
        "episode.language.label": "Используемый язык",
        "select.folder.label": "Выбрать или создать папку"
      },
      "tabs": {
        "tab.label.tab1": "Вкладка 1",
        "tab.label.tab2": "Вкладка 2",
        "tab.label.tab3": "Вкладка 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Извлеките максимум из Podsqueeze",
        "tutorial.chapter.introduction": "Введение",
        "tutorial.chapter.bestShowNotes": "Получите лучшие заметки и временные метки",
        "tutorial.chapter.blogPosts": "Использование блогов и новостных рассылок",
        "tutorial.chapter.editingTranscripts": "Встраивание и редактирование транскриптов",
        "tutorial.chapter.personalizingAI": "Персонализация ИИ и добавление собственного голоса",
        "tutorial.chapter.speedingUpNotes": "Ускорение заметок шоу",
        "tutorial.chapter.creatingClips": "Создание видеоклипов и изображений",
        "tutorial.chapter.generatingLandingPage": "Генерация целевой страницы",
        "tutorial.chapter.shareResults": "Поделитесь результатами с вашей командой",
        "tutorial.closeVideoCheckbox": "Закрыть видео, как только первые результаты будут готовы"
      },
      "uploadloadingbar": {
        "upload.loading": "Загрузка..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Свяжитесь с нами",
        "contact.section.email": "Напишите нам на support@podsqueeze.com",
        "contact.section.tiago.role": "Соучредитель",
        "contact.section.joao.role": "Соучредитель",
        "contact.section.image.alt.sendMessage": "Отправить сообщение",
        "contact.section.image.alt.tiago": "Соучредитель Podsqueeze Тьяго",
        "contact.section.image.alt.joao": "Соучредитель Podsqueeze Жоао"
      },
      "contactsection": {
        "contact.section.title": "Свяжитесь с нами",
        "contact.section.email": "Напишите нам на support@podsqueeze.com",
        "contact.section.tiago.role": "Соучредитель",
        "contact.section.joao.role": "Соучредитель",
        "contact.section.image.alt.sendMessage": "Отправить сообщение",
        "contact.section.image.alt.tiago": "Соучредитель Podsqueeze Тьяго",
        "contact.section.image.alt.joao": "Соучредитель Podsqueeze Жоао"
      },
      "home-agenciessection": {
        "join.content.creators": "Присоединяйтесь к 20,000 создателям контента и профессионалам подкастов, использующим Podsqueeze",
        "content.creators": "Создатели контента",
        "podcast.managers": "Менеджеры подкастов",
        "producers.studios": "Продюсеры и студии",
        "for.podcasters": "ДЛЯ ПОДКАСТЕРОВ, МЕНЕДЖЕРОВ ПОДКАСТОВ И АГЕНТСТВ",
        "manage.content.creation": "Легко управляйте созданием контента для",
        "multiple.podcasts": "нескольких подкастов",
        "podsqueeze.description": "Podsqueeze — это мощный инструмент для всех профессионалов подкастинга. Независимо от того, являетесь ли вы одиночным подкастером, менеджером подкастов или агентством, Podsqueeze предлагает все функции, необходимые для оптимизации вашего рабочего процесса создания контента подкастов.",
        "create.podcast.folders": "Создайте папки подкастов, чтобы организовать ваши эпизоды.",
        "share.content.page": "Легко делитесь вашей страницей контента с клиентами и командой",
        "tune.ai.voice": "Настройте голос ИИ для каждого шоу, которым вы управляете",
        "plan.content.episodes": "Планируйте контент для следующих эпизодов с нашим продвинутым",
        "podcast.topics.finder": "поисковиком тем подкастов",
        "podsqueeze.testimonial": "Способность Podsqueeze использовать подсказки для настройки контента каждого подкаста, которым мы управляем, и сохранять их для будущих эпизодов позволяет нам поддерживать согласованность голосов каждого шоу. Это элитная функция, которую мы не смогли найти в других инструментах.",
        "coo.podigy": "COO в Podigy Podcasts",
        "agenciessection.joinCreators": "Присоединяйтесь к 20,000 создателям контента и профессионалам подкастов, использующим Podsqueeze",
        "agenciessection.contentCreators": "Создатели контента",
        "agenciessection.podcastManagers": "Менеджеры подкастов",
        "agenciessection.producersStudios": "Продюсеры и студии",
        "agenciessection.forPodcasters": "ДЛЯ ПОДКАСТЕРОВ, МЕНЕДЖЕРОВ ПОДКАСТОВ И АГЕНТСТВ",
        "agenciessection.manageContent": "Легко управляйте созданием контента для",
        "agenciessection.multiplePodcasts": "нескольких подкастов",
        "agenciessection.podsqueezeDescription": "Podsqueeze — это мощный инструмент для всех профессионалов подкастинга. Независимо от того, являетесь ли вы одиночным подкастером, менеджером подкастов или агентством, Podsqueeze предлагает все функции, необходимые для оптимизации вашего рабочего процесса создания контента подкастов.",
        "agenciessection.createPodcastFolders": "Создайте папки подкастов, чтобы организовать ваши эпизоды.",
        "agenciessection.shareContent": "Легко делитесь вашей страницей контента с клиентами и командой",
        "agenciessection.tuneAI": "Настройте голос ИИ для каждого шоу, которым вы управляете",
        "agenciessection.planContent": "Планируйте контент для следующих эпизодов с нашим продвинутым",
        "agenciessection.podcastTopicsFinder": "поисковиком тем подкастов",
        "agenciessection.podsqueezeQuote": "Способность Podsqueeze использовать подсказки для настройки контента каждого подкаста, которым мы управляем, и сохранять их для будущих эпизодов позволяет нам поддерживать согласованность голосов каждого шоу. Это элитная функция, которую мы не смогли найти в других инструментах.",
        "agenciessection.coO": "COO в Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "НОВАЯ ФУНКЦИЯ",
        "seamless.editing": "Бесшовное редактирование и улучшение звука для естественного, ",
        "high.quality.results": " высококачественного результата",
        "experience.seamless.audio.editing": "Испытайте бесшовное редактирование аудио с помощью передовых алгоритмов ИИ для записи высшего качества. ",
        "remove.ums": "Удалить 'э-э'",
        "enhance.sound.quality": ", пауз и улучшите качество звука всего одним кликом.",
        "enhance.audio.now": "Улучшить звук сейчас",
        "sample.audio.recorded": "Пример аудио, записанный непосредственно с телефона.",
        "original.recording": "Оригинальная запись",
        "audio.after.ai.edit": "Аудио после редактирования и улучшения ИИ",
        "experience.audio.editing": "Испытайте бесшовное редактирование аудио с помощью передовых алгоритмов ИИ для записи высшего качества. "
      },
      "home-blogsection": {
        "more.resources.label": "БОЛЬШЕ РЕСУРСОВ ДЛЯ ВАШЕГО ПОДКАСТА",
        "learn.how.to.get.most": "Узнайте, как получить максимальную выгоду от",
        "your.content": "вашего контента",
        "get.most.out.of.ai.content": "Получите максимальную выгоду от контента, созданного ИИ, для вашего подкаста",
        "welcome.to.podsqueeze": "Добро пожаловать в Podsqueeze – самый простой способ транскрибировать ваш подкаст и создавать увлекательный контент...",
        "will.google.penalize.ai.content": "Будет ли Google наказывать ваш контент, созданный ИИ?",
        "ai.content.discussion": "Появление контента, созданного ИИ, вызвало обсуждения и обеспокоенность среди создателей контента, маркетологов и SEO...",
        "what.is.rss.feed": "Что такое RSS-канал для подкастов и как его использовать",
        "rss.feed.benefits": "Как подкастер, вы, возможно, слышали термин 'RSS-канал' раньше, но вы, возможно, не знаете точно, что это такое и как это может быть полезно...",
        "visit.blog": "Посетите блог"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "КЛИПЫ И АУДИОГРАММЫ",
        "clipsAndAudiograms.subtitle": "Легко преобразуйте ваш подкаст в клипы",
        "clipsAndAudiograms.description": "Просто выберите главу из вашего эпизода и экспортируйте её как клип или аудиограмму для TikTok, Instagram и YouTube Shorts. Выберите шаблон и настройте его под свой стиль.",
        "clipsAndAudiograms.createClips": "Создать клипы сейчас",
        "textEditor.title": "Редактор на основе текста",
        "textEditor.description": "Точно настраивайте ваши клипы и аудиограммы прямо из субтитров. Редактируйте субтитры и обрезайте ваше видео, удаляя конкретные слова.",
        "oneClickShorts.title": "Короткие видео в один клик (<60с)",
        "oneClickShorts.description": "Позвольте ИИ заняться редактированием за вас. Одним нажатием кнопки ИИ сократит каждую главу вашего эпизода до 60 секунд, готовую к публикации как YouTube Short или клип TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Связаться с основателями",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Разработчик и подкастер",
        "contact.section.joao.role": "- Дизайнер UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "ШИРОКИЙ ВЫБОР КОНТЕНТА",
        "generate.content": "Создайте контент с",
        "one.click": " одним кликом!",
        "transcript.srt": "Транскрипция и SRT",
        "transcript.description": "Получите полный текст вашего эпизода подкаста вместе с файлом SRT, готовым для создания субтитров.",
        "show.notes": "Примечания к шоу",
        "show.notes.description": "Подведите итоги основных тем, обсуждаемых в вашем эпизоде, и сделайте его более доступным для поиска",
        "timestamps": "Временные метки",
        "timestamps.description": "Создайте главы с временными метками и направьте слушателей к конкретным сегментам вашего эпизода подкаста",
        "blog.social.posts": "Блог и социальные посты",
        "blog.social.posts.description": "Публикуйте о вашем эпизоде подкаста везде и привлекайте новых слушателей",
        "newsletter": "Рассылка",
        "newsletter.description": "Держите ваших слушателей в курсе новых эпизодов",
        "titles.more": "Заголовки и многое другое!",
        "titles.more.description": "Создавайте привлекательные заголовки, цитаты, пункты, ключевые слова и многое другое!",
        "see.sample.content": "СМОТРЕТЬ ОБРАЗЕЦ КОНТЕНТА",
        "wannabe.entrepreneur": "Будущий предприниматель - #299 Podsqueeze только что достиг $100,000 годового дохода!",
        "making.space": "Создание пространства - Стив Харви: “Вы можете продолжать”",
        "modern.wisdom": "Современная мудрость - Эрик Хоэл - Руководство по фундаментальной тайне разума"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Линия разделителя"
      },
      "home-explanationsection": {
        "fast.accurate": "БЫСТРО И ТОЧНО",
        "generate.content": "Создайте контент для вашего подкаста с помощью",
        "power.of.ai": "силы ИИ",
        "upload.image.alt": "загрузить изображение",
        "select.episode": "Выберите эпизод из вашего RSS-канала или загрузите аудио/видео файл",
        "paste.rss.feed": "Просто вставьте URL вашего RSS-канала, чтобы выбрать эпизод из списка или загрузить аудио или видео файл.",
        "content.image.alt": "изображение контента",
        "one.click.content": "Получите весь контент одним кликом!",
        "user.friendly.interface": "Интуитивно понятный и удобный интерфейс, который вы можете начать использовать сразу. Создайте контент для вашего подкаста одним кликом.",
        "tune.image.alt": "изображение настройки",
        "edit.fine.tune": "Редактируйте и настраивайте каждый контент",
        "direct.edit.content": "Прямо редактируйте и настраивайте каждый контент по вашему желанию с помощью ИИ. Например, вы можете попросить о конкретном тоне, прямой или косвенной речи или просто исправить неправильно написанные имена.",
        "multiple.language.support": "Поддержка нескольких языков",
        "language.flags.alt": "флаги языков",
        "generate.content.aria": "Создать контент"
      },
      "home-featuressection": {
        "loading": "Загрузка...",
        "transcribe.write.show.notes": "Транскрибируйте и пишите заметки к вашему подкасту",
        "twenty.times.faster": "В 20 раз быстрее",
        "save.manual.work": "Сэкономьте до 100% ручной работы. Автоматически транскрибируйте ваш подкаст с высокой точностью и разметкой спикеров, а также генерируйте полные заметки к шоу и посты в социальных сетях своим голосом.",
        "generate.content": "Генерировать контент",
        "transcripts": "Транскрипты",
        "full.transcript": "Получите полный транскрипт ваших эпизодов подкаста и транскрипты видео с YouTube, а также файл SRT для субтитров.",
        "show.notes": "Заметки к шоу",
        "summarize.generate.show.notes": "Суммируйте и генерируйте заметки к шоу своим голосом, включая временные метки, пункты и упоминания.",
        "blog.newsletter": "Блог и рассылка",
        "actionable.blog.posts": "Получите практичные посты в блоге о ваших эпизодах и готовые к отправке рассылки с основными выводами.",
        "social.media": "Социальные сети",
        "short.posts.insights": "Получите короткие посты и краткие идеи для распространения информации в социальных сетях.",
        "quote": "Из всех лучших инструментов ИИ для транскрипции, которые мы тестировали, Podsqueeze генерировал самые полезные результаты для заметок к шоу, временных меток, заголовков, упоминаний, образцов постов в блоге и ключевых цитат.",
        "justin.jackson": "Джастин Джексон",
        "cofounder.transistor": "Соучредитель Transistor.fm",
        "transcribe_and_write_show_notes": "Подкаст транскрипции, резюме и социальные посты",
        "twenty_times_faster": "В 20 раз быстрее",
        "save_manual_work": "Сэкономьте до 100% ручной работы. Автоматически транскрибируйте ваш подкаст с высокой точностью и разметкой спикеров, а также генерируйте полные заметки к шоу и посты в социальных сетях своим голосом.",
        "generate_content": "Генерировать контент",
        "full_transcript": "Получите полный транскрипт ваших эпизодов подкаста и транскрипты видео с YouTube, а также файл SRT для субтитров.",
        "show_notes": "Заметки к шоу",
        "summarize_and_generate_show_notes": "Суммируйте и генерируйте заметки к шоу своим голосом, включая временные метки, пункты и упоминания.",
        "blog_and_newsletter": "Блог и рассылка",
        "actionable_blog_posts": "Получите практичные посты в блоге о ваших эпизодах и готовые к отправке рассылки с основными выводами.",
        "social_media": "Социальные сети",
        "short_posts_and_insights": "Получите короткие посты и краткие идеи для распространения информации в социальных сетях.",
        "testimonial": "Из всех лучших инструментов ИИ для транскрипции, которые мы тестировали, Podsqueeze генерировал самые полезные результаты для заметок к шоу, временных меток, заголовков, упоминаний, образцов постов в блоге и ключевых цитат.",
        "cofounder_transistor": "Соучредитель Transistor.fm"
      },
      "home-page": {
        "main.background": "Цвет фона для основного компонента"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "СЛУШАЙТЕ НАШ ПОДКАСТ",
        "podcast.section.subtitle": "Мастер-классы от",
        "podcast.section.highlight": "опытных подкастеров",
        "podcast.section.description": "Слушайте наш подкаст, в котором мы интервьюируем опытных подкастеров и пользователей Podsqueeze со всего мира. Мы просим их поделиться своими советами, идеями, историями и всем, что вам нужно знать, чтобы развивать свой собственный подкаст.",
        "podcast.link.spotify": "Слушать на Spotify",
        "podcast.link.apple": "Слушать на Apple Podcasts",
        "podcast.link.youtube": "Слушать на YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Загрузка..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Автоматизируйте свой подкаст",
        "tagline.productionPromotion": "Производство и продвижение",
        "tagline.launchGrow": "Легко запустите и развивайте свой аудио- или видеоподкаст с помощью всего необходимого в одном месте, с помощью ИИ.",
        "tagline.uploadGenerate": "Генерируйте подкаст транскрипции, резюме, короткие клипы с субтитрами и многое другое!",
        "tagline.singleClick": "все это одним кликом.",
        "tagline.transcripts": "Подкаст Транскрипции",
        "tagline.showNotes": "Заметки к шоу",
        "tagline.newslettersBlogs": "Рассылки и блоги",
        "tagline.socialPosts": "Социальные посты",
        "tagline.shortClipsAudiograms": "Короткие клипы и аудиограммы",
        "tagline.podcastWebsite": "Вебсайт подкаста",
        "tagline.aiAudioEnhancement": "Улучшение звука с помощью ИИ",
        "tagline.removeSilences": "Удаление пауз и 'эээ'",
        "tagline.generateNow": "Создайте сейчас бесплатно",
        "tagline.noCreditCard": "Кредитная карта не требуется",
        "testimonial.robWalling.title": "Роб Уоллинг, личность стартапов",
        "testimonial.robWalling.subtitle": "Подкаст 'Стартапы для нас'",
        "testimonial.robWalling.quote": "Заметки к шоу Podsqueeze были лучшими. Мы часто используем их для резюме и получения инсайтов из других подкастов.",
        "testimonial.johnGarmet.title": "Джон Гармет, директор по операциям",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze помогает нам быть более эффективными и генерировать больше контента для наших клиентов. Мы настоятельно рекомендуем это.",
        "testimonial.davidJackson.title": "Дэвид Джексон, коуч подкастов",
        "testimonial.davidJackson.subtitle": "Школа подкастинга",
        "testimonial.davidJackson.quote": "Podsqueeze — мой партнер по мозговому штурму. Это лучший способ придумать маркетинг подкастов."
      },
      "home-testimonials": {
        "testimonials.title": "Что говорят люди о Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Переиспользуйте контент вашего подкаста с помощью ИИ | Product Hunt",
        "testimonials.heading": "Что говорят люди о Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Неверный пароль",
        "error.userNotFound": "Пользователь не найден",
        "error.somethingWentWrong": "Упс, что-то пошло не так",
        "button.sendResetEmail": "Отправить письмо для сброса пароля",
        "button.login": "Войти",
        "placeholder.email": "Электронная почта",
        "placeholder.password": "Пароль",
        "link.forgotPassword": "Забыли пароль?",
        "link.createAccount": "Создать аккаунт",
        "text.or": "ИЛИ",
        "button.continueWithGoogle": "Продолжить с Google",
        "text.podcastDescription": "Легко запустите и развивайте свой аудио- или видеоподкаст с всем необходимым в одном месте.",
        "feature.transcripts": "Транскрипции",
        "feature.showNotes": "Примечания к шоу",
        "feature.newslettersAndBlogs": "Рассылки и блоги",
        "feature.socialPosts": "Социальные посты",
        "feature.shortClipsAndAudiograms": "Короткие клипы и аудиограммы",
        "feature.podcastWebsite": "Вебсайт подкаста",
        "feature.aiAudioEnhancement": "Улучшение звука с помощью ИИ",
        "feature.removeSilences": "Удалить паузы и 'эээ'",
        "error.emailNotVerified": "E-mail не верифицирован",
        "text.pleaseVerifyAccount": "Проверьте свою учетную запись",
        "text.checkSpamFolder": "Мы отправили вам электронное письмо для верификации. Пожалуйста, проверьте свою почту и папку спама.",
        "button.resendVerificationEmail": "Отправить e-mail для верификации повторно",
        "error.verificationEmailFailed": "Ошибка при отправке электронного письма для верификации. Пожалуйста, попробуйте еще раз."
      },
      "page": {
        "login.form": "ФормаВхода"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Страница Партнеров Podsqueeze",
        "affiliate.page.description": "Зарабатывайте 25% комиссионных с каждой продажи, сделанной по вашей эксклюзивной реферальной ссылке в течение 15 месяцев. Делитесь своей ссылкой на своем сайте, в социальных сетях или с друзьями. Присоединиться можно за считанные секунды. Автоматическое одобрение."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Лучший подарок для подкастера",
        "bestGiftForPodcaster.description": "Откройте для себя лучшие подарки для подкастеров, чтобы улучшить их опыт.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Получите больше слушателей подкастов",
        "get-more-podcast-listeners.description": "Получите больше слушателей подкастов и упростите производство с помощью автоматических заметок к шоу, коротких клипов для продвижения вашего шоу в социальных сетях и многого другого."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Увеличьте аудиторию вашего подкаста",
        "grow_your_podcast_audience.description": "Сэкономьте кучу времени и увеличьте аудиторию вашего подкаста с помощью Podsqueeze. Генерируйте полные заметки к шоу, посты в социальных сетях, короткие клипы и многое другое для вашего подкаста."
      },
      "index": {
        "home.page.title": "Заметки к подкасту, транскрипты, резюме и генератор клипов на основе ИИ.",
        "home.page.description": "Создавайте заметки, временные метки, информационные бюллетени и многое другое для вашего подкаста одним щелчком! Быстро генерируйте контент для вашего подкаста и настраивайте его под ваши нужды. Бесплатная регистрация."
      },
      "login": {
        "login.tryItNow": "Попробуйте сейчас!",
        "login.createAccountDescription": "Создайте аккаунт и начните генерировать заметки, временные метки, рассылки и многое другое для вашего подкаста одним кликом! Быстро создавайте контент для вашего подкаста и настраивайте его под ваши нужды. Бесплатная регистрация."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Маркетинг для подкастов",
        "marketing.for.podcasts.description": "Podsqueeze упрощает маркетинг для подкастов с помощью автоматически генерируемых заметок к шоу, публикаций в социальных сетях и коротких клипов, чтобы увеличить вашу аудиторию и развивать ваше шоу."
      },
      "media": {
        "media.page.title": "Страница медиа Podsqueeze",
        "media.page.description": "Узнайте больше о Podsqueeze. Свяжитесь с нами! Мы будем рады сотрудничеству!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Генератор описаний подкастов",
        "podcast.description.generator.description": "Увеличьте охват и вовлеченность вашего подкаста с помощью описаний, созданных ИИ. Автоматизируйте написание заметок к шоу и верните драгоценное время."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Переработайте ваш подкаст для публикаций в социальных сетях",
        "convert.podcast.episodes.to.social.media.posts": "Преобразуйте эпизоды подкаста в публикации в социальных сетях. Автоматически генерируйте посты для LinkedIn, Twitter, Facebook и короткие клипы для TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Бесплатный генератор тем для подкастов",
        "podcast.topics.generator.description": "Наш бесплатный генератор тем для подкастов помогает вам находить лучшие идеи тем и предсказывает их потенциальный охват в Google и YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Ваш виртуальный помощник для подкастов",
        "podcast.virtual.assistant.description": "Искусственный интеллект, виртуальный помощник для подкастов, который пишет ваши заметки к шоу и создает посты для социальных сетей. Упрощайте производство и маркетинг вашего подкаста с Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Цены",
        "pricing.description": "Создавайте заметки, временные метки, информационные бюллетени и многое другое для вашего подкаста одним щелчком мыши! У нас есть несколько уровней цен, чтобы удовлетворить ваши потребности в подкастинге."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Продвигайте свой подкаст",
        "promote.your.podcast.description": "Создавайте заметки к шоу, посты в социальных сетях и короткие клипы для публикации и продвижения вашего подкаста всего за несколько минут."
      },
      "register": {
        "create.podsqueeze.account": "Создать аккаунт Podsqueeze",
        "generate.content.podcast": "Создайте заметки к подкасту, временные метки, рассылки и многое другое для вашего подкаста одним кликом! Быстро генерируйте контент для вашего подкаста и настраивайте его под ваши нужды. Бесплатная регистрация."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Автоматически перерабатывайте контент подкаста",
        "repurpose.your.podcast.content.with.ai": "Перерабатывайте контент вашего подкаста с помощью ИИ. Автоматически генерируйте заметки к шоу, заголовки, короткие клипы для TikTok и многое другое — всё это одним кликом!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "БЕСПЛАТНЫЙ SEO Оптимизатор для подкастов",
        "seo.optimizer.description": "Анализируйте и оптимизируйте свои эпизоды подкаста для лучшей видимости в поисковых системах с помощью рекомендаций SEO на базе ИИ.",
        "seo.optimizer.heading": "SEO Оптимизатор Подкаста",
        "seo.optimizer.headingnote": "Анализируйте и оптимизируйте свои эпизоды подкаста для лучшей видимости в поисковых системах с помощью рекомендаций SEO на базе ИИ.",
        "seo.optimizer.selectEpisode": "Выберите эпизод для анализа",
        "seo.optimizer.results": "Результаты SEO-анализа",
        "seo.optimizer.searchPodcastPlaceholder": "Поиск подкаста",
        "seo.optimizer.searchEpisodesPlaceholder": "Поиск эпизодов...",
        "seo.optimizer.analyseAnotherEpisode": "Анализировать другой эпизод",
        "seo.optimizer.findingEpisodes": "Поиск всех эпизодов...",
        "seo.optimizer.analysingEpisode": "Анализ эпизода",
        "seo.optimizer.scoreTooltip": "Оценка:",
        "seo.optimizer.topKeywords": "Мы определили эти основные ключевые слова:",
        "seo.optimizer.topKeywordsnote": "На основе анализа ключевых слов внизу страницы.",
        "seo.optimizer.optimizedContent": "На основе ключевых слов вот оптимизированные заголовок и описание:",
        "seo.optimizer.originalTitle": "Оригинальный заголовок",
        "seo.optimizer.optimizedTitle": "Оптимизированный заголовок",
        "seo.optimizer.originalDescription": "Оригинальное описание",
        "seo.optimizer.optimizedDescription": "Оптимизированное описание",
        "seo.optimizer.showMore": "Показать больше",
        "seo.optimizer.showLess": "Показать меньше",
        "seo.optimizer.keywordAnalysis": "Анализ ключевых слов",
        "seo.optimizer.keywordAnalysisnote": "Оценки рассчитываются на основе объема поиска, конкуренции (сколько других результатов по тому же ключевому слову), а для YouTube — среднего количества просмотров на видео по тому же ключевому слову.",
        "seo.optimizer.seoScore": "Оценка SEO",
        "seo.optimizer.spotifyScore": "Оценка Spotify",
        "seo.optimizer.youtubeScore": "Оценка YouTube",
        "seo.optimizer.totalScore": "Итого"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - инструмент генерации контента для подкастов на основе ИИ",
        "podsqueeze.description": "Создавайте заметки к эпизодам, временные метки, рассылки и многое другое для вашего подкаста одним кликом! Быстро генерируйте контент для вашего подкаста и настраивайте его под свои нужды. Бесплатная регистрация."
      },
      "thumbnail-creator": {
        "title": "Бесплатный Генератор Миниатюр Подкастов - Создавайте Миниатюры Эпизодов с ИИ",
        "description": "Создавайте потрясающие миниатюры подкастов с помощью ИИ. Генерируйте профессиональные, привлекающие внимание визуальные эпизоды, которые повышают видимость и привлекают больше слушателей к вашему подкасту.",
        "selectPodcast": "Выберите Ваш Подкаст",
        "loadEpisodes": "Загрузить Эпизоды",
        "selectEpisode": "Выберите Эпизод для Создания Миниатюры",
        "createThumbnail": "Создать Миниатюру",
        "results": "Ваша Сгенерированная Миниатюра",
        "download": "Скачать",
        "share": "Поделиться",
        "regenerate": "Перегенерировать",
        "editThumbnail": "Редактировать Миниатюру",
        "editPlaceholder": "Опишите, как вы хотите изменить эту миниатюру...",
        "customPrompt": "Пользовательский Промпт",
        "yourThumbnail": "Ваша Миниатюра",
        "createAnother": "← Создать Другую Миниатюру",
        "findingEpisodes": "Поиск эпизодов...",
        "searchPodcastPlaceholder": "Найдите ваш подкаст...",
        "searchingPodcasts": "Поиск подкастов...",
        "heroDescription": "Генерируйте потрясающие, профессиональные миниатюры подкастов с дизайном на основе ИИ, который привлекает внимание и повышает видимость ваших эпизодов.",
        "generatedWithPrompt": "Сгенерировано с промптом:",
        "customPromptPlaceholder": "Введите пользовательский промпт для генерации миниатюр...",
        "generating": "Генерация...",
        "generate": "Генерировать",
        "modernMinimalist": "Современный и Минималистичный",
        "vibrantDynamic": "Яркий и Динамичный",
        "professionalClean": "Профессиональный и Чистый",
        "generatingThumbnail": "Генерация миниатюры...",
        "generatingNewThumbnail": "Генерация новой миниатюры...",
        "showingFirstEpisodes": "Показаны первые 10 эпизодов. Используйте поиск, чтобы найти конкретные эпизоды.",
        "imageUrlCopied": "URL изображения скопирован в буфер обмена!",
        "failedToGenerate": "Не удалось создать миниатюру. Попробуйте снова.",
        "promotionalTitle": "Генерируйте Заметки Шоу, Временные Метки, Вирусные Клипы и Многое Другое с Podsqueeze",
        "promotionalSubtitle": "Присоединяйтесь к 100K+ других создателей и начните развивать ваше шоу",
        "startNow": "Начать сейчас",
        "free": "БЕСПЛАТНО",
        "podcast": "ПОДКАСТ",
        "thumbnail": "МИНИАТЮРА",
        "creator": "СОЗДАТЕЛЬ",
        "replaceFace": "Заменить Лицо",
        "uploading": "Загрузка...",
        "uploadImageError": "Пожалуйста, загрузите файл изображения.",
        "uploadFailedError": "Не удалось загрузить изображение. Попробуйте снова.",
        "uploadingImage": "Загрузка изображения...",
        "generatingNewThumbnailLoading": "Генерация новой миниатюры...",
        "failedToGenerateWithFace": "Не удалось создать миниатюру с заменой лица. Попробуйте снова."
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Загрузка эпизодов...",
        "episodeList.noEpisodes": "Нет доступных публичных эпизодов",
        "episodeList.checkBack": "Загляните позже для новых эпизодов",
        "episodeList.title": "Эпизоды этого подкаста",
        "episodeList.readLess": "СВЕРНУТЬ",
        "episodeList.readMore": "ЧИТАТЬ ДАЛЕЕ",
        "episodeList.coverImageAlt": "Обложка для {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Начать",
        "alert.subscriptionRunning": "Ваша текущая подписка все еще активна.\n\nПожалуйста, отмените текущую подписку перед покупкой новой.",
        "alert.subscriptionEnds": "Ваша текущая подписка все еще активна.\n\nОна закончится {date}",
        "alert.subscriptionCancelled": "Ваша подписка уже отменена, и она закончится {date}",
        "button.openDashboard": "Открыть панель управления",
        "button.signUp": "Зарегистрироваться",
        "button.buySubscription": "Купить подписку",
        "button.cancelled": "Отменено",
        "button.cancelSubscription": "Отменить подписку",
        "button.upgradeSubscription": "Обновить подписку",
        "button.loading": "Загрузка",
        "upgrade.details.currentMinutes": "Это начнет новый период подписки. Вы сохраните все свои текущие минуты.",
        "upgrade.details.remainingAnnual": "Это значение было рассчитано на основе оставшегося времени в вашей текущей годовой подписке."
      },
      "page": {
        "pricing.free.title": "Бесплатно",
        "pricing.free.subtitle": "Попробуйте Podsqueeze. Кредитная карта не требуется.",
        "pricing.free.price.annual": "$0 Оплачивается ежегодно",
        "pricing.free.features.podcast_time": "30 минут подкастов в месяц",
        "pricing.free.features.video_clips": "3 видеоклипа",
        "common.with_watermark": "с водяным знаком",
        "pricing.free.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.free.features.file_upload": "Загрузка файлов до 4 Гб",
        "pricing.free.features.upload": "1 загрузка",
        "pricing.free.features.landing_pages": "Целевые страницы подкастов",
        "pricing.free.features.audio_enhancement": "Улучшение аудио",
        "common.sign_up": "Зарегистрироваться",
        "common.open_dashboard": "Открыть панель управления",
        "pricing.starter.title": "Стартовый",
        "pricing.starter.subtitle": "Идеально для любителей подкастов, которые хотят сэкономить время.",
        "pricing.starter.price.annual": "$132 Оплачивается ежегодно",
        "pricing.billed_annually": "Оплачивается ежегодно",
        "minutes.accumulate": "перенос минут",
        "pricing.starter.features.podcast_time": "160 минут подкастов в месяц",
        "pricing.starter.features.video_clips": "10 видеоклипов или аудиограмм",
        "pricing.starter.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.starter.features.file_upload": "Загрузка файлов до 4 Гб",
        "pricing.starter.features.unlimited_uploads": "Неограниченные загрузки",
        "pricing.starter.features.landing_pages": "Целевые страницы подкастов",
        "pricing.pro.title": "Про",
        "pricing.pro.subtitle": "Для профессионалов, которые используют подкасты для развития и поддержки своего бизнеса.",
        "pricing.pro.price.annual": "$324 Оплачивается ежегодно",
        "pricing.pro.features.podcast_time": "320 минут подкастов в месяц",
        "pricing.pro.features.personalize_ai_voice": "Персонализировать AI голос",
        "pricing.pro.features.video_clips": "20 видеоклипов или аудиограмм",
        "common.no_watermark": "без водяного знака",
        "pricing.pro.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.pro.features.file_upload": "Загрузка файлов до 10 Гб",
        "pricing.pro.features.unlimited_uploads": "Неограниченные загрузки",
        "pricing.pro.features.landing_pages": "Целевые страницы подкастов",
        "common.customizable": "настраиваемый",
        "pricing.pro.features.audio_video_edit": "Магическая редакция аудио и видео",
        "pricing.agency_lite.title": "Агентство Лайт",
        "pricing.agency_lite.subtitle": "Для подкаст-агентств, которые хотят оптимизировать и развивать свой бизнес.",
        "pricing.agency_lite.price.annual": "$495 Оплачивается ежегодно",
        "pricing.agency_lite.features.podcast_time": "600 минут подкастов в месяц",
        "pricing.agency_lite.features.personalize_ai_voice": "Персонализировать AI голос",
        "pricing.agency_lite.features.video_clips": "40 видеоклипов или аудиограмм",
        "pricing.agency_lite.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.agency_lite.features.file_upload": "Загрузка файлов до 10 Гб",
        "pricing.agency_lite.features.unlimited_uploads": "Неограниченные загрузки",
        "pricing.agency_lite.features.landing_pages": "Целевые страницы подкастов",
        "pricing.agency_lite.features.audio_video_edit": "Магическая редакция аудио и видео",
        "pricing.agency_plus.title": "Агентство Плюс",
        "pricing.agency_plus.subtitle": "Для подкаст-агентств, которые хотят оптимизировать и развивать свой бизнес.",
        "pricing.agency_plus.price.annual": "$1.251 Оплачивается ежегодно",
        "pricing.agency_plus.features.podcast_time": "2000 минут подкастов в месяц",
        "pricing.agency_plus.features.personalize_ai_voice": "Персонализировать AI голос",
        "pricing.agency_plus.features.video_clips": "80 видеоклипов или аудиограмм",
        "pricing.agency_plus.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.agency_plus.features.file_upload": "Загрузка файлов до 10 Гб",
        "pricing.agency_plus.features.unlimited_uploads": "Неограниченные загрузки",
        "pricing.agency_plus.features.landing_pages": "Целевые страницы подкастов",
        "pricing.agency_plus.features.audio_video_edit": "Магическая редакция аудио и видео",
        "pricing.agency_scale.title": "Агентство Масштаб",
        "pricing.agency_scale.subtitle": "Для подкаст-агентств, которые хотят оптимизировать и развивать свой бизнес.",
        "pricing.agency_scale.price.annual": "$2.175 Оплачивается ежегодно",
        "pricing.agency_scale.features.podcast_time": "4000 минут подкастов в месяц",
        "pricing.agency_scale.features.personalize_ai_voice": "Персонализировать AI голос",
        "pricing.agency_scale.features.video_clips": "160 видеоклипов или аудиограмм",
        "pricing.agency_scale.features.quote_images": "Неограниченное количество изображений с цитатами",
        "pricing.agency_scale.features.file_upload": "Загрузка файлов до 10 Гб",
        "pricing.agency_scale.features.unlimited_uploads": "Неограниченные загрузки",
        "pricing.agency_scale.features.landing_pages": "Целевые страницы подкастов",
        "pricing.agency_scale.features.audio_video_edit": "Магическая редакция аудио и видео",
        "pricing.header": "Для одиночных подкастеров и подкаст-агентств",
        "pricing.minutes_reset": "Вы можете накопить до 3 раз больше ваших ежемесячных минут, пока вы остаетесь на текущем тарифе или обновляете его.",
        "pricing.most_popular": "Самый популярный",
        "pricing.minutes_per_month": "Минут в месяц",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Для подкаст-агентств и медийных компаний, которые хотят оптимизировать и развивать свое дело.",
        "pricing.enterprise_price": "Настроенный",
        "pricing.enterprise_price_note": "Свяжитесь с team@podsqueeze.com или запишите демонстрацию ниже.",
        "pricing.enterprise_feature_priority_support": "Приоритетная поддержка",
        "pricing.enterprise_feature_team_sits": "Сессии команды",
        "pricing.enterprise_personalized_team_training": "Настройка команды и обучение",
        "pricing.book_demo": "Записать демонстрацию"
      },
      "toggle": {
        "pay.monthly": "Месяц",
        "pay.annually": "Год",
        "discount.30percent": "СКИДКА 30%"
      },
      "upgradeModal": {
        "upgrade.success": "Ваша подписка была успешно обновлена",
        "upgrade.error": "Извините, что-то пошло не так. Пожалуйста, попробуйте позже",
        "upgrade.loading": "Обновление",
        "upgrade.confirmPay": "Подтвердить и оплатить",
        "upgrade.cancel": "Отмена",
        "coupon.placeholder": "Код купона",
        "coupon.apply": "Применить",
        "coupon.have": "У меня есть купон",
        "upgrade.confirmation": "Вы собираетесь обновить до",
        "upgrade.price": "Вы заплатите"
      }
    },
    "register": {
      "page": {
        "register.form": "ФормаРегистрации"
      },
      "registerForm": {
        "error.invalidCredentials": "Пожалуйста, введите действительный адрес электронной почты и пароль.",
        "error.weakPassword": "Пожалуйста, используйте более надежный пароль 💪",
        "error.emailInUse": "Пользователь уже существует",
        "error.userNotFound": "Пользователь не найден",
        "error.generic": "Упс, что-то пошло не так",
        "placeholder.email": "Адрес электронной почты",
        "placeholder.password": "Пароль",
        "button.registering": "Регистрация...",
        "button.register": "Зарегистрироваться",
        "label.newsletter": "Присоединяйтесь к 12,000 подкастерам и подписывайтесь на нашу рассылку для получения обновлений о продуктах, полезных советов, электронных книг, розыгрышей и многого другого.",
        "label.alreadyHaveAccount": "Уже есть аккаунт?",
        "label.logInHere": "Войдите здесь",
        "label.or": "ИЛИ",
        "button.signingIn": "Вход в систему...",
        "button.continueWithGoogle": "Продолжить с Google",
        "label.podcastDescription": "Легко запустите и развивайте свой аудио- или видеоподкаст с помощью всего необходимого в одном месте.",
        "feature.transcripts": "Транскрипции",
        "feature.showNotes": "Заметки к шоу",
        "feature.newslettersBlogs": "Рассылки и блоги",
        "feature.socialPosts": "Социальные посты",
        "feature.shortClips": "Короткие клипы и аудиограммы",
        "feature.podcastWebsite": "Веб-сайт подкаста",
        "feature.audioEnhancement": "Улучшение звука с помощью ИИ",
        "feature.removeSilences": "Удаление пауз и 'эээ'"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "текст"
      },
      "TopicFinder": {
        "competition.veryHigh": "ОЧЕНЬ ВЫСОКИЙ",
        "competition.high": "ВЫСОКИЙ",
        "competition.medium": "СРЕДНИЙ",
        "competition.low": "НИЗКИЙ",
        "competition.veryLow": "ОЧЕНЬ НИЗКИЙ",
        "upgrade.button": "Перейти на Pro",
        "clicks.label": "клики",
        "searches.label": "поиски",
        "competition.label": "конкуренция",
        "fetching.results": "Получение результатов",
        "table.topic": "Тема",
        "tooltip.topic": "Основная тема, охватываемая вашим эпизодом подкаста",
        "table.monthlySearches": "Ежемесячные поиски",
        "tooltip.monthlySearches": "Диапазон ежемесячных поисков в Google, который вы можете ожидать",
        "table.competition": "Конкуренция",
        "tooltip.competition": "Основной предмет или тема, охватываемая подкастом.",
        "table.monthlyGoogleClicks": "Ежемесячные клики в Google",
        "tooltip.monthlyGoogleClicks": "Прогноз диапазона ежемесячных кликов в Google, который вы можете ожидать",
        "table.youtubeReach": "Охват на YouTube",
        "tooltip.youtubeReach": "Прогноз максимального количества просмотров на YouTube, которое вы можете ожидать в первые 6 месяцев, на основе среднего конкурента",
        "intro.title": "Бесплатный генератор тем для подкастов",
        "intro.description": "Получите идеи тем для вашего подкаста, которые ищут аудитории",
        "intro.check1": "Проверьте спрос на каждую идею темы в Google",
        "intro.check2": "Узнайте, насколько конкурентоспособна каждая идея темы подкаста",
        "intro.check3": "Оцените клики в Google и просмотры на YouTube, которые вы можете получить",
        "upgrade.message": "Вам нужно перейти на Pro, чтобы получить доступ ко всем результатам",
        "learnMore.label": "Узнайте больше о",
        "learnMore.link": "бесплатном инструменте генератора тем для подкастов",
        "newSearch.button": "Новый поиск",
        "share.button": "Поделиться этим поиском",
        "form.label": "Введите ваши ниши подкаста",
        "form.placeholder": "Цифровой маркетинг",
        "form.submit": "Найти идеи тем"
      },
      "page": {
        "main.background": "фон"
      },
      "shareTopics": {
        "share.results": "Поделиться результатами",
        "share.facebook": "Поделиться на Facebook",
        "share.whatsapp": "Поделиться в WhatsApp",
        "share.twitter": "Поделиться в Twitter",
        "share.linkedin": "Поделиться в LinkedIn",
        "copy.success": "Скопировано",
        "copy.link": "Скопировать ссылку"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "просмотры"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Не удалось получить текущую композицию",
        "error.addImage": "Ошибка при добавлении элемента изображения:",
        "alert.uploadImage": "Пожалуйста, загрузите файл изображения.",
        "error.uploadImage": "Ошибка при загрузке изображения:",
        "alert.uploadFailed": "Не удалось загрузить изображение. Пожалуйста, попробуйте снова.",
        "error.getDownloadURL": "Ошибка при получении URL для загрузки:",
        "alert.processImageFailed": "Не удалось обработать загруженное изображение. Пожалуйста, попробуйте снова.",
        "error.addText": "Ошибка при добавлении текстового элемента:",
        "text.settingsPlaceholder": "Настройки будут показаны при выборе элемента",
        "text.addElement": "Добавить элемент",
        "text.uploading": "Загрузка...",
        "button.uploadImage": "Загрузить изображение",
        "text.newText": "Новый текст",
        "button.addText": "Добавить текст",
        "text.selectedElementSettings": "Настройки выбранного элемента"
      },
      "FontSelector": {
        "allFonts": "Все шрифты",
        "myFonts": "Мои шрифты",
        "uploadFont": "Загрузить шрифт",
        "noCustomFonts": "Пользовательских шрифтов пока нет.",
        "uploadToAdd": "Загрузите файл шрифта, чтобы добавить его в свою коллекцию.",
        "text_outline": "Обводка текста",
        "outline_color": "Цвет обводки",
        "outline_width": "Толщина обводки"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "По размеру",
        "imageLayoutSettings.zoom": "Масштаб",
        "imageLayoutSettings.horizontalAlignment": "Горизонтальное выравнивание",
        "imageLayoutSettings.verticalAlignment": "Вертикальное выравнивание",
        "imageLayoutSettings.deleteElement": "Удалить элемент"
      },
      "TemplateBox": {
        "confirm.delete.template": "Вы уверены, что хотите удалить этот шаблон?"
      },
      "TextSettings": {
        "error.getting_current_text": "Ошибка получения текущего текста:",
        "event.delete_text_element_clicked": "Нажата кнопка удаления текстового элемента",
        "error.changing_text_font": "Ошибка изменения шрифта текста:",
        "event.text_font_changed": "Шрифт текста изменен",
        "error.changing_text_size": "Ошибка изменения размера текста:",
        "event.text_size_changed": "Размер текста изменен",
        "error.changing_text_color": "Ошибка изменения цвета текста:",
        "event.text_color_changed": "Цвет текста изменен",
        "event.text_content_added": "Текстовое содержимое добавлено",
        "error.adding_text_content": "Ошибка добавления текстового содержимого:",
        "event.text_content_updated": "Текстовое содержимое обновлено",
        "label.text_content": "Текстовое содержимое",
        "label.text_font": "Шрифт текста",
        "label.text_font_weight": "Толщина шрифта",
        "label.adjust_text_size": "Настроить размер текста",
        "label.text_color": "Цвет текста",
        "button.delete": "Удалить"
      },
      "audiogramBaseTemplate": {
        "color.white": "Белый",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "urlЭпизодаПоУмолчанию",
        "time.0s": "0 с",
        "font.inter": "Inter",
        "duration.1s": "1 с",
        "easing.quadraticOut": "квадратичный-выход",
        "animation.fade": "плавный переход",
        "type.text": "текст",
        "name.podcastTitle": "НазваниеПодкаста",
        "name.snippetTitle": "НазваниеФрагмента",
        "type.image": "изображение",
        "name.audioBackgroundImage": "ФоновоеИзображениеАудио",
        "name.subtitlesText": "текстСубтитров",
        "effect.highlight": "выделение",
        "type.audio": "аудио",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "названиеФрагмента",
        "podcast.title": "названиеПодкаста",
        "new.episode": "НОВЫЙ ЭПИЗОД"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Белый",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "urlЭпизодаПоУмолчанию",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "фоновая_музыка",
        "audio.type": "аудио"
      },
      "imageElement": {
        "upload.image.error": "Пожалуйста, загрузите файл изображения.",
        "upload.file.loading": "Загрузка файла. Пожалуйста, не закрывайте это окно.",
        "upload.image.label": "Заменить изображение",
        "ai.prompt.label": "Введите подсказку для ИИ, чтобы сгенерировать изображение",
        "ai.prompt.placeholder": "Напр: Собака, бегущая в парке...",
        "ai.processing": "Обработка...",
        "ai.create": "Создать",
        "customize.image.title": "Настроить изображение",
        "enter.image.url": "Введите URL изображения",
        "or": "или"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Ошибка при получении шаблонов:",
        "template.savedSuccessfully": "Шаблон успешно сохранен",
        "error.savingTemplate": "Ошибка при сохранении шаблона:",
        "loading.savedTemplates": "Загрузка сохраненных шаблонов...",
        "no.savedTemplates": "Нет сохраненных шаблонов",
        "select_template": "Выбрать шаблон",
        "saving.template": "Сохранение шаблона...",
        "template_name": "Название шаблона",
        "enter.templateName": "Введите название шаблона",
        "cancel": "Отмена",
        "save": "Сохранить",
        "default_templates": "Шаблоны по умолчанию",
        "saved_templates_count": "Сохраненные шаблоны ({count})",
        "folder_templates_count": "Шаблоны папок ({count})",
        "account_templates_count": "Шаблоны аккаунта ({count})",
        "save_current_template": "Сохранить текущий шаблон"
      },
      "subtitlesElement": {
        "edit.word": "Редактировать слово",
        "edit.label": "редактировать",
        "remove.word.subtitle": "Удалить слово только из субтитров",
        "erase.subtitle": "удалить из субтитров",
        "remove.word.clip": "Удалить слово из аудио и субтитров",
        "remove.clip": "удалить из клипа"
      },
      "utils": {
        "video.utils.title": "Название",
        "video.utils.currentTime": "Текущее время",
        "video.utils.nextTime": "Следующее время",
        "video.utils.duration": "Продолжительность",
        "video.utils.description": "Описание",
        "video.utils.srtSegment": "SRT сегмент"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Ваш текст субтитров здесь"
      }
    }
  },
  "th": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "เป็นพาร์ทเนอร์กับเรา",
        "SHARE_PODSQUEEZE": "แบ่งปัน Podsqueeze ให้กับผู้ชมของคุณ",
        "AND_EARN_MONEY": "และรับเงิน!",
        "LAST_UPDATED": "อัปเดตล่าสุด: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "เป็นพาร์ทเนอร์พันธมิตร",
        "EARN_COMMISSION": "รับ",
        "COMMISSION": "ค่าคอมมิชชั่น",
        "ON_EVERY_SALE": "ในทุกการขายที่ทำผ่านลิงก์การอ้างอิงพิเศษของคุณเป็นระยะเวลา 15 เดือน แบ่งปันลิงก์ของคุณบนเว็บไซต์ของคุณ สื่อสังคมออนไลน์ หรือกับเพื่อนๆ ใช้เวลาเพียงไม่กี่วินาทีในการเข้าร่วม",
        "GET_AUTOMATICALLY_APPROVED": "ได้รับการอนุมัติอัตโนมัติ",
        "JOIN_NOW": "เข้าร่วมทันที",
        "HOW_IT_WORKS": "วิธีการทำงาน",
        "FREQUENTLY_ASKED_QUESTIONS": "คำถามที่พบบ่อย",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "พาร์ทเนอร์พันธมิตรคืออะไร?",
        "AFFILIATE_PARTNER_DESCRIPTION": "พาร์ทเนอร์พันธมิตรคือผู้ที่โปรโมตผลิตภัณฑ์หรือบริการของบริษัทอื่นผ่านลิงก์การอ้างอิงที่ไม่ซ้ำใครและรับค่าคอมมิชชั่นในทุกการขายที่ทำผ่านลิงก์นั้น",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "ฉันจะเป็นพาร์ทเนอร์พันธมิตรได้อย่างไร?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "การเป็นพาร์ทเนอร์พันธมิตรนั้นง่ายและรวดเร็ว ใช้เวลาเพียงไม่กี่วินาที ในการเริ่มต้น เพียงคลิกที่ปุ่ม 'เข้าร่วมทันที' และลงทะเบียนโดยใช้ที่อยู่อีเมลของคุณ เมื่อสมัครเสร็จแล้ว คุณจะสามารถเข้าถึงแผงควบคุมที่ใช้งานง่ายซึ่งคุณจะพบลิงก์การอ้างอิงที่ไม่ซ้ำกันของคุณ แบ่งปันลิงก์นี้กับครอบครัว เพื่อนๆ หรือผู้ชมออนไลน์ของคุณ ทุกครั้งที่มีคนคลิกลิงก์การอ้างอิงของคุณและทำการซื้อบนเว็บไซต์ของ Podsqueeze คุณจะได้รับค่าคอมมิชชั่น 25% ในการชำระเงินทุกครั้งเป็นเวลา 15 เดือนเต็ม! ติดตามรายได้ของคุณได้อย่างง่ายดายผ่านแผงควบคุมพันธมิตรของคุณ ซึ่งให้ภาพรวมที่ชัดเจนของการขายทั้งหมดที่คุณสร้างขึ้น",
        "HOW_CAN_I_TRACK_MY_SALES": "ฉันจะติดตามการขายและค่าคอมมิชชั่นของฉันได้อย่างไร?",
        "TRACKING_SALES_DESCRIPTION": "ใช้แผงควบคุมโปรแกรมพันธมิตรของเราเพื่อติดตามการขายและค่าคอมมิชชั่นของคุณ ซอฟต์แวร์ติดตามสามารถใช้ได้กับทั้งพาร์ทเนอร์พันธมิตรและพาร์ทเนอร์ธุรกิจ",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "ฉันจะได้รับเงินเมื่อไหร่และอย่างไร?",
        "PAYMENT_DESCRIPTION": "คุณจะได้รับเงินผ่าน PayPal ทุก 30 วัน โปรดทราบว่ามีเกณฑ์การจ่ายเงินขั้นต่ำที่ $50 เมื่อคุณถึงจำนวนนี้แล้ว คุณสามารถคาดหวังว่าจะได้รับเงินของคุณทุก 30 วัน",
        "STILL_GOT_QUESTIONS": "ยังมีคำถามอีกหรือ?",
        "SEND_US_A_MESSAGE": "ส่งข้อความถึงเราผ่านการสนับสนุนแชทหรือส่งอีเมลถึงเราที่ team@podsqueeze.com",
        "NOTE": "หมายเหตุ",
        "AFFILIATE_ADS_RESTRICTION": "พันธมิตรไม่สามารถสร้างโฆษณาบน Google หรือมีส่วนร่วมในการประมูลคำหลักที่เกี่ยวข้องกับ Podsqueeze",
        "AFFILIATE_TERMS_OF_USE": "เงื่อนไขการใช้งานของพันธมิตร",
        "CAN_I_RUN_ADS": "ฉันสามารถทำโฆษณาและแคมเปญ CPC บน Google เพื่อโปรโมตลิงก์การอ้างอิงของฉันได้หรือไม่?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "พันธมิตรไม่ได้รับอนุญาตให้สร้างโฆษณาในเครื่องมือค้นหาหรือมีส่วนร่วมในการประมูลคำหลักที่เกี่ยวข้องกับ Podsqueeze ข้อจำกัดนี้ช่วยรักษาความซื่อสัตย์ของกลยุทธ์การโฆษณาของเราและช่วยให้มั่นใจในข้อความของแบรนด์ โปรดทราบว่าการขายที่เกิดจากแคมเปญการประมูลดังกล่าวจะไม่ได้รับสิทธิ์ในการจ่ายเงิน",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Podsqueeze สร้างชื่อเรื่องสำหรับพอดแคสต์ของคุณอย่างไร?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "แถบการนำทาง",
        "main.affiliateHero": "พันธมิตรฮีโร่",
        "main.footer": "ส่วนท้าย"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "เพิ่มดนตรีเปิดและปิด",
        "intro.music": "ดนตรีเปิด",
        "outro.music": "ดนตรีปิด",
        "intro.duration": "ระยะเวลาเปิด",
        "outro.duration": "ระยะเวลาปิด",
        "intro.mode": "โหมดเปิด",
        "outro.mode": "โหมดปิด",
        "cancel": "ยกเลิก",
        "save": "บันทึก",
        "apply": "นำไปใช้",
        "current.intro.music": "ดนตรีเปิดปัจจุบัน",
        "current.outro.music": "ดนตรีปิดปัจจุบัน",
        "change.music": "เปลี่ยนดนตรี",
        "choose.music": "เลือกไฟล์ดนตรี",
        "browser.not.support.audio": "เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง",
        "save.and.apply": "บันทึกและนำไปใช้",
        "no.music.selected": "ไม่ได้เลือกดนตรี",
        "delete.music": "ลบดนตรี",
        "uploading.file": "กำลังอัปโหลดไฟล์..."
      },
      "audioEditElements": {
        "error.processing.rss": "เรากำลังประสบปัญหาในการประมวลผลฟีด RSS บางรายการ กรุณาอัปโหลดไฟล์",
        "edit.enhance.audio": "แก้ไขและปรับปรุงการบันทึกเสียงของคุณ",
        "trial.label": "ทดลองใช้งาน",
        "audio.editing.experience": "สัมผัสประสบการณ์การแก้ไขเสียงที่ราบรื่นด้วยอัลกอริธึม AI ขั้นสูงเพื่อผลลัพธ์ที่เป็นธรรมชาติและมีคุณภาพสูง เพียงแค่คลิกเดียว",
        "improve.audio.quality": "ปรับปรุงคุณภาพเสียง",
        "remove.hums.silences": "ลบเสียงฮัมและความเงียบ",
        "upgrade.edit.audio": "อัปเกรดเพื่อให้สามารถแก้ไขเสียงของคุณด้วยการคลิกเพียงครั้งเดียว",
        "available.plans": "มีให้สำหรับทั้งหมดราคาที่จ่าย",
        "upgrade.now": "อัปเกรดตอนนี้",
        "audio.element.support": "เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง",
        "download.audio": "ดาวน์โหลดเสียง",
        "loading.audio": "กำลังดาวน์โหลดเสียง",
        "editing.audio": "กำลังแก้ไขเสียง"
      },
      "videoEditElements": {
        "error.exporting.video": "เกิดข้อผิดพลาดขณะส่งออกวิดีโอ",
        "download.failed": "การดาวน์โหลดล้มเหลว: {error.message}",
        "generating.video": "กำลังสร้างวิดีโอ",
        "error.generating.clip": "เกิดข้อผิดพลาดในการสร้างคลิป",
        "please.retry.support": "กรุณาลองอีกครั้งหรือติดต่อฝ่ายสนับสนุนผู้ใช้ของเรา",
        "browser.not.support.video": "เบราว์เซอร์ของคุณไม่รองรับแท็กวิดีโอ",
        "this.might.take.minutes": "กรุณาอย่าปิดหน้าต่างนี้ อาจใช้เวลาสักครู่",
        "exporting.video": "กำลังส่งออกวิดีโอของคุณ...",
        "seamless.audio.editing": "สัมผัสประสบการณ์การแก้ไขเสียงที่ไร้รอยต่อด้วยอัลกอริธึม AI ขั้นสูงเพื่อผลลัพธ์ที่เป็นธรรมชาติและมีคุณภาพสูง เพียงแค่คลิกเดียว",
        "difficulties.processing.rss": "เรากำลังประสบปัญหาในการประมวลผลฟีด RSS บางรายการ กรุณาอัปโหลดไฟล์",
        "edit.enhance.video.recording": "แก้ไขและปรับปรุงการบันทึกวิดีโอของคุณ",
        "trial": "ทดลองใช้งาน",
        "enhance.audio.quality": "ปรับปรุงคุณภาพเสียง",
        "enhance.audio.quality.edit": "ปรับปรุงคุณภาพเสียง & แก้ไข",
        "trim.filler.words.video": "ตัดคำฟุ่มเฟือยออกจากวิดีโอ (เช่น: เสียงฮัม)",
        "trim.long.silences.video": "ตัดความเงียบยาวออกจากวิดีโอ",
        "upgrade.to.edit.video": "อัปเกรดเพื่อให้สามารถแก้ไขวิดีโอของคุณได้ด้วยการคลิกเพียงครั้งเดียว",
        "available.pro.agency.plans": "มีให้สำหรับแผน Pro และ Agency",
        "upgrade.now": "อัปเกรดตอนนี้",
        "download.only.audio": "ดาวน์โหลดเฉพาะเสียง",
        "download.video": "ดาวน์โหลดวิดีโอ",
        "please.dont.close.window": "กรุณาอย่าปิดหน้าต่าง",
        "export.video": "ส่งออกวิดีโอ"
      },
      "videogramBaseTemplate": {
        "media.fit": "ครอบคลุม",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "สื่อ"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "ตอนอื่นๆ จากพอดคาสต์นี้",
        "tab.shownotes": "โน้ตรายการ",
        "tab.timestamps": "ตัวบอกเวลา",
        "tab.blogpost": "บทความบล็อก",
        "tab.transcript": "บทถอดเสียง",
        "key.points": "ประเด็นสำคัญ"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "หน้าแลนดิ้งของคุณเผยแพร่ในเครื่องมือค้นหาพอดแคสต์ของเรา แชร์ให้กับผู้ฟังของคุณ!",
        "landingPage.create": "สร้างหน้าแลนดิ้งที่สวยงามสำหรับตอนนี้",
        "landingPage.edit": "แก้ไขหน้า",
        "landingPage.visit": "เยี่ยมชมหน้า",
        "landingPage.delete": "ลบหน้า",
        "landingPage.createButton": "สร้างหน้าแลนดิ้ง"
      },
      "SocialLinksModal": {
        "manage.episode.links": "จัดการลิงก์ตอน",
        "youtube.link": "ลิงก์ YouTube",
        "enter.youtube.link": "กรอกลิงก์ YouTube",
        "apple.podcasts.link": "ลิงก์ Apple Podcasts",
        "enter.apple.podcasts.link": "กรอกลิงก์ Apple Podcasts",
        "spotify.link": "ลิงก์ Spotify",
        "enter.spotify.link": "กรอกลิงก์ Spotify",
        "saving": "กำลังบันทึก...",
        "save": "บันทึก",
        "social.links.updated.successfully": "อัปเดตลิงก์โซเชียลเรียบร้อยแล้ว!"
      },
      "affiliatesection": {
        "affiliate.section.title": "เข้าร่วมเป็นพันธมิตร",
        "affiliate.section.subtitle": "แชร์ Podsqueeze กับผู้ชมของคุณและ",
        "affiliate.section.earn": "รับเงิน!",
        "affiliate.section.commission": "โปรแกรมพันธมิตรของเรามีค่าคอมมิชชั่น 25% เป็นเวลา 15 เดือน สำหรับการขายและการต่ออายุการสมัครสมาชิกทุกครั้ง",
        "affiliate.section.join": "ใช้เวลาเพียงไม่กี่วินาทีในการเข้าร่วม!",
        "affiliate.section.knowMore": "เรียนรู้เพิ่มเติม"
      },
      "asseenon": {
        "podnews.logo": "โลโก้ podnews",
        "transistor.logo": "โลโก้ transistor",
        "thepodcasthost.logo": "โลโก้ the podcast host",
        "schoolofpodcasting.logo": "โลโก้ School of podcasting",
        "semrush.logo": "โลโก้ semrush"
      },
      "assembleshownotes": {
        "episode.description": "คำอธิบายตอน",
        "bullet.points": "จุดสำคัญ",
        "timestamps": "เวลาที่บันทึก",
        "links.and.mentions": "ลิงก์ & การกล่าวถึง",
        "extra.content": "เนื้อหาเพิ่มเติม",
        "assemble.show.notes": "จัดทำบันทึกการแสดงของคุณ",
        "downloading": "กำลังดาวน์โหลด",
        "copied": "คัดลอกแล้ว",
        "enter.placeholder": "กรอก {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "หยุดพักจากการทำพอดแคสต์",
        "cancellation.option.no_recurrent": "ฉันไม่ต้องการการสมัครสมาชิกแบบต่อเนื่อง",
        "cancellation.option.expensive": "มันแพงเกินไป",
        "cancellation.option.not_saving_time": "ไม่ช่วยประหยัดเวลาให้ฉันเพียงพอ",
        "cancellation.option.dissatisfied_content": "ไม่พอใจกับคุณภาพของเนื้อหาที่สร้างขึ้น",
        "cancellation.option.unresponsive_support": "การสนับสนุนลูกค้าไม่ตอบสนอง",
        "cancellation.option.not_using": "ไม่ใช้บริการเพียงพอ",
        "cancellation.option.difficulty_navigating": "มีความยากลำบากในการใช้/นำทางผลิตภัณฑ์",
        "cancellation.option.better_alternative": "พบผลิตภัณฑ์ทางเลือกที่ดีกว่า",
        "cancellation.option.other": "อื่นๆ",
        "cancellation.video.message": "70% ของผู้ใช้ของเราหยุดกระบวนการยกเลิกหลังจากดูวิดีโอนี้",
        "cancellation.button.cancel": "ฉันยังต้องการยกเลิก",
        "cancellation.button.try_again": "ฉันต้องการลองอีกครั้ง",
        "cancellation.prompt.select_reason": "กรุณาช่วยเราในการปรับปรุงผลิตภัณฑ์โดยการเลือกเหตุผลในการยกเลิกการสมัครสมาชิกของคุณ:",
        "cancellation.placeholder.answer": "พิมพ์คำตอบของคุณที่นี่...",
        "cancellation.placeholder.specify_reason": "กรุณาระบุเหตุผลในการยกเลิกของคุณ",
        "cancellation.button.next": "ถัดไป",
        "cancellation.button.go_back": "กลับไป",
        "cancellation.last_question.title": "คำถามสุดท้ายจากเรา",
        "lose.all.accumulated.minutes": "หากคุณยกเลิก คุณจะสูญเสียทุกนาทีที่สะสม",
        "here.are.some.ideas": "นี่คือบางความคิดที่จะทำให้คุณสามารถดำเนินการต่อจาก Podsqueeze",
        "keep.accumulating.minutes": "ดำเนินการต่อจาก Podsqueeze",
        "convert.and.repurpose.episodes": "แปลงและนำมาใช้ใหม่จากรายการที่เก่า",
        "generate.articles.favorite.podcasts.and.vides": "สร้างบทความจากรายการที่คุณชอบ",
        "share.your.account.with.a.friend": "แชร์บัญชีของคุณกับเพื่อนของคุณ พวกเขาอาจจะได้รับประโยชน์",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "นี่คือวิดีโอที่แสดงวิธีการทำความเข้าใจกับ Podsqueeze",
        "cancellation.last_question.prompt": "การเปลี่ยนแปลงหรือการปรับปรุงใดที่จะทำให้คุณพิจารณากลับมาใช้บริการของเราอีกครั้ง?",
        "cancellation.feedback.message": "ความคิดเห็นของคุณจะช่วยให้เราปรับปรุง 🙏",
        "cancellation.button.confirm": "ยืนยันการยกเลิก",
        "cancellation.minutes.accumulated": "คุณมี",
        "cancellation.minutes.accumulated.suffix": "นาทีที่สะสมมูลค่า",
        "cancellation.reminder.text": "โปรดจำไว้:",
        "cancellation.minutes.warning": "นาทีที่สะสมเป็นสิทธิพิเศษสำหรับการสมัครสมาชิกที่ใช้งานอยู่ การยกเลิกการสมัครสมาชิกของคุณนาทีจะหายไปอย่างถาวร",
        "cancellation.content.deletion.warning": "เนื้อหาที่สร้างทั้งหมดของคุณจะถูกลบอย่างถาวรหลังจาก 30 วัน",
        "cancellation.minutes.left.title": "คุณยังคงมีนาทีเหลืออยู่! อย่าให้มันสูญเปล่า!",
        "cancellation.suggestion.clips": "นำตอนเก่าที่มีอยู่มาใช้ในคลิปสำหรับโซเชียลมีเดีย",
        "cancellation.suggestion.articles": "เปลี่ยนตอนเก่าเป็นบทความด้วย Podsqueeze เพื่อได้รับประโยชน์จาก SEO",
        "cancellation.suggestion.linkedin": "เปลี่ยนตอนที่มีอำนาจเก่าเป็นโพสต์ LinkedIn เพื่อเสริมสร้างแบรนด์ส่วนตัวของคุณ",
        "cancellation.suggestion.share": "แชร์บัญชี Podsqueeze ของคุณกับเพื่อนเพื่อให้พวกเขาได้รับประโยชน์จากนาทีที่ไม่ได้ใช้ของคุณ",
        "cancellation.button.keep.subscription": "เก็บการสมัครสมาชิกของฉัน",
        "cancellation.button.keep.minutes": "เก็บ",
        "cancellation.button.keep.minutes.suffix": "มูลค่านาทีของฉัน",
        "cancellation.lifetime.before_you_go": "ก่อนที่คุณจะไป...",
        "cancellation.lifetime.title": "การเข้าถึงตลอดชีวิตในราคาเพียง $49 เป็นอย่างไร?",
        "cancellation.lifetime.subtitle": "เก็บบัญชี Starter ของคุณ ไม่มีการสมัครสมาชิก ไม่มีการต่ออายุ เป็นของคุณ — ตลอดไป",
        "cancellation.lifetime.feature1": "การเข้าถึง Podsqueeze ตลอดชีวิตด้วยการชำระเงินครั้งเดียว $49",
        "cancellation.lifetime.feature2": "ใช้เมื่อคุณต้องการ ไม่มีแรงกดดัน — เป็นของคุณตลอดไป",
        "cancellation.lifetime.feature3": "รวมฟีเจอร์ปัจจุบันและอนาคตทั้งหมดของแผน Starter",
        "cancellation.lifetime.button_cancel": "ฉันยังคงต้องการยกเลิก",
        "cancellation.lifetime.button_deal": "รับดีลตลอดชีวิต",
        "cancellation.downgrade.title": "เก็บเนื้อหาทั้งหมดของคุณในราคาเพียง $5.99/เดือน",
        "cancellation.downgrade.subtitle": "การลดระดับไป Starter ทำให้คุณสามารถ...",
        "cancellation.downgrade.feature1": "เก็บเนื้อหาที่สร้างทั้งหมด",
        "cancellation.downgrade.feature2": "เก็บเว็บไซต์ของคุณให้ทำงานต่อไป",
        "cancellation.downgrade.feature3": "160 นาทีและ 10 คลิปต่อเดือนสำหรับงานเป็นครั้งคราว",
        "cancellation.billing.monthly": "รายเดือน",
        "cancellation.billing.annual": "รายปี",
        "cancellation.billing.discount": "ส่วนลด 30%",
        "cancellation.plan.starter": "แผน Starter",
        "cancellation.price.monthly": "$8.99/เดือน",
        "cancellation.price.annual": "$5.99/เดือน",
        "cancellation.price.annual_billing": "เรียกเก็บ $71.88 ต่อปี",
        "cancellation.feature.minutes": "160 นาที/เดือน",
        "cancellation.feature.clips": "10 คลิป/เดือน",
        "cancellation.downgrade.button": "ลดระดับไป Starter และเก็บเนื้อหา",
        "cancellation.error.payment_link": "ไม่สามารถรับลิงก์การชำระเงินได้ กรุณาลองอีกครั้ง",
        "cancellation.error.payment_service": "ข้อผิดพลาดในการเชื่อมต่อกับบริการชำระเงิน",
        "cancellation.option.question.break": "คุณช่วยบอกเราเพิ่มเติมเกี่ยวกับเหตุผลที่คุณหยุดพักได้ไหม?",
        "cancellation.option.question.no_recurrent": "คุณสามารถแบ่งปันว่าทำไมคุณถึงไม่ต้องการการสมัครสมาชิกแบบต่อเนื่อง?",
        "cancellation.option.question.expensive": "ราคาหรือคุณสมบัติอะไรที่จะทำให้บริการมีคุณค่ามากขึ้นสำหรับคุณ?",
        "cancellation.option.question.not_saving_time": "อะไรที่ยังคงใช้เวลามากในกระบวนการของคุณ?",
        "cancellation.option.question.dissatisfied_content": "คุณไม่พอใจด้านใดของเนื้อหา?",
        "cancellation.option.question.unresponsive_support": "คุณสามารถอธิบายประสบการณ์ของคุณกับการสนับสนุนลูกค้าของเราได้ไหม?",
        "cancellation.option.question.not_using": "มีอะไรที่จะกระตุ้นให้คุณใช้บริการบ่อยขึ้นไหม?",
        "cancellation.option.question.difficulty_navigating": "คุณพบความยากลำบากอะไรในการใช้/นำทางผลิตภัณฑ์?",
        "cancellation.option.question.better_alternative": "ผลิตภัณฑ์ทางเลือกอะไรที่คุณพบและคุณชอบอะไรเกี่ยวกับมัน?",
        "cancellation.option.question.other": "กรุณาระบุเหตุผลในการยกเลิกของคุณ:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "เราคำนึงถึงความเป็นส่วนตัวของคุณ",
        "cookiebanner.cookieUsage": "เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์การใช้งานเว็บไซต์ของคุณและวิเคราะห์การเข้าชมของเรา โดยการคลิกยอมรับ คุณยินยอมให้เราใช้คุกกี้",
        "cookiebanner.privacyPolicy": "นโยบายความเป็นส่วนตัว",
        "cookiebanner.accept": "ยอมรับ",
        "cookiebanner.decline": "ปฏิเสธ"
      },
      "episodeTitleBox": {
        "loading": "กำลังโหลด...",
        "editEpisodeTitleClicked": "คลิกเพื่อแก้ไขชื่อตอน",
        "newEpisodeTitleStored": "บันทึกชื่อตอนใหม่เรียบร้อยแล้ว"
      },
      "famewall": {
        "loading.message": "กำลังโหลด..."
      },
      "footer": {
        "footer.features": "ฟีเจอร์",
        "footer.transcriptGenerator": "เครื่องสร้างทรานสคริปต์",
        "footer.subtitlesGenerator": "เครื่องสร้างซับไตเติ้ล",
        "footer.descriptionGenerator": "เครื่องสร้างคำอธิบาย",
        "footer.podcastSummarizer": "เครื่องสร้างคำสรุปพอดแคสต์",
        "footer.titlesGenerator": "เครื่องสร้างชื่อเรื่อง",
        "footer.bulletPointsGenerator": "เครื่องสร้างจุดสำคัญ",
        "footer.chaptersClipsGenerator": "เครื่องสร้างบทและคลิป",
        "footer.socialMediaPostsGenerator": "เครื่องสร้างโพสต์โซเชียลมีเดีย",
        "footer.newsletterGenerator": "เครื่องสร้างจดหมายข่าว",
        "footer.blogPostGenerator": "เครื่องสร้างบล็อกโพสต์",
        "footer.podcastLandingPages": "หน้าแลนดิ้งพอดแคสต์",
        "footer.podcastClipMaker": "เครื่องสร้างคลิปพอดแคสต์",
        "footer.audiogramGenerator": "เครื่องสร้างออดิโอแกรม",
        "footer.aiAudioEnhancer": "เครื่องปรับเสียง AI",
        "footer.convertYoutubeToText": "แปลง Youtube เป็นข้อความ",
        "footer.youtubeVideoNoiseRemover": "เครื่องลบเสียงรบกวนจากวิดีโอ Youtube",
        "footer.youtubeVideoKeyPoints": "จุดสำคัญของวิดีโอ Youtube",
        "footer.freeResources": "แหล่งข้อมูลฟรี",
        "footer.findPodcastTopicIdeas": "ค้นหาไอเดียหัวข้อพอดแคสต์",
        "footer.articles": "บทความ",
        "footer.freeEbooks": "eBooks ฟรี",
        "footer.community": "ชุมชน",
        "footer.ourPodcast": "พอดแคสต์ของเรา",
        "footer.product": "ผลิตภัณฑ์",
        "footer.giftCard": "บัตรของขวัญ",
        "footer.onboardingEbook": "eBook สำหรับการเริ่มต้น",
        "footer.pricing": "ราคา",
        "footer.affiliates": "พันธมิตร",
        "footer.media": "สื่อ",
        "footer.testimonials": "คำรับรอง",
        "footer.legal": "กฎหมาย",
        "footer.privacyPolicy": "นโยบายความเป็นส่วนตัว",
        "footer.termsOfUse": "เงื่อนไขการใช้งาน",
        "footer.refundPolicy": "นโยบายการคืนเงิน",
        "footer.allRightsReserved": "สงวนสิทธิ์ทั้งหมด."
      },
      "globalState": {
        "cookie.enabled": "เปิดใช้งานคุกกี้",
        "language.default": "ภาษาที่ตั้งไว้เริ่มต้น"
      },
      "head": {
        "keywords.list": "Podsqueeze, AI, พอดแคสต์, การสร้างเนื้อหา, การถอดเสียงพอดแคสต์, โน้ตแสดง, เวลาที่กำหนด, จดหมายข่าวพอดแคสต์, ทวีต, บล็อกโพสต์, โพสต์ในโซเชียล, ชื่อเรื่อง, ผู้เขียนโน้ตแสดง"
      },
      "imageResultModal": {
        "download.image": "ดาวน์โหลดภาพ",
        "generating.image": "กำลังสร้างภาพ",
        "ai.prompt.label": "กรอกคำสั่งเพื่อให้ AI สร้างภาพ",
        "ai.prompt.placeholder": "เช่น: สุนัขวิ่งในสวน...",
        "processing": "กำลังประมวลผล...",
        "create": "สร้าง",
        "text.color.label": "สีข้อความ",
        "quote.icon.color.label": "สีไอคอนคำคม",
        "background.color.label": "สีพื้นหลัง",
        "font.label": "ฟอนต์",
        "upload.cover.image": "อัปโหลดภาพปก",
        "aspect.ratio.info": "อัตราส่วน 1:1 ขนาดที่แนะนำ 1200x1200",
        "upload.logo.label": "อัปโหลดโลโก้",
        "choose.file": "เลือกไฟล์",
        "upload.success": "อัปโหลดสำเร็จ",
        "choose.quote": "เลือกคำคม",
        "select.template": "เลือกแม่แบบ",
        "quote.label": "คำคม",
        "enter.quote.here": "กรอกคำคมที่นี่",
        "author.label": "ผู้เขียน",
        "enter.author.name": "กรอกชื่อผู้เขียน",
        "podcast.name.label": "ชื่อพอดแคสต์",
        "enter.podcast.name": "กรอกชื่อพอดแคสต์",
        "colors": "สี",
        "select.font": "เลือกฟอนต์",
        "cover.logo.images": "ภาพปกและโลโก้",
        "logo.image": "โลโก้ภาพ",
        "upgrade.here": "อัปเกรดที่นี่",
        "remove.logo": "ลบโลโก้ Podsqueeze",
        "default_templates": "เทมเพลตเริ่มต้น",
        "saved_templates_count": "เทมเพลตที่บันทึกไว้",
        "save_current_template": "บันทึกเทมเพลตปัจจุบัน",
        "no_saved_templates": "ยังไม่มีเทมเพลตที่บันทึกไว้",
        "save_template": "บันทึกเทมเพลต",
        "cancel": "ยกเลิก",
        "save": "บันทึก",
        "enter_template_name": "ป้อนชื่อเทมเพลต",
        "reset_template": "รีเซ็ต",
        "add_element": "เพิ่มองค์ประกอบ",
        "generate": "สร้าง",
        "add_image": "เพิ่มรูปภาพ",
        "upload_image": "อัปโหลดรูปภาพ",
        "or": "หรือ",
        "generate_with_ai": "สร้างด้วย AI",
        "search_fonts": "ค้นหาแบบอักษร...",
        "upload_logo": "อัปโหลดโลโก้",
        "square_image_recommended": "แนะนำรูปภาพสี่เหลี่ยมจัตุรัส",
        "opacity": "ความทึบ",
        "layers": "เลเยอร์",
        "no_element_selected": "ไม่ได้เลือกองค์ประกอบ",
        "bold_shortcut": "ตัวหนา (Ctrl+B)",
        "italic_shortcut": "ตัวเอียง (Ctrl+I)",
        "underline_shortcut": "ขีดเส้นใต้ (Ctrl+U)",
        "edit_text": "แก้ไขข้อความ",
        "tint_color": "สีเทียบ",
        "toggle_gradient_transparent": "สลับไล่ระดับเป็นโปร่งใส",
        "rotate_gradient": "หมุนไล่ระดับ 45 องศา",
        "alt_background": "พื้นหลัง",
        "alt_podcast_logo": "โลโก้พอดคาสต์",
        "alt_custom": "กำหนดเอง",
        "alt_right_side": "ด้านขวา",
        "alt_profile": "โปรไฟล์"
      },
      "intentModal": {
        "intentModal.title": "คุณต้องการทำอะไรกับ Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "เขียนโน้ตการแสดง",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "เขียนบล็อกโพสต์ & จดหมายข่าว",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "สร้างคลิปวิดีโอหรือออดิโอแกรม",
        "intentModal.sourceOption.Create_Quote_Images": "สร้างภาพคำคม",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "แก้ไข & ปรับปรุงเสียง/วิดีโอ",
        "intentModal.sourceOption.Transcribe": "ถอดความ",
        "intentModal.sourceOption.Create_a_Website": "สร้างเว็บไซต์",
        "intentModal.sourceOption.All_of_the_Above": "ทั้งหมดข้างต้น",
        "intentModal.sourceOption.Other": "อื่นๆ",
        "intentModal.otherPlaceholder": "กรุณาระบุ",
        "intentModal.submitButton": "ส่ง & ลงทะเบียน",
        "intentModal.skip": "ข้าม"
      },
      "languageSwitcher": {
        "language.en": "อังกฤษ",
        "language.es": "สเปน",
        "language.fr": "ฝรั่งเศส",
        "language.de": "เยอรมัน",
        "language.it": "อิตาลี",
        "language.pt": "โปรตุเกส",
        "language.nl": "ดัตช์",
        "language.pl": "โปแลนด์",
        "language.ru": "รัสเซีย",
        "language.zh": "จีน",
        "language.ja": "ญี่ปุ่น",
        "language.ko": "เกาหลี",
        "language.ar": "อาหรับ",
        "language.th": "ไทย",
        "language.vi": "เวียดนาม"
      },
      "lazyImage": {
        "lazyImage.alt": "คำอธิบายภาพ"
      },
      "metadata": {
        "meta.title": "ชื่อหน้าของคุณ",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "ยูทิลิตี้"
      },
      "navbar": {
        "navbar.dashboard": "แดชบอร์ด",
        "navbar.login": "เข้าสู่ระบบ",
        "navbar.openMenu": "เปิดเมนูหลัก",
        "navbar.features": "ฟีเจอร์",
        "navbar.resources": "ทรัพยากร",
        "navbar.pricing": "ราคา",
        "navbar.contact": "ติดต่อ",
        "navbar.topPodcasts": "พอดแคสต์ที่มีความนิยม",
        "navbar.seeAllFeatures": "ดูฟีเจอร์ทั้งหมด",
        "navbar.mainFeatures": "ฟีเจอร์หลัก",
        "navbar.podcastTranscription": "เครื่องสร้างการถอดเสียงพอดแคสต์และวิดีโอ",
        "navbar.transcriptionDescription": "การถอดเสียงที่มีความแม่นยำสูงพร้อมการระบุผู้พูดและไฟล์ SRT สำหรับคำบรรยาย",
        "navbar.podcastSummarizer": "เครื่องสรุปพอดแคสต์",
        "navbar.summarizerDescription": "สร้างโน้ตการแสดงที่สมบูรณ์ 20 เท่ารวดเร็วในเสียงของคุณเอง",
        "navbar.podcastClipMaker": "เครื่องสร้างคลิปพอดแคสต์",
        "navbar.clipMakerDescription": "สร้างคลิปสั้นหรือออดิโอแกรมสำหรับพอดแคสต์ของคุณโดยอัตโนมัติ",
        "navbar.audioEnhancer": "เครื่องปรับเสียง Ai",
        "navbar.audioEnhancerDescription": "ปรับปรุงเสียงโดยอัตโนมัติ ลบความเงียบและคำฟุ่มเฟือย",
        "navbar.podsqueezeFeaturesWalkthrough": "การแนะนำฟีเจอร์ PODSQUEEZE",
        "navbar.blog": "บล็อก",
        "navbar.blogDescription": "บทความและคู่มือที่สามารถนำไปปฏิบัติได้เพื่อเริ่มต้นและเติบโตพอดแคสต์ที่ประสบความสำเร็จ",
        "navbar.podcastTopicIdeas": "ไอเดียหัวข้อพอดแคสต์",
        "navbar.topicIdeasDescription": "ค้นพบหัวข้อพอดแคสต์ที่ผู้ฟังกำลังค้นหา",
        "navbar.actionableEbooks": "eBook ที่ใช้ได้จริง",
        "navbar.ebooksDescription": "ดาวน์โหลด eBook ฟรีที่มีเคล็ดลับที่ใช้ได้จริงเพื่อยกระดับพอดแคสต์ของคุณไปสู่ระดับถัดไป",
        "navbar.freeThumbnailMaker": "เครื่องมือสร้างภาพขนาดย่อพอดแคสต์ฟรี",
        "navbar.freeThumbnailMakerDescription": "สร้างภาพขนาดย่อของตอนที่ดูเป็นมืออาชีพและดึงดูดสายตาด้วย AI",
        "navbar.seoOptimizer": "เครื่องมือปรับแต่ง SEO",
        "navbar.seoOptimizerDescription": "ปรับแต่งตอนพอดแคสต์ของคุณเพื่อให้มองเห็นได้ดีขึ้นในเครื่องมือค้นหา",
        "navbar.podcastDescription": "ฟังพอดแคสต์ของเรา ที่เราสัมภาษณ์นักพอดแคสต์ที่มีประสบการณ์และผู้ใช้ Podsqueeze จากทั่วโลก เราขอให้พวกเขาแบ่งปันเคล็ดลับ ข้อมูลเชิงลึก เรื่องราว และทุกสิ่งที่คุณจำเป็นต้องรู้เพื่อพัฒนาพอดแคสต์ของคุณเอง"
      },
      "resultModal": {
        "prompt.transcript.quote": "คำพูด",
        "prompt.transcript.blog": "บล็อก",
        "prompt.transcript.tweets": "ทวีต",
        "prompt.shownotes.firstPerson": "โน้ตแสดงผลแบบบุคคลที่หนึ่ง",
        "prompt.shownotes.replaceName": "เปลี่ยนชื่อในโน้ตแสดงผล",
        "prompt.shownotes.friendlyTone": "โน้ตแสดงผลแบบโทนที่เป็นมิตร",
        "prompt.shownotes.youtubeDescription": "คำอธิบาย YouTube ในโน้ตแสดงผล",
        "prompt.shownotes.engagingQuestion": "คำถามที่น่าสนใจในโน้ตแสดงผล",
        "prompt.timestamps.formatAsChapters": "จัดรูปแบบเวลาเป็นบทที่มีชื่อที่อธิบาย",
        "prompt.timestamps.detailedDescriptions": "สร้างเวลาที่มีคำอธิบายละเอียดของหัวข้อและจุดสำคัญ",
        "prompt.timestamps.improveSpeakerNames": "เปลี่ยนชื่อผู้พูดเป็นชื่อที่อธิบายมากกว่าเช่น 'ผู้ถาม', 'ผู้ตอบ' หรือ 'ผู้เข้าร่วม'",
        "prompt.newsletter.casualTone": "จดหมายข่าวแบบไม่เป็นทางการ",
        "prompt.newsletter.shorter": "จดหมายข่าวที่สั้นลง",
        "prompt.newsletter.contentSections": "ส่วนเนื้อหาในจดหมายข่าว",
        "prompt.newsletter.changeName": "เปลี่ยนชื่อในจดหมายข่าว",
        "prompt.mentions.fullURL": "URL เต็มในการกล่าวถึง",
        "prompt.mentions.replaceName": "เปลี่ยนชื่อในการกล่าวถึง",
        "prompt.tweets.underdogTone": "ทวีตแบบโทนผู้ที่ด้อยกว่า",
        "prompt.tweets.firstPerson": "ทวีตแบบบุคคลที่หนึ่ง",
        "prompt.shortPost.relevantEmojis": "อีโมจิที่เกี่ยวข้องในโพสต์สั้น",
        "prompt.shortPost.educationalTone": "โพสต์สั้นแบบโทนการศึกษา",
        "prompt.shortPost.underdogTone": "โพสต์สั้นแบบโทนผู้ที่ด้อยกว่า",
        "prompt.shortPost.firstPerson": "โพสต์สั้นแบบบุคคลที่หนึ่ง",
        "prompt.titles.youtubeOptimized": "ชื่อที่ปรับให้เหมาะกับ YouTube",
        "prompt.titles.startWithHowTo": "เริ่มด้วยชื่อ 'วิธีการ'",
        "prompt.titles.otherOptions": "ตัวเลือกอื่นสำหรับชื่อ",
        "prompt.keywords.youtubeOptimized": "คำสำคัญที่ปรับให้เหมาะกับ YouTube",
        "prompt.keywords.separateWithCommas": "แยกคำสำคัญด้วยเครื่องหมายจุลภาค",
        "prompt.quotes.lorem1": "คำพูด Lorem ipsum 1",
        "prompt.quotes.lorem2": "คำพูด Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "จุดสำคัญ Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "จุดสำคัญ Lorem ipsum 2",
        "prompt.longPost.firstPerson": "โพสต์ยาวแบบบุคคลที่หนึ่ง",
        "prompt.longPost.relevantEmojis": "อีโมจิที่เกี่ยวข้องในโพสต์ยาว",
        "prompt.longPost.changeName": "เปลี่ยนชื่อในโพสต์ยาว",
        "alert.tuningInstructionsEmpty": "คำแนะนำการปรับแต่งไม่สามารถว่างเปล่าได้.",
        "text.timestamps.byPodsqueeze": "เวลาโดย PodSqueeze",
        "button.copied": "คัดลอกแล้ว",
        "button.copy": "คัดลอก",
        "embed.transcript": "ฝังบทถอดเสียง",
        "embed.description": "คำอธิบายสำหรับการฝัง",
        "preview.title": "ชื่อพรีวิว",
        "loading.regenerating": "กำลังสร้างใหม่...",
        "placeholder.tuningInstructions": "กรอกคำแนะนำการปรับแต่ง...",
        "button.saveClose": "บันทึกและปิด",
        "button.acceptChanges": "ยอมรับการเปลี่ยนแปลง",
        "button.discard": "ยกเลิก",
        "button.embedTranscript": "ฝังบทถอดเสียง",
        "text.copiedToClipboard": "คัดลอกไปยังคลิปบอร์ด",
        "download.srtFile": "ดาวน์โหลดไฟล์ SRT",
        "text.forCaptions": "สำหรับคำบรรยาย",
        "tune.title": "ปรับแต่งผลลัพธ์ของคุณ",
        "tune.description": "ปรับผลลัพธ์ของคุณด้วยตัวเลือกต่อไปนี้.",
        "instruction.label": "คำแนะนำ:",
        "button.tuneResult": "ปรับผลลัพธ์",
        "instruction.saveForLater": "บันทึกไว้เพื่อใช้ในภายหลัง",
        "button.readMore": "อ่านมากขึ้น",
        "button.showLess": "แสดงน้อยลง",
        "customPrompt.used": "คำแนะนำการปรับแต่งที่ใช้:",
        "feedback.happyWithResults": "คุณพอใจกับผลลัพธ์หรือไม่?"
      },
      "resultModalTranscript": {
        "prompt.quote": "ค้นหาคำคมดีๆ สามคำจากการถอดความ",
        "prompt.blog": "เขียนบล็อกโพสต์ 500 คำที่มุ่งเน้นไปที่หัวข้อ X",
        "prompt.tweets": "เขียนทวีตที่น่าสนใจสามข้อความจากการถอดความ",
        "transcript.autoTranscribed": "ถอดความโดยอัตโนมัติด้วย Podsqueeze",
        "alert.emptyPrompt": "คำแนะนำไม่สามารถว่างเปล่าได้",
        "embed.transcript": "ฝังการถอดความ",
        "embed.description": "ฝังการถอดความขนาดที่จัดการได้พร้อมฟีเจอร์ค้นหาในเว็บไซต์ WordPress ของคุณหรือหน้า HTML ที่รองรับ",
        "button.copied": "คัดลอกแล้ว!",
        "button.copy": "คัดลอก",
        "preview.title": "ตัวอย่าง",
        "edit.speakers": "แก้ไขชื่อผู้พูด",
        "button.saveClose": "บันทึก & ปิด",
        "placeholder.prompt": "เช่น: ค้นหาคำคมดีๆ สามคำจากการถอดความ",
        "upgrade.pro": "อัปเกรดเป็น Pro เพื่อใช้ฟีเจอร์นี้",
        "upgrade.link": "อัปเกรดเป็น Pro",
        "button.generate": "สร้าง",
        "feedback.happy": "คุณพอใจกับผลลัพธ์หรือไม่?",
        "instruction": "คำแนะนำ: ",
        "generating.results": "กำลังสร้างผลลัพธ์",
        "full.transcription": "การถอดความทั้งหมด",
        "srt.file": "& ไฟล์ SRT",
        "download.srt": "ดาวน์โหลดไฟล์ SRT",
        "caption.subtitles": "สำหรับคำบรรยายและซับไตเติ้ล",
        "generate.from.transcript": "สร้างจากการถอดความด้วย Gpt-4o",
        "gpt.tweak.text": "ขอให้ GPT ล่าสุดปรับแต่งข้อความตามที่คุณต้องการ ใช้ภาษาธรรมชาติและอย่ากลัวที่จะระบุให้ชัดเจน",
        "copied.clipboard": "คัดลอกไปยังคลิปบอร์ด",
        "transcript.public.available": "URLสาธารณะ",
        "audio.notSupported": "เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "เพิ่มชื่อพอดแคสต์",
        "podcast.title": "{{title}} พอดแคสต์"
      },
      "sourceModal": {
        "sourceModal.title": "คุณรู้เกี่ยวกับ Podsqueeze ได้อย่างไร?",
        "sourceModal.otherPlaceholder": "กรุณาระบุ",
        "sourceModal.nextButton": "ถัดไป",
        "sourceModal.skip": "ข้าม"
      },
      "squeezeEditResults": {
        "error.processing.rss": "เรากำลังประสบปัญหาในการประมวลผลฟีด RSS บางรายการ กรุณาอัปโหลดไฟล์"
      },
      "squeezeResults": {
        "copiedToClipboard": "คัดลอกไปยังคลิปบอร์ด",
        "publicLink": "สาธารณะที่ ",
        "createLink": "สร้างลิงก์เพื่อแชร์หน้าผลลัพธ์นี้",
        "assembleShowNotes": "จัดทำโน้ตการแสดง",
        "convertAnotherEpisode": "แปลงตอนอื่น",
        "writtenContent": "เนื้อหาที่เขียน",
        "videoClipsAndImages": "คลิปวิดีโอ & รูปภาพ",
        "editAudio": "แก้ไขเสียง"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "ดูเพิ่มเติมและปรับแต่ง",
        "see.more": "ดูเพิ่มเติม",
        "generating": "กำลังสร้าง",
        "download.all": "ดาวน์โหลดทั้งหมด",
        "full.transcription": "ถอดความทั้งหมด",
        "transcript.benefit": "คุณรู้หรือไม่ว่าการเพิ่มถอดความทั้งหมดในหมายเหตุของคุณช่วยเพิ่มการเข้าชมเว็บไซต์และการมีส่วนร่วม?",
        "learn.more": "เรียนรู้เพิ่มเติม",
        "transcript.bonus": "คุณสามารถให้ถอดความทั้งหมดเป็นโบนัสสำหรับโปรแกรมสมาชิกพอดแคสต์ของคุณได้",
        "show.notes": "หมายเหตุรายการ",
        "show.notes.engagement": "พิจารณาเสริมคำอธิบายสั้น ๆ นี้ด้วยองค์ประกอบอื่น ๆ ในหมายเหตุรายการของคุณเพื่อเพิ่มการมีส่วนร่วมและ SEO",
        "show.notes.examples": "ค้นหาแรงบันดาลใจจากตัวอย่างหมายเหตุพอดแคสต์ 17 รายการเหล่านี้เพื่อสร้างหมายเหตุที่สมบูรณ์แบบสำหรับพอดแคสต์ของคุณ",
        "timestamps": "เวลา",
        "timestamps.benefit": "เพิ่มเวลาเหล่านี้ในคำอธิบายตอนของคุณและมันจะสร้างบทใน Spotify และ YouTube โดยอัตโนมัติ",
        "titles": "ชื่อเรื่อง",
        "titles.engagement": "ชื่อเรื่องที่มีเครื่องหมายคำถามและคำคุณศัพท์ที่ดีที่สุดมักจะดึงดูดความสนใจเป็นพิเศษ",
        "links.and.mentions": "ลิงก์ & การกล่าวถึง",
        "mentions.resources": "พิจารณาเพิ่มการกล่าวถึงด้านล่างในส่วนทรัพยากรของหมายเหตุรายการของคุณ",
        "mentions.affiliate": "ดูว่าผลิตภัณฑ์ที่กล่าวถึงมีโปรแกรมพันธมิตรหรือไม่และพิจารณาเพิ่มลิงก์พันธมิตรในหมายเหตุรายการของคุณ",
        "mentions.social.media": "แท็กผู้ที่ถูกกล่าวถึงในตอนของคุณในโซเชียลมีเดียเพื่อกระตุ้นให้พวกเขาแชร์และมีส่วนร่วมกับโพสต์ของคุณ",
        "keywords": "คำสำคัญ",
        "keywords.youtube": "เมื่อคุณอัปโหลดตอนของคุณไปยัง YouTube ให้คัดลอกและวางคำสำคัญเหล่านี้ในส่วนแท็ก",
        "keywords.social.media": "นำคำสำคัญเหล่านี้ไปใช้ใหม่สำหรับแฮชแท็กในโซเชียลมีเดีย",
        "blog.post": "โพสต์บล็อก",
        "blog.post.linkedin": "พิจารณาใช้เนื้อหานี้เพื่อสร้างโพสต์ยาวใน LinkedIn",
        "blog.post.share": "แชร์เนื้อหานี้ในชุมชน Reddit และกลุ่ม Facebook ที่เกี่ยวข้องกับหัวข้อพอดแคสต์ของคุณ",
        "newsletter": "จดหมายข่าว",
        "newsletter.content": "ผู้ใช้บางคนของเรานำเนื้อหาจดหมายข่าวนี้ไปใช้ใหม่เพื่อสร้างคำอธิบายตอนที่ครอบคลุมมากขึ้นสำหรับหมายเหตุรายการ",
        "linkedin.and.facebook": "LinkedIn & Facebook",
        "short.post.description": "ใช้โพสต์สั้นเหล่านี้เป็นคำอธิบายเมื่อแชร์คลิปวิดีโอและออดิโอแกรมที่เกี่ยวข้องในโซเชียลมีเดีย",
        "tweets": "ทวีต",
        "quotes": "คำคม",
        "bullet.points": "จุดสำคัญ",
        "add.custom.result": "เพิ่มผลลัพธ์สมบูรณ์",
        "bullet.points.skimming": "ผู้ทำพอดแคสต์มักจะระบุหัวข้อหลักของตอนเป็นจุดสำคัญในหมายเหตุรายการเพื่อให้ง่ายต่อการสแกน"
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "ดูเพิ่มเติมและปรับแต่ง",
        "generating": "กำลังสร้าง",
        "not.available.for.rss.feed": "ไม่สามารถใช้งานได้สำหรับฟีด RSS นี้",
        "regenerate.episode.upload.file": "สร้างตอนใหม่และอัปโหลดไฟล์เสียง/วิดีโอของคุณโดยตรงจากคอมพิวเตอร์",
        "processing.difficulties": "เรากำลังประสบปัญหาในการประมวลผลฟีด RSS บางรายการ กรุณาอัปโหลดไฟล์",
        "video.clips": "คลิปวิดีโอ",
        "ai.short.clips": "คลิปสั้น AI",
        "quote.image": "ภาพคำคม"
      },
      "title": {
        "title.text": "ป้ายของคุณ"
      },
      "topbar": {
        "topbar.forYou": "สำหรับคุณ",
        "topbar.joinPodcast": "เข้าร่วมการประชุมเสมือนจริงพอดแคสต์ครั้งถัดไปของเรา!",
        "topbar.saveYourSpot": "จองที่ของคุณ",
        "topbar.dismiss": "ปิด"
      },
      "trackers": {
        "trackers.init": "กำลังเริ่มต้นตัวติดตามโดยเปิดใช้งานคุกกี้: ",
        "trackers.loadScripts": "กำลังโหลดสคริปต์ติดตาม..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "ยินดีต้อนรับสู่แอปพลิเคชันของฉัน",
        "content.description": "นี่คือตัวอย่างแอปพลิเคชันที่แสดงการแปลภาษา",
        "button.submit": "ส่ง"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI กำลังแก้ไขคลิปของคุณ",
        "export_clip": "ส่งออกคลิป",
        "ai_edit": "แก้ไข AI",
        "ai_editing_clip_duration": "นี่จะใช้เวลาสักครู่",
        "generating_clip": "กำลังสร้างคลิปของคุณ...",
        "generating_clip_notice": "อาจใช้เวลาสักครู่ เราจะส่งอีเมลถึงคุณเมื่อเสร็จสิ้น",
        "edit_another_video": "คุณสามารถรอที่นี่หรือแก้ไขวิดีโออื่น",
        "download_video": "ดาวน์โหลดวิดีโอ",
        "back_to_editing": "กลับไปที่การแก้ไข",
        "export_video_button": "ส่งออกคลิป",
        "notice_storage": "หมายเหตุ: เราจะเก็บเสียงของคุณเป็นเวลา 30 วัน หลังจากนั้นคลิปนี้จะหมดอายุ",
        "error_generating_clip": "เกิดข้อผิดพลาดในการสร้างคลิป",
        "error_user_support": "กรุณาลองใหม่อีกครั้งหรือติดต่อฝ่ายสนับสนุนผู้ใช้ของเรา",
        "select_template": "เลือกแม่แบบ",
        "add_30s_prev": "30 วินาทีจากบทก่อนหน้า",
        "add_30s_next": "30 วินาทีจากบทถัดไป",
        "undo": "ย้อนกลับ",
        "subtitles_font": "ฟอนต์คำบรรยาย",
        "subtitles_color": "สีคำบรรยาย",
        "subtitles_box_color": "สีการเคลื่อนไหว",
        "adjust_podcast_title_position": "ปรับตำแหน่งแนวตั้งของชื่อพอดแคสต์",
        "adjust_subtitles_size": "ปรับขนาดคำบรรยาย",
        "adjust_subtitles_vertical_position": "ปรับตำแหน่งแนวตั้งของคำบรรยาย",
        "remove_subtitles": "ลบคำบรรยาย",
        "animated_subtitles": "คำบรรยายแอนิเมชัน",
        "upgrade_here": "อัปเกรดที่นี่",
        "remove_logo": "เพื่อลบโลโก้",
        "remove_podsqueeze_logo": "ลบโลโก้ podsqueeze",
        "aspect_ratio": "อัตราส่วนภาพ",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "ชื่อตอน",
        "podcast_title": "ชื่อพอดแคสต์",
        "titles_font": "ฟอนต์ชื่อเรื่อง",
        "title_colors": "สีชื่อพอดแคสต์/ตอน",
        "video_fit": "การปรับขนาดวิดีโอ",
        "adjust_horizontal_position": "ปรับตำแหน่งแนวนอน",
        "adjust_vertical_position": "ปรับตำแหน่งแนวตั้ง",
        "adjust_video_zoom": "ปรับความกว้างของวิดีโอ",
        "adjust_video_width": "ปรับความกว้างของวิดีโอ",
        "adjust_video_height": "ปรับความสูงของวิดีโอ",
        "background_color": "สีพื้นหลัง",
        "edit_clip": "แก้ไขคลิป",
        "edit_layout": "แก้ไขโครงร่าง",
        "choose_short": "เลือกคลิปสั้น",
        "edit_audio": "แก้ไขเสียง",
        "framing": "การจัดกรอบ",
        "background": "พื้นหลัง",
        "text_style": "สไตล์ข้อความ",
        "music": "เพลง",
        "choose_chapter": "เลือกบท",
        "clips_left": "คุณมี",
        "apply_layout": "นำเข้าโครงร่าง",
        "clips_left_number": "คลิปเหลืออยู่",
        "need_more_clips": "ต้องการคลิปเพิ่มเติม? อัปเกรดแผนของคุณที่นี่",
        "download_srt_file": "ดาวน์โหลดไฟล์ SRT",
        "track_selected": "แทร็ก: ",
        "no_background_music": "ไม่มีเพลงพื้นหลังที่เลือก",
        "volume": "ระดับเสียง:",
        "remove": "ลบ",
        "track_ambient_piano": "เปียโนและสายบรรเลง",
        "track_deep_meditation": "การทำสมาธิลึก",
        "track_chill_upbeat": "สำหรับบรรยากาศที่ผ่อนคลาย",
        "track_inspiring_ambient": "บรรยากาศภาพยนตร์ที่สร้างแรงบันดาลใจ",
        "track_just_relax": "แค่ผ่อนคลาย",
        "track_movement": "การเคลื่อนไหว",
        "track_once_in_paris": "ครั้งหนึ่งในปารีส",
        "track_perfect_beauty": "ความงามที่สมบูรณ์แบบ",
        "track_summer_adventures": "การผจญภัยในฤดูร้อน",
        "track_sunset_groove": "จังหวะพระอาทิตย์ตก",
        "track_tvari_cafe": "Tvari tokyo cafe",
        "track_short_piano_intermezzo": "บทเพลงเปียโนสั้น",
        "track_dramatic_background": "เพลงพื้นหลังแบบดราม่า",
        "track_dramatic_hiphop": "ดราม่าฮิปฮอปแจ๊ส",
        "track_emotional_orchestra": "ออร์เคสตราอารมณ์",
        "track_halloween_short": "เพลงฮาโลวีน",
        "track_improvisation_037": "แจ๊สด้นสด",
        "track_inspiration_piano": "เปียโนแรงบันดาลใจ",
        "track_medieval_extract": "เพลงยุคกลาง",
        "track_short_8": "แทร็กแอมเบียนท์สั้น",
        "track_flute": "ขลุ่ยสงบ",
        "track_piano_guitar_duet": "ดูเอทเปียโน-กีตาร์",
        "track_intro_jazz": "แจ๊สเปิดเพลง",
        "track_romantic_jazz": "แจ๊สโรแมนติก",
        "recommended_for_youtube": "แนะนำสำหรับ YouTube",
        "turn_into_short_clip": "แปลงคลิปนี้เป็นคลิปสั้น (<60 วินาที)",
        "browser_not_support_audio": "เบราว์เซอร์ของคุณไม่รองรับองค์ประกอบเสียง",
        "watch_tutorial": "ดูวิดีโอสอนนี้",
        "audiogram_maker": "เกี่ยวกับวิธีการใช้ประโยชน์จากเครื่องมือสร้างกราฟเสียงของเรา",
        "store_audio_notice": "หมายเหตุ: เราจะเก็บเสียงของคุณเป็นเวลา 30 วัน",
        "clip_maker": "เกี่ยวกับวิธีการใช้ประโยชน์จากเครื่องมือสร้างคลิปของเรา",
        "split_screen_mode": "ช่วยให้คุณสามารถสร้างคลิปหลายคลิปในหน้าจอเดียวกัน",
        "none": "ไม่มี",
        "layers": "ใช้เลเยอร์ด้านล่างเพื่อเลื่อนไปข้างหน้าหรือข้างหลัง",
        "vertical_split": "แบ่งด้านขวา",
        "horizontal_split": "แบ่งด้านล่าง",
        "screen_1_horizontal_position": "ตำแหน่งแนวนอนของหน้าจอ 1",
        "screen_2_horizontal_position": "ตำแหน่งแนวนอนของหน้าจอ 2",
        "track_mysterious_dark_background": "พื้นหลังมืดลึกลับ",
        "track_acoustic_ambient_inspiration": "แรงบันดาลใจอะคูสติกแอมเบียนท์",
        "track_aristocracy_classical": "อริสโตแครซีคลาสสิก",
        "track_folk_music_river_knows_my_name": "ดนตรีโฟล์ก - แม่น้ำรู้ชื่อฉัน",
        "track_funy_adventure": "การผจญภัยที่สนุก",
        "track_energetic_sports_rock_trailer": "เทรลเลอร์ร็อคกีฬาที่มีพลัง",
        "track_fun_upbeat_energetic_pop_rock": "ป็อปร็อคที่สนุกและมีพลัง",
        "track_epic_emotional_inspirational": "อิพิคที่ให้อารมณ์และแรงบันดาลใจ",
        "track_inspirational_epic": "อิพิคที่สร้างแรงบันดาลใจ",
        "all_music": "ดนตรีทั้งหมด",
        "energetic_music": "มีพลัง",
        "inspirational_music": "สร้างแรงบันดาลใจ",
        "ambient_music": "แอมเบียนท์",
        "chill_music": "ชิลล์",
        "hiphop_music": "ฮิปฮอป",
        "quirky_music": "แปลกประหลาด",
        "dramatic_music": "ดราม่า",
        "acoustic_music": "อะคูสติก",
        "classical_music": "คลาสสิก",
        "categories": "หมวดหมู่",
        "select_track": "เลือกแทร็ค",
        "upload_music": "อัปโหลดเพลง",
        "my_music": "เพลงของฉัน",
        "downloading": "กำลังดาวน์โหลด...",
        "download_again": "ดาวน์โหลดอีกครั้ง",
        "download": "ดาวน์โหลด",
        "download_failed_alert": "ดาวน์โหลดวิดีโอล้มเหลว กรุณาลองใหม่อีกครั้ง",
        "translate_subtitles": "แปลคำบรรยาย",
        "translate_to": "แปลเป็น",
        "select_language": "เลือกภาษา",
        "select_new_language": "เลือกภาษาใหม่",
        "translating": "กำลังแปล...",
        "translation_complete": "แปลเสร็จสิ้น",
        "error_translation": "เกิดข้อผิดพลาดในการแปล กรุณาลองใหม่อีกครั้ง",
        "original_language": "ต้นฉบับ"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "ชื่อตอน"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "คุณยังไม่มีเนื้อหาใดๆ",
        "userPodcastsInfo.generateContent": "สร้างเนื้อหาแรกของคุณ",
        "placeholder.search_folders": "ค้นหาโฟลเดอร์...",
        "search.no_results": "ไม่พบโฟลเดอร์ที่ตรงกับการค้นหาของคุณ"
      },
      "landingPageModal": {
        "upload.error": "ไม่สามารถอัปโหลดภาพได้: ",
        "upload.image.file": "กรุณาอัปโหลดไฟล์ภาพ.",
        "upgrade.pro.message": "การปรับแต่งหน้าเพจมีให้เฉพาะบัญชี Pro และ Agency เท่านั้น",
        "upgrade.now": "อัปเกรดตอนนี้",
        "upgrade.unique.landing.page": " และสร้างหน้าแลนดิ้งที่ไม่ซ้ำใครสำหรับตอนนี้.",
        "logo.recommendation": "ความสูงโลโก้ที่แนะนำ 200px",
        "social.links.top.menu": "ลิงก์โซเชียลในเมนูด้านบน",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "กรุณาใส่ลิงก์ LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "กรุณาใส่ลิงก์ Facebook",
        "saving...": "กำลังบันทึก...",
        "save": "บันทึก",
        "saved.successfully": "บันทึกสำเร็จ!",
        "uploading.image": "กำลังอัปโหลดภาพ...",
        "upload.episode.cover": "อัปโหลดปกตอน",
        "upload.logo": "อัปโหลดโลโก้",
        "where.listen.episode": "เราสามารถฟังตอนนี้ได้ที่ไหนอีก?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "กรุณาใส่ลิงก์ YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "กรุณาใส่ลิงก์ Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "กรุณาใส่ลิงก์ Spotify",
        "image.size.recommendation": "ขนาดที่แนะนำ 1000x1000px",
        "primary.color.label": "สีหลัก",
        "header.background.color": "สีพื้นหลังของหัวข้อและลิงก์.",
        "landing.page.customization": "การปรับแต่งหน้าแลนดิ้ง",
        "create.branded.landing.page": "สร้างหน้าแลนดิ้งที่สวยงามและมีแบรนด์เพื่อแชร์กับผู้ฟังของคุณ",
        "episode.image": "ภาพตอน",
        "episode.links": "ลิงก์ตอน",
        "page.header": "หัวข้อหน้า",
        "page.color": "สีหน้า",
        "visit.landing.page": "เยี่ยมชมหน้าแลนดิ้ง"
      },
      "page": {
        "loading.dashboard": "กำลังโหลดแดชบอร์ด",
        "convert.new.episode": "แปลงตอนใหม่",
        "convert.audio.or.video": "แปลงเสียงหรือวิดีโอ",
        "minutes.left": "คุณมี",
        "need.more.minutes": "ต้องการนาทีเพิ่มเติมหรือไม่?",
        "upgrade.plan": "อัปเกรดแผนของคุณที่นี่.",
        "your.podcasts": "พอดแคสต์ของคุณ",
        "podsqueeze.results.page": "หน้าผลลัพธ์ Podsqueeze",
        "access.podsqueeze.results": "เข้าถึงผลลัพธ์ Podsqueeze สำหรับตอนนี้ คุณจะสามารถดูเนื้อหาที่สร้างขึ้นทั้งหมด"
      },
      "podcast": {
        "confirm.delete_episode": "คุณแน่ใจหรือว่าต้องการลบตอนนี้?",
        "alert.something_wrong": "เกิดข้อผิดพลาดบางอย่าง กรุณาลองอีกครั้ง.",
        "confirm.delete_folder": "คุณแน่ใจหรือว่าต้องการลบโฟลเดอร์นี้?",
        "loading.episodes": "กำลังโหลดตอน...",
        "folder.empty": "โฟลเดอร์นี้ว่างเปล่า.",
        "content.no_content": "ไม่มีเนื้อหาที่พร้อมใช้งาน.",
        "content.generate_first": "สร้างพอดแคสต์แรกของคุณ.",
        "button.personalize_ai": "ปรับแต่งด้วย AI",
        "button.edit_website": "แก้ไขเว็บไซต์",
        "button.visit_website": "เยี่ยมชมเว็บไซต์",
        "button.generate_website": "สร้างเว็บไซต์",
        "placeholder.search": "ค้นหา...",
        "label.sort_by": "เรียงตาม",
        "label.last_episodes_loaded": "ตอนล่าสุดที่โหลด",
        "button.load_all_episodes": "โหลดตอนทั้งหมด",
        "loading": "กำลังโหลด...",
        "add.new.episode": "เพิ่มตอนใหม่",
        "order.newest": "ใหม่สุดก่อน",
        "order.oldest": "เก่าสุดก่อน",
        "order.a_to_z": "ก ถึง ฮ",
        "order.z_to_a": "ฮ ถึง ก"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "สร้างโฟลเดอร์พอดแคสต์ใหม่:",
        "folder.name.placeholder": "ชื่อโฟลเดอร์",
        "create.button": "สร้าง"
      },
      "podcastLandingModal": {
        "upload.image.error": "กรุณาอัปโหลดไฟล์ภาพ",
        "podcast.cover.title": "ภาพปกพอดแคสต์",
        "podcast.cover.upload": "อัปโหลดภาพปกพอดแคสต์ของคุณที่นี่ ซึ่งจะแสดงอย่างเด่นชัดบนหน้าแลนดิ้งของคุณ",
        "upload.image.uploading": "กำลังอัปโหลดภาพ...",
        "podcast.cover.upload.button": "อัปโหลดภาพปก",
        "podcast.cover.recommended.size": "ขนาดที่แนะนำ: 1400x1400 พิกเซล",
        "profile.info.title": "ข้อมูลโปรไฟล์",
        "profile.info.upload": "เพิ่มรูปโปรไฟล์และชื่อของคุณเพื่อปรับแต่งหน้าแลนดิ้งของคุณ",
        "profile.upload.button": "อัปโหลดรูปโปรไฟล์",
        "profile.name.label": "ชื่อโปรไฟล์",
        "profile.name.placeholder": "กรอกชื่อของคุณ",
        "platform.links.title": "ลิงก์แพลตฟอร์ม",
        "platform.links.upload": "เพิ่มลิงก์ไปยังพอดแคสต์ของคุณในแพลตฟอร์มต่างๆ",
        "platform.links.youtube_link": "ลิงก์ YouTube",
        "platform.links.youtube_link.placeholder": "กรอกลิงก์ YouTube",
        "platform.links.spotify_link": "ลิงก์ Spotify",
        "platform.links.spotify_link.placeholder": "กรอกลิงก์ Spotify",
        "platform.links.apple_podcast_link": "ลิงก์ Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "กรอกลิงก์ Apple Podcast",
        "platform.links.linkedin_link": "ลิงก์ LinkedIn",
        "platform.links.linkedin_link.placeholder": "กรอกลิงก์ LinkedIn",
        "platform.links.facebook_link": "ลิงก์ Facebook",
        "platform.links.facebook_link.placeholder": "กรอกลิงก์ Facebook",
        "platform.links.twitter_link": "ลิงก์ Twitter",
        "platform.links.twitter_link.placeholder": "กรอกลิงก์ Twitter",
        "call.to.action.title": "การเรียกร้องให้ดำเนินการ",
        "call.to.action.upload": "ตั้งค่าปุ่มเรียกร้องให้ดำเนินการสำหรับหน้าแลนดิ้ง",
        "call.to.action.button.text.label": "ข้อความปุ่ม",
        "call.to.action.button.text.placeholder": "กรอกข้อความปุ่ม",
        "call.to.action.button.link.label": "ลิงก์ปุ่ม",
        "call.to.action.button.link.placeholder": "กรอกลิงก์ปุ่ม",
        "color.styles.title": "สไตล์สี",
        "color.styles.upload": "ปรับแต่งสีของหน้าแลนดิ้งของคุณ",
        "color.styles.primary.label": "สีหลัก",
        "color.styles.primary.description": "เลือกสีหลักสำหรับหน้าแลนดิ้งของคุณ",
        "color.styles.secondary.label": "สีรอง",
        "color.styles.secondary.description": "เลือกสีรองสำหรับหน้าแลนดิ้งของคุณ",
        "podcast.info.title": "ข้อมูลพอดแคสต์",
        "podcast.info.upload": "แก้ไขรายละเอียดของพอดแคสต์ของคุณ",
        "podcast.info.name.label": "ชื่อพอดแคสต์",
        "podcast.info.name.placeholder": "กรอกชื่อพอดแคสต์",
        "podcast.info.description.label": "คำอธิบายพอดแคสต์",
        "podcast.info.description.placeholder": "กรอกคำอธิบายพอดแคสต์",
        "edit.website.title": "แก้ไขเว็บไซต์",
        "generate.website.title": "สร้างเว็บไซต์",
        "for": "สำหรับ",
        "saving": "กำลังบันทึก...",
        "save.changes": "บันทึกการเปลี่ยนแปลง",
        "generate.website": "สร้างเว็บไซต์",
        "changes.saved.success": "บันทึกการเปลี่ยนแปลงสำเร็จ!",
        "podcast.cover.menu": "ภาพปกพอดแคสต์",
        "podcast.info.menu": "ข้อมูลพอดแคสต์",
        "profile.menu": "โปรไฟล์",
        "platform.links.menu": "ลิงก์แพลตฟอร์ม",
        "call.to.action.menu": "การเรียกร้องให้ดำเนินการ",
        "color.styles.menu": "สไตล์สี",
        "logo.menu": "โลโก้",
        "logo.title": "อัปโหลดโลโก้",
        "logo.upload": "อัปโหลดโลโก้ของคุณที่นี่ ซึ่งจะแสดงอย่างเด่นชัดบนหน้าแลนดิ้งของคุณ",
        "logo.upload.button": "อัปโหลดโลโก้",
        "platform.links.description": "เพิ่มลิงก์ไปยังพอดแคสต์ของคุณในแพลตฟอร์มต่างๆ",
        "social.links.menu": "ลิงก์สังคม",
        "social.links.title": "ลิงก์สังคม",
        "social.links.description": "เพิ่มลิงก์ไปยังบัญชีสังคมของคุณ",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "กรอกลิงก์ LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "กรอกลิงก์ Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "กรอกลิงก์ Twitter",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "กรอกลิงก์ Instagram",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "กรอกลิงก์ YouTube",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "กรอกลิงก์ Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "กรอกลิงก์ Apple Podcast"
      },
      "podcastMoveModal": {
        "move.episode.label": "ย้ายตอนนี้ไปที่:",
        "move.episode.instruction": "คุณสามารถพิมพ์ชื่อใหม่เพื่อสร้างโฟลเดอร์ได้。",
        "move.episode.button": "ย้าย",
        "move.episode.error.selectFolder": "โปรดเลือกโฟลเดอร์เพื่อย้ายตอนนี้"
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "การตั้งค่า AI สำหรับพอดแคสต์ {{podcastTitle}}",
        "ai.customize.writing.style": "ปรับแต่งสไตล์การเขียน AI ของคุณ",
        "ai.content.writing.preference": "คุณต้องการให้ Podsqueeze เขียนเนื้อหาของคุณอย่างไร?",
        "ai.voice.placeholder": "ตัวอย่าง: โทนเสียงมืออาชีพแต่เป็นมิตร ผู้ฟังคือพอดแคสเตอร์ เขียนในรูปแบบบุคคลที่หนึ่ง",
        "ai.character.limit.reached": "คุณได้ถึงขีดจำกัดตัวอักษร 50 ตัวแล้ว",
        "ai.upgrade.now": "อัปเกรดตอนนี้",
        "ai.fix.transcript.misspells": "แก้ไขการสะกดผิดในทรานสคริปต์",
        "ai.enter.misspelled.words": "เขียนคำที่ AI มักสะกดผิดในตอนพอดแคสต์เหล่านี้ เช่น ชื่อ",
        "ai.enter.word.press.enter": "ป้อนคำและกด Enter",
        "ai.add.word": "เพิ่มคำ",
        "ai.tag.limit.reached": "ถึงขีดจำกัด 1 แท็กแล้ว",
        "ai.save": "บันทึก",
        "ai.save.close": "บันทึก & ปิด"
      },
      "selectedepisode": {
        "selectedEpisode.title": "ชื่อตอน",
        "selectedEpisode.podcastName": "ชื่อพอดแคสต์",
        "selectedEpisode.showNotes": "หมายเหตุการแสดง",
        "selectedEpisode.timestamp": "เวลาที่บันทึก",
        "selectedEpisode.staticTimestamp": "เวลาที่บันทึกแบบคงที่",
        "selectedEpisode.mentions": "การกล่าวถึง",
        "selectedEpisode.newsletter": "จดหมายข่าว",
        "selectedEpisode.titles": "ชื่อเรื่อง",
        "selectedEpisode.tweeter": "ผู้ทวีต",
        "selectedEpisode.shortPost": "โพสต์สั้น",
        "selectedEpisode.transcription": "การถอดความ",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "คำสำคัญ",
        "selectedEpisode.quotes": "คำคม",
        "selectedEpisode.longPost": "โพสต์ยาว",
        "selectedEpisode.bulletPoints": "จุดสำคัญ",
        "selectedEpisode.publicLink": "ลิงก์สาธารณะ",
        "selectedEpisode.embeddedId": "รหัสฝัง",
        "selectedEpisode.episodeUrl": "URL ตอน"
      },
      "sidebar": {
        "tools": "เครื่องมือ",
        "find.podcast.topic.ideas": "ค้นหาแนวคิดหัวข้อพอดแคสต์",
        "podcast.thumbnail.maker": "เครื่องมือสร้างภาพขนาดย่อพอดแคสต์",
        "podcast.seo.optimizer": "เครื่องมือปรับปรุง SEO พอดแคสต์",
        "account": "บัญชี",
        "payment.settings": "การตั้งค่าการชำระเงิน",
        "support": "สนับสนุน",
        "logout": "ออกจากระบบ",
        "plan": "แผน",
        "resets.in": "รีเซ็ตใน",
        "api.access": "การเข้าถึง API",
        "days": "วันและ",
        "hours": "ชั่วโมง",
        "upgrade.plan": "อัปเกรดแผน"
      },
      "updateEmailModal": {
        "email.validation.error": "กรุณาใส่อีเมลที่ถูกต้อง",
        "email.change.confirm": "คุณแน่ใจหรือว่าต้องการเปลี่ยนที่อยู่อีเมลของคุณ?",
        "email.change.success": "อีเมลของคุณได้ถูกเปลี่ยนเรียบร้อยแล้ว!",
        "email.in.use.error": "อีเมลนี้ถูกใช้งานอยู่แล้ว กรุณาลองใช้อีเมลอื่น",
        "email.recent.login.error": "ก่อนดำเนินการต่อ กรุณาเข้าสู่ระบบอีกครั้งด้วยที่อยู่อีเมลปัจจุบัน",
        "email.invalid.error": "ที่อยู่อีเมลไม่ถูกต้อง กรุณาลองใช้อีเมลอื่น",
        "subscription.cancel.error": "กรุณายกเลิกการสมัครสมาชิกที่ชำระเงินที่ใช้งานอยู่ก่อน",
        "account.delete.confirm": "คุณแน่ใจหรือว่าต้องการลบบัญชีของคุณ?\n\nการกระทำนี้ไม่สามารถย้อนกลับได้",
        "account.delete.success": "บัญชีของคุณได้ถูกลบเรียบร้อยแล้ว",
        "account.delete.error": "เกิดข้อผิดพลาดบางอย่างและเราไม่สามารถลบบัญชีของคุณได้\n\nกรุณาติดต่อฝ่ายสนับสนุนผู้ใช้ของเรา",
        "subscription.cancel": "ยกเลิกการสมัครสมาชิก",
        "account.delete": "ลบบัญชี",
        "account.delete.warning": "การลบบัญชีของคุณไม่สามารถย้อนกลับได้และจะลบเนื้อหาทั้งหมดและข้อมูลการเข้าสู่ระบบของคุณอย่างถาวร กรุณาดำเนินการด้วยความระมัดระวังเนื่องจากการกระทำนี้ไม่สามารถย้อนกลับได้",
        "current.account.email": "อีเมลบัญชีปัจจุบัน",
        "enter.new.email": "กรุณาใส่อีเมลบัญชีใหม่ของคุณ",
        "update": "อัปเดต",
        "change.password": "เปลี่ยนรหัสผ่าน",
        "payment.settings": "การตั้งค่าการชำระเงิน"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "ชื่อตอน"
      },
      "episodelist": {
        "loading.episodes": "กำลังโหลดตอน",
        "no.episodes.found": "ไม่พบตอนใด ๆ กรุณาลองอีกครั้งด้วย RSS id ที่ถูกต้อง",
        "select.episode": "เลือกตอนที่คุณต้องการสร้างเนื้อหา"
      },
      "interfaces": {
        "user.activePlan.tier": "ระดับ",
        "user.activePlan.creationDate": "วันที่สร้าง",
        "user.activePlan.minutesAvailable": "นาทีที่มีอยู่"
      },
      "loadingbar": {
        "loadingbar.magic": "เรายังคงทำเวทมนตร์อยู่ ✨",
        "loadingbar.longer": "บางตอนอาจใช้เวลานานกว่าปกติ... 🐌",
        "loadingbar.hardwork": "เซิร์ฟเวอร์ของเรากำลังทำงานอย่างหนัก 🦾"
      },
      "page": {
        "main.background": "พื้นหลังของส่วนหลัก"
      },
      "recordfile": {
        "microphone.camera.access.denied": "ข้อผิดพลาด: ไม่สามารถเข้าถึงไมโครโฟนหรือกล้องได้",
        "microphone.camera.not.found": "ข้อผิดพลาด: ไม่พบไมโครโฟนหรือกล้อง",
        "microphone.camera.not.readable": "ข้อผิดพลาด: ไมโครโฟนหรือกล้องไม่สามารถอ่านได้",
        "microphone.camera.access.error": "ข้อผิดพลาด: เกิดข้อผิดพลาดที่ไม่ทราบขณะเข้าถึงไมโครโฟนหรือกล้อง",
        "media.not.recorded": "ข้อผิดพลาด: ไม่มีสื่อที่ถูกบันทึก",
        "upload.failed": "ข้อผิดพลาด: การอัปโหลดล้มเหลว",
        "upload.success": "สำเร็จ: การอัปโหลดเสร็จสมบูรณ์",
        "upload.in.progress": "กำลังอัปโหลด...",
        "upload.button": "อัปโหลดการบันทึก",
        "stop.recording": "หยุดการบันทึก",
        "record.audio": "บันทึกเสียง",
        "record.audio.video": "บันทึกเสียงพร้อมวิดีโอ",
        "record.again": "บันทึกอีกครั้ง",
        "episode.language": "เลือกภาษาในตอน"
      },
      "selectBox": {
        "language.english": "อังกฤษ",
        "language.arabic": "อาหรับ",
        "language.bulgarian": "บัลแกเรีย",
        "language.catalan": "คาตาลัน",
        "language.croatian": "โครเอเชีย",
        "language.czech": "เช็ก",
        "language.danish": "เดนมาร์ก",
        "language.dutch": "ดัตช์",
        "language.finnish": "ฟินแลนด์",
        "language.french": "ฝรั่งเศส",
        "language.german": "เยอรมัน",
        "language.greek": "กรีก",
        "language.hindi": "ฮินดี",
        "language.hungarian": "ฮังการี",
        "language.indonesian": "อินโดนีเซีย",
        "language.italian": "อิตาลี",
        "language.japanese": "ญี่ปุ่น",
        "language.korean": "เกาหลี",
        "language.lithuanian": "ลิทัวเนีย",
        "language.latvian": "ลัตเวีย",
        "language.malay": "มาเลย์",
        "language.mandarin": "แมนดาริน",
        "language.norwegian": "นอร์เวย์",
        "language.polish": "โปแลนด์",
        "language.portuguese": "โปรตุเกส",
        "language.romanian": "โรมาเนีย",
        "language.russian": "รัสเซีย",
        "language.slovak": "สโลวัก",
        "language.slovenian": "สโลวีเนีย",
        "language.spanish": "สเปน",
        "language.swedish": "สวีเดน",
        "language.tamil": "ทมิฬ",
        "language.turkish": "ตุรกี",
        "language.ukrainian": "ยูเครน",
        "language.bashkir": "บาชคีเรีย",
        "language.basque": "บาสก์",
        "language.belarusian": "เบลารุส",
        "language.cantonese": "กวางตุ้ง",
        "language.esperanto": "เอสเปอรันโต",
        "language.estonian": "เอสโตเนีย",
        "language.galician": "กาลิเซีย",
        "language.interlingua": "อินเตอร์ลิงกัว",
        "language.marathi": "มาราธี",
        "language.mongolian": "มองโกเลีย",
        "language.persian": "เปอร์เซีย",
        "language.thai": "ไทย",
        "language.uyghur": "อุยกูร์",
        "language.vietnamese": "เวียดนาม",
        "language.welsh": "เวลส์"
      },
      "selectedepisode": {
        "processing.episode": "กำลังประมวลผลตอน",
        "processing.time": "โดยปกติใช้เวลาประมาณ 5 - 10 นาที",
        "email.notification": "คุณสามารถปิดหน้าต่างนี้ได้ เราจะส่งอีเมลถึงคุณเมื่อพร้อม เนื้อหาของคุณจะสามารถเข้าถึงได้ในแดชบอร์ดของคุณด้วย",
        "convert.another.episode": "แปลงตอนอื่น",
        "technical.difficulties": "อุ๊บส์! เรากำลังประสบปัญหาทางเทคนิคอยู่ โปรดมั่นใจว่าทีมงานของเรากำลังดำเนินการอยู่! กรุณาลองอีกครั้งในภายหลัง",
        "no.discount": "ไม่ต้องกังวล เราจะไม่ลดเวลาทั้งหมด!",
        "high.demand": "เรากำลังประสบความต้องการที่สูงกว่าปกติ ดังนั้นอาจใช้เวลานานกว่าปกติในการประมวลผลคำขอของคุณ เราขออภัยในความไม่สะดวก!",
        "email.ready": "เราจะส่งอีเมลถึงคุณเมื่อพร้อม คุณยังสามารถเข้าถึงผลลัพธ์ของคุณได้ในแดชบอร์ดของคุณ",
        "select.podcast.folder": "เลือกโฟลเดอร์พอดแคสต์ที่ตอนนี้อยู่ หรือสร้างใหม่โดยการพิมพ์ชื่อ",
        "give.voice": "ปรับแต่งเสียงของโฟลเดอร์",
        "generate.content": "สร้างเนื้อหา",
        "not.enough.minutes.title": "คุณไม่มีครบชั่วโมง",
        "not.enough.minutes.message": "คุณไม่มีครบชั่วโมงในการแปลงตอนนี้ กรุณาอัพเกรดสูงสุดเป็นครั้งถัดไป",
        "upgrade.plan": "อัพเกรดสูงสุด",
        "convert.shorter.episode": "แปลงตอนที่สั้นกว่านี้",
        "content.ready": "เนื้อหาของคุณพร้อมแล้ว!",
        "ask.ai.tune": "คุณยังสามารถขอให้ AI ปรับแต่งเนื้อหาแต่ละชิ้นให้เหมาะกับความต้องการของคุณได้",
        "error.title": "ข้อผิดพลาด",
        "convert.another.file": "แปลงไฟล์อื่น"
      },
      "submitfile": {
        "file.size.exceeded.free": "ขนาดไฟล์เกินขีดจำกัดสูงสุดที่ 4 GB <p>กรุณา <a href='/pricing'><b><u>อัปเกรดเพื่ออัปโหลดไฟล์ที่ใหญ่กว่า</u></b></a></p>",
        "file.size.exceeded.paid": "ขนาดไฟล์เกินขีดจำกัดสูงสุดที่ 10 GB <p>กรุณาเลือกไฟล์ที่มีขนาดเล็กกว่า</p>",
        "file.upload.invalid": "กรุณาอัปโหลดไฟล์เสียงหรือวิดีโอ",
        "upload.in.progress": "กำลังอัปโหลดไฟล์ กรุณาอย่าปิดหน้าต่างนี้",
        "upload.button": "อัปโหลด & สร้าง",
        "upgrade.message.free": "การอัปโหลดเพิ่มเติมมีให้เฉพาะในระดับที่ต้องชำระเงิน",
        "upgrade.now.button": "อัปเกรดตอนนี้",
        "close.button": "ปิด",
        "pricing.info": "เริ่มต้นที่ $12/เดือน",
        "upload.file.label": "อัปโหลดไฟล์เสียงหรือวิดีโอ",
        "max.file.size.free": "(สูงสุด 4 GB)",
        "max.file.size.paid": "(สูงสุด 10 GB)",
        "podsqueeze.audiograms.info": "Podsqueeze จะสร้าง audiograms สำหรับไฟล์เสียงและคลิปสั้นสำหรับไฟล์วิดีโอ",
        "file.placeholder": "ไฟล์ MP3/WAV ของคุณ",
        "episode.language.label": "ภาษาในตอน",
        "select.folder.label": "เลือกหรือสร้างโฟลเดอร์",
        "multiple.files.selected": "เลือก {{count}} ไฟล์แล้ว",
        "clear.all": "ล้างทั้งหมด",
        "file.name": "{{name}}",
        "multiple.files.toggle": "เลือกหลายไฟล์",
        "file.upload.error": "เกิดข้อผิดพลาดในการอัปโหลดไฟล์",
        "file.upload.success": "อัปโหลดไฟล์สำเร็จ",
        "file.upload.processing": "กำลังประมวลผลไฟล์",
        "click.to.upload": "คลิกเพื่ออัปโหลด",
        "click.to.upload.multiple": "คลิกเพื่ออัปโหลดหลายไฟล์",
        "enter.url": "ป้อน URL",
        "upload.file": "อัปโหลดไฟล์",
        "media.url.label": "URL สื่อ",
        "media.url.help": "ป้อน URL ของไฟล์เสียงหรือวิดีโอของคุณ เราจะดาวน์โหลดและประมวลผลให้คุณ",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "ชื่อตอน",
        "url.input.required": "กรุณาป้อน URL สื่อ",
        "url.upload.error": "ไม่สามารถอัปโหลดสื่อจาก URL ได้ กรุณาตรวจสอบ URL และลองอีกครั้ง",
        "supported.formats": "รูปแบบที่รองรับ",
        "uploading": "กำลังอัปโหลด...",
        "media.url.requirements": "URL ต้องเป็นลิงก์โดยตรงไปยังไฟล์สื่อสาธารณะ (ไม่ใช่หน้าเว็บ)"
      },
      "submitrssid": {
        "error.selectRss": "กรุณาเลือก RSS ที่ถูกต้องจากรายการดรอปดาวน์",
        "label.insertRssFeed": "แทรกฟีด RSS ของคุณ",
        "placeholder.insertRssFeed": "แทรกฟีด RSS ของคุณ",
        "label.searchByPodcast": "ค้นหาตามชื่อพอดแคสต์แทน",
        "label.searchForPodcast": "ค้นหาชื่อพอดแคสต์ของคุณ",
        "placeholder.searchForPodcast": "ค้นหาพอดแคสต์",
        "label.cantFindPodcast": "หาพอดแคสต์ของคุณไม่เจอ? ",
        "label.clickHereUseRss": "คลิกที่นี่เพื่อใช้ฟีด RSS ของคุณแทน",
        "label.selectedPodcast": "พอดแคสต์ที่เลือก",
        "label.episodeLanguage": "ภาษาในตอน",
        "button.seeAllEpisodes": "ดูตอนทั้งหมด",
        "select.folder.label": "เลือกหรือสร้างโฟลเดอร์"
      },
      "submitsection": {
        "search.podcast": "ค้นหาพอดแคสต์ของคุณ",
        "upload.audio.video": "อัปโหลดเสียงหรือวิดีโอ",
        "record.audio": "บันทึกเสียง",
        "youtube.video": "ลิงก์ YouTube",
        "create.content": "มาสร้างเนื้อหาสำหรับพอดแคสต์ของคุณกันเถอะ!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "ใส่ URL วิดีโอ YouTube",
        "error.insertYouTubeUrl": "กรุณาใส่ URL ของ YouTube.",
        "label.insertYouTubeUrl": "ใส่ URL วิดีโอ YouTube",
        "button.loading": "กำลังโหลด...",
        "message.downloadingFile": "กำลังดาวน์โหลดไฟล์...",
        "error.processingFailed": "ข้อผิดพลาด: การประมวลผลวิดีโอล้มเหลว.",
        "error.youtubeVideoNotAvailable": "วิดีโอ YouTube นี้ไม่พร้อมให้ดาวน์โหลด กรุณาอัพโหลดไฟล์เสียงหรือวิดีโอโดยตรงไปที่ Podsqueeze หรือใช้ ดาวน์โหลด YouTube ก่อน",
        "button.submitYouTubeVideo": "ส่งวิดีโอ YouTube",
        "episode.language.label": "ภาษาที่ใช้",
        "select.folder.label": "เลือกหรือสร้างโฟลเดอร์"
      },
      "tabs": {
        "tab.label.tab1": "แท็บ 1",
        "tab.label.tab2": "แท็บ 2",
        "tab.label.tab3": "แท็บ 3"
      },
      "tutorialVideo": {
        "tutorial.title": "ใช้ประโยชน์สูงสุดจาก Podsqueeze",
        "tutorial.chapter.introduction": "บทนำ",
        "tutorial.chapter.bestShowNotes": "รับโน้ตการแสดงและเวลาที่ดีที่สุด",
        "tutorial.chapter.blogPosts": "การใช้บล็อกโพสต์และจดหมายข่าว",
        "tutorial.chapter.editingTranscripts": "การฝังและแก้ไขทรานสคริปต์",
        "tutorial.chapter.personalizingAI": "ปรับแต่ง AI และให้เสียงของคุณเอง",
        "tutorial.chapter.speedingUpNotes": "เร่งความเร็วโน้ตการแสดง",
        "tutorial.chapter.creatingClips": "สร้างคลิปวิดีโอและภาพ",
        "tutorial.chapter.generatingLandingPage": "สร้างหน้าแลนดิ้ง",
        "tutorial.chapter.shareResults": "แชร์ผลลัพธ์กับทีมของคุณ",
        "tutorial.closeVideoCheckbox": "ปิดวิดีโอเมื่อผลลัพธ์แรกพร้อม"
      },
      "uploadloadingbar": {
        "upload.loading": "กำลังโหลด..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "ติดต่อเรา",
        "contact.section.email": "ส่งอีเมลถึงเราที่ support@podsqueeze.com",
        "contact.section.tiago.role": "ผู้ร่วมก่อตั้ง",
        "contact.section.joao.role": "ผู้ร่วมก่อตั้ง",
        "contact.section.image.alt.sendMessage": "ส่งข้อความ",
        "contact.section.image.alt.tiago": "ผู้ร่วมก่อตั้ง Podsqueeze Tiago",
        "contact.section.image.alt.joao": "ผู้ร่วมก่อตั้ง Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "ติดต่อเรา",
        "contact.section.email": "ส่งอีเมลถึงเราที่ support@podsqueeze.com",
        "contact.section.tiago.role": "ผู้ร่วมก่อตั้ง",
        "contact.section.joao.role": "ผู้ร่วมก่อตั้ง",
        "contact.section.image.alt.sendMessage": "ส่งข้อความ",
        "contact.section.image.alt.tiago": "ผู้ร่วมก่อตั้ง Podsqueeze Tiago",
        "contact.section.image.alt.joao": "ผู้ร่วมก่อตั้ง Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "เข้าร่วมกับผู้สร้างเนื้อหาและมืออาชีพด้านพอดแคสต์ 20,000 คนที่ใช้ Podsqueeze",
        "content.creators": "ผู้สร้างเนื้อหา",
        "podcast.managers": "ผู้จัดการพอดแคสต์",
        "producers.studios": "ผู้ผลิต & สตูดิโอ",
        "for.podcasters": "สำหรับพอดแคสเตอร์ ผู้จัดการพอดแคสต์ และเอเจนซี่",
        "manage.content.creation": "จัดการการสร้างเนื้อหาได้อย่างง่ายดายสำหรับ",
        "multiple.podcasts": "พอดแคสต์หลายรายการ",
        "podsqueeze.description": "Podsqueeze เป็นเครื่องมือที่ทรงพลังสำหรับมืออาชีพด้านพอดแคสต์ทุกคน ไม่ว่าคุณจะเป็นพอดแคสเตอร์เดี่ยว ผู้จัดการพอดแคสต์ หรือเอเจนซี่ Podsqueeze มีฟีเจอร์ทั้งหมดที่คุณต้องการเพื่อทำให้กระบวนการสร้างเนื้อหาพอดแคสต์ของคุณมีประสิทธิภาพมากขึ้น",
        "create.podcast.folders": "สร้างโฟลเดอร์พอดแคสต์เพื่อจัดระเบียบตอนของคุณ",
        "share.content.page": "แชร์หน้าสำหรับเนื้อหาของคุณกับลูกค้าและทีมได้อย่างง่ายดาย",
        "tune.ai.voice": "ปรับเสียง AI สำหรับทุกโชว์ที่คุณจัดการ",
        "plan.content.episodes": "วางแผนเนื้อหาสำหรับตอนถัดไปด้วย",
        "podcast.topics.finder": "เครื่องมือค้นหาหัวข้อพอดแคสต์ขั้นสูงของเรา",
        "podsqueeze.testimonial": "ความสามารถของ Podsqueeze ในการใช้คำสั่งเพื่อปรับเนื้อหาของพอดแคสต์แต่ละรายการที่เราจัดการและบันทึกไว้สำหรับตอนในอนาคต ช่วยให้เรารักษาเสียงของแต่ละโชว์ให้สอดคล้องกัน นี่คือฟีเจอร์ระดับสูงที่เราไม่สามารถหาได้จากเครื่องมืออื่น ๆ",
        "coo.podigy": "COO ที่ Podigy Podcasts",
        "agenciessection.joinCreators": "เข้าร่วมกับผู้สร้างเนื้อหาและมืออาชีพด้านพอดแคสต์ 20,000 คนที่ใช้ Podsqueeze",
        "agenciessection.contentCreators": "ผู้สร้างเนื้อหา",
        "agenciessection.podcastManagers": "ผู้จัดการพอดแคสต์",
        "agenciessection.producersStudios": "ผู้ผลิต & สตูดิโอ",
        "agenciessection.forPodcasters": "สำหรับพอดแคสเตอร์ ผู้จัดการพอดแคสต์ และเอเจนซี่",
        "agenciessection.manageContent": "จัดการการสร้างเนื้อหาได้อย่างง่ายดายสำหรับ",
        "agenciessection.multiplePodcasts": "พอดแคสต์หลายรายการ",
        "agenciessection.podsqueezeDescription": "Podsqueeze เป็นเครื่องมือที่ทรงพลังสำหรับมืออาชีพด้านพอดแคสต์ทุกคน ไม่ว่าคุณจะเป็นพอดแคสเตอร์เดี่ยว ผู้จัดการพอดแคสต์ หรือเอเจนซี่ Podsqueeze มีฟีเจอร์ทั้งหมดที่คุณต้องการเพื่อทำให้กระบวนการสร้างเนื้อหาพอดแคสต์ของคุณมีประสิทธิภาพมากขึ้น",
        "agenciessection.createPodcastFolders": "สร้างโฟลเดอร์พอดแคสต์เพื่อจัดระเบียบตอนของคุณ",
        "agenciessection.shareContent": "แชร์หน้าสำหรับเนื้อหาของคุณกับลูกค้าและทีมได้อย่างง่ายดาย",
        "agenciessection.tuneAI": "ปรับเสียง AI สำหรับทุกโชว์ที่คุณจัดการ",
        "agenciessection.planContent": "วางแผนเนื้อหาสำหรับตอนถัดไปด้วย",
        "agenciessection.podcastTopicsFinder": "เครื่องมือค้นหาหัวข้อพอดแคสต์ขั้นสูงของเรา",
        "agenciessection.podsqueezeQuote": "ความสามารถของ Podsqueeze ในการใช้คำสั่งเพื่อปรับเนื้อหาของพอดแคสต์แต่ละรายการที่เราจัดการและบันทึกไว้สำหรับตอนในอนาคต ช่วยให้เรารักษาเสียงของแต่ละโชว์ให้สอดคล้องกัน นี่คือฟีเจอร์ระดับสูงที่เราไม่สามารถหาได้จากเครื่องมืออื่น ๆ",
        "agenciessection.coO": "COO ที่ Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "ฟีเจอร์ใหม่",
        "seamless.editing": "การแก้ไขที่ราบรื่นและการปรับปรุงเสียงสำหรับธรรมชาติ, ",
        "high.quality.results": " ผลลัพธ์ที่มีคุณภาพสูง",
        "experience.seamless.audio.editing": "สัมผัสประสบการณ์การแก้ไขเสียงที่ราบรื่นด้วยอัลกอริธึม AI ขั้นสูงสำหรับการบันทึกที่ยอดเยี่ยม.",
        "remove.ums": "ลบคำว่า 'อืม'",
        "enhance.sound.quality": ", ความเงียบ และปรับปรุงคุณภาพเสียงด้วยการคลิกเพียงครั้งเดียว.",
        "enhance.audio.now": "ปรับปรุงเสียงตอนนี้",
        "sample.audio.recorded": "ตัวอย่างเสียงที่บันทึกโดยตรงจากโทรศัพท์.",
        "original.recording": "การบันทึกต้นฉบับ",
        "audio.after.ai.edit": "เสียงหลังจากการแก้ไขและปรับปรุงด้วย AI",
        "experience.audio.editing": "สัมผัสประสบการณ์การแก้ไขเสียงที่ราบรื่นด้วยอัลกอริธึม AI ขั้นสูงสำหรับการบันทึกที่ยอดเยี่ยม."
      },
      "home-blogsection": {
        "more.resources.label": "แหล่งข้อมูลเพิ่มเติมสำหรับพอดแคสต์ของคุณ",
        "learn.how.to.get.most": "เรียนรู้วิธีการใช้ประโยชน์สูงสุดจาก",
        "your.content": "เนื้อหาของคุณ",
        "get.most.out.of.ai.content": "ใช้ประโยชน์สูงสุดจากเนื้อหาที่สร้างโดย AI สำหรับพอดแคสต์ของคุณ",
        "welcome.to.podsqueeze": "ยินดีต้อนรับสู่ Podsqueeze – วิธีที่ง่ายที่สุดในการถอดเสียงพอดแคสต์ของคุณและสร้างเนื้อหาที่น่าสนใจ...",
        "will.google.penalize.ai.content": "Google จะลงโทษเนื้อหาที่สร้างโดย AI ของคุณหรือไม่?",
        "ai.content.discussion": "การเกิดขึ้นของเนื้อหาที่สร้างโดย AI ได้จุดประกายการสนทนาและสร้างความกังวลในหมู่ผู้สร้างเนื้อหา นักการตลาด และ SEO...",
        "what.is.rss.feed": "RSS feed คืออะไรสำหรับพอดแคสต์และวิธีการใช้งาน",
        "rss.feed.benefits": "ในฐานะที่เป็นผู้ทำพอดแคสต์ คุณอาจเคยได้ยินคำว่า 'RSS feed' มาก่อน แต่คุณอาจไม่รู้ว่ามันคืออะไรหรือจะเป็นประโยชน์อย่างไร...",
        "visit.blog": "เยี่ยมชมบล็อก"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "คลิป & ออดิโอแกรม",
        "clipsAndAudiograms.subtitle": "นำพอดแคสต์ของคุณมาใช้ใหม่เป็นคลิปได้อย่างง่ายดาย",
        "clipsAndAudiograms.description": "เพียงเลือกบทจากตอนของคุณและส่งออกเป็นคลิปหรือออดิโอแกรมสำหรับ TikTok, Instagram และ YouTube Shorts เลือกเทมเพลตและปรับให้เข้ากับสไตล์ของคุณเอง",
        "clipsAndAudiograms.createClips": "สร้างคลิปตอนนี้",
        "textEditor.title": "โปรแกรมแก้ไขข้อความ",
        "textEditor.description": "ปรับแต่งคลิปและออดิโอแกรมของคุณโดยตรงจากคำบรรยาย แก้ไขคำบรรยายและตัดวิดีโอของคุณโดยการลบคำเฉพาะ",
        "oneClickShorts.title": "คลิปเพียงคลิกเดียว (<60 วินาที)",
        "oneClickShorts.description": "ให้ AI จัดการการตัดต่อให้คุณ ด้วยการกดปุ่ม AI จะทำให้แต่ละบทของตอนของคุณสั้นลงไม่เกิน 60 วินาที พร้อมสำหรับการโพสต์เป็น YouTube Short หรือคลิป TikTok"
      },
      "home-conatctsection": {
        "contact.section.title": "ติดต่อผู้ก่อตั้ง",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- นักพัฒนา & พอดแคสเตอร์",
        "contact.section.joao.role": "- นักออกแบบ UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "ความหลากหลายของเนื้อหา",
        "generate.content": "สร้างเนื้อหาด้วย",
        "one.click": " คลิกเดียว!",
        "transcript.srt": "ถอดความ & SRT",
        "transcript.description": "รับถอดความเต็มรูปแบบของตอนพอดแคสต์ของคุณ พร้อมไฟล์ SRT ที่พร้อมสำหรับการสร้างคำบรรยายและซับไตเติ้ล",
        "show.notes": "หมายเหตุการแสดง",
        "show.notes.description": "สรุปหัวข้อหลักที่ครอบคลุมในตอนของคุณและทำให้ค้นหาได้ง่ายขึ้น",
        "timestamps": "เวลา",
        "timestamps.description": "สร้างบทที่มีเวลาและแนะนำผู้ฟังไปยังส่วนเฉพาะของตอนพอดแคสต์ของคุณ",
        "blog.social.posts": "บล็อก & โพสต์โซเชียล",
        "blog.social.posts.description": "โพสต์เกี่ยวกับตอนพอดแคสต์ของคุณทุกที่และดึงดูดผู้ฟังใหม่",
        "newsletter": "จดหมายข่าว",
        "newsletter.description": "ทำให้ผู้ฟังของคุณได้รับข้อมูลล่าสุดเกี่ยวกับตอนใหม่",
        "titles.more": "ชื่อเรื่อง & อื่นๆ!",
        "titles.more.description": "สร้างชื่อที่ดึงดูดใจ, คำคม, จุดสำคัญ, คำสำคัญ และอื่นๆ!",
        "see.sample.content": "ดูเนื้อหาตัวอย่าง",
        "wannabe.entrepreneur": "ผู้ประกอบการที่อยากเป็น - #299 Podsqueeze เพิ่งทำรายได้ถึง $100,000 ต่อปี!",
        "making.space": "Making Space - สตีฟ ฮาร์วีย์: “คุณอาจจะต้องเดินหน้าต่อไป”",
        "modern.wisdom": "Modern Wisdom - เอริค โฮเอล - คู่มือสู่ปริศนาพื้นฐานของจิตใจ"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "เส้นแบ่ง"
      },
      "home-explanationsection": {
        "fast.accurate": "รวดเร็วและแม่นยำ",
        "generate.content": "สร้างเนื้อหาสำหรับพอดแคสต์ของคุณด้วย",
        "power.of.ai": "พลังของ AI",
        "upload.image.alt": "อัปโหลดภาพ",
        "select.episode": "เลือกตอนจากฟีด RSS ของคุณหรืออัปโหลดไฟล์เสียง/วิดีโอ",
        "paste.rss.feed": "เพียงแค่วาง URL ฟีด RSS ของคุณเพื่อเลือกตอนจากรายการหรืออัปโหลดไฟล์เสียงหรือวิดีโอ.",
        "content.image.alt": "ภาพเนื้อหา",
        "one.click.content": "รับเนื้อหาทั้งหมดด้วยการคลิกเพียงครั้งเดียว!",
        "user.friendly.interface": "อินเทอร์เฟซที่ใช้งานง่ายและเข้าใจได้ คุณสามารถเริ่มใช้งานได้ทันที สร้างเนื้อหาสำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว.",
        "tune.image.alt": "ภาพการปรับแต่ง",
        "edit.fine.tune": "แก้ไขและปรับแต่งเนื้อหาแต่ละชิ้น",
        "direct.edit.content": "แก้ไขและปรับแต่งเนื้อหาแต่ละชิ้นตามที่คุณต้องการด้วย AI ตัวอย่างเช่น คุณสามารถขอให้มีโทนเสียงเฉพาะ การพูดตรงหรืออ้อม หรือเพียงแค่แก้ไขชื่อที่สะกดผิด.",
        "multiple.language.support": "รองรับหลายภาษา",
        "language.flags.alt": "ธงภาษา",
        "generate.content.aria": "สร้างเนื้อหา"
      },
      "home-featuressection": {
        "loading": "กำลังโหลด...",
        "transcribe.write.show.notes": "ถอดเสียงและเขียนโน้ตสำหรับพอดแคสต์ของคุณ",
        "twenty.times.faster": "เร็วขึ้น 20 เท่า",
        "save.manual.work": "ประหยัดงานด้วยตนเองได้ถึง 100% ถอดเสียงพอดแคสต์ของคุณโดยอัตโนมัติด้วยความแม่นยำที่ทันสมัยและการระบุผู้พูด และสร้างโน้ตที่สมบูรณ์และโพสต์โซเชียลมีเดียในเสียงของคุณเอง",
        "generate.content": "สร้างเนื้อหา",
        "transcripts": "ถอดเสียง",
        "full.transcript": "รับถอดเสียงเต็มรูปแบบของตอนพอดแคสต์และถอดเสียงวิดีโอ YouTube ของคุณ พร้อมไฟล์ SRT สำหรับคำบรรยาย",
        "show.notes": "โน้ตแสดง",
        "summarize.generate.show.notes": "สรุปและสร้างโน้ตแสดงในเสียงของคุณเอง พร้อมด้วยเวลา, จุดสำคัญ และการกล่าวถึง",
        "blog.newsletter": "บล็อกและจดหมายข่าว",
        "actionable.blog.posts": "รับบล็อกโพสต์ที่สามารถนำไปใช้ได้เกี่ยวกับตอนของคุณและจดหมายข่าวที่พร้อมส่งพร้อมกับข้อสรุปหลัก",
        "social.media": "โซเชียลมีเดีย",
        "short.posts.insights": "รับโพสต์สั้นและข้อมูลเชิงลึกขนาดเล็กเพื่อเผยแพร่ข่าวสารในโซเชียลมีเดีย",
        "quote": "จากเครื่องมือถอดเสียง AI ที่ดีที่สุดทั้งหมดที่เราทดสอบ, Podsqueeze สร้างผลลัพธ์ที่มีประโยชน์ที่สุดสำหรับโน้ตแสดง, เวลา, ชื่อ, การกล่าวถึง, ตัวอย่างบล็อกโพสต์, และคำพูดสำคัญ",
        "justin.jackson": "จัสติน แจ็คสัน",
        "cofounder.transistor": "ผู้ร่วมก่อตั้ง Transistor.fm",
        "transcribe_and_write_show_notes": "พอดแคสต์ถอดเสียง, สรุปและโพสต์โซเชียลมีเดีย",
        "twenty_times_faster": "เร็วขึ้น 20 เท่า",
        "save_manual_work": "ประหยัดงานด้วยตนเองได้ถึง 100% ถอดเสียงพอดแคสต์ของคุณโดยอัตโนมัติด้วยความแม่นยำที่ทันสมัยและการระบุผู้พูด และสร้างโน้ตที่สมบูรณ์และโพสต์โซเชียลมีเดียในเสียงของคุณเอง",
        "generate_content": "สร้างเนื้อหา",
        "full_transcript": "รับถอดเสียงเต็มรูปแบบของตอนพอดแคสต์และถอดเสียงวิดีโอ YouTube ของคุณ พร้อมไฟล์ SRT สำหรับคำบรรยาย",
        "show_notes": "โน้ตแสดง",
        "summarize_and_generate_show_notes": "สรุปและสร้างโน้ตแสดงในเสียงของคุณเอง พร้อมด้วยเวลา, จุดสำคัญ และการกล่าวถึง",
        "blog_and_newsletter": "บล็อกและจดหมายข่าว",
        "actionable_blog_posts": "รับบล็อกโพสต์ที่สามารถนำไปใช้ได้เกี่ยวกับตอนของคุณและจดหมายข่าวที่พร้อมส่งพร้อมกับข้อสรุปหลัก",
        "social_media": "โซเชียลมีเดีย",
        "short_posts_and_insights": "รับโพสต์สั้นและข้อมูลเชิงลึกขนาดเล็กเพื่อเผยแพร่ข่าวสารในโซเชียลมีเดีย",
        "testimonial": "จากเครื่องมือถอดเสียง AI ที่ดีที่สุดทั้งหมดที่เราทดสอบ, Podsqueeze สร้างผลลัพธ์ที่มีประโยชน์ที่สุดสำหรับโน้ตแสดง, เวลา, ชื่อ, การกล่าวถึง, ตัวอย่างบล็อกโพสต์, และคำพูดสำคัญ",
        "cofounder_transistor": "ผู้ร่วมก่อตั้ง Transistor.fm"
      },
      "home-page": {
        "main.background": "สีพื้นหลังสำหรับส่วนหลัก"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "ฟังพอดแคสต์ของเรา",
        "podcast.section.subtitle": "คลาสเรียนจาก",
        "podcast.section.highlight": "พอดแคสเตอร์ที่มีประสบการณ์",
        "podcast.section.description": "ฟังพอดแคสต์ของเรา ซึ่งเราสัมภาษณ์พอดแคสเตอร์ที่มีประสบการณ์และผู้ใช้ Podsqueeze จากทั่วโลก เราขอให้พวกเขาแบ่งปันเคล็ดลับ ข้อมูลเชิงลึก เรื่องราว และทุกสิ่งที่คุณต้องรู้เพื่อพัฒนาพอดแคสต์ของคุณเอง",
        "podcast.link.spotify": "ฟังบน Spotify",
        "podcast.link.apple": "ฟังบน Apple Podcasts",
        "podcast.link.youtube": "ฟังบน YouTube"
      },
      "home-spinner": {
        "spinner.loading": "กำลังโหลด..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "ทำให้พอดแคสต์ของคุณเป็นอัตโนมัติ",
        "tagline.productionPromotion": "การผลิต & การโปรโมต",
        "tagline.launchGrow": "เริ่มต้นและเติบโตพอดแคสต์เสียงหรือวิดีโอของคุณได้อย่างง่ายดายด้วยทุกสิ่งที่คุณต้องการในที่เดียว โดยมี AI ช่วยเหลือ",
        "tagline.uploadGenerate": "สร้างพอดแคสต์ถอดเสียง, สรุป, คลิปสั้นพร้อมกับคำบรรยายและมากกว่านี้!",
        "tagline.singleClick": " ทั้งหมดนี้เพียงแค่คลิกเดียว",
        "tagline.transcripts": "การถอดเสียงพอดแคสต์",
        "tagline.showNotes": "หมายเหตุการแสดง",
        "tagline.newslettersBlogs": "จดหมายข่าว & บล็อก",
        "tagline.socialPosts": "โพสต์โซเชียล",
        "tagline.shortClipsAudiograms": "คลิปสั้น & ออดิโอแกรม",
        "tagline.podcastWebsite": "เว็บไซต์พอดแคสต์",
        "tagline.aiAudioEnhancement": "การปรับปรุงเสียงด้วย AI",
        "tagline.removeSilences": "ลบความเงียบและเสียงอืมอา",
        "tagline.generateNow": "สร้างตอนนี้ฟรี",
        "tagline.noCreditCard": "ไม่ต้องใช้บัตรเครดิต",
        "testimonial.robWalling.title": "Rob Walling, บุคลิกภาพสตาร์ทอัพ",
        "testimonial.robWalling.subtitle": "พอดแคสต์สำหรับคนทั่วไป",
        "testimonial.robWalling.quote": "หมายเหตุการแสดงของ Podsqueeze เป็นสิ่งที่ดีที่สุด เราใช้มันมากสำหรับการสรุปและเพื่อให้ได้ข้อมูลเชิงลึกจากพอดแคสต์อื่น ๆ",
        "testimonial.johnGarmet.title": "John Garmet, ผู้อำนวยการฝ่ายปฏิบัติการ",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze ช่วยให้เรามีประสิทธิภาพมากขึ้นและสร้างเนื้อหามากขึ้นสำหรับลูกค้าของเรา เราขอแนะนำอย่างยิ่ง",
        "testimonial.davidJackson.title": "David Jackson, โค้ชพอดแคสต์",
        "testimonial.davidJackson.subtitle": "โรงเรียนพอดแคสต์",
        "testimonial.davidJackson.quote": "Podsqueeze เป็นคู่คิดของฉัน มันเป็นวิธีที่ดีที่สุดในการคิดค้นการตลาดพอดแคสต์"
      },
      "home-testimonials": {
        "testimonials.title": "ผู้คนพูดถึง Podsqueeze ว่าอย่างไร",
        "testimonials.image.alt": "Podsqueeze - ใช้ AI ในการนำเนื้อหาพอดแคสต์ของคุณกลับมาใช้ใหม่ | Product Hunt",
        "testimonials.heading": "ผู้คนพูดถึง Podsqueeze ว่าอย่างไร"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "รหัสผ่านไม่ถูกต้อง",
        "error.userNotFound": "ไม่พบผู้ใช้",
        "error.somethingWentWrong": "อุ๊ปส์ เกิดข้อผิดพลาดบางอย่าง",
        "button.sendResetEmail": "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        "button.login": "เข้าสู่ระบบ",
        "placeholder.email": "ที่อยู่อีเมล",
        "placeholder.password": "รหัสผ่าน",
        "link.forgotPassword": "ลืมรหัสผ่านใช่ไหม?",
        "link.createAccount": "สร้างบัญชี",
        "text.or": "หรือ",
        "button.continueWithGoogle": "ดำเนินการต่อด้วย Google",
        "text.podcastDescription": "เริ่มต้นและเติบโตพอดแคสต์เสียงหรือวิดีโอของคุณได้อย่างง่ายดายด้วยทุกสิ่งที่คุณต้องการในที่เดียว",
        "feature.transcripts": "ถอดความ",
        "feature.showNotes": "หมายเหตุการแสดง",
        "feature.newslettersAndBlogs": "จดหมายข่าว & บล็อก",
        "feature.socialPosts": "โพสต์โซเชียล",
        "feature.shortClipsAndAudiograms": "คลิปสั้น & ออดิโอแกรม",
        "feature.podcastWebsite": "เว็บไซต์พอดแคสต์",
        "feature.aiAudioEnhancement": "การปรับปรุงเสียงด้วย AI",
        "feature.removeSilences": "ลบความเงียบและเสียงอืมอา",
        "button.sendVerificationEmail": "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        "error.emailNotVerified": "อีเมลไม่ได้รับการยืนยัน",
        "text.pleaseVerifyAccount": "ตรวจสอบบัญชีของคุณ",
        "text.checkSpamFolder": "เราได้ส่งอีเมลยืนยันให้คุณแล้ว กรุณาตรวจสอบกล่องจดหมายของคุณและโฟลเดอร์สแปม",
        "button.resendVerificationEmail": "ส่งอีเมลยืนยันอีกครั้ง",
        "error.verificationEmailFailed": "การส่งอีเมลยืนยันลูกค้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
      },
      "page": {
        "login.form": "แบบฟอร์มเข้าสู่ระบบ"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "หน้าเพจพันธมิตร Podsqueeze",
        "affiliate.page.description": "รับค่าคอมมิชชั่น 25% จากทุกการขายที่เกิดขึ้นผ่านลิงก์แนะนำพิเศษของคุณเป็นระยะเวลา 15 เดือน แบ่งปันลิงก์ของคุณบนเว็บไซต์ โซเชียลมีเดีย หรือกับเพื่อนของคุณ ใช้เวลาเพียงไม่กี่วินาทีในการเข้าร่วม รับการอนุมัติอัตโนมัติ"
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "ของขวัญที่ดีที่สุดสำหรับพอดแคสเตอร์",
        "bestGiftForPodcaster.description": "ค้นพบของขวัญที่ดีที่สุดสำหรับพอดแคสเตอร์เพื่อเพิ่มประสบการณ์ของพวกเขา",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "เพิ่มผู้ฟังพอดแคสต์",
        "get-more-podcast-listeners.description": "เพิ่มผู้ฟังพอดแคสต์และทำให้การผลิตเป็นไปอย่างราบรื่นด้วยโน้ตโชว์อัตโนมัติ คลิปสั้นเพื่อขยายการแสดงของคุณในโซเชียลมีเดีย และอื่นๆ อีกมากมาย"
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "ขยายผู้ฟังพอดแคสต์ของคุณ",
        "grow_your_podcast_audience.description": "ประหยัดเวลาได้มากและขยายผู้ฟังพอดแคสต์ของคุณด้วย Podsqueeze สร้างโน้ตโชว์ที่สมบูรณ์ โพสต์โซเชียลมีเดีย คลิปสั้น และอื่นๆ สำหรับพอดแคสต์ของคุณ"
      },
      "index": {
        "home.page.title": "โน้ตโชว์, ถอดความ, สรุป และเครื่องสร้างคลิปสำหรับพอดแคสต์ AI.",
        "home.page.description": "สร้างโน้ตโชว์, เวลาที่เกิดเหตุ, จดหมายข่าว และอื่นๆ สำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว! สร้างเนื้อหาสำหรับพอดแคสต์ของคุณอย่างรวดเร็วและปรับให้ตรงกับความต้องการของคุณ ลงทะเบียนฟรี."
      },
      "login": {
        "login.tryItNow": "ลองเลย!",
        "login.createAccountDescription": "สร้างบัญชีและเริ่มสร้างโน้ตแสดง, เวลาที่บันทึก, จดหมายข่าว และอื่นๆ สำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว! สร้างเนื้อหาสำหรับพอดแคสต์ของคุณอย่างรวดเร็วและปรับให้ตรงกับความต้องการของคุณ ลงทะเบียนฟรี."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "การตลาดสำหรับพอดแคสต์",
        "marketing.for.podcasts.description": "Podsqueeze ช่วยให้การตลาดสำหรับพอดแคสต์เป็นเรื่องง่ายด้วยการสร้างโน้ตโชว์อัตโนมัติ โพสต์โซเชียลมีเดีย และคลิปสั้นเพื่อเพิ่มการเข้าถึงและขยายรายการของคุณ"
      },
      "media": {
        "media.page.title": "หน้าเว็บสื่อของ Podsqueeze",
        "media.page.description": "เรียนรู้เพิ่มเติมเกี่ยวกับ Podsqueeze ติดต่อเรา! เราหวังว่าจะได้ร่วมงานกัน!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "เครื่องสร้างคำอธิบายพอดแคสต์",
        "podcast.description.generator.description": "ปรับปรุงการเข้าถึงและการมีส่วนร่วมของพอดแคสต์ของคุณด้วยคำอธิบายที่สร้างโดย AI อัตโนมัติการเขียนโน้ตโชว์ของคุณและเรียกคืนเวลาที่มีค่า"
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "นำพอดแคสต์ของคุณไปใช้ใหม่สำหรับโพสต์ในโซเชียลมีเดีย",
        "convert.podcast.episodes.to.social.media.posts": "แปลงตอนพอดแคสต์เป็นโพสต์ในโซเชียลมีเดีย สร้างโพสต์โดยอัตโนมัติสำหรับ LinkedIn, Twitter, Facebook และคลิปสั้นสำหรับ TikTok"
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "เครื่องสร้างหัวข้อพอดแคสต์ฟรี",
        "podcast.topics.generator.description": "เครื่องสร้างหัวข้อพอดแคสต์ฟรีของเราช่วยให้คุณค้นหาหัวข้อที่ดีที่สุดและคาดการณ์การเข้าถึงที่เป็นไปได้บน Google และ YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "ผู้ช่วยเสมือนพอดแคสต์ของคุณ",
        "podcast.virtual.assistant.description": "ผู้ช่วยเสมือนพอดแคสต์ AI ที่เขียนโน้ตการแสดงของคุณและสร้างโพสต์ในโซเชียลมีเดีย ปรับปรุงการผลิตและการตลาดพอดแคสต์ของคุณด้วย Podsqueeze."
      },
      "pricing": {
        "pricing.title": "ราคา",
        "pricing.description": "สร้างโน้ตแสดงรายการ, เวลาที่บันทึก, จดหมายข่าว และอื่น ๆ สำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว! เรามีหลายระดับราคาเพื่อตอบสนองความต้องการในการทำพอดแคสต์ของคุณ."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "โปรโมทพอดแคสต์ของคุณ",
        "promote.your.podcast.description": "สร้างโน้ตโชว์ โพสต์บนโซเชียลมีเดีย และคลิปสั้นเพื่อเผยแพร่และโปรโมทพอดแคสต์ของคุณในเวลาเพียงไม่กี่นาที"
      },
      "register": {
        "create.podsqueeze.account": "สร้างบัญชี Podsqueeze",
        "generate.content.podcast": "สร้างโน้ตแสดง, เวลาที่เกิดเหตุการณ์, จดหมายข่าว และอื่นๆ สำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว! สร้างเนื้อหาสำหรับพอดแคสต์ของคุณอย่างรวดเร็วและปรับให้ตรงกับความต้องการของคุณ ลงทะเบียนฟรี."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "นำเนื้อหาพอดแคสต์มาใช้ใหม่โดยอัตโนมัติ",
        "repurpose.your.podcast.content.with.ai": "นำเนื้อหาพอดแคสต์ของคุณมาใช้ใหม่ด้วย AI สร้างโน้ตโชว์ ชื่อเรื่อง คลิปสั้นสำหรับ TikTok และอื่นๆ อีกมากมาย เพียงแค่คลิกเดียว!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "เครื่องมือปรับแต่ง SEO พอดแคสต์ฟรี",
        "seo.optimizer.description": "วิเคราะห์และปรับแต่งตอนพอดแคสต์ของคุณเพื่อให้มองเห็นได้ดีขึ้นในเครื่องมือค้นหาด้วยคำแนะนำ SEO ที่ขับเคลื่อนด้วย AI",
        "seo.optimizer.heading": "ตัวปรับแต่ง SEO สำหรับพอดแคสต์",
        "seo.optimizer.headingnote": "วิเคราะห์และปรับแต่งตอนพอดแคสต์ของคุณเพื่อให้มองเห็นได้ดีขึ้นในเครื่องมือค้นหาด้วยคำแนะนำ SEO ที่ขับเคลื่อนด้วย AI",
        "seo.optimizer.selectEpisode": "เลือกตอนเพื่อวิเคราะห์",
        "seo.optimizer.results": "ผลการวิเคราะห์ SEO",
        "seo.optimizer.searchPodcastPlaceholder": "ค้นหาพอดแคสต์",
        "seo.optimizer.searchEpisodesPlaceholder": "ค้นหาตอน...",
        "seo.optimizer.analyseAnotherEpisode": "วิเคราะห์ตอนอื่น",
        "seo.optimizer.findingEpisodes": "กำลังค้นหาทุกตอน...",
        "seo.optimizer.analysingEpisode": "กำลังวิเคราะห์ตอน",
        "seo.optimizer.scoreTooltip": "คะแนน:",
        "seo.optimizer.topKeywords": "เราระบุคีย์เวิร์ดหลักเหล่านี้:",
        "seo.optimizer.topKeywordsnote": "อ้างอิงจากการวิเคราะห์คีย์เวิร์ดด้านล่างของหน้า",
        "seo.optimizer.optimizedContent": "จากคีย์เวิร์ด นี่คือตำแหน่งและคำอธิบายที่ปรับแต่งแล้ว:",
        "seo.optimizer.originalTitle": "ชื่อเรื่องดั้งเดิม",
        "seo.optimizer.optimizedTitle": "ชื่อเรื่องที่ปรับแต่งแล้ว",
        "seo.optimizer.originalDescription": "คำอธิบายดั้งเดิม",
        "seo.optimizer.optimizedDescription": "คำอธิบายที่ปรับแต่งแล้ว",
        "seo.optimizer.showMore": "แสดงเพิ่มเติม",
        "seo.optimizer.showLess": "แสดงน้อยลง",
        "seo.optimizer.keywordAnalysis": "การวิเคราะห์คีย์เวิร์ด",
        "seo.optimizer.keywordAnalysisnote": "คะแนนคำนวณจากปริมาณการค้นหา การแข่งขัน (จำนวนผลลัพธ์อื่น ๆ สำหรับคีย์เวิร์ดเดียวกัน) และในกรณีของ YouTube คือจำนวนการดูเฉลี่ยต่อวิดีโอสำหรับคีย์เวิร์ดเดียวกัน",
        "seo.optimizer.seoScore": "คะแนน SEO",
        "seo.optimizer.spotifyScore": "คะแนน Spotify",
        "seo.optimizer.youtubeScore": "คะแนน YouTube",
        "seo.optimizer.totalScore": "รวมทั้งหมด"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - เครื่องมือสร้างเนื้อหาพอดแคสต์ด้วย AI",
        "podsqueeze.description": "สร้างโน้ตแสดงรายการ, เวลาที่เกิดเหตุการณ์, จดหมายข่าว และอื่นๆ สำหรับพอดแคสต์ของคุณด้วยการคลิกเพียงครั้งเดียว! สร้างเนื้อหาสำหรับพอดแคสต์ของคุณได้อย่างรวดเร็วและปรับให้ตรงตามความต้องการของคุณ ลงทะเบียนฟรี."
      },
      "thumbnail-creator": {
        "title": "เครื่องสร้างภาพขนาดย่อพอดแคสต์ฟรี - สร้างภาพขนาดย่อตอนด้วย AI",
        "description": "สร้างภาพขนาดย่อพอดแคสต์ที่น่าทึ่งด้วย AI สร้างผลงานศิลปะตอนที่เป็นมืออาชีพและดึงดูดสายตา ที่เพิ่มการมองเห็นและดึงดูดผู้ฟังมากขึ้นสู่พอดแคสต์ของคุณ",
        "selectPodcast": "เลือกพอดแคสต์ของคุณ",
        "loadEpisodes": "โหลดตอน",
        "selectEpisode": "เลือกตอนสำหรับสร้างภาพขนาดย่อ",
        "createThumbnail": "สร้างภาพขนาดย่อ",
        "results": "ภาพขนาดย่อที่สร้างของคุณ",
        "download": "ดาวน์โหลด",
        "share": "แชร์",
        "regenerate": "สร้างใหม่",
        "editThumbnail": "แก้ไขภาพขนาดย่อ",
        "editPlaceholder": "อธิบายว่าคุณต้องการแก้ไขภาพขนาดย่อนี้อย่างไร...",
        "customPrompt": "พร้อมต์แบบกำหนดเอง",
        "yourThumbnail": "ภาพขนาดย่อของคุณ",
        "createAnother": "← สร้างภาพขนาดย่ออื่น",
        "findingEpisodes": "กำลังค้นหาตอน...",
        "searchPodcastPlaceholder": "ค้นหาพอดแคสต์ของคุณ...",
        "searchingPodcasts": "กำลังค้นหาพอดแคสต์...",
        "heroDescription": "สร้างภาพขนาดย่อพอดแคสต์ที่น่าทึ่งและเป็นมืออาชีพด้วยการออกแบบที่ขับเคลื่อนด้วย AI ที่ดึงดูดความสนใจและเพิ่มการมองเห็นตอนของคุณ",
        "generatedWithPrompt": "สร้างด้วยพร้อมต์:",
        "customPromptPlaceholder": "ป้อนพร้อมต์แบบกำหนดเองสำหรับการสร้างภาพขนาดย่อ...",
        "generating": "กำลังสร้าง...",
        "generate": "สร้าง",
        "modernMinimalist": "โมเดิร์นและมินิมอล",
        "vibrantDynamic": "สดใสและไดนามิก",
        "professionalClean": "เป็นมืออาชีพและสะอาด",
        "generatingThumbnail": "กำลังสร้างภาพขนาดย่อ...",
        "generatingNewThumbnail": "กำลังสร้างภาพขนาดย่อใหม่...",
        "showingFirstEpisodes": "แสดง 10 ตอนแรก ใช้การค้นหาเพื่อหาตอนที่เฉพาะเจาะจง",
        "imageUrlCopied": "คัดลอก URL ของรูปภาพไปยังคลิปบอร์ดแล้ว!",
        "failedToGenerate": "ไม่สามารถสร้างภาพขนาดย่อได้ กรุณาลองใหม่อีกครั้ง",
        "promotionalTitle": "สร้างโน้ตรายการ ตราประทับเวลา คลิปไวรัล และอื่นๆ อีกมากมายด้วย Podsqueeze",
        "promotionalSubtitle": "เข้าร่วมกับนักสร้างสรรค์อีก 100K+ คนและเริ่มต้นการเติบโตของรายการของคุณ",
        "startNow": "เริ่มต้นตอนนี้",
        "free": "ฟรี",
        "podcast": "พอดแคสต์",
        "thumbnail": "ภาพขนาดย่อ",
        "creator": "ผู้สร้าง",
        "replaceFace": "เปลี่ยนใบหน้า",
        "uploading": "กำลังอัปโหลด...",
        "uploadImageError": "กรุณาอัปโหลดไฟล์รูปภาพ",
        "uploadFailedError": "การอัปโหลดรูปภาพล้มเหลว กรุณาลองใหม่อีกครั้ง",
        "uploadingImage": "กำลังอัปโหลดรูปภาพ...",
        "generatingNewThumbnailLoading": "กำลังสร้างภาพขนาดย่อใหม่...",
        "failedToGenerateWithFace": "การสร้างภาพขนาดย่อพร้อมการเปลี่ยนใบหน้าล้มเหลว กรุณาลองใหม่อีกครั้ง"
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "กำลังโหลดตอน...",
        "episodeList.noEpisodes": "ไม่มีตอนที่เผยแพร่",
        "episodeList.checkBack": "กลับมาดูตอนใหม่ภายหลัง",
        "episodeList.title": "ตอนจากพอดคาสต์นี้",
        "episodeList.readLess": "แสดงน้อยลง",
        "episodeList.readMore": "อ่านเพิ่มเติม",
        "episodeList.coverImageAlt": "ปกของ {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "เริ่มต้น",
        "alert.subscriptionRunning": "การสมัครสมาชิกปัจจุบันของคุณยังคงดำเนินอยู่。\n\nกรุณายกเลิกการสมัครสมาชิกปัจจุบันก่อนที่จะซื้อใหม่。",
        "alert.subscriptionEnds": "การสมัครสมาชิกปัจจุบันของคุณยังคงดำเนินอยู่。\n\nจะสิ้นสุดในวันที่ {date}",
        "alert.subscriptionCancelled": "การสมัครสมาชิกของคุณถูกยกเลิกแล้วและจะสิ้นสุดในวันที่ {date}",
        "button.openDashboard": "เปิดแดชบอร์ด",
        "button.signUp": "ลงทะเบียน",
        "button.buySubscription": "ซื้อการสมัครสมาชิก",
        "button.cancelled": "ถูกยกเลิก",
        "button.cancelSubscription": "ยกเลิกการสมัครสมาชิก",
        "button.upgradeSubscription": "อัปเกรดการสมัครสมาชิก",
        "button.loading": "กำลังโหลด",
        "upgrade.details.currentMinutes": "สิ่งนี้จะเริ่มช่วงการสมัครสมาชิกใหม่ คุณจะยังคงมีนาทีทั้งหมดในปัจจุบันของคุณ。",
        "upgrade.details.remainingAnnual": "ค่าดังกล่าวถูกคำนวณจากเวลาที่เหลือในการสมัครสมาชิกประจำปีปัจจุบันของคุณ."
      },
      "page": {
        "pricing.free.title": "ฟรี",
        "pricing.free.subtitle": "ลองใช้ Podsqueeze ไม่มีบัตรเครดิตที่จำเป็น",
        "pricing.free.price.annual": "$0 ชำระเงินรายปี",
        "pricing.free.features.podcast_time": "30 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.free.features.video_clips": "3 คลิปวิดีโอ",
        "common.with_watermark": "มีลายน้ำ",
        "pricing.free.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.free.features.file_upload": "อัปโหลดไฟล์สูงสุด 4Gb",
        "pricing.free.features.upload": "อัปโหลด 1 ครั้ง",
        "pricing.free.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "pricing.free.features.audio_enhancement": "การปรับปรุงเสียง",
        "common.sign_up": "ลงทะเบียน",
        "common.open_dashboard": "เปิดแดชบอร์ด",
        "pricing.starter.title": "เริ่มต้น",
        "pricing.starter.subtitle": "เหมาะสำหรับผู้ทำพอดแคสต์ที่ทำเป็นงานอดิเรกที่ต้องการประหยัดเวลา",
        "pricing.starter.price.annual": "$132 ชำระเงินรายปี",
        "pricing.billed_annually": "ชำระเงินรายปี",
        "minutes.accumulate": "การโอนนาทีที่เหลือ",
        "pricing.starter.features.podcast_time": "160 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.starter.features.video_clips": "10 คลิปวิดีโอหรือออดิโอแกรม",
        "pricing.starter.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.starter.features.file_upload": "อัปโหลดไฟล์สูงสุด 4Gb",
        "pricing.starter.features.unlimited_uploads": "อัปโหลดไม่จำกัด",
        "pricing.starter.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "pricing.pro.title": "โปร",
        "pricing.pro.subtitle": "สำหรับมืออาชีพที่ใช้พอดแคสต์ในการพัฒนาและสนับสนุนธุรกิจของตน",
        "pricing.pro.price.annual": "$324 ชำระเงินรายปี",
        "pricing.pro.features.podcast_time": "320 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.pro.features.personalize_ai_voice": "ปรับแต่งเสียง AI",
        "pricing.pro.features.video_clips": "20 คลิปวิดีโอหรือออดิโอแกรม",
        "common.no_watermark": "ไม่มีลายน้ำ",
        "pricing.pro.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.pro.features.file_upload": "อัปโหลดไฟล์สูงสุด 10Gb",
        "pricing.pro.features.unlimited_uploads": "อัปโหลดไม่จำกัด",
        "pricing.pro.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "common.customizable": "ปรับแต่งได้",
        "pricing.pro.features.audio_video_edit": "การแก้ไขเสียงและวิดีโอแบบมหัศจรรย์",
        "pricing.agency_lite.title": "เอเจนซี่ไลท์",
        "pricing.agency_lite.subtitle": "สำหรับเอเจนซี่พอดแคสต์ที่ต้องการปรับปรุงและขยายธุรกิจ",
        "pricing.agency_lite.price.annual": "$495 ชำระเงินรายปี",
        "pricing.agency_lite.features.podcast_time": "600 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.agency_lite.features.personalize_ai_voice": "ปรับแต่งเสียง AI",
        "pricing.agency_lite.features.video_clips": "40 คลิปวิดีโอหรือออดิโอแกรม",
        "pricing.agency_lite.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.agency_lite.features.file_upload": "อัปโหลดไฟล์สูงสุด 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "อัปโหลดไม่จำกัด",
        "pricing.agency_lite.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "pricing.agency_lite.features.audio_video_edit": "การแก้ไขเสียงและวิดีโอแบบมหัศจรรย์",
        "pricing.agency_plus.title": "เอเจนซี่พลัส",
        "pricing.agency_plus.subtitle": "สำหรับเอเจนซี่พอดแคสต์ที่ต้องการปรับปรุงและขยายธุรกิจ",
        "pricing.agency_plus.price.annual": "$1.251 ชำระเงินรายปี",
        "pricing.agency_plus.features.podcast_time": "2000 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.agency_plus.features.personalize_ai_voice": "ปรับแต่งเสียง AI",
        "pricing.agency_plus.features.video_clips": "80 คลิปวิดีโอหรือออดิโอแกรม",
        "pricing.agency_plus.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.agency_plus.features.file_upload": "อัปโหลดไฟล์สูงสุด 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "อัปโหลดไม่จำกัด",
        "pricing.agency_plus.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "pricing.agency_plus.features.audio_video_edit": "การแก้ไขเสียงและวิดีโอแบบมหัศจรรย์",
        "pricing.agency_scale.title": "เอเจนซี่สเกล",
        "pricing.agency_scale.subtitle": "สำหรับเอเจนซี่พอดแคสต์ที่ต้องการปรับปรุงและขยายธุรกิจ",
        "pricing.agency_scale.price.annual": "$2.175 ชำระเงินรายปี",
        "pricing.agency_scale.features.podcast_time": "4000 นาทีของเวลาในการทำพอดแคสต์ต่อเดือน",
        "pricing.agency_scale.features.personalize_ai_voice": "ปรับแต่งเสียง AI",
        "pricing.agency_scale.features.video_clips": "160 คลิปวิดีโอหรือออดิโอแกรม",
        "pricing.agency_scale.features.quote_images": "ภาพคำคมไม่จำกัด",
        "pricing.agency_scale.features.file_upload": "อัปโหลดไฟล์สูงสุด 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "อัปโหลดไม่จำกัด",
        "pricing.agency_scale.features.landing_pages": "หน้าแลนดิ้งพอดแคสต์",
        "pricing.agency_scale.features.audio_video_edit": "การแก้ไขเสียงและวิดีโอแบบมหัศจรรย์",
        "pricing.header": "สำหรับผู้ทำพอดแคสต์เดี่ยวและเอเจนซี่พอดแคสต์",
        "pricing.minutes_reset": "คุณสามารถสะสมได้สูงสุด 3 เท่าของนาทีรายเดือนของคุณ ตราบใดที่คุณยังคงอยู่ในแผนปัจจุบันหรืออัปเกรด",
        "pricing.most_popular": "ที่นิยมมากที่สุด",
        "pricing.minutes_per_month": "นาทีต่อเดือน",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "สำหรับเอเจนซี่พอดแคสต์และบริษัทมีดีไมเนิลที่ต้องการปรับปรุงและขยายธุรกิจ",
        "pricing.enterprise_price": "ปรับแต่งได้",
        "pricing.enterprise_price_note": "ติดต่อ team@podsqueeze.com หรือจองการสาธิตด้านล่าง",
        "pricing.enterprise_feature_priority_support": "การสนับสนุนรายสูงสุด",
        "pricing.enterprise_feature_team_sits": "การสาธิตทีม",
        "pricing.enterprise_personalized_team_training": "การสาธิตทีม",
        "pricing.book_demo": "จองการสาธิต"
      },
      "toggle": {
        "pay.monthly": "เดือน",
        "pay.annually": "ปี",
        "discount.30percent": "ส่วนลด 30%"
      },
      "upgradeModal": {
        "upgrade.success": "การสมัครสมาชิกของคุณได้รับการอัปเกรดเรียบร้อยแล้ว",
        "upgrade.error": "เราขอโทษ, เกิดข้อผิดพลาดบางอย่าง กรุณาลองอีกครั้งในภายหลัง",
        "upgrade.loading": "กำลังอัปเกรด",
        "upgrade.confirmPay": "ยืนยันและชำระเงิน",
        "upgrade.cancel": "ยกเลิก",
        "coupon.placeholder": "รหัสคูปอง",
        "coupon.apply": "ใช้",
        "coupon.have": "ฉันมีคูปอง",
        "upgrade.confirmation": "คุณกำลังจะอัปเกรดเป็น",
        "upgrade.price": "คุณจะต้องชำระ"
      }
    },
    "register": {
      "page": {
        "register.form": "แบบฟอร์มลงทะเบียน"
      },
      "registerForm": {
        "error.invalidCredentials": "กรุณาใส่อีเมลและรหัสผ่านที่ถูกต้อง",
        "error.weakPassword": "กรุณาใช้รหัสผ่านที่แข็งแกร่งกว่า 💪",
        "error.emailInUse": "ผู้ใช้มีอยู่แล้ว",
        "error.userNotFound": "ไม่พบผู้ใช้",
        "error.generic": "อุ๊ปส์, มีบางอย่างผิดพลาด",
        "placeholder.email": "ที่อยู่อีเมล",
        "placeholder.password": "รหัสผ่าน",
        "button.registering": "กำลังลงทะเบียน...",
        "button.register": "ลงทะเบียน",
        "label.newsletter": "เข้าร่วมกับพอดแคสเตอร์ 12,000 คนและสมัครรับจดหมายข่าวของเราเพื่อรับข้อมูลอัปเดตผลิตภัณฑ์ เคล็ดลับที่นำไปใช้ได้ อีบุ๊ก การแจกของรางวัล และอื่นๆ",
        "label.alreadyHaveAccount": "มีบัญชีอยู่แล้วหรือไม่?",
        "label.logInHere": "เข้าสู่ระบบที่นี่",
        "label.or": "หรือ",
        "button.signingIn": "กำลังเข้าสู่ระบบ...",
        "button.continueWithGoogle": "ดำเนินการต่อด้วย Google",
        "label.podcastDescription": "เริ่มต้นและเติบโตพอดแคสต์เสียงหรือวิดีโอของคุณได้อย่างง่ายดายด้วยทุกสิ่งที่คุณต้องการในที่เดียว",
        "feature.transcripts": "ข้อความบันทึก",
        "feature.showNotes": "หมายเหตุการแสดง",
        "feature.newslettersBlogs": "จดหมายข่าว & บล็อก",
        "feature.socialPosts": "โพสต์โซเชียล",
        "feature.shortClips": "คลิปสั้น & ออดิโอแกรม",
        "feature.podcastWebsite": "เว็บไซต์พอดแคสต์",
        "feature.audioEnhancement": "การปรับปรุงเสียงด้วย AI",
        "feature.removeSilences": "ลบความเงียบและเสียงอืม"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "ข้อความ"
      },
      "TopicFinder": {
        "competition.veryHigh": "สูงมาก",
        "competition.high": "สูง",
        "competition.medium": "ปานกลาง",
        "competition.low": "ต่ำ",
        "competition.veryLow": "ต่ำมาก",
        "upgrade.button": "อัปเกรดเป็น Pro",
        "clicks.label": "คลิก",
        "searches.label": "การค้นหา",
        "competition.label": "การแข่งขัน",
        "fetching.results": "กำลังดึงผลลัพธ์",
        "table.topic": "หัวข้อ",
        "tooltip.topic": "หัวข้อหลักที่ครอบคลุมโดยตอนพอดแคสต์ของคุณ",
        "table.monthlySearches": "การค้นหาเดือนละ",
        "tooltip.monthlySearches": "ช่วงการค้นหาบน Google ต่อเดือนที่คุณอาจคาดหวัง",
        "table.competition": "การแข่งขัน",
        "tooltip.competition": "หัวข้อหลักหรือหัวข้อที่ครอบคลุมโดยพอดแคสต์",
        "table.monthlyGoogleClicks": "คลิก Google ต่อเดือน",
        "tooltip.monthlyGoogleClicks": "การคาดการณ์ช่วงคลิก Google ต่อเดือนที่คุณอาจคาดหวัง",
        "table.youtubeReach": "การเข้าถึง YouTube",
        "tooltip.youtubeReach": "การคาดการณ์จำนวนการดู YouTube สูงสุดที่คุณอาจคาดหวังใน 6 เดือนแรก โดยอิงจากคู่แข่งเฉลี่ย",
        "intro.title": "เครื่องสร้างหัวข้อพอดแคสต์ฟรี",
        "intro.description": "รับแนวคิดหัวข้อสำหรับพอดแคสต์ของคุณที่ผู้ฟังกำลังค้นหา",
        "intro.check1": "ตรวจสอบความต้องการสำหรับแต่ละแนวคิดหัวข้อบน Google",
        "intro.check2": "ค้นหาว่าหัวข้อพอดแคสต์แต่ละหัวข้อมีการแข่งขันมากน้อยเพียงใด",
        "intro.check3": "ประมาณการคลิก Google และการดู YouTube ที่คุณสามารถได้รับ",
        "upgrade.message": "คุณต้องอัปเกรดเป็น Pro เพื่อเข้าถึงผลลัพธ์ทั้งหมด",
        "learnMore.label": "เรียนรู้เพิ่มเติมเกี่ยวกับ",
        "learnMore.link": "เครื่องสร้างหัวข้อพอดแคสต์ฟรี",
        "newSearch.button": "ค้นหาใหม่",
        "share.button": "แชร์การค้นหานี้",
        "form.label": "กรอกช่องทางพอดแคสต์ของคุณ",
        "form.placeholder": "การตลาดดิจิทัล",
        "form.submit": "ค้นหาแนวคิดหัวข้อ"
      },
      "page": {
        "main.background": "พื้นหลัง"
      },
      "shareTopics": {
        "share.results": "แชร์ผลลัพธ์",
        "share.facebook": "แชร์บน Facebook",
        "share.whatsapp": "แชร์บน WhatsApp",
        "share.twitter": "แชร์บน Twitter",
        "share.linkedin": "แชร์บน LinkedIn",
        "copy.success": "คัดลอกแล้ว",
        "copy.link": "คัดลอกลิงก์"
      },
      "youtubeScore": {
        "loading.placeholder": "1234",
        "views.label": "การดู"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "ไม่สามารถดึงองค์ประกอบปัจจุบันได้",
        "error.addImage": "เกิดข้อผิดพลาดในการเพิ่มองค์ประกอบภาพ:",
        "alert.uploadImage": "กรุณาอัปโหลดไฟล์ภาพ.",
        "error.uploadImage": "เกิดข้อผิดพลาดในการอัปโหลดภาพ:",
        "alert.uploadFailed": "การอัปโหลดภาพล้มเหลว กรุณาลองอีกครั้ง.",
        "error.getDownloadURL": "เกิดข้อผิดพลาดในการดึง URL สำหรับดาวน์โหลด:",
        "alert.processImageFailed": "การประมวลผลภาพที่อัปโหลดล้มเหลว กรุณาลองอีกครั้ง.",
        "error.addText": "เกิดข้อผิดพลาดในการเพิ่มองค์ประกอบข้อความ:",
        "text.settingsPlaceholder": "การตั้งค่าจะแสดงเมื่อเลือกองค์ประกอบ",
        "text.addElement": "เพิ่มองค์ประกอบ",
        "text.uploading": "กำลังอัปโหลด...",
        "button.uploadImage": "อัปโหลดภาพ",
        "text.newText": "ข้อความใหม่",
        "button.addText": "เพิ่มข้อความ",
        "text.selectedElementSettings": "การตั้งค่าองค์ประกอบที่เลือก"
      },
      "FontSelector": {
        "allFonts": "ฟอนต์ทั้งหมด",
        "myFonts": "ฟอนต์ของฉัน",
        "uploadFont": "อัปโหลดฟอนต์",
        "noCustomFonts": "ยังไม่มีฟอนต์ที่กำหนดเอง",
        "uploadToAdd": "อัปโหลดไฟล์ฟอนต์เพื่อเพิ่มลงในคอลเลกชันของคุณ",
        "text_outline": "เส้นขอบข้อความ",
        "outline_color": "สีเส้นขอบ",
        "outline_width": "ความหนาเส้นขอบ"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "พอดี",
        "imageLayoutSettings.zoom": "ซูม",
        "imageLayoutSettings.horizontalAlignment": "การจัดแนวนอน",
        "imageLayoutSettings.verticalAlignment": "การจัดแนวตั้ง",
        "imageLayoutSettings.deleteElement": "ลบองค์ประกอบ"
      },
      "TemplateBox": {
        "confirm.delete.template": "คุณแน่ใจหรือว่าต้องการลบแม่แบบนี้?"
      },
      "TextSettings": {
        "error.getting_current_text": "เกิดข้อผิดพลาดในการดึงข้อความปัจจุบัน:",
        "event.delete_text_element_clicked": "คลิกเพื่อลบองค์ประกอบข้อความ",
        "error.changing_text_font": "เกิดข้อผิดพลาดในการเปลี่ยนฟอนต์ข้อความ:",
        "event.text_font_changed": "ฟอนต์ข้อความถูกเปลี่ยน",
        "error.changing_text_size": "เกิดข้อผิดพลาดในการเปลี่ยนขนาดข้อความ:",
        "event.text_size_changed": "ขนาดข้อความถูกเปลี่ยน",
        "error.changing_text_color": "เกิดข้อผิดพลาดในการเปลี่ยนสีข้อความ:",
        "event.text_color_changed": "สีข้อความถูกเปลี่ยน",
        "event.text_content_added": "เนื้อหาข้อความถูกเพิ่ม",
        "error.adding_text_content": "เกิดข้อผิดพลาดในการเพิ่มเนื้อหาข้อความ:",
        "event.text_content_updated": "เนื้อหาข้อความถูกอัปเดต",
        "label.text_content": "เนื้อหาข้อความ",
        "label.text_font": "ฟอนต์ข้อความ",
        "label.adjust_text_size": "ปรับขนาดข้อความ",
        "label.text_color": "สีข้อความ",
        "button.delete": "ลบ"
      },
      "audiogramBaseTemplate": {
        "color.white": "สีขาว",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 วินาที",
        "font.inter": "Inter",
        "duration.1s": "1 วินาที",
        "easing.quadraticOut": "quadratic-out",
        "animation.fade": "เฟด",
        "type.text": "ข้อความ",
        "name.podcastTitle": "ชื่อพอดแคสต์",
        "name.snippetTitle": "ชื่อส่วนย่อย",
        "type.image": "ภาพ",
        "name.audioBackgroundImage": "ภาพพื้นหลังเสียง",
        "name.subtitlesText": "ข้อความคำบรรยาย",
        "effect.highlight": "เน้น",
        "type.audio": "เสียง",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "ชื่อส่วนย่อย",
        "podcast.title": "ชื่อพอดแคสต์",
        "new.episode": "ตอนใหม่"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "ขาว",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "defaultEpisodeUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "เพลงพื้นหลัง",
        "audio.type": "เสียง"
      },
      "imageElement": {
        "upload.image.error": "กรุณาอัปโหลดไฟล์ภาพ.",
        "upload.file.loading": "กำลังอัปโหลดไฟล์ กรุณาอย่าปิดหน้าต่างนี้.",
        "upload.image.label": "สร้างภาพ",
        "ai.prompt.label": "กรอกข้อความเพื่อให้ AI สร้างภาพ",
        "ai.prompt.placeholder": "เช่น: สุนัขวิ่งในสวน...",
        "ai.processing": "กำลังประมวลผล...",
        "ai.create": "สร้าง",
        "customize.image.title": "ปรับแต่งภาพ",
        "enter.image.url": "กรอก URL ของภาพ",
        "or": "หรือ"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "เกิดข้อผิดพลาดในการดึงเทมเพลต:",
        "template.savedSuccessfully": "บันทึกเทมเพลตเรียบร้อยแล้ว",
        "error.savingTemplate": "เกิดข้อผิดพลาดในการบันทึกเทมเพลต:",
        "loading.savedTemplates": "กำลังโหลดเทมเพลตที่บันทึกไว้...",
        "no.savedTemplates": "ไม่มีเทมเพลตที่บันทึกไว้",
        "select_template": "เลือกเทมเพลต",
        "saving.template": "กำลังบันทึกเทมเพลต...",
        "template_name": "ชื่อเทมเพลต",
        "enter.templateName": "กรอกชื่อเทมเพลต",
        "cancel": "ยกเลิก",
        "save": "บันทึก",
        "default_templates": "เทมเพลตเริ่มต้น",
        "saved_templates_count": "เทมเพลตที่บันทึกไว้ ({count})",
        "folder_templates_count": "เทมเพลตโฟลเดอร์ ({count})",
        "account_templates_count": "เทมเพลตบัญชี ({count})",
        "save_current_template": "บันทึกเทมเพลตปัจจุบัน"
      },
      "subtitlesElement": {
        "edit.word": "แก้ไขคำ",
        "edit.label": "แก้ไข",
        "remove.word.subtitle": "ลบคำออกจากคำบรรยายเท่านั้น",
        "erase.subtitle": "ลบจากคำบรรยาย",
        "remove.word.clip": "ลบคำออกจากเสียงและคำบรรยาย",
        "remove.clip": "ลบจากคลิป"
      },
      "utils": {
        "video.utils.title": "ชื่อเรื่อง",
        "video.utils.currentTime": "เวลาปัจจุบัน",
        "video.utils.nextTime": "เวลาถัดไป",
        "video.utils.duration": "ระยะเวลา",
        "video.utils.description": "คำอธิบาย",
        "video.utils.srtSegment": "ส่วน SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "ข้อความบรรยายของคุณที่นี่"
      }
    }
  },
  "vi": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "TRỞ THÀNH ĐỐI TÁC CỦA CHÚNG TÔI",
        "SHARE_PODSQUEEZE": "Chia sẻ Podsqueeze với khán giả của bạn",
        "AND_EARN_MONEY": "và kiếm tiền!",
        "LAST_UPDATED": "Cập nhật lần cuối: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "Trở thành Đối tác Liên kết",
        "EARN_COMMISSION": "Kiếm",
        "COMMISSION": "hoa hồng",
        "ON_EVERY_SALE": "trên mỗi lần bán hàng được thực hiện qua liên kết giới thiệu độc quyền của bạn trong vòng 15 tháng. Chia sẻ liên kết của bạn trên trang web của bạn, mạng xã hội, hoặc với bạn bè. Tham gia chỉ mất vài giây.",
        "GET_AUTOMATICALLY_APPROVED": "Được phê duyệt tự động.",
        "JOIN_NOW": "Tham gia ngay",
        "HOW_IT_WORKS": "CÁCH THỨC HOẠT ĐỘNG",
        "FREQUENTLY_ASKED_QUESTIONS": "Câu hỏi Thường gặp",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "Đối tác Liên kết là gì?",
        "AFFILIATE_PARTNER_DESCRIPTION": "Đối tác Liên kết là người quảng bá sản phẩm hoặc dịch vụ của công ty khác thông qua liên kết giới thiệu độc quyền và kiếm hoa hồng trên mỗi lần bán hàng được thực hiện qua liên kết đó.",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "Tôi có thể trở thành Đối tác Liên kết như thế nào?",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "Trở thành Đối tác Liên kết rất nhanh chóng và dễ dàng, chỉ mất vài giây. Để bắt đầu, chỉ cần nhấp vào nút 'Tham gia ngay' và đăng ký bằng email của bạn. Sau khi đăng ký, bạn sẽ có quyền truy cập vào bảng điều khiển thân thiện với người dùng nơi bạn sẽ tìm thấy liên kết giới thiệu độc quyền của mình. Chia sẻ liên kết này với gia đình, bạn bè, hoặc khán giả trực tuyến của bạn. Mỗi khi ai đó nhấp vào liên kết giới thiệu của bạn và thực hiện mua hàng trên trang web của Podsqueeze, bạn sẽ kiếm được 25% hoa hồng trên mỗi thanh toán trong suốt 15 tháng! Theo dõi thu nhập của bạn một cách dễ dàng thông qua bảng điều khiển Liên kết của bạn, cung cấp một cái nhìn tổng quan rõ ràng về tất cả các giao dịch bán hàng mà bạn đã tạo ra.",
        "HOW_CAN_I_TRACK_MY_SALES": "Tôi có thể theo dõi doanh số và hoa hồng của mình như thế nào?",
        "TRACKING_SALES_DESCRIPTION": "Sử dụng bảng điều khiển chương trình liên kết của chúng tôi để theo dõi doanh số và hoa hồng của bạn. Phần mềm theo dõi có sẵn cho cả Đối tác Liên kết và Đối tác Kinh doanh.",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "Khi nào và tôi sẽ nhận thanh toán như thế nào?",
        "PAYMENT_DESCRIPTION": "Bạn sẽ nhận được thanh toán qua PayPal mỗi 30 ngày. Xin lưu ý rằng có ngưỡng thanh toán tối thiểu là $50. Ngay khi bạn đạt được số tiền này, bạn có thể mong đợi sẽ nhận được thanh toán của mình một cách đều đặn mỗi 30 ngày.",
        "STILL_GOT_QUESTIONS": "VẪN CÓ CÂU HỎI?",
        "SEND_US_A_MESSAGE": "Gửi cho chúng tôi một tin nhắn trên chat hỗ trợ hoặc gửi email cho chúng tôi tại team@podsqueeze.com",
        "NOTE": "Lưu ý",
        "AFFILIATE_ADS_RESTRICTION": "Các đối tác liên kết bị cấm tạo quảng cáo trên Google hoặc tham gia đấu thầu từ khóa liên quan đến Podsqueeze.",
        "AFFILIATE_TERMS_OF_USE": "Điều khoản Sử dụng cho Đối tác Liên kết",
        "CAN_I_RUN_ADS": "Tôi có thể chạy quảng cáo và chiến dịch CPC trên Google để quảng bá liên kết giới thiệu của mình không?",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "Các đối tác liên kết bị cấm nghiêm ngặt trong việc tạo quảng cáo trên công cụ tìm kiếm hoặc tham gia đấu thầu từ khóa liên quan đến Podsqueeze. Hạn chế này giúp duy trì tính toàn vẹn của chiến lược quảng cáo của chúng tôi và đảm bảo thông điệp thương hiệu nhất quán. Xin lưu ý rằng các giao dịch bán hàng phát sinh từ các chiến dịch đấu thầu như vậy sẽ không đủ điều kiện để thanh toán.",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Podsqueeze tạo tiêu đề cho Podcast của bạn như thế nào?"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "Thanh điều hướng",
        "main.affiliateHero": "Đối tác",
        "main.footer": "Chân trang"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "Thêm Nhạc Mở Đầu và Kết Thúc",
        "intro.music": "Nhạc Mở Đầu",
        "outro.music": "Nhạc Kết Thúc",
        "intro.duration": "Thời Lượng Mở Đầu",
        "outro.duration": "Thời Lượng Kết Thúc",
        "intro.mode": "Chế Độ Mở Đầu",
        "outro.mode": "Chế Độ Kết Thúc",
        "cancel": "Hủy",
        "save": "Lưu",
        "apply": "Áp Dụng",
        "current.intro.music": "Nhạc Mở Đầu Hiện Tại",
        "current.outro.music": "Nhạc Kết Thúc Hiện Tại",
        "change.music": "Thay Đổi Nhạc",
        "choose.music": "Chọn Tệp Nhạc",
        "browser.not.support.audio": "Trình duyệt của bạn không hỗ trợ phần tử âm thanh.",
        "save.and.apply": "Lưu và Áp Dụng",
        "no.music.selected": "Chưa chọn nhạc",
        "delete.music": "Xóa nhạc",
        "uploading.file": "Đang tải tệp lên..."
      },
      "audioEditElements": {
        "error.processing.rss": "Chúng tôi đang gặp một số khó khăn trong việc xử lý một số nguồn cấp RSS. Vui lòng tải lên một tệp.",
        "edit.enhance.audio": "Chỉnh sửa và nâng cao bản ghi âm của bạn",
        "trial.label": "Thử nghiệm",
        "audio.editing.experience": "Trải nghiệm chỉnh sửa âm thanh liền mạch với các thuật toán AI tiên tiến cho kết quả tự nhiên, chất lượng cao, chỉ với một cú nhấp chuột.",
        "improve.audio.quality": "Cải thiện Chất lượng Âm thanh",
        "remove.hums.silences": "Xóa Tiếng Ồn & Im Lặng",
        "upgrade.edit.audio": "Nâng cấp để có thể chỉnh sửa âm thanh của bạn chỉ với một cú nhấp chuột",
        "available.plans": "Có sẵn cho tất cả các gói đã trả",
        "upgrade.now": "Nâng cấp Ngay",
        "audio.element.support": "Trình duyệt của bạn không hỗ trợ phần tử âm thanh.",
        "download.audio": "Tải xuống Âm thanh",
        "loading.audio": "Đang tải Âm thanh",
        "editing.audio": "Chỉnh sửa Âm thanh"
      },
      "videoEditElements": {
        "error.exporting.video": "Lỗi khi xuất video",
        "download.failed": "Tải xuống thất bại: {error.message}",
        "generating.video": "Đang tạo video",
        "error.generating.clip": "Lỗi khi tạo clip",
        "please.retry.support": "Vui lòng thử lại hoặc liên hệ với bộ phận hỗ trợ người dùng của chúng tôi",
        "browser.not.support.video": "Trình duyệt của bạn không hỗ trợ thẻ video.",
        "this.might.take.minutes": "Vui lòng không đóng cửa sổ, điều này có thể mất vài phút.",
        "exporting.video": "Đang xuất video của bạn...",
        "seamless.audio.editing": "Trải nghiệm chỉnh sửa âm thanh liền mạch với các thuật toán AI tiên tiến cho kết quả tự nhiên, chất lượng cao, chỉ với một cú nhấp chuột.",
        "difficulties.processing.rss": "Chúng tôi đang gặp một số khó khăn trong việc xử lý một số nguồn cấp RSS. Vui lòng tải lên một tệp.",
        "edit.enhance.video.recording": "Chỉnh sửa và nâng cao video của bạn",
        "trial": "Thử nghiệm",
        "enhance.audio.quality": "Nâng cao chất lượng âm thanh",
        "enhance.audio.quality.edit": "Nâng cao chất lượng âm thanh & Chỉnh sửa",
        "trim.filler.words.video": "Cắt bỏ các từ thừa trong video (ví dụ: tiếng ậm ừ)",
        "trim.long.silences.video": "Cắt bỏ những khoảng lặng dài trong video",
        "upgrade.to.edit.video": "Nâng cấp để có thể chỉnh sửa video của bạn chỉ với một cú nhấp chuột",
        "available.pro.agency.plans": "Có sẵn cho các gói Pro và Agency",
        "upgrade.now": "Nâng cấp ngay",
        "download.only.audio": "Tải xuống chỉ âm thanh",
        "download.video": "Tải xuống video",
        "please.dont.close.window": "Vui lòng không đóng cửa sổ",
        "export.video": "Xuất video"
      },
      "videogramBaseTemplate": {
        "media.fit": "bao phủ",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "thời gian"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "Các tập khác từ Podcast này",
        "tab.shownotes": "Ghi chú chương trình",
        "tab.timestamps": "Mốc thời gian",
        "tab.blogpost": "Bài viết blog",
        "tab.transcript": "Bản ghi",
        "key.points": "Điểm chính"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "Trang đích của bạn đã được phát hành trong công cụ tìm kiếm podcast của chúng tôi. Hãy chia sẻ nó với khán giả của bạn!",
        "landingPage.create": "Tạo một trang đích đẹp cho tập này",
        "landingPage.edit": "Chỉnh sửa Trang",
        "landingPage.visit": "Truy cập Trang",
        "landingPage.delete": "Xóa Trang",
        "landingPage.createButton": "Tạo Trang Đích"
      },
      "SocialLinksModal": {
        "manage.episode.links": "Quản lý liên kết tập phim",
        "youtube.link": "Liên kết YouTube",
        "enter.youtube.link": "Nhập liên kết YouTube",
        "apple.podcasts.link": "Liên kết Apple Podcasts",
        "enter.apple.podcasts.link": "Nhập liên kết Apple Podcasts",
        "spotify.link": "Liên kết Spotify",
        "enter.spotify.link": "Nhập liên kết Spotify",
        "saving": "Đang lưu...",
        "save": "Lưu",
        "social.links.updated.successfully": "Cập nhật liên kết xã hội thành công!"
      },
      "affiliatesection": {
        "affiliate.section.title": "TRỞ THÀNH ĐỐI TÁC LIÊN KẾT",
        "affiliate.section.subtitle": "Chia sẻ Podsqueeze với khán giả của bạn và",
        "affiliate.section.earn": "kiếm tiền!",
        "affiliate.section.commission": "Chương trình liên kết của chúng tôi cung cấp 25% hoa hồng trong 15 tháng, trên mỗi giao dịch bán hàng và thanh toán gia hạn đăng ký.",
        "affiliate.section.join": "Chỉ mất vài giây để tham gia!",
        "affiliate.section.knowMore": "Tìm hiểu thêm"
      },
      "asseenon": {
        "podnews.logo": "logo podnews",
        "transistor.logo": "logo transistor",
        "thepodcasthost.logo": "logo của nhà sản xuất podcast",
        "schoolofpodcasting.logo": "logo Trường Podcasting",
        "semrush.logo": "logo semrush"
      },
      "assembleshownotes": {
        "episode.description": "Mô tả Tập",
        "bullet.points": "Điểm Nổi Bật",
        "timestamps": "Thời Gian",
        "links.and.mentions": "Liên Kết & Đề Cập",
        "extra.content": "Nội Dung Thêm",
        "assemble.show.notes": "Tập Hợp Ghi Chú Chương Trình Của Bạn",
        "downloading": "Đang Tải Xuống",
        "copied": "Đã Sao Chép",
        "enter.placeholder": "Nhập {{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "Tạm dừng việc phát podcast",
        "cancellation.option.no_recurrent": "Tôi không muốn đăng ký định kỳ",
        "cancellation.option.expensive": "Nó quá đắt",
        "cancellation.option.not_saving_time": "Không tiết kiệm đủ thời gian cho tôi",
        "cancellation.option.dissatisfied_content": "Không hài lòng với chất lượng nội dung được tạo ra",
        "cancellation.option.unresponsive_support": "Hỗ trợ khách hàng không phản hồi",
        "cancellation.option.not_using": "Không sử dụng dịch vụ đủ nhiều",
        "cancellation.option.difficulty_navigating": "Khó khăn trong việc sử dụng/điều hướng sản phẩm",
        "cancellation.option.better_alternative": "Tìm thấy sản phẩm thay thế tốt hơn",
        "cancellation.option.other": "Khác",
        "cancellation.video.message": "70% người dùng của chúng tôi dừng quá trình hủy sau khi xem video này",
        "cancellation.button.cancel": "Tôi Vẫn Muốn Hủy",
        "cancellation.button.try_again": "Tôi Muốn Thử Lại",
        "cancellation.prompt.select_reason": "Xin vui lòng giúp chúng tôi cải thiện sản phẩm bằng cách chọn lý do hủy đăng ký của bạn:",
        "cancellation.placeholder.answer": "Gõ câu trả lời của bạn ở đây...",
        "cancellation.placeholder.specify_reason": "Xin vui lòng chỉ rõ lý do hủy của bạn",
        "cancellation.button.next": "Tiếp theo",
        "cancellation.button.go_back": "Quay lại",
        "cancellation.last_question.title": "Câu Hỏi Cuối Cùng Từ Chúng Tôi",
        "lose.all.accumulated.minutes": "Nếu bạn hủy, bạn sẽ mất tất cả phút tích lũy.",
        "here.are.some.ideas": "Dưới đây là một số ý tưởng để bạn có thể tiếp tục sử dụng Podsqueeze",
        "keep.accumulating.minutes": "Tiếp tục tích lũy phút để sử dụng khi bạn trở lại podcasting",
        "convert.and.repurpose.episodes": "Chuyển đổi và tái sử dụng các bản phát hành của bạn thành nội dung mới",
        "generate.articles.favorite.podcasts.and.vides": "Tạo bài viết từ các podcast yêu thích của bạn",
        "share.your.account.with.a.friend": "Chia sẻ tài khoản của bạn với người bạn có thể hữu ích",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "Đây là một video, chỉ ra cách tối đa sử dụng Podsqueeze",
        "cancellation.last_question.prompt": "Những thay đổi hoặc cải tiến nào sẽ khiến bạn xem xét việc tham gia lại dịch vụ của chúng tôi?",
        "cancellation.feedback.message": "Phản hồi của bạn sẽ giúp chúng tôi cải thiện 🙏",
        "cancellation.button.confirm": "Xác Nhận Hủy",
        "cancellation.minutes.accumulated": "Bạn có",
        "cancellation.minutes.accumulated.suffix": "phút tích lũy trị giá",
        "cancellation.reminder.text": "Xin hãy nhớ:",
        "cancellation.minutes.warning": "Phút tích lũy là đặc quyền cho các gói đăng ký đang hoạt động. Bằng việc hủy đăng ký, phút của bạn sẽ bị mất vĩnh viễn.",
        "cancellation.content.deletion.warning": "Tất cả nội dung đã tạo của bạn sẽ bị xóa vĩnh viễn sau 30 ngày.",
        "cancellation.minutes.left.title": "Bạn Vẫn Còn Phút! Đừng Để Chúng Lãng Phí!",
        "cancellation.suggestion.clips": "Tái sử dụng các tập cũ thành clip cho mạng xã hội",
        "cancellation.suggestion.articles": "Chuyển đổi các tập cũ thành bài viết với Podsqueeze để được lợi từ SEO.",
        "cancellation.suggestion.linkedin": "Chuyển đổi các tập có uy tín cũ thành bài viết LinkedIn để tăng cường thương hiệu cá nhân",
        "cancellation.suggestion.share": "Chia sẻ tài khoản Podsqueeze của bạn với bạn bè để họ có thể được lợi từ những phút chưa sử dụng của bạn.",
        "cancellation.button.keep.subscription": "Giữ Gói Đăng Ký",
        "cancellation.button.keep.minutes": "Giữ",
        "cancellation.button.keep.minutes.suffix": "Trị Giá Phút Của Tôi",
        "cancellation.lifetime.before_you_go": "Trước khi bạn rời đi...",
        "cancellation.lifetime.title": "Thế còn truy cập trọn đời chỉ với $49 thì sao?",
        "cancellation.lifetime.subtitle": "Giữ tài khoản Starter của bạn. Không có đăng ký. Không có gia hạn. Chỉ của bạn — mãi mãi.",
        "cancellation.lifetime.feature1": "Truy cập trọn đời vào Podsqueeze với một lần thanh toán $49",
        "cancellation.lifetime.feature2": "Sử dụng khi bạn cần, không áp lực — nó là của bạn mãi mãi",
        "cancellation.lifetime.feature3": "Bao gồm tất cả tính năng hiện tại và tương lai của Gói Starter",
        "cancellation.lifetime.button_cancel": "Tôi vẫn muốn hủy",
        "cancellation.lifetime.button_deal": "Nhận ưu đãi trọn đời",
        "cancellation.downgrade.title": "Giữ tất cả nội dung của bạn chỉ với $5.99/tháng",
        "cancellation.downgrade.subtitle": "Bằng cách hạ cấp xuống Starter bạn có thể...",
        "cancellation.downgrade.feature1": "Giữ tất cả nội dung đã tạo",
        "cancellation.downgrade.feature2": "Giữ website của bạn hoạt động",
        "cancellation.downgrade.feature3": "160 phút và 10 clip mỗi tháng cho công việc thỉnh thoảng",
        "cancellation.billing.monthly": "Hàng tháng",
        "cancellation.billing.annual": "Hàng năm",
        "cancellation.billing.discount": "GIẢM 30%",
        "cancellation.plan.starter": "Gói Starter",
        "cancellation.price.monthly": "$8.99/tháng",
        "cancellation.price.annual": "$5.99/tháng",
        "cancellation.price.annual_billing": "tính phí $71.88 hàng năm",
        "cancellation.feature.minutes": "160 phút/tháng",
        "cancellation.feature.clips": "10 clip/tháng",
        "cancellation.downgrade.button": "Hạ cấp xuống Starter & Giữ Nội dung",
        "cancellation.error.payment_link": "Không thể lấy liên kết thanh toán. Vui lòng thử lại.",
        "cancellation.error.payment_service": "Lỗi kết nối đến dịch vụ thanh toán.",
        "cancellation.option.question.break": "Bạn có thể cho chúng tôi biết thêm về lý do tại sao bạn đang nghỉ ngơi không?",
        "cancellation.option.question.no_recurrent": "Bạn có thể chia sẻ tại sao bạn không muốn có đăng ký định kỳ không?",
        "cancellation.option.question.expensive": "Giá cả hoặc tính năng nào sẽ làm cho dịch vụ có giá trị hơn đối với bạn?",
        "cancellation.option.question.not_saving_time": "Điều gì vẫn đang tốn nhiều thời gian trong quy trình của bạn?",
        "cancellation.option.question.dissatisfied_content": "Bạn không hài lòng với những khía cạnh nào của nội dung?",
        "cancellation.option.question.unresponsive_support": "Bạn có thể mô tả trải nghiệm của mình với bộ phận hỗ trợ khách hàng của chúng tôi không?",
        "cancellation.option.question.not_using": "Có điều gì sẽ khuyến khích bạn sử dụng dịch vụ thường xuyên hơn không?",
        "cancellation.option.question.difficulty_navigating": "Bạn gặp khó khăn gì khi sử dụng/điều hướng sản phẩm?",
        "cancellation.option.question.better_alternative": "Bạn tìm thấy sản phẩm thay thế nào và bạn thích điều gì về nó?",
        "cancellation.option.question.other": "Vui lòng chỉ định lý do hủy của bạn:"
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "Chúng tôi coi trọng quyền riêng tư của bạn",
        "cookiebanner.cookieUsage": "Chúng tôi sử dụng cookie để nâng cao trải nghiệm của bạn trên trang web và phân tích lưu lượng truy cập của chúng tôi. Bằng cách nhấp chấp nhận, bạn đồng ý với việc chúng tôi sử dụng cookie.",
        "cookiebanner.privacyPolicy": "Chính sách quyền riêng tư",
        "cookiebanner.accept": "Chấp nhận",
        "cookiebanner.decline": "Từ chối"
      },
      "episodeTitleBox": {
        "loading": "Đang tải...",
        "editEpisodeTitleClicked": "Đã nhấp vào chỉnh sửa tiêu đề tập",
        "newEpisodeTitleStored": "Tiêu đề tập mới đã được lưu"
      },
      "famewall": {
        "loading.message": "Đang tải..."
      },
      "footer": {
        "footer.features": "Tính năng",
        "footer.transcriptGenerator": "Trình tạo bản sao",
        "footer.subtitlesGenerator": "Trình tạo phụ đề",
        "footer.descriptionGenerator": "Trình tạo mô tả",
        "footer.podcastSummarizer": "Trình tạo tóm tắt podcast",
        "footer.titlesGenerator": "Trình tạo tiêu đề",
        "footer.bulletPointsGenerator": "Trình tạo điểm nổi bật",
        "footer.chaptersClipsGenerator": "Trình tạo chương & clip",
        "footer.socialMediaPostsGenerator": "Trình tạo bài đăng mạng xã hội",
        "footer.newsletterGenerator": "Trình tạo bản tin",
        "footer.blogPostGenerator": "Trình tạo bài viết blog",
        "footer.podcastLandingPages": "Trang đích podcast",
        "footer.podcastClipMaker": "Trình tạo clip podcast",
        "footer.audiogramGenerator": "Trình tạo audiogram",
        "footer.aiAudioEnhancer": "Nâng cao âm thanh AI",
        "footer.convertYoutubeToText": "Chuyển đổi Youtube thành văn bản",
        "footer.youtubeVideoNoiseRemover": "Công cụ xóa tiếng ồn video Youtube",
        "footer.youtubeVideoKeyPoints": "Điểm chính video Youtube",
        "footer.freeResources": "Tài nguyên miễn phí",
        "footer.findPodcastTopicIdeas": "Tìm ý tưởng chủ đề podcast",
        "footer.articles": "Bài viết",
        "footer.freeEbooks": "Sách điện tử miễn phí",
        "footer.community": "Cộng đồng",
        "footer.ourPodcast": "Podcast của chúng tôi",
        "footer.product": "Sản phẩm",
        "footer.giftCard": "Thẻ quà tặng",
        "footer.onboardingEbook": "Sách điện tử hướng dẫn",
        "footer.pricing": "Giá cả",
        "footer.affiliates": "Đối tác",
        "footer.media": "Truyền thông",
        "footer.testimonials": "Lời chứng thực",
        "footer.legal": "Pháp lý",
        "footer.privacyPolicy": "Chính sách bảo mật",
        "footer.termsOfUse": "Điều khoản sử dụng",
        "footer.refundPolicy": "Chính sách hoàn tiền",
        "footer.allRightsReserved": "Bảo lưu mọi quyền."
      },
      "globalState": {
        "cookie.enabled": "Cookie đã được kích hoạt",
        "language.default": "Ngôn ngữ mặc định"
      },
      "head": {
        "keywords.list": "Podsqueeze, AI, Podcast, Tạo nội dung, Chuyển văn bản podcast, Ghi chú chương trình, Thời gian, Bản tin podcast, Tweet, Bài viết blog, Bài đăng trên mạng xã hội, Tiêu đề, Người viết ghi chú chương trình"
      },
      "imageResultModal": {
        "download.image": "Tải hình ảnh",
        "generating.image": "Đang tạo hình ảnh",
        "ai.prompt.label": "Nhập một gợi ý để AI tạo ra hình ảnh",
        "ai.prompt.placeholder": "Ví dụ: Một con chó đang chạy trong công viên...",
        "processing": "Đang xử lý...",
        "create": "Tạo",
        "text.color.label": "Màu chữ",
        "quote.icon.color.label": "Màu biểu tượng trích dẫn",
        "background.color.label": "Màu nền",
        "font.label": "Phông chữ",
        "upload.cover.image": "Tải hình ảnh bìa",
        "aspect.ratio.info": "Tỷ lệ khung hình 1:1, kích thước khuyến nghị 1200x1200",
        "upload.logo.label": "Tải logo",
        "choose.file": "Chọn tệp",
        "upload.success": "Tải lên thành công",
        "choose.quote": "Chọn một câu trích dẫn",
        "select.template": "Chọn mẫu",
        "quote.label": "Câu trích dẫn",
        "enter.quote.here": "Nhập câu trích dẫn ở đây",
        "author.label": "Tác giả",
        "enter.author.name": "Nhập tên tác giả",
        "podcast.name.label": "Tên podcast",
        "enter.podcast.name": "Nhập tên podcast",
        "colors": "Màu sắc",
        "select.font": "Chọn phông chữ",
        "cover.logo.images": "Hình ảnh bìa & logo",
        "logo.image": "Hình ảnh logo",
        "upgrade.here": "Nâng cấp tại đây",
        "remove.logo": "Xóa logo Podsqueeze",
        "default_templates": "Mẫu mặc định",
        "saved_templates_count": "Mẫu đã lưu",
        "save_current_template": "Lưu mẫu hiện tại",
        "no_saved_templates": "Chưa có mẫu đã lưu",
        "save_template": "Lưu mẫu",
        "cancel": "Hủy",
        "save": "Lưu",
        "enter_template_name": "Nhập tên mẫu",
        "reset_template": "Đặt lại",
        "add_element": "Thêm phần tử",
        "generate": "Tạo",
        "add_image": "Thêm hình ảnh",
        "upload_image": "Tải lên hình ảnh",
        "or": "hoặc",
        "generate_with_ai": "Tạo bằng AI",
        "search_fonts": "Tìm kiếm phông chữ...",
        "upload_logo": "Tải lên logo",
        "square_image_recommended": "Khuyến nghị hình ảnh vuông",
        "opacity": "Độ mờ",
        "layers": "Lớp",
        "no_element_selected": "Chưa chọn phần tử nào",
        "bold_shortcut": "Đậm (Ctrl+B)",
        "italic_shortcut": "Nghiêng (Ctrl+I)",
        "underline_shortcut": "Gạch chân (Ctrl+U)",
        "edit_text": "Chỉnh sửa văn bản",
        "tint_color": "Màu sắc",
        "toggle_gradient_transparent": "Chuyển đổi gradient sang trong suốt",
        "rotate_gradient": "Xoay gradient 45 độ",
        "alt_background": "Nền",
        "alt_podcast_logo": "Logo podcast",
        "alt_custom": "Tùy chỉnh",
        "alt_right_side": "Bên phải",
        "alt_profile": "Hồ sơ"
      },
      "intentModal": {
        "intentModal.title": "Bạn muốn làm gì với Podsqueeze?",
        "intentModal.sourceOption.Write_Show_Notes": "Viết Ghi Chú Chương Trình",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "Viết Bài Blog & Bản Tin",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "Tạo Clip Video hoặc Audiogram",
        "intentModal.sourceOption.Create_Quote_Images": "Tạo Hình Ảnh Trích Dẫn",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "Chỉnh Sửa & Nâng Cao Âm Thanh/Video",
        "intentModal.sourceOption.Transcribe": "Chuyển Đổi Văn Bản",
        "intentModal.sourceOption.Create_a_Website": "Tạo Một Trang Web",
        "intentModal.sourceOption.All_of_the_Above": "Tất Cả Những Điều Trên",
        "intentModal.sourceOption.Other": "Khác",
        "intentModal.otherPlaceholder": "Vui lòng chỉ định",
        "intentModal.submitButton": "Gửi & Đăng Ký",
        "intentModal.skip": "Bỏ Qua"
      },
      "languageSwitcher": {
        "language.en": "Tiếng Anh",
        "language.es": "Tiếng Tây Ban Nha",
        "language.fr": "Tiếng Pháp",
        "language.de": "Tiếng Đức",
        "language.it": "Tiếng Ý",
        "language.pt": "Tiếng Bồ Đào Nha",
        "language.nl": "Tiếng Hà Lan",
        "language.pl": "Tiếng Ba Lan",
        "language.ru": "Tiếng Nga",
        "language.zh": "Tiếng Trung",
        "language.ja": "Tiếng Nhật",
        "language.ko": "Tiếng Hàn",
        "language.ar": "Tiếng Ả Rập",
        "language.th": "Tiếng Thái",
        "language.vi": "Tiếng Việt"
      },
      "lazyImage": {
        "lazyImage.alt": "Mô tả hình ảnh"
      },
      "metadata": {
        "meta.title": "Tiêu đề Trang của Bạn",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "Tiện ích"
      },
      "navbar": {
        "navbar.dashboard": "Bảng điều khiển",
        "navbar.login": "Đăng nhập",
        "navbar.openMenu": "Mở menu chính",
        "navbar.features": "Tính năng",
        "navbar.resources": "Tài nguyên",
        "navbar.pricing": "Giá cả",
        "navbar.contact": "Liên hệ",
        "navbar.topPodcasts": "Podcast nổi bật",
        "navbar.seeAllFeatures": "Xem tất cả tính năng",
        "navbar.mainFeatures": "CÁC TÍNH NĂNG CHÍNH",
        "navbar.podcastTranscription": "Trình tạo phiên âm Podcast và Video",
        "navbar.transcriptionDescription": "Bản sao chính xác cao với nhãn người nói và tệp SRT cho phụ đề.",
        "navbar.podcastSummarizer": "Tóm tắt Podcast",
        "navbar.summarizerDescription": "Tạo ghi chú chương trình hoàn chỉnh nhanh gấp 20 lần, bằng giọng nói của bạn.",
        "navbar.podcastClipMaker": "Trình tạo Clip Podcast",
        "navbar.clipMakerDescription": "Tự động tạo các clip ngắn hoặc audiogram cho podcast của bạn.",
        "navbar.audioEnhancer": "Nâng cao Âm thanh Ai",
        "navbar.audioEnhancerDescription": "Tự động nâng cao âm thanh, loại bỏ im lặng và từ ngữ thừa.",
        "navbar.podsqueezeFeaturesWalkthrough": "HƯỚNG DẪN TÍNH NĂNG PODSQUEEZE",
        "navbar.blog": "Blog",
        "navbar.blogDescription": "Các bài viết và hướng dẫn có thể hành động để khởi động và phát triển một podcast thành công.",
        "navbar.podcastTopicIdeas": "Ý tưởng Chủ đề Podcast",
        "navbar.topicIdeasDescription": "Khám phá các chủ đề podcast mà khán giả đang tìm kiếm.",
        "navbar.actionableEbooks": "eBook Thực Tiễn",
        "navbar.ebooksDescription": "Tải xuống eBook miễn phí với các mẹo thực tiễn để đưa podcast của bạn lên tầm cao mới.",
        "navbar.freeThumbnailMaker": "Công Cụ Tạo Thumbnail Podcast Miễn Phí",
        "navbar.freeThumbnailMakerDescription": "Tạo thumbnail tập phim chuyên nghiệp và bắt mắt với AI.",
        "navbar.seoOptimizer": "Công Cụ Tối Ưu SEO",
        "navbar.seoOptimizerDescription": "Tối ưu hóa các tập podcast của bạn để có khả năng hiển thị tốt hơn trên công cụ tìm kiếm.",
        "navbar.podcastDescription": "Nghe podcast của chúng tôi, nơi chúng tôi phỏng vấn các podcaster giàu kinh nghiệm và người dùng Podsqueeze từ khắp nơi trên thế giới. Chúng tôi yêu cầu họ chia sẻ các mẹo, hiểu biết, câu chuyện và mọi thứ bạn cần biết để phát triển podcast của riêng mình."
      },
      "resultModal": {
        "prompt.transcript.quote": "Trích dẫn",
        "prompt.transcript.blog": "Blog",
        "prompt.transcript.tweets": "Tweet",
        "prompt.shownotes.firstPerson": "Ghi chú người nói đầu tiên",
        "prompt.shownotes.replaceName": "Thay thế tên trong ghi chú",
        "prompt.shownotes.friendlyTone": "Ghi chú với giọng điệu thân thiện",
        "prompt.shownotes.youtubeDescription": "Ghi chú mô tả YouTube",
        "prompt.shownotes.engagingQuestion": "Ghi chú câu hỏi hấp dẫn",
        "prompt.timestamps.formatAsChapters": "Định dạng thời gian thành chương với tiêu đề mô tả",
        "prompt.timestamps.detailedDescriptions": "Tạo thời gian chi tiết với mô tả chủ đề và điểm chính",
        "prompt.timestamps.improveSpeakerNames": "Thay thế tên người nói bằng tiêu đề mô tả hơn như 'Người hỏi', 'Chuyên gia' hoặc 'Khách hàng'",
        "prompt.newsletter.casualTone": "Bản tin với giọng điệu thoải mái",
        "prompt.newsletter.shorter": "Bản tin ngắn hơn",
        "prompt.newsletter.contentSections": "Các phần nội dung bản tin",
        "prompt.newsletter.changeName": "Thay đổi tên trong bản tin",
        "prompt.mentions.fullURL": "Đề cập URL đầy đủ",
        "prompt.mentions.replaceName": "Thay thế tên trong đề cập",
        "prompt.tweets.underdogTone": "Tweet với giọng điệu kẻ yếu",
        "prompt.tweets.firstPerson": "Tweet người nói đầu tiên",
        "prompt.shortPost.relevantEmojis": "Biểu tượng cảm xúc liên quan trong bài viết ngắn",
        "prompt.shortPost.educationalTone": "Bài viết ngắn với giọng điệu giáo dục",
        "prompt.shortPost.underdogTone": "Bài viết ngắn với giọng điệu kẻ yếu",
        "prompt.shortPost.firstPerson": "Bài viết ngắn người nói đầu tiên",
        "prompt.titles.youtubeOptimized": "Tiêu đề tối ưu hóa cho YouTube",
        "prompt.titles.startWithHowTo": "Bắt đầu với tiêu đề 'Cách để'",
        "prompt.titles.otherOptions": "Các tùy chọn khác cho tiêu đề",
        "prompt.keywords.youtubeOptimized": "Từ khóa tối ưu hóa cho YouTube",
        "prompt.keywords.separateWithCommas": "Tách từ khóa bằng dấu phẩy",
        "prompt.quotes.lorem1": "Trích dẫn Lorem ipsum 1",
        "prompt.quotes.lorem2": "Trích dẫn Lorem ipsum 2",
        "prompt.bulletPoints.lorem1": "Điểm bullet Lorem ipsum 1",
        "prompt.bulletPoints.lorem2": "Điểm bullet Lorem ipsum 2",
        "prompt.longPost.firstPerson": "Bài viết dài người nói đầu tiên",
        "prompt.longPost.relevantEmojis": "Biểu tượng cảm xúc liên quan trong bài viết dài",
        "prompt.longPost.changeName": "Thay đổi tên trong bài viết dài",
        "alert.tuningInstructionsEmpty": "Hướng dẫn điều chỉnh không được để trống.",
        "text.timestamps.byPodsqueeze": "Thời gian bởi PodSqueeze",
        "button.copied": "Đã sao chép",
        "button.copy": "Sao chép",
        "embed.transcript": "Nhúng Bản ghi",
        "embed.description": "Mô tả cho việc nhúng",
        "preview.title": "Tiêu đề Xem trước",
        "loading.regenerating": "Đang tái tạo...",
        "placeholder.tuningInstructions": "Nhập hướng dẫn điều chỉnh...",
        "button.saveClose": "Lưu và Đóng",
        "button.acceptChanges": "Chấp nhận Thay đổi",
        "button.discard": "Bỏ qua",
        "button.embedTranscript": "Nhúng Bản ghi",
        "text.copiedToClipboard": "Đã sao chép vào clipboard",
        "download.srtFile": "Tải xuống tệp SRT",
        "text.forCaptions": "cho phụ đề",
        "tune.title": "Điều chỉnh Kết quả của Bạn",
        "tune.description": "Điều chỉnh kết quả của bạn với các tùy chọn sau.",
        "instruction.label": "Hướng dẫn:",
        "button.tuneResult": "Điều chỉnh Kết quả",
        "instruction.saveForLater": "Lưu lại để sau",
        "button.readMore": "Đọc thêm",
        "button.showLess": "Hiển thị ít hơn",
        "customPrompt.used": "Prompt tùy chỉnh đã sử dụng:",
        "feedback.happyWithResults": "Bạn có hài lòng với kết quả không?"
      },
      "resultModalTranscript": {
        "prompt.quote": "Tìm ba câu trích dẫn hay từ bản ghi",
        "prompt.blog": "Viết một bài blog 500 từ tập trung vào chủ đề X",
        "prompt.tweets": "Viết ba tweet hấp dẫn từ bản ghi",
        "transcript.autoTranscribed": "Được chuyển tự động với Podsqueeze",
        "alert.emptyPrompt": "Hướng dẫn không được để trống",
        "embed.transcript": "Nhúng Bản Ghi",
        "embed.description": "Nhúng một bản ghi có kích thước hợp lý với tính năng tìm kiếm trên trang WordPress của bạn hoặc bất kỳ trang nào hỗ trợ HTML.",
        "button.copied": "Đã sao chép!",
        "button.copy": "Sao chép",
        "preview.title": "Xem trước",
        "edit.speakers": "Chỉnh sửa Tên Người Nói",
        "button.saveClose": "Lưu & Đóng",
        "placeholder.prompt": "vd: Tìm ba câu trích dẫn hay từ bản ghi",
        "upgrade.pro": "Nâng cấp lên Pro để sử dụng tính năng này",
        "upgrade.link": "Nâng cấp lên Pro",
        "button.generate": "Tạo",
        "feedback.happy": "Bạn có hài lòng với kết quả không?",
        "instruction": "Hướng dẫn: ",
        "generating.results": "Đang tạo kết quả",
        "full.transcription": "Bản ghi đầy đủ",
        "srt.file": "& tệp SRT",
        "download.srt": "Tải xuống tệp SRT",
        "caption.subtitles": "cho phụ đề và phụ đề.",
        "generate.from.transcript": "Tạo từ Bản Ghi với Gpt-4o",
        "gpt.tweak.text": "Yêu cầu GPT mới nhất điều chỉnh văn bản theo ý bạn. Sử dụng ngôn ngữ tự nhiên và đừng ngại cụ thể.",
        "copied.clipboard": "Đã sao chép vào clipboard",
        "transcript.public.available": "URL công khai",
        "audio.notSupported": "Trình duyệt của bạn không hỗ trợ phần tử âm thanh.",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "Thêm Tên Podcast",
        "podcast.title": "Podcast {{title}}"
      },
      "sourceModal": {
        "sourceModal.title": "Bạn đã biết đến Podsqueeze qua đâu?",
        "sourceModal.otherPlaceholder": "Vui lòng chỉ rõ",
        "sourceModal.nextButton": "Tiếp theo",
        "sourceModal.skip": "Bỏ qua"
      },
      "squeezeEditResults": {
        "error.processing.rss": "Chúng tôi đang gặp một số khó khăn trong việc xử lý một số nguồn cấp dữ liệu RSS. Vui lòng tải lên một tệp."
      },
      "squeezeResults": {
        "copiedToClipboard": "Đã sao chép vào bảng tạm",
        "publicLink": "Công khai tại ",
        "createLink": "Tạo liên kết để chia sẻ Trang Kết Quả này",
        "assembleShowNotes": "Tập hợp ghi chú chương trình",
        "convertAnotherEpisode": "Chuyển đổi một tập khác",
        "writtenContent": "Nội dung viết",
        "videoClipsAndImages": "Video và Hình ảnh",
        "editAudio": "Chỉnh sửa Âm thanh"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "Xem thêm và điều chỉnh",
        "see.more": "Xem thêm",
        "generating": "Đang tạo",
        "download.all": "Tải xuống tất cả",
        "full.transcription": "Bản sao đầy đủ",
        "transcript.benefit": "Bạn có biết việc thêm bản sao đầy đủ vào ghi chú chương trình của bạn sẽ tăng lưu lượng truy cập và sự tương tác trên website không?",
        "learn.more": "Tìm hiểu thêm",
        "transcript.bonus": "Bạn có thể cung cấp bản sao đầy đủ như một phần thưởng cho chương trình thành viên podcast của bạn.",
        "show.notes": "Ghi chú chương trình",
        "show.notes.engagement": "Hãy xem xét việc bổ sung mô tả ngắn này với các yếu tố khác trong ghi chú chương trình của bạn để tăng cường sự tương tác và SEO.",
        "show.notes.examples": "Tìm cảm hứng từ 17 ví dụ ghi chú chương trình podcast này để tạo ra những ghi chú hoàn hảo cho podcast của bạn.",
        "timestamps": "Thời gian",
        "timestamps.benefit": "Thêm những thời gian này vào mô tả tập của bạn và nó sẽ tự động tạo chương trên Spotify và YouTube.",
        "titles": "Tiêu đề",
        "titles.engagement": "Các tiêu đề có dấu hỏi và tính từ so sánh thường thu hút sự chú ý đặc biệt.",
        "links.and.mentions": "Liên kết & Đề cập",
        "mentions.resources": "Hãy xem xét việc bao gồm các đề cập dưới đây trong phần tài nguyên của ghi chú chương trình của bạn.",
        "mentions.affiliate": "Xem xem các sản phẩm được đề cập có chương trình liên kết không và xem xét thêm liên kết liên kết vào ghi chú chương trình của bạn.",
        "mentions.social.media": "Gắn thẻ những người được đề cập trong tập của bạn trên mạng xã hội để khuyến khích họ chia sẻ và tương tác với bài đăng của bạn.",
        "keywords": "Từ khóa",
        "keywords.youtube": "Khi bạn tải tập của mình lên YouTube, chỉ cần sao chép và dán những từ khóa này vào phần thẻ.",
        "keywords.social.media": "Tái sử dụng những từ khóa này cho các thẻ hashtag trên mạng xã hội.",
        "blog.post": "Bài viết blog",
        "blog.post.linkedin": "Hãy xem xét việc sử dụng nội dung này để tạo một bài viết dài trên Linkedin,",
        "blog.post.share": "Chia sẻ nội dung này trong các cộng đồng Reddit và nhóm Facebook phù hợp với chủ đề podcast của bạn.",
        "newsletter": "Bản tin",
        "newsletter.content": "Một số người dùng của chúng tôi tái sử dụng nội dung bản tin này để tạo ra các mô tả tập toàn diện hơn cho ghi chú chương trình.",
        "linkedin.and.facebook": "Linkedin & Facebook",
        "short.post.description": "Sử dụng những bài đăng ngắn này làm mô tả khi chia sẻ các đoạn video và audiogram liên quan trên mạng xã hội.",
        "tweets": "Tweet",
        "quotes": "Trích dẫn",
        "bullet.points": "Điểm nổi bật",
        "add.custom.result": "Thêm kết quả tùy chỉnh",
        "bullet.points.skimming": "Các podcaster thường liệt kê các chủ đề chính của tập như các điểm nổi bật trong ghi chú chương trình để dễ dàng lướt qua."
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "Xem thêm và điều chỉnh",
        "generating": "Đang tạo",
        "not.available.for.rss.feed": "Không có sẵn cho nguồn RSS này",
        "regenerate.episode.upload.file": "Tạo lại tập và tải lên tệp âm thanh/video của bạn trực tiếp từ máy tính",
        "processing.difficulties": "Chúng tôi đang gặp một số khó khăn trong việc xử lý một số nguồn RSS. Vui lòng tải lên một tệp.",
        "video.clips": "Đoạn video",
        "ai.short.clips": "Đoạn video ngắn AI",
        "quote.image": "Hình ảnh trích dẫn"
      },
      "title": {
        "title.text": "nhãn.của.bạn"
      },
      "topbar": {
        "topbar.forYou": "Dành cho bạn",
        "topbar.joinPodcast": "Tham gia buổi gặp gỡ podcast ảo tiếp theo của chúng tôi!",
        "topbar.saveYourSpot": "Lưu chỗ của bạn",
        "topbar.dismiss": "Bỏ qua"
      },
      "trackers": {
        "trackers.init": "Khởi tạo các trình theo dõi với cookie được bật: ",
        "trackers.loadScripts": "Đang tải các tập lệnh theo dõi..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "Chào mừng đến với Ứng dụng của tôi",
        "content.description": "Đây là một ứng dụng mẫu minh họa việc dịch thuật.",
        "button.submit": "Gửi"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI đang chỉnh sửa clip của bạn",
        "export_clip": "Xuất Clip",
        "ai_edit": "Chỉnh sửa AI",
        "ai_editing_clip_duration": "Điều này sẽ mất vài giây",
        "generating_clip": "Đang tạo clip của bạn...",
        "generating_clip_notice": "Điều này có thể mất vài phút. Chúng tôi sẽ gửi email cho bạn khi hoàn tất.",
        "edit_another_video": "Bạn có thể chờ ở đây hoặc chỉnh sửa video khác",
        "download_video": "Tải Video",
        "back_to_editing": "Quay lại chỉnh sửa",
        "export_video_button": "Xuất Clip",
        "notice_storage": "Thông báo: Chúng tôi lưu trữ âm thanh của bạn trong 30 ngày. Sau thời gian này, clip này sẽ hết hạn.",
        "error_generating_clip": "Lỗi khi tạo clip",
        "error_user_support": "Vui lòng thử lại hoặc liên hệ với bộ phận hỗ trợ người dùng của chúng tôi",
        "select_template": "Chọn mẫu",
        "add_30s_prev": "30 giây từ chương trước",
        "add_30s_next": "30 giây từ chương tiếp theo",
        "undo": "Hoàn tác",
        "subtitles_font": "Phông chữ phụ đề",
        "subtitles_color": "Màu sắc phụ đề",
        "subtitles_box_color": "Màu sắc hoạt hình",
        "adjust_podcast_title_position": "Điều chỉnh vị trí dọc tiêu đề podcast",
        "adjust_subtitles_size": "Điều chỉnh kích thước phụ đề",
        "adjust_subtitles_vertical_position": "Điều chỉnh vị trí dọc phụ đề",
        "remove_subtitles": "Xóa phụ đề",
        "animated_subtitles": "Phụ đề hoạt hình",
        "upgrade_here": "Nâng cấp tại đây",
        "remove_logo": " để xóa logo",
        "remove_podsqueeze_logo": "Xóa logo podsqueeze",
        "aspect_ratio": "Tỷ lệ khung hình",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram Feed",
        "reels": "Reels, Stories, YouTube Shorts, TikTok",
        "episode_title": "Tiêu đề tập",
        "podcast_title": "Tiêu đề podcast",
        "titles_font": "Phông chữ tiêu đề",
        "title_colors": "Màu sắc tiêu đề podcast/tập",
        "video_fit": "Phù hợp video",
        "adjust_horizontal_position": "Điều chỉnh vị trí ngang",
        "adjust_vertical_position": "Điều chỉnh vị trí dọc",
        "adjust_video_zoom": "Điều chỉnh zoom video",
        "adjust_video_width": "Điều chỉnh chiều rộng video",
        "adjust_video_height": "Điều chỉnh chiều cao video",
        "background_color": "Màu nền",
        "edit_clip": "Chỉnh sửa Clip",
        "edit_layout": "Chỉnh sửa Layout",
        "choose_short": "Chọn Clip ngắn",
        "edit_audio": "Chỉnh sửa Âm thanh",
        "framing": "Khung hình",
        "background": "Nền",
        "text_style": "Kiểu chữ",
        "music": "Nhạc",
        "choose_chapter": "Chọn một chương",
        "clips_left": "Bạn còn",
        "apply_layout": "Áp dụng Layout",
        "clips_left_number": "clip còn lại",
        "need_more_clips": "Cần thêm clip? Nâng cấp gói của bạn tại đây",
        "download_srt_file": "Tải tệp SRT",
        "track_selected": "Bản nhạc: ",
        "no_background_music": "Không có nhạc nền nào được chọn",
        "volume": "Âm lượng:",
        "remove": "Xóa",
        "track_ambient_piano": "Piano và dây nhạc ambient",
        "track_deep_meditation": "Thiền sâu",
        "track_chill_upbeat": "Nhạc chill vui vẻ",
        "track_inspiring_ambient": "Nhạc ambient điện ảnh truyền cảm hứng",
        "track_just_relax": "Chỉ cần thư giãn",
        "track_movement": "Chuyển động",
        "track_once_in_paris": "Một lần ở Paris",
        "track_perfect_beauty": "Vẻ đẹp hoàn hảo",
        "track_summer_adventures": "Cuộc phiêu lưu mùa hè",
        "track_sunset_groove": "Giai điệu hoàng hôn",
        "track_tvari_cafe": "Quán cà phê Tvari Tokyo",
        "track_short_piano_intermezzo": "Intermezzo Piano Ngắn",
        "track_dramatic_background": "Nhạc Nền Kịch Tính",
        "track_dramatic_hiphop": "Hip-Hop Jazz Kịch Tính",
        "track_emotional_orchestra": "Dàn Nhạc Cảm Xúc",
        "track_halloween_short": "Nhạc Halloween",
        "track_improvisation_037": "Nhạc Jazz Ứng Tác",
        "track_inspiration_piano": "Piano Truyền Cảm Hứng",
        "track_medieval_extract": "Nhạc Trung Cổ",
        "track_short_8": "Track Ambient Ngắn",
        "track_flute": "Sáo Thanh Bình",
        "track_piano_guitar_duet": "Song Tấu Piano-Guitar",
        "track_intro_jazz": "Jazz Mở Đầu",
        "track_romantic_jazz": "Jazz Lãng Mạn",
        "recommended_for_youtube": "Được đề xuất cho YouTube",
        "turn_into_short_clip": "Chuyển đổi clip này thành clip ngắn (<60 giây)",
        "browser_not_support_audio": "Trình duyệt của bạn không hỗ trợ phần tử âm thanh.",
        "watch_tutorial": "Xem hướng dẫn này",
        "audiogram_maker": "cách tận dụng tối đa trình tạo audiogram của chúng tôi",
        "store_audio_notice": "Lưu ý: Chúng tôi lưu trữ âm thanh của bạn trong 30 ngày.",
        "clip_maker": "cách tận dụng tối đa trình tạo clip của chúng tôi",
        "split_screen_mode": "Chế độ chia màn hình",
        "none": "Không",
        "vertical_split": "Chia dọc",
        "horizontal_split": "Chia ngang",
        "layers": "Sử dụng các lớp bên dưới để di chuyển chúng về phía trước hoặc phía sau.",
        "screen_1_horizontal_position": "Vị trí ngang màn hình 1",
        "screen_2_horizontal_position": "Vị trí ngang màn hình 2",
        "track_mysterious_dark_background": "Nền tối bí ẩn",
        "track_acoustic_ambient_inspiration": "Cảm hứng ambient acoustic",
        "track_aristocracy_classical": "Aristocracy classical",
        "track_folk_music_river_knows_my_name": "Nhạc folk - Sông biết tên tôi",
        "track_funy_adventure": "Cuộc phiêu lưu vui nhộn",
        "track_energetic_sports_rock_trailer": "Trailer rock thể thao năng động",
        "track_fun_upbeat_energetic_pop_rock": "Pop rock năng động vui tươi",
        "track_epic_emotional_inspirational": "Sử thi cảm xúc truyền cảm hứng",
        "track_inspirational_epic": "Sử thi truyền cảm hứng",
        "all_music": "Tất cả nhạc",
        "energetic_music": "Năng động",
        "inspirational_music": "Truyền cảm hứng",
        "ambient_music": "Ambient",
        "chill_music": "Thư giãn",
        "hiphop_music": "Hip-Hop",
        "quirky_music": "Kỳ quặc",
        "dramatic_music": "Kịch tính",
        "acoustic_music": "Acoustic",
        "classical_music": "Cổ điển",
        "categories": "Danh mục",
        "select_track": "Chọn bản nhạc",
        "upload_music": "Tải lên nhạc",
        "my_music": "Nhạc của tôi",
        "downloading": "Đang tải xuống...",
        "download_again": "Tải lại",
        "download": "Tải xuống",
        "download_failed_alert": "Tải xuống video thất bại. Vui lòng thử lại.",
        "translate_subtitles": "Dịch Phụ Đề",
        "translate_to": "Dịch sang",
        "select_language": "Chọn Ngôn Ngữ",
        "select_new_language": "Chọn ngôn ngữ mới",
        "translating": "Đang dịch...",
        "translation_complete": "Dịch Hoàn Thành",
        "error_translation": "Lỗi trong quá trình dịch. Vui lòng thử lại.",
        "original_language": "Gốc"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "Tiêu đề Tập"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "Bạn chưa có nội dung nào.",
        "userPodcastsInfo.generateContent": "Tạo nội dung đầu tiên của bạn",
        "placeholder.search_folders": "Tìm kiếm thư mục...",
        "search.no_results": "Không có thư mục nào khớp với tìm kiếm của bạn."
      },
      "landingPageModal": {
        "upload.error": "Tải lên hình ảnh không thành công: ",
        "upload.image.file": "Vui lòng tải lên một tệp hình ảnh.",
        "upgrade.pro.message": "Tùy chỉnh trang chỉ có sẵn cho tài khoản Pro và Agency",
        "upgrade.now": "Nâng cấp ngay",
        "upgrade.unique.landing.page": " và tạo một trang đích tập riêng biệt.",
        "logo.recommendation": "Chiều cao logo được khuyến nghị 200px",
        "social.links.top.menu": "Liên kết mạng xã hội trên menu trên cùng",
        "linkedin.label": "LinkedIn",
        "linkedin.placeholder": "Nhập liên kết LinkedIn",
        "facebook.label": "Facebook",
        "facebook.placeholder": "Nhập liên kết Facebook",
        "saving...": "Đang lưu...",
        "save": "Lưu",
        "saved.successfully": "Lưu thành công!",
        "uploading.image": "Đang tải lên hình ảnh...",
        "upload.episode.cover": "Tải lên bìa tập",
        "upload.logo": "Tải lên logo",
        "where.listen.episode": "Chúng ta có thể nghe tập này ở đâu nữa?",
        "youtube.label": "YouTube",
        "youtube.placeholder": "Nhập liên kết YouTube",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "Nhập liên kết Apple Podcasts",
        "spotify.label": "Spotify",
        "spotify.placeholder": "Nhập liên kết Spotify",
        "image.size.recommendation": "Kích thước được khuyến nghị 1000x1000px",
        "primary.color.label": "Màu chính",
        "header.background.color": "Màu nền tiêu đề và liên kết.",
        "landing.page.customization": "Tùy chỉnh trang đích",
        "create.branded.landing.page": "Tạo một trang đích đẹp với thương hiệu để chia sẻ với người nghe của bạn",
        "episode.image": "Hình ảnh tập",
        "episode.links": "Liên kết tập",
        "page.header": "Tiêu đề trang",
        "page.color": "Màu trang",
        "visit.landing.page": "Truy cập trang đích"
      },
      "page": {
        "loading.dashboard": "Đang tải Bảng điều khiển",
        "convert.new.episode": "Chuyển đổi Tập mới",
        "convert.audio.or.video": "Chuyển đổi âm thanh hoặc video",
        "minutes.left": "Bạn còn",
        "need.more.minutes": "Cần thêm phút không?",
        "upgrade.plan": "Nâng cấp gói của bạn tại đây.",
        "your.podcasts": "Podcast của bạn",
        "podsqueeze.results.page": "Trang kết quả Podsqueeze",
        "access.podsqueeze.results": "Truy cập kết quả podsqueeze cho tập này. Bạn sẽ có thể xem tất cả nội dung đã được tạo ra"
      },
      "podcast": {
        "confirm.delete_episode": "Bạn có chắc chắn muốn xóa tập này không?",
        "alert.something_wrong": "Có điều gì đó không đúng. Vui lòng thử lại.",
        "confirm.delete_folder": "Bạn có chắc chắn muốn xóa thư mục này không?",
        "loading.episodes": "Đang tải các tập...",
        "folder.empty": "Thư mục này trống.",
        "content.no_content": "Không có nội dung nào.",
        "content.generate_first": "Tạo podcast đầu tiên của bạn.",
        "button.personalize_ai": "Cá nhân hóa với AI",
        "button.edit_website": "Chỉnh sửa Website",
        "button.visit_website": "Truy cập Website",
        "button.generate_website": "Tạo Website",
        "placeholder.search": "Tìm kiếm...",
        "label.sort_by": "Sắp xếp theo",
        "label.last_episodes_loaded": "Các tập cuối cùng đã tải",
        "button.load_all_episodes": "Tải tất cả các tập",
        "loading": "Đang tải...",
        "add.new.episode": "Thêm Tập Mới",
        "order.newest": "Mới nhất trước",
        "order.oldest": "Cũ nhất trước",
        "order.a_to_z": "A đến Z",
        "order.z_to_a": "Z đến A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "Tạo một thư mục podcast mới:",
        "folder.name.placeholder": "Tên thư mục",
        "create.button": "Tạo"
      },
      "podcastLandingModal": {
        "upload.image.error": "Vui lòng tải lên một tệp hình ảnh",
        "podcast.cover.title": "Hình Ảnh Bìa Podcast",
        "podcast.cover.upload": "Tải lên hình ảnh bìa podcast của bạn ở đây. Hình ảnh này sẽ được hiển thị nổi bật trên trang đích của bạn.",
        "upload.image.uploading": "Đang tải hình ảnh...",
        "podcast.cover.upload.button": "Tải lên Hình Ảnh Bìa",
        "podcast.cover.recommended.size": "Kích thước được khuyến nghị: 1400x1400 pixel",
        "profile.info.title": "Thông Tin Hồ Sơ",
        "profile.info.upload": "Thêm hình ảnh hồ sơ và tên của bạn để cá nhân hóa trang đích của bạn.",
        "profile.upload.button": "Tải lên Hình Ảnh Hồ Sơ",
        "profile.name.label": "Tên Hồ Sơ",
        "profile.name.placeholder": "Nhập tên của bạn",
        "platform.links.title": "Liên Kết Nền Tảng",
        "platform.links.upload": "Thêm liên kết đến podcast của bạn trên các nền tảng khác nhau.",
        "platform.links.youtube_link": "Liên Kết YouTube",
        "platform.links.youtube_link.placeholder": "Nhập liên kết YouTube",
        "platform.links.spotify_link": "Liên Kết Spotify",
        "platform.links.spotify_link.placeholder": "Nhập liên kết Spotify",
        "platform.links.apple_podcast_link": "Liên Kết Apple Podcast",
        "platform.links.apple_podcast_link.placeholder": "Nhập liên kết Apple Podcast",
        "platform.links.linkedin_link": "Liên Kết LinkedIn",
        "platform.links.linkedin_link.placeholder": "Nhập liên kết LinkedIn",
        "platform.links.facebook_link": "Liên Kết Facebook",
        "platform.links.facebook_link.placeholder": "Nhập liên kết Facebook",
        "platform.links.twitter_link": "Liên Kết Twitter",
        "platform.links.twitter_link.placeholder": "Nhập liên kết Twitter",
        "call.to.action.title": "Kêu Gọi Hành Động",
        "call.to.action.upload": "Thiết lập nút kêu gọi hành động cho trang đích.",
        "call.to.action.button.text.label": "Văn Bản Nút",
        "call.to.action.button.text.placeholder": "Nhập văn bản nút",
        "call.to.action.button.link.label": "Liên Kết Nút",
        "call.to.action.button.link.placeholder": "Nhập liên kết nút",
        "color.styles.title": "Phong Cách Màu Sắc",
        "color.styles.upload": "Tùy chỉnh màu sắc của trang đích của bạn.",
        "color.styles.primary.label": "Màu Sắc Chính",
        "color.styles.primary.description": "Chọn màu sắc chính cho trang đích của bạn",
        "color.styles.secondary.label": "Màu Sắc Phụ",
        "color.styles.secondary.description": "Chọn màu sắc phụ cho trang đích của bạn",
        "podcast.info.title": "Thông Tin Podcast",
        "podcast.info.upload": "Chỉnh sửa thông tin chi tiết của podcast của bạn.",
        "podcast.info.name.label": "Tên Podcast",
        "podcast.info.name.placeholder": "Nhập tên podcast",
        "podcast.info.description.label": "Mô Tả Podcast",
        "podcast.info.description.placeholder": "Nhập mô tả podcast",
        "edit.website.title": "Chỉnh Sửa Trang Web",
        "generate.website.title": "Tạo Trang Web",
        "for": "cho",
        "saving": "Đang lưu...",
        "save.changes": "Lưu Thay Đổi",
        "generate.website": "Tạo Trang Web",
        "changes.saved.success": "Thay đổi đã được lưu thành công!",
        "podcast.cover.menu": "Bìa Podcast",
        "podcast.info.menu": "Thông Tin Podcast",
        "profile.menu": "Hồ Sơ",
        "platform.links.menu": "Liên Kết Nền Tảng",
        "call.to.action.menu": "Kêu Gọi Hành Động",
        "color.styles.menu": "Phong Cách Màu Sắc",
        "logo.menu": "Logo",
        "logo.title": "Tải lên Logo",
        "logo.upload": "Tải lên logo của bạn ở đây. Logo này sẽ được hiển thị trên trang đích của bạn.",
        "logo.upload.button": "Tải lên Logo",
        "platform.links.description": "Thêm liên kết đến podcast của bạn trên các nền tảng khác nhau.",
        "social.links.menu": "Liên Kết Xã Hội",
        "social.links.title": "Liên Kết Xã Hội",
        "social.links.description": "Thêm liên kết đến các tài khoản xã hội của bạn.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Nhập liên kết LinkedIn",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Nhập liên kết Facebook",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Nhập liên kết Twitter",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Nhập liên kết Instagram",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Nhập liên kết YouTube",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Nhập liên kết Spotify",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Nhập liên kết Apple Podcast",
        "view.website": "Xem Trang Web"
      },
      "podcastMoveModal": {
        "move.episode.label": "Di chuyển tập này đến:",
        "move.episode.instruction": "Bạn có thể nhập tên mới để tạo một thư mục.",
        "move.episode.button": "Di chuyển",
        "move.episode.error.selectFolder": "Vui lòng chọn một thư mục để di chuyển tập."
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "Cài đặt AI cho Podcast {{podcastTitle}}",
        "ai.customize.writing.style": "Tùy chỉnh phong cách viết AI của bạn",
        "ai.content.writing.preference": "Bạn muốn Podsqueeze viết nội dung của bạn như thế nào?",
        "ai.voice.placeholder": "Ví dụ: Giọng điệu chuyên nghiệp nhưng thân thiện. Người nghe là các podcaster. Viết ở ngôi thứ nhất.",
        "ai.character.limit.reached": "Bạn đã đạt giới hạn ký tự là 50.",
        "ai.upgrade.now": "Nâng cấp ngay",
        "ai.fix.transcript.misspells": "Sửa lỗi chính tả trong bản ghi",
        "ai.enter.misspelled.words": "Ghi lại các từ mà AI thường viết sai trong các tập podcast này, ví dụ: tên",
        "ai.enter.word.press.enter": "Nhập một từ và nhấn Enter",
        "ai.add.word": "Thêm từ",
        "ai.tag.limit.reached": "Đã đạt giới hạn 1 thẻ.",
        "ai.save": "Lưu",
        "ai.save.close": "Lưu & Đóng"
      },
      "selectedepisode": {
        "selectedEpisode.title": "Tiêu đề Tập",
        "selectedEpisode.podcastName": "Tên Podcast",
        "selectedEpisode.showNotes": "Ghi chú Chương trình",
        "selectedEpisode.timestamp": "Thời gian",
        "selectedEpisode.staticTimestamp": "Thời gian Tĩnh",
        "selectedEpisode.mentions": "Đề cập",
        "selectedEpisode.newsletter": "Bản tin",
        "selectedEpisode.titles": "Tiêu đề",
        "selectedEpisode.tweeter": "Người Tweet",
        "selectedEpisode.shortPost": "Bài viết Ngắn",
        "selectedEpisode.transcription": "Bản sao",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "Từ khóa",
        "selectedEpisode.quotes": "Trích dẫn",
        "selectedEpisode.longPost": "Bài viết Dài",
        "selectedEpisode.bulletPoints": "Điểm nổi bật",
        "selectedEpisode.publicLink": "Liên kết Công khai",
        "selectedEpisode.embeddedId": "ID Nhúng",
        "selectedEpisode.episodeUrl": "URL Tập"
      },
      "sidebar": {
        "tools": "Công Cụ",
        "find.podcast.topic.ideas": "Tìm Ý Tưởng Chủ Đề Podcast",
        "podcast.thumbnail.maker": "Công Cụ Tạo Ảnh Thumbnail Podcast",
        "podcast.seo.optimizer": "Công Cụ Tối Ưu SEO Podcast",
        "account": "Tài Khoản",
        "payment.settings": "Cài Đặt Thanh Toán",
        "support": "Hỗ Trợ",
        "logout": "Đăng Xuất",
        "plan": "Kế Hoạch",
        "resets.in": "Đặt Lại Trong",
        "api.access": "Truy Cập API",
        "days": "ngày và",
        "hours": "giờ",
        "upgrade.plan": "Nâng Cấp Kế Hoạch"
      },
      "updateEmailModal": {
        "email.validation.error": "Vui lòng nhập địa chỉ email hợp lệ.",
        "email.change.confirm": "Bạn có chắc chắn muốn thay đổi địa chỉ email của mình không?",
        "email.change.success": "Địa chỉ email của bạn đã được thay đổi thành công!",
        "email.in.use.error": "Địa chỉ email này đã được sử dụng. Vui lòng thử một địa chỉ khác.",
        "email.recent.login.error": "Trước khi tiếp tục với thao tác này, vui lòng đăng nhập lại bằng địa chỉ email hiện tại.",
        "email.invalid.error": "Địa chỉ email không hợp lệ. Vui lòng thử một địa chỉ khác.",
        "subscription.cancel.error": "Vui lòng hủy đăng ký trả phí đang hoạt động của bạn trước.",
        "account.delete.confirm": "Bạn có chắc chắn muốn xóa tài khoản của mình không?\n\nHành động này không thể hoàn tác.",
        "account.delete.success": "Tài khoản của bạn đã được xóa thành công.",
        "account.delete.error": "Đã xảy ra sự cố và chúng tôi không thể xóa tài khoản của bạn.\n\nVui lòng liên hệ với bộ phận hỗ trợ người dùng của chúng tôi.",
        "subscription.cancel": "Hủy Đăng Ký",
        "account.delete": "Xóa Tài Khoản",
        "account.delete.warning": "Việc xóa tài khoản của bạn là không thể hoàn tác và sẽ xóa vĩnh viễn tất cả nội dung và thông tin đăng nhập của bạn. Vui lòng tiến hành cẩn thận vì hành động này không thể hoàn tác.",
        "current.account.email": "Email Tài Khoản Hiện Tại",
        "enter.new.email": "Nhập email tài khoản mới của bạn",
        "update": "Cập Nhật",
        "change.password": "Thay Đổi Mật Khẩu",
        "payment.settings": "Cài Đặt Thanh Toán"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "tiêu đềTập"
      },
      "episodelist": {
        "loading.episodes": "Đang tải các tập",
        "no.episodes.found": "Không tìm thấy tập nào. Vui lòng thử lại với một ID RSS hợp lệ",
        "select.episode": "Chọn tập mà bạn muốn tạo nội dung cho"
      },
      "interfaces": {
        "user.activePlan.tier": "Cấp độ",
        "user.activePlan.creationDate": "Ngày tạo",
        "user.activePlan.minutesAvailable": "Số phút có sẵn"
      },
      "loadingbar": {
        "loadingbar.magic": "Chúng tôi vẫn đang làm phép thuật của mình ✨",
        "loadingbar.longer": "Một số tập phim mất một chút thời gian hơn... 🐌",
        "loadingbar.hardwork": "Máy chủ của chúng tôi đang làm việc chăm chỉ 🦾"
      },
      "page": {
        "main.background": "Nền của thành phần chính"
      },
      "recordfile": {
        "microphone.camera.access.denied": "Lỗi: Quyền truy cập vào microphone hoặc camera đã bị từ chối.",
        "microphone.camera.not.found": "Lỗi: Không tìm thấy microphone hoặc camera.",
        "microphone.camera.not.readable": "Lỗi: Microphone hoặc camera không thể đọc được.",
        "microphone.camera.access.error": "Lỗi: Đã xảy ra lỗi không xác định khi truy cập vào microphone hoặc camera.",
        "media.not.recorded": "Lỗi: Không có phương tiện nào được ghi lại.",
        "upload.failed": "Lỗi: Tải lên không thành công.",
        "upload.success": "Thành công: Tải lên đã hoàn tất thành công.",
        "upload.in.progress": "Đang tải lên...",
        "upload.button": "Tải lên bản ghi",
        "stop.recording": "Dừng ghi âm",
        "record.audio": "Ghi âm âm thanh",
        "record.audio.video": "Ghi âm âm thanh với video",
        "record.again": "Ghi âm lại",
        "episode.language": "Chọn ngôn ngữ tập phim"
      },
      "selectBox": {
        "language.english": "Tiếng Anh",
        "language.arabic": "Tiếng Ả Rập",
        "language.bulgarian": "Tiếng Bulgaria",
        "language.catalan": "Tiếng Catalan",
        "language.croatian": "Tiếng Croatia",
        "language.czech": "Tiếng Séc",
        "language.danish": "Tiếng Đan Mạch",
        "language.dutch": "Tiếng Hà Lan",
        "language.finnish": "Tiếng Phần Lan",
        "language.french": "Tiếng Pháp",
        "language.german": "Tiếng Đức",
        "language.greek": "Tiếng Hy Lạp",
        "language.hindi": "Tiếng Hindi",
        "language.hungarian": "Tiếng Hungary",
        "language.indonesian": "Tiếng Indonesia",
        "language.italian": "Tiếng Ý",
        "language.japanese": "Tiếng Nhật",
        "language.korean": "Tiếng Hàn",
        "language.lithuanian": "Tiếng Litva",
        "language.latvian": "Tiếng Latvia",
        "language.malay": "Tiếng Mã Lai",
        "language.mandarin": "Tiếng Quan Thoại",
        "language.norwegian": "Tiếng Na Uy",
        "language.polish": "Tiếng Ba Lan",
        "language.portuguese": "Tiếng Bồ Đào Nha",
        "language.romanian": "Tiếng Rumani",
        "language.russian": "Tiếng Nga",
        "language.slovak": "Tiếng Slovakia",
        "language.slovenian": "Tiếng Slovenia",
        "language.spanish": "Tiếng Tây Ban Nha",
        "language.swedish": "Tiếng Thụy Điển",
        "language.tamil": "Tiếng Tamil",
        "language.turkish": "Tiếng Thổ Nhĩ Kỳ",
        "language.ukrainian": "Tiếng Ukraina",
        "language.bashkir": "Tiếng Bashkir",
        "language.basque": "Tiếng Basque",
        "language.belarusian": "Tiếng Belarus",
        "language.cantonese": "Tiếng Quảng Đông",
        "language.esperanto": "Tiếng Esperanto",
        "language.estonian": "Tiếng Estonia",
        "language.galician": "Tiếng Galician",
        "language.interlingua": "Tiếng Interlingua",
        "language.marathi": "Tiếng Marathi",
        "language.mongolian": "Tiếng Mông Cổ",
        "language.persian": "Tiếng Ba Tư",
        "language.thai": "Tiếng Thái",
        "language.uyghur": "Tiếng Uighur",
        "language.vietnamese": "Tiếng Việt",
        "language.welsh": "Tiếng Wales"
      },
      "selectedepisode": {
        "processing.episode": "Đang xử lý tập phim",
        "processing.time": "Thường mất từ 5 - 10 phút",
        "email.notification": "Bạn có thể đóng cửa sổ này. Chúng tôi sẽ gửi cho bạn một email khi nó sẵn sàng. Nội dung của bạn cũng sẽ có sẵn trên bảng điều khiển của bạn.",
        "convert.another.episode": "Chuyển đổi tập phim khác",
        "technical.difficulties": "Ôi! Chúng tôi đang gặp một số khó khăn kỹ thuật. Xin yên tâm, đội ngũ của chúng tôi đang xử lý! Vui lòng thử lại sau.",
        "no.discount": "Đừng lo, chúng tôi sẽ không giảm bất kỳ phút nào!",
        "high.demand": "Chúng tôi đang trải qua nhu cầu cao hơn bình thường, vì vậy có thể mất nhiều thời gian hơn để xử lý yêu cầu của bạn. Chúng tôi xin lỗi vì sự bất tiện này!",
        "email.ready": "Chúng tôi sẽ gửi cho bạn một email khi nó sẵn sàng. Bạn cũng có thể truy cập kết quả của mình trên bảng điều khiển.",
        "select.podcast.folder": "Chọn thư mục podcast mà tập phim này thuộc về, hoặc tạo một thư mục mới bằng cách nhập tên.",
        "give.voice": "Tùy chỉnh giọng nói của thư mục",
        "generate.content": "Tạo nội dung",
        "not.enough.minutes.title": "Bạn không có đủ phút",
        "not.enough.minutes.message": "Bạn không có đủ phút để chuyển đổi tập phim này. Vui lòng cập nhật kế hoạch của bạn.",
        "upgrade.plan": "Cập nhật kế hoạch của tôi",
        "convert.shorter.episode": "Chuyển đổi tập phim ngắn hơn",
        "content.ready": "Nội dung của bạn đã sẵn sàng!",
        "ask.ai.tune": "Bạn vẫn có thể yêu cầu AI điều chỉnh từng nội dung để phù hợp hơn với nhu cầu của bạn.",
        "error.title": "Lỗi",
        "convert.another.file": "Chuyển đổi tập tin khác"
      },
      "submitfile": {
        "file.size.exceeded.free": "Kích thước tệp vượt quá giới hạn tối đa là 4 GB. <p>Vui lòng <a href='/pricing'><b><u>nâng cấp để tải lên tệp lớn hơn</u></b></a></p>",
        "file.size.exceeded.paid": "Kích thước tệp vượt quá giới hạn tối đa là 10 GB. <p>Vui lòng chọn một tệp nhỏ hơn.</p>",
        "file.upload.invalid": "Vui lòng tải lên tệp âm thanh hoặc video",
        "upload.in.progress": "Đang tải tệp. Vui lòng không đóng cửa sổ này.",
        "upload.button": "Tải lên & Tạo",
        "close.button": "Đóng",
        "upgrade.message.free": "Nhiều lần tải lên chỉ có sẵn cho các gói trả phí.",
        "upgrade.now.button": "Nâng cấp ngay",
        "pricing.info": "bắt đầu từ 12 đô la/tháng",
        "upload.file.label": "Tải lên tệp âm thanh hoặc video",
        "max.file.size.free": "(tối đa 4 gb)",
        "max.file.size.paid": "(tối đa 10 gb)",
        "podsqueeze.audiograms.info": "Podsqueeze sẽ tạo ra các audiogram cho tệp âm thanh và các đoạn ngắn cho tệp video",
        "file.placeholder": "Tệp MP3/WAV của bạn",
        "episode.language.label": "Ngôn ngữ tập",
        "select.folder.label": "Chọn hoặc tạo thư mục",
        "multiple.files.selected": "Đã chọn {{count}} tệp",
        "clear.all": "Xóa tất cả",
        "file.name": "{{name}}",
        "multiple.files.toggle": "Chọn nhiều tệp",
        "file.upload.error": "Lỗi tải lên tệp",
        "file.upload.success": "Tải lên tệp thành công",
        "file.upload.processing": "Đang xử lý tệp",
        "click.to.upload": "Nhấp để tải lên",
        "click.to.upload.multiple": "Nhấp để tải lên nhiều tệp",
        "enter.url": "Nhập URL",
        "upload.file": "Tải lên tệp",
        "media.url.label": "URL phương tiện",
        "media.url.help": "Nhập URL của tệp âm thanh hoặc video của bạn. Chúng tôi sẽ tải xuống và xử lý nó cho bạn.",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "Tên tập",
        "url.input.required": "Vui lòng nhập URL phương tiện",
        "url.upload.error": "Không thể tải lên phương tiện từ URL. Vui lòng kiểm tra URL và thử lại.",
        "supported.formats": "Định dạng được hỗ trợ",
        "uploading": "Đang tải lên...",
        "media.url.requirements": "URL phải là liên kết trực tiếp đến tệp phương tiện công khai (không phải trang web)"
      },
      "submitrssid": {
        "error.selectRss": "Vui lòng chọn một RSS hợp lệ từ danh sách thả xuống",
        "label.insertRssFeed": "Chèn RSS Feed của bạn",
        "placeholder.insertRssFeed": "Chèn RSS Feed của bạn",
        "label.searchByPodcast": "Tìm kiếm theo tên podcast thay vào đó",
        "label.searchForPodcast": "Tìm kiếm tên podcast của bạn",
        "placeholder.searchForPodcast": "Tìm kiếm một podcast",
        "label.cantFindPodcast": "Không tìm thấy podcast của bạn? ",
        "label.clickHereUseRss": "Nhấp vào đây để sử dụng RSS feed của bạn thay vào đó",
        "label.selectedPodcast": "Podcast đã chọn",
        "label.episodeLanguage": "Ngôn ngữ tập",
        "button.seeAllEpisodes": "Xem tất cả các tập",
        "select.folder.label": "Chọn hoặc tạo thư mục"
      },
      "submitsection": {
        "search.podcast": "Tìm kiếm Podcast của bạn",
        "upload.audio.video": "Tải lên Âm thanh hoặc Video",
        "record.audio": "Ghi âm",
        "youtube.video": "Liên kết YouTube",
        "create.content": "Hãy cùng tạo nội dung cho podcast của bạn!"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "Nhập URL video YouTube",
        "error.insertYouTubeUrl": "Vui lòng nhập một URL YouTube.",
        "label.insertYouTubeUrl": "Chèn URL YouTube",
        "button.loading": "Đang tải...",
        "message.downloadingFile": "Đang tải tệp...",
        "error.processingFailed": "Lỗi: Xử lý video thất bại.",
        "error.youtubeVideoNotAvailable": "Video YouTube này không khả dụng cho tải xuống. Vui lòng tải trực tiếp âm thanh hoặc video lên Podsqueeze hoặc sử dụng YouTube downloader trước.",
        "button.submitYouTubeVideo": "Gửi video YouTube",
        "episode.language.label": "Ngôn ngữ sử dụng",
        "select.folder.label": "Chọn hoặc tạo thư mục"
      },
      "tabs": {
        "tab.label.tab1": "Tab 1",
        "tab.label.tab2": "Tab 2",
        "tab.label.tab3": "Tab 3"
      },
      "tutorialVideo": {
        "tutorial.title": "Tận Dụng Tối Đa Podsqueeze",
        "tutorial.chapter.introduction": "Giới thiệu",
        "tutorial.chapter.bestShowNotes": "Nhận ghi chú chương trình và thời gian tốt nhất",
        "tutorial.chapter.blogPosts": "Sử dụng bài viết blog và bản tin",
        "tutorial.chapter.editingTranscripts": "Nhúng và chỉnh sửa bản ghi",
        "tutorial.chapter.personalizingAI": "Cá nhân hóa AI và Đưa Giọng Nói Của Bạn Vào",
        "tutorial.chapter.speedingUpNotes": "Tăng Tốc Ghi Chú Chương Trình",
        "tutorial.chapter.creatingClips": "Tạo video clip và hình ảnh",
        "tutorial.chapter.generatingLandingPage": "Tạo trang đích",
        "tutorial.chapter.shareResults": "Chia Sẻ Kết Quả Với Nhóm Của Bạn",
        "tutorial.closeVideoCheckbox": "Đóng video khi kết quả đầu tiên đã sẵn sàng"
      },
      "uploadloadingbar": {
        "upload.loading": "Đang tải..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "Liên hệ với chúng tôi",
        "contact.section.email": "Gửi email cho chúng tôi tại support@podsqueeze.com",
        "contact.section.tiago.role": "Người đồng sáng lập",
        "contact.section.joao.role": "Người đồng sáng lập",
        "contact.section.image.alt.sendMessage": "Gửi tin nhắn",
        "contact.section.image.alt.tiago": "Người đồng sáng lập Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Người đồng sáng lập Podsqueeze João"
      },
      "contactsection": {
        "contact.section.title": "Liên hệ với chúng tôi",
        "contact.section.email": "Gửi email cho chúng tôi tại support@podsqueeze.com",
        "contact.section.tiago.role": "Người đồng sáng lập",
        "contact.section.joao.role": "Người đồng sáng lập",
        "contact.section.image.alt.sendMessage": "Gửi tin nhắn",
        "contact.section.image.alt.tiago": "Người đồng sáng lập Podsqueeze Tiago",
        "contact.section.image.alt.joao": "Người đồng sáng lập Podsqueeze João"
      },
      "home-agenciessection": {
        "join.content.creators": "Tham gia cùng 20.000 nhà sáng tạo nội dung và chuyên gia podcast đang sử dụng Podsqueeze",
        "content.creators": "Nhà Sáng Tạo Nội Dung",
        "podcast.managers": "Quản Lý Podcast",
        "producers.studios": "Nhà Sản Xuất & Studio",
        "for.podcasters": "DÀNH CHO CÁC PODCASTER, QUẢN LÝ PODCAST VÀ CÁC ĐẠI LÝ",
        "manage.content.creation": "Quản lý việc tạo nội dung một cách dễ dàng cho",
        "multiple.podcasts": "nhiều podcast",
        "podsqueeze.description": "Podsqueeze là một công cụ mạnh mẽ cho tất cả các chuyên gia podcast. Dù bạn là một podcaster độc lập, quản lý podcast hay đại lý, Podsqueeze cung cấp tất cả các tính năng bạn cần để tối ưu hóa quy trình tạo nội dung podcast của mình.",
        "create.podcast.folders": "Tạo thư mục podcast để giữ cho các tập của bạn được tổ chức.",
        "share.content.page": "Dễ dàng chia sẻ trang nội dung của bạn với khách hàng và đội ngũ",
        "tune.ai.voice": "Điều chỉnh giọng nói AI cho mỗi chương trình bạn quản lý",
        "plan.content.episodes": "Lập kế hoạch nội dung cho các tập tiếp theo với",
        "podcast.topics.finder": "công cụ tìm kiếm chủ đề podcast tiên tiến của chúng tôi",
        "podsqueeze.testimonial": "Khả năng của Podsqueeze trong việc sử dụng các gợi ý để điều chỉnh nội dung của từng podcast mà chúng tôi quản lý và lưu trữ cho các tập sau, cho phép chúng tôi giữ cho giọng điệu của mỗi chương trình nhất quán. Đây là một tính năng ưu việt mà chúng tôi không thể tìm thấy trong bất kỳ công cụ nào khác.",
        "coo.podigy": "COO tại Podigy Podcasts",
        "agenciessection.joinCreators": "Tham gia cùng 20.000 nhà sáng tạo nội dung và chuyên gia podcast đang sử dụng Podsqueeze",
        "agenciessection.contentCreators": "Nhà Sáng Tạo Nội Dung",
        "agenciessection.podcastManagers": "Quản Lý Podcast",
        "agenciessection.producersStudios": "Nhà Sản Xuất & Studio",
        "agenciessection.forPodcasters": "DÀNH CHO CÁC PODCASTER, QUẢN LÝ PODCAST VÀ CÁC ĐẠI LÝ",
        "agenciessection.manageContent": "Quản lý việc tạo nội dung một cách dễ dàng cho",
        "agenciessection.multiplePodcasts": "nhiều podcast",
        "agenciessection.podsqueezeDescription": "Podsqueeze là một công cụ mạnh mẽ cho tất cả các chuyên gia podcast. Dù bạn là một podcaster độc lập, quản lý podcast hay đại lý, Podsqueeze cung cấp tất cả các tính năng bạn cần để tối ưu hóa quy trình tạo nội dung podcast của mình.",
        "agenciessection.createPodcastFolders": "Tạo thư mục podcast để giữ cho các tập của bạn được tổ chức.",
        "agenciessection.shareContent": "Dễ dàng chia sẻ trang nội dung của bạn với khách hàng và đội ngũ",
        "agenciessection.tuneAI": "Điều chỉnh giọng nói AI cho mỗi chương trình bạn quản lý",
        "agenciessection.planContent": "Lập kế hoạch nội dung cho các tập tiếp theo với",
        "agenciessection.podcastTopicsFinder": "công cụ tìm kiếm chủ đề podcast tiên tiến của chúng tôi",
        "agenciessection.podsqueezeQuote": "Khả năng của Podsqueeze trong việc sử dụng các gợi ý để điều chỉnh nội dung của từng podcast mà chúng tôi quản lý và lưu trữ cho các tập sau, cho phép chúng tôi giữ cho giọng điệu của mỗi chương trình nhất quán. Đây là một tính năng ưu việt mà chúng tôi không thể tìm thấy trong bất kỳ công cụ nào khác.",
        "agenciessection.coO": "COO tại Podigy Podcasts"
      },
      "home-audioeditsection": {
        "new.feature": "TÍNH NĂNG MỚI",
        "seamless.editing": "Chỉnh sửa liền mạch và cải thiện âm thanh cho tự nhiên, ",
        "high.quality.results": " kết quả chất lượng cao",
        "experience.seamless.audio.editing": "Trải nghiệm chỉnh sửa âm thanh liền mạch với các thuật toán AI tiên tiến cho các bản ghi âm hàng đầu. ",
        "remove.ums": "Xóa âm thanh ậm ừ",
        "enhance.sound.quality": ", khoảng lặng, và cải thiện chất lượng âm thanh chỉ với một cú nhấp chuột.",
        "enhance.audio.now": "Cải thiện Âm Thanh Ngay",
        "sample.audio.recorded": "Mẫu âm thanh, được ghi trực tiếp từ điện thoại.",
        "original.recording": "Bản ghi gốc",
        "audio.after.ai.edit": "Âm thanh sau khi chỉnh sửa và cải thiện bằng AI",
        "experience.audio.editing": "Trải nghiệm chỉnh sửa âm thanh liền mạch với các thuật toán AI tiên tiến cho các bản ghi âm hàng đầu. "
      },
      "home-blogsection": {
        "more.resources.label": "TÀI NGUYÊN THÊM CHO PODCAST CỦA BẠN",
        "learn.how.to.get.most": "Tìm hiểu cách tận dụng tối đa",
        "your.content": "nội dung của bạn",
        "get.most.out.of.ai.content": "Tận Dụng Tối Đa Nội Dung Được Tạo Ra Bởi AI Cho Podcast Của Bạn",
        "welcome.to.podsqueeze": "Chào mừng bạn đến với Podsqueeze – cách đơn giản nhất để chuyển đổi podcast của bạn thành nội dung hấp dẫn...",
        "will.google.penalize.ai.content": "Liệu Google có phạt nội dung được tạo ra bởi AI của bạn không?",
        "ai.content.discussion": "Sự xuất hiện của nội dung được tạo ra bởi AI đã khơi dậy các cuộc thảo luận và lo ngại trong số các nhà sáng tạo nội dung, nhà tiếp thị và SEO...",
        "what.is.rss.feed": "RSS feed cho Podcast là gì và cách sử dụng nó",
        "rss.feed.benefits": "Là một podcaster, bạn có thể đã nghe đến thuật ngữ 'RSS feed' trước đây, nhưng có thể bạn không biết chính xác nó là gì hoặc nó có thể mang lại lợi ích như thế nào...",
        "visit.blog": "Truy cập Blog"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "CLIP & AUDIOGRAM",
        "clipsAndAudiograms.subtitle": "Biến podcast của bạn thành clip một cách dễ dàng",
        "clipsAndAudiograms.description": "Chỉ cần chọn một chương từ tập của bạn và xuất nó dưới dạng clip hoặc audiogram cho TikTok, Instagram và Youtube Shorts. Chọn một mẫu và điều chỉnh theo phong cách của riêng bạn.",
        "clipsAndAudiograms.createClips": "Tạo Clip Ngay",
        "textEditor.title": "Trình chỉnh sửa dựa trên văn bản",
        "textEditor.description": "Tinh chỉnh clip và audiogram của bạn trực tiếp từ phụ đề. Chỉnh sửa phụ đề và cắt video của bạn bằng cách loại bỏ các từ cụ thể.",
        "oneClickShorts.title": "Shorts một cú nhấp (<60s)",
        "oneClickShorts.description": "Để AI xử lý việc chỉnh sửa cho bạn. Chỉ với một nút bấm, AI sẽ rút ngắn mỗi chương của tập phim của bạn xuống dưới 60 giây, sẵn sàng để đăng dưới dạng YouTube Short hoặc clip TikTok."
      },
      "home-conatctsection": {
        "contact.section.title": "Liên hệ với những người sáng lập",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- Nhà phát triển & Người làm podcast",
        "contact.section.joao.role": "- Nhà thiết kế UX/UI"
      },
      "home-contentexplanation": {
        "wide.variety.content": "NHIỀU LOẠI NỘI DUNG",
        "generate.content": "Tạo nội dung với",
        "one.click": " một cú nhấp chuột!",
        "transcript.srt": "Bản ghi & SRT",
        "transcript.description": "Nhận bản ghi đầy đủ của tập podcast của bạn, cùng với tệp SRT sẵn sàng để tạo phụ đề và chú thích.",
        "show.notes": "Ghi chú chương trình",
        "show.notes.description": "Tóm tắt các chủ đề chính được đề cập trong tập của bạn và làm cho nó dễ tìm kiếm hơn",
        "timestamps": "Thời gian",
        "timestamps.description": "Tạo các chương với thời gian và hướng dẫn người nghe đến các đoạn cụ thể trong tập podcast của bạn",
        "blog.social.posts": "Bài viết Blog & Mạng xã hội",
        "blog.social.posts.description": "Đăng về tập podcast của bạn ở khắp mọi nơi và thu hút người nghe mới",
        "newsletter": "Bản tin",
        "newsletter.description": "Giữ cho người nghe của bạn cập nhật với các tập mới",
        "titles.more": "Tiêu đề & nhiều hơn nữa!",
        "titles.more.description": "Tạo tiêu đề hấp dẫn, trích dẫn, điểm chính, từ khóa và nhiều hơn nữa!",
        "see.sample.content": "XEM NỘI DUNG MẪU",
        "wannabe.entrepreneur": "Doanh nhân tương lai - #299 Podsqueeze vừa đạt 100.000 đô la doanh thu hàng năm!",
        "making.space": "Tạo không gian - Steve Harvey: “Bạn có thể tiếp tục”",
        "modern.wisdom": "Tri thức hiện đại - Erik Hoel - Hướng dẫn về Bí ẩn Cơ bản của Tâm trí"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "Đường phân cách"
      },
      "home-explanationsection": {
        "fast.accurate": "NHANH CHÓNG VÀ CHÍNH XÁC",
        "generate.content": "Tạo nội dung cho podcast của bạn với",
        "power.of.ai": "sức mạnh của AI",
        "upload.image.alt": "tải lên hình ảnh",
        "select.episode": "Chọn một tập từ nguồn cấp RSS của bạn hoặc tải lên tệp âm thanh/video",
        "paste.rss.feed": "Chỉ cần dán URL nguồn cấp RSS của bạn để chọn một tập từ danh sách hoặc tải lên tệp âm thanh hoặc video.",
        "content.image.alt": "hình ảnh nội dung",
        "one.click.content": "Nhận tất cả nội dung chỉ với một cú nhấp chuột!",
        "user.friendly.interface": "Giao diện trực quan và thân thiện với người dùng mà bạn có thể bắt đầu sử dụng ngay lập tức. Tạo nội dung cho podcast của bạn chỉ với một cú nhấp chuột.",
        "tune.image.alt": "hình ảnh điều chỉnh",
        "edit.fine.tune": "Chỉnh sửa và tinh chỉnh từng nội dung",
        "direct.edit.content": "Chỉnh sửa trực tiếp và tinh chỉnh từng nội dung theo sở thích của bạn với AI. Ví dụ, bạn có thể yêu cầu một giọng điệu cụ thể, lời nói trực tiếp hoặc gián tiếp hoặc đơn giản là sửa các tên viết sai.",
        "multiple.language.support": "Hỗ trợ nhiều ngôn ngữ",
        "language.flags.alt": "cờ ngôn ngữ",
        "generate.content.aria": "Tạo nội dung"
      },
      "home-featuressection": {
        "loading": "Đang tải...",
        "transcribe.write.show.notes": "Chuyển đổi và viết ghi chú cho podcast của bạn",
        "twenty.times.faster": "Nhanh gấp 20 lần",
        "save.manual.work": "Tiết kiệm tới 100% công việc thủ công. Tự động chuyển đổi podcast của bạn với độ chính xác hàng đầu và phân loại người nói, và tạo ra ghi chú hoàn chỉnh và bài đăng trên mạng xã hội bằng giọng nói của bạn.",
        "generate.content": "Tạo nội dung",
        "transcripts": "Bản sao",
        "full.transcript": "Nhận bản sao đầy đủ của các tập podcast và bản sao video YouTube của bạn, cùng với tệp SRT cho phụ đề.",
        "show.notes": "Ghi chú chương trình",
        "summarize.generate.show.notes": "Tóm tắt và tạo ghi chú chương trình bằng giọng nói của bạn, đầy đủ với thời gian, điểm chính và đề cập.",
        "blog.newsletter": "Blog và Bản tin",
        "actionable.blog.posts": "Nhận các bài viết blog có thể hành động về các tập của bạn và bản tin sẵn sàng gửi với những điểm chính.",
        "social.media": "Mạng xã hội",
        "short.posts.insights": "Nhận các bài đăng ngắn và thông tin nhỏ để lan tỏa trên mạng xã hội.",
        "quote": "Trong số tất cả các công cụ chuyển đổi AI tốt nhất mà chúng tôi đã thử nghiệm, Podsqueeze đã tạo ra các đầu ra hữu ích nhất cho Ghi chú chương trình, Thời gian, Tiêu đề, Đề cập, Mẫu bài viết blog và Trích dẫn chính.",
        "justin.jackson": "Justin Jackson",
        "cofounder.transistor": "Người đồng sáng lập Transistor.fm",
        "transcribe_and_write_show_notes": "Bản ghi chép podcast, tóm tắt và bài đăng trên mạng xã hội",
        "twenty_times_faster": "Nhanh gấp 20 lần",
        "save_manual_work": "Tiết kiệm tới 100% công việc thủ công. Tự động chuyển đổi podcast của bạn với độ chính xác hàng đầu và phân loại người nói, và tạo ra ghi chú hoàn chỉnh và bài đăng trên mạng xã hội bằng giọng nói của bạn.",
        "generate_content": "Tạo nội dung",
        "full_transcript": "Nhận bản sao đầy đủ của các tập podcast và bản sao video YouTube của bạn, cùng với tệp SRT cho phụ đề.",
        "show_notes": "Ghi chú chương trình",
        "summarize_and_generate_show_notes": "Tóm tắt và tạo ghi chú chương trình bằng giọng nói của bạn, đầy đủ với thời gian, điểm chính và đề cập.",
        "blog_and_newsletter": "Blog và Bản tin",
        "actionable_blog_posts": "Nhận các bài viết blog có thể hành động về các tập của bạn và bản tin sẵn sàng gửi với những điểm chính.",
        "social_media": "Mạng xã hội",
        "short_posts_and_insights": "Nhận các bài đăng ngắn và thông tin nhỏ để lan tỏa trên mạng xã hội.",
        "testimonial": "Trong số tất cả các công cụ chuyển đổi AI tốt nhất mà chúng tôi đã thử nghiệm, Podsqueeze đã tạo ra các đầu ra hữu ích nhất cho Ghi chú chương trình, Thời gian, Tiêu đề, Đề cập, Mẫu bài viết blog và Trích dẫn chính.",
        "cofounder_transistor": "Người đồng sáng lập Transistor.fm"
      },
      "home-page": {
        "main.background": "Màu nền cho thành phần chính"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "NGHE PODCAST CỦA CHÚNG TÔI",
        "podcast.section.subtitle": "Các lớp học từ",
        "podcast.section.highlight": "những Podcaster có kinh nghiệm",
        "podcast.section.description": "Nghe podcast của chúng tôi, nơi chúng tôi phỏng vấn những podcaster có kinh nghiệm và người dùng Podsqueeze từ khắp nơi trên thế giới. Chúng tôi yêu cầu họ chia sẻ mẹo, hiểu biết, câu chuyện và mọi thứ bạn cần biết để phát triển podcast của riêng mình.",
        "podcast.link.spotify": "Nghe trên Spotify",
        "podcast.link.apple": "Nghe trên Apple Podcasts",
        "podcast.link.youtube": "Nghe trên YouTube"
      },
      "home-spinner": {
        "spinner.loading": "Đang tải..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "Tự động hóa podcast của bạn",
        "tagline.productionPromotion": "Sản xuất & Quảng bá",
        "tagline.launchGrow": "Dễ dàng ra mắt và phát triển podcast âm thanh hoặc video của bạn với mọi thứ bạn cần trong một nơi, với sự trợ giúp của AI.",
        "tagline.uploadGenerate": "Dễ dàng tạo bản ghi podcast, tóm tắt nội dung, clip ngắn có phụ đề và nhiều hơn nữa!",
        "tagline.singleClick": "tất cả chỉ với một cú nhấp chuột.",
        "tagline.transcripts": "Bản ghi podcast",
        "tagline.showNotes": "Ghi chú chương trình",
        "tagline.newslettersBlogs": "Bản tin & Blog",
        "tagline.socialPosts": "Bài đăng trên mạng xã hội",
        "tagline.shortClipsAudiograms": "Clip ngắn & Audiogram",
        "tagline.podcastWebsite": "Trang web podcast",
        "tagline.aiAudioEnhancement": "Cải thiện âm thanh bằng AI",
        "tagline.removeSilences": "Loại bỏ khoảng lặng và âm thanh ậm ừ",
        "tagline.generateNow": "Tạo ngay bây giờ miễn phí",
        "tagline.noCreditCard": "Không cần thẻ tín dụng",
        "testimonial.robWalling.title": "Rob Walling, Nhân vật Khởi nghiệp",
        "testimonial.robWalling.subtitle": "Podcast Khởi nghiệp cho Chúng ta",
        "testimonial.robWalling.quote": "Ghi chú chương trình của Podsqueeze là tốt nhất. Chúng tôi sử dụng nó rất nhiều để tóm tắt và lấy thông tin từ các podcast khác.",
        "testimonial.johnGarmet.title": "John Garmet, Giám đốc Vận hành",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze giúp chúng tôi làm việc hiệu quả hơn và tạo ra nhiều nội dung hơn cho khách hàng của chúng tôi. Chúng tôi rất khuyến nghị nó.",
        "testimonial.davidJackson.title": "David Jackson, Huấn luyện viên Podcast",
        "testimonial.davidJackson.subtitle": "Trường Podcasting",
        "testimonial.davidJackson.quote": "Podsqueeze là đối tác động não của tôi. Đây là cách tốt nhất để nghĩ ra chiến lược marketing cho podcast."
      },
      "home-testimonials": {
        "testimonials.title": "Mọi người đang nói gì về Podsqueeze",
        "testimonials.image.alt": "Podsqueeze - Tái sử dụng nội dung podcast của bạn bằng AI | Product Hunt",
        "testimonials.heading": "Mọi người đang nói gì về Podsqueeze"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "Mật khẩu không chính xác",
        "error.userNotFound": "Không tìm thấy người dùng",
        "error.somethingWentWrong": "Ôi, có điều gì đó không đúng",
        "button.sendResetEmail": "Gửi Email Đặt Lại",
        "button.login": "Đăng Nhập",
        "placeholder.email": "Địa chỉ E-mail",
        "placeholder.password": "Mật khẩu",
        "link.forgotPassword": "Quên mật khẩu?",
        "link.createAccount": "Tạo Tài Khoản",
        "text.or": "HOẶC",
        "button.continueWithGoogle": "Tiếp Tục Với Google",
        "text.podcastDescription": "Khởi động và phát triển podcast âm thanh hoặc video của bạn một cách dễ dàng với mọi thứ bạn cần trong một nơi.",
        "feature.transcripts": "Bản sao",
        "feature.showNotes": "Ghi chú",
        "feature.newslettersAndBlogs": "Bản tin & Blog",
        "feature.socialPosts": "Bài đăng trên mạng xã hội",
        "feature.shortClipsAndAudiograms": "Clip ngắn & Audiogram",
        "feature.podcastWebsite": "Trang web Podcast",
        "feature.aiAudioEnhancement": "Cải thiện Âm thanh AI",
        "feature.removeSilences": "Xóa im lặng và âm thanh ậm ừ",
        "button.sendVerificationEmail": "Gửi email xác minh",
        "error.emailNotVerified": "Email không được xác minh",
        "text.pleaseVerifyAccount": "Xác minh tài khoản của bạn",
        "text.checkSpamFolder": "Chúng tôi đã gửi email xác minh cho bạn. Vui lòng kiểm tra hộp thư và thư mục thư rác của bạn.",
        "button.resendVerificationEmail": "Gửi email xác minh lại",
        "error.verificationEmailFailed": "Lỗi khi gửi email xác minh. Vui lòng thử lại."
      },
      "page": {
        "login.form": "Biểu mẫu Đăng nhập"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Trang Đối Tác Podsqueeze",
        "affiliate.page.description": "Kiếm 25% hoa hồng trên mỗi đơn hàng được thực hiện qua liên kết giới thiệu độc quyền của bạn trong vòng 15 tháng. Chia sẻ liên kết của bạn trên trang web, mạng xã hội hoặc với bạn bè. Tham gia chỉ mất vài giây. Được phê duyệt tự động."
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "Món Quà Tốt Nhất Dành Cho Người Làm Podcast",
        "bestGiftForPodcaster.description": "Khám phá những món quà tốt nhất cho người làm podcast để nâng cao trải nghiệm của họ.",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "Tăng lượng người nghe podcast",
        "get-more-podcast-listeners.description": "Tăng lượng người nghe podcast và tối ưu hóa quy trình sản xuất với ghi chú chương trình tự động, các đoạn clip ngắn để phát triển chương trình của bạn trên mạng xã hội và nhiều hơn nữa."
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "Mở Rộng Khán Giả Podcast Của Bạn",
        "grow_your_podcast_audience.description": "Tiết kiệm rất nhiều thời gian và mở rộng khán giả podcast của bạn với Podsqueeze. Tạo ghi chú chương trình hoàn chỉnh, bài đăng trên mạng xã hội, clip ngắn và nhiều hơn nữa cho podcast của bạn."
      },
      "index": {
        "home.page.title": "Ghi chú chương trình Podcast AI, Biên bản, Tóm tắt và Công cụ tạo Clip.",
        "home.page.description": "Tạo ghi chú, thời gian, bản tin và nhiều hơn nữa cho podcast của bạn chỉ với một cú nhấp chuột! Nhanh chóng tạo nội dung cho podcast của bạn và điều chỉnh theo nhu cầu của bạn. Đăng ký miễn phí."
      },
      "login": {
        "login.tryItNow": "Thử ngay!",
        "login.createAccountDescription": "Tạo một tài khoản và bắt đầu tạo ghi chú, thời gian, bản tin và nhiều hơn nữa cho podcast của bạn chỉ với một cú nhấp chuột! Nhanh chóng tạo nội dung cho podcast của bạn và điều chỉnh theo nhu cầu của bạn. Đăng ký miễn phí."
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "Tiếp thị cho Podcast",
        "marketing.for.podcasts.description": "Podsqueeze đơn giản hóa việc tiếp thị cho podcast với ghi chú chương trình tự động, bài đăng trên mạng xã hội và clip ngắn để tăng cường phạm vi tiếp cận và phát triển chương trình của bạn."
      },
      "media": {
        "media.page.title": "Trang Media Podsqueeze",
        "media.page.description": "Tìm hiểu thêm về Podsqueeze. Liên hệ với chúng tôi! Chúng tôi rất mong được hợp tác!"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "Trình Tạo Mô Tả Podcast",
        "podcast.description.generator.description": "Cải thiện khả năng tiếp cận và sự tương tác của podcast của bạn với các mô tả được tạo ra bởi AI. Tự động hóa việc viết Ghi Chú Chương Trình và lấy lại thời gian quý giá."
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "Chuyển đổi podcast của bạn thành các bài đăng trên mạng xã hội",
        "convert.podcast.episodes.to.social.media.posts": "Chuyển đổi các tập podcast thành các bài đăng trên mạng xã hội. Tự động tạo bài đăng cho LinkedIn, Twitter, Facebook và các clip ngắn cho TikTok."
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "Công Cụ Tạo Chủ Đề Podcast Miễn Phí",
        "podcast.topics.generator.description": "Công cụ tạo chủ đề podcast miễn phí của chúng tôi giúp bạn tìm ra những ý tưởng chủ đề tốt nhất và dự đoán khả năng tiếp cận của chúng trên Google và YouTube."
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "Trợ lý Ảo Podcast của Bạn",
        "podcast.virtual.assistant.description": "Trợ lý ảo podcast AI viết ghi chú chương trình của bạn và tạo bài đăng trên mạng xã hội. Tối ưu hóa quy trình sản xuất và tiếp thị podcast của bạn với Podsqueeze."
      },
      "pricing": {
        "pricing.title": "Giá cả",
        "pricing.description": "Tạo ghi chú, thời gian, bản tin và nhiều hơn nữa cho podcast của bạn chỉ với một cú nhấp chuột! Chúng tôi có nhiều mức giá để phù hợp với nhu cầu podcast của bạn."
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "Quảng bá Podcast của bạn",
        "promote.your.podcast.description": "Tạo ghi chú chương trình, bài đăng trên mạng xã hội và clip ngắn để xuất bản và quảng bá podcast của bạn chỉ trong vài phút."
      },
      "register": {
        "create.podsqueeze.account": "Tạo tài khoản Podsqueeze",
        "generate.content.podcast": "Tạo ghi chú, thời gian, bản tin và nhiều hơn nữa cho podcast của bạn chỉ với một cú nhấp chuột! Nhanh chóng tạo nội dung cho podcast của bạn và điều chỉnh theo nhu cầu của bạn. Đăng ký miễn phí."
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "Tự động tái sử dụng nội dung podcast",
        "repurpose.your.podcast.content.with.ai": "Tái sử dụng nội dung podcast của bạn với AI. Tự động tạo ghi chú chương trình, tiêu đề, clip ngắn cho TikTok và nhiều hơn nữa, tất cả chỉ với một cú nhấp chuột!"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "Công Cụ Tối Ưu Hóa SEO Podcast MIỄN PHÍ",
        "seo.optimizer.description": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.selectEpisode": "Select an Episode to Analyze",
        "seo.optimizer.results": "SEO Analysis Results",
        "seo.optimizer.searchPodcastPlaceholder": "Search for a podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Search episodes...",
        "seo.optimizer.analyseAnotherEpisode": "Analyse Another Episode",
        "seo.optimizer.findingEpisodes": "Finding all episodes...",
        "seo.optimizer.analysingEpisode": "Analysing Episode",
        "seo.optimizer.scoreTooltip": "Score:",
        "seo.optimizer.topKeywords": "We identified these Top Keywords:",
        "seo.optimizer.topKeywordsnote": "Based on the keyword analysis at the bottom of the page.",
        "seo.optimizer.optimizedContent": "Based on keywords here are the optimized title and description:",
        "seo.optimizer.originalTitle": "Original Title",
        "seo.optimizer.optimizedTitle": "Optimized Title",
        "seo.optimizer.originalDescription": "Original Description",
        "seo.optimizer.optimizedDescription": "Optimized Description",
        "seo.optimizer.showMore": "Show More",
        "seo.optimizer.showLess": "Show Less",
        "seo.optimizer.keywordAnalysis": "Keyword Analysis",
        "seo.optimizer.keywordAnalysisnote": "Scores are calculated based on search volume, competition (how many other results are there for the same keyword), and in the case of youtube, the average number of views per video under the same keyword.",
        "seo.optimizer.seoScore": "SEO Score",
        "seo.optimizer.spotifyScore": "Spotify Score",
        "seo.optimizer.youtubeScore": "YouTube Score",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - Công cụ tạo nội dung podcast AI",
        "podsqueeze.description": "Tạo ghi chú, thời gian, bản tin và nhiều hơn nữa cho podcast của bạn chỉ với một cú nhấp chuột! Nhanh chóng tạo nội dung cho podcast của bạn và điều chỉnh theo nhu cầu của bạn. Đăng ký miễn phí."
      },
      "thumbnail-creator": {
        "title": "Trình Tạo Thumbnail Podcast Miễn Phí - Tạo Thumbnail Tập Phim Được Hỗ Trợ Bởi AI",
        "description": "Tạo các thumbnail podcast tuyệt đẹp bằng AI. Tạo ra những tác phẩm nghệ thuật tập phim chuyên nghiệp, bắt mắt giúp tăng khả năng hiển thị và thu hút nhiều người nghe hơn đến podcast của bạn.",
        "selectPodcast": "Chọn Podcast Của Bạn",
        "loadEpisodes": "Tải Tập Phim",
        "selectEpisode": "Chọn Tập Phim Để Tạo Thumbnail",
        "createThumbnail": "Tạo Thumbnail",
        "results": "Thumbnail Được Tạo Của Bạn",
        "download": "Tải Xuống",
        "share": "Chia Sẻ",
        "regenerate": "Tạo Lại",
        "editThumbnail": "Chỉnh Sửa Thumbnail",
        "editPlaceholder": "Mô tả cách bạn muốn chỉnh sửa thumbnail này...",
        "customPrompt": "Lời Nhắc Tùy Chỉnh",
        "yourThumbnail": "Thumbnail Của Bạn",
        "createAnother": "← Tạo Thumbnail Khác",
        "findingEpisodes": "Đang tìm tập phim...",
        "searchPodcastPlaceholder": "Tìm kiếm podcast của bạn...",
        "searchingPodcasts": "Đang tìm kiếm podcast...",
        "heroDescription": "Tạo ra những thumbnail podcast tuyệt đẹp và chuyên nghiệp với thiết kế được hỗ trợ bởi AI, thu hút sự chú ý và tăng khả năng hiển thị của các tập phim của bạn.",
        "generatedWithPrompt": "Được tạo với lời nhắc:",
        "customPromptPlaceholder": "Nhập lời nhắc tùy chỉnh cho việc tạo thumbnail...",
        "generating": "Đang tạo...",
        "generate": "Tạo",
        "modernMinimalist": "Hiện Đại & Tối Giản",
        "vibrantDynamic": "Sống Động & Năng Động",
        "professionalClean": "Chuyên Nghiệp & Sạch Sẽ",
        "generatingThumbnail": "Đang tạo thumbnail...",
        "generatingNewThumbnail": "Đang tạo thumbnail mới...",
        "showingFirstEpisodes": "Hiển thị 10 tập phim đầu tiên. Sử dụng tìm kiếm để tìm các tập phim cụ thể.",
        "imageUrlCopied": "URL hình ảnh đã được sao chép vào clipboard!",
        "failedToGenerate": "Không thể tạo thumbnail. Vui lòng thử lại.",
        "promotionalTitle": "Tạo Ghi Chú Chương Trình, Dấu Thời Gian, Clip Viral và Nhiều Hơn Nữa Với Podsqueeze",
        "promotionalSubtitle": "Tham gia cùng hơn 100K+ người tạo nội dung khác và bắt đầu phát triển chương trình của bạn",
        "startNow": "Bắt đầu ngay",
        "free": "MIỄN PHÍ",
        "podcast": "PODCAST",
        "thumbnail": "THUMBNAIL",
        "creator": "NGƯỜI TẠO",
        "replaceFace": "Thay Thế Khuôn Mặt",
        "uploading": "Đang tải lên...",
        "uploadImageError": "Vui lòng tải lên tệp hình ảnh.",
        "uploadFailedError": "Tải lên hình ảnh thất bại. Vui lòng thử lại.",
        "uploadingImage": "Đang tải lên hình ảnh...",
        "generatingNewThumbnailLoading": "Đang tạo thumbnail mới...",
        "failedToGenerateWithFace": "Tạo thumbnail với thay thế khuôn mặt thất bại. Vui lòng thử lại."
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "Đang tải tập...",
        "episodeList.noEpisodes": "Không có tập công khai nào",
        "episodeList.checkBack": "Quay lại sau để xem các tập mới",
        "episodeList.title": "Các tập của Podcast này",
        "episodeList.readLess": "THU GỌN",
        "episodeList.readMore": "XEM THÊM",
        "episodeList.coverImageAlt": "Ảnh bìa của {episodeTitle}"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "Bắt đầu",
        "alert.subscriptionRunning": "Gói đăng ký hiện tại của bạn vẫn đang hoạt động.\n\nVui lòng hủy gói đăng ký hiện tại trước khi mua gói mới.",
        "alert.subscriptionEnds": "Gói đăng ký hiện tại của bạn vẫn đang hoạt động.\n\nNó sẽ kết thúc vào {date}",
        "alert.subscriptionCancelled": "Gói đăng ký của bạn đã bị hủy và sẽ kết thúc vào {date}",
        "button.openDashboard": "Mở Bảng điều khiển",
        "button.signUp": "Đăng ký",
        "button.buySubscription": "Mua Gói đăng ký",
        "button.cancelled": "Đã hủy",
        "button.cancelSubscription": "Hủy Gói đăng ký",
        "button.upgradeSubscription": "Nâng cấp Gói đăng ký",
        "button.loading": "Đang tải",
        "upgrade.details.currentMinutes": "Điều này sẽ bắt đầu một giai đoạn đăng ký mới. Bạn sẽ giữ lại tất cả phút hiện tại của mình.",
        "upgrade.details.remainingAnnual": "Giá trị này được tính toán dựa trên thời gian còn lại trong gói đăng ký hàng năm hiện tại của bạn."
      },
      "page": {
        "pricing.free.title": "Miễn phí",
        "pricing.free.subtitle": "Thử nghiệm Podsqueeze. Không cần thẻ tín dụng.",
        "pricing.free.price.annual": "$0 Thanh toán hàng năm",
        "pricing.free.features.podcast_time": "30 phút thời gian podcast mỗi tháng",
        "pricing.free.features.video_clips": "3 video clip",
        "common.with_watermark": "có watermark",
        "pricing.free.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.free.features.file_upload": "Tải tệp lên đến 4Gb",
        "pricing.free.features.upload": "1 lần tải lên",
        "pricing.free.features.landing_pages": "Trang đích podcast",
        "pricing.free.features.audio_enhancement": "Tăng cường âm thanh",
        "common.sign_up": "Đăng ký",
        "common.open_dashboard": "Mở Bảng điều khiển",
        "pricing.starter.title": "Khởi đầu",
        "pricing.starter.subtitle": "Hoàn hảo cho những podcaster nghiệp dư muốn tiết kiệm thời gian.",
        "pricing.starter.price.annual": "$132 Thanh toán hàng năm",
        "pricing.billed_annually": "Thanh toán hàng năm",
        "minutes.accumulate": "chuyển tiếp phút",
        "pricing.starter.features.podcast_time": "160 phút thời gian podcast mỗi tháng",
        "pricing.starter.features.video_clips": "10 video clip hoặc audiogram",
        "pricing.starter.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.starter.features.file_upload": "Tải tệp lên đến 4Gb",
        "pricing.starter.features.unlimited_uploads": "Tải lên không giới hạn",
        "pricing.starter.features.landing_pages": "Trang đích podcast",
        "pricing.pro.title": "Pro",
        "pricing.pro.subtitle": "Dành cho các chuyên gia sử dụng podcasting để phát triển và hỗ trợ doanh nghiệp của họ.",
        "pricing.pro.price.annual": "$324 Thanh toán hàng năm",
        "pricing.pro.features.podcast_time": "320 phút thời gian podcast mỗi tháng",
        "pricing.pro.features.personalize_ai_voice": "Cá nhân hóa giọng nói AI",
        "pricing.pro.features.video_clips": "20 video clip hoặc audiogram",
        "common.no_watermark": "không có watermark",
        "pricing.pro.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.pro.features.file_upload": "Tải tệp lên đến 10Gb",
        "pricing.pro.features.unlimited_uploads": "Tải lên không giới hạn",
        "pricing.pro.features.landing_pages": "Trang đích podcast",
        "common.customizable": "có thể tùy chỉnh",
        "pricing.pro.features.audio_video_edit": "Chỉnh sửa Âm thanh và Video Ma thuật",
        "pricing.agency_lite.title": "Cơ quan Lite",
        "pricing.agency_lite.subtitle": "Dành cho các cơ quan podcast muốn tối ưu hóa và phát triển doanh nghiệp của họ.",
        "pricing.agency_lite.price.annual": "$495 Thanh toán hàng năm",
        "pricing.agency_lite.features.podcast_time": "600 phút thời gian podcast mỗi tháng",
        "pricing.agency_lite.features.personalize_ai_voice": "Cá nhân hóa giọng nói AI",
        "pricing.agency_lite.features.video_clips": "40 video clip hoặc audiogram",
        "pricing.agency_lite.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.agency_lite.features.file_upload": "Tải tệp lên đến 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "Tải lên không giới hạn",
        "pricing.agency_lite.features.landing_pages": "Trang đích podcast",
        "pricing.agency_lite.features.audio_video_edit": "Chỉnh sửa Âm thanh và Video Ma thuật",
        "pricing.agency_plus.title": "Cơ quan Plus",
        "pricing.agency_plus.subtitle": "Dành cho các cơ quan podcast muốn tối ưu hóa và phát triển doanh nghiệp của họ.",
        "pricing.agency_plus.price.annual": "$1.251 Thanh toán hàng năm",
        "pricing.agency_plus.features.podcast_time": "2000 phút thời gian podcast mỗi tháng",
        "pricing.agency_plus.features.personalize_ai_voice": "Cá nhân hóa giọng nói AI",
        "pricing.agency_plus.features.video_clips": "80 video clip hoặc audiogram",
        "pricing.agency_plus.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.agency_plus.features.file_upload": "Tải tệp lên đến 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "Tải lên không giới hạn",
        "pricing.agency_plus.features.landing_pages": "Trang đích podcast",
        "pricing.agency_plus.features.audio_video_edit": "Chỉnh sửa Âm thanh và Video Ma thuật",
        "pricing.agency_scale.title": "Cơ quan Scale",
        "pricing.agency_scale.subtitle": "Dành cho các cơ quan podcast muốn tối ưu hóa và phát triển doanh nghiệp của họ.",
        "pricing.agency_scale.price.annual": "$2.175 Thanh toán hàng năm",
        "pricing.agency_scale.features.podcast_time": "4000 phút thời gian podcast mỗi tháng",
        "pricing.agency_scale.features.personalize_ai_voice": "Cá nhân hóa giọng nói AI",
        "pricing.agency_scale.features.video_clips": "160 video clip hoặc audiogram",
        "pricing.agency_scale.features.quote_images": "Hình ảnh trích dẫn không giới hạn",
        "pricing.agency_scale.features.file_upload": "Tải tệp lên đến 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "Tải lên không giới hạn",
        "pricing.agency_scale.features.landing_pages": "Trang đích podcast",
        "pricing.agency_scale.features.audio_video_edit": "Chỉnh sửa Âm thanh và Video Ma thuật",
        "pricing.header": "Dành cho podcaster cá nhân và các cơ quan podcast",
        "pricing.minutes_reset": "Bạn có thể tích lũy tối đa gấp 3 lần số phút hàng tháng của mình, miễn là bạn vẫn giữ gói hiện tại hoặc nâng cấp.",
        "pricing.most_popular": "Phổ biến nhất",
        "pricing.minutes_per_month": "Phút mỗi tháng",
        "pricing.enterprise_title": "Enterprise",
        "pricing.enterprise_subtitle": "Dành cho các cơ quan podcast và các công ty truyền thông muốn tối ưu hóa và phát triển doanh nghiệp của họ.",
        "pricing.enterprise_price": "Tùy chỉnh",
        "pricing.enterprise_price_note": "Liên hệ team@podsqueeze.com hoặc đặt lịch hẹn bên dưới.",
        "pricing.enterprise_feature_priority_support": "Hỗ trợ ưu tiên",
        "pricing.enterprise_feature_team_sits": "Hội nghị nhóm",
        "pricing.enterprise_personalized_team_training": "Hội nghị nhóm",
        "pricing.book_demo": "Đặt lịch hẹn"
      },
      "toggle": {
        "pay.monthly": "Tháng",
        "pay.annually": "Năm",
        "discount.30percent": "GIẢM GIÁ 30%"
      },
      "upgradeModal": {
        "upgrade.success": "Gói đăng ký của bạn đã được nâng cấp thành công",
        "upgrade.error": "Chúng tôi xin lỗi, đã có sự cố xảy ra. Vui lòng thử lại sau",
        "upgrade.loading": "Đang nâng cấp",
        "upgrade.confirmPay": "Xác nhận & Thanh toán",
        "upgrade.cancel": "Hủy",
        "coupon.placeholder": "Mã Giảm Giá",
        "coupon.apply": "Áp dụng",
        "coupon.have": "Tôi có một mã giảm giá",
        "upgrade.confirmation": "Bạn sắp nâng cấp lên",
        "upgrade.price": "Bạn sẽ thanh toán"
      }
    },
    "register": {
      "page": {
        "register.form": "MẫuĐăngKý"
      },
      "registerForm": {
        "error.invalidCredentials": "Vui lòng nhập địa chỉ email và mật khẩu hợp lệ.",
        "error.weakPassword": "Vui lòng sử dụng mật khẩu mạnh hơn 💪",
        "error.emailInUse": "Người dùng đã tồn tại",
        "error.userNotFound": "Không tìm thấy người dùng",
        "error.generic": "Ôi, có điều gì đó không đúng",
        "placeholder.email": "Địa chỉ E-mail",
        "placeholder.password": "Mật khẩu",
        "button.registering": "Đang đăng ký...",
        "button.register": "Đăng ký",
        "label.newsletter": "Tham gia cùng 12.000 podcaster và đăng ký nhận bản tin của chúng tôi để nhận cập nhật sản phẩm, mẹo hữu ích, sách điện tử, quà tặng và nhiều hơn nữa.",
        "label.alreadyHaveAccount": "Đã có tài khoản?",
        "label.logInHere": "Đăng nhập ở đây",
        "label.or": "HOẶC",
        "button.signingIn": "Đang đăng nhập...",
        "button.continueWithGoogle": "Tiếp tục với Google",
        "label.podcastDescription": "Khởi động và phát triển podcast âm thanh hoặc video của bạn một cách dễ dàng với mọi thứ bạn cần trong một nơi.",
        "feature.transcripts": "Bản ghi",
        "feature.showNotes": "Ghi chú chương trình",
        "feature.newslettersBlogs": "Bản tin & Blog",
        "feature.socialPosts": "Bài đăng trên mạng xã hội",
        "feature.shortClips": "Clip ngắn & Audiogram",
        "feature.podcastWebsite": "Trang web podcast",
        "feature.audioEnhancement": "Cải thiện âm thanh AI",
        "feature.removeSilences": "Xóa im lặng và âm thanh ậm ừ"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "văn bản"
      },
      "TopicFinder": {
        "competition.veryHigh": "RẤT CAO",
        "competition.high": "CAO",
        "competition.medium": "TRUNG BÌNH",
        "competition.low": "THẤP",
        "competition.veryLow": "RẤT THẤP",
        "upgrade.button": "Nâng cấp lên Pro",
        "clicks.label": "nhấp chuột",
        "searches.label": "tìm kiếm",
        "competition.label": "cạnh tranh",
        "fetching.results": "Đang lấy kết quả",
        "table.topic": "Chủ đề",
        "tooltip.topic": "Chủ đề chính được đề cập trong tập podcast của bạn",
        "table.monthlySearches": "Tìm kiếm hàng tháng",
        "tooltip.monthlySearches": "Phạm vi tìm kiếm hàng tháng trên Google mà bạn có thể mong đợi",
        "table.competition": "Cạnh tranh",
        "tooltip.competition": "Chủ đề chính hoặc đề tài được đề cập trong podcast.",
        "table.monthlyGoogleClicks": "Nhấp chuột hàng tháng trên Google",
        "tooltip.monthlyGoogleClicks": "Dự đoán phạm vi nhấp chuột hàng tháng trên Google mà bạn có thể mong đợi",
        "table.youtubeReach": "Lượt tiếp cận trên Youtube",
        "tooltip.youtubeReach": "Dự đoán số lượt xem tối đa trên Youtube mà bạn có thể mong đợi trong 6 tháng đầu, dựa trên đối thủ trung bình",
        "intro.title": "Công cụ tạo chủ đề podcast miễn phí",
        "intro.description": "Nhận ý tưởng chủ đề cho podcast của bạn mà khán giả đang tìm kiếm",
        "intro.check1": "Kiểm tra nhu cầu cho từng ý tưởng chủ đề trên Google",
        "intro.check2": "Tìm hiểu mức độ cạnh tranh của từng ý tưởng chủ đề podcast",
        "intro.check3": "Ước lượng số nhấp chuột trên Google và lượt xem trên YouTube mà bạn có thể nhận được",
        "upgrade.message": "Bạn cần nâng cấp lên phiên bản Pro để truy cập tất cả kết quả",
        "learnMore.label": "Tìm hiểu thêm về",
        "learnMore.link": "công cụ tạo chủ đề podcast miễn phí",
        "newSearch.button": "Tìm kiếm mới",
        "share.button": "Chia sẻ tìm kiếm này",
        "form.label": "Nhập ngách podcast của bạn",
        "form.placeholder": "Tiếp thị số",
        "form.submit": "Tìm ý tưởng chủ đề"
      },
      "page": {
        "main.background": "nền"
      },
      "shareTopics": {
        "share.results": "Chia sẻ kết quả",
        "share.facebook": "Chia sẻ trên Facebook",
        "share.whatsapp": "Chia sẻ trên WhatsApp",
        "share.twitter": "Chia sẻ trên Twitter",
        "share.linkedin": "Chia sẻ trên LinkedIn",
        "copy.success": "Đã sao chép",
        "copy.link": "Sao chép liên kết"
      },
      "youtubeScore": {
        "loading.placeholder": "Đang tải...",
        "views.label": "lượt xem"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "Không thể lấy thành phần hiện tại",
        "error.addImage": "Lỗi khi thêm phần tử hình ảnh:",
        "alert.uploadImage": "Vui lòng tải lên một tệp hình ảnh.",
        "error.uploadImage": "Lỗi khi tải lên hình ảnh:",
        "alert.uploadFailed": "Tải lên hình ảnh thất bại. Vui lòng thử lại.",
        "error.getDownloadURL": "Lỗi khi lấy URL tải xuống:",
        "alert.processImageFailed": "Xử lý hình ảnh đã tải lên thất bại. Vui lòng thử lại.",
        "error.addText": "Lỗi khi thêm phần tử văn bản:",
        "text.settingsPlaceholder": "Cài đặt sẽ hiển thị khi phần tử được chọn",
        "text.addElement": "Thêm phần tử",
        "text.uploading": "Đang tải lên...",
        "button.uploadImage": "Tải lên hình ảnh",
        "text.newText": "Văn bản mới",
        "button.addText": "Thêm văn bản",
        "text.selectedElementSettings": "Cài đặt phần tử đã chọn"
      },
      "FontSelector": {
        "allFonts": "Tất cả phông chữ",
        "myFonts": "Phông chữ của tôi",
        "uploadFont": "Tải lên phông chữ",
        "noCustomFonts": "Chưa có phông chữ tùy chỉnh.",
        "uploadToAdd": "Tải lên tệp phông chữ để thêm vào bộ sưu tập của bạn.",
        "text_outline": "Viền chữ",
        "outline_color": "Màu viền",
        "outline_width": "Độ dày viền"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "Vừa vặn",
        "imageLayoutSettings.zoom": "Phóng to",
        "imageLayoutSettings.horizontalAlignment": "Căn chỉnh ngang",
        "imageLayoutSettings.verticalAlignment": "Căn chỉnh dọc",
        "imageLayoutSettings.deleteElement": "Xóa phần tử"
      },
      "TemplateBox": {
        "confirm.delete.template": "Bạn có chắc chắn muốn xóa mẫu này không?"
      },
      "TextSettings": {
        "error.getting_current_text": "Lỗi khi lấy văn bản hiện tại:",
        "event.delete_text_element_clicked": "Đã nhấp vào Xóa phần tử văn bản",
        "error.changing_text_font": "Lỗi khi thay đổi phông chữ văn bản:",
        "event.text_font_changed": "Phông chữ văn bản đã được thay đổi",
        "error.changing_text_size": "Lỗi khi thay đổi kích thước văn bản:",
        "event.text_size_changed": "Kích thước văn bản đã được thay đổi",
        "error.changing_text_color": "Lỗi khi thay đổi màu văn bản:",
        "event.text_color_changed": "Màu văn bản đã được thay đổi",
        "event.text_content_added": "Nội dung văn bản đã được thêm",
        "error.adding_text_content": "Lỗi khi thêm nội dung văn bản:",
        "event.text_content_updated": "Nội dung văn bản đã được cập nhật",
        "label.text_content": "Nội dung văn bản",
        "label.text_font": "Phông chữ văn bản",
        "label.adjust_text_size": "Điều chỉnh kích thước văn bản",
        "label.text_color": "Màu văn bản",
        "button.delete": "Xóa"
      },
      "audiogramBaseTemplate": {
        "color.white": "Trắng",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 giây",
        "font.inter": "Inter",
        "duration.1s": "1 giây",
        "easing.quadraticOut": "quadratic-out",
        "animation.fade": "mờ",
        "type.text": "văn bản",
        "name.podcastTitle": "Tiêu đềPodcast",
        "name.snippetTitle": "Tiêu đềSnippet",
        "type.image": "hình ảnh",
        "name.audioBackgroundImage": "HìnhNềnÂmThanh",
        "name.subtitlesText": "văn bảnPhụĐề",
        "effect.highlight": "nổi bật",
        "type.audio": "âm thanh",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "tiêu đề đoạn mã",
        "podcast.title": "tiêu đề podcast",
        "new.episode": "TẬP MỚI"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "Trắng",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "defaultEpisodeUrl",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "nhạc_nền",
        "audio.type": "âm_thanh"
      },
      "imageElement": {
        "upload.image.error": "Vui lòng tải lên một tệp hình ảnh.",
        "upload.file.loading": "Đang tải tệp. Vui lòng không đóng cửa sổ này.",
        "upload.image.label": "Thay đổi hình ảnh",
        "ai.prompt.label": "Nhập một gợi ý để AI tạo ra hình ảnh",
        "ai.prompt.placeholder": "Ví dụ: Một con chó đang chạy trong công viên...",
        "ai.processing": "Đang xử lý...",
        "ai.create": "Tạo",
        "customize.image.title": "Tùy chỉnh Hình ảnh",
        "enter.image.url": "Nhập URL Hình ảnh",
        "or": "hoặc"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "Lỗi khi lấy mẫu:",
        "template.savedSuccessfully": "Mẫu đã được lưu thành công",
        "error.savingTemplate": "Lỗi khi lưu mẫu:",
        "loading.savedTemplates": "Đang tải các mẫu đã lưu...",
        "no.savedTemplates": "Không có mẫu nào được lưu",
        "select_template": "Chọn Mẫu",
        "saving.template": "Đang lưu mẫu...",
        "template_name": "Tên Mẫu",
        "enter.templateName": "Nhập tên mẫu",
        "cancel": "Hủy",
        "save": "Lưu",
        "default_templates": "Mẫu Mặc Định",
        "saved_templates_count": "Mẫu Đã Lưu ({count})",
        "folder_templates_count": "Mẫu Thư Mục ({count})",
        "account_templates_count": "Mẫu Tài Khoản ({count})",
        "save_current_template": "Lưu Mẫu Hiện Tại"
      },
      "subtitlesElement": {
        "edit.word": "Chỉnh sửa từ",
        "edit.label": "chỉnh sửa",
        "remove.word.subtitle": "Xóa từ chỉ trong phụ đề",
        "erase.subtitle": "xóa khỏi phụ đề",
        "remove.word.clip": "Xóa từ khỏi Âm thanh và Phụ đề",
        "remove.clip": "xóa khỏi đoạn clip"
      },
      "utils": {
        "video.utils.title": "Tiêu đề",
        "video.utils.currentTime": "Thời gian hiện tại",
        "video.utils.nextTime": "Thời gian tiếp theo",
        "video.utils.duration": "Thời gian",
        "video.utils.description": "Mô tả",
        "video.utils.srtSegment": "Phân đoạn SRT"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "Văn bản phụ đề của bạn ở đây"
      }
    }
  },
  "zh": {
    "affiliate": {
      "affiliatehero": {
        "BECOME_OUR_PARTNER": "成为我们的合作伙伴",
        "SHARE_PODSQUEEZE": "与您的观众分享 Podsqueeze",
        "AND_EARN_MONEY": "并赚取收入！",
        "LAST_UPDATED": "最后更新: {date}",
        "BECOME_AN_AFFILIATE_PARTNER": "成为联盟伙伴",
        "EARN_COMMISSION": "赚取",
        "COMMISSION": "佣金",
        "ON_EVERY_SALE": "在通过您的专属推荐链接进行的每次销售中，在 15 个月的时间内赚取佣金。 在您的网站、社交媒体或与朋友分享您的链接。 加入只需几秒钟。",
        "GET_AUTOMATICALLY_APPROVED": "自动获得批准。",
        "JOIN_NOW": "立即加入",
        "HOW_IT_WORKS": "如何运作",
        "FREQUENTLY_ASKED_QUESTIONS": "常见问题",
        "WHAT_IS_AN_AFFILIATE_PARTNER": "什么是联盟伙伴？",
        "AFFILIATE_PARTNER_DESCRIPTION": "联盟伙伴是通过独特的推荐链接推广其他公司的产品或服务的人，并通过该链接进行的每次销售赚取佣金。",
        "HOW_CAN_I_BECOME_AN_AFFILIATE_PARTNER": "我如何成为联盟伙伴？",
        "BECOMING_AN_AFFILIATE_PARTNER_DESCRIPTION": "成为联盟伙伴快速且简单，只需几秒钟。 要开始，请点击“立即加入”按钮并使用您的电子邮件注册。 注册后，您将可以访问用户友好的仪表板，您将在其中找到您的专属推荐链接。 与您的家人、朋友或在线观众分享此链接。 每次有人点击您的推荐链接并在 Podsqueeze 网站上进行购买时，您将在 15 个月的所有付款中赚取 25% 的佣金！ 通过您的联盟仪表板轻松跟踪您的收入，该仪表板提供您生成的所有销售的清晰概览。",
        "HOW_CAN_I_TRACK_MY_SALES": "我如何跟踪我的销售和佣金？",
        "TRACKING_SALES_DESCRIPTION": "使用我们的联盟计划仪表板跟踪您的销售和佣金。 该跟踪软件适用于联盟伙伴和业务伙伴。",
        "WHEN_AND_HOW_WILL_I_RECEIVE_PAYMENT": "我什么时候以及如何收到付款？",
        "PAYMENT_DESCRIPTION": "您将通过 PayPal 每 30 天收到一次付款。 请注意，最低支付门槛为 50 美元。 一旦达到这个金额，您可以期待每 30 天准时收到付款。",
        "STILL_GOT_QUESTIONS": "还有问题吗？",
        "SEND_US_A_MESSAGE": "在支持聊天中发送消息给我们或通过 team@podsqueeze.com 向我们发送电子邮件",
        "NOTE": "注意",
        "AFFILIATE_ADS_RESTRICTION": "禁止联盟伙伴在 Google 上创建广告或参与与 Podsqueeze 相关的关键词竞价。",
        "AFFILIATE_TERMS_OF_USE": "联盟使用条款",
        "CAN_I_RUN_ADS": "我可以在 Google 上运行广告和 CPC 活动来推广我的推荐链接吗？",
        "AFFILIATE_ADS_RESTRICTION_DESCRIPTION": "严格禁止联盟伙伴在搜索引擎上创建广告或参与与 Podsqueeze 相关的关键词竞价。 此限制有助于维护我们的广告策略的完整性，并确保品牌信息的一致性。 请注意，此类竞价活动产生的销售不符合支付条件。",
        "HOW_DOES_PODSQUEEZE_GENERATE_TITLES": "Podsqueeze 如何为您的播客生成标题？"
      },
      "page": {
        "main.backgroundColor": "bg-[#643ADA]",
        "main.navBar": "导航栏",
        "main.affiliateHero": "联盟英雄",
        "main.footer": "页脚"
      }
    },
    "edit": {
      "IntroOutroModal": {
        "add.intro.outro.music": "添加片头和片尾音乐",
        "intro.music": "片头音乐",
        "outro.music": "片尾音乐",
        "intro.duration": "片头时长",
        "outro.duration": "片尾时长",
        "intro.mode": "片头模式",
        "outro.mode": "片尾模式",
        "cancel": "取消",
        "save": "保存",
        "apply": "应用",
        "current.intro.music": "当前片头音乐",
        "current.outro.music": "当前片尾音乐",
        "change.music": "更改音乐",
        "choose.music": "选择音乐文件",
        "browser.not.support.audio": "您的浏览器不支持音频元素。",
        "save.and.apply": "保存并应用",
        "no.music.selected": "未选择音乐",
        "delete.music": "删除音乐",
        "uploading.file": "正在上传文件..."
      },
      "audioEditElements": {
        "error.processing.rss": "我们在处理某些RSS源时遇到了一些困难。请上传一个文件。",
        "edit.enhance.audio": "编辑和增强您的音频录音",
        "trial.label": "试用",
        "audio.editing.experience": "体验无缝音频编辑，使用先进的AI算法实现自然、高质量的结果，只需一键即可。",
        "improve.audio.quality": "改善音频质量",
        "remove.hums.silences": "去除嗡嗡声和静音",
        "upgrade.edit.audio": "升级以便能够一键编辑您的音频",
        "available.plans": "适用于所有付费计划",
        "upgrade.now": "立即升级",
        "audio.element.support": "您的浏览器不支持音频元素。",
        "download.audio": "下载音频",
        "loading.audio": "加载音频",
        "editing.audio": "编辑音频"
      },
      "videoEditElements": {
        "error.exporting.video": "导出视频时出错",
        "download.failed": "下载失败：{error.message}",
        "generating.video": "正在生成视频",
        "error.generating.clip": "生成剪辑时出错",
        "please.retry.support": "请重试或联系我们的用户支持",
        "browser.not.support.video": "您的浏览器不支持视频标签。",
        "this.might.take.minutes": "请不要关闭窗口，这可能需要几分钟。",
        "exporting.video": "正在导出您的视频...",
        "seamless.audio.editing": "体验无缝音频编辑，使用先进的AI算法实现自然、高质量的结果，只需一键即可。",
        "difficulties.processing.rss": "我们在处理某些RSS源时遇到了一些困难。请上传文件。",
        "edit.enhance.video.recording": "编辑和增强您的视频录制",
        "trial": "试用",
        "enhance.audio.quality": "提升音频质量",
        "enhance.audio.quality.edit": "提升音频质量并编辑",
        "trim.filler.words.video": "修剪视频中的填充词（例如：嗯）",
        "trim.long.silences.video": "修剪视频中的长时间沉默",
        "upgrade.to.edit.video": "升级以便能够一键编辑您的视频",
        "available.pro.agency.plans": "适用于专业和代理计划",
        "upgrade.now": "立即升级",
        "download.only.audio": "仅下载音频",
        "download.video": "下载视频",
        "please.dont.close.window": "请不要关闭窗口",
        "export.video": "导出视频"
      },
      "videogramBaseTemplate": {
        "media.fit": "覆盖",
        "media.width": "100%",
        "media.height": "100%",
        "media.x": "50%",
        "media.y": "50%",
        "video.frameRate": "25",
        "video.outputFormat": "mp4",
        "media.duration": "媒体"
      }
    },
    "episodePublicPage": {
      "audioPlayer": {
        "other.episodes": "此播客的其他剧集",
        "tab.shownotes": "节目笔记",
        "tab.timestamps": "时间戳",
        "tab.blogpost": "博客文章",
        "tab.transcript": "文字记录",
        "key.points": "要点"
      }
    },
    "general": {
      "EpisodeLandingPageToggle": {
        "landingPage.live": "您的着陆页在我们的播客查找器中已上线。与您的观众分享吧！",
        "landingPage.create": "为此集创建一个美丽的着陆页",
        "landingPage.edit": "编辑页面",
        "landingPage.visit": "访问页面",
        "landingPage.delete": "删除页面",
        "landingPage.createButton": "创建着陆页"
      },
      "SocialLinksModal": {
        "manage.episode.links": "管理剧集链接",
        "youtube.link": "YouTube链接",
        "enter.youtube.link": "输入YouTube链接",
        "apple.podcasts.link": "Apple Podcasts链接",
        "enter.apple.podcasts.link": "输入Apple Podcasts链接",
        "spotify.link": "Spotify链接",
        "enter.spotify.link": "输入Spotify链接",
        "saving": "保存中...",
        "save": "保存",
        "social.links.updated.successfully": "社交链接更新成功！"
      },
      "affiliatesection": {
        "affiliate.section.title": "成为合作伙伴",
        "affiliate.section.subtitle": "与您的受众分享 Podsqueeze 并",
        "affiliate.section.earn": "赚取收入！",
        "affiliate.section.commission": "我们的合作伙伴计划提供 15 个月内每笔销售和订阅续费 25% 的佣金。",
        "affiliate.section.join": "加入只需几秒钟！",
        "affiliate.section.knowMore": "了解更多"
      },
      "asseenon": {
        "podnews.logo": "podnews 标志",
        "transistor.logo": "transistor 标志",
        "thepodcasthost.logo": "播客主持人标志",
        "schoolofpodcasting.logo": "播客学院标志",
        "semrush.logo": "semrush 标志"
      },
      "assembleshownotes": {
        "episode.description": "剧集描述",
        "bullet.points": "要点",
        "timestamps": "时间戳",
        "links.and.mentions": "链接与提及",
        "extra.content": "额外内容",
        "assemble.show.notes": "整理您的节目笔记",
        "downloading": "下载中",
        "copied": "已复制",
        "enter.placeholder": "输入{{label}}..."
      },
      "cancelationModal": {
        "cancellation.option.break": "暂时停止播客",
        "cancellation.option.no_recurrent": "我不想要定期订阅",
        "cancellation.option.expensive": "太贵了",
        "cancellation.option.not_saving_time": "没有为我节省足够的时间",
        "cancellation.option.dissatisfied_content": "对生成内容的质量不满意",
        "cancellation.option.unresponsive_support": "客户支持反应迟缓",
        "cancellation.option.not_using": "没有足够使用该服务",
        "cancellation.option.difficulty_navigating": "使用/导航产品时遇到困难",
        "cancellation.option.better_alternative": "找到了更好的替代产品",
        "cancellation.option.other": "其他",
        "cancellation.video.message": "70%的用户在观看此视频后停止取消流程",
        "cancellation.button.cancel": "我仍然想取消",
        "cancellation.button.try_again": "我想再试一次",
        "cancellation.prompt.select_reason": "请帮助我们通过选择取消订阅的原因来改进产品：",
        "cancellation.placeholder.answer": "在这里输入您的答案...",
        "cancellation.placeholder.specify_reason": "请具体说明您取消的原因",
        "cancellation.button.next": "下一步",
        "cancellation.button.go_back": "返回",
        "cancellation.last_question.title": "我们这边的最后一个问题",
        "cancellation.last_question.prompt": "哪些变化或改进会让您考虑重新加入我们的服务？",
        "cancellation.feedback.message": "您的反馈将帮助我们改进 🙏",
        "here.are.some.ideas": "以下是一些保持从Podsqueeze获得价值的方法",
        "keep.accumulating.minutes": "保持积累分钟数，以便您下次返回播客时使用",
        "convert.and.repurpose.episodes": "将旧的剧集转换和重新利用为新鲜内容",
        "generate.articles.favorite.podcasts.and.vides": "从您最喜欢的播客生成文章",
        "share.your.account.with.a.friend": "与您的朋友分享您的账户，他们可能会受益",
        "video.showing.how.to.get.the.most.out.of.podsqueeze": "这里有一个视频，展示了如何充分利用Podsqueeze",
        "lose.all.accumulated.minutes": "如果您取消，您将失去所有累积的分钟数。",
        "cancellation.button.confirm": "确认取消",
        "cancellation.minutes.accumulated": "您有",
        "cancellation.minutes.accumulated.suffix": "累积分钟，价值",
        "cancellation.reminder.text": "请记住：",
        "cancellation.minutes.warning": "累积分钟是活跃订阅的特权。通过取消您的订阅，您的分钟将永久丢失。",
        "cancellation.content.deletion.warning": "您生成的所有内容将在30天后被永久删除。",
        "cancellation.minutes.left.title": "您还有剩余分钟！不要浪费它们！",
        "cancellation.suggestion.clips": "将旧集数重新用作社交媒体剪辑",
        "cancellation.suggestion.articles": "使用Podsqueeze将旧集数转换为文章以受益于SEO。",
        "cancellation.suggestion.linkedin": "将权威的旧集数转换为LinkedIn帖子以提升个人品牌",
        "cancellation.suggestion.share": "与朋友分享您的Podsqueeze账户，让他们可以从您未使用的分钟中受益。",
        "cancellation.button.keep.subscription": "保留我的订阅",
        "cancellation.button.keep.minutes": "保留我的",
        "cancellation.button.keep.minutes.suffix": "价值分钟",
        "cancellation.lifetime.before_you_go": "在您离开之前...",
        "cancellation.lifetime.title": "仅需$49的终身访问权限怎么样？",
        "cancellation.lifetime.subtitle": "保留您的Starter账户。 无订阅。无续费。 只属于您 — 永远。",
        "cancellation.lifetime.feature1": "一次性支付$49即可终身访问Podsqueeze",
        "cancellation.lifetime.feature2": "随时使用，无压力 — 永远属于您",
        "cancellation.lifetime.feature3": "包含所有当前和未来的Starter计划功能",
        "cancellation.lifetime.button_cancel": "我仍然想取消",
        "cancellation.lifetime.button_deal": "获取终身优惠",
        "cancellation.downgrade.title": "仅需$5.99/月保留您的所有内容",
        "cancellation.downgrade.subtitle": "通过降级到Starter您可以...",
        "cancellation.downgrade.feature1": "保留所有生成的内容",
        "cancellation.downgrade.feature2": "保持您的网站运行",
        "cancellation.downgrade.feature3": "每月160分钟和10个剪辑用于偶尔工作",
        "cancellation.billing.monthly": "月付",
        "cancellation.billing.annual": "年付",
        "cancellation.billing.discount": "30%折扣",
        "cancellation.plan.starter": "Starter计划",
        "cancellation.price.monthly": "$8.99/月",
        "cancellation.price.annual": "$5.99/月",
        "cancellation.price.annual_billing": "年付$71.88",
        "cancellation.feature.minutes": "160分钟/月",
        "cancellation.feature.clips": "10个剪辑/月",
        "cancellation.downgrade.button": "降级到Starter并保留内容",
        "cancellation.error.payment_link": "无法获取支付链接。请重试。",
        "cancellation.error.payment_service": "连接支付服务时出错。",
        "cancellation.option.question.break": "您能告诉我们更多关于为什么要休息的原因吗？",
        "cancellation.option.question.no_recurrent": "您能分享一下为什么您不希望有定期订阅吗？",
        "cancellation.option.question.expensive": "什么样的定价或功能会让这项服务对您更有价值？",
        "cancellation.option.question.not_saving_time": "您的流程中什么仍然占用您很多时间？",
        "cancellation.option.question.dissatisfied_content": "您对内容的哪些方面不满意？",
        "cancellation.option.question.unresponsive_support": "您能描述一下您与我们客户支持的体验吗？",
        "cancellation.option.question.not_using": "有什么能鼓励您更频繁地使用这项服务吗？",
        "cancellation.option.question.difficulty_navigating": "您在使用/导航产品时遇到了什么困难？",
        "cancellation.option.question.better_alternative": "您找到了什么替代产品，您喜欢它的什么地方？",
        "cancellation.option.question.other": "请说明您取消的原因："
      },
      "cookiebanner": {
        "cookiebanner.privacyNotice": "我们重视您的隐私",
        "cookiebanner.cookieUsage": "我们使用 cookies 来提升您的网站体验并分析我们的流量。点击接受即表示您同意我们使用 cookies。",
        "cookiebanner.privacyPolicy": "隐私政策",
        "cookiebanner.accept": "接受",
        "cookiebanner.decline": "拒绝"
      },
      "episodeTitleBox": {
        "loading": "加载中...",
        "editEpisodeTitleClicked": "点击编辑剧集标题",
        "newEpisodeTitleStored": "新剧集标题已保存"
      },
      "famewall": {
        "loading.message": "加载中..."
      },
      "footer": {
        "footer.features": "功能",
        "footer.transcriptGenerator": "成绩单生成器",
        "footer.subtitlesGenerator": "字幕生成器",
        "footer.descriptionGenerator": "描述生成器",
        "footer.podcastSummarizer": "播客摘要生成器",
        "footer.titlesGenerator": "标题生成器",
        "footer.bulletPointsGenerator": "要点生成器",
        "footer.chaptersClipsGenerator": "章节与剪辑生成器",
        "footer.socialMediaPostsGenerator": "社交媒体帖子生成器",
        "footer.newsletterGenerator": "通讯生成器",
        "footer.blogPostGenerator": "博客文章生成器",
        "footer.podcastLandingPages": "播客着陆页",
        "footer.podcastClipMaker": "播客剪辑制作器",
        "footer.audiogramGenerator": "音频图生成器",
        "footer.aiAudioEnhancer": "AI音频增强器",
        "footer.convertYoutubeToText": "将Youtube转换为文本",
        "footer.youtubeVideoNoiseRemover": "Youtube视频噪音去除器",
        "footer.youtubeVideoKeyPoints": "Youtube视频要点",
        "footer.freeResources": "免费资源",
        "footer.findPodcastTopicIdeas": "寻找播客主题创意",
        "footer.articles": "文章",
        "footer.freeEbooks": "免费电子书",
        "footer.community": "社区",
        "footer.ourPodcast": "我们的播客",
        "footer.product": "产品",
        "footer.giftCard": "礼品卡",
        "footer.onboardingEbook": "入门电子书",
        "footer.pricing": "定价",
        "footer.affiliates": "合作伙伴",
        "footer.media": "媒体",
        "footer.testimonials": "推荐信",
        "footer.legal": "法律",
        "footer.privacyPolicy": "隐私政策",
        "footer.termsOfUse": "使用条款",
        "footer.refundPolicy": "退款政策",
        "footer.allRightsReserved": "版权所有。"
      },
      "globalState": {
        "cookie.enabled": "启用Cookie",
        "language.default": "默认语言"
      },
      "head": {
        "keywords.list": "Podsqueeze, 人工智能, 播客, 内容生成, 播客转录, 节目说明, 时间戳, 播客通讯, 推文, 博客文章, 社交帖子, 标题, 节目说明撰写者"
      },
      "imageResultModal": {
        "download.image": "下载图片",
        "generating.image": "生成图片中",
        "ai.prompt.label": "输入提示以让AI生成图片",
        "ai.prompt.placeholder": "例如：一只在公园里奔跑的狗...",
        "processing": "处理中...",
        "create": "创建",
        "text.color.label": "文本颜色",
        "quote.icon.color.label": "引用图标颜色",
        "background.color.label": "背景颜色",
        "font.label": "字体",
        "upload.cover.image": "上传封面图片",
        "aspect.ratio.info": "宽高比 1:1，推荐尺寸 1200x1200",
        "upload.logo.label": "上传logo",
        "choose.file": "选择文件",
        "upload.success": "上传成功",
        "choose.quote": "选择引用",
        "select.template": "选择模板",
        "quote.label": "引用",
        "enter.quote.here": "在此输入引用",
        "author.label": "作者",
        "enter.author.name": "输入作者姓名",
        "podcast.name.label": "播客名称",
        "enter.podcast.name": "输入播客名称",
        "colors": "颜色",
        "select.font": "选择字体",
        "cover.logo.images": "封面和logo图片",
        "logo.image": "Logo图片",
        "upgrade.here": "在此升级",
        "remove.logo": "移除 Podsqueeze 徽标",
        "default_templates": "默认模板",
        "saved_templates_count": "已保存的模板",
        "save_current_template": "保存当前模板",
        "no_saved_templates": "还没有保存的模板",
        "save_template": "保存模板",
        "cancel": "取消",
        "save": "保存",
        "enter_template_name": "输入模板名称",
        "reset_template": "重置",
        "add_element": "添加元素",
        "generate": "生成",
        "add_image": "添加图片",
        "upload_image": "上传图片",
        "or": "或",
        "generate_with_ai": "AI生成",
        "search_fonts": "搜索字体...",
        "upload_logo": "上传标志",
        "square_image_recommended": "建议使用正方形图片",
        "opacity": "不透明度",
        "layers": "图层",
        "no_element_selected": "未选择元素",
        "bold_shortcut": "粗体 (Ctrl+B)",
        "italic_shortcut": "斜体 (Ctrl+I)",
        "underline_shortcut": "下划线 (Ctrl+U)",
        "edit_text": "编辑文本",
        "tint_color": "色调",
        "toggle_gradient_transparent": "切换渐变透明",
        "rotate_gradient": "旋转渐变45度",
        "alt_background": "背景",
        "alt_podcast_logo": "播客标志",
        "alt_custom": "自定义",
        "alt_right_side": "右侧",
        "alt_profile": "个人资料"
      },
      "intentModal": {
        "intentModal.title": "您想如何使用 Podsqueeze？",
        "intentModal.sourceOption.Write_Show_Notes": "撰写节目笔记",
        "intentModal.sourceOption.Write_Blog_Post_&_Newsletter": "撰写博客文章和通讯",
        "intentModal.sourceOption.Create_Video_Clips_or_Audiograms": "创建视频剪辑或音频图",
        "intentModal.sourceOption.Create_Quote_Images": "创建引用图片",
        "intentModal.sourceOption.Edit_&_Enhance_Audio/Video": "编辑和增强音频/视频",
        "intentModal.sourceOption.Transcribe": "转录",
        "intentModal.sourceOption.Create_a_Website": "创建网站",
        "intentModal.sourceOption.All_of_the_Above": "以上所有",
        "intentModal.sourceOption.Other": "其他",
        "intentModal.otherPlaceholder": "请具体说明",
        "intentModal.submitButton": "提交并注册",
        "intentModal.skip": "跳过"
      },
      "languageSwitcher": {
        "language.en": "英语",
        "language.es": "西班牙语",
        "language.fr": "法语",
        "language.de": "德语",
        "language.it": "意大利语",
        "language.pt": "葡萄牙语",
        "language.nl": "荷兰语",
        "language.pl": "波兰语",
        "language.ru": "俄语",
        "language.zh": "中文",
        "language.ja": "日语",
        "language.ko": "韩语",
        "language.ar": "阿拉伯语",
        "language.th": "泰语",
        "language.vi": "越南语"
      },
      "lazyImage": {
        "lazyImage.alt": "图片描述"
      },
      "metadata": {
        "meta.title": "您的页面标题",
        "meta.appName": "PodSqueeze",
        "meta.appCategory": "实用工具"
      },
      "navbar": {
        "navbar.dashboard": "仪表板",
        "navbar.login": "登录",
        "navbar.openMenu": "打开主菜单",
        "navbar.features": "功能",
        "navbar.resources": "资源",
        "navbar.pricing": "定价",
        "navbar.contact": "联系",
        "navbar.topPodcasts": "热门播客",
        "navbar.seeAllFeatures": "查看所有功能",
        "navbar.mainFeatures": "主要功能",
        "navbar.podcastTranscription": "播客和视频转录生成器",
        "navbar.transcriptionDescription": "高准确度的转录，带有发言者标记和用于字幕的SRT文件。",
        "navbar.podcastSummarizer": "播客摘要生成器",
        "navbar.summarizerDescription": "以自己的声音20倍更快地创建完整的节目笔记。",
        "navbar.podcastClipMaker": "播客剪辑制作器",
        "navbar.clipMakerDescription": "自动生成播客的短片或音频图。",
        "navbar.audioEnhancer": "AI音频增强器",
        "navbar.audioEnhancerDescription": "自动增强音频，去除静音和填充词。",
        "navbar.podsqueezeFeaturesWalkthrough": "PODSQUEEZE功能演示",
        "navbar.blog": "博客",
        "navbar.blogDescription": "可操作的文章和指南，帮助您启动和发展成功的播客。",
        "navbar.podcastTopicIdeas": "播客主题创意",
        "navbar.topicIdeasDescription": "发现观众正在搜索的播客主题。",
        "navbar.actionableEbooks": "实用电子书",
        "navbar.ebooksDescription": "下载免费电子书，获取实用技巧，将您的播客提升到新水平。",
        "navbar.freeThumbnailMaker": "免费播客缩略图制作工具",
        "navbar.freeThumbnailMakerDescription": "使用AI创建专业、引人注目的剧集缩略图。",
        "navbar.seoOptimizer": "SEO优化工具",
        "navbar.seoOptimizerDescription": "优化您的播客剧集，提高搜索引擎可见性。",
        "navbar.podcastDescription": "收听我们的播客，我们采访来自世界各地的经验丰富的播客主和Podsqueeze用户。我们请他们分享技巧、见解、故事以及您需要了解的一切，以发展自己的播客。"
      },
      "resultModal": {
        "prompt.transcript.quote": "引用",
        "prompt.transcript.blog": "博客",
        "prompt.transcript.tweets": "推文",
        "prompt.shownotes.firstPerson": "第一人称说明",
        "prompt.shownotes.replaceName": "在说明中替换名称",
        "prompt.shownotes.friendlyTone": "友好的语气说明",
        "prompt.shownotes.youtubeDescription": "YouTube 描述说明",
        "prompt.shownotes.engagingQuestion": "引人入胜的问题说明",
        "prompt.newsletter.casualTone": "随意语气的通讯",
        "prompt.newsletter.shorter": "更短的通讯",
        "prompt.newsletter.contentSections": "内容部分的通讯",
        "prompt.newsletter.changeName": "在通讯中更改名称",
        "prompt.mentions.fullURL": "完整 URL 提及",
        "prompt.mentions.replaceName": "在提及中替换名称",
        "prompt.tweets.underdogTone": "逆袭者语气的推文",
        "prompt.tweets.firstPerson": "第一人称推文",
        "prompt.shortPost.relevantEmojis": "相关表情符号的短文",
        "prompt.shortPost.educationalTone": "教育语气的短文",
        "prompt.shortPost.underdogTone": "逆袭者语气的短文",
        "prompt.shortPost.firstPerson": "第一人称短文",
        "prompt.titles.youtubeOptimized": "YouTube 优化标题",
        "prompt.titles.startWithHowTo": "以 '如何' 开头的标题",
        "prompt.titles.otherOptions": "标题的其他选项",
        "prompt.keywords.youtubeOptimized": "YouTube 优化关键词",
        "prompt.keywords.separateWithCommas": "用逗号分隔关键词",
        "prompt.quotes.lorem1": "Lorem ipsum 引用 1",
        "prompt.quotes.lorem2": "Lorem ipsum 引用 2",
        "prompt.bulletPoints.lorem1": "Lorem ipsum 要点 1",
        "prompt.bulletPoints.lorem2": "Lorem ipsum 要点 2",
        "prompt.longPost.firstPerson": "第一人称长文",
        "prompt.longPost.relevantEmojis": "相关表情符号的长文",
        "prompt.longPost.changeName": "在长文中更改名称",
        "alert.tuningInstructionsEmpty": "调优说明不能为空。",
        "text.timestamps.byPodsqueeze": "由 PodSqueeze 提供的时间戳",
        "button.copied": "已复制",
        "button.copy": "复制",
        "embed.transcript": "嵌入转录",
        "embed.description": "嵌入的描述",
        "preview.title": "预览标题",
        "loading.regenerating": "正在重新生成...",
        "placeholder.tuningInstructions": "输入调优说明...",
        "button.saveClose": "保存并关闭",
        "button.acceptChanges": "接受更改",
        "button.discard": "放弃",
        "button.embedTranscript": "嵌入转录",
        "text.copiedToClipboard": "已复制到剪贴板",
        "download.srtFile": "下载 SRT 文件",
        "text.forCaptions": "用于字幕",
        "tune.title": "调整您的结果",
        "tune.description": "使用以下选项调整您的结果。",
        "instruction.label": "说明：",
        "button.tuneResult": "调整结果",
        "instruction.saveForLater": "稍后保存",
        "button.readMore": "阅读更多",
        "button.showLess": "显示较少",
        "customPrompt.used": "使用的自定义提示：",
        "feedback.happyWithResults": "您对结果满意吗？",
        "prompt.timestamps.formatAsChapters": "将时间戳格式化为带有描述性标题的章节",
        "prompt.timestamps.detailedDescriptions": "创建详细的时间戳，包含主题描述和关键要点",
        "prompt.timestamps.improveSpeakerNames": "将说话者姓名替换为更具描述性的标题，如「主持人」、「专家」或「嘉宾」"
      },
      "resultModalTranscript": {
        "prompt.quote": "从转录文本中找到三个好的引用",
        "prompt.blog": "撰写一篇500字的博客文章，聚焦于主题X",
        "prompt.tweets": "从转录文本中写三条引人入胜的推文",
        "transcript.autoTranscribed": "通过Podsqueeze自动转录",
        "alert.emptyPrompt": "调优说明不能为空",
        "embed.transcript": "嵌入转录文本",
        "embed.description": "在您的WordPress网站或任何支持HTML的页面上嵌入一个可管理大小的转录文本，并带有搜索功能。",
        "button.copied": "已复制！",
        "button.copy": "复制",
        "preview.title": "预览",
        "edit.speakers": "编辑发言人姓名",
        "button.saveClose": "保存并关闭",
        "placeholder.prompt": "例如：从转录文本中找到三个好的引用",
        "upgrade.pro": "升级到专业版以使用此功能",
        "upgrade.link": "升级到专业版",
        "button.generate": "生成",
        "feedback.happy": "您对结果满意吗？",
        "instruction": "说明：",
        "generating.results": "生成结果中",
        "full.transcription": "完整转录",
        "srt.file": "& SRT文件",
        "download.srt": "下载SRT文件",
        "caption.subtitles": "用于字幕和字幕。",
        "generate.from.transcript": "从转录文本生成，使用Gpt-4o",
        "gpt.tweak.text": "请最新的GPT根据您的喜好调整文本。使用自然语言，不要害怕具体。",
        "copied.clipboard": "已复制到剪贴板",
        "transcript.public.available": "公共URL",
        "audio.notSupported": "您的浏览器不支持音频元素。",
        "button.chatWithTranscript": "Chat with the transcript",
        "button.closeChat": "Close chat",
        "label.speaker": "Speaker"
      },
      "selectPodcast": {
        "add.podcast.name": "添加播客名称",
        "podcast.title": "{{title}} 播客"
      },
      "sourceModal": {
        "sourceModal.title": "您是如何得知 Podsqueeze 的？",
        "sourceModal.otherPlaceholder": "请具体说明",
        "sourceModal.nextButton": "下一步",
        "sourceModal.skip": "跳过"
      },
      "squeezeEditResults": {
        "error.processing.rss": "我们在处理某些RSS源时遇到了一些困难。请上传一个文件。"
      },
      "squeezeResults": {
        "copiedToClipboard": "已复制到剪贴板",
        "publicLink": "公开于 ",
        "createLink": "创建一个链接以分享此结果页面",
        "assembleShowNotes": "整理节目笔记",
        "convertAnotherEpisode": "转换另一个剧集",
        "writtenContent": "书面内容",
        "videoClipsAndImages": "视频剪辑和图片",
        "editAudio": "编辑音频"
      },
      "squeezeTextResutls": {
        "see.more.and.tune": "查看更多并调整",
        "see.more": "查看更多",
        "generating": "生成中",
        "download.all": "下载全部",
        "full.transcription": "完整转录",
        "transcript.benefit": "您知道将完整转录添加到您的节目说明中可以提升网站流量和参与度吗？",
        "learn.more": "了解更多",
        "transcript.bonus": "您可以将完整转录作为您的播客会员计划的奖励提供。",
        "show.notes": "节目说明",
        "show.notes.engagement": "考虑用其他元素补充这个简短的描述，以提升参与度和搜索引擎优化。",
        "show.notes.examples": "从这17个播客节目说明示例中寻找灵感，为您的播客制作完美的节目说明。",
        "timestamps": "时间戳",
        "timestamps.benefit": "将这些时间戳添加到您节目的描述中，它将自动在Spotify和YouTube上创建章节。",
        "titles": "标题",
        "titles.engagement": "带有问号和最高级的标题往往特别吸引人。",
        "links.and.mentions": "链接与提及",
        "mentions.resources": "考虑在您的节目说明的资源部分中包含以下提及内容。",
        "mentions.affiliate": "查看提到的产品是否有联盟计划，并考虑在您的节目说明中添加联盟链接。",
        "mentions.social.media": "在社交媒体上标记您节目中提到的人，以鼓励他们分享和参与您的帖子。",
        "keywords": "关键词",
        "keywords.youtube": "当您将节目上传到YouTube时，只需将这些关键词复制并粘贴到标签部分。",
        "keywords.social.media": "将这些关键词用于社交媒体标签。",
        "blog.post": "博客文章",
        "blog.post.linkedin": "考虑使用这些内容撰写一篇长格式的LinkedIn帖子，",
        "blog.post.share": "在与您的播客主题相关的Reddit社区和Facebook小组中分享这些内容。",
        "newsletter": "新闻通讯",
        "newsletter.content": "我们的一些用户将这份新闻通讯内容重新利用，以创建更全面的节目说明。",
        "linkedin.and.facebook": "LinkedIn与Facebook",
        "short.post.description": "在社交媒体上分享相关视频剪辑和音频图时，使用这些简短的帖子作为描述。",
        "tweets": "推文",
        "quotes": "引用",
        "bullet.points": "要点",
        "add.custom.result": "添加自定义结果",
        "bullet.points.skimming": "播客主持人通常将主要节目主题列为要点，以便于快速浏览。"
      },
      "squeezeVideoResults": {
        "see.more.and.tune": "查看更多并调整",
        "generating": "正在生成",
        "not.available.for.rss.feed": "此 RSS 源不可用",
        "regenerate.episode.upload.file": "重新生成该集并直接从您的计算机上传音频/视频文件",
        "processing.difficulties": "我们在处理某些 RSS 源时遇到了一些困难。请上传一个文件。",
        "video.clips": "视频片段",
        "ai.short.clips": "AI 短片",
        "quote.image": "引用图片"
      },
      "title": {
        "title.text": "您的标签"
      },
      "topbar": {
        "topbar.forYou": "为您推荐",
        "topbar.joinPodcast": "加入我们的下一次播客虚拟聚会！",
        "topbar.saveYourSpot": "保留您的位置",
        "topbar.dismiss": "关闭"
      },
      "trackers": {
        "trackers.init": "正在初始化启用 cookies 的跟踪器：",
        "trackers.loadScripts": "正在加载跟踪脚本..."
      },
      "transcriptionChatElement": {
        "assistant.welcome": "I am your assistant. How can I help you today?",
        "button.send": "Send",
        "button.closeChat": "Close chat"
      },
      "translate": {
        "header.title": "欢迎使用我的应用程序",
        "content.description": "这是一个演示翻译的示例应用程序。",
        "button.submit": "提交"
      },
      "videoResultModal": {
        "ai_editing_clip": "Podsqueeze AI 正在编辑您的剪辑",
        "export_clip": "导出剪辑",
        "ai_edit": "AI 编辑",
        "ai_editing_clip_duration": "这将花费几秒钟",
        "generating_clip": "正在生成您的剪辑...",
        "generating_clip_notice": "这可能需要几分钟。完成后我们会通过电子邮件通知您。",
        "edit_another_video": "您可以在这里等待或编辑另一个视频",
        "download_video": "下载视频",
        "back_to_editing": "返回编辑",
        "export_video_button": "导出剪辑",
        "notice_storage": "注意：我们会存储您的音频 30 天。此后，该剪辑将过期。",
        "error_generating_clip": "生成剪辑时出错",
        "error_user_support": "请重试或联系用户支持",
        "select_template": "选择模板",
        "add_30s_prev": "从上一章节添加 30 秒",
        "add_30s_next": "从下一章节添加 30 秒",
        "undo": "撤销",
        "subtitles_font": "字幕字体",
        "subtitles_color": "字幕颜色",
        "subtitles_box_color": "动画颜色",
        "adjust_podcast_title_position": "调整播客标题垂直位置",
        "adjust_subtitles_size": "调整字幕大小",
        "adjust_subtitles_vertical_position": "调整字幕垂直位置",
        "remove_subtitles": "移除字幕",
        "animated_subtitles": "动画字幕",
        "upgrade_here": "在这里升级",
        "remove_logo": "以移除徽标",
        "remove_podsqueeze_logo": "移除 podsqueeze 徽标",
        "aspect_ratio": "纵横比",
        "youtube": "YouTube",
        "social_media": "Twitter (X), LinkedIn, Instagram 动态",
        "reels": "短视频, 故事, YouTube Shorts, TikTok",
        "episode_title": "剧集标题",
        "podcast_title": "播客标题",
        "titles_font": "标题字体",
        "title_colors": "播客/剧集标题颜色",
        "video_fit": "视频适配",
        "adjust_horizontal_position": "调整水平位置",
        "adjust_vertical_position": "调整垂直位置",
        "adjust_video_zoom": "调整视频缩放",
        "adjust_video_width": "调整视频宽度",
        "adjust_video_height": "调整视频高度",
        "background_color": "背景颜色",
        "edit_clip": "编辑剪辑",
        "edit_layout": "编辑布局",
        "choose_short": "选择短剪辑",
        "edit_audio": "编辑音频",
        "framing": "构图",
        "background": "背景",
        "text_style": "文本样式",
        "music": "音乐",
        "choose_chapter": "选择章节",
        "clips_left": "您还有",
        "apply_layout": "应用布局",
        "clips_left_number": "个剪辑剩余",
        "need_more_clips": "需要更多剪辑吗？在这里升级您的计划",
        "download_srt_file": "下载 SRT 文件",
        "track_selected": "音轨：",
        "no_background_music": "未选择背景音乐",
        "volume": "音量：",
        "remove": "移除",
        "track_ambient_piano": "环境钢琴和弦乐",
        "track_deep_meditation": "深度冥想",
        "track_chill_upbeat": "轻松愉快的音乐",
        "track_inspiring_ambient": "鼓舞人心的电影氛围",
        "track_just_relax": "放松一下",
        "track_movement": "运动",
        "track_once_in_paris": "在巴黎的一次",
        "track_perfect_beauty": "完美的美",
        "track_summer_adventures": "夏日冒险",
        "track_sunset_groove": "日落节奏",
        "track_tvari_cafe": "Tvari 东京咖啡馆",
        "track_short_piano_intermezzo": "短钢琴间奏曲",
        "track_dramatic_background": "戏剧性背景音乐",
        "track_dramatic_hiphop": "戏剧性嘻哈爵士",
        "track_emotional_orchestra": "情感管弦乐",
        "track_halloween_short": "万圣节音乐",
        "track_improvisation_037": "爵士即兴演奏",
        "track_inspiration_piano": "励志钢琴",
        "track_medieval_extract": "中世纪音乐",
        "track_short_8": "短环境音轨",
        "track_flute": "宁静长笛",
        "track_piano_guitar_duet": "钢琴吉他二重奏",
        "track_intro_jazz": "引子爵士",
        "track_romantic_jazz": "浪漫爵士",
        "recommended_for_youtube": "推荐用于 YouTube",
        "turn_into_short_clip": "将此剪辑转换为短剪辑（<60 秒）",
        "browser_not_support_audio": "您的浏览器不支持音频元素。",
        "watch_tutorial": "观看此教程",
        "audiogram_maker": "关于如何充分利用我们的听力图制作工具",
        "store_audio_notice": "注意：我们会存储您的音频 30 天",
        "clip_maker": "关于如何充分利用我们的剪辑制作工具",
        "split_screen_mode": "分屏模式",
        "none": "无",
        "vertical_split": "垂直分屏",
        "horizontal_split": "水平分屏",
        "layers": "拖动布局中的元素或选择下面的图层，将它们向前或向后移动。",
        "screen_1_horizontal_position": "屏幕 1 水平位置",
        "screen_2_horizontal_position": "屏幕 2 水平位置",
        "track_mysterious_dark_background": "神秘黑暗背景",
        "track_acoustic_ambient_inspiration": "原声环境灵感",
        "track_aristocracy_classical": "贵族古典",
        "track_folk_music_river_knows_my_name": "民谣音乐 - 河流知道我的名字",
        "track_funy_adventure": "有趣冒险",
        "track_energetic_sports_rock_trailer": "充满活力的体育摇滚预告片",
        "track_fun_upbeat_energetic_pop_rock": "有趣的欢快充满活力的流行摇滚",
        "track_epic_emotional_inspirational": "史诗般的情感激励",
        "track_inspirational_epic": "激励史诗",
        "all_music": "所有音乐",
        "energetic_music": "充满活力",
        "inspirational_music": "鼓舞人心",
        "ambient_music": "环境音乐",
        "chill_music": "轻松",
        "hiphop_music": "嘻哈",
        "quirky_music": "古怪",
        "dramatic_music": "戏剧性",
        "acoustic_music": "原声",
        "classical_music": "古典",
        "categories": "类别",
        "select_track": "选择音轨",
        "upload_music": "上传音乐",
        "my_music": "我的音乐",
        "downloading": "下载中...",
        "download_again": "重新下载",
        "download": "下载",
        "download_failed_alert": "下载视频失败。请重试。",
        "translate_subtitles": "翻译字幕",
        "translate_to": "翻译到",
        "select_language": "选择语言",
        "select_new_language": "选择新语言",
        "translating": "翻译中...",
        "translation_complete": "翻译完成",
        "error_translation": "翻译时出错。请重试。",
        "original_language": "原始"
      }
    },
    "generated": {
      "episode": {
        "episode.title": "剧集标题"
      },
      "episodelist": {
        "userPodcastsInfo.noContent": "您还没有任何内容。",
        "userPodcastsInfo.generateContent": "生成您的第一个内容",
        "placeholder.search_folders": "搜索文件夹...",
        "search.no_results": "没有文件夹匹配您的搜索。"
      },
      "landingPageModal": {
        "upload.error": "上传图片失败：",
        "upload.image.file": "请上传一张图片文件。",
        "upgrade.pro.message": "页面自定义仅适用于专业和代理账户",
        "upgrade.now": "立即升级",
        "upgrade.unique.landing.page": "并创建一个独特的剧集着陆页。",
        "logo.recommendation": "推荐的logo高度为200px",
        "social.links.top.menu": "顶部菜单的社交链接",
        "linkedin.label": "领英",
        "linkedin.placeholder": "输入领英链接",
        "facebook.label": "Facebook",
        "facebook.placeholder": "输入Facebook链接",
        "saving...": "保存中...",
        "save": "保存",
        "saved.successfully": "保存成功！",
        "uploading.image": "正在上传图片...",
        "upload.episode.cover": "上传剧集封面",
        "upload.logo": "上传Logo",
        "where.listen.episode": "我们还可以在哪里收听这个剧集？",
        "youtube.label": "YouTube",
        "youtube.placeholder": "输入YouTube链接",
        "apple.podcast.label": "Apple Podcasts",
        "apple.podcast.placeholder": "输入Apple Podcasts链接",
        "spotify.label": "Spotify",
        "spotify.placeholder": "输入Spotify链接",
        "image.size.recommendation": "推荐尺寸为1000x1000px",
        "primary.color.label": "主色",
        "header.background.color": "页眉背景色和链接。",
        "landing.page.customization": "着陆页自定义",
        "create.branded.landing.page": "创建一个美观的品牌着陆页与您的听众分享",
        "episode.image": "剧集图片",
        "episode.links": "剧集链接",
        "page.header": "页面标题",
        "page.color": "页面颜色",
        "visit.landing.page": "访问着陆页"
      },
      "page": {
        "loading.dashboard": "加载仪表板",
        "convert.new.episode": "转换新剧集",
        "convert.audio.or.video": "转换音频或视频",
        "minutes.left": "您还有",
        "need.more.minutes": "需要更多分钟吗？",
        "upgrade.plan": "在这里升级您的计划。",
        "your.podcasts": "您的播客",
        "podsqueeze.results.page": "Podsqueeze 结果页面",
        "access.podsqueeze.results": "访问此剧集的 podsqueeze 结果。您将能够查看所有生成的内容"
      },
      "podcast": {
        "confirm.delete_episode": "您确定要删除此集吗？",
        "alert.something_wrong": "出现了问题。请再试一次。",
        "confirm.delete_folder": "您确定要删除此文件夹吗？",
        "loading.episodes": "正在加载剧集...",
        "folder.empty": "此文件夹为空。",
        "content.no_content": "没有可用内容。",
        "content.generate_first": "生成您的第一期播客。",
        "button.personalize_ai": "与 AI 个性化",
        "button.edit_website": "编辑网站",
        "button.visit_website": "访问网站",
        "button.generate_website": "生成网站",
        "placeholder.search": "搜索...",
        "label.sort_by": "排序方式",
        "label.last_episodes_loaded": "最后加载的剧集",
        "button.load_all_episodes": "加载所有剧集",
        "loading": "加载中...",
        "add.new.episode": "添加新剧集",
        "order.newest": "最新优先",
        "order.oldest": "最旧优先",
        "order.a_to_z": "A 到 Z",
        "order.z_to_a": "Z 到 A"
      },
      "podcastFolderCreateModal": {
        "create.new.podcast.folder": "创建一个新的播客文件夹：",
        "folder.name.placeholder": "文件夹名称",
        "create.button": "创建"
      },
      "podcastLandingModal": {
        "upload.image.error": "请上传一个图像文件",
        "podcast.cover.title": "播客封面图像",
        "podcast.cover.upload": "在此上传您的播客封面图像。它将在您的登录页面上显著显示。",
        "upload.image.uploading": "正在上传图像...",
        "podcast.cover.upload.button": "上传封面图像",
        "podcast.cover.recommended.size": "推荐尺寸：1400x1400 像素",
        "profile.info.title": "个人信息",
        "profile.info.upload": "添加您的个人头像和姓名，以个性化您的登录页面。",
        "profile.upload.button": "上传个人头像",
        "profile.name.label": "个人名称",
        "profile.name.placeholder": "输入您的姓名",
        "platform.links.title": "平台链接",
        "platform.links.upload": "添加您播客在各个平台上的链接。",
        "platform.links.youtube_link": "YouTube 链接",
        "platform.links.youtube_link.placeholder": "输入 YouTube 链接",
        "platform.links.spotify_link": "Spotify 链接",
        "platform.links.spotify_link.placeholder": "输入 Spotify 链接",
        "platform.links.apple_podcast_link": "Apple Podcast 链接",
        "platform.links.apple_podcast_link.placeholder": "输入 Apple Podcast 链接",
        "platform.links.linkedin_link": "LinkedIn 链接",
        "platform.links.linkedin_link.placeholder": "输入 LinkedIn 链接",
        "platform.links.facebook_link": "Facebook 链接",
        "platform.links.facebook_link.placeholder": "输入 Facebook 链接",
        "platform.links.twitter_link": "Twitter 链接",
        "platform.links.twitter_link.placeholder": "输入 Twitter 链接",
        "call.to.action.title": "行动号召",
        "call.to.action.upload": "为登录页面设置您的行动号召按钮。",
        "call.to.action.button.text.label": "按钮文本",
        "call.to.action.button.text.placeholder": "输入按钮文本",
        "call.to.action.button.link.label": "按钮链接",
        "call.to.action.button.link.placeholder": "输入按钮链接",
        "color.styles.title": "颜色样式",
        "color.styles.upload": "自定义您的登录页面颜色。",
        "color.styles.primary.label": "主色",
        "color.styles.primary.description": "选择您的登录页面的主色",
        "color.styles.secondary.label": "次色",
        "color.styles.secondary.description": "选择您的登录页面的次色",
        "podcast.info.title": "播客信息",
        "podcast.info.upload": "编辑您的播客详细信息。",
        "podcast.info.name.label": "播客名称",
        "podcast.info.name.placeholder": "输入播客名称",
        "podcast.info.description.label": "播客描述",
        "podcast.info.description.placeholder": "输入播客描述",
        "edit.website.title": "编辑网站",
        "generate.website.title": "生成网站",
        "for": "为",
        "saving": "保存中...",
        "save.changes": "保存更改",
        "generate.website": "生成网站",
        "changes.saved.success": "更改成功保存！",
        "podcast.cover.menu": "播客封面",
        "podcast.info.menu": "播客信息",
        "profile.menu": "个人资料",
        "platform.links.menu": "平台链接",
        "call.to.action.menu": "行动号召",
        "color.styles.menu": "颜色样式",
        "logo.menu": "Logo",
        "logo.title": "Logo Uploaden",
        "logo.upload": "Upload hier je podcast logo. Dit logo wordt weergegeven op je landingspagina.",
        "logo.upload.button": "Logo Uploaden",
        "platform.links.description": "Voeg links naar je podcast op verschillende platforms toe.",
        "social.links.menu": "Sociale Links",
        "social.links.title": "Sociale Media Links",
        "social.links.description": "Voeg links naar je sociale media profielen toe.",
        "social.links.linkedinLink": "LinkedIn",
        "social.links.linkedinLink.placeholder": "Voer LinkedIn-link in",
        "social.links.facebookLink": "Facebook",
        "social.links.facebookLink.placeholder": "Voer Facebook-link in",
        "social.links.twitterLink": "Twitter",
        "social.links.twitterLink.placeholder": "Voer Twitter-link in",
        "social.links.instagramLink": "Instagram",
        "social.links.instagramLink.placeholder": "Voer Instagram-link in",
        "social.links.youtubeLink": "YouTube",
        "social.links.youtubeLink.placeholder": "Voer YouTube-link in",
        "social.links.spotifyLink": "Spotify",
        "social.links.spotifyLink.placeholder": "Voer Spotify-link in",
        "social.links.applePodcastLink": "Apple Podcast",
        "social.links.applePodcastLink.placeholder": "Voer Apple Podcast-link in",
        "view.website": "查看网站"
      },
      "podcastMoveModal": {
        "move.episode.label": "将此剧集移动到：",
        "move.episode.instruction": "您可以输入新名称以创建文件夹。",
        "move.episode.button": "移动",
        "move.episode.error.selectFolder": "请选择一个文件夹来移动剧集。"
      },
      "podcastTuneAiModal": {
        "ai.settings.title": "{{podcastTitle}} 播客的 AI 设置",
        "ai.customize.writing.style": "自定义您的 AI 写作风格",
        "ai.content.writing.preference": "您希望 Podsqueeze 如何撰写您的内容？",
        "ai.voice.placeholder": "示例：专业但友好的语气。听众是播客主持人。使用第一人称写作。",
        "ai.character.limit.reached": "您已达到 50 个字符的限制。",
        "ai.upgrade.now": "立即升级",
        "ai.fix.transcript.misspells": "修正转录中的拼写错误",
        "ai.enter.misspelled.words": "写下 AI 在这些播客剧集中特别容易拼错的单词，例如名字",
        "ai.enter.word.press.enter": "输入一个单词并按回车",
        "ai.add.word": "添加单词",
        "ai.tag.limit.reached": "已达到 1 个标签的限制。",
        "ai.save": "保存",
        "ai.save.close": "保存并关闭"
      },
      "selectedepisode": {
        "selectedEpisode.title": "剧集标题",
        "selectedEpisode.podcastName": "播客名称",
        "selectedEpisode.showNotes": "节目说明",
        "selectedEpisode.timestamp": "时间戳",
        "selectedEpisode.staticTimestamp": "静态时间戳",
        "selectedEpisode.mentions": "提及",
        "selectedEpisode.newsletter": "通讯",
        "selectedEpisode.titles": "标题",
        "selectedEpisode.tweeter": "推特用户",
        "selectedEpisode.shortPost": "短文",
        "selectedEpisode.transcription": "转录",
        "selectedEpisode.srt": "SRT",
        "selectedEpisode.keywords": "关键词",
        "selectedEpisode.quotes": "引用",
        "selectedEpisode.longPost": "长文",
        "selectedEpisode.bulletPoints": "要点",
        "selectedEpisode.publicLink": "公开链接",
        "selectedEpisode.embeddedId": "嵌入ID",
        "selectedEpisode.episodeUrl": "剧集链接"
      },
      "sidebar": {
        "tools": "工具",
        "find.podcast.topic.ideas": "寻找播客主题创意",
        "podcast.thumbnail.maker": "播客缩略图制作工具",
        "podcast.seo.optimizer": "播客SEO优化工具",
        "account": "账户",
        "payment.settings": "支付设置",
        "support": "支持",
        "logout": "登出",
        "plan": "计划",
        "resets.in": "重置在",
        "api.access": "API访问",
        "days": "天和",
        "hours": "小时",
        "upgrade.plan": "升级计划"
      },
      "updateEmailModal": {
        "email.validation.error": "请输入有效的电子邮件地址。",
        "email.change.confirm": "您确定要更改您的电子邮件地址吗？",
        "email.change.success": "您的电子邮件已成功更改！",
        "email.in.use.error": "此电子邮件已在使用中。请尝试其他电子邮件。",
        "email.recent.login.error": "在继续此操作之前，请使用当前电子邮件地址重新登录。",
        "email.invalid.error": "无效的电子邮件地址。请尝试其他电子邮件。",
        "subscription.cancel.error": "请先取消您当前的付费订阅。",
        "account.delete.confirm": "您确定要删除您的帐户吗？\n\n此操作无法撤销。",
        "account.delete.success": "您的帐户已成功删除。",
        "account.delete.error": "出现问题，我们无法删除您的帐户。\n\n请联系用户支持。",
        "subscription.cancel": "取消订阅",
        "account.delete": "删除帐户",
        "account.delete.warning": "删除您的帐户是不可逆的，将永久删除您所有的内容和登录信息。请谨慎操作，因为此操作无法撤销。",
        "current.account.email": "当前帐户电子邮件",
        "enter.new.email": "输入您的新帐户电子邮件",
        "update": "更新",
        "change.password": "更改密码",
        "payment.settings": "支付设置"
      }
    },
    "generator": {
      "episode": {
        "episode.title": "剧集标题"
      },
      "episodelist": {
        "loading.episodes": "加载剧集",
        "no.episodes.found": "未找到剧集。请尝试使用有效的 RSS ID 再次搜索",
        "select.episode": "选择您想要创建内容的剧集"
      },
      "interfaces": {
        "user.activePlan.tier": "等级",
        "user.activePlan.creationDate": "创建日期",
        "user.activePlan.minutesAvailable": "可用分钟数"
      },
      "loadingbar": {
        "loadingbar.magic": "我们仍在施展魔法 ✨",
        "loadingbar.longer": "有些剧集需要稍微久一点... 🐌",
        "loadingbar.hardwork": "我们的服务器正在努力工作 🦾"
      },
      "page": {
        "main.background": "主组件的背景"
      },
      "recordfile": {
        "microphone.camera.access.denied": "错误：访问麦克风或相机被拒绝。",
        "microphone.camera.not.found": "错误：未找到麦克风或相机。",
        "microphone.camera.not.readable": "错误：麦克风或相机不可读取。",
        "microphone.camera.access.error": "错误：访问麦克风或相机时发生未知错误。",
        "media.not.recorded": "错误：未录制任何媒体。",
        "upload.failed": "错误：上传失败。",
        "upload.success": "成功：上传完成。",
        "upload.in.progress": "上传进行中...",
        "upload.button": "上传录音",
        "stop.recording": "停止录音",
        "record.audio": "录制音频",
        "record.audio.video": "录制音频和视频",
        "record.again": "录制再次",
        "episode.language": "选择剧集语言"
      },
      "selectBox": {
        "language.english": "英语",
        "language.arabic": "阿拉伯语",
        "language.bulgarian": "保加利亚语",
        "language.catalan": "加泰罗尼亚语",
        "language.croatian": "克罗地亚语",
        "language.czech": "捷克语",
        "language.danish": "丹麦语",
        "language.dutch": "荷兰语",
        "language.finnish": "芬兰语",
        "language.french": "法语",
        "language.german": "德语",
        "language.greek": "希腊语",
        "language.hindi": "印地语",
        "language.hungarian": "匈牙利语",
        "language.indonesian": "印尼语",
        "language.italian": "意大利语",
        "language.japanese": "日语",
        "language.korean": "韩语",
        "language.lithuanian": "立陶宛语",
        "language.latvian": "拉脱维亚语",
        "language.malay": "马来语",
        "language.mandarin": "普通话",
        "language.norwegian": "挪威语",
        "language.polish": "波兰语",
        "language.portuguese": "葡萄牙语",
        "language.romanian": "罗马尼亚语",
        "language.russian": "俄语",
        "language.slovak": "斯洛伐克语",
        "language.slovenian": "斯洛文尼亚语",
        "language.spanish": "西班牙语",
        "language.swedish": "瑞典语",
        "language.tamil": "泰米尔语",
        "language.turkish": "土耳其语",
        "language.ukrainian": "乌克兰语",
        "language.bashkir": "巴什基尔语",
        "language.basque": "巴斯克语",
        "language.belarusian": "白俄罗斯语",
        "language.cantonese": "粤语",
        "language.esperanto": "世界语",
        "language.estonian": "爱沙尼亚语",
        "language.galician": "加利西亚语",
        "language.interlingua": "国际语",
        "language.marathi": "马拉地语",
        "language.mongolian": "蒙古语",
        "language.persian": "波斯语",
        "language.thai": "泰语",
        "language.uyghur": "维吾尔语",
        "language.vietnamese": "越南语",
        "language.welsh": "威尔士语"
      },
      "selectedepisode": {
        "processing.episode": "正在处理剧集",
        "processing.time": "通常需要 5 - 10 分钟",
        "email.notification": "您可以关闭此窗口。我们会在准备好后向您发送电子邮件。您的内容也将在您的仪表板上可用。",
        "convert.another.episode": "转换另一个剧集",
        "technical.difficulties": "哎呀！我们遇到了一些技术困难。请放心，我们的团队正在处理此事！请稍后再试。",
        "no.discount": "别担心，我们不会折扣任何分钟！",
        "high.demand": "我们正在经历高于正常水平的需求，因此处理您的请求可能会比平时更长。对此造成的任何不便，我们深表歉意！",
        "email.ready": "一旦准备好，我们会向您发送电子邮件。您也可以在您的仪表板上访问您的结果。",
        "select.podcast.folder": "选择此剧集所属的播客文件夹，或通过输入名称创建一个新文件夹。",
        "give.voice": "自定义文件夹的声音",
        "generate.content": "生成内容",
        "not.enough.minutes.title": "您没有足够的分钟",
        "not.enough.minutes.message": "您没有足够的分钟来转换此剧集。请更新您的计划。",
        "upgrade.plan": "更新我的计划",
        "convert.shorter.episode": "转换更短的剧集",
        "content.ready": "您的内容已准备好！",
        "ask.ai.tune": "您仍然可以要求 AI 调整每个内容，以更好地满足您的需求。",
        "error.title": "错误",
        "convert.another.file": "转换另一个文件"
      },
      "submitfile": {
        "file.size.exceeded.free": "文件大小超过最大限制4 GB。<p>请 <a href='/pricing'><b><u>升级以上传更大的文件</u></b></a></p>",
        "file.size.exceeded.paid": "文件大小超过最大限制10 GB。<p>请选取一个更小的文件。</p>",
        "file.upload.invalid": "请上传音频或视频文件",
        "upload.in.progress": "正在上传文件。请不要关闭此窗口。",
        "upload.button": "上传 & 生成",
        "close.button": "关闭",
        "upgrade.message.free": "更多上传仅适用于付费套餐。",
        "upgrade.now.button": "立即升级",
        "pricing.info": "起价$12/月",
        "upload.file.label": "上传音频或视频文件",
        "max.file.size.free": "(最大4 GB)",
        "max.file.size.paid": "(最大10 GB)",
        "podsqueeze.audiograms.info": "Podsqueeze将为音频文件生成音频图和为视频文件生成短片",
        "file.placeholder": "您的MP3/WAV文件",
        "episode.language.label": "剧集语言",
        "select.folder.label": "选择或创建文件夹",
        "multiple.files.selected": "已选择{{count}}个文件",
        "clear.all": "清除全部",
        "file.name": "{{name}}",
        "multiple.files.toggle": "选择多个文件",
        "file.upload.error": "文件上传错误",
        "file.upload.success": "文件上传成功",
        "file.upload.processing": "正在处理文件",
        "click.to.upload": "点击上传",
        "click.to.upload.multiple": "点击上传多个文件",
        "enter.url": "输入URL",
        "upload.file": "上传文件",
        "media.url.label": "媒体URL",
        "media.url.help": "输入您的音频或视频文件的URL。我们将为您下载并处理它。",
        "url.placeholder": "https://example.com/podcast.mp3",
        "episode.name.label": "剧集名称",
        "url.input.required": "请输入媒体URL",
        "url.upload.error": "从URL上传媒体失败。请检查URL并重试。",
        "supported.formats": "支持的格式",
        "uploading": "上传中...",
        "media.url.requirements": "URL必须是指向公共媒体文件的直接链接（不是网页）"
      },
      "submitrssid": {
        "error.selectRss": "请选择下拉菜单中的有效RSS",
        "label.insertRssFeed": "插入您的RSS源",
        "placeholder.insertRssFeed": "插入您的RSS源",
        "label.searchByPodcast": "改为按播客名称搜索",
        "label.searchForPodcast": "搜索您的播客名称",
        "placeholder.searchForPodcast": "搜索播客",
        "label.cantFindPodcast": "找不到您的播客？",
        "label.clickHereUseRss": "点击这里使用您的RSS源",
        "label.selectedPodcast": "已选择的播客",
        "label.episodeLanguage": "剧集语言",
        "button.seeAllEpisodes": "查看所有剧集",
        "select.folder.label": "选择或创建文件夹"
      },
      "submitsection": {
        "search.podcast": "搜索您的播客",
        "upload.audio.video": "上传音频或视频",
        "record.audio": "录制音频",
        "youtube.video": "YouTube链接",
        "create.content": "让我们为您的播客创建内容！"
      },
      "submityoutube": {
        "placeholder.insertYouTubeUrl": "输入 YouTube 视频 URL",
        "error.insertYouTubeUrl": "请插入一个 YouTube URL。",
        "label.insertYouTubeUrl": "插入 YouTube URL",
        "button.loading": "加载中...",
        "message.downloadingFile": "下载文件中...",
        "error.processingFailed": "错误：处理视频失败。",
        "error.youtubeVideoNotAvailable": "此 YouTube 视频不可用于下载。请直接上传您的音频或视频到 Podsqueeze 或使用 YouTube 下载器 先。感谢您的耐心。",
        "button.submitYouTubeVideo": "提交 YouTube 视频",
        "select.folder.label": "选择或创建文件夹"
      },
      "tabs": {
        "tab.label.tab1": "标签 1",
        "tab.label.tab2": "标签 2",
        "tab.label.tab3": "标签 3"
      },
      "tutorialVideo": {
        "tutorial.title": "充分利用 Podsqueeze",
        "tutorial.chapter.introduction": "介绍",
        "tutorial.chapter.bestShowNotes": "获取最佳节目笔记和时间戳",
        "tutorial.chapter.blogPosts": "利用博客文章和新闻通讯",
        "tutorial.chapter.editingTranscripts": "嵌入和编辑转录",
        "tutorial.chapter.personalizingAI": "个性化 AI 并赋予您自己的声音",
        "tutorial.chapter.speedingUpNotes": "加快节目笔记的速度",
        "tutorial.chapter.creatingClips": "创建视频剪辑和图像",
        "tutorial.chapter.generatingLandingPage": "生成着陆页",
        "tutorial.chapter.shareResults": "与您的团队分享结果",
        "tutorial.closeVideoCheckbox": "首次结果准备好后关闭视频"
      },
      "uploadloadingbar": {
        "upload.loading": "加载中..."
      }
    },
    "home": {
      "conatctsection": {
        "contact.section.title": "联系我们",
        "contact.section.email": "通过 support@podsqueeze.com 给我们发送电子邮件",
        "contact.section.tiago.role": "联合创始人",
        "contact.section.joao.role": "联合创始人",
        "contact.section.image.alt.sendMessage": "发送消息",
        "contact.section.image.alt.tiago": "Podsqueeze 联合创始人 Tiago",
        "contact.section.image.alt.joao": "Podsqueeze 联合创始人 João"
      },
      "contactsection": {
        "contact.section.title": "联系我们",
        "contact.section.email": "通过 support@podsqueeze.com 给我们发送电子邮件",
        "contact.section.tiago.role": "联合创始人",
        "contact.section.joao.role": "联合创始人",
        "contact.section.image.alt.sendMessage": "发送消息",
        "contact.section.image.alt.tiago": "Podsqueeze 联合创始人 Tiago",
        "contact.section.image.alt.joao": "Podsqueeze 联合创始人 João"
      },
      "home-agenciessection": {
        "join.content.creators": "加入 20,000 名使用 Podsqueeze 的内容创作者和播客专业人士",
        "content.creators": "内容创作者",
        "podcast.managers": "播客经理",
        "producers.studios": "制作人和工作室",
        "for.podcasters": "为播客创作者、播客经理和代理机构服务",
        "manage.content.creation": "轻松管理内容创作",
        "multiple.podcasts": "多个播客",
        "podsqueeze.description": "Podsqueeze 是一款强大的工具，适用于所有播客专业人士。无论您是独立播客创作者、播客经理还是代理机构，Podsqueeze 提供您所需的所有功能，以简化播客内容创作工作流程。",
        "create.podcast.folders": "创建播客文件夹以保持您的剧集有序。",
        "share.content.page": "轻松与客户和团队分享您的内容页面",
        "tune.ai.voice": "为您管理的每个节目调整 AI 语音",
        "plan.content.episodes": "使用我们的高级播客主题查找器规划下一集的内容",
        "podcast.topics.finder": "播客主题查找器",
        "podsqueeze.testimonial": "Podsqueeze 能够使用提示调整我们管理的每个播客的内容并将其保存以供未来剧集使用，使我们能够保持每个节目的声音一致。这是我们在其他工具中找不到的精英功能。",
        "coo.podigy": "Podigy 播客的首席运营官",
        "agenciessection.joinCreators": "加入 20,000 名使用 Podsqueeze 的内容创作者和播客专业人士",
        "agenciessection.contentCreators": "内容创作者",
        "agenciessection.podcastManagers": "播客经理",
        "agenciessection.producersStudios": "制作人和工作室",
        "agenciessection.forPodcasters": "为播客创作者、播客经理和代理机构服务",
        "agenciessection.manageContent": "轻松管理内容创作",
        "agenciessection.multiplePodcasts": "多个播客",
        "agenciessection.podsqueezeDescription": "Podsqueeze 是一款强大的工具，适用于所有播客专业人士。无论您是独立播客创作者、播客经理还是代理机构，Podsqueeze 提供您所需的所有功能，以简化播客内容创作工作流程。",
        "agenciessection.createPodcastFolders": "创建播客文件夹以保持您的剧集有序。",
        "agenciessection.shareContent": "轻松与客户和团队分享您的内容页面",
        "agenciessection.tuneAI": "为您管理的每个节目调整 AI 语音",
        "agenciessection.planContent": "使用我们的高级播客主题查找器规划下一集的内容",
        "agenciessection.podcastTopicsFinder": "播客主题查找器",
        "agenciessection.podsqueezeQuote": "Podsqueeze 能够使用提示调整我们管理的每个播客的内容并将其保存以供未来剧集使用，使我们能够保持每个节目的声音一致。这是我们在其他工具中找不到的精英功能。",
        "agenciessection.coO": "Podigy 播客的首席运营官"
      },
      "home-audioeditsection": {
        "new.feature": "新功能",
        "seamless.editing": "无缝编辑和音频增强，带来自然的",
        "high.quality.results": "高质量结果",
        "experience.seamless.audio.editing": "体验无缝音频编辑，使用先进的AI算法录制顶级音频。",
        "remove.ums": "去除“呃”",
        "enhance.sound.quality": "，静音，并仅需一键即可增强音质。",
        "enhance.audio.now": "立即增强音频",
        "sample.audio.recorded": "样本音频，直接从手机录制。",
        "original.recording": "原始录音",
        "audio.after.ai.edit": "AI编辑和增强后的音频",
        "experience.audio.editing": "体验无缝音频编辑，使用先进的AI算法录制顶级音频。"
      },
      "home-blogsection": {
        "more.resources.label": "更多资源供您的播客使用",
        "learn.how.to.get.most": "了解如何充分利用",
        "your.content": "您的内容",
        "get.most.out.of.ai.content": "充分利用AI生成的内容为您的播客服务",
        "welcome.to.podsqueeze": "欢迎来到Podsqueeze – 转录您的播客并创建引人入胜内容的最简单方式...",
        "will.google.penalize.ai.content": "谷歌会惩罚您的AI生成内容吗？",
        "ai.content.discussion": "AI生成内容的出现引发了内容创作者、营销人员和SEO之间的讨论和担忧...",
        "what.is.rss.feed": "播客的RSS订阅源是什么以及如何使用",
        "rss.feed.benefits": "作为播客主，您可能听说过“RSS订阅源”这个术语，但您可能不太清楚它是什么或它能带来什么好处...",
        "visit.blog": "访问博客"
      },
      "home-clipssection": {
        "clipsAndAudiograms.title": "剪辑与音频图",
        "clipsAndAudiograms.subtitle": "轻松将您的播客转化为剪辑",
        "clipsAndAudiograms.description": "只需选择您节目的一个章节，并将其导出为适用于 TikTok、Instagram 和 YouTube Shorts 的剪辑或音频图。选择一个模板，调整到您自己的风格。",
        "clipsAndAudiograms.createClips": "立即创建剪辑",
        "textEditor.title": "基于文本的编辑器",
        "textEditor.description": "直接从字幕中微调您的剪辑和音频图。编辑字幕并通过删除特定单词来修剪视频。",
        "oneClickShorts.title": "一键短视频（<60秒）",
        "oneClickShorts.description": "让 AI 为您处理编辑。只需按一下按钮，AI 将把您节目的每个章节缩短到 60 秒以内，准备发布为 YouTube Shorts 或 TikTok 剪辑。"
      },
      "home-conatctsection": {
        "contact.section.title": "联系创始人",
        "contact.section.email": "team@podsqueeze.com",
        "contact.section.tiago.role": "- 开发者 & 播客",
        "contact.section.joao.role": "- 用户体验/用户界面设计师"
      },
      "home-contentexplanation": {
        "wide.variety.content": "丰富多样的内容",
        "generate.content": "一键生成内容",
        "one.click": " 一键完成！",
        "transcript.srt": "文字稿与SRT",
        "transcript.description": "获取您播客节目的完整文字稿，以及一个准备好生成字幕和翻译的SRT文件。",
        "show.notes": "节目笔记",
        "show.notes.description": "总结您节目中涵盖的主要主题，使其更易于搜索",
        "timestamps": "时间戳",
        "timestamps.description": "创建带有时间戳的章节，引导听众到您播客节目的特定片段",
        "blog.social.posts": "博客与社交帖子",
        "blog.social.posts.description": "在各处发布关于您播客节目的内容，吸引新听众",
        "newsletter": "通讯",
        "newsletter.description": "让您的听众及时了解新剧集",
        "titles.more": "标题及更多！",
        "titles.more.description": "生成引人注目的标题、引用、要点、关键词等！",
        "see.sample.content": "查看示例内容",
        "wannabe.entrepreneur": "想当企业家 - #299 Podsqueeze 刚刚达到10万美元的年收入！",
        "making.space": "创造空间 - 史蒂夫·哈维：“你不妨继续前进”",
        "modern.wisdom": "现代智慧 - 埃里克·霍尔 - 心灵基本奥秘指南"
      },
      "home-divider": {
        "divider.border": " ",
        "divider.line": "分隔线"
      },
      "home-explanationsection": {
        "fast.accurate": "快速且准确",
        "generate.content": "使用以下内容为您的播客生成内容",
        "power.of.ai": "人工智能的力量",
        "upload.image.alt": "上传图片",
        "select.episode": "从您的 RSS 源中选择一集或上传音频/视频文件",
        "paste.rss.feed": "只需粘贴您的 RSS 源 URL，即可从列表中选择一集或上传音频或视频文件。",
        "content.image.alt": "内容图片",
        "one.click.content": "一键获取所有内容！",
        "user.friendly.interface": "直观且用户友好的界面，您可以立即开始使用。只需一键即可为您的播客生成内容。",
        "tune.image.alt": "调音图片",
        "edit.fine.tune": "编辑和微调每个内容",
        "direct.edit.content": "直接编辑和微调每个内容以满足您的喜好，使用人工智能。例如，您可以要求特定的语气、直接或间接的讲话，或简单地纠正拼写错误的名字。",
        "multiple.language.support": "多语言支持",
        "language.flags.alt": "语言旗帜",
        "generate.content.aria": "生成内容"
      },
      "home-featuressection": {
        "loading": "加载中...",
        "transcribe.write.show.notes": "为您的播客转录并撰写节目笔记",
        "twenty.times.faster": "快20倍",
        "save.manual.work": "节省高达100%的手动工作。以最先进的准确性和说话者标记自动转录您的播客，并生成完整的节目笔记和社交媒体帖子，使用您自己的声音。",
        "generate.content": "生成内容",
        "transcripts": "转录文本",
        "full.transcript": "获取您播客集和YouTube视频转录的完整文本，以及用于字幕的SRT文件。",
        "show.notes": "节目笔记",
        "summarize.generate.show.notes": "总结并生成您自己的声音的节目笔记，包含时间戳、要点和提及。",
        "blog.newsletter": "博客和通讯",
        "actionable.blog.posts": "获取关于您节目的可操作博客文章和准备发送的通讯，包含主要要点。",
        "social.media": "社交媒体",
        "short.posts.insights": "获取简短的帖子和简明的见解，以在社交媒体上传播信息。",
        "quote": "在我们测试的所有最佳AI转录工具中，Podsqueeze生成了最有用的节目笔记、时间戳、标题、提及、示例博客文章和关键引用。",
        "justin.jackson": "贾斯廷·杰克逊",
        "cofounder.transistor": "Transistor.fm的联合创始人",
        "transcribe_and_write_show_notes": "播客转录、摘要和社交媒体帖子",
        "twenty_times_faster": "快20倍",
        "save_manual_work": "节省高达100%的手动工作。以最先进的准确性和说话者标记自动转录您的播客，并生成完整的节目笔记和社交媒体帖子，使用您自己的声音。",
        "generate_content": "生成内容",
        "full_transcript": "获取您播客集和YouTube视频转录的完整文本，以及用于字幕的SRT文件。",
        "show_notes": "节目笔记",
        "summarize_and_generate_show_notes": "总结并生成您自己的声音的节目笔记，包含时间戳、要点和提及。",
        "blog_and_newsletter": "博客和通讯",
        "actionable_blog_posts": "获取关于您节目的可操作博客文章和准备发送的通讯，包含主要要点。",
        "social_media": "社交媒体",
        "short_posts_and_insights": "获取简短的帖子和简明的见解，以在社交媒体上传播信息。",
        "testimonial": "在我们测试的所有最佳AI转录工具中，Podsqueeze生成了最有用的节目笔记、时间戳、标题、提及、示例博客文章和关键引用。",
        "cofounder_transistor": "Transistor.fm的联合创始人"
      },
      "home-page": {
        "main.background": "主组件的背景颜色"
      },
      "home-podcastvideosection": {
        "podcast.section.title": "收听我们的播客",
        "podcast.section.subtitle": "来自",
        "podcast.section.highlight": "经验丰富的播客主持人",
        "podcast.section.description": "收听我们的播客，我们采访来自世界各地的经验丰富的播客主持人和Podsqueeze用户。我们请他们分享他们的技巧、见解、故事，以及您需要了解的一切，以便发展自己的播客。",
        "podcast.link.spotify": "在Spotify上收听",
        "podcast.link.apple": "在Apple Podcasts上收听",
        "podcast.link.youtube": "在YouTube上收听"
      },
      "home-spinner": {
        "spinner.loading": "加载中..."
      },
      "home-tagline": {
        "tagline.automatePodcast": "自动化您的播客",
        "tagline.productionPromotion": "制作与推广",
        "tagline.launchGrow": "借助 AI 的帮助，轻松启动和发展您的音频或视频播客，所有所需功能尽在一处。",
        "tagline.uploadGenerate": "轻松生成播客转录、摘要、带有字幕的短片等!",
        "tagline.singleClick": "一键完成。",
        "tagline.transcripts": "播客转录",
        "tagline.showNotes": "节目笔记",
        "tagline.newslettersBlogs": "新闻通讯与博客",
        "tagline.socialPosts": "社交帖子",
        "tagline.shortClipsAudiograms": "短片与音频图",
        "tagline.podcastWebsite": "播客网站",
        "tagline.aiAudioEnhancement": "AI 音频增强",
        "tagline.removeSilences": "去除沉默和呃声",
        "tagline.generateNow": "立即免费生成",
        "tagline.noCreditCard": "无需信用卡",
        "testimonial.robWalling.title": "Rob Walling，创业专家",
        "testimonial.robWalling.subtitle": "为我们所有人服务的创业播客",
        "testimonial.robWalling.quote": "Podsqueeze 的节目笔记是最好的。我们经常用它来总结和获取其他播客的见解。",
        "testimonial.johnGarmet.title": "John Garmet，运营总监",
        "testimonial.johnGarmet.subtitle": "Heard Media",
        "testimonial.johnGarmet.quote": "Podsqueeze 帮助我们提高效率，为客户生成更多内容。我们强烈推荐它。",
        "testimonial.davidJackson.title": "David Jackson，播客教练",
        "testimonial.davidJackson.subtitle": "播客学院",
        "testimonial.davidJackson.quote": "Podsqueeze 是我的头脑风暴伙伴。它是制定播客营销的最佳方式。"
      },
      "home-testimonials": {
        "testimonials.title": "人们对 Podsqueeze 的评价",
        "testimonials.image.alt": "Podsqueeze - 使用 AI 重新利用您的播客内容 | Product Hunt",
        "testimonials.heading": "人们对 Podsqueeze 的评价"
      }
    },
    "login": {
      "loginForm": {
        "error.incorrectPassword": "密码错误",
        "error.userNotFound": "用户未找到",
        "error.somethingWentWrong": "哎呀，出了点问题",
        "button.sendResetEmail": "发送重置邮件",
        "button.login": "登录",
        "placeholder.email": "电子邮件地址",
        "placeholder.password": "密码",
        "link.forgotPassword": "忘记密码？",
        "link.createAccount": "创建账户",
        "text.or": "或",
        "button.continueWithGoogle": "使用谷歌继续",
        "text.podcastDescription": "轻松启动和发展您的音频或视频播客，所需的一切尽在一个地方。",
        "feature.transcripts": "文字记录",
        "feature.showNotes": "节目笔记",
        "feature.newslettersAndBlogs": "新闻通讯和博客",
        "feature.socialPosts": "社交帖子",
        "feature.shortClipsAndAudiograms": "短片和音频图",
        "feature.podcastWebsite": "播客网站",
        "feature.aiAudioEnhancement": "AI音频增强",
        "feature.removeSilences": "去除沉默和呃声",
        "button.sendVerificationEmail": "发送验证邮件",
        "error.emailNotVerified": "电子邮件未验证",
        "text.pleaseVerifyAccount": "请验证您的账户",
        "text.checkSpamFolder": "我们已向您发送了验证邮件。请检查您的邮箱和垃圾邮件文件夹。",
        "button.resendVerificationEmail": "重新发送验证邮件",
        "error.verificationEmailFailed": "发送验证邮件失败。请再试一次。"
      },
      "page": {
        "login.form": "登录表单"
      }
    },
    "pages": {
      "affiliates": {
        "affiliate.page.title": "Podsqueeze 联盟页面",
        "affiliate.page.description": "通过您的专属推荐链接，每笔销售可赚取 25% 的佣金，持续 15 个月。可以在您的网站、社交媒体或与朋友分享您的链接。加入只需几秒钟。自动获得批准。"
      },
      "best-gift-for-a-podcaster": {
        "bestGiftForPodcaster.title": "播客主持人的最佳礼物",
        "bestGiftForPodcaster.description": "发现提升播客主持人体验的最佳礼物。",
        "bestGiftForPodcaster.href": "https://podsqueeze.com/best-gift-for-a-podcaster/"
      },
      "get-more-podcast-listeners": {
        "get-more-podcast-listeners.title": "获取更多播客听众",
        "get-more-podcast-listeners.description": "获取更多播客听众，并通过自动生成节目笔记、短视频片段来简化制作，以在社交媒体上推广您的节目，还有更多功能。"
      },
      "grow-your-podcast-audience": {
        "grow_your_podcast_audience.title": "扩大您的播客受众",
        "grow_your_podcast_audience.description": "使用 Podsqueeze 节省大量时间并扩大您的播客受众。为您的播客生成完整的节目笔记、社交媒体帖子、短片等。"
      },
      "index": {
        "home.page.title": "AI 播客节目笔记、转录、摘要和剪辑生成器。",
        "home.page.description": "一键生成播客的节目笔记、时间戳、通讯等内容！快速为您的播客生成内容，并根据您的需求进行调整。免费注册。"
      },
      "login": {
        "login.tryItNow": "立即尝试！",
        "login.createAccountDescription": "创建一个账户，轻松生成播客的显示笔记、时间戳、新闻通讯等内容！快速为您的播客生成内容，并根据您的需求进行调整。免费注册。"
      },
      "marketing-for-podcasts": {
        "marketing.for.podcasts.title": "播客营销",
        "marketing.for.podcasts.description": "Podsqueeze 通过自动生成的节目笔记、社交媒体帖子和短视频片段来简化播客的营销，帮助您扩大影响力并发展您的节目。"
      },
      "media": {
        "media.page.title": "Podsqueeze 媒体页面",
        "media.page.description": "了解更多关于 Podsqueeze 的信息。与我们联系！我们期待合作！"
      },
      "podcast-description-generator": {
        "podcast.description.generator.title": "播客描述生成器",
        "podcast.description.generator.description": "通过AI生成的描述提升您播客的覆盖面和参与度。自动化您的节目笔记写作，重新获得宝贵的时间。"
      },
      "podcast-social-media-posts": {
        "repurpose.podcast.social.media.posts": "将您的播客重新利用为社交媒体帖子",
        "convert.podcast.episodes.to.social.media.posts": "将播客集转换为社交媒体帖子。自动为LinkedIn、Twitter、Facebook生成帖子，并为TikTok生成短视频片段。"
      },
      "podcast-topics-ideas": {
        "free.podcast.topics.generator": "免费播客主题生成器",
        "podcast.topics.generator.description": "我们的免费播客主题生成器可以帮助您找到最佳主题创意，并预测它们在 Google 和 YouTube 上的潜在覆盖率。"
      },
      "podcast-virtual-assistant": {
        "podcast.virtual.assistant.title": "您的播客虚拟助手",
        "podcast.virtual.assistant.description": "AI播客虚拟助手，撰写您的节目笔记并创建社交媒体帖子。通过Podsqueeze简化您的播客制作和营销。"
      },
      "pricing": {
        "pricing.title": "定价",
        "pricing.description": "只需一键即可为您的播客生成显示说明、时间戳、新闻通讯等！我们提供多个价格层级以满足您的播客需求。"
      },
      "promote-your-podcast": {
        "promote.your.podcast.title": "推广您的播客",
        "promote.your.podcast.description": "生成节目说明、社交媒体帖子和短视频，以便在几分钟内发布和推广您的播客。"
      },
      "register": {
        "create.podsqueeze.account": "创建 Podsqueeze 账户",
        "generate.content.podcast": "一键生成播客的展示说明、时间戳、新闻通讯等内容！快速为您的播客生成内容，并根据您的需求进行调整。免费注册。"
      },
      "repurpose-podcast-content": {
        "automatically.repurpose.podcast.content": "自动重新利用播客内容",
        "repurpose.your.podcast.content.with.ai": "使用人工智能重新利用您的播客内容。只需一键即可自动生成节目说明、标题、短视频剪辑（适用于 TikTok）等更多内容！"
      },
      "seo-optimizer": {
        "seo.optimizer.title": "免费播客SEO优化器",
        "seo.optimizer.description": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.heading": "Podcast SEO Optimizer",
        "seo.optimizer.headingnote": "Analyze and optimize your podcast episodes for better search engine visibility with AI-powered SEO recommendations.",
        "seo.optimizer.selectEpisode": "Select an Episode to Analyze",
        "seo.optimizer.results": "SEO Analysis Results",
        "seo.optimizer.searchPodcastPlaceholder": "Search for a podcast",
        "seo.optimizer.searchEpisodesPlaceholder": "Search episodes...",
        "seo.optimizer.analyseAnotherEpisode": "Analyse Another Episode",
        "seo.optimizer.findingEpisodes": "Finding all episodes...",
        "seo.optimizer.analysingEpisode": "Analysing Episode",
        "seo.optimizer.scoreTooltip": "Score:",
        "seo.optimizer.topKeywords": "We identified these Top Keywords:",
        "seo.optimizer.topKeywordsnote": "Based on the keyword analysis at the bottom of the page.",
        "seo.optimizer.optimizedContent": "Based on keywords here are the optimized title and description:",
        "seo.optimizer.originalTitle": "Original Title",
        "seo.optimizer.optimizedTitle": "Optimized Title",
        "seo.optimizer.originalDescription": "Original Description",
        "seo.optimizer.optimizedDescription": "Optimized Description",
        "seo.optimizer.showMore": "Show More",
        "seo.optimizer.showLess": "Show Less",
        "seo.optimizer.keywordAnalysis": "Keyword Analysis",
        "seo.optimizer.keywordAnalysisnote": "Scores are calculated based on search volume, competition (how many other results are there for the same keyword), and in the case of youtube, the average number of views per video under the same keyword.",
        "seo.optimizer.seoScore": "SEO Score",
        "seo.optimizer.spotifyScore": "Spotify Score",
        "seo.optimizer.youtubeScore": "YouTube Score",
        "seo.optimizer.totalScore": "Total"
      },
      "squeeze": {
        "podsqueeze.title": "Podsqueeze - AI 播客内容生成工具",
        "podsqueeze.description": "一键生成播客的节目单、时间戳、通讯等内容！快速为您的播客生成内容，并根据您的需求进行调整。免费注册。"
      },
      "thumbnail-creator": {
        "title": "免费播客缩略图生成器 - 创建AI驱动的节目缩略图",
        "description": "使用AI创建令人惊叹的播客缩略图。生成专业、引人注目的节目视觉效果，提高可见度并为您的播客吸引更多听众。",
        "selectPodcast": "选择您的播客",
        "loadEpisodes": "加载节目",
        "selectEpisode": "选择节目创建缩略图",
        "createThumbnail": "创建缩略图",
        "results": "您生成的缩略图",
        "download": "下载",
        "share": "分享",
        "regenerate": "重新生成",
        "editThumbnail": "编辑缩略图",
        "editPlaceholder": "描述您希望如何修改此缩略图...",
        "customPrompt": "自定义提示",
        "yourThumbnail": "您的缩略图",
        "createAnother": "← 创建其他缩略图",
        "findingEpisodes": "查找节目中...",
        "searchPodcastPlaceholder": "搜索您的播客...",
        "searchingPodcasts": "搜索播客中...",
        "heroDescription": "使用AI驱动的设计生成令人惊叹的专业播客缩略图，吸引注意力并提高您节目的可见度。",
        "generatedWithPrompt": "使用提示生成：",
        "customPromptPlaceholder": "输入缩略图生成的自定义提示...",
        "generating": "生成中...",
        "generate": "生成",
        "modernMinimalist": "现代简约",
        "vibrantDynamic": "生动动感",
        "professionalClean": "专业简洁",
        "generatingThumbnail": "生成缩略图中...",
        "generatingNewThumbnail": "生成新缩略图中...",
        "showingFirstEpisodes": "显示前10个节目。使用搜索查找特定节目。",
        "imageUrlCopied": "图片URL已复制到剪贴板！",
        "failedToGenerate": "生成缩略图失败。请重试。",
        "promotionalTitle": "使用Podsqueeze生成节目笔记、时间戳、病毒剪辑等",
        "promotionalSubtitle": "加入100K+其他创作者并开始发展您的节目",
        "startNow": "立即开始",
        "free": "免费",
        "podcast": "播客",
        "thumbnail": "缩略图",
        "creator": "创作者",
        "replaceFace": "替换面部",
        "uploading": "上传中...",
        "uploadImageError": "请上传图片文件。",
        "uploadFailedError": "图片上传失败。请重试。",
        "uploadingImage": "图片上传中...",
        "generatingNewThumbnailLoading": "生成新缩略图中...",
        "failedToGenerateWithFace": "面部替换缩略图生成失败。请重试。"
      }
    },
    "podcasting": {
      "episodeList": {
        "episodeList.loading": "正在加载剧集...",
        "episodeList.noEpisodes": "暂无公开剧集",
        "episodeList.checkBack": "稍后回来查看新剧集",
        "episodeList.title": "此播客的剧集",
        "episodeList.readLess": "收起",
        "episodeList.readMore": "阅读更多",
        "episodeList.coverImageAlt": "{episodeTitle}的封面"
      }
    },
    "pricing": {
      "button": {
        "button.getStarted": "开始使用",
        "alert.subscriptionRunning": "您当前的订阅仍在进行中。\n\n请在购买新订阅之前取消当前订阅。",
        "alert.subscriptionEnds": "您当前的订阅仍在进行中。\n\n它将在 {date} 结束。",
        "alert.subscriptionCancelled": "您的订阅已被取消，将在 {date} 结束。",
        "button.openDashboard": "打开仪表板",
        "button.signUp": "注册",
        "button.buySubscription": "购买订阅",
        "button.cancelled": "已取消",
        "button.cancelSubscription": "取消订阅",
        "button.upgradeSubscription": "升级订阅",
        "button.loading": "加载中",
        "upgrade.details.currentMinutes": "这将开始一个新的订阅周期。您将保留您当前的所有分钟数。",
        "upgrade.details.remainingAnnual": "此值是根据您当前年度订阅剩余的时间计算得出的。"
      },
      "page": {
        "pricing.free.title": "免费",
        "pricing.free.subtitle": "试用 Podsqueeze。无需信用卡。",
        "pricing.free.price.annual": "每年 $0",
        "pricing.free.features.podcast_time": "每月 50 分钟播客时间",
        "pricing.free.features.video_clips": "3 个视频剪辑",
        "common.with_watermark": "带水印",
        "pricing.free.features.quote_images": "无限制引用图片",
        "pricing.free.features.file_upload": "文件上传最高 4Gb",
        "pricing.free.features.upload": "1 次上传",
        "pricing.free.features.landing_pages": "播客着陆页",
        "pricing.free.features.audio_enhancement": "音频增强",
        "common.sign_up": "注册",
        "common.open_dashboard": "打开仪表板",
        "pricing.starter.title": "入门版",
        "pricing.starter.subtitle": "适合想要节省时间的业余播客制作人。",
        "pricing.starter.price.annual": "每年 $132",
        "pricing.billed_annually": "每年",
        "pricing.starter.features.podcast_time": "每月 160 分钟播客时间",
        "pricing.starter.features.video_clips": "10 个视频剪辑或音频图",
        "pricing.starter.features.quote_images": "无限制引用图片",
        "pricing.starter.features.file_upload": "文件上传最高 4Gb",
        "pricing.starter.features.unlimited_uploads": "无限制上传",
        "pricing.starter.features.landing_pages": "播客着陆页",
        "pricing.pro.title": "专业版",
        "pricing.pro.subtitle": "为使用播客发展和支持其业务的专业人士提供。",
        "pricing.pro.price.annual": "每年 $324",
        "pricing.pro.features.podcast_time": "每月 320 分钟播客时间",
        "pricing.pro.features.personalize_ai_voice": "个性化 AI 语音",
        "pricing.pro.features.video_clips": "20 个视频剪辑或音频图",
        "common.no_watermark": "无水印",
        "pricing.pro.features.quote_images": "无限制引用图片",
        "pricing.pro.features.file_upload": "文件上传最高 10Gb",
        "pricing.pro.features.unlimited_uploads": "无限制上传",
        "pricing.pro.features.landing_pages": "播客着陆页",
        "common.customizable": "可定制",
        "minutes.accumulate": "分钟结转",
        "pricing.pro.features.audio_video_edit": "音频和视频魔法编辑",
        "pricing.agency_lite.title": "代理 Lite",
        "pricing.agency_lite.subtitle": "为希望简化和发展业务的播客代理提供。",
        "pricing.agency_lite.price.annual": "每年 $495",
        "pricing.agency_lite.features.podcast_time": "每月 600 分钟播客时间",
        "pricing.agency_lite.features.personalize_ai_voice": "个性化 AI 语音",
        "pricing.agency_lite.features.video_clips": "40 个视频剪辑或音频图",
        "pricing.agency_lite.features.quote_images": "无限制引用图片",
        "pricing.agency_lite.features.file_upload": "文件上传最高 10Gb",
        "pricing.agency_lite.features.unlimited_uploads": "无限制上传",
        "pricing.agency_lite.features.landing_pages": "播客着陆页",
        "pricing.agency_lite.features.audio_video_edit": "音频和视频魔法编辑",
        "pricing.agency_plus.title": "代理 Plus",
        "pricing.agency_plus.subtitle": "为希望简化和发展业务的播客代理提供。",
        "pricing.agency_plus.price.annual": "每年 $1,251",
        "pricing.agency_plus.features.podcast_time": "每月 2000 分钟播客时间",
        "pricing.agency_plus.features.personalize_ai_voice": "个性化 AI 语音",
        "pricing.agency_plus.features.video_clips": "80 个视频剪辑或音频图",
        "pricing.agency_plus.features.quote_images": "无限制引用图片",
        "pricing.agency_plus.features.file_upload": "文件上传最高 10Gb",
        "pricing.agency_plus.features.unlimited_uploads": "无限制上传",
        "pricing.agency_plus.features.landing_pages": "播客着陆页",
        "pricing.agency_plus.features.audio_video_edit": "音频和视频魔法编辑",
        "pricing.agency_scale.title": "代理 Scale",
        "pricing.agency_scale.subtitle": "为希望简化和发展业务的播客代理提供。",
        "pricing.agency_scale.price.annual": "每年 $2,175",
        "pricing.agency_scale.features.podcast_time": "每月 4000 分钟播客时间",
        "pricing.agency_scale.features.personalize_ai_voice": "个性化 AI 语音",
        "pricing.agency_scale.features.video_clips": "160 个视频剪辑或音频图",
        "pricing.agency_scale.features.quote_images": "无限制引用图片",
        "pricing.agency_scale.features.file_upload": "文件上传最高 10Gb",
        "pricing.agency_scale.features.unlimited_uploads": "无限制上传",
        "pricing.agency_scale.features.landing_pages": "播客着陆页",
        "pricing.agency_scale.features.audio_video_edit": "音频和视频魔法编辑",
        "pricing.header": "为独立播客制作人和播客代理提供",
        "pricing.minutes_reset": "只要您保持当前计划或升级，您可以累积最多3倍的月度分钟数。",
        "pricing.most_popular": "最受欢迎",
        "pricing.minutes_per_month": "分钟每月",
        "pricing.enterprise_title": "企业版",
        "pricing.enterprise_subtitle": "为播客代理和媒体公司提供，希望优化和发展其业务。",
        "pricing.enterprise_price": "定制",
        "pricing.enterprise_price_note": "联系 team@podsqueeze.com 或预约演示。",
        "pricing.enterprise_feature_priority_support": "优先支持",
        "pricing.enterprise_feature_team_sits": "团队会议",
        "pricing.enterprise_personalized_team_training": "团队会议",
        "pricing.book_demo": "预约演示"
      },
      "toggle": {
        "pay.monthly": "月",
        "pay.annually": "年",
        "discount.30percent": "30% 折扣"
      },
      "upgradeModal": {
        "upgrade.success": "您的订阅已成功升级",
        "upgrade.error": "我们很抱歉，出现了问题。请稍后再试",
        "upgrade.loading": "正在升级",
        "upgrade.confirmPay": "确认并支付",
        "upgrade.cancel": "取消",
        "coupon.placeholder": "优惠券代码",
        "coupon.apply": "应用",
        "coupon.have": "我有优惠券",
        "upgrade.confirmation": "您即将升级到",
        "upgrade.price": "您将支付"
      }
    },
    "register": {
      "page": {
        "register.form": "注册表单"
      },
      "registerForm": {
        "error.invalidCredentials": "请输入有效的电子邮件地址和密码。",
        "error.weakPassword": "请使用更强的密码 💪",
        "error.emailInUse": "用户已存在",
        "error.userNotFound": "未找到用户",
        "error.generic": "哎呀，出了点问题",
        "placeholder.email": "电子邮件地址",
        "placeholder.password": "密码",
        "button.registering": "注册中...",
        "button.register": "注册",
        "label.newsletter": "加入12,000名播客创作者，订阅我们的新闻通讯，获取产品更新、实用技巧、电子书、赠品等。",
        "label.alreadyHaveAccount": "已经有账户了吗？",
        "label.logInHere": "在这里登录",
        "label.or": "或者",
        "button.signingIn": "登录中...",
        "button.continueWithGoogle": "使用Google继续",
        "label.podcastDescription": "轻松启动和发展您的音频或视频播客，所需的一切尽在一个地方。",
        "feature.transcripts": "文字记录",
        "feature.showNotes": "节目笔记",
        "feature.newslettersBlogs": "新闻通讯与博客",
        "feature.socialPosts": "社交帖子",
        "feature.shortClips": "短片与音频图",
        "feature.podcastWebsite": "播客网站",
        "feature.audioEnhancement": "AI音频增强",
        "feature.removeSilences": "去除沉默和呃声"
      }
    },
    "topicFinder": {
      "InfoTooltip": {
        "tooltip.text": "文本"
      },
      "TopicFinder": {
        "competition.veryHigh": "非常高",
        "competition.high": "高",
        "competition.medium": "中",
        "competition.low": "低",
        "competition.veryLow": "非常低",
        "upgrade.button": "升级到专业版",
        "clicks.label": "点击数",
        "searches.label": "搜索次数",
        "competition.label": "竞争度",
        "fetching.results": "正在获取结果",
        "table.topic": "主题",
        "tooltip.topic": "您的播客集所涵盖的主要主题",
        "table.monthlySearches": "每月搜索次数",
        "tooltip.monthlySearches": "您可能预期的每月谷歌搜索范围",
        "table.competition": "竞争",
        "tooltip.competition": "播客所涵盖的主要主题或话题。",
        "table.monthlyGoogleClicks": "每月谷歌点击数",
        "tooltip.monthlyGoogleClicks": "您可能预期的每月谷歌点击范围的预测",
        "table.youtubeReach": "YouTube覆盖",
        "tooltip.youtubeReach": "基于平均竞争对手，您在前6个月可能预期的最大YouTube观看次数的预测",
        "intro.title": "免费播客主题生成器",
        "intro.description": "获取观众正在搜索的播客主题创意",
        "intro.check1": "查看每个主题创意在谷歌上的需求",
        "intro.check2": "了解每个播客主题创意的竞争程度",
        "intro.check3": "估算您可以获得的谷歌点击数和YouTube观看次数",
        "upgrade.message": "您需要升级到专业版才能访问所有结果",
        "learnMore.label": "了解更多关于",
        "learnMore.link": "免费播客主题生成器工具",
        "newSearch.button": "新搜索",
        "share.button": "分享此搜索",
        "form.label": "输入您的播客细分领域",
        "form.placeholder": "数字营销",
        "form.submit": "查找主题创意"
      },
      "page": {
        "main.background": "背景"
      },
      "shareTopics": {
        "share.results": "分享结果",
        "share.facebook": "分享到 Facebook",
        "share.whatsapp": "分享到 WhatsApp",
        "share.twitter": "分享到 Twitter",
        "share.linkedin": "分享到 LinkedIn",
        "copy.success": "已复制",
        "copy.link": "复制链接"
      },
      "youtubeScore": {
        "loading.placeholder": "加载中...",
        "views.label": "浏览量"
      }
    },
    "video": {
      "EditLayoutElements": {
        "error.currentComposition": "无法获取当前组合",
        "error.addImage": "添加图像元素时出错：",
        "alert.uploadImage": "请上传图像文件。",
        "error.uploadImage": "上传图像时出错：",
        "alert.uploadFailed": "上传图像失败。请再试一次。",
        "error.getDownloadURL": "获取下载链接时出错：",
        "alert.processImageFailed": "处理上传的图像失败。请再试一次。",
        "error.addText": "添加文本元素时出错：",
        "text.settingsPlaceholder": "选择元素时将显示设置",
        "text.addElement": "添加元素",
        "text.uploading": "上传中...",
        "button.uploadImage": "上传图像",
        "text.newText": "新文本",
        "button.addText": "添加文本",
        "text.selectedElementSettings": "选定元素设置"
      },
      "FontSelector": {
        "allFonts": "所有字体",
        "myFonts": "我的字体",
        "uploadFont": "上传字体",
        "noCustomFonts": "还没有自定义字体。",
        "uploadToAdd": "上传字体文件以添加到您的收藏中。",
        "text_outline": "文字轮廓",
        "outline_color": "轮廓颜色",
        "outline_width": "轮廓宽度"
      },
      "ImageLayoutSettings": {
        "imageLayoutSettings.fit": "适应",
        "imageLayoutSettings.zoom": "缩放",
        "imageLayoutSettings.horizontalAlignment": "水平对齐",
        "imageLayoutSettings.verticalAlignment": "垂直对齐",
        "imageLayoutSettings.deleteElement": "删除元素"
      },
      "TemplateBox": {
        "confirm.delete.template": "您确定要删除此模板吗？"
      },
      "TextSettings": {
        "error.getting_current_text": "获取当前文本时出错：",
        "event.delete_text_element_clicked": "点击删除文本元素",
        "error.changing_text_font": "更改文本字体时出错：",
        "event.text_font_changed": "文本字体已更改",
        "error.changing_text_size": "更改文本大小时出错：",
        "event.text_size_changed": "文本大小已更改",
        "error.changing_text_color": "更改文本颜色时出错：",
        "event.text_color_changed": "文本颜色已更改",
        "event.text_content_added": "文本内容已添加",
        "error.adding_text_content": "添加文本内容时出错：",
        "event.text_content_updated": "文本内容已更新",
        "label.text_content": "文本内容",
        "label.text_font": "文本字体",
        "label.adjust_text_size": "调整文本大小",
        "label.text_color": "文本颜色",
        "button.delete": "删除"
      },
      "audiogramBaseTemplate": {
        "color.white": "白色",
        "font.roboto": "Roboto",
        "color.black": "#000",
        "url.defaultEpisode": "defaultEpisodeUrl",
        "time.0s": "0 秒",
        "font.inter": "Inter",
        "duration.1s": "1 秒",
        "easing.quadraticOut": "二次出",
        "animation.fade": "淡入淡出",
        "type.text": "文本",
        "name.podcastTitle": "播客标题",
        "name.snippetTitle": "片段标题",
        "type.image": "图像",
        "name.audioBackgroundImage": "音频背景图像",
        "name.subtitlesText": "字幕文本",
        "effect.highlight": "高亮",
        "type.audio": "音频",
        "format.mp4": "mp4"
      },
      "audiogramFullImageTemplate": {
        "snippet.title": "片段标题",
        "podcast.title": "播客标题",
        "new.episode": "新剧集"
      },
      "audiogramRoundImageTemplate": {
        "default.color.white": "白色",
        "default.font.judson": "Judson",
        "default.color.background": "#e5e0dc",
        "default.url.episode": "默认剧集链接",
        "default.color.subtitles": "#858585"
      },
      "commonElements": {
        "background.music": "背景音乐",
        "audio.type": "音频"
      },
      "imageElement": {
        "upload.image.error": "请上传一个图像文件。",
        "upload.file.loading": "正在上传文件。请不要关闭此窗口。",
        "upload.image.label": "替换图像",
        "ai.prompt.label": "输入提示以让AI生成图像",
        "ai.prompt.placeholder": "例如：一只在公园里奔跑的狗...",
        "ai.processing": "处理中...",
        "ai.create": "创建",
        "customize.image.title": "自定义图像",
        "enter.image.url": "输入图像URL",
        "or": "或"
      },
      "selectTemplatesElement": {
        "error.fetchingTemplates": "获取模板时出错：",
        "template.savedSuccessfully": "模板保存成功",
        "error.savingTemplate": "保存模板时出错：",
        "loading.savedTemplates": "加载已保存的模板...",
        "no.savedTemplates": "没有保存的模板",
        "select_template": "选择模板",
        "saving.template": "正在保存模板...",
        "template_name": "模板名称",
        "enter.templateName": "输入模板名称",
        "cancel": "取消",
        "save": "保存",
        "default_templates": "默认模板",
        "saved_templates_count": "已保存模板 ({count})",
        "folder_templates_count": "文件夹模板 ({count})",
        "account_templates_count": "账户模板 ({count})",
        "save_current_template": "保存当前模板"
      },
      "subtitlesElement": {
        "edit.word": "编辑单词",
        "edit.label": "编辑",
        "remove.word.subtitle": "仅从字幕中移除单词",
        "erase.subtitle": "从字幕中擦除",
        "remove.word.clip": "从音频和字幕中移除单词",
        "remove.clip": "从剪辑中移除"
      },
      "utils": {
        "video.utils.title": "标题",
        "video.utils.currentTime": "当前时间",
        "video.utils.nextTime": "下一个时间",
        "video.utils.duration": "时长",
        "video.utils.description": "描述",
        "video.utils.srtSegment": "SRT 段"
      },
      "videogramBaseTemplate": {
        "output.format.mp4": "mp4",
        "subtitle.text": "在此输入您的字幕文本"
      }
    }
  }
};